var cz = Object.defineProperty;
var p1 = (e) => {
  throw TypeError(e);
};
var uz = (e, t, n) => t in e ? cz(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var nt = (e, t, n) => uz(e, typeof t != "symbol" ? t + "" : t, n), _v = (e, t, n) => t.has(e) || p1("Cannot " + n);
var ge = (e, t, n) => (_v(e, t, "read from private field"), n ? n.call(e) : t.get(e)), Lt = (e, t, n) => t.has(e) ? p1("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), ht = (e, t, n, r) => (_v(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n), ln = (e, t, n) => (_v(e, t, "access private method"), n);
var ng = (e, t, n, r) => ({
  set _(o) {
    ht(e, t, o, n);
  },
  get _() {
    return ge(e, t, r);
  }
});
import * as m from "react";
import en, { forwardRef as dz, useContext as Li, Children as fz, isValidElement as Mg, cloneElement as Ag, createElement as fc, createContext as Pc, useState as Jt, useEffect as ir, useMemo as pl, useRef as ho, useCallback as CC } from "react";
import * as xC from "react-dom";
import rg from "react-dom";
function pz(e, t) {
  for (var n = 0; n < t.length; n++) {
    const r = t[n];
    if (typeof r != "string" && !Array.isArray(r)) {
      for (const o in r)
        if (o !== "default" && !(o in e)) {
          const i = Object.getOwnPropertyDescriptor(r, o);
          i && Object.defineProperty(e, o, i.get ? i : {
            enumerable: !0,
            get: () => r[o]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
var Cr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function D_(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function hz(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var o = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var Uw = { exports: {} }, nf = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h1;
function gz() {
  if (h1) return nf;
  h1 = 1;
  var e = en, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(l, c, d) {
    var f, p = {}, g = null, b = null;
    d !== void 0 && (g = "" + d), c.key !== void 0 && (g = "" + c.key), c.ref !== void 0 && (b = c.ref);
    for (f in c) r.call(c, f) && !i.hasOwnProperty(f) && (p[f] = c[f]);
    if (l && l.defaultProps) for (f in c = l.defaultProps, c) p[f] === void 0 && (p[f] = c[f]);
    return { $$typeof: t, type: l, key: g, ref: b, props: p, _owner: o.current };
  }
  return nf.Fragment = n, nf.jsx = a, nf.jsxs = a, nf;
}
var rf = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var g1;
function mz() {
  return g1 || (g1 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = en, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), b = Symbol.for("react.offscreen"), v = Symbol.iterator, y = "@@iterator";
    function S(Z) {
      if (Z === null || typeof Z != "object")
        return null;
      var be = v && Z[v] || Z[y];
      return typeof be == "function" ? be : null;
    }
    var E = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function I(Z) {
      {
        for (var be = arguments.length, Re = new Array(be > 1 ? be - 1 : 0), pe = 1; pe < be; pe++)
          Re[pe - 1] = arguments[pe];
        O("error", Z, Re);
      }
    }
    function O(Z, be, Re) {
      {
        var pe = E.ReactDebugCurrentFrame, he = pe.getStackAddendum();
        he !== "" && (be += "%s", Re = Re.concat([he]));
        var Fe = Re.map(function(We) {
          return String(We);
        });
        Fe.unshift("Warning: " + be), Function.prototype.apply.call(console[Z], console, Fe);
      }
    }
    var T = !1, P = !1, R = !1, F = !1, A = !1, _;
    _ = Symbol.for("react.module.reference");
    function C(Z) {
      return !!(typeof Z == "string" || typeof Z == "function" || Z === r || Z === i || A || Z === o || Z === d || Z === f || F || Z === b || T || P || R || typeof Z == "object" && Z !== null && (Z.$$typeof === g || Z.$$typeof === p || Z.$$typeof === a || Z.$$typeof === l || Z.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Z.$$typeof === _ || Z.getModuleId !== void 0));
    }
    function D(Z, be, Re) {
      var pe = Z.displayName;
      if (pe)
        return pe;
      var he = be.displayName || be.name || "";
      return he !== "" ? Re + "(" + he + ")" : Re;
    }
    function L(Z) {
      return Z.displayName || "Context";
    }
    function B(Z) {
      if (Z == null)
        return null;
      if (typeof Z.tag == "number" && I("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Z == "function")
        return Z.displayName || Z.name || null;
      if (typeof Z == "string")
        return Z;
      switch (Z) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case d:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof Z == "object")
        switch (Z.$$typeof) {
          case l:
            var be = Z;
            return L(be) + ".Consumer";
          case a:
            var Re = Z;
            return L(Re._context) + ".Provider";
          case c:
            return D(Z, Z.render, "ForwardRef");
          case p:
            var pe = Z.displayName || null;
            return pe !== null ? pe : B(Z.type) || "Memo";
          case g: {
            var he = Z, Fe = he._payload, We = he._init;
            try {
              return B(We(Fe));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, k = 0, N, j, W, V, $, z, ne;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function Q() {
      {
        if (k === 0) {
          N = console.log, j = console.info, W = console.warn, V = console.error, $ = console.group, z = console.groupCollapsed, ne = console.groupEnd;
          var Z = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Z,
            log: Z,
            warn: Z,
            error: Z,
            group: Z,
            groupCollapsed: Z,
            groupEnd: Z
          });
        }
        k++;
      }
    }
    function re() {
      {
        if (k--, k === 0) {
          var Z = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, Z, {
              value: N
            }),
            info: H({}, Z, {
              value: j
            }),
            warn: H({}, Z, {
              value: W
            }),
            error: H({}, Z, {
              value: V
            }),
            group: H({}, Z, {
              value: $
            }),
            groupCollapsed: H({}, Z, {
              value: z
            }),
            groupEnd: H({}, Z, {
              value: ne
            })
          });
        }
        k < 0 && I("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var te = E.ReactCurrentDispatcher, ie;
    function ae(Z, be, Re) {
      {
        if (ie === void 0)
          try {
            throw Error();
          } catch (he) {
            var pe = he.stack.trim().match(/\n( *(at )?)/);
            ie = pe && pe[1] || "";
          }
        return `
` + ie + Z;
      }
    }
    var ce = !1, le;
    {
      var we = typeof WeakMap == "function" ? WeakMap : Map;
      le = new we();
    }
    function q(Z, be) {
      if (!Z || ce)
        return "";
      {
        var Re = le.get(Z);
        if (Re !== void 0)
          return Re;
      }
      var pe;
      ce = !0;
      var he = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Fe;
      Fe = te.current, te.current = null, Q();
      try {
        if (be) {
          var We = function() {
            throw Error();
          };
          if (Object.defineProperty(We.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(We, []);
            } catch (Qn) {
              pe = Qn;
            }
            Reflect.construct(Z, [], We);
          } else {
            try {
              We.call();
            } catch (Qn) {
              pe = Qn;
            }
            Z.call(We.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Qn) {
            pe = Qn;
          }
          Z();
        }
      } catch (Qn) {
        if (Qn && pe && typeof Qn.stack == "string") {
          for (var Ue = Qn.stack.split(`
`), dt = pe.stack.split(`
`), Tt = Ue.length - 1, zt = dt.length - 1; Tt >= 1 && zt >= 0 && Ue[Tt] !== dt[zt]; )
            zt--;
          for (; Tt >= 1 && zt >= 0; Tt--, zt--)
            if (Ue[Tt] !== dt[zt]) {
              if (Tt !== 1 || zt !== 1)
                do
                  if (Tt--, zt--, zt < 0 || Ue[Tt] !== dt[zt]) {
                    var pn = `
` + Ue[Tt].replace(" at new ", " at ");
                    return Z.displayName && pn.includes("<anonymous>") && (pn = pn.replace("<anonymous>", Z.displayName)), typeof Z == "function" && le.set(Z, pn), pn;
                  }
                while (Tt >= 1 && zt >= 0);
              break;
            }
        }
      } finally {
        ce = !1, te.current = Fe, re(), Error.prepareStackTrace = he;
      }
      var Ar = Z ? Z.displayName || Z.name : "", Gr = Ar ? ae(Ar) : "";
      return typeof Z == "function" && le.set(Z, Gr), Gr;
    }
    function Ee(Z, be, Re) {
      return q(Z, !1);
    }
    function _e(Z) {
      var be = Z.prototype;
      return !!(be && be.isReactComponent);
    }
    function $e(Z, be, Re) {
      if (Z == null)
        return "";
      if (typeof Z == "function")
        return q(Z, _e(Z));
      if (typeof Z == "string")
        return ae(Z);
      switch (Z) {
        case d:
          return ae("Suspense");
        case f:
          return ae("SuspenseList");
      }
      if (typeof Z == "object")
        switch (Z.$$typeof) {
          case c:
            return Ee(Z.render);
          case p:
            return $e(Z.type, be, Re);
          case g: {
            var pe = Z, he = pe._payload, Fe = pe._init;
            try {
              return $e(Fe(he), be, Re);
            } catch {
            }
          }
        }
      return "";
    }
    var Le = Object.prototype.hasOwnProperty, Ze = {}, J = E.ReactDebugCurrentFrame;
    function fe(Z) {
      if (Z) {
        var be = Z._owner, Re = $e(Z.type, Z._source, be ? be.type : null);
        J.setExtraStackFrame(Re);
      } else
        J.setExtraStackFrame(null);
    }
    function me(Z, be, Re, pe, he) {
      {
        var Fe = Function.call.bind(Le);
        for (var We in Z)
          if (Fe(Z, We)) {
            var Ue = void 0;
            try {
              if (typeof Z[We] != "function") {
                var dt = Error((pe || "React class") + ": " + Re + " type `" + We + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Z[We] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw dt.name = "Invariant Violation", dt;
              }
              Ue = Z[We](be, We, pe, Re, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Tt) {
              Ue = Tt;
            }
            Ue && !(Ue instanceof Error) && (fe(he), I("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", pe || "React class", Re, We, typeof Ue), fe(null)), Ue instanceof Error && !(Ue.message in Ze) && (Ze[Ue.message] = !0, fe(he), I("Failed %s type: %s", Re, Ue.message), fe(null));
          }
      }
    }
    var Oe = Array.isArray;
    function Ce(Z) {
      return Oe(Z);
    }
    function Te(Z) {
      {
        var be = typeof Symbol == "function" && Symbol.toStringTag, Re = be && Z[Symbol.toStringTag] || Z.constructor.name || "Object";
        return Re;
      }
    }
    function Pe(Z) {
      try {
        return Ye(Z), !1;
      } catch {
        return !0;
      }
    }
    function Ye(Z) {
      return "" + Z;
    }
    function Ke(Z) {
      if (Pe(Z))
        return I("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Te(Z)), Ye(Z);
    }
    var je = E.ReactCurrentOwner, Qe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, et, Et, Xe;
    Xe = {};
    function xt(Z) {
      if (Le.call(Z, "ref")) {
        var be = Object.getOwnPropertyDescriptor(Z, "ref").get;
        if (be && be.isReactWarning)
          return !1;
      }
      return Z.ref !== void 0;
    }
    function tt(Z) {
      if (Le.call(Z, "key")) {
        var be = Object.getOwnPropertyDescriptor(Z, "key").get;
        if (be && be.isReactWarning)
          return !1;
      }
      return Z.key !== void 0;
    }
    function ct(Z, be) {
      if (typeof Z.ref == "string" && je.current && be && je.current.stateNode !== be) {
        var Re = B(je.current.type);
        Xe[Re] || (I('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B(je.current.type), Z.ref), Xe[Re] = !0);
      }
    }
    function Je(Z, be) {
      {
        var Re = function() {
          et || (et = !0, I("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", be));
        };
        Re.isReactWarning = !0, Object.defineProperty(Z, "key", {
          get: Re,
          configurable: !0
        });
      }
    }
    function Ge(Z, be) {
      {
        var Re = function() {
          Et || (Et = !0, I("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", be));
        };
        Re.isReactWarning = !0, Object.defineProperty(Z, "ref", {
          get: Re,
          configurable: !0
        });
      }
    }
    var lt = function(Z, be, Re, pe, he, Fe, We) {
      var Ue = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: Z,
        key: be,
        ref: Re,
        props: We,
        // Record the component responsible for creating this element.
        _owner: Fe
      };
      return Ue._store = {}, Object.defineProperty(Ue._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Ue, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: pe
      }), Object.defineProperty(Ue, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: he
      }), Object.freeze && (Object.freeze(Ue.props), Object.freeze(Ue)), Ue;
    };
    function It(Z, be, Re, pe, he) {
      {
        var Fe, We = {}, Ue = null, dt = null;
        Re !== void 0 && (Ke(Re), Ue = "" + Re), tt(be) && (Ke(be.key), Ue = "" + be.key), xt(be) && (dt = be.ref, ct(be, he));
        for (Fe in be)
          Le.call(be, Fe) && !Qe.hasOwnProperty(Fe) && (We[Fe] = be[Fe]);
        if (Z && Z.defaultProps) {
          var Tt = Z.defaultProps;
          for (Fe in Tt)
            We[Fe] === void 0 && (We[Fe] = Tt[Fe]);
        }
        if (Ue || dt) {
          var zt = typeof Z == "function" ? Z.displayName || Z.name || "Unknown" : Z;
          Ue && Je(We, zt), dt && Ge(We, zt);
        }
        return lt(Z, Ue, dt, he, pe, je.current, We);
      }
    }
    var fn = E.ReactCurrentOwner, Bn = E.ReactDebugCurrentFrame;
    function kn(Z) {
      if (Z) {
        var be = Z._owner, Re = $e(Z.type, Z._source, be ? be.type : null);
        Bn.setExtraStackFrame(Re);
      } else
        Bn.setExtraStackFrame(null);
    }
    var fr;
    fr = !1;
    function ar(Z) {
      return typeof Z == "object" && Z !== null && Z.$$typeof === t;
    }
    function Mr() {
      {
        if (fn.current) {
          var Z = B(fn.current.type);
          if (Z)
            return `

Check the render method of \`` + Z + "`.";
        }
        return "";
      }
    }
    function Lr(Z) {
      return "";
    }
    var lr = {};
    function mt(Z) {
      {
        var be = Mr();
        if (!be) {
          var Re = typeof Z == "string" ? Z : Z.displayName || Z.name;
          Re && (be = `

Check the top-level render call using <` + Re + ">.");
        }
        return be;
      }
    }
    function er(Z, be) {
      {
        if (!Z._store || Z._store.validated || Z.key != null)
          return;
        Z._store.validated = !0;
        var Re = mt(be);
        if (lr[Re])
          return;
        lr[Re] = !0;
        var pe = "";
        Z && Z._owner && Z._owner !== fn.current && (pe = " It was passed a child from " + B(Z._owner.type) + "."), kn(Z), I('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Re, pe), kn(null);
      }
    }
    function eo(Z, be) {
      {
        if (typeof Z != "object")
          return;
        if (Ce(Z))
          for (var Re = 0; Re < Z.length; Re++) {
            var pe = Z[Re];
            ar(pe) && er(pe, be);
          }
        else if (ar(Z))
          Z._store && (Z._store.validated = !0);
        else if (Z) {
          var he = S(Z);
          if (typeof he == "function" && he !== Z.entries)
            for (var Fe = he.call(Z), We; !(We = Fe.next()).done; )
              ar(We.value) && er(We.value, be);
        }
      }
    }
    function ue(Z) {
      {
        var be = Z.type;
        if (be == null || typeof be == "string")
          return;
        var Re;
        if (typeof be == "function")
          Re = be.propTypes;
        else if (typeof be == "object" && (be.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        be.$$typeof === p))
          Re = be.propTypes;
        else
          return;
        if (Re) {
          var pe = B(be);
          me(Re, Z.props, "prop", pe, Z);
        } else if (be.PropTypes !== void 0 && !fr) {
          fr = !0;
          var he = B(be);
          I("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", he || "Unknown");
        }
        typeof be.getDefaultProps == "function" && !be.getDefaultProps.isReactClassApproved && I("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ve(Z) {
      {
        for (var be = Object.keys(Z.props), Re = 0; Re < be.length; Re++) {
          var pe = be[Re];
          if (pe !== "children" && pe !== "key") {
            kn(Z), I("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", pe), kn(null);
            break;
          }
        }
        Z.ref !== null && (kn(Z), I("Invalid attribute `ref` supplied to `React.Fragment`."), kn(null));
      }
    }
    var Se = {};
    function ze(Z, be, Re, pe, he, Fe) {
      {
        var We = C(Z);
        if (!We) {
          var Ue = "";
          (Z === void 0 || typeof Z == "object" && Z !== null && Object.keys(Z).length === 0) && (Ue += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var dt = Lr();
          dt ? Ue += dt : Ue += Mr();
          var Tt;
          Z === null ? Tt = "null" : Ce(Z) ? Tt = "array" : Z !== void 0 && Z.$$typeof === t ? (Tt = "<" + (B(Z.type) || "Unknown") + " />", Ue = " Did you accidentally export a JSX literal instead of a component?") : Tt = typeof Z, I("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Tt, Ue);
        }
        var zt = It(Z, be, Re, he, Fe);
        if (zt == null)
          return zt;
        if (We) {
          var pn = be.children;
          if (pn !== void 0)
            if (pe)
              if (Ce(pn)) {
                for (var Ar = 0; Ar < pn.length; Ar++)
                  eo(pn[Ar], Z);
                Object.freeze && Object.freeze(pn);
              } else
                I("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              eo(pn, Z);
        }
        if (Le.call(be, "key")) {
          var Gr = B(Z), Qn = Object.keys(be).filter(function(qt) {
            return qt !== "key";
          }), Wr = Qn.length > 0 ? "{key: someKey, " + Qn.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Se[Gr + Wr]) {
            var Ko = Qn.length > 0 ? "{" + Qn.join(": ..., ") + ": ...}" : "{}";
            I(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Wr, Gr, Ko, Gr), Se[Gr + Wr] = !0;
          }
        }
        return Z === r ? ve(zt) : ue(zt), zt;
      }
    }
    function st(Z, be, Re) {
      return ze(Z, be, Re, !0);
    }
    function bt(Z, be, Re) {
      return ze(Z, be, Re, !1);
    }
    var Dt = bt, at = st;
    rf.Fragment = r, rf.jsx = Dt, rf.jsxs = at;
  }()), rf;
}
process.env.NODE_ENV === "production" ? Uw.exports = gz() : Uw.exports = mz();
var w = Uw.exports;
const Qf = {
  black: "#000",
  white: "#fff"
}, Jc = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, Zc = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, eu = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, tu = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, nu = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, of = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, bz = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
};
function Bs(e, ...t) {
  const n = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((r) => n.searchParams.append("args[]", r)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
const Di = "$$material";
function U() {
  return U = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, U.apply(null, arguments);
}
var yz = !1;
function vz(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function wz(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var Cz = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(o) {
      var i;
      r.tags.length === 0 ? r.insertionPoint ? i = r.insertionPoint.nextSibling : r.prepend ? i = r.container.firstChild : i = r.before : i = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(o, i), r.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? !yz : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(wz(this));
    var o = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var i = vz(o);
      try {
        i.insertRule(r, i.cssRules.length);
      } catch {
      }
    } else
      o.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      var o;
      return (o = r.parentNode) == null ? void 0 : o.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), fo = "-ms-", Xg = "-moz-", bn = "-webkit-", N_ = "comm", SC = "rule", EC = "decl", xz = "@import", F_ = "@keyframes", Sz = "@layer", Ez = Math.abs, Wm = String.fromCharCode, Tz = Object.assign;
function Oz(e, t) {
  return oo(e, 0) ^ 45 ? (((t << 2 ^ oo(e, 0)) << 2 ^ oo(e, 1)) << 2 ^ oo(e, 2)) << 2 ^ oo(e, 3) : 0;
}
function $_(e) {
  return e.trim();
}
function Pz(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function yn(e, t, n) {
  return e.replace(t, n);
}
function zw(e, t) {
  return e.indexOf(t);
}
function oo(e, t) {
  return e.charCodeAt(t) | 0;
}
function Xf(e, t, n) {
  return e.slice(t, n);
}
function Cs(e) {
  return e.length;
}
function TC(e) {
  return e.length;
}
function og(e, t) {
  return t.push(e), e;
}
function Iz(e, t) {
  return e.map(t).join("");
}
var qm = 1, od = 1, L_ = 0, zo = 0, Nr = 0, Sd = "";
function Km(e, t, n, r, o, i, a) {
  return { value: e, root: t, parent: n, type: r, props: o, children: i, line: qm, column: od, length: a, return: "" };
}
function sf(e, t) {
  return Tz(Km("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function Rz() {
  return Nr;
}
function _z() {
  return Nr = zo > 0 ? oo(Sd, --zo) : 0, od--, Nr === 10 && (od = 1, qm--), Nr;
}
function ci() {
  return Nr = zo < L_ ? oo(Sd, zo++) : 0, od++, Nr === 10 && (od = 1, qm++), Nr;
}
function Ds() {
  return oo(Sd, zo);
}
function Dg() {
  return zo;
}
function Mp(e, t) {
  return Xf(Sd, e, t);
}
function Jf(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function j_(e) {
  return qm = od = 1, L_ = Cs(Sd = e), zo = 0, [];
}
function B_(e) {
  return Sd = "", e;
}
function Ng(e) {
  return $_(Mp(zo - 1, Gw(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function kz(e) {
  for (; (Nr = Ds()) && Nr < 33; )
    ci();
  return Jf(e) > 2 || Jf(Nr) > 3 ? "" : " ";
}
function Mz(e, t) {
  for (; --t && ci() && !(Nr < 48 || Nr > 102 || Nr > 57 && Nr < 65 || Nr > 70 && Nr < 97); )
    ;
  return Mp(e, Dg() + (t < 6 && Ds() == 32 && ci() == 32));
}
function Gw(e) {
  for (; ci(); )
    switch (Nr) {
      case e:
        return zo;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Gw(Nr);
        break;
      case 40:
        e === 41 && Gw(e);
        break;
      case 92:
        ci();
        break;
    }
  return zo;
}
function Az(e, t) {
  for (; ci() && e + Nr !== 57; )
    if (e + Nr === 84 && Ds() === 47)
      break;
  return "/*" + Mp(t, zo - 1) + "*" + Wm(e === 47 ? e : ci());
}
function Dz(e) {
  for (; !Jf(Ds()); )
    ci();
  return Mp(e, zo);
}
function Nz(e) {
  return B_(Fg("", null, null, null, [""], e = j_(e), 0, [0], e));
}
function Fg(e, t, n, r, o, i, a, l, c) {
  for (var d = 0, f = 0, p = a, g = 0, b = 0, v = 0, y = 1, S = 1, E = 1, I = 0, O = "", T = o, P = i, R = r, F = O; S; )
    switch (v = I, I = ci()) {
      case 40:
        if (v != 108 && oo(F, p - 1) == 58) {
          zw(F += yn(Ng(I), "&", "&\f"), "&\f") != -1 && (E = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        F += Ng(I);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        F += kz(v);
        break;
      case 92:
        F += Mz(Dg() - 1, 7);
        continue;
      case 47:
        switch (Ds()) {
          case 42:
          case 47:
            og(Fz(Az(ci(), Dg()), t, n), c);
            break;
          default:
            F += "/";
        }
        break;
      case 123 * y:
        l[d++] = Cs(F) * E;
      case 125 * y:
      case 59:
      case 0:
        switch (I) {
          case 0:
          case 125:
            S = 0;
          case 59 + f:
            E == -1 && (F = yn(F, /\f/g, "")), b > 0 && Cs(F) - p && og(b > 32 ? b1(F + ";", r, n, p - 1) : b1(yn(F, " ", "") + ";", r, n, p - 2), c);
            break;
          case 59:
            F += ";";
          default:
            if (og(R = m1(F, t, n, d, f, o, l, O, T = [], P = [], p), i), I === 123)
              if (f === 0)
                Fg(F, t, R, R, T, i, p, l, P);
              else
                switch (g === 99 && oo(F, 3) === 110 ? 100 : g) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Fg(e, R, R, r && og(m1(e, R, R, 0, 0, o, l, O, o, T = [], p), P), o, P, p, l, r ? T : P);
                    break;
                  default:
                    Fg(F, R, R, R, [""], P, 0, l, P);
                }
        }
        d = f = b = 0, y = E = 1, O = F = "", p = a;
        break;
      case 58:
        p = 1 + Cs(F), b = v;
      default:
        if (y < 1) {
          if (I == 123)
            --y;
          else if (I == 125 && y++ == 0 && _z() == 125)
            continue;
        }
        switch (F += Wm(I), I * y) {
          case 38:
            E = f > 0 ? 1 : (F += "\f", -1);
            break;
          case 44:
            l[d++] = (Cs(F) - 1) * E, E = 1;
            break;
          case 64:
            Ds() === 45 && (F += Ng(ci())), g = Ds(), f = p = Cs(O = F += Dz(Dg())), I++;
            break;
          case 45:
            v === 45 && Cs(F) == 2 && (y = 0);
        }
    }
  return i;
}
function m1(e, t, n, r, o, i, a, l, c, d, f) {
  for (var p = o - 1, g = o === 0 ? i : [""], b = TC(g), v = 0, y = 0, S = 0; v < r; ++v)
    for (var E = 0, I = Xf(e, p + 1, p = Ez(y = a[v])), O = e; E < b; ++E)
      (O = $_(y > 0 ? g[E] + " " + I : yn(I, /&\f/g, g[E]))) && (c[S++] = O);
  return Km(e, t, n, o === 0 ? SC : l, c, d, f);
}
function Fz(e, t, n) {
  return Km(e, t, n, N_, Wm(Rz()), Xf(e, 2, -2), 0);
}
function b1(e, t, n, r) {
  return Km(e, t, n, EC, Xf(e, 0, r), Xf(e, r + 1, -1), r);
}
function Du(e, t) {
  for (var n = "", r = TC(e), o = 0; o < r; o++)
    n += t(e[o], o, e, t) || "";
  return n;
}
function $z(e, t, n, r) {
  switch (e.type) {
    case Sz:
      if (e.children.length) break;
    case xz:
    case EC:
      return e.return = e.return || e.value;
    case N_:
      return "";
    case F_:
      return e.return = e.value + "{" + Du(e.children, r) + "}";
    case SC:
      e.value = e.props.join(",");
  }
  return Cs(n = Du(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function Lz(e) {
  var t = TC(e);
  return function(n, r, o, i) {
    for (var a = "", l = 0; l < t; l++)
      a += e[l](n, r, o, i) || "";
    return a;
  };
}
function jz(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function V_(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var Bz = function(t, n, r) {
  for (var o = 0, i = 0; o = i, i = Ds(), o === 38 && i === 12 && (n[r] = 1), !Jf(i); )
    ci();
  return Mp(t, zo);
}, Vz = function(t, n) {
  var r = -1, o = 44;
  do
    switch (Jf(o)) {
      case 0:
        o === 38 && Ds() === 12 && (n[r] = 1), t[r] += Bz(zo - 1, n, r);
        break;
      case 2:
        t[r] += Ng(o);
        break;
      case 4:
        if (o === 44) {
          t[++r] = Ds() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      default:
        t[r] += Wm(o);
    }
  while (o = ci());
  return t;
}, Hz = function(t, n) {
  return B_(Vz(j_(t), n));
}, y1 = /* @__PURE__ */ new WeakMap(), Uz = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, o = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !y1.get(r)) && !o) {
      y1.set(t, !0);
      for (var i = [], a = Hz(n, i), l = r.props, c = 0, d = 0; c < a.length; c++)
        for (var f = 0; f < l.length; f++, d++)
          t.props[d] = i[c] ? a[c].replace(/&\f/g, l[f]) : l[f] + " " + a[c];
    }
  }
}, zz = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function H_(e, t) {
  switch (Oz(e, t)) {
    case 5103:
      return bn + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return bn + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return bn + e + Xg + e + fo + e + e;
    case 6828:
    case 4268:
      return bn + e + fo + e + e;
    case 6165:
      return bn + e + fo + "flex-" + e + e;
    case 5187:
      return bn + e + yn(e, /(\w+).+(:[^]+)/, bn + "box-$1$2" + fo + "flex-$1$2") + e;
    case 5443:
      return bn + e + fo + "flex-item-" + yn(e, /flex-|-self/, "") + e;
    case 4675:
      return bn + e + fo + "flex-line-pack" + yn(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return bn + e + fo + yn(e, "shrink", "negative") + e;
    case 5292:
      return bn + e + fo + yn(e, "basis", "preferred-size") + e;
    case 6060:
      return bn + "box-" + yn(e, "-grow", "") + bn + e + fo + yn(e, "grow", "positive") + e;
    case 4554:
      return bn + yn(e, /([^-])(transform)/g, "$1" + bn + "$2") + e;
    case 6187:
      return yn(yn(yn(e, /(zoom-|grab)/, bn + "$1"), /(image-set)/, bn + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return yn(e, /(image-set\([^]*)/, bn + "$1$`$1");
    case 4968:
      return yn(yn(e, /(.+:)(flex-)?(.*)/, bn + "box-pack:$3" + fo + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + bn + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return yn(e, /(.+)-inline(.+)/, bn + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Cs(e) - 1 - t > 6) switch (oo(e, t + 1)) {
        case 109:
          if (oo(e, t + 4) !== 45) break;
        case 102:
          return yn(e, /(.+:)(.+)-([^]+)/, "$1" + bn + "$2-$3$1" + Xg + (oo(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~zw(e, "stretch") ? H_(yn(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    case 4949:
      if (oo(e, t + 1) !== 115) break;
    case 6444:
      switch (oo(e, Cs(e) - 3 - (~zw(e, "!important") && 10))) {
        case 107:
          return yn(e, ":", ":" + bn) + e;
        case 101:
          return yn(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + bn + (oo(e, 14) === 45 ? "inline-" : "") + "box$3$1" + bn + "$2$3$1" + fo + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (oo(e, t + 11)) {
        case 114:
          return bn + e + fo + yn(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return bn + e + fo + yn(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return bn + e + fo + yn(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return bn + e + fo + e + e;
  }
  return e;
}
var Gz = function(t, n, r, o) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case EC:
      t.return = H_(t.value, t.length);
      break;
    case F_:
      return Du([sf(t, {
        value: yn(t.value, "@", "@" + bn)
      })], o);
    case SC:
      if (t.length) return Iz(t.props, function(i) {
        switch (Pz(i, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return Du([sf(t, {
              props: [yn(i, /:(read-\w+)/, ":" + Xg + "$1")]
            })], o);
          case "::placeholder":
            return Du([sf(t, {
              props: [yn(i, /:(plac\w+)/, ":" + bn + "input-$1")]
            }), sf(t, {
              props: [yn(i, /:(plac\w+)/, ":" + Xg + "$1")]
            }), sf(t, {
              props: [yn(i, /:(plac\w+)/, fo + "input-$1")]
            })], o);
        }
        return "";
      });
  }
}, Wz = [Gz], qz = function(t) {
  var n = t.key;
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(y) {
      var S = y.getAttribute("data-emotion");
      S.indexOf(" ") !== -1 && (document.head.appendChild(y), y.setAttribute("data-s", ""));
    });
  }
  var o = t.stylisPlugins || Wz, i = {}, a, l = [];
  a = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(y) {
      for (var S = y.getAttribute("data-emotion").split(" "), E = 1; E < S.length; E++)
        i[S[E]] = !0;
      l.push(y);
    }
  );
  var c, d = [Uz, zz];
  {
    var f, p = [$z, jz(function(y) {
      f.insert(y);
    })], g = Lz(d.concat(o, p)), b = function(S) {
      return Du(Nz(S), g);
    };
    c = function(S, E, I, O) {
      f = I, b(S ? S + "{" + E.styles + "}" : E.styles), O && (v.inserted[E.name] = !0);
    };
  }
  var v = {
    key: n,
    sheet: new Cz({
      key: n,
      container: a,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: i,
    registered: {},
    insert: c
  };
  return v.sheet.hydrate(l), v;
}, ig = { exports: {} }, Cn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var v1;
function Kz() {
  if (v1) return Cn;
  v1 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, b = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, S = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, I = e ? Symbol.for("react.scope") : 60119;
  function O(P) {
    if (typeof P == "object" && P !== null) {
      var R = P.$$typeof;
      switch (R) {
        case t:
          switch (P = P.type, P) {
            case c:
            case d:
            case r:
            case i:
            case o:
            case p:
              return P;
            default:
              switch (P = P && P.$$typeof, P) {
                case l:
                case f:
                case v:
                case b:
                case a:
                  return P;
                default:
                  return R;
              }
          }
        case n:
          return R;
      }
    }
  }
  function T(P) {
    return O(P) === d;
  }
  return Cn.AsyncMode = c, Cn.ConcurrentMode = d, Cn.ContextConsumer = l, Cn.ContextProvider = a, Cn.Element = t, Cn.ForwardRef = f, Cn.Fragment = r, Cn.Lazy = v, Cn.Memo = b, Cn.Portal = n, Cn.Profiler = i, Cn.StrictMode = o, Cn.Suspense = p, Cn.isAsyncMode = function(P) {
    return T(P) || O(P) === c;
  }, Cn.isConcurrentMode = T, Cn.isContextConsumer = function(P) {
    return O(P) === l;
  }, Cn.isContextProvider = function(P) {
    return O(P) === a;
  }, Cn.isElement = function(P) {
    return typeof P == "object" && P !== null && P.$$typeof === t;
  }, Cn.isForwardRef = function(P) {
    return O(P) === f;
  }, Cn.isFragment = function(P) {
    return O(P) === r;
  }, Cn.isLazy = function(P) {
    return O(P) === v;
  }, Cn.isMemo = function(P) {
    return O(P) === b;
  }, Cn.isPortal = function(P) {
    return O(P) === n;
  }, Cn.isProfiler = function(P) {
    return O(P) === i;
  }, Cn.isStrictMode = function(P) {
    return O(P) === o;
  }, Cn.isSuspense = function(P) {
    return O(P) === p;
  }, Cn.isValidElementType = function(P) {
    return typeof P == "string" || typeof P == "function" || P === r || P === d || P === i || P === o || P === p || P === g || typeof P == "object" && P !== null && (P.$$typeof === v || P.$$typeof === b || P.$$typeof === a || P.$$typeof === l || P.$$typeof === f || P.$$typeof === S || P.$$typeof === E || P.$$typeof === I || P.$$typeof === y);
  }, Cn.typeOf = O, Cn;
}
var xn = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var w1;
function Yz() {
  return w1 || (w1 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, b = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, S = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, I = e ? Symbol.for("react.scope") : 60119;
    function O(q) {
      return typeof q == "string" || typeof q == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      q === r || q === d || q === i || q === o || q === p || q === g || typeof q == "object" && q !== null && (q.$$typeof === v || q.$$typeof === b || q.$$typeof === a || q.$$typeof === l || q.$$typeof === f || q.$$typeof === S || q.$$typeof === E || q.$$typeof === I || q.$$typeof === y);
    }
    function T(q) {
      if (typeof q == "object" && q !== null) {
        var Ee = q.$$typeof;
        switch (Ee) {
          case t:
            var _e = q.type;
            switch (_e) {
              case c:
              case d:
              case r:
              case i:
              case o:
              case p:
                return _e;
              default:
                var $e = _e && _e.$$typeof;
                switch ($e) {
                  case l:
                  case f:
                  case v:
                  case b:
                  case a:
                    return $e;
                  default:
                    return Ee;
                }
            }
          case n:
            return Ee;
        }
      }
    }
    var P = c, R = d, F = l, A = a, _ = t, C = f, D = r, L = v, B = b, H = n, k = i, N = o, j = p, W = !1;
    function V(q) {
      return W || (W = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), $(q) || T(q) === c;
    }
    function $(q) {
      return T(q) === d;
    }
    function z(q) {
      return T(q) === l;
    }
    function ne(q) {
      return T(q) === a;
    }
    function K(q) {
      return typeof q == "object" && q !== null && q.$$typeof === t;
    }
    function Q(q) {
      return T(q) === f;
    }
    function re(q) {
      return T(q) === r;
    }
    function te(q) {
      return T(q) === v;
    }
    function ie(q) {
      return T(q) === b;
    }
    function ae(q) {
      return T(q) === n;
    }
    function ce(q) {
      return T(q) === i;
    }
    function le(q) {
      return T(q) === o;
    }
    function we(q) {
      return T(q) === p;
    }
    xn.AsyncMode = P, xn.ConcurrentMode = R, xn.ContextConsumer = F, xn.ContextProvider = A, xn.Element = _, xn.ForwardRef = C, xn.Fragment = D, xn.Lazy = L, xn.Memo = B, xn.Portal = H, xn.Profiler = k, xn.StrictMode = N, xn.Suspense = j, xn.isAsyncMode = V, xn.isConcurrentMode = $, xn.isContextConsumer = z, xn.isContextProvider = ne, xn.isElement = K, xn.isForwardRef = Q, xn.isFragment = re, xn.isLazy = te, xn.isMemo = ie, xn.isPortal = ae, xn.isProfiler = ce, xn.isStrictMode = le, xn.isSuspense = we, xn.isValidElementType = O, xn.typeOf = T;
  }()), xn;
}
var C1;
function OC() {
  return C1 || (C1 = 1, process.env.NODE_ENV === "production" ? ig.exports = Kz() : ig.exports = Yz()), ig.exports;
}
var U_ = OC(), Qz = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Xz = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, z_ = {};
z_[U_.ForwardRef] = Qz;
z_[U_.Memo] = Xz;
var Jz = !0;
function G_(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? t.push(e[o] + ";") : o && (r += o + " ");
  }), r;
}
var PC = function(t, n, r) {
  var o = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Jz === !1) && t.registered[o] === void 0 && (t.registered[o] = n.styles);
}, IC = function(t, n, r) {
  PC(t, n, r);
  var o = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var i = n;
    do
      t.insert(n === i ? "." + o : "", i, t.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function Zz(e) {
  for (var t = 0, n, r = 0, o = e.length; o >= 4; ++r, o -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var e5 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, t5 = !1, n5 = /[A-Z]|^ms/g, r5 = /_EMO_([^_]+?)_([^]*?)_EMO_/g, W_ = function(t) {
  return t.charCodeAt(1) === 45;
}, x1 = function(t) {
  return t != null && typeof t != "boolean";
}, kv = /* @__PURE__ */ V_(function(e) {
  return W_(e) ? e : e.replace(n5, "-$&").toLowerCase();
}), S1 = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(r5, function(r, o, i) {
          return xs = {
            name: o,
            styles: i,
            next: xs
          }, o;
        });
  }
  return e5[t] !== 1 && !W_(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
}, o5 = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Zf(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var o = n;
      if (o.anim === 1)
        return xs = {
          name: o.name,
          styles: o.styles,
          next: xs
        }, o.name;
      var i = n;
      if (i.styles !== void 0) {
        var a = i.next;
        if (a !== void 0)
          for (; a !== void 0; )
            xs = {
              name: a.name,
              styles: a.styles,
              next: xs
            }, a = a.next;
        var l = i.styles + ";";
        return l;
      }
      return i5(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var c = xs, d = n(e);
        return xs = c, Zf(e, t, d);
      }
      break;
    }
  }
  var f = n;
  if (t == null)
    return f;
  var p = t[f];
  return p !== void 0 ? p : f;
}
function i5(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      r += Zf(e, t, n[o]) + ";";
  else
    for (var i in n) {
      var a = n[i];
      if (typeof a != "object") {
        var l = a;
        t != null && t[l] !== void 0 ? r += i + "{" + t[l] + "}" : x1(l) && (r += kv(i) + ":" + S1(i, l) + ";");
      } else {
        if (i === "NO_COMPONENT_SELECTOR" && t5)
          throw new Error(o5);
        if (Array.isArray(a) && typeof a[0] == "string" && (t == null || t[a[0]] === void 0))
          for (var c = 0; c < a.length; c++)
            x1(a[c]) && (r += kv(i) + ":" + S1(i, a[c]) + ";");
        else {
          var d = Zf(e, t, a);
          switch (i) {
            case "animation":
            case "animationName": {
              r += kv(i) + ":" + d + ";";
              break;
            }
            default:
              r += i + "{" + d + "}";
          }
        }
      }
    }
  return r;
}
var E1 = /label:\s*([^\s;{]+)\s*(;|$)/g, xs;
function Ap(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, o = "";
  xs = void 0;
  var i = e[0];
  if (i == null || i.raw === void 0)
    r = !1, o += Zf(n, t, i);
  else {
    var a = i;
    o += a[0];
  }
  for (var l = 1; l < e.length; l++)
    if (o += Zf(n, t, e[l]), r) {
      var c = i;
      o += c[l];
    }
  E1.lastIndex = 0;
  for (var d = "", f; (f = E1.exec(o)) !== null; )
    d += "-" + f[1];
  var p = Zz(o) + d;
  return {
    name: p,
    styles: o,
    next: xs
  };
}
var s5 = function(t) {
  return t();
}, q_ = m.useInsertionEffect ? m.useInsertionEffect : !1, K_ = q_ || s5, T1 = q_ || m.useLayoutEffect, a5 = !1, Y_ = /* @__PURE__ */ m.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ qz({
    key: "css"
  }) : null
);
Y_.Provider;
var RC = function(t) {
  return /* @__PURE__ */ dz(function(n, r) {
    var o = Li(Y_);
    return t(n, o, r);
  });
}, Dp = /* @__PURE__ */ m.createContext({}), _C = {}.hasOwnProperty, Ww = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", l5 = function(t, n) {
  var r = {};
  for (var o in n)
    _C.call(n, o) && (r[o] = n[o]);
  return r[Ww] = t, r;
}, c5 = function(t) {
  var n = t.cache, r = t.serialized, o = t.isStringTag;
  return PC(n, r, o), K_(function() {
    return IC(n, r, o);
  }), null;
}, u5 = /* @__PURE__ */ RC(function(e, t, n) {
  var r = e.css;
  typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
  var o = e[Ww], i = [r], a = "";
  typeof e.className == "string" ? a = G_(t.registered, i, e.className) : e.className != null && (a = e.className + " ");
  var l = Ap(i, void 0, m.useContext(Dp));
  a += t.key + "-" + l.name;
  var c = {};
  for (var d in e)
    _C.call(e, d) && d !== "css" && d !== Ww && !a5 && (c[d] = e[d]);
  return c.className = a, n && (c.ref = n), /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(c5, {
    cache: t,
    serialized: l,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ m.createElement(o, c));
}), d5 = u5, O1 = function(t, n) {
  var r = arguments;
  if (n == null || !_C.call(n, "css"))
    return m.createElement.apply(void 0, r);
  var o = r.length, i = new Array(o);
  i[0] = d5, i[1] = l5(t, n);
  for (var a = 2; a < o; a++)
    i[a] = r[a];
  return m.createElement.apply(null, i);
};
(function(e) {
  var t;
  t || (t = e.JSX || (e.JSX = {}));
})(O1 || (O1 = {}));
var f5 = /* @__PURE__ */ RC(function(e, t) {
  var n = e.styles, r = Ap([n], void 0, m.useContext(Dp)), o = m.useRef();
  return T1(function() {
    var i = t.key + "-global", a = new t.sheet.constructor({
      key: i,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), l = !1, c = document.querySelector('style[data-emotion="' + i + " " + r.name + '"]');
    return t.sheet.tags.length && (a.before = t.sheet.tags[0]), c !== null && (l = !0, c.setAttribute("data-emotion", i), a.hydrate([c])), o.current = [a, l], function() {
      a.flush();
    };
  }, [t]), T1(function() {
    var i = o.current, a = i[0], l = i[1];
    if (l) {
      i[1] = !1;
      return;
    }
    if (r.next !== void 0 && IC(t, r.next, !0), a.tags.length) {
      var c = a.tags[a.tags.length - 1].nextElementSibling;
      a.before = c, a.flush();
    }
    t.insert("", r, a, !1);
  }, [t, r.name]), null;
});
function El() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Ap(t);
}
function Gs() {
  var e = El.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var p5 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, h5 = /* @__PURE__ */ V_(
  function(e) {
    return p5.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), g5 = !1, m5 = h5, b5 = function(t) {
  return t !== "theme";
}, P1 = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? m5 : b5;
}, I1 = function(t, n, r) {
  var o;
  if (n) {
    var i = n.shouldForwardProp;
    o = t.__emotion_forwardProp && i ? function(a) {
      return t.__emotion_forwardProp(a) && i(a);
    } : i;
  }
  return typeof o != "function" && r && (o = t.__emotion_forwardProp), o;
}, y5 = function(t) {
  var n = t.cache, r = t.serialized, o = t.isStringTag;
  return PC(n, r, o), K_(function() {
    return IC(n, r, o);
  }), null;
}, v5 = function e(t, n) {
  var r = t.__emotion_real === t, o = r && t.__emotion_base || t, i, a;
  n !== void 0 && (i = n.label, a = n.target);
  var l = I1(t, n, r), c = l || P1(o), d = !c("as");
  return function() {
    var f = arguments, p = r && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (i !== void 0 && p.push("label:" + i + ";"), f[0] == null || f[0].raw === void 0)
      p.push.apply(p, f);
    else {
      var g = f[0];
      p.push(g[0]);
      for (var b = f.length, v = 1; v < b; v++)
        p.push(f[v], g[v]);
    }
    var y = RC(function(S, E, I) {
      var O = d && S.as || o, T = "", P = [], R = S;
      if (S.theme == null) {
        R = {};
        for (var F in S)
          R[F] = S[F];
        R.theme = m.useContext(Dp);
      }
      typeof S.className == "string" ? T = G_(E.registered, P, S.className) : S.className != null && (T = S.className + " ");
      var A = Ap(p.concat(P), E.registered, R);
      T += E.key + "-" + A.name, a !== void 0 && (T += " " + a);
      var _ = d && l === void 0 ? P1(O) : c, C = {};
      for (var D in S)
        d && D === "as" || _(D) && (C[D] = S[D]);
      return C.className = T, I && (C.ref = I), /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(y5, {
        cache: E,
        serialized: A,
        isStringTag: typeof O == "string"
      }), /* @__PURE__ */ m.createElement(O, C));
    });
    return y.displayName = i !== void 0 ? i : "Styled(" + (typeof o == "string" ? o : o.displayName || o.name || "Component") + ")", y.defaultProps = t.defaultProps, y.__emotion_real = y, y.__emotion_base = o, y.__emotion_styles = p, y.__emotion_forwardProp = l, Object.defineProperty(y, "toString", {
      value: function() {
        return a === void 0 && g5 ? "NO_COMPONENT_SELECTOR" : "." + a;
      }
    }), y.withComponent = function(S, E) {
      var I = e(S, U({}, n, E, {
        shouldForwardProp: I1(y, E, !0)
      }));
      return I.apply(void 0, p);
    }, y;
  };
}, w5 = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], qw = v5.bind(null);
w5.forEach(function(e) {
  qw[e] = qw(e);
});
var Kw = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Mv, R1;
function C5() {
  if (R1) return Mv;
  R1 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, l = 0; l < 10; l++)
        a["_" + String.fromCharCode(l)] = l;
      var c = Object.getOwnPropertyNames(a).map(function(f) {
        return a[f];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        d[f] = f;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Mv = o() ? Object.assign : function(i, a) {
    for (var l, c = r(i), d, f = 1; f < arguments.length; f++) {
      l = Object(arguments[f]);
      for (var p in l)
        t.call(l, p) && (c[p] = l[p]);
      if (e) {
        d = e(l);
        for (var g = 0; g < d.length; g++)
          n.call(l, d[g]) && (c[d[g]] = l[d[g]]);
      }
    }
    return c;
  }, Mv;
}
var Av, _1;
function kC() {
  if (_1) return Av;
  _1 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Av = e, Av;
}
var Dv, k1;
function Q_() {
  return k1 || (k1 = 1, Dv = Function.call.bind(Object.prototype.hasOwnProperty)), Dv;
}
var Nv, M1;
function x5() {
  if (M1) return Nv;
  M1 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = kC(), n = {}, r = Q_();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function o(i, a, l, c, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in i)
        if (r(i, f)) {
          var p;
          try {
            if (typeof i[f] != "function") {
              var g = Error(
                (c || "React class") + ": " + l + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw g.name = "Invariant Violation", g;
            }
            p = i[f](a, f, c, l, null, t);
          } catch (v) {
            p = v;
          }
          if (p && !(p instanceof Error) && e(
            (c || "React class") + ": type specification of " + l + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof p + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), p instanceof Error && !(p.message in n)) {
            n[p.message] = !0;
            var b = d ? d() : "";
            e(
              "Failed " + l + " type: " + p.message + (b ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Nv = o, Nv;
}
var Fv, A1;
function S5() {
  if (A1) return Fv;
  A1 = 1;
  var e = OC(), t = C5(), n = kC(), r = Q_(), o = x5(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(l) {
    var c = "Warning: " + l;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return Fv = function(l, c) {
    var d = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function p($) {
      var z = $ && (d && $[d] || $[f]);
      if (typeof z == "function")
        return z;
    }
    var g = "<<anonymous>>", b = {
      array: E("array"),
      bigint: E("bigint"),
      bool: E("boolean"),
      func: E("function"),
      number: E("number"),
      object: E("object"),
      string: E("string"),
      symbol: E("symbol"),
      any: I(),
      arrayOf: O,
      element: T(),
      elementType: P(),
      instanceOf: R,
      node: C(),
      objectOf: A,
      oneOf: F,
      oneOfType: _,
      shape: L,
      exact: B
    };
    function v($, z) {
      return $ === z ? $ !== 0 || 1 / $ === 1 / z : $ !== $ && z !== z;
    }
    function y($, z) {
      this.message = $, this.data = z && typeof z == "object" ? z : {}, this.stack = "";
    }
    y.prototype = Error.prototype;
    function S($) {
      if (process.env.NODE_ENV !== "production")
        var z = {}, ne = 0;
      function K(re, te, ie, ae, ce, le, we) {
        if (ae = ae || g, le = le || ie, we !== n) {
          if (c) {
            var q = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw q.name = "Invariant Violation", q;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Ee = ae + ":" + ie;
            !z[Ee] && // Avoid spamming the console because they are often not actionable except for lib authors
            ne < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + le + "` prop on `" + ae + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), z[Ee] = !0, ne++);
          }
        }
        return te[ie] == null ? re ? te[ie] === null ? new y("The " + ce + " `" + le + "` is marked as required " + ("in `" + ae + "`, but its value is `null`.")) : new y("The " + ce + " `" + le + "` is marked as required in " + ("`" + ae + "`, but its value is `undefined`.")) : null : $(te, ie, ae, ce, le);
      }
      var Q = K.bind(null, !1);
      return Q.isRequired = K.bind(null, !0), Q;
    }
    function E($) {
      function z(ne, K, Q, re, te, ie) {
        var ae = ne[K], ce = N(ae);
        if (ce !== $) {
          var le = j(ae);
          return new y(
            "Invalid " + re + " `" + te + "` of type " + ("`" + le + "` supplied to `" + Q + "`, expected ") + ("`" + $ + "`."),
            { expectedType: $ }
          );
        }
        return null;
      }
      return S(z);
    }
    function I() {
      return S(a);
    }
    function O($) {
      function z(ne, K, Q, re, te) {
        if (typeof $ != "function")
          return new y("Property `" + te + "` of component `" + Q + "` has invalid PropType notation inside arrayOf.");
        var ie = ne[K];
        if (!Array.isArray(ie)) {
          var ae = N(ie);
          return new y("Invalid " + re + " `" + te + "` of type " + ("`" + ae + "` supplied to `" + Q + "`, expected an array."));
        }
        for (var ce = 0; ce < ie.length; ce++) {
          var le = $(ie, ce, Q, re, te + "[" + ce + "]", n);
          if (le instanceof Error)
            return le;
        }
        return null;
      }
      return S(z);
    }
    function T() {
      function $(z, ne, K, Q, re) {
        var te = z[ne];
        if (!l(te)) {
          var ie = N(te);
          return new y("Invalid " + Q + " `" + re + "` of type " + ("`" + ie + "` supplied to `" + K + "`, expected a single ReactElement."));
        }
        return null;
      }
      return S($);
    }
    function P() {
      function $(z, ne, K, Q, re) {
        var te = z[ne];
        if (!e.isValidElementType(te)) {
          var ie = N(te);
          return new y("Invalid " + Q + " `" + re + "` of type " + ("`" + ie + "` supplied to `" + K + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return S($);
    }
    function R($) {
      function z(ne, K, Q, re, te) {
        if (!(ne[K] instanceof $)) {
          var ie = $.name || g, ae = V(ne[K]);
          return new y("Invalid " + re + " `" + te + "` of type " + ("`" + ae + "` supplied to `" + Q + "`, expected ") + ("instance of `" + ie + "`."));
        }
        return null;
      }
      return S(z);
    }
    function F($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function z(ne, K, Q, re, te) {
        for (var ie = ne[K], ae = 0; ae < $.length; ae++)
          if (v(ie, $[ae]))
            return null;
        var ce = JSON.stringify($, function(we, q) {
          var Ee = j(q);
          return Ee === "symbol" ? String(q) : q;
        });
        return new y("Invalid " + re + " `" + te + "` of value `" + String(ie) + "` " + ("supplied to `" + Q + "`, expected one of " + ce + "."));
      }
      return S(z);
    }
    function A($) {
      function z(ne, K, Q, re, te) {
        if (typeof $ != "function")
          return new y("Property `" + te + "` of component `" + Q + "` has invalid PropType notation inside objectOf.");
        var ie = ne[K], ae = N(ie);
        if (ae !== "object")
          return new y("Invalid " + re + " `" + te + "` of type " + ("`" + ae + "` supplied to `" + Q + "`, expected an object."));
        for (var ce in ie)
          if (r(ie, ce)) {
            var le = $(ie, ce, Q, re, te + "." + ce, n);
            if (le instanceof Error)
              return le;
          }
        return null;
      }
      return S(z);
    }
    function _($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var z = 0; z < $.length; z++) {
        var ne = $[z];
        if (typeof ne != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + W(ne) + " at index " + z + "."
          ), a;
      }
      function K(Q, re, te, ie, ae) {
        for (var ce = [], le = 0; le < $.length; le++) {
          var we = $[le], q = we(Q, re, te, ie, ae, n);
          if (q == null)
            return null;
          q.data && r(q.data, "expectedType") && ce.push(q.data.expectedType);
        }
        var Ee = ce.length > 0 ? ", expected one of type [" + ce.join(", ") + "]" : "";
        return new y("Invalid " + ie + " `" + ae + "` supplied to " + ("`" + te + "`" + Ee + "."));
      }
      return S(K);
    }
    function C() {
      function $(z, ne, K, Q, re) {
        return H(z[ne]) ? null : new y("Invalid " + Q + " `" + re + "` supplied to " + ("`" + K + "`, expected a ReactNode."));
      }
      return S($);
    }
    function D($, z, ne, K, Q) {
      return new y(
        ($ || "React class") + ": " + z + " type `" + ne + "." + K + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Q + "`."
      );
    }
    function L($) {
      function z(ne, K, Q, re, te) {
        var ie = ne[K], ae = N(ie);
        if (ae !== "object")
          return new y("Invalid " + re + " `" + te + "` of type `" + ae + "` " + ("supplied to `" + Q + "`, expected `object`."));
        for (var ce in $) {
          var le = $[ce];
          if (typeof le != "function")
            return D(Q, re, te, ce, j(le));
          var we = le(ie, ce, Q, re, te + "." + ce, n);
          if (we)
            return we;
        }
        return null;
      }
      return S(z);
    }
    function B($) {
      function z(ne, K, Q, re, te) {
        var ie = ne[K], ae = N(ie);
        if (ae !== "object")
          return new y("Invalid " + re + " `" + te + "` of type `" + ae + "` " + ("supplied to `" + Q + "`, expected `object`."));
        var ce = t({}, ne[K], $);
        for (var le in ce) {
          var we = $[le];
          if (r($, le) && typeof we != "function")
            return D(Q, re, te, le, j(we));
          if (!we)
            return new y(
              "Invalid " + re + " `" + te + "` key `" + le + "` supplied to `" + Q + "`.\nBad object: " + JSON.stringify(ne[K], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys($), null, "  ")
            );
          var q = we(ie, le, Q, re, te + "." + le, n);
          if (q)
            return q;
        }
        return null;
      }
      return S(z);
    }
    function H($) {
      switch (typeof $) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !$;
        case "object":
          if (Array.isArray($))
            return $.every(H);
          if ($ === null || l($))
            return !0;
          var z = p($);
          if (z) {
            var ne = z.call($), K;
            if (z !== $.entries) {
              for (; !(K = ne.next()).done; )
                if (!H(K.value))
                  return !1;
            } else
              for (; !(K = ne.next()).done; ) {
                var Q = K.value;
                if (Q && !H(Q[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function k($, z) {
      return $ === "symbol" ? !0 : z ? z["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && z instanceof Symbol : !1;
    }
    function N($) {
      var z = typeof $;
      return Array.isArray($) ? "array" : $ instanceof RegExp ? "object" : k(z, $) ? "symbol" : z;
    }
    function j($) {
      if (typeof $ > "u" || $ === null)
        return "" + $;
      var z = N($);
      if (z === "object") {
        if ($ instanceof Date)
          return "date";
        if ($ instanceof RegExp)
          return "regexp";
      }
      return z;
    }
    function W($) {
      var z = j($);
      switch (z) {
        case "array":
        case "object":
          return "an " + z;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + z;
        default:
          return z;
      }
    }
    function V($) {
      return !$.constructor || !$.constructor.name ? g : $.constructor.name;
    }
    return b.checkPropTypes = o, b.resetWarningCache = o.resetWarningCache, b.PropTypes = b, b;
  }, Fv;
}
var $v, D1;
function E5() {
  if (D1) return $v;
  D1 = 1;
  var e = kC();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, $v = function() {
    function r(a, l, c, d, f, p) {
      if (p !== e) {
        var g = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw g.name = "Invariant Violation", g;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, $v;
}
if (process.env.NODE_ENV !== "production") {
  var T5 = OC(), O5 = !0;
  Kw.exports = S5()(T5.isElement, O5);
} else
  Kw.exports = E5()();
var P5 = Kw.exports;
const s = /* @__PURE__ */ D_(P5);
function I5(e) {
  return e == null || Object.keys(e).length === 0;
}
function MC(e) {
  const {
    styles: t,
    defaultTheme: n = {}
  } = e, r = typeof t == "function" ? (o) => t(I5(o) ? n : o) : t;
  return /* @__PURE__ */ w.jsx(f5, {
    styles: r
  });
}
process.env.NODE_ENV !== "production" && (MC.propTypes = {
  defaultTheme: s.object,
  styles: s.oneOfType([s.array, s.string, s.object, s.func])
});
/**
 * @mui/styled-engine v6.3.1
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function X_(e, t) {
  const n = qw(e, t);
  return process.env.NODE_ENV !== "production" ? (...r) => {
    const o = typeof e == "string" ? `"${e}"` : "component";
    return r.length === 0 ? console.error([`MUI: Seems like you called \`styled(${o})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : r.some((i) => i === void 0) && console.error(`MUI: the styled(${o})(...args) API requires all its args to be defined.`), n(...r);
  } : n;
}
function R5(e, t) {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}
const N1 = [];
function F1(e) {
  return N1[0] = e, Ap(N1);
}
function Os(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function J_(e) {
  if (/* @__PURE__ */ m.isValidElement(e) || !Os(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = J_(e[n]);
  }), t;
}
function Jr(e, t, n = {
  clone: !0
}) {
  const r = n.clone ? {
    ...e
  } : e;
  return Os(e) && Os(t) && Object.keys(t).forEach((o) => {
    /* @__PURE__ */ m.isValidElement(t[o]) ? r[o] = t[o] : Os(t[o]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, o) && Os(e[o]) ? r[o] = Jr(e[o], t[o], n) : n.clone ? r[o] = Os(t[o]) ? J_(t[o]) : t[o] : r[o] = t[o];
  }), r;
}
const _5 = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, r) => n.val - r.val), t.reduce((n, r) => ({
    ...n,
    [r.key]: r.val
  }), {});
};
function k5(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: r = 5,
    ...o
  } = e, i = _5(t), a = Object.keys(i);
  function l(g) {
    return `@media (min-width:${typeof t[g] == "number" ? t[g] : g}${n})`;
  }
  function c(g) {
    return `@media (max-width:${(typeof t[g] == "number" ? t[g] : g) - r / 100}${n})`;
  }
  function d(g, b) {
    const v = a.indexOf(b);
    return `@media (min-width:${typeof t[g] == "number" ? t[g] : g}${n}) and (max-width:${(v !== -1 && typeof t[a[v]] == "number" ? t[a[v]] : b) - r / 100}${n})`;
  }
  function f(g) {
    return a.indexOf(g) + 1 < a.length ? d(g, a[a.indexOf(g) + 1]) : l(g);
  }
  function p(g) {
    const b = a.indexOf(g);
    return b === 0 ? l(a[1]) : b === a.length - 1 ? c(a[b]) : d(g, a[a.indexOf(g) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: a,
    values: i,
    up: l,
    down: c,
    between: d,
    only: f,
    not: p,
    unit: n,
    ...o
  };
}
function M5(e, t) {
  if (!e.containerQueries)
    return t;
  const n = Object.keys(t).filter((r) => r.startsWith("@container")).sort((r, o) => {
    var a, l;
    const i = /min-width:\s*([0-9.]+)/;
    return +(((a = r.match(i)) == null ? void 0 : a[1]) || 0) - +(((l = o.match(i)) == null ? void 0 : l[1]) || 0);
  });
  return n.length ? n.reduce((r, o) => {
    const i = t[o];
    return delete r[o], r[o] = i, r;
  }, {
    ...t
  }) : t;
}
function A5(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((n) => t.startsWith(`@${n}`)) || !!t.match(/^@\d/));
}
function D5(e, t) {
  const n = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!n) {
    if (process.env.NODE_ENV !== "production")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${t})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.` : Bs(18, `(${t})`));
    return null;
  }
  const [, r, o] = n, i = Number.isNaN(+r) ? r || 0 : +r;
  return e.containerQueries(o).up(i);
}
function N5(e) {
  const t = (i, a) => i.replace("@media", a ? `@container ${a}` : "@container");
  function n(i, a) {
    i.up = (...l) => t(e.breakpoints.up(...l), a), i.down = (...l) => t(e.breakpoints.down(...l), a), i.between = (...l) => t(e.breakpoints.between(...l), a), i.only = (...l) => t(e.breakpoints.only(...l), a), i.not = (...l) => {
      const c = t(e.breakpoints.not(...l), a);
      return c.includes("not all and") ? c.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : c;
    };
  }
  const r = {}, o = (i) => (n(r, i), r);
  return n(o), {
    ...e,
    containerQueries: o
  };
}
const F5 = {
  borderRadius: 4
}, Tl = process.env.NODE_ENV !== "production" ? s.oneOfType([s.number, s.string, s.object, s.array]) : {};
function Lf(e, t) {
  return t ? Jr(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const Ym = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, $1 = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Ym[e]}px)`
}, $5 = {
  containerQueries: (e) => ({
    up: (t) => {
      let n = typeof t == "number" ? t : Ym[t] || t;
      return typeof n == "number" && (n = `${n}px`), e ? `@container ${e} (min-width:${n})` : `@container (min-width:${n})`;
    }
  })
};
function is(e, t, n) {
  const r = e.theme || {};
  if (Array.isArray(t)) {
    const i = r.breakpoints || $1;
    return t.reduce((a, l, c) => (a[i.up(i.keys[c])] = n(t[c]), a), {});
  }
  if (typeof t == "object") {
    const i = r.breakpoints || $1;
    return Object.keys(t).reduce((a, l) => {
      if (A5(i.keys, l)) {
        const c = D5(r.containerQueries ? r : $5, l);
        c && (a[c] = n(t[l], l));
      } else if (Object.keys(i.values || Ym).includes(l)) {
        const c = i.up(l);
        a[c] = n(t[l], l);
      } else {
        const c = l;
        a[c] = t[c];
      }
      return a;
    }, {});
  }
  return n(t);
}
function Z_(e = {}) {
  var n;
  return ((n = e.keys) == null ? void 0 : n.reduce((r, o) => {
    const i = e.up(o);
    return r[i] = {}, r;
  }, {})) || {};
}
function ek(e, t) {
  return e.reduce((n, r) => {
    const o = n[r];
    return (!o || Object.keys(o).length === 0) && delete n[r], n;
  }, t);
}
function L5(e, ...t) {
  const n = Z_(e), r = [n, ...t].reduce((o, i) => Jr(o, i), {});
  return ek(Object.keys(n), r);
}
function j5(e, t) {
  if (typeof e != "object")
    return {};
  const n = {}, r = Object.keys(t);
  return Array.isArray(e) ? r.forEach((o, i) => {
    i < e.length && (n[o] = !0);
  }) : r.forEach((o) => {
    e[o] != null && (n[o] = !0);
  }), n;
}
function Lv({
  values: e,
  breakpoints: t,
  base: n
}) {
  const r = n || j5(e, t), o = Object.keys(r);
  if (o.length === 0)
    return e;
  let i;
  return o.reduce((a, l, c) => (Array.isArray(e) ? (a[l] = e[c] != null ? e[c] : e[i], i = c) : typeof e == "object" ? (a[l] = e[l] != null ? e[l] : e[i], i = l) : a[l] = e, a), {});
}
function Me(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : Bs(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function id(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const r = `vars.${t}`.split(".").reduce((o, i) => o && o[i] ? o[i] : null, e);
    if (r != null)
      return r;
  }
  return t.split(".").reduce((r, o) => r && r[o] != null ? r[o] : null, e);
}
function Jg(e, t, n, r = n) {
  let o;
  return typeof e == "function" ? o = e(n) : Array.isArray(e) ? o = e[n] || r : o = id(e, n) || r, t && (o = t(o, r, e)), o;
}
function _r(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: r,
    transform: o
  } = e, i = (a) => {
    if (a[t] == null)
      return null;
    const l = a[t], c = a.theme, d = id(c, r) || {};
    return is(a, l, (p) => {
      let g = Jg(d, o, p);
      return p === g && typeof p == "string" && (g = Jg(d, o, `${t}${p === "default" ? "" : Me(p)}`, p)), n === !1 ? g : {
        [n]: g
      };
    });
  };
  return i.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: Tl
  } : {}, i.filterProps = [t], i;
}
function B5(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const V5 = {
  m: "margin",
  p: "padding"
}, H5 = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, L1 = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, U5 = B5((e) => {
  if (e.length > 2)
    if (L1[e])
      e = L1[e];
    else
      return [e];
  const [t, n] = e.split(""), r = V5[t], o = H5[n] || "";
  return Array.isArray(o) ? o.map((i) => r + i) : [r + o];
}), Qm = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], Xm = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], z5 = [...Qm, ...Xm];
function Np(e, t, n, r) {
  const o = id(e, t, !0) ?? n;
  return typeof o == "number" || typeof o == "string" ? (i) => typeof i == "string" ? i : (process.env.NODE_ENV !== "production" && typeof i != "number" && console.error(`MUI: Expected ${r} argument to be a number or a string, got ${i}.`), typeof o == "string" ? `calc(${i} * ${o})` : o * i) : Array.isArray(o) ? (i) => {
    if (typeof i == "string")
      return i;
    const a = Math.abs(i);
    process.env.NODE_ENV !== "production" && (Number.isInteger(a) ? a > o.length - 1 && console.error([`MUI: The value provided (${a}) overflows.`, `The supported values are: ${JSON.stringify(o)}.`, `${a} > ${o.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`)));
    const l = o[a];
    return i >= 0 ? l : typeof l == "number" ? -l : `-${l}`;
  } : typeof o == "function" ? o : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${o}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function Jm(e) {
  return Np(e, "spacing", 8, "spacing");
}
function vc(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function G5(e, t) {
  return (n) => e.reduce((r, o) => (r[o] = vc(t, n), r), {});
}
function W5(e, t, n, r) {
  if (!t.includes(n))
    return null;
  const o = U5(n), i = G5(o, r), a = e[n];
  return is(e, a, i);
}
function tk(e, t) {
  const n = Jm(e.theme);
  return Object.keys(e).map((r) => W5(e, t, r, n)).reduce(Lf, {});
}
function gr(e) {
  return tk(e, Qm);
}
gr.propTypes = process.env.NODE_ENV !== "production" ? Qm.reduce((e, t) => (e[t] = Tl, e), {}) : {};
gr.filterProps = Qm;
function mr(e) {
  return tk(e, Xm);
}
mr.propTypes = process.env.NODE_ENV !== "production" ? Xm.reduce((e, t) => (e[t] = Tl, e), {}) : {};
mr.filterProps = Xm;
process.env.NODE_ENV !== "production" && z5.reduce((e, t) => (e[t] = Tl, e), {});
function nk(e = 8, t = Jm({
  spacing: e
})) {
  if (e.mui)
    return e;
  const n = (...r) => (process.env.NODE_ENV !== "production" && (r.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${r.length}`)), (r.length === 0 ? [1] : r).map((i) => {
    const a = t(i);
    return typeof a == "number" ? `${a}px` : a;
  }).join(" "));
  return n.mui = !0, n;
}
function Zm(...e) {
  const t = e.reduce((r, o) => (o.filterProps.forEach((i) => {
    r[i] = o;
  }), r), {}), n = (r) => Object.keys(r).reduce((o, i) => t[i] ? Lf(o, t[i](r)) : o, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((r, o) => Object.assign(r, o.propTypes), {}) : {}, n.filterProps = e.reduce((r, o) => r.concat(o.filterProps), []), n;
}
function ki(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function ji(e, t) {
  return _r({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const q5 = ji("border", ki), K5 = ji("borderTop", ki), Y5 = ji("borderRight", ki), Q5 = ji("borderBottom", ki), X5 = ji("borderLeft", ki), J5 = ji("borderColor"), Z5 = ji("borderTopColor"), eG = ji("borderRightColor"), tG = ji("borderBottomColor"), nG = ji("borderLeftColor"), rG = ji("outline", ki), oG = ji("outlineColor"), eb = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = Np(e.theme, "shape.borderRadius", 4, "borderRadius"), n = (r) => ({
      borderRadius: vc(t, r)
    });
    return is(e, e.borderRadius, n);
  }
  return null;
};
eb.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: Tl
} : {};
eb.filterProps = ["borderRadius"];
Zm(q5, K5, Y5, Q5, X5, J5, Z5, eG, tG, nG, eb, rG, oG);
const tb = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = Np(e.theme, "spacing", 8, "gap"), n = (r) => ({
      gap: vc(t, r)
    });
    return is(e, e.gap, n);
  }
  return null;
};
tb.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: Tl
} : {};
tb.filterProps = ["gap"];
const nb = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = Np(e.theme, "spacing", 8, "columnGap"), n = (r) => ({
      columnGap: vc(t, r)
    });
    return is(e, e.columnGap, n);
  }
  return null;
};
nb.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: Tl
} : {};
nb.filterProps = ["columnGap"];
const rb = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = Np(e.theme, "spacing", 8, "rowGap"), n = (r) => ({
      rowGap: vc(t, r)
    });
    return is(e, e.rowGap, n);
  }
  return null;
};
rb.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: Tl
} : {};
rb.filterProps = ["rowGap"];
const iG = _r({
  prop: "gridColumn"
}), sG = _r({
  prop: "gridRow"
}), aG = _r({
  prop: "gridAutoFlow"
}), lG = _r({
  prop: "gridAutoColumns"
}), cG = _r({
  prop: "gridAutoRows"
}), uG = _r({
  prop: "gridTemplateColumns"
}), dG = _r({
  prop: "gridTemplateRows"
}), fG = _r({
  prop: "gridTemplateAreas"
}), pG = _r({
  prop: "gridArea"
});
Zm(tb, nb, rb, iG, sG, aG, lG, cG, uG, dG, fG, pG);
function Nu(e, t) {
  return t === "grey" ? t : e;
}
const hG = _r({
  prop: "color",
  themeKey: "palette",
  transform: Nu
}), gG = _r({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: Nu
}), mG = _r({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: Nu
});
Zm(hG, gG, mG);
function si(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const bG = _r({
  prop: "width",
  transform: si
}), AC = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var o, i, a, l, c;
      const r = ((a = (i = (o = e.theme) == null ? void 0 : o.breakpoints) == null ? void 0 : i.values) == null ? void 0 : a[n]) || Ym[n];
      return r ? ((c = (l = e.theme) == null ? void 0 : l.breakpoints) == null ? void 0 : c.unit) !== "px" ? {
        maxWidth: `${r}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: r
      } : {
        maxWidth: si(n)
      };
    };
    return is(e, e.maxWidth, t);
  }
  return null;
};
AC.filterProps = ["maxWidth"];
const yG = _r({
  prop: "minWidth",
  transform: si
}), vG = _r({
  prop: "height",
  transform: si
}), wG = _r({
  prop: "maxHeight",
  transform: si
}), CG = _r({
  prop: "minHeight",
  transform: si
});
_r({
  prop: "size",
  cssProperty: "width",
  transform: si
});
_r({
  prop: "size",
  cssProperty: "height",
  transform: si
});
const xG = _r({
  prop: "boxSizing"
});
Zm(bG, AC, yG, vG, wG, CG, xG);
const Fp = {
  // borders
  border: {
    themeKey: "borders",
    transform: ki
  },
  borderTop: {
    themeKey: "borders",
    transform: ki
  },
  borderRight: {
    themeKey: "borders",
    transform: ki
  },
  borderBottom: {
    themeKey: "borders",
    transform: ki
  },
  borderLeft: {
    themeKey: "borders",
    transform: ki
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: ki
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: eb
  },
  // palette
  color: {
    themeKey: "palette",
    transform: Nu
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: Nu
  },
  backgroundColor: {
    themeKey: "palette",
    transform: Nu
  },
  // spacing
  p: {
    style: mr
  },
  pt: {
    style: mr
  },
  pr: {
    style: mr
  },
  pb: {
    style: mr
  },
  pl: {
    style: mr
  },
  px: {
    style: mr
  },
  py: {
    style: mr
  },
  padding: {
    style: mr
  },
  paddingTop: {
    style: mr
  },
  paddingRight: {
    style: mr
  },
  paddingBottom: {
    style: mr
  },
  paddingLeft: {
    style: mr
  },
  paddingX: {
    style: mr
  },
  paddingY: {
    style: mr
  },
  paddingInline: {
    style: mr
  },
  paddingInlineStart: {
    style: mr
  },
  paddingInlineEnd: {
    style: mr
  },
  paddingBlock: {
    style: mr
  },
  paddingBlockStart: {
    style: mr
  },
  paddingBlockEnd: {
    style: mr
  },
  m: {
    style: gr
  },
  mt: {
    style: gr
  },
  mr: {
    style: gr
  },
  mb: {
    style: gr
  },
  ml: {
    style: gr
  },
  mx: {
    style: gr
  },
  my: {
    style: gr
  },
  margin: {
    style: gr
  },
  marginTop: {
    style: gr
  },
  marginRight: {
    style: gr
  },
  marginBottom: {
    style: gr
  },
  marginLeft: {
    style: gr
  },
  marginX: {
    style: gr
  },
  marginY: {
    style: gr
  },
  marginInline: {
    style: gr
  },
  marginInlineStart: {
    style: gr
  },
  marginInlineEnd: {
    style: gr
  },
  marginBlock: {
    style: gr
  },
  marginBlockStart: {
    style: gr
  },
  marginBlockEnd: {
    style: gr
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: tb
  },
  rowGap: {
    style: rb
  },
  columnGap: {
    style: nb
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: si
  },
  maxWidth: {
    style: AC
  },
  minWidth: {
    transform: si
  },
  height: {
    transform: si
  },
  maxHeight: {
    transform: si
  },
  minHeight: {
    transform: si
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function SG(...e) {
  const t = e.reduce((r, o) => r.concat(Object.keys(o)), []), n = new Set(t);
  return e.every((r) => n.size === Object.keys(r).length);
}
function EG(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function TG() {
  function e(n, r, o, i) {
    const a = {
      [n]: r,
      theme: o
    }, l = i[n];
    if (!l)
      return {
        [n]: r
      };
    const {
      cssProperty: c = n,
      themeKey: d,
      transform: f,
      style: p
    } = l;
    if (r == null)
      return null;
    if (d === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const g = id(o, d) || {};
    return p ? p(a) : is(a, r, (v) => {
      let y = Jg(g, f, v);
      return v === y && typeof v == "string" && (y = Jg(g, f, `${n}${v === "default" ? "" : Me(v)}`, v)), c === !1 ? y : {
        [c]: y
      };
    });
  }
  function t(n) {
    const {
      sx: r,
      theme: o = {}
    } = n || {};
    if (!r)
      return null;
    const i = o.unstable_sxConfig ?? Fp;
    function a(l) {
      let c = l;
      if (typeof l == "function")
        c = l(o);
      else if (typeof l != "object")
        return l;
      if (!c)
        return null;
      const d = Z_(o.breakpoints), f = Object.keys(d);
      let p = d;
      return Object.keys(c).forEach((g) => {
        const b = EG(c[g], o);
        if (b != null)
          if (typeof b == "object")
            if (i[g])
              p = Lf(p, e(g, b, o, i));
            else {
              const v = is({
                theme: o
              }, b, (y) => ({
                [g]: y
              }));
              SG(v, b) ? p[g] = t({
                sx: b,
                theme: o
              }) : p = Lf(p, v);
            }
          else
            p = Lf(p, e(g, b, o, i));
      }), M5(o, ek(f, p));
    }
    return Array.isArray(r) ? r.map(a) : a(r);
  }
  return t;
}
const hl = TG();
hl.filterProps = ["sx"];
function OG(e, t) {
  var r;
  const n = this;
  if (n.vars) {
    if (!((r = n.colorSchemes) != null && r[e]) || typeof n.getColorSchemeSelector != "function")
      return {};
    let o = n.getColorSchemeSelector(e);
    return o === "&" ? t : ((o.includes("data-") || o.includes(".")) && (o = `*:where(${o.replace(/\s*&$/, "")}) &`), {
      [o]: t
    });
  }
  return n.palette.mode === e ? t : {};
}
function $p(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: r = {},
    spacing: o,
    shape: i = {},
    ...a
  } = e, l = k5(n), c = nk(o);
  let d = Jr({
    breakpoints: l,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...r
    },
    spacing: c,
    shape: {
      ...F5,
      ...i
    }
  }, a);
  return d = N5(d), d.applyStyles = OG, d = t.reduce((f, p) => Jr(f, p), d), d.unstable_sxConfig = {
    ...Fp,
    ...a == null ? void 0 : a.unstable_sxConfig
  }, d.unstable_sx = function(p) {
    return hl({
      sx: p,
      theme: this
    });
  }, d;
}
function PG(e) {
  return Object.keys(e).length === 0;
}
function DC(e = null) {
  const t = m.useContext(Dp);
  return !t || PG(t) ? e : t;
}
const IG = $p();
function Lp(e = IG) {
  return DC(e);
}
function rk({
  styles: e,
  themeId: t,
  defaultTheme: n = {}
}) {
  const r = Lp(n), o = typeof e == "function" ? e(t && r[t] || r) : e;
  return /* @__PURE__ */ w.jsx(MC, {
    styles: o
  });
}
process.env.NODE_ENV !== "production" && (rk.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: s.object,
  /**
   * @ignore
   */
  styles: s.oneOfType([s.array, s.func, s.number, s.object, s.string, s.bool]),
  /**
   * @ignore
   */
  themeId: s.string
});
const RG = (e) => {
  var r;
  const t = {
    systemProps: {},
    otherProps: {}
  }, n = ((r = e == null ? void 0 : e.theme) == null ? void 0 : r.unstable_sxConfig) ?? Fp;
  return Object.keys(e).forEach((o) => {
    n[o] ? t.systemProps[o] = e[o] : t.otherProps[o] = e[o];
  }), t;
};
function ob(e) {
  const {
    sx: t,
    ...n
  } = e, {
    systemProps: r,
    otherProps: o
  } = RG(n);
  let i;
  return Array.isArray(t) ? i = [r, ...t] : typeof t == "function" ? i = (...a) => {
    const l = t(...a);
    return Os(l) ? {
      ...r,
      ...l
    } : r;
  } : i = {
    ...r,
    ...t
  }, {
    ...o,
    sx: i
  };
}
const j1 = (e) => e, _G = () => {
  let e = j1;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = j1;
    }
  };
}, ok = _G();
function ik(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = ik(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function ke() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = ik(e)) && (r && (r += " "), r += t);
  return r;
}
function kG(e = {}) {
  const {
    themeId: t,
    defaultTheme: n,
    defaultClassName: r = "MuiBox-root",
    generateClassName: o
  } = e, i = X_("div", {
    shouldForwardProp: (l) => l !== "theme" && l !== "sx" && l !== "as"
  })(hl);
  return /* @__PURE__ */ m.forwardRef(function(c, d) {
    const f = Lp(n), {
      className: p,
      component: g = "div",
      ...b
    } = ob(c);
    return /* @__PURE__ */ w.jsx(i, {
      as: g,
      ref: d,
      className: ke(p, o ? o(r) : r),
      theme: t && f[t] || f,
      ...b
    });
  });
}
const MG = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function gt(e, t, n = "Mui") {
  const r = MG[t];
  return r ? `${n}-${r}` : `${ok.generate(e)}-${t}`;
}
function vt(e, t, n = "Mui") {
  const r = {};
  return t.forEach((o) => {
    r[o] = gt(e, o, n);
  }), r;
}
var Yw = { exports: {} }, Mn = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var B1;
function AG() {
  if (B1) return Mn;
  B1 = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.consumer"), a = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), b = Symbol.for("react.client.reference");
  function v(y) {
    if (typeof y == "object" && y !== null) {
      var S = y.$$typeof;
      switch (S) {
        case e:
          switch (y = y.type, y) {
            case n:
            case o:
            case r:
            case c:
            case d:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case a:
                case l:
                case p:
                case f:
                  return y;
                case i:
                  return y;
                default:
                  return S;
              }
          }
        case t:
          return S;
      }
    }
  }
  return Mn.ContextConsumer = i, Mn.ContextProvider = a, Mn.Element = e, Mn.ForwardRef = l, Mn.Fragment = n, Mn.Lazy = p, Mn.Memo = f, Mn.Portal = t, Mn.Profiler = o, Mn.StrictMode = r, Mn.Suspense = c, Mn.SuspenseList = d, Mn.isContextConsumer = function(y) {
    return v(y) === i;
  }, Mn.isContextProvider = function(y) {
    return v(y) === a;
  }, Mn.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, Mn.isForwardRef = function(y) {
    return v(y) === l;
  }, Mn.isFragment = function(y) {
    return v(y) === n;
  }, Mn.isLazy = function(y) {
    return v(y) === p;
  }, Mn.isMemo = function(y) {
    return v(y) === f;
  }, Mn.isPortal = function(y) {
    return v(y) === t;
  }, Mn.isProfiler = function(y) {
    return v(y) === o;
  }, Mn.isStrictMode = function(y) {
    return v(y) === r;
  }, Mn.isSuspense = function(y) {
    return v(y) === c;
  }, Mn.isSuspenseList = function(y) {
    return v(y) === d;
  }, Mn.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === o || y === r || y === c || y === d || y === g || typeof y == "object" && y !== null && (y.$$typeof === p || y.$$typeof === f || y.$$typeof === a || y.$$typeof === i || y.$$typeof === l || y.$$typeof === b || y.getModuleId !== void 0);
  }, Mn.typeOf = v, Mn;
}
var An = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var V1;
function DG() {
  return V1 || (V1 = 1, process.env.NODE_ENV !== "production" && function() {
    function e(y) {
      if (typeof y == "object" && y !== null) {
        var S = y.$$typeof;
        switch (S) {
          case t:
            switch (y = y.type, y) {
              case r:
              case i:
              case o:
              case d:
              case f:
                return y;
              default:
                switch (y = y && y.$$typeof, y) {
                  case l:
                  case c:
                  case g:
                  case p:
                    return y;
                  case a:
                    return y;
                  default:
                    return S;
                }
            }
          case n:
            return S;
        }
      }
    }
    var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.consumer"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), b = Symbol.for("react.offscreen"), v = Symbol.for("react.client.reference");
    An.ContextConsumer = a, An.ContextProvider = l, An.Element = t, An.ForwardRef = c, An.Fragment = r, An.Lazy = g, An.Memo = p, An.Portal = n, An.Profiler = i, An.StrictMode = o, An.Suspense = d, An.SuspenseList = f, An.isContextConsumer = function(y) {
      return e(y) === a;
    }, An.isContextProvider = function(y) {
      return e(y) === l;
    }, An.isElement = function(y) {
      return typeof y == "object" && y !== null && y.$$typeof === t;
    }, An.isForwardRef = function(y) {
      return e(y) === c;
    }, An.isFragment = function(y) {
      return e(y) === r;
    }, An.isLazy = function(y) {
      return e(y) === g;
    }, An.isMemo = function(y) {
      return e(y) === p;
    }, An.isPortal = function(y) {
      return e(y) === n;
    }, An.isProfiler = function(y) {
      return e(y) === i;
    }, An.isStrictMode = function(y) {
      return e(y) === o;
    }, An.isSuspense = function(y) {
      return e(y) === d;
    }, An.isSuspenseList = function(y) {
      return e(y) === f;
    }, An.isValidElementType = function(y) {
      return typeof y == "string" || typeof y == "function" || y === r || y === i || y === o || y === d || y === f || y === b || typeof y == "object" && y !== null && (y.$$typeof === g || y.$$typeof === p || y.$$typeof === l || y.$$typeof === a || y.$$typeof === c || y.$$typeof === v || y.getModuleId !== void 0);
    }, An.typeOf = e;
  }()), An;
}
process.env.NODE_ENV === "production" ? Yw.exports = AG() : Yw.exports = DG();
var sd = Yw.exports;
function sk(e, t = "") {
  return e.displayName || e.name || t;
}
function H1(e, t, n) {
  const r = sk(t);
  return e.displayName || (r !== "" ? `${n}(${r})` : n);
}
function NG(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return sk(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case sd.ForwardRef:
          return H1(e, e.render, "ForwardRef");
        case sd.Memo:
          return H1(e, e.type, "memo");
        default:
          return;
      }
  }
}
function ak(e) {
  const {
    variants: t,
    ...n
  } = e, r = {
    variants: t,
    style: F1(n),
    isProcessed: !0
  };
  return r.style === n || t && t.forEach((o) => {
    typeof o.style != "function" && (o.style = F1(o.style));
  }), r;
}
const FG = $p();
function jv(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function $G(e) {
  return e ? (t, n) => n[e] : null;
}
function LG(e, t, n) {
  e.theme = VG(e.theme) ? n : e.theme[t] || e.theme;
}
function $g(e, t) {
  const n = typeof t == "function" ? t(e) : t;
  if (Array.isArray(n))
    return n.flatMap((r) => $g(e, r));
  if (Array.isArray(n == null ? void 0 : n.variants)) {
    let r;
    if (n.isProcessed)
      r = n.style;
    else {
      const {
        variants: o,
        ...i
      } = n;
      r = i;
    }
    return lk(e, n.variants, [r]);
  }
  return n != null && n.isProcessed ? n.style : n;
}
function lk(e, t, n = []) {
  var o;
  let r;
  e: for (let i = 0; i < t.length; i += 1) {
    const a = t[i];
    if (typeof a.props == "function") {
      if (r ?? (r = {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }), !a.props(r))
        continue;
    } else
      for (const l in a.props)
        if (e[l] !== a.props[l] && ((o = e.ownerState) == null ? void 0 : o[l]) !== a.props[l])
          continue e;
    typeof a.style == "function" ? (r ?? (r = {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }), n.push(a.style(r))) : n.push(a.style);
  }
  return n;
}
function ck(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = FG,
    rootShouldForwardProp: r = jv,
    slotShouldForwardProp: o = jv
  } = e;
  function i(l) {
    LG(l, t, n);
  }
  return (l, c = {}) => {
    R5(l, (P) => P.filter((R) => R !== hl));
    const {
      name: d,
      slot: f,
      skipVariantsResolver: p,
      skipSx: g,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: b = $G(uk(f)),
      ...v
    } = c, y = p !== void 0 ? p : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      f && f !== "Root" && f !== "root" || !1
    ), S = g || !1;
    let E = jv;
    f === "Root" || f === "root" ? E = r : f ? E = o : HG(l) && (E = void 0);
    const I = X_(l, {
      shouldForwardProp: E,
      label: BG(d, f),
      ...v
    }), O = (P) => {
      if (typeof P == "function" && P.__emotion_real !== P)
        return function(F) {
          return $g(F, P);
        };
      if (Os(P)) {
        const R = ak(P);
        return R.variants ? function(A) {
          return $g(A, R);
        } : R.style;
      }
      return P;
    }, T = (...P) => {
      const R = [], F = P.map(O), A = [];
      if (R.push(i), d && b && A.push(function(L) {
        var N, j;
        const H = (j = (N = L.theme.components) == null ? void 0 : N[d]) == null ? void 0 : j.styleOverrides;
        if (!H)
          return null;
        const k = {};
        for (const W in H)
          k[W] = $g(L, H[W]);
        return b(L, k);
      }), d && !y && A.push(function(L) {
        var k, N;
        const B = L.theme, H = (N = (k = B == null ? void 0 : B.components) == null ? void 0 : k[d]) == null ? void 0 : N.variants;
        return H ? lk(L, H) : null;
      }), S || A.push(hl), Array.isArray(F[0])) {
        const D = F.shift(), L = new Array(R.length).fill(""), B = new Array(A.length).fill("");
        let H;
        H = [...L, ...D, ...B], H.raw = [...L, ...D.raw, ...B], R.unshift(H);
      }
      const _ = [...R, ...F, ...A], C = I(..._);
      return l.muiName && (C.muiName = l.muiName), process.env.NODE_ENV !== "production" && (C.displayName = jG(d, f, l)), C;
    };
    return I.withConfig && (T.withConfig = I.withConfig), T;
  };
}
function jG(e, t, n) {
  return e ? `${e}${Me(t || "")}` : `Styled(${NG(n)})`;
}
function BG(e, t) {
  let n;
  return process.env.NODE_ENV !== "production" && e && (n = `${e}-${uk(t || "Root")}`), n;
}
function VG(e) {
  for (const t in e)
    return !1;
  return !0;
}
function HG(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function uk(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
const On = ck();
function ep(e, t) {
  const n = {
    ...t
  };
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      const o = r;
      if (o === "components" || o === "slots")
        n[o] = {
          ...e[o],
          ...n[o]
        };
      else if (o === "componentsProps" || o === "slotProps") {
        const i = e[o], a = t[o];
        if (!a)
          n[o] = i || {};
        else if (!i)
          n[o] = a;
        else {
          n[o] = {
            ...a
          };
          for (const l in i)
            if (Object.prototype.hasOwnProperty.call(i, l)) {
              const c = l;
              n[o][c] = ep(i[c], a[c]);
            }
        }
      } else n[o] === void 0 && (n[o] = e[o]);
    }
  return n;
}
function dk(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  return !t || !t.components || !t.components[n] || !t.components[n].defaultProps ? r : ep(t.components[n].defaultProps, r);
}
function NC({
  props: e,
  name: t,
  defaultTheme: n,
  themeId: r
}) {
  let o = Lp(n);
  return r && (o = o[r] || o), dk({
    theme: o,
    name: t,
    props: e
  });
}
const ss = typeof window < "u" ? m.useLayoutEffect : m.useEffect;
function UG(e, t, n, r, o) {
  const [i, a] = m.useState(() => o && n ? n(e).matches : r ? r(e).matches : t);
  return ss(() => {
    if (!n)
      return;
    const l = n(e), c = () => {
      a(l.matches);
    };
    return c(), l.addEventListener("change", c), () => {
      l.removeEventListener("change", c);
    };
  }, [e, n]), i;
}
const zG = {
  ...m
}, fk = zG.useSyncExternalStore;
function GG(e, t, n, r, o) {
  const i = m.useCallback(() => t, [t]), a = m.useMemo(() => {
    if (o && n)
      return () => n(e).matches;
    if (r !== null) {
      const {
        matches: f
      } = r(e);
      return () => f;
    }
    return i;
  }, [i, e, r, o, n]), [l, c] = m.useMemo(() => {
    if (n === null)
      return [i, () => () => {
      }];
    const f = n(e);
    return [() => f.matches, (p) => (f.addEventListener("change", p), () => {
      f.removeEventListener("change", p);
    })];
  }, [i, n, e]);
  return fk(c, l, a);
}
function WG(e = {}) {
  const {
    themeId: t
  } = e;
  return function(r, o = {}) {
    let i = DC();
    i && t && (i = i[t] || i);
    const a = typeof window < "u" && typeof window.matchMedia < "u", {
      defaultMatches: l = !1,
      matchMedia: c = a ? window.matchMedia : null,
      ssrMatchMedia: d = null,
      noSsr: f = !1
    } = dk({
      name: "MuiUseMediaQuery",
      props: o,
      theme: i
    });
    process.env.NODE_ENV !== "production" && typeof r == "function" && i === null && console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
    let p = typeof r == "function" ? r(i) : r;
    p = p.replace(/^@media( ?)/m, "");
    const b = (fk !== void 0 ? GG : UG)(p, l, c, d, f);
    return process.env.NODE_ENV !== "production" && m.useDebugValue({
      query: p,
      match: b
    }), b;
  };
}
function qG(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
function FC(e, t = 0, n = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > n) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${n}].`), qG(e, t, n);
}
function KG(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((r) => r + r)), process.env.NODE_ENV !== "production" && e.length !== e.trim().length && console.error(`MUI: The color: "${e}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((r, o) => o < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Vs(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Vs(KG(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(n))
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : Bs(9, e));
  let r = e.substring(t + 1, e.length - 1), o;
  if (n === "color") {
    if (r = r.split(" "), o = r.shift(), r.length === 4 && r[3].charAt(0) === "/" && (r[3] = r[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(o))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${o}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : Bs(10, o));
  } else
    r = r.split(",");
  return r = r.map((i) => parseFloat(i)), {
    type: n,
    values: r,
    colorSpace: o
  };
}
const YG = (e) => {
  const t = Vs(e);
  return t.values.slice(0, 3).map((n, r) => t.type.includes("hsl") && r !== 0 ? `${n}%` : n).join(" ");
}, Of = (e, t) => {
  try {
    return YG(e);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
};
function jp(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: r
  } = e;
  return t.includes("rgb") ? r = r.map((o, i) => i < 3 ? parseInt(o, 10) : o) : t.includes("hsl") && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), t.includes("color") ? r = `${n} ${r.join(" ")}` : r = `${r.join(", ")}`, `${t}(${r})`;
}
function pk(e) {
  e = Vs(e);
  const {
    values: t
  } = e, n = t[0], r = t[1] / 100, o = t[2] / 100, i = r * Math.min(o, 1 - o), a = (d, f = (d + n / 30) % 12) => o - i * Math.max(Math.min(f - 3, 9 - f, 1), -1);
  let l = "rgb";
  const c = [Math.round(a(0) * 255), Math.round(a(8) * 255), Math.round(a(4) * 255)];
  return e.type === "hsla" && (l += "a", c.push(t[3])), jp({
    type: l,
    values: c
  });
}
function Qw(e) {
  e = Vs(e);
  let t = e.type === "hsl" || e.type === "hsla" ? Vs(pk(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function U1(e, t) {
  const n = Qw(e), r = Qw(t);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
function Vt(e, t) {
  return e = Vs(e), t = FC(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, jp(e);
}
function sg(e, t, n) {
  try {
    return Vt(e, t);
  } catch {
    return e;
  }
}
function gl(e, t) {
  if (e = Vs(e), t = FC(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return jp(e);
}
function Hn(e, t, n) {
  try {
    return gl(e, t);
  } catch {
    return e;
  }
}
function ml(e, t) {
  if (e = Vs(e), t = FC(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return jp(e);
}
function Un(e, t, n) {
  try {
    return ml(e, t);
  } catch {
    return e;
  }
}
function QG(e, t = 0.15) {
  return Qw(e) > 0.5 ? gl(e, t) : ml(e, t);
}
function ag(e, t, n) {
  try {
    return QG(e, t);
  } catch {
    return e;
  }
}
function Go(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...r) {
    return e(...r) || t(...r);
  };
}
function XG(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function hk(e, t, n, r, o) {
  const i = e[t], a = o || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let l;
  const c = i.type;
  return typeof c == "function" && !XG(c) && (l = "Did you accidentally use a plain function component for an element instead?"), l !== void 0 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an element that can hold a ref. ${l} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Ic = Go(s.element, hk);
Ic.isRequired = Go(s.element.isRequired, hk);
function JG(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function ZG(e, t, n, r, o) {
  const i = e[t], a = o || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let l;
  return typeof i == "function" && !JG(i) && (l = "Did you accidentally provide a plain function component instead?"), l !== void 0 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an element type that can hold a ref. ${l} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Ed = Go(s.elementType, ZG), eW = "exact-prop: ​";
function Bp(e) {
  return process.env.NODE_ENV === "production" ? e : {
    ...e,
    [eW]: (t) => {
      const n = Object.keys(t).filter((r) => !e.hasOwnProperty(r));
      return n.length > 0 ? new Error(`The following props are not supported: ${n.map((r) => `\`${r}\``).join(", ")}. Please remove them.`) : null;
    }
  };
}
function ba(e, t, n, r, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = e[t], a = o || t;
  return i == null ? null : i && i.nodeType !== 1 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an HTMLElement.`) : null;
}
const Wo = s.oneOfType([s.func, s.object]);
function z1(...e) {
  return e.reduce((t, n) => n == null ? t : function(...o) {
    t.apply(this, o), n.apply(this, o);
  }, () => {
  });
}
function gk(e, t = 166) {
  let n;
  function r(...o) {
    const i = () => {
      e.apply(this, o);
    };
    clearTimeout(n), n = setTimeout(i, t);
  }
  return r.clear = () => {
    clearTimeout(n);
  }, r;
}
function pc(e, t) {
  var n, r, o;
  return /* @__PURE__ */ m.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    e.type.muiName ?? ((o = (r = (n = e.type) == null ? void 0 : n._payload) == null ? void 0 : r.value) == null ? void 0 : o.muiName)
  ) !== -1;
}
function go(e) {
  return e && e.ownerDocument || document;
}
function ya(e) {
  return go(e).defaultView || window;
}
function tW(e, t) {
  if (process.env.NODE_ENV === "production")
    return () => null;
  const n = t ? {
    ...t.propTypes
  } : null;
  return (o) => (i, a, l, c, d, ...f) => {
    const p = d || a, g = n == null ? void 0 : n[p];
    if (g) {
      const b = g(i, a, l, c, d, ...f);
      if (b)
        return b;
    }
    return typeof i[a] < "u" && !i[o] ? new Error(`The prop \`${p}\` of \`${e}\` can only be used together with the \`${o}\` prop.`) : null;
  };
}
function Zg(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
let G1 = 0;
function nW(e) {
  const [t, n] = m.useState(e), r = e || t;
  return m.useEffect(() => {
    t == null && (G1 += 1, n(`mui-${G1}`));
  }, [t]), r;
}
const rW = {
  ...m
}, W1 = rW.useId;
function wc(e) {
  if (W1 !== void 0) {
    const t = W1();
    return e ?? t;
  }
  return nW(e);
}
function oW(e, t, n, r, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = o || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${i}\` is not supported. Please remove it.`) : null;
}
function ul({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: o
  } = m.useRef(e !== void 0), [i, a] = m.useState(t), l = o ? e : i;
  if (process.env.NODE_ENV !== "production") {
    m.useEffect(() => {
      o !== (e !== void 0) && console.error([`MUI: A component is changing the ${o ? "" : "un"}controlled ${r} state of ${n} to be ${o ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: d
    } = m.useRef(t);
    m.useEffect(() => {
      !o && !Object.is(d, t) && console.error([`MUI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const c = m.useCallback((d) => {
    o || a(d);
  }, []);
  return [l, c];
}
function li(e) {
  const t = m.useRef(e);
  return ss(() => {
    t.current = e;
  }), m.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function sr(...e) {
  return m.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      Zg(n, t);
    });
  }, e);
}
const q1 = {};
function mk(e, t) {
  const n = m.useRef(q1);
  return n.current === q1 && (n.current = e(t)), n;
}
const iW = [];
function sW(e) {
  m.useEffect(e, iW);
}
let bk = class yk {
  constructor() {
    nt(this, "currentId", null);
    nt(this, "clear", () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    });
    nt(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new yk();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
};
function tc() {
  const e = mk(bk.create).current;
  return sW(e.disposeEffect), e;
}
function ad(e) {
  try {
    return e.matches(":focus-visible");
  } catch {
    process.env.NODE_ENV !== "production" && !/jsdom/.test(window.navigator.userAgent) && console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join(`
`));
  }
  return !1;
}
function vk(e = window) {
  const t = e.document.documentElement.clientWidth;
  return e.innerWidth - t;
}
const $C = (e) => {
  const t = m.useRef({});
  return m.useEffect(() => {
    t.current = e;
  }), t.current;
};
function aW(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function wk(e, t, n, r) {
  const o = e[t];
  if (o == null || !Number.isInteger(o)) {
    const i = aW(o);
    return new RangeError(`Invalid ${r} \`${t}\` of type \`${i}\` supplied to \`${n}\`, expected \`integer\`.`);
  }
  return null;
}
function Ck(e, t, ...n) {
  return e[t] === void 0 ? null : wk(e, t, ...n);
}
function Xw() {
  return null;
}
Ck.isRequired = wk;
Xw.isRequired = Xw;
const dl = process.env.NODE_ENV === "production" ? Xw : Ck;
function Ct(e, t, n = void 0) {
  const r = {};
  for (const o in e) {
    const i = e[o];
    let a = "", l = !0;
    for (let c = 0; c < i.length; c += 1) {
      const d = i[c];
      d && (a += (l === !0 ? "" : " ") + t(d), l = !1, n && n[d] && (a += " " + n[d]));
    }
    r[o] = a;
  }
  return r;
}
function lW(e) {
  return typeof e == "string";
}
function xk(e, t, n) {
  return e === void 0 || lW(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...n
    }
  };
}
function Sk(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function K1(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function Ek(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: o,
    className: i
  } = e;
  if (!t) {
    const b = ke(n == null ? void 0 : n.className, i, o == null ? void 0 : o.className, r == null ? void 0 : r.className), v = {
      ...n == null ? void 0 : n.style,
      ...o == null ? void 0 : o.style,
      ...r == null ? void 0 : r.style
    }, y = {
      ...n,
      ...o,
      ...r
    };
    return b.length > 0 && (y.className = b), Object.keys(v).length > 0 && (y.style = v), {
      props: y,
      internalRef: void 0
    };
  }
  const a = Sk({
    ...o,
    ...r
  }), l = K1(r), c = K1(o), d = t(a), f = ke(d == null ? void 0 : d.className, n == null ? void 0 : n.className, i, o == null ? void 0 : o.className, r == null ? void 0 : r.className), p = {
    ...d == null ? void 0 : d.style,
    ...n == null ? void 0 : n.style,
    ...o == null ? void 0 : o.style,
    ...r == null ? void 0 : r.style
  }, g = {
    ...d,
    ...n,
    ...c,
    ...l
  };
  return f.length > 0 && (g.className = f), Object.keys(p).length > 0 && (g.style = p), {
    props: g,
    internalRef: d.ref
  };
}
function Tk(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function tp(e) {
  var p;
  const {
    elementType: t,
    externalSlotProps: n,
    ownerState: r,
    skipResolvingSlotProps: o = !1,
    ...i
  } = e, a = o ? {} : Tk(n, r), {
    props: l,
    internalRef: c
  } = Ek({
    ...i,
    externalSlotProps: a
  }), d = sr(c, a == null ? void 0 : a.ref, (p = e.additionalProps) == null ? void 0 : p.ref);
  return xk(t, {
    ...l,
    ref: d
  }, r);
}
function Rc(e) {
  var t;
  return parseInt(m.version, 10) >= 19 ? ((t = e == null ? void 0 : e.props) == null ? void 0 : t.ref) || null : (e == null ? void 0 : e.ref) || null;
}
const LC = /* @__PURE__ */ m.createContext(null);
process.env.NODE_ENV !== "production" && (LC.displayName = "ThemeContext");
function jC() {
  const e = m.useContext(LC);
  return process.env.NODE_ENV !== "production" && m.useDebugValue(e), e;
}
const cW = typeof Symbol == "function" && Symbol.for, uW = cW ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function dW(e, t) {
  if (typeof t == "function") {
    const n = t(e);
    return process.env.NODE_ENV !== "production" && (n || console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), n;
  }
  return {
    ...e,
    ...t
  };
}
function em(e) {
  const {
    children: t,
    theme: n
  } = e, r = jC();
  process.env.NODE_ENV !== "production" && r === null && typeof n == "function" && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const o = m.useMemo(() => {
    const i = r === null ? {
      ...n
    } : dW(r, n);
    return i != null && (i[uW] = r !== null), i;
  }, [n, r]);
  return /* @__PURE__ */ w.jsx(LC.Provider, {
    value: o,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (em.propTypes = {
  /**
   * Your component tree.
   */
  children: s.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: s.oneOfType([s.object, s.func]).isRequired
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (em.propTypes = Bp(em.propTypes));
const Ok = /* @__PURE__ */ m.createContext();
function Pk({
  value: e,
  ...t
}) {
  return /* @__PURE__ */ w.jsx(Ok.Provider, {
    value: e ?? !0,
    ...t
  });
}
process.env.NODE_ENV !== "production" && (Pk.propTypes = {
  children: s.node,
  value: s.bool
});
const mi = () => m.useContext(Ok) ?? !1, Ik = /* @__PURE__ */ m.createContext(void 0);
function Rk({
  value: e,
  children: t
}) {
  return /* @__PURE__ */ w.jsx(Ik.Provider, {
    value: e,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (Rk.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: s.node,
  /**
   * @ignore
   */
  value: s.object
});
function fW(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  if (!t || !t.components || !t.components[n])
    return r;
  const o = t.components[n];
  return o.defaultProps ? ep(o.defaultProps, r) : !o.styleOverrides && !o.variants ? ep(o, r) : r;
}
function pW({
  props: e,
  name: t
}) {
  const n = m.useContext(Ik);
  return fW({
    props: e,
    name: t,
    theme: {
      components: n
    }
  });
}
const Y1 = {};
function Q1(e, t, n, r = !1) {
  return m.useMemo(() => {
    const o = e && t[e] || t;
    if (typeof n == "function") {
      const i = n(o), a = e ? {
        ...t,
        [e]: i
      } : i;
      return r ? () => a : a;
    }
    return e ? {
      ...t,
      [e]: n
    } : {
      ...t,
      ...n
    };
  }, [e, t, n, r]);
}
function np(e) {
  const {
    children: t,
    theme: n,
    themeId: r
  } = e, o = DC(Y1), i = jC() || Y1;
  process.env.NODE_ENV !== "production" && (o === null && typeof n == "function" || r && o && !o[r] && typeof n == "function") && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const a = Q1(r, o, n), l = Q1(r, i, n, !0), c = (r ? a[r] : a).direction === "rtl";
  return /* @__PURE__ */ w.jsx(em, {
    theme: l,
    children: /* @__PURE__ */ w.jsx(Dp.Provider, {
      value: a,
      children: /* @__PURE__ */ w.jsx(Pk, {
        value: c,
        children: /* @__PURE__ */ w.jsx(Rk, {
          value: r ? a[r].components : a.components,
          children: t
        })
      })
    })
  });
}
process.env.NODE_ENV !== "production" && (np.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: s.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: s.oneOfType([s.func, s.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: s.string
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (np.propTypes = Bp(np.propTypes));
const X1 = {
  theme: void 0
};
function hW(e) {
  let t, n;
  return function(o) {
    let i = t;
    return (i === void 0 || o.theme !== n) && (X1.theme = o.theme, i = ak(e(X1)), t = i, n = o.theme), i;
  };
}
const BC = "mode", VC = "color-scheme", gW = "data-color-scheme";
function mW(e) {
  const {
    defaultMode: t = "system",
    defaultLightColorScheme: n = "light",
    defaultDarkColorScheme: r = "dark",
    modeStorageKey: o = BC,
    colorSchemeStorageKey: i = VC,
    attribute: a = gW,
    colorSchemeNode: l = "document.documentElement",
    nonce: c
  } = e || {};
  let d = "", f = a;
  if (a === "class" && (f = ".%s"), a === "data" && (f = "[data-%s]"), f.startsWith(".")) {
    const g = f.substring(1);
    d += `${l}.classList.remove('${g}'.replace('%s', light), '${g}'.replace('%s', dark));
      ${l}.classList.add('${g}'.replace('%s', colorScheme));`;
  }
  const p = f.match(/\[([^\]]+)\]/);
  if (p) {
    const [g, b] = p[1].split("=");
    b || (d += `${l}.removeAttribute('${g}'.replace('%s', light));
      ${l}.removeAttribute('${g}'.replace('%s', dark));`), d += `
      ${l}.setAttribute('${g}'.replace('%s', colorScheme), ${b ? `${b}.replace('%s', colorScheme)` : '""'});`;
  } else
    d += `${l}.setAttribute('${f}', colorScheme);`;
  return /* @__PURE__ */ w.jsx("script", {
    suppressHydrationWarning: !0,
    nonce: typeof window > "u" ? c : "",
    dangerouslySetInnerHTML: {
      __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${o}') || '${t}';
  const dark = localStorage.getItem('${i}-dark') || '${r}';
  const light = localStorage.getItem('${i}-light') || '${n}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${d}
  }
} catch(e){}})();`
    }
  }, "mui-color-scheme-init");
}
function J1(e) {
  if (typeof window < "u" && typeof window.matchMedia == "function" && e === "system")
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function _k(e, t) {
  if (e.mode === "light" || e.mode === "system" && e.systemMode === "light")
    return t("light");
  if (e.mode === "dark" || e.mode === "system" && e.systemMode === "dark")
    return t("dark");
}
function bW(e) {
  return _k(e, (t) => {
    if (t === "light")
      return e.lightColorScheme;
    if (t === "dark")
      return e.darkColorScheme;
  });
}
function Bv(e, t) {
  if (typeof window > "u")
    return;
  let n;
  try {
    n = localStorage.getItem(e) || void 0, n || localStorage.setItem(e, t);
  } catch {
  }
  return n || t;
}
function yW(e) {
  const {
    defaultMode: t = "light",
    defaultLightColorScheme: n,
    defaultDarkColorScheme: r,
    supportedColorSchemes: o = [],
    modeStorageKey: i = BC,
    colorSchemeStorageKey: a = VC,
    storageWindow: l = typeof window > "u" ? void 0 : window,
    noSsr: c = !1
  } = e, d = o.join(","), f = o.length > 1, [p, g] = m.useState(() => {
    const T = Bv(i, t), P = Bv(`${a}-light`, n), R = Bv(`${a}-dark`, r);
    return {
      mode: T,
      systemMode: J1(T),
      lightColorScheme: P,
      darkColorScheme: R
    };
  }), [b, v] = m.useState(c || !f);
  m.useEffect(() => {
    v(!0);
  }, []);
  const y = bW(p), S = m.useCallback((T) => {
    g((P) => {
      if (T === P.mode)
        return P;
      const R = T ?? t;
      try {
        localStorage.setItem(i, R);
      } catch {
      }
      return {
        ...P,
        mode: R,
        systemMode: J1(R)
      };
    });
  }, [i, t]), E = m.useCallback((T) => {
    T ? typeof T == "string" ? T && !d.includes(T) ? console.error(`\`${T}\` does not exist in \`theme.colorSchemes\`.`) : g((P) => {
      const R = {
        ...P
      };
      return _k(P, (F) => {
        try {
          localStorage.setItem(`${a}-${F}`, T);
        } catch {
        }
        F === "light" && (R.lightColorScheme = T), F === "dark" && (R.darkColorScheme = T);
      }), R;
    }) : g((P) => {
      const R = {
        ...P
      }, F = T.light === null ? n : T.light, A = T.dark === null ? r : T.dark;
      if (F)
        if (!d.includes(F))
          console.error(`\`${F}\` does not exist in \`theme.colorSchemes\`.`);
        else {
          R.lightColorScheme = F;
          try {
            localStorage.setItem(`${a}-light`, F);
          } catch {
          }
        }
      if (A)
        if (!d.includes(A))
          console.error(`\`${A}\` does not exist in \`theme.colorSchemes\`.`);
        else {
          R.darkColorScheme = A;
          try {
            localStorage.setItem(`${a}-dark`, A);
          } catch {
          }
        }
      return R;
    }) : g((P) => {
      try {
        localStorage.setItem(`${a}-light`, n), localStorage.setItem(`${a}-dark`, r);
      } catch {
      }
      return {
        ...P,
        lightColorScheme: n,
        darkColorScheme: r
      };
    });
  }, [d, a, n, r]), I = m.useCallback((T) => {
    p.mode === "system" && g((P) => {
      const R = T != null && T.matches ? "dark" : "light";
      return P.systemMode === R ? P : {
        ...P,
        systemMode: R
      };
    });
  }, [p.mode]), O = m.useRef(I);
  return O.current = I, m.useEffect(() => {
    if (typeof window.matchMedia != "function" || !f)
      return;
    const T = (...R) => O.current(...R), P = window.matchMedia("(prefers-color-scheme: dark)");
    return P.addListener(T), T(P), () => {
      P.removeListener(T);
    };
  }, [f]), m.useEffect(() => {
    if (l && f) {
      const T = (P) => {
        const R = P.newValue;
        typeof P.key == "string" && P.key.startsWith(a) && (!R || d.match(R)) && (P.key.endsWith("light") && E({
          light: R
        }), P.key.endsWith("dark") && E({
          dark: R
        })), P.key === i && (!R || ["light", "dark", "system"].includes(R)) && S(R || t);
      };
      return l.addEventListener("storage", T), () => {
        l.removeEventListener("storage", T);
      };
    }
  }, [E, S, i, a, d, t, l, f]), {
    ...p,
    mode: b ? p.mode : void 0,
    systemMode: b ? p.systemMode : void 0,
    colorScheme: b ? y : void 0,
    setMode: S,
    setColorScheme: E
  };
}
const vW = "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
function wW(e) {
  const {
    themeId: t,
    /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */
    theme: n = {},
    modeStorageKey: r = BC,
    colorSchemeStorageKey: o = VC,
    disableTransitionOnChange: i = !1,
    defaultColorScheme: a,
    resolveTheme: l
  } = e, c = {
    allColorSchemes: [],
    colorScheme: void 0,
    darkColorScheme: void 0,
    lightColorScheme: void 0,
    mode: void 0,
    setColorScheme: () => {
    },
    setMode: () => {
    },
    systemMode: void 0
  }, d = /* @__PURE__ */ m.createContext(void 0);
  process.env.NODE_ENV !== "production" && (d.displayName = "ColorSchemeContext");
  const f = () => m.useContext(d) || c, p = {}, g = {};
  function b(E) {
    var Te, Pe, Ye, Ke;
    const {
      children: I,
      theme: O,
      modeStorageKey: T = r,
      colorSchemeStorageKey: P = o,
      disableTransitionOnChange: R = i,
      storageWindow: F = typeof window > "u" ? void 0 : window,
      documentNode: A = typeof document > "u" ? void 0 : document,
      colorSchemeNode: _ = typeof document > "u" ? void 0 : document.documentElement,
      disableNestedContext: C = !1,
      disableStyleSheetGeneration: D = !1,
      defaultMode: L = "system",
      noSsr: B
    } = E, H = m.useRef(!1), k = jC(), N = m.useContext(d), j = !!N && !C, W = m.useMemo(() => O || (typeof n == "function" ? n() : n), [O]), V = W[t], $ = V || W, {
      colorSchemes: z = p,
      components: ne = g,
      cssVarPrefix: K
    } = $, Q = Object.keys(z).filter((je) => !!z[je]).join(","), re = m.useMemo(() => Q.split(","), [Q]), te = typeof a == "string" ? a : a.light, ie = typeof a == "string" ? a : a.dark, ae = z[te] && z[ie] ? L : ((Pe = (Te = z[$.defaultColorScheme]) == null ? void 0 : Te.palette) == null ? void 0 : Pe.mode) || ((Ye = $.palette) == null ? void 0 : Ye.mode), {
      mode: ce,
      setMode: le,
      systemMode: we,
      lightColorScheme: q,
      darkColorScheme: Ee,
      colorScheme: _e,
      setColorScheme: $e
    } = yW({
      supportedColorSchemes: re,
      defaultLightColorScheme: te,
      defaultDarkColorScheme: ie,
      modeStorageKey: T,
      colorSchemeStorageKey: P,
      defaultMode: ae,
      storageWindow: F,
      noSsr: B
    });
    let Le = ce, Ze = _e;
    j && (Le = N.mode, Ze = N.colorScheme);
    const J = m.useMemo(() => {
      var Et;
      const je = Ze || $.defaultColorScheme, Qe = ((Et = $.generateThemeVars) == null ? void 0 : Et.call($)) || $.vars, et = {
        ...$,
        components: ne,
        colorSchemes: z,
        cssVarPrefix: K,
        vars: Qe
      };
      if (typeof et.generateSpacing == "function" && (et.spacing = et.generateSpacing()), je) {
        const Xe = z[je];
        Xe && typeof Xe == "object" && Object.keys(Xe).forEach((xt) => {
          Xe[xt] && typeof Xe[xt] == "object" ? et[xt] = {
            ...et[xt],
            ...Xe[xt]
          } : et[xt] = Xe[xt];
        });
      }
      return l ? l(et) : et;
    }, [$, Ze, ne, z, K]), fe = $.colorSchemeSelector;
    m.useEffect(() => {
      if (Ze && _ && fe && fe !== "media") {
        const je = fe;
        let Qe = fe;
        if (je === "class" && (Qe = ".%s"), je === "data" && (Qe = "[data-%s]"), je != null && je.startsWith("data-") && !je.includes("%s") && (Qe = `[${je}="%s"]`), Qe.startsWith("."))
          _.classList.remove(...re.map((et) => Qe.substring(1).replace("%s", et))), _.classList.add(Qe.substring(1).replace("%s", Ze));
        else {
          const et = Qe.replace("%s", Ze).match(/\[([^\]]+)\]/);
          if (et) {
            const [Et, Xe] = et[1].split("=");
            Xe || re.forEach((xt) => {
              _.removeAttribute(Et.replace(Ze, xt));
            }), _.setAttribute(Et, Xe ? Xe.replace(/"|'/g, "") : "");
          } else
            _.setAttribute(Qe, Ze);
        }
      }
    }, [Ze, fe, _, re]), m.useEffect(() => {
      let je;
      if (R && H.current && A) {
        const Qe = A.createElement("style");
        Qe.appendChild(A.createTextNode(vW)), A.head.appendChild(Qe), window.getComputedStyle(A.body), je = setTimeout(() => {
          A.head.removeChild(Qe);
        }, 1);
      }
      return () => {
        clearTimeout(je);
      };
    }, [Ze, R, A]), m.useEffect(() => (H.current = !0, () => {
      H.current = !1;
    }), []);
    const me = m.useMemo(() => ({
      allColorSchemes: re,
      colorScheme: Ze,
      darkColorScheme: Ee,
      lightColorScheme: q,
      mode: Le,
      setColorScheme: $e,
      setMode: process.env.NODE_ENV === "production" ? le : (je) => {
        J.colorSchemeSelector === "media" && console.error(["MUI: The `setMode` function has no effect if `colorSchemeSelector` is `media` (`media` is the default value).", "To toggle the mode manually, please configure `colorSchemeSelector` to use a class or data attribute.", "To learn more, visit https://mui.com/material-ui/customization/css-theme-variables/configuration/#toggling-dark-mode-manually"].join(`
`)), le(je);
      },
      systemMode: we
    }), [re, Ze, Ee, q, Le, $e, le, we, J.colorSchemeSelector]);
    let Oe = !0;
    (D || $.cssVariables === !1 || j && (k == null ? void 0 : k.cssVarPrefix) === K) && (Oe = !1);
    const Ce = /* @__PURE__ */ w.jsxs(m.Fragment, {
      children: [/* @__PURE__ */ w.jsx(np, {
        themeId: V ? t : void 0,
        theme: J,
        children: I
      }), Oe && /* @__PURE__ */ w.jsx(MC, {
        styles: ((Ke = J.generateStyleSheets) == null ? void 0 : Ke.call(J)) || []
      })]
    });
    return j ? Ce : /* @__PURE__ */ w.jsx(d.Provider, {
      value: me,
      children: Ce
    });
  }
  process.env.NODE_ENV !== "production" && (b.propTypes = {
    /**
     * The component tree.
     */
    children: s.node,
    /**
     * The node used to attach the color-scheme attribute
     */
    colorSchemeNode: s.any,
    /**
     * localStorage key used to store `colorScheme`
     */
    colorSchemeStorageKey: s.string,
    /**
     * The default mode when the storage is empty,
     * require the theme to have `colorSchemes` with light and dark.
     */
    defaultMode: s.string,
    /**
     * If `true`, the provider creates its own context and generate stylesheet as if it is a root `CssVarsProvider`.
     */
    disableNestedContext: s.bool,
    /**
     * If `true`, the style sheet won't be generated.
     *
     * This is useful for controlling nested CssVarsProvider behavior.
     */
    disableStyleSheetGeneration: s.bool,
    /**
     * Disable CSS transitions when switching between modes or color schemes.
     */
    disableTransitionOnChange: s.bool,
    /**
     * The document to attach the attribute to.
     */
    documentNode: s.any,
    /**
     * The key in the local storage used to store current color scheme.
     */
    modeStorageKey: s.string,
    /**
     * If `true`, the mode will be the same value as the storage without an extra rerendering after the hydration.
     * You should use this option in conjuction with `InitColorSchemeScript` component.
     */
    noSsr: s.bool,
    /**
     * The window that attaches the 'storage' event listener.
     * @default window
     */
    storageWindow: s.any,
    /**
     * The calculated theme object that will be passed through context.
     */
    theme: s.object
  });
  const v = typeof a == "string" ? a : a.light, y = typeof a == "string" ? a : a.dark;
  return {
    CssVarsProvider: b,
    useColorScheme: f,
    getInitColorSchemeScript: (E) => mW({
      colorSchemeStorageKey: o,
      defaultLightColorScheme: v,
      defaultDarkColorScheme: y,
      modeStorageKey: r,
      ...E
    })
  };
}
function CW(e = "") {
  function t(...r) {
    if (!r.length)
      return "";
    const o = r[0];
    return typeof o == "string" && !o.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${o}${t(...r.slice(1))})` : `, ${o}`;
  }
  return (r, ...o) => `var(--${e ? `${e}-` : ""}${r}${t(...o)})`;
}
const Z1 = (e, t, n, r = []) => {
  let o = e;
  t.forEach((i, a) => {
    a === t.length - 1 ? Array.isArray(o) ? o[Number(i)] = n : o && typeof o == "object" && (o[i] = n) : o && typeof o == "object" && (o[i] || (o[i] = r.includes(i) ? [] : {}), o = o[i]);
  });
}, xW = (e, t, n) => {
  function r(o, i = [], a = []) {
    Object.entries(o).forEach(([l, c]) => {
      (!n || n && !n([...i, l])) && c != null && (typeof c == "object" && Object.keys(c).length > 0 ? r(c, [...i, l], Array.isArray(c) ? [...a, l] : a) : t([...i, l], c, a));
    });
  }
  r(e);
}, SW = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((r) => e.includes(r)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function Vv(e, t) {
  const {
    prefix: n,
    shouldSkipGeneratingVar: r
  } = t || {}, o = {}, i = {}, a = {};
  return xW(
    e,
    (l, c, d) => {
      if ((typeof c == "string" || typeof c == "number") && (!r || !r(l, c))) {
        const f = `--${n ? `${n}-` : ""}${l.join("-")}`, p = SW(l, c);
        Object.assign(o, {
          [f]: p
        }), Z1(i, l, `var(${f})`, d), Z1(a, l, `var(${f}, ${p})`, d);
      }
    },
    (l) => l[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: o,
    vars: i,
    varsWithDefaults: a
  };
}
function EW(e, t = {}) {
  const {
    getSelector: n = S,
    disableCssColorScheme: r,
    colorSchemeSelector: o
  } = t, {
    colorSchemes: i = {},
    components: a,
    defaultColorScheme: l = "light",
    ...c
  } = e, {
    vars: d,
    css: f,
    varsWithDefaults: p
  } = Vv(c, t);
  let g = p;
  const b = {}, {
    [l]: v,
    ...y
  } = i;
  if (Object.entries(y || {}).forEach(([O, T]) => {
    const {
      vars: P,
      css: R,
      varsWithDefaults: F
    } = Vv(T, t);
    g = Jr(g, F), b[O] = {
      css: R,
      vars: P
    };
  }), v) {
    const {
      css: O,
      vars: T,
      varsWithDefaults: P
    } = Vv(v, t);
    g = Jr(g, P), b[l] = {
      css: O,
      vars: T
    };
  }
  function S(O, T) {
    var R, F;
    let P = o;
    if (o === "class" && (P = ".%s"), o === "data" && (P = "[data-%s]"), o != null && o.startsWith("data-") && !o.includes("%s") && (P = `[${o}="%s"]`), O) {
      if (P === "media")
        return e.defaultColorScheme === O ? ":root" : {
          [`@media (prefers-color-scheme: ${((F = (R = i[O]) == null ? void 0 : R.palette) == null ? void 0 : F.mode) || O})`]: {
            ":root": T
          }
        };
      if (P)
        return e.defaultColorScheme === O ? `:root, ${P.replace("%s", String(O))}` : P.replace("%s", String(O));
    }
    return ":root";
  }
  return {
    vars: g,
    generateThemeVars: () => {
      let O = {
        ...d
      };
      return Object.entries(b).forEach(([, {
        vars: T
      }]) => {
        O = Jr(O, T);
      }), O;
    },
    generateStyleSheets: () => {
      var A, _;
      const O = [], T = e.defaultColorScheme || "light";
      function P(C, D) {
        Object.keys(D).length && O.push(typeof C == "string" ? {
          [C]: {
            ...D
          }
        } : C);
      }
      P(n(void 0, {
        ...f
      }), f);
      const {
        [T]: R,
        ...F
      } = b;
      if (R) {
        const {
          css: C
        } = R, D = (_ = (A = i[T]) == null ? void 0 : A.palette) == null ? void 0 : _.mode, L = !r && D ? {
          colorScheme: D,
          ...C
        } : {
          ...C
        };
        P(n(T, {
          ...L
        }), L);
      }
      return Object.entries(F).forEach(([C, {
        css: D
      }]) => {
        var H, k;
        const L = (k = (H = i[C]) == null ? void 0 : H.palette) == null ? void 0 : k.mode, B = !r && L ? {
          colorScheme: L,
          ...D
        } : {
          ...D
        };
        P(n(C, {
          ...B
        }), B);
      }), O;
    }
  };
}
function TW(e) {
  return function(n) {
    return e === "media" ? (process.env.NODE_ENV !== "production" && n !== "light" && n !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${n}'.`), `@media (prefers-color-scheme: ${n})`) : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${n}"] &` : e === "class" ? `.${n} &` : e === "data" ? `[data-${n}] &` : `${e.replace("%s", n)} &` : "&";
  };
}
const OW = (e, t) => e.filter((n) => t.includes(n)), Td = (e, t, n) => {
  const r = e.keys[0];
  Array.isArray(t) ? t.forEach((o, i) => {
    n((a, l) => {
      i <= e.keys.length - 1 && (i === 0 ? Object.assign(a, l) : a[e.up(e.keys[i])] = l);
    }, o);
  }) : t && typeof t == "object" ? (Object.keys(t).length > e.keys.length ? e.keys : OW(e.keys, Object.keys(t))).forEach((i) => {
    if (e.keys.includes(i)) {
      const a = t[i];
      a !== void 0 && n((l, c) => {
        r === i ? Object.assign(l, c) : l[e.up(i)] = c;
      }, a);
    }
  }) : (typeof t == "number" || typeof t == "string") && n((o, i) => {
    Object.assign(o, i);
  }, t);
};
function tm(e) {
  return `--Grid-${e}Spacing`;
}
function ib(e) {
  return `--Grid-parent-${e}Spacing`;
}
const eO = "--Grid-columns", Fu = "--Grid-parent-columns", PW = ({
  theme: e,
  ownerState: t
}) => {
  const n = {};
  return Td(e.breakpoints, t.size, (r, o) => {
    let i = {};
    o === "grow" && (i = {
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: "100%"
    }), o === "auto" && (i = {
      flexBasis: "auto",
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: "none",
      width: "auto"
    }), typeof o == "number" && (i = {
      flexGrow: 0,
      flexBasis: "auto",
      width: `calc(100% * ${o} / var(${Fu}) - (var(${Fu}) - ${o}) * (var(${ib("column")}) / var(${Fu})))`
    }), r(n, i);
  }), n;
}, IW = ({
  theme: e,
  ownerState: t
}) => {
  const n = {};
  return Td(e.breakpoints, t.offset, (r, o) => {
    let i = {};
    o === "auto" && (i = {
      marginLeft: "auto"
    }), typeof o == "number" && (i = {
      marginLeft: o === 0 ? "0px" : `calc(100% * ${o} / var(${Fu}) + var(${ib("column")}) * ${o} / var(${Fu}))`
    }), r(n, i);
  }), n;
}, RW = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {
    [eO]: 12
  };
  return Td(e.breakpoints, t.columns, (r, o) => {
    const i = o ?? 12;
    r(n, {
      [eO]: i,
      "> *": {
        [Fu]: i
      }
    });
  }), n;
}, _W = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return Td(e.breakpoints, t.rowSpacing, (r, o) => {
    var a;
    const i = typeof o == "string" ? o : (a = e.spacing) == null ? void 0 : a.call(e, o);
    r(n, {
      [tm("row")]: i,
      "> *": {
        [ib("row")]: i
      }
    });
  }), n;
}, kW = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return Td(e.breakpoints, t.columnSpacing, (r, o) => {
    var a;
    const i = typeof o == "string" ? o : (a = e.spacing) == null ? void 0 : a.call(e, o);
    r(n, {
      [tm("column")]: i,
      "> *": {
        [ib("column")]: i
      }
    });
  }), n;
}, MW = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return Td(e.breakpoints, t.direction, (r, o) => {
    r(n, {
      flexDirection: o
    });
  }), n;
}, AW = ({
  ownerState: e
}) => ({
  minWidth: 0,
  boxSizing: "border-box",
  ...e.container && {
    display: "flex",
    flexWrap: "wrap",
    ...e.wrap && e.wrap !== "wrap" && {
      flexWrap: e.wrap
    },
    gap: `var(${tm("row")}) var(${tm("column")})`
  }
}), DW = (e) => {
  const t = [];
  return Object.entries(e).forEach(([n, r]) => {
    r !== !1 && r !== void 0 && t.push(`grid-${n}-${String(r)}`);
  }), t;
}, NW = (e, t = "xs") => {
  function n(r) {
    return r === void 0 ? !1 : typeof r == "string" && !Number.isNaN(Number(r)) || typeof r == "number" && r > 0;
  }
  if (n(e))
    return [`spacing-${t}-${String(e)}`];
  if (typeof e == "object" && !Array.isArray(e)) {
    const r = [];
    return Object.entries(e).forEach(([o, i]) => {
      n(i) && r.push(`spacing-${o}-${String(i)}`);
    }), r;
  }
  return [];
}, FW = (e) => e === void 0 ? [] : typeof e == "object" ? Object.entries(e).map(([t, n]) => `direction-${t}-${n}`) : [`direction-xs-${String(e)}`], $W = $p(), LW = On("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function jW(e) {
  return NC({
    props: e,
    name: "MuiGrid",
    defaultTheme: $W
  });
}
function BW(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = LW,
    useThemeProps: n = jW,
    useTheme: r = Lp,
    componentName: o = "MuiGrid"
  } = e, i = (d, f) => {
    const {
      container: p,
      direction: g,
      spacing: b,
      wrap: v,
      size: y
    } = d, S = {
      root: ["root", p && "container", v !== "wrap" && `wrap-xs-${String(v)}`, ...FW(g), ...DW(y), ...p ? NW(b, f.breakpoints.keys[0]) : []]
    };
    return Ct(S, (E) => gt(o, E), {});
  };
  function a(d, f, p = () => !0) {
    const g = {};
    return d === null || (Array.isArray(d) ? d.forEach((b, v) => {
      b !== null && p(b) && f.keys[v] && (g[f.keys[v]] = b);
    }) : typeof d == "object" ? Object.keys(d).forEach((b) => {
      const v = d[b];
      v != null && p(v) && (g[b] = v);
    }) : g[f.keys[0]] = d), g;
  }
  const l = t(RW, kW, _W, PW, MW, AW, IW), c = /* @__PURE__ */ m.forwardRef(function(f, p) {
    const g = r(), b = n(f), v = ob(b), {
      className: y,
      children: S,
      columns: E = 12,
      container: I = !1,
      component: O = "div",
      direction: T = "row",
      wrap: P = "wrap",
      size: R = {},
      offset: F = {},
      spacing: A = 0,
      rowSpacing: _ = A,
      columnSpacing: C = A,
      unstable_level: D = 0,
      ...L
    } = v, B = a(R, g.breakpoints, (z) => z !== !1), H = a(F, g.breakpoints), k = f.columns ?? (D ? void 0 : E), N = f.spacing ?? (D ? void 0 : A), j = f.rowSpacing ?? f.spacing ?? (D ? void 0 : _), W = f.columnSpacing ?? f.spacing ?? (D ? void 0 : C), V = {
      ...v,
      level: D,
      columns: k,
      container: I,
      direction: T,
      wrap: P,
      spacing: N,
      rowSpacing: j,
      columnSpacing: W,
      size: B,
      offset: H
    }, $ = i(V, g);
    return /* @__PURE__ */ w.jsx(l, {
      ref: p,
      as: O,
      ownerState: V,
      className: ke($.root, y),
      ...L,
      children: m.Children.map(S, (z) => {
        var ne;
        return /* @__PURE__ */ m.isValidElement(z) && pc(z, ["Grid"]) && I && z.props.container ? /* @__PURE__ */ m.cloneElement(z, {
          unstable_level: ((ne = z.props) == null ? void 0 : ne.unstable_level) ?? D + 1
        }) : z;
      })
    });
  });
  return process.env.NODE_ENV !== "production" && (c.propTypes = {
    children: s.node,
    className: s.string,
    columns: s.oneOfType([s.arrayOf(s.number), s.number, s.object]),
    columnSpacing: s.oneOfType([s.arrayOf(s.oneOfType([s.number, s.string])), s.number, s.object, s.string]),
    component: s.elementType,
    container: s.bool,
    direction: s.oneOfType([s.oneOf(["column-reverse", "column", "row-reverse", "row"]), s.arrayOf(s.oneOf(["column-reverse", "column", "row-reverse", "row"])), s.object]),
    offset: s.oneOfType([s.string, s.number, s.arrayOf(s.oneOfType([s.string, s.number])), s.object]),
    rowSpacing: s.oneOfType([s.arrayOf(s.oneOfType([s.number, s.string])), s.number, s.object, s.string]),
    size: s.oneOfType([s.string, s.bool, s.number, s.arrayOf(s.oneOfType([s.string, s.bool, s.number])), s.object]),
    spacing: s.oneOfType([s.arrayOf(s.oneOfType([s.number, s.string])), s.number, s.object, s.string]),
    sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
    wrap: s.oneOf(["nowrap", "wrap-reverse", "wrap"])
  }), c.muiName = "Grid", c;
}
const VW = $p(), HW = On("div", {
  name: "MuiStack",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function UW(e) {
  return NC({
    props: e,
    name: "MuiStack",
    defaultTheme: VW
  });
}
function zW(e, t) {
  const n = m.Children.toArray(e).filter(Boolean);
  return n.reduce((r, o, i) => (r.push(o), i < n.length - 1 && r.push(/* @__PURE__ */ m.cloneElement(t, {
    key: `separator-${i}`
  })), r), []);
}
const GW = (e) => ({
  row: "Left",
  "row-reverse": "Right",
  column: "Top",
  "column-reverse": "Bottom"
})[e], WW = ({
  ownerState: e,
  theme: t
}) => {
  let n = {
    display: "flex",
    flexDirection: "column",
    ...is({
      theme: t
    }, Lv({
      values: e.direction,
      breakpoints: t.breakpoints.values
    }), (r) => ({
      flexDirection: r
    }))
  };
  if (e.spacing) {
    const r = Jm(t), o = Object.keys(t.breakpoints.values).reduce((c, d) => ((typeof e.spacing == "object" && e.spacing[d] != null || typeof e.direction == "object" && e.direction[d] != null) && (c[d] = !0), c), {}), i = Lv({
      values: e.direction,
      base: o
    }), a = Lv({
      values: e.spacing,
      base: o
    });
    typeof i == "object" && Object.keys(i).forEach((c, d, f) => {
      if (!i[c]) {
        const g = d > 0 ? i[f[d - 1]] : "column";
        i[c] = g;
      }
    }), n = Jr(n, is({
      theme: t
    }, a, (c, d) => e.useFlexGap ? {
      gap: vc(r, c)
    } : {
      // The useFlexGap={false} implement relies on each child to give up control of the margin.
      // We need to reset the margin to avoid double spacing.
      "& > :not(style):not(style)": {
        margin: 0
      },
      "& > :not(style) ~ :not(style)": {
        [`margin${GW(d ? i[d] : e.direction)}`]: vc(r, c)
      }
    }));
  }
  return n = L5(t.breakpoints, n), n;
};
function qW(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = HW,
    useThemeProps: n = UW,
    componentName: r = "MuiStack"
  } = e, o = () => Ct({
    root: ["root"]
  }, (c) => gt(r, c), {}), i = t(WW), a = /* @__PURE__ */ m.forwardRef(function(c, d) {
    const f = n(c), p = ob(f), {
      component: g = "div",
      direction: b = "column",
      spacing: v = 0,
      divider: y,
      children: S,
      className: E,
      useFlexGap: I = !1,
      ...O
    } = p, T = {
      direction: b,
      spacing: v,
      useFlexGap: I
    }, P = o();
    return /* @__PURE__ */ w.jsx(i, {
      as: g,
      ownerState: T,
      ref: d,
      className: ke(P.root, E),
      ...O,
      children: y ? zW(S, y) : S
    });
  });
  return process.env.NODE_ENV !== "production" && (a.propTypes = {
    children: s.node,
    direction: s.oneOfType([s.oneOf(["column-reverse", "column", "row-reverse", "row"]), s.arrayOf(s.oneOf(["column-reverse", "column", "row-reverse", "row"])), s.object]),
    divider: s.node,
    spacing: s.oneOfType([s.arrayOf(s.oneOfType([s.number, s.string])), s.number, s.object, s.string]),
    sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
  }), a;
}
function kk() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: Qf.white,
      default: Qf.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const KW = kk();
function Mk() {
  return {
    text: {
      primary: Qf.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: Qf.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const tO = Mk();
function nO(e, t, n, r) {
  const o = r.light || r, i = r.dark || r * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = ml(e.main, o) : t === "dark" && (e.dark = gl(e.main, i)));
}
function YW(e = "light") {
  return e === "dark" ? {
    main: eu[200],
    light: eu[50],
    dark: eu[400]
  } : {
    main: eu[700],
    light: eu[400],
    dark: eu[800]
  };
}
function QW(e = "light") {
  return e === "dark" ? {
    main: Zc[200],
    light: Zc[50],
    dark: Zc[400]
  } : {
    main: Zc[500],
    light: Zc[300],
    dark: Zc[700]
  };
}
function XW(e = "light") {
  return e === "dark" ? {
    main: Jc[500],
    light: Jc[300],
    dark: Jc[700]
  } : {
    main: Jc[700],
    light: Jc[400],
    dark: Jc[800]
  };
}
function JW(e = "light") {
  return e === "dark" ? {
    main: tu[400],
    light: tu[300],
    dark: tu[700]
  } : {
    main: tu[700],
    light: tu[500],
    dark: tu[900]
  };
}
function ZW(e = "light") {
  return e === "dark" ? {
    main: nu[400],
    light: nu[300],
    dark: nu[700]
  } : {
    main: nu[800],
    light: nu[500],
    dark: nu[900]
  };
}
function eq(e = "light") {
  return e === "dark" ? {
    main: of[400],
    light: of[300],
    dark: of[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: of[500],
    dark: of[900]
  };
}
function HC(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: r = 0.2,
    ...o
  } = e, i = e.primary || YW(t), a = e.secondary || QW(t), l = e.error || XW(t), c = e.info || JW(t), d = e.success || ZW(t), f = e.warning || eq(t);
  function p(y) {
    const S = U1(y, tO.text.primary) >= n ? tO.text.primary : KW.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const E = U1(y, S);
      E < 3 && console.error([`MUI: The contrast ratio of ${E}:1 for ${S} on ${y}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return S;
  }
  const g = ({
    color: y,
    name: S,
    mainShade: E = 500,
    lightShade: I = 300,
    darkShade: O = 700
  }) => {
    if (y = {
      ...y
    }, !y.main && y[E] && (y.main = y[E]), !y.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${S ? ` (${S})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${E}\` property.` : Bs(11, S ? ` (${S})` : "", E));
    if (typeof y.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${S ? ` (${S})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(y.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : Bs(12, S ? ` (${S})` : "", JSON.stringify(y.main)));
    return nO(y, "light", I, r), nO(y, "dark", O, r), y.contrastText || (y.contrastText = p(y.main)), y;
  };
  let b;
  return t === "light" ? b = kk() : t === "dark" && (b = Mk()), process.env.NODE_ENV !== "production" && (b || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), Jr({
    // A collection of common colors.
    common: {
      ...Qf
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: g({
      color: i,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: g({
      color: a,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: g({
      color: l,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: g({
      color: f,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: g({
      color: c,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: g({
      color: d,
      name: "success"
    }),
    // The grey colors.
    grey: bz,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: p,
    // Generate a rich color object.
    augmentColor: g,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: r,
    // The light and dark mode object.
    ...b
  }, o);
}
function tq(e) {
  const t = {};
  return Object.entries(e).forEach((r) => {
    const [o, i] = r;
    typeof i == "object" && (t[o] = `${i.fontStyle ? `${i.fontStyle} ` : ""}${i.fontVariant ? `${i.fontVariant} ` : ""}${i.fontWeight ? `${i.fontWeight} ` : ""}${i.fontStretch ? `${i.fontStretch} ` : ""}${i.fontSize || ""}${i.lineHeight ? `/${i.lineHeight} ` : ""}${i.fontFamily || ""}`);
  }), t;
}
function nq(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
function rq(e) {
  return Math.round(e * 1e5) / 1e5;
}
const rO = {
  textTransform: "uppercase"
}, oO = '"Roboto", "Helvetica", "Arial", sans-serif';
function Ak(e, t) {
  const {
    fontFamily: n = oO,
    // The default font size of the Material Specification.
    fontSize: r = 14,
    // px
    fontWeightLight: o = 300,
    fontWeightRegular: i = 400,
    fontWeightMedium: a = 500,
    fontWeightBold: l = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: c = 16,
    // Apply the CSS properties to all the variants.
    allVariants: d,
    pxToRem: f,
    ...p
  } = typeof t == "function" ? t(e) : t;
  process.env.NODE_ENV !== "production" && (typeof r != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof c != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const g = r / 14, b = f || ((S) => `${S / c * g}rem`), v = (S, E, I, O, T) => ({
    fontFamily: n,
    fontWeight: S,
    fontSize: b(E),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: I,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...n === oO ? {
      letterSpacing: `${rq(O / E)}em`
    } : {},
    ...T,
    ...d
  }), y = {
    h1: v(o, 96, 1.167, -1.5),
    h2: v(o, 60, 1.2, -0.5),
    h3: v(i, 48, 1.167, 0),
    h4: v(i, 34, 1.235, 0.25),
    h5: v(i, 24, 1.334, 0),
    h6: v(a, 20, 1.6, 0.15),
    subtitle1: v(i, 16, 1.75, 0.15),
    subtitle2: v(a, 14, 1.57, 0.1),
    body1: v(i, 16, 1.5, 0.15),
    body2: v(i, 14, 1.43, 0.15),
    button: v(a, 14, 1.75, 0.4, rO),
    caption: v(i, 12, 1.66, 0.4),
    overline: v(i, 12, 2.66, 1, rO),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return Jr({
    htmlFontSize: c,
    pxToRem: b,
    fontFamily: n,
    fontSize: r,
    fontWeightLight: o,
    fontWeightRegular: i,
    fontWeightMedium: a,
    fontWeightBold: l,
    ...y
  }, p, {
    clone: !1
    // No need to clone deep
  });
}
const oq = 0.2, iq = 0.14, sq = 0.12;
function nr(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${oq})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${iq})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${sq})`].join(",");
}
const aq = ["none", nr(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), nr(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), nr(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), nr(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), nr(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), nr(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), nr(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), nr(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), nr(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), nr(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), nr(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), nr(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), nr(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), nr(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), nr(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), nr(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), nr(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), nr(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), nr(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), nr(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), nr(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), nr(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), nr(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), nr(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], lq = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, Dk = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function iO(e) {
  return `${Math.round(e)}ms`;
}
function cq(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function uq(e) {
  const t = {
    ...lq,
    ...e.easing
  }, n = {
    ...Dk,
    ...e.duration
  };
  return {
    getAutoHeightDuration: cq,
    create: (o = ["all"], i = {}) => {
      const {
        duration: a = n.standard,
        easing: l = t.easeInOut,
        delay: c = 0,
        ...d
      } = i;
      if (process.env.NODE_ENV !== "production") {
        const f = (g) => typeof g == "string", p = (g) => !Number.isNaN(parseFloat(g));
        !f(o) && !Array.isArray(o) && console.error('MUI: Argument "props" must be a string or Array.'), !p(a) && !f(a) && console.error(`MUI: Argument "duration" must be a number or a string but found ${a}.`), f(l) || console.error('MUI: Argument "easing" must be a string.'), !p(c) && !f(c) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof i != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(d).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(d).join(",")}].`);
      }
      return (Array.isArray(o) ? o : [o]).map((f) => `${f} ${typeof a == "string" ? a : iO(a)} ${l} ${typeof c == "string" ? c : iO(c)}`).join(",");
    },
    ...e,
    easing: t,
    duration: n
  };
}
const dq = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function fq(e) {
  return Os(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function Nk(e = {}) {
  const t = {
    ...e
  };
  function n(r) {
    const o = Object.entries(r);
    for (let i = 0; i < o.length; i++) {
      const [a, l] = o[i];
      !fq(l) || a.startsWith("unstable_") ? delete r[a] : Os(l) && (r[a] = {
        ...l
      }, n(r[a]));
    }
  }
  return n(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function Jw(e = {}, ...t) {
  const {
    breakpoints: n,
    mixins: r = {},
    spacing: o,
    palette: i = {},
    transitions: a = {},
    typography: l = {},
    shape: c,
    ...d
  } = e;
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : Bs(20));
  const f = HC(i), p = $p(e);
  let g = Jr(p, {
    mixins: nq(p.breakpoints, r),
    palette: f,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: aq.slice(),
    typography: Ak(f, l),
    transitions: uq(a),
    zIndex: {
      ...dq
    }
  });
  if (g = Jr(g, d), g = t.reduce((b, v) => Jr(b, v), g), process.env.NODE_ENV !== "production") {
    const b = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], v = (y, S) => {
      let E;
      for (E in y) {
        const I = y[E];
        if (b.includes(E) && Object.keys(I).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const O = gt("", E);
            console.error([`MUI: The \`${S}\` component increases the CSS specificity of the \`${E}\` internal state.`, "You can not override it like this: ", JSON.stringify(y, null, 2), "", `Instead, you need to use the '&.${O}' syntax:`, JSON.stringify({
              root: {
                [`&.${O}`]: I
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          y[E] = {};
        }
      }
    };
    Object.keys(g.components).forEach((y) => {
      const S = g.components[y].styleOverrides;
      S && y.startsWith("Mui") && v(S, y);
    });
  }
  return g.unstable_sxConfig = {
    ...Fp,
    ...d == null ? void 0 : d.unstable_sxConfig
  }, g.unstable_sx = function(v) {
    return hl({
      sx: v,
      theme: this
    });
  }, g.toRuntimeSource = Nk, g;
}
function Zw(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const pq = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const n = Zw(t);
  return `linear-gradient(rgba(255 255 255 / ${n}), rgba(255 255 255 / ${n}))`;
});
function Fk(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function $k(e) {
  return e === "dark" ? pq : [];
}
function hq(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: n,
    overlays: r,
    ...o
  } = e, i = HC(t);
  return {
    palette: i,
    opacity: {
      ...Fk(i.mode),
      ...n
    },
    overlays: r || $k(i.mode),
    ...o
  };
}
function gq(e) {
  var t;
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((t = e[1]) != null && t.match(/(mode|contrastThreshold|tonalOffset)/));
}
const mq = (e) => [...[...Array(25)].map((t, n) => `--${e ? `${e}-` : ""}overlays-${n}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], bq = (e) => (t, n) => {
  const r = e.rootSelector || ":root", o = e.colorSchemeSelector;
  let i = o;
  if (o === "class" && (i = ".%s"), o === "data" && (i = "[data-%s]"), o != null && o.startsWith("data-") && !o.includes("%s") && (i = `[${o}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const a = {};
      return mq(e.cssVarPrefix).forEach((l) => {
        a[l] = n[l], delete n[l];
      }), i === "media" ? {
        [r]: n,
        "@media (prefers-color-scheme: dark)": {
          [r]: a
        }
      } : i ? {
        [i.replace("%s", t)]: a,
        [`${r}, ${i.replace("%s", t)}`]: n
      } : {
        [r]: {
          ...n,
          ...a
        }
      };
    }
    if (i && i !== "media")
      return `${r}, ${i.replace("%s", String(t))}`;
  } else if (t) {
    if (i === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [r]: n
        }
      };
    if (i)
      return i.replace("%s", String(t));
  }
  return r;
};
function yq(e, t) {
  t.forEach((n) => {
    e[n] || (e[n] = {});
  });
}
function Ae(e, t, n) {
  !e[t] && n && (e[t] = n);
}
function Pf(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : pk(e);
}
function oa(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = Of(Pf(e[t]), `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function vq(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const hs = (e) => {
  try {
    return e();
  } catch {
  }
}, wq = (e = "mui") => CW(e);
function Hv(e, t, n, r) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const o = r === "dark" ? "dark" : "light";
  if (!n) {
    e[r] = hq({
      ...t,
      palette: {
        mode: o,
        ...t == null ? void 0 : t.palette
      }
    });
    return;
  }
  const {
    palette: i,
    ...a
  } = Jw({
    ...n,
    palette: {
      mode: o,
      ...t == null ? void 0 : t.palette
    }
  });
  return e[r] = {
    ...t,
    palette: i,
    opacity: {
      ...Fk(o),
      ...t == null ? void 0 : t.opacity
    },
    overlays: (t == null ? void 0 : t.overlays) || $k(o)
  }, a;
}
function Cq(e = {}, ...t) {
  const {
    colorSchemes: n = {
      light: !0
    },
    defaultColorScheme: r,
    disableCssColorScheme: o = !1,
    cssVarPrefix: i = "mui",
    shouldSkipGeneratingVar: a = gq,
    colorSchemeSelector: l = n.light && n.dark ? "media" : void 0,
    rootSelector: c = ":root",
    ...d
  } = e, f = Object.keys(n)[0], p = r || (n.light && f !== "light" ? "light" : f), g = wq(i), {
    [p]: b,
    light: v,
    dark: y,
    ...S
  } = n, E = {
    ...S
  };
  let I = b;
  if ((p === "dark" && !("dark" in n) || p === "light" && !("light" in n)) && (I = !0), !I)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${p}\` option is either missing or invalid.` : Bs(21, p));
  const O = Hv(E, I, d, p);
  v && !E.light && Hv(E, v, void 0, "light"), y && !E.dark && Hv(E, y, void 0, "dark");
  let T = {
    defaultColorScheme: p,
    ...O,
    cssVarPrefix: i,
    colorSchemeSelector: l,
    rootSelector: c,
    getCssVar: g,
    colorSchemes: E,
    font: {
      ...tq(O.typography),
      ...O.font
    },
    spacing: vq(d.spacing)
  };
  Object.keys(T.colorSchemes).forEach((_) => {
    const C = T.colorSchemes[_].palette, D = (L) => {
      const B = L.split("-"), H = B[1], k = B[2];
      return g(L, C[H][k]);
    };
    if (C.mode === "light" && (Ae(C.common, "background", "#fff"), Ae(C.common, "onBackground", "#000")), C.mode === "dark" && (Ae(C.common, "background", "#000"), Ae(C.common, "onBackground", "#fff")), yq(C, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), C.mode === "light") {
      Ae(C.Alert, "errorColor", Hn(C.error.light, 0.6)), Ae(C.Alert, "infoColor", Hn(C.info.light, 0.6)), Ae(C.Alert, "successColor", Hn(C.success.light, 0.6)), Ae(C.Alert, "warningColor", Hn(C.warning.light, 0.6)), Ae(C.Alert, "errorFilledBg", D("palette-error-main")), Ae(C.Alert, "infoFilledBg", D("palette-info-main")), Ae(C.Alert, "successFilledBg", D("palette-success-main")), Ae(C.Alert, "warningFilledBg", D("palette-warning-main")), Ae(C.Alert, "errorFilledColor", hs(() => C.getContrastText(C.error.main))), Ae(C.Alert, "infoFilledColor", hs(() => C.getContrastText(C.info.main))), Ae(C.Alert, "successFilledColor", hs(() => C.getContrastText(C.success.main))), Ae(C.Alert, "warningFilledColor", hs(() => C.getContrastText(C.warning.main))), Ae(C.Alert, "errorStandardBg", Un(C.error.light, 0.9)), Ae(C.Alert, "infoStandardBg", Un(C.info.light, 0.9)), Ae(C.Alert, "successStandardBg", Un(C.success.light, 0.9)), Ae(C.Alert, "warningStandardBg", Un(C.warning.light, 0.9)), Ae(C.Alert, "errorIconColor", D("palette-error-main")), Ae(C.Alert, "infoIconColor", D("palette-info-main")), Ae(C.Alert, "successIconColor", D("palette-success-main")), Ae(C.Alert, "warningIconColor", D("palette-warning-main")), Ae(C.AppBar, "defaultBg", D("palette-grey-100")), Ae(C.Avatar, "defaultBg", D("palette-grey-400")), Ae(C.Button, "inheritContainedBg", D("palette-grey-300")), Ae(C.Button, "inheritContainedHoverBg", D("palette-grey-A100")), Ae(C.Chip, "defaultBorder", D("palette-grey-400")), Ae(C.Chip, "defaultAvatarColor", D("palette-grey-700")), Ae(C.Chip, "defaultIconColor", D("palette-grey-700")), Ae(C.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), Ae(C.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), Ae(C.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), Ae(C.LinearProgress, "primaryBg", Un(C.primary.main, 0.62)), Ae(C.LinearProgress, "secondaryBg", Un(C.secondary.main, 0.62)), Ae(C.LinearProgress, "errorBg", Un(C.error.main, 0.62)), Ae(C.LinearProgress, "infoBg", Un(C.info.main, 0.62)), Ae(C.LinearProgress, "successBg", Un(C.success.main, 0.62)), Ae(C.LinearProgress, "warningBg", Un(C.warning.main, 0.62)), Ae(C.Skeleton, "bg", `rgba(${D("palette-text-primaryChannel")} / 0.11)`), Ae(C.Slider, "primaryTrack", Un(C.primary.main, 0.62)), Ae(C.Slider, "secondaryTrack", Un(C.secondary.main, 0.62)), Ae(C.Slider, "errorTrack", Un(C.error.main, 0.62)), Ae(C.Slider, "infoTrack", Un(C.info.main, 0.62)), Ae(C.Slider, "successTrack", Un(C.success.main, 0.62)), Ae(C.Slider, "warningTrack", Un(C.warning.main, 0.62));
      const L = ag(C.background.default, 0.8);
      Ae(C.SnackbarContent, "bg", L), Ae(C.SnackbarContent, "color", hs(() => C.getContrastText(L))), Ae(C.SpeedDialAction, "fabHoverBg", ag(C.background.paper, 0.15)), Ae(C.StepConnector, "border", D("palette-grey-400")), Ae(C.StepContent, "border", D("palette-grey-400")), Ae(C.Switch, "defaultColor", D("palette-common-white")), Ae(C.Switch, "defaultDisabledColor", D("palette-grey-100")), Ae(C.Switch, "primaryDisabledColor", Un(C.primary.main, 0.62)), Ae(C.Switch, "secondaryDisabledColor", Un(C.secondary.main, 0.62)), Ae(C.Switch, "errorDisabledColor", Un(C.error.main, 0.62)), Ae(C.Switch, "infoDisabledColor", Un(C.info.main, 0.62)), Ae(C.Switch, "successDisabledColor", Un(C.success.main, 0.62)), Ae(C.Switch, "warningDisabledColor", Un(C.warning.main, 0.62)), Ae(C.TableCell, "border", Un(sg(C.divider, 1), 0.88)), Ae(C.Tooltip, "bg", sg(C.grey[700], 0.92));
    }
    if (C.mode === "dark") {
      Ae(C.Alert, "errorColor", Un(C.error.light, 0.6)), Ae(C.Alert, "infoColor", Un(C.info.light, 0.6)), Ae(C.Alert, "successColor", Un(C.success.light, 0.6)), Ae(C.Alert, "warningColor", Un(C.warning.light, 0.6)), Ae(C.Alert, "errorFilledBg", D("palette-error-dark")), Ae(C.Alert, "infoFilledBg", D("palette-info-dark")), Ae(C.Alert, "successFilledBg", D("palette-success-dark")), Ae(C.Alert, "warningFilledBg", D("palette-warning-dark")), Ae(C.Alert, "errorFilledColor", hs(() => C.getContrastText(C.error.dark))), Ae(C.Alert, "infoFilledColor", hs(() => C.getContrastText(C.info.dark))), Ae(C.Alert, "successFilledColor", hs(() => C.getContrastText(C.success.dark))), Ae(C.Alert, "warningFilledColor", hs(() => C.getContrastText(C.warning.dark))), Ae(C.Alert, "errorStandardBg", Hn(C.error.light, 0.9)), Ae(C.Alert, "infoStandardBg", Hn(C.info.light, 0.9)), Ae(C.Alert, "successStandardBg", Hn(C.success.light, 0.9)), Ae(C.Alert, "warningStandardBg", Hn(C.warning.light, 0.9)), Ae(C.Alert, "errorIconColor", D("palette-error-main")), Ae(C.Alert, "infoIconColor", D("palette-info-main")), Ae(C.Alert, "successIconColor", D("palette-success-main")), Ae(C.Alert, "warningIconColor", D("palette-warning-main")), Ae(C.AppBar, "defaultBg", D("palette-grey-900")), Ae(C.AppBar, "darkBg", D("palette-background-paper")), Ae(C.AppBar, "darkColor", D("palette-text-primary")), Ae(C.Avatar, "defaultBg", D("palette-grey-600")), Ae(C.Button, "inheritContainedBg", D("palette-grey-800")), Ae(C.Button, "inheritContainedHoverBg", D("palette-grey-700")), Ae(C.Chip, "defaultBorder", D("palette-grey-700")), Ae(C.Chip, "defaultAvatarColor", D("palette-grey-300")), Ae(C.Chip, "defaultIconColor", D("palette-grey-300")), Ae(C.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), Ae(C.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), Ae(C.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), Ae(C.LinearProgress, "primaryBg", Hn(C.primary.main, 0.5)), Ae(C.LinearProgress, "secondaryBg", Hn(C.secondary.main, 0.5)), Ae(C.LinearProgress, "errorBg", Hn(C.error.main, 0.5)), Ae(C.LinearProgress, "infoBg", Hn(C.info.main, 0.5)), Ae(C.LinearProgress, "successBg", Hn(C.success.main, 0.5)), Ae(C.LinearProgress, "warningBg", Hn(C.warning.main, 0.5)), Ae(C.Skeleton, "bg", `rgba(${D("palette-text-primaryChannel")} / 0.13)`), Ae(C.Slider, "primaryTrack", Hn(C.primary.main, 0.5)), Ae(C.Slider, "secondaryTrack", Hn(C.secondary.main, 0.5)), Ae(C.Slider, "errorTrack", Hn(C.error.main, 0.5)), Ae(C.Slider, "infoTrack", Hn(C.info.main, 0.5)), Ae(C.Slider, "successTrack", Hn(C.success.main, 0.5)), Ae(C.Slider, "warningTrack", Hn(C.warning.main, 0.5));
      const L = ag(C.background.default, 0.98);
      Ae(C.SnackbarContent, "bg", L), Ae(C.SnackbarContent, "color", hs(() => C.getContrastText(L))), Ae(C.SpeedDialAction, "fabHoverBg", ag(C.background.paper, 0.15)), Ae(C.StepConnector, "border", D("palette-grey-600")), Ae(C.StepContent, "border", D("palette-grey-600")), Ae(C.Switch, "defaultColor", D("palette-grey-300")), Ae(C.Switch, "defaultDisabledColor", D("palette-grey-600")), Ae(C.Switch, "primaryDisabledColor", Hn(C.primary.main, 0.55)), Ae(C.Switch, "secondaryDisabledColor", Hn(C.secondary.main, 0.55)), Ae(C.Switch, "errorDisabledColor", Hn(C.error.main, 0.55)), Ae(C.Switch, "infoDisabledColor", Hn(C.info.main, 0.55)), Ae(C.Switch, "successDisabledColor", Hn(C.success.main, 0.55)), Ae(C.Switch, "warningDisabledColor", Hn(C.warning.main, 0.55)), Ae(C.TableCell, "border", Hn(sg(C.divider, 1), 0.68)), Ae(C.Tooltip, "bg", sg(C.grey[700], 0.92));
    }
    oa(C.background, "default"), oa(C.background, "paper"), oa(C.common, "background"), oa(C.common, "onBackground"), oa(C, "divider"), Object.keys(C).forEach((L) => {
      const B = C[L];
      L !== "tonalOffset" && B && typeof B == "object" && (B.main && Ae(C[L], "mainChannel", Of(Pf(B.main))), B.light && Ae(C[L], "lightChannel", Of(Pf(B.light))), B.dark && Ae(C[L], "darkChannel", Of(Pf(B.dark))), B.contrastText && Ae(C[L], "contrastTextChannel", Of(Pf(B.contrastText))), L === "text" && (oa(C[L], "primary"), oa(C[L], "secondary")), L === "action" && (B.active && oa(C[L], "active"), B.selected && oa(C[L], "selected")));
    });
  }), T = t.reduce((_, C) => Jr(_, C), T);
  const P = {
    prefix: i,
    disableCssColorScheme: o,
    shouldSkipGeneratingVar: a,
    getSelector: bq(T)
  }, {
    vars: R,
    generateThemeVars: F,
    generateStyleSheets: A
  } = EW(T, P);
  return T.vars = R, Object.entries(T.colorSchemes[T.defaultColorScheme]).forEach(([_, C]) => {
    T[_] = C;
  }), T.generateThemeVars = F, T.generateStyleSheets = A, T.generateSpacing = function() {
    return nk(d.spacing, Jm(this));
  }, T.getColorSchemeSelector = TW(l), T.spacing = T.generateSpacing(), T.shouldSkipGeneratingVar = a, T.unstable_sxConfig = {
    ...Fp,
    ...d == null ? void 0 : d.unstable_sxConfig
  }, T.unstable_sx = function(C) {
    return hl({
      sx: C,
      theme: this
    });
  }, T.toRuntimeSource = Nk, T;
}
function sO(e, t, n) {
  e.colorSchemes && n && (e.colorSchemes[t] = {
    ...n !== !0 && n,
    palette: HC({
      ...n === !0 ? {} : n.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function UC(e = {}, ...t) {
  const {
    palette: n,
    cssVariables: r = !1,
    colorSchemes: o = n ? void 0 : {
      light: !0
    },
    defaultColorScheme: i = n == null ? void 0 : n.mode,
    ...a
  } = e, l = i || "light", c = o == null ? void 0 : o[l], d = {
    ...o,
    ...n ? {
      [l]: {
        ...typeof c != "boolean" && c,
        palette: n
      }
    } : void 0
  };
  if (r === !1) {
    if (!("colorSchemes" in e))
      return Jw(e, ...t);
    let f = n;
    "palette" in e || d[l] && (d[l] !== !0 ? f = d[l].palette : l === "dark" && (f = {
      mode: "dark"
    }));
    const p = Jw({
      ...e,
      palette: f
    }, ...t);
    return p.defaultColorScheme = l, p.colorSchemes = d, p.palette.mode === "light" && (p.colorSchemes.light = {
      ...d.light !== !0 && d.light,
      palette: p.palette
    }, sO(p, "dark", d.dark)), p.palette.mode === "dark" && (p.colorSchemes.dark = {
      ...d.dark !== !0 && d.dark,
      palette: p.palette
    }, sO(p, "light", d.light)), p;
  }
  return !n && !("light" in d) && l === "light" && (d.light = !0), Cq({
    ...a,
    colorSchemes: d,
    defaultColorScheme: l,
    ...typeof r != "boolean" && r
  }, ...t);
}
function xq(e) {
  return String(e).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function Sq(e) {
  return parseFloat(e);
}
const sb = UC();
function bo() {
  const e = Lp(sb);
  return process.env.NODE_ENV !== "production" && m.useDebugValue(e), e[Di] || e;
}
function Lk({
  props: e,
  name: t
}) {
  return NC({
    props: e,
    name: t,
    defaultTheme: sb,
    themeId: Di
  });
}
function jk(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const qo = (e) => jk(e) && e !== "classes", oe = ck({
  themeId: Di,
  defaultTheme: sb,
  rootShouldForwardProp: qo
});
function aO({
  theme: e,
  ...t
}) {
  const n = Di in e ? e[Di] : void 0;
  return /* @__PURE__ */ w.jsx(np, {
    ...t,
    themeId: n ? Di : void 0,
    theme: n || e
  });
}
const lg = {
  attribute: "data-mui-color-scheme",
  colorSchemeStorageKey: "mui-color-scheme",
  defaultLightColorScheme: "light",
  defaultDarkColorScheme: "dark",
  modeStorageKey: "mui-mode"
}, {
  CssVarsProvider: Eq,
  useColorScheme: mwe,
  getInitColorSchemeScript: bwe
} = wW({
  themeId: Di,
  // @ts-ignore ignore module augmentation tests
  theme: () => UC({
    cssVariables: !0
  }),
  colorSchemeStorageKey: lg.colorSchemeStorageKey,
  modeStorageKey: lg.modeStorageKey,
  defaultColorScheme: {
    light: lg.defaultLightColorScheme,
    dark: lg.defaultDarkColorScheme
  },
  resolveTheme: (e) => {
    const t = {
      ...e,
      typography: Ak(e.palette, e.typography)
    };
    return t.unstable_sx = function(r) {
      return hl({
        sx: r,
        theme: this
      });
    }, t;
  }
}), Tq = Eq;
function Oq({
  theme: e,
  ...t
}) {
  return typeof e == "function" ? /* @__PURE__ */ w.jsx(aO, {
    theme: e,
    ...t
  }) : "colorSchemes" in (Di in e ? e[Di] : e) ? /* @__PURE__ */ w.jsx(Tq, {
    theme: e,
    ...t
  }) : /* @__PURE__ */ w.jsx(aO, {
    theme: e,
    ...t
  });
}
function Bk(e) {
  return /* @__PURE__ */ w.jsx(rk, {
    ...e,
    defaultTheme: sb,
    themeId: Di
  });
}
process.env.NODE_ENV !== "production" && (Bk.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: s.oneOfType([s.array, s.func, s.number, s.object, s.string, s.bool])
});
function Pq(e) {
  return function(n) {
    return (
      // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
      /* @__PURE__ */ w.jsx(Bk, {
        styles: typeof e == "function" ? (r) => e({
          theme: r,
          ...n
        }) : e
      })
    );
  };
}
function Iq() {
  return ob;
}
const ut = hW;
process.env.NODE_ENV !== "production" && (s.node, s.object.isRequired);
function St(e) {
  return pW(e);
}
function Rq(e) {
  return gt("MuiSvgIcon", e);
}
vt("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const _q = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: r
  } = e, o = {
    root: ["root", t !== "inherit" && `color${Me(t)}`, `fontSize${Me(n)}`]
  };
  return Ct(o, Rq, r);
}, kq = oe("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${Me(n.color)}`], t[`fontSize${Me(n.fontSize)}`]];
  }
})(ut(({
  theme: e
}) => {
  var t, n, r, o, i, a, l, c, d, f, p, g, b, v;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    transition: (o = (t = e.transitions) == null ? void 0 : t.create) == null ? void 0 : o.call(t, "fill", {
      duration: (r = (n = (e.vars ?? e).transitions) == null ? void 0 : n.duration) == null ? void 0 : r.shorter
    }),
    variants: [
      {
        props: (y) => !y.hasSvgAsChild,
        style: {
          // the <svg> will define the property that has `currentColor`
          // for example heroicons uses fill="none" and stroke="currentColor"
          fill: "currentColor"
        }
      },
      {
        props: {
          fontSize: "inherit"
        },
        style: {
          fontSize: "inherit"
        }
      },
      {
        props: {
          fontSize: "small"
        },
        style: {
          fontSize: ((a = (i = e.typography) == null ? void 0 : i.pxToRem) == null ? void 0 : a.call(i, 20)) || "1.25rem"
        }
      },
      {
        props: {
          fontSize: "medium"
        },
        style: {
          fontSize: ((c = (l = e.typography) == null ? void 0 : l.pxToRem) == null ? void 0 : c.call(l, 24)) || "1.5rem"
        }
      },
      {
        props: {
          fontSize: "large"
        },
        style: {
          fontSize: ((f = (d = e.typography) == null ? void 0 : d.pxToRem) == null ? void 0 : f.call(d, 35)) || "2.1875rem"
        }
      },
      // TODO v5 deprecate color prop, v6 remove for sx
      ...Object.entries((e.vars ?? e).palette).filter(([, y]) => y && y.main).map(([y]) => {
        var S, E;
        return {
          props: {
            color: y
          },
          style: {
            color: (E = (S = (e.vars ?? e).palette) == null ? void 0 : S[y]) == null ? void 0 : E.main
          }
        };
      }),
      {
        props: {
          color: "action"
        },
        style: {
          color: (g = (p = (e.vars ?? e).palette) == null ? void 0 : p.action) == null ? void 0 : g.active
        }
      },
      {
        props: {
          color: "disabled"
        },
        style: {
          color: (v = (b = (e.vars ?? e).palette) == null ? void 0 : b.action) == null ? void 0 : v.disabled
        }
      },
      {
        props: {
          color: "inherit"
        },
        style: {
          color: void 0
        }
      }
    ]
  };
})), ld = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: o,
    className: i,
    color: a = "inherit",
    component: l = "svg",
    fontSize: c = "medium",
    htmlColor: d,
    inheritViewBox: f = !1,
    titleAccess: p,
    viewBox: g = "0 0 24 24",
    ...b
  } = r, v = /* @__PURE__ */ m.isValidElement(o) && o.type === "svg", y = {
    ...r,
    color: a,
    component: l,
    fontSize: c,
    instanceFontSize: t.fontSize,
    inheritViewBox: f,
    viewBox: g,
    hasSvgAsChild: v
  }, S = {};
  f || (S.viewBox = g);
  const E = _q(y);
  return /* @__PURE__ */ w.jsxs(kq, {
    as: l,
    className: ke(E.root, i),
    focusable: "false",
    color: d,
    "aria-hidden": p ? void 0 : !0,
    role: p ? "img" : void 0,
    ref: n,
    ...S,
    ...b,
    ...v && o.props,
    ownerState: y,
    children: [v ? o.props.children : o, p ? /* @__PURE__ */ w.jsx("title", {
      children: p
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (ld.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: s.oneOfType([s.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: s.oneOfType([s.oneOf(["inherit", "large", "medium", "small"]), s.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: s.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: s.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: s.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: s.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: s.string
});
ld.muiName = "SvgIcon";
function At(e, t) {
  function n(r, o) {
    return /* @__PURE__ */ w.jsx(ld, {
      "data-testid": `${t}Icon`,
      ref: o,
      ...r,
      children: e
    });
  }
  return process.env.NODE_ENV !== "production" && (n.displayName = `${t}Icon`), n.muiName = ld.muiName, /* @__PURE__ */ m.memo(/* @__PURE__ */ m.forwardRef(n));
}
function yt(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.includes(r)) continue;
    n[r] = e[r];
  }
  return n;
}
function e0(e, t) {
  return e0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, e0(e, t);
}
function Vk(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e0(e, t);
}
const lO = {
  disabled: !1
};
var Mq = process.env.NODE_ENV !== "production" ? s.oneOfType([s.number, s.shape({
  enter: s.number,
  exit: s.number,
  appear: s.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && s.oneOfType([s.string, s.shape({
  enter: s.string,
  exit: s.string,
  active: s.string
}), s.shape({
  enter: s.string,
  enterDone: s.string,
  enterActive: s.string,
  exit: s.string,
  exitDone: s.string,
  exitActive: s.string
})]);
const nm = en.createContext(null);
var Aq = function(t) {
  return t.scrollTop;
}, If = "unmounted", ql = "exited", Kl = "entering", Su = "entered", t0 = "exiting", ls = /* @__PURE__ */ function(e) {
  Vk(t, e);
  function t(r, o) {
    var i;
    i = e.call(this, r, o) || this;
    var a = o, l = a && !a.isMounting ? r.enter : r.appear, c;
    return i.appearStatus = null, r.in ? l ? (c = ql, i.appearStatus = Kl) : c = Su : r.unmountOnExit || r.mountOnEnter ? c = If : c = ql, i.state = {
      status: c
    }, i.nextCallback = null, i;
  }
  t.getDerivedStateFromProps = function(o, i) {
    var a = o.in;
    return a && i.status === If ? {
      status: ql
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(o) {
    var i = null;
    if (o !== this.props) {
      var a = this.state.status;
      this.props.in ? a !== Kl && a !== Su && (i = Kl) : (a === Kl || a === Su) && (i = t0);
    }
    this.updateStatus(!1, i);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var o = this.props.timeout, i, a, l;
    return i = a = l = o, o != null && typeof o != "number" && (i = o.exit, a = o.enter, l = o.appear !== void 0 ? o.appear : a), {
      exit: i,
      enter: a,
      appear: l
    };
  }, n.updateStatus = function(o, i) {
    if (o === void 0 && (o = !1), i !== null)
      if (this.cancelNextCallback(), i === Kl) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var a = this.props.nodeRef ? this.props.nodeRef.current : rg.findDOMNode(this);
          a && Aq(a);
        }
        this.performEnter(o);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === ql && this.setState({
      status: If
    });
  }, n.performEnter = function(o) {
    var i = this, a = this.props.enter, l = this.context ? this.context.isMounting : o, c = this.props.nodeRef ? [l] : [rg.findDOMNode(this), l], d = c[0], f = c[1], p = this.getTimeouts(), g = l ? p.appear : p.enter;
    if (!o && !a || lO.disabled) {
      this.safeSetState({
        status: Su
      }, function() {
        i.props.onEntered(d);
      });
      return;
    }
    this.props.onEnter(d, f), this.safeSetState({
      status: Kl
    }, function() {
      i.props.onEntering(d, f), i.onTransitionEnd(g, function() {
        i.safeSetState({
          status: Su
        }, function() {
          i.props.onEntered(d, f);
        });
      });
    });
  }, n.performExit = function() {
    var o = this, i = this.props.exit, a = this.getTimeouts(), l = this.props.nodeRef ? void 0 : rg.findDOMNode(this);
    if (!i || lO.disabled) {
      this.safeSetState({
        status: ql
      }, function() {
        o.props.onExited(l);
      });
      return;
    }
    this.props.onExit(l), this.safeSetState({
      status: t0
    }, function() {
      o.props.onExiting(l), o.onTransitionEnd(a.exit, function() {
        o.safeSetState({
          status: ql
        }, function() {
          o.props.onExited(l);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(o, i) {
    i = this.setNextCallback(i), this.setState(o, i);
  }, n.setNextCallback = function(o) {
    var i = this, a = !0;
    return this.nextCallback = function(l) {
      a && (a = !1, i.nextCallback = null, o(l));
    }, this.nextCallback.cancel = function() {
      a = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(o, i) {
    this.setNextCallback(i);
    var a = this.props.nodeRef ? this.props.nodeRef.current : rg.findDOMNode(this), l = o == null && !this.props.addEndListener;
    if (!a || l) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var c = this.props.nodeRef ? [this.nextCallback] : [a, this.nextCallback], d = c[0], f = c[1];
      this.props.addEndListener(d, f);
    }
    o != null && setTimeout(this.nextCallback, o);
  }, n.render = function() {
    var o = this.state.status;
    if (o === If)
      return null;
    var i = this.props, a = i.children;
    i.in, i.mountOnEnter, i.unmountOnExit, i.appear, i.enter, i.exit, i.timeout, i.addEndListener, i.onEnter, i.onEntering, i.onEntered, i.onExit, i.onExiting, i.onExited, i.nodeRef;
    var l = yt(i, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ en.createElement(nm.Provider, {
        value: null
      }, typeof a == "function" ? a(o, l) : en.cloneElement(en.Children.only(a), l))
    );
  }, t;
}(en.Component);
ls.contextType = nm;
ls.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: s.shape({
    current: typeof Element > "u" ? s.any : function(e, t, n, r, o, i) {
      var a = e[t];
      return s.instanceOf(a && "ownerDocument" in a ? a.ownerDocument.defaultView.Element : Element)(e, t, n, r, o, i);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: s.oneOfType([s.func.isRequired, s.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: s.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: s.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: s.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: s.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: s.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: s.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var n = Mq;
    t.addEndListener || (n = n.isRequired);
    for (var r = arguments.length, o = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
      o[i - 1] = arguments[i];
    return n.apply(void 0, [t].concat(o));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: s.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: s.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: s.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: s.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: s.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: s.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: s.func
} : {};
function ru() {
}
ls.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: ru,
  onEntering: ru,
  onEntered: ru,
  onExit: ru,
  onExiting: ru,
  onExited: ru
};
ls.UNMOUNTED = If;
ls.EXITED = ql;
ls.ENTERING = Kl;
ls.ENTERED = Su;
ls.EXITING = t0;
function Dq(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function zC(e, t) {
  var n = function(i) {
    return t && Mg(i) ? t(i) : i;
  }, r = /* @__PURE__ */ Object.create(null);
  return e && fz.map(e, function(o) {
    return o;
  }).forEach(function(o) {
    r[o.key] = n(o);
  }), r;
}
function Nq(e, t) {
  e = e || {}, t = t || {};
  function n(f) {
    return f in t ? t[f] : e[f];
  }
  var r = /* @__PURE__ */ Object.create(null), o = [];
  for (var i in e)
    i in t ? o.length && (r[i] = o, o = []) : o.push(i);
  var a, l = {};
  for (var c in t) {
    if (r[c])
      for (a = 0; a < r[c].length; a++) {
        var d = r[c][a];
        l[r[c][a]] = n(d);
      }
    l[c] = n(c);
  }
  for (a = 0; a < o.length; a++)
    l[o[a]] = n(o[a]);
  return l;
}
function nc(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function Fq(e, t) {
  return zC(e.children, function(n) {
    return Ag(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: nc(n, "appear", e),
      enter: nc(n, "enter", e),
      exit: nc(n, "exit", e)
    });
  });
}
function $q(e, t, n) {
  var r = zC(e.children), o = Nq(t, r);
  return Object.keys(o).forEach(function(i) {
    var a = o[i];
    if (Mg(a)) {
      var l = i in t, c = i in r, d = t[i], f = Mg(d) && !d.props.in;
      c && (!l || f) ? o[i] = Ag(a, {
        onExited: n.bind(null, a),
        in: !0,
        exit: nc(a, "exit", e),
        enter: nc(a, "enter", e)
      }) : !c && l && !f ? o[i] = Ag(a, {
        in: !1
      }) : c && l && Mg(d) && (o[i] = Ag(a, {
        onExited: n.bind(null, a),
        in: d.props.in,
        exit: nc(a, "exit", e),
        enter: nc(a, "enter", e)
      }));
    }
  }), o;
}
var Lq = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, jq = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, GC = /* @__PURE__ */ function(e) {
  Vk(t, e);
  function t(r, o) {
    var i;
    i = e.call(this, r, o) || this;
    var a = i.handleExited.bind(Dq(i));
    return i.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: a,
      firstRender: !0
    }, i;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(o, i) {
    var a = i.children, l = i.handleExited, c = i.firstRender;
    return {
      children: c ? Fq(o, l) : $q(o, a, l),
      firstRender: !1
    };
  }, n.handleExited = function(o, i) {
    var a = zC(this.props.children);
    o.key in a || (o.props.onExited && o.props.onExited(i), this.mounted && this.setState(function(l) {
      var c = U({}, l.children);
      return delete c[o.key], {
        children: c
      };
    }));
  }, n.render = function() {
    var o = this.props, i = o.component, a = o.childFactory, l = yt(o, ["component", "childFactory"]), c = this.state.contextValue, d = Lq(this.state.children).map(a);
    return delete l.appear, delete l.enter, delete l.exit, i === null ? /* @__PURE__ */ en.createElement(nm.Provider, {
      value: c
    }, d) : /* @__PURE__ */ en.createElement(nm.Provider, {
      value: c
    }, /* @__PURE__ */ en.createElement(i, l, d));
  }, t;
}(en.Component);
GC.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: s.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: s.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: s.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: s.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: s.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: s.func
} : {};
GC.defaultProps = jq;
const Hk = (e) => e.scrollTop;
function cd(e, t) {
  const {
    timeout: n,
    easing: r,
    style: o = {}
  } = e;
  return {
    duration: o.transitionDuration ?? (typeof n == "number" ? n : n[t.mode] || 0),
    easing: o.transitionTimingFunction ?? (typeof r == "object" ? r[t.mode] : r),
    delay: o.transitionDelay
  };
}
function Bq(e) {
  return gt("MuiCollapse", e);
}
vt("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);
const Vq = (e) => {
  const {
    orientation: t,
    classes: n
  } = e, r = {
    root: ["root", `${t}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${t}`],
    wrapperInner: ["wrapperInner", `${t}`]
  };
  return Ct(r, Bq, n);
}, Hq = oe("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation], n.state === "entered" && t.entered, n.state === "exited" && !n.in && n.collapsedSize === "0px" && t.hidden];
  }
})(ut(({
  theme: e
}) => ({
  height: 0,
  overflow: "hidden",
  transition: e.transitions.create("height"),
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      height: "auto",
      width: 0,
      transition: e.transitions.create("width")
    }
  }, {
    props: {
      state: "entered"
    },
    style: {
      height: "auto",
      overflow: "visible"
    }
  }, {
    props: {
      state: "entered",
      orientation: "horizontal"
    },
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.state === "exited" && !t.in && t.collapsedSize === "0px",
    style: {
      visibility: "hidden"
    }
  }]
}))), Uq = oe("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (e, t) => t.wrapper
})({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
}), zq = oe("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (e, t) => t.wrapperInner
})({
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
}), rp = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiCollapse"
  }), {
    addEndListener: o,
    children: i,
    className: a,
    collapsedSize: l = "0px",
    component: c,
    easing: d,
    in: f,
    onEnter: p,
    onEntered: g,
    onEntering: b,
    onExit: v,
    onExited: y,
    onExiting: S,
    orientation: E = "vertical",
    style: I,
    timeout: O = Dk.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: T = ls,
    ...P
  } = r, R = {
    ...r,
    orientation: E,
    collapsedSize: l
  }, F = Vq(R), A = bo(), _ = tc(), C = m.useRef(null), D = m.useRef(), L = typeof l == "number" ? `${l}px` : l, B = E === "horizontal", H = B ? "width" : "height", k = m.useRef(null), N = sr(n, k), j = (te) => (ie) => {
    if (te) {
      const ae = k.current;
      ie === void 0 ? te(ae) : te(ae, ie);
    }
  }, W = () => C.current ? C.current[B ? "clientWidth" : "clientHeight"] : 0, V = j((te, ie) => {
    C.current && B && (C.current.style.position = "absolute"), te.style[H] = L, p && p(te, ie);
  }), $ = j((te, ie) => {
    const ae = W();
    C.current && B && (C.current.style.position = "");
    const {
      duration: ce,
      easing: le
    } = cd({
      style: I,
      timeout: O,
      easing: d
    }, {
      mode: "enter"
    });
    if (O === "auto") {
      const we = A.transitions.getAutoHeightDuration(ae);
      te.style.transitionDuration = `${we}ms`, D.current = we;
    } else
      te.style.transitionDuration = typeof ce == "string" ? ce : `${ce}ms`;
    te.style[H] = `${ae}px`, te.style.transitionTimingFunction = le, b && b(te, ie);
  }), z = j((te, ie) => {
    te.style[H] = "auto", g && g(te, ie);
  }), ne = j((te) => {
    te.style[H] = `${W()}px`, v && v(te);
  }), K = j(y), Q = j((te) => {
    const ie = W(), {
      duration: ae,
      easing: ce
    } = cd({
      style: I,
      timeout: O,
      easing: d
    }, {
      mode: "exit"
    });
    if (O === "auto") {
      const le = A.transitions.getAutoHeightDuration(ie);
      te.style.transitionDuration = `${le}ms`, D.current = le;
    } else
      te.style.transitionDuration = typeof ae == "string" ? ae : `${ae}ms`;
    te.style[H] = L, te.style.transitionTimingFunction = ce, S && S(te);
  }), re = (te) => {
    O === "auto" && _.start(D.current || 0, te), o && o(k.current, te);
  };
  return /* @__PURE__ */ w.jsx(T, {
    in: f,
    onEnter: V,
    onEntered: z,
    onEntering: $,
    onExit: ne,
    onExited: K,
    onExiting: Q,
    addEndListener: re,
    nodeRef: k,
    timeout: O === "auto" ? null : O,
    ...P,
    children: (te, {
      ownerState: ie,
      ...ae
    }) => /* @__PURE__ */ w.jsx(Hq, {
      as: c,
      className: ke(F.root, a, {
        entered: F.entered,
        exited: !f && L === "0px" && F.hidden
      }[te]),
      style: {
        [B ? "minWidth" : "minHeight"]: L,
        ...I
      },
      ref: N,
      ownerState: {
        ...R,
        state: te
      },
      ...ae,
      children: /* @__PURE__ */ w.jsx(Uq, {
        ownerState: {
          ...R,
          state: te
        },
        className: F.wrapper,
        ref: C,
        children: /* @__PURE__ */ w.jsx(zq, {
          ownerState: {
            ...R,
            state: te
          },
          className: F.wrapperInner,
          children: i
        })
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (rp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: s.func,
  /**
   * The content node to be collapsed.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: s.oneOfType([s.number, s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Ed,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: s.oneOfType([s.shape({
    enter: s.string,
    exit: s.string
  }), s.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: s.bool,
  /**
   * @ignore
   */
  onEnter: s.func,
  /**
   * @ignore
   */
  onEntered: s.func,
  /**
   * @ignore
   */
  onEntering: s.func,
  /**
   * @ignore
   */
  onExit: s.func,
  /**
   * @ignore
   */
  onExited: s.func,
  /**
   * @ignore
   */
  onExiting: s.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: s.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: s.oneOfType([s.oneOf(["auto"]), s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })])
});
rp && (rp.muiSupportAuto = !0);
function Gq(e) {
  return gt("MuiPaper", e);
}
vt("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const Wq = (e) => {
  const {
    square: t,
    elevation: n,
    variant: r,
    classes: o
  } = e, i = {
    root: ["root", r, !t && "rounded", r === "elevation" && `elevation${n}`]
  };
  return Ct(i, Gq, o);
}, qq = oe("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], !n.square && t.rounded, n.variant === "elevation" && t[`elevation${n.elevation}`]];
  }
})(ut(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  color: (e.vars || e).palette.text.primary,
  transition: e.transitions.create("box-shadow"),
  variants: [{
    props: ({
      ownerState: t
    }) => !t.square,
    style: {
      borderRadius: e.shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: {
      variant: "elevation"
    },
    style: {
      boxShadow: "var(--Paper-shadow)",
      backgroundImage: "var(--Paper-overlay)"
    }
  }]
}))), cs = /* @__PURE__ */ m.forwardRef(function(t, n) {
  var b;
  const r = St({
    props: t,
    name: "MuiPaper"
  }), o = bo(), {
    className: i,
    component: a = "div",
    elevation: l = 1,
    square: c = !1,
    variant: d = "elevation",
    ...f
  } = r, p = {
    ...r,
    component: a,
    elevation: l,
    square: c,
    variant: d
  }, g = Wq(p);
  return process.env.NODE_ENV !== "production" && o.shadows[l] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${l}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${l}]\` is defined.`].join(`
`)), /* @__PURE__ */ w.jsx(qq, {
    as: a,
    ownerState: p,
    className: ke(g.root, i),
    ref: n,
    ...f,
    style: {
      ...d === "elevation" && {
        "--Paper-shadow": (o.vars || o).shadows[l],
        ...o.vars && {
          "--Paper-overlay": (b = o.vars.overlays) == null ? void 0 : b[l]
        },
        ...!o.vars && o.palette.mode === "dark" && {
          "--Paper-overlay": `linear-gradient(${Vt("#fff", Zw(l))}, ${Vt("#fff", Zw(l))})`
        }
      },
      ...f.style
    }
  });
});
process.env.NODE_ENV !== "production" && (cs.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: Go(dl, (e) => {
    const {
      elevation: t,
      variant: n
    } = e;
    return t > 0 && n === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${n}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: s.bool,
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: s.oneOfType([s.oneOf(["elevation", "outlined"]), s.string])
});
const WC = /* @__PURE__ */ m.createContext({});
process.env.NODE_ENV !== "production" && (WC.displayName = "AccordionContext");
function gn(e, t) {
  const {
    className: n,
    elementType: r,
    ownerState: o,
    externalForwardedProps: i,
    internalForwardedProps: a,
    ...l
  } = t, {
    component: c,
    slots: d = {
      [e]: void 0
    },
    slotProps: f = {
      [e]: void 0
    },
    ...p
  } = i, g = d[e] || r, b = Tk(f[e], o), {
    props: {
      component: v,
      ...y
    },
    internalRef: S
  } = Ek({
    className: n,
    ...l,
    externalForwardedProps: e === "root" ? p : void 0,
    externalSlotProps: b
  }), E = sr(S, b == null ? void 0 : b.ref, t.ref), I = e === "root" ? v || c : v, O = xk(g, {
    ...e === "root" && !c && !d[e] && a,
    ...e !== "root" && !d[e] && a,
    ...y,
    ...I && {
      as: I
    },
    ref: E
  }, o);
  return [g, O];
}
function Kq(e) {
  return gt("MuiAccordion", e);
}
const cg = vt("MuiAccordion", ["root", "heading", "rounded", "expanded", "disabled", "gutters", "region"]), Yq = (e) => {
  const {
    classes: t,
    square: n,
    expanded: r,
    disabled: o,
    disableGutters: i
  } = e;
  return Ct({
    root: ["root", !n && "rounded", r && "expanded", o && "disabled", !i && "gutters"],
    heading: ["heading"],
    region: ["region"]
  }, Kq, t);
}, Qq = oe(cs, {
  name: "MuiAccordion",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${cg.region}`]: t.region
    }, t.root, !n.square && t.rounded, !n.disableGutters && t.gutters];
  }
})(ut(({
  theme: e
}) => {
  const t = {
    duration: e.transitions.duration.shortest
  };
  return {
    position: "relative",
    transition: e.transitions.create(["margin"], t),
    overflowAnchor: "none",
    // Keep the same scrolling position
    "&::before": {
      position: "absolute",
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: (e.vars || e).palette.divider,
      transition: e.transitions.create(["opacity", "background-color"], t)
    },
    "&:first-of-type": {
      "&::before": {
        display: "none"
      }
    },
    [`&.${cg.expanded}`]: {
      "&::before": {
        opacity: 0
      },
      "&:first-of-type": {
        marginTop: 0
      },
      "&:last-of-type": {
        marginBottom: 0
      },
      "& + &": {
        "&::before": {
          display: "none"
        }
      }
    },
    [`&.${cg.disabled}`]: {
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    }
  };
}), ut(({
  theme: e
}) => ({
  variants: [{
    props: (t) => !t.square,
    style: {
      borderRadius: 0,
      "&:first-of-type": {
        borderTopLeftRadius: (e.vars || e).shape.borderRadius,
        borderTopRightRadius: (e.vars || e).shape.borderRadius
      },
      "&:last-of-type": {
        borderBottomLeftRadius: (e.vars || e).shape.borderRadius,
        borderBottomRightRadius: (e.vars || e).shape.borderRadius,
        // Fix a rendering issue on Edge
        "@supports (-ms-ime-align: auto)": {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    }
  }, {
    props: (t) => !t.disableGutters,
    style: {
      [`&.${cg.expanded}`]: {
        margin: "16px 0"
      }
    }
  }]
}))), Xq = oe("h3", {
  name: "MuiAccordion",
  slot: "Heading",
  overridesResolver: (e, t) => t.heading
})({
  all: "unset"
}), qC = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiAccordion"
  }), {
    children: o,
    className: i,
    defaultExpanded: a = !1,
    disabled: l = !1,
    disableGutters: c = !1,
    expanded: d,
    onChange: f,
    square: p = !1,
    slots: g = {},
    slotProps: b = {},
    TransitionComponent: v,
    TransitionProps: y,
    ...S
  } = r, [E, I] = ul({
    controlled: d,
    default: a,
    name: "Accordion",
    state: "expanded"
  }), O = m.useCallback((N) => {
    I(!E), f && f(N, !E);
  }, [E, f, I]), [T, ...P] = m.Children.toArray(o), R = m.useMemo(() => ({
    expanded: E,
    disabled: l,
    disableGutters: c,
    toggle: O
  }), [E, l, c, O]), F = {
    ...r,
    square: p,
    disabled: l,
    disableGutters: c,
    expanded: E
  }, A = Yq(F), _ = {
    transition: v,
    ...g
  }, C = {
    transition: y,
    ...b
  }, D = {
    slots: _,
    slotProps: C
  }, [L, B] = gn("heading", {
    elementType: Xq,
    externalForwardedProps: D,
    className: A.heading,
    ownerState: F
  }), [H, k] = gn("transition", {
    elementType: rp,
    externalForwardedProps: D,
    ownerState: F
  });
  return /* @__PURE__ */ w.jsxs(Qq, {
    className: ke(A.root, i),
    ref: n,
    ownerState: F,
    square: p,
    ...S,
    children: [/* @__PURE__ */ w.jsx(L, {
      ...B,
      children: /* @__PURE__ */ w.jsx(WC.Provider, {
        value: R,
        children: T
      })
    }), /* @__PURE__ */ w.jsx(H, {
      in: E,
      timeout: "auto",
      ...k,
      children: /* @__PURE__ */ w.jsx("div", {
        "aria-labelledby": T.props.id,
        id: T.props["aria-controls"],
        role: "region",
        className: A.region,
        children: P
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (qC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: Go(s.node.isRequired, (e) => {
    const t = m.Children.toArray(e.children)[0];
    return sd.isFragment(t) ? new Error("MUI: The Accordion doesn't accept a Fragment as a child. Consider providing an array instead.") : /* @__PURE__ */ m.isValidElement(t) ? null : new Error("MUI: Expected the first child of Accordion to be a valid element.");
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * If `true`, expands the accordion by default.
   * @default false
   */
  defaultExpanded: s.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, it removes the margin between two expanded accordion items and the increase of height.
   * @default false
   */
  disableGutters: s.bool,
  /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */
  expanded: s.bool,
  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */
  onChange: s.func,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    heading: s.oneOfType([s.func, s.object]),
    transition: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    heading: s.elementType,
    transition: s.elementType
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: s.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionProps: s.object
});
function Jq(e) {
  return gt("MuiAccordionDetails", e);
}
vt("MuiAccordionDetails", ["root"]);
const Zq = (e) => {
  const {
    classes: t
  } = e;
  return Ct({
    root: ["root"]
  }, Jq, t);
}, e4 = oe("div", {
  name: "MuiAccordionDetails",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(ut(({
  theme: e
}) => ({
  padding: e.spacing(1, 2, 2)
}))), KC = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiAccordionDetails"
  }), {
    className: o,
    ...i
  } = r, a = r, l = Zq(a);
  return /* @__PURE__ */ w.jsx(e4, {
    className: ke(l.root, o),
    ref: n,
    ownerState: a,
    ...i
  });
});
process.env.NODE_ENV !== "production" && (KC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
class rm {
  constructor() {
    nt(this, "mountEffect", () => {
      this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
    });
    this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new rm();
  }
  static use() {
    const t = mk(rm.create).current, [n, r] = m.useState(!1);
    return t.shouldMount = n, t.setShouldMount = r, m.useEffect(t.mountEffect, [n]), t;
  }
  mount() {
    return this.mounted || (this.mounted = n4(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  /* Ripple API */
  start(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.start(...t);
    });
  }
  stop(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.stop(...t);
    });
  }
  pulsate(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.pulsate(...t);
    });
  }
}
function t4() {
  return rm.use();
}
function n4() {
  let e, t;
  const n = new Promise((r, o) => {
    e = r, t = o;
  });
  return n.resolve = e, n.reject = t, n;
}
function Uk(e) {
  const {
    className: t,
    classes: n,
    pulsate: r = !1,
    rippleX: o,
    rippleY: i,
    rippleSize: a,
    in: l,
    onExited: c,
    timeout: d
  } = e, [f, p] = m.useState(!1), g = ke(t, n.ripple, n.rippleVisible, r && n.ripplePulsate), b = {
    width: a,
    height: a,
    top: -(a / 2) + i,
    left: -(a / 2) + o
  }, v = ke(n.child, f && n.childLeaving, r && n.childPulsate);
  return !l && !f && p(!0), m.useEffect(() => {
    if (!l && c != null) {
      const y = setTimeout(c, d);
      return () => {
        clearTimeout(y);
      };
    }
  }, [c, l, d]), /* @__PURE__ */ w.jsx("span", {
    className: g,
    style: b,
    children: /* @__PURE__ */ w.jsx("span", {
      className: v
    })
  });
}
process.env.NODE_ENV !== "production" && (Uk.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object.isRequired,
  className: s.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: s.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: s.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: s.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: s.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: s.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: s.number,
  /**
   * exit delay
   */
  timeout: s.number.isRequired
});
const _i = vt("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), n0 = 550, r4 = 80, o4 = Gs`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, i4 = Gs`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, s4 = Gs`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, a4 = oe("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), l4 = oe(Uk, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${_i.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${o4};
    animation-duration: ${n0}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  &.${_i.ripplePulsate} {
    animation-duration: ${({
  theme: e
}) => e.transitions.duration.shorter}ms;
  }

  & .${_i.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${_i.childLeaving} {
    opacity: 0;
    animation-name: ${i4};
    animation-duration: ${n0}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  & .${_i.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${s4};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, zk = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: o = !1,
    classes: i = {},
    className: a,
    ...l
  } = r, [c, d] = m.useState([]), f = m.useRef(0), p = m.useRef(null);
  m.useEffect(() => {
    p.current && (p.current(), p.current = null);
  }, [c]);
  const g = m.useRef(!1), b = tc(), v = m.useRef(null), y = m.useRef(null), S = m.useCallback((T) => {
    const {
      pulsate: P,
      rippleX: R,
      rippleY: F,
      rippleSize: A,
      cb: _
    } = T;
    d((C) => [...C, /* @__PURE__ */ w.jsx(l4, {
      classes: {
        ripple: ke(i.ripple, _i.ripple),
        rippleVisible: ke(i.rippleVisible, _i.rippleVisible),
        ripplePulsate: ke(i.ripplePulsate, _i.ripplePulsate),
        child: ke(i.child, _i.child),
        childLeaving: ke(i.childLeaving, _i.childLeaving),
        childPulsate: ke(i.childPulsate, _i.childPulsate)
      },
      timeout: n0,
      pulsate: P,
      rippleX: R,
      rippleY: F,
      rippleSize: A
    }, f.current)]), f.current += 1, p.current = _;
  }, [i]), E = m.useCallback((T = {}, P = {}, R = () => {
  }) => {
    const {
      pulsate: F = !1,
      center: A = o || P.pulsate,
      fakeElement: _ = !1
      // For test purposes
    } = P;
    if ((T == null ? void 0 : T.type) === "mousedown" && g.current) {
      g.current = !1;
      return;
    }
    (T == null ? void 0 : T.type) === "touchstart" && (g.current = !0);
    const C = _ ? null : y.current, D = C ? C.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let L, B, H;
    if (A || T === void 0 || T.clientX === 0 && T.clientY === 0 || !T.clientX && !T.touches)
      L = Math.round(D.width / 2), B = Math.round(D.height / 2);
    else {
      const {
        clientX: k,
        clientY: N
      } = T.touches && T.touches.length > 0 ? T.touches[0] : T;
      L = Math.round(k - D.left), B = Math.round(N - D.top);
    }
    if (A)
      H = Math.sqrt((2 * D.width ** 2 + D.height ** 2) / 3), H % 2 === 0 && (H += 1);
    else {
      const k = Math.max(Math.abs((C ? C.clientWidth : 0) - L), L) * 2 + 2, N = Math.max(Math.abs((C ? C.clientHeight : 0) - B), B) * 2 + 2;
      H = Math.sqrt(k ** 2 + N ** 2);
    }
    T != null && T.touches ? v.current === null && (v.current = () => {
      S({
        pulsate: F,
        rippleX: L,
        rippleY: B,
        rippleSize: H,
        cb: R
      });
    }, b.start(r4, () => {
      v.current && (v.current(), v.current = null);
    })) : S({
      pulsate: F,
      rippleX: L,
      rippleY: B,
      rippleSize: H,
      cb: R
    });
  }, [o, S, b]), I = m.useCallback(() => {
    E({}, {
      pulsate: !0
    });
  }, [E]), O = m.useCallback((T, P) => {
    if (b.clear(), (T == null ? void 0 : T.type) === "touchend" && v.current) {
      v.current(), v.current = null, b.start(0, () => {
        O(T, P);
      });
      return;
    }
    v.current = null, d((R) => R.length > 0 ? R.slice(1) : R), p.current = P;
  }, [b]);
  return m.useImperativeHandle(n, () => ({
    pulsate: I,
    start: E,
    stop: O
  }), [I, E, O]), /* @__PURE__ */ w.jsx(a4, {
    className: ke(_i.root, i.root, a),
    ref: y,
    ...l,
    children: /* @__PURE__ */ w.jsx(GC, {
      component: null,
      exit: !0,
      children: c
    })
  });
});
process.env.NODE_ENV !== "production" && (zk.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string
});
function c4(e) {
  return gt("MuiButtonBase", e);
}
const u4 = vt("MuiButtonBase", ["root", "disabled", "focusVisible"]), d4 = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: r,
    classes: o
  } = e, a = Ct({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, c4, o);
  return n && r && (a.root += ` ${r}`), a;
}, f4 = oe("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${u4.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), va = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: o,
    centerRipple: i = !1,
    children: a,
    className: l,
    component: c = "button",
    disabled: d = !1,
    disableRipple: f = !1,
    disableTouchRipple: p = !1,
    focusRipple: g = !1,
    focusVisibleClassName: b,
    LinkComponent: v = "a",
    onBlur: y,
    onClick: S,
    onContextMenu: E,
    onDragLeave: I,
    onFocus: O,
    onFocusVisible: T,
    onKeyDown: P,
    onKeyUp: R,
    onMouseDown: F,
    onMouseLeave: A,
    onMouseUp: _,
    onTouchEnd: C,
    onTouchMove: D,
    onTouchStart: L,
    tabIndex: B = 0,
    TouchRippleProps: H,
    touchRippleRef: k,
    type: N,
    ...j
  } = r, W = m.useRef(null), V = t4(), $ = sr(V.ref, k), [z, ne] = m.useState(!1);
  d && z && ne(!1), m.useImperativeHandle(o, () => ({
    focusVisible: () => {
      ne(!0), W.current.focus();
    }
  }), []);
  const K = V.shouldMount && !f && !d;
  m.useEffect(() => {
    z && g && !f && V.pulsate();
  }, [f, g, z, V]);
  const Q = ia(V, "start", F, p), re = ia(V, "stop", E, p), te = ia(V, "stop", I, p), ie = ia(V, "stop", _, p), ae = ia(V, "stop", (Ce) => {
    z && Ce.preventDefault(), A && A(Ce);
  }, p), ce = ia(V, "start", L, p), le = ia(V, "stop", C, p), we = ia(V, "stop", D, p), q = ia(V, "stop", (Ce) => {
    ad(Ce.target) || ne(!1), y && y(Ce);
  }, !1), Ee = li((Ce) => {
    W.current || (W.current = Ce.currentTarget), ad(Ce.target) && (ne(!0), T && T(Ce)), O && O(Ce);
  }), _e = () => {
    const Ce = W.current;
    return c && c !== "button" && !(Ce.tagName === "A" && Ce.href);
  }, $e = li((Ce) => {
    g && !Ce.repeat && z && Ce.key === " " && V.stop(Ce, () => {
      V.start(Ce);
    }), Ce.target === Ce.currentTarget && _e() && Ce.key === " " && Ce.preventDefault(), P && P(Ce), Ce.target === Ce.currentTarget && _e() && Ce.key === "Enter" && !d && (Ce.preventDefault(), S && S(Ce));
  }), Le = li((Ce) => {
    g && Ce.key === " " && z && !Ce.defaultPrevented && V.stop(Ce, () => {
      V.pulsate(Ce);
    }), R && R(Ce), S && Ce.target === Ce.currentTarget && _e() && Ce.key === " " && !Ce.defaultPrevented && S(Ce);
  });
  let Ze = c;
  Ze === "button" && (j.href || j.to) && (Ze = v);
  const J = {};
  Ze === "button" ? (J.type = N === void 0 ? "button" : N, J.disabled = d) : (!j.href && !j.to && (J.role = "button"), d && (J["aria-disabled"] = d));
  const fe = sr(n, W), me = {
    ...r,
    centerRipple: i,
    component: c,
    disabled: d,
    disableRipple: f,
    disableTouchRipple: p,
    focusRipple: g,
    tabIndex: B,
    focusVisible: z
  }, Oe = d4(me);
  return /* @__PURE__ */ w.jsxs(f4, {
    as: Ze,
    className: ke(Oe.root, l),
    ownerState: me,
    onBlur: q,
    onClick: S,
    onContextMenu: re,
    onFocus: Ee,
    onKeyDown: $e,
    onKeyUp: Le,
    onMouseDown: Q,
    onMouseLeave: ae,
    onMouseUp: ie,
    onDragLeave: te,
    onTouchEnd: le,
    onTouchMove: we,
    onTouchStart: ce,
    ref: fe,
    tabIndex: d ? -1 : B,
    type: N,
    ...J,
    ...j,
    children: [a, K ? /* @__PURE__ */ w.jsx(zk, {
      ref: $,
      center: i,
      ...H
    }) : null]
  });
});
function ia(e, t, n, r = !1) {
  return li((o) => (n && n(o), r || e[t](o), !0));
}
process.env.NODE_ENV !== "production" && (va.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: Wo,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: s.bool,
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Ed,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: s.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: s.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: s.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: s.string,
  /**
   * @ignore
   */
  href: s.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: s.elementType,
  /**
   * @ignore
   */
  onBlur: s.func,
  /**
   * @ignore
   */
  onClick: s.func,
  /**
   * @ignore
   */
  onContextMenu: s.func,
  /**
   * @ignore
   */
  onDragLeave: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: s.func,
  /**
   * @ignore
   */
  onKeyDown: s.func,
  /**
   * @ignore
   */
  onKeyUp: s.func,
  /**
   * @ignore
   */
  onMouseDown: s.func,
  /**
   * @ignore
   */
  onMouseLeave: s.func,
  /**
   * @ignore
   */
  onMouseUp: s.func,
  /**
   * @ignore
   */
  onTouchEnd: s.func,
  /**
   * @ignore
   */
  onTouchMove: s.func,
  /**
   * @ignore
   */
  onTouchStart: s.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * @default 0
   */
  tabIndex: s.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: s.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: s.oneOfType([s.func, s.shape({
    current: s.shape({
      pulsate: s.func.isRequired,
      start: s.func.isRequired,
      stop: s.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: s.oneOfType([s.oneOf(["button", "reset", "submit"]), s.string])
});
function p4(e) {
  return gt("MuiAccordionSummary", e);
}
const Ru = vt("MuiAccordionSummary", ["root", "expanded", "focusVisible", "disabled", "gutters", "contentGutters", "content", "expandIconWrapper"]), h4 = (e) => {
  const {
    classes: t,
    expanded: n,
    disabled: r,
    disableGutters: o
  } = e;
  return Ct({
    root: ["root", n && "expanded", r && "disabled", !o && "gutters"],
    focusVisible: ["focusVisible"],
    content: ["content", n && "expanded", !o && "contentGutters"],
    expandIconWrapper: ["expandIconWrapper", n && "expanded"]
  }, p4, t);
}, g4 = oe(va, {
  name: "MuiAccordionSummary",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(ut(({
  theme: e
}) => {
  const t = {
    duration: e.transitions.duration.shortest
  };
  return {
    display: "flex",
    width: "100%",
    minHeight: 48,
    padding: e.spacing(0, 2),
    transition: e.transitions.create(["min-height", "background-color"], t),
    [`&.${Ru.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    [`&.${Ru.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity
    },
    [`&:hover:not(.${Ru.disabled})`]: {
      cursor: "pointer"
    },
    variants: [{
      props: (n) => !n.disableGutters,
      style: {
        [`&.${Ru.expanded}`]: {
          minHeight: 64
        }
      }
    }]
  };
})), m4 = oe("span", {
  name: "MuiAccordionSummary",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})(ut(({
  theme: e
}) => ({
  display: "flex",
  textAlign: "start",
  flexGrow: 1,
  margin: "12px 0",
  variants: [{
    props: (t) => !t.disableGutters,
    style: {
      transition: e.transitions.create(["margin"], {
        duration: e.transitions.duration.shortest
      }),
      [`&.${Ru.expanded}`]: {
        margin: "20px 0"
      }
    }
  }]
}))), b4 = oe("span", {
  name: "MuiAccordionSummary",
  slot: "ExpandIconWrapper",
  overridesResolver: (e, t) => t.expandIconWrapper
})(ut(({
  theme: e
}) => ({
  display: "flex",
  color: (e.vars || e).palette.action.active,
  transform: "rotate(0deg)",
  transition: e.transitions.create("transform", {
    duration: e.transitions.duration.shortest
  }),
  [`&.${Ru.expanded}`]: {
    transform: "rotate(180deg)"
  }
}))), YC = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiAccordionSummary"
  }), {
    children: o,
    className: i,
    expandIcon: a,
    focusVisibleClassName: l,
    onClick: c,
    ...d
  } = r, {
    disabled: f = !1,
    disableGutters: p,
    expanded: g,
    toggle: b
  } = m.useContext(WC), v = (E) => {
    b && b(E), c && c(E);
  }, y = {
    ...r,
    expanded: g,
    disabled: f,
    disableGutters: p
  }, S = h4(y);
  return /* @__PURE__ */ w.jsxs(g4, {
    focusRipple: !1,
    disableRipple: !0,
    disabled: f,
    "aria-expanded": g,
    className: ke(S.root, i),
    focusVisibleClassName: ke(S.focusVisible, l),
    onClick: v,
    ref: n,
    ownerState: y,
    ...d,
    children: [/* @__PURE__ */ w.jsx(m4, {
      className: S.content,
      ownerState: y,
      children: o
    }), a && /* @__PURE__ */ w.jsx(b4, {
      className: S.expandIconWrapper,
      ownerState: y,
      children: a
    })]
  });
});
process.env.NODE_ENV !== "production" && (YC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: s.node,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: s.string,
  /**
   * @ignore
   */
  onClick: s.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function y4(e) {
  return typeof e.main == "string";
}
function v4(e, t = []) {
  if (!y4(e))
    return !1;
  for (const n of t)
    if (!e.hasOwnProperty(n) || typeof e[n] != "string")
      return !1;
  return !0;
}
function Jn(e = []) {
  return ([, t]) => t && v4(t, e);
}
function w4(e) {
  return gt("MuiAlert", e);
}
const cO = vt("MuiAlert", ["root", "action", "icon", "message", "filled", "colorSuccess", "colorInfo", "colorWarning", "colorError", "filledSuccess", "filledInfo", "filledWarning", "filledError", "outlined", "outlinedSuccess", "outlinedInfo", "outlinedWarning", "outlinedError", "standard", "standardSuccess", "standardInfo", "standardWarning", "standardError"]);
function C4(e) {
  return gt("MuiIconButton", e);
}
const x4 = vt("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), S4 = (e) => {
  const {
    classes: t,
    disabled: n,
    color: r,
    edge: o,
    size: i
  } = e, a = {
    root: ["root", n && "disabled", r !== "default" && `color${Me(r)}`, o && `edge${Me(o)}`, `size${Me(i)}`]
  };
  return Ct(a, C4, t);
}, E4 = oe(va, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${Me(n.color)}`], n.edge && t[`edge${Me(n.edge)}`], t[`size${Me(n.size)}`]];
  }
})(ut(({
  theme: e
}) => ({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: (t) => !t.disableRipple,
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : Vt(e.palette.action.active, e.palette.action.hoverOpacity),
      "&:hover": {
        backgroundColor: "var(--IconButton-hoverBg)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }]
})), ut(({
  theme: e
}) => ({
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, ...Object.entries(e.palette).filter(Jn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), ...Object.entries(e.palette).filter(Jn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${(e.vars || e).palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Vt((e.vars || e).palette[t].main, e.palette.action.hoverOpacity)
    }
  })), {
    props: {
      size: "small"
    },
    style: {
      padding: 5,
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 12,
      fontSize: e.typography.pxToRem(28)
    }
  }],
  [`&.${x4.disabled}`]: {
    backgroundColor: "transparent",
    color: (e.vars || e).palette.action.disabled
  }
}))), ks = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: o = !1,
    children: i,
    className: a,
    color: l = "default",
    disabled: c = !1,
    disableFocusRipple: d = !1,
    size: f = "medium",
    ...p
  } = r, g = {
    ...r,
    edge: o,
    color: l,
    disabled: c,
    disableFocusRipple: d,
    size: f
  }, b = S4(g);
  return /* @__PURE__ */ w.jsx(E4, {
    className: ke(b.root, a),
    centerRipple: !0,
    focusRipple: !d,
    disabled: c,
    ref: n,
    ...p,
    ownerState: g,
    children: i
  });
});
process.env.NODE_ENV !== "production" && (ks.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: Go(s.node, (e) => m.Children.toArray(e.children).some((n) => /* @__PURE__ */ m.isValidElement(n) && n.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: s.oneOfType([s.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: s.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: s.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: s.oneOf(["end", "start", !1]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["small", "medium", "large"]), s.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const T4 = At(/* @__PURE__ */ w.jsx("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined"), O4 = At(/* @__PURE__ */ w.jsx("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined"), P4 = At(/* @__PURE__ */ w.jsx("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline"), I4 = At(/* @__PURE__ */ w.jsx("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined"), Gk = At(/* @__PURE__ */ w.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), R4 = (e) => {
  const {
    variant: t,
    color: n,
    severity: r,
    classes: o
  } = e, i = {
    root: ["root", `color${Me(n || r)}`, `${t}${Me(n || r)}`, `${t}`],
    icon: ["icon"],
    message: ["message"],
    action: ["action"]
  };
  return Ct(i, w4, o);
}, _4 = oe(cs, {
  name: "MuiAlert",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${Me(n.color || n.severity)}`]];
  }
})(ut(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? gl : ml, n = e.palette.mode === "light" ? ml : gl;
  return {
    ...e.typography.body2,
    backgroundColor: "transparent",
    display: "flex",
    padding: "6px 16px",
    variants: [...Object.entries(e.palette).filter(Jn(["light"])).map(([r]) => ({
      props: {
        colorSeverity: r,
        variant: "standard"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${r}Color`] : t(e.palette[r].light, 0.6),
        backgroundColor: e.vars ? e.vars.palette.Alert[`${r}StandardBg`] : n(e.palette[r].light, 0.9),
        [`& .${cO.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${r}IconColor`]
        } : {
          color: e.palette[r].main
        }
      }
    })), ...Object.entries(e.palette).filter(Jn(["light"])).map(([r]) => ({
      props: {
        colorSeverity: r,
        variant: "outlined"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${r}Color`] : t(e.palette[r].light, 0.6),
        border: `1px solid ${(e.vars || e).palette[r].light}`,
        [`& .${cO.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${r}IconColor`]
        } : {
          color: e.palette[r].main
        }
      }
    })), ...Object.entries(e.palette).filter(Jn(["dark"])).map(([r]) => ({
      props: {
        colorSeverity: r,
        variant: "filled"
      },
      style: {
        fontWeight: e.typography.fontWeightMedium,
        ...e.vars ? {
          color: e.vars.palette.Alert[`${r}FilledColor`],
          backgroundColor: e.vars.palette.Alert[`${r}FilledBg`]
        } : {
          backgroundColor: e.palette.mode === "dark" ? e.palette[r].dark : e.palette[r].main,
          color: e.palette.getContrastText(e.palette[r].main)
        }
      }
    }))]
  };
})), k4 = oe("div", {
  name: "MuiAlert",
  slot: "Icon",
  overridesResolver: (e, t) => t.icon
})({
  marginRight: 12,
  padding: "7px 0",
  display: "flex",
  fontSize: 22,
  opacity: 0.9
}), M4 = oe("div", {
  name: "MuiAlert",
  slot: "Message",
  overridesResolver: (e, t) => t.message
})({
  padding: "8px 0",
  minWidth: 0,
  overflow: "auto"
}), uO = oe("div", {
  name: "MuiAlert",
  slot: "Action",
  overridesResolver: (e, t) => t.action
})({
  display: "flex",
  alignItems: "flex-start",
  padding: "4px 0 0 16px",
  marginLeft: "auto",
  marginRight: -8
}), dO = {
  success: /* @__PURE__ */ w.jsx(T4, {
    fontSize: "inherit"
  }),
  warning: /* @__PURE__ */ w.jsx(O4, {
    fontSize: "inherit"
  }),
  error: /* @__PURE__ */ w.jsx(P4, {
    fontSize: "inherit"
  }),
  info: /* @__PURE__ */ w.jsx(I4, {
    fontSize: "inherit"
  })
}, Wk = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiAlert"
  }), {
    action: o,
    children: i,
    className: a,
    closeText: l = "Close",
    color: c,
    components: d = {},
    componentsProps: f = {},
    icon: p,
    iconMapping: g = dO,
    onClose: b,
    role: v = "alert",
    severity: y = "success",
    slotProps: S = {},
    slots: E = {},
    variant: I = "standard",
    ...O
  } = r, T = {
    ...r,
    color: c,
    severity: y,
    variant: I,
    colorSeverity: c || y
  }, P = R4(T), R = {
    slots: {
      closeButton: d.CloseButton,
      closeIcon: d.CloseIcon,
      ...E
    },
    slotProps: {
      ...f,
      ...S
    }
  }, [F, A] = gn("closeButton", {
    elementType: ks,
    externalForwardedProps: R,
    ownerState: T
  }), [_, C] = gn("closeIcon", {
    elementType: Gk,
    externalForwardedProps: R,
    ownerState: T
  });
  return /* @__PURE__ */ w.jsxs(_4, {
    role: v,
    elevation: 0,
    ownerState: T,
    className: ke(P.root, a),
    ref: n,
    ...O,
    children: [p !== !1 ? /* @__PURE__ */ w.jsx(k4, {
      ownerState: T,
      className: P.icon,
      children: p || g[y] || dO[y]
    }) : null, /* @__PURE__ */ w.jsx(M4, {
      ownerState: T,
      className: P.message,
      children: i
    }), o != null ? /* @__PURE__ */ w.jsx(uO, {
      ownerState: T,
      className: P.action,
      children: o
    }) : null, o == null && b ? /* @__PURE__ */ w.jsx(uO, {
      ownerState: T,
      className: P.action,
      children: /* @__PURE__ */ w.jsx(F, {
        size: "small",
        "aria-label": l,
        title: l,
        color: "inherit",
        onClick: b,
        ...A,
        children: /* @__PURE__ */ w.jsx(_, {
          fontSize: "small",
          ...C
        })
      })
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (Wk.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: s.node,
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: s.string,
  /**
   * The color of the component. Unless provided, the value is taken from the `severity` prop.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: s.oneOfType([s.oneOf(["error", "info", "success", "warning"]), s.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    CloseButton: s.elementType,
    CloseIcon: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    closeButton: s.object,
    closeIcon: s.object
  }),
  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   * Set to `false` to remove the `icon`.
   */
  icon: s.node,
  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: s.shape({
    error: s.node,
    info: s.node,
    success: s.node,
    warning: s.node
  }),
  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: s.func,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: s.string,
  /**
   * The severity of the alert. This defines the color and icon used.
   * @default 'success'
   */
  severity: s.oneOfType([s.oneOf(["error", "info", "success", "warning"]), s.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    closeButton: s.oneOfType([s.func, s.object]),
    closeIcon: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    closeButton: s.elementType,
    closeIcon: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: s.oneOfType([s.oneOf(["filled", "outlined", "standard"]), s.string])
});
function A4(e) {
  return gt("MuiTypography", e);
}
const om = vt("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]), D4 = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, N4 = Iq(), F4 = (e) => {
  const {
    align: t,
    gutterBottom: n,
    noWrap: r,
    paragraph: o,
    variant: i,
    classes: a
  } = e, l = {
    root: ["root", i, e.align !== "inherit" && `align${Me(t)}`, n && "gutterBottom", r && "noWrap", o && "paragraph"]
  };
  return Ct(l, A4, a);
}, $4 = oe("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.variant && t[n.variant], n.align !== "inherit" && t[`align${Me(n.align)}`], n.noWrap && t.noWrap, n.gutterBottom && t.gutterBottom, n.paragraph && t.paragraph];
  }
})(ut(({
  theme: e
}) => {
  var t;
  return {
    margin: 0,
    variants: [{
      props: {
        variant: "inherit"
      },
      style: {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit",
        lineHeight: "inherit",
        letterSpacing: "inherit"
      }
    }, ...Object.entries(e.typography).filter(([n, r]) => n !== "inherit" && r && typeof r == "object").map(([n, r]) => ({
      props: {
        variant: n
      },
      style: r
    })), ...Object.entries(e.palette).filter(Jn()).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        color: (e.vars || e).palette[n].main
      }
    })), ...Object.entries(((t = e.palette) == null ? void 0 : t.text) || {}).filter(([, n]) => typeof n == "string").map(([n]) => ({
      props: {
        color: `text${Me(n)}`
      },
      style: {
        color: (e.vars || e).palette.text[n]
      }
    })), {
      props: ({
        ownerState: n
      }) => n.align !== "inherit",
      style: {
        textAlign: "var(--Typography-textAlign)"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.noWrap,
      style: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.gutterBottom,
      style: {
        marginBottom: "0.35em"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.paragraph,
      style: {
        marginBottom: 16
      }
    }]
  };
})), fO = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, Rt = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    color: r,
    ...o
  } = St({
    props: t,
    name: "MuiTypography"
  }), i = !D4[r], a = N4({
    ...o,
    ...i && {
      color: r
    }
  }), {
    align: l = "inherit",
    className: c,
    component: d,
    gutterBottom: f = !1,
    noWrap: p = !1,
    paragraph: g = !1,
    variant: b = "body1",
    variantMapping: v = fO,
    ...y
  } = a, S = {
    ...a,
    align: l,
    color: r,
    className: c,
    component: d,
    gutterBottom: f,
    noWrap: p,
    paragraph: g,
    variant: b,
    variantMapping: v
  }, E = d || (g ? "p" : v[b] || fO[b]) || "span", I = F4(S);
  return /* @__PURE__ */ w.jsx($4, {
    as: E,
    ref: n,
    className: ke(I.root, c),
    ...y,
    ownerState: S,
    style: {
      ...l !== "inherit" && {
        "--Typography-textAlign": l
      },
      ...y.style
    }
  });
});
process.env.NODE_ENV !== "production" && (Rt.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: s.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: s.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: s.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   * @deprecated Use the `component` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  paragraph: s.bool,
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: s.oneOfType([s.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), s.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: s.object
});
function L4(e) {
  return gt("MuiAlertTitle", e);
}
vt("MuiAlertTitle", ["root"]);
const j4 = (e) => {
  const {
    classes: t
  } = e;
  return Ct({
    root: ["root"]
  }, L4, t);
}, B4 = oe(Rt, {
  name: "MuiAlertTitle",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(ut(({
  theme: e
}) => ({
  fontWeight: e.typography.fontWeightMedium,
  marginTop: -2
}))), qk = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiAlertTitle"
  }), {
    className: o,
    ...i
  } = r, a = r, l = j4(a);
  return /* @__PURE__ */ w.jsx(B4, {
    gutterBottom: !0,
    component: "div",
    ownerState: a,
    ref: n,
    className: ke(l.root, o),
    ...i
  });
});
process.env.NODE_ENV !== "production" && (qk.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function pO(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function Kk(e = {}) {
  const {
    ignoreAccents: t = !0,
    ignoreCase: n = !0,
    limit: r,
    matchFrom: o = "any",
    stringify: i,
    trim: a = !1
  } = e;
  return (l, {
    inputValue: c,
    getOptionLabel: d
  }) => {
    let f = a ? c.trim() : c;
    n && (f = f.toLowerCase()), t && (f = pO(f));
    const p = f ? l.filter((g) => {
      let b = (i || d)(g);
      return n && (b = b.toLowerCase()), t && (b = pO(b)), o === "start" ? b.startsWith(f) : b.includes(f);
    }) : l;
    return typeof r == "number" ? p.slice(0, r) : p;
  };
}
const V4 = Kk(), hO = 5, H4 = (e) => {
  var t;
  return e.current !== null && ((t = e.current.parentElement) == null ? void 0 : t.contains(document.activeElement));
}, U4 = [];
function z4(e) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: t = H4,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: n = "Mui",
    autoComplete: r = !1,
    autoHighlight: o = !1,
    autoSelect: i = !1,
    blurOnSelect: a = !1,
    clearOnBlur: l = !e.freeSolo,
    clearOnEscape: c = !1,
    componentName: d = "useAutocomplete",
    defaultValue: f = e.multiple ? U4 : null,
    disableClearable: p = !1,
    disableCloseOnSelect: g = !1,
    disabled: b,
    disabledItemsFocusable: v = !1,
    disableListWrap: y = !1,
    filterOptions: S = V4,
    filterSelectedOptions: E = !1,
    freeSolo: I = !1,
    getOptionDisabled: O,
    getOptionKey: T,
    getOptionLabel: P = (pe) => pe.label ?? pe,
    groupBy: R,
    handleHomeEndKeys: F = !e.freeSolo,
    id: A,
    includeInputInList: _ = !1,
    inputValue: C,
    isOptionEqualToValue: D = (pe, he) => pe === he,
    multiple: L = !1,
    onChange: B,
    onClose: H,
    onHighlightChange: k,
    onInputChange: N,
    onOpen: j,
    open: W,
    openOnFocus: V = !1,
    options: $,
    readOnly: z = !1,
    selectOnFocus: ne = !e.freeSolo,
    value: K
  } = e, Q = wc(A);
  let re = P;
  re = (pe) => {
    const he = P(pe);
    if (typeof he != "string") {
      if (process.env.NODE_ENV !== "production") {
        const Fe = he === void 0 ? "undefined" : `${typeof he} (${he})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${d} returned ${Fe} instead of a string for ${JSON.stringify(pe)}.`);
      }
      return String(he);
    }
    return he;
  };
  const te = m.useRef(!1), ie = m.useRef(!0), ae = m.useRef(null), ce = m.useRef(null), [le, we] = m.useState(null), [q, Ee] = m.useState(-1), _e = o ? 0 : -1, $e = m.useRef(_e), [Le, Ze] = ul({
    controlled: K,
    default: f,
    name: d
  }), [J, fe] = ul({
    controlled: C,
    default: "",
    name: d,
    state: "inputValue"
  }), [me, Oe] = m.useState(!1), Ce = m.useCallback((pe, he, Fe) => {
    if (!(L ? Le.length < he.length : he !== null) && !l)
      return;
    let Ue;
    if (L)
      Ue = "";
    else if (he == null)
      Ue = "";
    else {
      const dt = re(he);
      Ue = typeof dt == "string" ? dt : "";
    }
    J !== Ue && (fe(Ue), N && N(pe, Ue, Fe));
  }, [re, J, L, N, fe, l, Le]), [Te, Pe] = ul({
    controlled: W,
    default: !1,
    name: d,
    state: "open"
  }), [Ye, Ke] = m.useState(!0), je = !L && Le != null && J === re(Le), Qe = Te && !z, et = Qe ? S(
    $.filter((pe) => !(E && (L ? Le : [Le]).some((he) => he !== null && D(pe, he)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: je && Ye ? "" : J,
      getOptionLabel: re
    }
  ) : [], Et = $C({
    filteredOptions: et,
    value: Le,
    inputValue: J
  });
  m.useEffect(() => {
    const pe = Le !== Et.value;
    me && !pe || I && !pe || Ce(null, Le, "reset");
  }, [Le, Ce, me, Et.value, I]);
  const Xe = Te && et.length > 0 && !z, xt = li((pe) => {
    pe === -1 ? ae.current.focus() : le.querySelector(`[data-tag-index="${pe}"]`).focus();
  });
  m.useEffect(() => {
    L && q > Le.length - 1 && (Ee(-1), xt(-1));
  }, [Le, L, q, xt]);
  function tt(pe, he) {
    if (!ce.current || pe < 0 || pe >= et.length)
      return -1;
    let Fe = pe;
    for (; ; ) {
      const We = ce.current.querySelector(`[data-option-index="${Fe}"]`), Ue = v ? !1 : !We || We.disabled || We.getAttribute("aria-disabled") === "true";
      if (We && We.hasAttribute("tabindex") && !Ue)
        return Fe;
      if (he === "next" ? Fe = (Fe + 1) % et.length : Fe = (Fe - 1 + et.length) % et.length, Fe === pe)
        return -1;
    }
  }
  const ct = li(({
    event: pe,
    index: he,
    reason: Fe = "auto"
  }) => {
    if ($e.current = he, he === -1 ? ae.current.removeAttribute("aria-activedescendant") : ae.current.setAttribute("aria-activedescendant", `${Q}-option-${he}`), k && k(pe, he === -1 ? null : et[he], Fe), !ce.current)
      return;
    const We = ce.current.querySelector(`[role="option"].${n}-focused`);
    We && (We.classList.remove(`${n}-focused`), We.classList.remove(`${n}-focusVisible`));
    let Ue = ce.current;
    if (ce.current.getAttribute("role") !== "listbox" && (Ue = ce.current.parentElement.querySelector('[role="listbox"]')), !Ue)
      return;
    if (he === -1) {
      Ue.scrollTop = 0;
      return;
    }
    const dt = ce.current.querySelector(`[data-option-index="${he}"]`);
    if (dt && (dt.classList.add(`${n}-focused`), Fe === "keyboard" && dt.classList.add(`${n}-focusVisible`), Ue.scrollHeight > Ue.clientHeight && Fe !== "mouse" && Fe !== "touch")) {
      const Tt = dt, zt = Ue.clientHeight + Ue.scrollTop, pn = Tt.offsetTop + Tt.offsetHeight;
      pn > zt ? Ue.scrollTop = pn - Ue.clientHeight : Tt.offsetTop - Tt.offsetHeight * (R ? 1.3 : 0) < Ue.scrollTop && (Ue.scrollTop = Tt.offsetTop - Tt.offsetHeight * (R ? 1.3 : 0));
    }
  }), Je = li(({
    event: pe,
    diff: he,
    direction: Fe = "next",
    reason: We = "auto"
  }) => {
    if (!Qe)
      return;
    const dt = tt((() => {
      const Tt = et.length - 1;
      if (he === "reset")
        return _e;
      if (he === "start")
        return 0;
      if (he === "end")
        return Tt;
      const zt = $e.current + he;
      return zt < 0 ? zt === -1 && _ ? -1 : y && $e.current !== -1 || Math.abs(he) > 1 ? 0 : Tt : zt > Tt ? zt === Tt + 1 && _ ? -1 : y || Math.abs(he) > 1 ? Tt : 0 : zt;
    })(), Fe);
    if (ct({
      index: dt,
      reason: We,
      event: pe
    }), r && he !== "reset")
      if (dt === -1)
        ae.current.value = J;
      else {
        const Tt = re(et[dt]);
        ae.current.value = Tt, Tt.toLowerCase().indexOf(J.toLowerCase()) === 0 && J.length > 0 && ae.current.setSelectionRange(J.length, Tt.length);
      }
  }), Ge = () => {
    const pe = (he, Fe) => {
      const We = he ? re(he) : "", Ue = Fe ? re(Fe) : "";
      return We === Ue;
    };
    if ($e.current !== -1 && Et.filteredOptions && Et.filteredOptions.length !== et.length && Et.inputValue === J && (L ? Le.length === Et.value.length && Et.value.every((he, Fe) => re(Le[Fe]) === re(he)) : pe(Et.value, Le))) {
      const he = Et.filteredOptions[$e.current];
      if (he)
        return et.findIndex((Fe) => re(Fe) === re(he));
    }
    return -1;
  }, lt = m.useCallback(() => {
    if (!Qe)
      return;
    const pe = Ge();
    if (pe !== -1) {
      $e.current = pe;
      return;
    }
    const he = L ? Le[0] : Le;
    if (et.length === 0 || he == null) {
      Je({
        diff: "reset"
      });
      return;
    }
    if (ce.current) {
      if (he != null) {
        const Fe = et[$e.current];
        if (L && Fe && Le.findIndex((Ue) => D(Fe, Ue)) !== -1)
          return;
        const We = et.findIndex((Ue) => D(Ue, he));
        We === -1 ? Je({
          diff: "reset"
        }) : ct({
          index: We
        });
        return;
      }
      if ($e.current >= et.length - 1) {
        ct({
          index: et.length - 1
        });
        return;
      }
      ct({
        index: $e.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    et.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    L ? !1 : Le,
    E,
    Je,
    ct,
    Qe,
    J,
    L
  ]), It = li((pe) => {
    Zg(ce, pe), pe && lt();
  });
  process.env.NODE_ENV !== "production" && m.useEffect(() => {
    (!ae.current || ae.current.nodeName !== "INPUT") && (ae.current && ae.current.nodeName === "TEXTAREA" ? console.warn([`A textarea element was provided to ${d} where input was expected.`, "This is not a supported scenario but it may work under certain conditions.", "A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).", "Make sure to test keyboard navigation and add custom event handlers if necessary."].join(`
`)) : console.error([`MUI: Unable to find the input element. It was resolved to ${ae.current} while an HTMLInputElement was expected.`, `Instead, ${d} expects an input element.`, "", d === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."].join(`
`)));
  }, [d]), m.useEffect(() => {
    lt();
  }, [lt]);
  const fn = (pe) => {
    Te || (Pe(!0), Ke(!0), j && j(pe));
  }, Bn = (pe, he) => {
    Te && (Pe(!1), H && H(pe, he));
  }, kn = (pe, he, Fe, We) => {
    if (L) {
      if (Le.length === he.length && Le.every((Ue, dt) => Ue === he[dt]))
        return;
    } else if (Le === he)
      return;
    B && B(pe, he, Fe, We), Ze(he);
  }, fr = m.useRef(!1), ar = (pe, he, Fe = "selectOption", We = "options") => {
    let Ue = Fe, dt = he;
    if (L) {
      if (dt = Array.isArray(Le) ? Le.slice() : [], process.env.NODE_ENV !== "production") {
        const zt = dt.filter((pn) => D(he, pn));
        zt.length > 1 && console.error([`MUI: The \`isOptionEqualToValue\` method of ${d} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${zt.length} matches.`].join(`
`));
      }
      const Tt = dt.findIndex((zt) => D(he, zt));
      Tt === -1 ? dt.push(he) : We !== "freeSolo" && (dt.splice(Tt, 1), Ue = "removeOption");
    }
    Ce(pe, dt, Ue), kn(pe, dt, Ue, {
      option: he
    }), !g && (!pe || !pe.ctrlKey && !pe.metaKey) && Bn(pe, Ue), (a === !0 || a === "touch" && fr.current || a === "mouse" && !fr.current) && ae.current.blur();
  };
  function Mr(pe, he) {
    if (pe === -1)
      return -1;
    let Fe = pe;
    for (; ; ) {
      if (he === "next" && Fe === Le.length || he === "previous" && Fe === -1)
        return -1;
      const We = le.querySelector(`[data-tag-index="${Fe}"]`);
      if (!We || !We.hasAttribute("tabindex") || We.disabled || We.getAttribute("aria-disabled") === "true")
        Fe += he === "next" ? 1 : -1;
      else
        return Fe;
    }
  }
  const Lr = (pe, he) => {
    if (!L)
      return;
    J === "" && Bn(pe, "toggleInput");
    let Fe = q;
    q === -1 ? J === "" && he === "previous" && (Fe = Le.length - 1) : (Fe += he === "next" ? 1 : -1, Fe < 0 && (Fe = 0), Fe === Le.length && (Fe = -1)), Fe = Mr(Fe, he), Ee(Fe), xt(Fe);
  }, lr = (pe) => {
    te.current = !0, fe(""), N && N(pe, "", "clear"), kn(pe, L ? [] : null, "clear");
  }, mt = (pe) => (he) => {
    if (pe.onKeyDown && pe.onKeyDown(he), !he.defaultMuiPrevented && (q !== -1 && !["ArrowLeft", "ArrowRight"].includes(he.key) && (Ee(-1), xt(-1)), he.which !== 229))
      switch (he.key) {
        case "Home":
          Qe && F && (he.preventDefault(), Je({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: he
          }));
          break;
        case "End":
          Qe && F && (he.preventDefault(), Je({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: he
          }));
          break;
        case "PageUp":
          he.preventDefault(), Je({
            diff: -hO,
            direction: "previous",
            reason: "keyboard",
            event: he
          }), fn(he);
          break;
        case "PageDown":
          he.preventDefault(), Je({
            diff: hO,
            direction: "next",
            reason: "keyboard",
            event: he
          }), fn(he);
          break;
        case "ArrowDown":
          he.preventDefault(), Je({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: he
          }), fn(he);
          break;
        case "ArrowUp":
          he.preventDefault(), Je({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: he
          }), fn(he);
          break;
        case "ArrowLeft":
          Lr(he, "previous");
          break;
        case "ArrowRight":
          Lr(he, "next");
          break;
        case "Enter":
          if ($e.current !== -1 && Qe) {
            const Fe = et[$e.current], We = O ? O(Fe) : !1;
            if (he.preventDefault(), We)
              return;
            ar(he, Fe, "selectOption"), r && ae.current.setSelectionRange(ae.current.value.length, ae.current.value.length);
          } else I && J !== "" && je === !1 && (L && he.preventDefault(), ar(he, J, "createOption", "freeSolo"));
          break;
        case "Escape":
          Qe ? (he.preventDefault(), he.stopPropagation(), Bn(he, "escape")) : c && (J !== "" || L && Le.length > 0) && (he.preventDefault(), he.stopPropagation(), lr(he));
          break;
        case "Backspace":
          if (L && !z && J === "" && Le.length > 0) {
            const Fe = q === -1 ? Le.length - 1 : q, We = Le.slice();
            We.splice(Fe, 1), kn(he, We, "removeOption", {
              option: Le[Fe]
            });
          }
          break;
        case "Delete":
          if (L && !z && J === "" && Le.length > 0 && q !== -1) {
            const Fe = q, We = Le.slice();
            We.splice(Fe, 1), kn(he, We, "removeOption", {
              option: Le[Fe]
            });
          }
          break;
      }
  }, er = (pe) => {
    Oe(!0), V && !te.current && fn(pe);
  }, eo = (pe) => {
    if (t(ce)) {
      ae.current.focus();
      return;
    }
    Oe(!1), ie.current = !0, te.current = !1, i && $e.current !== -1 && Qe ? ar(pe, et[$e.current], "blur") : i && I && J !== "" ? ar(pe, J, "blur", "freeSolo") : l && Ce(pe, Le, "blur"), Bn(pe, "blur");
  }, ue = (pe) => {
    const he = pe.target.value;
    J !== he && (fe(he), Ke(!1), N && N(pe, he, "input")), he === "" ? !p && !L && kn(pe, null, "clear") : fn(pe);
  }, ve = (pe) => {
    const he = Number(pe.currentTarget.getAttribute("data-option-index"));
    $e.current !== he && ct({
      event: pe,
      index: he,
      reason: "mouse"
    });
  }, Se = (pe) => {
    ct({
      event: pe,
      index: Number(pe.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), fr.current = !0;
  }, ze = (pe) => {
    const he = Number(pe.currentTarget.getAttribute("data-option-index"));
    ar(pe, et[he], "selectOption"), fr.current = !1;
  }, st = (pe) => (he) => {
    const Fe = Le.slice();
    Fe.splice(pe, 1), kn(he, Fe, "removeOption", {
      option: Le[pe]
    });
  }, bt = (pe) => {
    Te ? Bn(pe, "toggleInput") : fn(pe);
  }, Dt = (pe) => {
    pe.currentTarget.contains(pe.target) && pe.target.getAttribute("id") !== Q && pe.preventDefault();
  }, at = (pe) => {
    pe.currentTarget.contains(pe.target) && (ae.current.focus(), ne && ie.current && ae.current.selectionEnd - ae.current.selectionStart === 0 && ae.current.select(), ie.current = !1);
  }, Z = (pe) => {
    !b && (J === "" || !Te) && bt(pe);
  };
  let be = I && J.length > 0;
  be = be || (L ? Le.length > 0 : Le !== null);
  let Re = et;
  if (R) {
    const pe = /* @__PURE__ */ new Map();
    let he = !1;
    Re = et.reduce((Fe, We, Ue) => {
      const dt = R(We);
      return Fe.length > 0 && Fe[Fe.length - 1].group === dt ? Fe[Fe.length - 1].options.push(We) : (process.env.NODE_ENV !== "production" && (pe.get(dt) && !he && (console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${d} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`."), he = !0), pe.set(dt, !0)), Fe.push({
        key: Ue,
        index: Ue,
        group: dt,
        options: [We]
      })), Fe;
    }, []);
  }
  return b && me && eo(), {
    getRootProps: (pe = {}) => ({
      "aria-owns": Xe ? `${Q}-listbox` : null,
      ...pe,
      onKeyDown: mt(pe),
      onMouseDown: Dt,
      onClick: at
    }),
    getInputLabelProps: () => ({
      id: `${Q}-label`,
      htmlFor: Q
    }),
    getInputProps: () => ({
      id: Q,
      value: J,
      onBlur: eo,
      onFocus: er,
      onChange: ue,
      onMouseDown: Z,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": Qe ? "" : null,
      "aria-autocomplete": r ? "both" : "list",
      "aria-controls": Xe ? `${Q}-listbox` : void 0,
      "aria-expanded": Xe,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: ae,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: b
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: lr
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: bt
    }),
    getTagProps: ({
      index: pe
    }) => ({
      key: pe,
      "data-tag-index": pe,
      tabIndex: -1,
      ...!z && {
        onDelete: st(pe)
      }
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${Q}-listbox`,
      "aria-labelledby": `${Q}-label`,
      ref: It,
      onMouseDown: (pe) => {
        pe.preventDefault();
      }
    }),
    getOptionProps: ({
      index: pe,
      option: he
    }) => {
      const Fe = (L ? Le : [Le]).some((Ue) => Ue != null && D(he, Ue)), We = O ? O(he) : !1;
      return {
        key: (T == null ? void 0 : T(he)) ?? re(he),
        tabIndex: -1,
        role: "option",
        id: `${Q}-option-${pe}`,
        onMouseMove: ve,
        onClick: ze,
        onTouchStart: Se,
        "data-option-index": pe,
        "aria-disabled": We,
        "aria-selected": Fe
      };
    },
    id: Q,
    inputValue: J,
    value: Le,
    dirty: be,
    expanded: Qe && le,
    popupOpen: Qe,
    focused: me || q !== -1,
    anchorEl: le,
    setAnchorEl: we,
    focusedTag: q,
    groupedOptions: Re
  };
}
var Ho = "top", Fi = "bottom", $i = "right", Uo = "left", QC = "auto", Vp = [Ho, Fi, $i, Uo], ud = "start", op = "end", G4 = "clippingParents", Yk = "viewport", af = "popper", W4 = "reference", gO = /* @__PURE__ */ Vp.reduce(function(e, t) {
  return e.concat([t + "-" + ud, t + "-" + op]);
}, []), Qk = /* @__PURE__ */ [].concat(Vp, [QC]).reduce(function(e, t) {
  return e.concat([t, t + "-" + ud, t + "-" + op]);
}, []), q4 = "beforeRead", K4 = "read", Y4 = "afterRead", Q4 = "beforeMain", X4 = "main", J4 = "afterMain", Z4 = "beforeWrite", e3 = "write", t3 = "afterWrite", n3 = [q4, K4, Y4, Q4, X4, J4, Z4, e3, t3];
function Hs(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function fi(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Cc(e) {
  var t = fi(e).Element;
  return e instanceof t || e instanceof Element;
}
function Ni(e) {
  var t = fi(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function XC(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = fi(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function r3(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, o = t.attributes[n] || {}, i = t.elements[n];
    !Ni(i) || !Hs(i) || (Object.assign(i.style, r), Object.keys(o).forEach(function(a) {
      var l = o[a];
      l === !1 ? i.removeAttribute(a) : i.setAttribute(a, l === !0 ? "" : l);
    }));
  });
}
function o3(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var o = t.elements[r], i = t.attributes[r] || {}, a = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), l = a.reduce(function(c, d) {
        return c[d] = "", c;
      }, {});
      !Ni(o) || !Hs(o) || (Object.assign(o.style, l), Object.keys(i).forEach(function(c) {
        o.removeAttribute(c);
      }));
    });
  };
}
const i3 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: r3,
  effect: o3,
  requires: ["computeStyles"]
};
function Ns(e) {
  return e.split("-")[0];
}
var hc = Math.max, im = Math.min, dd = Math.round;
function r0() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Xk() {
  return !/^((?!chrome|android).)*safari/i.test(r0());
}
function fd(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), o = 1, i = 1;
  t && Ni(e) && (o = e.offsetWidth > 0 && dd(r.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && dd(r.height) / e.offsetHeight || 1);
  var a = Cc(e) ? fi(e) : window, l = a.visualViewport, c = !Xk() && n, d = (r.left + (c && l ? l.offsetLeft : 0)) / o, f = (r.top + (c && l ? l.offsetTop : 0)) / i, p = r.width / o, g = r.height / i;
  return {
    width: p,
    height: g,
    top: f,
    right: d + p,
    bottom: f + g,
    left: d,
    x: d,
    y: f
  };
}
function JC(e) {
  var t = fd(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function Jk(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && XC(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function wa(e) {
  return fi(e).getComputedStyle(e);
}
function s3(e) {
  return ["table", "td", "th"].indexOf(Hs(e)) >= 0;
}
function Ol(e) {
  return ((Cc(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function ab(e) {
  return Hs(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (XC(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Ol(e)
  );
}
function mO(e) {
  return !Ni(e) || // https://github.com/popperjs/popper-core/issues/837
  wa(e).position === "fixed" ? null : e.offsetParent;
}
function a3(e) {
  var t = /firefox/i.test(r0()), n = /Trident/i.test(r0());
  if (n && Ni(e)) {
    var r = wa(e);
    if (r.position === "fixed")
      return null;
  }
  var o = ab(e);
  for (XC(o) && (o = o.host); Ni(o) && ["html", "body"].indexOf(Hs(o)) < 0; ) {
    var i = wa(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Hp(e) {
  for (var t = fi(e), n = mO(e); n && s3(n) && wa(n).position === "static"; )
    n = mO(n);
  return n && (Hs(n) === "html" || Hs(n) === "body" && wa(n).position === "static") ? t : n || a3(e) || t;
}
function ZC(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function jf(e, t, n) {
  return hc(e, im(t, n));
}
function l3(e, t, n) {
  var r = jf(e, t, n);
  return r > n ? n : r;
}
function Zk() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function eM(e) {
  return Object.assign({}, Zk(), e);
}
function tM(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var c3 = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, eM(typeof t != "number" ? t : tM(t, Vp));
};
function u3(e) {
  var t, n = e.state, r = e.name, o = e.options, i = n.elements.arrow, a = n.modifiersData.popperOffsets, l = Ns(n.placement), c = ZC(l), d = [Uo, $i].indexOf(l) >= 0, f = d ? "height" : "width";
  if (!(!i || !a)) {
    var p = c3(o.padding, n), g = JC(i), b = c === "y" ? Ho : Uo, v = c === "y" ? Fi : $i, y = n.rects.reference[f] + n.rects.reference[c] - a[c] - n.rects.popper[f], S = a[c] - n.rects.reference[c], E = Hp(i), I = E ? c === "y" ? E.clientHeight || 0 : E.clientWidth || 0 : 0, O = y / 2 - S / 2, T = p[b], P = I - g[f] - p[v], R = I / 2 - g[f] / 2 + O, F = jf(T, R, P), A = c;
    n.modifiersData[r] = (t = {}, t[A] = F, t.centerOffset = F - R, t);
  }
}
function d3(e) {
  var t = e.state, n = e.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || Jk(t.elements.popper, o) && (t.elements.arrow = o));
}
const f3 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: u3,
  effect: d3,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function pd(e) {
  return e.split("-")[1];
}
var p3 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function h3(e, t) {
  var n = e.x, r = e.y, o = t.devicePixelRatio || 1;
  return {
    x: dd(n * o) / o || 0,
    y: dd(r * o) / o || 0
  };
}
function bO(e) {
  var t, n = e.popper, r = e.popperRect, o = e.placement, i = e.variation, a = e.offsets, l = e.position, c = e.gpuAcceleration, d = e.adaptive, f = e.roundOffsets, p = e.isFixed, g = a.x, b = g === void 0 ? 0 : g, v = a.y, y = v === void 0 ? 0 : v, S = typeof f == "function" ? f({
    x: b,
    y
  }) : {
    x: b,
    y
  };
  b = S.x, y = S.y;
  var E = a.hasOwnProperty("x"), I = a.hasOwnProperty("y"), O = Uo, T = Ho, P = window;
  if (d) {
    var R = Hp(n), F = "clientHeight", A = "clientWidth";
    if (R === fi(n) && (R = Ol(n), wa(R).position !== "static" && l === "absolute" && (F = "scrollHeight", A = "scrollWidth")), R = R, o === Ho || (o === Uo || o === $i) && i === op) {
      T = Fi;
      var _ = p && R === P && P.visualViewport ? P.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        R[F]
      );
      y -= _ - r.height, y *= c ? 1 : -1;
    }
    if (o === Uo || (o === Ho || o === Fi) && i === op) {
      O = $i;
      var C = p && R === P && P.visualViewport ? P.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        R[A]
      );
      b -= C - r.width, b *= c ? 1 : -1;
    }
  }
  var D = Object.assign({
    position: l
  }, d && p3), L = f === !0 ? h3({
    x: b,
    y
  }, fi(n)) : {
    x: b,
    y
  };
  if (b = L.x, y = L.y, c) {
    var B;
    return Object.assign({}, D, (B = {}, B[T] = I ? "0" : "", B[O] = E ? "0" : "", B.transform = (P.devicePixelRatio || 1) <= 1 ? "translate(" + b + "px, " + y + "px)" : "translate3d(" + b + "px, " + y + "px, 0)", B));
  }
  return Object.assign({}, D, (t = {}, t[T] = I ? y + "px" : "", t[O] = E ? b + "px" : "", t.transform = "", t));
}
function g3(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, i = n.adaptive, a = i === void 0 ? !0 : i, l = n.roundOffsets, c = l === void 0 ? !0 : l, d = {
    placement: Ns(t.placement),
    variation: pd(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, bO(Object.assign({}, d, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: a,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, bO(Object.assign({}, d, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const m3 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: g3,
  data: {}
};
var ug = {
  passive: !0
};
function b3(e) {
  var t = e.state, n = e.instance, r = e.options, o = r.scroll, i = o === void 0 ? !0 : o, a = r.resize, l = a === void 0 ? !0 : a, c = fi(t.elements.popper), d = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && d.forEach(function(f) {
    f.addEventListener("scroll", n.update, ug);
  }), l && c.addEventListener("resize", n.update, ug), function() {
    i && d.forEach(function(f) {
      f.removeEventListener("scroll", n.update, ug);
    }), l && c.removeEventListener("resize", n.update, ug);
  };
}
const y3 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: b3,
  data: {}
};
var v3 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Lg(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return v3[t];
  });
}
var w3 = {
  start: "end",
  end: "start"
};
function yO(e) {
  return e.replace(/start|end/g, function(t) {
    return w3[t];
  });
}
function ex(e) {
  var t = fi(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function tx(e) {
  return fd(Ol(e)).left + ex(e).scrollLeft;
}
function C3(e, t) {
  var n = fi(e), r = Ol(e), o = n.visualViewport, i = r.clientWidth, a = r.clientHeight, l = 0, c = 0;
  if (o) {
    i = o.width, a = o.height;
    var d = Xk();
    (d || !d && t === "fixed") && (l = o.offsetLeft, c = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: l + tx(e),
    y: c
  };
}
function x3(e) {
  var t, n = Ol(e), r = ex(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, i = hc(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), a = hc(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), l = -r.scrollLeft + tx(e), c = -r.scrollTop;
  return wa(o || n).direction === "rtl" && (l += hc(n.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: a,
    x: l,
    y: c
  };
}
function nx(e) {
  var t = wa(e), n = t.overflow, r = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function nM(e) {
  return ["html", "body", "#document"].indexOf(Hs(e)) >= 0 ? e.ownerDocument.body : Ni(e) && nx(e) ? e : nM(ab(e));
}
function Bf(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = nM(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = fi(r), a = o ? [i].concat(i.visualViewport || [], nx(r) ? r : []) : r, l = t.concat(a);
  return o ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(Bf(ab(a)))
  );
}
function o0(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function S3(e, t) {
  var n = fd(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function vO(e, t, n) {
  return t === Yk ? o0(C3(e, n)) : Cc(t) ? S3(t, n) : o0(x3(Ol(e)));
}
function E3(e) {
  var t = Bf(ab(e)), n = ["absolute", "fixed"].indexOf(wa(e).position) >= 0, r = n && Ni(e) ? Hp(e) : e;
  return Cc(r) ? t.filter(function(o) {
    return Cc(o) && Jk(o, r) && Hs(o) !== "body";
  }) : [];
}
function T3(e, t, n, r) {
  var o = t === "clippingParents" ? E3(e) : [].concat(t), i = [].concat(o, [n]), a = i[0], l = i.reduce(function(c, d) {
    var f = vO(e, d, r);
    return c.top = hc(f.top, c.top), c.right = im(f.right, c.right), c.bottom = im(f.bottom, c.bottom), c.left = hc(f.left, c.left), c;
  }, vO(e, a, r));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function rM(e) {
  var t = e.reference, n = e.element, r = e.placement, o = r ? Ns(r) : null, i = r ? pd(r) : null, a = t.x + t.width / 2 - n.width / 2, l = t.y + t.height / 2 - n.height / 2, c;
  switch (o) {
    case Ho:
      c = {
        x: a,
        y: t.y - n.height
      };
      break;
    case Fi:
      c = {
        x: a,
        y: t.y + t.height
      };
      break;
    case $i:
      c = {
        x: t.x + t.width,
        y: l
      };
      break;
    case Uo:
      c = {
        x: t.x - n.width,
        y: l
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var d = o ? ZC(o) : null;
  if (d != null) {
    var f = d === "y" ? "height" : "width";
    switch (i) {
      case ud:
        c[d] = c[d] - (t[f] / 2 - n[f] / 2);
        break;
      case op:
        c[d] = c[d] + (t[f] / 2 - n[f] / 2);
        break;
    }
  }
  return c;
}
function ip(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = r === void 0 ? e.placement : r, i = n.strategy, a = i === void 0 ? e.strategy : i, l = n.boundary, c = l === void 0 ? G4 : l, d = n.rootBoundary, f = d === void 0 ? Yk : d, p = n.elementContext, g = p === void 0 ? af : p, b = n.altBoundary, v = b === void 0 ? !1 : b, y = n.padding, S = y === void 0 ? 0 : y, E = eM(typeof S != "number" ? S : tM(S, Vp)), I = g === af ? W4 : af, O = e.rects.popper, T = e.elements[v ? I : g], P = T3(Cc(T) ? T : T.contextElement || Ol(e.elements.popper), c, f, a), R = fd(e.elements.reference), F = rM({
    reference: R,
    element: O,
    strategy: "absolute",
    placement: o
  }), A = o0(Object.assign({}, O, F)), _ = g === af ? A : R, C = {
    top: P.top - _.top + E.top,
    bottom: _.bottom - P.bottom + E.bottom,
    left: P.left - _.left + E.left,
    right: _.right - P.right + E.right
  }, D = e.modifiersData.offset;
  if (g === af && D) {
    var L = D[o];
    Object.keys(C).forEach(function(B) {
      var H = [$i, Fi].indexOf(B) >= 0 ? 1 : -1, k = [Ho, Fi].indexOf(B) >= 0 ? "y" : "x";
      C[B] += L[k] * H;
    });
  }
  return C;
}
function O3(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = n.boundary, i = n.rootBoundary, a = n.padding, l = n.flipVariations, c = n.allowedAutoPlacements, d = c === void 0 ? Qk : c, f = pd(r), p = f ? l ? gO : gO.filter(function(v) {
    return pd(v) === f;
  }) : Vp, g = p.filter(function(v) {
    return d.indexOf(v) >= 0;
  });
  g.length === 0 && (g = p);
  var b = g.reduce(function(v, y) {
    return v[y] = ip(e, {
      placement: y,
      boundary: o,
      rootBoundary: i,
      padding: a
    })[Ns(y)], v;
  }, {});
  return Object.keys(b).sort(function(v, y) {
    return b[v] - b[y];
  });
}
function P3(e) {
  if (Ns(e) === QC)
    return [];
  var t = Lg(e);
  return [yO(e), t, yO(t)];
}
function I3(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, l = a === void 0 ? !0 : a, c = n.fallbackPlacements, d = n.padding, f = n.boundary, p = n.rootBoundary, g = n.altBoundary, b = n.flipVariations, v = b === void 0 ? !0 : b, y = n.allowedAutoPlacements, S = t.options.placement, E = Ns(S), I = E === S, O = c || (I || !v ? [Lg(S)] : P3(S)), T = [S].concat(O).reduce(function(Q, re) {
      return Q.concat(Ns(re) === QC ? O3(t, {
        placement: re,
        boundary: f,
        rootBoundary: p,
        padding: d,
        flipVariations: v,
        allowedAutoPlacements: y
      }) : re);
    }, []), P = t.rects.reference, R = t.rects.popper, F = /* @__PURE__ */ new Map(), A = !0, _ = T[0], C = 0; C < T.length; C++) {
      var D = T[C], L = Ns(D), B = pd(D) === ud, H = [Ho, Fi].indexOf(L) >= 0, k = H ? "width" : "height", N = ip(t, {
        placement: D,
        boundary: f,
        rootBoundary: p,
        altBoundary: g,
        padding: d
      }), j = H ? B ? $i : Uo : B ? Fi : Ho;
      P[k] > R[k] && (j = Lg(j));
      var W = Lg(j), V = [];
      if (i && V.push(N[L] <= 0), l && V.push(N[j] <= 0, N[W] <= 0), V.every(function(Q) {
        return Q;
      })) {
        _ = D, A = !1;
        break;
      }
      F.set(D, V);
    }
    if (A)
      for (var $ = v ? 3 : 1, z = function(re) {
        var te = T.find(function(ie) {
          var ae = F.get(ie);
          if (ae)
            return ae.slice(0, re).every(function(ce) {
              return ce;
            });
        });
        if (te)
          return _ = te, "break";
      }, ne = $; ne > 0; ne--) {
        var K = z(ne);
        if (K === "break") break;
      }
    t.placement !== _ && (t.modifiersData[r]._skip = !0, t.placement = _, t.reset = !0);
  }
}
const R3 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: I3,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function wO(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function CO(e) {
  return [Ho, $i, Fi, Uo].some(function(t) {
    return e[t] >= 0;
  });
}
function _3(e) {
  var t = e.state, n = e.name, r = t.rects.reference, o = t.rects.popper, i = t.modifiersData.preventOverflow, a = ip(t, {
    elementContext: "reference"
  }), l = ip(t, {
    altBoundary: !0
  }), c = wO(a, r), d = wO(l, o, i), f = CO(c), p = CO(d);
  t.modifiersData[n] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: d,
    isReferenceHidden: f,
    hasPopperEscaped: p
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": f,
    "data-popper-escaped": p
  });
}
const k3 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: _3
};
function M3(e, t, n) {
  var r = Ns(e), o = [Uo, Ho].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, a = i[0], l = i[1];
  return a = a || 0, l = (l || 0) * o, [Uo, $i].indexOf(r) >= 0 ? {
    x: l,
    y: a
  } : {
    x: a,
    y: l
  };
}
function A3(e) {
  var t = e.state, n = e.options, r = e.name, o = n.offset, i = o === void 0 ? [0, 0] : o, a = Qk.reduce(function(f, p) {
    return f[p] = M3(p, t.rects, i), f;
  }, {}), l = a[t.placement], c = l.x, d = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += d), t.modifiersData[r] = a;
}
const D3 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: A3
};
function N3(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = rM({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const F3 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: N3,
  data: {}
};
function $3(e) {
  return e === "x" ? "y" : "x";
}
function L3(e) {
  var t = e.state, n = e.options, r = e.name, o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, l = a === void 0 ? !1 : a, c = n.boundary, d = n.rootBoundary, f = n.altBoundary, p = n.padding, g = n.tether, b = g === void 0 ? !0 : g, v = n.tetherOffset, y = v === void 0 ? 0 : v, S = ip(t, {
    boundary: c,
    rootBoundary: d,
    padding: p,
    altBoundary: f
  }), E = Ns(t.placement), I = pd(t.placement), O = !I, T = ZC(E), P = $3(T), R = t.modifiersData.popperOffsets, F = t.rects.reference, A = t.rects.popper, _ = typeof y == "function" ? y(Object.assign({}, t.rects, {
    placement: t.placement
  })) : y, C = typeof _ == "number" ? {
    mainAxis: _,
    altAxis: _
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, _), D = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, L = {
    x: 0,
    y: 0
  };
  if (R) {
    if (i) {
      var B, H = T === "y" ? Ho : Uo, k = T === "y" ? Fi : $i, N = T === "y" ? "height" : "width", j = R[T], W = j + S[H], V = j - S[k], $ = b ? -A[N] / 2 : 0, z = I === ud ? F[N] : A[N], ne = I === ud ? -A[N] : -F[N], K = t.elements.arrow, Q = b && K ? JC(K) : {
        width: 0,
        height: 0
      }, re = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Zk(), te = re[H], ie = re[k], ae = jf(0, F[N], Q[N]), ce = O ? F[N] / 2 - $ - ae - te - C.mainAxis : z - ae - te - C.mainAxis, le = O ? -F[N] / 2 + $ + ae + ie + C.mainAxis : ne + ae + ie + C.mainAxis, we = t.elements.arrow && Hp(t.elements.arrow), q = we ? T === "y" ? we.clientTop || 0 : we.clientLeft || 0 : 0, Ee = (B = D == null ? void 0 : D[T]) != null ? B : 0, _e = j + ce - Ee - q, $e = j + le - Ee, Le = jf(b ? im(W, _e) : W, j, b ? hc(V, $e) : V);
      R[T] = Le, L[T] = Le - j;
    }
    if (l) {
      var Ze, J = T === "x" ? Ho : Uo, fe = T === "x" ? Fi : $i, me = R[P], Oe = P === "y" ? "height" : "width", Ce = me + S[J], Te = me - S[fe], Pe = [Ho, Uo].indexOf(E) !== -1, Ye = (Ze = D == null ? void 0 : D[P]) != null ? Ze : 0, Ke = Pe ? Ce : me - F[Oe] - A[Oe] - Ye + C.altAxis, je = Pe ? me + F[Oe] + A[Oe] - Ye - C.altAxis : Te, Qe = b && Pe ? l3(Ke, me, je) : jf(b ? Ke : Ce, me, b ? je : Te);
      R[P] = Qe, L[P] = Qe - me;
    }
    t.modifiersData[r] = L;
  }
}
const j3 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: L3,
  requiresIfExists: ["offset"]
};
function B3(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function V3(e) {
  return e === fi(e) || !Ni(e) ? ex(e) : B3(e);
}
function H3(e) {
  var t = e.getBoundingClientRect(), n = dd(t.width) / e.offsetWidth || 1, r = dd(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function U3(e, t, n) {
  n === void 0 && (n = !1);
  var r = Ni(t), o = Ni(t) && H3(t), i = Ol(t), a = fd(e, o, n), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((Hs(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  nx(i)) && (l = V3(t)), Ni(t) ? (c = fd(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : i && (c.x = tx(i))), {
    x: a.left + l.scrollLeft - c.x,
    y: a.top + l.scrollTop - c.y,
    width: a.width,
    height: a.height
  };
}
function z3(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function o(i) {
    n.add(i.name);
    var a = [].concat(i.requires || [], i.requiresIfExists || []);
    a.forEach(function(l) {
      if (!n.has(l)) {
        var c = t.get(l);
        c && o(c);
      }
    }), r.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || o(i);
  }), r;
}
function G3(e) {
  var t = z3(e);
  return n3.reduce(function(n, r) {
    return n.concat(t.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function W3(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function q3(e) {
  var t = e.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var xO = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function SO() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function K3(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, o = t.defaultOptions, i = o === void 0 ? xO : o;
  return function(l, c, d) {
    d === void 0 && (d = i);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, xO, i),
      modifiersData: {},
      elements: {
        reference: l,
        popper: c
      },
      attributes: {},
      styles: {}
    }, p = [], g = !1, b = {
      state: f,
      setOptions: function(E) {
        var I = typeof E == "function" ? E(f.options) : E;
        y(), f.options = Object.assign({}, i, f.options, I), f.scrollParents = {
          reference: Cc(l) ? Bf(l) : l.contextElement ? Bf(l.contextElement) : [],
          popper: Bf(c)
        };
        var O = G3(q3([].concat(r, f.options.modifiers)));
        return f.orderedModifiers = O.filter(function(T) {
          return T.enabled;
        }), v(), b.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!g) {
          var E = f.elements, I = E.reference, O = E.popper;
          if (SO(I, O)) {
            f.rects = {
              reference: U3(I, Hp(O), f.options.strategy === "fixed"),
              popper: JC(O)
            }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function(C) {
              return f.modifiersData[C.name] = Object.assign({}, C.data);
            });
            for (var T = 0; T < f.orderedModifiers.length; T++) {
              if (f.reset === !0) {
                f.reset = !1, T = -1;
                continue;
              }
              var P = f.orderedModifiers[T], R = P.fn, F = P.options, A = F === void 0 ? {} : F, _ = P.name;
              typeof R == "function" && (f = R({
                state: f,
                options: A,
                name: _,
                instance: b
              }) || f);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: W3(function() {
        return new Promise(function(S) {
          b.forceUpdate(), S(f);
        });
      }),
      destroy: function() {
        y(), g = !0;
      }
    };
    if (!SO(l, c))
      return b;
    b.setOptions(d).then(function(S) {
      !g && d.onFirstUpdate && d.onFirstUpdate(S);
    });
    function v() {
      f.orderedModifiers.forEach(function(S) {
        var E = S.name, I = S.options, O = I === void 0 ? {} : I, T = S.effect;
        if (typeof T == "function") {
          var P = T({
            state: f,
            name: E,
            instance: b,
            options: O
          }), R = function() {
          };
          p.push(P || R);
        }
      });
    }
    function y() {
      p.forEach(function(S) {
        return S();
      }), p = [];
    }
    return b;
  };
}
var Y3 = [y3, F3, m3, i3, D3, R3, j3, f3, k3], Q3 = /* @__PURE__ */ K3({
  defaultModifiers: Y3
});
function X3(e) {
  return typeof e == "function" ? e() : e;
}
const sp = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    children: r,
    container: o,
    disablePortal: i = !1
  } = t, [a, l] = m.useState(null), c = sr(/* @__PURE__ */ m.isValidElement(r) ? Rc(r) : null, n);
  if (ss(() => {
    i || l(X3(o) || document.body);
  }, [o, i]), ss(() => {
    if (a && !i)
      return Zg(n, a), () => {
        Zg(n, null);
      };
  }, [n, a, i]), i) {
    if (/* @__PURE__ */ m.isValidElement(r)) {
      const d = {
        ref: c
      };
      return /* @__PURE__ */ m.cloneElement(r, d);
    }
    return r;
  }
  return a && /* @__PURE__ */ xC.createPortal(r, a);
});
process.env.NODE_ENV !== "production" && (sp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: s.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: s.oneOfType([ba, s.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: s.bool
});
process.env.NODE_ENV !== "production" && (sp.propTypes = Bp(sp.propTypes));
function J3(e) {
  return gt("MuiPopper", e);
}
vt("MuiPopper", ["root"]);
function Z3(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function sm(e) {
  return typeof e == "function" ? e() : e;
}
function lb(e) {
  return e.nodeType !== void 0;
}
function e6(e) {
  return !lb(e);
}
const t6 = (e) => {
  const {
    classes: t
  } = e;
  return Ct({
    root: ["root"]
  }, J3, t);
}, n6 = {}, r6 = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: o,
    direction: i,
    disablePortal: a,
    modifiers: l,
    open: c,
    placement: d,
    popperOptions: f,
    popperRef: p,
    slotProps: g = {},
    slots: b = {},
    TransitionProps: v,
    // @ts-ignore internal logic
    ownerState: y,
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...S
  } = t, E = m.useRef(null), I = sr(E, n), O = m.useRef(null), T = sr(O, p), P = m.useRef(T);
  ss(() => {
    P.current = T;
  }, [T]), m.useImperativeHandle(p, () => O.current, []);
  const R = Z3(d, i), [F, A] = m.useState(R), [_, C] = m.useState(sm(r));
  m.useEffect(() => {
    O.current && O.current.forceUpdate();
  }), m.useEffect(() => {
    r && C(sm(r));
  }, [r]), ss(() => {
    if (!_ || !c)
      return;
    const k = (W) => {
      A(W.placement);
    };
    if (process.env.NODE_ENV !== "production" && _ && lb(_) && _.nodeType === 1) {
      const W = _.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && W.top === 0 && W.left === 0 && W.right === 0 && W.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let N = [{
      name: "preventOverflow",
      options: {
        altBoundary: a
      }
    }, {
      name: "flip",
      options: {
        altBoundary: a
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: W
      }) => {
        k(W);
      }
    }];
    l != null && (N = N.concat(l)), f && f.modifiers != null && (N = N.concat(f.modifiers));
    const j = Q3(_, E.current, {
      placement: R,
      ...f,
      modifiers: N
    });
    return P.current(j), () => {
      j.destroy(), P.current(null);
    };
  }, [_, a, l, c, f, R]);
  const D = {
    placement: F
  };
  v !== null && (D.TransitionProps = v);
  const L = t6(t), B = b.root ?? "div", H = tp({
    elementType: B,
    externalSlotProps: g.root,
    externalForwardedProps: S,
    additionalProps: {
      role: "tooltip",
      ref: I
    },
    ownerState: t,
    className: L.root
  });
  return /* @__PURE__ */ w.jsx(B, {
    ...H,
    children: typeof o == "function" ? o(D) : o
  });
}), oM = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: o,
    container: i,
    direction: a = "ltr",
    disablePortal: l = !1,
    keepMounted: c = !1,
    modifiers: d,
    open: f,
    placement: p = "bottom",
    popperOptions: g = n6,
    popperRef: b,
    style: v,
    transition: y = !1,
    slotProps: S = {},
    slots: E = {},
    ...I
  } = t, [O, T] = m.useState(!0), P = () => {
    T(!1);
  }, R = () => {
    T(!0);
  };
  if (!c && !f && (!y || O))
    return null;
  let F;
  if (i)
    F = i;
  else if (r) {
    const C = sm(r);
    F = C && lb(C) ? go(C).body : go(null).body;
  }
  const A = !f && c && (!y || O) ? "none" : void 0, _ = y ? {
    in: f,
    onEnter: P,
    onExited: R
  } : void 0;
  return /* @__PURE__ */ w.jsx(sp, {
    disablePortal: l,
    container: F,
    children: /* @__PURE__ */ w.jsx(r6, {
      anchorEl: r,
      direction: a,
      disablePortal: l,
      modifiers: d,
      ref: n,
      open: y ? !O : f,
      placement: p,
      popperOptions: g,
      popperRef: b,
      slotProps: S,
      slots: E,
      ...I,
      style: {
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: A,
        ...v
      },
      TransitionProps: _,
      children: o
    })
  });
});
process.env.NODE_ENV !== "production" && (oM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: Go(s.oneOfType([ba, s.object, s.func]), (e) => {
    if (e.open) {
      const t = sm(e.anchorEl);
      if (t && lb(t) && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || e6(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: s.oneOfType([s.node, s.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: s.oneOfType([ba, s.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: s.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: s.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: s.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: s.arrayOf(s.shape({
    data: s.object,
    effect: s.func,
    enabled: s.bool,
    fn: s.func,
    name: s.any,
    options: s.object,
    phase: s.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: s.arrayOf(s.string),
    requiresIfExists: s.arrayOf(s.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: s.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: s.shape({
    modifiers: s.array,
    onFirstUpdate: s.func,
    placement: s.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: s.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Wo,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: s.shape({
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: s.shape({
    root: s.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: s.bool
});
const o6 = oe(oM, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Pl = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = mi(), o = St({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: i,
    component: a,
    components: l,
    componentsProps: c,
    container: d,
    disablePortal: f,
    keepMounted: p,
    modifiers: g,
    open: b,
    placement: v,
    popperOptions: y,
    popperRef: S,
    transition: E,
    slots: I,
    slotProps: O,
    ...T
  } = o, P = (I == null ? void 0 : I.root) ?? (l == null ? void 0 : l.Root), R = {
    anchorEl: i,
    container: d,
    disablePortal: f,
    keepMounted: p,
    modifiers: g,
    open: b,
    placement: v,
    popperOptions: y,
    popperRef: S,
    transition: E,
    ...T
  };
  return /* @__PURE__ */ w.jsx(o6, {
    as: a,
    direction: r ? "rtl" : "ltr",
    slots: {
      root: P
    },
    slotProps: O ?? c,
    ...R,
    ref: n
  });
});
process.env.NODE_ENV !== "production" && (Pl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: s.oneOfType([ba, s.object, s.func]),
  /**
   * Popper render function or node.
   */
  children: s.oneOfType([s.node, s.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  components: s.shape({
    Root: s.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  componentsProps: s.shape({
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: s.oneOfType([ba, s.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: s.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: s.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: s.arrayOf(s.shape({
    data: s.object,
    effect: s.func,
    enabled: s.bool,
    fn: s.func,
    name: s.any,
    options: s.object,
    phase: s.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: s.arrayOf(s.string),
    requiresIfExists: s.arrayOf(s.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: s.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: s.shape({
    modifiers: s.array,
    onFirstUpdate: s.func,
    placement: s.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: s.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Wo,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: s.shape({
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: s.shape({
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: s.bool
});
function i6(e) {
  return gt("MuiListSubheader", e);
}
vt("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]);
const s6 = (e) => {
  const {
    classes: t,
    color: n,
    disableGutters: r,
    inset: o,
    disableSticky: i
  } = e, a = {
    root: ["root", n !== "default" && `color${Me(n)}`, !r && "gutters", o && "inset", !i && "sticky"]
  };
  return Ct(a, i6, t);
}, a6 = oe("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${Me(n.color)}`], !n.disableGutters && t.gutters, n.inset && t.inset, !n.disableSticky && t.sticky];
  }
})(ut(({
  theme: e
}) => ({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (e.vars || e).palette.text.secondary,
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(14),
  variants: [{
    props: {
      color: "primary"
    },
    style: {
      color: (e.vars || e).palette.primary.main
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.inset,
    style: {
      paddingLeft: 72
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableSticky,
    style: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: (e.vars || e).palette.background.paper
    }
  }]
}))), am = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiListSubheader"
  }), {
    className: o,
    color: i = "default",
    component: a = "li",
    disableGutters: l = !1,
    disableSticky: c = !1,
    inset: d = !1,
    ...f
  } = r, p = {
    ...r,
    color: i,
    component: a,
    disableGutters: l,
    disableSticky: c,
    inset: d
  }, g = s6(p);
  return /* @__PURE__ */ w.jsx(a6, {
    as: a,
    className: ke(g.root, o),
    ref: n,
    ownerState: p,
    ...f
  });
});
am && (am.muiSkipListHighlight = !0);
process.env.NODE_ENV !== "production" && (am.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: s.oneOf(["default", "inherit", "primary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: s.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: s.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const l6 = At(/* @__PURE__ */ w.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function c6(e) {
  return gt("MuiChip", e);
}
const on = vt("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorDefault", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), u6 = (e) => {
  const {
    classes: t,
    disabled: n,
    size: r,
    color: o,
    iconColor: i,
    onDelete: a,
    clickable: l,
    variant: c
  } = e, d = {
    root: ["root", c, n && "disabled", `size${Me(r)}`, `color${Me(o)}`, l && "clickable", l && `clickableColor${Me(o)}`, a && "deletable", a && `deletableColor${Me(o)}`, `${c}${Me(o)}`],
    label: ["label", `label${Me(r)}`],
    avatar: ["avatar", `avatar${Me(r)}`, `avatarColor${Me(o)}`],
    icon: ["icon", `icon${Me(r)}`, `iconColor${Me(i)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${Me(r)}`, `deleteIconColor${Me(o)}`, `deleteIcon${Me(c)}Color${Me(o)}`]
  };
  return Ct(d, c6, t);
}, d6 = oe("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      color: r,
      iconColor: o,
      clickable: i,
      onDelete: a,
      size: l,
      variant: c
    } = n;
    return [{
      [`& .${on.avatar}`]: t.avatar
    }, {
      [`& .${on.avatar}`]: t[`avatar${Me(l)}`]
    }, {
      [`& .${on.avatar}`]: t[`avatarColor${Me(r)}`]
    }, {
      [`& .${on.icon}`]: t.icon
    }, {
      [`& .${on.icon}`]: t[`icon${Me(l)}`]
    }, {
      [`& .${on.icon}`]: t[`iconColor${Me(o)}`]
    }, {
      [`& .${on.deleteIcon}`]: t.deleteIcon
    }, {
      [`& .${on.deleteIcon}`]: t[`deleteIcon${Me(l)}`]
    }, {
      [`& .${on.deleteIcon}`]: t[`deleteIconColor${Me(r)}`]
    }, {
      [`& .${on.deleteIcon}`]: t[`deleteIcon${Me(c)}Color${Me(r)}`]
    }, t.root, t[`size${Me(l)}`], t[`color${Me(r)}`], i && t.clickable, i && r !== "default" && t[`clickableColor${Me(r)})`], a && t.deletable, a && r !== "default" && t[`deletableColor${Me(r)}`], t[c], t[`${c}${Me(r)}`]];
  }
})(ut(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return {
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${on.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${on.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : t,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${on.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${on.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${on.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${on.icon}`]: {
      marginLeft: 5,
      marginRight: -6
    },
    [`& .${on.deleteIcon}`]: {
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : Vt(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : Vt(e.palette.text.primary, 0.4)
      }
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        height: 24,
        [`& .${on.icon}`]: {
          fontSize: 18,
          marginLeft: 4,
          marginRight: -4
        },
        [`& .${on.deleteIcon}`]: {
          fontSize: 16,
          marginRight: 4,
          marginLeft: -4
        }
      }
    }, ...Object.entries(e.palette).filter(Jn(["contrastText"])).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        backgroundColor: (e.vars || e).palette[n].main,
        color: (e.vars || e).palette[n].contrastText,
        [`& .${on.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[n].contrastTextChannel} / 0.7)` : Vt(e.palette[n].contrastText, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[n].contrastText
          }
        }
      }
    })), {
      props: (n) => n.iconColor === n.color,
      style: {
        [`& .${on.icon}`]: {
          color: e.vars ? e.vars.palette.Chip.defaultIconColor : t
        }
      }
    }, {
      props: (n) => n.iconColor === n.color && n.color !== "default",
      style: {
        [`& .${on.icon}`]: {
          color: "inherit"
        }
      }
    }, {
      props: {
        onDelete: !0
      },
      style: {
        [`&.${on.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Vt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        }
      }
    }, ...Object.entries(e.palette).filter(Jn(["dark"])).map(([n]) => ({
      props: {
        color: n,
        onDelete: !0
      },
      style: {
        [`&.${on.focusVisible}`]: {
          background: (e.vars || e).palette[n].dark
        }
      }
    })), {
      props: {
        clickable: !0
      },
      style: {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Vt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
        },
        [`&.${on.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Vt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[1]
        }
      }
    }, ...Object.entries(e.palette).filter(Jn(["dark"])).map(([n]) => ({
      props: {
        color: n,
        clickable: !0
      },
      style: {
        [`&:hover, &.${on.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette[n].dark
        }
      }
    })), {
      props: {
        variant: "outlined"
      },
      style: {
        backgroundColor: "transparent",
        border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
        [`&.${on.clickable}:hover`]: {
          backgroundColor: (e.vars || e).palette.action.hover
        },
        [`&.${on.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette.action.focus
        },
        [`& .${on.avatar}`]: {
          marginLeft: 4
        },
        [`& .${on.avatarSmall}`]: {
          marginLeft: 2
        },
        [`& .${on.icon}`]: {
          marginLeft: 4
        },
        [`& .${on.iconSmall}`]: {
          marginLeft: 2
        },
        [`& .${on.deleteIcon}`]: {
          marginRight: 5
        },
        [`& .${on.deleteIconSmall}`]: {
          marginRight: 3
        }
      }
    }, ...Object.entries(e.palette).filter(Jn()).map(([n]) => ({
      props: {
        variant: "outlined",
        color: n
      },
      style: {
        color: (e.vars || e).palette[n].main,
        border: `1px solid ${e.vars ? `rgba(${e.vars.palette[n].mainChannel} / 0.7)` : Vt(e.palette[n].main, 0.7)}`,
        [`&.${on.clickable}:hover`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Vt(e.palette[n].main, e.palette.action.hoverOpacity)
        },
        [`&.${on.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / ${e.vars.palette.action.focusOpacity})` : Vt(e.palette[n].main, e.palette.action.focusOpacity)
        },
        [`& .${on.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / 0.7)` : Vt(e.palette[n].main, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[n].main
          }
        }
      }
    }))]
  };
})), f6 = oe("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      size: r
    } = n;
    return [t.label, t[`label${Me(r)}`]];
  }
})({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      variant: "outlined"
    },
    style: {
      paddingLeft: 11,
      paddingRight: 11
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingLeft: 8,
      paddingRight: 8
    }
  }, {
    props: {
      size: "small",
      variant: "outlined"
    },
    style: {
      paddingLeft: 7,
      paddingRight: 7
    }
  }]
});
function EO(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const rx = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiChip"
  }), {
    avatar: o,
    className: i,
    clickable: a,
    color: l = "default",
    component: c,
    deleteIcon: d,
    disabled: f = !1,
    icon: p,
    label: g,
    onClick: b,
    onDelete: v,
    onKeyDown: y,
    onKeyUp: S,
    size: E = "medium",
    variant: I = "filled",
    tabIndex: O,
    skipFocusWhenDisabled: T = !1,
    // TODO v6: Rename to `focusableWhenDisabled`.
    ...P
  } = r, R = m.useRef(null), F = sr(R, n), A = (V) => {
    V.stopPropagation(), v && v(V);
  }, _ = (V) => {
    V.currentTarget === V.target && EO(V) && V.preventDefault(), y && y(V);
  }, C = (V) => {
    V.currentTarget === V.target && v && EO(V) && v(V), S && S(V);
  }, D = a !== !1 && b ? !0 : a, L = D || v ? va : c || "div", B = {
    ...r,
    component: L,
    disabled: f,
    size: E,
    color: l,
    iconColor: /* @__PURE__ */ m.isValidElement(p) && p.props.color || l,
    onDelete: !!v,
    clickable: D,
    variant: I
  }, H = u6(B), k = L === va ? {
    component: c || "div",
    focusVisibleClassName: H.focusVisible,
    ...v && {
      disableRipple: !0
    }
  } : {};
  let N = null;
  v && (N = d && /* @__PURE__ */ m.isValidElement(d) ? /* @__PURE__ */ m.cloneElement(d, {
    className: ke(d.props.className, H.deleteIcon),
    onClick: A
  }) : /* @__PURE__ */ w.jsx(l6, {
    className: ke(H.deleteIcon),
    onClick: A
  }));
  let j = null;
  o && /* @__PURE__ */ m.isValidElement(o) && (j = /* @__PURE__ */ m.cloneElement(o, {
    className: ke(H.avatar, o.props.className)
  }));
  let W = null;
  return p && /* @__PURE__ */ m.isValidElement(p) && (W = /* @__PURE__ */ m.cloneElement(p, {
    className: ke(H.icon, p.props.className)
  })), process.env.NODE_ENV !== "production" && j && W && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ w.jsxs(d6, {
    as: L,
    className: ke(H.root, i),
    disabled: D && f ? !0 : void 0,
    onClick: b,
    onKeyDown: _,
    onKeyUp: C,
    ref: F,
    tabIndex: T && f ? -1 : O,
    ownerState: B,
    ...k,
    ...P,
    children: [j || W, /* @__PURE__ */ w.jsx(f6, {
      className: ke(H.label),
      ownerState: B,
      children: g
    }), N]
  });
});
process.env.NODE_ENV !== "production" && (rx.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: s.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: oW,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: s.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: s.oneOfType([s.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: s.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * Icon element.
   */
  icon: s.element,
  /**
   * The content of the component.
   */
  label: s.node,
  /**
   * @ignore
   */
  onClick: s.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: s.func,
  /**
   * @ignore
   */
  onKeyDown: s.func,
  /**
   * @ignore
   */
  onKeyUp: s.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * @ignore
   */
  tabIndex: s.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: s.oneOfType([s.oneOf(["filled", "outlined"]), s.string])
});
function dg(e) {
  return parseInt(e, 10) || 0;
}
const p6 = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function h6(e) {
  return e == null || Object.keys(e).length === 0 || e.outerHeightStyle === 0 && !e.overflowing;
}
const iM = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    onChange: r,
    maxRows: o,
    minRows: i = 1,
    style: a,
    value: l,
    ...c
  } = t, {
    current: d
  } = m.useRef(l != null), f = m.useRef(null), p = sr(n, f), g = m.useRef(null), b = m.useRef(null), v = m.useCallback(() => {
    const E = f.current, O = ya(E).getComputedStyle(E);
    if (O.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    const T = b.current;
    T.style.width = O.width, T.value = E.value || t.placeholder || "x", T.value.slice(-1) === `
` && (T.value += " ");
    const P = O.boxSizing, R = dg(O.paddingBottom) + dg(O.paddingTop), F = dg(O.borderBottomWidth) + dg(O.borderTopWidth), A = T.scrollHeight;
    T.value = "x";
    const _ = T.scrollHeight;
    let C = A;
    i && (C = Math.max(Number(i) * _, C)), o && (C = Math.min(Number(o) * _, C)), C = Math.max(C, _);
    const D = C + (P === "border-box" ? R + F : 0), L = Math.abs(C - A) <= 1;
    return {
      outerHeightStyle: D,
      overflowing: L
    };
  }, [o, i, t.placeholder]), y = m.useCallback(() => {
    const E = v();
    if (h6(E))
      return;
    const I = E.outerHeightStyle, O = f.current;
    g.current !== I && (g.current = I, O.style.height = `${I}px`), O.style.overflow = E.overflowing ? "hidden" : "";
  }, [v]);
  ss(() => {
    const E = () => {
      y();
    };
    let I;
    const O = () => {
      cancelAnimationFrame(I), I = requestAnimationFrame(() => {
        E();
      });
    }, T = gk(E), P = f.current, R = ya(P);
    R.addEventListener("resize", T);
    let F;
    return typeof ResizeObserver < "u" && (F = new ResizeObserver(process.env.NODE_ENV === "test" ? O : E), F.observe(P)), () => {
      T.clear(), cancelAnimationFrame(I), R.removeEventListener("resize", T), F && F.disconnect();
    };
  }, [v, y]), ss(() => {
    y();
  });
  const S = (E) => {
    d || y(), r && r(E);
  };
  return /* @__PURE__ */ w.jsxs(m.Fragment, {
    children: [/* @__PURE__ */ w.jsx("textarea", {
      value: l,
      onChange: S,
      ref: p,
      rows: i,
      style: a,
      ...c
    }), /* @__PURE__ */ w.jsx("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: b,
      tabIndex: -1,
      style: {
        ...p6.shadow,
        ...a,
        paddingTop: 0,
        paddingBottom: 0
      }
    })]
  });
});
process.env.NODE_ENV !== "production" && (iM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: s.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * @ignore
   */
  onChange: s.func,
  /**
   * @ignore
   */
  placeholder: s.string,
  /**
   * @ignore
   */
  style: s.object,
  /**
   * @ignore
   */
  value: s.oneOfType([s.arrayOf(s.string), s.number, s.string])
});
function ap(e) {
  return typeof e == "string";
}
function _c({
  props: e,
  states: t,
  muiFormControl: n
}) {
  return t.reduce((r, o) => (r[o] = e[o], n && typeof e[o] > "u" && (r[o] = n[o]), r), {});
}
const Up = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (Up.displayName = "FormControlContext");
function Sa() {
  return m.useContext(Up);
}
function TO(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function lm(e, t = !1) {
  return e && (TO(e.value) && e.value !== "" || t && TO(e.defaultValue) && e.defaultValue !== "");
}
function g6(e) {
  return e.startAdornment;
}
function m6(e) {
  return gt("MuiInputBase", e);
}
const Xr = vt("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]);
var OO;
const cb = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.formControl && t.formControl, n.startAdornment && t.adornedStart, n.endAdornment && t.adornedEnd, n.error && t.error, n.size === "small" && t.sizeSmall, n.multiline && t.multiline, n.color && t[`color${Me(n.color)}`], n.fullWidth && t.fullWidth, n.hiddenLabel && t.hiddenLabel];
}, ub = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.input, n.size === "small" && t.inputSizeSmall, n.multiline && t.inputMultiline, n.type === "search" && t.inputTypeSearch, n.startAdornment && t.inputAdornedStart, n.endAdornment && t.inputAdornedEnd, n.hiddenLabel && t.inputHiddenLabel];
}, b6 = (e) => {
  const {
    classes: t,
    color: n,
    disabled: r,
    error: o,
    endAdornment: i,
    focused: a,
    formControl: l,
    fullWidth: c,
    hiddenLabel: d,
    multiline: f,
    readOnly: p,
    size: g,
    startAdornment: b,
    type: v
  } = e, y = {
    root: ["root", `color${Me(n)}`, r && "disabled", o && "error", c && "fullWidth", a && "focused", l && "formControl", g && g !== "medium" && `size${Me(g)}`, f && "multiline", b && "adornedStart", i && "adornedEnd", d && "hiddenLabel", p && "readOnly"],
    input: ["input", r && "disabled", v === "search" && "inputTypeSearch", f && "inputMultiline", g === "small" && "inputSizeSmall", d && "inputHiddenLabel", b && "inputAdornedStart", i && "inputAdornedEnd", p && "readOnly"]
  };
  return Ct(y, m6, t);
}, db = oe("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: cb
})(ut(({
  theme: e
}) => ({
  ...e.typography.body1,
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${Xr.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: "4px 0 5px"
    }
  }, {
    props: ({
      ownerState: t,
      size: n
    }) => t.multiline && n === "small",
    style: {
      paddingTop: 1
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      width: "100%"
    }
  }]
}))), fb = oe("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: ub
})(ut(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = {
    color: "currentColor",
    ...e.vars ? {
      opacity: e.vars.opacity.inputPlaceholder
    } : {
      opacity: t ? 0.42 : 0.5
    },
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }, r = {
    opacity: "0 !important"
  }, o = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: t ? 0.42 : 0.5
  };
  return {
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    "&::-webkit-input-placeholder": n,
    "&::-moz-placeholder": n,
    // Firefox 19+
    "&::-ms-input-placeholder": n,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${Xr.formControl} &`]: {
      "&::-webkit-input-placeholder": r,
      "&::-moz-placeholder": r,
      // Firefox 19+
      "&::-ms-input-placeholder": r,
      // Edge
      "&:focus::-webkit-input-placeholder": o,
      "&:focus::-moz-placeholder": o,
      // Firefox 19+
      "&:focus::-ms-input-placeholder": o
      // Edge
    },
    [`&.${Xr.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    variants: [{
      props: ({
        ownerState: i
      }) => !i.disableInjectingGlobalStyles,
      style: {
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&:-webkit-autofill": {
          animationDuration: "5000s",
          animationName: "mui-auto-fill"
        }
      }
    }, {
      props: {
        size: "small"
      },
      style: {
        paddingTop: 1
      }
    }, {
      props: ({
        ownerState: i
      }) => i.multiline,
      style: {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
      }
    }, {
      props: {
        type: "search"
      },
      style: {
        MozAppearance: "textfield"
        // Improve type search style.
      }
    }]
  };
})), PO = Pq({
  "@keyframes mui-auto-fill": {
    from: {
      display: "block"
    }
  },
  "@keyframes mui-auto-fill-cancel": {
    from: {
      display: "block"
    }
  }
}), kc = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiInputBase"
  }), {
    "aria-describedby": o,
    autoComplete: i,
    autoFocus: a,
    className: l,
    color: c,
    components: d = {},
    componentsProps: f = {},
    defaultValue: p,
    disabled: g,
    disableInjectingGlobalStyles: b,
    endAdornment: v,
    error: y,
    fullWidth: S = !1,
    id: E,
    inputComponent: I = "input",
    inputProps: O = {},
    inputRef: T,
    margin: P,
    maxRows: R,
    minRows: F,
    multiline: A = !1,
    name: _,
    onBlur: C,
    onChange: D,
    onClick: L,
    onFocus: B,
    onKeyDown: H,
    onKeyUp: k,
    placeholder: N,
    readOnly: j,
    renderSuffix: W,
    rows: V,
    size: $,
    slotProps: z = {},
    slots: ne = {},
    startAdornment: K,
    type: Q = "text",
    value: re,
    ...te
  } = r, ie = O.value != null ? O.value : re, {
    current: ae
  } = m.useRef(ie != null), ce = m.useRef(), le = m.useCallback((Xe) => {
    process.env.NODE_ENV !== "production" && Xe && Xe.nodeName !== "INPUT" && !Xe.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), we = sr(ce, T, O.ref, le), [q, Ee] = m.useState(!1), _e = Sa();
  process.env.NODE_ENV !== "production" && m.useEffect(() => {
    if (_e)
      return _e.registerEffect();
  }, [_e]);
  const $e = _c({
    props: r,
    muiFormControl: _e,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  $e.focused = _e ? _e.focused : q, m.useEffect(() => {
    !_e && g && q && (Ee(!1), C && C());
  }, [_e, g, q, C]);
  const Le = _e && _e.onFilled, Ze = _e && _e.onEmpty, J = m.useCallback((Xe) => {
    lm(Xe) ? Le && Le() : Ze && Ze();
  }, [Le, Ze]);
  ss(() => {
    ae && J({
      value: ie
    });
  }, [ie, J, ae]);
  const fe = (Xe) => {
    B && B(Xe), O.onFocus && O.onFocus(Xe), _e && _e.onFocus ? _e.onFocus(Xe) : Ee(!0);
  }, me = (Xe) => {
    C && C(Xe), O.onBlur && O.onBlur(Xe), _e && _e.onBlur ? _e.onBlur(Xe) : Ee(!1);
  }, Oe = (Xe, ...xt) => {
    if (!ae) {
      const tt = Xe.target || ce.current;
      if (tt == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : Bs(1));
      J({
        value: tt.value
      });
    }
    O.onChange && O.onChange(Xe, ...xt), D && D(Xe, ...xt);
  };
  m.useEffect(() => {
    J(ce.current);
  }, []);
  const Ce = (Xe) => {
    ce.current && Xe.currentTarget === Xe.target && ce.current.focus(), L && L(Xe);
  };
  let Te = I, Pe = O;
  A && Te === "input" && (V ? (process.env.NODE_ENV !== "production" && (F || R) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), Pe = {
    type: void 0,
    minRows: V,
    maxRows: V,
    ...Pe
  }) : Pe = {
    type: void 0,
    maxRows: R,
    minRows: F,
    ...Pe
  }, Te = iM);
  const Ye = (Xe) => {
    J(Xe.animationName === "mui-auto-fill-cancel" ? ce.current : {
      value: "x"
    });
  };
  m.useEffect(() => {
    _e && _e.setAdornedStart(!!K);
  }, [_e, K]);
  const Ke = {
    ...r,
    color: $e.color || "primary",
    disabled: $e.disabled,
    endAdornment: v,
    error: $e.error,
    focused: $e.focused,
    formControl: _e,
    fullWidth: S,
    hiddenLabel: $e.hiddenLabel,
    multiline: A,
    size: $e.size,
    startAdornment: K,
    type: Q
  }, je = b6(Ke), Qe = ne.root || d.Root || db, et = z.root || f.root || {}, Et = ne.input || d.Input || fb;
  return Pe = {
    ...Pe,
    ...z.input ?? f.input
  }, /* @__PURE__ */ w.jsxs(m.Fragment, {
    children: [!b && typeof PO == "function" && // For Emotion/Styled-components, InputGlobalStyles will be a function
    // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
    (OO || (OO = /* @__PURE__ */ w.jsx(PO, {}))), /* @__PURE__ */ w.jsxs(Qe, {
      ...et,
      ref: n,
      onClick: Ce,
      ...te,
      ...!ap(Qe) && {
        ownerState: {
          ...Ke,
          ...et.ownerState
        }
      },
      className: ke(je.root, et.className, l, j && "MuiInputBase-readOnly"),
      children: [K, /* @__PURE__ */ w.jsx(Up.Provider, {
        value: null,
        children: /* @__PURE__ */ w.jsx(Et, {
          "aria-invalid": $e.error,
          "aria-describedby": o,
          autoComplete: i,
          autoFocus: a,
          defaultValue: p,
          disabled: $e.disabled,
          id: E,
          onAnimationStart: Ye,
          name: _,
          placeholder: N,
          readOnly: j,
          required: $e.required,
          rows: V,
          value: ie,
          onKeyDown: H,
          onKeyUp: k,
          type: Q,
          ...Pe,
          ...!ap(Et) && {
            as: Te,
            ownerState: {
              ...Ke,
              ...Pe.ownerState
            }
          },
          ref: we,
          className: ke(je.input, Pe.className, j && "MuiInputBase-readOnly"),
          onBlur: me,
          onChange: Oe,
          onFocus: fe
        })
      }), v, W ? W({
        ...$e,
        startAdornment: K
      }) : null]
    })]
  });
});
process.env.NODE_ENV !== "production" && (kc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": s.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: s.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Input: s.elementType,
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: s.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: s.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: s.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: s.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: Ed,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Wo,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: s.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: s.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: s.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * @ignore
   */
  onClick: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: s.func,
  /**
   * @ignore
   */
  onKeyDown: s.func,
  /**
   * @ignore
   */
  onKeyUp: s.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: s.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: s.bool,
  /**
   * @ignore
   */
  renderSuffix: s.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: s.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: s.oneOfType([s.number, s.string]),
  /**
   * The size of the component.
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: s.shape({
    input: s.elementType,
    root: s.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: s.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: s.any
});
function y6(e) {
  return gt("MuiInput", e);
}
const Ya = {
  ...Xr,
  ...vt("MuiInput", ["root", "underline", "input"])
};
function v6(e) {
  return gt("MuiOutlinedInput", e);
}
const Ti = {
  ...Xr,
  ...vt("MuiOutlinedInput", ["root", "notchedOutline", "input"])
};
function w6(e) {
  return gt("MuiFilledInput", e);
}
const ri = {
  ...Xr,
  ...vt("MuiFilledInput", ["root", "underline", "input", "adornedStart", "adornedEnd", "sizeSmall", "multiline", "hiddenLabel"])
}, sM = At(/* @__PURE__ */ w.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function C6(e) {
  return gt("MuiAutocomplete", e);
}
const Qt = vt("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
var IO, RO;
const x6 = (e) => {
  const {
    classes: t,
    disablePortal: n,
    expanded: r,
    focused: o,
    fullWidth: i,
    hasClearIcon: a,
    hasPopupIcon: l,
    inputFocused: c,
    popupOpen: d,
    size: f
  } = e, p = {
    root: ["root", r && "expanded", o && "focused", i && "fullWidth", a && "hasClearIcon", l && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", c && "inputFocused"],
    tag: ["tag", `tagSize${Me(f)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", d && "popupIndicatorOpen"],
    popper: ["popper", n && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return Ct(p, C6, t);
}, S6 = oe("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      fullWidth: r,
      hasClearIcon: o,
      hasPopupIcon: i,
      inputFocused: a,
      size: l
    } = n;
    return [{
      [`& .${Qt.tag}`]: t.tag
    }, {
      [`& .${Qt.tag}`]: t[`tagSize${Me(l)}`]
    }, {
      [`& .${Qt.inputRoot}`]: t.inputRoot
    }, {
      [`& .${Qt.input}`]: t.input
    }, {
      [`& .${Qt.input}`]: a && t.inputFocused
    }, t.root, r && t.fullWidth, i && t.hasPopupIcon, o && t.hasClearIcon];
  }
})({
  [`&.${Qt.focused} .${Qt.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${Qt.clearIndicator}`]: {
      visibility: "visible"
    }
  },
  [`& .${Qt.tag}`]: {
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  },
  [`& .${Qt.inputRoot}`]: {
    [`.${Qt.hasPopupIcon}&, .${Qt.hasClearIcon}&`]: {
      paddingRight: 30
    },
    [`.${Qt.hasPopupIcon}.${Qt.hasClearIcon}&`]: {
      paddingRight: 56
    },
    [`& .${Qt.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${Ya.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${Ya.root}.${Xr.sizeSmall}`]: {
    [`& .${Ya.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${Ti.root}`]: {
    padding: 9,
    [`.${Qt.hasPopupIcon}&, .${Qt.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${Qt.hasPopupIcon}.${Qt.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${Qt.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${Qt.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${Ti.root}.${Xr.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${Qt.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${ri.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${Qt.hasPopupIcon}&, .${Qt.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${Qt.hasPopupIcon}.${Qt.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${ri.input}`]: {
      padding: "7px 4px"
    },
    [`& .${Qt.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${ri.root}.${Xr.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${ri.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${Xr.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${ri.root}.${Xr.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${Qt.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${ri.root}.${Xr.hiddenLabel}.${Xr.sizeSmall}`]: {
    [`& .${Qt.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${Qt.input}`]: {
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      [`& .${Qt.tag}`]: {
        margin: 2,
        maxWidth: "calc(100% - 4px)"
      }
    }
  }, {
    props: {
      inputFocused: !0
    },
    style: {
      [`& .${Qt.input}`]: {
        opacity: 1
      }
    }
  }, {
    props: {
      multiple: !0
    },
    style: {
      [`& .${Qt.inputRoot}`]: {
        flexWrap: "wrap"
      }
    }
  }]
}), E6 = oe("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment",
  overridesResolver: (e, t) => t.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translate(0, -50%)"
}), T6 = oe(ks, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator",
  overridesResolver: (e, t) => t.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
}), O6 = oe(ks, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popupIndicator, n.popupOpen && t.popupIndicatorOpen];
  }
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: !0
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}), P6 = oe(Pl, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${Qt.option}`]: t.option
    }, t.popper, n.disablePortal && t.popperDisablePortal];
  }
})(ut(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.modal,
  variants: [{
    props: {
      disablePortal: !0
    },
    style: {
      position: "absolute"
    }
  }]
}))), I6 = oe(cs, {
  name: "MuiAutocomplete",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(ut(({
  theme: e
}) => ({
  ...e.typography.body1,
  overflow: "auto"
}))), R6 = oe("div", {
  name: "MuiAutocomplete",
  slot: "Loading",
  overridesResolver: (e, t) => t.loading
})(ut(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), _6 = oe("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions",
  overridesResolver: (e, t) => t.noOptions
})(ut(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), k6 = oe("ul", {
  name: "MuiAutocomplete",
  slot: "Listbox",
  overridesResolver: (e, t) => t.listbox
})(ut(({
  theme: e
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${Qt.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [e.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${Qt.focused}`]: {
      backgroundColor: (e.vars || e).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${Qt.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Vt(e.palette.primary.main, e.palette.action.selectedOpacity),
      [`&.${Qt.focused}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Vt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (e.vars || e).palette.action.selected
        }
      },
      [`&.${Qt.focusVisible}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Vt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
      }
    }
  }
}))), M6 = oe(am, {
  name: "MuiAutocomplete",
  slot: "GroupLabel",
  overridesResolver: (e, t) => t.groupLabel
})(ut(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  top: -8
}))), A6 = oe("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl",
  overridesResolver: (e, t) => t.groupUl
})({
  padding: 0,
  [`& .${Qt.option}`]: {
    paddingLeft: 24
  }
}), zp = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiAutocomplete"
  }), {
    autoComplete: o = !1,
    autoHighlight: i = !1,
    autoSelect: a = !1,
    blurOnSelect: l = !1,
    ChipProps: c,
    className: d,
    clearIcon: f = IO || (IO = /* @__PURE__ */ w.jsx(Gk, {
      fontSize: "small"
    })),
    clearOnBlur: p = !r.freeSolo,
    clearOnEscape: g = !1,
    clearText: b = "Clear",
    closeText: v = "Close",
    componentsProps: y,
    defaultValue: S = r.multiple ? [] : null,
    disableClearable: E = !1,
    disableCloseOnSelect: I = !1,
    disabled: O = !1,
    disabledItemsFocusable: T = !1,
    disableListWrap: P = !1,
    disablePortal: R = !1,
    filterOptions: F,
    filterSelectedOptions: A = !1,
    forcePopupIcon: _ = "auto",
    freeSolo: C = !1,
    fullWidth: D = !1,
    getLimitTagsText: L = (qt) => `+${qt}`,
    getOptionDisabled: B,
    getOptionKey: H,
    getOptionLabel: k,
    isOptionEqualToValue: N,
    groupBy: j,
    handleHomeEndKeys: W = !r.freeSolo,
    id: V,
    includeInputInList: $ = !1,
    inputValue: z,
    limitTags: ne = -1,
    ListboxComponent: K,
    ListboxProps: Q,
    loading: re = !1,
    loadingText: te = "Loading…",
    multiple: ie = !1,
    noOptionsText: ae = "No options",
    onChange: ce,
    onClose: le,
    onHighlightChange: we,
    onInputChange: q,
    onOpen: Ee,
    open: _e,
    openOnFocus: $e = !1,
    openText: Le = "Open",
    options: Ze,
    PaperComponent: J,
    PopperComponent: fe,
    popupIcon: me = RO || (RO = /* @__PURE__ */ w.jsx(sM, {})),
    readOnly: Oe = !1,
    renderGroup: Ce,
    renderInput: Te,
    renderOption: Pe,
    renderTags: Ye,
    selectOnFocus: Ke = !r.freeSolo,
    size: je = "medium",
    slots: Qe = {},
    slotProps: et = {},
    value: Et,
    ...Xe
  } = r, {
    getRootProps: xt,
    getInputProps: tt,
    getInputLabelProps: ct,
    getPopupIndicatorProps: Je,
    getClearProps: Ge,
    getTagProps: lt,
    getListboxProps: It,
    getOptionProps: fn,
    value: Bn,
    dirty: kn,
    expanded: fr,
    id: ar,
    popupOpen: Mr,
    focused: Lr,
    focusedTag: lr,
    anchorEl: mt,
    setAnchorEl: er,
    inputValue: eo,
    groupedOptions: ue
  } = z4({
    ...r,
    componentName: "Autocomplete"
  }), ve = !E && !O && kn && !Oe, Se = (!C || _ === !0) && _ !== !1, {
    onMouseDown: ze
  } = tt(), {
    ref: st,
    ...bt
  } = It(), at = k || ((qt) => qt.label ?? qt), Z = {
    ...r,
    disablePortal: R,
    expanded: fr,
    focused: Lr,
    fullWidth: D,
    getOptionLabel: at,
    hasClearIcon: ve,
    hasPopupIcon: Se,
    inputFocused: lr === -1,
    popupOpen: Mr,
    size: je
  }, be = x6(Z), Re = {
    slots: {
      paper: J,
      popper: fe,
      ...Qe
    },
    slotProps: {
      chip: c,
      listbox: Q,
      ...y,
      ...et
    }
  }, [pe, he] = gn("listbox", {
    elementType: k6,
    externalForwardedProps: Re,
    ownerState: Z,
    className: be.listbox,
    additionalProps: bt,
    ref: st
  }), [Fe, We] = gn("paper", {
    elementType: cs,
    externalForwardedProps: Re,
    ownerState: Z,
    className: be.paper
  }), [Ue, dt] = gn("popper", {
    elementType: Pl,
    externalForwardedProps: Re,
    ownerState: Z,
    className: be.popper,
    additionalProps: {
      disablePortal: R,
      style: {
        width: mt ? mt.clientWidth : null
      },
      role: "presentation",
      anchorEl: mt,
      open: Mr
    }
  });
  let Tt;
  if (ie && Bn.length > 0) {
    const qt = (jt) => ({
      className: be.tag,
      disabled: O,
      ...lt(jt)
    });
    Ye ? Tt = Ye(Bn, qt, Z) : Tt = Bn.map((jt, hn) => {
      const {
        key: _o,
        ...Ks
      } = qt({
        index: hn
      });
      return /* @__PURE__ */ w.jsx(rx, {
        label: at(jt),
        size: je,
        ...Ks,
        ...Re.slotProps.chip
      }, _o);
    });
  }
  if (ne > -1 && Array.isArray(Tt)) {
    const qt = Tt.length - ne;
    !Lr && qt > 0 && (Tt = Tt.splice(0, ne), Tt.push(/* @__PURE__ */ w.jsx("span", {
      className: be.tag,
      children: L(qt)
    }, Tt.length)));
  }
  const pn = Ce || ((qt) => /* @__PURE__ */ w.jsxs("li", {
    children: [/* @__PURE__ */ w.jsx(M6, {
      className: be.groupLabel,
      ownerState: Z,
      component: "div",
      children: qt.group
    }), /* @__PURE__ */ w.jsx(A6, {
      className: be.groupUl,
      ownerState: Z,
      children: qt.children
    })]
  }, qt.key)), Gr = Pe || ((qt, jt) => {
    const {
      key: hn,
      ..._o
    } = qt;
    return /* @__PURE__ */ w.jsx("li", {
      ..._o,
      children: at(jt)
    }, hn);
  }), Qn = (qt, jt) => {
    const hn = fn({
      option: qt,
      index: jt
    });
    return Gr({
      ...hn,
      className: be.option
    }, qt, {
      selected: hn["aria-selected"],
      index: jt,
      inputValue: eo
    }, Z);
  }, Wr = Re.slotProps.clearIndicator, Ko = Re.slotProps.popupIndicator;
  return /* @__PURE__ */ w.jsxs(m.Fragment, {
    children: [/* @__PURE__ */ w.jsx(S6, {
      ref: n,
      className: ke(be.root, d),
      ownerState: Z,
      ...xt(Xe),
      children: Te({
        id: ar,
        disabled: O,
        fullWidth: !0,
        size: je === "small" ? "small" : void 0,
        InputLabelProps: ct(),
        InputProps: {
          ref: er,
          className: be.inputRoot,
          startAdornment: Tt,
          onMouseDown: (qt) => {
            qt.target === qt.currentTarget && ze(qt);
          },
          ...(ve || Se) && {
            endAdornment: /* @__PURE__ */ w.jsxs(E6, {
              className: be.endAdornment,
              ownerState: Z,
              children: [ve ? /* @__PURE__ */ w.jsx(T6, {
                ...Ge(),
                "aria-label": b,
                title: b,
                ownerState: Z,
                ...Wr,
                className: ke(be.clearIndicator, Wr == null ? void 0 : Wr.className),
                children: f
              }) : null, Se ? /* @__PURE__ */ w.jsx(O6, {
                ...Je(),
                disabled: O,
                "aria-label": Mr ? v : Le,
                title: Mr ? v : Le,
                ownerState: Z,
                ...Ko,
                className: ke(be.popupIndicator, Ko == null ? void 0 : Ko.className),
                children: me
              }) : null]
            })
          }
        },
        inputProps: {
          className: be.input,
          disabled: O,
          readOnly: Oe,
          ...tt()
        }
      })
    }), mt ? /* @__PURE__ */ w.jsx(P6, {
      as: Ue,
      ...dt,
      children: /* @__PURE__ */ w.jsxs(I6, {
        as: Fe,
        ...We,
        children: [re && ue.length === 0 ? /* @__PURE__ */ w.jsx(R6, {
          className: be.loading,
          ownerState: Z,
          children: te
        }) : null, ue.length === 0 && !C && !re ? /* @__PURE__ */ w.jsx(_6, {
          className: be.noOptions,
          ownerState: Z,
          role: "presentation",
          onMouseDown: (qt) => {
            qt.preventDefault();
          },
          children: ae
        }) : null, ue.length > 0 ? /* @__PURE__ */ w.jsx(pe, {
          as: K,
          ...he,
          children: ue.map((qt, jt) => j ? pn({
            key: qt.key,
            group: qt.group,
            children: qt.options.map((hn, _o) => Qn(hn, qt.index + _o))
          }) : Qn(qt, jt))
        }) : null]
      })
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (zp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: s.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: s.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */
  autoSelect: s.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: s.oneOfType([s.oneOf(["mouse", "touch"]), s.bool]),
  /**
   * Props applied to the [`Chip`](https://mui.com/material-ui/api/chip/) element.
   * @deprecated Use `slotProps.chip` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ChipProps: s.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: s.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: s.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: s.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: s.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: s.string,
  /**
   * The props used for each slot inside.
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: s.shape({
    clearIndicator: s.object,
    paper: s.object,
    popper: s.object,
    popupIndicator: s.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: Go(s.any, (e) => e.multiple && e.defaultValue !== void 0 && !Array.isArray(e.defaultValue) ? new Error(["MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.", `However, ${e.defaultValue} was provided.`].join(`
`)) : null),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: s.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: s.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: s.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: s.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: s.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: s.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: s.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: s.oneOfType([s.oneOf(["auto"]), s.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: s.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: s.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: s.func,
  /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */
  getOptionKey: s.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: s.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} option The Autocomplete option.
   * @returns {string}
   */
  groupBy: s.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: s.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: s.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: s.bool,
  /**
   * The input value.
   */
  inputValue: s.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: s.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: dl,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   * @deprecated Use `slotProps.listbox.component` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxComponent: s.elementType,
  /**
   * Props applied to the Listbox element.
   * @deprecated Use `slotProps.listbox` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxProps: s.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */
  loading: s.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: s.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: s.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: s.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: s.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: s.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: s.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`, `"blur"`, `"selectOption"`, `"removeOption"`
   */
  onInputChange: s.func,
  /**
   * @ignore
   */
  onKeyDown: s.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: s.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: s.string,
  /**
   * A list of options that will be shown in the Autocomplete.
   */
  options: s.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   * @deprecated Use `slots.paper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PaperComponent: s.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   * @deprecated Use `slots.popper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: s.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: s.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: s.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: s.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: s.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: s.func,
  /**
   * Render the selected value.
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: s.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: s.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["small", "medium"]), s.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    chip: s.oneOfType([s.func, s.object]),
    clearIndicator: s.oneOfType([s.func, s.object]),
    listbox: s.oneOfType([s.func, s.object]),
    paper: s.oneOfType([s.func, s.object]),
    popper: s.oneOfType([s.func, s.object]),
    popupIndicator: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    listbox: s.elementType,
    paper: s.elementType,
    popper: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: Go(s.any, (e) => e.multiple && e.value !== void 0 && !Array.isArray(e.value) ? new Error(["MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.", `However, ${e.value} was provided.`].join(`
`)) : null)
});
const D6 = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, ox = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = bo(), o = {
    enter: r.transitions.duration.enteringScreen,
    exit: r.transitions.duration.leavingScreen
  }, {
    addEndListener: i,
    appear: a = !0,
    children: l,
    easing: c,
    in: d,
    onEnter: f,
    onEntered: p,
    onEntering: g,
    onExit: b,
    onExited: v,
    onExiting: y,
    style: S,
    timeout: E = o,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: I = ls,
    ...O
  } = t, T = m.useRef(null), P = sr(T, Rc(l), n), R = (H) => (k) => {
    if (H) {
      const N = T.current;
      k === void 0 ? H(N) : H(N, k);
    }
  }, F = R(g), A = R((H, k) => {
    Hk(H);
    const N = cd({
      style: S,
      timeout: E,
      easing: c
    }, {
      mode: "enter"
    });
    H.style.webkitTransition = r.transitions.create("opacity", N), H.style.transition = r.transitions.create("opacity", N), f && f(H, k);
  }), _ = R(p), C = R(y), D = R((H) => {
    const k = cd({
      style: S,
      timeout: E,
      easing: c
    }, {
      mode: "exit"
    });
    H.style.webkitTransition = r.transitions.create("opacity", k), H.style.transition = r.transitions.create("opacity", k), b && b(H);
  }), L = R(v), B = (H) => {
    i && i(T.current, H);
  };
  return /* @__PURE__ */ w.jsx(I, {
    appear: a,
    in: d,
    nodeRef: T,
    onEnter: A,
    onEntered: _,
    onEntering: F,
    onExit: D,
    onExited: L,
    onExiting: C,
    addEndListener: B,
    timeout: E,
    ...O,
    children: (H, {
      ownerState: k,
      ...N
    }) => /* @__PURE__ */ m.cloneElement(l, {
      style: {
        opacity: 0,
        visibility: H === "exited" && !d ? "hidden" : void 0,
        ...D6[H],
        ...S,
        ...l.props.style
      },
      ref: P,
      ...N
    })
  });
});
process.env.NODE_ENV !== "production" && (ox.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: s.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: s.bool,
  /**
   * A single child content element.
   */
  children: Ic.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: s.oneOfType([s.shape({
    enter: s.string,
    exit: s.string
  }), s.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: s.bool,
  /**
   * @ignore
   */
  onEnter: s.func,
  /**
   * @ignore
   */
  onEntered: s.func,
  /**
   * @ignore
   */
  onEntering: s.func,
  /**
   * @ignore
   */
  onExit: s.func,
  /**
   * @ignore
   */
  onExited: s.func,
  /**
   * @ignore
   */
  onExiting: s.func,
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: s.oneOfType([s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })])
});
function N6(e) {
  return gt("MuiBackdrop", e);
}
vt("MuiBackdrop", ["root", "invisible"]);
const F6 = (e) => {
  const {
    classes: t,
    invisible: n
  } = e;
  return Ct({
    root: ["root", n && "invisible"]
  }, N6, t);
}, $6 = oe("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.invisible && t.invisible];
  }
})({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent",
  variants: [{
    props: {
      invisible: !0
    },
    style: {
      backgroundColor: "transparent"
    }
  }]
}), ix = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: o,
    className: i,
    component: a = "div",
    invisible: l = !1,
    open: c,
    components: d = {},
    componentsProps: f = {},
    slotProps: p = {},
    slots: g = {},
    TransitionComponent: b,
    transitionDuration: v,
    ...y
  } = r, S = {
    ...r,
    component: a,
    invisible: l
  }, E = F6(S), I = {
    transition: b,
    root: d.Root,
    ...g
  }, O = {
    ...f,
    ...p
  }, T = {
    slots: I,
    slotProps: O
  }, [P, R] = gn("root", {
    elementType: $6,
    externalForwardedProps: T,
    className: ke(E.root, i),
    ownerState: S
  }), [F, A] = gn("transition", {
    elementType: ox,
    externalForwardedProps: T,
    ownerState: S
  });
  return /* @__PURE__ */ w.jsx(F, {
    in: c,
    timeout: v,
    ...y,
    ...A,
    children: /* @__PURE__ */ w.jsx(P, {
      "aria-hidden": !0,
      ...R,
      classes: E,
      ref: n,
      children: o
    })
  });
});
process.env.NODE_ENV !== "production" && (ix.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    root: s.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: s.bool,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    root: s.oneOfType([s.func, s.object]),
    transition: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    root: s.elementType,
    transition: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: s.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: s.oneOfType([s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })])
});
function L6(e) {
  const {
    badgeContent: t,
    invisible: n = !1,
    max: r = 99,
    showZero: o = !1
  } = e, i = $C({
    badgeContent: t,
    max: r
  });
  let a = n;
  n === !1 && t === 0 && !o && (a = !0);
  const {
    badgeContent: l,
    max: c = r
  } = a ? i : e, d = l && Number(l) > c ? `${c}+` : l;
  return {
    badgeContent: l,
    invisible: a,
    max: c,
    displayValue: d
  };
}
function j6(e) {
  return gt("MuiBadge", e);
}
const La = vt("MuiBadge", [
  "root",
  "badge",
  "dot",
  "standard",
  "anchorOriginTopRight",
  "anchorOriginBottomRight",
  "anchorOriginTopLeft",
  "anchorOriginBottomLeft",
  "invisible",
  "colorError",
  "colorInfo",
  "colorPrimary",
  "colorSecondary",
  "colorSuccess",
  "colorWarning",
  "overlapRectangular",
  "overlapCircular",
  // TODO: v6 remove the overlap value from these class keys
  "anchorOriginTopLeftCircular",
  "anchorOriginTopLeftRectangular",
  "anchorOriginTopRightCircular",
  "anchorOriginTopRightRectangular",
  "anchorOriginBottomLeftCircular",
  "anchorOriginBottomLeftRectangular",
  "anchorOriginBottomRightCircular",
  "anchorOriginBottomRightRectangular"
]), Uv = 10, zv = 4, B6 = (e) => {
  const {
    color: t,
    anchorOrigin: n,
    invisible: r,
    overlap: o,
    variant: i,
    classes: a = {}
  } = e, l = {
    root: ["root"],
    badge: ["badge", i, r && "invisible", `anchorOrigin${Me(n.vertical)}${Me(n.horizontal)}`, `anchorOrigin${Me(n.vertical)}${Me(n.horizontal)}${Me(o)}`, `overlap${Me(o)}`, t !== "default" && `color${Me(t)}`]
  };
  return Ct(l, j6, a);
}, V6 = oe("span", {
  name: "MuiBadge",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  position: "relative",
  display: "inline-flex",
  // For correct alignment with the text.
  verticalAlign: "middle",
  flexShrink: 0
}), H6 = oe("span", {
  name: "MuiBadge",
  slot: "Badge",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.badge, t[n.variant], t[`anchorOrigin${Me(n.anchorOrigin.vertical)}${Me(n.anchorOrigin.horizontal)}${Me(n.overlap)}`], n.color !== "default" && t[`color${Me(n.color)}`], n.invisible && t.invisible];
  }
})(ut(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "center",
  alignContent: "center",
  alignItems: "center",
  position: "absolute",
  boxSizing: "border-box",
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(12),
  minWidth: Uv * 2,
  lineHeight: 1,
  padding: "0 6px",
  height: Uv * 2,
  borderRadius: Uv,
  zIndex: 1,
  // Render the badge on top of potential ripples.
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeInOut,
    duration: e.transitions.duration.enteringScreen
  }),
  variants: [...Object.entries(e.palette).filter(Jn(["contrastText"])).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      backgroundColor: (e.vars || e).palette[t].main,
      color: (e.vars || e).palette[t].contrastText
    }
  })), {
    props: {
      variant: "dot"
    },
    style: {
      borderRadius: zv,
      height: zv * 2,
      minWidth: zv * 2,
      padding: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "right" && t.overlap === "rectangular",
    style: {
      top: 0,
      right: 0,
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%",
      [`&.${La.invisible}`]: {
        transform: "scale(0) translate(50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "right" && t.overlap === "rectangular",
    style: {
      bottom: 0,
      right: 0,
      transform: "scale(1) translate(50%, 50%)",
      transformOrigin: "100% 100%",
      [`&.${La.invisible}`]: {
        transform: "scale(0) translate(50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "left" && t.overlap === "rectangular",
    style: {
      top: 0,
      left: 0,
      transform: "scale(1) translate(-50%, -50%)",
      transformOrigin: "0% 0%",
      [`&.${La.invisible}`]: {
        transform: "scale(0) translate(-50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "left" && t.overlap === "rectangular",
    style: {
      bottom: 0,
      left: 0,
      transform: "scale(1) translate(-50%, 50%)",
      transformOrigin: "0% 100%",
      [`&.${La.invisible}`]: {
        transform: "scale(0) translate(-50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "right" && t.overlap === "circular",
    style: {
      top: "14%",
      right: "14%",
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%",
      [`&.${La.invisible}`]: {
        transform: "scale(0) translate(50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "right" && t.overlap === "circular",
    style: {
      bottom: "14%",
      right: "14%",
      transform: "scale(1) translate(50%, 50%)",
      transformOrigin: "100% 100%",
      [`&.${La.invisible}`]: {
        transform: "scale(0) translate(50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "left" && t.overlap === "circular",
    style: {
      top: "14%",
      left: "14%",
      transform: "scale(1) translate(-50%, -50%)",
      transformOrigin: "0% 0%",
      [`&.${La.invisible}`]: {
        transform: "scale(0) translate(-50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "left" && t.overlap === "circular",
    style: {
      bottom: "14%",
      left: "14%",
      transform: "scale(1) translate(-50%, 50%)",
      transformOrigin: "0% 100%",
      [`&.${La.invisible}`]: {
        transform: "scale(0) translate(-50%, 50%)"
      }
    }
  }, {
    props: {
      invisible: !0
    },
    style: {
      transition: e.transitions.create("transform", {
        easing: e.transitions.easing.easeInOut,
        duration: e.transitions.duration.leavingScreen
      })
    }
  }]
})));
function _O(e) {
  return {
    vertical: (e == null ? void 0 : e.vertical) ?? "top",
    horizontal: (e == null ? void 0 : e.horizontal) ?? "right"
  };
}
const aM = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiBadge"
  }), {
    anchorOrigin: o,
    className: i,
    classes: a,
    component: l,
    components: c = {},
    componentsProps: d = {},
    children: f,
    overlap: p = "rectangular",
    color: g = "default",
    invisible: b = !1,
    max: v = 99,
    badgeContent: y,
    slots: S,
    slotProps: E,
    showZero: I = !1,
    variant: O = "standard",
    ...T
  } = r, {
    badgeContent: P,
    invisible: R,
    max: F,
    displayValue: A
  } = L6({
    max: v,
    invisible: b,
    badgeContent: y,
    showZero: I
  }), _ = $C({
    anchorOrigin: _O(o),
    color: g,
    overlap: p,
    variant: O,
    badgeContent: y
  }), C = R || P == null && O !== "dot", {
    color: D = g,
    overlap: L = p,
    anchorOrigin: B,
    variant: H = O
  } = C ? _ : r, k = _O(B), N = H !== "dot" ? A : void 0, j = {
    ...r,
    badgeContent: P,
    invisible: C,
    max: F,
    displayValue: N,
    showZero: I,
    anchorOrigin: k,
    color: D,
    overlap: L,
    variant: H
  }, W = B6(j), V = (S == null ? void 0 : S.root) ?? c.Root ?? V6, $ = (S == null ? void 0 : S.badge) ?? c.Badge ?? H6, z = (E == null ? void 0 : E.root) ?? d.root, ne = (E == null ? void 0 : E.badge) ?? d.badge, K = tp({
    elementType: V,
    externalSlotProps: z,
    externalForwardedProps: T,
    additionalProps: {
      ref: n,
      as: l
    },
    ownerState: j,
    className: ke(z == null ? void 0 : z.className, W.root, i)
  }), Q = tp({
    elementType: $,
    externalSlotProps: ne,
    ownerState: j,
    className: ke(W.badge, ne == null ? void 0 : ne.className)
  });
  return /* @__PURE__ */ w.jsxs(V, {
    ...K,
    children: [f, /* @__PURE__ */ w.jsx($, {
      ...Q,
      children: N
    })]
  });
});
process.env.NODE_ENV !== "production" && (aM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The anchor of the badge.
   * @default {
   *   vertical: 'top',
   *   horizontal: 'right',
   * }
   */
  anchorOrigin: s.shape({
    horizontal: s.oneOf(["left", "right"]),
    vertical: s.oneOf(["bottom", "top"])
  }),
  /**
   * The content rendered within the badge.
   */
  badgeContent: s.node,
  /**
   * The badge will be added relative to this node.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: s.oneOfType([s.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Badge: s.elementType,
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    badge: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * If `true`, the badge is invisible.
   * @default false
   */
  invisible: s.bool,
  /**
   * Max count to show.
   * @default 99
   */
  max: s.number,
  /**
   * Wrapped shape the badge should overlap.
   * @default 'rectangular'
   */
  overlap: s.oneOf(["circular", "rectangular"]),
  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   * @default false
   */
  showZero: s.bool,
  /**
   * The props used for each slot inside the Badge.
   * @default {}
   */
  slotProps: s.shape({
    badge: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside the Badge.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: s.shape({
    badge: s.elementType,
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: s.oneOfType([s.oneOf(["dot", "standard"]), s.string])
});
const U6 = vt("MuiBox", ["root"]), z6 = UC(), _t = kG({
  themeId: Di,
  defaultTheme: z6,
  defaultClassName: U6.root,
  generateClassName: ok.generate
});
process.env.NODE_ENV !== "production" && (_t.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: s.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function G6(e) {
  return gt("MuiButton", e);
}
const ou = vt("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge"]), lM = /* @__PURE__ */ m.createContext({});
process.env.NODE_ENV !== "production" && (lM.displayName = "ButtonGroupContext");
const cM = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (cM.displayName = "ButtonGroupButtonContext");
const W6 = (e) => {
  const {
    color: t,
    disableElevation: n,
    fullWidth: r,
    size: o,
    variant: i,
    classes: a
  } = e, l = {
    root: ["root", i, `${i}${Me(t)}`, `size${Me(o)}`, `${i}Size${Me(o)}`, `color${Me(t)}`, n && "disableElevation", r && "fullWidth"],
    label: ["label"],
    startIcon: ["icon", "startIcon", `iconSize${Me(o)}`],
    endIcon: ["icon", "endIcon", `iconSize${Me(o)}`]
  }, c = Ct(l, G6, a);
  return {
    ...a,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...c
  };
}, uM = [{
  props: {
    size: "small"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 18
    }
  }
}, {
  props: {
    size: "medium"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 20
    }
  }
}, {
  props: {
    size: "large"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 22
    }
  }
}], q6 = oe(va, {
  shouldForwardProp: (e) => qo(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${Me(n.color)}`], t[`size${Me(n.size)}`], t[`${n.variant}Size${Me(n.size)}`], n.color === "inherit" && t.colorInherit, n.disableElevation && t.disableElevation, n.fullWidth && t.fullWidth];
  }
})(ut(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], n = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return {
    ...e.typography.button,
    minWidth: 64,
    padding: "6px 16px",
    border: 0,
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": {
      textDecoration: "none"
    },
    [`&.${ou.disabled}`]: {
      color: (e.vars || e).palette.action.disabled
    },
    variants: [{
      props: {
        variant: "contained"
      },
      style: {
        color: "var(--variant-containedColor)",
        backgroundColor: "var(--variant-containedBg)",
        boxShadow: (e.vars || e).shadows[2],
        "&:hover": {
          boxShadow: (e.vars || e).shadows[4],
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            boxShadow: (e.vars || e).shadows[2]
          }
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[8]
        },
        [`&.${ou.focusVisible}`]: {
          boxShadow: (e.vars || e).shadows[6]
        },
        [`&.${ou.disabled}`]: {
          color: (e.vars || e).palette.action.disabled,
          boxShadow: (e.vars || e).shadows[0],
          backgroundColor: (e.vars || e).palette.action.disabledBackground
        }
      }
    }, {
      props: {
        variant: "outlined"
      },
      style: {
        padding: "5px 15px",
        border: "1px solid currentColor",
        borderColor: "var(--variant-outlinedBorder, currentColor)",
        backgroundColor: "var(--variant-outlinedBg)",
        color: "var(--variant-outlinedColor)",
        [`&.${ou.disabled}`]: {
          border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
        }
      }
    }, {
      props: {
        variant: "text"
      },
      style: {
        padding: "6px 8px",
        color: "var(--variant-textColor)",
        backgroundColor: "var(--variant-textBg)"
      }
    }, ...Object.entries(e.palette).filter(Jn()).map(([r]) => ({
      props: {
        color: r
      },
      style: {
        "--variant-textColor": (e.vars || e).palette[r].main,
        "--variant-outlinedColor": (e.vars || e).palette[r].main,
        "--variant-outlinedBorder": e.vars ? `rgba(${e.vars.palette[r].mainChannel} / 0.5)` : Vt(e.palette[r].main, 0.5),
        "--variant-containedColor": (e.vars || e).palette[r].contrastText,
        "--variant-containedBg": (e.vars || e).palette[r].main,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": (e.vars || e).palette[r].dark,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Vt(e.palette[r].main, e.palette.action.hoverOpacity),
            "--variant-outlinedBorder": (e.vars || e).palette[r].main,
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Vt(e.palette[r].main, e.palette.action.hoverOpacity)
          }
        }
      }
    })), {
      props: {
        color: "inherit"
      },
      style: {
        color: "inherit",
        borderColor: "currentColor",
        "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedBg : t,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedHoverBg : n,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : Vt(e.palette.text.primary, e.palette.action.hoverOpacity),
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : Vt(e.palette.text.primary, e.palette.action.hoverOpacity)
          }
        }
      }
    }, {
      props: {
        size: "small",
        variant: "text"
      },
      style: {
        padding: "4px 5px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "text"
      },
      style: {
        padding: "8px 11px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "outlined"
      },
      style: {
        padding: "3px 9px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "outlined"
      },
      style: {
        padding: "7px 21px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "contained"
      },
      style: {
        padding: "4px 10px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "contained"
      },
      style: {
        padding: "8px 22px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        disableElevation: !0
      },
      style: {
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none"
        },
        [`&.${ou.focusVisible}`]: {
          boxShadow: "none"
        },
        "&:active": {
          boxShadow: "none"
        },
        [`&.${ou.disabled}`]: {
          boxShadow: "none"
        }
      }
    }, {
      props: {
        fullWidth: !0
      },
      style: {
        width: "100%"
      }
    }]
  };
})), K6 = oe("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.startIcon, t[`iconSize${Me(n.size)}`]];
  }
})({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginLeft: -2
    }
  }, ...uM]
}), Y6 = oe("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.endIcon, t[`iconSize${Me(n.size)}`]];
  }
})({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginRight: -2
    }
  }, ...uM]
}), as = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = m.useContext(lM), o = m.useContext(cM), i = ep(r, t), a = St({
    props: i,
    name: "MuiButton"
  }), {
    children: l,
    color: c = "primary",
    component: d = "button",
    className: f,
    disabled: p = !1,
    disableElevation: g = !1,
    disableFocusRipple: b = !1,
    endIcon: v,
    focusVisibleClassName: y,
    fullWidth: S = !1,
    size: E = "medium",
    startIcon: I,
    type: O,
    variant: T = "text",
    ...P
  } = a, R = {
    ...a,
    color: c,
    component: d,
    disabled: p,
    disableElevation: g,
    disableFocusRipple: b,
    fullWidth: S,
    size: E,
    type: O,
    variant: T
  }, F = W6(R), A = I && /* @__PURE__ */ w.jsx(K6, {
    className: F.startIcon,
    ownerState: R,
    children: I
  }), _ = v && /* @__PURE__ */ w.jsx(Y6, {
    className: F.endIcon,
    ownerState: R,
    children: v
  }), C = o || "";
  return /* @__PURE__ */ w.jsxs(q6, {
    ownerState: R,
    className: ke(r.className, F.root, f, C),
    component: d,
    disabled: p,
    focusRipple: !b,
    focusVisibleClassName: ke(F.focusVisible, y),
    ref: n,
    type: O,
    ...P,
    classes: F,
    children: [A, l, _]
  });
});
process.env.NODE_ENV !== "production" && (as.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: s.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: s.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: s.bool,
  /**
   * Element placed after the children.
   */
  endIcon: s.node,
  /**
   * @ignore
   */
  focusVisibleClassName: s.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: s.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["small", "medium", "large"]), s.string]),
  /**
   * Element placed before the children.
   */
  startIcon: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * @ignore
   */
  type: s.oneOfType([s.oneOf(["button", "reset", "submit"]), s.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: s.oneOfType([s.oneOf(["contained", "outlined", "text"]), s.string])
});
function Q6(e) {
  return gt("MuiCard", e);
}
vt("MuiCard", ["root"]);
const X6 = (e) => {
  const {
    classes: t
  } = e;
  return Ct({
    root: ["root"]
  }, Q6, t);
}, J6 = oe(cs, {
  name: "MuiCard",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  overflow: "hidden"
}), sx = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiCard"
  }), {
    className: o,
    raised: i = !1,
    ...a
  } = r, l = {
    ...r,
    raised: i
  }, c = X6(l);
  return /* @__PURE__ */ w.jsx(J6, {
    className: ke(c.root, o),
    elevation: i ? 8 : void 0,
    ref: n,
    ownerState: l,
    ...a
  });
});
process.env.NODE_ENV !== "production" && (sx.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * If `true`, the card will use raised styling.
   * @default false
   */
  raised: Go(s.bool, (e) => e.raised && e.variant === "outlined" ? new Error('MUI: Combining `raised={true}` with `variant="outlined"` has no effect.') : null),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function Z6(e) {
  return gt("MuiCardContent", e);
}
vt("MuiCardContent", ["root"]);
const e9 = (e) => {
  const {
    classes: t
  } = e;
  return Ct({
    root: ["root"]
  }, Z6, t);
}, t9 = oe("div", {
  name: "MuiCardContent",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: 16,
  "&:last-child": {
    paddingBottom: 24
  }
}), pb = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiCardContent"
  }), {
    className: o,
    component: i = "div",
    ...a
  } = r, l = {
    ...r,
    component: i
  }, c = e9(l);
  return /* @__PURE__ */ w.jsx(t9, {
    as: i,
    className: ke(c.root, o),
    ownerState: l,
    ref: n,
    ...a
  });
});
process.env.NODE_ENV !== "production" && (pb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function n9(e) {
  return gt("MuiCardHeader", e);
}
const cm = vt("MuiCardHeader", ["root", "avatar", "action", "content", "title", "subheader"]), r9 = (e) => {
  const {
    classes: t
  } = e;
  return Ct({
    root: ["root"],
    avatar: ["avatar"],
    action: ["action"],
    content: ["content"],
    title: ["title"],
    subheader: ["subheader"]
  }, n9, t);
}, o9 = oe("div", {
  name: "MuiCardHeader",
  slot: "Root",
  overridesResolver: (e, t) => [{
    [`& .${cm.title}`]: t.title
  }, {
    [`& .${cm.subheader}`]: t.subheader
  }, t.root]
})({
  display: "flex",
  alignItems: "center",
  padding: 16
}), i9 = oe("div", {
  name: "MuiCardHeader",
  slot: "Avatar",
  overridesResolver: (e, t) => t.avatar
})({
  display: "flex",
  flex: "0 0 auto",
  marginRight: 16
}), s9 = oe("div", {
  name: "MuiCardHeader",
  slot: "Action",
  overridesResolver: (e, t) => t.action
})({
  flex: "0 0 auto",
  alignSelf: "flex-start",
  marginTop: -4,
  marginRight: -8,
  marginBottom: -4
}), a9 = oe("div", {
  name: "MuiCardHeader",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})({
  flex: "1 1 auto",
  [`.${om.root}:where(& .${cm.title})`]: {
    display: "block"
  },
  [`.${om.root}:where(& .${cm.subheader})`]: {
    display: "block"
  }
}), dM = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiCardHeader"
  }), {
    action: o,
    avatar: i,
    className: a,
    component: l = "div",
    disableTypography: c = !1,
    subheader: d,
    subheaderTypographyProps: f,
    title: p,
    titleTypographyProps: g,
    ...b
  } = r, v = {
    ...r,
    component: l,
    disableTypography: c
  }, y = r9(v);
  let S = p;
  S != null && S.type !== Rt && !c && (S = /* @__PURE__ */ w.jsx(Rt, {
    variant: i ? "body2" : "h5",
    className: y.title,
    component: "span",
    ...g,
    children: S
  }));
  let E = d;
  return E != null && E.type !== Rt && !c && (E = /* @__PURE__ */ w.jsx(Rt, {
    variant: i ? "body2" : "body1",
    className: y.subheader,
    color: "textSecondary",
    component: "span",
    ...f,
    children: E
  })), /* @__PURE__ */ w.jsxs(o9, {
    className: ke(y.root, a),
    as: l,
    ref: n,
    ownerState: v,
    ...b,
    children: [i && /* @__PURE__ */ w.jsx(i9, {
      className: y.avatar,
      ownerState: v,
      children: i
    }), /* @__PURE__ */ w.jsxs(a9, {
      className: y.content,
      ownerState: v,
      children: [S, E]
    }), o && /* @__PURE__ */ w.jsx(s9, {
      className: y.action,
      ownerState: v,
      children: o
    })]
  });
});
process.env.NODE_ENV !== "production" && (dM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display in the card header.
   */
  action: s.node,
  /**
   * The Avatar element to display.
   */
  avatar: s.node,
  /**
   * @ignore
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `title` text, and optional `subheader` text
   * with the Typography component.
   * @default false
   */
  disableTypography: s.bool,
  /**
   * The content of the component.
   */
  subheader: s.node,
  /**
   * These props will be forwarded to the subheader
   * (as long as disableTypography is not `true`).
   */
  subheaderTypographyProps: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The content of the component.
   */
  title: s.node,
  /**
   * These props will be forwarded to the title
   * (as long as disableTypography is not `true`).
   */
  titleTypographyProps: s.object
});
function l9(e) {
  return gt("PrivateSwitchBase", e);
}
vt("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const c9 = (e) => {
  const {
    classes: t,
    checked: n,
    disabled: r,
    edge: o
  } = e, i = {
    root: ["root", n && "checked", r && "disabled", o && `edge${Me(o)}`],
    input: ["input"]
  };
  return Ct(i, l9, t);
}, u9 = oe(va)({
  padding: 9,
  borderRadius: "50%",
  variants: [{
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "start" && t.size !== "small",
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "end" && t.size !== "small",
    style: {
      marginRight: -12
    }
  }]
}), d9 = oe("input", {
  shouldForwardProp: qo
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), fM = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    autoFocus: r,
    checked: o,
    checkedIcon: i,
    className: a,
    defaultChecked: l,
    disabled: c,
    disableFocusRipple: d = !1,
    edge: f = !1,
    icon: p,
    id: g,
    inputProps: b,
    inputRef: v,
    name: y,
    onBlur: S,
    onChange: E,
    onFocus: I,
    readOnly: O,
    required: T = !1,
    tabIndex: P,
    type: R,
    value: F,
    ...A
  } = t, [_, C] = ul({
    controlled: o,
    default: !!l,
    name: "SwitchBase",
    state: "checked"
  }), D = Sa(), L = (V) => {
    I && I(V), D && D.onFocus && D.onFocus(V);
  }, B = (V) => {
    S && S(V), D && D.onBlur && D.onBlur(V);
  }, H = (V) => {
    if (V.nativeEvent.defaultPrevented)
      return;
    const $ = V.target.checked;
    C($), E && E(V, $);
  };
  let k = c;
  D && typeof k > "u" && (k = D.disabled);
  const N = R === "checkbox" || R === "radio", j = {
    ...t,
    checked: _,
    disabled: k,
    disableFocusRipple: d,
    edge: f
  }, W = c9(j);
  return /* @__PURE__ */ w.jsxs(u9, {
    component: "span",
    className: ke(W.root, a),
    centerRipple: !0,
    focusRipple: !d,
    disabled: k,
    tabIndex: null,
    role: void 0,
    onFocus: L,
    onBlur: B,
    ownerState: j,
    ref: n,
    ...A,
    children: [/* @__PURE__ */ w.jsx(d9, {
      autoFocus: r,
      checked: o,
      defaultChecked: l,
      className: W.input,
      disabled: k,
      id: N ? g : void 0,
      name: y,
      onChange: H,
      readOnly: O,
      ref: v,
      required: T,
      ownerState: j,
      tabIndex: P,
      type: R,
      ...R === "checkbox" && F === void 0 ? {} : {
        value: F
      },
      ...b
    }), _ ? i : p]
  });
});
process.env.NODE_ENV !== "production" && (fM.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: s.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: s.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: s.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * @ignore
   */
  defaultChecked: s.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: s.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: s.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: s.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: s.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Wo,
  /*
   * @ignore
   */
  name: s.string,
  /**
   * @ignore
   */
  onBlur: s.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: s.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.object,
  /**
   * @ignore
   */
  tabIndex: s.oneOfType([s.number, s.string]),
  /**
   * The input component prop `type`.
   */
  type: s.string.isRequired,
  /**
   * The value of the component.
   */
  value: s.any
});
const f9 = At(/* @__PURE__ */ w.jsx("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), p9 = At(/* @__PURE__ */ w.jsx("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), h9 = At(/* @__PURE__ */ w.jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function g9(e) {
  return gt("MuiCheckbox", e);
}
const Gv = vt("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]), m9 = (e) => {
  const {
    classes: t,
    indeterminate: n,
    color: r,
    size: o
  } = e, i = {
    root: ["root", n && "indeterminate", `color${Me(r)}`, `size${Me(o)}`]
  }, a = Ct(i, g9, t);
  return {
    ...t,
    // forward the disabled and checked classes to the SwitchBase
    ...a
  };
}, b9 = oe(fM, {
  shouldForwardProp: (e) => qo(e) || e === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.indeterminate && t.indeterminate, t[`size${Me(n.size)}`], n.color !== "default" && t[`color${Me(n.color)}`]];
  }
})(ut(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  variants: [{
    props: {
      color: "default",
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : Vt(e.palette.action.active, e.palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(e.palette).filter(Jn()).map(([t]) => ({
    props: {
      color: t,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Vt(e.palette[t].main, e.palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(e.palette).filter(Jn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${Gv.checked}, &.${Gv.indeterminate}`]: {
        color: (e.vars || e).palette[t].main
      },
      [`&.${Gv.disabled}`]: {
        color: (e.vars || e).palette.action.disabled
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
}))), y9 = /* @__PURE__ */ w.jsx(p9, {}), v9 = /* @__PURE__ */ w.jsx(f9, {}), w9 = /* @__PURE__ */ w.jsx(h9, {}), hb = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiCheckbox"
  }), {
    checkedIcon: o = y9,
    color: i = "primary",
    icon: a = v9,
    indeterminate: l = !1,
    indeterminateIcon: c = w9,
    inputProps: d,
    size: f = "medium",
    disableRipple: p = !1,
    className: g,
    ...b
  } = r, v = l ? c : a, y = l ? c : o, S = {
    ...r,
    disableRipple: p,
    color: i,
    indeterminate: l,
    size: f
  }, E = m9(S);
  return /* @__PURE__ */ w.jsx(b9, {
    type: "checkbox",
    inputProps: {
      "data-indeterminate": l,
      ...d
    },
    icon: /* @__PURE__ */ m.cloneElement(v, {
      fontSize: v.props.fontSize ?? f
    }),
    checkedIcon: /* @__PURE__ */ m.cloneElement(y, {
      fontSize: y.props.fontSize ?? f
    }),
    ownerState: S,
    ref: n,
    className: ke(E.root, g),
    disableRipple: p,
    ...b,
    classes: E
  });
});
process.env.NODE_ENV !== "production" && (hb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: s.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: s.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: s.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: s.node,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: s.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: s.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Wo,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: s.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: s.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: s.any
});
function C9(e) {
  return gt("MuiCircularProgress", e);
}
vt("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const ja = 44, i0 = Gs`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`, s0 = Gs`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`, x9 = typeof i0 != "string" ? El`
        animation: ${i0} 1.4s linear infinite;
      ` : null, S9 = typeof s0 != "string" ? El`
        animation: ${s0} 1.4s ease-in-out infinite;
      ` : null, E9 = (e) => {
  const {
    classes: t,
    variant: n,
    color: r,
    disableShrink: o
  } = e, i = {
    root: ["root", n, `color${Me(r)}`],
    svg: ["svg"],
    circle: ["circle", `circle${Me(n)}`, o && "circleDisableShrink"]
  };
  return Ct(i, C9, t);
}, T9 = oe("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`color${Me(n.color)}`]];
  }
})(ut(({
  theme: e
}) => ({
  display: "inline-block",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("transform")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: x9 || {
      animation: `${i0} 1.4s linear infinite`
    }
  }, ...Object.entries(e.palette).filter(Jn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  }))]
}))), O9 = oe("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (e, t) => t.svg
})({
  display: "block"
  // Keeps the progress centered
}), P9 = oe("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.circle, t[`circle${Me(n.variant)}`], n.disableShrink && t.circleDisableShrink];
  }
})(ut(({
  theme: e
}) => ({
  stroke: "currentColor",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("stroke-dashoffset")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: {
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: 0
      // Add the unit to fix a Edge 16 and below bug.
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" && !t.disableShrink,
    style: S9 || {
      // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
      animation: `${s0} 1.4s ease-in-out infinite`
    }
  }]
}))), Gp = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiCircularProgress"
  }), {
    className: o,
    color: i = "primary",
    disableShrink: a = !1,
    size: l = 40,
    style: c,
    thickness: d = 3.6,
    value: f = 0,
    variant: p = "indeterminate",
    ...g
  } = r, b = {
    ...r,
    color: i,
    disableShrink: a,
    size: l,
    thickness: d,
    value: f,
    variant: p
  }, v = E9(b), y = {}, S = {}, E = {};
  if (p === "determinate") {
    const I = 2 * Math.PI * ((ja - d) / 2);
    y.strokeDasharray = I.toFixed(3), E["aria-valuenow"] = Math.round(f), y.strokeDashoffset = `${((100 - f) / 100 * I).toFixed(3)}px`, S.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ w.jsx(T9, {
    className: ke(v.root, o),
    style: {
      width: l,
      height: l,
      ...S,
      ...c
    },
    ownerState: b,
    ref: n,
    role: "progressbar",
    ...E,
    ...g,
    children: /* @__PURE__ */ w.jsx(O9, {
      className: v.svg,
      ownerState: b,
      viewBox: `${ja / 2} ${ja / 2} ${ja} ${ja}`,
      children: /* @__PURE__ */ w.jsx(P9, {
        className: v.circle,
        style: y,
        ownerState: b,
        cx: ja,
        cy: ja,
        r: (ja - d) / 2,
        fill: "none",
        strokeWidth: d
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Gp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: Go(s.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: s.oneOfType([s.number, s.string]),
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: s.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: s.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: s.oneOf(["determinate", "indeterminate"])
});
function kO(e) {
  return e.substring(2).toLowerCase();
}
function I9(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function lp(e) {
  const {
    children: t,
    disableReactTree: n = !1,
    mouseEvent: r = "onClick",
    onClickAway: o,
    touchEvent: i = "onTouchEnd"
  } = e, a = m.useRef(!1), l = m.useRef(null), c = m.useRef(!1), d = m.useRef(!1);
  m.useEffect(() => (setTimeout(() => {
    c.current = !0;
  }, 0), () => {
    c.current = !1;
  }), []);
  const f = sr(Rc(t), l), p = li((v) => {
    const y = d.current;
    d.current = !1;
    const S = go(l.current);
    if (!c.current || !l.current || "clientX" in v && I9(v, S))
      return;
    if (a.current) {
      a.current = !1;
      return;
    }
    let E;
    v.composedPath ? E = v.composedPath().includes(l.current) : E = !S.documentElement.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      v.target
    ) || l.current.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      v.target
    ), !E && (n || !y) && o(v);
  }), g = (v) => (y) => {
    d.current = !0;
    const S = t.props[v];
    S && S(y);
  }, b = {
    ref: f
  };
  return i !== !1 && (b[i] = g(i)), m.useEffect(() => {
    if (i !== !1) {
      const v = kO(i), y = go(l.current), S = () => {
        a.current = !0;
      };
      return y.addEventListener(v, p), y.addEventListener("touchmove", S), () => {
        y.removeEventListener(v, p), y.removeEventListener("touchmove", S);
      };
    }
  }, [p, i]), r !== !1 && (b[r] = g(r)), m.useEffect(() => {
    if (r !== !1) {
      const v = kO(r), y = go(l.current);
      return y.addEventListener(v, p), () => {
        y.removeEventListener(v, p);
      };
    }
  }, [p, r]), /* @__PURE__ */ m.cloneElement(t, b);
}
process.env.NODE_ENV !== "production" && (lp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The wrapped element.
   */
  children: Ic.isRequired,
  /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   * @default false
   */
  disableReactTree: s.bool,
  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   * @default 'onClick'
   */
  mouseEvent: s.oneOf(["onClick", "onMouseDown", "onMouseUp", "onPointerDown", "onPointerUp", !1]),
  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: s.func.isRequired,
  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   * @default 'onTouchEnd'
   */
  touchEvent: s.oneOf(["onTouchEnd", "onTouchStart", !1])
});
process.env.NODE_ENV !== "production" && (lp.propTypes = Bp(lp.propTypes));
function R9(e) {
  const t = go(e);
  return t.body === e ? ya(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function Vf(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function MO(e) {
  return parseInt(ya(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function _9(e) {
  const n = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].includes(e.tagName), r = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return n || r;
}
function AO(e, t, n, r, o) {
  const i = [t, n, ...r];
  [].forEach.call(e.children, (a) => {
    const l = !i.includes(a), c = !_9(a);
    l && c && Vf(a, o);
  });
}
function Wv(e, t) {
  let n = -1;
  return e.some((r, o) => t(r) ? (n = o, !0) : !1), n;
}
function k9(e, t) {
  const n = [], r = e.container;
  if (!t.disableScrollLock) {
    if (R9(r)) {
      const a = vk(ya(r));
      n.push({
        value: r.style.paddingRight,
        property: "padding-right",
        el: r
      }), r.style.paddingRight = `${MO(r) + a}px`;
      const l = go(r).querySelectorAll(".mui-fixed");
      [].forEach.call(l, (c) => {
        n.push({
          value: c.style.paddingRight,
          property: "padding-right",
          el: c
        }), c.style.paddingRight = `${MO(c) + a}px`;
      });
    }
    let i;
    if (r.parentNode instanceof DocumentFragment)
      i = go(r).body;
    else {
      const a = r.parentElement, l = ya(r);
      i = (a == null ? void 0 : a.nodeName) === "HTML" && l.getComputedStyle(a).overflowY === "scroll" ? a : r;
    }
    n.push({
      value: i.style.overflow,
      property: "overflow",
      el: i
    }, {
      value: i.style.overflowX,
      property: "overflow-x",
      el: i
    }, {
      value: i.style.overflowY,
      property: "overflow-y",
      el: i
    }), i.style.overflow = "hidden";
  }
  return () => {
    n.forEach(({
      value: i,
      el: a,
      property: l
    }) => {
      i ? a.style.setProperty(l, i) : a.style.removeProperty(l);
    });
  };
}
function M9(e) {
  const t = [];
  return [].forEach.call(e.children, (n) => {
    n.getAttribute("aria-hidden") === "true" && t.push(n);
  }), t;
}
class A9 {
  constructor() {
    this.modals = [], this.containers = [];
  }
  add(t, n) {
    let r = this.modals.indexOf(t);
    if (r !== -1)
      return r;
    r = this.modals.length, this.modals.push(t), t.modalRef && Vf(t.modalRef, !1);
    const o = M9(n);
    AO(n, t.mount, t.modalRef, o, !0);
    const i = Wv(this.containers, (a) => a.container === n);
    return i !== -1 ? (this.containers[i].modals.push(t), r) : (this.containers.push({
      modals: [t],
      container: n,
      restore: null,
      hiddenSiblings: o
    }), r);
  }
  mount(t, n) {
    const r = Wv(this.containers, (i) => i.modals.includes(t)), o = this.containers[r];
    o.restore || (o.restore = k9(o, n));
  }
  remove(t, n = !0) {
    const r = this.modals.indexOf(t);
    if (r === -1)
      return r;
    const o = Wv(this.containers, (a) => a.modals.includes(t)), i = this.containers[o];
    if (i.modals.splice(i.modals.indexOf(t), 1), this.modals.splice(r, 1), i.modals.length === 0)
      i.restore && i.restore(), t.modalRef && Vf(t.modalRef, n), AO(i.container, t.mount, t.modalRef, i.hiddenSiblings, !1), this.containers.splice(o, 1);
    else {
      const a = i.modals[i.modals.length - 1];
      a.modalRef && Vf(a.modalRef, !1);
    }
    return r;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
const D9 = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function N9(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function F9(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (r) => e.ownerDocument.querySelector(`input[type="radio"]${r}`);
  let n = t(`[name="${e.name}"]:checked`);
  return n || (n = t(`[name="${e.name}"]`)), n !== e;
}
function $9(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || F9(e));
}
function L9(e) {
  const t = [], n = [];
  return Array.from(e.querySelectorAll(D9)).forEach((r, o) => {
    const i = N9(r);
    i === -1 || !$9(r) || (i === 0 ? t.push(r) : n.push({
      documentOrder: o,
      tabIndex: i,
      node: r
    }));
  }), n.sort((r, o) => r.tabIndex === o.tabIndex ? r.documentOrder - o.documentOrder : r.tabIndex - o.tabIndex).map((r) => r.node).concat(t);
}
function j9() {
  return !0;
}
function cp(e) {
  const {
    children: t,
    disableAutoFocus: n = !1,
    disableEnforceFocus: r = !1,
    disableRestoreFocus: o = !1,
    getTabbable: i = L9,
    isEnabled: a = j9,
    open: l
  } = e, c = m.useRef(!1), d = m.useRef(null), f = m.useRef(null), p = m.useRef(null), g = m.useRef(null), b = m.useRef(!1), v = m.useRef(null), y = sr(Rc(t), v), S = m.useRef(null);
  m.useEffect(() => {
    !l || !v.current || (b.current = !n);
  }, [n, l]), m.useEffect(() => {
    if (!l || !v.current)
      return;
    const O = go(v.current);
    return v.current.contains(O.activeElement) || (v.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), v.current.setAttribute("tabIndex", "-1")), b.current && v.current.focus()), () => {
      o || (p.current && p.current.focus && (c.current = !0, p.current.focus()), p.current = null);
    };
  }, [l]), m.useEffect(() => {
    if (!l || !v.current)
      return;
    const O = go(v.current), T = (F) => {
      S.current = F, !(r || !a() || F.key !== "Tab") && O.activeElement === v.current && F.shiftKey && (c.current = !0, f.current && f.current.focus());
    }, P = () => {
      var _, C;
      const F = v.current;
      if (F === null)
        return;
      if (!O.hasFocus() || !a() || c.current) {
        c.current = !1;
        return;
      }
      if (F.contains(O.activeElement) || r && O.activeElement !== d.current && O.activeElement !== f.current)
        return;
      if (O.activeElement !== g.current)
        g.current = null;
      else if (g.current !== null)
        return;
      if (!b.current)
        return;
      let A = [];
      if ((O.activeElement === d.current || O.activeElement === f.current) && (A = i(v.current)), A.length > 0) {
        const D = !!((_ = S.current) != null && _.shiftKey && ((C = S.current) == null ? void 0 : C.key) === "Tab"), L = A[0], B = A[A.length - 1];
        typeof L != "string" && typeof B != "string" && (D ? B.focus() : L.focus());
      } else
        F.focus();
    };
    O.addEventListener("focusin", P), O.addEventListener("keydown", T, !0);
    const R = setInterval(() => {
      O.activeElement && O.activeElement.tagName === "BODY" && P();
    }, 50);
    return () => {
      clearInterval(R), O.removeEventListener("focusin", P), O.removeEventListener("keydown", T, !0);
    };
  }, [n, r, o, a, l, i]);
  const E = (O) => {
    p.current === null && (p.current = O.relatedTarget), b.current = !0, g.current = O.target;
    const T = t.props.onFocus;
    T && T(O);
  }, I = (O) => {
    p.current === null && (p.current = O.relatedTarget), b.current = !0;
  };
  return /* @__PURE__ */ w.jsxs(m.Fragment, {
    children: [/* @__PURE__ */ w.jsx("div", {
      tabIndex: l ? 0 : -1,
      onFocus: I,
      ref: d,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ m.cloneElement(t, {
      ref: y,
      onFocus: E
    }), /* @__PURE__ */ w.jsx("div", {
      tabIndex: l ? 0 : -1,
      onFocus: I,
      ref: f,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (cp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: Ic,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: s.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: s.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: s.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: s.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: s.func,
  /**
   * If `true`, focus is locked.
   */
  open: s.bool.isRequired
});
process.env.NODE_ENV !== "production" && (cp.propTypes = Bp(cp.propTypes));
function B9(e) {
  return typeof e == "function" ? e() : e;
}
function V9(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const DO = () => {
}, fg = new A9();
function H9(e) {
  const {
    container: t,
    disableEscapeKeyDown: n = !1,
    disableScrollLock: r = !1,
    closeAfterTransition: o = !1,
    onTransitionEnter: i,
    onTransitionExited: a,
    children: l,
    onClose: c,
    open: d,
    rootRef: f
  } = e, p = m.useRef({}), g = m.useRef(null), b = m.useRef(null), v = sr(b, f), [y, S] = m.useState(!d), E = V9(l);
  let I = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (I = !1);
  const O = () => go(g.current), T = () => (p.current.modalRef = b.current, p.current.mount = g.current, p.current), P = () => {
    fg.mount(T(), {
      disableScrollLock: r
    }), b.current && (b.current.scrollTop = 0);
  }, R = li(() => {
    const k = B9(t) || O().body;
    fg.add(T(), k), b.current && P();
  }), F = () => fg.isTopModal(T()), A = li((k) => {
    g.current = k, k && (d && F() ? P() : b.current && Vf(b.current, I));
  }), _ = m.useCallback(() => {
    fg.remove(T(), I);
  }, [I]);
  m.useEffect(() => () => {
    _();
  }, [_]), m.useEffect(() => {
    d ? R() : (!E || !o) && _();
  }, [d, _, E, o, R]);
  const C = (k) => (N) => {
    var j;
    (j = k.onKeyDown) == null || j.call(k, N), !(N.key !== "Escape" || N.which === 229 || // Wait until IME is settled.
    !F()) && (n || (N.stopPropagation(), c && c(N, "escapeKeyDown")));
  }, D = (k) => (N) => {
    var j;
    (j = k.onClick) == null || j.call(k, N), N.target === N.currentTarget && c && c(N, "backdropClick");
  };
  return {
    getRootProps: (k = {}) => {
      const N = Sk(e);
      delete N.onTransitionEnter, delete N.onTransitionExited;
      const j = {
        ...N,
        ...k
      };
      return {
        /*
         * Marking an element with the role presentation indicates to assistive technology
         * that this element should be ignored; it exists to support the web application and
         * is not meant for humans to interact with directly.
         * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
         */
        role: "presentation",
        ...j,
        onKeyDown: C(j),
        ref: v
      };
    },
    getBackdropProps: (k = {}) => {
      const N = k;
      return {
        "aria-hidden": !0,
        ...N,
        onClick: D(N),
        open: d
      };
    },
    getTransitionProps: () => {
      const k = () => {
        S(!1), i && i();
      }, N = () => {
        S(!0), a && a(), o && _();
      };
      return {
        onEnter: z1(k, (l == null ? void 0 : l.props.onEnter) ?? DO),
        onExited: z1(N, (l == null ? void 0 : l.props.onExited) ?? DO)
      };
    },
    rootRef: v,
    portalRef: A,
    isTopModal: F,
    exited: y,
    hasTransition: E
  };
}
function U9(e) {
  return gt("MuiModal", e);
}
vt("MuiModal", ["root", "hidden", "backdrop"]);
const z9 = (e) => {
  const {
    open: t,
    exited: n,
    classes: r
  } = e;
  return Ct({
    root: ["root", !t && n && "hidden"],
    backdrop: ["backdrop"]
  }, U9, r);
}, G9 = oe("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.open && n.exited && t.hidden];
  }
})(ut(({
  theme: e
}) => ({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  variants: [{
    props: ({
      ownerState: t
    }) => !t.open && t.exited,
    style: {
      visibility: "hidden"
    }
  }]
}))), W9 = oe(ix, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), ax = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: o = W9,
    BackdropProps: i,
    classes: a,
    className: l,
    closeAfterTransition: c = !1,
    children: d,
    container: f,
    component: p,
    components: g = {},
    componentsProps: b = {},
    disableAutoFocus: v = !1,
    disableEnforceFocus: y = !1,
    disableEscapeKeyDown: S = !1,
    disablePortal: E = !1,
    disableRestoreFocus: I = !1,
    disableScrollLock: O = !1,
    hideBackdrop: T = !1,
    keepMounted: P = !1,
    onBackdropClick: R,
    onClose: F,
    onTransitionEnter: A,
    onTransitionExited: _,
    open: C,
    slotProps: D = {},
    slots: L = {},
    // eslint-disable-next-line react/prop-types
    theme: B,
    ...H
  } = r, k = {
    ...r,
    closeAfterTransition: c,
    disableAutoFocus: v,
    disableEnforceFocus: y,
    disableEscapeKeyDown: S,
    disablePortal: E,
    disableRestoreFocus: I,
    disableScrollLock: O,
    hideBackdrop: T,
    keepMounted: P
  }, {
    getRootProps: N,
    getBackdropProps: j,
    getTransitionProps: W,
    portalRef: V,
    isTopModal: $,
    exited: z,
    hasTransition: ne
  } = H9({
    ...k,
    rootRef: n
  }), K = {
    ...k,
    exited: z
  }, Q = z9(K), re = {};
  if (d.props.tabIndex === void 0 && (re.tabIndex = "-1"), ne) {
    const {
      onEnter: q,
      onExited: Ee
    } = W();
    re.onEnter = q, re.onExited = Ee;
  }
  const te = {
    ...H,
    slots: {
      root: g.Root,
      backdrop: g.Backdrop,
      ...L
    },
    slotProps: {
      ...b,
      ...D
    }
  }, [ie, ae] = gn("root", {
    elementType: G9,
    externalForwardedProps: te,
    getSlotProps: N,
    additionalProps: {
      ref: n,
      as: p
    },
    ownerState: K,
    className: ke(l, Q == null ? void 0 : Q.root, !K.open && K.exited && (Q == null ? void 0 : Q.hidden))
  }), [ce, le] = gn("backdrop", {
    elementType: o,
    externalForwardedProps: te,
    additionalProps: i,
    getSlotProps: (q) => j({
      ...q,
      onClick: (Ee) => {
        R && R(Ee), q != null && q.onClick && q.onClick(Ee);
      }
    }),
    className: ke(i == null ? void 0 : i.className, Q == null ? void 0 : Q.backdrop),
    ownerState: K
  }), we = sr(i == null ? void 0 : i.ref, le.ref);
  return !P && !C && (!ne || z) ? null : /* @__PURE__ */ w.jsx(sp, {
    ref: V,
    container: f,
    disablePortal: E,
    children: /* @__PURE__ */ w.jsxs(ie, {
      ...ae,
      children: [!T && o ? /* @__PURE__ */ w.jsx(ce, {
        ...le,
        ref: we
      }) : null, /* @__PURE__ */ w.jsx(cp, {
        disableEnforceFocus: y,
        disableAutoFocus: v,
        disableRestoreFocus: I,
        isEnabled: $,
        open: C,
        children: /* @__PURE__ */ m.cloneElement(d, re)
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (ax.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: s.elementType,
  /**
   * Props applied to the [`Backdrop`](https://mui.com/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: s.object,
  /**
   * A single child content element.
   */
  children: Ic.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: s.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Backdrop: s.elementType,
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    backdrop: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: s.oneOfType([ba, s.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: s.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: s.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: s.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: s.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: s.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: s.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: s.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: s.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: s.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: s.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: s.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: s.shape({
    backdrop: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: s.shape({
    backdrop: s.elementType,
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function q9(e) {
  return gt("MuiDialog", e);
}
const qv = vt("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]), pM = /* @__PURE__ */ m.createContext({});
process.env.NODE_ENV !== "production" && (pM.displayName = "DialogContext");
const K9 = oe(ix, {
  name: "MuiDialog",
  slot: "Backdrop",
  overrides: (e, t) => t.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
}), Y9 = (e) => {
  const {
    classes: t,
    scroll: n,
    maxWidth: r,
    fullWidth: o,
    fullScreen: i
  } = e, a = {
    root: ["root"],
    container: ["container", `scroll${Me(n)}`],
    paper: ["paper", `paperScroll${Me(n)}`, `paperWidth${Me(String(r))}`, o && "paperFullWidth", i && "paperFullScreen"]
  };
  return Ct(a, q9, t);
}, Q9 = oe(ax, {
  name: "MuiDialog",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  "@media print": {
    // Use !important to override the Modal inline-style.
    position: "absolute !important"
  }
}), X9 = oe("div", {
  name: "MuiDialog",
  slot: "Container",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.container, t[`scroll${Me(n.scroll)}`]];
  }
})({
  height: "100%",
  "@media print": {
    height: "auto"
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  variants: [{
    props: {
      scroll: "paper"
    },
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, {
    props: {
      scroll: "body"
    },
    style: {
      overflowY: "auto",
      overflowX: "hidden",
      textAlign: "center",
      "&::after": {
        content: '""',
        display: "inline-block",
        verticalAlign: "middle",
        height: "100%",
        width: "0"
      }
    }
  }]
}), J9 = oe(cs, {
  name: "MuiDialog",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.paper, t[`scrollPaper${Me(n.scroll)}`], t[`paperWidth${Me(String(n.maxWidth))}`], n.fullWidth && t.paperFullWidth, n.fullScreen && t.paperFullScreen];
  }
})(ut(({
  theme: e
}) => ({
  margin: 32,
  position: "relative",
  overflowY: "auto",
  "@media print": {
    overflowY: "visible",
    boxShadow: "none"
  },
  variants: [{
    props: {
      scroll: "paper"
    },
    style: {
      display: "flex",
      flexDirection: "column",
      maxHeight: "calc(100% - 64px)"
    }
  }, {
    props: {
      scroll: "body"
    },
    style: {
      display: "inline-block",
      verticalAlign: "middle",
      textAlign: "initial"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.maxWidth,
    style: {
      maxWidth: "calc(100% - 64px)"
    }
  }, {
    props: {
      maxWidth: "xs"
    },
    style: {
      maxWidth: e.breakpoints.unit === "px" ? Math.max(e.breakpoints.values.xs, 444) : `max(${e.breakpoints.values.xs}${e.breakpoints.unit}, 444px)`,
      [`&.${qv.paperScrollBody}`]: {
        [e.breakpoints.down(Math.max(e.breakpoints.values.xs, 444) + 32 * 2)]: {
          maxWidth: "calc(100% - 64px)"
        }
      }
    }
  }, ...Object.keys(e.breakpoints.values).filter((t) => t !== "xs").map((t) => ({
    props: {
      maxWidth: t
    },
    style: {
      maxWidth: `${e.breakpoints.values[t]}${e.breakpoints.unit}`,
      [`&.${qv.paperScrollBody}`]: {
        [e.breakpoints.down(e.breakpoints.values[t] + 32 * 2)]: {
          maxWidth: "calc(100% - 64px)"
        }
      }
    }
  })), {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      width: "calc(100% - 64px)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullScreen,
    style: {
      margin: 0,
      width: "100%",
      maxWidth: "100%",
      height: "100%",
      maxHeight: "none",
      borderRadius: 0,
      [`&.${qv.paperScrollBody}`]: {
        margin: 0,
        maxWidth: "100%"
      }
    }
  }]
}))), hM = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiDialog"
  }), o = bo(), i = {
    enter: o.transitions.duration.enteringScreen,
    exit: o.transitions.duration.leavingScreen
  }, {
    "aria-describedby": a,
    "aria-labelledby": l,
    "aria-modal": c = !0,
    BackdropComponent: d,
    BackdropProps: f,
    children: p,
    className: g,
    disableEscapeKeyDown: b = !1,
    fullScreen: v = !1,
    fullWidth: y = !1,
    maxWidth: S = "sm",
    onBackdropClick: E,
    onClick: I,
    onClose: O,
    open: T,
    PaperComponent: P = cs,
    PaperProps: R = {},
    scroll: F = "paper",
    TransitionComponent: A = ox,
    transitionDuration: _ = i,
    TransitionProps: C,
    ...D
  } = r, L = {
    ...r,
    disableEscapeKeyDown: b,
    fullScreen: v,
    fullWidth: y,
    maxWidth: S,
    scroll: F
  }, B = Y9(L), H = m.useRef(), k = (V) => {
    H.current = V.target === V.currentTarget;
  }, N = (V) => {
    I && I(V), H.current && (H.current = null, E && E(V), O && O(V, "backdropClick"));
  }, j = wc(l), W = m.useMemo(() => ({
    titleId: j
  }), [j]);
  return /* @__PURE__ */ w.jsx(Q9, {
    className: ke(B.root, g),
    closeAfterTransition: !0,
    components: {
      Backdrop: K9
    },
    componentsProps: {
      backdrop: {
        transitionDuration: _,
        as: d,
        ...f
      }
    },
    disableEscapeKeyDown: b,
    onClose: O,
    open: T,
    ref: n,
    onClick: N,
    ownerState: L,
    ...D,
    children: /* @__PURE__ */ w.jsx(A, {
      appear: !0,
      in: T,
      timeout: _,
      role: "presentation",
      ...C,
      children: /* @__PURE__ */ w.jsx(X9, {
        className: ke(B.container),
        onMouseDown: k,
        ownerState: L,
        children: /* @__PURE__ */ w.jsx(J9, {
          as: P,
          elevation: 24,
          role: "dialog",
          "aria-describedby": a,
          "aria-labelledby": j,
          "aria-modal": c,
          ...R,
          className: ke(B.paper, R.className),
          ownerState: L,
          children: /* @__PURE__ */ w.jsx(pM.Provider, {
            value: W,
            children: p
          })
        })
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (hM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  "aria-describedby": s.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  "aria-labelledby": s.string,
  /**
   * Informs assistive technologies that the element is modal.
   * It's added on the element with role="dialog".
   * @default true
   */
  "aria-modal": s.oneOfType([s.oneOf(["false", "true"]), s.bool]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: s.elementType,
  /**
   * @ignore
   */
  BackdropProps: s.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: s.bool,
  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: s.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: s.oneOfType([s.oneOf(["xs", "sm", "md", "lg", "xl", !1]), s.string]),
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: s.func,
  /**
   * @ignore
   */
  onClick: s.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: s.elementType,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: s.object,
  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: s.oneOf(["body", "paper"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: s.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: s.oneOfType([s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: s.object
});
function Z9(e) {
  return gt("MuiDivider", e);
}
const NO = vt("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), e8 = (e) => {
  const {
    absolute: t,
    children: n,
    classes: r,
    flexItem: o,
    light: i,
    orientation: a,
    textAlign: l,
    variant: c
  } = e;
  return Ct({
    root: ["root", t && "absolute", c, i && "light", a === "vertical" && "vertical", o && "flexItem", n && "withChildren", n && a === "vertical" && "withChildrenVertical", l === "right" && a !== "vertical" && "textAlignRight", l === "left" && a !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", a === "vertical" && "wrapperVertical"]
  }, Z9, r);
}, t8 = oe("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.absolute && t.absolute, t[n.variant], n.light && t.light, n.orientation === "vertical" && t.vertical, n.flexItem && t.flexItem, n.children && t.withChildren, n.children && n.orientation === "vertical" && t.withChildrenVertical, n.textAlign === "right" && n.orientation !== "vertical" && t.textAlignRight, n.textAlign === "left" && n.orientation !== "vertical" && t.textAlignLeft];
  }
})(ut(({
  theme: e
}) => ({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (e.vars || e).palette.divider,
  borderBottomWidth: "thin",
  variants: [{
    props: {
      absolute: !0
    },
    style: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%"
    }
  }, {
    props: {
      light: !0
    },
    style: {
      borderColor: e.vars ? `rgba(${e.vars.palette.dividerChannel} / 0.08)` : Vt(e.palette.divider, 0.08)
    }
  }, {
    props: {
      variant: "inset"
    },
    style: {
      marginLeft: 72
    }
  }, {
    props: {
      variant: "middle",
      orientation: "horizontal"
    },
    style: {
      marginLeft: e.spacing(2),
      marginRight: e.spacing(2)
    }
  }, {
    props: {
      variant: "middle",
      orientation: "vertical"
    },
    style: {
      marginTop: e.spacing(1),
      marginBottom: e.spacing(1)
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      borderBottomWidth: 0,
      borderRightWidth: "thin"
    }
  }, {
    props: {
      flexItem: !0
    },
    style: {
      alignSelf: "stretch",
      height: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.children,
    style: {
      display: "flex",
      textAlign: "center",
      border: 0,
      borderTopStyle: "solid",
      borderLeftStyle: "solid",
      "&::before, &::after": {
        content: '""',
        alignSelf: "center"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.children && t.orientation !== "vertical",
    style: {
      "&::before, &::after": {
        width: "100%",
        borderTop: `thin solid ${(e.vars || e).palette.divider}`,
        borderTopStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.orientation === "vertical" && t.children,
    style: {
      flexDirection: "column",
      "&::before, &::after": {
        height: "100%",
        borderLeft: `thin solid ${(e.vars || e).palette.divider}`,
        borderLeftStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "right" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "90%"
      },
      "&::after": {
        width: "10%"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "left" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "10%"
      },
      "&::after": {
        width: "90%"
      }
    }
  }]
}))), n8 = oe("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.wrapper, n.orientation === "vertical" && t.wrapperVertical];
  }
})(ut(({
  theme: e
}) => ({
  display: "inline-block",
  paddingLeft: `calc(${e.spacing(1)} * 1.2)`,
  paddingRight: `calc(${e.spacing(1)} * 1.2)`,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      paddingTop: `calc(${e.spacing(1)} * 1.2)`,
      paddingBottom: `calc(${e.spacing(1)} * 1.2)`
    }
  }]
}))), up = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiDivider"
  }), {
    absolute: o = !1,
    children: i,
    className: a,
    orientation: l = "horizontal",
    component: c = i || l === "vertical" ? "div" : "hr",
    flexItem: d = !1,
    light: f = !1,
    role: p = c !== "hr" ? "separator" : void 0,
    textAlign: g = "center",
    variant: b = "fullWidth",
    ...v
  } = r, y = {
    ...r,
    absolute: o,
    component: c,
    flexItem: d,
    light: f,
    orientation: l,
    role: p,
    textAlign: g,
    variant: b
  }, S = e8(y);
  return /* @__PURE__ */ w.jsx(t8, {
    as: c,
    className: ke(S.root, a),
    role: p,
    ref: n,
    ownerState: y,
    "aria-orientation": p === "separator" && (c !== "hr" || l === "vertical") ? l : void 0,
    ...v,
    children: i ? /* @__PURE__ */ w.jsx(n8, {
      className: S.wrapper,
      ownerState: y,
      children: i
    }) : null
  });
});
up && (up.muiSkipListHighlight = !0);
process.env.NODE_ENV !== "production" && (up.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: s.bool,
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: s.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  light: s.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: s.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: s.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: s.oneOf(["center", "left", "right"]),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: s.oneOfType([s.oneOf(["fullWidth", "inset", "middle"]), s.string])
});
const r8 = (e) => {
  const {
    classes: t,
    disableUnderline: n,
    startAdornment: r,
    endAdornment: o,
    size: i,
    hiddenLabel: a,
    multiline: l
  } = e, c = {
    root: ["root", !n && "underline", r && "adornedStart", o && "adornedEnd", i === "small" && `size${Me(i)}`, a && "hiddenLabel", l && "multiline"],
    input: ["input"]
  }, d = Ct(c, w6, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...d
  };
}, o8 = oe(db, {
  shouldForwardProp: (e) => qo(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...cb(e, t), !n.disableUnderline && t.underline];
  }
})(ut(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", r = t ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", o = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", i = t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : o,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
      }
    },
    [`&.${ri.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
    },
    [`&.${ri.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : i
    },
    variants: [{
      props: ({
        ownerState: a
      }) => !a.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${ri.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${ri.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : n}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${ri.disabled}, .${ri.error}):before`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
        },
        [`&.${ri.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(Jn()).map(([a]) => {
      var l;
      return {
        props: {
          disableUnderline: !1,
          color: a
        },
        style: {
          "&::after": {
            borderBottom: `2px solid ${(l = (e.vars || e).palette[a]) == null ? void 0 : l.main}`
          }
        }
      };
    }), {
      props: ({
        ownerState: a
      }) => a.startAdornment,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        ownerState: a
      }) => a.endAdornment,
      style: {
        paddingRight: 12
      }
    }, {
      props: ({
        ownerState: a
      }) => a.multiline,
      style: {
        padding: "25px 12px 8px"
      }
    }, {
      props: ({
        ownerState: a,
        size: l
      }) => a.multiline && l === "small",
      style: {
        paddingTop: 21,
        paddingBottom: 4
      }
    }, {
      props: ({
        ownerState: a
      }) => a.multiline && a.hiddenLabel,
      style: {
        paddingTop: 16,
        paddingBottom: 17
      }
    }, {
      props: ({
        ownerState: a
      }) => a.multiline && a.hiddenLabel && a.size === "small",
      style: {
        paddingTop: 8,
        paddingBottom: 9
      }
    }]
  };
})), i8 = oe(fb, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: ub
})(ut(({
  theme: e
}) => ({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel,
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel && t.size === "small",
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    }
  }]
}))), gb = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiFilledInput"
  }), {
    disableUnderline: o = !1,
    components: i = {},
    componentsProps: a,
    fullWidth: l = !1,
    hiddenLabel: c,
    // declare here to prevent spreading to DOM
    inputComponent: d = "input",
    multiline: f = !1,
    slotProps: p,
    slots: g = {},
    type: b = "text",
    ...v
  } = r, y = {
    ...r,
    disableUnderline: o,
    fullWidth: l,
    inputComponent: d,
    multiline: f,
    type: b
  }, S = r8(r), E = {
    root: {
      ownerState: y
    },
    input: {
      ownerState: y
    }
  }, I = p ?? a ? Jr(E, p ?? a) : E, O = g.root ?? i.Root ?? o8, T = g.input ?? i.Input ?? i8;
  return /* @__PURE__ */ w.jsx(kc, {
    slots: {
      root: O,
      input: T
    },
    slotProps: I,
    fullWidth: l,
    inputComponent: d,
    multiline: f,
    ref: n,
    type: b,
    ...v,
    classes: S
  });
});
process.env.NODE_ENV !== "production" && (gb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: s.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary"]), s.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Input: s.elementType,
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: s.bool,
  /**
   * If `true`, the input will not have an underline.
   * @default false
   */
  disableUnderline: s.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: s.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: s.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: s.bool,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: s.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Wo,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: s.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: s.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: s.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: s.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: s.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: s.oneOfType([s.number, s.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: s.shape({
    input: s.elementType,
    root: s.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: s.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: s.any
});
gb.muiName = "Input";
function s8(e) {
  return gt("MuiFormControl", e);
}
vt("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const a8 = (e) => {
  const {
    classes: t,
    margin: n,
    fullWidth: r
  } = e, o = {
    root: ["root", n !== "none" && `margin${Me(n)}`, r && "fullWidth"]
  };
  return Ct(o, s8, t);
}, l8 = oe("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`margin${Me(n.margin)}`], n.fullWidth && t.fullWidth];
  }
})({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top",
  // Fix alignment issue on Safari.
  variants: [{
    props: {
      margin: "normal"
    },
    style: {
      marginTop: 16,
      marginBottom: 8
    }
  }, {
    props: {
      margin: "dense"
    },
    style: {
      marginTop: 8,
      marginBottom: 4
    }
  }, {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }]
}), lx = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiFormControl"
  }), {
    children: o,
    className: i,
    color: a = "primary",
    component: l = "div",
    disabled: c = !1,
    error: d = !1,
    focused: f,
    fullWidth: p = !1,
    hiddenLabel: g = !1,
    margin: b = "none",
    required: v = !1,
    size: y = "medium",
    variant: S = "outlined",
    ...E
  } = r, I = {
    ...r,
    color: a,
    component: l,
    disabled: c,
    error: d,
    fullWidth: p,
    hiddenLabel: g,
    margin: b,
    required: v,
    size: y,
    variant: S
  }, O = a8(I), [T, P] = m.useState(() => {
    let H = !1;
    return o && m.Children.forEach(o, (k) => {
      if (!pc(k, ["Input", "Select"]))
        return;
      const N = pc(k, ["Select"]) ? k.props.input : k;
      N && g6(N.props) && (H = !0);
    }), H;
  }), [R, F] = m.useState(() => {
    let H = !1;
    return o && m.Children.forEach(o, (k) => {
      pc(k, ["Input", "Select"]) && (lm(k.props, !0) || lm(k.props.inputProps, !0)) && (H = !0);
    }), H;
  }), [A, _] = m.useState(!1);
  c && A && _(!1);
  const C = f !== void 0 && !c ? f : A;
  let D;
  const L = m.useRef(!1);
  process.env.NODE_ENV !== "production" && (D = () => (L.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), L.current = !0, () => {
    L.current = !1;
  }));
  const B = m.useMemo(() => ({
    adornedStart: T,
    setAdornedStart: P,
    color: a,
    disabled: c,
    error: d,
    filled: R,
    focused: C,
    fullWidth: p,
    hiddenLabel: g,
    size: y,
    onBlur: () => {
      _(!1);
    },
    onEmpty: () => {
      F(!1);
    },
    onFilled: () => {
      F(!0);
    },
    onFocus: () => {
      _(!0);
    },
    registerEffect: D,
    required: v,
    variant: S
  }), [T, a, c, d, R, C, p, g, D, v, y, S]);
  return /* @__PURE__ */ w.jsx(Up.Provider, {
    value: B,
    children: /* @__PURE__ */ w.jsx(l8, {
      as: l,
      ownerState: I,
      className: ke(O.root, i),
      ref: n,
      ...E,
      children: o
    })
  });
});
process.env.NODE_ENV !== "production" && (lx.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: s.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: s.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: s.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: s.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: s.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: s.oneOf(["filled", "outlined", "standard"])
});
function c8(e) {
  return gt("MuiFormControlLabel", e);
}
const Rf = vt("MuiFormControlLabel", ["root", "labelPlacementStart", "labelPlacementTop", "labelPlacementBottom", "disabled", "label", "error", "required", "asterisk"]), u8 = (e) => {
  const {
    classes: t,
    disabled: n,
    labelPlacement: r,
    error: o,
    required: i
  } = e, a = {
    root: ["root", n && "disabled", `labelPlacement${Me(r)}`, o && "error", i && "required"],
    label: ["label", n && "disabled"],
    asterisk: ["asterisk", o && "error"]
  };
  return Ct(a, c8, t);
}, d8 = oe("label", {
  name: "MuiFormControlLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${Rf.label}`]: t.label
    }, t.root, t[`labelPlacement${Me(n.labelPlacement)}`]];
  }
})(ut(({
  theme: e
}) => ({
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  // For correct alignment with the text.
  verticalAlign: "middle",
  WebkitTapHighlightColor: "transparent",
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${Rf.disabled}`]: {
    cursor: "default"
  },
  [`& .${Rf.label}`]: {
    [`&.${Rf.disabled}`]: {
      color: (e.vars || e).palette.text.disabled
    }
  },
  variants: [{
    props: {
      labelPlacement: "start"
    },
    style: {
      flexDirection: "row-reverse",
      marginRight: -11
    }
  }, {
    props: {
      labelPlacement: "top"
    },
    style: {
      flexDirection: "column-reverse"
    }
  }, {
    props: {
      labelPlacement: "bottom"
    },
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      labelPlacement: t
    }) => t === "start" || t === "top" || t === "bottom",
    style: {
      marginLeft: 16
      // used for row presentation of radio/checkbox
    }
  }]
}))), f8 = oe("span", {
  name: "MuiFormControlLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(ut(({
  theme: e
}) => ({
  [`&.${Rf.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), dp = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiFormControlLabel"
  }), {
    checked: o,
    className: i,
    componentsProps: a = {},
    control: l,
    disabled: c,
    disableTypography: d,
    inputRef: f,
    label: p,
    labelPlacement: g = "end",
    name: b,
    onChange: v,
    required: y,
    slots: S = {},
    slotProps: E = {},
    value: I,
    ...O
  } = r, T = Sa(), P = c ?? l.props.disabled ?? (T == null ? void 0 : T.disabled), R = y ?? l.props.required, F = {
    disabled: P,
    required: R
  };
  ["checked", "name", "onChange", "value", "inputRef"].forEach((k) => {
    typeof l.props[k] > "u" && typeof r[k] < "u" && (F[k] = r[k]);
  });
  const A = _c({
    props: r,
    muiFormControl: T,
    states: ["error"]
  }), _ = {
    ...r,
    disabled: P,
    labelPlacement: g,
    required: R,
    error: A.error
  }, C = u8(_), D = {
    slots: S,
    slotProps: {
      ...a,
      ...E
    }
  }, [L, B] = gn("typography", {
    elementType: Rt,
    externalForwardedProps: D,
    ownerState: _
  });
  let H = p;
  return H != null && H.type !== Rt && !d && (H = /* @__PURE__ */ w.jsx(L, {
    component: "span",
    ...B,
    className: ke(C.label, B == null ? void 0 : B.className),
    children: H
  })), /* @__PURE__ */ w.jsxs(d8, {
    className: ke(C.root, i),
    ownerState: _,
    ref: n,
    ...O,
    children: [/* @__PURE__ */ m.cloneElement(l, F), R ? /* @__PURE__ */ w.jsxs("div", {
      children: [H, /* @__PURE__ */ w.jsxs(f8, {
        ownerState: _,
        "aria-hidden": !0,
        className: C.asterisk,
        children: [" ", "*"]
      })]
    }) : H]
  });
});
process.env.NODE_ENV !== "production" && (dp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component appears selected.
   */
  checked: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The props used for each slot inside.
   * @default {}
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: s.shape({
    typography: s.object
  }),
  /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: s.element.isRequired,
  /**
   * If `true`, the control is disabled.
   */
  disabled: s.bool,
  /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */
  disableTypography: s.bool,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Wo,
  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: s.node,
  /**
   * The position of the label.
   * @default 'end'
   */
  labelPlacement: s.oneOf(["bottom", "end", "start", "top"]),
  /**
   * @ignore
   */
  name: s.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: s.func,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: s.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    typography: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    typography: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The value of the component.
   */
  value: s.any
});
function p8(e) {
  return gt("MuiFormHelperText", e);
}
const FO = vt("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var $O;
const h8 = (e) => {
  const {
    classes: t,
    contained: n,
    size: r,
    disabled: o,
    error: i,
    filled: a,
    focused: l,
    required: c
  } = e, d = {
    root: ["root", o && "disabled", i && "error", r && `size${Me(r)}`, n && "contained", l && "focused", a && "filled", c && "required"]
  };
  return Ct(d, p8, t);
}, g8 = oe("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size && t[`size${Me(n.size)}`], n.contained && t.contained, n.filled && t.filled];
  }
})(ut(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.caption,
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${FO.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${FO.error}`]: {
    color: (e.vars || e).palette.error.main
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginTop: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => t.contained,
    style: {
      marginLeft: 14,
      marginRight: 14
    }
  }]
}))), cx = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiFormHelperText"
  }), {
    children: o,
    className: i,
    component: a = "p",
    disabled: l,
    error: c,
    filled: d,
    focused: f,
    margin: p,
    required: g,
    variant: b,
    ...v
  } = r, y = Sa(), S = _c({
    props: r,
    muiFormControl: y,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), E = {
    ...r,
    component: a,
    contained: S.variant === "filled" || S.variant === "outlined",
    variant: S.variant,
    size: S.size,
    disabled: S.disabled,
    error: S.error,
    filled: S.filled,
    focused: S.focused,
    required: S.required
  };
  delete E.ownerState;
  const I = h8(E);
  return /* @__PURE__ */ w.jsx(g8, {
    as: a,
    className: ke(I.root, i),
    ref: n,
    ...v,
    ownerState: E,
    children: o === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      $O || ($O = /* @__PURE__ */ w.jsx("span", {
        className: "notranslate",
        "aria-hidden": !0,
        children: "​"
      }))
    ) : o
  });
});
process.env.NODE_ENV !== "production" && (cx.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: s.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: s.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: s.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: s.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: s.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   */
  variant: s.oneOfType([s.oneOf(["filled", "outlined", "standard"]), s.string])
});
function m8(e) {
  return gt("MuiFormLabel", e);
}
const Hf = vt("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), b8 = (e) => {
  const {
    classes: t,
    color: n,
    focused: r,
    disabled: o,
    error: i,
    filled: a,
    required: l
  } = e, c = {
    root: ["root", `color${Me(n)}`, o && "disabled", i && "error", a && "filled", r && "focused", l && "required"],
    asterisk: ["asterisk", i && "error"]
  };
  return Ct(c, m8, t);
}, y8 = oe("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color === "secondary" && t.colorSecondary, n.filled && t.filled];
  }
})(ut(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.body1,
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  variants: [...Object.entries(e.palette).filter(Jn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${Hf.focused}`]: {
        color: (e.vars || e).palette[t].main
      }
    }
  })), {
    props: {},
    style: {
      [`&.${Hf.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      },
      [`&.${Hf.error}`]: {
        color: (e.vars || e).palette.error.main
      }
    }
  }]
}))), v8 = oe("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(ut(({
  theme: e
}) => ({
  [`&.${Hf.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), gM = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiFormLabel"
  }), {
    children: o,
    className: i,
    color: a,
    component: l = "label",
    disabled: c,
    error: d,
    filled: f,
    focused: p,
    required: g,
    ...b
  } = r, v = Sa(), y = _c({
    props: r,
    muiFormControl: v,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), S = {
    ...r,
    color: y.color || "primary",
    component: l,
    disabled: y.disabled,
    error: y.error,
    filled: y.filled,
    focused: y.focused,
    required: y.required
  }, E = b8(S);
  return /* @__PURE__ */ w.jsxs(y8, {
    as: l,
    ownerState: S,
    className: ke(E.root, i),
    ref: n,
    ...b,
    children: [o, y.required && /* @__PURE__ */ w.jsxs(v8, {
      ownerState: S,
      "aria-hidden": !0,
      className: E.asterisk,
      children: [" ", "*"]
    })]
  });
});
process.env.NODE_ENV !== "production" && (gM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: s.oneOfType([s.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: s.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: s.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: s.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: s.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const ux = BW({
  createStyledComponent: oe("div", {
    name: "MuiGrid2",
    slot: "Root",
    overridesResolver: (e, t) => {
      const {
        ownerState: n
      } = e;
      return [t.root, n.container && t.container];
    }
  }),
  componentName: "MuiGrid2",
  useThemeProps: (e) => St({
    props: e,
    name: "MuiGrid2"
  }),
  useTheme: bo
});
process.env.NODE_ENV !== "production" && (ux.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * The number of columns.
   * @default 12
   */
  columns: s.oneOfType([s.arrayOf(s.number), s.number, s.object]),
  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: s.oneOfType([s.arrayOf(s.oneOfType([s.number, s.string])), s.number, s.object, s.string]),
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  container: s.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */
  direction: s.oneOfType([s.oneOf(["column-reverse", "column", "row-reverse", "row"]), s.arrayOf(s.oneOf(["column-reverse", "column", "row-reverse", "row"])), s.object]),
  /**
   * Defines the offset value for the type `item` components.
   */
  offset: s.oneOfType([s.string, s.number, s.arrayOf(s.oneOfType([s.string, s.number])), s.object]),
  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: s.oneOfType([s.arrayOf(s.oneOfType([s.number, s.string])), s.number, s.object, s.string]),
  /**
   * Defines the size of the the type `item` components.
   */
  size: s.oneOfType([s.string, s.bool, s.number, s.arrayOf(s.oneOfType([s.string, s.bool, s.number])), s.object]),
  /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */
  spacing: s.oneOfType([s.arrayOf(s.oneOfType([s.number, s.string])), s.number, s.object, s.string]),
  /**
   * @ignore
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * @internal
   * The level of the grid starts from `0` and increases when the grid nests
   * inside another grid. Nesting is defined as a container Grid being a direct
   * child of a container Grid.
   *
   * ```js
   * <Grid container> // level 0
   *   <Grid container> // level 1
   *     <Grid container> // level 2
   * ```
   *
   * Only consecutive grid is considered nesting. A grid container will start at
   * `0` if there are non-Grid container element above it.
   *
   * ```js
   * <Grid container> // level 0
   *   <div>
   *     <Grid container> // level 0
   * ```
   *
   * ```js
   * <Grid container> // level 0
   *   <Grid>
   *     <Grid container> // level 0
   * ```
   */
  unstable_level: s.number,
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */
  wrap: s.oneOf(["nowrap", "wrap-reverse", "wrap"])
});
if (process.env.NODE_ENV !== "production") {
  const e = ux, t = tW("Grid2", e);
  e.propTypes = {
    // eslint-disable-next-line react/forbid-foreign-prop-types
    ...e.propTypes,
    direction: t("container"),
    spacing: t("container"),
    wrap: t("container")
  };
}
function a0(e) {
  return `scale(${e}, ${e ** 2})`;
}
const w8 = {
  entering: {
    opacity: 1,
    transform: a0(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, Kv = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), hd = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    addEndListener: r,
    appear: o = !0,
    children: i,
    easing: a,
    in: l,
    onEnter: c,
    onEntered: d,
    onEntering: f,
    onExit: p,
    onExited: g,
    onExiting: b,
    style: v,
    timeout: y = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: S = ls,
    ...E
  } = t, I = tc(), O = m.useRef(), T = bo(), P = m.useRef(null), R = sr(P, Rc(i), n), F = (k) => (N) => {
    if (k) {
      const j = P.current;
      N === void 0 ? k(j) : k(j, N);
    }
  }, A = F(f), _ = F((k, N) => {
    Hk(k);
    const {
      duration: j,
      delay: W,
      easing: V
    } = cd({
      style: v,
      timeout: y,
      easing: a
    }, {
      mode: "enter"
    });
    let $;
    y === "auto" ? ($ = T.transitions.getAutoHeightDuration(k.clientHeight), O.current = $) : $ = j, k.style.transition = [T.transitions.create("opacity", {
      duration: $,
      delay: W
    }), T.transitions.create("transform", {
      duration: Kv ? $ : $ * 0.666,
      delay: W,
      easing: V
    })].join(","), c && c(k, N);
  }), C = F(d), D = F(b), L = F((k) => {
    const {
      duration: N,
      delay: j,
      easing: W
    } = cd({
      style: v,
      timeout: y,
      easing: a
    }, {
      mode: "exit"
    });
    let V;
    y === "auto" ? (V = T.transitions.getAutoHeightDuration(k.clientHeight), O.current = V) : V = N, k.style.transition = [T.transitions.create("opacity", {
      duration: V,
      delay: j
    }), T.transitions.create("transform", {
      duration: Kv ? V : V * 0.666,
      delay: Kv ? j : j || V * 0.333,
      easing: W
    })].join(","), k.style.opacity = 0, k.style.transform = a0(0.75), p && p(k);
  }), B = F(g), H = (k) => {
    y === "auto" && I.start(O.current || 0, k), r && r(P.current, k);
  };
  return /* @__PURE__ */ w.jsx(S, {
    appear: o,
    in: l,
    nodeRef: P,
    onEnter: _,
    onEntered: C,
    onEntering: A,
    onExit: L,
    onExited: B,
    onExiting: D,
    addEndListener: H,
    timeout: y === "auto" ? null : y,
    ...E,
    children: (k, {
      ownerState: N,
      ...j
    }) => /* @__PURE__ */ m.cloneElement(i, {
      style: {
        opacity: 0,
        transform: a0(0.75),
        visibility: k === "exited" && !l ? "hidden" : void 0,
        ...w8[k],
        ...v,
        ...i.props.style
      },
      ref: R,
      ...j
    })
  });
});
process.env.NODE_ENV !== "production" && (hd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: s.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: s.bool,
  /**
   * A single child content element.
   */
  children: Ic.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: s.oneOfType([s.shape({
    enter: s.string,
    exit: s.string
  }), s.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: s.bool,
  /**
   * @ignore
   */
  onEnter: s.func,
  /**
   * @ignore
   */
  onEntered: s.func,
  /**
   * @ignore
   */
  onEntering: s.func,
  /**
   * @ignore
   */
  onExit: s.func,
  /**
   * @ignore
   */
  onExited: s.func,
  /**
   * @ignore
   */
  onExiting: s.func,
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: s.oneOfType([s.oneOf(["auto"]), s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })])
});
hd && (hd.muiSupportAuto = !0);
const dx = WG({
  themeId: Di
}), C8 = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, o = Ct({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, y6, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...o
  };
}, x8 = oe(db, {
  shouldForwardProp: (e) => qo(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...cb(e, t), !n.disableUnderline && t.underline];
  }
})(ut(({
  theme: e
}) => {
  let n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (n = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), {
    position: "relative",
    variants: [{
      props: ({
        ownerState: r
      }) => r.formControl,
      style: {
        "label + &": {
          marginTop: 16
        }
      }
    }, {
      props: ({
        ownerState: r
      }) => !r.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${Ya.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${Ya.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${n}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${Ya.disabled}, .${Ya.error}):before`]: {
          borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${n}`
          }
        },
        [`&.${Ya.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(Jn()).map(([r]) => ({
      props: {
        color: r,
        disableUnderline: !1
      },
      style: {
        "&::after": {
          borderBottom: `2px solid ${(e.vars || e).palette[r].main}`
        }
      }
    }))]
  };
})), S8 = oe(fb, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: ub
})({}), mb = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiInput"
  }), {
    disableUnderline: o = !1,
    components: i = {},
    componentsProps: a,
    fullWidth: l = !1,
    inputComponent: c = "input",
    multiline: d = !1,
    slotProps: f,
    slots: p = {},
    type: g = "text",
    ...b
  } = r, v = C8(r), S = {
    root: {
      ownerState: {
        disableUnderline: o
      }
    }
  }, E = f ?? a ? Jr(f ?? a, S) : S, I = p.root ?? i.Root ?? x8, O = p.input ?? i.Input ?? S8;
  return /* @__PURE__ */ w.jsx(kc, {
    slots: {
      root: I,
      input: O
    },
    slotProps: E,
    fullWidth: l,
    inputComponent: c,
    multiline: d,
    ref: n,
    type: g,
    ...b,
    classes: v
  });
});
process.env.NODE_ENV !== "production" && (mb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: s.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary"]), s.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Input: s.elementType,
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: s.bool,
  /**
   * If `true`, the `input` will not have an underline.
   * @default false
   */
  disableUnderline: s.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: s.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: s.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: s.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Wo,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: s.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: s.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: s.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: s.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: s.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: s.oneOfType([s.number, s.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: s.shape({
    input: s.elementType,
    root: s.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: s.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: s.any
});
mb.muiName = "Input";
function E8(e) {
  return gt("MuiInputAdornment", e);
}
const LO = vt("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var jO;
const T8 = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, t[`position${Me(n.position)}`], n.disablePointerEvents === !0 && t.disablePointerEvents, t[n.variant]];
}, O8 = (e) => {
  const {
    classes: t,
    disablePointerEvents: n,
    hiddenLabel: r,
    position: o,
    size: i,
    variant: a
  } = e, l = {
    root: ["root", n && "disablePointerEvents", o && `position${Me(o)}`, a, r && "hiddenLabel", i && `size${Me(i)}`]
  };
  return Ct(l, E8, t);
}, P8 = oe("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: T8
})(ut(({
  theme: e
}) => ({
  display: "flex",
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (e.vars || e).palette.action.active,
  variants: [{
    props: {
      variant: "filled"
    },
    style: {
      [`&.${LO.positionStart}&:not(.${LO.hiddenLabel})`]: {
        marginTop: 16
      }
    }
  }, {
    props: {
      position: "start"
    },
    style: {
      marginRight: 8
    }
  }, {
    props: {
      position: "end"
    },
    style: {
      marginLeft: 8
    }
  }, {
    props: {
      disablePointerEvents: !0
    },
    style: {
      pointerEvents: "none"
    }
  }]
}))), bl = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiInputAdornment"
  }), {
    children: o,
    className: i,
    component: a = "div",
    disablePointerEvents: l = !1,
    disableTypography: c = !1,
    position: d,
    variant: f,
    ...p
  } = r, g = Sa() || {};
  let b = f;
  f && g.variant && process.env.NODE_ENV !== "production" && f === g.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), g && !b && (b = g.variant);
  const v = {
    ...r,
    hiddenLabel: g.hiddenLabel,
    size: g.size,
    disablePointerEvents: l,
    position: d,
    variant: b
  }, y = O8(v);
  return /* @__PURE__ */ w.jsx(Up.Provider, {
    value: null,
    children: /* @__PURE__ */ w.jsx(P8, {
      as: a,
      ownerState: v,
      className: ke(y.root, i),
      ref: n,
      ...p,
      children: typeof o == "string" && !c ? /* @__PURE__ */ w.jsx(Rt, {
        color: "textSecondary",
        children: o
      }) : /* @__PURE__ */ w.jsxs(m.Fragment, {
        children: [d === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          jO || (jO = /* @__PURE__ */ w.jsx("span", {
            className: "notranslate",
            "aria-hidden": !0,
            children: "​"
          }))
        ) : null, o]
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (bl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: s.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: s.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: s.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: s.oneOf(["filled", "outlined", "standard"])
});
function I8(e) {
  return gt("MuiInputLabel", e);
}
vt("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
const R8 = (e) => {
  const {
    classes: t,
    formControl: n,
    size: r,
    shrink: o,
    disableAnimation: i,
    variant: a,
    required: l
  } = e, c = {
    root: ["root", n && "formControl", !i && "animated", o && "shrink", r && r !== "normal" && `size${Me(r)}`, a],
    asterisk: [l && "asterisk"]
  }, d = Ct(c, I8, t);
  return {
    ...t,
    // forward the focused, disabled, etc. classes to the FormLabel
    ...d
  };
}, _8 = oe(gM, {
  shouldForwardProp: (e) => qo(e) || e === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${Hf.asterisk}`]: t.asterisk
    }, t.root, n.formControl && t.formControl, n.size === "small" && t.sizeSmall, n.shrink && t.shrink, !n.disableAnimation && t.animated, n.focused && t.focused, t[n.variant]];
  }
})(ut(({
  theme: e
}) => ({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
  variants: [{
    props: ({
      ownerState: t
    }) => t.formControl,
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: "translate(0, 20px) scale(1)"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      // Compensation for the `Input.inputSizeSmall` style.
      transform: "translate(0, 17px) scale(1)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.shrink,
    style: {
      transform: "translate(0, -1.5px) scale(0.75)",
      transformOrigin: "top left",
      maxWidth: "133%"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableAnimation,
    style: {
      transition: e.transitions.create(["color", "transform", "max-width"], {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(12px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "filled",
      size: "small"
    },
    style: {
      transform: "translate(12px, 13px) scale(1)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: n
    }) => t === "filled" && n.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      transform: "translate(12px, 7px) scale(0.75)",
      maxWidth: "calc(133% - 24px)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: n,
      size: r
    }) => t === "filled" && n.shrink && r === "small",
    style: {
      transform: "translate(12px, 4px) scale(0.75)"
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(14px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "outlined",
      size: "small"
    },
    style: {
      transform: "translate(14px, 9px) scale(1)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: n
    }) => t === "outlined" && n.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      // Theoretically, we should have (8+5)*2/0.75 = 34px
      // but it feels a better when it bleeds a bit on the left, so 32px.
      maxWidth: "calc(133% - 32px)",
      transform: "translate(14px, -9px) scale(0.75)"
    }
  }]
}))), fx = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    name: "MuiInputLabel",
    props: t
  }), {
    disableAnimation: o = !1,
    margin: i,
    shrink: a,
    variant: l,
    className: c,
    ...d
  } = r, f = Sa();
  let p = a;
  typeof p > "u" && f && (p = f.filled || f.focused || f.adornedStart);
  const g = _c({
    props: r,
    muiFormControl: f,
    states: ["size", "variant", "required", "focused"]
  }), b = {
    ...r,
    disableAnimation: o,
    formControl: f,
    shrink: p,
    size: g.size,
    variant: g.variant,
    required: g.required,
    focused: g.focused
  }, v = R8(b);
  return /* @__PURE__ */ w.jsx(_8, {
    "data-shrink": p,
    ref: n,
    className: ke(v.root, c),
    ...d,
    ownerState: b,
    classes: v
  });
});
process.env.NODE_ENV !== "production" && (fx.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: s.oneOfType([s.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), s.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: s.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: s.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: s.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: s.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: s.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: s.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: s.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: s.oneOfType([s.oneOf(["normal", "small"]), s.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   */
  variant: s.oneOf(["filled", "outlined", "standard"])
});
function k8(e) {
  return gt("MuiLinearProgress", e);
}
vt("MuiLinearProgress", ["root", "colorPrimary", "colorSecondary", "determinate", "indeterminate", "buffer", "query", "dashed", "dashedColorPrimary", "dashedColorSecondary", "bar", "barColorPrimary", "barColorSecondary", "bar1Indeterminate", "bar1Determinate", "bar1Buffer", "bar2Indeterminate", "bar2Buffer"]);
const l0 = 4, c0 = Gs`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`, M8 = typeof c0 != "string" ? El`
        animation: ${c0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      ` : null, u0 = Gs`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`, A8 = typeof u0 != "string" ? El`
        animation: ${u0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
      ` : null, d0 = Gs`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`, D8 = typeof d0 != "string" ? El`
        animation: ${d0} 3s infinite linear;
      ` : null, N8 = (e) => {
  const {
    classes: t,
    variant: n,
    color: r
  } = e, o = {
    root: ["root", `color${Me(r)}`, n],
    dashed: ["dashed", `dashedColor${Me(r)}`],
    bar1: ["bar", `barColor${Me(r)}`, (n === "indeterminate" || n === "query") && "bar1Indeterminate", n === "determinate" && "bar1Determinate", n === "buffer" && "bar1Buffer"],
    bar2: ["bar", n !== "buffer" && `barColor${Me(r)}`, n === "buffer" && `color${Me(r)}`, (n === "indeterminate" || n === "query") && "bar2Indeterminate", n === "buffer" && "bar2Buffer"]
  };
  return Ct(o, k8, t);
}, px = (e, t) => e.vars ? e.vars.palette.LinearProgress[`${t}Bg`] : e.palette.mode === "light" ? ml(e.palette[t].main, 0.62) : gl(e.palette[t].main, 0.5), F8 = oe("span", {
  name: "MuiLinearProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`color${Me(n.color)}`], t[n.variant]];
  }
})(ut(({
  theme: e
}) => ({
  position: "relative",
  overflow: "hidden",
  display: "block",
  height: 4,
  // Fix Safari's bug during composition of different paint.
  zIndex: 0,
  "@media print": {
    colorAdjust: "exact"
  },
  variants: [...Object.entries(e.palette).filter(Jn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      backgroundColor: px(e, t)
    }
  })), {
    props: ({
      ownerState: t
    }) => t.color === "inherit" && t.variant !== "buffer",
    style: {
      "&::before": {
        content: '""',
        position: "absolute",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "currentColor",
        opacity: 0.3
      }
    }
  }, {
    props: {
      variant: "buffer"
    },
    style: {
      backgroundColor: "transparent"
    }
  }, {
    props: {
      variant: "query"
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}))), $8 = oe("span", {
  name: "MuiLinearProgress",
  slot: "Dashed",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.dashed, t[`dashedColor${Me(n.color)}`]];
  }
})(ut(({
  theme: e
}) => ({
  position: "absolute",
  marginTop: 0,
  height: "100%",
  width: "100%",
  backgroundSize: "10px 10px",
  backgroundPosition: "0 -23px",
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      opacity: 0.3,
      backgroundImage: "radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)"
    }
  }, ...Object.entries(e.palette).filter(Jn()).map(([t]) => {
    const n = px(e, t);
    return {
      props: {
        color: t
      },
      style: {
        backgroundImage: `radial-gradient(${n} 0%, ${n} 16%, transparent 42%)`
      }
    };
  })]
})), D8 || {
  // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
  animation: `${d0} 3s infinite linear`
}), L8 = oe("span", {
  name: "MuiLinearProgress",
  slot: "Bar1",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.bar, t[`barColor${Me(n.color)}`], (n.variant === "indeterminate" || n.variant === "query") && t.bar1Indeterminate, n.variant === "determinate" && t.bar1Determinate, n.variant === "buffer" && t.bar1Buffer];
  }
})(ut(({
  theme: e
}) => ({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left",
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      backgroundColor: "currentColor"
    }
  }, ...Object.entries(e.palette).filter(Jn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      backgroundColor: (e.vars || e).palette[t].main
    }
  })), {
    props: {
      variant: "determinate"
    },
    style: {
      transition: `transform .${l0}s linear`
    }
  }, {
    props: {
      variant: "buffer"
    },
    style: {
      zIndex: 1,
      transition: `transform .${l0}s linear`
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" || t.variant === "query",
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" || t.variant === "query",
    style: M8 || {
      animation: `${c0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`
    }
  }]
}))), j8 = oe("span", {
  name: "MuiLinearProgress",
  slot: "Bar2",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.bar, t[`barColor${Me(n.color)}`], (n.variant === "indeterminate" || n.variant === "query") && t.bar2Indeterminate, n.variant === "buffer" && t.bar2Buffer];
  }
})(ut(({
  theme: e
}) => ({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left",
  variants: [...Object.entries(e.palette).filter(Jn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--LinearProgressBar2-barColor": (e.vars || e).palette[t].main
    }
  })), {
    props: ({
      ownerState: t
    }) => t.variant !== "buffer" && t.color !== "inherit",
    style: {
      backgroundColor: "var(--LinearProgressBar2-barColor, currentColor)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant !== "buffer" && t.color === "inherit",
    style: {
      backgroundColor: "currentColor"
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      opacity: 0.3
    }
  }, ...Object.entries(e.palette).filter(Jn()).map(([t]) => ({
    props: {
      color: t,
      variant: "buffer"
    },
    style: {
      backgroundColor: px(e, t),
      transition: `transform .${l0}s linear`
    }
  })), {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" || t.variant === "query",
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" || t.variant === "query",
    style: A8 || {
      animation: `${u0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`
    }
  }]
}))), hx = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiLinearProgress"
  }), {
    className: o,
    color: i = "primary",
    value: a,
    valueBuffer: l,
    variant: c = "indeterminate",
    ...d
  } = r, f = {
    ...r,
    color: i,
    variant: c
  }, p = N8(f), g = mi(), b = {}, v = {
    bar1: {},
    bar2: {}
  };
  if (c === "determinate" || c === "buffer")
    if (a !== void 0) {
      b["aria-valuenow"] = Math.round(a), b["aria-valuemin"] = 0, b["aria-valuemax"] = 100;
      let y = a - 100;
      g && (y = -y), v.bar1.transform = `translateX(${y}%)`;
    } else process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a value prop when using the determinate or buffer variant of LinearProgress .");
  if (c === "buffer")
    if (l !== void 0) {
      let y = (l || 0) - 100;
      g && (y = -y), v.bar2.transform = `translateX(${y}%)`;
    } else process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a valueBuffer prop when using the buffer variant of LinearProgress.");
  return /* @__PURE__ */ w.jsxs(F8, {
    className: ke(p.root, o),
    ownerState: f,
    role: "progressbar",
    ...b,
    ref: n,
    ...d,
    children: [c === "buffer" ? /* @__PURE__ */ w.jsx($8, {
      className: p.dashed,
      ownerState: f
    }) : null, /* @__PURE__ */ w.jsx(L8, {
      className: p.bar1,
      ownerState: f,
      style: v.bar1
    }), c === "determinate" ? null : /* @__PURE__ */ w.jsx(j8, {
      className: p.bar2,
      ownerState: f,
      style: v.bar2
    })]
  });
});
process.env.NODE_ENV !== "production" && (hx.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["inherit", "primary", "secondary"]), s.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: s.number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: s.number,
  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */
  variant: s.oneOf(["buffer", "determinate", "indeterminate", "query"])
});
function B8(e) {
  return gt("MuiLink", e);
}
const V8 = vt("MuiLink", ["root", "underlineNone", "underlineHover", "underlineAlways", "button", "focusVisible"]), H8 = ({
  theme: e,
  ownerState: t
}) => {
  const n = t.color, r = id(e, `palette.${n}`, !1) || t.color, o = id(e, `palette.${n}Channel`);
  return "vars" in e && o ? `rgba(${o} / 0.4)` : Vt(r, 0.4);
}, BO = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, U8 = (e) => {
  const {
    classes: t,
    component: n,
    focusVisible: r,
    underline: o
  } = e, i = {
    root: ["root", `underline${Me(o)}`, n === "button" && "button", r && "focusVisible"]
  };
  return Ct(i, B8, t);
}, z8 = oe(Rt, {
  name: "MuiLink",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`underline${Me(n.underline)}`], n.component === "button" && t.button];
  }
})(ut(({
  theme: e
}) => ({
  variants: [{
    props: {
      underline: "none"
    },
    style: {
      textDecoration: "none"
    }
  }, {
    props: {
      underline: "hover"
    },
    style: {
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline"
      }
    }
  }, {
    props: {
      underline: "always"
    },
    style: {
      textDecoration: "underline",
      "&:hover": {
        textDecorationColor: "inherit"
      }
    }
  }, {
    props: ({
      underline: t,
      ownerState: n
    }) => t === "always" && n.color !== "inherit",
    style: {
      textDecorationColor: "var(--Link-underlineColor)"
    }
  }, ...Object.entries(e.palette).filter(Jn()).map(([t]) => ({
    props: {
      underline: "always",
      color: t
    },
    style: {
      "--Link-underlineColor": e.vars ? `rgba(${e.vars.palette[t].mainChannel} / 0.4)` : Vt(e.palette[t].main, 0.4)
    }
  })), {
    props: {
      underline: "always",
      color: "textPrimary"
    },
    style: {
      "--Link-underlineColor": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : Vt(e.palette.text.primary, 0.4)
    }
  }, {
    props: {
      underline: "always",
      color: "textSecondary"
    },
    style: {
      "--Link-underlineColor": e.vars ? `rgba(${e.vars.palette.text.secondaryChannel} / 0.4)` : Vt(e.palette.text.secondary, 0.4)
    }
  }, {
    props: {
      underline: "always",
      color: "textDisabled"
    },
    style: {
      "--Link-underlineColor": (e.vars || e).palette.text.disabled
    }
  }, {
    props: {
      component: "button"
    },
    style: {
      position: "relative",
      WebkitTapHighlightColor: "transparent",
      backgroundColor: "transparent",
      // Reset default value
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      border: 0,
      margin: 0,
      // Remove the margin in Safari
      borderRadius: 0,
      padding: 0,
      // Remove the padding in Firefox
      cursor: "pointer",
      userSelect: "none",
      verticalAlign: "middle",
      MozAppearance: "none",
      // Reset
      WebkitAppearance: "none",
      // Reset
      "&::-moz-focus-inner": {
        borderStyle: "none"
        // Remove Firefox dotted outline.
      },
      [`&.${V8.focusVisible}`]: {
        outline: "auto"
      }
    }
  }]
}))), mM = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiLink"
  }), o = bo(), {
    className: i,
    color: a = "primary",
    component: l = "a",
    onBlur: c,
    onFocus: d,
    TypographyClasses: f,
    underline: p = "always",
    variant: g = "inherit",
    sx: b,
    ...v
  } = r, [y, S] = m.useState(!1), E = (P) => {
    ad(P.target) || S(!1), c && c(P);
  }, I = (P) => {
    ad(P.target) && S(!0), d && d(P);
  }, O = {
    ...r,
    color: a,
    component: l,
    focusVisible: y,
    underline: p,
    variant: g
  }, T = U8(O);
  return /* @__PURE__ */ w.jsx(z8, {
    color: a,
    className: ke(T.root, i),
    classes: f,
    component: l,
    onBlur: E,
    onFocus: I,
    ref: n,
    ownerState: O,
    variant: g,
    ...v,
    sx: [...BO[a] === void 0 ? [{
      color: a
    }] : [], ...Array.isArray(b) ? b : [b]],
    style: {
      ...v.style,
      ...p === "always" && a !== "inherit" && !BO[a] && {
        "--Link-underlineColor": H8({
          theme: o,
          ownerState: O
        })
      }
    }
  });
});
process.env.NODE_ENV !== "production" && (mM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the link.
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Ed,
  /**
   * @ignore
   */
  onBlur: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * `classes` prop applied to the [`Typography`](https://mui.com/material-ui/api/typography/) element.
   */
  TypographyClasses: s.object,
  /**
   * Controls when the link should have an underline.
   * @default 'always'
   */
  underline: s.oneOf(["always", "hover", "none"]),
  /**
   * Applies the theme typography styles.
   * @default 'inherit'
   */
  variant: s.oneOfType([s.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), s.string])
});
const Fs = /* @__PURE__ */ m.createContext({});
process.env.NODE_ENV !== "production" && (Fs.displayName = "ListContext");
function G8(e) {
  return gt("MuiList", e);
}
vt("MuiList", ["root", "padding", "dense", "subheader"]);
const W8 = (e) => {
  const {
    classes: t,
    disablePadding: n,
    dense: r,
    subheader: o
  } = e;
  return Ct({
    root: ["root", !n && "padding", r && "dense", o && "subheader"]
  }, G8, t);
}, q8 = oe("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disablePadding && t.padding, n.dense && t.dense, n.subheader && t.subheader];
  }
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative",
  variants: [{
    props: ({
      ownerState: e
    }) => !e.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: e
    }) => e.subheader,
    style: {
      paddingTop: 0
    }
  }]
}), Wp = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiList"
  }), {
    children: o,
    className: i,
    component: a = "ul",
    dense: l = !1,
    disablePadding: c = !1,
    subheader: d,
    ...f
  } = r, p = m.useMemo(() => ({
    dense: l
  }), [l]), g = {
    ...r,
    component: a,
    dense: l,
    disablePadding: c
  }, b = W8(g);
  return /* @__PURE__ */ w.jsx(Fs.Provider, {
    value: p,
    children: /* @__PURE__ */ w.jsxs(q8, {
      as: a,
      className: ke(b.root, i),
      ref: n,
      ownerState: g,
      ...f,
      children: [d, o]
    })
  });
});
process.env.NODE_ENV !== "production" && (Wp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: s.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: s.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function K8(e) {
  return gt("MuiListItem", e);
}
vt("MuiListItem", ["root", "container", "dense", "alignItemsFlexStart", "divider", "gutters", "padding", "secondaryAction"]);
const Y8 = vt("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]);
function Q8(e) {
  return gt("MuiListItemSecondaryAction", e);
}
vt("MuiListItemSecondaryAction", ["root", "disableGutters"]);
const X8 = (e) => {
  const {
    disableGutters: t,
    classes: n
  } = e;
  return Ct({
    root: ["root", t && "disableGutters"]
  }, Q8, n);
}, J8 = oe("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.disableGutters && t.disableGutters];
  }
})({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)",
  variants: [{
    props: ({
      ownerState: e
    }) => e.disableGutters,
    style: {
      right: 0
    }
  }]
}), gx = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiListItemSecondaryAction"
  }), {
    className: o,
    ...i
  } = r, a = m.useContext(Fs), l = {
    ...r,
    disableGutters: a.disableGutters
  }, c = X8(l);
  return /* @__PURE__ */ w.jsx(J8, {
    className: ke(c.root, o),
    ownerState: l,
    ref: n,
    ...i
  });
});
process.env.NODE_ENV !== "production" && (gx.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
gx.muiName = "ListItemSecondaryAction";
const Z8 = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.alignItems === "flex-start" && t.alignItemsFlexStart, n.divider && t.divider, !n.disableGutters && t.gutters, !n.disablePadding && t.padding, n.hasSecondaryAction && t.secondaryAction];
}, eK = (e) => {
  const {
    alignItems: t,
    classes: n,
    dense: r,
    disableGutters: o,
    disablePadding: i,
    divider: a,
    hasSecondaryAction: l
  } = e;
  return Ct({
    root: ["root", r && "dense", !o && "gutters", !i && "padding", a && "divider", t === "flex-start" && "alignItemsFlexStart", l && "secondaryAction"],
    container: ["container"]
  }, K8, n);
}, tK = oe("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver: Z8
})(ut(({
  theme: e
}) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && t.dense,
    style: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !!t.secondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.secondaryAction,
    style: {
      [`& > .${Y8.root}`]: {
        paddingRight: 48
      }
    }
  }, {
    props: {
      alignItems: "flex-start"
    },
    style: {
      alignItems: "flex-start"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.button,
    style: {
      transition: e.transitions.create("background-color", {
        duration: e.transitions.duration.shortest
      }),
      "&:hover": {
        textDecoration: "none",
        backgroundColor: (e.vars || e).palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hasSecondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }]
}))), nK = oe("li", {
  name: "MuiListItem",
  slot: "Container",
  overridesResolver: (e, t) => t.container
})({
  position: "relative"
}), bb = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiListItem"
  }), {
    alignItems: o = "center",
    children: i,
    className: a,
    component: l,
    components: c = {},
    componentsProps: d = {},
    ContainerComponent: f = "li",
    ContainerProps: {
      className: p,
      ...g
    } = {},
    dense: b = !1,
    disableGutters: v = !1,
    disablePadding: y = !1,
    divider: S = !1,
    secondaryAction: E,
    slotProps: I = {},
    slots: O = {},
    ...T
  } = r, P = m.useContext(Fs), R = m.useMemo(() => ({
    dense: b || P.dense || !1,
    alignItems: o,
    disableGutters: v
  }), [o, P.dense, b, v]), F = m.useRef(null), A = m.Children.toArray(i), _ = A.length && pc(A[A.length - 1], ["ListItemSecondaryAction"]), C = {
    ...r,
    alignItems: o,
    dense: R.dense,
    disableGutters: v,
    disablePadding: y,
    divider: S,
    hasSecondaryAction: _
  }, D = eK(C), L = sr(F, n), B = O.root || c.Root || tK, H = I.root || d.root || {}, k = {
    className: ke(D.root, H.className, a),
    ...T
  };
  let N = l || "li";
  return _ ? (N = !k.component && !l ? "div" : N, f === "li" && (N === "li" ? N = "div" : k.component === "li" && (k.component = "div")), /* @__PURE__ */ w.jsx(Fs.Provider, {
    value: R,
    children: /* @__PURE__ */ w.jsxs(nK, {
      as: f,
      className: ke(D.container, p),
      ref: L,
      ownerState: C,
      ...g,
      children: [/* @__PURE__ */ w.jsx(B, {
        ...H,
        ...!ap(B) && {
          as: N,
          ownerState: {
            ...C,
            ...H.ownerState
          }
        },
        ...k,
        children: A
      }), A.pop()]
    })
  })) : /* @__PURE__ */ w.jsx(Fs.Provider, {
    value: R,
    children: /* @__PURE__ */ w.jsxs(B, {
      ...H,
      as: N,
      ref: L,
      ...!ap(B) && {
        ownerState: {
          ...C,
          ...H.ownerState
        }
      },
      ...k,
      children: [A, E && /* @__PURE__ */ w.jsx(gx, {
        children: E
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (bb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: s.oneOf(["center", "flex-start"]),
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: Go(s.node, (e) => {
    const t = m.Children.toArray(e.children);
    let n = -1;
    for (let r = t.length - 1; r >= 0; r -= 1) {
      const o = t[r];
      if (pc(o, ["ListItemSecondaryAction"])) {
        n = r;
        break;
      }
    }
    return n !== -1 && n !== t.length - 1 ? new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.") : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  components: s.shape({
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  componentsProps: s.shape({
    root: s.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated Use the `component` or `slots.root` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerComponent: Ed,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated Use the `slotProps.root` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerProps: s.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: s.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: s.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: s.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: s.bool,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: s.node,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: s.shape({
    root: s.object
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: s.shape({
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function rK(e) {
  return gt("MuiListItemIcon", e);
}
const VO = vt("MuiListItemIcon", ["root", "alignItemsFlexStart"]), oK = (e) => {
  const {
    alignItems: t,
    classes: n
  } = e;
  return Ct({
    root: ["root", t === "flex-start" && "alignItemsFlexStart"]
  }, rK, n);
}, iK = oe("div", {
  name: "MuiListItemIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.alignItems === "flex-start" && t.alignItemsFlexStart];
  }
})(ut(({
  theme: e
}) => ({
  minWidth: 56,
  color: (e.vars || e).palette.action.active,
  flexShrink: 0,
  display: "inline-flex",
  variants: [{
    props: {
      alignItems: "flex-start"
    },
    style: {
      marginTop: 8
    }
  }]
}))), gc = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiListItemIcon"
  }), {
    className: o,
    ...i
  } = r, a = m.useContext(Fs), l = {
    ...r,
    alignItems: a.alignItems
  }, c = oK(l);
  return /* @__PURE__ */ w.jsx(iK, {
    className: ke(c.root, o),
    ownerState: l,
    ref: n,
    ...i
  });
});
process.env.NODE_ENV !== "production" && (gc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@mui/icons-material` SVG icon element.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function sK(e) {
  return gt("MuiListItemText", e);
}
const _u = vt("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), aK = (e) => {
  const {
    classes: t,
    inset: n,
    primary: r,
    secondary: o,
    dense: i
  } = e;
  return Ct({
    root: ["root", n && "inset", i && "dense", r && o && "multiline"],
    primary: ["primary"],
    secondary: ["secondary"]
  }, sK, t);
}, lK = oe("div", {
  name: "MuiListItemText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${_u.primary}`]: t.primary
    }, {
      [`& .${_u.secondary}`]: t.secondary
    }, t.root, n.inset && t.inset, n.primary && n.secondary && t.multiline, n.dense && t.dense];
  }
})({
  flex: "1 1 auto",
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4,
  [`.${om.root}:where(& .${_u.primary})`]: {
    display: "block"
  },
  [`.${om.root}:where(& .${_u.secondary})`]: {
    display: "block"
  },
  variants: [{
    props: ({
      ownerState: e
    }) => e.primary && e.secondary,
    style: {
      marginTop: 6,
      marginBottom: 6
    }
  }, {
    props: ({
      ownerState: e
    }) => e.inset,
    style: {
      paddingLeft: 56
    }
  }]
}), mc = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiListItemText"
  }), {
    children: o,
    className: i,
    disableTypography: a = !1,
    inset: l = !1,
    primary: c,
    primaryTypographyProps: d,
    secondary: f,
    secondaryTypographyProps: p,
    slots: g = {},
    slotProps: b = {},
    ...v
  } = r, {
    dense: y
  } = m.useContext(Fs);
  let S = c ?? o, E = f;
  const I = {
    ...r,
    disableTypography: a,
    inset: l,
    primary: !!S,
    secondary: !!E,
    dense: y
  }, O = aK(I), T = {
    slots: g,
    slotProps: {
      primary: d,
      secondary: p,
      ...b
    }
  }, [P, R] = gn("primary", {
    className: O.primary,
    elementType: Rt,
    externalForwardedProps: T,
    ownerState: I
  }), [F, A] = gn("secondary", {
    className: O.secondary,
    elementType: Rt,
    externalForwardedProps: T,
    ownerState: I
  });
  return S != null && S.type !== Rt && !a && (S = /* @__PURE__ */ w.jsx(P, {
    variant: y ? "body2" : "body1",
    component: R != null && R.variant ? void 0 : "span",
    ...R,
    children: S
  })), E != null && E.type !== Rt && !a && (E = /* @__PURE__ */ w.jsx(F, {
    variant: "body2",
    color: "textSecondary",
    ...A,
    children: E
  })), /* @__PURE__ */ w.jsxs(lK, {
    className: ke(O.root, i),
    ownerState: I,
    ref: n,
    ...v,
    children: [S, E]
  });
});
process.env.NODE_ENV !== "production" && (mc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Alias for the `primary` prop.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */
  disableTypography: s.bool,
  /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */
  inset: s.bool,
  /**
   * The main content element.
   */
  primary: s.node,
  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.primary` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  primaryTypographyProps: s.object,
  /**
   * The secondary content element.
   */
  secondary: s.node,
  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.secondary` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  secondaryTypographyProps: s.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    primary: s.oneOfType([s.func, s.object]),
    secondary: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    primary: s.elementType,
    secondary: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function Yv(e, t, n) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild;
}
function HO(e, t, n) {
  return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild;
}
function bM(e, t) {
  if (t === void 0)
    return !0;
  let n = e.innerText;
  return n === void 0 && (n = e.textContent), n = n.trim().toLowerCase(), n.length === 0 ? !1 : t.repeating ? n[0] === t.keys[0] : n.startsWith(t.keys.join(""));
}
function lf(e, t, n, r, o, i) {
  let a = !1, l = o(e, t, t ? n : !1);
  for (; l; ) {
    if (l === e.firstChild) {
      if (a)
        return !1;
      a = !0;
    }
    const c = r ? !1 : l.disabled || l.getAttribute("aria-disabled") === "true";
    if (!l.hasAttribute("tabindex") || !bM(l, i) || c)
      l = o(e, l, n);
    else
      return l.focus(), !0;
  }
  return !1;
}
const qp = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: r,
    autoFocus: o = !1,
    autoFocusItem: i = !1,
    children: a,
    className: l,
    disabledItemsFocusable: c = !1,
    disableListWrap: d = !1,
    onKeyDown: f,
    variant: p = "selectedMenu",
    ...g
  } = t, b = m.useRef(null), v = m.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  ss(() => {
    o && b.current.focus();
  }, [o]), m.useImperativeHandle(r, () => ({
    adjustStyleForScrollbar: (O, {
      direction: T
    }) => {
      const P = !b.current.style.width;
      if (O.clientHeight < b.current.clientHeight && P) {
        const R = `${vk(ya(O))}px`;
        b.current.style[T === "rtl" ? "paddingLeft" : "paddingRight"] = R, b.current.style.width = `calc(100% + ${R})`;
      }
      return b.current;
    }
  }), []);
  const y = (O) => {
    const T = b.current, P = O.key;
    if (O.ctrlKey || O.metaKey || O.altKey) {
      f && f(O);
      return;
    }
    const F = go(T).activeElement;
    if (P === "ArrowDown")
      O.preventDefault(), lf(T, F, d, c, Yv);
    else if (P === "ArrowUp")
      O.preventDefault(), lf(T, F, d, c, HO);
    else if (P === "Home")
      O.preventDefault(), lf(T, null, d, c, Yv);
    else if (P === "End")
      O.preventDefault(), lf(T, null, d, c, HO);
    else if (P.length === 1) {
      const A = v.current, _ = P.toLowerCase(), C = performance.now();
      A.keys.length > 0 && (C - A.lastTime > 500 ? (A.keys = [], A.repeating = !0, A.previousKeyMatched = !0) : A.repeating && _ !== A.keys[0] && (A.repeating = !1)), A.lastTime = C, A.keys.push(_);
      const D = F && !A.repeating && bM(F, A);
      A.previousKeyMatched && (D || lf(T, F, !1, c, Yv, A)) ? O.preventDefault() : A.previousKeyMatched = !1;
    }
    f && f(O);
  }, S = sr(b, n);
  let E = -1;
  m.Children.forEach(a, (O, T) => {
    if (!/* @__PURE__ */ m.isValidElement(O)) {
      E === T && (E += 1, E >= a.length && (E = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && sd.isFragment(O) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), O.props.disabled || (p === "selectedMenu" && O.props.selected || E === -1) && (E = T), E === T && (O.props.disabled || O.props.muiSkipListHighlight || O.type.muiSkipListHighlight) && (E += 1, E >= a.length && (E = -1));
  });
  const I = m.Children.map(a, (O, T) => {
    if (T === E) {
      const P = {};
      return i && (P.autoFocus = !0), O.props.tabIndex === void 0 && p === "selectedMenu" && (P.tabIndex = 0), /* @__PURE__ */ m.cloneElement(O, P);
    }
    return O;
  });
  return /* @__PURE__ */ w.jsx(Wp, {
    role: "menu",
    ref: S,
    className: l,
    onKeyDown: y,
    tabIndex: o ? 0 : -1,
    ...g,
    children: I
  });
});
process.env.NODE_ENV !== "production" && (qp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: s.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: s.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: s.node,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: s.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: s.bool,
  /**
   * @ignore
   */
  onKeyDown: s.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: s.oneOf(["menu", "selectedMenu"])
});
function cK(e) {
  return gt("MuiPopover", e);
}
vt("MuiPopover", ["root", "paper"]);
function UO(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.height / 2 : t === "bottom" && (n = e.height), n;
}
function zO(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.width / 2 : t === "right" && (n = e.width), n;
}
function GO(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function jg(e) {
  return typeof e == "function" ? e() : e;
}
const uK = (e) => {
  const {
    classes: t
  } = e;
  return Ct({
    root: ["root"],
    paper: ["paper"]
  }, cK, t);
}, dK = oe(ax, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), yM = oe(cs, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), vM = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiPopover"
  }), {
    action: o,
    anchorEl: i,
    anchorOrigin: a = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: l,
    anchorReference: c = "anchorEl",
    children: d,
    className: f,
    container: p,
    elevation: g = 8,
    marginThreshold: b = 16,
    open: v,
    PaperProps: y = {},
    slots: S = {},
    slotProps: E = {},
    transformOrigin: I = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: O = hd,
    transitionDuration: T = "auto",
    TransitionProps: {
      onEntering: P,
      ...R
    } = {},
    disableScrollLock: F = !1,
    ...A
  } = r, _ = (E == null ? void 0 : E.paper) ?? y, C = m.useRef(), D = {
    ...r,
    anchorOrigin: a,
    anchorReference: c,
    elevation: g,
    marginThreshold: b,
    externalPaperSlotProps: _,
    transformOrigin: I,
    TransitionComponent: O,
    transitionDuration: T,
    TransitionProps: R
  }, L = uK(D), B = m.useCallback(() => {
    if (c === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (l || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), l;
    const le = jg(i), we = le && le.nodeType === 1 ? le : go(C.current).body, q = we.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const Ee = we.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && Ee.top === 0 && Ee.left === 0 && Ee.right === 0 && Ee.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: q.top + UO(q, a.vertical),
      left: q.left + zO(q, a.horizontal)
    };
  }, [i, a.horizontal, a.vertical, l, c]), H = m.useCallback((le) => ({
    vertical: UO(le, I.vertical),
    horizontal: zO(le, I.horizontal)
  }), [I.horizontal, I.vertical]), k = m.useCallback((le) => {
    const we = {
      width: le.offsetWidth,
      height: le.offsetHeight
    }, q = H(we);
    if (c === "none")
      return {
        top: null,
        left: null,
        transformOrigin: GO(q)
      };
    const Ee = B();
    let _e = Ee.top - q.vertical, $e = Ee.left - q.horizontal;
    const Le = _e + we.height, Ze = $e + we.width, J = ya(jg(i)), fe = J.innerHeight - b, me = J.innerWidth - b;
    if (b !== null && _e < b) {
      const Oe = _e - b;
      _e -= Oe, q.vertical += Oe;
    } else if (b !== null && Le > fe) {
      const Oe = Le - fe;
      _e -= Oe, q.vertical += Oe;
    }
    if (process.env.NODE_ENV !== "production" && we.height > fe && we.height && fe && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${we.height - fe}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), b !== null && $e < b) {
      const Oe = $e - b;
      $e -= Oe, q.horizontal += Oe;
    } else if (Ze > me) {
      const Oe = Ze - me;
      $e -= Oe, q.horizontal += Oe;
    }
    return {
      top: `${Math.round(_e)}px`,
      left: `${Math.round($e)}px`,
      transformOrigin: GO(q)
    };
  }, [i, c, B, H, b]), [N, j] = m.useState(v), W = m.useCallback(() => {
    const le = C.current;
    if (!le)
      return;
    const we = k(le);
    we.top !== null && le.style.setProperty("top", we.top), we.left !== null && (le.style.left = we.left), le.style.transformOrigin = we.transformOrigin, j(!0);
  }, [k]);
  m.useEffect(() => (F && window.addEventListener("scroll", W), () => window.removeEventListener("scroll", W)), [i, F, W]);
  const V = (le, we) => {
    P && P(le, we), W();
  }, $ = () => {
    j(!1);
  };
  m.useEffect(() => {
    v && W();
  }), m.useImperativeHandle(o, () => v ? {
    updatePosition: () => {
      W();
    }
  } : null, [v, W]), m.useEffect(() => {
    if (!v)
      return;
    const le = gk(() => {
      W();
    }), we = ya(i);
    return we.addEventListener("resize", le), () => {
      le.clear(), we.removeEventListener("resize", le);
    };
  }, [i, v, W]);
  let z = T;
  T === "auto" && !O.muiSupportAuto && (z = void 0);
  const ne = p || (i ? go(jg(i)).body : void 0), K = {
    slots: S,
    slotProps: {
      ...E,
      paper: _
    }
  }, [Q, re] = gn("paper", {
    elementType: yM,
    externalForwardedProps: K,
    additionalProps: {
      elevation: g,
      className: ke(L.paper, _ == null ? void 0 : _.className),
      style: N ? _.style : {
        ..._.style,
        opacity: 0
      }
    },
    ownerState: D
  }), [te, {
    slotProps: ie,
    ...ae
  }] = gn("root", {
    elementType: dK,
    externalForwardedProps: K,
    additionalProps: {
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: ne,
      open: v
    },
    ownerState: D,
    className: ke(L.root, f)
  }), ce = sr(C, re.ref);
  return /* @__PURE__ */ w.jsx(te, {
    ...ae,
    ...!ap(te) && {
      slotProps: ie,
      disableScrollLock: F
    },
    ...A,
    ref: n,
    children: /* @__PURE__ */ w.jsx(O, {
      appear: !0,
      in: v,
      onEntering: V,
      onExited: $,
      timeout: z,
      ...R,
      children: /* @__PURE__ */ w.jsx(Q, {
        ...re,
        ref: ce,
        children: d
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (vM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: Wo,
  /**
   * An HTML element, [PopoverVirtualElement](https://mui.com/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: Go(s.oneOfType([ba, s.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = jg(e.anchorEl);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: s.shape({
    horizontal: s.oneOfType([s.oneOf(["center", "left", "right"]), s.number]).isRequired,
    vertical: s.oneOfType([s.oneOf(["bottom", "center", "top"]), s.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: s.shape({
    left: s.number.isRequired,
    top: s.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: s.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slotProps.root.slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slotProps.root.slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: s.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.root.slotProps.backdrop` instead.
   */
  BackdropProps: s.object,
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: s.oneOfType([ba, s.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: s.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: dl,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: s.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: s.shape({
    component: Ed
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    paper: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    paper: s.elementType,
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: s.shape({
    horizontal: s.oneOfType([s.oneOf(["center", "left", "right"]), s.number]).isRequired,
    vertical: s.oneOfType([s.oneOf(["bottom", "center", "top"]), s.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: s.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: s.oneOfType([s.oneOf(["auto"]), s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: s.object
});
function fK(e) {
  return gt("MuiMenu", e);
}
vt("MuiMenu", ["root", "paper", "list"]);
const pK = {
  vertical: "top",
  horizontal: "right"
}, hK = {
  vertical: "top",
  horizontal: "left"
}, gK = (e) => {
  const {
    classes: t
  } = e;
  return Ct({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, fK, t);
}, mK = oe(vM, {
  shouldForwardProp: (e) => qo(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), bK = oe(yM, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), yK = oe(qp, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), wM = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: o = !0,
    children: i,
    className: a,
    disableAutoFocusItem: l = !1,
    MenuListProps: c = {},
    onClose: d,
    open: f,
    PaperProps: p = {},
    PopoverClasses: g,
    transitionDuration: b = "auto",
    TransitionProps: {
      onEntering: v,
      ...y
    } = {},
    variant: S = "selectedMenu",
    slots: E = {},
    slotProps: I = {},
    ...O
  } = r, T = mi(), P = {
    ...r,
    autoFocus: o,
    disableAutoFocusItem: l,
    MenuListProps: c,
    onEntering: v,
    PaperProps: p,
    transitionDuration: b,
    TransitionProps: y,
    variant: S
  }, R = gK(P), F = o && !l && f, A = m.useRef(null), _ = (N, j) => {
    A.current && A.current.adjustStyleForScrollbar(N, {
      direction: T ? "rtl" : "ltr"
    }), v && v(N, j);
  }, C = (N) => {
    N.key === "Tab" && (N.preventDefault(), d && d(N, "tabKeyDown"));
  };
  let D = -1;
  m.Children.map(i, (N, j) => {
    /* @__PURE__ */ m.isValidElement(N) && (process.env.NODE_ENV !== "production" && sd.isFragment(N) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), N.props.disabled || (S === "selectedMenu" && N.props.selected || D === -1) && (D = j));
  });
  const L = E.paper ?? bK, B = I.paper ?? p, H = tp({
    elementType: E.root,
    externalSlotProps: I.root,
    ownerState: P,
    className: [R.root, a]
  }), k = tp({
    elementType: L,
    externalSlotProps: B,
    ownerState: P,
    className: R.paper
  });
  return /* @__PURE__ */ w.jsx(mK, {
    onClose: d,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: T ? "right" : "left"
    },
    transformOrigin: T ? pK : hK,
    slots: {
      paper: L,
      root: E.root
    },
    slotProps: {
      root: H,
      paper: k
    },
    open: f,
    ref: n,
    transitionDuration: b,
    TransitionProps: {
      onEntering: _,
      ...y
    },
    ownerState: P,
    ...O,
    classes: g,
    children: /* @__PURE__ */ w.jsx(yK, {
      onKeyDown: C,
      actions: A,
      autoFocus: o && (D === -1 || l),
      autoFocusItem: F,
      variant: S,
      ...c,
      className: ke(R.list, c.className),
      children: i
    })
  });
});
process.env.NODE_ENV !== "production" && (wM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: s.oneOfType([ba, s.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: s.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: s.bool,
  /**
   * Props applied to the [`MenuList`](https://mui.com/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: s.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: s.object,
  /**
   * `classes` prop applied to the [`Popover`](https://mui.com/material-ui/api/popover/) element.
   */
  PopoverClasses: s.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    paper: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    paper: s.elementType,
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: s.oneOfType([s.oneOf(["auto"]), s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: s.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: s.oneOf(["menu", "selectedMenu"])
});
function vK(e) {
  return gt("MuiMenuItem", e);
}
const cf = vt("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), wK = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.divider && t.divider, !n.disableGutters && t.gutters];
}, CK = (e) => {
  const {
    disabled: t,
    dense: n,
    divider: r,
    disableGutters: o,
    selected: i,
    classes: a
  } = e, c = Ct({
    root: ["root", n && "dense", t && "disabled", !o && "gutters", r && "divider", i && "selected"]
  }, vK, a);
  return {
    ...a,
    ...c
  };
}, xK = oe(va, {
  shouldForwardProp: (e) => qo(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: wK
})(ut(({
  theme: e
}) => ({
  ...e.typography.body1,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap",
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${cf.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Vt(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${cf.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Vt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${cf.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Vt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Vt(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${cf.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${cf.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${NO.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${NO.inset}`]: {
    marginLeft: 52
  },
  [`& .${_u.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${_u.inset}`]: {
    paddingLeft: 36
  },
  [`& .${VO.root}`]: {
    minWidth: 36
  },
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.dense,
    style: {
      [e.breakpoints.up("sm")]: {
        minHeight: "auto"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.dense,
    style: {
      minHeight: 32,
      // https://m2.material.io/components/menus#specs > Dense
      paddingTop: 4,
      paddingBottom: 4,
      ...e.typography.body2,
      [`& .${VO.root} svg`]: {
        fontSize: "1.25rem"
      }
    }
  }]
}))), ts = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: o = !1,
    component: i = "li",
    dense: a = !1,
    divider: l = !1,
    disableGutters: c = !1,
    focusVisibleClassName: d,
    role: f = "menuitem",
    tabIndex: p,
    className: g,
    ...b
  } = r, v = m.useContext(Fs), y = m.useMemo(() => ({
    dense: a || v.dense || !1,
    disableGutters: c
  }), [v.dense, a, c]), S = m.useRef(null);
  ss(() => {
    o && (S.current ? S.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [o]);
  const E = {
    ...r,
    dense: y.dense,
    divider: l,
    disableGutters: c
  }, I = CK(r), O = sr(S, n);
  let T;
  return r.disabled || (T = p !== void 0 ? p : -1), /* @__PURE__ */ w.jsx(Fs.Provider, {
    value: y,
    children: /* @__PURE__ */ w.jsx(xK, {
      ref: O,
      role: f,
      tabIndex: T,
      component: i,
      focusVisibleClassName: ke(I.focusVisible, d),
      className: ke(I.root, g),
      ...b,
      ownerState: E,
      classes: I
    })
  });
});
process.env.NODE_ENV !== "production" && (ts.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: s.bool,
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: s.bool,
  /**
   * @ignore
   */
  disabled: s.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: s.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: s.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: s.string,
  /**
   * @ignore
   */
  role: s.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * @default 0
   */
  tabIndex: s.number
});
function SK(e) {
  return gt("MuiNativeSelect", e);
}
const mx = vt("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), EK = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: o,
    open: i,
    error: a
  } = e, l = {
    select: ["select", n, r && "disabled", o && "multiple", a && "error"],
    icon: ["icon", `icon${Me(n)}`, i && "iconOpen", r && "disabled"]
  };
  return Ct(l, SK, t);
}, CM = oe("select")(({
  theme: e
}) => ({
  // Reset
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  // Reset
  borderRadius: 0,
  cursor: "pointer",
  "&:focus": {
    // Reset Chrome style
    borderRadius: 0
  },
  [`&.${mx.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (e.vars || e).palette.background.paper
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.variant !== "filled" && t.variant !== "outlined",
    style: {
      // Bump specificity to allow extending custom inputs
      "&&&": {
        paddingRight: 24,
        minWidth: 16
        // So it doesn't collapse.
      }
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      "&&&": {
        paddingRight: 32
      }
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius,
      "&:focus": {
        borderRadius: (e.vars || e).shape.borderRadius
        // Reset the reset for Chrome style
      },
      "&&&": {
        paddingRight: 32
      }
    }
  }]
})), TK = oe(CM, {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: qo,
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.select, t[n.variant], n.error && t.error, {
      [`&.${mx.multiple}`]: t.multiple
    }];
  }
})({}), xM = oe("svg")(({
  theme: e
}) => ({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  // Center vertically, height is 1em
  top: "calc(50% - .5em)",
  // Don't block pointer events on the select under the icon.
  pointerEvents: "none",
  color: (e.vars || e).palette.action.active,
  [`&.${mx.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.open,
    style: {
      transform: "rotate(180deg)"
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      right: 7
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      right: 7
    }
  }]
})), OK = oe(xM, {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${Me(n.variant)}`], n.open && t.iconOpen];
  }
})({}), SM = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    className: r,
    disabled: o,
    error: i,
    IconComponent: a,
    inputRef: l,
    variant: c = "standard",
    ...d
  } = t, f = {
    ...t,
    disabled: o,
    variant: c,
    error: i
  }, p = EK(f);
  return /* @__PURE__ */ w.jsxs(m.Fragment, {
    children: [/* @__PURE__ */ w.jsx(TK, {
      ownerState: f,
      className: ke(p.select, r),
      disabled: o,
      ref: l || n,
      ...d
    }), t.multiple ? null : /* @__PURE__ */ w.jsx(OK, {
      as: a,
      ownerState: f,
      className: p.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (SM.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The CSS class name of the select element.
   */
  className: s.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: s.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: s.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: s.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: Wo,
  /**
   * @ignore
   */
  multiple: s.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: s.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * The input value.
   */
  value: s.any,
  /**
   * The variant to use.
   */
  variant: s.oneOf(["standard", "outlined", "filled"])
});
var WO;
const PK = oe("fieldset", {
  shouldForwardProp: qo
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), IK = oe("legend", {
  shouldForwardProp: qo
})(ut(({
  theme: e
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: ({
      ownerState: t
    }) => !t.withLabel,
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: e.transitions.create("width", {
        duration: 150,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel,
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: e.transitions.create("max-width", {
        duration: 50,
        easing: e.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel && t.notched,
    style: {
      maxWidth: "100%",
      transition: e.transitions.create("max-width", {
        duration: 100,
        easing: e.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
})));
function EM(e) {
  const {
    children: t,
    classes: n,
    className: r,
    label: o,
    notched: i,
    ...a
  } = e, l = o != null && o !== "", c = {
    ...e,
    notched: i,
    withLabel: l
  };
  return /* @__PURE__ */ w.jsx(PK, {
    "aria-hidden": !0,
    className: r,
    ownerState: c,
    ...a,
    children: /* @__PURE__ */ w.jsx(IK, {
      ownerState: c,
      children: l ? /* @__PURE__ */ w.jsx("span", {
        children: o
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        WO || (WO = /* @__PURE__ */ w.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      )
    })
  });
}
process.env.NODE_ENV !== "production" && (EM.propTypes = {
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The label.
   */
  label: s.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: s.bool.isRequired,
  /**
   * @ignore
   */
  style: s.object
});
const RK = (e) => {
  const {
    classes: t
  } = e, r = Ct({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, v6, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...r
  };
}, _K = oe(db, {
  shouldForwardProp: (e) => qo(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: cb
})(ut(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${Ti.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${Ti.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
      }
    },
    [`&.${Ti.focused} .${Ti.notchedOutline}`]: {
      borderWidth: 2
    },
    variants: [...Object.entries(e.palette).filter(Jn()).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        [`&.${Ti.focused} .${Ti.notchedOutline}`]: {
          borderColor: (e.vars || e).palette[n].main
        }
      }
    })), {
      props: {},
      // to overide the above style
      style: {
        [`&.${Ti.error} .${Ti.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.error.main
        },
        [`&.${Ti.disabled} .${Ti.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.action.disabled
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.startAdornment,
      style: {
        paddingLeft: 14
      }
    }, {
      props: ({
        ownerState: n
      }) => n.endAdornment,
      style: {
        paddingRight: 14
      }
    }, {
      props: ({
        ownerState: n
      }) => n.multiline,
      style: {
        padding: "16.5px 14px"
      }
    }, {
      props: ({
        ownerState: n,
        size: r
      }) => n.multiline && r === "small",
      style: {
        padding: "8.5px 14px"
      }
    }]
  };
})), kK = oe(EM, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(ut(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
})), MK = oe(fb, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: ub
})(ut(({
  theme: e
}) => ({
  padding: "16.5px 14px",
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 14px"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }]
}))), yb = /* @__PURE__ */ m.forwardRef(function(t, n) {
  var r;
  const o = St({
    props: t,
    name: "MuiOutlinedInput"
  }), {
    components: i = {},
    fullWidth: a = !1,
    inputComponent: l = "input",
    label: c,
    multiline: d = !1,
    notched: f,
    slots: p = {},
    type: g = "text",
    ...b
  } = o, v = RK(o), y = Sa(), S = _c({
    props: o,
    muiFormControl: y,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), E = {
    ...o,
    color: S.color || "primary",
    disabled: S.disabled,
    error: S.error,
    focused: S.focused,
    formControl: y,
    fullWidth: a,
    hiddenLabel: S.hiddenLabel,
    multiline: d,
    size: S.size,
    type: g
  }, I = p.root ?? i.Root ?? _K, O = p.input ?? i.Input ?? MK;
  return /* @__PURE__ */ w.jsx(kc, {
    slots: {
      root: I,
      input: O
    },
    renderSuffix: (T) => /* @__PURE__ */ w.jsx(kK, {
      ownerState: E,
      className: v.notchedOutline,
      label: c != null && c !== "" && S.required ? r || (r = /* @__PURE__ */ w.jsxs(m.Fragment, {
        children: [c, " ", "*"]
      })) : c,
      notched: typeof f < "u" ? f : !!(T.startAdornment || T.filled || T.focused)
    }),
    fullWidth: a,
    inputComponent: l,
    multiline: d,
    ref: n,
    type: g,
    ...b,
    classes: {
      ...v,
      notchedOutline: null
    }
  });
});
process.env.NODE_ENV !== "production" && (yb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: s.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary"]), s.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Input: s.elementType,
    Root: s.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: s.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: s.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: s.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: s.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Wo,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: s.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: s.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: s.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: s.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: s.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: s.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: s.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: s.oneOfType([s.number, s.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: s.shape({
    input: s.elementType,
    root: s.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: s.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: s.any
});
yb.muiName = "Input";
const AK = At(/* @__PURE__ */ w.jsx("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage"), DK = At(/* @__PURE__ */ w.jsx("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage");
function NK(e) {
  return gt("MuiSelect", e);
}
const uf = vt("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var qO;
const FK = oe(CM, {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${uf.select}`]: t.select
      },
      {
        [`&.${uf.select}`]: t[n.variant]
      },
      {
        [`&.${uf.error}`]: t.error
      },
      {
        [`&.${uf.multiple}`]: t.multiple
      }
    ];
  }
})({
  // Win specificity over the input base
  [`&.${uf.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), $K = oe(xM, {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${Me(n.variant)}`], n.open && t.iconOpen];
  }
})({}), LK = oe("input", {
  shouldForwardProp: (e) => jk(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, t) => t.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function KO(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
function jK(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const BK = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: o,
    open: i,
    error: a
  } = e, l = {
    select: ["select", n, r && "disabled", o && "multiple", a && "error"],
    icon: ["icon", `icon${Me(n)}`, i && "iconOpen", r && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return Ct(l, NK, t);
}, TM = /* @__PURE__ */ m.forwardRef(function(t, n) {
  var Je;
  const {
    "aria-describedby": r,
    "aria-label": o,
    autoFocus: i,
    autoWidth: a,
    children: l,
    className: c,
    defaultOpen: d,
    defaultValue: f,
    disabled: p,
    displayEmpty: g,
    error: b = !1,
    IconComponent: v,
    inputRef: y,
    labelId: S,
    MenuProps: E = {},
    multiple: I,
    name: O,
    onBlur: T,
    onChange: P,
    onClose: R,
    onFocus: F,
    onOpen: A,
    open: _,
    readOnly: C,
    renderValue: D,
    required: L,
    SelectDisplayProps: B = {},
    tabIndex: H,
    // catching `type` from Input which makes no sense for SelectInput
    type: k,
    value: N,
    variant: j = "standard",
    ...W
  } = t, [V, $] = ul({
    controlled: N,
    default: f,
    name: "Select"
  }), [z, ne] = ul({
    controlled: _,
    default: d,
    name: "Select"
  }), K = m.useRef(null), Q = m.useRef(null), [re, te] = m.useState(null), {
    current: ie
  } = m.useRef(_ != null), [ae, ce] = m.useState(), le = sr(n, y), we = m.useCallback((Ge) => {
    Q.current = Ge, Ge && te(Ge);
  }, []), q = re == null ? void 0 : re.parentNode;
  m.useImperativeHandle(le, () => ({
    focus: () => {
      Q.current.focus();
    },
    node: K.current,
    value: V
  }), [V]), m.useEffect(() => {
    d && z && re && !ie && (ce(a ? null : q.clientWidth), Q.current.focus());
  }, [re, a]), m.useEffect(() => {
    i && Q.current.focus();
  }, [i]), m.useEffect(() => {
    if (!S)
      return;
    const Ge = go(Q.current).getElementById(S);
    if (Ge) {
      const lt = () => {
        getSelection().isCollapsed && Q.current.focus();
      };
      return Ge.addEventListener("click", lt), () => {
        Ge.removeEventListener("click", lt);
      };
    }
  }, [S]);
  const Ee = (Ge, lt) => {
    Ge ? A && A(lt) : R && R(lt), ie || (ce(a ? null : q.clientWidth), ne(Ge));
  }, _e = (Ge) => {
    Ge.button === 0 && (Ge.preventDefault(), Q.current.focus(), Ee(!0, Ge));
  }, $e = (Ge) => {
    Ee(!1, Ge);
  }, Le = m.Children.toArray(l), Ze = (Ge) => {
    const lt = Le.find((It) => It.props.value === Ge.target.value);
    lt !== void 0 && ($(lt.props.value), P && P(Ge, lt));
  }, J = (Ge) => (lt) => {
    let It;
    if (lt.currentTarget.hasAttribute("tabindex")) {
      if (I) {
        It = Array.isArray(V) ? V.slice() : [];
        const fn = V.indexOf(Ge.props.value);
        fn === -1 ? It.push(Ge.props.value) : It.splice(fn, 1);
      } else
        It = Ge.props.value;
      if (Ge.props.onClick && Ge.props.onClick(lt), V !== It && ($(It), P)) {
        const fn = lt.nativeEvent || lt, Bn = new fn.constructor(fn.type, fn);
        Object.defineProperty(Bn, "target", {
          writable: !0,
          value: {
            value: It,
            name: O
          }
        }), P(Bn, Ge);
      }
      I || Ee(!1, lt);
    }
  }, fe = (Ge) => {
    C || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].includes(Ge.key) && (Ge.preventDefault(), Ee(!0, Ge));
  }, me = re !== null && z, Oe = (Ge) => {
    !me && T && (Object.defineProperty(Ge, "target", {
      writable: !0,
      value: {
        value: V,
        name: O
      }
    }), T(Ge));
  };
  delete W["aria-invalid"];
  let Ce, Te;
  const Pe = [];
  let Ye = !1, Ke = !1;
  (lm({
    value: V
  }) || g) && (D ? Ce = D(V) : Ye = !0);
  const je = Le.map((Ge) => {
    if (!/* @__PURE__ */ m.isValidElement(Ge))
      return null;
    process.env.NODE_ENV !== "production" && sd.isFragment(Ge) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let lt;
    if (I) {
      if (!Array.isArray(V))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : Bs(2));
      lt = V.some((It) => KO(It, Ge.props.value)), lt && Ye && Pe.push(Ge.props.children);
    } else
      lt = KO(V, Ge.props.value), lt && Ye && (Te = Ge.props.children);
    return lt && (Ke = !0), /* @__PURE__ */ m.cloneElement(Ge, {
      "aria-selected": lt ? "true" : "false",
      onClick: J(Ge),
      onKeyUp: (It) => {
        It.key === " " && It.preventDefault(), Ge.props.onKeyUp && Ge.props.onKeyUp(It);
      },
      role: "option",
      selected: lt,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": Ge.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && m.useEffect(() => {
    if (!Ke && !I && V !== "") {
      const Ge = Le.map((lt) => lt.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${V}\` for the select ${O ? `(name="${O}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${Ge.filter((lt) => lt != null).map((lt) => `\`${lt}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [Ke, Le, I, O, V]), Ye && (I ? Pe.length === 0 ? Ce = null : Ce = Pe.reduce((Ge, lt, It) => (Ge.push(lt), It < Pe.length - 1 && Ge.push(", "), Ge), []) : Ce = Te);
  let Qe = ae;
  !a && ie && re && (Qe = q.clientWidth);
  let et;
  typeof H < "u" ? et = H : et = p ? null : 0;
  const Et = B.id || (O ? `mui-component-select-${O}` : void 0), Xe = {
    ...t,
    variant: j,
    value: V,
    open: me,
    error: b
  }, xt = BK(Xe), tt = {
    ...E.PaperProps,
    ...(Je = E.slotProps) == null ? void 0 : Je.paper
  }, ct = wc();
  return /* @__PURE__ */ w.jsxs(m.Fragment, {
    children: [/* @__PURE__ */ w.jsx(FK, {
      as: "div",
      ref: we,
      tabIndex: et,
      role: "combobox",
      "aria-controls": ct,
      "aria-disabled": p ? "true" : void 0,
      "aria-expanded": me ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": o,
      "aria-labelledby": [S, Et].filter(Boolean).join(" ") || void 0,
      "aria-describedby": r,
      "aria-required": L ? "true" : void 0,
      "aria-invalid": b ? "true" : void 0,
      onKeyDown: fe,
      onMouseDown: p || C ? null : _e,
      onBlur: Oe,
      onFocus: F,
      ...B,
      ownerState: Xe,
      className: ke(B.className, xt.select, c),
      id: Et,
      children: jK(Ce) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        qO || (qO = /* @__PURE__ */ w.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      ) : Ce
    }), /* @__PURE__ */ w.jsx(LK, {
      "aria-invalid": b,
      value: Array.isArray(V) ? V.join(",") : V,
      name: O,
      ref: K,
      "aria-hidden": !0,
      onChange: Ze,
      tabIndex: -1,
      disabled: p,
      className: xt.nativeInput,
      autoFocus: i,
      required: L,
      ...W,
      ownerState: Xe
    }), /* @__PURE__ */ w.jsx($K, {
      as: v,
      className: xt.icon,
      ownerState: Xe
    }), /* @__PURE__ */ w.jsx(wM, {
      id: `menu-${O || ""}`,
      anchorEl: q,
      open: me,
      onClose: $e,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      ...E,
      MenuListProps: {
        "aria-labelledby": S,
        role: "listbox",
        "aria-multiselectable": I ? "true" : void 0,
        disableListWrap: !0,
        id: ct,
        ...E.MenuListProps
      },
      slotProps: {
        ...E.slotProps,
        paper: {
          ...tt,
          style: {
            minWidth: Qe,
            ...tt != null ? tt.style : null
          }
        }
      },
      children: je
    })]
  });
});
process.env.NODE_ENV !== "production" && (TM.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": s.string,
  /**
   * @ignore
   */
  "aria-label": s.string,
  /**
   * @ignore
   */
  autoFocus: s.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: s.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The CSS class name of the select element.
   */
  className: s.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: s.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: s.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: s.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: s.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: s.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: Wo,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: s.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: s.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: s.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: s.string,
  /**
   * @ignore
   */
  onBlur: s.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: s.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool,
  /**
   * @ignore
   */
  readOnly: s.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: s.func,
  /**
   * If `true`, the component is required.
   */
  required: s.bool,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: s.object,
  /**
   * @ignore
   */
  tabIndex: s.oneOfType([s.number, s.string]),
  /**
   * @ignore
   */
  type: s.any,
  /**
   * The input value.
   */
  value: s.any,
  /**
   * The variant to use.
   */
  variant: s.oneOf(["standard", "outlined", "filled"])
});
const VK = (e) => {
  const {
    classes: t
  } = e;
  return t;
}, bx = {
  name: "MuiSelect",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => qo(e) && e !== "variant",
  slot: "Root"
}, HK = oe(mb, bx)(""), UK = oe(yb, bx)(""), zK = oe(gb, bx)(""), Kp = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    name: "MuiSelect",
    props: t
  }), {
    autoWidth: o = !1,
    children: i,
    classes: a = {},
    className: l,
    defaultOpen: c = !1,
    displayEmpty: d = !1,
    IconComponent: f = sM,
    id: p,
    input: g,
    inputProps: b,
    label: v,
    labelId: y,
    MenuProps: S,
    multiple: E = !1,
    native: I = !1,
    onClose: O,
    onOpen: T,
    open: P,
    renderValue: R,
    SelectDisplayProps: F,
    variant: A = "outlined",
    ..._
  } = r, C = I ? SM : TM, D = Sa(), L = _c({
    props: r,
    muiFormControl: D,
    states: ["variant", "error"]
  }), B = L.variant || A, H = {
    ...r,
    variant: B,
    classes: a
  }, k = VK(H), {
    root: N,
    ...j
  } = k, W = g || {
    standard: /* @__PURE__ */ w.jsx(HK, {
      ownerState: H
    }),
    outlined: /* @__PURE__ */ w.jsx(UK, {
      label: v,
      ownerState: H
    }),
    filled: /* @__PURE__ */ w.jsx(zK, {
      ownerState: H
    })
  }[B], V = sr(n, Rc(W));
  return /* @__PURE__ */ w.jsx(m.Fragment, {
    children: /* @__PURE__ */ m.cloneElement(W, {
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: C,
      inputProps: {
        children: i,
        error: L.error,
        IconComponent: f,
        variant: B,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: E,
        ...I ? {
          id: p
        } : {
          autoWidth: o,
          defaultOpen: c,
          displayEmpty: d,
          labelId: y,
          MenuProps: S,
          onClose: O,
          onOpen: T,
          open: P,
          renderValue: R,
          SelectDisplayProps: {
            id: p,
            ...F
          }
        },
        ...b,
        classes: b ? Jr(j, b.classes) : j,
        ...g ? g.props.inputProps : {}
      },
      ...(E && I || d) && B === "outlined" ? {
        notched: !0
      } : {},
      ref: V,
      className: ke(W.props.className, l, k.root),
      // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
      ...!g && {
        variant: B
      },
      ..._
    })
  });
});
process.env.NODE_ENV !== "production" && (Kp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: s.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: s.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: s.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: s.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: s.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: s.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: s.object,
  /**
   * See [OutlinedInput#label](https://mui.com/material-ui/api/outlined-input/#props)
   */
  label: s.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: s.string,
  /**
   * Props applied to the [`Menu`](https://mui.com/material-ui/api/menu/) element.
   */
  MenuProps: s.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: s.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: s.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: s.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: s.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: s.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: s.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: s.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: s.oneOfType([s.oneOf([""]), s.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: s.oneOf(["filled", "outlined", "standard"])
});
Kp.muiName = "Select";
function GK(e) {
  return gt("MuiSkeleton", e);
}
vt("MuiSkeleton", ["root", "text", "rectangular", "rounded", "circular", "pulse", "wave", "withChildren", "fitContent", "heightAuto"]);
const WK = (e) => {
  const {
    classes: t,
    variant: n,
    animation: r,
    hasChildren: o,
    width: i,
    height: a
  } = e;
  return Ct({
    root: ["root", n, r, o && "withChildren", o && !i && "fitContent", o && !a && "heightAuto"]
  }, GK, t);
}, f0 = Gs`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`, p0 = Gs`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`, qK = typeof f0 != "string" ? El`
        animation: ${f0} 2s ease-in-out 0.5s infinite;
      ` : null, KK = typeof p0 != "string" ? El`
        &::after {
          animation: ${p0} 2s linear 0.5s infinite;
        }
      ` : null, YK = oe("span", {
  name: "MuiSkeleton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], n.animation !== !1 && t[n.animation], n.hasChildren && t.withChildren, n.hasChildren && !n.width && t.fitContent, n.hasChildren && !n.height && t.heightAuto];
  }
})(ut(({
  theme: e
}) => {
  const t = xq(e.shape.borderRadius) || "px", n = Sq(e.shape.borderRadius);
  return {
    display: "block",
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: e.vars ? e.vars.palette.Skeleton.bg : Vt(e.palette.text.primary, e.palette.mode === "light" ? 0.11 : 0.13),
    height: "1.2em",
    variants: [{
      props: {
        variant: "text"
      },
      style: {
        marginTop: 0,
        marginBottom: 0,
        height: "auto",
        transformOrigin: "0 55%",
        transform: "scale(1, 0.60)",
        borderRadius: `${n}${t}/${Math.round(n / 0.6 * 10) / 10}${t}`,
        "&:empty:before": {
          content: '"\\00a0"'
        }
      }
    }, {
      props: {
        variant: "circular"
      },
      style: {
        borderRadius: "50%"
      }
    }, {
      props: {
        variant: "rounded"
      },
      style: {
        borderRadius: (e.vars || e).shape.borderRadius
      }
    }, {
      props: ({
        ownerState: r
      }) => r.hasChildren,
      style: {
        "& > *": {
          visibility: "hidden"
        }
      }
    }, {
      props: ({
        ownerState: r
      }) => r.hasChildren && !r.width,
      style: {
        maxWidth: "fit-content"
      }
    }, {
      props: ({
        ownerState: r
      }) => r.hasChildren && !r.height,
      style: {
        height: "auto"
      }
    }, {
      props: {
        animation: "pulse"
      },
      style: qK || {
        animation: `${f0} 2s ease-in-out 0.5s infinite`
      }
    }, {
      props: {
        animation: "wave"
      },
      style: {
        position: "relative",
        overflow: "hidden",
        /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
        WebkitMaskImage: "-webkit-radial-gradient(white, black)",
        "&::after": {
          background: `linear-gradient(
                90deg,
                transparent,
                ${(e.vars || e).palette.action.hover},
                transparent
              )`,
          content: '""',
          position: "absolute",
          transform: "translateX(-100%)",
          bottom: 0,
          left: 0,
          right: 0,
          top: 0
        }
      }
    }, {
      props: {
        animation: "wave"
      },
      style: KK || {
        "&::after": {
          animation: `${p0} 2s linear 0.5s infinite`
        }
      }
    }]
  };
})), OM = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiSkeleton"
  }), {
    animation: o = "pulse",
    className: i,
    component: a = "span",
    height: l,
    style: c,
    variant: d = "text",
    width: f,
    ...p
  } = r, g = {
    ...r,
    animation: o,
    component: a,
    variant: d,
    hasChildren: !!p.children
  }, b = WK(g);
  return /* @__PURE__ */ w.jsx(YK, {
    as: a,
    ref: n,
    className: ke(b.root, i),
    ownerState: g,
    ...p,
    style: {
      width: f,
      height: l,
      ...c
    }
  });
});
process.env.NODE_ENV !== "production" && (OM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The animation.
   * If `false` the animation effect is disabled.
   * @default 'pulse'
   */
  animation: s.oneOf(["pulse", "wave", !1]),
  /**
   * Optional children to infer width and height from.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * Height of the skeleton.
   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
   */
  height: s.oneOfType([s.number, s.string]),
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The type of content that will be rendered.
   * @default 'text'
   */
  variant: s.oneOfType([s.oneOf(["circular", "rectangular", "rounded", "text"]), s.string]),
  /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: s.oneOfType([s.number, s.string])
});
function QK(e) {
  return gt("MuiTooltip", e);
}
const ur = vt("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]);
function XK(e) {
  return Math.round(e * 1e5) / 1e5;
}
const JK = (e) => {
  const {
    classes: t,
    disableInteractive: n,
    arrow: r,
    touch: o,
    placement: i
  } = e, a = {
    popper: ["popper", !n && "popperInteractive", r && "popperArrow"],
    tooltip: ["tooltip", r && "tooltipArrow", o && "touch", `tooltipPlacement${Me(i.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return Ct(a, QK, t);
}, ZK = oe(Pl, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popper, !n.disableInteractive && t.popperInteractive, n.arrow && t.popperArrow, !n.open && t.popperClose];
  }
})(ut(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableInteractive,
    style: {
      pointerEvents: "auto"
    }
  }, {
    props: ({
      open: t
    }) => !t,
    style: {
      pointerEvents: "none"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow,
    style: {
      [`&[data-popper-placement*="bottom"] .${ur.arrow}`]: {
        top: 0,
        marginTop: "-0.71em",
        "&::before": {
          transformOrigin: "0 100%"
        }
      },
      [`&[data-popper-placement*="top"] .${ur.arrow}`]: {
        bottom: 0,
        marginBottom: "-0.71em",
        "&::before": {
          transformOrigin: "100% 0"
        }
      },
      [`&[data-popper-placement*="right"] .${ur.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "100% 100%"
        }
      },
      [`&[data-popper-placement*="left"] .${ur.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "0 0"
        }
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !t.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${ur.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !!t.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${ur.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !t.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${ur.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !!t.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${ur.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }]
}))), e7 = oe("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.tooltip, n.touch && t.touch, n.arrow && t.tooltipArrow, t[`tooltipPlacement${Me(n.placement.split("-")[0])}`]];
  }
})(ut(({
  theme: e
}) => ({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : Vt(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium,
  [`.${ur.popper}[data-popper-placement*="left"] &`]: {
    transformOrigin: "right center"
  },
  [`.${ur.popper}[data-popper-placement*="right"] &`]: {
    transformOrigin: "left center"
  },
  [`.${ur.popper}[data-popper-placement*="top"] &`]: {
    transformOrigin: "center bottom",
    marginBottom: "14px"
  },
  [`.${ur.popper}[data-popper-placement*="bottom"] &`]: {
    transformOrigin: "center top",
    marginTop: "14px"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.arrow,
    style: {
      position: "relative",
      margin: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      padding: "8px 16px",
      fontSize: e.typography.pxToRem(14),
      lineHeight: `${XK(16 / 14)}em`,
      fontWeight: e.typography.fontWeightRegular
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.isRtl,
    style: {
      [`.${ur.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "14px"
      },
      [`.${ur.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "14px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.isRtl && t.touch,
    style: {
      [`.${ur.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "24px"
      },
      [`.${ur.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.isRtl,
    style: {
      [`.${ur.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "14px"
      },
      [`.${ur.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "14px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.isRtl && t.touch,
    style: {
      [`.${ur.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "24px"
      },
      [`.${ur.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      [`.${ur.popper}[data-popper-placement*="top"] &`]: {
        marginBottom: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      [`.${ur.popper}[data-popper-placement*="bottom"] &`]: {
        marginTop: "24px"
      }
    }
  }]
}))), t7 = oe("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (e, t) => t.arrow
})(ut(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : Vt(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
})));
let pg = !1;
const YO = new bk();
let df = {
  x: 0,
  y: 0
};
function hg(e, t) {
  return (n, ...r) => {
    t && t(n, ...r), e(n, ...r);
  };
}
const yx = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiTooltip"
  }), {
    arrow: o = !1,
    children: i,
    classes: a,
    components: l = {},
    componentsProps: c = {},
    describeChild: d = !1,
    disableFocusListener: f = !1,
    disableHoverListener: p = !1,
    disableInteractive: g = !1,
    disableTouchListener: b = !1,
    enterDelay: v = 100,
    enterNextDelay: y = 0,
    enterTouchDelay: S = 700,
    followCursor: E = !1,
    id: I,
    leaveDelay: O = 0,
    leaveTouchDelay: T = 1500,
    onClose: P,
    onOpen: R,
    open: F,
    placement: A = "bottom",
    PopperComponent: _,
    PopperProps: C = {},
    slotProps: D = {},
    slots: L = {},
    title: B,
    TransitionComponent: H,
    TransitionProps: k,
    ...N
  } = r, j = /* @__PURE__ */ m.isValidElement(i) ? i : /* @__PURE__ */ w.jsx("span", {
    children: i
  }), W = bo(), V = mi(), [$, z] = m.useState(), [ne, K] = m.useState(null), Q = m.useRef(!1), re = g || E, te = tc(), ie = tc(), ae = tc(), ce = tc(), [le, we] = ul({
    controlled: F,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let q = le;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: mt
    } = m.useRef(F !== void 0);
    m.useEffect(() => {
      $ && $.disabled && !mt && B !== "" && $.tagName.toLowerCase() === "button" && console.warn(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [B, $, mt]);
  }
  const Ee = wc(I), _e = m.useRef(), $e = li(() => {
    _e.current !== void 0 && (document.body.style.WebkitUserSelect = _e.current, _e.current = void 0), ce.clear();
  });
  m.useEffect(() => $e, [$e]);
  const Le = (mt) => {
    YO.clear(), pg = !0, we(!0), R && !q && R(mt);
  }, Ze = li(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (mt) => {
      YO.start(800 + O, () => {
        pg = !1;
      }), we(!1), P && q && P(mt), te.start(W.transitions.duration.shortest, () => {
        Q.current = !1;
      });
    }
  ), J = (mt) => {
    Q.current && mt.type !== "touchstart" || ($ && $.removeAttribute("title"), ie.clear(), ae.clear(), v || pg && y ? ie.start(pg ? y : v, () => {
      Le(mt);
    }) : Le(mt));
  }, fe = (mt) => {
    ie.clear(), ae.start(O, () => {
      Ze(mt);
    });
  }, [, me] = m.useState(!1), Oe = (mt) => {
    ad(mt.target) || (me(!1), fe(mt));
  }, Ce = (mt) => {
    $ || z(mt.currentTarget), ad(mt.target) && (me(!0), J(mt));
  }, Te = (mt) => {
    Q.current = !0;
    const er = j.props;
    er.onTouchStart && er.onTouchStart(mt);
  }, Pe = (mt) => {
    Te(mt), ae.clear(), te.clear(), $e(), _e.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", ce.start(S, () => {
      document.body.style.WebkitUserSelect = _e.current, J(mt);
    });
  }, Ye = (mt) => {
    j.props.onTouchEnd && j.props.onTouchEnd(mt), $e(), ae.start(T, () => {
      Ze(mt);
    });
  };
  m.useEffect(() => {
    if (!q)
      return;
    function mt(er) {
      er.key === "Escape" && Ze(er);
    }
    return document.addEventListener("keydown", mt), () => {
      document.removeEventListener("keydown", mt);
    };
  }, [Ze, q]);
  const Ke = sr(Rc(j), z, n);
  !B && B !== 0 && (q = !1);
  const je = m.useRef(), Qe = (mt) => {
    const er = j.props;
    er.onMouseMove && er.onMouseMove(mt), df = {
      x: mt.clientX,
      y: mt.clientY
    }, je.current && je.current.update();
  }, et = {}, Et = typeof B == "string";
  d ? (et.title = !q && Et && !p ? B : null, et["aria-describedby"] = q ? Ee : null) : (et["aria-label"] = Et ? B : null, et["aria-labelledby"] = q && !Et ? Ee : null);
  const Xe = {
    ...et,
    ...N,
    ...j.props,
    className: ke(N.className, j.props.className),
    onTouchStart: Te,
    ref: Ke,
    ...E ? {
      onMouseMove: Qe
    } : {}
  };
  process.env.NODE_ENV !== "production" && (Xe["data-mui-internal-clone-element"] = !0, m.useEffect(() => {
    $ && !$.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [$]));
  const xt = {};
  b || (Xe.onTouchStart = Pe, Xe.onTouchEnd = Ye), p || (Xe.onMouseOver = hg(J, Xe.onMouseOver), Xe.onMouseLeave = hg(fe, Xe.onMouseLeave), re || (xt.onMouseOver = J, xt.onMouseLeave = fe)), f || (Xe.onFocus = hg(Ce, Xe.onFocus), Xe.onBlur = hg(Oe, Xe.onBlur), re || (xt.onFocus = Ce, xt.onBlur = Oe)), process.env.NODE_ENV !== "production" && j.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${j.props.title}\` or the Tooltip component.`].join(`
`));
  const tt = {
    ...r,
    isRtl: V,
    arrow: o,
    disableInteractive: re,
    placement: A,
    PopperComponentProp: _,
    touch: Q.current
  }, ct = typeof D.popper == "function" ? D.popper(tt) : D.popper, Je = m.useMemo(() => {
    var er, eo;
    let mt = [{
      name: "arrow",
      enabled: !!ne,
      options: {
        element: ne,
        padding: 4
      }
    }];
    return (er = C.popperOptions) != null && er.modifiers && (mt = mt.concat(C.popperOptions.modifiers)), (eo = ct == null ? void 0 : ct.popperOptions) != null && eo.modifiers && (mt = mt.concat(ct.popperOptions.modifiers)), {
      ...C.popperOptions,
      ...ct == null ? void 0 : ct.popperOptions,
      modifiers: mt
    };
  }, [ne, C.popperOptions, ct == null ? void 0 : ct.popperOptions]), Ge = JK(tt), lt = typeof D.transition == "function" ? D.transition(tt) : D.transition, It = {
    slots: {
      popper: l.Popper,
      transition: l.Transition ?? H,
      tooltip: l.Tooltip,
      arrow: l.Arrow,
      ...L
    },
    slotProps: {
      arrow: D.arrow ?? c.arrow,
      popper: {
        ...C,
        ...ct ?? c.popper
      },
      // resolvedPopperProps can be spread because it's already an object
      tooltip: D.tooltip ?? c.tooltip,
      transition: {
        ...k,
        ...lt ?? c.transition
      }
    }
  }, [fn, Bn] = gn("popper", {
    elementType: ZK,
    externalForwardedProps: It,
    ownerState: tt,
    className: ke(Ge.popper, C == null ? void 0 : C.className)
  }), [kn, fr] = gn("transition", {
    elementType: hd,
    externalForwardedProps: It,
    ownerState: tt
  }), [ar, Mr] = gn("tooltip", {
    elementType: e7,
    className: Ge.tooltip,
    externalForwardedProps: It,
    ownerState: tt
  }), [Lr, lr] = gn("arrow", {
    elementType: t7,
    className: Ge.arrow,
    externalForwardedProps: It,
    ownerState: tt,
    ref: K
  });
  return /* @__PURE__ */ w.jsxs(m.Fragment, {
    children: [/* @__PURE__ */ m.cloneElement(j, Xe), /* @__PURE__ */ w.jsx(fn, {
      as: _ ?? Pl,
      placement: A,
      anchorEl: E ? {
        getBoundingClientRect: () => ({
          top: df.y,
          left: df.x,
          right: df.x,
          bottom: df.y,
          width: 0,
          height: 0
        })
      } : $,
      popperRef: je,
      open: $ ? q : !1,
      id: Ee,
      transition: !0,
      ...xt,
      ...Bn,
      popperOptions: Je,
      children: ({
        TransitionProps: mt
      }) => /* @__PURE__ */ w.jsx(kn, {
        timeout: W.transitions.duration.shorter,
        ...mt,
        ...fr,
        children: /* @__PURE__ */ w.jsxs(ar, {
          ...Mr,
          children: [B, o ? /* @__PURE__ */ w.jsx(Lr, {
            ...lr
          }) : null]
        })
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (yx.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: s.bool,
  /**
   * Tooltip reference element.
   */
  children: Ic.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Arrow: s.elementType,
    Popper: s.elementType,
    Tooltip: s.elementType,
    Transition: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    arrow: s.object,
    popper: s.object,
    tooltip: s.object,
    transition: s.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: s.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: s.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: s.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: s.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: s.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: s.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: s.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: s.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: s.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: s.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: s.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: s.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: s.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: s.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @deprecated use the `slots.popper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: s.elementType,
  /**
   * Props applied to the [`Popper`](https://mui.com/material-ui/api/popper/) element.
   * @deprecated use the `slotProps.popper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  PopperProps: s.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    arrow: s.oneOfType([s.func, s.object]),
    popper: s.oneOfType([s.func, s.object]),
    tooltip: s.oneOfType([s.func, s.object]),
    transition: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    arrow: s.elementType,
    popper: s.elementType,
    tooltip: s.elementType,
    transition: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: s.node,
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: s.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: s.object
});
const $r = qW({
  createStyledComponent: oe("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (e, t) => t.root
  }),
  useThemeProps: (e) => St({
    props: e,
    name: "MuiStack"
  })
});
process.env.NODE_ENV !== "production" && ($r.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: s.oneOfType([s.oneOf(["column-reverse", "column", "row-reverse", "row"]), s.arrayOf(s.oneOf(["column-reverse", "column", "row-reverse", "row"])), s.object]),
  /**
   * Add an element between each child.
   */
  divider: s.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: s.oneOfType([s.arrayOf(s.oneOfType([s.number, s.string])), s.number, s.object, s.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: s.bool
});
const Od = /* @__PURE__ */ m.createContext({});
process.env.NODE_ENV !== "production" && (Od.displayName = "StepperContext");
const Yp = /* @__PURE__ */ m.createContext({});
process.env.NODE_ENV !== "production" && (Yp.displayName = "StepContext");
function n7(e) {
  return gt("MuiStep", e);
}
vt("MuiStep", ["root", "horizontal", "vertical", "alternativeLabel", "completed"]);
const r7 = (e) => {
  const {
    classes: t,
    orientation: n,
    alternativeLabel: r,
    completed: o
  } = e;
  return Ct({
    root: ["root", n, r && "alternativeLabel", o && "completed"]
  }, n7, t);
}, o7 = oe("div", {
  name: "MuiStep",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation], n.alternativeLabel && t.alternativeLabel, n.completed && t.completed];
  }
})({
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      paddingLeft: 8,
      paddingRight: 8
    }
  }, {
    props: {
      alternativeLabel: !0
    },
    style: {
      flex: 1,
      position: "relative"
    }
  }]
}), PM = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiStep"
  }), {
    active: o,
    children: i,
    className: a,
    component: l = "div",
    completed: c,
    disabled: d,
    expanded: f = !1,
    index: p,
    last: g,
    ...b
  } = r, {
    activeStep: v,
    connector: y,
    alternativeLabel: S,
    orientation: E,
    nonLinear: I
  } = m.useContext(Od);
  let [O = !1, T = !1, P = !1] = [o, c, d];
  v === p ? O = o !== void 0 ? o : !0 : !I && v > p ? T = c !== void 0 ? c : !0 : !I && v < p && (P = d !== void 0 ? d : !0);
  const R = m.useMemo(() => ({
    index: p,
    last: g,
    expanded: f,
    icon: p + 1,
    active: O,
    completed: T,
    disabled: P
  }), [p, g, f, O, T, P]), F = {
    ...r,
    active: O,
    orientation: E,
    alternativeLabel: S,
    completed: T,
    disabled: P,
    expanded: f,
    component: l
  }, A = r7(F), _ = /* @__PURE__ */ w.jsxs(o7, {
    as: l,
    className: ke(A.root, a),
    ref: n,
    ownerState: F,
    ...b,
    children: [y && S && p !== 0 ? y : null, i]
  });
  return /* @__PURE__ */ w.jsx(Yp.Provider, {
    value: R,
    children: y && !S && p !== 0 ? /* @__PURE__ */ w.jsxs(m.Fragment, {
      children: [y, _]
    }) : _
  });
});
process.env.NODE_ENV !== "production" && (PM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Sets the step as active. Is passed to child components.
   */
  active: s.bool,
  /**
   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: s.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the step is disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */
  disabled: s.bool,
  /**
   * Expand the step.
   * @default false
   */
  expanded: s.bool,
  /**
   * The position of the step.
   * The prop defaults to the value inherited from the parent Stepper component.
   */
  index: dl,
  /**
   * If `true`, the Step is displayed as rendered last.
   * The prop defaults to the value inherited from the parent Stepper component.
   */
  last: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const i7 = At(/* @__PURE__ */ w.jsx("path", {
  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), "CheckCircle"), s7 = At(/* @__PURE__ */ w.jsx("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), "Warning");
function a7(e) {
  return gt("MuiStepIcon", e);
}
const Qv = vt("MuiStepIcon", ["root", "active", "completed", "error", "text"]);
var QO;
const l7 = (e) => {
  const {
    classes: t,
    active: n,
    completed: r,
    error: o
  } = e;
  return Ct({
    root: ["root", n && "active", r && "completed", o && "error"],
    text: ["text"]
  }, a7, t);
}, Xv = oe(ld, {
  name: "MuiStepIcon",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(ut(({
  theme: e
}) => ({
  display: "block",
  transition: e.transitions.create("color", {
    duration: e.transitions.duration.shortest
  }),
  color: (e.vars || e).palette.text.disabled,
  [`&.${Qv.completed}`]: {
    color: (e.vars || e).palette.primary.main
  },
  [`&.${Qv.active}`]: {
    color: (e.vars || e).palette.primary.main
  },
  [`&.${Qv.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), c7 = oe("text", {
  name: "MuiStepIcon",
  slot: "Text",
  overridesResolver: (e, t) => t.text
})(ut(({
  theme: e
}) => ({
  fill: (e.vars || e).palette.primary.contrastText,
  fontSize: e.typography.caption.fontSize,
  fontFamily: e.typography.fontFamily
}))), vx = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiStepIcon"
  }), {
    active: o = !1,
    className: i,
    completed: a = !1,
    error: l = !1,
    icon: c,
    ...d
  } = r, f = {
    ...r,
    active: o,
    completed: a,
    error: l
  }, p = l7(f);
  if (typeof c == "number" || typeof c == "string") {
    const g = ke(i, p.root);
    return l ? /* @__PURE__ */ w.jsx(Xv, {
      as: s7,
      className: g,
      ref: n,
      ownerState: f,
      ...d
    }) : a ? /* @__PURE__ */ w.jsx(Xv, {
      as: i7,
      className: g,
      ref: n,
      ownerState: f,
      ...d
    }) : /* @__PURE__ */ w.jsxs(Xv, {
      className: g,
      ref: n,
      ownerState: f,
      ...d,
      children: [QO || (QO = /* @__PURE__ */ w.jsx("circle", {
        cx: "12",
        cy: "12",
        r: "12"
      })), /* @__PURE__ */ w.jsx(c7, {
        className: p.text,
        x: "12",
        y: "12",
        textAnchor: "middle",
        dominantBaseline: "central",
        ownerState: f,
        children: c
      })]
    });
  }
  return c;
});
process.env.NODE_ENV !== "production" && (vx.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Whether this step is active.
   * @default false
   */
  active: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: s.bool,
  /**
   * If `true`, the step is marked as failed.
   * @default false
   */
  error: s.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function u7(e) {
  return gt("MuiStepLabel", e);
}
const sl = vt("MuiStepLabel", ["root", "horizontal", "vertical", "label", "active", "completed", "error", "disabled", "iconContainer", "alternativeLabel", "labelContainer"]), d7 = (e) => {
  const {
    classes: t,
    orientation: n,
    active: r,
    completed: o,
    error: i,
    disabled: a,
    alternativeLabel: l
  } = e;
  return Ct({
    root: ["root", n, i && "error", a && "disabled", l && "alternativeLabel"],
    label: ["label", r && "active", o && "completed", i && "error", a && "disabled", l && "alternativeLabel"],
    iconContainer: ["iconContainer", r && "active", o && "completed", i && "error", a && "disabled", l && "alternativeLabel"],
    labelContainer: ["labelContainer", l && "alternativeLabel"]
  }, u7, t);
}, f7 = oe("span", {
  name: "MuiStepLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation]];
  }
})({
  display: "flex",
  alignItems: "center",
  [`&.${sl.alternativeLabel}`]: {
    flexDirection: "column"
  },
  [`&.${sl.disabled}`]: {
    cursor: "default"
  },
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      textAlign: "left",
      padding: "8px 0"
    }
  }]
}), p7 = oe("span", {
  name: "MuiStepLabel",
  slot: "Label",
  overridesResolver: (e, t) => t.label
})(ut(({
  theme: e
}) => ({
  ...e.typography.body2,
  display: "block",
  transition: e.transitions.create("color", {
    duration: e.transitions.duration.shortest
  }),
  [`&.${sl.active}`]: {
    color: (e.vars || e).palette.text.primary,
    fontWeight: 500
  },
  [`&.${sl.completed}`]: {
    color: (e.vars || e).palette.text.primary,
    fontWeight: 500
  },
  [`&.${sl.alternativeLabel}`]: {
    marginTop: 16
  },
  [`&.${sl.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), h7 = oe("span", {
  name: "MuiStepLabel",
  slot: "IconContainer",
  overridesResolver: (e, t) => t.iconContainer
})({
  flexShrink: 0,
  display: "flex",
  paddingRight: 8,
  [`&.${sl.alternativeLabel}`]: {
    paddingRight: 0
  }
}), g7 = oe("span", {
  name: "MuiStepLabel",
  slot: "LabelContainer",
  overridesResolver: (e, t) => t.labelContainer
})(ut(({
  theme: e
}) => ({
  width: "100%",
  color: (e.vars || e).palette.text.secondary,
  [`&.${sl.alternativeLabel}`]: {
    textAlign: "center"
  }
}))), vb = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiStepLabel"
  }), {
    children: o,
    className: i,
    componentsProps: a = {},
    error: l = !1,
    icon: c,
    optional: d,
    slots: f = {},
    slotProps: p = {},
    StepIconComponent: g,
    StepIconProps: b,
    ...v
  } = r, {
    alternativeLabel: y,
    orientation: S
  } = m.useContext(Od), {
    active: E,
    disabled: I,
    completed: O,
    icon: T
  } = m.useContext(Yp), P = c || T;
  let R = g;
  P && !R && (R = vx);
  const F = {
    ...r,
    active: E,
    alternativeLabel: y,
    completed: O,
    disabled: I,
    error: l,
    orientation: S
  }, A = d7(F), _ = {
    slots: f,
    slotProps: {
      stepIcon: b,
      ...a,
      ...p
    }
  }, [C, D] = gn("label", {
    elementType: p7,
    externalForwardedProps: _,
    ownerState: F
  }), [L, B] = gn("stepIcon", {
    elementType: R,
    externalForwardedProps: _,
    ownerState: F
  });
  return /* @__PURE__ */ w.jsxs(f7, {
    className: ke(A.root, i),
    ref: n,
    ownerState: F,
    ...v,
    children: [P || L ? /* @__PURE__ */ w.jsx(h7, {
      className: A.iconContainer,
      ownerState: F,
      children: /* @__PURE__ */ w.jsx(L, {
        completed: O,
        active: E,
        error: l,
        icon: P,
        ...B
      })
    }) : null, /* @__PURE__ */ w.jsxs(g7, {
      className: A.labelContainer,
      ownerState: F,
      children: [o ? /* @__PURE__ */ w.jsx(C, {
        ...D,
        className: ke(A.label, D == null ? void 0 : D.className),
        children: o
      }) : null, d]
    })]
  });
});
process.env.NODE_ENV !== "production" && (vb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * In most cases will simply be a string containing a title for the label.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The props used for each slot inside.
   * @default {}
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: s.shape({
    label: s.object
  }),
  /**
   * If `true`, the step is marked as failed.
   * @default false
   */
  error: s.bool,
  /**
   * Override the default label of the step icon.
   */
  icon: s.node,
  /**
   * The optional node to display.
   */
  optional: s.node,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    label: s.oneOfType([s.func, s.object]),
    stepIcon: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    label: s.elementType,
    stepIcon: s.elementType
  }),
  /**
   * The component to render in place of the [`StepIcon`](https://mui.com/material-ui/api/step-icon/).
   * @deprecated Use `slots.stepIcon` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  StepIconComponent: s.elementType,
  /**
   * Props applied to the [`StepIcon`](https://mui.com/material-ui/api/step-icon/) element.
   * @deprecated Use `slotProps.stepIcon` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  StepIconProps: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
vb.muiName = "StepLabel";
function m7(e) {
  return gt("MuiStepButton", e);
}
const XO = vt("MuiStepButton", ["root", "horizontal", "vertical", "touchRipple"]), b7 = (e) => {
  const {
    classes: t,
    orientation: n
  } = e;
  return Ct({
    root: ["root", n],
    touchRipple: ["touchRipple"]
  }, m7, t);
}, y7 = oe(va, {
  name: "MuiStepButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${XO.touchRipple}`]: t.touchRipple
    }, t.root, t[n.orientation]];
  }
})({
  width: "100%",
  padding: "24px 16px",
  margin: "-24px -16px",
  boxSizing: "content-box",
  [`& .${XO.touchRipple}`]: {
    color: "rgba(0, 0, 0, 0.3)"
  },
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      justifyContent: "flex-start",
      padding: "8px",
      margin: "-8px"
    }
  }]
}), IM = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiStepButton"
  }), {
    children: o,
    className: i,
    icon: a,
    optional: l,
    ...c
  } = r, {
    disabled: d,
    active: f
  } = m.useContext(Yp), {
    orientation: p
  } = m.useContext(Od), g = {
    ...r,
    orientation: p
  }, b = b7(g), v = {
    icon: a,
    optional: l
  }, y = pc(o, ["StepLabel"]) ? /* @__PURE__ */ m.cloneElement(o, v) : /* @__PURE__ */ w.jsx(vb, {
    ...v,
    children: o
  });
  return /* @__PURE__ */ w.jsx(y7, {
    focusRipple: !0,
    disabled: d,
    TouchRippleProps: {
      className: b.touchRipple
    },
    className: ke(b.root, i),
    ref: n,
    ownerState: g,
    "aria-current": f ? "step" : void 0,
    ...c,
    children: y
  });
});
process.env.NODE_ENV !== "production" && (IM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The icon displayed by the step label.
   */
  icon: s.node,
  /**
   * The optional node to display.
   */
  optional: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function v7(e) {
  return gt("MuiStepConnector", e);
}
vt("MuiStepConnector", ["root", "horizontal", "vertical", "alternativeLabel", "active", "completed", "disabled", "line", "lineHorizontal", "lineVertical"]);
const w7 = (e) => {
  const {
    classes: t,
    orientation: n,
    alternativeLabel: r,
    active: o,
    completed: i,
    disabled: a
  } = e, l = {
    root: ["root", n, r && "alternativeLabel", o && "active", i && "completed", a && "disabled"],
    line: ["line", `line${Me(n)}`]
  };
  return Ct(l, v7, t);
}, C7 = oe("div", {
  name: "MuiStepConnector",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation], n.alternativeLabel && t.alternativeLabel, n.completed && t.completed];
  }
})({
  flex: "1 1 auto",
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      marginLeft: 12
      // half icon
    }
  }, {
    props: {
      alternativeLabel: !0
    },
    style: {
      position: "absolute",
      top: 12,
      left: "calc(-50% + 20px)",
      right: "calc(50% + 20px)"
    }
  }]
}), x7 = oe("span", {
  name: "MuiStepConnector",
  slot: "Line",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.line, t[`line${Me(n.orientation)}`]];
  }
})(ut(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[600];
  return {
    display: "block",
    borderColor: e.vars ? e.vars.palette.StepConnector.border : t,
    variants: [{
      props: {
        orientation: "horizontal"
      },
      style: {
        borderTopStyle: "solid",
        borderTopWidth: 1
      }
    }, {
      props: {
        orientation: "vertical"
      },
      style: {
        borderLeftStyle: "solid",
        borderLeftWidth: 1,
        minHeight: 24
      }
    }]
  };
})), RM = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiStepConnector"
  }), {
    className: o,
    ...i
  } = r, {
    alternativeLabel: a,
    orientation: l = "horizontal"
  } = m.useContext(Od), {
    active: c,
    disabled: d,
    completed: f
  } = m.useContext(Yp), p = {
    ...r,
    alternativeLabel: a,
    orientation: l,
    active: c,
    completed: f,
    disabled: d
  }, g = w7(p);
  return /* @__PURE__ */ w.jsx(C7, {
    className: ke(g.root, o),
    ref: n,
    ownerState: p,
    ...i,
    children: /* @__PURE__ */ w.jsx(x7, {
      className: g.line,
      ownerState: p
    })
  });
});
process.env.NODE_ENV !== "production" && (RM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function S7(e) {
  return gt("MuiStepper", e);
}
vt("MuiStepper", ["root", "horizontal", "vertical", "nonLinear", "alternativeLabel"]);
const E7 = (e) => {
  const {
    orientation: t,
    nonLinear: n,
    alternativeLabel: r,
    classes: o
  } = e;
  return Ct({
    root: ["root", t, n && "nonLinear", r && "alternativeLabel"]
  }, S7, o);
}, T7 = oe("div", {
  name: "MuiStepper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation], n.alternativeLabel && t.alternativeLabel, n.nonLinear && t.nonLinear];
  }
})({
  display: "flex",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      flexDirection: "row",
      alignItems: "center"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      flexDirection: "column"
    }
  }, {
    props: {
      alternativeLabel: !0
    },
    style: {
      alignItems: "flex-start"
    }
  }]
}), O7 = /* @__PURE__ */ w.jsx(RM, {}), _M = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiStepper"
  }), {
    activeStep: o = 0,
    alternativeLabel: i = !1,
    children: a,
    className: l,
    component: c = "div",
    connector: d = O7,
    nonLinear: f = !1,
    orientation: p = "horizontal",
    ...g
  } = r, b = {
    ...r,
    nonLinear: f,
    alternativeLabel: i,
    orientation: p,
    component: c
  }, v = E7(b), y = m.Children.toArray(a).filter(Boolean), S = y.map((I, O) => /* @__PURE__ */ m.cloneElement(I, {
    index: O,
    last: O + 1 === y.length,
    ...I.props
  })), E = m.useMemo(() => ({
    activeStep: o,
    alternativeLabel: i,
    connector: d,
    nonLinear: f,
    orientation: p
  }), [o, i, d, f, p]);
  return /* @__PURE__ */ w.jsx(Od.Provider, {
    value: E,
    children: /* @__PURE__ */ w.jsx(T7, {
      as: c,
      ownerState: b,
      className: ke(v.root, l),
      ref: n,
      ...g,
      children: S
    })
  });
});
process.env.NODE_ENV !== "production" && (_M.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the active step (zero based index).
   * Set to -1 to disable all the steps.
   * @default 0
   */
  activeStep: dl,
  /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   * @default false
   */
  alternativeLabel: s.bool,
  /**
   * Two or more `<Step />` components.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * An element to be placed between each step.
   * @default <StepConnector />
   */
  connector: s.element,
  /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   * @default false
   */
  nonLinear: s.bool,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: s.oneOf(["horizontal", "vertical"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const kM = /* @__PURE__ */ m.createContext();
process.env.NODE_ENV !== "production" && (kM.displayName = "TableContext");
const MM = /* @__PURE__ */ m.createContext();
process.env.NODE_ENV !== "production" && (MM.displayName = "Tablelvl2Context");
function P7(e) {
  return gt("MuiTableCell", e);
}
const I7 = vt("MuiTableCell", ["root", "head", "body", "footer", "sizeSmall", "sizeMedium", "paddingCheckbox", "paddingNone", "alignLeft", "alignCenter", "alignRight", "alignJustify", "stickyHeader"]), R7 = (e) => {
  const {
    classes: t,
    variant: n,
    align: r,
    padding: o,
    size: i,
    stickyHeader: a
  } = e, l = {
    root: ["root", n, a && "stickyHeader", r !== "inherit" && `align${Me(r)}`, o !== "normal" && `padding${Me(o)}`, `size${Me(i)}`]
  };
  return Ct(l, P7, t);
}, _7 = oe("td", {
  name: "MuiTableCell",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`size${Me(n.size)}`], n.padding !== "normal" && t[`padding${Me(n.padding)}`], n.align !== "inherit" && t[`align${Me(n.align)}`], n.stickyHeader && t.stickyHeader];
  }
})(ut(({
  theme: e
}) => ({
  ...e.typography.body2,
  display: "table-cell",
  verticalAlign: "inherit",
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: e.vars ? `1px solid ${e.vars.palette.TableCell.border}` : `1px solid
    ${e.palette.mode === "light" ? ml(Vt(e.palette.divider, 1), 0.88) : gl(Vt(e.palette.divider, 1), 0.68)}`,
  textAlign: "left",
  padding: 16,
  variants: [{
    props: {
      variant: "head"
    },
    style: {
      color: (e.vars || e).palette.text.primary,
      lineHeight: e.typography.pxToRem(24),
      fontWeight: e.typography.fontWeightMedium
    }
  }, {
    props: {
      variant: "body"
    },
    style: {
      color: (e.vars || e).palette.text.primary
    }
  }, {
    props: {
      variant: "footer"
    },
    style: {
      color: (e.vars || e).palette.text.secondary,
      lineHeight: e.typography.pxToRem(21),
      fontSize: e.typography.pxToRem(12)
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      padding: "6px 16px",
      [`&.${I7.paddingCheckbox}`]: {
        width: 24,
        // prevent the checkbox column from growing
        padding: "0 12px 0 16px",
        "& > *": {
          padding: 0
        }
      }
    }
  }, {
    props: {
      padding: "checkbox"
    },
    style: {
      width: 48,
      // prevent the checkbox column from growing
      padding: "0 0 0 4px"
    }
  }, {
    props: {
      padding: "none"
    },
    style: {
      padding: 0
    }
  }, {
    props: {
      align: "left"
    },
    style: {
      textAlign: "left"
    }
  }, {
    props: {
      align: "center"
    },
    style: {
      textAlign: "center"
    }
  }, {
    props: {
      align: "right"
    },
    style: {
      textAlign: "right",
      flexDirection: "row-reverse"
    }
  }, {
    props: {
      align: "justify"
    },
    style: {
      textAlign: "justify"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.stickyHeader,
    style: {
      position: "sticky",
      top: 0,
      zIndex: 2,
      backgroundColor: (e.vars || e).palette.background.default
    }
  }]
}))), um = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiTableCell"
  }), {
    align: o = "inherit",
    className: i,
    component: a,
    padding: l,
    scope: c,
    size: d,
    sortDirection: f,
    variant: p,
    ...g
  } = r, b = m.useContext(kM), v = m.useContext(MM), y = v && v.variant === "head";
  let S;
  a ? S = a : S = y ? "th" : "td";
  let E = c;
  S === "td" ? E = void 0 : !E && y && (E = "col");
  const I = p || v && v.variant, O = {
    ...r,
    align: o,
    component: S,
    padding: l || (b && b.padding ? b.padding : "normal"),
    size: d || (b && b.size ? b.size : "medium"),
    sortDirection: f,
    stickyHeader: I === "head" && b && b.stickyHeader,
    variant: I
  }, T = R7(O);
  let P = null;
  return f && (P = f === "asc" ? "ascending" : "descending"), /* @__PURE__ */ w.jsx(_7, {
    as: S,
    ref: n,
    className: ke(T.root, i),
    "aria-sort": P,
    scope: E,
    ownerState: O,
    ...g
  });
});
process.env.NODE_ENV !== "production" && (um.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */
  align: s.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */
  padding: s.oneOf(["checkbox", "none", "normal"]),
  /**
   * Set scope attribute.
   */
  scope: s.string,
  /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * Set aria-sort direction.
   */
  sortDirection: s.oneOf(["asc", "desc", !1]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */
  variant: s.oneOfType([s.oneOf(["body", "footer", "head"]), s.string])
});
function k7(e) {
  return gt("MuiToolbar", e);
}
vt("MuiToolbar", ["root", "gutters", "regular", "dense"]);
const M7 = (e) => {
  const {
    classes: t,
    disableGutters: n,
    variant: r
  } = e;
  return Ct({
    root: ["root", !n && "gutters", r]
  }, k7, t);
}, A7 = oe("div", {
  name: "MuiToolbar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disableGutters && t.gutters, t[n.variant]];
  }
})(ut(({
  theme: e
}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: e.spacing(2),
      paddingRight: e.spacing(2),
      [e.breakpoints.up("sm")]: {
        paddingLeft: e.spacing(3),
        paddingRight: e.spacing(3)
      }
    }
  }, {
    props: {
      variant: "dense"
    },
    style: {
      minHeight: 48
    }
  }, {
    props: {
      variant: "regular"
    },
    style: e.mixins.toolbar
  }]
}))), AM = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiToolbar"
  }), {
    className: o,
    component: i = "div",
    disableGutters: a = !1,
    variant: l = "regular",
    ...c
  } = r, d = {
    ...r,
    component: i,
    disableGutters: a,
    variant: l
  }, f = M7(d);
  return /* @__PURE__ */ w.jsx(A7, {
    as: i,
    className: ke(f.root, o),
    ref: n,
    ownerState: d,
    ...c
  });
});
process.env.NODE_ENV !== "production" && (AM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   * The Toolbar is a flex container, allowing flex item properties to be used to lay out the children.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, disables gutter padding.
   * @default false
   */
  disableGutters: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   * @default 'regular'
   */
  variant: s.oneOfType([s.oneOf(["dense", "regular"]), s.string])
});
const D7 = At(/* @__PURE__ */ w.jsx("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft"), N7 = At(/* @__PURE__ */ w.jsx("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight"), DM = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    backIconButtonProps: r,
    count: o,
    disabled: i = !1,
    getItemAriaLabel: a,
    nextIconButtonProps: l,
    onPageChange: c,
    page: d,
    rowsPerPage: f,
    showFirstButton: p,
    showLastButton: g,
    slots: b = {},
    slotProps: v = {},
    ...y
  } = t, S = mi(), E = (z) => {
    c(z, 0);
  }, I = (z) => {
    c(z, d - 1);
  }, O = (z) => {
    c(z, d + 1);
  }, T = (z) => {
    c(z, Math.max(0, Math.ceil(o / f) - 1));
  }, P = b.firstButton ?? ks, R = b.lastButton ?? ks, F = b.nextButton ?? ks, A = b.previousButton ?? ks, _ = b.firstButtonIcon ?? AK, C = b.lastButtonIcon ?? DK, D = b.nextButtonIcon ?? N7, L = b.previousButtonIcon ?? D7, B = S ? R : P, H = S ? F : A, k = S ? A : F, N = S ? P : R, j = S ? v.lastButton : v.firstButton, W = S ? v.nextButton : v.previousButton, V = S ? v.previousButton : v.nextButton, $ = S ? v.firstButton : v.lastButton;
  return /* @__PURE__ */ w.jsxs("div", {
    ref: n,
    ...y,
    children: [p && /* @__PURE__ */ w.jsx(B, {
      onClick: E,
      disabled: i || d === 0,
      "aria-label": a("first", d),
      title: a("first", d),
      ...j,
      children: S ? /* @__PURE__ */ w.jsx(C, {
        ...v.lastButtonIcon
      }) : /* @__PURE__ */ w.jsx(_, {
        ...v.firstButtonIcon
      })
    }), /* @__PURE__ */ w.jsx(H, {
      onClick: I,
      disabled: i || d === 0,
      color: "inherit",
      "aria-label": a("previous", d),
      title: a("previous", d),
      ...W ?? r,
      children: S ? /* @__PURE__ */ w.jsx(D, {
        ...v.nextButtonIcon
      }) : /* @__PURE__ */ w.jsx(L, {
        ...v.previousButtonIcon
      })
    }), /* @__PURE__ */ w.jsx(k, {
      onClick: O,
      disabled: i || (o !== -1 ? d >= Math.ceil(o / f) - 1 : !1),
      color: "inherit",
      "aria-label": a("next", d),
      title: a("next", d),
      ...V ?? l,
      children: S ? /* @__PURE__ */ w.jsx(L, {
        ...v.previousButtonIcon
      }) : /* @__PURE__ */ w.jsx(D, {
        ...v.nextButtonIcon
      })
    }), g && /* @__PURE__ */ w.jsx(N, {
      onClick: T,
      disabled: i || d >= Math.ceil(o / f) - 1,
      "aria-label": a("last", d),
      title: a("last", d),
      ...$,
      children: S ? /* @__PURE__ */ w.jsx(_, {
        ...v.firstButtonIcon
      }) : /* @__PURE__ */ w.jsx(C, {
        ...v.lastButtonIcon
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (DM.propTypes = {
  /**
   * Props applied to the back arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */
  backIconButtonProps: s.object,
  /**
   * The total number of rows.
   */
  count: s.number.isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   *
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @returns {string}
   */
  getItemAriaLabel: s.func.isRequired,
  /**
   * Props applied to the next arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */
  nextIconButtonProps: s.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: s.func.isRequired,
  /**
   * The zero-based index of the current page.
   */
  page: s.number.isRequired,
  /**
   * The number of rows per page.
   */
  rowsPerPage: s.number.isRequired,
  /**
   * If `true`, show the first-page button.
   */
  showFirstButton: s.bool.isRequired,
  /**
   * If `true`, show the last-page button.
   */
  showLastButton: s.bool.isRequired,
  /**
   * The props used for each slot inside the TablePaginationActions.
   * @default {}
   */
  slotProps: s.shape({
    firstButton: s.object,
    firstButtonIcon: s.object,
    lastButton: s.object,
    lastButtonIcon: s.object,
    nextButton: s.object,
    nextButtonIcon: s.object,
    previousButton: s.object,
    previousButtonIcon: s.object
  }),
  /**
   * The components used for each slot inside the TablePaginationActions.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: s.shape({
    firstButton: s.elementType,
    firstButtonIcon: s.elementType,
    lastButton: s.elementType,
    lastButtonIcon: s.elementType,
    nextButton: s.elementType,
    nextButtonIcon: s.elementType,
    previousButton: s.elementType,
    previousButtonIcon: s.elementType
  })
});
function F7(e) {
  return gt("MuiTablePagination", e);
}
const bc = vt("MuiTablePagination", ["root", "toolbar", "spacer", "selectLabel", "selectRoot", "select", "selectIcon", "input", "menuItem", "displayedRows", "actions"]);
var JO;
const $7 = oe(um, {
  name: "MuiTablePagination",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(ut(({
  theme: e
}) => ({
  overflow: "auto",
  color: (e.vars || e).palette.text.primary,
  fontSize: e.typography.pxToRem(14),
  // Increase the specificity to override TableCell.
  "&:last-child": {
    padding: 0
  }
}))), L7 = oe(AM, {
  name: "MuiTablePagination",
  slot: "Toolbar",
  overridesResolver: (e, t) => ({
    [`& .${bc.actions}`]: t.actions,
    ...t.toolbar
  })
})(ut(({
  theme: e
}) => ({
  minHeight: 52,
  paddingRight: 2,
  [`${e.breakpoints.up("xs")} and (orientation: landscape)`]: {
    minHeight: 52
  },
  [e.breakpoints.up("sm")]: {
    minHeight: 52,
    paddingRight: 2
  },
  [`& .${bc.actions}`]: {
    flexShrink: 0,
    marginLeft: 20
  }
}))), j7 = oe("div", {
  name: "MuiTablePagination",
  slot: "Spacer",
  overridesResolver: (e, t) => t.spacer
})({
  flex: "1 1 100%"
}), B7 = oe("p", {
  name: "MuiTablePagination",
  slot: "SelectLabel",
  overridesResolver: (e, t) => t.selectLabel
})(ut(({
  theme: e
}) => ({
  ...e.typography.body2,
  flexShrink: 0
}))), V7 = oe(Kp, {
  name: "MuiTablePagination",
  slot: "Select",
  overridesResolver: (e, t) => ({
    [`& .${bc.selectIcon}`]: t.selectIcon,
    [`& .${bc.select}`]: t.select,
    ...t.input,
    ...t.selectRoot
  })
})({
  color: "inherit",
  fontSize: "inherit",
  flexShrink: 0,
  marginRight: 32,
  marginLeft: 8,
  [`& .${bc.select}`]: {
    paddingLeft: 8,
    paddingRight: 24,
    textAlign: "right",
    textAlignLast: "right"
    // Align <select> on Chrome.
  }
}), H7 = oe(ts, {
  name: "MuiTablePagination",
  slot: "MenuItem",
  overridesResolver: (e, t) => t.menuItem
})({}), U7 = oe("p", {
  name: "MuiTablePagination",
  slot: "DisplayedRows",
  overridesResolver: (e, t) => t.displayedRows
})(ut(({
  theme: e
}) => ({
  ...e.typography.body2,
  flexShrink: 0
})));
function z7({
  from: e,
  to: t,
  count: n
}) {
  return `${e}–${t} of ${n !== -1 ? n : `more than ${t}`}`;
}
function G7(e) {
  return `Go to ${e} page`;
}
const W7 = (e) => {
  const {
    classes: t
  } = e;
  return Ct({
    root: ["root"],
    toolbar: ["toolbar"],
    spacer: ["spacer"],
    selectLabel: ["selectLabel"],
    select: ["select"],
    input: ["input"],
    selectIcon: ["selectIcon"],
    menuItem: ["menuItem"],
    displayedRows: ["displayedRows"],
    actions: ["actions"]
  }, F7, t);
}, NM = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiTablePagination"
  }), {
    ActionsComponent: o = DM,
    backIconButtonProps: i,
    colSpan: a,
    component: l = um,
    count: c,
    disabled: d = !1,
    getItemAriaLabel: f = G7,
    labelDisplayedRows: p = z7,
    labelRowsPerPage: g = "Rows per page:",
    nextIconButtonProps: b,
    onPageChange: v,
    onRowsPerPageChange: y,
    page: S,
    rowsPerPage: E,
    rowsPerPageOptions: I = [10, 25, 50, 100],
    SelectProps: O = {},
    showFirstButton: T = !1,
    showLastButton: P = !1,
    slotProps: R = {},
    slots: F = {},
    ...A
  } = r, _ = r, C = W7(_), D = (R == null ? void 0 : R.select) ?? O, L = D.native ? "option" : H7;
  let B;
  (l === um || l === "td") && (B = a || 1e3);
  const H = wc(D.id), k = wc(D.labelId), N = () => c === -1 ? (S + 1) * E : E === -1 ? c : Math.min(c, (S + 1) * E), j = {
    slots: F,
    slotProps: R
  }, [W, V] = gn("root", {
    ref: n,
    className: C.root,
    elementType: $7,
    externalForwardedProps: {
      ...j,
      component: l,
      ...A
    },
    ownerState: _,
    additionalProps: {
      colSpan: B
    }
  }), [$, z] = gn("toolbar", {
    className: C.toolbar,
    elementType: L7,
    externalForwardedProps: j,
    ownerState: _
  }), [ne, K] = gn("spacer", {
    className: C.spacer,
    elementType: j7,
    externalForwardedProps: j,
    ownerState: _
  }), [Q, re] = gn("selectLabel", {
    className: C.selectLabel,
    elementType: B7,
    externalForwardedProps: j,
    ownerState: _,
    additionalProps: {
      id: k
    }
  }), [te, ie] = gn("select", {
    className: C.select,
    elementType: V7,
    externalForwardedProps: j,
    ownerState: _
  }), [ae, ce] = gn("menuItem", {
    className: C.menuItem,
    elementType: L,
    externalForwardedProps: j,
    ownerState: _
  }), [le, we] = gn("displayedRows", {
    className: C.displayedRows,
    elementType: U7,
    externalForwardedProps: j,
    ownerState: _
  });
  return /* @__PURE__ */ w.jsx(W, {
    ...V,
    children: /* @__PURE__ */ w.jsxs($, {
      ...z,
      children: [/* @__PURE__ */ w.jsx(ne, {
        ...K
      }), I.length > 1 && /* @__PURE__ */ w.jsx(Q, {
        ...re,
        children: g
      }), I.length > 1 && /* @__PURE__ */ w.jsx(te, {
        variant: "standard",
        ...!D.variant && {
          input: JO || (JO = /* @__PURE__ */ w.jsx(kc, {}))
        },
        value: E,
        onChange: y,
        id: H,
        labelId: k,
        ...D,
        classes: {
          ...D.classes,
          // TODO v5 remove `classes.input`
          root: ke(C.input, C.selectRoot, (D.classes || {}).root),
          select: ke(C.select, (D.classes || {}).select),
          // TODO v5 remove `selectIcon`
          icon: ke(C.selectIcon, (D.classes || {}).icon)
        },
        disabled: d,
        ...ie,
        children: I.map((q) => /* @__PURE__ */ fc(ae, {
          ...ce,
          key: q.label ? q.label : q,
          value: q.value ? q.value : q
        }, q.label ? q.label : q))
      }), /* @__PURE__ */ w.jsx(le, {
        ...we,
        children: p({
          from: c === 0 ? 0 : S * E + 1,
          to: N(),
          count: c === -1 ? -1 : c,
          page: S
        })
      }), /* @__PURE__ */ w.jsx(o, {
        className: C.actions,
        backIconButtonProps: i,
        count: c,
        nextIconButtonProps: b,
        onPageChange: v,
        page: S,
        rowsPerPage: E,
        showFirstButton: T,
        showLastButton: P,
        slotProps: R.actions,
        slots: F.actions,
        getItemAriaLabel: f,
        disabled: d
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (NM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The component used for displaying the actions.
   * Either a string to use a HTML element or a component.
   * @default TablePaginationActions
   */
  ActionsComponent: s.elementType,
  /**
   * Props applied to the back arrow [`IconButton`](https://mui.com/material-ui/api/icon-button/) component.
   *
   * This prop is an alias for `slotProps.actions.previousButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.previousButton` instead.
   */
  backIconButtonProps: s.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  colSpan: s.number,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The total number of rows.
   *
   * To enable server side pagination for an unknown number of items, provide -1.
   */
  count: dl.isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('first' | 'last' | 'next' | 'previous').
   * @returns {string}
   * @default function defaultGetAriaLabel(type) {
   *   return `Go to ${type} page`;
   * }
   */
  getItemAriaLabel: s.func,
  /**
   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
   * object.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default function defaultLabelDisplayedRows({ from, to, count }) {
   *   return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
   * }
   */
  labelDisplayedRows: s.func,
  /**
   * Customize the rows per page label.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Rows per page:'
   */
  labelRowsPerPage: s.node,
  /**
   * Props applied to the next arrow [`IconButton`](https://mui.com/material-ui/api/icon-button/) element.
   *
   * This prop is an alias for `slotProps.actions.nextButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.nextButton` instead.
   */
  nextIconButtonProps: s.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.MouseEvent<HTMLButtonElement> | null} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: s.func.isRequired,
  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   */
  onRowsPerPageChange: s.func,
  /**
   * The zero-based index of the current page.
   */
  page: Go(dl.isRequired, (e) => {
    const {
      count: t,
      page: n,
      rowsPerPage: r
    } = e;
    if (t === -1)
      return null;
    const o = Math.max(0, Math.ceil(t / r) - 1);
    return n < 0 || n > o ? new Error(`MUI: The page prop of a TablePagination is out of range (0 to ${o}, but page is ${n}).`) : null;
  }),
  /**
   * The number of rows per page.
   *
   * Set -1 to display all the rows.
   */
  rowsPerPage: dl.isRequired,
  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   * Use -1 for the value with a custom label to show all the rows.
   * @default [10, 25, 50, 100]
   */
  rowsPerPageOptions: s.arrayOf(s.oneOfType([s.number, s.shape({
    label: s.string.isRequired,
    value: s.number.isRequired
  })]).isRequired),
  /**
   * Props applied to the rows per page [`Select`](https://mui.com/material-ui/api/select/) element.
   *
   * This prop is an alias for `slotProps.select` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.select` instead.
   *
   * @default {}
   */
  SelectProps: s.object,
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: s.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: s.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    actions: s.shape({
      firstButton: s.object,
      firstButtonIcon: s.object,
      lastButton: s.object,
      lastButtonIcon: s.object,
      nextButton: s.object,
      nextButtonIcon: s.object,
      previousButton: s.object,
      previousButtonIcon: s.object
    }),
    displayedRows: s.oneOfType([s.func, s.object]),
    menuItem: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object]),
    select: s.object,
    selectLabel: s.oneOfType([s.func, s.object]),
    spacer: s.oneOfType([s.func, s.object]),
    toolbar: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    actions: s.shape({
      firstButton: s.elementType,
      firstButtonIcon: s.elementType,
      lastButton: s.elementType,
      lastButtonIcon: s.elementType,
      nextButton: s.elementType,
      nextButtonIcon: s.elementType,
      previousButton: s.elementType,
      previousButtonIcon: s.elementType
    }),
    displayedRows: s.elementType,
    menuItem: s.elementType,
    root: s.elementType,
    select: s.elementType,
    selectLabel: s.elementType,
    spacer: s.elementType,
    toolbar: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function q7(e) {
  return gt("MuiTextField", e);
}
vt("MuiTextField", ["root"]);
const K7 = {
  standard: mb,
  filled: gb,
  outlined: yb
}, Y7 = (e) => {
  const {
    classes: t
  } = e;
  return Ct({
    root: ["root"]
  }, q7, t);
}, Q7 = oe(lx, {
  name: "MuiTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Ea = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const r = St({
    props: t,
    name: "MuiTextField"
  }), {
    autoComplete: o,
    autoFocus: i = !1,
    children: a,
    className: l,
    color: c = "primary",
    defaultValue: d,
    disabled: f = !1,
    error: p = !1,
    FormHelperTextProps: g,
    fullWidth: b = !1,
    helperText: v,
    id: y,
    InputLabelProps: S,
    inputProps: E,
    InputProps: I,
    inputRef: O,
    label: T,
    maxRows: P,
    minRows: R,
    multiline: F = !1,
    name: A,
    onBlur: _,
    onChange: C,
    onFocus: D,
    placeholder: L,
    required: B = !1,
    rows: H,
    select: k = !1,
    SelectProps: N,
    slots: j = {},
    slotProps: W = {},
    type: V,
    value: $,
    variant: z = "outlined",
    ...ne
  } = r, K = {
    ...r,
    autoFocus: i,
    color: c,
    disabled: f,
    error: p,
    fullWidth: b,
    multiline: F,
    required: B,
    select: k,
    variant: z
  }, Q = Y7(K);
  process.env.NODE_ENV !== "production" && k && !a && console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
  const re = wc(y), te = v && re ? `${re}-helper-text` : void 0, ie = T && re ? `${re}-label` : void 0, ae = K7[z], ce = {
    slots: j,
    slotProps: {
      input: I,
      inputLabel: S,
      htmlInput: E,
      formHelperText: g,
      select: N,
      ...W
    }
  }, le = {}, we = ce.slotProps.inputLabel;
  z === "outlined" && (we && typeof we.shrink < "u" && (le.notched = we.shrink), le.label = T), k && ((!N || !N.native) && (le.id = void 0), le["aria-describedby"] = void 0);
  const [q, Ee] = gn("input", {
    elementType: ae,
    externalForwardedProps: ce,
    additionalProps: le,
    ownerState: K
  }), [_e, $e] = gn("inputLabel", {
    elementType: fx,
    externalForwardedProps: ce,
    ownerState: K
  }), [Le, Ze] = gn("htmlInput", {
    elementType: "input",
    externalForwardedProps: ce,
    ownerState: K
  }), [J, fe] = gn("formHelperText", {
    elementType: cx,
    externalForwardedProps: ce,
    ownerState: K
  }), [me, Oe] = gn("select", {
    elementType: Kp,
    externalForwardedProps: ce,
    ownerState: K
  }), Ce = /* @__PURE__ */ w.jsx(q, {
    "aria-describedby": te,
    autoComplete: o,
    autoFocus: i,
    defaultValue: d,
    fullWidth: b,
    multiline: F,
    name: A,
    rows: H,
    maxRows: P,
    minRows: R,
    type: V,
    value: $,
    id: re,
    inputRef: O,
    onBlur: _,
    onChange: C,
    onFocus: D,
    placeholder: L,
    inputProps: Ze,
    slots: {
      input: j.htmlInput ? Le : void 0
    },
    ...Ee
  });
  return /* @__PURE__ */ w.jsxs(Q7, {
    className: ke(Q.root, l),
    disabled: f,
    error: p,
    fullWidth: b,
    ref: n,
    required: B,
    color: c,
    variant: z,
    ownerState: K,
    ...ne,
    children: [T != null && T !== "" && /* @__PURE__ */ w.jsx(_e, {
      htmlFor: re,
      id: ie,
      ...$e,
      children: T
    }), k ? /* @__PURE__ */ w.jsx(me, {
      "aria-describedby": te,
      id: re,
      labelId: ie,
      value: $,
      input: Ce,
      ...Oe,
      children: a
    }) : Ce, v && /* @__PURE__ */ w.jsx(J, {
      id: te,
      ...fe,
      children: v
    })]
  });
});
process.env.NODE_ENV !== "production" && (Ea.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: s.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: s.bool,
  /**
   * @ignore
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: s.bool,
  /**
   * Props applied to the [`FormHelperText`](https://mui.com/material-ui/api/form-helper-text/) element.
   * @deprecated Use `slotProps.formHelperText` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  FormHelperTextProps: s.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The helper text content.
   */
  helperText: s.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: s.string,
  /**
   * Props applied to the [`InputLabel`](https://mui.com/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   * @deprecated Use `slotProps.inputLabel` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputLabelProps: s.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @deprecated Use `slotProps.htmlInput` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: s.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](https://mui.com/material-ui/api/filled-input/),
   * [`OutlinedInput`](https://mui.com/material-ui/api/outlined-input/) or [`Input`](https://mui.com/material-ui/api/input/)
   * component depending on the `variant` prop value.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Wo,
  /**
   * The label content.
   */
  label: s.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: s.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: s.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * @ignore
   */
  onBlur: s.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: s.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: s.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: s.oneOfType([s.number, s.string]),
  /**
   * Render a [`Select`](https://mui.com/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: s.bool,
  /**
   * Props applied to the [`Select`](https://mui.com/material-ui/api/select/) element.
   * @deprecated Use `slotProps.select` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  SelectProps: s.object,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    formHelperText: s.oneOfType([s.func, s.object]),
    htmlInput: s.oneOfType([s.func, s.object]),
    input: s.oneOfType([s.func, s.object]),
    inputLabel: s.oneOfType([s.func, s.object]),
    select: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    formHelperText: s.elementType,
    htmlInput: s.elementType,
    input: s.elementType,
    inputLabel: s.elementType,
    select: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: s.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: s.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: s.oneOf(["filled", "outlined", "standard"])
});
const wx = oe(as)(() => ({
  minWidth: "120px"
})), FM = {
  /*
  components: {
    MuiBreadcrumbs: { defaultProps: {
      expandText: 'Show path',
    }},
    MuiTablePagination: { defaultProps: {
      getItemAriaLabel: (type) => {
        if (type === 'first') {
          return 'Go to first page';
        }
        if (type === 'last') {
          return 'Go to last page';
        }
        if (type === 'next') {
          return 'Go to next page';
        }
        // if (type === 'previous') {
        return 'Go to previous page';
      },
      labelRowsPerPage: 'Rows per page:',
      labelDisplayedRows: ({ from, to, count }) =>
  `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`, 
    }},
    MuiRating: { defaultProps: {
      getLabelText: value => `${value} Star${value !== 1 ? 's' : ''}`,
      emptyLabelText: 'Empty',
    }},
    MuiAutocomplete: { defaultProps: {
      clearText: 'Clear',
      closeText: 'Close',
      loadingText: 'Loading…',
      noOptionsText: 'No options',
      openText: 'Open',
    }},
    MuiAlert: { defaultProps: {
      closeText: 'Close',
    }},
    MuiPagination: {  defaultProps: {
      'aria-label': 'Pagination navigation',
      getItemAriaLabel: (type, page, selected) => {
        if (type === 'page') {
          return `${selected ? '' : 'Go to '}page ${page}`;
        }
        if (type === 'first') {
          return 'Go to first page';
        }
        if (type === 'last') {
          return 'Go to last page';
        }
        if (type === 'next') {
          return 'Go to next page';
        }
        // if (type === 'previous') {
        return 'Go to previous page';
      },
    }},
  },
  */
};
function yl(e, ...t) {
  const n = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((r) => n.searchParams.append("args[]", r)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
function h0() {
  return h0 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, h0.apply(null, arguments);
}
function X7(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Jv = { exports: {} }, Sn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ZO;
function J7() {
  if (ZO) return Sn;
  ZO = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, b = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, S = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, I = e ? Symbol.for("react.scope") : 60119;
  function O(P) {
    if (typeof P == "object" && P !== null) {
      var R = P.$$typeof;
      switch (R) {
        case t:
          switch (P = P.type, P) {
            case c:
            case d:
            case r:
            case i:
            case o:
            case p:
              return P;
            default:
              switch (P = P && P.$$typeof, P) {
                case l:
                case f:
                case v:
                case b:
                case a:
                  return P;
                default:
                  return R;
              }
          }
        case n:
          return R;
      }
    }
  }
  function T(P) {
    return O(P) === d;
  }
  return Sn.AsyncMode = c, Sn.ConcurrentMode = d, Sn.ContextConsumer = l, Sn.ContextProvider = a, Sn.Element = t, Sn.ForwardRef = f, Sn.Fragment = r, Sn.Lazy = v, Sn.Memo = b, Sn.Portal = n, Sn.Profiler = i, Sn.StrictMode = o, Sn.Suspense = p, Sn.isAsyncMode = function(P) {
    return T(P) || O(P) === c;
  }, Sn.isConcurrentMode = T, Sn.isContextConsumer = function(P) {
    return O(P) === l;
  }, Sn.isContextProvider = function(P) {
    return O(P) === a;
  }, Sn.isElement = function(P) {
    return typeof P == "object" && P !== null && P.$$typeof === t;
  }, Sn.isForwardRef = function(P) {
    return O(P) === f;
  }, Sn.isFragment = function(P) {
    return O(P) === r;
  }, Sn.isLazy = function(P) {
    return O(P) === v;
  }, Sn.isMemo = function(P) {
    return O(P) === b;
  }, Sn.isPortal = function(P) {
    return O(P) === n;
  }, Sn.isProfiler = function(P) {
    return O(P) === i;
  }, Sn.isStrictMode = function(P) {
    return O(P) === o;
  }, Sn.isSuspense = function(P) {
    return O(P) === p;
  }, Sn.isValidElementType = function(P) {
    return typeof P == "string" || typeof P == "function" || P === r || P === d || P === i || P === o || P === p || P === g || typeof P == "object" && P !== null && (P.$$typeof === v || P.$$typeof === b || P.$$typeof === a || P.$$typeof === l || P.$$typeof === f || P.$$typeof === S || P.$$typeof === E || P.$$typeof === I || P.$$typeof === y);
  }, Sn.typeOf = O, Sn;
}
var Rn = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var eP;
function Z7() {
  return eP || (eP = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, b = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, S = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, I = e ? Symbol.for("react.scope") : 60119;
    function O(q) {
      return typeof q == "string" || typeof q == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      q === r || q === d || q === i || q === o || q === p || q === g || typeof q == "object" && q !== null && (q.$$typeof === v || q.$$typeof === b || q.$$typeof === a || q.$$typeof === l || q.$$typeof === f || q.$$typeof === S || q.$$typeof === E || q.$$typeof === I || q.$$typeof === y);
    }
    function T(q) {
      if (typeof q == "object" && q !== null) {
        var Ee = q.$$typeof;
        switch (Ee) {
          case t:
            var _e = q.type;
            switch (_e) {
              case c:
              case d:
              case r:
              case i:
              case o:
              case p:
                return _e;
              default:
                var $e = _e && _e.$$typeof;
                switch ($e) {
                  case l:
                  case f:
                  case v:
                  case b:
                  case a:
                    return $e;
                  default:
                    return Ee;
                }
            }
          case n:
            return Ee;
        }
      }
    }
    var P = c, R = d, F = l, A = a, _ = t, C = f, D = r, L = v, B = b, H = n, k = i, N = o, j = p, W = !1;
    function V(q) {
      return W || (W = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), $(q) || T(q) === c;
    }
    function $(q) {
      return T(q) === d;
    }
    function z(q) {
      return T(q) === l;
    }
    function ne(q) {
      return T(q) === a;
    }
    function K(q) {
      return typeof q == "object" && q !== null && q.$$typeof === t;
    }
    function Q(q) {
      return T(q) === f;
    }
    function re(q) {
      return T(q) === r;
    }
    function te(q) {
      return T(q) === v;
    }
    function ie(q) {
      return T(q) === b;
    }
    function ae(q) {
      return T(q) === n;
    }
    function ce(q) {
      return T(q) === i;
    }
    function le(q) {
      return T(q) === o;
    }
    function we(q) {
      return T(q) === p;
    }
    Rn.AsyncMode = P, Rn.ConcurrentMode = R, Rn.ContextConsumer = F, Rn.ContextProvider = A, Rn.Element = _, Rn.ForwardRef = C, Rn.Fragment = D, Rn.Lazy = L, Rn.Memo = B, Rn.Portal = H, Rn.Profiler = k, Rn.StrictMode = N, Rn.Suspense = j, Rn.isAsyncMode = V, Rn.isConcurrentMode = $, Rn.isContextConsumer = z, Rn.isContextProvider = ne, Rn.isElement = K, Rn.isForwardRef = Q, Rn.isFragment = re, Rn.isLazy = te, Rn.isMemo = ie, Rn.isPortal = ae, Rn.isProfiler = ce, Rn.isStrictMode = le, Rn.isSuspense = we, Rn.isValidElementType = O, Rn.typeOf = T;
  }()), Rn;
}
var tP;
function $M() {
  return tP || (tP = 1, process.env.NODE_ENV === "production" ? Jv.exports = J7() : Jv.exports = Z7()), Jv.exports;
}
var g0 = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Zv, nP;
function eY() {
  if (nP) return Zv;
  nP = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, l = 0; l < 10; l++)
        a["_" + String.fromCharCode(l)] = l;
      var c = Object.getOwnPropertyNames(a).map(function(f) {
        return a[f];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        d[f] = f;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Zv = o() ? Object.assign : function(i, a) {
    for (var l, c = r(i), d, f = 1; f < arguments.length; f++) {
      l = Object(arguments[f]);
      for (var p in l)
        t.call(l, p) && (c[p] = l[p]);
      if (e) {
        d = e(l);
        for (var g = 0; g < d.length; g++)
          n.call(l, d[g]) && (c[d[g]] = l[d[g]]);
      }
    }
    return c;
  }, Zv;
}
var ew, rP;
function Cx() {
  if (rP) return ew;
  rP = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ew = e, ew;
}
var oP, iP;
function LM() {
  return iP || (iP = 1, oP = Function.call.bind(Object.prototype.hasOwnProperty)), oP;
}
var tw, sP;
function tY() {
  if (sP) return tw;
  sP = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Cx(), n = {}, r = LM();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function o(i, a, l, c, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in i)
        if (r(i, f)) {
          var p;
          try {
            if (typeof i[f] != "function") {
              var g = Error(
                (c || "React class") + ": " + l + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw g.name = "Invariant Violation", g;
            }
            p = i[f](a, f, c, l, null, t);
          } catch (v) {
            p = v;
          }
          if (p && !(p instanceof Error) && e(
            (c || "React class") + ": type specification of " + l + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof p + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), p instanceof Error && !(p.message in n)) {
            n[p.message] = !0;
            var b = d ? d() : "";
            e(
              "Failed " + l + " type: " + p.message + (b ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, tw = o, tw;
}
var nw, aP;
function nY() {
  if (aP) return nw;
  aP = 1;
  var e = $M(), t = eY(), n = Cx(), r = LM(), o = tY(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(l) {
    var c = "Warning: " + l;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return nw = function(l, c) {
    var d = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function p($) {
      var z = $ && (d && $[d] || $[f]);
      if (typeof z == "function")
        return z;
    }
    var g = "<<anonymous>>", b = {
      array: E("array"),
      bigint: E("bigint"),
      bool: E("boolean"),
      func: E("function"),
      number: E("number"),
      object: E("object"),
      string: E("string"),
      symbol: E("symbol"),
      any: I(),
      arrayOf: O,
      element: T(),
      elementType: P(),
      instanceOf: R,
      node: C(),
      objectOf: A,
      oneOf: F,
      oneOfType: _,
      shape: L,
      exact: B
    };
    function v($, z) {
      return $ === z ? $ !== 0 || 1 / $ === 1 / z : $ !== $ && z !== z;
    }
    function y($, z) {
      this.message = $, this.data = z && typeof z == "object" ? z : {}, this.stack = "";
    }
    y.prototype = Error.prototype;
    function S($) {
      if (process.env.NODE_ENV !== "production")
        var z = {}, ne = 0;
      function K(re, te, ie, ae, ce, le, we) {
        if (ae = ae || g, le = le || ie, we !== n) {
          if (c) {
            var q = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw q.name = "Invariant Violation", q;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Ee = ae + ":" + ie;
            !z[Ee] && // Avoid spamming the console because they are often not actionable except for lib authors
            ne < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + le + "` prop on `" + ae + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), z[Ee] = !0, ne++);
          }
        }
        return te[ie] == null ? re ? te[ie] === null ? new y("The " + ce + " `" + le + "` is marked as required " + ("in `" + ae + "`, but its value is `null`.")) : new y("The " + ce + " `" + le + "` is marked as required in " + ("`" + ae + "`, but its value is `undefined`.")) : null : $(te, ie, ae, ce, le);
      }
      var Q = K.bind(null, !1);
      return Q.isRequired = K.bind(null, !0), Q;
    }
    function E($) {
      function z(ne, K, Q, re, te, ie) {
        var ae = ne[K], ce = N(ae);
        if (ce !== $) {
          var le = j(ae);
          return new y(
            "Invalid " + re + " `" + te + "` of type " + ("`" + le + "` supplied to `" + Q + "`, expected ") + ("`" + $ + "`."),
            { expectedType: $ }
          );
        }
        return null;
      }
      return S(z);
    }
    function I() {
      return S(a);
    }
    function O($) {
      function z(ne, K, Q, re, te) {
        if (typeof $ != "function")
          return new y("Property `" + te + "` of component `" + Q + "` has invalid PropType notation inside arrayOf.");
        var ie = ne[K];
        if (!Array.isArray(ie)) {
          var ae = N(ie);
          return new y("Invalid " + re + " `" + te + "` of type " + ("`" + ae + "` supplied to `" + Q + "`, expected an array."));
        }
        for (var ce = 0; ce < ie.length; ce++) {
          var le = $(ie, ce, Q, re, te + "[" + ce + "]", n);
          if (le instanceof Error)
            return le;
        }
        return null;
      }
      return S(z);
    }
    function T() {
      function $(z, ne, K, Q, re) {
        var te = z[ne];
        if (!l(te)) {
          var ie = N(te);
          return new y("Invalid " + Q + " `" + re + "` of type " + ("`" + ie + "` supplied to `" + K + "`, expected a single ReactElement."));
        }
        return null;
      }
      return S($);
    }
    function P() {
      function $(z, ne, K, Q, re) {
        var te = z[ne];
        if (!e.isValidElementType(te)) {
          var ie = N(te);
          return new y("Invalid " + Q + " `" + re + "` of type " + ("`" + ie + "` supplied to `" + K + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return S($);
    }
    function R($) {
      function z(ne, K, Q, re, te) {
        if (!(ne[K] instanceof $)) {
          var ie = $.name || g, ae = V(ne[K]);
          return new y("Invalid " + re + " `" + te + "` of type " + ("`" + ae + "` supplied to `" + Q + "`, expected ") + ("instance of `" + ie + "`."));
        }
        return null;
      }
      return S(z);
    }
    function F($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function z(ne, K, Q, re, te) {
        for (var ie = ne[K], ae = 0; ae < $.length; ae++)
          if (v(ie, $[ae]))
            return null;
        var ce = JSON.stringify($, function(le, we) {
          var q = j(we);
          return q === "symbol" ? String(we) : we;
        });
        return new y("Invalid " + re + " `" + te + "` of value `" + String(ie) + "` " + ("supplied to `" + Q + "`, expected one of " + ce + "."));
      }
      return S(z);
    }
    function A($) {
      function z(ne, K, Q, re, te) {
        if (typeof $ != "function")
          return new y("Property `" + te + "` of component `" + Q + "` has invalid PropType notation inside objectOf.");
        var ie = ne[K], ae = N(ie);
        if (ae !== "object")
          return new y("Invalid " + re + " `" + te + "` of type " + ("`" + ae + "` supplied to `" + Q + "`, expected an object."));
        for (var ce in ie)
          if (r(ie, ce)) {
            var le = $(ie, ce, Q, re, te + "." + ce, n);
            if (le instanceof Error)
              return le;
          }
        return null;
      }
      return S(z);
    }
    function _($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var z = 0; z < $.length; z++) {
        var ne = $[z];
        if (typeof ne != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + W(ne) + " at index " + z + "."
          ), a;
      }
      function K(Q, re, te, ie, ae) {
        for (var ce = [], le = 0; le < $.length; le++) {
          var we = $[le], q = we(Q, re, te, ie, ae, n);
          if (q == null)
            return null;
          q.data && r(q.data, "expectedType") && ce.push(q.data.expectedType);
        }
        var Ee = ce.length > 0 ? ", expected one of type [" + ce.join(", ") + "]" : "";
        return new y("Invalid " + ie + " `" + ae + "` supplied to " + ("`" + te + "`" + Ee + "."));
      }
      return S(K);
    }
    function C() {
      function $(z, ne, K, Q, re) {
        return H(z[ne]) ? null : new y("Invalid " + Q + " `" + re + "` supplied to " + ("`" + K + "`, expected a ReactNode."));
      }
      return S($);
    }
    function D($, z, ne, K, Q) {
      return new y(
        ($ || "React class") + ": " + z + " type `" + ne + "." + K + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Q + "`."
      );
    }
    function L($) {
      function z(ne, K, Q, re, te) {
        var ie = ne[K], ae = N(ie);
        if (ae !== "object")
          return new y("Invalid " + re + " `" + te + "` of type `" + ae + "` " + ("supplied to `" + Q + "`, expected `object`."));
        for (var ce in $) {
          var le = $[ce];
          if (typeof le != "function")
            return D(Q, re, te, ce, j(le));
          var we = le(ie, ce, Q, re, te + "." + ce, n);
          if (we)
            return we;
        }
        return null;
      }
      return S(z);
    }
    function B($) {
      function z(ne, K, Q, re, te) {
        var ie = ne[K], ae = N(ie);
        if (ae !== "object")
          return new y("Invalid " + re + " `" + te + "` of type `" + ae + "` " + ("supplied to `" + Q + "`, expected `object`."));
        var ce = t({}, ne[K], $);
        for (var le in ce) {
          var we = $[le];
          if (r($, le) && typeof we != "function")
            return D(Q, re, te, le, j(we));
          if (!we)
            return new y(
              "Invalid " + re + " `" + te + "` key `" + le + "` supplied to `" + Q + "`.\nBad object: " + JSON.stringify(ne[K], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys($), null, "  ")
            );
          var q = we(ie, le, Q, re, te + "." + le, n);
          if (q)
            return q;
        }
        return null;
      }
      return S(z);
    }
    function H($) {
      switch (typeof $) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !$;
        case "object":
          if (Array.isArray($))
            return $.every(H);
          if ($ === null || l($))
            return !0;
          var z = p($);
          if (z) {
            var ne = z.call($), K;
            if (z !== $.entries) {
              for (; !(K = ne.next()).done; )
                if (!H(K.value))
                  return !1;
            } else
              for (; !(K = ne.next()).done; ) {
                var Q = K.value;
                if (Q && !H(Q[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function k($, z) {
      return $ === "symbol" ? !0 : z ? z["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && z instanceof Symbol : !1;
    }
    function N($) {
      var z = typeof $;
      return Array.isArray($) ? "array" : $ instanceof RegExp ? "object" : k(z, $) ? "symbol" : z;
    }
    function j($) {
      if (typeof $ > "u" || $ === null)
        return "" + $;
      var z = N($);
      if (z === "object") {
        if ($ instanceof Date)
          return "date";
        if ($ instanceof RegExp)
          return "regexp";
      }
      return z;
    }
    function W($) {
      var z = j($);
      switch (z) {
        case "array":
        case "object":
          return "an " + z;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + z;
        default:
          return z;
      }
    }
    function V($) {
      return !$.constructor || !$.constructor.name ? g : $.constructor.name;
    }
    return b.checkPropTypes = o, b.resetWarningCache = o.resetWarningCache, b.PropTypes = b, b;
  }, nw;
}
var rw, lP;
function rY() {
  if (lP) return rw;
  lP = 1;
  var e = Cx();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, rw = function() {
    function r(a, l, c, d, f, p) {
      if (p !== e) {
        var g = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw g.name = "Invariant Violation", g;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, rw;
}
if (process.env.NODE_ENV !== "production") {
  var oY = $M(), iY = !0;
  g0.exports = nY()(oY.isElement, iY);
} else
  g0.exports = rY()();
var sY = g0.exports;
const ff = /* @__PURE__ */ X7(sY);
function Qa(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function jM(e) {
  if (/* @__PURE__ */ m.isValidElement(e) || !Qa(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = jM(e[n]);
  }), t;
}
function ui(e, t, n = {
  clone: !0
}) {
  const r = n.clone ? {
    ...e
  } : e;
  return Qa(e) && Qa(t) && Object.keys(t).forEach((o) => {
    /* @__PURE__ */ m.isValidElement(t[o]) ? r[o] = t[o] : Qa(t[o]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, o) && Qa(e[o]) ? r[o] = ui(e[o], t[o], n) : n.clone ? r[o] = Qa(t[o]) ? jM(t[o]) : t[o] : r[o] = t[o];
  }), r;
}
const aY = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, r) => n.val - r.val), t.reduce((n, r) => ({
    ...n,
    [r.key]: r.val
  }), {});
};
function lY(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: r = 5,
    ...o
  } = e, i = aY(t), a = Object.keys(i);
  function l(g) {
    return `@media (min-width:${typeof t[g] == "number" ? t[g] : g}${n})`;
  }
  function c(g) {
    return `@media (max-width:${(typeof t[g] == "number" ? t[g] : g) - r / 100}${n})`;
  }
  function d(g, b) {
    const v = a.indexOf(b);
    return `@media (min-width:${typeof t[g] == "number" ? t[g] : g}${n}) and (max-width:${(v !== -1 && typeof t[a[v]] == "number" ? t[a[v]] : b) - r / 100}${n})`;
  }
  function f(g) {
    return a.indexOf(g) + 1 < a.length ? d(g, a[a.indexOf(g) + 1]) : l(g);
  }
  function p(g) {
    const b = a.indexOf(g);
    return b === 0 ? l(a[1]) : b === a.length - 1 ? c(a[b]) : d(g, a[a.indexOf(g) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: a,
    values: i,
    up: l,
    down: c,
    between: d,
    only: f,
    not: p,
    unit: n,
    ...o
  };
}
function cY(e, t) {
  if (!e.containerQueries)
    return t;
  const n = Object.keys(t).filter((r) => r.startsWith("@container")).sort((r, o) => {
    var i, a;
    const l = /min-width:\s*([0-9.]+)/;
    return +(((i = r.match(l)) == null ? void 0 : i[1]) || 0) - +(((a = o.match(l)) == null ? void 0 : a[1]) || 0);
  });
  return n.length ? n.reduce((r, o) => {
    const i = t[o];
    return delete r[o], r[o] = i, r;
  }, {
    ...t
  }) : t;
}
function uY(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((n) => t.startsWith(`@${n}`)) || !!t.match(/^@\d/));
}
function dY(e, t) {
  const n = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!n) {
    if (process.env.NODE_ENV !== "production")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${t})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.` : yl(18, `(${t})`));
    return null;
  }
  const [, r, o] = n, i = Number.isNaN(+r) ? r || 0 : +r;
  return e.containerQueries(o).up(i);
}
function fY(e) {
  const t = (i, a) => i.replace("@media", a ? `@container ${a}` : "@container");
  function n(i, a) {
    i.up = (...l) => t(e.breakpoints.up(...l), a), i.down = (...l) => t(e.breakpoints.down(...l), a), i.between = (...l) => t(e.breakpoints.between(...l), a), i.only = (...l) => t(e.breakpoints.only(...l), a), i.not = (...l) => {
      const c = t(e.breakpoints.not(...l), a);
      return c.includes("not all and") ? c.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : c;
    };
  }
  const r = {}, o = (i) => (n(r, i), r);
  return n(o), {
    ...e,
    containerQueries: o
  };
}
const pY = {
  borderRadius: 4
}, Il = process.env.NODE_ENV !== "production" ? ff.oneOfType([ff.number, ff.string, ff.object, ff.array]) : {};
function Uf(e, t) {
  return t ? ui(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const wb = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, cP = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${wb[e]}px)`
}, hY = {
  containerQueries: (e) => ({
    up: (t) => {
      let n = typeof t == "number" ? t : wb[t] || t;
      return typeof n == "number" && (n = `${n}px`), e ? `@container ${e} (min-width:${n})` : `@container (min-width:${n})`;
    }
  })
};
function Ca(e, t, n) {
  const r = e.theme || {};
  if (Array.isArray(t)) {
    const o = r.breakpoints || cP;
    return t.reduce((i, a, l) => (i[o.up(o.keys[l])] = n(t[l]), i), {});
  }
  if (typeof t == "object") {
    const o = r.breakpoints || cP;
    return Object.keys(t).reduce((i, a) => {
      if (uY(o.keys, a)) {
        const l = dY(r.containerQueries ? r : hY, a);
        l && (i[l] = n(t[a], a));
      } else if (Object.keys(o.values || wb).includes(a)) {
        const l = o.up(a);
        i[l] = n(t[a], a);
      } else {
        const l = a;
        i[l] = t[l];
      }
      return i;
    }, {});
  }
  return n(t);
}
function gY(e = {}) {
  var t;
  return ((t = e.keys) == null ? void 0 : t.reduce((n, r) => {
    const o = e.up(r);
    return n[o] = {}, n;
  }, {})) || {};
}
function mY(e, t) {
  return e.reduce((n, r) => {
    const o = n[r];
    return (!o || Object.keys(o).length === 0) && delete n[r], n;
  }, t);
}
function BM(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : yl(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function Cb(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const r = `vars.${t}`.split(".").reduce((o, i) => o && o[i] ? o[i] : null, e);
    if (r != null)
      return r;
  }
  return t.split(".").reduce((r, o) => r && r[o] != null ? r[o] : null, e);
}
function dm(e, t, n, r = n) {
  let o;
  return typeof e == "function" ? o = e(n) : Array.isArray(e) ? o = e[n] || r : o = Cb(e, n) || r, t && (o = t(o, r, e)), o;
}
function kr(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: r,
    transform: o
  } = e, i = (a) => {
    if (a[t] == null)
      return null;
    const l = a[t], c = a.theme, d = Cb(c, r) || {};
    return Ca(a, l, (f) => {
      let p = dm(d, o, f);
      return f === p && typeof f == "string" && (p = dm(d, o, `${t}${f === "default" ? "" : BM(f)}`, f)), n === !1 ? p : {
        [n]: p
      };
    });
  };
  return i.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: Il
  } : {}, i.filterProps = [t], i;
}
function bY(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const yY = {
  m: "margin",
  p: "padding"
}, vY = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, uP = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, wY = bY((e) => {
  if (e.length > 2)
    if (uP[e])
      e = uP[e];
    else
      return [e];
  const [t, n] = e.split(""), r = yY[t], o = vY[n] || "";
  return Array.isArray(o) ? o.map((i) => r + i) : [r + o];
}), xb = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], Sb = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], CY = [...xb, ...Sb];
function Qp(e, t, n, r) {
  const o = Cb(e, t, !0) ?? n;
  return typeof o == "number" || typeof o == "string" ? (i) => typeof i == "string" ? i : (process.env.NODE_ENV !== "production" && typeof i != "number" && console.error(`MUI: Expected ${r} argument to be a number or a string, got ${i}.`), typeof o == "string" ? `calc(${i} * ${o})` : o * i) : Array.isArray(o) ? (i) => {
    if (typeof i == "string")
      return i;
    const a = Math.abs(i);
    process.env.NODE_ENV !== "production" && (Number.isInteger(a) ? a > o.length - 1 && console.error([`MUI: The value provided (${a}) overflows.`, `The supported values are: ${JSON.stringify(o)}.`, `${a} > ${o.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`)));
    const l = o[a];
    return i >= 0 ? l : typeof l == "number" ? -l : `-${l}`;
  } : typeof o == "function" ? o : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${o}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function xx(e) {
  return Qp(e, "spacing", 8, "spacing");
}
function Xp(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function xY(e, t) {
  return (n) => e.reduce((r, o) => (r[o] = Xp(t, n), r), {});
}
function SY(e, t, n, r) {
  if (!t.includes(n))
    return null;
  const o = wY(n), i = xY(o, r), a = e[n];
  return Ca(e, a, i);
}
function VM(e, t) {
  const n = xx(e.theme);
  return Object.keys(e).map((r) => SY(e, t, r, n)).reduce(Uf, {});
}
function br(e) {
  return VM(e, xb);
}
br.propTypes = process.env.NODE_ENV !== "production" ? xb.reduce((e, t) => (e[t] = Il, e), {}) : {};
br.filterProps = xb;
function yr(e) {
  return VM(e, Sb);
}
yr.propTypes = process.env.NODE_ENV !== "production" ? Sb.reduce((e, t) => (e[t] = Il, e), {}) : {};
yr.filterProps = Sb;
process.env.NODE_ENV !== "production" && CY.reduce((e, t) => (e[t] = Il, e), {});
function HM(e = 8, t = xx({
  spacing: e
})) {
  if (e.mui)
    return e;
  const n = (...r) => (process.env.NODE_ENV !== "production" && (r.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${r.length}`)), (r.length === 0 ? [1] : r).map((o) => {
    const i = t(o);
    return typeof i == "number" ? `${i}px` : i;
  }).join(" "));
  return n.mui = !0, n;
}
function Eb(...e) {
  const t = e.reduce((r, o) => (o.filterProps.forEach((i) => {
    r[i] = o;
  }), r), {}), n = (r) => Object.keys(r).reduce((o, i) => t[i] ? Uf(o, t[i](r)) : o, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((r, o) => Object.assign(r, o.propTypes), {}) : {}, n.filterProps = e.reduce((r, o) => r.concat(o.filterProps), []), n;
}
function Mi(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function Bi(e, t) {
  return kr({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const EY = Bi("border", Mi), TY = Bi("borderTop", Mi), OY = Bi("borderRight", Mi), PY = Bi("borderBottom", Mi), IY = Bi("borderLeft", Mi), RY = Bi("borderColor"), _Y = Bi("borderTopColor"), kY = Bi("borderRightColor"), MY = Bi("borderBottomColor"), AY = Bi("borderLeftColor"), DY = Bi("outline", Mi), NY = Bi("outlineColor"), Tb = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = Qp(e.theme, "shape.borderRadius", 4, "borderRadius"), n = (r) => ({
      borderRadius: Xp(t, r)
    });
    return Ca(e, e.borderRadius, n);
  }
  return null;
};
Tb.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: Il
} : {};
Tb.filterProps = ["borderRadius"];
Eb(EY, TY, OY, PY, IY, RY, _Y, kY, MY, AY, Tb, DY, NY);
const Ob = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = Qp(e.theme, "spacing", 8, "gap"), n = (r) => ({
      gap: Xp(t, r)
    });
    return Ca(e, e.gap, n);
  }
  return null;
};
Ob.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: Il
} : {};
Ob.filterProps = ["gap"];
const Pb = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = Qp(e.theme, "spacing", 8, "columnGap"), n = (r) => ({
      columnGap: Xp(t, r)
    });
    return Ca(e, e.columnGap, n);
  }
  return null;
};
Pb.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: Il
} : {};
Pb.filterProps = ["columnGap"];
const Ib = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = Qp(e.theme, "spacing", 8, "rowGap"), n = (r) => ({
      rowGap: Xp(t, r)
    });
    return Ca(e, e.rowGap, n);
  }
  return null;
};
Ib.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: Il
} : {};
Ib.filterProps = ["rowGap"];
const FY = kr({
  prop: "gridColumn"
}), $Y = kr({
  prop: "gridRow"
}), LY = kr({
  prop: "gridAutoFlow"
}), jY = kr({
  prop: "gridAutoColumns"
}), BY = kr({
  prop: "gridAutoRows"
}), VY = kr({
  prop: "gridTemplateColumns"
}), HY = kr({
  prop: "gridTemplateRows"
}), UY = kr({
  prop: "gridTemplateAreas"
}), zY = kr({
  prop: "gridArea"
});
Eb(Ob, Pb, Ib, FY, $Y, LY, jY, BY, VY, HY, UY, zY);
function $u(e, t) {
  return t === "grey" ? t : e;
}
const GY = kr({
  prop: "color",
  themeKey: "palette",
  transform: $u
}), WY = kr({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: $u
}), qY = kr({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: $u
});
Eb(GY, WY, qY);
function ai(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const KY = kr({
  prop: "width",
  transform: ai
}), Sx = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var r, o, i, a, l;
      const c = ((i = (o = (r = e.theme) == null ? void 0 : r.breakpoints) == null ? void 0 : o.values) == null ? void 0 : i[n]) || wb[n];
      return c ? ((l = (a = e.theme) == null ? void 0 : a.breakpoints) == null ? void 0 : l.unit) !== "px" ? {
        maxWidth: `${c}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: c
      } : {
        maxWidth: ai(n)
      };
    };
    return Ca(e, e.maxWidth, t);
  }
  return null;
};
Sx.filterProps = ["maxWidth"];
const YY = kr({
  prop: "minWidth",
  transform: ai
}), QY = kr({
  prop: "height",
  transform: ai
}), XY = kr({
  prop: "maxHeight",
  transform: ai
}), JY = kr({
  prop: "minHeight",
  transform: ai
});
kr({
  prop: "size",
  cssProperty: "width",
  transform: ai
});
kr({
  prop: "size",
  cssProperty: "height",
  transform: ai
});
const ZY = kr({
  prop: "boxSizing"
});
Eb(KY, Sx, YY, QY, XY, JY, ZY);
const Rb = {
  // borders
  border: {
    themeKey: "borders",
    transform: Mi
  },
  borderTop: {
    themeKey: "borders",
    transform: Mi
  },
  borderRight: {
    themeKey: "borders",
    transform: Mi
  },
  borderBottom: {
    themeKey: "borders",
    transform: Mi
  },
  borderLeft: {
    themeKey: "borders",
    transform: Mi
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: Mi
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Tb
  },
  // palette
  color: {
    themeKey: "palette",
    transform: $u
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: $u
  },
  backgroundColor: {
    themeKey: "palette",
    transform: $u
  },
  // spacing
  p: {
    style: yr
  },
  pt: {
    style: yr
  },
  pr: {
    style: yr
  },
  pb: {
    style: yr
  },
  pl: {
    style: yr
  },
  px: {
    style: yr
  },
  py: {
    style: yr
  },
  padding: {
    style: yr
  },
  paddingTop: {
    style: yr
  },
  paddingRight: {
    style: yr
  },
  paddingBottom: {
    style: yr
  },
  paddingLeft: {
    style: yr
  },
  paddingX: {
    style: yr
  },
  paddingY: {
    style: yr
  },
  paddingInline: {
    style: yr
  },
  paddingInlineStart: {
    style: yr
  },
  paddingInlineEnd: {
    style: yr
  },
  paddingBlock: {
    style: yr
  },
  paddingBlockStart: {
    style: yr
  },
  paddingBlockEnd: {
    style: yr
  },
  m: {
    style: br
  },
  mt: {
    style: br
  },
  mr: {
    style: br
  },
  mb: {
    style: br
  },
  ml: {
    style: br
  },
  mx: {
    style: br
  },
  my: {
    style: br
  },
  margin: {
    style: br
  },
  marginTop: {
    style: br
  },
  marginRight: {
    style: br
  },
  marginBottom: {
    style: br
  },
  marginLeft: {
    style: br
  },
  marginX: {
    style: br
  },
  marginY: {
    style: br
  },
  marginInline: {
    style: br
  },
  marginInlineStart: {
    style: br
  },
  marginInlineEnd: {
    style: br
  },
  marginBlock: {
    style: br
  },
  marginBlockStart: {
    style: br
  },
  marginBlockEnd: {
    style: br
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: Ob
  },
  rowGap: {
    style: Ib
  },
  columnGap: {
    style: Pb
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: ai
  },
  maxWidth: {
    style: Sx
  },
  minWidth: {
    transform: ai
  },
  height: {
    transform: ai
  },
  maxHeight: {
    transform: ai
  },
  minHeight: {
    transform: ai
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function eQ(...e) {
  const t = e.reduce((r, o) => r.concat(Object.keys(o)), []), n = new Set(t);
  return e.every((r) => n.size === Object.keys(r).length);
}
function tQ(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function nQ() {
  function e(n, r, o, i) {
    const a = {
      [n]: r,
      theme: o
    }, l = i[n];
    if (!l)
      return {
        [n]: r
      };
    const {
      cssProperty: c = n,
      themeKey: d,
      transform: f,
      style: p
    } = l;
    if (r == null)
      return null;
    if (d === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const g = Cb(o, d) || {};
    return p ? p(a) : Ca(a, r, (b) => {
      let v = dm(g, f, b);
      return b === v && typeof b == "string" && (v = dm(g, f, `${n}${b === "default" ? "" : BM(b)}`, b)), c === !1 ? v : {
        [c]: v
      };
    });
  }
  function t(n) {
    const {
      sx: r,
      theme: o = {}
    } = n || {};
    if (!r)
      return null;
    const i = o.unstable_sxConfig ?? Rb;
    function a(l) {
      let c = l;
      if (typeof l == "function")
        c = l(o);
      else if (typeof l != "object")
        return l;
      if (!c)
        return null;
      const d = gY(o.breakpoints), f = Object.keys(d);
      let p = d;
      return Object.keys(c).forEach((g) => {
        const b = tQ(c[g], o);
        if (b != null)
          if (typeof b == "object")
            if (i[g])
              p = Uf(p, e(g, b, o, i));
            else {
              const v = Ca({
                theme: o
              }, b, (y) => ({
                [g]: y
              }));
              eQ(v, b) ? p[g] = t({
                sx: b,
                theme: o
              }) : p = Uf(p, v);
            }
          else
            p = Uf(p, e(g, b, o, i));
      }), cY(o, mY(f, p));
    }
    return Array.isArray(r) ? r.map(a) : a(r);
  }
  return t;
}
const _b = nQ();
_b.filterProps = ["sx"];
function rQ(e, t) {
  var n;
  const r = this;
  if (r.vars) {
    if (!((n = r.colorSchemes) != null && n[e]) || typeof r.getColorSchemeSelector != "function")
      return {};
    let o = r.getColorSchemeSelector(e);
    return o === "&" ? t : ((o.includes("data-") || o.includes(".")) && (o = `*:where(${o.replace(/\s*&$/, "")}) &`), {
      [o]: t
    });
  }
  return r.palette.mode === e ? t : {};
}
function oQ(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: r = {},
    spacing: o,
    shape: i = {},
    ...a
  } = e, l = lY(n), c = HM(o);
  let d = ui({
    breakpoints: l,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...r
    },
    spacing: c,
    shape: {
      ...pY,
      ...i
    }
  }, a);
  return d = fY(d), d.applyStyles = rQ, d = t.reduce((f, p) => ui(f, p), d), d.unstable_sxConfig = {
    ...Rb,
    ...a == null ? void 0 : a.unstable_sxConfig
  }, d.unstable_sx = function(f) {
    return _b({
      sx: f,
      theme: this
    });
  }, d;
}
const dP = (e) => e, iQ = () => {
  let e = dP;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = dP;
    }
  };
}, sQ = iQ(), aQ = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function lQ(e, t, n = "Mui") {
  const r = aQ[t];
  return r ? `${n}-${r}` : `${sQ.generate(e)}-${t}`;
}
function cQ(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
function Ex(e, t = 0, n = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > n) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${n}].`), cQ(e, t, n);
}
function uQ(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((r) => r + r)), process.env.NODE_ENV !== "production" && e.length !== e.trim().length && console.error(`MUI: The color: "${e}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((r, o) => o < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function vl(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return vl(uQ(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(n))
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : yl(9, e));
  let r = e.substring(t + 1, e.length - 1), o;
  if (n === "color") {
    if (r = r.split(" "), o = r.shift(), r.length === 4 && r[3].charAt(0) === "/" && (r[3] = r[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(o))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${o}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : yl(10, o));
  } else
    r = r.split(",");
  return r = r.map((i) => parseFloat(i)), {
    type: n,
    values: r,
    colorSpace: o
  };
}
const dQ = (e) => {
  const t = vl(e);
  return t.values.slice(0, 3).map((n, r) => t.type.includes("hsl") && r !== 0 ? `${n}%` : n).join(" ");
}, _f = (e, t) => {
  try {
    return dQ(e);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
};
function kb(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: r
  } = e;
  return t.includes("rgb") ? r = r.map((o, i) => i < 3 ? parseInt(o, 10) : o) : t.includes("hsl") && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), t.includes("color") ? r = `${n} ${r.join(" ")}` : r = `${r.join(", ")}`, `${t}(${r})`;
}
function UM(e) {
  e = vl(e);
  const {
    values: t
  } = e, n = t[0], r = t[1] / 100, o = t[2] / 100, i = r * Math.min(o, 1 - o), a = (d, f = (d + n / 30) % 12) => o - i * Math.max(Math.min(f - 3, 9 - f, 1), -1);
  let l = "rgb";
  const c = [Math.round(a(0) * 255), Math.round(a(8) * 255), Math.round(a(4) * 255)];
  return e.type === "hsla" && (l += "a", c.push(t[3])), kb({
    type: l,
    values: c
  });
}
function m0(e) {
  e = vl(e);
  let t = e.type === "hsl" || e.type === "hsla" ? vl(UM(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function fP(e, t) {
  const n = m0(e), r = m0(t);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
function fQ(e, t) {
  return e = vl(e), t = Ex(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, kb(e);
}
function gg(e, t, n) {
  try {
    return fQ(e, t);
  } catch {
    return e;
  }
}
function Tx(e, t) {
  if (e = vl(e), t = Ex(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return kb(e);
}
function zn(e, t, n) {
  try {
    return Tx(e, t);
  } catch {
    return e;
  }
}
function Ox(e, t) {
  if (e = vl(e), t = Ex(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return kb(e);
}
function Gn(e, t, n) {
  try {
    return Ox(e, t);
  } catch {
    return e;
  }
}
function pQ(e, t = 0.15) {
  return m0(e) > 0.5 ? Tx(e, t) : Ox(e, t);
}
function mg(e, t, n) {
  try {
    return pQ(e, t);
  } catch {
    return e;
  }
}
function hQ(e = "") {
  function t(...n) {
    if (!n.length)
      return "";
    const r = n[0];
    return typeof r == "string" && !r.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${r}${t(...n.slice(1))})` : `, ${r}`;
  }
  return (n, ...r) => `var(--${e ? `${e}-` : ""}${n}${t(...r)})`;
}
const pP = (e, t, n, r = []) => {
  let o = e;
  t.forEach((i, a) => {
    a === t.length - 1 ? Array.isArray(o) ? o[Number(i)] = n : o && typeof o == "object" && (o[i] = n) : o && typeof o == "object" && (o[i] || (o[i] = r.includes(i) ? [] : {}), o = o[i]);
  });
}, gQ = (e, t, n) => {
  function r(o, i = [], a = []) {
    Object.entries(o).forEach(([l, c]) => {
      (!n || n && !n([...i, l])) && c != null && (typeof c == "object" && Object.keys(c).length > 0 ? r(c, [...i, l], Array.isArray(c) ? [...a, l] : a) : t([...i, l], c, a));
    });
  }
  r(e);
}, mQ = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((n) => e.includes(n)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function ow(e, t) {
  const {
    prefix: n,
    shouldSkipGeneratingVar: r
  } = t || {}, o = {}, i = {}, a = {};
  return gQ(
    e,
    (l, c, d) => {
      if ((typeof c == "string" || typeof c == "number") && (!r || !r(l, c))) {
        const f = `--${n ? `${n}-` : ""}${l.join("-")}`, p = mQ(l, c);
        Object.assign(o, {
          [f]: p
        }), pP(i, l, `var(${f})`, d), pP(a, l, `var(${f}, ${p})`, d);
      }
    },
    (l) => l[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: o,
    vars: i,
    varsWithDefaults: a
  };
}
function bQ(e, t = {}) {
  const {
    getSelector: n = S,
    disableCssColorScheme: r,
    colorSchemeSelector: o
  } = t, {
    colorSchemes: i = {},
    components: a,
    defaultColorScheme: l = "light",
    ...c
  } = e, {
    vars: d,
    css: f,
    varsWithDefaults: p
  } = ow(c, t);
  let g = p;
  const b = {}, {
    [l]: v,
    ...y
  } = i;
  if (Object.entries(y || {}).forEach(([E, I]) => {
    const {
      vars: O,
      css: T,
      varsWithDefaults: P
    } = ow(I, t);
    g = ui(g, P), b[E] = {
      css: T,
      vars: O
    };
  }), v) {
    const {
      css: E,
      vars: I,
      varsWithDefaults: O
    } = ow(v, t);
    g = ui(g, O), b[l] = {
      css: E,
      vars: I
    };
  }
  function S(E, I) {
    var O, T;
    let P = o;
    if (o === "class" && (P = ".%s"), o === "data" && (P = "[data-%s]"), o != null && o.startsWith("data-") && !o.includes("%s") && (P = `[${o}="%s"]`), E) {
      if (P === "media")
        return e.defaultColorScheme === E ? ":root" : {
          [`@media (prefers-color-scheme: ${((T = (O = i[E]) == null ? void 0 : O.palette) == null ? void 0 : T.mode) || E})`]: {
            ":root": I
          }
        };
      if (P)
        return e.defaultColorScheme === E ? `:root, ${P.replace("%s", String(E))}` : P.replace("%s", String(E));
    }
    return ":root";
  }
  return {
    vars: g,
    generateThemeVars: () => {
      let E = {
        ...d
      };
      return Object.entries(b).forEach(([, {
        vars: I
      }]) => {
        E = ui(E, I);
      }), E;
    },
    generateStyleSheets: () => {
      var E, I;
      const O = [], T = e.defaultColorScheme || "light";
      function P(A, _) {
        Object.keys(_).length && O.push(typeof A == "string" ? {
          [A]: {
            ..._
          }
        } : A);
      }
      P(n(void 0, {
        ...f
      }), f);
      const {
        [T]: R,
        ...F
      } = b;
      if (R) {
        const {
          css: A
        } = R, _ = (I = (E = i[T]) == null ? void 0 : E.palette) == null ? void 0 : I.mode, C = !r && _ ? {
          colorScheme: _,
          ...A
        } : {
          ...A
        };
        P(n(T, {
          ...C
        }), C);
      }
      return Object.entries(F).forEach(([A, {
        css: _
      }]) => {
        var C, D;
        const L = (D = (C = i[A]) == null ? void 0 : C.palette) == null ? void 0 : D.mode, B = !r && L ? {
          colorScheme: L,
          ..._
        } : {
          ..._
        };
        P(n(A, {
          ...B
        }), B);
      }), O;
    }
  };
}
function yQ(e) {
  return function(t) {
    return e === "media" ? (process.env.NODE_ENV !== "production" && t !== "light" && t !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${t}'.`), `@media (prefers-color-scheme: ${t})`) : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${t}"] &` : e === "class" ? `.${t} &` : e === "data" ? `[data-${t}] &` : `${e.replace("%s", t)} &` : "&";
  };
}
const fp = {
  black: "#000",
  white: "#fff"
}, vQ = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, iu = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, su = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, pf = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, au = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, lu = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, cu = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
};
function zM() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: fp.white,
      default: fp.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const wQ = zM();
function GM() {
  return {
    text: {
      primary: fp.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: fp.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const hP = GM();
function gP(e, t, n, r) {
  const o = r.light || r, i = r.dark || r * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = Ox(e.main, o) : t === "dark" && (e.dark = Tx(e.main, i)));
}
function CQ(e = "light") {
  return e === "dark" ? {
    main: au[200],
    light: au[50],
    dark: au[400]
  } : {
    main: au[700],
    light: au[400],
    dark: au[800]
  };
}
function xQ(e = "light") {
  return e === "dark" ? {
    main: iu[200],
    light: iu[50],
    dark: iu[400]
  } : {
    main: iu[500],
    light: iu[300],
    dark: iu[700]
  };
}
function SQ(e = "light") {
  return e === "dark" ? {
    main: su[500],
    light: su[300],
    dark: su[700]
  } : {
    main: su[700],
    light: su[400],
    dark: su[800]
  };
}
function EQ(e = "light") {
  return e === "dark" ? {
    main: lu[400],
    light: lu[300],
    dark: lu[700]
  } : {
    main: lu[700],
    light: lu[500],
    dark: lu[900]
  };
}
function TQ(e = "light") {
  return e === "dark" ? {
    main: cu[400],
    light: cu[300],
    dark: cu[700]
  } : {
    main: cu[800],
    light: cu[500],
    dark: cu[900]
  };
}
function OQ(e = "light") {
  return e === "dark" ? {
    main: pf[400],
    light: pf[300],
    dark: pf[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: pf[500],
    dark: pf[900]
  };
}
function Px(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: r = 0.2,
    ...o
  } = e, i = e.primary || CQ(t), a = e.secondary || xQ(t), l = e.error || SQ(t), c = e.info || EQ(t), d = e.success || TQ(t), f = e.warning || OQ(t);
  function p(v) {
    const y = fP(v, hP.text.primary) >= n ? hP.text.primary : wQ.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const S = fP(v, y);
      S < 3 && console.error([`MUI: The contrast ratio of ${S}:1 for ${y} on ${v}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return y;
  }
  const g = ({
    color: v,
    name: y,
    mainShade: S = 500,
    lightShade: E = 300,
    darkShade: I = 700
  }) => {
    if (v = {
      ...v
    }, !v.main && v[S] && (v.main = v[S]), !v.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${y ? ` (${y})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${S}\` property.` : yl(11, y ? ` (${y})` : "", S));
    if (typeof v.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${y ? ` (${y})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(v.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : yl(12, y ? ` (${y})` : "", JSON.stringify(v.main)));
    return gP(v, "light", E, r), gP(v, "dark", I, r), v.contrastText || (v.contrastText = p(v.main)), v;
  };
  let b;
  return t === "light" ? b = zM() : t === "dark" && (b = GM()), process.env.NODE_ENV !== "production" && (b || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), ui({
    // A collection of common colors.
    common: {
      ...fp
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: g({
      color: i,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: g({
      color: a,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: g({
      color: l,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: g({
      color: f,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: g({
      color: c,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: g({
      color: d,
      name: "success"
    }),
    // The grey colors.
    grey: vQ,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: p,
    // Generate a rich color object.
    augmentColor: g,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: r,
    // The light and dark mode object.
    ...b
  }, o);
}
function PQ(e) {
  const t = {};
  return Object.entries(e).forEach((n) => {
    const [r, o] = n;
    typeof o == "object" && (t[r] = `${o.fontStyle ? `${o.fontStyle} ` : ""}${o.fontVariant ? `${o.fontVariant} ` : ""}${o.fontWeight ? `${o.fontWeight} ` : ""}${o.fontStretch ? `${o.fontStretch} ` : ""}${o.fontSize || ""}${o.lineHeight ? `/${o.lineHeight} ` : ""}${o.fontFamily || ""}`);
  }), t;
}
function IQ(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
function RQ(e) {
  return Math.round(e * 1e5) / 1e5;
}
const mP = {
  textTransform: "uppercase"
}, bP = '"Roboto", "Helvetica", "Arial", sans-serif';
function _Q(e, t) {
  const {
    fontFamily: n = bP,
    // The default font size of the Material Specification.
    fontSize: r = 14,
    // px
    fontWeightLight: o = 300,
    fontWeightRegular: i = 400,
    fontWeightMedium: a = 500,
    fontWeightBold: l = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: c = 16,
    // Apply the CSS properties to all the variants.
    allVariants: d,
    pxToRem: f,
    ...p
  } = typeof t == "function" ? t(e) : t;
  process.env.NODE_ENV !== "production" && (typeof r != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof c != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const g = r / 14, b = f || ((S) => `${S / c * g}rem`), v = (S, E, I, O, T) => ({
    fontFamily: n,
    fontWeight: S,
    fontSize: b(E),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: I,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...n === bP ? {
      letterSpacing: `${RQ(O / E)}em`
    } : {},
    ...T,
    ...d
  }), y = {
    h1: v(o, 96, 1.167, -1.5),
    h2: v(o, 60, 1.2, -0.5),
    h3: v(i, 48, 1.167, 0),
    h4: v(i, 34, 1.235, 0.25),
    h5: v(i, 24, 1.334, 0),
    h6: v(a, 20, 1.6, 0.15),
    subtitle1: v(i, 16, 1.75, 0.15),
    subtitle2: v(a, 14, 1.57, 0.1),
    body1: v(i, 16, 1.5, 0.15),
    body2: v(i, 14, 1.43, 0.15),
    button: v(a, 14, 1.75, 0.4, mP),
    caption: v(i, 12, 1.66, 0.4),
    overline: v(i, 12, 2.66, 1, mP),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return ui({
    htmlFontSize: c,
    pxToRem: b,
    fontFamily: n,
    fontSize: r,
    fontWeightLight: o,
    fontWeightRegular: i,
    fontWeightMedium: a,
    fontWeightBold: l,
    ...y
  }, p, {
    clone: !1
    // No need to clone deep
  });
}
const kQ = 0.2, MQ = 0.14, AQ = 0.12;
function rr(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${kQ})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${MQ})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${AQ})`].join(",");
}
const DQ = ["none", rr(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), rr(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), rr(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), rr(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), rr(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), rr(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), rr(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), rr(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), rr(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), rr(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), rr(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), rr(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), rr(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), rr(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), rr(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), rr(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), rr(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), rr(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), rr(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), rr(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), rr(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), rr(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), rr(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), rr(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], NQ = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, FQ = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function yP(e) {
  return `${Math.round(e)}ms`;
}
function $Q(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function LQ(e) {
  const t = {
    ...NQ,
    ...e.easing
  }, n = {
    ...FQ,
    ...e.duration
  };
  return {
    getAutoHeightDuration: $Q,
    create: (r = ["all"], o = {}) => {
      const {
        duration: i = n.standard,
        easing: a = t.easeInOut,
        delay: l = 0,
        ...c
      } = o;
      if (process.env.NODE_ENV !== "production") {
        const d = (p) => typeof p == "string", f = (p) => !Number.isNaN(parseFloat(p));
        !d(r) && !Array.isArray(r) && console.error('MUI: Argument "props" must be a string or Array.'), !f(i) && !d(i) && console.error(`MUI: Argument "duration" must be a number or a string but found ${i}.`), d(a) || console.error('MUI: Argument "easing" must be a string.'), !f(l) && !d(l) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof o != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(c).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(c).join(",")}].`);
      }
      return (Array.isArray(r) ? r : [r]).map((d) => `${d} ${typeof i == "string" ? i : yP(i)} ${a} ${typeof l == "string" ? l : yP(l)}`).join(",");
    },
    ...e,
    easing: t,
    duration: n
  };
}
const jQ = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function BQ(e) {
  return Qa(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function WM(e = {}) {
  const t = {
    ...e
  };
  function n(r) {
    const o = Object.entries(r);
    for (let i = 0; i < o.length; i++) {
      const [a, l] = o[i];
      !BQ(l) || a.startsWith("unstable_") ? delete r[a] : Qa(l) && (r[a] = {
        ...l
      }, n(r[a]));
    }
  }
  return n(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function b0(e = {}, ...t) {
  const {
    breakpoints: n,
    mixins: r = {},
    spacing: o,
    palette: i = {},
    transitions: a = {},
    typography: l = {},
    shape: c,
    ...d
  } = e;
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : yl(20));
  const f = Px(i), p = oQ(e);
  let g = ui(p, {
    mixins: IQ(p.breakpoints, r),
    palette: f,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: DQ.slice(),
    typography: _Q(f, l),
    transitions: LQ(a),
    zIndex: {
      ...jQ
    }
  });
  if (g = ui(g, d), g = t.reduce((b, v) => ui(b, v), g), process.env.NODE_ENV !== "production") {
    const b = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], v = (y, S) => {
      let E;
      for (E in y) {
        const I = y[E];
        if (b.includes(E) && Object.keys(I).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const O = lQ("", E);
            console.error([`MUI: The \`${S}\` component increases the CSS specificity of the \`${E}\` internal state.`, "You can not override it like this: ", JSON.stringify(y, null, 2), "", `Instead, you need to use the '&.${O}' syntax:`, JSON.stringify({
              root: {
                [`&.${O}`]: I
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          y[E] = {};
        }
      }
    };
    Object.keys(g.components).forEach((y) => {
      const S = g.components[y].styleOverrides;
      S && y.startsWith("Mui") && v(S, y);
    });
  }
  return g.unstable_sxConfig = {
    ...Rb,
    ...d == null ? void 0 : d.unstable_sxConfig
  }, g.unstable_sx = function(b) {
    return _b({
      sx: b,
      theme: this
    });
  }, g.toRuntimeSource = WM, g;
}
function VQ(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const HQ = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const n = VQ(t);
  return `linear-gradient(rgba(255 255 255 / ${n}), rgba(255 255 255 / ${n}))`;
});
function qM(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function KM(e) {
  return e === "dark" ? HQ : [];
}
function UQ(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: n,
    overlays: r,
    ...o
  } = e, i = Px(t);
  return {
    palette: i,
    opacity: {
      ...qM(i.mode),
      ...n
    },
    overlays: r || KM(i.mode),
    ...o
  };
}
function zQ(e) {
  var t;
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((t = e[1]) != null && t.match(/(mode|contrastThreshold|tonalOffset)/));
}
const GQ = (e) => [...[...Array(25)].map((t, n) => `--${e ? `${e}-` : ""}overlays-${n}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], WQ = (e) => (t, n) => {
  const r = e.rootSelector || ":root", o = e.colorSchemeSelector;
  let i = o;
  if (o === "class" && (i = ".%s"), o === "data" && (i = "[data-%s]"), o != null && o.startsWith("data-") && !o.includes("%s") && (i = `[${o}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const a = {};
      return GQ(e.cssVarPrefix).forEach((l) => {
        a[l] = n[l], delete n[l];
      }), i === "media" ? {
        [r]: n,
        "@media (prefers-color-scheme: dark)": {
          [r]: a
        }
      } : i ? {
        [i.replace("%s", t)]: a,
        [`${r}, ${i.replace("%s", t)}`]: n
      } : {
        [r]: {
          ...n,
          ...a
        }
      };
    }
    if (i && i !== "media")
      return `${r}, ${i.replace("%s", String(t))}`;
  } else if (t) {
    if (i === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [r]: n
        }
      };
    if (i)
      return i.replace("%s", String(t));
  }
  return r;
};
function qQ(e, t) {
  t.forEach((n) => {
    e[n] || (e[n] = {});
  });
}
function De(e, t, n) {
  !e[t] && n && (e[t] = n);
}
function kf(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : UM(e);
}
function sa(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = _f(kf(e[t]), `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function KQ(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const gs = (e) => {
  try {
    return e();
  } catch {
  }
}, YQ = (e = "mui") => hQ(e);
function iw(e, t, n, r) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const o = r === "dark" ? "dark" : "light";
  if (!n) {
    e[r] = UQ({
      ...t,
      palette: {
        mode: o,
        ...t == null ? void 0 : t.palette
      }
    });
    return;
  }
  const {
    palette: i,
    ...a
  } = b0({
    ...n,
    palette: {
      mode: o,
      ...t == null ? void 0 : t.palette
    }
  });
  return e[r] = {
    ...t,
    palette: i,
    opacity: {
      ...qM(o),
      ...t == null ? void 0 : t.opacity
    },
    overlays: (t == null ? void 0 : t.overlays) || KM(o)
  }, a;
}
function QQ(e = {}, ...t) {
  const {
    colorSchemes: n = {
      light: !0
    },
    defaultColorScheme: r,
    disableCssColorScheme: o = !1,
    cssVarPrefix: i = "mui",
    shouldSkipGeneratingVar: a = zQ,
    colorSchemeSelector: l = n.light && n.dark ? "media" : void 0,
    rootSelector: c = ":root",
    ...d
  } = e, f = Object.keys(n)[0], p = r || (n.light && f !== "light" ? "light" : f), g = YQ(i), {
    [p]: b,
    light: v,
    dark: y,
    ...S
  } = n, E = {
    ...S
  };
  let I = b;
  if ((p === "dark" && !("dark" in n) || p === "light" && !("light" in n)) && (I = !0), !I)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${p}\` option is either missing or invalid.` : yl(21, p));
  const O = iw(E, I, d, p);
  v && !E.light && iw(E, v, void 0, "light"), y && !E.dark && iw(E, y, void 0, "dark");
  let T = {
    defaultColorScheme: p,
    ...O,
    cssVarPrefix: i,
    colorSchemeSelector: l,
    rootSelector: c,
    getCssVar: g,
    colorSchemes: E,
    font: {
      ...PQ(O.typography),
      ...O.font
    },
    spacing: KQ(d.spacing)
  };
  Object.keys(T.colorSchemes).forEach((_) => {
    const C = T.colorSchemes[_].palette, D = (L) => {
      const B = L.split("-"), H = B[1], k = B[2];
      return g(L, C[H][k]);
    };
    if (C.mode === "light" && (De(C.common, "background", "#fff"), De(C.common, "onBackground", "#000")), C.mode === "dark" && (De(C.common, "background", "#000"), De(C.common, "onBackground", "#fff")), qQ(C, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), C.mode === "light") {
      De(C.Alert, "errorColor", zn(C.error.light, 0.6)), De(C.Alert, "infoColor", zn(C.info.light, 0.6)), De(C.Alert, "successColor", zn(C.success.light, 0.6)), De(C.Alert, "warningColor", zn(C.warning.light, 0.6)), De(C.Alert, "errorFilledBg", D("palette-error-main")), De(C.Alert, "infoFilledBg", D("palette-info-main")), De(C.Alert, "successFilledBg", D("palette-success-main")), De(C.Alert, "warningFilledBg", D("palette-warning-main")), De(C.Alert, "errorFilledColor", gs(() => C.getContrastText(C.error.main))), De(C.Alert, "infoFilledColor", gs(() => C.getContrastText(C.info.main))), De(C.Alert, "successFilledColor", gs(() => C.getContrastText(C.success.main))), De(C.Alert, "warningFilledColor", gs(() => C.getContrastText(C.warning.main))), De(C.Alert, "errorStandardBg", Gn(C.error.light, 0.9)), De(C.Alert, "infoStandardBg", Gn(C.info.light, 0.9)), De(C.Alert, "successStandardBg", Gn(C.success.light, 0.9)), De(C.Alert, "warningStandardBg", Gn(C.warning.light, 0.9)), De(C.Alert, "errorIconColor", D("palette-error-main")), De(C.Alert, "infoIconColor", D("palette-info-main")), De(C.Alert, "successIconColor", D("palette-success-main")), De(C.Alert, "warningIconColor", D("palette-warning-main")), De(C.AppBar, "defaultBg", D("palette-grey-100")), De(C.Avatar, "defaultBg", D("palette-grey-400")), De(C.Button, "inheritContainedBg", D("palette-grey-300")), De(C.Button, "inheritContainedHoverBg", D("palette-grey-A100")), De(C.Chip, "defaultBorder", D("palette-grey-400")), De(C.Chip, "defaultAvatarColor", D("palette-grey-700")), De(C.Chip, "defaultIconColor", D("palette-grey-700")), De(C.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), De(C.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), De(C.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), De(C.LinearProgress, "primaryBg", Gn(C.primary.main, 0.62)), De(C.LinearProgress, "secondaryBg", Gn(C.secondary.main, 0.62)), De(C.LinearProgress, "errorBg", Gn(C.error.main, 0.62)), De(C.LinearProgress, "infoBg", Gn(C.info.main, 0.62)), De(C.LinearProgress, "successBg", Gn(C.success.main, 0.62)), De(C.LinearProgress, "warningBg", Gn(C.warning.main, 0.62)), De(C.Skeleton, "bg", `rgba(${D("palette-text-primaryChannel")} / 0.11)`), De(C.Slider, "primaryTrack", Gn(C.primary.main, 0.62)), De(C.Slider, "secondaryTrack", Gn(C.secondary.main, 0.62)), De(C.Slider, "errorTrack", Gn(C.error.main, 0.62)), De(C.Slider, "infoTrack", Gn(C.info.main, 0.62)), De(C.Slider, "successTrack", Gn(C.success.main, 0.62)), De(C.Slider, "warningTrack", Gn(C.warning.main, 0.62));
      const L = mg(C.background.default, 0.8);
      De(C.SnackbarContent, "bg", L), De(C.SnackbarContent, "color", gs(() => C.getContrastText(L))), De(C.SpeedDialAction, "fabHoverBg", mg(C.background.paper, 0.15)), De(C.StepConnector, "border", D("palette-grey-400")), De(C.StepContent, "border", D("palette-grey-400")), De(C.Switch, "defaultColor", D("palette-common-white")), De(C.Switch, "defaultDisabledColor", D("palette-grey-100")), De(C.Switch, "primaryDisabledColor", Gn(C.primary.main, 0.62)), De(C.Switch, "secondaryDisabledColor", Gn(C.secondary.main, 0.62)), De(C.Switch, "errorDisabledColor", Gn(C.error.main, 0.62)), De(C.Switch, "infoDisabledColor", Gn(C.info.main, 0.62)), De(C.Switch, "successDisabledColor", Gn(C.success.main, 0.62)), De(C.Switch, "warningDisabledColor", Gn(C.warning.main, 0.62)), De(C.TableCell, "border", Gn(gg(C.divider, 1), 0.88)), De(C.Tooltip, "bg", gg(C.grey[700], 0.92));
    }
    if (C.mode === "dark") {
      De(C.Alert, "errorColor", Gn(C.error.light, 0.6)), De(C.Alert, "infoColor", Gn(C.info.light, 0.6)), De(C.Alert, "successColor", Gn(C.success.light, 0.6)), De(C.Alert, "warningColor", Gn(C.warning.light, 0.6)), De(C.Alert, "errorFilledBg", D("palette-error-dark")), De(C.Alert, "infoFilledBg", D("palette-info-dark")), De(C.Alert, "successFilledBg", D("palette-success-dark")), De(C.Alert, "warningFilledBg", D("palette-warning-dark")), De(C.Alert, "errorFilledColor", gs(() => C.getContrastText(C.error.dark))), De(C.Alert, "infoFilledColor", gs(() => C.getContrastText(C.info.dark))), De(C.Alert, "successFilledColor", gs(() => C.getContrastText(C.success.dark))), De(C.Alert, "warningFilledColor", gs(() => C.getContrastText(C.warning.dark))), De(C.Alert, "errorStandardBg", zn(C.error.light, 0.9)), De(C.Alert, "infoStandardBg", zn(C.info.light, 0.9)), De(C.Alert, "successStandardBg", zn(C.success.light, 0.9)), De(C.Alert, "warningStandardBg", zn(C.warning.light, 0.9)), De(C.Alert, "errorIconColor", D("palette-error-main")), De(C.Alert, "infoIconColor", D("palette-info-main")), De(C.Alert, "successIconColor", D("palette-success-main")), De(C.Alert, "warningIconColor", D("palette-warning-main")), De(C.AppBar, "defaultBg", D("palette-grey-900")), De(C.AppBar, "darkBg", D("palette-background-paper")), De(C.AppBar, "darkColor", D("palette-text-primary")), De(C.Avatar, "defaultBg", D("palette-grey-600")), De(C.Button, "inheritContainedBg", D("palette-grey-800")), De(C.Button, "inheritContainedHoverBg", D("palette-grey-700")), De(C.Chip, "defaultBorder", D("palette-grey-700")), De(C.Chip, "defaultAvatarColor", D("palette-grey-300")), De(C.Chip, "defaultIconColor", D("palette-grey-300")), De(C.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), De(C.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), De(C.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), De(C.LinearProgress, "primaryBg", zn(C.primary.main, 0.5)), De(C.LinearProgress, "secondaryBg", zn(C.secondary.main, 0.5)), De(C.LinearProgress, "errorBg", zn(C.error.main, 0.5)), De(C.LinearProgress, "infoBg", zn(C.info.main, 0.5)), De(C.LinearProgress, "successBg", zn(C.success.main, 0.5)), De(C.LinearProgress, "warningBg", zn(C.warning.main, 0.5)), De(C.Skeleton, "bg", `rgba(${D("palette-text-primaryChannel")} / 0.13)`), De(C.Slider, "primaryTrack", zn(C.primary.main, 0.5)), De(C.Slider, "secondaryTrack", zn(C.secondary.main, 0.5)), De(C.Slider, "errorTrack", zn(C.error.main, 0.5)), De(C.Slider, "infoTrack", zn(C.info.main, 0.5)), De(C.Slider, "successTrack", zn(C.success.main, 0.5)), De(C.Slider, "warningTrack", zn(C.warning.main, 0.5));
      const L = mg(C.background.default, 0.98);
      De(C.SnackbarContent, "bg", L), De(C.SnackbarContent, "color", gs(() => C.getContrastText(L))), De(C.SpeedDialAction, "fabHoverBg", mg(C.background.paper, 0.15)), De(C.StepConnector, "border", D("palette-grey-600")), De(C.StepContent, "border", D("palette-grey-600")), De(C.Switch, "defaultColor", D("palette-grey-300")), De(C.Switch, "defaultDisabledColor", D("palette-grey-600")), De(C.Switch, "primaryDisabledColor", zn(C.primary.main, 0.55)), De(C.Switch, "secondaryDisabledColor", zn(C.secondary.main, 0.55)), De(C.Switch, "errorDisabledColor", zn(C.error.main, 0.55)), De(C.Switch, "infoDisabledColor", zn(C.info.main, 0.55)), De(C.Switch, "successDisabledColor", zn(C.success.main, 0.55)), De(C.Switch, "warningDisabledColor", zn(C.warning.main, 0.55)), De(C.TableCell, "border", zn(gg(C.divider, 1), 0.68)), De(C.Tooltip, "bg", gg(C.grey[700], 0.92));
    }
    sa(C.background, "default"), sa(C.background, "paper"), sa(C.common, "background"), sa(C.common, "onBackground"), sa(C, "divider"), Object.keys(C).forEach((L) => {
      const B = C[L];
      L !== "tonalOffset" && B && typeof B == "object" && (B.main && De(C[L], "mainChannel", _f(kf(B.main))), B.light && De(C[L], "lightChannel", _f(kf(B.light))), B.dark && De(C[L], "darkChannel", _f(kf(B.dark))), B.contrastText && De(C[L], "contrastTextChannel", _f(kf(B.contrastText))), L === "text" && (sa(C[L], "primary"), sa(C[L], "secondary")), L === "action" && (B.active && sa(C[L], "active"), B.selected && sa(C[L], "selected")));
    });
  }), T = t.reduce((_, C) => ui(_, C), T);
  const P = {
    prefix: i,
    disableCssColorScheme: o,
    shouldSkipGeneratingVar: a,
    getSelector: WQ(T)
  }, {
    vars: R,
    generateThemeVars: F,
    generateStyleSheets: A
  } = bQ(T, P);
  return T.vars = R, Object.entries(T.colorSchemes[T.defaultColorScheme]).forEach(([_, C]) => {
    T[_] = C;
  }), T.generateThemeVars = F, T.generateStyleSheets = A, T.generateSpacing = function() {
    return HM(d.spacing, xx(this));
  }, T.getColorSchemeSelector = yQ(l), T.spacing = T.generateSpacing(), T.shouldSkipGeneratingVar = a, T.unstable_sxConfig = {
    ...Rb,
    ...d == null ? void 0 : d.unstable_sxConfig
  }, T.unstable_sx = function(_) {
    return _b({
      sx: _,
      theme: this
    });
  }, T.toRuntimeSource = WM, T;
}
function vP(e, t, n) {
  e.colorSchemes && n && (e.colorSchemes[t] = {
    ...n !== !0 && n,
    palette: Px({
      ...n === !0 ? {} : n.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function wP(e = {}, ...t) {
  const {
    palette: n,
    cssVariables: r = !1,
    colorSchemes: o = n ? void 0 : {
      light: !0
    },
    defaultColorScheme: i = n == null ? void 0 : n.mode,
    ...a
  } = e, l = i || "light", c = o == null ? void 0 : o[l], d = {
    ...o,
    ...n ? {
      [l]: {
        ...typeof c != "boolean" && c,
        palette: n
      }
    } : void 0
  };
  if (r === !1) {
    if (!("colorSchemes" in e))
      return b0(e, ...t);
    let f = n;
    "palette" in e || d[l] && (d[l] !== !0 ? f = d[l].palette : l === "dark" && (f = {
      mode: "dark"
    }));
    const p = b0({
      ...e,
      palette: f
    }, ...t);
    return p.defaultColorScheme = l, p.colorSchemes = d, p.palette.mode === "light" && (p.colorSchemes.light = {
      ...d.light !== !0 && d.light,
      palette: p.palette
    }, vP(p, "dark", d.dark)), p.palette.mode === "dark" && (p.colorSchemes.dark = {
      ...d.dark !== !0 && d.dark,
      palette: p.palette
    }, vP(p, "light", d.light)), p;
  }
  return !n && !("light" in d) && l === "light" && (d.light = !0), QQ({
    ...a,
    colorSchemes: d,
    defaultColorScheme: l,
    ...typeof r != "boolean" && r
  }, ...t);
}
const XQ = (e, t) => {
  var n, r;
  return {
    components: {
      MuiDataGrid: {
        defaultProps: {
          localeText: h0({}, e, {
            MuiTablePagination: ((r = (n = t == null ? void 0 : t.components) == null ? void 0 : n.MuiTablePagination) == null ? void 0 : r.defaultProps) || {}
          })
        }
      }
    }
  };
}, JQ = {
  // Root
  noRowsLabel: "No rows",
  noResultsOverlayLabel: "No results found.",
  // Density selector toolbar button text
  toolbarDensity: "Density",
  toolbarDensityLabel: "Density",
  toolbarDensityCompact: "Compact",
  toolbarDensityStandard: "Standard",
  toolbarDensityComfortable: "Comfortable",
  // Columns selector toolbar button text
  toolbarColumns: "Columns",
  toolbarColumnsLabel: "Select columns",
  // Filters toolbar button text
  toolbarFilters: "Filters",
  toolbarFiltersLabel: "Show filters",
  toolbarFiltersTooltipHide: "Hide filters",
  toolbarFiltersTooltipShow: "Show filters",
  toolbarFiltersTooltipActive: (e) => e !== 1 ? `${e} active filters` : `${e} active filter`,
  // Quick filter toolbar field
  toolbarQuickFilterPlaceholder: "Search…",
  toolbarQuickFilterLabel: "Search",
  toolbarQuickFilterDeleteIconLabel: "Clear",
  // Export selector toolbar button text
  toolbarExport: "Export",
  toolbarExportLabel: "Export",
  toolbarExportCSV: "Download as CSV",
  toolbarExportPrint: "Print",
  toolbarExportExcel: "Download as Excel",
  // Columns management text
  columnsManagementSearchTitle: "Search",
  columnsManagementNoColumns: "No columns",
  columnsManagementShowHideAllText: "Show/Hide All",
  columnsManagementReset: "Reset",
  // Filter panel text
  filterPanelAddFilter: "Add filter",
  filterPanelRemoveAll: "Remove all",
  filterPanelDeleteIconLabel: "Delete",
  filterPanelLogicOperator: "Logic operator",
  filterPanelOperator: "Operator",
  filterPanelOperatorAnd: "And",
  filterPanelOperatorOr: "Or",
  filterPanelColumns: "Columns",
  filterPanelInputLabel: "Value",
  filterPanelInputPlaceholder: "Filter value",
  // Filter operators text
  filterOperatorContains: "contains",
  filterOperatorEquals: "equals",
  filterOperatorStartsWith: "starts with",
  filterOperatorEndsWith: "ends with",
  filterOperatorIs: "is",
  filterOperatorNot: "is not",
  filterOperatorAfter: "is after",
  filterOperatorOnOrAfter: "is on or after",
  filterOperatorBefore: "is before",
  filterOperatorOnOrBefore: "is on or before",
  filterOperatorIsEmpty: "is empty",
  filterOperatorIsNotEmpty: "is not empty",
  filterOperatorIsAnyOf: "is any of",
  "filterOperator=": "=",
  "filterOperator!=": "!=",
  "filterOperator>": ">",
  "filterOperator>=": ">=",
  "filterOperator<": "<",
  "filterOperator<=": "<=",
  // Header filter operators text
  headerFilterOperatorContains: "Contains",
  headerFilterOperatorEquals: "Equals",
  headerFilterOperatorStartsWith: "Starts with",
  headerFilterOperatorEndsWith: "Ends with",
  headerFilterOperatorIs: "Is",
  headerFilterOperatorNot: "Is not",
  headerFilterOperatorAfter: "Is after",
  headerFilterOperatorOnOrAfter: "Is on or after",
  headerFilterOperatorBefore: "Is before",
  headerFilterOperatorOnOrBefore: "Is on or before",
  headerFilterOperatorIsEmpty: "Is empty",
  headerFilterOperatorIsNotEmpty: "Is not empty",
  headerFilterOperatorIsAnyOf: "Is any of",
  "headerFilterOperator=": "Equals",
  "headerFilterOperator!=": "Not equals",
  "headerFilterOperator>": "Greater than",
  "headerFilterOperator>=": "Greater than or equal to",
  "headerFilterOperator<": "Less than",
  "headerFilterOperator<=": "Less than or equal to",
  // Filter values text
  filterValueAny: "any",
  filterValueTrue: "true",
  filterValueFalse: "false",
  // Column menu text
  columnMenuLabel: "Menu",
  columnMenuShowColumns: "Show columns",
  columnMenuManageColumns: "Manage columns",
  columnMenuFilter: "Filter",
  columnMenuHideColumn: "Hide column",
  columnMenuUnsort: "Unsort",
  columnMenuSortAsc: "Sort by ASC",
  columnMenuSortDesc: "Sort by DESC",
  // Column header text
  columnHeaderFiltersTooltipActive: (e) => e !== 1 ? `${e} active filters` : `${e} active filter`,
  columnHeaderFiltersLabel: "Show filters",
  columnHeaderSortIconLabel: "Sort",
  // Rows selected footer text
  footerRowSelected: (e) => e !== 1 ? `${e.toLocaleString()} rows selected` : `${e.toLocaleString()} row selected`,
  // Total row amount footer text
  footerTotalRows: "Total Rows:",
  // Total visible row amount footer text
  footerTotalVisibleRows: (e, t) => `${e.toLocaleString()} of ${t.toLocaleString()}`,
  // Checkbox selection text
  checkboxSelectionHeaderName: "Checkbox selection",
  checkboxSelectionSelectAllRows: "Select all rows",
  checkboxSelectionUnselectAllRows: "Unselect all rows",
  checkboxSelectionSelectRow: "Select row",
  checkboxSelectionUnselectRow: "Unselect row",
  // Boolean cell text
  booleanCellTrueLabel: "yes",
  booleanCellFalseLabel: "no",
  // Actions cell more text
  actionsCellMore: "more",
  // Column pinning text
  pinToLeft: "Pin to left",
  pinToRight: "Pin to right",
  unpin: "Unpin",
  // Tree Data
  treeDataGroupingHeaderName: "Group",
  treeDataExpand: "see children",
  treeDataCollapse: "hide children",
  // Grouping columns
  groupingColumnHeaderName: "Group",
  groupColumn: (e) => `Group by ${e}`,
  unGroupColumn: (e) => `Stop grouping by ${e}`,
  // Master/detail
  detailPanelToggle: "Detail panel toggle",
  expandDetailPanel: "Expand",
  collapseDetailPanel: "Collapse",
  // Used core components translation keys
  MuiTablePagination: {},
  // Row reordering text
  rowReorderingHeaderName: "Row reordering",
  // Aggregation
  aggregationMenuItemHeader: "Aggregation",
  aggregationFunctionLabelSum: "sum",
  aggregationFunctionLabelAvg: "avg",
  aggregationFunctionLabelMin: "min",
  aggregationFunctionLabelMax: "max",
  aggregationFunctionLabelSize: "size"
}, ZQ = XQ(JQ, FM);
function eX() {
  return [FM, ZQ];
}
function tX() {
  const e = {
    primary: {
      main: "#004798",
      900: "#00223C",
      400: "#007EC3",
      200: "#99BAE3"
    },
    secondary: {
      main: "#8BBC07"
    },
    action: {
      hover: "rgb(33 150 243 / 0.04)",
      selected: "rgb(33 150 243 / 0.08)"
    },
    text: {
      primary: "#323F4B",
      secondary: "#7B8794"
    },
    warning: {
      main: "#EF7C00",
      900: "#E05200",
      200: "#F3DB90",
      100: "#F9EDC7"
    },
    success: {
      main: "#158600",
      400: "#34C369",
      200: "#97E3B3",
      100: "#CBF1D9"
    },
    error: {
      main: "#C34545",
      600: "#8D0909",
      400: "#C34545",
      200: "#F99C9C",
      100: "#FFECEC"
    },
    grey: {
      900: "#171D23",
      800: "#323F4B",
      400: "#7B8794",
      300: "#B0B9C1",
      200: "#CBD2D9",
      100: "#E3E7EB"
    }
  }, t = wP(
    {
      palette: e,
      typography: {
        fontFamily: "Nunito",
        allVariants: {
          color: e.text.primary
        },
        h1: { fontSize: "2rem", fontWeight: 700, letterSpacing: "0rem" },
        h2: {
          fontSize: "1.5rem",
          fontWeight: 700,
          letterSpacing: "0.009375rem"
        },
        h3: {
          fontSize: "1.125rem",
          fontWeight: 700,
          letterSpacing: "0.009375rem"
        },
        h4: {
          fontSize: "0.875rem",
          fontWeight: 700,
          letterSpacing: "0.009375rem"
        },
        h5: {
          fontSize: "0.75rem",
          fontWeight: 700,
          letterSpacing: "0.09375rem"
        },
        body1: {
          // bodyRegular
          fontSize: "0.875rem",
          fontWeight: 400,
          letterSpacing: "0rem"
        },
        body2: {
          // bodySemiBold
          fontSize: "0.875rem",
          fontWeight: 600,
          letterSpacing: "0rem"
        },
        subtitle1: {
          // labelRegular
          fontSize: "0.75rem",
          fontWeight: 400,
          letterSpacing: "0.0125rem"
        },
        button: {
          fontSize: "0.75rem",
          fontWeight: 700,
          letterSpacing: "0.078125rem"
        },
        input: {
          fontSize: "1rem",
          fontStyle: "normal",
          lineHeight: "1.5rem",
          letterSpacing: "0.009rem",
          fontWeight: 400,
          fontFamily: "Roboto"
        }
      },
      cropConnect: {
        layout: {
          headerHeight: 64,
          footerMinHeight: 250
        },
        palette: {
          border: e.grey[400],
          status: {
            neutral: e.grey[900],
            neutralLight: e.grey[800],
            active: e.success.main,
            disabled: e.error.main
          },
          background: {
            general: "#F5F7FA",
            sidebar: e.primary[900]
          },
          textOnBackground: {
            general: e.primary.main,
            sidebar: e.primary[200]
          },
          grey: e.grey[300]
        },
        shape: {
          borderRadius: 18
        },
        icons: {
          viewBox: "0 0 24 24",
          width: 24,
          height: 24
        }
      }
    },
    ...eX()
  );
  return wP(t, {
    components: {
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: "none",
            borderRadius: t.cropConnect.shape.borderRadius,
            border: "none",
            padding: t.spacing(2)
          }
        }
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontSize: t.typography.h5.fontSize,
            fontWeight: t.typography.h5.fontWeight,
            letterSpacing: t.typography.h5.letterSpacing,
            top: "2px"
          },
          shrink: {
            left: "4px",
            top: "-4px"
          }
        }
      },
      MuiFilledInput: {
        styleOverrides: {
          root: {
            border: "0.5px solid transparent",
            borderRadius: "16px",
            disableUnderline: !0,
            "&.Mui-error": {
              borderColor: t.palette.error.main
            },
            "& .MuiFilledInput-input": {
              position: "relative",
              top: "-8px",
              left: "8px"
            }
          },
          multiline: {
            paddingLeft: "20px"
          }
        }
      },
      MuiAutocomplete: {
        styleOverrides: {
          clearIndicator: {
            color: e.text.primary
          },
          popupIndicator: {
            color: e.text.primary
          }
        }
      },
      MuiLink: {
        defaultProps: {
          underline: "none"
        }
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: t.cropConnect.shape.borderRadius
          }
        }
      }
    }
  });
}
const nX = tX();
function rX(e, ...t) {
  const n = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((r) => n.searchParams.append("args[]", r)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
function YM(e, t, n, r, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = e[t], a = o || t;
  return i == null ? null : i && i.nodeType !== 1 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an HTMLElement.`) : null;
}
const oX = s.oneOfType([s.func, s.object]);
function Jp(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : rX(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function fl(e) {
  return e && e.ownerDocument || document;
}
function iX(e) {
  return fl(e).defaultView || window;
}
function sX(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const Zr = typeof window < "u" ? m.useLayoutEffect : m.useEffect;
let CP = 0;
function aX(e) {
  const [t, n] = m.useState(e), r = t;
  return m.useEffect(() => {
    t == null && (CP += 1, n(`mui-${CP}`));
  }, [t]), r;
}
const lX = {
  ...m
}, xP = lX.useId;
function xr(e) {
  return xP !== void 0 ? xP() : aX(e);
}
function Yn(e) {
  const t = m.useRef(e);
  return Zr(() => {
    t.current = e;
  }), m.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function Rl(...e) {
  return m.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      sX(n, t);
    });
  }, e);
}
const SP = {};
function Ws(e, t) {
  const n = m.useRef(SP);
  return n.current === SP && (n.current = e(t)), n;
}
const cX = [];
function Mb(e) {
  m.useEffect(e, cX);
}
class Ix {
  constructor() {
    nt(this, "currentId", null);
    nt(this, "clear", () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    });
    nt(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new Ix();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
}
function Pd() {
  const e = Ws(Ix.create).current;
  return Mb(e.disposeEffect), e;
}
function QM(e, t) {
  const n = {
    ...t
  };
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      const o = r;
      if (o === "components" || o === "slots")
        n[o] = {
          ...e[o],
          ...n[o]
        };
      else if (o === "componentsProps" || o === "slotProps") {
        const i = e[o], a = t[o];
        if (!a)
          n[o] = i || {};
        else if (!i)
          n[o] = a;
        else {
          n[o] = {
            ...a
          };
          for (const l in i)
            if (Object.prototype.hasOwnProperty.call(i, l)) {
              const c = l;
              n[o][c] = QM(i[c], a[c]);
            }
        }
      } else n[o] === void 0 && (n[o] = e[o]);
    }
  return n;
}
function tn(e, t, n = void 0) {
  const r = {};
  for (const o in e) {
    const i = e[o];
    let a = "", l = !0;
    for (let c = 0; c < i.length; c += 1) {
      const d = i[c];
      d && (a += (l === !0 ? "" : " ") + t(d), l = !1, n && n[d] && (a += " " + n[d]));
    }
    r[o] = a;
  }
  return r;
}
const EP = (e) => e, uX = () => {
  let e = EP;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = EP;
    }
  };
}, dX = uX(), fX = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function XM(e, t, n = "Mui") {
  const r = fX[t];
  return r ? `${n}-${r}` : `${dX.generate(e)}-${t}`;
}
function JM(e, t, n = "Mui") {
  const r = {};
  return t.forEach((o) => {
    r[o] = XM(e, o, n);
  }), r;
}
const pX = ["localeText"], y0 = /* @__PURE__ */ m.createContext(null);
process.env.NODE_ENV !== "production" && (y0.displayName = "MuiPickersAdapterContext");
const ZM = function(t) {
  const {
    localeText: n
  } = t, r = yt(t, pX), {
    utils: o,
    localeText: i
  } = m.useContext(y0) ?? {
    utils: void 0,
    localeText: void 0
  }, a = Lk({
    // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
    // We will then merge this theme value with our value manually
    props: r,
    name: "MuiLocalizationProvider"
  }), {
    children: l,
    dateAdapter: c,
    dateFormats: d,
    dateLibInstance: f,
    adapterLocale: p,
    localeText: g
  } = a, b = m.useMemo(() => U({}, g, i, n), [g, i, n]), v = m.useMemo(() => {
    if (!c)
      return o || null;
    const E = new c({
      locale: p,
      formats: d,
      instance: f
    });
    if (!E.isMUIAdapter)
      throw new Error(["MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`", "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`", "More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation"].join(`
`));
    return E;
  }, [c, p, d, f, o]), y = m.useMemo(() => v ? {
    minDate: v.date("1900-01-01T00:00:00.000"),
    maxDate: v.date("2099-12-31T00:00:00.000")
  } : null, [v]), S = m.useMemo(() => ({
    utils: v,
    defaultDates: y,
    localeText: b
  }), [y, v, b]);
  return /* @__PURE__ */ w.jsx(y0.Provider, {
    value: S,
    children: l
  });
};
process.env.NODE_ENV !== "production" && (ZM.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Locale for the date library you are using
   */
  adapterLocale: s.any,
  children: s.node,
  /**
   * Date library adapter class function.
   * @see See the localization provider {@link https://mui.com/x/react-date-pickers/getting-started/#setup-your-date-library-adapter date adapter setup section} for more details.
   */
  dateAdapter: s.func,
  /**
   * Formats that are used for any child pickers
   */
  dateFormats: s.shape({
    dayOfMonth: s.string,
    dayOfMonthFull: s.string,
    fullDate: s.string,
    fullTime: s.string,
    fullTime12h: s.string,
    fullTime24h: s.string,
    hours12h: s.string,
    hours24h: s.string,
    keyboardDate: s.string,
    keyboardDateTime: s.string,
    keyboardDateTime12h: s.string,
    keyboardDateTime24h: s.string,
    meridiem: s.string,
    minutes: s.string,
    month: s.string,
    monthShort: s.string,
    normalDate: s.string,
    normalDateWithWeekday: s.string,
    seconds: s.string,
    shortDate: s.string,
    weekday: s.string,
    weekdayShort: s.string,
    year: s.string
  }),
  /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */
  dateLibInstance: s.any,
  /**
   * Locale for components texts
   */
  localeText: s.object
});
const TP = /* @__PURE__ */ new Set();
function ns(e, t = "warning") {
  if (process.env.NODE_ENV === "production")
    return;
  const n = Array.isArray(e) ? e.join(`
`) : e;
  TP.has(n) || (TP.add(n), t === "error" ? console.error(n) : console.warn(n));
}
const eA = Pc({
  isLoading: !0,
  session: null,
  error: null,
  logout: async () => ({ error: new Error("Session not loaded yet") }),
  useSso: !0
});
function Rx() {
  const e = Li(eA);
  if (e === void 0)
    throw new Error(
      "useSessionContext must be used within a SessionContextProvider."
    );
  return e;
}
var Zp = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.add(e), this.onSubscribe(), () => {
      this.listeners.delete(e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, xc = typeof window > "u" || "Deno" in globalThis;
function Pi() {
}
function hX(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function v0(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function tA(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function Lu(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Zi(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function OP(e, t) {
  const {
    type: n = "all",
    exact: r,
    fetchStatus: o,
    predicate: i,
    queryKey: a,
    stale: l
  } = e;
  if (a) {
    if (r) {
      if (t.queryHash !== _x(a, t.options))
        return !1;
    } else if (!hp(t.queryKey, a))
      return !1;
  }
  if (n !== "all") {
    const c = t.isActive();
    if (n === "active" && !c || n === "inactive" && c)
      return !1;
  }
  return !(typeof l == "boolean" && t.isStale() !== l || o && o !== t.state.fetchStatus || i && !i(t));
}
function PP(e, t) {
  const { exact: n, status: r, predicate: o, mutationKey: i } = e;
  if (i) {
    if (!t.options.mutationKey)
      return !1;
    if (n) {
      if (pp(t.options.mutationKey) !== pp(i))
        return !1;
    } else if (!hp(t.options.mutationKey, i))
      return !1;
  }
  return !(r && t.state.status !== r || o && !o(t));
}
function _x(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || pp)(e);
}
function pp(e) {
  return JSON.stringify(
    e,
    (t, n) => x0(n) ? Object.keys(n).sort().reduce((r, o) => (r[o] = n[o], r), {}) : n
  );
}
function hp(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some((n) => !hp(e[n], t[n])) : !1;
}
function w0(e, t) {
  if (e === t)
    return e;
  const n = IP(e) && IP(t);
  if (n || x0(e) && x0(t)) {
    const r = n ? e : Object.keys(e), o = r.length, i = n ? t : Object.keys(t), a = i.length, l = n ? [] : {};
    let c = 0;
    for (let d = 0; d < a; d++) {
      const f = n ? d : i[d];
      (!n && r.includes(f) || n) && e[f] === void 0 && t[f] === void 0 ? (l[f] = void 0, c++) : (l[f] = w0(e[f], t[f]), l[f] === e[f] && e[f] !== void 0 && c++);
    }
    return o === a && c === o ? e : l;
  }
  return t;
}
function C0(e, t) {
  if (!t || Object.keys(e).length !== Object.keys(t).length)
    return !1;
  for (const n in e)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function IP(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function x0(e) {
  if (!RP(e))
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(!RP(n) || !n.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function RP(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function gX(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function S0(e, t, n) {
  if (typeof n.structuralSharing == "function")
    return n.structuralSharing(e, t);
  if (n.structuralSharing !== !1) {
    if (process.env.NODE_ENV !== "production")
      try {
        return w0(e, t);
      } catch (r) {
        console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${n.queryHash}]: ${r}`
        );
      }
    return w0(e, t);
  }
  return t;
}
function mX(e, t, n = 0) {
  const r = [...e, t];
  return n && r.length > n ? r.slice(1) : r;
}
function bX(e, t, n = 0) {
  const r = [t, ...e];
  return n && r.length > n ? r.slice(0, -1) : r;
}
var fm = Symbol();
function nA(e, t) {
  return process.env.NODE_ENV !== "production" && e.queryFn === fm && console.error(
    `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${e.queryHash}'`
  ), !e.queryFn && (t != null && t.initialPromise) ? () => t.initialPromise : !e.queryFn || e.queryFn === fm ? () => Promise.reject(new Error(`Missing queryFn: '${e.queryHash}'`)) : e.queryFn;
}
var ic, Za, Gu, T_, yX = (T_ = class extends Zp {
  constructor() {
    super();
    Lt(this, ic);
    Lt(this, Za);
    Lt(this, Gu);
    ht(this, Gu, (t) => {
      if (!xc && window.addEventListener) {
        const n = () => t();
        return window.addEventListener("visibilitychange", n, !1), () => {
          window.removeEventListener("visibilitychange", n);
        };
      }
    });
  }
  onSubscribe() {
    ge(this, Za) || this.setEventListener(ge(this, Gu));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = ge(this, Za)) == null || t.call(this), ht(this, Za, void 0));
  }
  setEventListener(t) {
    var n;
    ht(this, Gu, t), (n = ge(this, Za)) == null || n.call(this), ht(this, Za, t((r) => {
      typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
    }));
  }
  setFocused(t) {
    ge(this, ic) !== t && (ht(this, ic, t), this.onFocus());
  }
  onFocus() {
    const t = this.isFocused();
    this.listeners.forEach((n) => {
      n(t);
    });
  }
  isFocused() {
    var t;
    return typeof ge(this, ic) == "boolean" ? ge(this, ic) : ((t = globalThis.document) == null ? void 0 : t.visibilityState) !== "hidden";
  }
}, ic = new WeakMap(), Za = new WeakMap(), Gu = new WeakMap(), T_), kx = new yX(), Wu, el, qu, O_, vX = (O_ = class extends Zp {
  constructor() {
    super();
    Lt(this, Wu, !0);
    Lt(this, el);
    Lt(this, qu);
    ht(this, qu, (t) => {
      if (!xc && window.addEventListener) {
        const n = () => t(!0), r = () => t(!1);
        return window.addEventListener("online", n, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", n), window.removeEventListener("offline", r);
        };
      }
    });
  }
  onSubscribe() {
    ge(this, el) || this.setEventListener(ge(this, qu));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = ge(this, el)) == null || t.call(this), ht(this, el, void 0));
  }
  setEventListener(t) {
    var n;
    ht(this, qu, t), (n = ge(this, el)) == null || n.call(this), ht(this, el, t(this.setOnline.bind(this)));
  }
  setOnline(t) {
    ge(this, Wu) !== t && (ht(this, Wu, t), this.listeners.forEach((r) => {
      r(t);
    }));
  }
  isOnline() {
    return ge(this, Wu);
  }
}, Wu = new WeakMap(), el = new WeakMap(), qu = new WeakMap(), O_), pm = new vX();
function E0() {
  let e, t;
  const n = new Promise((o, i) => {
    e = o, t = i;
  });
  n.status = "pending", n.catch(() => {
  });
  function r(o) {
    Object.assign(n, o), delete n.resolve, delete n.reject;
  }
  return n.resolve = (o) => {
    r({
      status: "fulfilled",
      value: o
    }), e(o);
  }, n.reject = (o) => {
    r({
      status: "rejected",
      reason: o
    }), t(o);
  }, n;
}
function wX(e) {
  return Math.min(1e3 * 2 ** e, 3e4);
}
function rA(e) {
  return (e ?? "online") === "online" ? pm.isOnline() : !0;
}
var oA = class extends Error {
  constructor(e) {
    super("CancelledError"), this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
};
function sw(e) {
  return e instanceof oA;
}
function iA(e) {
  let t = !1, n = 0, r = !1, o;
  const i = E0(), a = (y) => {
    var S;
    r || (g(new oA(y)), (S = e.abort) == null || S.call(e));
  }, l = () => {
    t = !0;
  }, c = () => {
    t = !1;
  }, d = () => kx.isFocused() && (e.networkMode === "always" || pm.isOnline()) && e.canRun(), f = () => rA(e.networkMode) && e.canRun(), p = (y) => {
    var S;
    r || (r = !0, (S = e.onSuccess) == null || S.call(e, y), o == null || o(), i.resolve(y));
  }, g = (y) => {
    var S;
    r || (r = !0, (S = e.onError) == null || S.call(e, y), o == null || o(), i.reject(y));
  }, b = () => new Promise((y) => {
    var S;
    o = (E) => {
      (r || d()) && y(E);
    }, (S = e.onPause) == null || S.call(e);
  }).then(() => {
    var y;
    o = void 0, r || (y = e.onContinue) == null || y.call(e);
  }), v = () => {
    if (r)
      return;
    let y;
    const S = n === 0 ? e.initialPromise : void 0;
    try {
      y = S ?? e.fn();
    } catch (E) {
      y = Promise.reject(E);
    }
    Promise.resolve(y).then(p).catch((E) => {
      var R;
      if (r)
        return;
      const I = e.retry ?? (xc ? 0 : 3), O = e.retryDelay ?? wX, T = typeof O == "function" ? O(n, E) : O, P = I === !0 || typeof I == "number" && n < I || typeof I == "function" && I(n, E);
      if (t || !P) {
        g(E);
        return;
      }
      n++, (R = e.onFail) == null || R.call(e, n, E), gX(T).then(() => d() ? void 0 : b()).then(() => {
        t ? g(E) : v();
      });
    });
  };
  return {
    promise: i,
    cancel: a,
    continue: () => (o == null || o(), i),
    cancelRetry: l,
    continueRetry: c,
    canStart: f,
    start: () => (f() ? v() : b().then(v), i)
  };
}
function CX() {
  let e = [], t = 0, n = (l) => {
    l();
  }, r = (l) => {
    l();
  }, o = (l) => setTimeout(l, 0);
  const i = (l) => {
    t ? e.push(l) : o(() => {
      n(l);
    });
  }, a = () => {
    const l = e;
    e = [], l.length && o(() => {
      r(() => {
        l.forEach((c) => {
          n(c);
        });
      });
    });
  };
  return {
    batch: (l) => {
      let c;
      t++;
      try {
        c = l();
      } finally {
        t--, t || a();
      }
      return c;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (l) => (...c) => {
      i(() => {
        l(...c);
      });
    },
    schedule: i,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (l) => {
      n = l;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (l) => {
      r = l;
    },
    setScheduler: (l) => {
      o = l;
    }
  };
}
var io = CX(), sc, P_, sA = (P_ = class {
  constructor() {
    Lt(this, sc);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), v0(this.gcTime) && ht(this, sc, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(e) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      e ?? (xc ? 1 / 0 : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    ge(this, sc) && (clearTimeout(ge(this, sc)), ht(this, sc, void 0));
  }
}, sc = new WeakMap(), P_), Ku, Yu, Oi, po, Ip, ac, Yi, la, I_, xX = (I_ = class extends sA {
  constructor(t) {
    super();
    Lt(this, Yi);
    Lt(this, Ku);
    Lt(this, Yu);
    Lt(this, Oi);
    Lt(this, po);
    Lt(this, Ip);
    Lt(this, ac);
    ht(this, ac, !1), ht(this, Ip, t.defaultOptions), this.setOptions(t.options), this.observers = [], ht(this, Oi, t.cache), this.queryKey = t.queryKey, this.queryHash = t.queryHash, ht(this, Ku, SX(this.options)), this.state = t.state ?? ge(this, Ku), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var t;
    return (t = ge(this, po)) == null ? void 0 : t.promise;
  }
  setOptions(t) {
    this.options = { ...ge(this, Ip), ...t }, this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && ge(this, Oi).remove(this);
  }
  setData(t, n) {
    const r = S0(this.state.data, t, this.options);
    return ln(this, Yi, la).call(this, {
      data: r,
      type: "success",
      dataUpdatedAt: n == null ? void 0 : n.updatedAt,
      manual: n == null ? void 0 : n.manual
    }), r;
  }
  setState(t, n) {
    ln(this, Yi, la).call(this, { type: "setState", state: t, setStateOptions: n });
  }
  cancel(t) {
    var r, o;
    const n = (r = ge(this, po)) == null ? void 0 : r.promise;
    return (o = ge(this, po)) == null || o.cancel(t), n ? n.then(Pi).catch(Pi) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(ge(this, Ku));
  }
  isActive() {
    return this.observers.some(
      (t) => Zi(t.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === fm || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStale() {
    return this.state.isInvalidated ? !0 : this.getObserversCount() > 0 ? this.observers.some(
      (t) => t.getCurrentResult().isStale
    ) : this.state.data === void 0;
  }
  isStaleByTime(t = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !tA(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    var n;
    const t = this.observers.find((r) => r.shouldFetchOnWindowFocus());
    t == null || t.refetch({ cancelRefetch: !1 }), (n = ge(this, po)) == null || n.continue();
  }
  onOnline() {
    var n;
    const t = this.observers.find((r) => r.shouldFetchOnReconnect());
    t == null || t.refetch({ cancelRefetch: !1 }), (n = ge(this, po)) == null || n.continue();
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), ge(this, Oi).notify({ type: "observerAdded", query: this, observer: t }));
  }
  removeObserver(t) {
    this.observers.includes(t) && (this.observers = this.observers.filter((n) => n !== t), this.observers.length || (ge(this, po) && (ge(this, ac) ? ge(this, po).cancel({ revert: !0 }) : ge(this, po).cancelRetry()), this.scheduleGc()), ge(this, Oi).notify({ type: "observerRemoved", query: this, observer: t }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || ln(this, Yi, la).call(this, { type: "invalidate" });
  }
  fetch(t, n) {
    var c, d, f;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && (n != null && n.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (ge(this, po))
        return ge(this, po).continueRetry(), ge(this, po).promise;
    }
    if (t && this.setOptions(t), !this.options.queryFn) {
      const p = this.observers.find((g) => g.options.queryFn);
      p && this.setOptions(p.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const r = new AbortController(), o = (p) => {
      Object.defineProperty(p, "signal", {
        enumerable: !0,
        get: () => (ht(this, ac, !0), r.signal)
      });
    }, i = () => {
      const p = nA(this.options, n), g = {
        queryKey: this.queryKey,
        meta: this.meta
      };
      return o(g), ht(this, ac, !1), this.options.persister ? this.options.persister(
        p,
        g,
        this
      ) : p(g);
    }, a = {
      fetchOptions: n,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: i
    };
    o(a), (c = this.options.behavior) == null || c.onFetch(
      a,
      this
    ), ht(this, Yu, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((d = a.fetchOptions) == null ? void 0 : d.meta)) && ln(this, Yi, la).call(this, { type: "fetch", meta: (f = a.fetchOptions) == null ? void 0 : f.meta });
    const l = (p) => {
      var g, b, v, y;
      sw(p) && p.silent || ln(this, Yi, la).call(this, {
        type: "error",
        error: p
      }), sw(p) || ((b = (g = ge(this, Oi).config).onError) == null || b.call(
        g,
        p,
        this
      ), (y = (v = ge(this, Oi).config).onSettled) == null || y.call(
        v,
        this.state.data,
        p,
        this
      )), this.scheduleGc();
    };
    return ht(this, po, iA({
      initialPromise: n == null ? void 0 : n.initialPromise,
      fn: a.fetchFn,
      abort: r.abort.bind(r),
      onSuccess: (p) => {
        var g, b, v, y;
        if (p === void 0) {
          process.env.NODE_ENV !== "production" && console.error(
            `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
          ), l(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        try {
          this.setData(p);
        } catch (S) {
          l(S);
          return;
        }
        (b = (g = ge(this, Oi).config).onSuccess) == null || b.call(g, p, this), (y = (v = ge(this, Oi).config).onSettled) == null || y.call(
          v,
          p,
          this.state.error,
          this
        ), this.scheduleGc();
      },
      onError: l,
      onFail: (p, g) => {
        ln(this, Yi, la).call(this, { type: "failed", failureCount: p, error: g });
      },
      onPause: () => {
        ln(this, Yi, la).call(this, { type: "pause" });
      },
      onContinue: () => {
        ln(this, Yi, la).call(this, { type: "continue" });
      },
      retry: a.options.retry,
      retryDelay: a.options.retryDelay,
      networkMode: a.options.networkMode,
      canRun: () => !0
    })), ge(this, po).start();
  }
}, Ku = new WeakMap(), Yu = new WeakMap(), Oi = new WeakMap(), po = new WeakMap(), Ip = new WeakMap(), ac = new WeakMap(), Yi = new WeakSet(), la = function(t) {
  const n = (r) => {
    switch (t.type) {
      case "failed":
        return {
          ...r,
          fetchFailureCount: t.failureCount,
          fetchFailureReason: t.error
        };
      case "pause":
        return {
          ...r,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...r,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...r,
          ...aA(r.data, this.options),
          fetchMeta: t.meta ?? null
        };
      case "success":
        return {
          ...r,
          data: t.data,
          dataUpdateCount: r.dataUpdateCount + 1,
          dataUpdatedAt: t.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!t.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const o = t.error;
        return sw(o) && o.revert && ge(this, Yu) ? { ...ge(this, Yu), fetchStatus: "idle" } : {
          ...r,
          error: o,
          errorUpdateCount: r.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: r.fetchFailureCount + 1,
          fetchFailureReason: o,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...r,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...r,
          ...t.state
        };
    }
  };
  this.state = n(this.state), io.batch(() => {
    this.observers.forEach((r) => {
      r.onQueryUpdate();
    }), ge(this, Oi).notify({ query: this, type: "updated", action: t });
  });
}, I_);
function aA(e, t) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: rA(t.networkMode) ? "fetching" : "paused",
    ...e === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function SX(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, n = t !== void 0, r = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var bs, R_, EX = (R_ = class extends Zp {
  constructor(t = {}) {
    super();
    Lt(this, bs);
    this.config = t, ht(this, bs, /* @__PURE__ */ new Map());
  }
  build(t, n, r) {
    const o = n.queryKey, i = n.queryHash ?? _x(o, n);
    let a = this.get(i);
    return a || (a = new xX({
      cache: this,
      queryKey: o,
      queryHash: i,
      options: t.defaultQueryOptions(n),
      state: r,
      defaultOptions: t.getQueryDefaults(o)
    }), this.add(a)), a;
  }
  add(t) {
    ge(this, bs).has(t.queryHash) || (ge(this, bs).set(t.queryHash, t), this.notify({
      type: "added",
      query: t
    }));
  }
  remove(t) {
    const n = ge(this, bs).get(t.queryHash);
    n && (t.destroy(), n === t && ge(this, bs).delete(t.queryHash), this.notify({ type: "removed", query: t }));
  }
  clear() {
    io.batch(() => {
      this.getAll().forEach((t) => {
        this.remove(t);
      });
    });
  }
  get(t) {
    return ge(this, bs).get(t);
  }
  getAll() {
    return [...ge(this, bs).values()];
  }
  find(t) {
    const n = { exact: !0, ...t };
    return this.getAll().find(
      (r) => OP(n, r)
    );
  }
  findAll(t = {}) {
    const n = this.getAll();
    return Object.keys(t).length > 0 ? n.filter((r) => OP(t, r)) : n;
  }
  notify(t) {
    io.batch(() => {
      this.listeners.forEach((n) => {
        n(t);
      });
    });
  }
  onFocus() {
    io.batch(() => {
      this.getAll().forEach((t) => {
        t.onFocus();
      });
    });
  }
  onOnline() {
    io.batch(() => {
      this.getAll().forEach((t) => {
        t.onOnline();
      });
    });
  }
}, bs = new WeakMap(), R_), ys, xo, lc, vs, Va, __, TX = (__ = class extends sA {
  constructor(t) {
    super();
    Lt(this, vs);
    Lt(this, ys);
    Lt(this, xo);
    Lt(this, lc);
    this.mutationId = t.mutationId, ht(this, xo, t.mutationCache), ht(this, ys, []), this.state = t.state || OX(), this.setOptions(t.options), this.scheduleGc();
  }
  setOptions(t) {
    this.options = t, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(t) {
    ge(this, ys).includes(t) || (ge(this, ys).push(t), this.clearGcTimeout(), ge(this, xo).notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    ht(this, ys, ge(this, ys).filter((n) => n !== t)), this.scheduleGc(), ge(this, xo).notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    ge(this, ys).length || (this.state.status === "pending" ? this.scheduleGc() : ge(this, xo).remove(this));
  }
  continue() {
    var t;
    return ((t = ge(this, lc)) == null ? void 0 : t.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(t) {
    var o, i, a, l, c, d, f, p, g, b, v, y, S, E, I, O, T, P, R, F;
    ht(this, lc, iA({
      fn: () => this.options.mutationFn ? this.options.mutationFn(t) : Promise.reject(new Error("No mutationFn found")),
      onFail: (A, _) => {
        ln(this, vs, Va).call(this, { type: "failed", failureCount: A, error: _ });
      },
      onPause: () => {
        ln(this, vs, Va).call(this, { type: "pause" });
      },
      onContinue: () => {
        ln(this, vs, Va).call(this, { type: "continue" });
      },
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => ge(this, xo).canRun(this)
    }));
    const n = this.state.status === "pending", r = !ge(this, lc).canStart();
    try {
      if (!n) {
        ln(this, vs, Va).call(this, { type: "pending", variables: t, isPaused: r }), await ((i = (o = ge(this, xo).config).onMutate) == null ? void 0 : i.call(
          o,
          t,
          this
        ));
        const _ = await ((l = (a = this.options).onMutate) == null ? void 0 : l.call(a, t));
        _ !== this.state.context && ln(this, vs, Va).call(this, {
          type: "pending",
          context: _,
          variables: t,
          isPaused: r
        });
      }
      const A = await ge(this, lc).start();
      return await ((d = (c = ge(this, xo).config).onSuccess) == null ? void 0 : d.call(
        c,
        A,
        t,
        this.state.context,
        this
      )), await ((p = (f = this.options).onSuccess) == null ? void 0 : p.call(f, A, t, this.state.context)), await ((b = (g = ge(this, xo).config).onSettled) == null ? void 0 : b.call(
        g,
        A,
        null,
        this.state.variables,
        this.state.context,
        this
      )), await ((y = (v = this.options).onSettled) == null ? void 0 : y.call(v, A, null, t, this.state.context)), ln(this, vs, Va).call(this, { type: "success", data: A }), A;
    } catch (A) {
      try {
        throw await ((E = (S = ge(this, xo).config).onError) == null ? void 0 : E.call(
          S,
          A,
          t,
          this.state.context,
          this
        )), await ((O = (I = this.options).onError) == null ? void 0 : O.call(
          I,
          A,
          t,
          this.state.context
        )), await ((P = (T = ge(this, xo).config).onSettled) == null ? void 0 : P.call(
          T,
          void 0,
          A,
          this.state.variables,
          this.state.context,
          this
        )), await ((F = (R = this.options).onSettled) == null ? void 0 : F.call(
          R,
          void 0,
          A,
          t,
          this.state.context
        )), A;
      } finally {
        ln(this, vs, Va).call(this, { type: "error", error: A });
      }
    } finally {
      ge(this, xo).runNext(this);
    }
  }
}, ys = new WeakMap(), xo = new WeakMap(), lc = new WeakMap(), vs = new WeakSet(), Va = function(t) {
  const n = (r) => {
    switch (t.type) {
      case "failed":
        return {
          ...r,
          failureCount: t.failureCount,
          failureReason: t.error
        };
      case "pause":
        return {
          ...r,
          isPaused: !0
        };
      case "continue":
        return {
          ...r,
          isPaused: !1
        };
      case "pending":
        return {
          ...r,
          context: t.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: t.isPaused,
          status: "pending",
          variables: t.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...r,
          data: t.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...r,
          data: void 0,
          error: t.error,
          failureCount: r.failureCount + 1,
          failureReason: t.error,
          isPaused: !1,
          status: "error"
        };
    }
  };
  this.state = n(this.state), io.batch(() => {
    ge(this, ys).forEach((r) => {
      r.onMutationUpdate(t);
    }), ge(this, xo).notify({
      mutation: this,
      type: "updated",
      action: t
    });
  });
}, __);
function OX() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var pa, Qi, Rp, k_, PX = (k_ = class extends Zp {
  constructor(t = {}) {
    super();
    Lt(this, pa);
    Lt(this, Qi);
    Lt(this, Rp);
    this.config = t, ht(this, pa, /* @__PURE__ */ new Set()), ht(this, Qi, /* @__PURE__ */ new Map()), ht(this, Rp, 0);
  }
  build(t, n, r) {
    const o = new TX({
      mutationCache: this,
      mutationId: ++ng(this, Rp)._,
      options: t.defaultMutationOptions(n),
      state: r
    });
    return this.add(o), o;
  }
  add(t) {
    ge(this, pa).add(t);
    const n = bg(t);
    if (typeof n == "string") {
      const r = ge(this, Qi).get(n);
      r ? r.push(t) : ge(this, Qi).set(n, [t]);
    }
    this.notify({ type: "added", mutation: t });
  }
  remove(t) {
    if (ge(this, pa).delete(t)) {
      const n = bg(t);
      if (typeof n == "string") {
        const r = ge(this, Qi).get(n);
        if (r)
          if (r.length > 1) {
            const o = r.indexOf(t);
            o !== -1 && r.splice(o, 1);
          } else r[0] === t && ge(this, Qi).delete(n);
      }
    }
    this.notify({ type: "removed", mutation: t });
  }
  canRun(t) {
    const n = bg(t);
    if (typeof n == "string") {
      const r = ge(this, Qi).get(n), o = r == null ? void 0 : r.find(
        (i) => i.state.status === "pending"
      );
      return !o || o === t;
    } else
      return !0;
  }
  runNext(t) {
    var r;
    const n = bg(t);
    if (typeof n == "string") {
      const o = (r = ge(this, Qi).get(n)) == null ? void 0 : r.find((i) => i !== t && i.state.isPaused);
      return (o == null ? void 0 : o.continue()) ?? Promise.resolve();
    } else
      return Promise.resolve();
  }
  clear() {
    io.batch(() => {
      ge(this, pa).forEach((t) => {
        this.notify({ type: "removed", mutation: t });
      }), ge(this, pa).clear(), ge(this, Qi).clear();
    });
  }
  getAll() {
    return Array.from(ge(this, pa));
  }
  find(t) {
    const n = { exact: !0, ...t };
    return this.getAll().find(
      (r) => PP(n, r)
    );
  }
  findAll(t = {}) {
    return this.getAll().filter((n) => PP(t, n));
  }
  notify(t) {
    io.batch(() => {
      this.listeners.forEach((n) => {
        n(t);
      });
    });
  }
  resumePausedMutations() {
    const t = this.getAll().filter((n) => n.state.isPaused);
    return io.batch(
      () => Promise.all(
        t.map((n) => n.continue().catch(Pi))
      )
    );
  }
}, pa = new WeakMap(), Qi = new WeakMap(), Rp = new WeakMap(), k_);
function bg(e) {
  var t;
  return (t = e.options.scope) == null ? void 0 : t.id;
}
function _P(e) {
  return {
    onFetch: (t, n) => {
      var f, p, g, b, v;
      const r = t.options, o = (g = (p = (f = t.fetchOptions) == null ? void 0 : f.meta) == null ? void 0 : p.fetchMore) == null ? void 0 : g.direction, i = ((b = t.state.data) == null ? void 0 : b.pages) || [], a = ((v = t.state.data) == null ? void 0 : v.pageParams) || [];
      let l = { pages: [], pageParams: [] }, c = 0;
      const d = async () => {
        let y = !1;
        const S = (O) => {
          Object.defineProperty(O, "signal", {
            enumerable: !0,
            get: () => (t.signal.aborted ? y = !0 : t.signal.addEventListener("abort", () => {
              y = !0;
            }), t.signal)
          });
        }, E = nA(t.options, t.fetchOptions), I = async (O, T, P) => {
          if (y)
            return Promise.reject();
          if (T == null && O.pages.length)
            return Promise.resolve(O);
          const R = {
            queryKey: t.queryKey,
            pageParam: T,
            direction: P ? "backward" : "forward",
            meta: t.options.meta
          };
          S(R);
          const F = await E(
            R
          ), { maxPages: A } = t.options, _ = P ? bX : mX;
          return {
            pages: _(O.pages, F, A),
            pageParams: _(O.pageParams, T, A)
          };
        };
        if (o && i.length) {
          const O = o === "backward", T = O ? IX : kP, P = {
            pages: i,
            pageParams: a
          }, R = T(r, P);
          l = await I(P, R, O);
        } else {
          const O = e ?? i.length;
          do {
            const T = c === 0 ? a[0] ?? r.initialPageParam : kP(r, l);
            if (c > 0 && T == null)
              break;
            l = await I(l, T), c++;
          } while (c < O);
        }
        return l;
      };
      t.options.persister ? t.fetchFn = () => {
        var y, S;
        return (S = (y = t.options).persister) == null ? void 0 : S.call(
          y,
          d,
          {
            queryKey: t.queryKey,
            meta: t.options.meta,
            signal: t.signal
          },
          n
        );
      } : t.fetchFn = d;
    }
  };
}
function kP(e, { pages: t, pageParams: n }) {
  const r = t.length - 1;
  return t.length > 0 ? e.getNextPageParam(
    t[r],
    t,
    n[r],
    n
  ) : void 0;
}
function IX(e, { pages: t, pageParams: n }) {
  var r;
  return t.length > 0 ? (r = e.getPreviousPageParam) == null ? void 0 : r.call(e, t[0], t, n[0], n) : void 0;
}
var vr, tl, nl, Qu, Xu, rl, Ju, Zu, M_, RX = (M_ = class {
  constructor(e = {}) {
    Lt(this, vr);
    Lt(this, tl);
    Lt(this, nl);
    Lt(this, Qu);
    Lt(this, Xu);
    Lt(this, rl);
    Lt(this, Ju);
    Lt(this, Zu);
    ht(this, vr, e.queryCache || new EX()), ht(this, tl, e.mutationCache || new PX()), ht(this, nl, e.defaultOptions || {}), ht(this, Qu, /* @__PURE__ */ new Map()), ht(this, Xu, /* @__PURE__ */ new Map()), ht(this, rl, 0);
  }
  mount() {
    ng(this, rl)._++, ge(this, rl) === 1 && (ht(this, Ju, kx.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), ge(this, vr).onFocus());
    })), ht(this, Zu, pm.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), ge(this, vr).onOnline());
    })));
  }
  unmount() {
    var e, t;
    ng(this, rl)._--, ge(this, rl) === 0 && ((e = ge(this, Ju)) == null || e.call(this), ht(this, Ju, void 0), (t = ge(this, Zu)) == null || t.call(this), ht(this, Zu, void 0));
  }
  isFetching(e) {
    return ge(this, vr).findAll({ ...e, fetchStatus: "fetching" }).length;
  }
  isMutating(e) {
    return ge(this, tl).findAll({ ...e, status: "pending" }).length;
  }
  getQueryData(e) {
    var n;
    const t = this.defaultQueryOptions({ queryKey: e });
    return (n = ge(this, vr).get(t.queryHash)) == null ? void 0 : n.state.data;
  }
  ensureQueryData(e) {
    const t = this.defaultQueryOptions(e), n = ge(this, vr).build(this, t), r = n.state.data;
    return r === void 0 ? this.fetchQuery(e) : (e.revalidateIfStale && n.isStaleByTime(Lu(t.staleTime, n)) && this.prefetchQuery(t), Promise.resolve(r));
  }
  getQueriesData(e) {
    return ge(this, vr).findAll(e).map(({ queryKey: t, state: n }) => {
      const r = n.data;
      return [t, r];
    });
  }
  setQueryData(e, t, n) {
    const r = this.defaultQueryOptions({ queryKey: e }), o = ge(this, vr).get(
      r.queryHash
    ), i = o == null ? void 0 : o.state.data, a = hX(t, i);
    if (a !== void 0)
      return ge(this, vr).build(this, r).setData(a, { ...n, manual: !0 });
  }
  setQueriesData(e, t, n) {
    return io.batch(
      () => ge(this, vr).findAll(e).map(({ queryKey: r }) => [
        r,
        this.setQueryData(r, t, n)
      ])
    );
  }
  getQueryState(e) {
    var n;
    const t = this.defaultQueryOptions({ queryKey: e });
    return (n = ge(this, vr).get(
      t.queryHash
    )) == null ? void 0 : n.state;
  }
  removeQueries(e) {
    const t = ge(this, vr);
    io.batch(() => {
      t.findAll(e).forEach((n) => {
        t.remove(n);
      });
    });
  }
  resetQueries(e, t) {
    const n = ge(this, vr), r = {
      type: "active",
      ...e
    };
    return io.batch(() => (n.findAll(e).forEach((o) => {
      o.reset();
    }), this.refetchQueries(r, t)));
  }
  cancelQueries(e, t = {}) {
    const n = { revert: !0, ...t }, r = io.batch(
      () => ge(this, vr).findAll(e).map((o) => o.cancel(n))
    );
    return Promise.all(r).then(Pi).catch(Pi);
  }
  invalidateQueries(e, t = {}) {
    return io.batch(() => {
      if (ge(this, vr).findAll(e).forEach((r) => {
        r.invalidate();
      }), (e == null ? void 0 : e.refetchType) === "none")
        return Promise.resolve();
      const n = {
        ...e,
        type: (e == null ? void 0 : e.refetchType) ?? (e == null ? void 0 : e.type) ?? "active"
      };
      return this.refetchQueries(n, t);
    });
  }
  refetchQueries(e, t = {}) {
    const n = {
      ...t,
      cancelRefetch: t.cancelRefetch ?? !0
    }, r = io.batch(
      () => ge(this, vr).findAll(e).filter((o) => !o.isDisabled()).map((o) => {
        let i = o.fetch(void 0, n);
        return n.throwOnError || (i = i.catch(Pi)), o.state.fetchStatus === "paused" ? Promise.resolve() : i;
      })
    );
    return Promise.all(r).then(Pi);
  }
  fetchQuery(e) {
    const t = this.defaultQueryOptions(e);
    t.retry === void 0 && (t.retry = !1);
    const n = ge(this, vr).build(this, t);
    return n.isStaleByTime(
      Lu(t.staleTime, n)
    ) ? n.fetch(t) : Promise.resolve(n.state.data);
  }
  prefetchQuery(e) {
    return this.fetchQuery(e).then(Pi).catch(Pi);
  }
  fetchInfiniteQuery(e) {
    return e.behavior = _P(e.pages), this.fetchQuery(e);
  }
  prefetchInfiniteQuery(e) {
    return this.fetchInfiniteQuery(e).then(Pi).catch(Pi);
  }
  ensureInfiniteQueryData(e) {
    return e.behavior = _P(e.pages), this.ensureQueryData(e);
  }
  resumePausedMutations() {
    return pm.isOnline() ? ge(this, tl).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return ge(this, vr);
  }
  getMutationCache() {
    return ge(this, tl);
  }
  getDefaultOptions() {
    return ge(this, nl);
  }
  setDefaultOptions(e) {
    ht(this, nl, e);
  }
  setQueryDefaults(e, t) {
    ge(this, Qu).set(pp(e), {
      queryKey: e,
      defaultOptions: t
    });
  }
  getQueryDefaults(e) {
    const t = [...ge(this, Qu).values()], n = {};
    return t.forEach((r) => {
      hp(e, r.queryKey) && Object.assign(n, r.defaultOptions);
    }), n;
  }
  setMutationDefaults(e, t) {
    ge(this, Xu).set(pp(e), {
      mutationKey: e,
      defaultOptions: t
    });
  }
  getMutationDefaults(e) {
    const t = [...ge(this, Xu).values()];
    let n = {};
    return t.forEach((r) => {
      hp(e, r.mutationKey) && (n = { ...n, ...r.defaultOptions });
    }), n;
  }
  defaultQueryOptions(e) {
    if (e._defaulted)
      return e;
    const t = {
      ...ge(this, nl).queries,
      ...this.getQueryDefaults(e.queryKey),
      ...e,
      _defaulted: !0
    };
    return t.queryHash || (t.queryHash = _x(
      t.queryKey,
      t
    )), t.refetchOnReconnect === void 0 && (t.refetchOnReconnect = t.networkMode !== "always"), t.throwOnError === void 0 && (t.throwOnError = !!t.suspense), !t.networkMode && t.persister && (t.networkMode = "offlineFirst"), t.queryFn === fm && (t.enabled = !1), t;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...ge(this, nl).mutations,
      ...(e == null ? void 0 : e.mutationKey) && this.getMutationDefaults(e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    ge(this, vr).clear(), ge(this, tl).clear();
  }
}, vr = new WeakMap(), tl = new WeakMap(), nl = new WeakMap(), Qu = new WeakMap(), Xu = new WeakMap(), rl = new WeakMap(), Ju = new WeakMap(), Zu = new WeakMap(), M_), $o, cn, _p, So, cc, ed, ol, ws, kp, td, nd, uc, dc, il, rd, Tn, Mf, T0, O0, P0, I0, R0, _0, k0, lA, A_, _X = (A_ = class extends Zp {
  constructor(t, n) {
    super();
    Lt(this, Tn);
    Lt(this, $o);
    Lt(this, cn);
    Lt(this, _p);
    Lt(this, So);
    Lt(this, cc);
    Lt(this, ed);
    Lt(this, ol);
    Lt(this, ws);
    Lt(this, kp);
    Lt(this, td);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    Lt(this, nd);
    Lt(this, uc);
    Lt(this, dc);
    Lt(this, il);
    Lt(this, rd, /* @__PURE__ */ new Set());
    this.options = n, ht(this, $o, t), ht(this, ws, null), ht(this, ol, E0()), this.options.experimental_prefetchInRender || ge(this, ol).reject(
      new Error("experimental_prefetchInRender feature flag is not enabled")
    ), this.bindMethods(), this.setOptions(n);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (ge(this, cn).addObserver(this), MP(ge(this, cn), this.options) ? ln(this, Tn, Mf).call(this) : this.updateResult(), ln(this, Tn, I0).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return M0(
      ge(this, cn),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return M0(
      ge(this, cn),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), ln(this, Tn, R0).call(this), ln(this, Tn, _0).call(this), ge(this, cn).removeObserver(this);
  }
  setOptions(t, n) {
    const r = this.options, o = ge(this, cn);
    if (this.options = ge(this, $o).defaultQueryOptions(t), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof Zi(this.options.enabled, ge(this, cn)) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    ln(this, Tn, k0).call(this), ge(this, cn).setOptions(this.options), r._defaulted && !C0(this.options, r) && ge(this, $o).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: ge(this, cn),
      observer: this
    });
    const i = this.hasListeners();
    i && AP(
      ge(this, cn),
      o,
      this.options,
      r
    ) && ln(this, Tn, Mf).call(this), this.updateResult(n), i && (ge(this, cn) !== o || Zi(this.options.enabled, ge(this, cn)) !== Zi(r.enabled, ge(this, cn)) || Lu(this.options.staleTime, ge(this, cn)) !== Lu(r.staleTime, ge(this, cn))) && ln(this, Tn, T0).call(this);
    const a = ln(this, Tn, O0).call(this);
    i && (ge(this, cn) !== o || Zi(this.options.enabled, ge(this, cn)) !== Zi(r.enabled, ge(this, cn)) || a !== ge(this, il)) && ln(this, Tn, P0).call(this, a);
  }
  getOptimisticResult(t) {
    const n = ge(this, $o).getQueryCache().build(ge(this, $o), t), r = this.createResult(n, t);
    return MX(this, r) && (ht(this, So, r), ht(this, ed, this.options), ht(this, cc, ge(this, cn).state)), r;
  }
  getCurrentResult() {
    return ge(this, So);
  }
  trackResult(t, n) {
    const r = {};
    return Object.keys(t).forEach((o) => {
      Object.defineProperty(r, o, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackProp(o), n == null || n(o), t[o])
      });
    }), r;
  }
  trackProp(t) {
    ge(this, rd).add(t);
  }
  getCurrentQuery() {
    return ge(this, cn);
  }
  refetch({ ...t } = {}) {
    return this.fetch({
      ...t
    });
  }
  fetchOptimistic(t) {
    const n = ge(this, $o).defaultQueryOptions(t), r = ge(this, $o).getQueryCache().build(ge(this, $o), n);
    return r.fetch().then(() => this.createResult(r, n));
  }
  fetch(t) {
    return ln(this, Tn, Mf).call(this, {
      ...t,
      cancelRefetch: t.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), ge(this, So)));
  }
  createResult(t, n) {
    var A;
    const r = ge(this, cn), o = this.options, i = ge(this, So), a = ge(this, cc), l = ge(this, ed), d = t !== r ? t.state : ge(this, _p), { state: f } = t;
    let p = { ...f }, g = !1, b;
    if (n._optimisticResults) {
      const _ = this.hasListeners(), C = !_ && MP(t, n), D = _ && AP(t, r, n, o);
      (C || D) && (p = {
        ...p,
        ...aA(f.data, t.options)
      }), n._optimisticResults === "isRestoring" && (p.fetchStatus = "idle");
    }
    let { error: v, errorUpdatedAt: y, status: S } = p;
    if (n.select && p.data !== void 0)
      if (i && p.data === (a == null ? void 0 : a.data) && n.select === ge(this, kp))
        b = ge(this, td);
      else
        try {
          ht(this, kp, n.select), b = n.select(p.data), b = S0(i == null ? void 0 : i.data, b, n), ht(this, td, b), ht(this, ws, null);
        } catch (_) {
          ht(this, ws, _);
        }
    else
      b = p.data;
    if (n.placeholderData !== void 0 && b === void 0 && S === "pending") {
      let _;
      if (i != null && i.isPlaceholderData && n.placeholderData === (l == null ? void 0 : l.placeholderData))
        _ = i.data;
      else if (_ = typeof n.placeholderData == "function" ? n.placeholderData(
        (A = ge(this, nd)) == null ? void 0 : A.state.data,
        ge(this, nd)
      ) : n.placeholderData, n.select && _ !== void 0)
        try {
          _ = n.select(_), ht(this, ws, null);
        } catch (C) {
          ht(this, ws, C);
        }
      _ !== void 0 && (S = "success", b = S0(
        i == null ? void 0 : i.data,
        _,
        n
      ), g = !0);
    }
    ge(this, ws) && (v = ge(this, ws), b = ge(this, td), y = Date.now(), S = "error");
    const E = p.fetchStatus === "fetching", I = S === "pending", O = S === "error", T = I && E, P = b !== void 0, F = {
      status: S,
      fetchStatus: p.fetchStatus,
      isPending: I,
      isSuccess: S === "success",
      isError: O,
      isInitialLoading: T,
      isLoading: T,
      data: b,
      dataUpdatedAt: p.dataUpdatedAt,
      error: v,
      errorUpdatedAt: y,
      failureCount: p.fetchFailureCount,
      failureReason: p.fetchFailureReason,
      errorUpdateCount: p.errorUpdateCount,
      isFetched: p.dataUpdateCount > 0 || p.errorUpdateCount > 0,
      isFetchedAfterMount: p.dataUpdateCount > d.dataUpdateCount || p.errorUpdateCount > d.errorUpdateCount,
      isFetching: E,
      isRefetching: E && !I,
      isLoadingError: O && !P,
      isPaused: p.fetchStatus === "paused",
      isPlaceholderData: g,
      isRefetchError: O && P,
      isStale: Mx(t, n),
      refetch: this.refetch,
      promise: ge(this, ol)
    };
    if (this.options.experimental_prefetchInRender) {
      const _ = (L) => {
        F.status === "error" ? L.reject(F.error) : F.data !== void 0 && L.resolve(F.data);
      }, C = () => {
        const L = ht(this, ol, F.promise = E0());
        _(L);
      }, D = ge(this, ol);
      switch (D.status) {
        case "pending":
          t.queryHash === r.queryHash && _(D);
          break;
        case "fulfilled":
          (F.status === "error" || F.data !== D.value) && C();
          break;
        case "rejected":
          (F.status !== "error" || F.error !== D.reason) && C();
          break;
      }
    }
    return F;
  }
  updateResult(t) {
    const n = ge(this, So), r = this.createResult(ge(this, cn), this.options);
    if (ht(this, cc, ge(this, cn).state), ht(this, ed, this.options), ge(this, cc).data !== void 0 && ht(this, nd, ge(this, cn)), C0(r, n))
      return;
    ht(this, So, r);
    const o = {}, i = () => {
      if (!n)
        return !0;
      const { notifyOnChangeProps: a } = this.options, l = typeof a == "function" ? a() : a;
      if (l === "all" || !l && !ge(this, rd).size)
        return !0;
      const c = new Set(
        l ?? ge(this, rd)
      );
      return this.options.throwOnError && c.add("error"), Object.keys(ge(this, So)).some((d) => {
        const f = d;
        return ge(this, So)[f] !== n[f] && c.has(f);
      });
    };
    (t == null ? void 0 : t.listeners) !== !1 && i() && (o.listeners = !0), ln(this, Tn, lA).call(this, { ...o, ...t });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && ln(this, Tn, I0).call(this);
  }
}, $o = new WeakMap(), cn = new WeakMap(), _p = new WeakMap(), So = new WeakMap(), cc = new WeakMap(), ed = new WeakMap(), ol = new WeakMap(), ws = new WeakMap(), kp = new WeakMap(), td = new WeakMap(), nd = new WeakMap(), uc = new WeakMap(), dc = new WeakMap(), il = new WeakMap(), rd = new WeakMap(), Tn = new WeakSet(), Mf = function(t) {
  ln(this, Tn, k0).call(this);
  let n = ge(this, cn).fetch(
    this.options,
    t
  );
  return t != null && t.throwOnError || (n = n.catch(Pi)), n;
}, T0 = function() {
  ln(this, Tn, R0).call(this);
  const t = Lu(
    this.options.staleTime,
    ge(this, cn)
  );
  if (xc || ge(this, So).isStale || !v0(t))
    return;
  const r = tA(ge(this, So).dataUpdatedAt, t) + 1;
  ht(this, uc, setTimeout(() => {
    ge(this, So).isStale || this.updateResult();
  }, r));
}, O0 = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(ge(this, cn)) : this.options.refetchInterval) ?? !1;
}, P0 = function(t) {
  ln(this, Tn, _0).call(this), ht(this, il, t), !(xc || Zi(this.options.enabled, ge(this, cn)) === !1 || !v0(ge(this, il)) || ge(this, il) === 0) && ht(this, dc, setInterval(() => {
    (this.options.refetchIntervalInBackground || kx.isFocused()) && ln(this, Tn, Mf).call(this);
  }, ge(this, il)));
}, I0 = function() {
  ln(this, Tn, T0).call(this), ln(this, Tn, P0).call(this, ln(this, Tn, O0).call(this));
}, R0 = function() {
  ge(this, uc) && (clearTimeout(ge(this, uc)), ht(this, uc, void 0));
}, _0 = function() {
  ge(this, dc) && (clearInterval(ge(this, dc)), ht(this, dc, void 0));
}, k0 = function() {
  const t = ge(this, $o).getQueryCache().build(ge(this, $o), this.options);
  if (t === ge(this, cn))
    return;
  const n = ge(this, cn);
  ht(this, cn, t), ht(this, _p, t.state), this.hasListeners() && (n == null || n.removeObserver(this), t.addObserver(this));
}, lA = function(t) {
  io.batch(() => {
    t.listeners && this.listeners.forEach((n) => {
      n(ge(this, So));
    }), ge(this, $o).getQueryCache().notify({
      query: ge(this, cn),
      type: "observerResultsUpdated"
    });
  });
}, A_);
function kX(e, t) {
  return Zi(t.enabled, e) !== !1 && e.state.data === void 0 && !(e.state.status === "error" && t.retryOnMount === !1);
}
function MP(e, t) {
  return kX(e, t) || e.state.data !== void 0 && M0(e, t, t.refetchOnMount);
}
function M0(e, t, n) {
  if (Zi(t.enabled, e) !== !1) {
    const r = typeof n == "function" ? n(e) : n;
    return r === "always" || r !== !1 && Mx(e, t);
  }
  return !1;
}
function AP(e, t, n, r) {
  return (e !== t || Zi(r.enabled, e) === !1) && (!n.suspense || e.state.status !== "error") && Mx(e, n);
}
function Mx(e, t) {
  return Zi(t.enabled, e) !== !1 && e.isStaleByTime(Lu(t.staleTime, e));
}
function MX(e, t) {
  return !C0(e.getCurrentResult(), t);
}
var cA = m.createContext(
  void 0
), Ab = (e) => {
  const t = m.useContext(cA);
  if (!t)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return t;
}, AX = ({
  client: e,
  children: t
}) => (m.useEffect(() => (e.mount(), () => {
  e.unmount();
}), [e]), /* @__PURE__ */ w.jsx(cA.Provider, { value: e, children: t })), uA = m.createContext(!1), DX = () => m.useContext(uA);
uA.Provider;
function NX() {
  let e = !1;
  return {
    clearReset: () => {
      e = !1;
    },
    reset: () => {
      e = !0;
    },
    isReset: () => e
  };
}
var FX = m.createContext(NX()), $X = () => m.useContext(FX);
function LX(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
function DP() {
}
var jX = (e, t) => {
  (e.suspense || e.throwOnError || e.experimental_prefetchInRender) && (t.isReset() || (e.retryOnMount = !1));
}, BX = (e) => {
  m.useEffect(() => {
    e.clearReset();
  }, [e]);
}, VX = ({
  result: e,
  errorResetBoundary: t,
  throwOnError: n,
  query: r
}) => e.isError && !t.isReset() && !e.isFetching && r && LX(n, [e.error, r]), HX = (e) => {
  const t = e.staleTime;
  e.suspense && (e.staleTime = typeof t == "function" ? (...n) => Math.max(t(...n), 1e3) : Math.max(t ?? 1e3, 1e3), typeof e.gcTime == "number" && (e.gcTime = Math.max(e.gcTime, 1e3)));
}, UX = (e, t) => e.isLoading && e.isFetching && !t, zX = (e, t) => (e == null ? void 0 : e.suspense) && t.isPending, NP = (e, t, n) => t.fetchOptimistic(e).catch(() => {
  n.clearReset();
});
function GX(e, t, n) {
  var p, g, b, v, y;
  if (process.env.NODE_ENV !== "production" && (typeof e != "object" || Array.isArray(e)))
    throw new Error(
      'Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object'
    );
  const r = Ab(), o = DX(), i = $X(), a = r.defaultQueryOptions(e);
  (g = (p = r.getDefaultOptions().queries) == null ? void 0 : p._experimental_beforeQuery) == null || g.call(
    p,
    a
  ), a._optimisticResults = o ? "isRestoring" : "optimistic", HX(a), jX(a, i), BX(i);
  const l = !r.getQueryCache().get(a.queryHash), [c] = m.useState(
    () => new t(
      r,
      a
    )
  ), d = c.getOptimisticResult(a), f = !o && e.subscribed !== !1;
  if (m.useSyncExternalStore(
    m.useCallback(
      (S) => {
        const E = f ? c.subscribe(io.batchCalls(S)) : DP;
        return c.updateResult(), E;
      },
      [c, f]
    ),
    () => c.getCurrentResult(),
    () => c.getCurrentResult()
  ), m.useEffect(() => {
    c.setOptions(a, { listeners: !1 });
  }, [a, c]), zX(a, d))
    throw NP(a, c, i);
  if (VX({
    result: d,
    errorResetBoundary: i,
    throwOnError: a.throwOnError,
    query: r.getQueryCache().get(a.queryHash)
  }))
    throw d.error;
  if ((v = (b = r.getDefaultOptions().queries) == null ? void 0 : b._experimental_afterQuery) == null || v.call(
    b,
    a,
    d
  ), a.experimental_prefetchInRender && !xc && UX(d, o)) {
    const S = l ? (
      // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
      NP(a, c, i)
    ) : (
      // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
      (y = r.getQueryCache().get(a.queryHash)) == null ? void 0 : y.promise
    );
    S == null || S.catch(DP).finally(() => {
      c.updateResult();
    });
  }
  return a.notifyOnChangeProps ? d : c.trackResult(d);
}
function Db(e, t) {
  return GX(e, _X);
}
function lo(e) {
  return e === null || typeof e > "u";
}
function wt(e) {
  return !lo(e);
}
function Ax(e) {
  if (wt(e))
    return e;
  throw Error("The given value is expected to be defined but was undefined");
}
function WX(e) {
  return typeof e == "object" && e !== null && e.constructor.name === "Object";
}
const A0 = {
  BadRequest: 400,
  Unauthorized: 401,
  NotFound: 404,
  InternalServerError: 500
};
function dA(e) {
  if (e instanceof Response)
    return e.status;
}
function qX(e) {
  const t = dA(e);
  return wt(t) && t >= A0.BadRequest && t < A0.InternalServerError;
}
function KX(e) {
  const t = dA(e);
  return wt(t) && t >= A0.InternalServerError;
}
function YX(e, t) {
  return qX(t) ? !1 : e < 1;
}
function QX({
  children: e
}) {
  const [t] = Jt(
    () => new RX({
      defaultOptions: {
        queries: {
          retry: YX,
          refetchOnWindowFocus: !1,
          // globally default to 5 minutes
          staleTime: 3e5,
          // throw server errors by default
          throwOnError: KX
        }
      }
    })
  ), n = Rx();
  return ir(() => {
    t.invalidateQueries();
  }, [n.session, t]), /* @__PURE__ */ w.jsx(AX, { client: t, children: e });
}
const XX = (e) => {
  let t;
  return e ? t = e : typeof fetch > "u" ? t = (...n) => Promise.resolve().then(() => Id).then(({ default: r }) => r(...n)) : t = fetch, (...n) => t(...n);
};
class Dx extends Error {
  constructor(t, n = "FunctionsError", r) {
    super(t), this.name = n, this.context = r;
  }
}
class fA extends Dx {
  constructor(t) {
    super("Failed to send a request to the Edge Function", "FunctionsFetchError", t);
  }
}
class pA extends Dx {
  constructor(t) {
    super("Relay Error invoking the Edge Function", "FunctionsRelayError", t);
  }
}
class hA extends Dx {
  constructor(t) {
    super("Edge Function returned a non-2xx status code", "FunctionsHttpError", t);
  }
}
var D0;
(function(e) {
  e.Any = "any", e.ApNortheast1 = "ap-northeast-1", e.ApNortheast2 = "ap-northeast-2", e.ApSouth1 = "ap-south-1", e.ApSoutheast1 = "ap-southeast-1", e.ApSoutheast2 = "ap-southeast-2", e.CaCentral1 = "ca-central-1", e.EuCentral1 = "eu-central-1", e.EuWest1 = "eu-west-1", e.EuWest2 = "eu-west-2", e.EuWest3 = "eu-west-3", e.SaEast1 = "sa-east-1", e.UsEast1 = "us-east-1", e.UsWest1 = "us-west-1", e.UsWest2 = "us-west-2";
})(D0 || (D0 = {}));
var JX = function(e, t, n, r) {
  function o(i) {
    return i instanceof n ? i : new n(function(a) {
      a(i);
    });
  }
  return new (n || (n = Promise))(function(i, a) {
    function l(f) {
      try {
        d(r.next(f));
      } catch (p) {
        a(p);
      }
    }
    function c(f) {
      try {
        d(r.throw(f));
      } catch (p) {
        a(p);
      }
    }
    function d(f) {
      f.done ? i(f.value) : o(f.value).then(l, c);
    }
    d((r = r.apply(e, t || [])).next());
  });
};
class ZX {
  constructor(t, { headers: n = {}, customFetch: r, region: o = D0.Any } = {}) {
    this.url = t, this.headers = n, this.region = o, this.fetch = XX(r);
  }
  /**
   * Updates the authorization header
   * @param token - the new jwt token sent in the authorisation header
   */
  setAuth(t) {
    this.headers.Authorization = `Bearer ${t}`;
  }
  /**
   * Invokes a function
   * @param functionName - The name of the Function to invoke.
   * @param options - Options for invoking the Function.
   */
  invoke(t, n = {}) {
    var r;
    return JX(this, void 0, void 0, function* () {
      try {
        const { headers: o, method: i, body: a } = n;
        let l = {}, { region: c } = n;
        c || (c = this.region), c && c !== "any" && (l["x-region"] = c);
        let d;
        a && (o && !Object.prototype.hasOwnProperty.call(o, "Content-Type") || !o) && (typeof Blob < "u" && a instanceof Blob || a instanceof ArrayBuffer ? (l["Content-Type"] = "application/octet-stream", d = a) : typeof a == "string" ? (l["Content-Type"] = "text/plain", d = a) : typeof FormData < "u" && a instanceof FormData ? d = a : (l["Content-Type"] = "application/json", d = JSON.stringify(a)));
        const f = yield this.fetch(`${this.url}/${t}`, {
          method: i || "POST",
          // headers priority is (high to low):
          // 1. invoke-level headers
          // 2. client-level headers
          // 3. default Content-Type header
          headers: Object.assign(Object.assign(Object.assign({}, l), this.headers), o),
          body: d
        }).catch((v) => {
          throw new fA(v);
        }), p = f.headers.get("x-relay-error");
        if (p && p === "true")
          throw new pA(f);
        if (!f.ok)
          throw new hA(f);
        let g = ((r = f.headers.get("Content-Type")) !== null && r !== void 0 ? r : "text/plain").split(";")[0].trim(), b;
        return g === "application/json" ? b = yield f.json() : g === "application/octet-stream" ? b = yield f.blob() : g === "text/event-stream" ? b = f : g === "multipart/form-data" ? b = yield f.formData() : b = yield f.text(), { data: b, error: null };
      } catch (o) {
        return { data: null, error: o };
      }
    });
  }
}
var Bo = {}, Nx = {}, Nb = {}, eh = {}, Fb = {}, $b = {}, eJ = function() {
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("unable to locate global object");
}, gd = eJ();
const tJ = gd.fetch, gA = gd.fetch.bind(gd), mA = gd.Headers, nJ = gd.Request, rJ = gd.Response, Id = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Headers: mA,
  Request: nJ,
  Response: rJ,
  default: gA,
  fetch: tJ
}, Symbol.toStringTag, { value: "Module" })), oJ = /* @__PURE__ */ hz(Id);
var Lb = {};
Object.defineProperty(Lb, "__esModule", { value: !0 });
class iJ extends Error {
  constructor(t) {
    super(t.message), this.name = "PostgrestError", this.details = t.details, this.hint = t.hint, this.code = t.code;
  }
}
Lb.default = iJ;
var bA = Cr && Cr.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty($b, "__esModule", { value: !0 });
const sJ = bA(oJ), aJ = bA(Lb);
let lJ = class {
  constructor(t) {
    this.shouldThrowOnError = !1, this.method = t.method, this.url = t.url, this.headers = t.headers, this.schema = t.schema, this.body = t.body, this.shouldThrowOnError = t.shouldThrowOnError, this.signal = t.signal, this.isMaybeSingle = t.isMaybeSingle, t.fetch ? this.fetch = t.fetch : typeof fetch > "u" ? this.fetch = sJ.default : this.fetch = fetch;
  }
  /**
   * If there's an error with the query, throwOnError will reject the promise by
   * throwing the error instead of returning it as part of a successful response.
   *
   * {@link https://github.com/supabase/supabase-js/issues/92}
   */
  throwOnError() {
    return this.shouldThrowOnError = !0, this;
  }
  /**
   * Set an HTTP header for the request.
   */
  setHeader(t, n) {
    return this.headers = Object.assign({}, this.headers), this.headers[t] = n, this;
  }
  then(t, n) {
    this.schema === void 0 || (["GET", "HEAD"].includes(this.method) ? this.headers["Accept-Profile"] = this.schema : this.headers["Content-Profile"] = this.schema), this.method !== "GET" && this.method !== "HEAD" && (this.headers["Content-Type"] = "application/json");
    const r = this.fetch;
    let o = r(this.url.toString(), {
      method: this.method,
      headers: this.headers,
      body: JSON.stringify(this.body),
      signal: this.signal
    }).then(async (i) => {
      var a, l, c;
      let d = null, f = null, p = null, g = i.status, b = i.statusText;
      if (i.ok) {
        if (this.method !== "HEAD") {
          const E = await i.text();
          E === "" || (this.headers.Accept === "text/csv" || this.headers.Accept && this.headers.Accept.includes("application/vnd.pgrst.plan+text") ? f = E : f = JSON.parse(E));
        }
        const y = (a = this.headers.Prefer) === null || a === void 0 ? void 0 : a.match(/count=(exact|planned|estimated)/), S = (l = i.headers.get("content-range")) === null || l === void 0 ? void 0 : l.split("/");
        y && S && S.length > 1 && (p = parseInt(S[1])), this.isMaybeSingle && this.method === "GET" && Array.isArray(f) && (f.length > 1 ? (d = {
          // https://github.com/PostgREST/postgrest/blob/a867d79c42419af16c18c3fb019eba8df992626f/src/PostgREST/Error.hs#L553
          code: "PGRST116",
          details: `Results contain ${f.length} rows, application/vnd.pgrst.object+json requires 1 row`,
          hint: null,
          message: "JSON object requested, multiple (or no) rows returned"
        }, f = null, p = null, g = 406, b = "Not Acceptable") : f.length === 1 ? f = f[0] : f = null);
      } else {
        const y = await i.text();
        try {
          d = JSON.parse(y), Array.isArray(d) && i.status === 404 && (f = [], d = null, g = 200, b = "OK");
        } catch {
          i.status === 404 && y === "" ? (g = 204, b = "No Content") : d = {
            message: y
          };
        }
        if (d && this.isMaybeSingle && (!((c = d == null ? void 0 : d.details) === null || c === void 0) && c.includes("0 rows")) && (d = null, g = 200, b = "OK"), d && this.shouldThrowOnError)
          throw new aJ.default(d);
      }
      return {
        error: d,
        data: f,
        count: p,
        status: g,
        statusText: b
      };
    });
    return this.shouldThrowOnError || (o = o.catch((i) => {
      var a, l, c;
      return {
        error: {
          message: `${(a = i == null ? void 0 : i.name) !== null && a !== void 0 ? a : "FetchError"}: ${i == null ? void 0 : i.message}`,
          details: `${(l = i == null ? void 0 : i.stack) !== null && l !== void 0 ? l : ""}`,
          hint: "",
          code: `${(c = i == null ? void 0 : i.code) !== null && c !== void 0 ? c : ""}`
        },
        data: null,
        count: null,
        status: 0,
        statusText: ""
      };
    })), o.then(t, n);
  }
};
$b.default = lJ;
var cJ = Cr && Cr.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Fb, "__esModule", { value: !0 });
const uJ = cJ($b);
let dJ = class extends uJ.default {
  /**
   * Perform a SELECT on the query result.
   *
   * By default, `.insert()`, `.update()`, `.upsert()`, and `.delete()` do not
   * return modified rows. By calling this method, modified rows are returned in
   * `data`.
   *
   * @param columns - The columns to retrieve, separated by commas
   */
  select(t) {
    let n = !1;
    const r = (t ?? "*").split("").map((o) => /\s/.test(o) && !n ? "" : (o === '"' && (n = !n), o)).join("");
    return this.url.searchParams.set("select", r), this.headers.Prefer && (this.headers.Prefer += ","), this.headers.Prefer += "return=representation", this;
  }
  /**
   * Order the query result by `column`.
   *
   * You can call this method multiple times to order by multiple columns.
   *
   * You can order referenced tables, but it only affects the ordering of the
   * parent table if you use `!inner` in the query.
   *
   * @param column - The column to order by
   * @param options - Named parameters
   * @param options.ascending - If `true`, the result will be in ascending order
   * @param options.nullsFirst - If `true`, `null`s appear first. If `false`,
   * `null`s appear last.
   * @param options.referencedTable - Set this to order a referenced table by
   * its columns
   * @param options.foreignTable - Deprecated, use `options.referencedTable`
   * instead
   */
  order(t, { ascending: n = !0, nullsFirst: r, foreignTable: o, referencedTable: i = o } = {}) {
    const a = i ? `${i}.order` : "order", l = this.url.searchParams.get(a);
    return this.url.searchParams.set(a, `${l ? `${l},` : ""}${t}.${n ? "asc" : "desc"}${r === void 0 ? "" : r ? ".nullsfirst" : ".nullslast"}`), this;
  }
  /**
   * Limit the query result by `count`.
   *
   * @param count - The maximum number of rows to return
   * @param options - Named parameters
   * @param options.referencedTable - Set this to limit rows of referenced
   * tables instead of the parent table
   * @param options.foreignTable - Deprecated, use `options.referencedTable`
   * instead
   */
  limit(t, { foreignTable: n, referencedTable: r = n } = {}) {
    const o = typeof r > "u" ? "limit" : `${r}.limit`;
    return this.url.searchParams.set(o, `${t}`), this;
  }
  /**
   * Limit the query result by starting at an offset `from` and ending at the offset `to`.
   * Only records within this range are returned.
   * This respects the query order and if there is no order clause the range could behave unexpectedly.
   * The `from` and `to` values are 0-based and inclusive: `range(1, 3)` will include the second, third
   * and fourth rows of the query.
   *
   * @param from - The starting index from which to limit the result
   * @param to - The last index to which to limit the result
   * @param options - Named parameters
   * @param options.referencedTable - Set this to limit rows of referenced
   * tables instead of the parent table
   * @param options.foreignTable - Deprecated, use `options.referencedTable`
   * instead
   */
  range(t, n, { foreignTable: r, referencedTable: o = r } = {}) {
    const i = typeof o > "u" ? "offset" : `${o}.offset`, a = typeof o > "u" ? "limit" : `${o}.limit`;
    return this.url.searchParams.set(i, `${t}`), this.url.searchParams.set(a, `${n - t + 1}`), this;
  }
  /**
   * Set the AbortSignal for the fetch request.
   *
   * @param signal - The AbortSignal to use for the fetch request
   */
  abortSignal(t) {
    return this.signal = t, this;
  }
  /**
   * Return `data` as a single object instead of an array of objects.
   *
   * Query result must be one row (e.g. using `.limit(1)`), otherwise this
   * returns an error.
   */
  single() {
    return this.headers.Accept = "application/vnd.pgrst.object+json", this;
  }
  /**
   * Return `data` as a single object instead of an array of objects.
   *
   * Query result must be zero or one row (e.g. using `.limit(1)`), otherwise
   * this returns an error.
   */
  maybeSingle() {
    return this.method === "GET" ? this.headers.Accept = "application/json" : this.headers.Accept = "application/vnd.pgrst.object+json", this.isMaybeSingle = !0, this;
  }
  /**
   * Return `data` as a string in CSV format.
   */
  csv() {
    return this.headers.Accept = "text/csv", this;
  }
  /**
   * Return `data` as an object in [GeoJSON](https://geojson.org) format.
   */
  geojson() {
    return this.headers.Accept = "application/geo+json", this;
  }
  /**
   * Return `data` as the EXPLAIN plan for the query.
   *
   * You need to enable the
   * [db_plan_enabled](https://supabase.com/docs/guides/database/debugging-performance#enabling-explain)
   * setting before using this method.
   *
   * @param options - Named parameters
   *
   * @param options.analyze - If `true`, the query will be executed and the
   * actual run time will be returned
   *
   * @param options.verbose - If `true`, the query identifier will be returned
   * and `data` will include the output columns of the query
   *
   * @param options.settings - If `true`, include information on configuration
   * parameters that affect query planning
   *
   * @param options.buffers - If `true`, include information on buffer usage
   *
   * @param options.wal - If `true`, include information on WAL record generation
   *
   * @param options.format - The format of the output, can be `"text"` (default)
   * or `"json"`
   */
  explain({ analyze: t = !1, verbose: n = !1, settings: r = !1, buffers: o = !1, wal: i = !1, format: a = "text" } = {}) {
    var l;
    const c = [
      t ? "analyze" : null,
      n ? "verbose" : null,
      r ? "settings" : null,
      o ? "buffers" : null,
      i ? "wal" : null
    ].filter(Boolean).join("|"), d = (l = this.headers.Accept) !== null && l !== void 0 ? l : "application/json";
    return this.headers.Accept = `application/vnd.pgrst.plan+${a}; for="${d}"; options=${c};`, a === "json" ? this : this;
  }
  /**
   * Rollback the query.
   *
   * `data` will still be returned, but the query is not committed.
   */
  rollback() {
    var t;
    return ((t = this.headers.Prefer) !== null && t !== void 0 ? t : "").trim().length > 0 ? this.headers.Prefer += ",tx=rollback" : this.headers.Prefer = "tx=rollback", this;
  }
  /**
   * Override the type of the returned `data`.
   *
   * @typeParam NewResult - The new result type to override with
   */
  returns() {
    return this;
  }
};
Fb.default = dJ;
var fJ = Cr && Cr.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(eh, "__esModule", { value: !0 });
const pJ = fJ(Fb);
let hJ = class extends pJ.default {
  /**
   * Match only rows where `column` is equal to `value`.
   *
   * To check if the value of `column` is NULL, you should use `.is()` instead.
   *
   * @param column - The column to filter on
   * @param value - The value to filter with
   */
  eq(t, n) {
    return this.url.searchParams.append(t, `eq.${n}`), this;
  }
  /**
   * Match only rows where `column` is not equal to `value`.
   *
   * @param column - The column to filter on
   * @param value - The value to filter with
   */
  neq(t, n) {
    return this.url.searchParams.append(t, `neq.${n}`), this;
  }
  /**
   * Match only rows where `column` is greater than `value`.
   *
   * @param column - The column to filter on
   * @param value - The value to filter with
   */
  gt(t, n) {
    return this.url.searchParams.append(t, `gt.${n}`), this;
  }
  /**
   * Match only rows where `column` is greater than or equal to `value`.
   *
   * @param column - The column to filter on
   * @param value - The value to filter with
   */
  gte(t, n) {
    return this.url.searchParams.append(t, `gte.${n}`), this;
  }
  /**
   * Match only rows where `column` is less than `value`.
   *
   * @param column - The column to filter on
   * @param value - The value to filter with
   */
  lt(t, n) {
    return this.url.searchParams.append(t, `lt.${n}`), this;
  }
  /**
   * Match only rows where `column` is less than or equal to `value`.
   *
   * @param column - The column to filter on
   * @param value - The value to filter with
   */
  lte(t, n) {
    return this.url.searchParams.append(t, `lte.${n}`), this;
  }
  /**
   * Match only rows where `column` matches `pattern` case-sensitively.
   *
   * @param column - The column to filter on
   * @param pattern - The pattern to match with
   */
  like(t, n) {
    return this.url.searchParams.append(t, `like.${n}`), this;
  }
  /**
   * Match only rows where `column` matches all of `patterns` case-sensitively.
   *
   * @param column - The column to filter on
   * @param patterns - The patterns to match with
   */
  likeAllOf(t, n) {
    return this.url.searchParams.append(t, `like(all).{${n.join(",")}}`), this;
  }
  /**
   * Match only rows where `column` matches any of `patterns` case-sensitively.
   *
   * @param column - The column to filter on
   * @param patterns - The patterns to match with
   */
  likeAnyOf(t, n) {
    return this.url.searchParams.append(t, `like(any).{${n.join(",")}}`), this;
  }
  /**
   * Match only rows where `column` matches `pattern` case-insensitively.
   *
   * @param column - The column to filter on
   * @param pattern - The pattern to match with
   */
  ilike(t, n) {
    return this.url.searchParams.append(t, `ilike.${n}`), this;
  }
  /**
   * Match only rows where `column` matches all of `patterns` case-insensitively.
   *
   * @param column - The column to filter on
   * @param patterns - The patterns to match with
   */
  ilikeAllOf(t, n) {
    return this.url.searchParams.append(t, `ilike(all).{${n.join(",")}}`), this;
  }
  /**
   * Match only rows where `column` matches any of `patterns` case-insensitively.
   *
   * @param column - The column to filter on
   * @param patterns - The patterns to match with
   */
  ilikeAnyOf(t, n) {
    return this.url.searchParams.append(t, `ilike(any).{${n.join(",")}}`), this;
  }
  /**
   * Match only rows where `column` IS `value`.
   *
   * For non-boolean columns, this is only relevant for checking if the value of
   * `column` is NULL by setting `value` to `null`.
   *
   * For boolean columns, you can also set `value` to `true` or `false` and it
   * will behave the same way as `.eq()`.
   *
   * @param column - The column to filter on
   * @param value - The value to filter with
   */
  is(t, n) {
    return this.url.searchParams.append(t, `is.${n}`), this;
  }
  /**
   * Match only rows where `column` is included in the `values` array.
   *
   * @param column - The column to filter on
   * @param values - The values array to filter with
   */
  in(t, n) {
    const r = Array.from(new Set(n)).map((o) => typeof o == "string" && new RegExp("[,()]").test(o) ? `"${o}"` : `${o}`).join(",");
    return this.url.searchParams.append(t, `in.(${r})`), this;
  }
  /**
   * Only relevant for jsonb, array, and range columns. Match only rows where
   * `column` contains every element appearing in `value`.
   *
   * @param column - The jsonb, array, or range column to filter on
   * @param value - The jsonb, array, or range value to filter with
   */
  contains(t, n) {
    return typeof n == "string" ? this.url.searchParams.append(t, `cs.${n}`) : Array.isArray(n) ? this.url.searchParams.append(t, `cs.{${n.join(",")}}`) : this.url.searchParams.append(t, `cs.${JSON.stringify(n)}`), this;
  }
  /**
   * Only relevant for jsonb, array, and range columns. Match only rows where
   * every element appearing in `column` is contained by `value`.
   *
   * @param column - The jsonb, array, or range column to filter on
   * @param value - The jsonb, array, or range value to filter with
   */
  containedBy(t, n) {
    return typeof n == "string" ? this.url.searchParams.append(t, `cd.${n}`) : Array.isArray(n) ? this.url.searchParams.append(t, `cd.{${n.join(",")}}`) : this.url.searchParams.append(t, `cd.${JSON.stringify(n)}`), this;
  }
  /**
   * Only relevant for range columns. Match only rows where every element in
   * `column` is greater than any element in `range`.
   *
   * @param column - The range column to filter on
   * @param range - The range to filter with
   */
  rangeGt(t, n) {
    return this.url.searchParams.append(t, `sr.${n}`), this;
  }
  /**
   * Only relevant for range columns. Match only rows where every element in
   * `column` is either contained in `range` or greater than any element in
   * `range`.
   *
   * @param column - The range column to filter on
   * @param range - The range to filter with
   */
  rangeGte(t, n) {
    return this.url.searchParams.append(t, `nxl.${n}`), this;
  }
  /**
   * Only relevant for range columns. Match only rows where every element in
   * `column` is less than any element in `range`.
   *
   * @param column - The range column to filter on
   * @param range - The range to filter with
   */
  rangeLt(t, n) {
    return this.url.searchParams.append(t, `sl.${n}`), this;
  }
  /**
   * Only relevant for range columns. Match only rows where every element in
   * `column` is either contained in `range` or less than any element in
   * `range`.
   *
   * @param column - The range column to filter on
   * @param range - The range to filter with
   */
  rangeLte(t, n) {
    return this.url.searchParams.append(t, `nxr.${n}`), this;
  }
  /**
   * Only relevant for range columns. Match only rows where `column` is
   * mutually exclusive to `range` and there can be no element between the two
   * ranges.
   *
   * @param column - The range column to filter on
   * @param range - The range to filter with
   */
  rangeAdjacent(t, n) {
    return this.url.searchParams.append(t, `adj.${n}`), this;
  }
  /**
   * Only relevant for array and range columns. Match only rows where
   * `column` and `value` have an element in common.
   *
   * @param column - The array or range column to filter on
   * @param value - The array or range value to filter with
   */
  overlaps(t, n) {
    return typeof n == "string" ? this.url.searchParams.append(t, `ov.${n}`) : this.url.searchParams.append(t, `ov.{${n.join(",")}}`), this;
  }
  /**
   * Only relevant for text and tsvector columns. Match only rows where
   * `column` matches the query string in `query`.
   *
   * @param column - The text or tsvector column to filter on
   * @param query - The query text to match with
   * @param options - Named parameters
   * @param options.config - The text search configuration to use
   * @param options.type - Change how the `query` text is interpreted
   */
  textSearch(t, n, { config: r, type: o } = {}) {
    let i = "";
    o === "plain" ? i = "pl" : o === "phrase" ? i = "ph" : o === "websearch" && (i = "w");
    const a = r === void 0 ? "" : `(${r})`;
    return this.url.searchParams.append(t, `${i}fts${a}.${n}`), this;
  }
  /**
   * Match only rows where each column in `query` keys is equal to its
   * associated value. Shorthand for multiple `.eq()`s.
   *
   * @param query - The object to filter with, with column names as keys mapped
   * to their filter values
   */
  match(t) {
    return Object.entries(t).forEach(([n, r]) => {
      this.url.searchParams.append(n, `eq.${r}`);
    }), this;
  }
  /**
   * Match only rows which doesn't satisfy the filter.
   *
   * Unlike most filters, `opearator` and `value` are used as-is and need to
   * follow [PostgREST
   * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
   * to make sure they are properly sanitized.
   *
   * @param column - The column to filter on
   * @param operator - The operator to be negated to filter with, following
   * PostgREST syntax
   * @param value - The value to filter with, following PostgREST syntax
   */
  not(t, n, r) {
    return this.url.searchParams.append(t, `not.${n}.${r}`), this;
  }
  /**
   * Match only rows which satisfy at least one of the filters.
   *
   * Unlike most filters, `filters` is used as-is and needs to follow [PostgREST
   * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
   * to make sure it's properly sanitized.
   *
   * It's currently not possible to do an `.or()` filter across multiple tables.
   *
   * @param filters - The filters to use, following PostgREST syntax
   * @param options - Named parameters
   * @param options.referencedTable - Set this to filter on referenced tables
   * instead of the parent table
   * @param options.foreignTable - Deprecated, use `referencedTable` instead
   */
  or(t, { foreignTable: n, referencedTable: r = n } = {}) {
    const o = r ? `${r}.or` : "or";
    return this.url.searchParams.append(o, `(${t})`), this;
  }
  /**
   * Match only rows which satisfy the filter. This is an escape hatch - you
   * should use the specific filter methods wherever possible.
   *
   * Unlike most filters, `opearator` and `value` are used as-is and need to
   * follow [PostgREST
   * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
   * to make sure they are properly sanitized.
   *
   * @param column - The column to filter on
   * @param operator - The operator to filter with, following PostgREST syntax
   * @param value - The value to filter with, following PostgREST syntax
   */
  filter(t, n, r) {
    return this.url.searchParams.append(t, `${n}.${r}`), this;
  }
};
eh.default = hJ;
var gJ = Cr && Cr.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Nb, "__esModule", { value: !0 });
const hf = gJ(eh);
let mJ = class {
  constructor(t, { headers: n = {}, schema: r, fetch: o }) {
    this.url = t, this.headers = n, this.schema = r, this.fetch = o;
  }
  /**
   * Perform a SELECT query on the table or view.
   *
   * @param columns - The columns to retrieve, separated by commas. Columns can be renamed when returned with `customName:columnName`
   *
   * @param options - Named parameters
   *
   * @param options.head - When set to `true`, `data` will not be returned.
   * Useful if you only need the count.
   *
   * @param options.count - Count algorithm to use to count rows in the table or view.
   *
   * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
   * hood.
   *
   * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
   * statistics under the hood.
   *
   * `"estimated"`: Uses exact count for low numbers and planned count for high
   * numbers.
   */
  select(t, { head: n = !1, count: r } = {}) {
    const o = n ? "HEAD" : "GET";
    let i = !1;
    const a = (t ?? "*").split("").map((l) => /\s/.test(l) && !i ? "" : (l === '"' && (i = !i), l)).join("");
    return this.url.searchParams.set("select", a), r && (this.headers.Prefer = `count=${r}`), new hf.default({
      method: o,
      url: this.url,
      headers: this.headers,
      schema: this.schema,
      fetch: this.fetch,
      allowEmpty: !1
    });
  }
  /**
   * Perform an INSERT into the table or view.
   *
   * By default, inserted rows are not returned. To return it, chain the call
   * with `.select()`.
   *
   * @param values - The values to insert. Pass an object to insert a single row
   * or an array to insert multiple rows.
   *
   * @param options - Named parameters
   *
   * @param options.count - Count algorithm to use to count inserted rows.
   *
   * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
   * hood.
   *
   * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
   * statistics under the hood.
   *
   * `"estimated"`: Uses exact count for low numbers and planned count for high
   * numbers.
   *
   * @param options.defaultToNull - Make missing fields default to `null`.
   * Otherwise, use the default value for the column. Only applies for bulk
   * inserts.
   */
  insert(t, { count: n, defaultToNull: r = !0 } = {}) {
    const o = "POST", i = [];
    if (this.headers.Prefer && i.push(this.headers.Prefer), n && i.push(`count=${n}`), r || i.push("missing=default"), this.headers.Prefer = i.join(","), Array.isArray(t)) {
      const a = t.reduce((l, c) => l.concat(Object.keys(c)), []);
      if (a.length > 0) {
        const l = [...new Set(a)].map((c) => `"${c}"`);
        this.url.searchParams.set("columns", l.join(","));
      }
    }
    return new hf.default({
      method: o,
      url: this.url,
      headers: this.headers,
      schema: this.schema,
      body: t,
      fetch: this.fetch,
      allowEmpty: !1
    });
  }
  /**
   * Perform an UPSERT on the table or view. Depending on the column(s) passed
   * to `onConflict`, `.upsert()` allows you to perform the equivalent of
   * `.insert()` if a row with the corresponding `onConflict` columns doesn't
   * exist, or if it does exist, perform an alternative action depending on
   * `ignoreDuplicates`.
   *
   * By default, upserted rows are not returned. To return it, chain the call
   * with `.select()`.
   *
   * @param values - The values to upsert with. Pass an object to upsert a
   * single row or an array to upsert multiple rows.
   *
   * @param options - Named parameters
   *
   * @param options.onConflict - Comma-separated UNIQUE column(s) to specify how
   * duplicate rows are determined. Two rows are duplicates if all the
   * `onConflict` columns are equal.
   *
   * @param options.ignoreDuplicates - If `true`, duplicate rows are ignored. If
   * `false`, duplicate rows are merged with existing rows.
   *
   * @param options.count - Count algorithm to use to count upserted rows.
   *
   * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
   * hood.
   *
   * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
   * statistics under the hood.
   *
   * `"estimated"`: Uses exact count for low numbers and planned count for high
   * numbers.
   *
   * @param options.defaultToNull - Make missing fields default to `null`.
   * Otherwise, use the default value for the column. This only applies when
   * inserting new rows, not when merging with existing rows under
   * `ignoreDuplicates: false`. This also only applies when doing bulk upserts.
   */
  upsert(t, { onConflict: n, ignoreDuplicates: r = !1, count: o, defaultToNull: i = !0 } = {}) {
    const a = "POST", l = [`resolution=${r ? "ignore" : "merge"}-duplicates`];
    if (n !== void 0 && this.url.searchParams.set("on_conflict", n), this.headers.Prefer && l.push(this.headers.Prefer), o && l.push(`count=${o}`), i || l.push("missing=default"), this.headers.Prefer = l.join(","), Array.isArray(t)) {
      const c = t.reduce((d, f) => d.concat(Object.keys(f)), []);
      if (c.length > 0) {
        const d = [...new Set(c)].map((f) => `"${f}"`);
        this.url.searchParams.set("columns", d.join(","));
      }
    }
    return new hf.default({
      method: a,
      url: this.url,
      headers: this.headers,
      schema: this.schema,
      body: t,
      fetch: this.fetch,
      allowEmpty: !1
    });
  }
  /**
   * Perform an UPDATE on the table or view.
   *
   * By default, updated rows are not returned. To return it, chain the call
   * with `.select()` after filters.
   *
   * @param values - The values to update with
   *
   * @param options - Named parameters
   *
   * @param options.count - Count algorithm to use to count updated rows.
   *
   * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
   * hood.
   *
   * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
   * statistics under the hood.
   *
   * `"estimated"`: Uses exact count for low numbers and planned count for high
   * numbers.
   */
  update(t, { count: n } = {}) {
    const r = "PATCH", o = [];
    return this.headers.Prefer && o.push(this.headers.Prefer), n && o.push(`count=${n}`), this.headers.Prefer = o.join(","), new hf.default({
      method: r,
      url: this.url,
      headers: this.headers,
      schema: this.schema,
      body: t,
      fetch: this.fetch,
      allowEmpty: !1
    });
  }
  /**
   * Perform a DELETE on the table or view.
   *
   * By default, deleted rows are not returned. To return it, chain the call
   * with `.select()` after filters.
   *
   * @param options - Named parameters
   *
   * @param options.count - Count algorithm to use to count deleted rows.
   *
   * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
   * hood.
   *
   * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
   * statistics under the hood.
   *
   * `"estimated"`: Uses exact count for low numbers and planned count for high
   * numbers.
   */
  delete({ count: t } = {}) {
    const n = "DELETE", r = [];
    return t && r.push(`count=${t}`), this.headers.Prefer && r.unshift(this.headers.Prefer), this.headers.Prefer = r.join(","), new hf.default({
      method: n,
      url: this.url,
      headers: this.headers,
      schema: this.schema,
      fetch: this.fetch,
      allowEmpty: !1
    });
  }
};
Nb.default = mJ;
var jb = {}, Bb = {};
Object.defineProperty(Bb, "__esModule", { value: !0 });
Bb.version = void 0;
Bb.version = "0.0.0-automated";
Object.defineProperty(jb, "__esModule", { value: !0 });
jb.DEFAULT_HEADERS = void 0;
const bJ = Bb;
jb.DEFAULT_HEADERS = { "X-Client-Info": `postgrest-js/${bJ.version}` };
var yA = Cr && Cr.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Nx, "__esModule", { value: !0 });
const yJ = yA(Nb), vJ = yA(eh), wJ = jb;
let CJ = class vA {
  // TODO: Add back shouldThrowOnError once we figure out the typings
  /**
   * Creates a PostgREST client.
   *
   * @param url - URL of the PostgREST endpoint
   * @param options - Named parameters
   * @param options.headers - Custom headers
   * @param options.schema - Postgres schema to switch to
   * @param options.fetch - Custom fetch
   */
  constructor(t, { headers: n = {}, schema: r, fetch: o } = {}) {
    this.url = t, this.headers = Object.assign(Object.assign({}, wJ.DEFAULT_HEADERS), n), this.schemaName = r, this.fetch = o;
  }
  /**
   * Perform a query on a table or a view.
   *
   * @param relation - The table or view name to query
   */
  from(t) {
    const n = new URL(`${this.url}/${t}`);
    return new yJ.default(n, {
      headers: Object.assign({}, this.headers),
      schema: this.schemaName,
      fetch: this.fetch
    });
  }
  /**
   * Select a schema to query or perform an function (rpc) call.
   *
   * The schema needs to be on the list of exposed schemas inside Supabase.
   *
   * @param schema - The schema to query
   */
  schema(t) {
    return new vA(this.url, {
      headers: this.headers,
      schema: t,
      fetch: this.fetch
    });
  }
  /**
   * Perform a function call.
   *
   * @param fn - The function name to call
   * @param args - The arguments to pass to the function call
   * @param options - Named parameters
   * @param options.head - When set to `true`, `data` will not be returned.
   * Useful if you only need the count.
   * @param options.get - When set to `true`, the function will be called with
   * read-only access mode.
   * @param options.count - Count algorithm to use to count rows returned by the
   * function. Only applicable for [set-returning
   * functions](https://www.postgresql.org/docs/current/functions-srf.html).
   *
   * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
   * hood.
   *
   * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
   * statistics under the hood.
   *
   * `"estimated"`: Uses exact count for low numbers and planned count for high
   * numbers.
   */
  rpc(t, n = {}, { head: r = !1, get: o = !1, count: i } = {}) {
    let a;
    const l = new URL(`${this.url}/rpc/${t}`);
    let c;
    r || o ? (a = r ? "HEAD" : "GET", Object.entries(n).filter(([f, p]) => p !== void 0).map(([f, p]) => [f, Array.isArray(p) ? `{${p.join(",")}}` : `${p}`]).forEach(([f, p]) => {
      l.searchParams.append(f, p);
    })) : (a = "POST", c = n);
    const d = Object.assign({}, this.headers);
    return i && (d.Prefer = `count=${i}`), new vJ.default({
      method: a,
      url: l,
      headers: d,
      schema: this.schemaName,
      body: c,
      fetch: this.fetch,
      allowEmpty: !1
    });
  }
};
Nx.default = CJ;
var Rd = Cr && Cr.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Bo, "__esModule", { value: !0 });
Bo.PostgrestError = Bo.PostgrestBuilder = Bo.PostgrestTransformBuilder = Bo.PostgrestFilterBuilder = Bo.PostgrestQueryBuilder = Bo.PostgrestClient = void 0;
const wA = Rd(Nx);
Bo.PostgrestClient = wA.default;
const CA = Rd(Nb);
Bo.PostgrestQueryBuilder = CA.default;
const xA = Rd(eh);
Bo.PostgrestFilterBuilder = xA.default;
const SA = Rd(Fb);
Bo.PostgrestTransformBuilder = SA.default;
const EA = Rd($b);
Bo.PostgrestBuilder = EA.default;
const TA = Rd(Lb);
Bo.PostgrestError = TA.default;
var xJ = Bo.default = {
  PostgrestClient: wA.default,
  PostgrestQueryBuilder: CA.default,
  PostgrestFilterBuilder: xA.default,
  PostgrestTransformBuilder: SA.default,
  PostgrestBuilder: EA.default,
  PostgrestError: TA.default
};
const {
  PostgrestClient: SJ,
  PostgrestQueryBuilder: xwe,
  PostgrestFilterBuilder: Swe,
  PostgrestTransformBuilder: Ewe,
  PostgrestBuilder: Twe
} = xJ, EJ = "2.11.2", TJ = { "X-Client-Info": `realtime-js/${EJ}` }, OJ = "1.0.0", OA = 1e4, PJ = 1e3;
var ju;
(function(e) {
  e[e.connecting = 0] = "connecting", e[e.open = 1] = "open", e[e.closing = 2] = "closing", e[e.closed = 3] = "closed";
})(ju || (ju = {}));
var ti;
(function(e) {
  e.closed = "closed", e.errored = "errored", e.joined = "joined", e.joining = "joining", e.leaving = "leaving";
})(ti || (ti = {}));
var Xi;
(function(e) {
  e.close = "phx_close", e.error = "phx_error", e.join = "phx_join", e.reply = "phx_reply", e.leave = "phx_leave", e.access_token = "access_token";
})(Xi || (Xi = {}));
var N0;
(function(e) {
  e.websocket = "websocket";
})(N0 || (N0 = {}));
var Jl;
(function(e) {
  e.Connecting = "connecting", e.Open = "open", e.Closing = "closing", e.Closed = "closed";
})(Jl || (Jl = {}));
class IJ {
  constructor() {
    this.HEADER_LENGTH = 1;
  }
  decode(t, n) {
    return t.constructor === ArrayBuffer ? n(this._binaryDecode(t)) : n(typeof t == "string" ? JSON.parse(t) : {});
  }
  _binaryDecode(t) {
    const n = new DataView(t), r = new TextDecoder();
    return this._decodeBroadcast(t, n, r);
  }
  _decodeBroadcast(t, n, r) {
    const o = n.getUint8(1), i = n.getUint8(2);
    let a = this.HEADER_LENGTH + 2;
    const l = r.decode(t.slice(a, a + o));
    a = a + o;
    const c = r.decode(t.slice(a, a + i));
    a = a + i;
    const d = JSON.parse(r.decode(t.slice(a, t.byteLength)));
    return { ref: null, topic: l, event: c, payload: d };
  }
}
class PA {
  constructor(t, n) {
    this.callback = t, this.timerCalc = n, this.timer = void 0, this.tries = 0, this.callback = t, this.timerCalc = n;
  }
  reset() {
    this.tries = 0, clearTimeout(this.timer);
  }
  // Cancels any previous scheduleTimeout and schedules callback
  scheduleTimeout() {
    clearTimeout(this.timer), this.timer = setTimeout(() => {
      this.tries = this.tries + 1, this.callback();
    }, this.timerCalc(this.tries + 1));
  }
}
var Kn;
(function(e) {
  e.abstime = "abstime", e.bool = "bool", e.date = "date", e.daterange = "daterange", e.float4 = "float4", e.float8 = "float8", e.int2 = "int2", e.int4 = "int4", e.int4range = "int4range", e.int8 = "int8", e.int8range = "int8range", e.json = "json", e.jsonb = "jsonb", e.money = "money", e.numeric = "numeric", e.oid = "oid", e.reltime = "reltime", e.text = "text", e.time = "time", e.timestamp = "timestamp", e.timestamptz = "timestamptz", e.timetz = "timetz", e.tsrange = "tsrange", e.tstzrange = "tstzrange";
})(Kn || (Kn = {}));
const FP = (e, t, n = {}) => {
  var r;
  const o = (r = n.skipTypes) !== null && r !== void 0 ? r : [];
  return Object.keys(t).reduce((i, a) => (i[a] = RJ(a, e, t, o), i), {});
}, RJ = (e, t, n, r) => {
  const o = t.find((l) => l.name === e), i = o == null ? void 0 : o.type, a = n[e];
  return i && !r.includes(i) ? IA(i, a) : F0(a);
}, IA = (e, t) => {
  if (e.charAt(0) === "_") {
    const n = e.slice(1, e.length);
    return AJ(t, n);
  }
  switch (e) {
    case Kn.bool:
      return _J(t);
    case Kn.float4:
    case Kn.float8:
    case Kn.int2:
    case Kn.int4:
    case Kn.int8:
    case Kn.numeric:
    case Kn.oid:
      return kJ(t);
    case Kn.json:
    case Kn.jsonb:
      return MJ(t);
    case Kn.timestamp:
      return DJ(t);
    case Kn.abstime:
    case Kn.date:
    case Kn.daterange:
    case Kn.int4range:
    case Kn.int8range:
    case Kn.money:
    case Kn.reltime:
    case Kn.text:
    case Kn.time:
    case Kn.timestamptz:
    case Kn.timetz:
    case Kn.tsrange:
    case Kn.tstzrange:
      return F0(t);
    default:
      return F0(t);
  }
}, F0 = (e) => e, _J = (e) => {
  switch (e) {
    case "t":
      return !0;
    case "f":
      return !1;
    default:
      return e;
  }
}, kJ = (e) => {
  if (typeof e == "string") {
    const t = parseFloat(e);
    if (!Number.isNaN(t))
      return t;
  }
  return e;
}, MJ = (e) => {
  if (typeof e == "string")
    try {
      return JSON.parse(e);
    } catch (t) {
      return console.log(`JSON parse error: ${t}`), e;
    }
  return e;
}, AJ = (e, t) => {
  if (typeof e != "string")
    return e;
  const n = e.length - 1, r = e[n];
  if (e[0] === "{" && r === "}") {
    let i;
    const a = e.slice(1, n);
    try {
      i = JSON.parse("[" + a + "]");
    } catch {
      i = a ? a.split(",") : [];
    }
    return i.map((l) => IA(t, l));
  }
  return e;
}, DJ = (e) => typeof e == "string" ? e.replace(" ", "T") : e, RA = (e) => {
  let t = e;
  return t = t.replace(/^ws/i, "http"), t = t.replace(/(\/socket\/websocket|\/socket|\/websocket)\/?$/i, ""), t.replace(/\/+$/, "");
};
class aw {
  /**
   * Initializes the Push
   *
   * @param channel The Channel
   * @param event The event, for example `"phx_join"`
   * @param payload The payload, for example `{user_id: 123}`
   * @param timeout The push timeout in milliseconds
   */
  constructor(t, n, r = {}, o = OA) {
    this.channel = t, this.event = n, this.payload = r, this.timeout = o, this.sent = !1, this.timeoutTimer = void 0, this.ref = "", this.receivedResp = null, this.recHooks = [], this.refEvent = null;
  }
  resend(t) {
    this.timeout = t, this._cancelRefEvent(), this.ref = "", this.refEvent = null, this.receivedResp = null, this.sent = !1, this.send();
  }
  send() {
    this._hasReceived("timeout") || (this.startTimeout(), this.sent = !0, this.channel.socket.push({
      topic: this.channel.topic,
      event: this.event,
      payload: this.payload,
      ref: this.ref,
      join_ref: this.channel._joinRef()
    }));
  }
  updatePayload(t) {
    this.payload = Object.assign(Object.assign({}, this.payload), t);
  }
  receive(t, n) {
    var r;
    return this._hasReceived(t) && n((r = this.receivedResp) === null || r === void 0 ? void 0 : r.response), this.recHooks.push({ status: t, callback: n }), this;
  }
  startTimeout() {
    if (this.timeoutTimer)
      return;
    this.ref = this.channel.socket._makeRef(), this.refEvent = this.channel._replyEventName(this.ref);
    const t = (n) => {
      this._cancelRefEvent(), this._cancelTimeout(), this.receivedResp = n, this._matchReceive(n);
    };
    this.channel._on(this.refEvent, {}, t), this.timeoutTimer = setTimeout(() => {
      this.trigger("timeout", {});
    }, this.timeout);
  }
  trigger(t, n) {
    this.refEvent && this.channel._trigger(this.refEvent, { status: t, response: n });
  }
  destroy() {
    this._cancelRefEvent(), this._cancelTimeout();
  }
  _cancelRefEvent() {
    this.refEvent && this.channel._off(this.refEvent, {});
  }
  _cancelTimeout() {
    clearTimeout(this.timeoutTimer), this.timeoutTimer = void 0;
  }
  _matchReceive({ status: t, response: n }) {
    this.recHooks.filter((r) => r.status === t).forEach((r) => r.callback(n));
  }
  _hasReceived(t) {
    return this.receivedResp && this.receivedResp.status === t;
  }
}
var $P;
(function(e) {
  e.SYNC = "sync", e.JOIN = "join", e.LEAVE = "leave";
})($P || ($P = {}));
class zf {
  /**
   * Initializes the Presence.
   *
   * @param channel - The RealtimeChannel
   * @param opts - The options,
   *        for example `{events: {state: 'state', diff: 'diff'}}`
   */
  constructor(t, n) {
    this.channel = t, this.state = {}, this.pendingDiffs = [], this.joinRef = null, this.caller = {
      onJoin: () => {
      },
      onLeave: () => {
      },
      onSync: () => {
      }
    };
    const r = (n == null ? void 0 : n.events) || {
      state: "presence_state",
      diff: "presence_diff"
    };
    this.channel._on(r.state, {}, (o) => {
      const { onJoin: i, onLeave: a, onSync: l } = this.caller;
      this.joinRef = this.channel._joinRef(), this.state = zf.syncState(this.state, o, i, a), this.pendingDiffs.forEach((c) => {
        this.state = zf.syncDiff(this.state, c, i, a);
      }), this.pendingDiffs = [], l();
    }), this.channel._on(r.diff, {}, (o) => {
      const { onJoin: i, onLeave: a, onSync: l } = this.caller;
      this.inPendingSyncState() ? this.pendingDiffs.push(o) : (this.state = zf.syncDiff(this.state, o, i, a), l());
    }), this.onJoin((o, i, a) => {
      this.channel._trigger("presence", {
        event: "join",
        key: o,
        currentPresences: i,
        newPresences: a
      });
    }), this.onLeave((o, i, a) => {
      this.channel._trigger("presence", {
        event: "leave",
        key: o,
        currentPresences: i,
        leftPresences: a
      });
    }), this.onSync(() => {
      this.channel._trigger("presence", { event: "sync" });
    });
  }
  /**
   * Used to sync the list of presences on the server with the
   * client's state.
   *
   * An optional `onJoin` and `onLeave` callback can be provided to
   * react to changes in the client's local presences across
   * disconnects and reconnects with the server.
   *
   * @internal
   */
  static syncState(t, n, r, o) {
    const i = this.cloneDeep(t), a = this.transformState(n), l = {}, c = {};
    return this.map(i, (d, f) => {
      a[d] || (c[d] = f);
    }), this.map(a, (d, f) => {
      const p = i[d];
      if (p) {
        const g = f.map((S) => S.presence_ref), b = p.map((S) => S.presence_ref), v = f.filter((S) => b.indexOf(S.presence_ref) < 0), y = p.filter((S) => g.indexOf(S.presence_ref) < 0);
        v.length > 0 && (l[d] = v), y.length > 0 && (c[d] = y);
      } else
        l[d] = f;
    }), this.syncDiff(i, { joins: l, leaves: c }, r, o);
  }
  /**
   * Used to sync a diff of presence join and leave events from the
   * server, as they happen.
   *
   * Like `syncState`, `syncDiff` accepts optional `onJoin` and
   * `onLeave` callbacks to react to a user joining or leaving from a
   * device.
   *
   * @internal
   */
  static syncDiff(t, n, r, o) {
    const { joins: i, leaves: a } = {
      joins: this.transformState(n.joins),
      leaves: this.transformState(n.leaves)
    };
    return r || (r = () => {
    }), o || (o = () => {
    }), this.map(i, (l, c) => {
      var d;
      const f = (d = t[l]) !== null && d !== void 0 ? d : [];
      if (t[l] = this.cloneDeep(c), f.length > 0) {
        const p = t[l].map((b) => b.presence_ref), g = f.filter((b) => p.indexOf(b.presence_ref) < 0);
        t[l].unshift(...g);
      }
      r(l, f, c);
    }), this.map(a, (l, c) => {
      let d = t[l];
      if (!d)
        return;
      const f = c.map((p) => p.presence_ref);
      d = d.filter((p) => f.indexOf(p.presence_ref) < 0), t[l] = d, o(l, d, c), d.length === 0 && delete t[l];
    }), t;
  }
  /** @internal */
  static map(t, n) {
    return Object.getOwnPropertyNames(t).map((r) => n(r, t[r]));
  }
  /**
   * Remove 'metas' key
   * Change 'phx_ref' to 'presence_ref'
   * Remove 'phx_ref' and 'phx_ref_prev'
   *
   * @example
   * // returns {
   *  abc123: [
   *    { presence_ref: '2', user_id: 1 },
   *    { presence_ref: '3', user_id: 2 }
   *  ]
   * }
   * RealtimePresence.transformState({
   *  abc123: {
   *    metas: [
   *      { phx_ref: '2', phx_ref_prev: '1' user_id: 1 },
   *      { phx_ref: '3', user_id: 2 }
   *    ]
   *  }
   * })
   *
   * @internal
   */
  static transformState(t) {
    return t = this.cloneDeep(t), Object.getOwnPropertyNames(t).reduce((n, r) => {
      const o = t[r];
      return "metas" in o ? n[r] = o.metas.map((i) => (i.presence_ref = i.phx_ref, delete i.phx_ref, delete i.phx_ref_prev, i)) : n[r] = o, n;
    }, {});
  }
  /** @internal */
  static cloneDeep(t) {
    return JSON.parse(JSON.stringify(t));
  }
  /** @internal */
  onJoin(t) {
    this.caller.onJoin = t;
  }
  /** @internal */
  onLeave(t) {
    this.caller.onLeave = t;
  }
  /** @internal */
  onSync(t) {
    this.caller.onSync = t;
  }
  /** @internal */
  inPendingSyncState() {
    return !this.joinRef || this.joinRef !== this.channel._joinRef();
  }
}
var LP;
(function(e) {
  e.ALL = "*", e.INSERT = "INSERT", e.UPDATE = "UPDATE", e.DELETE = "DELETE";
})(LP || (LP = {}));
var jP;
(function(e) {
  e.BROADCAST = "broadcast", e.PRESENCE = "presence", e.POSTGRES_CHANGES = "postgres_changes", e.SYSTEM = "system";
})(jP || (jP = {}));
var ua;
(function(e) {
  e.SUBSCRIBED = "SUBSCRIBED", e.TIMED_OUT = "TIMED_OUT", e.CLOSED = "CLOSED", e.CHANNEL_ERROR = "CHANNEL_ERROR";
})(ua || (ua = {}));
class Fx {
  constructor(t, n = { config: {} }, r) {
    this.topic = t, this.params = n, this.socket = r, this.bindings = {}, this.state = ti.closed, this.joinedOnce = !1, this.pushBuffer = [], this.subTopic = t.replace(/^realtime:/i, ""), this.params.config = Object.assign({
      broadcast: { ack: !1, self: !1 },
      presence: { key: "" },
      private: !1
    }, n.config), this.timeout = this.socket.timeout, this.joinPush = new aw(this, Xi.join, this.params, this.timeout), this.rejoinTimer = new PA(() => this._rejoinUntilConnected(), this.socket.reconnectAfterMs), this.joinPush.receive("ok", () => {
      this.state = ti.joined, this.rejoinTimer.reset(), this.pushBuffer.forEach((o) => o.send()), this.pushBuffer = [];
    }), this._onClose(() => {
      this.rejoinTimer.reset(), this.socket.log("channel", `close ${this.topic} ${this._joinRef()}`), this.state = ti.closed, this.socket._remove(this);
    }), this._onError((o) => {
      this._isLeaving() || this._isClosed() || (this.socket.log("channel", `error ${this.topic}`, o), this.state = ti.errored, this.rejoinTimer.scheduleTimeout());
    }), this.joinPush.receive("timeout", () => {
      this._isJoining() && (this.socket.log("channel", `timeout ${this.topic}`, this.joinPush.timeout), this.state = ti.errored, this.rejoinTimer.scheduleTimeout());
    }), this._on(Xi.reply, {}, (o, i) => {
      this._trigger(this._replyEventName(i), o);
    }), this.presence = new zf(this), this.broadcastEndpointURL = RA(this.socket.endPoint) + "/api/broadcast", this.private = this.params.config.private || !1;
  }
  /** Subscribe registers your client with the server */
  subscribe(t, n = this.timeout) {
    var r, o;
    if (this.socket.isConnected() || this.socket.connect(), this.joinedOnce)
      throw "tried to subscribe multiple times. 'subscribe' can only be called a single time per channel instance";
    {
      const { config: { broadcast: i, presence: a, private: l } } = this.params;
      this._onError((f) => t == null ? void 0 : t(ua.CHANNEL_ERROR, f)), this._onClose(() => t == null ? void 0 : t(ua.CLOSED));
      const c = {}, d = {
        broadcast: i,
        presence: a,
        postgres_changes: (o = (r = this.bindings.postgres_changes) === null || r === void 0 ? void 0 : r.map((f) => f.filter)) !== null && o !== void 0 ? o : [],
        private: l
      };
      this.socket.accessTokenValue && (c.access_token = this.socket.accessTokenValue), this.updateJoinPayload(Object.assign({ config: d }, c)), this.joinedOnce = !0, this._rejoin(n), this.joinPush.receive("ok", async ({ postgres_changes: f }) => {
        var p;
        if (this.socket.setAuth(), f === void 0) {
          t == null || t(ua.SUBSCRIBED);
          return;
        } else {
          const g = this.bindings.postgres_changes, b = (p = g == null ? void 0 : g.length) !== null && p !== void 0 ? p : 0, v = [];
          for (let y = 0; y < b; y++) {
            const S = g[y], { filter: { event: E, schema: I, table: O, filter: T } } = S, P = f && f[y];
            if (P && P.event === E && P.schema === I && P.table === O && P.filter === T)
              v.push(Object.assign(Object.assign({}, S), { id: P.id }));
            else {
              this.unsubscribe(), t == null || t(ua.CHANNEL_ERROR, new Error("mismatch between server and client bindings for postgres changes"));
              return;
            }
          }
          this.bindings.postgres_changes = v, t && t(ua.SUBSCRIBED);
          return;
        }
      }).receive("error", (f) => {
        t == null || t(ua.CHANNEL_ERROR, new Error(JSON.stringify(Object.values(f).join(", ") || "error")));
      }).receive("timeout", () => {
        t == null || t(ua.TIMED_OUT);
      });
    }
    return this;
  }
  presenceState() {
    return this.presence.state;
  }
  async track(t, n = {}) {
    return await this.send({
      type: "presence",
      event: "track",
      payload: t
    }, n.timeout || this.timeout);
  }
  async untrack(t = {}) {
    return await this.send({
      type: "presence",
      event: "untrack"
    }, t);
  }
  on(t, n, r) {
    return this._on(t, n, r);
  }
  /**
   * Sends a message into the channel.
   *
   * @param args Arguments to send to channel
   * @param args.type The type of event to send
   * @param args.event The name of the event being sent
   * @param args.payload Payload to be sent
   * @param opts Options to be used during the send process
   */
  async send(t, n = {}) {
    var r, o;
    if (!this._canPush() && t.type === "broadcast") {
      const { event: i, payload: a } = t, c = {
        method: "POST",
        headers: {
          Authorization: this.socket.accessTokenValue ? `Bearer ${this.socket.accessTokenValue}` : "",
          apikey: this.socket.apiKey ? this.socket.apiKey : "",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          messages: [
            {
              topic: this.subTopic,
              event: i,
              payload: a,
              private: this.private
            }
          ]
        })
      };
      try {
        const d = await this._fetchWithTimeout(this.broadcastEndpointURL, c, (r = n.timeout) !== null && r !== void 0 ? r : this.timeout);
        return await ((o = d.body) === null || o === void 0 ? void 0 : o.cancel()), d.ok ? "ok" : "error";
      } catch (d) {
        return d.name === "AbortError" ? "timed out" : "error";
      }
    } else
      return new Promise((i) => {
        var a, l, c;
        const d = this._push(t.type, t, n.timeout || this.timeout);
        t.type === "broadcast" && !(!((c = (l = (a = this.params) === null || a === void 0 ? void 0 : a.config) === null || l === void 0 ? void 0 : l.broadcast) === null || c === void 0) && c.ack) && i("ok"), d.receive("ok", () => i("ok")), d.receive("error", () => i("error")), d.receive("timeout", () => i("timed out"));
      });
  }
  updateJoinPayload(t) {
    this.joinPush.updatePayload(t);
  }
  /**
   * Leaves the channel.
   *
   * Unsubscribes from server events, and instructs channel to terminate on server.
   * Triggers onClose() hooks.
   *
   * To receive leave acknowledgements, use the a `receive` hook to bind to the server ack, ie:
   * channel.unsubscribe().receive("ok", () => alert("left!") )
   */
  unsubscribe(t = this.timeout) {
    this.state = ti.leaving;
    const n = () => {
      this.socket.log("channel", `leave ${this.topic}`), this._trigger(Xi.close, "leave", this._joinRef());
    };
    return this.rejoinTimer.reset(), this.joinPush.destroy(), new Promise((r) => {
      const o = new aw(this, Xi.leave, {}, t);
      o.receive("ok", () => {
        n(), r("ok");
      }).receive("timeout", () => {
        n(), r("timed out");
      }).receive("error", () => {
        r("error");
      }), o.send(), this._canPush() || o.trigger("ok", {});
    });
  }
  /** @internal */
  async _fetchWithTimeout(t, n, r) {
    const o = new AbortController(), i = setTimeout(() => o.abort(), r), a = await this.socket.fetch(t, Object.assign(Object.assign({}, n), { signal: o.signal }));
    return clearTimeout(i), a;
  }
  /** @internal */
  _push(t, n, r = this.timeout) {
    if (!this.joinedOnce)
      throw `tried to push '${t}' to '${this.topic}' before joining. Use channel.subscribe() before pushing events`;
    let o = new aw(this, t, n, r);
    return this._canPush() ? o.send() : (o.startTimeout(), this.pushBuffer.push(o)), o;
  }
  /**
   * Overridable message hook
   *
   * Receives all events for specialized message handling before dispatching to the channel callbacks.
   * Must return the payload, modified or unmodified.
   *
   * @internal
   */
  _onMessage(t, n, r) {
    return n;
  }
  /** @internal */
  _isMember(t) {
    return this.topic === t;
  }
  /** @internal */
  _joinRef() {
    return this.joinPush.ref;
  }
  /** @internal */
  _trigger(t, n, r) {
    var o, i;
    const a = t.toLocaleLowerCase(), { close: l, error: c, leave: d, join: f } = Xi;
    if (r && [l, c, d, f].indexOf(a) >= 0 && r !== this._joinRef())
      return;
    let g = this._onMessage(a, n, r);
    if (n && !g)
      throw "channel onMessage callbacks must return the payload, modified or unmodified";
    ["insert", "update", "delete"].includes(a) ? (o = this.bindings.postgres_changes) === null || o === void 0 || o.filter((b) => {
      var v, y, S;
      return ((v = b.filter) === null || v === void 0 ? void 0 : v.event) === "*" || ((S = (y = b.filter) === null || y === void 0 ? void 0 : y.event) === null || S === void 0 ? void 0 : S.toLocaleLowerCase()) === a;
    }).map((b) => b.callback(g, r)) : (i = this.bindings[a]) === null || i === void 0 || i.filter((b) => {
      var v, y, S, E, I, O;
      if (["broadcast", "presence", "postgres_changes"].includes(a))
        if ("id" in b) {
          const T = b.id, P = (v = b.filter) === null || v === void 0 ? void 0 : v.event;
          return T && ((y = n.ids) === null || y === void 0 ? void 0 : y.includes(T)) && (P === "*" || (P == null ? void 0 : P.toLocaleLowerCase()) === ((S = n.data) === null || S === void 0 ? void 0 : S.type.toLocaleLowerCase()));
        } else {
          const T = (I = (E = b == null ? void 0 : b.filter) === null || E === void 0 ? void 0 : E.event) === null || I === void 0 ? void 0 : I.toLocaleLowerCase();
          return T === "*" || T === ((O = n == null ? void 0 : n.event) === null || O === void 0 ? void 0 : O.toLocaleLowerCase());
        }
      else
        return b.type.toLocaleLowerCase() === a;
    }).map((b) => {
      if (typeof g == "object" && "ids" in g) {
        const v = g.data, { schema: y, table: S, commit_timestamp: E, type: I, errors: O } = v;
        g = Object.assign(Object.assign({}, {
          schema: y,
          table: S,
          commit_timestamp: E,
          eventType: I,
          new: {},
          old: {},
          errors: O
        }), this._getPayloadRecords(v));
      }
      b.callback(g, r);
    });
  }
  /** @internal */
  _isClosed() {
    return this.state === ti.closed;
  }
  /** @internal */
  _isJoined() {
    return this.state === ti.joined;
  }
  /** @internal */
  _isJoining() {
    return this.state === ti.joining;
  }
  /** @internal */
  _isLeaving() {
    return this.state === ti.leaving;
  }
  /** @internal */
  _replyEventName(t) {
    return `chan_reply_${t}`;
  }
  /** @internal */
  _on(t, n, r) {
    const o = t.toLocaleLowerCase(), i = {
      type: o,
      filter: n,
      callback: r
    };
    return this.bindings[o] ? this.bindings[o].push(i) : this.bindings[o] = [i], this;
  }
  /** @internal */
  _off(t, n) {
    const r = t.toLocaleLowerCase();
    return this.bindings[r] = this.bindings[r].filter((o) => {
      var i;
      return !(((i = o.type) === null || i === void 0 ? void 0 : i.toLocaleLowerCase()) === r && Fx.isEqual(o.filter, n));
    }), this;
  }
  /** @internal */
  static isEqual(t, n) {
    if (Object.keys(t).length !== Object.keys(n).length)
      return !1;
    for (const r in t)
      if (t[r] !== n[r])
        return !1;
    return !0;
  }
  /** @internal */
  _rejoinUntilConnected() {
    this.rejoinTimer.scheduleTimeout(), this.socket.isConnected() && this._rejoin();
  }
  /**
   * Registers a callback that will be executed when the channel closes.
   *
   * @internal
   */
  _onClose(t) {
    this._on(Xi.close, {}, t);
  }
  /**
   * Registers a callback that will be executed when the channel encounteres an error.
   *
   * @internal
   */
  _onError(t) {
    this._on(Xi.error, {}, (n) => t(n));
  }
  /**
   * Returns `true` if the socket is connected and the channel has been joined.
   *
   * @internal
   */
  _canPush() {
    return this.socket.isConnected() && this._isJoined();
  }
  /** @internal */
  _rejoin(t = this.timeout) {
    this._isLeaving() || (this.socket._leaveOpenTopic(this.topic), this.state = ti.joining, this.joinPush.resend(t));
  }
  /** @internal */
  _getPayloadRecords(t) {
    const n = {
      new: {},
      old: {}
    };
    return (t.type === "INSERT" || t.type === "UPDATE") && (n.new = FP(t.columns, t.record)), (t.type === "UPDATE" || t.type === "DELETE") && (n.old = FP(t.columns, t.old_record)), n;
  }
}
const NJ = () => {
}, FJ = typeof WebSocket < "u", $J = `
  addEventListener("message", (e) => {
    if (e.data.event === "start") {
      setInterval(() => postMessage({ event: "keepAlive" }), e.data.interval);
    }
  });`;
class LJ {
  /**
   * Initializes the Socket.
   *
   * @param endPoint The string WebSocket endpoint, ie, "ws://example.com/socket", "wss://example.com", "/socket" (inherited host & protocol)
   * @param httpEndpoint The string HTTP endpoint, ie, "https://example.com", "/" (inherited host & protocol)
   * @param options.transport The Websocket Transport, for example WebSocket.
   * @param options.timeout The default timeout in milliseconds to trigger push timeouts.
   * @param options.params The optional params to pass when connecting.
   * @param options.headers The optional headers to pass when connecting.
   * @param options.heartbeatIntervalMs The millisec interval to send a heartbeat message.
   * @param options.logger The optional function for specialized logging, ie: logger: (kind, msg, data) => { console.log(`${kind}: ${msg}`, data) }
   * @param options.encode The function to encode outgoing messages. Defaults to JSON: (payload, callback) => callback(JSON.stringify(payload))
   * @param options.decode The function to decode incoming messages. Defaults to Serializer's decode.
   * @param options.reconnectAfterMs he optional function that returns the millsec reconnect interval. Defaults to stepped backoff off.
   * @param options.worker Use Web Worker to set a side flow. Defaults to false.
   * @param options.workerUrl The URL of the worker script. Defaults to https://realtime.supabase.com/worker.js that includes a heartbeat event call to keep the connection alive.
   */
  constructor(t, n) {
    var r;
    this.accessTokenValue = null, this.apiKey = null, this.channels = [], this.endPoint = "", this.httpEndpoint = "", this.headers = TJ, this.params = {}, this.timeout = OA, this.heartbeatIntervalMs = 3e4, this.heartbeatTimer = void 0, this.pendingHeartbeatRef = null, this.ref = 0, this.logger = NJ, this.conn = null, this.sendBuffer = [], this.serializer = new IJ(), this.stateChangeCallbacks = {
      open: [],
      close: [],
      error: [],
      message: []
    }, this.accessToken = null, this._resolveFetch = (i) => {
      let a;
      return i ? a = i : typeof fetch > "u" ? a = (...l) => Promise.resolve().then(() => Id).then(({ default: c }) => c(...l)) : a = fetch, (...l) => a(...l);
    }, this.endPoint = `${t}/${N0.websocket}`, this.httpEndpoint = RA(t), n != null && n.transport ? this.transport = n.transport : this.transport = null, n != null && n.params && (this.params = n.params), n != null && n.headers && (this.headers = Object.assign(Object.assign({}, this.headers), n.headers)), n != null && n.timeout && (this.timeout = n.timeout), n != null && n.logger && (this.logger = n.logger), n != null && n.heartbeatIntervalMs && (this.heartbeatIntervalMs = n.heartbeatIntervalMs);
    const o = (r = n == null ? void 0 : n.params) === null || r === void 0 ? void 0 : r.apikey;
    if (o && (this.accessTokenValue = o, this.apiKey = o), this.reconnectAfterMs = n != null && n.reconnectAfterMs ? n.reconnectAfterMs : (i) => [1e3, 2e3, 5e3, 1e4][i - 1] || 1e4, this.encode = n != null && n.encode ? n.encode : (i, a) => a(JSON.stringify(i)), this.decode = n != null && n.decode ? n.decode : this.serializer.decode.bind(this.serializer), this.reconnectTimer = new PA(async () => {
      this.disconnect(), this.connect();
    }, this.reconnectAfterMs), this.fetch = this._resolveFetch(n == null ? void 0 : n.fetch), n != null && n.worker) {
      if (typeof window < "u" && !window.Worker)
        throw new Error("Web Worker is not supported");
      this.worker = (n == null ? void 0 : n.worker) || !1, this.workerUrl = n == null ? void 0 : n.workerUrl;
    }
    this.accessToken = (n == null ? void 0 : n.accessToken) || null;
  }
  /**
   * Connects the socket, unless already connected.
   */
  connect() {
    if (!this.conn) {
      if (this.transport) {
        this.conn = new this.transport(this.endpointURL(), void 0, {
          headers: this.headers
        });
        return;
      }
      if (FJ) {
        this.conn = new WebSocket(this.endpointURL()), this.setupConnection();
        return;
      }
      this.conn = new jJ(this.endpointURL(), void 0, {
        close: () => {
          this.conn = null;
        }
      }), import("./browser-CC2y0nHX.mjs").then((t) => t.b).then(({ default: t }) => {
        this.conn = new t(this.endpointURL(), void 0, {
          headers: this.headers
        }), this.setupConnection();
      });
    }
  }
  /**
   * Returns the URL of the websocket.
   * @returns string The URL of the websocket.
   */
  endpointURL() {
    return this._appendParams(this.endPoint, Object.assign({}, this.params, { vsn: OJ }));
  }
  /**
   * Disconnects the socket.
   *
   * @param code A numeric status code to send on disconnect.
   * @param reason A custom reason for the disconnect.
   */
  disconnect(t, n) {
    this.conn && (this.conn.onclose = function() {
    }, t ? this.conn.close(t, n ?? "") : this.conn.close(), this.conn = null, this.heartbeatTimer && clearInterval(this.heartbeatTimer), this.reconnectTimer.reset());
  }
  /**
   * Returns all created channels
   */
  getChannels() {
    return this.channels;
  }
  /**
   * Unsubscribes and removes a single channel
   * @param channel A RealtimeChannel instance
   */
  async removeChannel(t) {
    const n = await t.unsubscribe();
    return this.channels.length === 0 && this.disconnect(), n;
  }
  /**
   * Unsubscribes and removes all channels
   */
  async removeAllChannels() {
    const t = await Promise.all(this.channels.map((n) => n.unsubscribe()));
    return this.disconnect(), t;
  }
  /**
   * Logs the message.
   *
   * For customized logging, `this.logger` can be overridden.
   */
  log(t, n, r) {
    this.logger(t, n, r);
  }
  /**
   * Returns the current state of the socket.
   */
  connectionState() {
    switch (this.conn && this.conn.readyState) {
      case ju.connecting:
        return Jl.Connecting;
      case ju.open:
        return Jl.Open;
      case ju.closing:
        return Jl.Closing;
      default:
        return Jl.Closed;
    }
  }
  /**
   * Returns `true` is the connection is open.
   */
  isConnected() {
    return this.connectionState() === Jl.Open;
  }
  channel(t, n = { config: {} }) {
    const r = new Fx(`realtime:${t}`, n, this);
    return this.channels.push(r), r;
  }
  /**
   * Push out a message if the socket is connected.
   *
   * If the socket is not connected, the message gets enqueued within a local buffer, and sent out when a connection is next established.
   */
  push(t) {
    const { topic: n, event: r, payload: o, ref: i } = t, a = () => {
      this.encode(t, (l) => {
        var c;
        (c = this.conn) === null || c === void 0 || c.send(l);
      });
    };
    this.log("push", `${n} ${r} (${i})`, o), this.isConnected() ? a() : this.sendBuffer.push(a);
  }
  /**
   * Sets the JWT access token used for channel subscription authorization and Realtime RLS.
   *
   * If param is null it will use the `accessToken` callback function or the token set on the client.
   *
   * On callback used, it will set the value of the token internal to the client.
   *
   * @param token A JWT string to override the token set on the client.
   */
  async setAuth(t = null) {
    let n = t || this.accessToken && await this.accessToken() || this.accessTokenValue;
    if (n) {
      let r = null;
      try {
        r = JSON.parse(atob(n.split(".")[1]));
      } catch {
      }
      if (r && r.exp && !(Math.floor(Date.now() / 1e3) - r.exp < 0))
        return this.log("auth", `InvalidJWTToken: Invalid value for JWT claim "exp" with value ${r.exp}`), Promise.reject(`InvalidJWTToken: Invalid value for JWT claim "exp" with value ${r.exp}`);
      this.accessTokenValue = n, this.channels.forEach((o) => {
        n && o.updateJoinPayload({ access_token: n }), o.joinedOnce && o._isJoined() && o._push(Xi.access_token, {
          access_token: n
        });
      });
    }
  }
  /**
   * Sends a heartbeat message if the socket is connected.
   */
  async sendHeartbeat() {
    var t;
    if (this.isConnected()) {
      if (this.pendingHeartbeatRef) {
        this.pendingHeartbeatRef = null, this.log("transport", "heartbeat timeout. Attempting to re-establish connection"), (t = this.conn) === null || t === void 0 || t.close(PJ, "hearbeat timeout");
        return;
      }
      this.pendingHeartbeatRef = this._makeRef(), this.push({
        topic: "phoenix",
        event: "heartbeat",
        payload: {},
        ref: this.pendingHeartbeatRef
      }), this.setAuth();
    }
  }
  /**
   * Flushes send buffer
   */
  flushSendBuffer() {
    this.isConnected() && this.sendBuffer.length > 0 && (this.sendBuffer.forEach((t) => t()), this.sendBuffer = []);
  }
  /**
   * Return the next message ref, accounting for overflows
   *
   * @internal
   */
  _makeRef() {
    let t = this.ref + 1;
    return t === this.ref ? this.ref = 0 : this.ref = t, this.ref.toString();
  }
  /**
   * Unsubscribe from channels with the specified topic.
   *
   * @internal
   */
  _leaveOpenTopic(t) {
    let n = this.channels.find((r) => r.topic === t && (r._isJoined() || r._isJoining()));
    n && (this.log("transport", `leaving duplicate topic "${t}"`), n.unsubscribe());
  }
  /**
   * Removes a subscription from the socket.
   *
   * @param channel An open subscription.
   *
   * @internal
   */
  _remove(t) {
    this.channels = this.channels.filter((n) => n._joinRef() !== t._joinRef());
  }
  /**
   * Sets up connection handlers.
   *
   * @internal
   */
  setupConnection() {
    this.conn && (this.conn.binaryType = "arraybuffer", this.conn.onopen = () => this._onConnOpen(), this.conn.onerror = (t) => this._onConnError(t), this.conn.onmessage = (t) => this._onConnMessage(t), this.conn.onclose = (t) => this._onConnClose(t));
  }
  /** @internal */
  _onConnMessage(t) {
    this.decode(t.data, (n) => {
      let { topic: r, event: o, payload: i, ref: a } = n;
      a && a === this.pendingHeartbeatRef && (this.pendingHeartbeatRef = null), this.log("receive", `${i.status || ""} ${r} ${o} ${a && "(" + a + ")" || ""}`, i), this.channels.filter((l) => l._isMember(r)).forEach((l) => l._trigger(o, i, a)), this.stateChangeCallbacks.message.forEach((l) => l(n));
    });
  }
  /** @internal */
  async _onConnOpen() {
    if (this.log("transport", `connected to ${this.endpointURL()}`), this.flushSendBuffer(), this.reconnectTimer.reset(), !this.worker)
      this.heartbeatTimer && clearInterval(this.heartbeatTimer), this.heartbeatTimer = setInterval(() => this.sendHeartbeat(), this.heartbeatIntervalMs);
    else {
      this.workerUrl ? this.log("worker", `starting worker for from ${this.workerUrl}`) : this.log("worker", "starting default worker");
      const t = this._workerObjectUrl(this.workerUrl);
      this.workerRef = new Worker(t), this.workerRef.onerror = (n) => {
        this.log("worker", "worker error", n.message), this.workerRef.terminate();
      }, this.workerRef.onmessage = (n) => {
        n.data.event === "keepAlive" && this.sendHeartbeat();
      }, this.workerRef.postMessage({
        event: "start",
        interval: this.heartbeatIntervalMs
      });
    }
    this.stateChangeCallbacks.open.forEach((t) => t());
  }
  /** @internal */
  _onConnClose(t) {
    this.log("transport", "close", t), this._triggerChanError(), this.heartbeatTimer && clearInterval(this.heartbeatTimer), this.reconnectTimer.scheduleTimeout(), this.stateChangeCallbacks.close.forEach((n) => n(t));
  }
  /** @internal */
  _onConnError(t) {
    this.log("transport", t.message), this._triggerChanError(), this.stateChangeCallbacks.error.forEach((n) => n(t));
  }
  /** @internal */
  _triggerChanError() {
    this.channels.forEach((t) => t._trigger(Xi.error));
  }
  /** @internal */
  _appendParams(t, n) {
    if (Object.keys(n).length === 0)
      return t;
    const r = t.match(/\?/) ? "&" : "?", o = new URLSearchParams(n);
    return `${t}${r}${o}`;
  }
  _workerObjectUrl(t) {
    let n;
    if (t)
      n = t;
    else {
      const r = new Blob([$J], { type: "application/javascript" });
      n = URL.createObjectURL(r);
    }
    return n;
  }
}
class jJ {
  constructor(t, n, r) {
    this.binaryType = "arraybuffer", this.onclose = () => {
    }, this.onerror = () => {
    }, this.onmessage = () => {
    }, this.onopen = () => {
    }, this.readyState = ju.connecting, this.send = () => {
    }, this.url = null, this.url = t, this.close = r.close;
  }
}
class $x extends Error {
  constructor(t) {
    super(t), this.__isStorageError = !0, this.name = "StorageError";
  }
}
function Yr(e) {
  return typeof e == "object" && e !== null && "__isStorageError" in e;
}
class BJ extends $x {
  constructor(t, n) {
    super(t), this.name = "StorageApiError", this.status = n;
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      status: this.status
    };
  }
}
class $0 extends $x {
  constructor(t, n) {
    super(t), this.name = "StorageUnknownError", this.originalError = n;
  }
}
var VJ = function(e, t, n, r) {
  function o(i) {
    return i instanceof n ? i : new n(function(a) {
      a(i);
    });
  }
  return new (n || (n = Promise))(function(i, a) {
    function l(f) {
      try {
        d(r.next(f));
      } catch (p) {
        a(p);
      }
    }
    function c(f) {
      try {
        d(r.throw(f));
      } catch (p) {
        a(p);
      }
    }
    function d(f) {
      f.done ? i(f.value) : o(f.value).then(l, c);
    }
    d((r = r.apply(e, t || [])).next());
  });
};
const _A = (e) => {
  let t;
  return e ? t = e : typeof fetch > "u" ? t = (...n) => Promise.resolve().then(() => Id).then(({ default: r }) => r(...n)) : t = fetch, (...n) => t(...n);
}, HJ = () => VJ(void 0, void 0, void 0, function* () {
  return typeof Response > "u" ? (yield Promise.resolve().then(() => Id)).Response : Response;
}), L0 = (e) => {
  if (Array.isArray(e))
    return e.map((n) => L0(n));
  if (typeof e == "function" || e !== Object(e))
    return e;
  const t = {};
  return Object.entries(e).forEach(([n, r]) => {
    const o = n.replace(/([-_][a-z])/gi, (i) => i.toUpperCase().replace(/[-_]/g, ""));
    t[o] = L0(r);
  }), t;
};
var Mc = function(e, t, n, r) {
  function o(i) {
    return i instanceof n ? i : new n(function(a) {
      a(i);
    });
  }
  return new (n || (n = Promise))(function(i, a) {
    function l(f) {
      try {
        d(r.next(f));
      } catch (p) {
        a(p);
      }
    }
    function c(f) {
      try {
        d(r.throw(f));
      } catch (p) {
        a(p);
      }
    }
    function d(f) {
      f.done ? i(f.value) : o(f.value).then(l, c);
    }
    d((r = r.apply(e, t || [])).next());
  });
};
const lw = (e) => e.msg || e.message || e.error_description || e.error || JSON.stringify(e), UJ = (e, t, n) => Mc(void 0, void 0, void 0, function* () {
  const r = yield HJ();
  e instanceof r && !(n != null && n.noResolveJson) ? e.json().then((o) => {
    t(new BJ(lw(o), e.status || 500));
  }).catch((o) => {
    t(new $0(lw(o), o));
  }) : t(new $0(lw(e), e));
}), zJ = (e, t, n, r) => {
  const o = { method: e, headers: (t == null ? void 0 : t.headers) || {} };
  return e === "GET" ? o : (o.headers = Object.assign({ "Content-Type": "application/json" }, t == null ? void 0 : t.headers), r && (o.body = JSON.stringify(r)), Object.assign(Object.assign({}, o), n));
};
function th(e, t, n, r, o, i) {
  return Mc(this, void 0, void 0, function* () {
    return new Promise((a, l) => {
      e(n, zJ(t, r, o, i)).then((c) => {
        if (!c.ok)
          throw c;
        return r != null && r.noResolveJson ? c : c.json();
      }).then((c) => a(c)).catch((c) => UJ(c, l, r));
    });
  });
}
function hm(e, t, n, r) {
  return Mc(this, void 0, void 0, function* () {
    return th(e, "GET", t, n, r);
  });
}
function qa(e, t, n, r, o) {
  return Mc(this, void 0, void 0, function* () {
    return th(e, "POST", t, r, o, n);
  });
}
function GJ(e, t, n, r, o) {
  return Mc(this, void 0, void 0, function* () {
    return th(e, "PUT", t, r, o, n);
  });
}
function WJ(e, t, n, r) {
  return Mc(this, void 0, void 0, function* () {
    return th(e, "HEAD", t, Object.assign(Object.assign({}, n), { noResolveJson: !0 }), r);
  });
}
function kA(e, t, n, r, o) {
  return Mc(this, void 0, void 0, function* () {
    return th(e, "DELETE", t, r, o, n);
  });
}
var No = function(e, t, n, r) {
  function o(i) {
    return i instanceof n ? i : new n(function(a) {
      a(i);
    });
  }
  return new (n || (n = Promise))(function(i, a) {
    function l(f) {
      try {
        d(r.next(f));
      } catch (p) {
        a(p);
      }
    }
    function c(f) {
      try {
        d(r.throw(f));
      } catch (p) {
        a(p);
      }
    }
    function d(f) {
      f.done ? i(f.value) : o(f.value).then(l, c);
    }
    d((r = r.apply(e, t || [])).next());
  });
};
const qJ = {
  limit: 100,
  offset: 0,
  sortBy: {
    column: "name",
    order: "asc"
  }
}, BP = {
  cacheControl: "3600",
  contentType: "text/plain;charset=UTF-8",
  upsert: !1
};
class KJ {
  constructor(t, n = {}, r, o) {
    this.url = t, this.headers = n, this.bucketId = r, this.fetch = _A(o);
  }
  /**
   * Uploads a file to an existing bucket or replaces an existing file at the specified path with a new one.
   *
   * @param method HTTP method.
   * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
   * @param fileBody The body of the file to be stored in the bucket.
   */
  uploadOrUpdate(t, n, r, o) {
    return No(this, void 0, void 0, function* () {
      try {
        let i;
        const a = Object.assign(Object.assign({}, BP), o);
        let l = Object.assign(Object.assign({}, this.headers), t === "POST" && { "x-upsert": String(a.upsert) });
        const c = a.metadata;
        typeof Blob < "u" && r instanceof Blob ? (i = new FormData(), i.append("cacheControl", a.cacheControl), c && i.append("metadata", this.encodeMetadata(c)), i.append("", r)) : typeof FormData < "u" && r instanceof FormData ? (i = r, i.append("cacheControl", a.cacheControl), c && i.append("metadata", this.encodeMetadata(c))) : (i = r, l["cache-control"] = `max-age=${a.cacheControl}`, l["content-type"] = a.contentType, c && (l["x-metadata"] = this.toBase64(this.encodeMetadata(c)))), o != null && o.headers && (l = Object.assign(Object.assign({}, l), o.headers));
        const d = this._removeEmptyFolders(n), f = this._getFinalPath(d), p = yield this.fetch(`${this.url}/object/${f}`, Object.assign({ method: t, body: i, headers: l }, a != null && a.duplex ? { duplex: a.duplex } : {})), g = yield p.json();
        return p.ok ? {
          data: { path: d, id: g.Id, fullPath: g.Key },
          error: null
        } : { data: null, error: g };
      } catch (i) {
        if (Yr(i))
          return { data: null, error: i };
        throw i;
      }
    });
  }
  /**
   * Uploads a file to an existing bucket.
   *
   * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
   * @param fileBody The body of the file to be stored in the bucket.
   */
  upload(t, n, r) {
    return No(this, void 0, void 0, function* () {
      return this.uploadOrUpdate("POST", t, n, r);
    });
  }
  /**
   * Upload a file with a token generated from `createSignedUploadUrl`.
   * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
   * @param token The token generated from `createSignedUploadUrl`
   * @param fileBody The body of the file to be stored in the bucket.
   */
  uploadToSignedUrl(t, n, r, o) {
    return No(this, void 0, void 0, function* () {
      const i = this._removeEmptyFolders(t), a = this._getFinalPath(i), l = new URL(this.url + `/object/upload/sign/${a}`);
      l.searchParams.set("token", n);
      try {
        let c;
        const d = Object.assign({ upsert: BP.upsert }, o), f = Object.assign(Object.assign({}, this.headers), { "x-upsert": String(d.upsert) });
        typeof Blob < "u" && r instanceof Blob ? (c = new FormData(), c.append("cacheControl", d.cacheControl), c.append("", r)) : typeof FormData < "u" && r instanceof FormData ? (c = r, c.append("cacheControl", d.cacheControl)) : (c = r, f["cache-control"] = `max-age=${d.cacheControl}`, f["content-type"] = d.contentType);
        const p = yield this.fetch(l.toString(), {
          method: "PUT",
          body: c,
          headers: f
        }), g = yield p.json();
        return p.ok ? {
          data: { path: i, fullPath: g.Key },
          error: null
        } : { data: null, error: g };
      } catch (c) {
        if (Yr(c))
          return { data: null, error: c };
        throw c;
      }
    });
  }
  /**
   * Creates a signed upload URL.
   * Signed upload URLs can be used to upload files to the bucket without further authentication.
   * They are valid for 2 hours.
   * @param path The file path, including the current file name. For example `folder/image.png`.
   * @param options.upsert If set to true, allows the file to be overwritten if it already exists.
   */
  createSignedUploadUrl(t, n) {
    return No(this, void 0, void 0, function* () {
      try {
        let r = this._getFinalPath(t);
        const o = Object.assign({}, this.headers);
        n != null && n.upsert && (o["x-upsert"] = "true");
        const i = yield qa(this.fetch, `${this.url}/object/upload/sign/${r}`, {}, { headers: o }), a = new URL(this.url + i.url), l = a.searchParams.get("token");
        if (!l)
          throw new $x("No token returned by API");
        return { data: { signedUrl: a.toString(), path: t, token: l }, error: null };
      } catch (r) {
        if (Yr(r))
          return { data: null, error: r };
        throw r;
      }
    });
  }
  /**
   * Replaces an existing file at the specified path with a new one.
   *
   * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to update.
   * @param fileBody The body of the file to be stored in the bucket.
   */
  update(t, n, r) {
    return No(this, void 0, void 0, function* () {
      return this.uploadOrUpdate("PUT", t, n, r);
    });
  }
  /**
   * Moves an existing file to a new path in the same bucket.
   *
   * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
   * @param toPath The new file path, including the new file name. For example `folder/image-new.png`.
   * @param options The destination options.
   */
  move(t, n, r) {
    return No(this, void 0, void 0, function* () {
      try {
        return { data: yield qa(this.fetch, `${this.url}/object/move`, {
          bucketId: this.bucketId,
          sourceKey: t,
          destinationKey: n,
          destinationBucket: r == null ? void 0 : r.destinationBucket
        }, { headers: this.headers }), error: null };
      } catch (o) {
        if (Yr(o))
          return { data: null, error: o };
        throw o;
      }
    });
  }
  /**
   * Copies an existing file to a new path in the same bucket.
   *
   * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
   * @param toPath The new file path, including the new file name. For example `folder/image-copy.png`.
   * @param options The destination options.
   */
  copy(t, n, r) {
    return No(this, void 0, void 0, function* () {
      try {
        return { data: { path: (yield qa(this.fetch, `${this.url}/object/copy`, {
          bucketId: this.bucketId,
          sourceKey: t,
          destinationKey: n,
          destinationBucket: r == null ? void 0 : r.destinationBucket
        }, { headers: this.headers })).Key }, error: null };
      } catch (o) {
        if (Yr(o))
          return { data: null, error: o };
        throw o;
      }
    });
  }
  /**
   * Creates a signed URL. Use a signed URL to share a file for a fixed amount of time.
   *
   * @param path The file path, including the current file name. For example `folder/image.png`.
   * @param expiresIn The number of seconds until the signed URL expires. For example, `60` for a URL which is valid for one minute.
   * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
   * @param options.transform Transform the asset before serving it to the client.
   */
  createSignedUrl(t, n, r) {
    return No(this, void 0, void 0, function* () {
      try {
        let o = this._getFinalPath(t), i = yield qa(this.fetch, `${this.url}/object/sign/${o}`, Object.assign({ expiresIn: n }, r != null && r.transform ? { transform: r.transform } : {}), { headers: this.headers });
        const a = r != null && r.download ? `&download=${r.download === !0 ? "" : r.download}` : "";
        return i = { signedUrl: encodeURI(`${this.url}${i.signedURL}${a}`) }, { data: i, error: null };
      } catch (o) {
        if (Yr(o))
          return { data: null, error: o };
        throw o;
      }
    });
  }
  /**
   * Creates multiple signed URLs. Use a signed URL to share a file for a fixed amount of time.
   *
   * @param paths The file paths to be downloaded, including the current file names. For example `['folder/image.png', 'folder2/image2.png']`.
   * @param expiresIn The number of seconds until the signed URLs expire. For example, `60` for URLs which are valid for one minute.
   * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
   */
  createSignedUrls(t, n, r) {
    return No(this, void 0, void 0, function* () {
      try {
        const o = yield qa(this.fetch, `${this.url}/object/sign/${this.bucketId}`, { expiresIn: n, paths: t }, { headers: this.headers }), i = r != null && r.download ? `&download=${r.download === !0 ? "" : r.download}` : "";
        return {
          data: o.map((a) => Object.assign(Object.assign({}, a), { signedUrl: a.signedURL ? encodeURI(`${this.url}${a.signedURL}${i}`) : null })),
          error: null
        };
      } catch (o) {
        if (Yr(o))
          return { data: null, error: o };
        throw o;
      }
    });
  }
  /**
   * Downloads a file from a private bucket. For public buckets, make a request to the URL returned from `getPublicUrl` instead.
   *
   * @param path The full path and file name of the file to be downloaded. For example `folder/image.png`.
   * @param options.transform Transform the asset before serving it to the client.
   */
  download(t, n) {
    return No(this, void 0, void 0, function* () {
      const o = typeof (n == null ? void 0 : n.transform) < "u" ? "render/image/authenticated" : "object", i = this.transformOptsToQueryString((n == null ? void 0 : n.transform) || {}), a = i ? `?${i}` : "";
      try {
        const l = this._getFinalPath(t);
        return { data: yield (yield hm(this.fetch, `${this.url}/${o}/${l}${a}`, {
          headers: this.headers,
          noResolveJson: !0
        })).blob(), error: null };
      } catch (l) {
        if (Yr(l))
          return { data: null, error: l };
        throw l;
      }
    });
  }
  /**
   * Retrieves the details of an existing file.
   * @param path
   */
  info(t) {
    return No(this, void 0, void 0, function* () {
      const n = this._getFinalPath(t);
      try {
        const r = yield hm(this.fetch, `${this.url}/object/info/${n}`, {
          headers: this.headers
        });
        return { data: L0(r), error: null };
      } catch (r) {
        if (Yr(r))
          return { data: null, error: r };
        throw r;
      }
    });
  }
  /**
   * Checks the existence of a file.
   * @param path
   */
  exists(t) {
    return No(this, void 0, void 0, function* () {
      const n = this._getFinalPath(t);
      try {
        return yield WJ(this.fetch, `${this.url}/object/${n}`, {
          headers: this.headers
        }), { data: !0, error: null };
      } catch (r) {
        if (Yr(r) && r instanceof $0) {
          const o = r.originalError;
          if ([400, 404].includes(o == null ? void 0 : o.status))
            return { data: !1, error: r };
        }
        throw r;
      }
    });
  }
  /**
   * A simple convenience function to get the URL for an asset in a public bucket. If you do not want to use this function, you can construct the public URL by concatenating the bucket URL with the path to the asset.
   * This function does not verify if the bucket is public. If a public URL is created for a bucket which is not public, you will not be able to download the asset.
   *
   * @param path The path and name of the file to generate the public URL for. For example `folder/image.png`.
   * @param options.download Triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
   * @param options.transform Transform the asset before serving it to the client.
   */
  getPublicUrl(t, n) {
    const r = this._getFinalPath(t), o = [], i = n != null && n.download ? `download=${n.download === !0 ? "" : n.download}` : "";
    i !== "" && o.push(i);
    const l = typeof (n == null ? void 0 : n.transform) < "u" ? "render/image" : "object", c = this.transformOptsToQueryString((n == null ? void 0 : n.transform) || {});
    c !== "" && o.push(c);
    let d = o.join("&");
    return d !== "" && (d = `?${d}`), {
      data: { publicUrl: encodeURI(`${this.url}/${l}/public/${r}${d}`) }
    };
  }
  /**
   * Deletes files within the same bucket
   *
   * @param paths An array of files to delete, including the path and file name. For example [`'folder/image.png'`].
   */
  remove(t) {
    return No(this, void 0, void 0, function* () {
      try {
        return { data: yield kA(this.fetch, `${this.url}/object/${this.bucketId}`, { prefixes: t }, { headers: this.headers }), error: null };
      } catch (n) {
        if (Yr(n))
          return { data: null, error: n };
        throw n;
      }
    });
  }
  /**
   * Get file metadata
   * @param id the file id to retrieve metadata
   */
  // async getMetadata(
  //   id: string
  // ): Promise<
  //   | {
  //       data: Metadata
  //       error: null
  //     }
  //   | {
  //       data: null
  //       error: StorageError
  //     }
  // > {
  //   try {
  //     const data = await get(this.fetch, `${this.url}/metadata/${id}`, { headers: this.headers })
  //     return { data, error: null }
  //   } catch (error) {
  //     if (isStorageError(error)) {
  //       return { data: null, error }
  //     }
  //     throw error
  //   }
  // }
  /**
   * Update file metadata
   * @param id the file id to update metadata
   * @param meta the new file metadata
   */
  // async updateMetadata(
  //   id: string,
  //   meta: Metadata
  // ): Promise<
  //   | {
  //       data: Metadata
  //       error: null
  //     }
  //   | {
  //       data: null
  //       error: StorageError
  //     }
  // > {
  //   try {
  //     const data = await post(
  //       this.fetch,
  //       `${this.url}/metadata/${id}`,
  //       { ...meta },
  //       { headers: this.headers }
  //     )
  //     return { data, error: null }
  //   } catch (error) {
  //     if (isStorageError(error)) {
  //       return { data: null, error }
  //     }
  //     throw error
  //   }
  // }
  /**
   * Lists all the files within a bucket.
   * @param path The folder path.
   */
  list(t, n, r) {
    return No(this, void 0, void 0, function* () {
      try {
        const o = Object.assign(Object.assign(Object.assign({}, qJ), n), { prefix: t || "" });
        return { data: yield qa(this.fetch, `${this.url}/object/list/${this.bucketId}`, o, { headers: this.headers }, r), error: null };
      } catch (o) {
        if (Yr(o))
          return { data: null, error: o };
        throw o;
      }
    });
  }
  encodeMetadata(t) {
    return JSON.stringify(t);
  }
  toBase64(t) {
    return typeof Buffer < "u" ? Buffer.from(t).toString("base64") : btoa(t);
  }
  _getFinalPath(t) {
    return `${this.bucketId}/${t}`;
  }
  _removeEmptyFolders(t) {
    return t.replace(/^\/|\/$/g, "").replace(/\/+/g, "/");
  }
  transformOptsToQueryString(t) {
    const n = [];
    return t.width && n.push(`width=${t.width}`), t.height && n.push(`height=${t.height}`), t.resize && n.push(`resize=${t.resize}`), t.format && n.push(`format=${t.format}`), t.quality && n.push(`quality=${t.quality}`), n.join("&");
  }
}
const YJ = "2.7.1", QJ = { "X-Client-Info": `storage-js/${YJ}` };
var uu = function(e, t, n, r) {
  function o(i) {
    return i instanceof n ? i : new n(function(a) {
      a(i);
    });
  }
  return new (n || (n = Promise))(function(i, a) {
    function l(f) {
      try {
        d(r.next(f));
      } catch (p) {
        a(p);
      }
    }
    function c(f) {
      try {
        d(r.throw(f));
      } catch (p) {
        a(p);
      }
    }
    function d(f) {
      f.done ? i(f.value) : o(f.value).then(l, c);
    }
    d((r = r.apply(e, t || [])).next());
  });
};
class XJ {
  constructor(t, n = {}, r) {
    this.url = t, this.headers = Object.assign(Object.assign({}, QJ), n), this.fetch = _A(r);
  }
  /**
   * Retrieves the details of all Storage buckets within an existing project.
   */
  listBuckets() {
    return uu(this, void 0, void 0, function* () {
      try {
        return { data: yield hm(this.fetch, `${this.url}/bucket`, { headers: this.headers }), error: null };
      } catch (t) {
        if (Yr(t))
          return { data: null, error: t };
        throw t;
      }
    });
  }
  /**
   * Retrieves the details of an existing Storage bucket.
   *
   * @param id The unique identifier of the bucket you would like to retrieve.
   */
  getBucket(t) {
    return uu(this, void 0, void 0, function* () {
      try {
        return { data: yield hm(this.fetch, `${this.url}/bucket/${t}`, { headers: this.headers }), error: null };
      } catch (n) {
        if (Yr(n))
          return { data: null, error: n };
        throw n;
      }
    });
  }
  /**
   * Creates a new Storage bucket
   *
   * @param id A unique identifier for the bucket you are creating.
   * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations. By default, buckets are private.
   * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
   * The global file size limit takes precedence over this value.
   * The default value is null, which doesn't set a per bucket file size limit.
   * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
   * The default value is null, which allows files with all mime types to be uploaded.
   * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
   * @returns newly created bucket id
   */
  createBucket(t, n = {
    public: !1
  }) {
    return uu(this, void 0, void 0, function* () {
      try {
        return { data: yield qa(this.fetch, `${this.url}/bucket`, {
          id: t,
          name: t,
          public: n.public,
          file_size_limit: n.fileSizeLimit,
          allowed_mime_types: n.allowedMimeTypes
        }, { headers: this.headers }), error: null };
      } catch (r) {
        if (Yr(r))
          return { data: null, error: r };
        throw r;
      }
    });
  }
  /**
   * Updates a Storage bucket
   *
   * @param id A unique identifier for the bucket you are updating.
   * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations.
   * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
   * The global file size limit takes precedence over this value.
   * The default value is null, which doesn't set a per bucket file size limit.
   * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
   * The default value is null, which allows files with all mime types to be uploaded.
   * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
   */
  updateBucket(t, n) {
    return uu(this, void 0, void 0, function* () {
      try {
        return { data: yield GJ(this.fetch, `${this.url}/bucket/${t}`, {
          id: t,
          name: t,
          public: n.public,
          file_size_limit: n.fileSizeLimit,
          allowed_mime_types: n.allowedMimeTypes
        }, { headers: this.headers }), error: null };
      } catch (r) {
        if (Yr(r))
          return { data: null, error: r };
        throw r;
      }
    });
  }
  /**
   * Removes all objects inside a single bucket.
   *
   * @param id The unique identifier of the bucket you would like to empty.
   */
  emptyBucket(t) {
    return uu(this, void 0, void 0, function* () {
      try {
        return { data: yield qa(this.fetch, `${this.url}/bucket/${t}/empty`, {}, { headers: this.headers }), error: null };
      } catch (n) {
        if (Yr(n))
          return { data: null, error: n };
        throw n;
      }
    });
  }
  /**
   * Deletes an existing bucket. A bucket can't be deleted with existing objects inside it.
   * You must first `empty()` the bucket.
   *
   * @param id The unique identifier of the bucket you would like to delete.
   */
  deleteBucket(t) {
    return uu(this, void 0, void 0, function* () {
      try {
        return { data: yield kA(this.fetch, `${this.url}/bucket/${t}`, {}, { headers: this.headers }), error: null };
      } catch (n) {
        if (Yr(n))
          return { data: null, error: n };
        throw n;
      }
    });
  }
}
class JJ extends XJ {
  constructor(t, n = {}, r) {
    super(t, n, r);
  }
  /**
   * Perform file operation in a bucket.
   *
   * @param id The bucket id to operate on.
   */
  from(t) {
    return new KJ(this.url, this.headers, t, this.fetch);
  }
}
const ZJ = "2.47.3";
let Af = "";
typeof Deno < "u" ? Af = "deno" : typeof document < "u" ? Af = "web" : typeof navigator < "u" && navigator.product === "ReactNative" ? Af = "react-native" : Af = "node";
const eZ = { "X-Client-Info": `supabase-js-${Af}/${ZJ}` }, tZ = {
  headers: eZ
}, nZ = {
  schema: "public"
}, rZ = {
  autoRefreshToken: !0,
  persistSession: !0,
  detectSessionInUrl: !0,
  flowType: "implicit"
}, oZ = {};
var iZ = function(e, t, n, r) {
  function o(i) {
    return i instanceof n ? i : new n(function(a) {
      a(i);
    });
  }
  return new (n || (n = Promise))(function(i, a) {
    function l(f) {
      try {
        d(r.next(f));
      } catch (p) {
        a(p);
      }
    }
    function c(f) {
      try {
        d(r.throw(f));
      } catch (p) {
        a(p);
      }
    }
    function d(f) {
      f.done ? i(f.value) : o(f.value).then(l, c);
    }
    d((r = r.apply(e, t || [])).next());
  });
};
const sZ = (e) => {
  let t;
  return e ? t = e : typeof fetch > "u" ? t = gA : t = fetch, (...n) => t(...n);
}, aZ = () => typeof Headers > "u" ? mA : Headers, lZ = (e, t, n) => {
  const r = sZ(n), o = aZ();
  return (i, a) => iZ(void 0, void 0, void 0, function* () {
    var l;
    const c = (l = yield t()) !== null && l !== void 0 ? l : e;
    let d = new o(a == null ? void 0 : a.headers);
    return d.has("apikey") || d.set("apikey", e), d.has("Authorization") || d.set("Authorization", `Bearer ${c}`), r(i, Object.assign(Object.assign({}, a), { headers: d }));
  });
};
var cZ = function(e, t, n, r) {
  function o(i) {
    return i instanceof n ? i : new n(function(a) {
      a(i);
    });
  }
  return new (n || (n = Promise))(function(i, a) {
    function l(f) {
      try {
        d(r.next(f));
      } catch (p) {
        a(p);
      }
    }
    function c(f) {
      try {
        d(r.throw(f));
      } catch (p) {
        a(p);
      }
    }
    function d(f) {
      f.done ? i(f.value) : o(f.value).then(l, c);
    }
    d((r = r.apply(e, t || [])).next());
  });
};
function uZ(e) {
  return e.replace(/\/$/, "");
}
function dZ(e, t) {
  const { db: n, auth: r, realtime: o, global: i } = e, { db: a, auth: l, realtime: c, global: d } = t, f = {
    db: Object.assign(Object.assign({}, a), n),
    auth: Object.assign(Object.assign({}, l), r),
    realtime: Object.assign(Object.assign({}, c), o),
    global: Object.assign(Object.assign({}, d), i),
    accessToken: () => cZ(this, void 0, void 0, function* () {
      return "";
    })
  };
  return e.accessToken ? f.accessToken = e.accessToken : delete f.accessToken, f;
}
const MA = "2.66.1", fZ = "http://localhost:9999", pZ = "supabase.auth.token", hZ = { "X-Client-Info": `gotrue-js/${MA}` }, VP = 10, j0 = "X-Supabase-Api-Version", AA = {
  "2024-01-01": {
    timestamp: Date.parse("2024-01-01T00:00:00.0Z"),
    name: "2024-01-01"
  }
};
function gZ(e) {
  return Math.round(Date.now() / 1e3) + e;
}
function mZ() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
    const t = Math.random() * 16 | 0;
    return (e == "x" ? t : t & 3 | 8).toString(16);
  });
}
const qi = () => typeof document < "u", Wl = {
  tested: !1,
  writable: !1
}, Gf = () => {
  if (!qi())
    return !1;
  try {
    if (typeof globalThis.localStorage != "object")
      return !1;
  } catch {
    return !1;
  }
  if (Wl.tested)
    return Wl.writable;
  const e = `lswt-${Math.random()}${Math.random()}`;
  try {
    globalThis.localStorage.setItem(e, e), globalThis.localStorage.removeItem(e), Wl.tested = !0, Wl.writable = !0;
  } catch {
    Wl.tested = !0, Wl.writable = !1;
  }
  return Wl.writable;
};
function cw(e) {
  const t = {}, n = new URL(e);
  if (n.hash && n.hash[0] === "#")
    try {
      new URLSearchParams(n.hash.substring(1)).forEach((o, i) => {
        t[i] = o;
      });
    } catch {
    }
  return n.searchParams.forEach((r, o) => {
    t[o] = r;
  }), t;
}
const DA = (e) => {
  let t;
  return e ? t = e : typeof fetch > "u" ? t = (...n) => Promise.resolve().then(() => Id).then(({ default: r }) => r(...n)) : t = fetch, (...n) => t(...n);
}, bZ = (e) => typeof e == "object" && e !== null && "status" in e && "ok" in e && "json" in e && typeof e.json == "function", NA = async (e, t, n) => {
  await e.setItem(t, JSON.stringify(n));
}, yg = async (e, t) => {
  const n = await e.getItem(t);
  if (!n)
    return null;
  try {
    return JSON.parse(n);
  } catch {
    return n;
  }
}, vg = async (e, t) => {
  await e.removeItem(t);
};
function yZ(e) {
  const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  let n = "", r, o, i, a, l, c, d, f = 0;
  for (e = e.replace("-", "+").replace("_", "/"); f < e.length; )
    a = t.indexOf(e.charAt(f++)), l = t.indexOf(e.charAt(f++)), c = t.indexOf(e.charAt(f++)), d = t.indexOf(e.charAt(f++)), r = a << 2 | l >> 4, o = (l & 15) << 4 | c >> 2, i = (c & 3) << 6 | d, n = n + String.fromCharCode(r), c != 64 && o != 0 && (n = n + String.fromCharCode(o)), d != 64 && i != 0 && (n = n + String.fromCharCode(i));
  return n;
}
let FA = class $A {
  constructor() {
    this.promise = new $A.promiseConstructor((t, n) => {
      this.resolve = t, this.reject = n;
    });
  }
};
FA.promiseConstructor = Promise;
function HP(e) {
  const t = /^([a-z0-9_-]{4})*($|[a-z0-9_-]{3}=?$|[a-z0-9_-]{2}(==)?$)$/i, n = e.split(".");
  if (n.length !== 3)
    throw new Error("JWT is not valid: not a JWT structure");
  if (!t.test(n[1]))
    throw new Error("JWT is not valid: payload is not in base64url format");
  const r = n[1];
  return JSON.parse(yZ(r));
}
async function vZ(e) {
  return await new Promise((t) => {
    setTimeout(() => t(null), e);
  });
}
function wZ(e, t) {
  return new Promise((r, o) => {
    (async () => {
      for (let i = 0; i < 1 / 0; i++)
        try {
          const a = await e(i);
          if (!t(i, null, a)) {
            r(a);
            return;
          }
        } catch (a) {
          if (!t(i, a)) {
            o(a);
            return;
          }
        }
    })();
  });
}
function CZ(e) {
  return ("0" + e.toString(16)).substr(-2);
}
function xZ() {
  const t = new Uint32Array(56);
  if (typeof crypto > "u") {
    const n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~", r = n.length;
    let o = "";
    for (let i = 0; i < 56; i++)
      o += n.charAt(Math.floor(Math.random() * r));
    return o;
  }
  return crypto.getRandomValues(t), Array.from(t, CZ).join("");
}
async function SZ(e) {
  const n = new TextEncoder().encode(e), r = await crypto.subtle.digest("SHA-256", n), o = new Uint8Array(r);
  return Array.from(o).map((i) => String.fromCharCode(i)).join("");
}
function EZ(e) {
  return btoa(e).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
async function TZ(e) {
  if (!(typeof crypto < "u" && typeof crypto.subtle < "u" && typeof TextEncoder < "u"))
    return console.warn("WebCrypto API is not supported. Code challenge method will default to use plain instead of sha256."), e;
  const n = await SZ(e);
  return EZ(n);
}
async function du(e, t, n = !1) {
  const r = xZ();
  let o = r;
  n && (o += "/PASSWORD_RECOVERY"), await NA(e, `${t}-code-verifier`, o);
  const i = await TZ(r);
  return [i, r === i ? "plain" : "s256"];
}
const OZ = /^2[0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/i;
function PZ(e) {
  const t = e.headers.get(j0);
  if (!t || !t.match(OZ))
    return null;
  try {
    return /* @__PURE__ */ new Date(`${t}T00:00:00.0Z`);
  } catch {
    return null;
  }
}
class Lx extends Error {
  constructor(t, n, r) {
    super(t), this.__isAuthError = !0, this.name = "AuthError", this.status = n, this.code = r;
  }
}
function Xt(e) {
  return typeof e == "object" && e !== null && "__isAuthError" in e;
}
class IZ extends Lx {
  constructor(t, n, r) {
    super(t, n, r), this.name = "AuthApiError", this.status = n, this.code = r;
  }
}
function RZ(e) {
  return Xt(e) && e.name === "AuthApiError";
}
class LA extends Lx {
  constructor(t, n) {
    super(t), this.name = "AuthUnknownError", this.originalError = n;
  }
}
class Ac extends Lx {
  constructor(t, n, r, o) {
    super(t, r, o), this.name = n, this.status = r;
  }
}
class Ha extends Ac {
  constructor() {
    super("Auth session missing!", "AuthSessionMissingError", 400, void 0);
  }
}
function _Z(e) {
  return Xt(e) && e.name === "AuthSessionMissingError";
}
class uw extends Ac {
  constructor() {
    super("Auth session or user missing", "AuthInvalidTokenResponseError", 500, void 0);
  }
}
class wg extends Ac {
  constructor(t) {
    super(t, "AuthInvalidCredentialsError", 400, void 0);
  }
}
class Cg extends Ac {
  constructor(t, n = null) {
    super(t, "AuthImplicitGrantRedirectError", 500, void 0), this.details = null, this.details = n;
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      status: this.status,
      details: this.details
    };
  }
}
function kZ(e) {
  return Xt(e) && e.name === "AuthImplicitGrantRedirectError";
}
class UP extends Ac {
  constructor(t, n = null) {
    super(t, "AuthPKCEGrantCodeExchangeError", 500, void 0), this.details = null, this.details = n;
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      status: this.status,
      details: this.details
    };
  }
}
class B0 extends Ac {
  constructor(t, n) {
    super(t, "AuthRetryableFetchError", n, void 0);
  }
}
function dw(e) {
  return Xt(e) && e.name === "AuthRetryableFetchError";
}
class zP extends Ac {
  constructor(t, n, r) {
    super(t, "AuthWeakPasswordError", n, "weak_password"), this.reasons = r;
  }
}
var MZ = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Yl = (e) => e.msg || e.message || e.error_description || e.error || JSON.stringify(e), AZ = [502, 503, 504];
async function GP(e) {
  var t;
  if (!bZ(e))
    throw new B0(Yl(e), 0);
  if (AZ.includes(e.status))
    throw new B0(Yl(e), e.status);
  let n;
  try {
    n = await e.json();
  } catch (i) {
    throw new LA(Yl(i), i);
  }
  let r;
  const o = PZ(e);
  if (o && o.getTime() >= AA["2024-01-01"].timestamp && typeof n == "object" && n && typeof n.code == "string" ? r = n.code : typeof n == "object" && n && typeof n.error_code == "string" && (r = n.error_code), r) {
    if (r === "weak_password")
      throw new zP(Yl(n), e.status, ((t = n.weak_password) === null || t === void 0 ? void 0 : t.reasons) || []);
    if (r === "session_not_found")
      throw new Ha();
  } else if (typeof n == "object" && n && typeof n.weak_password == "object" && n.weak_password && Array.isArray(n.weak_password.reasons) && n.weak_password.reasons.length && n.weak_password.reasons.reduce((i, a) => i && typeof a == "string", !0))
    throw new zP(Yl(n), e.status, n.weak_password.reasons);
  throw new IZ(Yl(n), e.status || 500, r);
}
const DZ = (e, t, n, r) => {
  const o = { method: e, headers: (t == null ? void 0 : t.headers) || {} };
  return e === "GET" ? o : (o.headers = Object.assign({ "Content-Type": "application/json;charset=UTF-8" }, t == null ? void 0 : t.headers), o.body = JSON.stringify(r), Object.assign(Object.assign({}, o), n));
};
async function un(e, t, n, r) {
  var o;
  const i = Object.assign({}, r == null ? void 0 : r.headers);
  i[j0] || (i[j0] = AA["2024-01-01"].name), r != null && r.jwt && (i.Authorization = `Bearer ${r.jwt}`);
  const a = (o = r == null ? void 0 : r.query) !== null && o !== void 0 ? o : {};
  r != null && r.redirectTo && (a.redirect_to = r.redirectTo);
  const l = Object.keys(a).length ? "?" + new URLSearchParams(a).toString() : "", c = await NZ(e, t, n + l, {
    headers: i,
    noResolveJson: r == null ? void 0 : r.noResolveJson
  }, {}, r == null ? void 0 : r.body);
  return r != null && r.xform ? r == null ? void 0 : r.xform(c) : { data: Object.assign({}, c), error: null };
}
async function NZ(e, t, n, r, o, i) {
  const a = DZ(t, r, o, i);
  let l;
  try {
    l = await e(n, Object.assign({}, a));
  } catch (c) {
    throw console.error(c), new B0(Yl(c), 0);
  }
  if (l.ok || await GP(l), r != null && r.noResolveJson)
    return l;
  try {
    return await l.json();
  } catch (c) {
    await GP(c);
  }
}
function Ua(e) {
  var t;
  let n = null;
  jZ(e) && (n = Object.assign({}, e), e.expires_at || (n.expires_at = gZ(e.expires_in)));
  const r = (t = e.user) !== null && t !== void 0 ? t : e;
  return { data: { session: n, user: r }, error: null };
}
function WP(e) {
  const t = Ua(e);
  return !t.error && e.weak_password && typeof e.weak_password == "object" && Array.isArray(e.weak_password.reasons) && e.weak_password.reasons.length && e.weak_password.message && typeof e.weak_password.message == "string" && e.weak_password.reasons.reduce((n, r) => n && typeof r == "string", !0) && (t.data.weak_password = e.weak_password), t;
}
function Xa(e) {
  var t;
  return { data: { user: (t = e.user) !== null && t !== void 0 ? t : e }, error: null };
}
function FZ(e) {
  return { data: e, error: null };
}
function $Z(e) {
  const { action_link: t, email_otp: n, hashed_token: r, redirect_to: o, verification_type: i } = e, a = MZ(e, ["action_link", "email_otp", "hashed_token", "redirect_to", "verification_type"]), l = {
    action_link: t,
    email_otp: n,
    hashed_token: r,
    redirect_to: o,
    verification_type: i
  }, c = Object.assign({}, a);
  return {
    data: {
      properties: l,
      user: c
    },
    error: null
  };
}
function LZ(e) {
  return e;
}
function jZ(e) {
  return e.access_token && e.refresh_token && e.expires_in;
}
var BZ = function(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
class VZ {
  constructor({ url: t = "", headers: n = {}, fetch: r }) {
    this.url = t, this.headers = n, this.fetch = DA(r), this.mfa = {
      listFactors: this._listFactors.bind(this),
      deleteFactor: this._deleteFactor.bind(this)
    };
  }
  /**
   * Removes a logged-in session.
   * @param jwt A valid, logged-in JWT.
   * @param scope The logout sope.
   */
  async signOut(t, n = "global") {
    try {
      return await un(this.fetch, "POST", `${this.url}/logout?scope=${n}`, {
        headers: this.headers,
        jwt: t,
        noResolveJson: !0
      }), { data: null, error: null };
    } catch (r) {
      if (Xt(r))
        return { data: null, error: r };
      throw r;
    }
  }
  /**
   * Sends an invite link to an email address.
   * @param email The email address of the user.
   * @param options Additional options to be included when inviting.
   */
  async inviteUserByEmail(t, n = {}) {
    try {
      return await un(this.fetch, "POST", `${this.url}/invite`, {
        body: { email: t, data: n.data },
        headers: this.headers,
        redirectTo: n.redirectTo,
        xform: Xa
      });
    } catch (r) {
      if (Xt(r))
        return { data: { user: null }, error: r };
      throw r;
    }
  }
  /**
   * Generates email links and OTPs to be sent via a custom email provider.
   * @param email The user's email.
   * @param options.password User password. For signup only.
   * @param options.data Optional user metadata. For signup only.
   * @param options.redirectTo The redirect url which should be appended to the generated link
   */
  async generateLink(t) {
    try {
      const { options: n } = t, r = BZ(t, ["options"]), o = Object.assign(Object.assign({}, r), n);
      return "newEmail" in r && (o.new_email = r == null ? void 0 : r.newEmail, delete o.newEmail), await un(this.fetch, "POST", `${this.url}/admin/generate_link`, {
        body: o,
        headers: this.headers,
        xform: $Z,
        redirectTo: n == null ? void 0 : n.redirectTo
      });
    } catch (n) {
      if (Xt(n))
        return {
          data: {
            properties: null,
            user: null
          },
          error: n
        };
      throw n;
    }
  }
  // User Admin API
  /**
   * Creates a new user.
   * This function should only be called on a server. Never expose your `service_role` key in the browser.
   */
  async createUser(t) {
    try {
      return await un(this.fetch, "POST", `${this.url}/admin/users`, {
        body: t,
        headers: this.headers,
        xform: Xa
      });
    } catch (n) {
      if (Xt(n))
        return { data: { user: null }, error: n };
      throw n;
    }
  }
  /**
   * Get a list of users.
   *
   * This function should only be called on a server. Never expose your `service_role` key in the browser.
   * @param params An object which supports `page` and `perPage` as numbers, to alter the paginated results.
   */
  async listUsers(t) {
    var n, r, o, i, a, l, c;
    try {
      const d = { nextPage: null, lastPage: 0, total: 0 }, f = await un(this.fetch, "GET", `${this.url}/admin/users`, {
        headers: this.headers,
        noResolveJson: !0,
        query: {
          page: (r = (n = t == null ? void 0 : t.page) === null || n === void 0 ? void 0 : n.toString()) !== null && r !== void 0 ? r : "",
          per_page: (i = (o = t == null ? void 0 : t.perPage) === null || o === void 0 ? void 0 : o.toString()) !== null && i !== void 0 ? i : ""
        },
        xform: LZ
      });
      if (f.error)
        throw f.error;
      const p = await f.json(), g = (a = f.headers.get("x-total-count")) !== null && a !== void 0 ? a : 0, b = (c = (l = f.headers.get("link")) === null || l === void 0 ? void 0 : l.split(",")) !== null && c !== void 0 ? c : [];
      return b.length > 0 && (b.forEach((v) => {
        const y = parseInt(v.split(";")[0].split("=")[1].substring(0, 1)), S = JSON.parse(v.split(";")[1].split("=")[1]);
        d[`${S}Page`] = y;
      }), d.total = parseInt(g)), { data: Object.assign(Object.assign({}, p), d), error: null };
    } catch (d) {
      if (Xt(d))
        return { data: { users: [] }, error: d };
      throw d;
    }
  }
  /**
   * Get user by id.
   *
   * @param uid The user's unique identifier
   *
   * This function should only be called on a server. Never expose your `service_role` key in the browser.
   */
  async getUserById(t) {
    try {
      return await un(this.fetch, "GET", `${this.url}/admin/users/${t}`, {
        headers: this.headers,
        xform: Xa
      });
    } catch (n) {
      if (Xt(n))
        return { data: { user: null }, error: n };
      throw n;
    }
  }
  /**
   * Updates the user data.
   *
   * @param attributes The data you want to update.
   *
   * This function should only be called on a server. Never expose your `service_role` key in the browser.
   */
  async updateUserById(t, n) {
    try {
      return await un(this.fetch, "PUT", `${this.url}/admin/users/${t}`, {
        body: n,
        headers: this.headers,
        xform: Xa
      });
    } catch (r) {
      if (Xt(r))
        return { data: { user: null }, error: r };
      throw r;
    }
  }
  /**
   * Delete a user. Requires a `service_role` key.
   *
   * @param id The user id you want to remove.
   * @param shouldSoftDelete If true, then the user will be soft-deleted from the auth schema. Soft deletion allows user identification from the hashed user ID but is not reversible.
   * Defaults to false for backward compatibility.
   *
   * This function should only be called on a server. Never expose your `service_role` key in the browser.
   */
  async deleteUser(t, n = !1) {
    try {
      return await un(this.fetch, "DELETE", `${this.url}/admin/users/${t}`, {
        headers: this.headers,
        body: {
          should_soft_delete: n
        },
        xform: Xa
      });
    } catch (r) {
      if (Xt(r))
        return { data: { user: null }, error: r };
      throw r;
    }
  }
  async _listFactors(t) {
    try {
      const { data: n, error: r } = await un(this.fetch, "GET", `${this.url}/admin/users/${t.userId}/factors`, {
        headers: this.headers,
        xform: (o) => ({ data: { factors: o }, error: null })
      });
      return { data: n, error: r };
    } catch (n) {
      if (Xt(n))
        return { data: null, error: n };
      throw n;
    }
  }
  async _deleteFactor(t) {
    try {
      return { data: await un(this.fetch, "DELETE", `${this.url}/admin/users/${t.userId}/factors/${t.id}`, {
        headers: this.headers
      }), error: null };
    } catch (n) {
      if (Xt(n))
        return { data: null, error: n };
      throw n;
    }
  }
}
const HZ = {
  getItem: (e) => Gf() ? globalThis.localStorage.getItem(e) : null,
  setItem: (e, t) => {
    Gf() && globalThis.localStorage.setItem(e, t);
  },
  removeItem: (e) => {
    Gf() && globalThis.localStorage.removeItem(e);
  }
};
function qP(e = {}) {
  return {
    getItem: (t) => e[t] || null,
    setItem: (t, n) => {
      e[t] = n;
    },
    removeItem: (t) => {
      delete e[t];
    }
  };
}
function UZ() {
  if (typeof globalThis != "object")
    try {
      Object.defineProperty(Object.prototype, "__magic__", {
        get: function() {
          return this;
        },
        configurable: !0
      }), __magic__.globalThis = __magic__, delete Object.prototype.__magic__;
    } catch {
      typeof self < "u" && (self.globalThis = self);
    }
}
const fu = {
  /**
   * @experimental
   */
  debug: !!(globalThis && Gf() && globalThis.localStorage && globalThis.localStorage.getItem("supabase.gotrue-js.locks.debug") === "true")
};
class jA extends Error {
  constructor(t) {
    super(t), this.isAcquireTimeout = !0;
  }
}
class zZ extends jA {
}
async function GZ(e, t, n) {
  fu.debug && console.log("@supabase/gotrue-js: navigatorLock: acquire lock", e, t);
  const r = new globalThis.AbortController();
  return t > 0 && setTimeout(() => {
    r.abort(), fu.debug && console.log("@supabase/gotrue-js: navigatorLock acquire timed out", e);
  }, t), await globalThis.navigator.locks.request(e, t === 0 ? {
    mode: "exclusive",
    ifAvailable: !0
  } : {
    mode: "exclusive",
    signal: r.signal
  }, async (o) => {
    if (o) {
      fu.debug && console.log("@supabase/gotrue-js: navigatorLock: acquired", e, o.name);
      try {
        return await n();
      } finally {
        fu.debug && console.log("@supabase/gotrue-js: navigatorLock: released", e, o.name);
      }
    } else {
      if (t === 0)
        throw fu.debug && console.log("@supabase/gotrue-js: navigatorLock: not immediately available", e), new zZ(`Acquiring an exclusive Navigator LockManager lock "${e}" immediately failed`);
      if (fu.debug)
        try {
          const i = await globalThis.navigator.locks.query();
          console.log("@supabase/gotrue-js: Navigator LockManager state", JSON.stringify(i, null, "  "));
        } catch (i) {
          console.warn("@supabase/gotrue-js: Error when querying Navigator LockManager state", i);
        }
      return console.warn("@supabase/gotrue-js: Navigator LockManager returned a null lock when using #request without ifAvailable set to true, it appears this browser is not following the LockManager spec https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request"), await n();
    }
  });
}
UZ();
const WZ = {
  url: fZ,
  storageKey: pZ,
  autoRefreshToken: !0,
  persistSession: !0,
  detectSessionInUrl: !0,
  headers: hZ,
  flowType: "implicit",
  debug: !1,
  hasCustomAuthorizationHeader: !1
}, gf = 30 * 1e3, KP = 3;
async function YP(e, t, n) {
  return await n();
}
class gp {
  /**
   * Create a new client for use in the browser.
   */
  constructor(t) {
    var n, r;
    this.memoryStorage = null, this.stateChangeEmitters = /* @__PURE__ */ new Map(), this.autoRefreshTicker = null, this.visibilityChangedCallback = null, this.refreshingDeferred = null, this.initializePromise = null, this.detectSessionInUrl = !0, this.hasCustomAuthorizationHeader = !1, this.suppressGetSessionWarning = !1, this.lockAcquired = !1, this.pendingInLock = [], this.broadcastChannel = null, this.logger = console.log, this.instanceID = gp.nextInstanceID, gp.nextInstanceID += 1, this.instanceID > 0 && qi() && console.warn("Multiple GoTrueClient instances detected in the same browser context. It is not an error, but this should be avoided as it may produce undefined behavior when used concurrently under the same storage key.");
    const o = Object.assign(Object.assign({}, WZ), t);
    if (this.logDebugMessages = !!o.debug, typeof o.debug == "function" && (this.logger = o.debug), this.persistSession = o.persistSession, this.storageKey = o.storageKey, this.autoRefreshToken = o.autoRefreshToken, this.admin = new VZ({
      url: o.url,
      headers: o.headers,
      fetch: o.fetch
    }), this.url = o.url, this.headers = o.headers, this.fetch = DA(o.fetch), this.lock = o.lock || YP, this.detectSessionInUrl = o.detectSessionInUrl, this.flowType = o.flowType, this.hasCustomAuthorizationHeader = o.hasCustomAuthorizationHeader, o.lock ? this.lock = o.lock : qi() && (!((n = globalThis == null ? void 0 : globalThis.navigator) === null || n === void 0) && n.locks) ? this.lock = GZ : this.lock = YP, this.mfa = {
      verify: this._verify.bind(this),
      enroll: this._enroll.bind(this),
      unenroll: this._unenroll.bind(this),
      challenge: this._challenge.bind(this),
      listFactors: this._listFactors.bind(this),
      challengeAndVerify: this._challengeAndVerify.bind(this),
      getAuthenticatorAssuranceLevel: this._getAuthenticatorAssuranceLevel.bind(this)
    }, this.persistSession ? o.storage ? this.storage = o.storage : Gf() ? this.storage = HZ : (this.memoryStorage = {}, this.storage = qP(this.memoryStorage)) : (this.memoryStorage = {}, this.storage = qP(this.memoryStorage)), qi() && globalThis.BroadcastChannel && this.persistSession && this.storageKey) {
      try {
        this.broadcastChannel = new globalThis.BroadcastChannel(this.storageKey);
      } catch (i) {
        console.error("Failed to create a new BroadcastChannel, multi-tab state changes will not be available", i);
      }
      (r = this.broadcastChannel) === null || r === void 0 || r.addEventListener("message", async (i) => {
        this._debug("received broadcast notification from other tab or client", i), await this._notifyAllSubscribers(i.data.event, i.data.session, !1);
      });
    }
    this.initialize();
  }
  _debug(...t) {
    return this.logDebugMessages && this.logger(`GoTrueClient@${this.instanceID} (${MA}) ${(/* @__PURE__ */ new Date()).toISOString()}`, ...t), this;
  }
  /**
   * Initializes the client session either from the url or from storage.
   * This method is automatically called when instantiating the client, but should also be called
   * manually when checking for an error from an auth redirect (oauth, magiclink, password recovery, etc).
   */
  async initialize() {
    return this.initializePromise ? await this.initializePromise : (this.initializePromise = (async () => await this._acquireLock(-1, async () => await this._initialize()))(), await this.initializePromise);
  }
  /**
   * IMPORTANT:
   * 1. Never throw in this method, as it is called from the constructor
   * 2. Never return a session from this method as it would be cached over
   *    the whole lifetime of the client
   */
  async _initialize() {
    var t;
    try {
      const n = qi() ? await this._isPKCEFlow() : !1;
      if (this._debug("#_initialize()", "begin", "is PKCE flow", n), n || this.detectSessionInUrl && this._isImplicitGrantFlow()) {
        const { data: r, error: o } = await this._getSessionFromURL(n);
        if (o) {
          if (this._debug("#_initialize()", "error detecting session from URL", o), kZ(o)) {
            const l = (t = o.details) === null || t === void 0 ? void 0 : t.code;
            if (l === "identity_already_exists" || l === "identity_not_found" || l === "single_identity_not_deletable")
              return { error: o };
          }
          return await this._removeSession(), { error: o };
        }
        const { session: i, redirectType: a } = r;
        return this._debug("#_initialize()", "detected session in URL", i, "redirect type", a), await this._saveSession(i), setTimeout(async () => {
          a === "recovery" ? await this._notifyAllSubscribers("PASSWORD_RECOVERY", i) : await this._notifyAllSubscribers("SIGNED_IN", i);
        }, 0), { error: null };
      }
      return await this._recoverAndRefresh(), { error: null };
    } catch (n) {
      return Xt(n) ? { error: n } : {
        error: new LA("Unexpected error during initialization", n)
      };
    } finally {
      await this._handleVisibilityChange(), this._debug("#_initialize()", "end");
    }
  }
  /**
   * Creates a new anonymous user.
   *
   * @returns A session where the is_anonymous claim in the access token JWT set to true
   */
  async signInAnonymously(t) {
    var n, r, o;
    try {
      const i = await un(this.fetch, "POST", `${this.url}/signup`, {
        headers: this.headers,
        body: {
          data: (r = (n = t == null ? void 0 : t.options) === null || n === void 0 ? void 0 : n.data) !== null && r !== void 0 ? r : {},
          gotrue_meta_security: { captcha_token: (o = t == null ? void 0 : t.options) === null || o === void 0 ? void 0 : o.captchaToken }
        },
        xform: Ua
      }), { data: a, error: l } = i;
      if (l || !a)
        return { data: { user: null, session: null }, error: l };
      const c = a.session, d = a.user;
      return a.session && (await this._saveSession(a.session), await this._notifyAllSubscribers("SIGNED_IN", c)), { data: { user: d, session: c }, error: null };
    } catch (i) {
      if (Xt(i))
        return { data: { user: null, session: null }, error: i };
      throw i;
    }
  }
  /**
   * Creates a new user.
   *
   * Be aware that if a user account exists in the system you may get back an
   * error message that attempts to hide this information from the user.
   * This method has support for PKCE via email signups. The PKCE flow cannot be used when autoconfirm is enabled.
   *
   * @returns A logged-in session if the server has "autoconfirm" ON
   * @returns A user if the server has "autoconfirm" OFF
   */
  async signUp(t) {
    var n, r, o;
    try {
      let i;
      if ("email" in t) {
        const { email: f, password: p, options: g } = t;
        let b = null, v = null;
        this.flowType === "pkce" && ([b, v] = await du(this.storage, this.storageKey)), i = await un(this.fetch, "POST", `${this.url}/signup`, {
          headers: this.headers,
          redirectTo: g == null ? void 0 : g.emailRedirectTo,
          body: {
            email: f,
            password: p,
            data: (n = g == null ? void 0 : g.data) !== null && n !== void 0 ? n : {},
            gotrue_meta_security: { captcha_token: g == null ? void 0 : g.captchaToken },
            code_challenge: b,
            code_challenge_method: v
          },
          xform: Ua
        });
      } else if ("phone" in t) {
        const { phone: f, password: p, options: g } = t;
        i = await un(this.fetch, "POST", `${this.url}/signup`, {
          headers: this.headers,
          body: {
            phone: f,
            password: p,
            data: (r = g == null ? void 0 : g.data) !== null && r !== void 0 ? r : {},
            channel: (o = g == null ? void 0 : g.channel) !== null && o !== void 0 ? o : "sms",
            gotrue_meta_security: { captcha_token: g == null ? void 0 : g.captchaToken }
          },
          xform: Ua
        });
      } else
        throw new wg("You must provide either an email or phone number and a password");
      const { data: a, error: l } = i;
      if (l || !a)
        return { data: { user: null, session: null }, error: l };
      const c = a.session, d = a.user;
      return a.session && (await this._saveSession(a.session), await this._notifyAllSubscribers("SIGNED_IN", c)), { data: { user: d, session: c }, error: null };
    } catch (i) {
      if (Xt(i))
        return { data: { user: null, session: null }, error: i };
      throw i;
    }
  }
  /**
   * Log in an existing user with an email and password or phone and password.
   *
   * Be aware that you may get back an error message that will not distinguish
   * between the cases where the account does not exist or that the
   * email/phone and password combination is wrong or that the account can only
   * be accessed via social login.
   */
  async signInWithPassword(t) {
    try {
      let n;
      if ("email" in t) {
        const { email: i, password: a, options: l } = t;
        n = await un(this.fetch, "POST", `${this.url}/token?grant_type=password`, {
          headers: this.headers,
          body: {
            email: i,
            password: a,
            gotrue_meta_security: { captcha_token: l == null ? void 0 : l.captchaToken }
          },
          xform: WP
        });
      } else if ("phone" in t) {
        const { phone: i, password: a, options: l } = t;
        n = await un(this.fetch, "POST", `${this.url}/token?grant_type=password`, {
          headers: this.headers,
          body: {
            phone: i,
            password: a,
            gotrue_meta_security: { captcha_token: l == null ? void 0 : l.captchaToken }
          },
          xform: WP
        });
      } else
        throw new wg("You must provide either an email or phone number and a password");
      const { data: r, error: o } = n;
      return o ? { data: { user: null, session: null }, error: o } : !r || !r.session || !r.user ? { data: { user: null, session: null }, error: new uw() } : (r.session && (await this._saveSession(r.session), await this._notifyAllSubscribers("SIGNED_IN", r.session)), {
        data: Object.assign({ user: r.user, session: r.session }, r.weak_password ? { weakPassword: r.weak_password } : null),
        error: o
      });
    } catch (n) {
      if (Xt(n))
        return { data: { user: null, session: null }, error: n };
      throw n;
    }
  }
  /**
   * Log in an existing user via a third-party provider.
   * This method supports the PKCE flow.
   */
  async signInWithOAuth(t) {
    var n, r, o, i;
    return await this._handleProviderSignIn(t.provider, {
      redirectTo: (n = t.options) === null || n === void 0 ? void 0 : n.redirectTo,
      scopes: (r = t.options) === null || r === void 0 ? void 0 : r.scopes,
      queryParams: (o = t.options) === null || o === void 0 ? void 0 : o.queryParams,
      skipBrowserRedirect: (i = t.options) === null || i === void 0 ? void 0 : i.skipBrowserRedirect
    });
  }
  /**
   * Log in an existing user by exchanging an Auth Code issued during the PKCE flow.
   */
  async exchangeCodeForSession(t) {
    return await this.initializePromise, this._acquireLock(-1, async () => this._exchangeCodeForSession(t));
  }
  async _exchangeCodeForSession(t) {
    const n = await yg(this.storage, `${this.storageKey}-code-verifier`), [r, o] = (n ?? "").split("/");
    try {
      const { data: i, error: a } = await un(this.fetch, "POST", `${this.url}/token?grant_type=pkce`, {
        headers: this.headers,
        body: {
          auth_code: t,
          code_verifier: r
        },
        xform: Ua
      });
      if (await vg(this.storage, `${this.storageKey}-code-verifier`), a)
        throw a;
      return !i || !i.session || !i.user ? {
        data: { user: null, session: null, redirectType: null },
        error: new uw()
      } : (i.session && (await this._saveSession(i.session), await this._notifyAllSubscribers("SIGNED_IN", i.session)), { data: Object.assign(Object.assign({}, i), { redirectType: o ?? null }), error: a });
    } catch (i) {
      if (Xt(i))
        return { data: { user: null, session: null, redirectType: null }, error: i };
      throw i;
    }
  }
  /**
   * Allows signing in with an OIDC ID token. The authentication provider used
   * should be enabled and configured.
   */
  async signInWithIdToken(t) {
    try {
      const { options: n, provider: r, token: o, access_token: i, nonce: a } = t, l = await un(this.fetch, "POST", `${this.url}/token?grant_type=id_token`, {
        headers: this.headers,
        body: {
          provider: r,
          id_token: o,
          access_token: i,
          nonce: a,
          gotrue_meta_security: { captcha_token: n == null ? void 0 : n.captchaToken }
        },
        xform: Ua
      }), { data: c, error: d } = l;
      return d ? { data: { user: null, session: null }, error: d } : !c || !c.session || !c.user ? {
        data: { user: null, session: null },
        error: new uw()
      } : (c.session && (await this._saveSession(c.session), await this._notifyAllSubscribers("SIGNED_IN", c.session)), { data: c, error: d });
    } catch (n) {
      if (Xt(n))
        return { data: { user: null, session: null }, error: n };
      throw n;
    }
  }
  /**
   * Log in a user using magiclink or a one-time password (OTP).
   *
   * If the `{{ .ConfirmationURL }}` variable is specified in the email template, a magiclink will be sent.
   * If the `{{ .Token }}` variable is specified in the email template, an OTP will be sent.
   * If you're using phone sign-ins, only an OTP will be sent. You won't be able to send a magiclink for phone sign-ins.
   *
   * Be aware that you may get back an error message that will not distinguish
   * between the cases where the account does not exist or, that the account
   * can only be accessed via social login.
   *
   * Do note that you will need to configure a Whatsapp sender on Twilio
   * if you are using phone sign in with the 'whatsapp' channel. The whatsapp
   * channel is not supported on other providers
   * at this time.
   * This method supports PKCE when an email is passed.
   */
  async signInWithOtp(t) {
    var n, r, o, i, a;
    try {
      if ("email" in t) {
        const { email: l, options: c } = t;
        let d = null, f = null;
        this.flowType === "pkce" && ([d, f] = await du(this.storage, this.storageKey));
        const { error: p } = await un(this.fetch, "POST", `${this.url}/otp`, {
          headers: this.headers,
          body: {
            email: l,
            data: (n = c == null ? void 0 : c.data) !== null && n !== void 0 ? n : {},
            create_user: (r = c == null ? void 0 : c.shouldCreateUser) !== null && r !== void 0 ? r : !0,
            gotrue_meta_security: { captcha_token: c == null ? void 0 : c.captchaToken },
            code_challenge: d,
            code_challenge_method: f
          },
          redirectTo: c == null ? void 0 : c.emailRedirectTo
        });
        return { data: { user: null, session: null }, error: p };
      }
      if ("phone" in t) {
        const { phone: l, options: c } = t, { data: d, error: f } = await un(this.fetch, "POST", `${this.url}/otp`, {
          headers: this.headers,
          body: {
            phone: l,
            data: (o = c == null ? void 0 : c.data) !== null && o !== void 0 ? o : {},
            create_user: (i = c == null ? void 0 : c.shouldCreateUser) !== null && i !== void 0 ? i : !0,
            gotrue_meta_security: { captcha_token: c == null ? void 0 : c.captchaToken },
            channel: (a = c == null ? void 0 : c.channel) !== null && a !== void 0 ? a : "sms"
          }
        });
        return { data: { user: null, session: null, messageId: d == null ? void 0 : d.message_id }, error: f };
      }
      throw new wg("You must provide either an email or phone number.");
    } catch (l) {
      if (Xt(l))
        return { data: { user: null, session: null }, error: l };
      throw l;
    }
  }
  /**
   * Log in a user given a User supplied OTP or TokenHash received through mobile or email.
   */
  async verifyOtp(t) {
    var n, r;
    try {
      let o, i;
      "options" in t && (o = (n = t.options) === null || n === void 0 ? void 0 : n.redirectTo, i = (r = t.options) === null || r === void 0 ? void 0 : r.captchaToken);
      const { data: a, error: l } = await un(this.fetch, "POST", `${this.url}/verify`, {
        headers: this.headers,
        body: Object.assign(Object.assign({}, t), { gotrue_meta_security: { captcha_token: i } }),
        redirectTo: o,
        xform: Ua
      });
      if (l)
        throw l;
      if (!a)
        throw new Error("An error occurred on token verification.");
      const c = a.session, d = a.user;
      return c != null && c.access_token && (await this._saveSession(c), await this._notifyAllSubscribers(t.type == "recovery" ? "PASSWORD_RECOVERY" : "SIGNED_IN", c)), { data: { user: d, session: c }, error: null };
    } catch (o) {
      if (Xt(o))
        return { data: { user: null, session: null }, error: o };
      throw o;
    }
  }
  /**
   * Attempts a single-sign on using an enterprise Identity Provider. A
   * successful SSO attempt will redirect the current page to the identity
   * provider authorization page. The redirect URL is implementation and SSO
   * protocol specific.
   *
   * You can use it by providing a SSO domain. Typically you can extract this
   * domain by asking users for their email address. If this domain is
   * registered on the Auth instance the redirect will use that organization's
   * currently active SSO Identity Provider for the login.
   *
   * If you have built an organization-specific login page, you can use the
   * organization's SSO Identity Provider UUID directly instead.
   */
  async signInWithSSO(t) {
    var n, r, o;
    try {
      let i = null, a = null;
      return this.flowType === "pkce" && ([i, a] = await du(this.storage, this.storageKey)), await un(this.fetch, "POST", `${this.url}/sso`, {
        body: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, "providerId" in t ? { provider_id: t.providerId } : null), "domain" in t ? { domain: t.domain } : null), { redirect_to: (r = (n = t.options) === null || n === void 0 ? void 0 : n.redirectTo) !== null && r !== void 0 ? r : void 0 }), !((o = t == null ? void 0 : t.options) === null || o === void 0) && o.captchaToken ? { gotrue_meta_security: { captcha_token: t.options.captchaToken } } : null), { skip_http_redirect: !0, code_challenge: i, code_challenge_method: a }),
        headers: this.headers,
        xform: FZ
      });
    } catch (i) {
      if (Xt(i))
        return { data: null, error: i };
      throw i;
    }
  }
  /**
   * Sends a reauthentication OTP to the user's email or phone number.
   * Requires the user to be signed-in.
   */
  async reauthenticate() {
    return await this.initializePromise, await this._acquireLock(-1, async () => await this._reauthenticate());
  }
  async _reauthenticate() {
    try {
      return await this._useSession(async (t) => {
        const { data: { session: n }, error: r } = t;
        if (r)
          throw r;
        if (!n)
          throw new Ha();
        const { error: o } = await un(this.fetch, "GET", `${this.url}/reauthenticate`, {
          headers: this.headers,
          jwt: n.access_token
        });
        return { data: { user: null, session: null }, error: o };
      });
    } catch (t) {
      if (Xt(t))
        return { data: { user: null, session: null }, error: t };
      throw t;
    }
  }
  /**
   * Resends an existing signup confirmation email, email change email, SMS OTP or phone change OTP.
   */
  async resend(t) {
    try {
      const n = `${this.url}/resend`;
      if ("email" in t) {
        const { email: r, type: o, options: i } = t, { error: a } = await un(this.fetch, "POST", n, {
          headers: this.headers,
          body: {
            email: r,
            type: o,
            gotrue_meta_security: { captcha_token: i == null ? void 0 : i.captchaToken }
          },
          redirectTo: i == null ? void 0 : i.emailRedirectTo
        });
        return { data: { user: null, session: null }, error: a };
      } else if ("phone" in t) {
        const { phone: r, type: o, options: i } = t, { data: a, error: l } = await un(this.fetch, "POST", n, {
          headers: this.headers,
          body: {
            phone: r,
            type: o,
            gotrue_meta_security: { captcha_token: i == null ? void 0 : i.captchaToken }
          }
        });
        return { data: { user: null, session: null, messageId: a == null ? void 0 : a.message_id }, error: l };
      }
      throw new wg("You must provide either an email or phone number and a type");
    } catch (n) {
      if (Xt(n))
        return { data: { user: null, session: null }, error: n };
      throw n;
    }
  }
  /**
   * Returns the session, refreshing it if necessary.
   *
   * The session returned can be null if the session is not detected which can happen in the event a user is not signed-in or has logged out.
   *
   * **IMPORTANT:** This method loads values directly from the storage attached
   * to the client. If that storage is based on request cookies for example,
   * the values in it may not be authentic and therefore it's strongly advised
   * against using this method and its results in such circumstances. A warning
   * will be emitted if this is detected. Use {@link #getUser()} instead.
   */
  async getSession() {
    return await this.initializePromise, await this._acquireLock(-1, async () => this._useSession(async (n) => n));
  }
  /**
   * Acquires a global lock based on the storage key.
   */
  async _acquireLock(t, n) {
    this._debug("#_acquireLock", "begin", t);
    try {
      if (this.lockAcquired) {
        const r = this.pendingInLock.length ? this.pendingInLock[this.pendingInLock.length - 1] : Promise.resolve(), o = (async () => (await r, await n()))();
        return this.pendingInLock.push((async () => {
          try {
            await o;
          } catch {
          }
        })()), o;
      }
      return await this.lock(`lock:${this.storageKey}`, t, async () => {
        this._debug("#_acquireLock", "lock acquired for storage key", this.storageKey);
        try {
          this.lockAcquired = !0;
          const r = n();
          for (this.pendingInLock.push((async () => {
            try {
              await r;
            } catch {
            }
          })()), await r; this.pendingInLock.length; ) {
            const o = [...this.pendingInLock];
            await Promise.all(o), this.pendingInLock.splice(0, o.length);
          }
          return await r;
        } finally {
          this._debug("#_acquireLock", "lock released for storage key", this.storageKey), this.lockAcquired = !1;
        }
      });
    } finally {
      this._debug("#_acquireLock", "end");
    }
  }
  /**
   * Use instead of {@link #getSession} inside the library. It is
   * semantically usually what you want, as getting a session involves some
   * processing afterwards that requires only one client operating on the
   * session at once across multiple tabs or processes.
   */
  async _useSession(t) {
    this._debug("#_useSession", "begin");
    try {
      const n = await this.__loadSession();
      return await t(n);
    } finally {
      this._debug("#_useSession", "end");
    }
  }
  /**
   * NEVER USE DIRECTLY!
   *
   * Always use {@link #_useSession}.
   */
  async __loadSession() {
    this._debug("#__loadSession()", "begin"), this.lockAcquired || this._debug("#__loadSession()", "used outside of an acquired lock!", new Error().stack);
    try {
      let t = null;
      const n = await yg(this.storage, this.storageKey);
      if (this._debug("#getSession()", "session from storage", n), n !== null && (this._isValidSession(n) ? t = n : (this._debug("#getSession()", "session from storage is not valid"), await this._removeSession())), !t)
        return { data: { session: null }, error: null };
      const r = t.expires_at ? t.expires_at <= Date.now() / 1e3 : !1;
      if (this._debug("#__loadSession()", `session has${r ? "" : " not"} expired`, "expires_at", t.expires_at), !r) {
        if (this.storage.isServer) {
          let a = this.suppressGetSessionWarning;
          t = new Proxy(t, {
            get: (c, d, f) => (!a && d === "user" && (console.warn("Using the user object as returned from supabase.auth.getSession() or from some supabase.auth.onAuthStateChange() events could be insecure! This value comes directly from the storage medium (usually cookies on the server) and may not be authentic. Use supabase.auth.getUser() instead which authenticates the data by contacting the Supabase Auth server."), a = !0, this.suppressGetSessionWarning = !0), Reflect.get(c, d, f))
          });
        }
        return { data: { session: t }, error: null };
      }
      const { session: o, error: i } = await this._callRefreshToken(t.refresh_token);
      return i ? { data: { session: null }, error: i } : { data: { session: o }, error: null };
    } finally {
      this._debug("#__loadSession()", "end");
    }
  }
  /**
   * Gets the current user details if there is an existing session. This method
   * performs a network request to the Supabase Auth server, so the returned
   * value is authentic and can be used to base authorization rules on.
   *
   * @param jwt Takes in an optional access token JWT. If no JWT is provided, the JWT from the current session is used.
   */
  async getUser(t) {
    return t ? await this._getUser(t) : (await this.initializePromise, await this._acquireLock(-1, async () => await this._getUser()));
  }
  async _getUser(t) {
    try {
      return t ? await un(this.fetch, "GET", `${this.url}/user`, {
        headers: this.headers,
        jwt: t,
        xform: Xa
      }) : await this._useSession(async (n) => {
        var r, o, i;
        const { data: a, error: l } = n;
        if (l)
          throw l;
        return !(!((r = a.session) === null || r === void 0) && r.access_token) && !this.hasCustomAuthorizationHeader ? { data: { user: null }, error: new Ha() } : await un(this.fetch, "GET", `${this.url}/user`, {
          headers: this.headers,
          jwt: (i = (o = a.session) === null || o === void 0 ? void 0 : o.access_token) !== null && i !== void 0 ? i : void 0,
          xform: Xa
        });
      });
    } catch (n) {
      if (Xt(n))
        return _Z(n) && (await this._removeSession(), await vg(this.storage, `${this.storageKey}-code-verifier`)), { data: { user: null }, error: n };
      throw n;
    }
  }
  /**
   * Updates user data for a logged in user.
   */
  async updateUser(t, n = {}) {
    return await this.initializePromise, await this._acquireLock(-1, async () => await this._updateUser(t, n));
  }
  async _updateUser(t, n = {}) {
    try {
      return await this._useSession(async (r) => {
        const { data: o, error: i } = r;
        if (i)
          throw i;
        if (!o.session)
          throw new Ha();
        const a = o.session;
        let l = null, c = null;
        this.flowType === "pkce" && t.email != null && ([l, c] = await du(this.storage, this.storageKey));
        const { data: d, error: f } = await un(this.fetch, "PUT", `${this.url}/user`, {
          headers: this.headers,
          redirectTo: n == null ? void 0 : n.emailRedirectTo,
          body: Object.assign(Object.assign({}, t), { code_challenge: l, code_challenge_method: c }),
          jwt: a.access_token,
          xform: Xa
        });
        if (f)
          throw f;
        return a.user = d.user, await this._saveSession(a), await this._notifyAllSubscribers("USER_UPDATED", a), { data: { user: a.user }, error: null };
      });
    } catch (r) {
      if (Xt(r))
        return { data: { user: null }, error: r };
      throw r;
    }
  }
  /**
   * Decodes a JWT (without performing any validation).
   */
  _decodeJWT(t) {
    return HP(t);
  }
  /**
   * Sets the session data from the current session. If the current session is expired, setSession will take care of refreshing it to obtain a new session.
   * If the refresh token or access token in the current session is invalid, an error will be thrown.
   * @param currentSession The current session that minimally contains an access token and refresh token.
   */
  async setSession(t) {
    return await this.initializePromise, await this._acquireLock(-1, async () => await this._setSession(t));
  }
  async _setSession(t) {
    try {
      if (!t.access_token || !t.refresh_token)
        throw new Ha();
      const n = Date.now() / 1e3;
      let r = n, o = !0, i = null;
      const a = HP(t.access_token);
      if (a.exp && (r = a.exp, o = r <= n), o) {
        const { session: l, error: c } = await this._callRefreshToken(t.refresh_token);
        if (c)
          return { data: { user: null, session: null }, error: c };
        if (!l)
          return { data: { user: null, session: null }, error: null };
        i = l;
      } else {
        const { data: l, error: c } = await this._getUser(t.access_token);
        if (c)
          throw c;
        i = {
          access_token: t.access_token,
          refresh_token: t.refresh_token,
          user: l.user,
          token_type: "bearer",
          expires_in: r - n,
          expires_at: r
        }, await this._saveSession(i), await this._notifyAllSubscribers("SIGNED_IN", i);
      }
      return { data: { user: i.user, session: i }, error: null };
    } catch (n) {
      if (Xt(n))
        return { data: { session: null, user: null }, error: n };
      throw n;
    }
  }
  /**
   * Returns a new session, regardless of expiry status.
   * Takes in an optional current session. If not passed in, then refreshSession() will attempt to retrieve it from getSession().
   * If the current session's refresh token is invalid, an error will be thrown.
   * @param currentSession The current session. If passed in, it must contain a refresh token.
   */
  async refreshSession(t) {
    return await this.initializePromise, await this._acquireLock(-1, async () => await this._refreshSession(t));
  }
  async _refreshSession(t) {
    try {
      return await this._useSession(async (n) => {
        var r;
        if (!t) {
          const { data: a, error: l } = n;
          if (l)
            throw l;
          t = (r = a.session) !== null && r !== void 0 ? r : void 0;
        }
        if (!(t != null && t.refresh_token))
          throw new Ha();
        const { session: o, error: i } = await this._callRefreshToken(t.refresh_token);
        return i ? { data: { user: null, session: null }, error: i } : o ? { data: { user: o.user, session: o }, error: null } : { data: { user: null, session: null }, error: null };
      });
    } catch (n) {
      if (Xt(n))
        return { data: { user: null, session: null }, error: n };
      throw n;
    }
  }
  /**
   * Gets the session data from a URL string
   */
  async _getSessionFromURL(t) {
    try {
      if (!qi())
        throw new Cg("No browser detected.");
      if (this.flowType === "implicit" && !this._isImplicitGrantFlow())
        throw new Cg("Not a valid implicit grant flow url.");
      if (this.flowType == "pkce" && !t)
        throw new UP("Not a valid PKCE flow url.");
      const n = cw(window.location.href);
      if (t) {
        if (!n.code)
          throw new UP("No code detected.");
        const { data: I, error: O } = await this._exchangeCodeForSession(n.code);
        if (O)
          throw O;
        const T = new URL(window.location.href);
        return T.searchParams.delete("code"), window.history.replaceState(window.history.state, "", T.toString()), { data: { session: I.session, redirectType: null }, error: null };
      }
      if (n.error || n.error_description || n.error_code)
        throw new Cg(n.error_description || "Error in URL with unspecified error_description", {
          error: n.error || "unspecified_error",
          code: n.error_code || "unspecified_code"
        });
      const { provider_token: r, provider_refresh_token: o, access_token: i, refresh_token: a, expires_in: l, expires_at: c, token_type: d } = n;
      if (!i || !l || !a || !d)
        throw new Cg("No session defined in URL");
      const f = Math.round(Date.now() / 1e3), p = parseInt(l);
      let g = f + p;
      c && (g = parseInt(c));
      const b = g - f;
      b * 1e3 <= gf && console.warn(`@supabase/gotrue-js: Session as retrieved from URL expires in ${b}s, should have been closer to ${p}s`);
      const v = g - p;
      f - v >= 120 ? console.warn("@supabase/gotrue-js: Session as retrieved from URL was issued over 120s ago, URL could be stale", v, g, f) : f - v < 0 && console.warn("@supabase/gotrue-js: Session as retrieved from URL was issued in the future? Check the device clock for skew", v, g, f);
      const { data: y, error: S } = await this._getUser(i);
      if (S)
        throw S;
      const E = {
        provider_token: r,
        provider_refresh_token: o,
        access_token: i,
        expires_in: p,
        expires_at: g,
        refresh_token: a,
        token_type: d,
        user: y.user
      };
      return window.location.hash = "", this._debug("#_getSessionFromURL()", "clearing window.location.hash"), { data: { session: E, redirectType: n.type }, error: null };
    } catch (n) {
      if (Xt(n))
        return { data: { session: null, redirectType: null }, error: n };
      throw n;
    }
  }
  /**
   * Checks if the current URL contains parameters given by an implicit oauth grant flow (https://www.rfc-editor.org/rfc/rfc6749.html#section-4.2)
   */
  _isImplicitGrantFlow() {
    const t = cw(window.location.href);
    return !!(qi() && (t.access_token || t.error_description));
  }
  /**
   * Checks if the current URL and backing storage contain parameters given by a PKCE flow
   */
  async _isPKCEFlow() {
    const t = cw(window.location.href), n = await yg(this.storage, `${this.storageKey}-code-verifier`);
    return !!(t.code && n);
  }
  /**
   * Inside a browser context, `signOut()` will remove the logged in user from the browser session and log them out - removing all items from localstorage and then trigger a `"SIGNED_OUT"` event.
   *
   * For server-side management, you can revoke all refresh tokens for a user by passing a user's JWT through to `auth.api.signOut(JWT: string)`.
   * There is no way to revoke a user's access token jwt until it expires. It is recommended to set a shorter expiry on the jwt for this reason.
   *
   * If using `others` scope, no `SIGNED_OUT` event is fired!
   */
  async signOut(t = { scope: "global" }) {
    return await this.initializePromise, await this._acquireLock(-1, async () => await this._signOut(t));
  }
  async _signOut({ scope: t } = { scope: "global" }) {
    return await this._useSession(async (n) => {
      var r;
      const { data: o, error: i } = n;
      if (i)
        return { error: i };
      const a = (r = o.session) === null || r === void 0 ? void 0 : r.access_token;
      if (a) {
        const { error: l } = await this.admin.signOut(a, t);
        if (l && !(RZ(l) && (l.status === 404 || l.status === 401 || l.status === 403)))
          return { error: l };
      }
      return t !== "others" && (await this._removeSession(), await vg(this.storage, `${this.storageKey}-code-verifier`)), { error: null };
    });
  }
  /**
   * Receive a notification every time an auth event happens.
   * @param callback A callback function to be invoked when an auth event happens.
   */
  onAuthStateChange(t) {
    const n = mZ(), r = {
      id: n,
      callback: t,
      unsubscribe: () => {
        this._debug("#unsubscribe()", "state change callback with id removed", n), this.stateChangeEmitters.delete(n);
      }
    };
    return this._debug("#onAuthStateChange()", "registered callback with id", n), this.stateChangeEmitters.set(n, r), (async () => (await this.initializePromise, await this._acquireLock(-1, async () => {
      this._emitInitialSession(n);
    })))(), { data: { subscription: r } };
  }
  async _emitInitialSession(t) {
    return await this._useSession(async (n) => {
      var r, o;
      try {
        const { data: { session: i }, error: a } = n;
        if (a)
          throw a;
        await ((r = this.stateChangeEmitters.get(t)) === null || r === void 0 ? void 0 : r.callback("INITIAL_SESSION", i)), this._debug("INITIAL_SESSION", "callback id", t, "session", i);
      } catch (i) {
        await ((o = this.stateChangeEmitters.get(t)) === null || o === void 0 ? void 0 : o.callback("INITIAL_SESSION", null)), this._debug("INITIAL_SESSION", "callback id", t, "error", i), console.error(i);
      }
    });
  }
  /**
   * Sends a password reset request to an email address. This method supports the PKCE flow.
   *
   * @param email The email address of the user.
   * @param options.redirectTo The URL to send the user to after they click the password reset link.
   * @param options.captchaToken Verification token received when the user completes the captcha on the site.
   */
  async resetPasswordForEmail(t, n = {}) {
    let r = null, o = null;
    this.flowType === "pkce" && ([r, o] = await du(
      this.storage,
      this.storageKey,
      !0
      // isPasswordRecovery
    ));
    try {
      return await un(this.fetch, "POST", `${this.url}/recover`, {
        body: {
          email: t,
          code_challenge: r,
          code_challenge_method: o,
          gotrue_meta_security: { captcha_token: n.captchaToken }
        },
        headers: this.headers,
        redirectTo: n.redirectTo
      });
    } catch (i) {
      if (Xt(i))
        return { data: null, error: i };
      throw i;
    }
  }
  /**
   * Gets all the identities linked to a user.
   */
  async getUserIdentities() {
    var t;
    try {
      const { data: n, error: r } = await this.getUser();
      if (r)
        throw r;
      return { data: { identities: (t = n.user.identities) !== null && t !== void 0 ? t : [] }, error: null };
    } catch (n) {
      if (Xt(n))
        return { data: null, error: n };
      throw n;
    }
  }
  /**
   * Links an oauth identity to an existing user.
   * This method supports the PKCE flow.
   */
  async linkIdentity(t) {
    var n;
    try {
      const { data: r, error: o } = await this._useSession(async (i) => {
        var a, l, c, d, f;
        const { data: p, error: g } = i;
        if (g)
          throw g;
        const b = await this._getUrlForProvider(`${this.url}/user/identities/authorize`, t.provider, {
          redirectTo: (a = t.options) === null || a === void 0 ? void 0 : a.redirectTo,
          scopes: (l = t.options) === null || l === void 0 ? void 0 : l.scopes,
          queryParams: (c = t.options) === null || c === void 0 ? void 0 : c.queryParams,
          skipBrowserRedirect: !0
        });
        return await un(this.fetch, "GET", b, {
          headers: this.headers,
          jwt: (f = (d = p.session) === null || d === void 0 ? void 0 : d.access_token) !== null && f !== void 0 ? f : void 0
        });
      });
      if (o)
        throw o;
      return qi() && !(!((n = t.options) === null || n === void 0) && n.skipBrowserRedirect) && window.location.assign(r == null ? void 0 : r.url), { data: { provider: t.provider, url: r == null ? void 0 : r.url }, error: null };
    } catch (r) {
      if (Xt(r))
        return { data: { provider: t.provider, url: null }, error: r };
      throw r;
    }
  }
  /**
   * Unlinks an identity from a user by deleting it. The user will no longer be able to sign in with that identity once it's unlinked.
   */
  async unlinkIdentity(t) {
    try {
      return await this._useSession(async (n) => {
        var r, o;
        const { data: i, error: a } = n;
        if (a)
          throw a;
        return await un(this.fetch, "DELETE", `${this.url}/user/identities/${t.identity_id}`, {
          headers: this.headers,
          jwt: (o = (r = i.session) === null || r === void 0 ? void 0 : r.access_token) !== null && o !== void 0 ? o : void 0
        });
      });
    } catch (n) {
      if (Xt(n))
        return { data: null, error: n };
      throw n;
    }
  }
  /**
   * Generates a new JWT.
   * @param refreshToken A valid refresh token that was returned on login.
   */
  async _refreshAccessToken(t) {
    const n = `#_refreshAccessToken(${t.substring(0, 5)}...)`;
    this._debug(n, "begin");
    try {
      const r = Date.now();
      return await wZ(async (o) => (o > 0 && await vZ(200 * Math.pow(2, o - 1)), this._debug(n, "refreshing attempt", o), await un(this.fetch, "POST", `${this.url}/token?grant_type=refresh_token`, {
        body: { refresh_token: t },
        headers: this.headers,
        xform: Ua
      })), (o, i) => {
        const a = 200 * Math.pow(2, o);
        return i && dw(i) && // retryable only if the request can be sent before the backoff overflows the tick duration
        Date.now() + a - r < gf;
      });
    } catch (r) {
      if (this._debug(n, "error", r), Xt(r))
        return { data: { session: null, user: null }, error: r };
      throw r;
    } finally {
      this._debug(n, "end");
    }
  }
  _isValidSession(t) {
    return typeof t == "object" && t !== null && "access_token" in t && "refresh_token" in t && "expires_at" in t;
  }
  async _handleProviderSignIn(t, n) {
    const r = await this._getUrlForProvider(`${this.url}/authorize`, t, {
      redirectTo: n.redirectTo,
      scopes: n.scopes,
      queryParams: n.queryParams
    });
    return this._debug("#_handleProviderSignIn()", "provider", t, "options", n, "url", r), qi() && !n.skipBrowserRedirect && window.location.assign(r), { data: { provider: t, url: r }, error: null };
  }
  /**
   * Recovers the session from LocalStorage and refreshes the token
   * Note: this method is async to accommodate for AsyncStorage e.g. in React native.
   */
  async _recoverAndRefresh() {
    var t;
    const n = "#_recoverAndRefresh()";
    this._debug(n, "begin");
    try {
      const r = await yg(this.storage, this.storageKey);
      if (this._debug(n, "session from storage", r), !this._isValidSession(r)) {
        this._debug(n, "session is not valid"), r !== null && await this._removeSession();
        return;
      }
      const o = Math.round(Date.now() / 1e3), i = ((t = r.expires_at) !== null && t !== void 0 ? t : 1 / 0) < o + VP;
      if (this._debug(n, `session has${i ? "" : " not"} expired with margin of ${VP}s`), i) {
        if (this.autoRefreshToken && r.refresh_token) {
          const { error: a } = await this._callRefreshToken(r.refresh_token);
          a && (console.error(a), dw(a) || (this._debug(n, "refresh failed with a non-retryable error, removing the session", a), await this._removeSession()));
        }
      } else
        await this._notifyAllSubscribers("SIGNED_IN", r);
    } catch (r) {
      this._debug(n, "error", r), console.error(r);
      return;
    } finally {
      this._debug(n, "end");
    }
  }
  async _callRefreshToken(t) {
    var n, r;
    if (!t)
      throw new Ha();
    if (this.refreshingDeferred)
      return this.refreshingDeferred.promise;
    const o = `#_callRefreshToken(${t.substring(0, 5)}...)`;
    this._debug(o, "begin");
    try {
      this.refreshingDeferred = new FA();
      const { data: i, error: a } = await this._refreshAccessToken(t);
      if (a)
        throw a;
      if (!i.session)
        throw new Ha();
      await this._saveSession(i.session), await this._notifyAllSubscribers("TOKEN_REFRESHED", i.session);
      const l = { session: i.session, error: null };
      return this.refreshingDeferred.resolve(l), l;
    } catch (i) {
      if (this._debug(o, "error", i), Xt(i)) {
        const a = { session: null, error: i };
        return dw(i) || await this._removeSession(), (n = this.refreshingDeferred) === null || n === void 0 || n.resolve(a), a;
      }
      throw (r = this.refreshingDeferred) === null || r === void 0 || r.reject(i), i;
    } finally {
      this.refreshingDeferred = null, this._debug(o, "end");
    }
  }
  async _notifyAllSubscribers(t, n, r = !0) {
    const o = `#_notifyAllSubscribers(${t})`;
    this._debug(o, "begin", n, `broadcast = ${r}`);
    try {
      this.broadcastChannel && r && this.broadcastChannel.postMessage({ event: t, session: n });
      const i = [], a = Array.from(this.stateChangeEmitters.values()).map(async (l) => {
        try {
          await l.callback(t, n);
        } catch (c) {
          i.push(c);
        }
      });
      if (await Promise.all(a), i.length > 0) {
        for (let l = 0; l < i.length; l += 1)
          console.error(i[l]);
        throw i[0];
      }
    } finally {
      this._debug(o, "end");
    }
  }
  /**
   * set currentSession and currentUser
   * process to _startAutoRefreshToken if possible
   */
  async _saveSession(t) {
    this._debug("#_saveSession()", t), this.suppressGetSessionWarning = !0, await NA(this.storage, this.storageKey, t);
  }
  async _removeSession() {
    this._debug("#_removeSession()"), await vg(this.storage, this.storageKey), await this._notifyAllSubscribers("SIGNED_OUT", null);
  }
  /**
   * Removes any registered visibilitychange callback.
   *
   * {@see #startAutoRefresh}
   * {@see #stopAutoRefresh}
   */
  _removeVisibilityChangedCallback() {
    this._debug("#_removeVisibilityChangedCallback()");
    const t = this.visibilityChangedCallback;
    this.visibilityChangedCallback = null;
    try {
      t && qi() && (window != null && window.removeEventListener) && window.removeEventListener("visibilitychange", t);
    } catch (n) {
      console.error("removing visibilitychange callback failed", n);
    }
  }
  /**
   * This is the private implementation of {@link #startAutoRefresh}. Use this
   * within the library.
   */
  async _startAutoRefresh() {
    await this._stopAutoRefresh(), this._debug("#_startAutoRefresh()");
    const t = setInterval(() => this._autoRefreshTokenTick(), gf);
    this.autoRefreshTicker = t, t && typeof t == "object" && typeof t.unref == "function" ? t.unref() : typeof Deno < "u" && typeof Deno.unrefTimer == "function" && Deno.unrefTimer(t), setTimeout(async () => {
      await this.initializePromise, await this._autoRefreshTokenTick();
    }, 0);
  }
  /**
   * This is the private implementation of {@link #stopAutoRefresh}. Use this
   * within the library.
   */
  async _stopAutoRefresh() {
    this._debug("#_stopAutoRefresh()");
    const t = this.autoRefreshTicker;
    this.autoRefreshTicker = null, t && clearInterval(t);
  }
  /**
   * Starts an auto-refresh process in the background. The session is checked
   * every few seconds. Close to the time of expiration a process is started to
   * refresh the session. If refreshing fails it will be retried for as long as
   * necessary.
   *
   * If you set the {@link GoTrueClientOptions#autoRefreshToken} you don't need
   * to call this function, it will be called for you.
   *
   * On browsers the refresh process works only when the tab/window is in the
   * foreground to conserve resources as well as prevent race conditions and
   * flooding auth with requests. If you call this method any managed
   * visibility change callback will be removed and you must manage visibility
   * changes on your own.
   *
   * On non-browser platforms the refresh process works *continuously* in the
   * background, which may not be desirable. You should hook into your
   * platform's foreground indication mechanism and call these methods
   * appropriately to conserve resources.
   *
   * {@see #stopAutoRefresh}
   */
  async startAutoRefresh() {
    this._removeVisibilityChangedCallback(), await this._startAutoRefresh();
  }
  /**
   * Stops an active auto refresh process running in the background (if any).
   *
   * If you call this method any managed visibility change callback will be
   * removed and you must manage visibility changes on your own.
   *
   * See {@link #startAutoRefresh} for more details.
   */
  async stopAutoRefresh() {
    this._removeVisibilityChangedCallback(), await this._stopAutoRefresh();
  }
  /**
   * Runs the auto refresh token tick.
   */
  async _autoRefreshTokenTick() {
    this._debug("#_autoRefreshTokenTick()", "begin");
    try {
      await this._acquireLock(0, async () => {
        try {
          const t = Date.now();
          try {
            return await this._useSession(async (n) => {
              const { data: { session: r } } = n;
              if (!r || !r.refresh_token || !r.expires_at) {
                this._debug("#_autoRefreshTokenTick()", "no session");
                return;
              }
              const o = Math.floor((r.expires_at * 1e3 - t) / gf);
              this._debug("#_autoRefreshTokenTick()", `access token expires in ${o} ticks, a tick lasts ${gf}ms, refresh threshold is ${KP} ticks`), o <= KP && await this._callRefreshToken(r.refresh_token);
            });
          } catch (n) {
            console.error("Auto refresh tick failed with error. This is likely a transient error.", n);
          }
        } finally {
          this._debug("#_autoRefreshTokenTick()", "end");
        }
      });
    } catch (t) {
      if (t.isAcquireTimeout || t instanceof jA)
        this._debug("auto refresh token tick lock not available");
      else
        throw t;
    }
  }
  /**
   * Registers callbacks on the browser / platform, which in-turn run
   * algorithms when the browser window/tab are in foreground. On non-browser
   * platforms it assumes always foreground.
   */
  async _handleVisibilityChange() {
    if (this._debug("#_handleVisibilityChange()"), !qi() || !(window != null && window.addEventListener))
      return this.autoRefreshToken && this.startAutoRefresh(), !1;
    try {
      this.visibilityChangedCallback = async () => await this._onVisibilityChanged(!1), window == null || window.addEventListener("visibilitychange", this.visibilityChangedCallback), await this._onVisibilityChanged(!0);
    } catch (t) {
      console.error("_handleVisibilityChange", t);
    }
  }
  /**
   * Callback registered with `window.addEventListener('visibilitychange')`.
   */
  async _onVisibilityChanged(t) {
    const n = `#_onVisibilityChanged(${t})`;
    this._debug(n, "visibilityState", document.visibilityState), document.visibilityState === "visible" ? (this.autoRefreshToken && this._startAutoRefresh(), t || (await this.initializePromise, await this._acquireLock(-1, async () => {
      if (document.visibilityState !== "visible") {
        this._debug(n, "acquired the lock to recover the session, but the browser visibilityState is no longer visible, aborting");
        return;
      }
      await this._recoverAndRefresh();
    }))) : document.visibilityState === "hidden" && this.autoRefreshToken && this._stopAutoRefresh();
  }
  /**
   * Generates the relevant login URL for a third-party provider.
   * @param options.redirectTo A URL or mobile address to send the user to after they are confirmed.
   * @param options.scopes A space-separated list of scopes granted to the OAuth application.
   * @param options.queryParams An object of key-value pairs containing query parameters granted to the OAuth application.
   */
  async _getUrlForProvider(t, n, r) {
    const o = [`provider=${encodeURIComponent(n)}`];
    if (r != null && r.redirectTo && o.push(`redirect_to=${encodeURIComponent(r.redirectTo)}`), r != null && r.scopes && o.push(`scopes=${encodeURIComponent(r.scopes)}`), this.flowType === "pkce") {
      const [i, a] = await du(this.storage, this.storageKey), l = new URLSearchParams({
        code_challenge: `${encodeURIComponent(i)}`,
        code_challenge_method: `${encodeURIComponent(a)}`
      });
      o.push(l.toString());
    }
    if (r != null && r.queryParams) {
      const i = new URLSearchParams(r.queryParams);
      o.push(i.toString());
    }
    return r != null && r.skipBrowserRedirect && o.push(`skip_http_redirect=${r.skipBrowserRedirect}`), `${t}?${o.join("&")}`;
  }
  async _unenroll(t) {
    try {
      return await this._useSession(async (n) => {
        var r;
        const { data: o, error: i } = n;
        return i ? { data: null, error: i } : await un(this.fetch, "DELETE", `${this.url}/factors/${t.factorId}`, {
          headers: this.headers,
          jwt: (r = o == null ? void 0 : o.session) === null || r === void 0 ? void 0 : r.access_token
        });
      });
    } catch (n) {
      if (Xt(n))
        return { data: null, error: n };
      throw n;
    }
  }
  async _enroll(t) {
    try {
      return await this._useSession(async (n) => {
        var r, o;
        const { data: i, error: a } = n;
        if (a)
          return { data: null, error: a };
        const l = Object.assign({ friendly_name: t.friendlyName, factor_type: t.factorType }, t.factorType === "phone" ? { phone: t.phone } : { issuer: t.issuer }), { data: c, error: d } = await un(this.fetch, "POST", `${this.url}/factors`, {
          body: l,
          headers: this.headers,
          jwt: (r = i == null ? void 0 : i.session) === null || r === void 0 ? void 0 : r.access_token
        });
        return d ? { data: null, error: d } : (t.factorType === "totp" && (!((o = c == null ? void 0 : c.totp) === null || o === void 0) && o.qr_code) && (c.totp.qr_code = `data:image/svg+xml;utf-8,${c.totp.qr_code}`), { data: c, error: null });
      });
    } catch (n) {
      if (Xt(n))
        return { data: null, error: n };
      throw n;
    }
  }
  /**
   * {@see GoTrueMFAApi#verify}
   */
  async _verify(t) {
    return this._acquireLock(-1, async () => {
      try {
        return await this._useSession(async (n) => {
          var r;
          const { data: o, error: i } = n;
          if (i)
            return { data: null, error: i };
          const { data: a, error: l } = await un(this.fetch, "POST", `${this.url}/factors/${t.factorId}/verify`, {
            body: { code: t.code, challenge_id: t.challengeId },
            headers: this.headers,
            jwt: (r = o == null ? void 0 : o.session) === null || r === void 0 ? void 0 : r.access_token
          });
          return l ? { data: null, error: l } : (await this._saveSession(Object.assign({ expires_at: Math.round(Date.now() / 1e3) + a.expires_in }, a)), await this._notifyAllSubscribers("MFA_CHALLENGE_VERIFIED", a), { data: a, error: l });
        });
      } catch (n) {
        if (Xt(n))
          return { data: null, error: n };
        throw n;
      }
    });
  }
  /**
   * {@see GoTrueMFAApi#challenge}
   */
  async _challenge(t) {
    return this._acquireLock(-1, async () => {
      try {
        return await this._useSession(async (n) => {
          var r;
          const { data: o, error: i } = n;
          return i ? { data: null, error: i } : await un(this.fetch, "POST", `${this.url}/factors/${t.factorId}/challenge`, {
            body: { channel: t.channel },
            headers: this.headers,
            jwt: (r = o == null ? void 0 : o.session) === null || r === void 0 ? void 0 : r.access_token
          });
        });
      } catch (n) {
        if (Xt(n))
          return { data: null, error: n };
        throw n;
      }
    });
  }
  /**
   * {@see GoTrueMFAApi#challengeAndVerify}
   */
  async _challengeAndVerify(t) {
    const { data: n, error: r } = await this._challenge({
      factorId: t.factorId
    });
    return r ? { data: null, error: r } : await this._verify({
      factorId: t.factorId,
      challengeId: n.id,
      code: t.code
    });
  }
  /**
   * {@see GoTrueMFAApi#listFactors}
   */
  async _listFactors() {
    const { data: { user: t }, error: n } = await this.getUser();
    if (n)
      return { data: null, error: n };
    const r = (t == null ? void 0 : t.factors) || [], o = r.filter((a) => a.factor_type === "totp" && a.status === "verified"), i = r.filter((a) => a.factor_type === "phone" && a.status === "verified");
    return {
      data: {
        all: r,
        totp: o,
        phone: i
      },
      error: null
    };
  }
  /**
   * {@see GoTrueMFAApi#getAuthenticatorAssuranceLevel}
   */
  async _getAuthenticatorAssuranceLevel() {
    return this._acquireLock(-1, async () => await this._useSession(async (t) => {
      var n, r;
      const { data: { session: o }, error: i } = t;
      if (i)
        return { data: null, error: i };
      if (!o)
        return {
          data: { currentLevel: null, nextLevel: null, currentAuthenticationMethods: [] },
          error: null
        };
      const a = this._decodeJWT(o.access_token);
      let l = null;
      a.aal && (l = a.aal);
      let c = l;
      ((r = (n = o.user.factors) === null || n === void 0 ? void 0 : n.filter((p) => p.status === "verified")) !== null && r !== void 0 ? r : []).length > 0 && (c = "aal2");
      const f = a.amr || [];
      return { data: { currentLevel: l, nextLevel: c, currentAuthenticationMethods: f }, error: null };
    }));
  }
}
gp.nextInstanceID = 0;
const qZ = gp;
class KZ extends qZ {
  constructor(t) {
    super(t);
  }
}
var YZ = function(e, t, n, r) {
  function o(i) {
    return i instanceof n ? i : new n(function(a) {
      a(i);
    });
  }
  return new (n || (n = Promise))(function(i, a) {
    function l(f) {
      try {
        d(r.next(f));
      } catch (p) {
        a(p);
      }
    }
    function c(f) {
      try {
        d(r.throw(f));
      } catch (p) {
        a(p);
      }
    }
    function d(f) {
      f.done ? i(f.value) : o(f.value).then(l, c);
    }
    d((r = r.apply(e, t || [])).next());
  });
};
class QZ {
  /**
   * Create a new client for use in the browser.
   * @param supabaseUrl The unique Supabase URL which is supplied when you create a new project in your project dashboard.
   * @param supabaseKey The unique Supabase Key which is supplied when you create a new project in your project dashboard.
   * @param options.db.schema You can switch in between schemas. The schema needs to be on the list of exposed schemas inside Supabase.
   * @param options.auth.autoRefreshToken Set to "true" if you want to automatically refresh the token before expiring.
   * @param options.auth.persistSession Set to "true" if you want to automatically save the user session into local storage.
   * @param options.auth.detectSessionInUrl Set to "true" if you want to automatically detects OAuth grants in the URL and signs in the user.
   * @param options.realtime Options passed along to realtime-js constructor.
   * @param options.global.fetch A custom fetch implementation.
   * @param options.global.headers Any additional headers to send with each network request.
   */
  constructor(t, n, r) {
    var o, i, a;
    if (this.supabaseUrl = t, this.supabaseKey = n, !t)
      throw new Error("supabaseUrl is required.");
    if (!n)
      throw new Error("supabaseKey is required.");
    const l = uZ(t);
    this.realtimeUrl = `${l}/realtime/v1`.replace(/^http/i, "ws"), this.authUrl = `${l}/auth/v1`, this.storageUrl = `${l}/storage/v1`, this.functionsUrl = `${l}/functions/v1`;
    const c = `sb-${new URL(this.authUrl).hostname.split(".")[0]}-auth-token`, d = {
      db: nZ,
      realtime: oZ,
      auth: Object.assign(Object.assign({}, rZ), { storageKey: c }),
      global: tZ
    }, f = dZ(r ?? {}, d);
    this.storageKey = (o = f.auth.storageKey) !== null && o !== void 0 ? o : "", this.headers = (i = f.global.headers) !== null && i !== void 0 ? i : {}, f.accessToken ? (this.accessToken = f.accessToken, this.auth = new Proxy({}, {
      get: (p, g) => {
        throw new Error(`@supabase/supabase-js: Supabase Client is configured with the accessToken option, accessing supabase.auth.${String(g)} is not possible`);
      }
    })) : this.auth = this._initSupabaseAuthClient((a = f.auth) !== null && a !== void 0 ? a : {}, this.headers, f.global.fetch), this.fetch = lZ(n, this._getAccessToken.bind(this), f.global.fetch), this.realtime = this._initRealtimeClient(Object.assign({ headers: this.headers, accessToken: this._getAccessToken.bind(this) }, f.realtime)), this.rest = new SJ(`${l}/rest/v1`, {
      headers: this.headers,
      schema: f.db.schema,
      fetch: this.fetch
    }), f.accessToken || this._listenForAuthEvents();
  }
  /**
   * Supabase Functions allows you to deploy and invoke edge functions.
   */
  get functions() {
    return new ZX(this.functionsUrl, {
      headers: this.headers,
      customFetch: this.fetch
    });
  }
  /**
   * Supabase Storage allows you to manage user-generated content, such as photos or videos.
   */
  get storage() {
    return new JJ(this.storageUrl, this.headers, this.fetch);
  }
  /**
   * Perform a query on a table or a view.
   *
   * @param relation - The table or view name to query
   */
  from(t) {
    return this.rest.from(t);
  }
  // NOTE: signatures must be kept in sync with PostgrestClient.schema
  /**
   * Select a schema to query or perform an function (rpc) call.
   *
   * The schema needs to be on the list of exposed schemas inside Supabase.
   *
   * @param schema - The schema to query
   */
  schema(t) {
    return this.rest.schema(t);
  }
  // NOTE: signatures must be kept in sync with PostgrestClient.rpc
  /**
   * Perform a function call.
   *
   * @param fn - The function name to call
   * @param args - The arguments to pass to the function call
   * @param options - Named parameters
   * @param options.head - When set to `true`, `data` will not be returned.
   * Useful if you only need the count.
   * @param options.get - When set to `true`, the function will be called with
   * read-only access mode.
   * @param options.count - Count algorithm to use to count rows returned by the
   * function. Only applicable for [set-returning
   * functions](https://www.postgresql.org/docs/current/functions-srf.html).
   *
   * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
   * hood.
   *
   * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
   * statistics under the hood.
   *
   * `"estimated"`: Uses exact count for low numbers and planned count for high
   * numbers.
   */
  rpc(t, n = {}, r = {}) {
    return this.rest.rpc(t, n, r);
  }
  /**
   * Creates a Realtime channel with Broadcast, Presence, and Postgres Changes.
   *
   * @param {string} name - The name of the Realtime channel.
   * @param {Object} opts - The options to pass to the Realtime channel.
   *
   */
  channel(t, n = { config: {} }) {
    return this.realtime.channel(t, n);
  }
  /**
   * Returns all Realtime channels.
   */
  getChannels() {
    return this.realtime.getChannels();
  }
  /**
   * Unsubscribes and removes Realtime channel from Realtime client.
   *
   * @param {RealtimeChannel} channel - The name of the Realtime channel.
   *
   */
  removeChannel(t) {
    return this.realtime.removeChannel(t);
  }
  /**
   * Unsubscribes and removes all Realtime channels from Realtime client.
   */
  removeAllChannels() {
    return this.realtime.removeAllChannels();
  }
  _getAccessToken() {
    var t, n;
    return YZ(this, void 0, void 0, function* () {
      if (this.accessToken)
        return yield this.accessToken();
      const { data: r } = yield this.auth.getSession();
      return (n = (t = r.session) === null || t === void 0 ? void 0 : t.access_token) !== null && n !== void 0 ? n : null;
    });
  }
  _initSupabaseAuthClient({ autoRefreshToken: t, persistSession: n, detectSessionInUrl: r, storage: o, storageKey: i, flowType: a, lock: l, debug: c }, d, f) {
    var p;
    const g = {
      Authorization: `Bearer ${this.supabaseKey}`,
      apikey: `${this.supabaseKey}`
    };
    return new KZ({
      url: this.authUrl,
      headers: Object.assign(Object.assign({}, g), d),
      storageKey: i,
      autoRefreshToken: t,
      persistSession: n,
      detectSessionInUrl: r,
      storage: o,
      flowType: a,
      lock: l,
      debug: c,
      fetch: f,
      // auth checks if there is a custom authorizaiton header using this flag
      // so it knows whether to return an error when getUser is called with no session
      hasCustomAuthorizationHeader: (p = "Authorization" in this.headers) !== null && p !== void 0 ? p : !1
    });
  }
  _initRealtimeClient(t) {
    return new LJ(this.realtimeUrl, Object.assign(Object.assign({}, t), { params: Object.assign({ apikey: this.supabaseKey }, t == null ? void 0 : t.params) }));
  }
  _listenForAuthEvents() {
    return this.auth.onAuthStateChange((n, r) => {
      this._handleTokenChanged(n, "CLIENT", r == null ? void 0 : r.access_token);
    });
  }
  _handleTokenChanged(t, n, r) {
    (t === "TOKEN_REFRESHED" || t === "SIGNED_IN") && this.changedAccessToken !== r ? this.changedAccessToken = r : t === "SIGNED_OUT" && (this.realtime.setAuth(), n == "STORAGE" && this.auth.signOut(), this.changedAccessToken = void 0);
  }
}
const XZ = (e, t, n) => new QZ(e, t, n);
class JZ {
  constructor(t) {
    nt(this, "translations");
    this.translations = t;
  }
  safeGet(t, n, r = !1) {
    const o = this.translations.get(t);
    return o == null ? (console.warn(
      `There is no text for the key '${t}' provided. Use the fallback instead.`
    ), n("fallBackTexts:" + t)) : r && o === "" ? (console.warn(
      `The provided text for the key '${t}' is empty. Use the fallback instead.`
    ), n("fallBackTexts:" + t)) : o;
  }
}
function BA(e, t, n, r) {
  try {
    return e();
  } catch (o) {
    const i = o;
    t.push({
      name: i.name,
      message: i.message,
      table: n,
      rowId: r
    });
  }
}
function jx(e, t) {
  if (e === null)
    throw Error(`Unexpected format: ${t} is null`);
  if (typeof e != "object" || Array.isArray(e))
    throw Error(`Unexpected format: ${t} is no record`);
}
function gm(e, t, n) {
  jx(e, n);
  const r = t.filter((o) => !(o in e));
  if (r.length > 0)
    throw Error(
      `Missing keys of contract.definition${n}: ${r.join(",")}`
    );
  return e;
}
function QP(e, t, n, r) {
  const o = (r == null ? void 0 : r.filter((i) => !(i in e && typeof e[i] === n))) || [];
  if (o.length > 0)
    throw Error(
      `Keys of contract.definition${t} that don't lead to ${n}: ${o.join(",")}`
    );
}
function Io(e, t, n, r) {
  return jx(e, t), QP(e, t, "string", n), QP(e, t, "number", r), e;
}
function nh(e, t) {
  return jx(e, t), e;
}
function wl(e, t, n) {
  return _l(e, t).map((r) => nh(r, t)).filter((r) => r.ID === n);
}
function _l(e, t) {
  if (!Array.isArray(e))
    throw Error(`Unexpected format: ${t} is no array`);
  return e;
}
function VA(e, t, n) {
  const r = t + ".ET_ZZBZVMENGEN";
  return wl(
    e,
    r,
    n
  ).map((i) => {
    const a = nh(i, r);
    return Io(
      a,
      r,
      ["SHOW_BLOCKED_QUANTITY", "BF_NAME", "BF_GROUP", "ZKAMPAGNE"],
      [
        "REDU_AMOUNT",
        "BLOCKED_QUANTITY",
        "MIN_AMOUNT",
        "MAX_AMOUNT",
        "AMOUNT",
        "TOTAL_ACREAGE",
        "Z_5_YEARS_YIELD"
      ]
    );
  });
}
function HA(e, t, n) {
  const r = t + ".ET_POSITIONS";
  return wl(
    e,
    r,
    n
  ).map((i) => Io(
    nh(i, r),
    r,
    [
      "BF_GROUP",
      "POSNAME",
      "CY_F",
      "CY_T",
      "INFORMATION",
      "POSNR",
      "UNIT",
      "CONFIRMATION_INFORMATION",
      "URL",
      "POSGRP"
    ],
    [
      "PERCENTAGE",
      "AMOUNT",
      "ACERAGE",
      "PRICE",
      "MAX_PERCENTAGE",
      "MAX_AMOUNT"
    ]
  ));
}
function UA(e, t, n) {
  const r = t + ".ET_QUESTIONS";
  return wl(
    e,
    r,
    n
  ).map((o) => Io(o, r, [
    "PARTNER",
    "QUESTID",
    "POSNR",
    "QUESTION",
    "QTYPE",
    "MANDATORY",
    "UNIT",
    "DATA_VALUE"
  ]));
}
function V0(e) {
  switch (e) {
    case "":
      return "HIDDEN";
    case "1":
      return "EDITABLE";
    case "2":
    case "3":
      return "READONLY";
    default:
      throw Error(
        `The given AttributeState "${e}" couldn't be mapped!`
      );
  }
}
function ZZ(e) {
  switch (e) {
    case "":
      return "PERCENT";
    case "1":
      return "WEIGHT";
    case "2":
      return "ACREAGE";
    default:
      throw Error(
        `The given ContractUnit "${e}" couldn't be mapped!`
      );
  }
}
function eee(e) {
  switch (e) {
    case "1":
      return "WEIGHT";
    case "2":
      return "PERCENT";
    case "3":
      return "ACREAGE";
    default:
      throw Error(
        `The given PositionDistributionUnit "${e}" couldn't be mapped!`
      );
  }
}
const zA = {
  "": "OPEN",
  1: "REJECTED",
  2: "ACCEPTED",
  3: "INTEREST"
};
function GA(e) {
  const t = zA[e];
  if (!t)
    throw Error(`The given contract status "${e}" couldn't be mapped!`);
  return t;
}
function tee(e) {
  const t = Object.entries(zA).find(
    ([, n]) => n === e
  );
  if (!t)
    throw Error(
      `The given contract status string "${e}" couldn't be parsed!`
    );
  return t[0];
}
function nee(e) {
  switch (e) {
    case "0":
      return "INFO";
    case "1":
      return "NUMERIC";
    case "2":
      return "CHECKBOX";
    case "3":
      return "FREETEXT";
    case "4":
      return "DROPDOWN";
    default:
      throw Error(`The given question type "${e}" couldn't be mapped!`);
  }
}
function Bx(e) {
  switch (e) {
    case "":
      return !1;
    case "X":
      return !0;
    default:
      throw Error(
        `The given input "${e}" couldn't be mapped to a boolean!`
      );
  }
}
function ree(e) {
  switch (e) {
    case "1":
      return !1;
    case "2":
      return !0;
    default:
      throw Error(`The given ACTION "${e}" is not supported!`);
  }
}
function oee(e) {
  switch (e) {
    case "0":
      return "NO_VALIDATION";
    case "1":
      return "REQUIRED";
    case "2":
      return "COMPARISON_LARGER_EQUAL";
    case "3":
      return "COMPARISON_SMALLER_EQUAL";
    case "4":
      return "COMPARISON_EQUALITY";
    default:
      throw Error(
        `The given input "${e}" couldn't be mapped to a CheckType!`
      );
  }
}
function iee(e) {
  switch (e) {
    case "S":
      return "SUCCESS";
    case "E":
      return "ERROR";
    case "W":
      return "WARNING";
    case "I":
      return "INFO";
    case "A":
      return "ALERT";
    default:
      throw Error(
        `The given input "${e}" couldn't be mapped to a MessageType!`
      );
  }
}
function see(e) {
  return e === "";
}
function aee(e, t, n) {
  const r = n + ".ET_HEADER", o = _l(t, r);
  if (o.length === 0)
    throw Error("No headers defined for contract!");
  if (o.length > 1)
    throw Error("More than one header defined for contract!");
  const i = Io(
    o[0],
    r,
    [
      "ID",
      "CONTRACTNAME",
      "CONTRACT_STATUS",
      "CONTRACT_STATUSTEXT",
      "ACTION",
      "LAND1",
      "BUKRS"
    ]
  );
  if (i.ID !== e)
    throw Error("Contract id mismatch between header and database!");
  return {
    id: i.ID,
    title: i.CONTRACTNAME,
    country: i.LAND1,
    companyCode: i.BUKRS,
    status: GA(i.CONTRACT_STATUS),
    statusText: i.CONTRACT_STATUSTEXT,
    editable: ree(i.ACTION)
  };
}
function lee(e, t, n, r, o) {
  const i = /* @__PURE__ */ new Map(), a = o + ".ET_TEXTS";
  for (const g of wl(t, a, e)) {
    const b = Io(g, a, [
      "AREANAME",
      "VIEWNAME",
      "LANGTEXT"
    ]);
    i.set(
      `${b.AREANAME}_${b.VIEWNAME}`,
      b.LANGTEXT
    );
  }
  const l = o + ".ET_LABLE";
  for (const g of wl(n, l, e)) {
    const b = Io(g, l, [
      "FIELDNAME",
      "LABLE"
    ]);
    i.set(b.FIELDNAME, b.LABLE);
  }
  const c = o + ".ET_ROUNDTYP", d = _l(r, c), f = ["BUTTON1", "BUTTON2", "BUTTON3", "BUTTON4"], p = Io(
    d[0],
    c,
    f
  );
  return f.forEach((g) => {
    i.set(g, p[g]);
  }), new JZ(i);
}
function cee(e, t, n) {
  const r = n + ".ET_DOCS", o = [];
  for (const i of wl(e, r, t)) {
    const a = Io(i, r, [
      "DESCRIPTION",
      "LINK"
    ]);
    o.push({
      description: a.DESCRIPTION,
      link: a.LINK
    });
  }
  return o;
}
function uee(e, t, n, r) {
  if (e === "DROPDOWN" && t !== "901" && r) {
    let o = "";
    return r.forEach((i, a) => {
      i === n && (o = a);
    }), o;
  } else return e === "CHECKBOX" ? n === "X" ? "true" : "false" : n;
}
function dee(e) {
  e.sort((t, n) => t.POSNR !== n.POSNR ? t.POSNR > n.POSNR ? 1 : -1 : t.QUESTID > n.QUESTID ? 1 : -1);
}
function fee(e, t, n, r) {
  const o = r + ".ET_SPECANSWERS", i = /* @__PURE__ */ new Map();
  for (const c of _l(t, o)) {
    const d = Io(
      c,
      o,
      ["PARTNER", "QUESTID", "ANTWORT_ID", "ANTWORT_TXT"]
    );
    if (d.ANTWORT_TXT === "")
      continue;
    const f = d.PARTNER + "_" + d.QUESTID;
    i.get(f) === void 0 && i.set(f, /* @__PURE__ */ new Map()), i.get(f).set(
      d.ANTWORT_ID,
      d.ANTWORT_TXT
    );
  }
  const a = [], l = UA(e, r, n);
  dee(l);
  for (const c of l) {
    const d = nee(c.QTYPE), f = d === "DROPDOWN" ? i.get(c.PARTNER + "_" + c.QUESTID) : void 0;
    a.push({
      id: c.QUESTID,
      partnerId: c.PARTNER,
      question: c.QUESTION,
      type: d,
      mandatory: Bx(c.MANDATORY),
      unit: c.UNIT,
      answerOptions: f,
      answer: uee(
        d,
        c.QUESTID,
        c.DATA_VALUE,
        f
      )
    });
  }
  for (const c of a)
    if (c.type === "DROPDOWN") {
      const d = c.partnerId + "_" + c.id;
      c.answerOptions = i.get(d);
    }
  return a;
}
function pee(e, t, n, r) {
  const o = [], i = VA(
    e,
    r,
    t
  );
  for (const a of i) {
    const l = n.find((c) => c.id == a.BF_GROUP);
    if (!l)
      throw Error(
        `${r}: BF_GROUP with id "${a.BF_GROUP}" not found for zzbzvmenge!`
      );
    o.push({
      reducedAmount: a.REDU_AMOUNT,
      showBlockedQuantity: Bx(a.SHOW_BLOCKED_QUANTITY),
      blockedQuantity: a.BLOCKED_QUANTITY,
      minAmount: a.MIN_AMOUNT,
      maxAmount: a.MAX_AMOUNT,
      bfName: a.BF_NAME,
      amount: a.AMOUNT,
      totalAcreage: a.TOTAL_ACREAGE,
      bfGroupId: a.BF_GROUP,
      campaign: a.ZKAMPAGNE,
      fiveYearsYield: a.Z_5_YEARS_YIELD,
      amountForInput: l.amountForInput,
      reduceForInput: l.reduceForInput,
      inputIfNoReduceAt: l.inputIfNoReduceAt
    });
  }
  return o;
}
function hee(e, t) {
  const n = t + ".ET_BFGROUP", r = [], o = _l(e, n);
  for (const i of o) {
    const a = nh(i, n), l = Io(a, n, [
      "BF_GROUP",
      "AMOUNT_FOR_INPUT",
      "REDUCE_FOR_INPUT",
      "INPUT_IF_NO_REDUCE_AT"
    ]);
    r.push({
      id: l.BF_GROUP,
      amountForInput: V0(l.AMOUNT_FOR_INPUT),
      reduceForInput: V0(l.REDUCE_FOR_INPUT),
      inputIfNoReduceAt: l.INPUT_IF_NO_REDUCE_AT
    });
  }
  return r;
}
function gee(e, t, n, r) {
  const o = [], i = HA(
    e,
    r,
    t
  );
  for (const a of i) {
    const l = n.find((d) => d.id == a.BF_GROUP);
    if (!l)
      throw Error(
        `${r}: BF_GROUP with id "${a.BF_GROUP}" not found for position!`
      );
    const c = {
      bfGroupId: a.BF_GROUP,
      positionName: a.POSNAME,
      yearFrom: parseInt(a.CY_F),
      yearTo: parseInt(a.CY_T),
      percentage: a.PERCENTAGE,
      amount: a.AMOUNT,
      acreage: a.ACERAGE,
      price: a.PRICE,
      information: a.INFORMATION,
      confirmInformation: Bx(a.CONFIRMATION_INFORMATION),
      informationLink: a.URL,
      positionNumber: a.POSNR,
      amountForInput: l.amountForInput,
      unit: a.UNIT,
      maxPercentage: a.MAX_PERCENTAGE,
      maxAmount: a.MAX_AMOUNT,
      positionGroup: a.POSGRP
    };
    c.informationLink && c.confirmInformation && console.warn(
      `The position '${c.positionName}' has an url and must be confirmed. This is not expected.`
    ), o.push(c);
  }
  return o;
}
function mee(e, t, n) {
  const r = n + ".ET_CHARACTERISTICS", o = [];
  for (const i of wl(
    e,
    r,
    t
  )) {
    const a = Io(
      i,
      r,
      ["POSNR", "FIELDNAME", "UNIT", "Z_INPUT"]
    );
    o.push({
      positionNumber: a.POSNR,
      fieldname: a.FIELDNAME,
      unit: a.UNIT,
      attributeState: V0(
        a.Z_INPUT
      )
    });
  }
  return o;
}
function bee(e, t, n) {
  const r = n + ".ET_CHECKS", o = [];
  for (const i of wl(e, r, t)) {
    const a = Io(
      i,
      r,
      [
        "POSNR",
        "FIELDNAME",
        "CHECK_TYPE",
        "MESSAGE_TYPE",
        "MESSAGE_TEXT",
        "MSG_NOT_REL_INT_USER",
        "BF_GROUP"
      ],
      ["CHECK_VALUE"]
    );
    o.push({
      positionNumber: a.POSNR,
      fieldName: a.FIELDNAME,
      checkType: oee(a.CHECK_TYPE),
      checkValue: a.CHECK_VALUE,
      messageType: iee(a.MESSAGE_TYPE),
      messageText: a.MESSAGE_TEXT,
      isMessageRelevantForInternalUser: see(
        a.MSG_NOT_REL_INT_USER
      ),
      bfGroupId: a.BF_GROUP
    });
  }
  return o;
}
function yee(e, t) {
  const n = t + ".ET_STATUS", r = /* @__PURE__ */ new Map();
  for (const o of _l(e, n)) {
    const i = Io(
      o,
      n,
      ["STATUS", "STATUSTEXT"]
    );
    r.set(
      GA(i.STATUS),
      i.STATUSTEXT
    );
  }
  return r;
}
function vee(e, t, n, r, o, i, a) {
  const l = a + ".ET_HEADER", c = _l(e, l), d = Io(
    c[0],
    l,
    ["ID", "CONTRACTING_IN", "VALUES_IN"]
  ), f = hee(t, a);
  return {
    quantities: pee(
      o,
      d.ID,
      f,
      a
    ),
    positions: gee(
      n,
      d.ID,
      f,
      a
    ),
    characteristics: mee(
      r,
      d.ID,
      a
    ),
    checks: bee(i, d.ID, a),
    positionDistributionUnit: eee(
      d.VALUES_IN
    ),
    contractUnit: ZZ(d.CONTRACTING_IN)
  };
}
function WA(e, t, n, r = !0) {
  const o = "contract.definition", i = nh(t, o), a = gm(
    i,
    [
      "ET_HEADER",
      "ET_TEXTS",
      "ET_LABLE",
      "ET_DOCS",
      "ET_QUESTIONS",
      "ET_ROUNDTYP",
      "ET_SPECANSWERS",
      "ET_ZZBZVMENGEN",
      "ET_BFGROUP",
      "ET_POSITIONS",
      "ET_CHARACTERISTICS",
      "ET_CHECKS",
      "ET_STATUS"
    ],
    o
  ), l = Io(
    i,
    o,
    ["EV_GROWERNAME", "EV_DEVIANTMAIL"]
  ), c = {
    ...aee(e, a.ET_HEADER, o),
    mdwTransferredAt: n,
    deviantMail: l.EV_DEVIANTMAIL,
    growerName: l.EV_GROWERNAME,
    texts: lee(
      e,
      a.ET_TEXTS,
      a.ET_LABLE,
      a.ET_ROUNDTYP,
      o
    ),
    documents: [],
    questions: [],
    quantityDetails: {},
    statusDescriptions: yee(
      a.ET_STATUS,
      o
    )
  };
  return r && (c.documents = cee(
    a.ET_DOCS,
    e,
    o
  ), c.questions = fee(
    a.ET_QUESTIONS,
    a.ET_SPECANSWERS,
    e,
    o
  ), c.quantityDetails = vee(
    a.ET_HEADER,
    a.ET_BFGROUP,
    a.ET_POSITIONS,
    a.ET_CHARACTERISTICS,
    a.ET_ZZBZVMENGEN,
    a.ET_CHECKS,
    o
  )), c;
}
function wee(e, t) {
  return BA(
    () => {
      const n = WA(
        e.contract_id,
        e.definition,
        e.mdw_transferred_at,
        !1
      );
      return {
        contractUuid: e.id,
        contractHeader: n,
        campaignYear: String(e.campaign_year),
        mdwTransferredAt: e.mdw_transferred_at,
        waitingForResponse: e.waiting_for_response,
        originalContractDefinition: e.definition
      };
    },
    t,
    "mdw_contracts",
    e.id
  );
}
function Cee(e, t, n) {
  const r = VA(
    t,
    n,
    e.id
  );
  if (e.quantityDetails.quantities.length !== r.length)
    throw Error("Tried to update with different count of quantities.");
  return e.quantityDetails.quantities.forEach((o, i) => {
    r[i].REDU_AMOUNT = o.reducedAmount, r[i].BLOCKED_QUANTITY = o.blockedQuantity, r[i].AMOUNT = o.amount, r[i].TOTAL_ACREAGE = o.totalAcreage;
  }), r;
}
function xee(e, t, n) {
  const r = HA(t, n, e.id);
  if (e.quantityDetails.positions.length !== r.length)
    throw Error("Tried to update with different count of positions.");
  return e.quantityDetails.positions.forEach((o, i) => {
    r[i].AMOUNT = o.amount, r[i].PERCENTAGE = o.percentage, r[i].PRICE = o.price, r[i].ACERAGE = o.acreage;
  }), r;
}
function See(e, t, n) {
  const r = UA(t, n, e.id);
  return e.questions.forEach((o) => {
    var l;
    let i = "";
    o.id === "901" && o.answer && parseInt(o.answer) !== 0 ? i = o.answer : o.type === "DROPDOWN" ? i = (l = o.answerOptions) == null ? void 0 : l.get(o.answer ?? "") : o.type === "CHECKBOX" ? i = o.answer === "true" ? "X" : "" : i = o.answer;
    const a = r.find(
      (c) => c.QUESTID === o.id
    );
    if (a)
      a.DATA_VALUE = i ?? "";
    else
      throw Error(
        `Can not update question, which was not in the contract before. (questid = ${o.id})`
      );
  }), r;
}
function qA(e, t, n, r) {
  const o = n + ".ET_HEADER", i = gm(
    t,
    ["ET_HEADER"],
    n
  ), a = gm(
    _l(i.ET_HEADER, n)[0],
    ["CONTRACT_STATUS", "CONTRACT_STATUSTEXT"],
    o
  ), l = tee(r);
  a.CONTRACT_STATUS = l;
  const c = e.statusDescriptions.get(r);
  if (c)
    a.CONTRACT_STATUSTEXT = c;
  else
    throw Error(`No status description for ${r} found`);
  return i.ET_HEADER = [a], i;
}
function Eee(e) {
  return JSON.parse(JSON.stringify(e));
}
function Tee(e, t) {
  const n = "contract.definition", r = Eee(t), o = gm(
    r,
    ["ET_QUESTIONS", "ET_ZZBZVMENGEN", "ET_POSITIONS", "EV_DEVIANTMAIL"],
    n
  );
  return o.ET_ZZBZVMENGEN = Cee(
    e,
    o.ET_ZZBZVMENGEN,
    n
  ), o.ET_POSITIONS = xee(
    e,
    o.ET_POSITIONS,
    n
  ), o.ET_QUESTIONS = See(
    e,
    o.ET_QUESTIONS,
    n
  ), o.EV_DEVIANTMAIL = e.deviantMail, qA(
    e,
    o,
    n,
    e.status
  );
}
function Oee(e, t) {
  return qA(
    e,
    t,
    "contract.definition",
    "REJECTED"
  );
}
function mf(e) {
  const { is_crop_season_field: t, ...n } = e;
  return n;
}
class KA {
  constructor(t, n) {
    nt(this, "supabaseClient");
    this.supabaseClient = XZ(t, n);
  }
  getBaseClient() {
    return this.supabaseClient;
  }
  async getFarms(t) {
    let n = this.supabaseClient.from("farms").select();
    t && (n = n.eq("business_partner_id", t));
    const r = n.order("name").returns(), { data: o, error: i } = await r;
    if (i)
      throw i;
    return o;
  }
  async getFarmsMap(t) {
    return (await this.getFarms(t)).reduce(function(r, o) {
      return r.set(o.id, o.name), r;
    }, /* @__PURE__ */ new Map());
  }
  async getFarm(t) {
    const { data: n, error: r } = await this.supabaseClient.from("farms").select().eq("id", t).returns();
    if (r)
      throw r;
    return this.extractUniqueElement(n);
  }
  async createFarm(t) {
    const { data: n, error: r } = await this.supabaseClient.from("farms").insert(t).select().returns();
    if (r)
      throw r;
    return this.extractUniqueElement(n);
  }
  async updateFarm(t, n) {
    if (n.id !== void 0 && n.id !== t)
      throw new Error("The id from the parameter and the object don't match.");
    const { data: r, error: o } = await this.supabaseClient.from("farms").update({ ...n, id: t }).eq("id", t).select().returns();
    if (o)
      throw o;
    return this.extractUniqueElement(r);
  }
  async getMasterdataFields(t) {
    const { data: n, error: r } = await this.supabaseClient.from("fields").select().eq("farm", t).eq("is_crop_season_field", !1).order("name").returns();
    if (r)
      throw r;
    return n.map((o) => mf(o));
  }
  async getMasterdataField(t) {
    const n = await this.getField(t);
    if (n.is_crop_season_field)
      throw new Error(`Field with id ${t} is not part of the masterdata`);
    return mf(n);
  }
  async getCropSeasonField(t) {
    const n = await this.getField(t);
    if (!n.is_crop_season_field)
      throw new Error(
        `Field with id ${t} is not part of the crop season data`
      );
    return mf(n);
  }
  async getField(t) {
    const { data: n, error: r } = await this.supabaseClient.from("fields").select().eq("id", t).returns();
    if (r)
      throw r;
    return this.extractUniqueElement(n);
  }
  async createField(t) {
    const { data: n, error: r } = await this.supabaseClient.from("fields").insert(t).select().returns();
    if (r)
      throw r;
    return this.extractUniqueElement(n);
  }
  async getAllMasterdataFields(t) {
    let n = this.supabaseClient.from("masterdata_field_overviews").select().order("name");
    t && (n = n.eq("business_partner_id", t));
    const r = n.returns(), { data: o, error: i } = await r;
    if (i)
      throw i;
    return o;
  }
  async getEnabledFieldsWithBoundaries(t, n) {
    let r = this.supabaseClient.from("fields").select(
      `
          *,
          farms!inner(business_partner_id)
         `
    ).neq("boundaries", null).eq("is_crop_season_field", n).eq("disabled", !1);
    t && (r = r.eq(
      "farms.business_partner_id",
      t
    ));
    const o = r.returns(), { data: i, error: a } = await o;
    if (a)
      throw a;
    return i;
  }
  async getEnabledMasterdataFieldsWithBoundaries(t) {
    return await this.getEnabledFieldsWithBoundaries(t, !1);
  }
  async getEnabledCropSeasonFieldsWithBoundaries(t) {
    return await this.getEnabledFieldsWithBoundaries(t, !0);
  }
  async updateField(t, n) {
    if (n.id !== void 0 && t !== n.id)
      throw Error("The id from the parameter and the object don't match.");
    const { data: r, error: o } = await this.supabaseClient.from("fields").update({ ...n, id: t, is_crop_season_field: void 0 }).eq("id", t).select().returns();
    if (o)
      throw o;
    return mf(this.extractUniqueElement(r));
  }
  async getHistoricalFieldsWithBoundaries(t) {
    const { data: n, error: r } = await this.supabaseClient.from("mdw_historical_fields").select().eq("business_partner_id", t).neq("boundaries", null).order("name").returns();
    if (r)
      throw r;
    return n;
  }
  extractUniqueElement(t) {
    if (t.length > 1)
      throw new Error("Multiple elements found!");
    if (t.length < 1)
      throw new Error("No element found!");
    return t[0];
  }
  async getFieldCultivationRestrictions() {
    const { data: t, error: n } = await this.supabaseClient.from("field_cultivation_restrictions").select().returns();
    if (n)
      throw n;
    return t.reduce(function(r, o) {
      return r.set(o.id, o.value), r;
    }, /* @__PURE__ */ new Map());
  }
  async getSeasons() {
    const { data: t, error: n } = await this.supabaseClient.from("seasons").select().returns();
    if (n)
      throw n;
    return t.reduce(function(r, o) {
      return r.set(o.id, o.name), r;
    }, /* @__PURE__ */ new Map());
  }
  async getRunningSeasonIds() {
    const t = (/* @__PURE__ */ new Date()).toISOString(), { data: n, error: r } = await this.supabaseClient.from("seasons").select().lte("start_date", t).gte("end_date", t).order("name", { ascending: !0 }).returns();
    if (r)
      throw r;
    return n.map((o) => o.id);
  }
  async getCurrentAndNextSeason(t, n = !0) {
    const r = /* @__PURE__ */ new Date();
    r.setFullYear(r.getFullYear() + 2);
    const o = (/* @__PURE__ */ new Date()).toISOString().split("T")[0];
    let i = this.supabaseClient.from("seasons").select().in("company_code", t).gte("end_date", o).lte("end_date", r.toISOString());
    n && (i = i.or(
      `last_maintanance_opportunity.gte.${o},last_maintanance_opportunity.is.null`
    ));
    const { data: a, error: l } = await i.order("end_date", { ascending: !0 }).returns();
    if (l)
      throw l;
    return a.reduce(function(c, d) {
      return c.set(d.id, d.name), c;
    }, /* @__PURE__ */ new Map());
  }
  async getSeason(t) {
    const { data: n, error: r } = await this.supabaseClient.from("seasons").select().eq("id", t).returns();
    if (r)
      throw r;
    return this.extractUniqueElement(n);
  }
  async getSeasonWithCountry(t) {
    const { data: n, error: r } = await this.supabaseClient.from("seasons_with_country").select().eq("id", t).returns();
    if (r)
      throw r;
    return this.extractUniqueElement(n);
  }
  async getCropTypes() {
    const { data: t, error: n } = await this.supabaseClient.rpc("get_enum_values", {
      enum_type: "Crop"
    });
    if (n)
      throw n;
    if (!Array.isArray(t))
      throw Error("Error: Invalid data received as enum values");
    return t;
  }
  async getCropVarieties() {
    const { data: t, error: n } = await this.supabaseClient.from("mdw_crop_varieties").select().returns();
    if (n)
      throw n;
    return t.reduce(function(r, o) {
      return r.set(o.id, o.description), r;
    }, /* @__PURE__ */ new Map());
  }
  async getCropVarietiesForCrop(t, n) {
    const { data: r, error: o } = await this.supabaseClient.from("mdw_crop_varieties").select().eq("crop", t).eq("company_code", n).returns();
    if (o)
      throw o;
    return r.reduce(function(i, a) {
      return i.set(a.id, a.description), i;
    }, /* @__PURE__ */ new Map());
  }
  async getHarvestServiceProviders(t) {
    const n = this.supabaseClient.rpc("get_harvest_service_providers", {
      country_code: t
    }), { data: r, error: o } = await n;
    if (o)
      throw o;
    return r.reduce(function(i, a) {
      return i.set(a.id, fw(a)), i;
    }, /* @__PURE__ */ new Map());
  }
  async getLithuanianDeliveryServiceProviders() {
    const t = this.supabaseClient.rpc(
      "get_lithuanian_delivery_service_providers"
    ), { data: n, error: r } = await t;
    if (r)
      throw r;
    return n.reduce(function(o, i) {
      return o.set(i.id, fw(i)), o;
    }, /* @__PURE__ */ new Map());
  }
  async getSwedishCoveringServiceProviders() {
    const t = this.supabaseClient.rpc(
      "get_swedish_covering_service_providers"
    ), { data: n, error: r } = await t;
    if (r)
      throw r;
    return n.reduce(function(o, i) {
      return o.set(i.id, fw(i)), o;
    }, /* @__PURE__ */ new Map());
  }
  async getDeliveryPhases(t) {
    const { data: n, error: r } = await this.supabaseClient.from("mdw_delivery_phases").select().eq("season_id", t);
    if (r)
      throw r;
    return n.reduce(function(o, i) {
      return o.set(i.id, i.name), o;
    }, /* @__PURE__ */ new Map());
  }
  // Note: Can't handle it when a query with multiple words has one word which is a column name
  async searchSapDistricts(t, n) {
    const r = t.trim().toLowerCase().replaceAll(/[^\p{L}\p{N}\s-]/gu, ""), o = r.split(/\s+/), i = o.length === 1 ? `${r} | ${r}:*` : o.map((d) => `${d}:*`).join(" & ");
    let a = this.supabaseClient.from("mdw_sap_districts").select().eq("is_active", !0).order("name").textSearch("fts", i);
    n && (a = a.ilike("country", `${n}`));
    const { data: l, error: c } = await a.returns();
    if (c)
      throw c;
    return l;
  }
  async getSapDistrict(t) {
    const { data: n, error: r } = await this.supabaseClient.from("mdw_sap_districts").select().eq("id", t).returns();
    if (r)
      throw r;
    return this.extractUniqueElement(n);
  }
  async initiallySetSapDistrictBoundingBox(t, n) {
    const { error: r } = await this.supabaseClient.rpc(
      "initially_set_sap_district_bounding_box",
      {
        district_id: t,
        bbox: n
      }
    );
    if (r)
      throw r;
  }
  async getYieldEstimation(t, n, r) {
    const { data: o, error: i } = await this.supabaseClient.from("mdw_yield_estimations").select().eq("district_id", t).eq("grower_bpno", n).eq("year", r).returns();
    if (i)
      throw i;
    return this.extractUniqueElement(o);
  }
  async getCropSeasons(t) {
    let n = this.supabaseClient.from("crop_season_overviews").select().order("field_name");
    t && (n = n.eq("business_partner_id", t));
    const r = n.returns(), { data: o, error: i } = await r;
    if (i)
      throw i;
    return o;
  }
  async getCropSeasonExtendedInformation(t) {
    const { data: n, error: r } = await this.supabaseClient.from("enriched_crop_seasons").select(
      `
            *,
            fields (*, farms(*)),
            seasons (*, mdw_company_codes(country))
           `
    ).eq("id", t).returns();
    if (r)
      throw r;
    const o = this.extractUniqueElement(
      n
    );
    return {
      ...o,
      fields: mf(o.fields)
    };
  }
  async getCropSeasonsFieldBoundaries(t, n) {
    const { data: r, error: o } = await this.supabaseClient.from("crop_seasons").select(
      `
              id,
              season_id,
              fields!inner(id, name, boundaries, farms!inner(business_partner_id))              
             `
    ).eq("season_id", n).eq("fields.farms.business_partner_id", t).returns();
    if (o)
      throw o;
    return r;
  }
  async createCropSeason(t) {
    const { data: n, error: r } = await this.supabaseClient.from("crop_seasons").insert({
      ...t
    }).select().returns();
    if (r)
      throw r;
    return this.extractUniqueElement(n);
  }
  async updateCropSeason(t, n) {
    if (n.id !== void 0 && t !== n.id)
      throw Error("The id from the parameter and the object don't match.");
    const { data: r, error: o } = await this.supabaseClient.from("crop_seasons").update({
      ...n,
      id: t
    }).eq("id", t).select().returns();
    if (o)
      throw o;
    return this.extractUniqueElement(r);
  }
  async disableCropSeason(t) {
    const { data: n, error: r } = await this.supabaseClient.from("crop_seasons").update({ disabled: !0 }).eq("id", t).select().returns();
    if (r)
      throw r;
    if (n.length === 0)
      throw new Error(`Crop season with id ${t} does not exist`);
  }
  async enableCropSeason(t) {
    const { data: n, error: r } = await this.supabaseClient.from("crop_seasons").update({ disabled: !1 }).eq("id", t).select().returns();
    if (r)
      throw r;
    if (n.length === 0)
      throw new Error(`Crop season with id ${t} does not exist`);
  }
  async getSplittedFieldsForCropSeason(t) {
    const { data: n, error: r } = await this.supabaseClient.from("splitted_fields").select().eq("crop_season_id", t).order("field_order", { ascending: !0 }).returns();
    if (r)
      throw r;
    return n;
  }
  async createSplittedFields(t) {
    const { data: n, error: r } = await this.supabaseClient.from("splitted_fields").insert(t).select().returns();
    if (r)
      throw r;
    return n;
  }
  async updateSplittedFields(t, n) {
    if (t.some(
      (o) => o.crop_season_id !== n
    ))
      throw Error(
        "The crop season id from the parameter and the objects don't match."
      );
    if (this.hasDuplicatedOrders(t))
      throw Error("There are duplicated orders which is not allowed.");
    const r = [];
    for (const o of t) {
      const { data: i, error: a } = await this.supabaseClient.from("splitted_fields").update({ field_size: o.field_size }).eq("crop_season_id", n).eq("field_order", o.field_order).select();
      if (a)
        throw a;
      r.push(i);
    }
    return r;
  }
  hasDuplicatedOrders(t) {
    const n = {};
    for (const r of t)
      n[r.field_order] = (n[r.field_order] || 0) + 1;
    return Object.entries(n).some(([, r]) => r > 1);
  }
  async deleteSplittedFields(t, n) {
    const { data: r, error: o } = await this.supabaseClient.from("splitted_fields").delete().in("field_order", t).eq("crop_season_id", n).select().returns();
    if (o)
      throw o;
    return r;
  }
  async getAllBusinessPartners() {
    const { data: t, error: n } = await this.supabaseClient.from("business_partners").select().order("name").returns();
    if (n)
      throw n;
    return t;
  }
  async getBusinessPartner(t) {
    const { data: n, error: r } = await this.supabaseClient.from("business_partners").select().eq("bpno", t).returns();
    if (r)
      throw r;
    return this.extractUniqueElement(n);
  }
  async getContractHeaders(t) {
    let n = this.supabaseClient.from("mdw_contracts").select().order("id");
    t && (n = n.eq("business_partner_id", t));
    const r = n.returns(), { data: o, error: i } = await r;
    if (i)
      throw i;
    const a = [], l = o.map((c) => wee(c, a)).filter((c) => c !== void 0);
    return a.sort((c, d) => c.message > d.message ? 1 : -1), {
      contracts: l,
      errors: a
    };
  }
  async getContract(t, n) {
    const r = this.supabaseClient.rpc(
      "get_contract_with_opening_tracking",
      {
        contract_uuid: t,
        skip_opening_tracking: n
      }
    ), { data: o, error: i } = await r;
    if (i)
      throw i;
    const a = this.extractUniqueElement(o), l = [], c = BA(
      () => WA(
        a.contract_id,
        a.definition,
        a.mdw_transferred_at
      ),
      l,
      "mdw_contracts",
      a.id
    );
    return {
      contract: c ? {
        contractUuid: t,
        contract: c,
        originalContractDefinition: a.definition,
        mdwTransferredAt: a.mdw_transferred_at
      } : void 0,
      errors: l
    };
  }
  async updateContract(t, n, r, o) {
    const i = Tee(
      n,
      r
    ), { error: a } = await this.supabaseClient.functions.invoke(
      "update-contract",
      {
        method: "POST",
        body: {
          contractId: t,
          contractDefinition: i,
          mdwTransferredAt: o
        }
      }
    );
    if (a)
      throw a instanceof hA ? await a.context.json() : a instanceof pA || a instanceof fA ? a.message : a.context.body ? Error((await new Response(a.context.body).json()).message) : a;
  }
  async declineContract(t, n, r, o) {
    const i = Oee(
      n,
      r
    ), { error: a } = await this.supabaseClient.functions.invoke(
      "update-contract",
      {
        method: "POST",
        body: {
          contractId: t,
          contractDefinition: i,
          mdwTransferredAt: o
        }
      }
    );
    if (a)
      throw a.context.body ? Error((await new Response(a.context.body).json()).message) : a;
  }
  async getAcreageCalculatorData(t, n) {
    const r = this.supabaseClient.from("acreage_calculator_combined_data").select().eq("business_partner_id", t).eq("year", n), { data: o, error: i } = await r;
    if (i)
      throw i;
    return this.extractUniqueElement(o);
  }
  async getQueueMessages(t, n) {
    const r = this.supabaseClient.rpc("read_from_agri_log_queue", {
      quantity: t,
      visibility_timeout: n
    }), { data: o, error: i } = await r;
    if (i)
      throw i;
    return o;
  }
  async isInternalUserWithAccessOnBehalfTo(t) {
    const { data: n, error: r } = await this.supabaseClient.rpc(
      "is_internal_user_and_can_access_on_behalf",
      {
        business_partner_number: t
      }
    );
    if (r)
      throw r;
    return n;
  }
}
function fw(e) {
  return `${e.name} (${e.bpno})`;
}
const YA = en.createContext(
  void 0
), Vx = Pc({
  supabaseUrl: "",
  supabaseAnonKey: "",
  ssoIdentityProviderId: ""
});
function Pee(e) {
  const t = Li(Vx), n = t.supabaseUrl, r = t.supabaseAnonKey;
  if (!n || !r)
    throw Error("Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY variable");
  const o = pl(() => ({
    dataClient: new KA(n, r)
  }), [n, r]);
  return /* @__PURE__ */ w.jsx(YA.Provider, { value: o, children: e.children });
}
class Iee {
  constructor(t) {
    nt(this, "supabaseAuthClient");
    this.supabaseAuthClient = t.getBaseClient().auth;
  }
  getSession() {
    return this.supabaseAuthClient.getSession();
  }
  async signInWithSSO(t) {
    return await this.supabaseAuthClient.signInWithSSO({
      providerId: t,
      options: { redirectTo: window.location.href }
    });
  }
  onAuthStateChange(t) {
    return this.supabaseAuthClient.onAuthStateChange(t);
  }
  logout() {
    return this.supabaseAuthClient.signOut();
  }
}
function _d() {
  const e = Li(YA);
  if (e === void 0)
    throw new Error(
      "useDataClient must be used within a DataClientContextProvider."
    );
  return e;
}
var mm = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
mm.exports;
(function(e, t) {
  (function() {
    var n, r = "4.17.21", o = 200, i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", l = "Invalid `variable` option passed into `_.template`", c = "__lodash_hash_undefined__", d = 500, f = "__lodash_placeholder__", p = 1, g = 2, b = 4, v = 1, y = 2, S = 1, E = 2, I = 4, O = 8, T = 16, P = 32, R = 64, F = 128, A = 256, _ = 512, C = 30, D = "...", L = 800, B = 16, H = 1, k = 2, N = 3, j = 1 / 0, W = 9007199254740991, V = 17976931348623157e292, $ = NaN, z = 4294967295, ne = z - 1, K = z >>> 1, Q = [
      ["ary", F],
      ["bind", S],
      ["bindKey", E],
      ["curry", O],
      ["curryRight", T],
      ["flip", _],
      ["partial", P],
      ["partialRight", R],
      ["rearg", A]
    ], re = "[object Arguments]", te = "[object Array]", ie = "[object AsyncFunction]", ae = "[object Boolean]", ce = "[object Date]", le = "[object DOMException]", we = "[object Error]", q = "[object Function]", Ee = "[object GeneratorFunction]", _e = "[object Map]", $e = "[object Number]", Le = "[object Null]", Ze = "[object Object]", J = "[object Promise]", fe = "[object Proxy]", me = "[object RegExp]", Oe = "[object Set]", Ce = "[object String]", Te = "[object Symbol]", Pe = "[object Undefined]", Ye = "[object WeakMap]", Ke = "[object WeakSet]", je = "[object ArrayBuffer]", Qe = "[object DataView]", et = "[object Float32Array]", Et = "[object Float64Array]", Xe = "[object Int8Array]", xt = "[object Int16Array]", tt = "[object Int32Array]", ct = "[object Uint8Array]", Je = "[object Uint8ClampedArray]", Ge = "[object Uint16Array]", lt = "[object Uint32Array]", It = /\b__p \+= '';/g, fn = /\b(__p \+=) '' \+/g, Bn = /(__e\(.*?\)|\b__t\)) \+\n'';/g, kn = /&(?:amp|lt|gt|quot|#39);/g, fr = /[&<>"']/g, ar = RegExp(kn.source), Mr = RegExp(fr.source), Lr = /<%-([\s\S]+?)%>/g, lr = /<%([\s\S]+?)%>/g, mt = /<%=([\s\S]+?)%>/g, er = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, eo = /^\w*$/, ue = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ve = /[\\^$.*+?()[\]{}|]/g, Se = RegExp(ve.source), ze = /^\s+/, st = /\s/, bt = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Dt = /\{\n\/\* \[wrapped with (.+)\] \*/, at = /,? & /, Z = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, be = /[()=,{}\[\]\/\s]/, Re = /\\(\\)?/g, pe = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, he = /\w*$/, Fe = /^[-+]0x[0-9a-f]+$/i, We = /^0b[01]+$/i, Ue = /^\[object .+?Constructor\]$/, dt = /^0o[0-7]+$/i, Tt = /^(?:0|[1-9]\d*)$/, zt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, pn = /($^)/, Ar = /['\n\r\u2028\u2029\\]/g, Gr = "\\ud800-\\udfff", Qn = "\\u0300-\\u036f", Wr = "\\ufe20-\\ufe2f", Ko = "\\u20d0-\\u20ff", qt = Qn + Wr + Ko, jt = "\\u2700-\\u27bf", hn = "a-z\\xdf-\\xf6\\xf8-\\xff", _o = "\\xac\\xb1\\xd7\\xf7", Ks = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", pr = "\\u2000-\\u206f", Ia = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Bd = "A-Z\\xc0-\\xd6\\xd8-\\xde", gh = "\\ufe0e\\ufe0f", qS = _o + Ks + pr + Ia, wy = "['’]", cL = "[" + Gr + "]", KS = "[" + qS + "]", mh = "[" + qt + "]", YS = "\\d+", uL = "[" + jt + "]", QS = "[" + hn + "]", XS = "[^" + Gr + qS + YS + jt + hn + Bd + "]", Cy = "\\ud83c[\\udffb-\\udfff]", dL = "(?:" + mh + "|" + Cy + ")", JS = "[^" + Gr + "]", xy = "(?:\\ud83c[\\udde6-\\uddff]){2}", Sy = "[\\ud800-\\udbff][\\udc00-\\udfff]", Lc = "[" + Bd + "]", ZS = "\\u200d", eE = "(?:" + QS + "|" + XS + ")", fL = "(?:" + Lc + "|" + XS + ")", tE = "(?:" + wy + "(?:d|ll|m|re|s|t|ve))?", nE = "(?:" + wy + "(?:D|LL|M|RE|S|T|VE))?", rE = dL + "?", oE = "[" + gh + "]?", pL = "(?:" + ZS + "(?:" + [JS, xy, Sy].join("|") + ")" + oE + rE + ")*", hL = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", gL = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", iE = oE + rE + pL, mL = "(?:" + [uL, xy, Sy].join("|") + ")" + iE, bL = "(?:" + [JS + mh + "?", mh, xy, Sy, cL].join("|") + ")", yL = RegExp(wy, "g"), vL = RegExp(mh, "g"), Ey = RegExp(Cy + "(?=" + Cy + ")|" + bL + iE, "g"), wL = RegExp([
      Lc + "?" + QS + "+" + tE + "(?=" + [KS, Lc, "$"].join("|") + ")",
      fL + "+" + nE + "(?=" + [KS, Lc + eE, "$"].join("|") + ")",
      Lc + "?" + eE + "+" + tE,
      Lc + "+" + nE,
      gL,
      hL,
      YS,
      mL
    ].join("|"), "g"), CL = RegExp("[" + ZS + Gr + qt + gh + "]"), xL = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, SL = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], EL = -1, Xn = {};
    Xn[et] = Xn[Et] = Xn[Xe] = Xn[xt] = Xn[tt] = Xn[ct] = Xn[Je] = Xn[Ge] = Xn[lt] = !0, Xn[re] = Xn[te] = Xn[je] = Xn[ae] = Xn[Qe] = Xn[ce] = Xn[we] = Xn[q] = Xn[_e] = Xn[$e] = Xn[Ze] = Xn[me] = Xn[Oe] = Xn[Ce] = Xn[Ye] = !1;
    var qn = {};
    qn[re] = qn[te] = qn[je] = qn[Qe] = qn[ae] = qn[ce] = qn[et] = qn[Et] = qn[Xe] = qn[xt] = qn[tt] = qn[_e] = qn[$e] = qn[Ze] = qn[me] = qn[Oe] = qn[Ce] = qn[Te] = qn[ct] = qn[Je] = qn[Ge] = qn[lt] = !0, qn[we] = qn[q] = qn[Ye] = !1;
    var TL = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, OL = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, PL = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, IL = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, RL = parseFloat, _L = parseInt, sE = typeof Cr == "object" && Cr && Cr.Object === Object && Cr, kL = typeof self == "object" && self && self.Object === Object && self, to = sE || kL || Function("return this")(), Ty = t && !t.nodeType && t, $l = Ty && !0 && e && !e.nodeType && e, aE = $l && $l.exports === Ty, Oy = aE && sE.process, bi = function() {
      try {
        var ye = $l && $l.require && $l.require("util").types;
        return ye || Oy && Oy.binding && Oy.binding("util");
      } catch {
      }
    }(), lE = bi && bi.isArrayBuffer, cE = bi && bi.isDate, uE = bi && bi.isMap, dE = bi && bi.isRegExp, fE = bi && bi.isSet, pE = bi && bi.isTypedArray;
    function Yo(ye, Ne, Ie) {
      switch (Ie.length) {
        case 0:
          return ye.call(Ne);
        case 1:
          return ye.call(Ne, Ie[0]);
        case 2:
          return ye.call(Ne, Ie[0], Ie[1]);
        case 3:
          return ye.call(Ne, Ie[0], Ie[1], Ie[2]);
      }
      return ye.apply(Ne, Ie);
    }
    function ML(ye, Ne, Ie, pt) {
      for (var Ht = -1, mn = ye == null ? 0 : ye.length; ++Ht < mn; ) {
        var jr = ye[Ht];
        Ne(pt, jr, Ie(jr), ye);
      }
      return pt;
    }
    function yi(ye, Ne) {
      for (var Ie = -1, pt = ye == null ? 0 : ye.length; ++Ie < pt && Ne(ye[Ie], Ie, ye) !== !1; )
        ;
      return ye;
    }
    function AL(ye, Ne) {
      for (var Ie = ye == null ? 0 : ye.length; Ie-- && Ne(ye[Ie], Ie, ye) !== !1; )
        ;
      return ye;
    }
    function hE(ye, Ne) {
      for (var Ie = -1, pt = ye == null ? 0 : ye.length; ++Ie < pt; )
        if (!Ne(ye[Ie], Ie, ye))
          return !1;
      return !0;
    }
    function Ra(ye, Ne) {
      for (var Ie = -1, pt = ye == null ? 0 : ye.length, Ht = 0, mn = []; ++Ie < pt; ) {
        var jr = ye[Ie];
        Ne(jr, Ie, ye) && (mn[Ht++] = jr);
      }
      return mn;
    }
    function bh(ye, Ne) {
      var Ie = ye == null ? 0 : ye.length;
      return !!Ie && jc(ye, Ne, 0) > -1;
    }
    function Py(ye, Ne, Ie) {
      for (var pt = -1, Ht = ye == null ? 0 : ye.length; ++pt < Ht; )
        if (Ie(Ne, ye[pt]))
          return !0;
      return !1;
    }
    function tr(ye, Ne) {
      for (var Ie = -1, pt = ye == null ? 0 : ye.length, Ht = Array(pt); ++Ie < pt; )
        Ht[Ie] = Ne(ye[Ie], Ie, ye);
      return Ht;
    }
    function _a(ye, Ne) {
      for (var Ie = -1, pt = Ne.length, Ht = ye.length; ++Ie < pt; )
        ye[Ht + Ie] = Ne[Ie];
      return ye;
    }
    function Iy(ye, Ne, Ie, pt) {
      var Ht = -1, mn = ye == null ? 0 : ye.length;
      for (pt && mn && (Ie = ye[++Ht]); ++Ht < mn; )
        Ie = Ne(Ie, ye[Ht], Ht, ye);
      return Ie;
    }
    function DL(ye, Ne, Ie, pt) {
      var Ht = ye == null ? 0 : ye.length;
      for (pt && Ht && (Ie = ye[--Ht]); Ht--; )
        Ie = Ne(Ie, ye[Ht], Ht, ye);
      return Ie;
    }
    function Ry(ye, Ne) {
      for (var Ie = -1, pt = ye == null ? 0 : ye.length; ++Ie < pt; )
        if (Ne(ye[Ie], Ie, ye))
          return !0;
      return !1;
    }
    var NL = _y("length");
    function FL(ye) {
      return ye.split("");
    }
    function $L(ye) {
      return ye.match(Z) || [];
    }
    function gE(ye, Ne, Ie) {
      var pt;
      return Ie(ye, function(Ht, mn, jr) {
        if (Ne(Ht, mn, jr))
          return pt = mn, !1;
      }), pt;
    }
    function yh(ye, Ne, Ie, pt) {
      for (var Ht = ye.length, mn = Ie + (pt ? 1 : -1); pt ? mn-- : ++mn < Ht; )
        if (Ne(ye[mn], mn, ye))
          return mn;
      return -1;
    }
    function jc(ye, Ne, Ie) {
      return Ne === Ne ? YL(ye, Ne, Ie) : yh(ye, mE, Ie);
    }
    function LL(ye, Ne, Ie, pt) {
      for (var Ht = Ie - 1, mn = ye.length; ++Ht < mn; )
        if (pt(ye[Ht], Ne))
          return Ht;
      return -1;
    }
    function mE(ye) {
      return ye !== ye;
    }
    function bE(ye, Ne) {
      var Ie = ye == null ? 0 : ye.length;
      return Ie ? My(ye, Ne) / Ie : $;
    }
    function _y(ye) {
      return function(Ne) {
        return Ne == null ? n : Ne[ye];
      };
    }
    function ky(ye) {
      return function(Ne) {
        return ye == null ? n : ye[Ne];
      };
    }
    function yE(ye, Ne, Ie, pt, Ht) {
      return Ht(ye, function(mn, jr, Vn) {
        Ie = pt ? (pt = !1, mn) : Ne(Ie, mn, jr, Vn);
      }), Ie;
    }
    function jL(ye, Ne) {
      var Ie = ye.length;
      for (ye.sort(Ne); Ie--; )
        ye[Ie] = ye[Ie].value;
      return ye;
    }
    function My(ye, Ne) {
      for (var Ie, pt = -1, Ht = ye.length; ++pt < Ht; ) {
        var mn = Ne(ye[pt]);
        mn !== n && (Ie = Ie === n ? mn : Ie + mn);
      }
      return Ie;
    }
    function Ay(ye, Ne) {
      for (var Ie = -1, pt = Array(ye); ++Ie < ye; )
        pt[Ie] = Ne(Ie);
      return pt;
    }
    function BL(ye, Ne) {
      return tr(Ne, function(Ie) {
        return [Ie, ye[Ie]];
      });
    }
    function vE(ye) {
      return ye && ye.slice(0, SE(ye) + 1).replace(ze, "");
    }
    function Qo(ye) {
      return function(Ne) {
        return ye(Ne);
      };
    }
    function Dy(ye, Ne) {
      return tr(Ne, function(Ie) {
        return ye[Ie];
      });
    }
    function Vd(ye, Ne) {
      return ye.has(Ne);
    }
    function wE(ye, Ne) {
      for (var Ie = -1, pt = ye.length; ++Ie < pt && jc(Ne, ye[Ie], 0) > -1; )
        ;
      return Ie;
    }
    function CE(ye, Ne) {
      for (var Ie = ye.length; Ie-- && jc(Ne, ye[Ie], 0) > -1; )
        ;
      return Ie;
    }
    function VL(ye, Ne) {
      for (var Ie = ye.length, pt = 0; Ie--; )
        ye[Ie] === Ne && ++pt;
      return pt;
    }
    var HL = ky(TL), UL = ky(OL);
    function zL(ye) {
      return "\\" + IL[ye];
    }
    function GL(ye, Ne) {
      return ye == null ? n : ye[Ne];
    }
    function Bc(ye) {
      return CL.test(ye);
    }
    function WL(ye) {
      return xL.test(ye);
    }
    function qL(ye) {
      for (var Ne, Ie = []; !(Ne = ye.next()).done; )
        Ie.push(Ne.value);
      return Ie;
    }
    function Ny(ye) {
      var Ne = -1, Ie = Array(ye.size);
      return ye.forEach(function(pt, Ht) {
        Ie[++Ne] = [Ht, pt];
      }), Ie;
    }
    function xE(ye, Ne) {
      return function(Ie) {
        return ye(Ne(Ie));
      };
    }
    function ka(ye, Ne) {
      for (var Ie = -1, pt = ye.length, Ht = 0, mn = []; ++Ie < pt; ) {
        var jr = ye[Ie];
        (jr === Ne || jr === f) && (ye[Ie] = f, mn[Ht++] = Ie);
      }
      return mn;
    }
    function vh(ye) {
      var Ne = -1, Ie = Array(ye.size);
      return ye.forEach(function(pt) {
        Ie[++Ne] = pt;
      }), Ie;
    }
    function KL(ye) {
      var Ne = -1, Ie = Array(ye.size);
      return ye.forEach(function(pt) {
        Ie[++Ne] = [pt, pt];
      }), Ie;
    }
    function YL(ye, Ne, Ie) {
      for (var pt = Ie - 1, Ht = ye.length; ++pt < Ht; )
        if (ye[pt] === Ne)
          return pt;
      return -1;
    }
    function QL(ye, Ne, Ie) {
      for (var pt = Ie + 1; pt--; )
        if (ye[pt] === Ne)
          return pt;
      return pt;
    }
    function Vc(ye) {
      return Bc(ye) ? JL(ye) : NL(ye);
    }
    function Ui(ye) {
      return Bc(ye) ? ZL(ye) : FL(ye);
    }
    function SE(ye) {
      for (var Ne = ye.length; Ne-- && st.test(ye.charAt(Ne)); )
        ;
      return Ne;
    }
    var XL = ky(PL);
    function JL(ye) {
      for (var Ne = Ey.lastIndex = 0; Ey.test(ye); )
        ++Ne;
      return Ne;
    }
    function ZL(ye) {
      return ye.match(Ey) || [];
    }
    function ej(ye) {
      return ye.match(wL) || [];
    }
    var tj = function ye(Ne) {
      Ne = Ne == null ? to : Hc.defaults(to.Object(), Ne, Hc.pick(to, SL));
      var Ie = Ne.Array, pt = Ne.Date, Ht = Ne.Error, mn = Ne.Function, jr = Ne.Math, Vn = Ne.Object, Fy = Ne.RegExp, nj = Ne.String, vi = Ne.TypeError, wh = Ie.prototype, rj = mn.prototype, Uc = Vn.prototype, Ch = Ne["__core-js_shared__"], xh = rj.toString, In = Uc.hasOwnProperty, oj = 0, EE = function() {
        var u = /[^.]+$/.exec(Ch && Ch.keys && Ch.keys.IE_PROTO || "");
        return u ? "Symbol(src)_1." + u : "";
      }(), Sh = Uc.toString, ij = xh.call(Vn), sj = to._, aj = Fy(
        "^" + xh.call(In).replace(ve, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Eh = aE ? Ne.Buffer : n, Ma = Ne.Symbol, Th = Ne.Uint8Array, TE = Eh ? Eh.allocUnsafe : n, Oh = xE(Vn.getPrototypeOf, Vn), OE = Vn.create, PE = Uc.propertyIsEnumerable, Ph = wh.splice, IE = Ma ? Ma.isConcatSpreadable : n, Hd = Ma ? Ma.iterator : n, Ll = Ma ? Ma.toStringTag : n, Ih = function() {
        try {
          var u = Ul(Vn, "defineProperty");
          return u({}, "", {}), u;
        } catch {
        }
      }(), lj = Ne.clearTimeout !== to.clearTimeout && Ne.clearTimeout, cj = pt && pt.now !== to.Date.now && pt.now, uj = Ne.setTimeout !== to.setTimeout && Ne.setTimeout, Rh = jr.ceil, _h = jr.floor, $y = Vn.getOwnPropertySymbols, dj = Eh ? Eh.isBuffer : n, RE = Ne.isFinite, fj = wh.join, pj = xE(Vn.keys, Vn), Br = jr.max, co = jr.min, hj = pt.now, gj = Ne.parseInt, _E = jr.random, mj = wh.reverse, Ly = Ul(Ne, "DataView"), Ud = Ul(Ne, "Map"), jy = Ul(Ne, "Promise"), zc = Ul(Ne, "Set"), zd = Ul(Ne, "WeakMap"), Gd = Ul(Vn, "create"), kh = zd && new zd(), Gc = {}, bj = zl(Ly), yj = zl(Ud), vj = zl(jy), wj = zl(zc), Cj = zl(zd), Mh = Ma ? Ma.prototype : n, Wd = Mh ? Mh.valueOf : n, kE = Mh ? Mh.toString : n;
      function Y(u) {
        if (hr(u) && !Gt(u) && !(u instanceof sn)) {
          if (u instanceof wi)
            return u;
          if (In.call(u, "__wrapped__"))
            return MT(u);
        }
        return new wi(u);
      }
      var Wc = /* @__PURE__ */ function() {
        function u() {
        }
        return function(h) {
          if (!cr(h))
            return {};
          if (OE)
            return OE(h);
          u.prototype = h;
          var x = new u();
          return u.prototype = n, x;
        };
      }();
      function Ah() {
      }
      function wi(u, h) {
        this.__wrapped__ = u, this.__actions__ = [], this.__chain__ = !!h, this.__index__ = 0, this.__values__ = n;
      }
      Y.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Lr,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: lr,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: mt,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: Y
        }
      }, Y.prototype = Ah.prototype, Y.prototype.constructor = Y, wi.prototype = Wc(Ah.prototype), wi.prototype.constructor = wi;
      function sn(u) {
        this.__wrapped__ = u, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = z, this.__views__ = [];
      }
      function xj() {
        var u = new sn(this.__wrapped__);
        return u.__actions__ = ko(this.__actions__), u.__dir__ = this.__dir__, u.__filtered__ = this.__filtered__, u.__iteratees__ = ko(this.__iteratees__), u.__takeCount__ = this.__takeCount__, u.__views__ = ko(this.__views__), u;
      }
      function Sj() {
        if (this.__filtered__) {
          var u = new sn(this);
          u.__dir__ = -1, u.__filtered__ = !0;
        } else
          u = this.clone(), u.__dir__ *= -1;
        return u;
      }
      function Ej() {
        var u = this.__wrapped__.value(), h = this.__dir__, x = Gt(u), M = h < 0, G = x ? u.length : 0, X = F2(0, G, this.__views__), se = X.start, de = X.end, xe = de - se, Ve = M ? de : se - 1, He = this.__iteratees__, qe = He.length, ot = 0, Ot = co(xe, this.__takeCount__);
        if (!x || !M && G == xe && Ot == xe)
          return tT(u, this.__actions__);
        var Ft = [];
        e:
          for (; xe-- && ot < Ot; ) {
            Ve += h;
            for (var Yt = -1, $t = u[Ve]; ++Yt < qe; ) {
              var rn = He[Yt], an = rn.iteratee, Zo = rn.type, Co = an($t);
              if (Zo == k)
                $t = Co;
              else if (!Co) {
                if (Zo == H)
                  continue e;
                break e;
              }
            }
            Ft[ot++] = $t;
          }
        return Ft;
      }
      sn.prototype = Wc(Ah.prototype), sn.prototype.constructor = sn;
      function jl(u) {
        var h = -1, x = u == null ? 0 : u.length;
        for (this.clear(); ++h < x; ) {
          var M = u[h];
          this.set(M[0], M[1]);
        }
      }
      function Tj() {
        this.__data__ = Gd ? Gd(null) : {}, this.size = 0;
      }
      function Oj(u) {
        var h = this.has(u) && delete this.__data__[u];
        return this.size -= h ? 1 : 0, h;
      }
      function Pj(u) {
        var h = this.__data__;
        if (Gd) {
          var x = h[u];
          return x === c ? n : x;
        }
        return In.call(h, u) ? h[u] : n;
      }
      function Ij(u) {
        var h = this.__data__;
        return Gd ? h[u] !== n : In.call(h, u);
      }
      function Rj(u, h) {
        var x = this.__data__;
        return this.size += this.has(u) ? 0 : 1, x[u] = Gd && h === n ? c : h, this;
      }
      jl.prototype.clear = Tj, jl.prototype.delete = Oj, jl.prototype.get = Pj, jl.prototype.has = Ij, jl.prototype.set = Rj;
      function Ys(u) {
        var h = -1, x = u == null ? 0 : u.length;
        for (this.clear(); ++h < x; ) {
          var M = u[h];
          this.set(M[0], M[1]);
        }
      }
      function _j() {
        this.__data__ = [], this.size = 0;
      }
      function kj(u) {
        var h = this.__data__, x = Dh(h, u);
        if (x < 0)
          return !1;
        var M = h.length - 1;
        return x == M ? h.pop() : Ph.call(h, x, 1), --this.size, !0;
      }
      function Mj(u) {
        var h = this.__data__, x = Dh(h, u);
        return x < 0 ? n : h[x][1];
      }
      function Aj(u) {
        return Dh(this.__data__, u) > -1;
      }
      function Dj(u, h) {
        var x = this.__data__, M = Dh(x, u);
        return M < 0 ? (++this.size, x.push([u, h])) : x[M][1] = h, this;
      }
      Ys.prototype.clear = _j, Ys.prototype.delete = kj, Ys.prototype.get = Mj, Ys.prototype.has = Aj, Ys.prototype.set = Dj;
      function Qs(u) {
        var h = -1, x = u == null ? 0 : u.length;
        for (this.clear(); ++h < x; ) {
          var M = u[h];
          this.set(M[0], M[1]);
        }
      }
      function Nj() {
        this.size = 0, this.__data__ = {
          hash: new jl(),
          map: new (Ud || Ys)(),
          string: new jl()
        };
      }
      function Fj(u) {
        var h = Wh(this, u).delete(u);
        return this.size -= h ? 1 : 0, h;
      }
      function $j(u) {
        return Wh(this, u).get(u);
      }
      function Lj(u) {
        return Wh(this, u).has(u);
      }
      function jj(u, h) {
        var x = Wh(this, u), M = x.size;
        return x.set(u, h), this.size += x.size == M ? 0 : 1, this;
      }
      Qs.prototype.clear = Nj, Qs.prototype.delete = Fj, Qs.prototype.get = $j, Qs.prototype.has = Lj, Qs.prototype.set = jj;
      function Bl(u) {
        var h = -1, x = u == null ? 0 : u.length;
        for (this.__data__ = new Qs(); ++h < x; )
          this.add(u[h]);
      }
      function Bj(u) {
        return this.__data__.set(u, c), this;
      }
      function Vj(u) {
        return this.__data__.has(u);
      }
      Bl.prototype.add = Bl.prototype.push = Bj, Bl.prototype.has = Vj;
      function zi(u) {
        var h = this.__data__ = new Ys(u);
        this.size = h.size;
      }
      function Hj() {
        this.__data__ = new Ys(), this.size = 0;
      }
      function Uj(u) {
        var h = this.__data__, x = h.delete(u);
        return this.size = h.size, x;
      }
      function zj(u) {
        return this.__data__.get(u);
      }
      function Gj(u) {
        return this.__data__.has(u);
      }
      function Wj(u, h) {
        var x = this.__data__;
        if (x instanceof Ys) {
          var M = x.__data__;
          if (!Ud || M.length < o - 1)
            return M.push([u, h]), this.size = ++x.size, this;
          x = this.__data__ = new Qs(M);
        }
        return x.set(u, h), this.size = x.size, this;
      }
      zi.prototype.clear = Hj, zi.prototype.delete = Uj, zi.prototype.get = zj, zi.prototype.has = Gj, zi.prototype.set = Wj;
      function ME(u, h) {
        var x = Gt(u), M = !x && Gl(u), G = !x && !M && $a(u), X = !x && !M && !G && Qc(u), se = x || M || G || X, de = se ? Ay(u.length, nj) : [], xe = de.length;
        for (var Ve in u)
          (h || In.call(u, Ve)) && !(se && // Safari 9 has enumerable `arguments.length` in strict mode.
          (Ve == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          G && (Ve == "offset" || Ve == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          X && (Ve == "buffer" || Ve == "byteLength" || Ve == "byteOffset") || // Skip index properties.
          ea(Ve, xe))) && de.push(Ve);
        return de;
      }
      function AE(u) {
        var h = u.length;
        return h ? u[Qy(0, h - 1)] : n;
      }
      function qj(u, h) {
        return qh(ko(u), Vl(h, 0, u.length));
      }
      function Kj(u) {
        return qh(ko(u));
      }
      function By(u, h, x) {
        (x !== n && !Gi(u[h], x) || x === n && !(h in u)) && Xs(u, h, x);
      }
      function qd(u, h, x) {
        var M = u[h];
        (!(In.call(u, h) && Gi(M, x)) || x === n && !(h in u)) && Xs(u, h, x);
      }
      function Dh(u, h) {
        for (var x = u.length; x--; )
          if (Gi(u[x][0], h))
            return x;
        return -1;
      }
      function Yj(u, h, x, M) {
        return Aa(u, function(G, X, se) {
          h(M, G, x(G), se);
        }), M;
      }
      function DE(u, h) {
        return u && fs(h, qr(h), u);
      }
      function Qj(u, h) {
        return u && fs(h, Ao(h), u);
      }
      function Xs(u, h, x) {
        h == "__proto__" && Ih ? Ih(u, h, {
          configurable: !0,
          enumerable: !0,
          value: x,
          writable: !0
        }) : u[h] = x;
      }
      function Vy(u, h) {
        for (var x = -1, M = h.length, G = Ie(M), X = u == null; ++x < M; )
          G[x] = X ? n : Cv(u, h[x]);
        return G;
      }
      function Vl(u, h, x) {
        return u === u && (x !== n && (u = u <= x ? u : x), h !== n && (u = u >= h ? u : h)), u;
      }
      function Ci(u, h, x, M, G, X) {
        var se, de = h & p, xe = h & g, Ve = h & b;
        if (x && (se = G ? x(u, M, G, X) : x(u)), se !== n)
          return se;
        if (!cr(u))
          return u;
        var He = Gt(u);
        if (He) {
          if (se = L2(u), !de)
            return ko(u, se);
        } else {
          var qe = uo(u), ot = qe == q || qe == Ee;
          if ($a(u))
            return oT(u, de);
          if (qe == Ze || qe == re || ot && !G) {
            if (se = xe || ot ? {} : ST(u), !de)
              return xe ? P2(u, Qj(se, u)) : O2(u, DE(se, u));
          } else {
            if (!qn[qe])
              return G ? u : {};
            se = j2(u, qe, de);
          }
        }
        X || (X = new zi());
        var Ot = X.get(u);
        if (Ot)
          return Ot;
        X.set(u, se), JT(u) ? u.forEach(function($t) {
          se.add(Ci($t, h, x, $t, u, X));
        }) : QT(u) && u.forEach(function($t, rn) {
          se.set(rn, Ci($t, h, x, rn, u, X));
        });
        var Ft = Ve ? xe ? av : sv : xe ? Ao : qr, Yt = He ? n : Ft(u);
        return yi(Yt || u, function($t, rn) {
          Yt && (rn = $t, $t = u[rn]), qd(se, rn, Ci($t, h, x, rn, u, X));
        }), se;
      }
      function Xj(u) {
        var h = qr(u);
        return function(x) {
          return NE(x, u, h);
        };
      }
      function NE(u, h, x) {
        var M = x.length;
        if (u == null)
          return !M;
        for (u = Vn(u); M--; ) {
          var G = x[M], X = h[G], se = u[G];
          if (se === n && !(G in u) || !X(se))
            return !1;
        }
        return !0;
      }
      function FE(u, h, x) {
        if (typeof u != "function")
          throw new vi(a);
        return ef(function() {
          u.apply(n, x);
        }, h);
      }
      function Kd(u, h, x, M) {
        var G = -1, X = bh, se = !0, de = u.length, xe = [], Ve = h.length;
        if (!de)
          return xe;
        x && (h = tr(h, Qo(x))), M ? (X = Py, se = !1) : h.length >= o && (X = Vd, se = !1, h = new Bl(h));
        e:
          for (; ++G < de; ) {
            var He = u[G], qe = x == null ? He : x(He);
            if (He = M || He !== 0 ? He : 0, se && qe === qe) {
              for (var ot = Ve; ot--; )
                if (h[ot] === qe)
                  continue e;
              xe.push(He);
            } else X(h, qe, M) || xe.push(He);
          }
        return xe;
      }
      var Aa = cT(ds), $E = cT(Uy, !0);
      function Jj(u, h) {
        var x = !0;
        return Aa(u, function(M, G, X) {
          return x = !!h(M, G, X), x;
        }), x;
      }
      function Nh(u, h, x) {
        for (var M = -1, G = u.length; ++M < G; ) {
          var X = u[M], se = h(X);
          if (se != null && (de === n ? se === se && !Jo(se) : x(se, de)))
            var de = se, xe = X;
        }
        return xe;
      }
      function Zj(u, h, x, M) {
        var G = u.length;
        for (x = Kt(x), x < 0 && (x = -x > G ? 0 : G + x), M = M === n || M > G ? G : Kt(M), M < 0 && (M += G), M = x > M ? 0 : e1(M); x < M; )
          u[x++] = h;
        return u;
      }
      function LE(u, h) {
        var x = [];
        return Aa(u, function(M, G, X) {
          h(M, G, X) && x.push(M);
        }), x;
      }
      function no(u, h, x, M, G) {
        var X = -1, se = u.length;
        for (x || (x = V2), G || (G = []); ++X < se; ) {
          var de = u[X];
          h > 0 && x(de) ? h > 1 ? no(de, h - 1, x, M, G) : _a(G, de) : M || (G[G.length] = de);
        }
        return G;
      }
      var Hy = uT(), jE = uT(!0);
      function ds(u, h) {
        return u && Hy(u, h, qr);
      }
      function Uy(u, h) {
        return u && jE(u, h, qr);
      }
      function Fh(u, h) {
        return Ra(h, function(x) {
          return ta(u[x]);
        });
      }
      function Hl(u, h) {
        h = Na(h, u);
        for (var x = 0, M = h.length; u != null && x < M; )
          u = u[ps(h[x++])];
        return x && x == M ? u : n;
      }
      function BE(u, h, x) {
        var M = h(u);
        return Gt(u) ? M : _a(M, x(u));
      }
      function vo(u) {
        return u == null ? u === n ? Pe : Le : Ll && Ll in Vn(u) ? N2(u) : K2(u);
      }
      function zy(u, h) {
        return u > h;
      }
      function e2(u, h) {
        return u != null && In.call(u, h);
      }
      function t2(u, h) {
        return u != null && h in Vn(u);
      }
      function n2(u, h, x) {
        return u >= co(h, x) && u < Br(h, x);
      }
      function Gy(u, h, x) {
        for (var M = x ? Py : bh, G = u[0].length, X = u.length, se = X, de = Ie(X), xe = 1 / 0, Ve = []; se--; ) {
          var He = u[se];
          se && h && (He = tr(He, Qo(h))), xe = co(He.length, xe), de[se] = !x && (h || G >= 120 && He.length >= 120) ? new Bl(se && He) : n;
        }
        He = u[0];
        var qe = -1, ot = de[0];
        e:
          for (; ++qe < G && Ve.length < xe; ) {
            var Ot = He[qe], Ft = h ? h(Ot) : Ot;
            if (Ot = x || Ot !== 0 ? Ot : 0, !(ot ? Vd(ot, Ft) : M(Ve, Ft, x))) {
              for (se = X; --se; ) {
                var Yt = de[se];
                if (!(Yt ? Vd(Yt, Ft) : M(u[se], Ft, x)))
                  continue e;
              }
              ot && ot.push(Ft), Ve.push(Ot);
            }
          }
        return Ve;
      }
      function r2(u, h, x, M) {
        return ds(u, function(G, X, se) {
          h(M, x(G), X, se);
        }), M;
      }
      function Yd(u, h, x) {
        h = Na(h, u), u = PT(u, h);
        var M = u == null ? u : u[ps(Si(h))];
        return M == null ? n : Yo(M, u, x);
      }
      function VE(u) {
        return hr(u) && vo(u) == re;
      }
      function o2(u) {
        return hr(u) && vo(u) == je;
      }
      function i2(u) {
        return hr(u) && vo(u) == ce;
      }
      function Qd(u, h, x, M, G) {
        return u === h ? !0 : u == null || h == null || !hr(u) && !hr(h) ? u !== u && h !== h : s2(u, h, x, M, Qd, G);
      }
      function s2(u, h, x, M, G, X) {
        var se = Gt(u), de = Gt(h), xe = se ? te : uo(u), Ve = de ? te : uo(h);
        xe = xe == re ? Ze : xe, Ve = Ve == re ? Ze : Ve;
        var He = xe == Ze, qe = Ve == Ze, ot = xe == Ve;
        if (ot && $a(u)) {
          if (!$a(h))
            return !1;
          se = !0, He = !1;
        }
        if (ot && !He)
          return X || (X = new zi()), se || Qc(u) ? wT(u, h, x, M, G, X) : A2(u, h, xe, x, M, G, X);
        if (!(x & v)) {
          var Ot = He && In.call(u, "__wrapped__"), Ft = qe && In.call(h, "__wrapped__");
          if (Ot || Ft) {
            var Yt = Ot ? u.value() : u, $t = Ft ? h.value() : h;
            return X || (X = new zi()), G(Yt, $t, x, M, X);
          }
        }
        return ot ? (X || (X = new zi()), D2(u, h, x, M, G, X)) : !1;
      }
      function a2(u) {
        return hr(u) && uo(u) == _e;
      }
      function Wy(u, h, x, M) {
        var G = x.length, X = G, se = !M;
        if (u == null)
          return !X;
        for (u = Vn(u); G--; ) {
          var de = x[G];
          if (se && de[2] ? de[1] !== u[de[0]] : !(de[0] in u))
            return !1;
        }
        for (; ++G < X; ) {
          de = x[G];
          var xe = de[0], Ve = u[xe], He = de[1];
          if (se && de[2]) {
            if (Ve === n && !(xe in u))
              return !1;
          } else {
            var qe = new zi();
            if (M)
              var ot = M(Ve, He, xe, u, h, qe);
            if (!(ot === n ? Qd(He, Ve, v | y, M, qe) : ot))
              return !1;
          }
        }
        return !0;
      }
      function HE(u) {
        if (!cr(u) || U2(u))
          return !1;
        var h = ta(u) ? aj : Ue;
        return h.test(zl(u));
      }
      function l2(u) {
        return hr(u) && vo(u) == me;
      }
      function c2(u) {
        return hr(u) && uo(u) == Oe;
      }
      function u2(u) {
        return hr(u) && Zh(u.length) && !!Xn[vo(u)];
      }
      function UE(u) {
        return typeof u == "function" ? u : u == null ? Do : typeof u == "object" ? Gt(u) ? WE(u[0], u[1]) : GE(u) : d1(u);
      }
      function qy(u) {
        if (!Zd(u))
          return pj(u);
        var h = [];
        for (var x in Vn(u))
          In.call(u, x) && x != "constructor" && h.push(x);
        return h;
      }
      function d2(u) {
        if (!cr(u))
          return q2(u);
        var h = Zd(u), x = [];
        for (var M in u)
          M == "constructor" && (h || !In.call(u, M)) || x.push(M);
        return x;
      }
      function Ky(u, h) {
        return u < h;
      }
      function zE(u, h) {
        var x = -1, M = Mo(u) ? Ie(u.length) : [];
        return Aa(u, function(G, X, se) {
          M[++x] = h(G, X, se);
        }), M;
      }
      function GE(u) {
        var h = cv(u);
        return h.length == 1 && h[0][2] ? TT(h[0][0], h[0][1]) : function(x) {
          return x === u || Wy(x, u, h);
        };
      }
      function WE(u, h) {
        return dv(u) && ET(h) ? TT(ps(u), h) : function(x) {
          var M = Cv(x, u);
          return M === n && M === h ? xv(x, u) : Qd(h, M, v | y);
        };
      }
      function $h(u, h, x, M, G) {
        u !== h && Hy(h, function(X, se) {
          if (G || (G = new zi()), cr(X))
            f2(u, h, se, x, $h, M, G);
          else {
            var de = M ? M(pv(u, se), X, se + "", u, h, G) : n;
            de === n && (de = X), By(u, se, de);
          }
        }, Ao);
      }
      function f2(u, h, x, M, G, X, se) {
        var de = pv(u, x), xe = pv(h, x), Ve = se.get(xe);
        if (Ve) {
          By(u, x, Ve);
          return;
        }
        var He = X ? X(de, xe, x + "", u, h, se) : n, qe = He === n;
        if (qe) {
          var ot = Gt(xe), Ot = !ot && $a(xe), Ft = !ot && !Ot && Qc(xe);
          He = xe, ot || Ot || Ft ? Gt(de) ? He = de : Er(de) ? He = ko(de) : Ot ? (qe = !1, He = oT(xe, !0)) : Ft ? (qe = !1, He = iT(xe, !0)) : He = [] : tf(xe) || Gl(xe) ? (He = de, Gl(de) ? He = t1(de) : (!cr(de) || ta(de)) && (He = ST(xe))) : qe = !1;
        }
        qe && (se.set(xe, He), G(He, xe, M, X, se), se.delete(xe)), By(u, x, He);
      }
      function qE(u, h) {
        var x = u.length;
        if (x)
          return h += h < 0 ? x : 0, ea(h, x) ? u[h] : n;
      }
      function KE(u, h, x) {
        h.length ? h = tr(h, function(X) {
          return Gt(X) ? function(se) {
            return Hl(se, X.length === 1 ? X[0] : X);
          } : X;
        }) : h = [Do];
        var M = -1;
        h = tr(h, Qo(Nt()));
        var G = zE(u, function(X, se, de) {
          var xe = tr(h, function(Ve) {
            return Ve(X);
          });
          return { criteria: xe, index: ++M, value: X };
        });
        return jL(G, function(X, se) {
          return T2(X, se, x);
        });
      }
      function p2(u, h) {
        return YE(u, h, function(x, M) {
          return xv(u, M);
        });
      }
      function YE(u, h, x) {
        for (var M = -1, G = h.length, X = {}; ++M < G; ) {
          var se = h[M], de = Hl(u, se);
          x(de, se) && Xd(X, Na(se, u), de);
        }
        return X;
      }
      function h2(u) {
        return function(h) {
          return Hl(h, u);
        };
      }
      function Yy(u, h, x, M) {
        var G = M ? LL : jc, X = -1, se = h.length, de = u;
        for (u === h && (h = ko(h)), x && (de = tr(u, Qo(x))); ++X < se; )
          for (var xe = 0, Ve = h[X], He = x ? x(Ve) : Ve; (xe = G(de, He, xe, M)) > -1; )
            de !== u && Ph.call(de, xe, 1), Ph.call(u, xe, 1);
        return u;
      }
      function QE(u, h) {
        for (var x = u ? h.length : 0, M = x - 1; x--; ) {
          var G = h[x];
          if (x == M || G !== X) {
            var X = G;
            ea(G) ? Ph.call(u, G, 1) : Zy(u, G);
          }
        }
        return u;
      }
      function Qy(u, h) {
        return u + _h(_E() * (h - u + 1));
      }
      function g2(u, h, x, M) {
        for (var G = -1, X = Br(Rh((h - u) / (x || 1)), 0), se = Ie(X); X--; )
          se[M ? X : ++G] = u, u += x;
        return se;
      }
      function Xy(u, h) {
        var x = "";
        if (!u || h < 1 || h > W)
          return x;
        do
          h % 2 && (x += u), h = _h(h / 2), h && (u += u);
        while (h);
        return x;
      }
      function Zt(u, h) {
        return hv(OT(u, h, Do), u + "");
      }
      function m2(u) {
        return AE(Xc(u));
      }
      function b2(u, h) {
        var x = Xc(u);
        return qh(x, Vl(h, 0, x.length));
      }
      function Xd(u, h, x, M) {
        if (!cr(u))
          return u;
        h = Na(h, u);
        for (var G = -1, X = h.length, se = X - 1, de = u; de != null && ++G < X; ) {
          var xe = ps(h[G]), Ve = x;
          if (xe === "__proto__" || xe === "constructor" || xe === "prototype")
            return u;
          if (G != se) {
            var He = de[xe];
            Ve = M ? M(He, xe, de) : n, Ve === n && (Ve = cr(He) ? He : ea(h[G + 1]) ? [] : {});
          }
          qd(de, xe, Ve), de = de[xe];
        }
        return u;
      }
      var XE = kh ? function(u, h) {
        return kh.set(u, h), u;
      } : Do, y2 = Ih ? function(u, h) {
        return Ih(u, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Ev(h),
          writable: !0
        });
      } : Do;
      function v2(u) {
        return qh(Xc(u));
      }
      function xi(u, h, x) {
        var M = -1, G = u.length;
        h < 0 && (h = -h > G ? 0 : G + h), x = x > G ? G : x, x < 0 && (x += G), G = h > x ? 0 : x - h >>> 0, h >>>= 0;
        for (var X = Ie(G); ++M < G; )
          X[M] = u[M + h];
        return X;
      }
      function w2(u, h) {
        var x;
        return Aa(u, function(M, G, X) {
          return x = h(M, G, X), !x;
        }), !!x;
      }
      function Lh(u, h, x) {
        var M = 0, G = u == null ? M : u.length;
        if (typeof h == "number" && h === h && G <= K) {
          for (; M < G; ) {
            var X = M + G >>> 1, se = u[X];
            se !== null && !Jo(se) && (x ? se <= h : se < h) ? M = X + 1 : G = X;
          }
          return G;
        }
        return Jy(u, h, Do, x);
      }
      function Jy(u, h, x, M) {
        var G = 0, X = u == null ? 0 : u.length;
        if (X === 0)
          return 0;
        h = x(h);
        for (var se = h !== h, de = h === null, xe = Jo(h), Ve = h === n; G < X; ) {
          var He = _h((G + X) / 2), qe = x(u[He]), ot = qe !== n, Ot = qe === null, Ft = qe === qe, Yt = Jo(qe);
          if (se)
            var $t = M || Ft;
          else Ve ? $t = Ft && (M || ot) : de ? $t = Ft && ot && (M || !Ot) : xe ? $t = Ft && ot && !Ot && (M || !Yt) : Ot || Yt ? $t = !1 : $t = M ? qe <= h : qe < h;
          $t ? G = He + 1 : X = He;
        }
        return co(X, ne);
      }
      function JE(u, h) {
        for (var x = -1, M = u.length, G = 0, X = []; ++x < M; ) {
          var se = u[x], de = h ? h(se) : se;
          if (!x || !Gi(de, xe)) {
            var xe = de;
            X[G++] = se === 0 ? 0 : se;
          }
        }
        return X;
      }
      function ZE(u) {
        return typeof u == "number" ? u : Jo(u) ? $ : +u;
      }
      function Xo(u) {
        if (typeof u == "string")
          return u;
        if (Gt(u))
          return tr(u, Xo) + "";
        if (Jo(u))
          return kE ? kE.call(u) : "";
        var h = u + "";
        return h == "0" && 1 / u == -j ? "-0" : h;
      }
      function Da(u, h, x) {
        var M = -1, G = bh, X = u.length, se = !0, de = [], xe = de;
        if (x)
          se = !1, G = Py;
        else if (X >= o) {
          var Ve = h ? null : k2(u);
          if (Ve)
            return vh(Ve);
          se = !1, G = Vd, xe = new Bl();
        } else
          xe = h ? [] : de;
        e:
          for (; ++M < X; ) {
            var He = u[M], qe = h ? h(He) : He;
            if (He = x || He !== 0 ? He : 0, se && qe === qe) {
              for (var ot = xe.length; ot--; )
                if (xe[ot] === qe)
                  continue e;
              h && xe.push(qe), de.push(He);
            } else G(xe, qe, x) || (xe !== de && xe.push(qe), de.push(He));
          }
        return de;
      }
      function Zy(u, h) {
        return h = Na(h, u), u = PT(u, h), u == null || delete u[ps(Si(h))];
      }
      function eT(u, h, x, M) {
        return Xd(u, h, x(Hl(u, h)), M);
      }
      function jh(u, h, x, M) {
        for (var G = u.length, X = M ? G : -1; (M ? X-- : ++X < G) && h(u[X], X, u); )
          ;
        return x ? xi(u, M ? 0 : X, M ? X + 1 : G) : xi(u, M ? X + 1 : 0, M ? G : X);
      }
      function tT(u, h) {
        var x = u;
        return x instanceof sn && (x = x.value()), Iy(h, function(M, G) {
          return G.func.apply(G.thisArg, _a([M], G.args));
        }, x);
      }
      function ev(u, h, x) {
        var M = u.length;
        if (M < 2)
          return M ? Da(u[0]) : [];
        for (var G = -1, X = Ie(M); ++G < M; )
          for (var se = u[G], de = -1; ++de < M; )
            de != G && (X[G] = Kd(X[G] || se, u[de], h, x));
        return Da(no(X, 1), h, x);
      }
      function nT(u, h, x) {
        for (var M = -1, G = u.length, X = h.length, se = {}; ++M < G; ) {
          var de = M < X ? h[M] : n;
          x(se, u[M], de);
        }
        return se;
      }
      function tv(u) {
        return Er(u) ? u : [];
      }
      function nv(u) {
        return typeof u == "function" ? u : Do;
      }
      function Na(u, h) {
        return Gt(u) ? u : dv(u, h) ? [u] : kT(wn(u));
      }
      var C2 = Zt;
      function Fa(u, h, x) {
        var M = u.length;
        return x = x === n ? M : x, !h && x >= M ? u : xi(u, h, x);
      }
      var rT = lj || function(u) {
        return to.clearTimeout(u);
      };
      function oT(u, h) {
        if (h)
          return u.slice();
        var x = u.length, M = TE ? TE(x) : new u.constructor(x);
        return u.copy(M), M;
      }
      function rv(u) {
        var h = new u.constructor(u.byteLength);
        return new Th(h).set(new Th(u)), h;
      }
      function x2(u, h) {
        var x = h ? rv(u.buffer) : u.buffer;
        return new u.constructor(x, u.byteOffset, u.byteLength);
      }
      function S2(u) {
        var h = new u.constructor(u.source, he.exec(u));
        return h.lastIndex = u.lastIndex, h;
      }
      function E2(u) {
        return Wd ? Vn(Wd.call(u)) : {};
      }
      function iT(u, h) {
        var x = h ? rv(u.buffer) : u.buffer;
        return new u.constructor(x, u.byteOffset, u.length);
      }
      function sT(u, h) {
        if (u !== h) {
          var x = u !== n, M = u === null, G = u === u, X = Jo(u), se = h !== n, de = h === null, xe = h === h, Ve = Jo(h);
          if (!de && !Ve && !X && u > h || X && se && xe && !de && !Ve || M && se && xe || !x && xe || !G)
            return 1;
          if (!M && !X && !Ve && u < h || Ve && x && G && !M && !X || de && x && G || !se && G || !xe)
            return -1;
        }
        return 0;
      }
      function T2(u, h, x) {
        for (var M = -1, G = u.criteria, X = h.criteria, se = G.length, de = x.length; ++M < se; ) {
          var xe = sT(G[M], X[M]);
          if (xe) {
            if (M >= de)
              return xe;
            var Ve = x[M];
            return xe * (Ve == "desc" ? -1 : 1);
          }
        }
        return u.index - h.index;
      }
      function aT(u, h, x, M) {
        for (var G = -1, X = u.length, se = x.length, de = -1, xe = h.length, Ve = Br(X - se, 0), He = Ie(xe + Ve), qe = !M; ++de < xe; )
          He[de] = h[de];
        for (; ++G < se; )
          (qe || G < X) && (He[x[G]] = u[G]);
        for (; Ve--; )
          He[de++] = u[G++];
        return He;
      }
      function lT(u, h, x, M) {
        for (var G = -1, X = u.length, se = -1, de = x.length, xe = -1, Ve = h.length, He = Br(X - de, 0), qe = Ie(He + Ve), ot = !M; ++G < He; )
          qe[G] = u[G];
        for (var Ot = G; ++xe < Ve; )
          qe[Ot + xe] = h[xe];
        for (; ++se < de; )
          (ot || G < X) && (qe[Ot + x[se]] = u[G++]);
        return qe;
      }
      function ko(u, h) {
        var x = -1, M = u.length;
        for (h || (h = Ie(M)); ++x < M; )
          h[x] = u[x];
        return h;
      }
      function fs(u, h, x, M) {
        var G = !x;
        x || (x = {});
        for (var X = -1, se = h.length; ++X < se; ) {
          var de = h[X], xe = M ? M(x[de], u[de], de, x, u) : n;
          xe === n && (xe = u[de]), G ? Xs(x, de, xe) : qd(x, de, xe);
        }
        return x;
      }
      function O2(u, h) {
        return fs(u, uv(u), h);
      }
      function P2(u, h) {
        return fs(u, CT(u), h);
      }
      function Bh(u, h) {
        return function(x, M) {
          var G = Gt(x) ? ML : Yj, X = h ? h() : {};
          return G(x, u, Nt(M, 2), X);
        };
      }
      function qc(u) {
        return Zt(function(h, x) {
          var M = -1, G = x.length, X = G > 1 ? x[G - 1] : n, se = G > 2 ? x[2] : n;
          for (X = u.length > 3 && typeof X == "function" ? (G--, X) : n, se && wo(x[0], x[1], se) && (X = G < 3 ? n : X, G = 1), h = Vn(h); ++M < G; ) {
            var de = x[M];
            de && u(h, de, M, X);
          }
          return h;
        });
      }
      function cT(u, h) {
        return function(x, M) {
          if (x == null)
            return x;
          if (!Mo(x))
            return u(x, M);
          for (var G = x.length, X = h ? G : -1, se = Vn(x); (h ? X-- : ++X < G) && M(se[X], X, se) !== !1; )
            ;
          return x;
        };
      }
      function uT(u) {
        return function(h, x, M) {
          for (var G = -1, X = Vn(h), se = M(h), de = se.length; de--; ) {
            var xe = se[u ? de : ++G];
            if (x(X[xe], xe, X) === !1)
              break;
          }
          return h;
        };
      }
      function I2(u, h, x) {
        var M = h & S, G = Jd(u);
        function X() {
          var se = this && this !== to && this instanceof X ? G : u;
          return se.apply(M ? x : this, arguments);
        }
        return X;
      }
      function dT(u) {
        return function(h) {
          h = wn(h);
          var x = Bc(h) ? Ui(h) : n, M = x ? x[0] : h.charAt(0), G = x ? Fa(x, 1).join("") : h.slice(1);
          return M[u]() + G;
        };
      }
      function Kc(u) {
        return function(h) {
          return Iy(c1(l1(h).replace(yL, "")), u, "");
        };
      }
      function Jd(u) {
        return function() {
          var h = arguments;
          switch (h.length) {
            case 0:
              return new u();
            case 1:
              return new u(h[0]);
            case 2:
              return new u(h[0], h[1]);
            case 3:
              return new u(h[0], h[1], h[2]);
            case 4:
              return new u(h[0], h[1], h[2], h[3]);
            case 5:
              return new u(h[0], h[1], h[2], h[3], h[4]);
            case 6:
              return new u(h[0], h[1], h[2], h[3], h[4], h[5]);
            case 7:
              return new u(h[0], h[1], h[2], h[3], h[4], h[5], h[6]);
          }
          var x = Wc(u.prototype), M = u.apply(x, h);
          return cr(M) ? M : x;
        };
      }
      function R2(u, h, x) {
        var M = Jd(u);
        function G() {
          for (var X = arguments.length, se = Ie(X), de = X, xe = Yc(G); de--; )
            se[de] = arguments[de];
          var Ve = X < 3 && se[0] !== xe && se[X - 1] !== xe ? [] : ka(se, xe);
          if (X -= Ve.length, X < x)
            return mT(
              u,
              h,
              Vh,
              G.placeholder,
              n,
              se,
              Ve,
              n,
              n,
              x - X
            );
          var He = this && this !== to && this instanceof G ? M : u;
          return Yo(He, this, se);
        }
        return G;
      }
      function fT(u) {
        return function(h, x, M) {
          var G = Vn(h);
          if (!Mo(h)) {
            var X = Nt(x, 3);
            h = qr(h), x = function(de) {
              return X(G[de], de, G);
            };
          }
          var se = u(h, x, M);
          return se > -1 ? G[X ? h[se] : se] : n;
        };
      }
      function pT(u) {
        return Zs(function(h) {
          var x = h.length, M = x, G = wi.prototype.thru;
          for (u && h.reverse(); M--; ) {
            var X = h[M];
            if (typeof X != "function")
              throw new vi(a);
            if (G && !se && Gh(X) == "wrapper")
              var se = new wi([], !0);
          }
          for (M = se ? M : x; ++M < x; ) {
            X = h[M];
            var de = Gh(X), xe = de == "wrapper" ? lv(X) : n;
            xe && fv(xe[0]) && xe[1] == (F | O | P | A) && !xe[4].length && xe[9] == 1 ? se = se[Gh(xe[0])].apply(se, xe[3]) : se = X.length == 1 && fv(X) ? se[de]() : se.thru(X);
          }
          return function() {
            var Ve = arguments, He = Ve[0];
            if (se && Ve.length == 1 && Gt(He))
              return se.plant(He).value();
            for (var qe = 0, ot = x ? h[qe].apply(this, Ve) : He; ++qe < x; )
              ot = h[qe].call(this, ot);
            return ot;
          };
        });
      }
      function Vh(u, h, x, M, G, X, se, de, xe, Ve) {
        var He = h & F, qe = h & S, ot = h & E, Ot = h & (O | T), Ft = h & _, Yt = ot ? n : Jd(u);
        function $t() {
          for (var rn = arguments.length, an = Ie(rn), Zo = rn; Zo--; )
            an[Zo] = arguments[Zo];
          if (Ot)
            var Co = Yc($t), ei = VL(an, Co);
          if (M && (an = aT(an, M, G, Ot)), X && (an = lT(an, X, se, Ot)), rn -= ei, Ot && rn < Ve) {
            var Tr = ka(an, Co);
            return mT(
              u,
              h,
              Vh,
              $t.placeholder,
              x,
              an,
              Tr,
              de,
              xe,
              Ve - rn
            );
          }
          var Wi = qe ? x : this, ra = ot ? Wi[u] : u;
          return rn = an.length, de ? an = Y2(an, de) : Ft && rn > 1 && an.reverse(), He && xe < rn && (an.length = xe), this && this !== to && this instanceof $t && (ra = Yt || Jd(ra)), ra.apply(Wi, an);
        }
        return $t;
      }
      function hT(u, h) {
        return function(x, M) {
          return r2(x, u, h(M), {});
        };
      }
      function Hh(u, h) {
        return function(x, M) {
          var G;
          if (x === n && M === n)
            return h;
          if (x !== n && (G = x), M !== n) {
            if (G === n)
              return M;
            typeof x == "string" || typeof M == "string" ? (x = Xo(x), M = Xo(M)) : (x = ZE(x), M = ZE(M)), G = u(x, M);
          }
          return G;
        };
      }
      function ov(u) {
        return Zs(function(h) {
          return h = tr(h, Qo(Nt())), Zt(function(x) {
            var M = this;
            return u(h, function(G) {
              return Yo(G, M, x);
            });
          });
        });
      }
      function Uh(u, h) {
        h = h === n ? " " : Xo(h);
        var x = h.length;
        if (x < 2)
          return x ? Xy(h, u) : h;
        var M = Xy(h, Rh(u / Vc(h)));
        return Bc(h) ? Fa(Ui(M), 0, u).join("") : M.slice(0, u);
      }
      function _2(u, h, x, M) {
        var G = h & S, X = Jd(u);
        function se() {
          for (var de = -1, xe = arguments.length, Ve = -1, He = M.length, qe = Ie(He + xe), ot = this && this !== to && this instanceof se ? X : u; ++Ve < He; )
            qe[Ve] = M[Ve];
          for (; xe--; )
            qe[Ve++] = arguments[++de];
          return Yo(ot, G ? x : this, qe);
        }
        return se;
      }
      function gT(u) {
        return function(h, x, M) {
          return M && typeof M != "number" && wo(h, x, M) && (x = M = n), h = na(h), x === n ? (x = h, h = 0) : x = na(x), M = M === n ? h < x ? 1 : -1 : na(M), g2(h, x, M, u);
        };
      }
      function zh(u) {
        return function(h, x) {
          return typeof h == "string" && typeof x == "string" || (h = Ei(h), x = Ei(x)), u(h, x);
        };
      }
      function mT(u, h, x, M, G, X, se, de, xe, Ve) {
        var He = h & O, qe = He ? se : n, ot = He ? n : se, Ot = He ? X : n, Ft = He ? n : X;
        h |= He ? P : R, h &= ~(He ? R : P), h & I || (h &= ~(S | E));
        var Yt = [
          u,
          h,
          G,
          Ot,
          qe,
          Ft,
          ot,
          de,
          xe,
          Ve
        ], $t = x.apply(n, Yt);
        return fv(u) && IT($t, Yt), $t.placeholder = M, RT($t, u, h);
      }
      function iv(u) {
        var h = jr[u];
        return function(x, M) {
          if (x = Ei(x), M = M == null ? 0 : co(Kt(M), 292), M && RE(x)) {
            var G = (wn(x) + "e").split("e"), X = h(G[0] + "e" + (+G[1] + M));
            return G = (wn(X) + "e").split("e"), +(G[0] + "e" + (+G[1] - M));
          }
          return h(x);
        };
      }
      var k2 = zc && 1 / vh(new zc([, -0]))[1] == j ? function(u) {
        return new zc(u);
      } : Pv;
      function bT(u) {
        return function(h) {
          var x = uo(h);
          return x == _e ? Ny(h) : x == Oe ? KL(h) : BL(h, u(h));
        };
      }
      function Js(u, h, x, M, G, X, se, de) {
        var xe = h & E;
        if (!xe && typeof u != "function")
          throw new vi(a);
        var Ve = M ? M.length : 0;
        if (Ve || (h &= ~(P | R), M = G = n), se = se === n ? se : Br(Kt(se), 0), de = de === n ? de : Kt(de), Ve -= G ? G.length : 0, h & R) {
          var He = M, qe = G;
          M = G = n;
        }
        var ot = xe ? n : lv(u), Ot = [
          u,
          h,
          x,
          M,
          G,
          He,
          qe,
          X,
          se,
          de
        ];
        if (ot && W2(Ot, ot), u = Ot[0], h = Ot[1], x = Ot[2], M = Ot[3], G = Ot[4], de = Ot[9] = Ot[9] === n ? xe ? 0 : u.length : Br(Ot[9] - Ve, 0), !de && h & (O | T) && (h &= ~(O | T)), !h || h == S)
          var Ft = I2(u, h, x);
        else h == O || h == T ? Ft = R2(u, h, de) : (h == P || h == (S | P)) && !G.length ? Ft = _2(u, h, x, M) : Ft = Vh.apply(n, Ot);
        var Yt = ot ? XE : IT;
        return RT(Yt(Ft, Ot), u, h);
      }
      function yT(u, h, x, M) {
        return u === n || Gi(u, Uc[x]) && !In.call(M, x) ? h : u;
      }
      function vT(u, h, x, M, G, X) {
        return cr(u) && cr(h) && (X.set(h, u), $h(u, h, n, vT, X), X.delete(h)), u;
      }
      function M2(u) {
        return tf(u) ? n : u;
      }
      function wT(u, h, x, M, G, X) {
        var se = x & v, de = u.length, xe = h.length;
        if (de != xe && !(se && xe > de))
          return !1;
        var Ve = X.get(u), He = X.get(h);
        if (Ve && He)
          return Ve == h && He == u;
        var qe = -1, ot = !0, Ot = x & y ? new Bl() : n;
        for (X.set(u, h), X.set(h, u); ++qe < de; ) {
          var Ft = u[qe], Yt = h[qe];
          if (M)
            var $t = se ? M(Yt, Ft, qe, h, u, X) : M(Ft, Yt, qe, u, h, X);
          if ($t !== n) {
            if ($t)
              continue;
            ot = !1;
            break;
          }
          if (Ot) {
            if (!Ry(h, function(rn, an) {
              if (!Vd(Ot, an) && (Ft === rn || G(Ft, rn, x, M, X)))
                return Ot.push(an);
            })) {
              ot = !1;
              break;
            }
          } else if (!(Ft === Yt || G(Ft, Yt, x, M, X))) {
            ot = !1;
            break;
          }
        }
        return X.delete(u), X.delete(h), ot;
      }
      function A2(u, h, x, M, G, X, se) {
        switch (x) {
          case Qe:
            if (u.byteLength != h.byteLength || u.byteOffset != h.byteOffset)
              return !1;
            u = u.buffer, h = h.buffer;
          case je:
            return !(u.byteLength != h.byteLength || !X(new Th(u), new Th(h)));
          case ae:
          case ce:
          case $e:
            return Gi(+u, +h);
          case we:
            return u.name == h.name && u.message == h.message;
          case me:
          case Ce:
            return u == h + "";
          case _e:
            var de = Ny;
          case Oe:
            var xe = M & v;
            if (de || (de = vh), u.size != h.size && !xe)
              return !1;
            var Ve = se.get(u);
            if (Ve)
              return Ve == h;
            M |= y, se.set(u, h);
            var He = wT(de(u), de(h), M, G, X, se);
            return se.delete(u), He;
          case Te:
            if (Wd)
              return Wd.call(u) == Wd.call(h);
        }
        return !1;
      }
      function D2(u, h, x, M, G, X) {
        var se = x & v, de = sv(u), xe = de.length, Ve = sv(h), He = Ve.length;
        if (xe != He && !se)
          return !1;
        for (var qe = xe; qe--; ) {
          var ot = de[qe];
          if (!(se ? ot in h : In.call(h, ot)))
            return !1;
        }
        var Ot = X.get(u), Ft = X.get(h);
        if (Ot && Ft)
          return Ot == h && Ft == u;
        var Yt = !0;
        X.set(u, h), X.set(h, u);
        for (var $t = se; ++qe < xe; ) {
          ot = de[qe];
          var rn = u[ot], an = h[ot];
          if (M)
            var Zo = se ? M(an, rn, ot, h, u, X) : M(rn, an, ot, u, h, X);
          if (!(Zo === n ? rn === an || G(rn, an, x, M, X) : Zo)) {
            Yt = !1;
            break;
          }
          $t || ($t = ot == "constructor");
        }
        if (Yt && !$t) {
          var Co = u.constructor, ei = h.constructor;
          Co != ei && "constructor" in u && "constructor" in h && !(typeof Co == "function" && Co instanceof Co && typeof ei == "function" && ei instanceof ei) && (Yt = !1);
        }
        return X.delete(u), X.delete(h), Yt;
      }
      function Zs(u) {
        return hv(OT(u, n, NT), u + "");
      }
      function sv(u) {
        return BE(u, qr, uv);
      }
      function av(u) {
        return BE(u, Ao, CT);
      }
      var lv = kh ? function(u) {
        return kh.get(u);
      } : Pv;
      function Gh(u) {
        for (var h = u.name + "", x = Gc[h], M = In.call(Gc, h) ? x.length : 0; M--; ) {
          var G = x[M], X = G.func;
          if (X == null || X == u)
            return G.name;
        }
        return h;
      }
      function Yc(u) {
        var h = In.call(Y, "placeholder") ? Y : u;
        return h.placeholder;
      }
      function Nt() {
        var u = Y.iteratee || Tv;
        return u = u === Tv ? UE : u, arguments.length ? u(arguments[0], arguments[1]) : u;
      }
      function Wh(u, h) {
        var x = u.__data__;
        return H2(h) ? x[typeof h == "string" ? "string" : "hash"] : x.map;
      }
      function cv(u) {
        for (var h = qr(u), x = h.length; x--; ) {
          var M = h[x], G = u[M];
          h[x] = [M, G, ET(G)];
        }
        return h;
      }
      function Ul(u, h) {
        var x = GL(u, h);
        return HE(x) ? x : n;
      }
      function N2(u) {
        var h = In.call(u, Ll), x = u[Ll];
        try {
          u[Ll] = n;
          var M = !0;
        } catch {
        }
        var G = Sh.call(u);
        return M && (h ? u[Ll] = x : delete u[Ll]), G;
      }
      var uv = $y ? function(u) {
        return u == null ? [] : (u = Vn(u), Ra($y(u), function(h) {
          return PE.call(u, h);
        }));
      } : Iv, CT = $y ? function(u) {
        for (var h = []; u; )
          _a(h, uv(u)), u = Oh(u);
        return h;
      } : Iv, uo = vo;
      (Ly && uo(new Ly(new ArrayBuffer(1))) != Qe || Ud && uo(new Ud()) != _e || jy && uo(jy.resolve()) != J || zc && uo(new zc()) != Oe || zd && uo(new zd()) != Ye) && (uo = function(u) {
        var h = vo(u), x = h == Ze ? u.constructor : n, M = x ? zl(x) : "";
        if (M)
          switch (M) {
            case bj:
              return Qe;
            case yj:
              return _e;
            case vj:
              return J;
            case wj:
              return Oe;
            case Cj:
              return Ye;
          }
        return h;
      });
      function F2(u, h, x) {
        for (var M = -1, G = x.length; ++M < G; ) {
          var X = x[M], se = X.size;
          switch (X.type) {
            case "drop":
              u += se;
              break;
            case "dropRight":
              h -= se;
              break;
            case "take":
              h = co(h, u + se);
              break;
            case "takeRight":
              u = Br(u, h - se);
              break;
          }
        }
        return { start: u, end: h };
      }
      function $2(u) {
        var h = u.match(Dt);
        return h ? h[1].split(at) : [];
      }
      function xT(u, h, x) {
        h = Na(h, u);
        for (var M = -1, G = h.length, X = !1; ++M < G; ) {
          var se = ps(h[M]);
          if (!(X = u != null && x(u, se)))
            break;
          u = u[se];
        }
        return X || ++M != G ? X : (G = u == null ? 0 : u.length, !!G && Zh(G) && ea(se, G) && (Gt(u) || Gl(u)));
      }
      function L2(u) {
        var h = u.length, x = new u.constructor(h);
        return h && typeof u[0] == "string" && In.call(u, "index") && (x.index = u.index, x.input = u.input), x;
      }
      function ST(u) {
        return typeof u.constructor == "function" && !Zd(u) ? Wc(Oh(u)) : {};
      }
      function j2(u, h, x) {
        var M = u.constructor;
        switch (h) {
          case je:
            return rv(u);
          case ae:
          case ce:
            return new M(+u);
          case Qe:
            return x2(u, x);
          case et:
          case Et:
          case Xe:
          case xt:
          case tt:
          case ct:
          case Je:
          case Ge:
          case lt:
            return iT(u, x);
          case _e:
            return new M();
          case $e:
          case Ce:
            return new M(u);
          case me:
            return S2(u);
          case Oe:
            return new M();
          case Te:
            return E2(u);
        }
      }
      function B2(u, h) {
        var x = h.length;
        if (!x)
          return u;
        var M = x - 1;
        return h[M] = (x > 1 ? "& " : "") + h[M], h = h.join(x > 2 ? ", " : " "), u.replace(bt, `{
/* [wrapped with ` + h + `] */
`);
      }
      function V2(u) {
        return Gt(u) || Gl(u) || !!(IE && u && u[IE]);
      }
      function ea(u, h) {
        var x = typeof u;
        return h = h ?? W, !!h && (x == "number" || x != "symbol" && Tt.test(u)) && u > -1 && u % 1 == 0 && u < h;
      }
      function wo(u, h, x) {
        if (!cr(x))
          return !1;
        var M = typeof h;
        return (M == "number" ? Mo(x) && ea(h, x.length) : M == "string" && h in x) ? Gi(x[h], u) : !1;
      }
      function dv(u, h) {
        if (Gt(u))
          return !1;
        var x = typeof u;
        return x == "number" || x == "symbol" || x == "boolean" || u == null || Jo(u) ? !0 : eo.test(u) || !er.test(u) || h != null && u in Vn(h);
      }
      function H2(u) {
        var h = typeof u;
        return h == "string" || h == "number" || h == "symbol" || h == "boolean" ? u !== "__proto__" : u === null;
      }
      function fv(u) {
        var h = Gh(u), x = Y[h];
        if (typeof x != "function" || !(h in sn.prototype))
          return !1;
        if (u === x)
          return !0;
        var M = lv(x);
        return !!M && u === M[0];
      }
      function U2(u) {
        return !!EE && EE in u;
      }
      var z2 = Ch ? ta : Rv;
      function Zd(u) {
        var h = u && u.constructor, x = typeof h == "function" && h.prototype || Uc;
        return u === x;
      }
      function ET(u) {
        return u === u && !cr(u);
      }
      function TT(u, h) {
        return function(x) {
          return x == null ? !1 : x[u] === h && (h !== n || u in Vn(x));
        };
      }
      function G2(u) {
        var h = Xh(u, function(M) {
          return x.size === d && x.clear(), M;
        }), x = h.cache;
        return h;
      }
      function W2(u, h) {
        var x = u[1], M = h[1], G = x | M, X = G < (S | E | F), se = M == F && x == O || M == F && x == A && u[7].length <= h[8] || M == (F | A) && h[7].length <= h[8] && x == O;
        if (!(X || se))
          return u;
        M & S && (u[2] = h[2], G |= x & S ? 0 : I);
        var de = h[3];
        if (de) {
          var xe = u[3];
          u[3] = xe ? aT(xe, de, h[4]) : de, u[4] = xe ? ka(u[3], f) : h[4];
        }
        return de = h[5], de && (xe = u[5], u[5] = xe ? lT(xe, de, h[6]) : de, u[6] = xe ? ka(u[5], f) : h[6]), de = h[7], de && (u[7] = de), M & F && (u[8] = u[8] == null ? h[8] : co(u[8], h[8])), u[9] == null && (u[9] = h[9]), u[0] = h[0], u[1] = G, u;
      }
      function q2(u) {
        var h = [];
        if (u != null)
          for (var x in Vn(u))
            h.push(x);
        return h;
      }
      function K2(u) {
        return Sh.call(u);
      }
      function OT(u, h, x) {
        return h = Br(h === n ? u.length - 1 : h, 0), function() {
          for (var M = arguments, G = -1, X = Br(M.length - h, 0), se = Ie(X); ++G < X; )
            se[G] = M[h + G];
          G = -1;
          for (var de = Ie(h + 1); ++G < h; )
            de[G] = M[G];
          return de[h] = x(se), Yo(u, this, de);
        };
      }
      function PT(u, h) {
        return h.length < 2 ? u : Hl(u, xi(h, 0, -1));
      }
      function Y2(u, h) {
        for (var x = u.length, M = co(h.length, x), G = ko(u); M--; ) {
          var X = h[M];
          u[M] = ea(X, x) ? G[X] : n;
        }
        return u;
      }
      function pv(u, h) {
        if (!(h === "constructor" && typeof u[h] == "function") && h != "__proto__")
          return u[h];
      }
      var IT = _T(XE), ef = uj || function(u, h) {
        return to.setTimeout(u, h);
      }, hv = _T(y2);
      function RT(u, h, x) {
        var M = h + "";
        return hv(u, B2(M, Q2($2(M), x)));
      }
      function _T(u) {
        var h = 0, x = 0;
        return function() {
          var M = hj(), G = B - (M - x);
          if (x = M, G > 0) {
            if (++h >= L)
              return arguments[0];
          } else
            h = 0;
          return u.apply(n, arguments);
        };
      }
      function qh(u, h) {
        var x = -1, M = u.length, G = M - 1;
        for (h = h === n ? M : h; ++x < h; ) {
          var X = Qy(x, G), se = u[X];
          u[X] = u[x], u[x] = se;
        }
        return u.length = h, u;
      }
      var kT = G2(function(u) {
        var h = [];
        return u.charCodeAt(0) === 46 && h.push(""), u.replace(ue, function(x, M, G, X) {
          h.push(G ? X.replace(Re, "$1") : M || x);
        }), h;
      });
      function ps(u) {
        if (typeof u == "string" || Jo(u))
          return u;
        var h = u + "";
        return h == "0" && 1 / u == -j ? "-0" : h;
      }
      function zl(u) {
        if (u != null) {
          try {
            return xh.call(u);
          } catch {
          }
          try {
            return u + "";
          } catch {
          }
        }
        return "";
      }
      function Q2(u, h) {
        return yi(Q, function(x) {
          var M = "_." + x[0];
          h & x[1] && !bh(u, M) && u.push(M);
        }), u.sort();
      }
      function MT(u) {
        if (u instanceof sn)
          return u.clone();
        var h = new wi(u.__wrapped__, u.__chain__);
        return h.__actions__ = ko(u.__actions__), h.__index__ = u.__index__, h.__values__ = u.__values__, h;
      }
      function X2(u, h, x) {
        (x ? wo(u, h, x) : h === n) ? h = 1 : h = Br(Kt(h), 0);
        var M = u == null ? 0 : u.length;
        if (!M || h < 1)
          return [];
        for (var G = 0, X = 0, se = Ie(Rh(M / h)); G < M; )
          se[X++] = xi(u, G, G += h);
        return se;
      }
      function J2(u) {
        for (var h = -1, x = u == null ? 0 : u.length, M = 0, G = []; ++h < x; ) {
          var X = u[h];
          X && (G[M++] = X);
        }
        return G;
      }
      function Z2() {
        var u = arguments.length;
        if (!u)
          return [];
        for (var h = Ie(u - 1), x = arguments[0], M = u; M--; )
          h[M - 1] = arguments[M];
        return _a(Gt(x) ? ko(x) : [x], no(h, 1));
      }
      var eB = Zt(function(u, h) {
        return Er(u) ? Kd(u, no(h, 1, Er, !0)) : [];
      }), tB = Zt(function(u, h) {
        var x = Si(h);
        return Er(x) && (x = n), Er(u) ? Kd(u, no(h, 1, Er, !0), Nt(x, 2)) : [];
      }), nB = Zt(function(u, h) {
        var x = Si(h);
        return Er(x) && (x = n), Er(u) ? Kd(u, no(h, 1, Er, !0), n, x) : [];
      });
      function rB(u, h, x) {
        var M = u == null ? 0 : u.length;
        return M ? (h = x || h === n ? 1 : Kt(h), xi(u, h < 0 ? 0 : h, M)) : [];
      }
      function oB(u, h, x) {
        var M = u == null ? 0 : u.length;
        return M ? (h = x || h === n ? 1 : Kt(h), h = M - h, xi(u, 0, h < 0 ? 0 : h)) : [];
      }
      function iB(u, h) {
        return u && u.length ? jh(u, Nt(h, 3), !0, !0) : [];
      }
      function sB(u, h) {
        return u && u.length ? jh(u, Nt(h, 3), !0) : [];
      }
      function aB(u, h, x, M) {
        var G = u == null ? 0 : u.length;
        return G ? (x && typeof x != "number" && wo(u, h, x) && (x = 0, M = G), Zj(u, h, x, M)) : [];
      }
      function AT(u, h, x) {
        var M = u == null ? 0 : u.length;
        if (!M)
          return -1;
        var G = x == null ? 0 : Kt(x);
        return G < 0 && (G = Br(M + G, 0)), yh(u, Nt(h, 3), G);
      }
      function DT(u, h, x) {
        var M = u == null ? 0 : u.length;
        if (!M)
          return -1;
        var G = M - 1;
        return x !== n && (G = Kt(x), G = x < 0 ? Br(M + G, 0) : co(G, M - 1)), yh(u, Nt(h, 3), G, !0);
      }
      function NT(u) {
        var h = u == null ? 0 : u.length;
        return h ? no(u, 1) : [];
      }
      function lB(u) {
        var h = u == null ? 0 : u.length;
        return h ? no(u, j) : [];
      }
      function cB(u, h) {
        var x = u == null ? 0 : u.length;
        return x ? (h = h === n ? 1 : Kt(h), no(u, h)) : [];
      }
      function uB(u) {
        for (var h = -1, x = u == null ? 0 : u.length, M = {}; ++h < x; ) {
          var G = u[h];
          M[G[0]] = G[1];
        }
        return M;
      }
      function FT(u) {
        return u && u.length ? u[0] : n;
      }
      function dB(u, h, x) {
        var M = u == null ? 0 : u.length;
        if (!M)
          return -1;
        var G = x == null ? 0 : Kt(x);
        return G < 0 && (G = Br(M + G, 0)), jc(u, h, G);
      }
      function fB(u) {
        var h = u == null ? 0 : u.length;
        return h ? xi(u, 0, -1) : [];
      }
      var pB = Zt(function(u) {
        var h = tr(u, tv);
        return h.length && h[0] === u[0] ? Gy(h) : [];
      }), hB = Zt(function(u) {
        var h = Si(u), x = tr(u, tv);
        return h === Si(x) ? h = n : x.pop(), x.length && x[0] === u[0] ? Gy(x, Nt(h, 2)) : [];
      }), gB = Zt(function(u) {
        var h = Si(u), x = tr(u, tv);
        return h = typeof h == "function" ? h : n, h && x.pop(), x.length && x[0] === u[0] ? Gy(x, n, h) : [];
      });
      function mB(u, h) {
        return u == null ? "" : fj.call(u, h);
      }
      function Si(u) {
        var h = u == null ? 0 : u.length;
        return h ? u[h - 1] : n;
      }
      function bB(u, h, x) {
        var M = u == null ? 0 : u.length;
        if (!M)
          return -1;
        var G = M;
        return x !== n && (G = Kt(x), G = G < 0 ? Br(M + G, 0) : co(G, M - 1)), h === h ? QL(u, h, G) : yh(u, mE, G, !0);
      }
      function yB(u, h) {
        return u && u.length ? qE(u, Kt(h)) : n;
      }
      var vB = Zt($T);
      function $T(u, h) {
        return u && u.length && h && h.length ? Yy(u, h) : u;
      }
      function wB(u, h, x) {
        return u && u.length && h && h.length ? Yy(u, h, Nt(x, 2)) : u;
      }
      function CB(u, h, x) {
        return u && u.length && h && h.length ? Yy(u, h, n, x) : u;
      }
      var xB = Zs(function(u, h) {
        var x = u == null ? 0 : u.length, M = Vy(u, h);
        return QE(u, tr(h, function(G) {
          return ea(G, x) ? +G : G;
        }).sort(sT)), M;
      });
      function SB(u, h) {
        var x = [];
        if (!(u && u.length))
          return x;
        var M = -1, G = [], X = u.length;
        for (h = Nt(h, 3); ++M < X; ) {
          var se = u[M];
          h(se, M, u) && (x.push(se), G.push(M));
        }
        return QE(u, G), x;
      }
      function gv(u) {
        return u == null ? u : mj.call(u);
      }
      function EB(u, h, x) {
        var M = u == null ? 0 : u.length;
        return M ? (x && typeof x != "number" && wo(u, h, x) ? (h = 0, x = M) : (h = h == null ? 0 : Kt(h), x = x === n ? M : Kt(x)), xi(u, h, x)) : [];
      }
      function TB(u, h) {
        return Lh(u, h);
      }
      function OB(u, h, x) {
        return Jy(u, h, Nt(x, 2));
      }
      function PB(u, h) {
        var x = u == null ? 0 : u.length;
        if (x) {
          var M = Lh(u, h);
          if (M < x && Gi(u[M], h))
            return M;
        }
        return -1;
      }
      function IB(u, h) {
        return Lh(u, h, !0);
      }
      function RB(u, h, x) {
        return Jy(u, h, Nt(x, 2), !0);
      }
      function _B(u, h) {
        var x = u == null ? 0 : u.length;
        if (x) {
          var M = Lh(u, h, !0) - 1;
          if (Gi(u[M], h))
            return M;
        }
        return -1;
      }
      function kB(u) {
        return u && u.length ? JE(u) : [];
      }
      function MB(u, h) {
        return u && u.length ? JE(u, Nt(h, 2)) : [];
      }
      function AB(u) {
        var h = u == null ? 0 : u.length;
        return h ? xi(u, 1, h) : [];
      }
      function DB(u, h, x) {
        return u && u.length ? (h = x || h === n ? 1 : Kt(h), xi(u, 0, h < 0 ? 0 : h)) : [];
      }
      function NB(u, h, x) {
        var M = u == null ? 0 : u.length;
        return M ? (h = x || h === n ? 1 : Kt(h), h = M - h, xi(u, h < 0 ? 0 : h, M)) : [];
      }
      function FB(u, h) {
        return u && u.length ? jh(u, Nt(h, 3), !1, !0) : [];
      }
      function $B(u, h) {
        return u && u.length ? jh(u, Nt(h, 3)) : [];
      }
      var LB = Zt(function(u) {
        return Da(no(u, 1, Er, !0));
      }), jB = Zt(function(u) {
        var h = Si(u);
        return Er(h) && (h = n), Da(no(u, 1, Er, !0), Nt(h, 2));
      }), BB = Zt(function(u) {
        var h = Si(u);
        return h = typeof h == "function" ? h : n, Da(no(u, 1, Er, !0), n, h);
      });
      function VB(u) {
        return u && u.length ? Da(u) : [];
      }
      function HB(u, h) {
        return u && u.length ? Da(u, Nt(h, 2)) : [];
      }
      function UB(u, h) {
        return h = typeof h == "function" ? h : n, u && u.length ? Da(u, n, h) : [];
      }
      function mv(u) {
        if (!(u && u.length))
          return [];
        var h = 0;
        return u = Ra(u, function(x) {
          if (Er(x))
            return h = Br(x.length, h), !0;
        }), Ay(h, function(x) {
          return tr(u, _y(x));
        });
      }
      function LT(u, h) {
        if (!(u && u.length))
          return [];
        var x = mv(u);
        return h == null ? x : tr(x, function(M) {
          return Yo(h, n, M);
        });
      }
      var zB = Zt(function(u, h) {
        return Er(u) ? Kd(u, h) : [];
      }), GB = Zt(function(u) {
        return ev(Ra(u, Er));
      }), WB = Zt(function(u) {
        var h = Si(u);
        return Er(h) && (h = n), ev(Ra(u, Er), Nt(h, 2));
      }), qB = Zt(function(u) {
        var h = Si(u);
        return h = typeof h == "function" ? h : n, ev(Ra(u, Er), n, h);
      }), KB = Zt(mv);
      function YB(u, h) {
        return nT(u || [], h || [], qd);
      }
      function QB(u, h) {
        return nT(u || [], h || [], Xd);
      }
      var XB = Zt(function(u) {
        var h = u.length, x = h > 1 ? u[h - 1] : n;
        return x = typeof x == "function" ? (u.pop(), x) : n, LT(u, x);
      });
      function jT(u) {
        var h = Y(u);
        return h.__chain__ = !0, h;
      }
      function JB(u, h) {
        return h(u), u;
      }
      function Kh(u, h) {
        return h(u);
      }
      var ZB = Zs(function(u) {
        var h = u.length, x = h ? u[0] : 0, M = this.__wrapped__, G = function(X) {
          return Vy(X, u);
        };
        return h > 1 || this.__actions__.length || !(M instanceof sn) || !ea(x) ? this.thru(G) : (M = M.slice(x, +x + (h ? 1 : 0)), M.__actions__.push({
          func: Kh,
          args: [G],
          thisArg: n
        }), new wi(M, this.__chain__).thru(function(X) {
          return h && !X.length && X.push(n), X;
        }));
      });
      function eV() {
        return jT(this);
      }
      function tV() {
        return new wi(this.value(), this.__chain__);
      }
      function nV() {
        this.__values__ === n && (this.__values__ = ZT(this.value()));
        var u = this.__index__ >= this.__values__.length, h = u ? n : this.__values__[this.__index__++];
        return { done: u, value: h };
      }
      function rV() {
        return this;
      }
      function oV(u) {
        for (var h, x = this; x instanceof Ah; ) {
          var M = MT(x);
          M.__index__ = 0, M.__values__ = n, h ? G.__wrapped__ = M : h = M;
          var G = M;
          x = x.__wrapped__;
        }
        return G.__wrapped__ = u, h;
      }
      function iV() {
        var u = this.__wrapped__;
        if (u instanceof sn) {
          var h = u;
          return this.__actions__.length && (h = new sn(this)), h = h.reverse(), h.__actions__.push({
            func: Kh,
            args: [gv],
            thisArg: n
          }), new wi(h, this.__chain__);
        }
        return this.thru(gv);
      }
      function sV() {
        return tT(this.__wrapped__, this.__actions__);
      }
      var aV = Bh(function(u, h, x) {
        In.call(u, x) ? ++u[x] : Xs(u, x, 1);
      });
      function lV(u, h, x) {
        var M = Gt(u) ? hE : Jj;
        return x && wo(u, h, x) && (h = n), M(u, Nt(h, 3));
      }
      function cV(u, h) {
        var x = Gt(u) ? Ra : LE;
        return x(u, Nt(h, 3));
      }
      var uV = fT(AT), dV = fT(DT);
      function fV(u, h) {
        return no(Yh(u, h), 1);
      }
      function pV(u, h) {
        return no(Yh(u, h), j);
      }
      function hV(u, h, x) {
        return x = x === n ? 1 : Kt(x), no(Yh(u, h), x);
      }
      function BT(u, h) {
        var x = Gt(u) ? yi : Aa;
        return x(u, Nt(h, 3));
      }
      function VT(u, h) {
        var x = Gt(u) ? AL : $E;
        return x(u, Nt(h, 3));
      }
      var gV = Bh(function(u, h, x) {
        In.call(u, x) ? u[x].push(h) : Xs(u, x, [h]);
      });
      function mV(u, h, x, M) {
        u = Mo(u) ? u : Xc(u), x = x && !M ? Kt(x) : 0;
        var G = u.length;
        return x < 0 && (x = Br(G + x, 0)), eg(u) ? x <= G && u.indexOf(h, x) > -1 : !!G && jc(u, h, x) > -1;
      }
      var bV = Zt(function(u, h, x) {
        var M = -1, G = typeof h == "function", X = Mo(u) ? Ie(u.length) : [];
        return Aa(u, function(se) {
          X[++M] = G ? Yo(h, se, x) : Yd(se, h, x);
        }), X;
      }), yV = Bh(function(u, h, x) {
        Xs(u, x, h);
      });
      function Yh(u, h) {
        var x = Gt(u) ? tr : zE;
        return x(u, Nt(h, 3));
      }
      function vV(u, h, x, M) {
        return u == null ? [] : (Gt(h) || (h = h == null ? [] : [h]), x = M ? n : x, Gt(x) || (x = x == null ? [] : [x]), KE(u, h, x));
      }
      var wV = Bh(function(u, h, x) {
        u[x ? 0 : 1].push(h);
      }, function() {
        return [[], []];
      });
      function CV(u, h, x) {
        var M = Gt(u) ? Iy : yE, G = arguments.length < 3;
        return M(u, Nt(h, 4), x, G, Aa);
      }
      function xV(u, h, x) {
        var M = Gt(u) ? DL : yE, G = arguments.length < 3;
        return M(u, Nt(h, 4), x, G, $E);
      }
      function SV(u, h) {
        var x = Gt(u) ? Ra : LE;
        return x(u, Jh(Nt(h, 3)));
      }
      function EV(u) {
        var h = Gt(u) ? AE : m2;
        return h(u);
      }
      function TV(u, h, x) {
        (x ? wo(u, h, x) : h === n) ? h = 1 : h = Kt(h);
        var M = Gt(u) ? qj : b2;
        return M(u, h);
      }
      function OV(u) {
        var h = Gt(u) ? Kj : v2;
        return h(u);
      }
      function PV(u) {
        if (u == null)
          return 0;
        if (Mo(u))
          return eg(u) ? Vc(u) : u.length;
        var h = uo(u);
        return h == _e || h == Oe ? u.size : qy(u).length;
      }
      function IV(u, h, x) {
        var M = Gt(u) ? Ry : w2;
        return x && wo(u, h, x) && (h = n), M(u, Nt(h, 3));
      }
      var RV = Zt(function(u, h) {
        if (u == null)
          return [];
        var x = h.length;
        return x > 1 && wo(u, h[0], h[1]) ? h = [] : x > 2 && wo(h[0], h[1], h[2]) && (h = [h[0]]), KE(u, no(h, 1), []);
      }), Qh = cj || function() {
        return to.Date.now();
      };
      function _V(u, h) {
        if (typeof h != "function")
          throw new vi(a);
        return u = Kt(u), function() {
          if (--u < 1)
            return h.apply(this, arguments);
        };
      }
      function HT(u, h, x) {
        return h = x ? n : h, h = u && h == null ? u.length : h, Js(u, F, n, n, n, n, h);
      }
      function UT(u, h) {
        var x;
        if (typeof h != "function")
          throw new vi(a);
        return u = Kt(u), function() {
          return --u > 0 && (x = h.apply(this, arguments)), u <= 1 && (h = n), x;
        };
      }
      var bv = Zt(function(u, h, x) {
        var M = S;
        if (x.length) {
          var G = ka(x, Yc(bv));
          M |= P;
        }
        return Js(u, M, h, x, G);
      }), zT = Zt(function(u, h, x) {
        var M = S | E;
        if (x.length) {
          var G = ka(x, Yc(zT));
          M |= P;
        }
        return Js(h, M, u, x, G);
      });
      function GT(u, h, x) {
        h = x ? n : h;
        var M = Js(u, O, n, n, n, n, n, h);
        return M.placeholder = GT.placeholder, M;
      }
      function WT(u, h, x) {
        h = x ? n : h;
        var M = Js(u, T, n, n, n, n, n, h);
        return M.placeholder = WT.placeholder, M;
      }
      function qT(u, h, x) {
        var M, G, X, se, de, xe, Ve = 0, He = !1, qe = !1, ot = !0;
        if (typeof u != "function")
          throw new vi(a);
        h = Ei(h) || 0, cr(x) && (He = !!x.leading, qe = "maxWait" in x, X = qe ? Br(Ei(x.maxWait) || 0, h) : X, ot = "trailing" in x ? !!x.trailing : ot);
        function Ot(Tr) {
          var Wi = M, ra = G;
          return M = G = n, Ve = Tr, se = u.apply(ra, Wi), se;
        }
        function Ft(Tr) {
          return Ve = Tr, de = ef(rn, h), He ? Ot(Tr) : se;
        }
        function Yt(Tr) {
          var Wi = Tr - xe, ra = Tr - Ve, f1 = h - Wi;
          return qe ? co(f1, X - ra) : f1;
        }
        function $t(Tr) {
          var Wi = Tr - xe, ra = Tr - Ve;
          return xe === n || Wi >= h || Wi < 0 || qe && ra >= X;
        }
        function rn() {
          var Tr = Qh();
          if ($t(Tr))
            return an(Tr);
          de = ef(rn, Yt(Tr));
        }
        function an(Tr) {
          return de = n, ot && M ? Ot(Tr) : (M = G = n, se);
        }
        function Zo() {
          de !== n && rT(de), Ve = 0, M = xe = G = de = n;
        }
        function Co() {
          return de === n ? se : an(Qh());
        }
        function ei() {
          var Tr = Qh(), Wi = $t(Tr);
          if (M = arguments, G = this, xe = Tr, Wi) {
            if (de === n)
              return Ft(xe);
            if (qe)
              return rT(de), de = ef(rn, h), Ot(xe);
          }
          return de === n && (de = ef(rn, h)), se;
        }
        return ei.cancel = Zo, ei.flush = Co, ei;
      }
      var kV = Zt(function(u, h) {
        return FE(u, 1, h);
      }), MV = Zt(function(u, h, x) {
        return FE(u, Ei(h) || 0, x);
      });
      function AV(u) {
        return Js(u, _);
      }
      function Xh(u, h) {
        if (typeof u != "function" || h != null && typeof h != "function")
          throw new vi(a);
        var x = function() {
          var M = arguments, G = h ? h.apply(this, M) : M[0], X = x.cache;
          if (X.has(G))
            return X.get(G);
          var se = u.apply(this, M);
          return x.cache = X.set(G, se) || X, se;
        };
        return x.cache = new (Xh.Cache || Qs)(), x;
      }
      Xh.Cache = Qs;
      function Jh(u) {
        if (typeof u != "function")
          throw new vi(a);
        return function() {
          var h = arguments;
          switch (h.length) {
            case 0:
              return !u.call(this);
            case 1:
              return !u.call(this, h[0]);
            case 2:
              return !u.call(this, h[0], h[1]);
            case 3:
              return !u.call(this, h[0], h[1], h[2]);
          }
          return !u.apply(this, h);
        };
      }
      function DV(u) {
        return UT(2, u);
      }
      var NV = C2(function(u, h) {
        h = h.length == 1 && Gt(h[0]) ? tr(h[0], Qo(Nt())) : tr(no(h, 1), Qo(Nt()));
        var x = h.length;
        return Zt(function(M) {
          for (var G = -1, X = co(M.length, x); ++G < X; )
            M[G] = h[G].call(this, M[G]);
          return Yo(u, this, M);
        });
      }), yv = Zt(function(u, h) {
        var x = ka(h, Yc(yv));
        return Js(u, P, n, h, x);
      }), KT = Zt(function(u, h) {
        var x = ka(h, Yc(KT));
        return Js(u, R, n, h, x);
      }), FV = Zs(function(u, h) {
        return Js(u, A, n, n, n, h);
      });
      function $V(u, h) {
        if (typeof u != "function")
          throw new vi(a);
        return h = h === n ? h : Kt(h), Zt(u, h);
      }
      function LV(u, h) {
        if (typeof u != "function")
          throw new vi(a);
        return h = h == null ? 0 : Br(Kt(h), 0), Zt(function(x) {
          var M = x[h], G = Fa(x, 0, h);
          return M && _a(G, M), Yo(u, this, G);
        });
      }
      function jV(u, h, x) {
        var M = !0, G = !0;
        if (typeof u != "function")
          throw new vi(a);
        return cr(x) && (M = "leading" in x ? !!x.leading : M, G = "trailing" in x ? !!x.trailing : G), qT(u, h, {
          leading: M,
          maxWait: h,
          trailing: G
        });
      }
      function BV(u) {
        return HT(u, 1);
      }
      function VV(u, h) {
        return yv(nv(h), u);
      }
      function HV() {
        if (!arguments.length)
          return [];
        var u = arguments[0];
        return Gt(u) ? u : [u];
      }
      function UV(u) {
        return Ci(u, b);
      }
      function zV(u, h) {
        return h = typeof h == "function" ? h : n, Ci(u, b, h);
      }
      function GV(u) {
        return Ci(u, p | b);
      }
      function WV(u, h) {
        return h = typeof h == "function" ? h : n, Ci(u, p | b, h);
      }
      function qV(u, h) {
        return h == null || NE(u, h, qr(h));
      }
      function Gi(u, h) {
        return u === h || u !== u && h !== h;
      }
      var KV = zh(zy), YV = zh(function(u, h) {
        return u >= h;
      }), Gl = VE(/* @__PURE__ */ function() {
        return arguments;
      }()) ? VE : function(u) {
        return hr(u) && In.call(u, "callee") && !PE.call(u, "callee");
      }, Gt = Ie.isArray, QV = lE ? Qo(lE) : o2;
      function Mo(u) {
        return u != null && Zh(u.length) && !ta(u);
      }
      function Er(u) {
        return hr(u) && Mo(u);
      }
      function XV(u) {
        return u === !0 || u === !1 || hr(u) && vo(u) == ae;
      }
      var $a = dj || Rv, JV = cE ? Qo(cE) : i2;
      function ZV(u) {
        return hr(u) && u.nodeType === 1 && !tf(u);
      }
      function eH(u) {
        if (u == null)
          return !0;
        if (Mo(u) && (Gt(u) || typeof u == "string" || typeof u.splice == "function" || $a(u) || Qc(u) || Gl(u)))
          return !u.length;
        var h = uo(u);
        if (h == _e || h == Oe)
          return !u.size;
        if (Zd(u))
          return !qy(u).length;
        for (var x in u)
          if (In.call(u, x))
            return !1;
        return !0;
      }
      function tH(u, h) {
        return Qd(u, h);
      }
      function nH(u, h, x) {
        x = typeof x == "function" ? x : n;
        var M = x ? x(u, h) : n;
        return M === n ? Qd(u, h, n, x) : !!M;
      }
      function vv(u) {
        if (!hr(u))
          return !1;
        var h = vo(u);
        return h == we || h == le || typeof u.message == "string" && typeof u.name == "string" && !tf(u);
      }
      function rH(u) {
        return typeof u == "number" && RE(u);
      }
      function ta(u) {
        if (!cr(u))
          return !1;
        var h = vo(u);
        return h == q || h == Ee || h == ie || h == fe;
      }
      function YT(u) {
        return typeof u == "number" && u == Kt(u);
      }
      function Zh(u) {
        return typeof u == "number" && u > -1 && u % 1 == 0 && u <= W;
      }
      function cr(u) {
        var h = typeof u;
        return u != null && (h == "object" || h == "function");
      }
      function hr(u) {
        return u != null && typeof u == "object";
      }
      var QT = uE ? Qo(uE) : a2;
      function oH(u, h) {
        return u === h || Wy(u, h, cv(h));
      }
      function iH(u, h, x) {
        return x = typeof x == "function" ? x : n, Wy(u, h, cv(h), x);
      }
      function sH(u) {
        return XT(u) && u != +u;
      }
      function aH(u) {
        if (z2(u))
          throw new Ht(i);
        return HE(u);
      }
      function lH(u) {
        return u === null;
      }
      function cH(u) {
        return u == null;
      }
      function XT(u) {
        return typeof u == "number" || hr(u) && vo(u) == $e;
      }
      function tf(u) {
        if (!hr(u) || vo(u) != Ze)
          return !1;
        var h = Oh(u);
        if (h === null)
          return !0;
        var x = In.call(h, "constructor") && h.constructor;
        return typeof x == "function" && x instanceof x && xh.call(x) == ij;
      }
      var wv = dE ? Qo(dE) : l2;
      function uH(u) {
        return YT(u) && u >= -W && u <= W;
      }
      var JT = fE ? Qo(fE) : c2;
      function eg(u) {
        return typeof u == "string" || !Gt(u) && hr(u) && vo(u) == Ce;
      }
      function Jo(u) {
        return typeof u == "symbol" || hr(u) && vo(u) == Te;
      }
      var Qc = pE ? Qo(pE) : u2;
      function dH(u) {
        return u === n;
      }
      function fH(u) {
        return hr(u) && uo(u) == Ye;
      }
      function pH(u) {
        return hr(u) && vo(u) == Ke;
      }
      var hH = zh(Ky), gH = zh(function(u, h) {
        return u <= h;
      });
      function ZT(u) {
        if (!u)
          return [];
        if (Mo(u))
          return eg(u) ? Ui(u) : ko(u);
        if (Hd && u[Hd])
          return qL(u[Hd]());
        var h = uo(u), x = h == _e ? Ny : h == Oe ? vh : Xc;
        return x(u);
      }
      function na(u) {
        if (!u)
          return u === 0 ? u : 0;
        if (u = Ei(u), u === j || u === -j) {
          var h = u < 0 ? -1 : 1;
          return h * V;
        }
        return u === u ? u : 0;
      }
      function Kt(u) {
        var h = na(u), x = h % 1;
        return h === h ? x ? h - x : h : 0;
      }
      function e1(u) {
        return u ? Vl(Kt(u), 0, z) : 0;
      }
      function Ei(u) {
        if (typeof u == "number")
          return u;
        if (Jo(u))
          return $;
        if (cr(u)) {
          var h = typeof u.valueOf == "function" ? u.valueOf() : u;
          u = cr(h) ? h + "" : h;
        }
        if (typeof u != "string")
          return u === 0 ? u : +u;
        u = vE(u);
        var x = We.test(u);
        return x || dt.test(u) ? _L(u.slice(2), x ? 2 : 8) : Fe.test(u) ? $ : +u;
      }
      function t1(u) {
        return fs(u, Ao(u));
      }
      function mH(u) {
        return u ? Vl(Kt(u), -W, W) : u === 0 ? u : 0;
      }
      function wn(u) {
        return u == null ? "" : Xo(u);
      }
      var bH = qc(function(u, h) {
        if (Zd(h) || Mo(h)) {
          fs(h, qr(h), u);
          return;
        }
        for (var x in h)
          In.call(h, x) && qd(u, x, h[x]);
      }), n1 = qc(function(u, h) {
        fs(h, Ao(h), u);
      }), tg = qc(function(u, h, x, M) {
        fs(h, Ao(h), u, M);
      }), yH = qc(function(u, h, x, M) {
        fs(h, qr(h), u, M);
      }), vH = Zs(Vy);
      function wH(u, h) {
        var x = Wc(u);
        return h == null ? x : DE(x, h);
      }
      var CH = Zt(function(u, h) {
        u = Vn(u);
        var x = -1, M = h.length, G = M > 2 ? h[2] : n;
        for (G && wo(h[0], h[1], G) && (M = 1); ++x < M; )
          for (var X = h[x], se = Ao(X), de = -1, xe = se.length; ++de < xe; ) {
            var Ve = se[de], He = u[Ve];
            (He === n || Gi(He, Uc[Ve]) && !In.call(u, Ve)) && (u[Ve] = X[Ve]);
          }
        return u;
      }), xH = Zt(function(u) {
        return u.push(n, vT), Yo(r1, n, u);
      });
      function SH(u, h) {
        return gE(u, Nt(h, 3), ds);
      }
      function EH(u, h) {
        return gE(u, Nt(h, 3), Uy);
      }
      function TH(u, h) {
        return u == null ? u : Hy(u, Nt(h, 3), Ao);
      }
      function OH(u, h) {
        return u == null ? u : jE(u, Nt(h, 3), Ao);
      }
      function PH(u, h) {
        return u && ds(u, Nt(h, 3));
      }
      function IH(u, h) {
        return u && Uy(u, Nt(h, 3));
      }
      function RH(u) {
        return u == null ? [] : Fh(u, qr(u));
      }
      function _H(u) {
        return u == null ? [] : Fh(u, Ao(u));
      }
      function Cv(u, h, x) {
        var M = u == null ? n : Hl(u, h);
        return M === n ? x : M;
      }
      function kH(u, h) {
        return u != null && xT(u, h, e2);
      }
      function xv(u, h) {
        return u != null && xT(u, h, t2);
      }
      var MH = hT(function(u, h, x) {
        h != null && typeof h.toString != "function" && (h = Sh.call(h)), u[h] = x;
      }, Ev(Do)), AH = hT(function(u, h, x) {
        h != null && typeof h.toString != "function" && (h = Sh.call(h)), In.call(u, h) ? u[h].push(x) : u[h] = [x];
      }, Nt), DH = Zt(Yd);
      function qr(u) {
        return Mo(u) ? ME(u) : qy(u);
      }
      function Ao(u) {
        return Mo(u) ? ME(u, !0) : d2(u);
      }
      function NH(u, h) {
        var x = {};
        return h = Nt(h, 3), ds(u, function(M, G, X) {
          Xs(x, h(M, G, X), M);
        }), x;
      }
      function FH(u, h) {
        var x = {};
        return h = Nt(h, 3), ds(u, function(M, G, X) {
          Xs(x, G, h(M, G, X));
        }), x;
      }
      var $H = qc(function(u, h, x) {
        $h(u, h, x);
      }), r1 = qc(function(u, h, x, M) {
        $h(u, h, x, M);
      }), LH = Zs(function(u, h) {
        var x = {};
        if (u == null)
          return x;
        var M = !1;
        h = tr(h, function(X) {
          return X = Na(X, u), M || (M = X.length > 1), X;
        }), fs(u, av(u), x), M && (x = Ci(x, p | g | b, M2));
        for (var G = h.length; G--; )
          Zy(x, h[G]);
        return x;
      });
      function jH(u, h) {
        return o1(u, Jh(Nt(h)));
      }
      var BH = Zs(function(u, h) {
        return u == null ? {} : p2(u, h);
      });
      function o1(u, h) {
        if (u == null)
          return {};
        var x = tr(av(u), function(M) {
          return [M];
        });
        return h = Nt(h), YE(u, x, function(M, G) {
          return h(M, G[0]);
        });
      }
      function VH(u, h, x) {
        h = Na(h, u);
        var M = -1, G = h.length;
        for (G || (G = 1, u = n); ++M < G; ) {
          var X = u == null ? n : u[ps(h[M])];
          X === n && (M = G, X = x), u = ta(X) ? X.call(u) : X;
        }
        return u;
      }
      function HH(u, h, x) {
        return u == null ? u : Xd(u, h, x);
      }
      function UH(u, h, x, M) {
        return M = typeof M == "function" ? M : n, u == null ? u : Xd(u, h, x, M);
      }
      var i1 = bT(qr), s1 = bT(Ao);
      function zH(u, h, x) {
        var M = Gt(u), G = M || $a(u) || Qc(u);
        if (h = Nt(h, 4), x == null) {
          var X = u && u.constructor;
          G ? x = M ? new X() : [] : cr(u) ? x = ta(X) ? Wc(Oh(u)) : {} : x = {};
        }
        return (G ? yi : ds)(u, function(se, de, xe) {
          return h(x, se, de, xe);
        }), x;
      }
      function GH(u, h) {
        return u == null ? !0 : Zy(u, h);
      }
      function WH(u, h, x) {
        return u == null ? u : eT(u, h, nv(x));
      }
      function qH(u, h, x, M) {
        return M = typeof M == "function" ? M : n, u == null ? u : eT(u, h, nv(x), M);
      }
      function Xc(u) {
        return u == null ? [] : Dy(u, qr(u));
      }
      function KH(u) {
        return u == null ? [] : Dy(u, Ao(u));
      }
      function YH(u, h, x) {
        return x === n && (x = h, h = n), x !== n && (x = Ei(x), x = x === x ? x : 0), h !== n && (h = Ei(h), h = h === h ? h : 0), Vl(Ei(u), h, x);
      }
      function QH(u, h, x) {
        return h = na(h), x === n ? (x = h, h = 0) : x = na(x), u = Ei(u), n2(u, h, x);
      }
      function XH(u, h, x) {
        if (x && typeof x != "boolean" && wo(u, h, x) && (h = x = n), x === n && (typeof h == "boolean" ? (x = h, h = n) : typeof u == "boolean" && (x = u, u = n)), u === n && h === n ? (u = 0, h = 1) : (u = na(u), h === n ? (h = u, u = 0) : h = na(h)), u > h) {
          var M = u;
          u = h, h = M;
        }
        if (x || u % 1 || h % 1) {
          var G = _E();
          return co(u + G * (h - u + RL("1e-" + ((G + "").length - 1))), h);
        }
        return Qy(u, h);
      }
      var JH = Kc(function(u, h, x) {
        return h = h.toLowerCase(), u + (x ? a1(h) : h);
      });
      function a1(u) {
        return Sv(wn(u).toLowerCase());
      }
      function l1(u) {
        return u = wn(u), u && u.replace(zt, HL).replace(vL, "");
      }
      function ZH(u, h, x) {
        u = wn(u), h = Xo(h);
        var M = u.length;
        x = x === n ? M : Vl(Kt(x), 0, M);
        var G = x;
        return x -= h.length, x >= 0 && u.slice(x, G) == h;
      }
      function eU(u) {
        return u = wn(u), u && Mr.test(u) ? u.replace(fr, UL) : u;
      }
      function tU(u) {
        return u = wn(u), u && Se.test(u) ? u.replace(ve, "\\$&") : u;
      }
      var nU = Kc(function(u, h, x) {
        return u + (x ? "-" : "") + h.toLowerCase();
      }), rU = Kc(function(u, h, x) {
        return u + (x ? " " : "") + h.toLowerCase();
      }), oU = dT("toLowerCase");
      function iU(u, h, x) {
        u = wn(u), h = Kt(h);
        var M = h ? Vc(u) : 0;
        if (!h || M >= h)
          return u;
        var G = (h - M) / 2;
        return Uh(_h(G), x) + u + Uh(Rh(G), x);
      }
      function sU(u, h, x) {
        u = wn(u), h = Kt(h);
        var M = h ? Vc(u) : 0;
        return h && M < h ? u + Uh(h - M, x) : u;
      }
      function aU(u, h, x) {
        u = wn(u), h = Kt(h);
        var M = h ? Vc(u) : 0;
        return h && M < h ? Uh(h - M, x) + u : u;
      }
      function lU(u, h, x) {
        return x || h == null ? h = 0 : h && (h = +h), gj(wn(u).replace(ze, ""), h || 0);
      }
      function cU(u, h, x) {
        return (x ? wo(u, h, x) : h === n) ? h = 1 : h = Kt(h), Xy(wn(u), h);
      }
      function uU() {
        var u = arguments, h = wn(u[0]);
        return u.length < 3 ? h : h.replace(u[1], u[2]);
      }
      var dU = Kc(function(u, h, x) {
        return u + (x ? "_" : "") + h.toLowerCase();
      });
      function fU(u, h, x) {
        return x && typeof x != "number" && wo(u, h, x) && (h = x = n), x = x === n ? z : x >>> 0, x ? (u = wn(u), u && (typeof h == "string" || h != null && !wv(h)) && (h = Xo(h), !h && Bc(u)) ? Fa(Ui(u), 0, x) : u.split(h, x)) : [];
      }
      var pU = Kc(function(u, h, x) {
        return u + (x ? " " : "") + Sv(h);
      });
      function hU(u, h, x) {
        return u = wn(u), x = x == null ? 0 : Vl(Kt(x), 0, u.length), h = Xo(h), u.slice(x, x + h.length) == h;
      }
      function gU(u, h, x) {
        var M = Y.templateSettings;
        x && wo(u, h, x) && (h = n), u = wn(u), h = tg({}, h, M, yT);
        var G = tg({}, h.imports, M.imports, yT), X = qr(G), se = Dy(G, X), de, xe, Ve = 0, He = h.interpolate || pn, qe = "__p += '", ot = Fy(
          (h.escape || pn).source + "|" + He.source + "|" + (He === mt ? pe : pn).source + "|" + (h.evaluate || pn).source + "|$",
          "g"
        ), Ot = "//# sourceURL=" + (In.call(h, "sourceURL") ? (h.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++EL + "]") + `
`;
        u.replace(ot, function($t, rn, an, Zo, Co, ei) {
          return an || (an = Zo), qe += u.slice(Ve, ei).replace(Ar, zL), rn && (de = !0, qe += `' +
__e(` + rn + `) +
'`), Co && (xe = !0, qe += `';
` + Co + `;
__p += '`), an && (qe += `' +
((__t = (` + an + `)) == null ? '' : __t) +
'`), Ve = ei + $t.length, $t;
        }), qe += `';
`;
        var Ft = In.call(h, "variable") && h.variable;
        if (!Ft)
          qe = `with (obj) {
` + qe + `
}
`;
        else if (be.test(Ft))
          throw new Ht(l);
        qe = (xe ? qe.replace(It, "") : qe).replace(fn, "$1").replace(Bn, "$1;"), qe = "function(" + (Ft || "obj") + `) {
` + (Ft ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (de ? ", __e = _.escape" : "") + (xe ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + qe + `return __p
}`;
        var Yt = u1(function() {
          return mn(X, Ot + "return " + qe).apply(n, se);
        });
        if (Yt.source = qe, vv(Yt))
          throw Yt;
        return Yt;
      }
      function mU(u) {
        return wn(u).toLowerCase();
      }
      function bU(u) {
        return wn(u).toUpperCase();
      }
      function yU(u, h, x) {
        if (u = wn(u), u && (x || h === n))
          return vE(u);
        if (!u || !(h = Xo(h)))
          return u;
        var M = Ui(u), G = Ui(h), X = wE(M, G), se = CE(M, G) + 1;
        return Fa(M, X, se).join("");
      }
      function vU(u, h, x) {
        if (u = wn(u), u && (x || h === n))
          return u.slice(0, SE(u) + 1);
        if (!u || !(h = Xo(h)))
          return u;
        var M = Ui(u), G = CE(M, Ui(h)) + 1;
        return Fa(M, 0, G).join("");
      }
      function wU(u, h, x) {
        if (u = wn(u), u && (x || h === n))
          return u.replace(ze, "");
        if (!u || !(h = Xo(h)))
          return u;
        var M = Ui(u), G = wE(M, Ui(h));
        return Fa(M, G).join("");
      }
      function CU(u, h) {
        var x = C, M = D;
        if (cr(h)) {
          var G = "separator" in h ? h.separator : G;
          x = "length" in h ? Kt(h.length) : x, M = "omission" in h ? Xo(h.omission) : M;
        }
        u = wn(u);
        var X = u.length;
        if (Bc(u)) {
          var se = Ui(u);
          X = se.length;
        }
        if (x >= X)
          return u;
        var de = x - Vc(M);
        if (de < 1)
          return M;
        var xe = se ? Fa(se, 0, de).join("") : u.slice(0, de);
        if (G === n)
          return xe + M;
        if (se && (de += xe.length - de), wv(G)) {
          if (u.slice(de).search(G)) {
            var Ve, He = xe;
            for (G.global || (G = Fy(G.source, wn(he.exec(G)) + "g")), G.lastIndex = 0; Ve = G.exec(He); )
              var qe = Ve.index;
            xe = xe.slice(0, qe === n ? de : qe);
          }
        } else if (u.indexOf(Xo(G), de) != de) {
          var ot = xe.lastIndexOf(G);
          ot > -1 && (xe = xe.slice(0, ot));
        }
        return xe + M;
      }
      function xU(u) {
        return u = wn(u), u && ar.test(u) ? u.replace(kn, XL) : u;
      }
      var SU = Kc(function(u, h, x) {
        return u + (x ? " " : "") + h.toUpperCase();
      }), Sv = dT("toUpperCase");
      function c1(u, h, x) {
        return u = wn(u), h = x ? n : h, h === n ? WL(u) ? ej(u) : $L(u) : u.match(h) || [];
      }
      var u1 = Zt(function(u, h) {
        try {
          return Yo(u, n, h);
        } catch (x) {
          return vv(x) ? x : new Ht(x);
        }
      }), EU = Zs(function(u, h) {
        return yi(h, function(x) {
          x = ps(x), Xs(u, x, bv(u[x], u));
        }), u;
      });
      function TU(u) {
        var h = u == null ? 0 : u.length, x = Nt();
        return u = h ? tr(u, function(M) {
          if (typeof M[1] != "function")
            throw new vi(a);
          return [x(M[0]), M[1]];
        }) : [], Zt(function(M) {
          for (var G = -1; ++G < h; ) {
            var X = u[G];
            if (Yo(X[0], this, M))
              return Yo(X[1], this, M);
          }
        });
      }
      function OU(u) {
        return Xj(Ci(u, p));
      }
      function Ev(u) {
        return function() {
          return u;
        };
      }
      function PU(u, h) {
        return u == null || u !== u ? h : u;
      }
      var IU = pT(), RU = pT(!0);
      function Do(u) {
        return u;
      }
      function Tv(u) {
        return UE(typeof u == "function" ? u : Ci(u, p));
      }
      function _U(u) {
        return GE(Ci(u, p));
      }
      function kU(u, h) {
        return WE(u, Ci(h, p));
      }
      var MU = Zt(function(u, h) {
        return function(x) {
          return Yd(x, u, h);
        };
      }), AU = Zt(function(u, h) {
        return function(x) {
          return Yd(u, x, h);
        };
      });
      function Ov(u, h, x) {
        var M = qr(h), G = Fh(h, M);
        x == null && !(cr(h) && (G.length || !M.length)) && (x = h, h = u, u = this, G = Fh(h, qr(h)));
        var X = !(cr(x) && "chain" in x) || !!x.chain, se = ta(u);
        return yi(G, function(de) {
          var xe = h[de];
          u[de] = xe, se && (u.prototype[de] = function() {
            var Ve = this.__chain__;
            if (X || Ve) {
              var He = u(this.__wrapped__), qe = He.__actions__ = ko(this.__actions__);
              return qe.push({ func: xe, args: arguments, thisArg: u }), He.__chain__ = Ve, He;
            }
            return xe.apply(u, _a([this.value()], arguments));
          });
        }), u;
      }
      function DU() {
        return to._ === this && (to._ = sj), this;
      }
      function Pv() {
      }
      function NU(u) {
        return u = Kt(u), Zt(function(h) {
          return qE(h, u);
        });
      }
      var FU = ov(tr), $U = ov(hE), LU = ov(Ry);
      function d1(u) {
        return dv(u) ? _y(ps(u)) : h2(u);
      }
      function jU(u) {
        return function(h) {
          return u == null ? n : Hl(u, h);
        };
      }
      var BU = gT(), VU = gT(!0);
      function Iv() {
        return [];
      }
      function Rv() {
        return !1;
      }
      function HU() {
        return {};
      }
      function UU() {
        return "";
      }
      function zU() {
        return !0;
      }
      function GU(u, h) {
        if (u = Kt(u), u < 1 || u > W)
          return [];
        var x = z, M = co(u, z);
        h = Nt(h), u -= z;
        for (var G = Ay(M, h); ++x < u; )
          h(x);
        return G;
      }
      function WU(u) {
        return Gt(u) ? tr(u, ps) : Jo(u) ? [u] : ko(kT(wn(u)));
      }
      function qU(u) {
        var h = ++oj;
        return wn(u) + h;
      }
      var KU = Hh(function(u, h) {
        return u + h;
      }, 0), YU = iv("ceil"), QU = Hh(function(u, h) {
        return u / h;
      }, 1), XU = iv("floor");
      function JU(u) {
        return u && u.length ? Nh(u, Do, zy) : n;
      }
      function ZU(u, h) {
        return u && u.length ? Nh(u, Nt(h, 2), zy) : n;
      }
      function ez(u) {
        return bE(u, Do);
      }
      function tz(u, h) {
        return bE(u, Nt(h, 2));
      }
      function nz(u) {
        return u && u.length ? Nh(u, Do, Ky) : n;
      }
      function rz(u, h) {
        return u && u.length ? Nh(u, Nt(h, 2), Ky) : n;
      }
      var oz = Hh(function(u, h) {
        return u * h;
      }, 1), iz = iv("round"), sz = Hh(function(u, h) {
        return u - h;
      }, 0);
      function az(u) {
        return u && u.length ? My(u, Do) : 0;
      }
      function lz(u, h) {
        return u && u.length ? My(u, Nt(h, 2)) : 0;
      }
      return Y.after = _V, Y.ary = HT, Y.assign = bH, Y.assignIn = n1, Y.assignInWith = tg, Y.assignWith = yH, Y.at = vH, Y.before = UT, Y.bind = bv, Y.bindAll = EU, Y.bindKey = zT, Y.castArray = HV, Y.chain = jT, Y.chunk = X2, Y.compact = J2, Y.concat = Z2, Y.cond = TU, Y.conforms = OU, Y.constant = Ev, Y.countBy = aV, Y.create = wH, Y.curry = GT, Y.curryRight = WT, Y.debounce = qT, Y.defaults = CH, Y.defaultsDeep = xH, Y.defer = kV, Y.delay = MV, Y.difference = eB, Y.differenceBy = tB, Y.differenceWith = nB, Y.drop = rB, Y.dropRight = oB, Y.dropRightWhile = iB, Y.dropWhile = sB, Y.fill = aB, Y.filter = cV, Y.flatMap = fV, Y.flatMapDeep = pV, Y.flatMapDepth = hV, Y.flatten = NT, Y.flattenDeep = lB, Y.flattenDepth = cB, Y.flip = AV, Y.flow = IU, Y.flowRight = RU, Y.fromPairs = uB, Y.functions = RH, Y.functionsIn = _H, Y.groupBy = gV, Y.initial = fB, Y.intersection = pB, Y.intersectionBy = hB, Y.intersectionWith = gB, Y.invert = MH, Y.invertBy = AH, Y.invokeMap = bV, Y.iteratee = Tv, Y.keyBy = yV, Y.keys = qr, Y.keysIn = Ao, Y.map = Yh, Y.mapKeys = NH, Y.mapValues = FH, Y.matches = _U, Y.matchesProperty = kU, Y.memoize = Xh, Y.merge = $H, Y.mergeWith = r1, Y.method = MU, Y.methodOf = AU, Y.mixin = Ov, Y.negate = Jh, Y.nthArg = NU, Y.omit = LH, Y.omitBy = jH, Y.once = DV, Y.orderBy = vV, Y.over = FU, Y.overArgs = NV, Y.overEvery = $U, Y.overSome = LU, Y.partial = yv, Y.partialRight = KT, Y.partition = wV, Y.pick = BH, Y.pickBy = o1, Y.property = d1, Y.propertyOf = jU, Y.pull = vB, Y.pullAll = $T, Y.pullAllBy = wB, Y.pullAllWith = CB, Y.pullAt = xB, Y.range = BU, Y.rangeRight = VU, Y.rearg = FV, Y.reject = SV, Y.remove = SB, Y.rest = $V, Y.reverse = gv, Y.sampleSize = TV, Y.set = HH, Y.setWith = UH, Y.shuffle = OV, Y.slice = EB, Y.sortBy = RV, Y.sortedUniq = kB, Y.sortedUniqBy = MB, Y.split = fU, Y.spread = LV, Y.tail = AB, Y.take = DB, Y.takeRight = NB, Y.takeRightWhile = FB, Y.takeWhile = $B, Y.tap = JB, Y.throttle = jV, Y.thru = Kh, Y.toArray = ZT, Y.toPairs = i1, Y.toPairsIn = s1, Y.toPath = WU, Y.toPlainObject = t1, Y.transform = zH, Y.unary = BV, Y.union = LB, Y.unionBy = jB, Y.unionWith = BB, Y.uniq = VB, Y.uniqBy = HB, Y.uniqWith = UB, Y.unset = GH, Y.unzip = mv, Y.unzipWith = LT, Y.update = WH, Y.updateWith = qH, Y.values = Xc, Y.valuesIn = KH, Y.without = zB, Y.words = c1, Y.wrap = VV, Y.xor = GB, Y.xorBy = WB, Y.xorWith = qB, Y.zip = KB, Y.zipObject = YB, Y.zipObjectDeep = QB, Y.zipWith = XB, Y.entries = i1, Y.entriesIn = s1, Y.extend = n1, Y.extendWith = tg, Ov(Y, Y), Y.add = KU, Y.attempt = u1, Y.camelCase = JH, Y.capitalize = a1, Y.ceil = YU, Y.clamp = YH, Y.clone = UV, Y.cloneDeep = GV, Y.cloneDeepWith = WV, Y.cloneWith = zV, Y.conformsTo = qV, Y.deburr = l1, Y.defaultTo = PU, Y.divide = QU, Y.endsWith = ZH, Y.eq = Gi, Y.escape = eU, Y.escapeRegExp = tU, Y.every = lV, Y.find = uV, Y.findIndex = AT, Y.findKey = SH, Y.findLast = dV, Y.findLastIndex = DT, Y.findLastKey = EH, Y.floor = XU, Y.forEach = BT, Y.forEachRight = VT, Y.forIn = TH, Y.forInRight = OH, Y.forOwn = PH, Y.forOwnRight = IH, Y.get = Cv, Y.gt = KV, Y.gte = YV, Y.has = kH, Y.hasIn = xv, Y.head = FT, Y.identity = Do, Y.includes = mV, Y.indexOf = dB, Y.inRange = QH, Y.invoke = DH, Y.isArguments = Gl, Y.isArray = Gt, Y.isArrayBuffer = QV, Y.isArrayLike = Mo, Y.isArrayLikeObject = Er, Y.isBoolean = XV, Y.isBuffer = $a, Y.isDate = JV, Y.isElement = ZV, Y.isEmpty = eH, Y.isEqual = tH, Y.isEqualWith = nH, Y.isError = vv, Y.isFinite = rH, Y.isFunction = ta, Y.isInteger = YT, Y.isLength = Zh, Y.isMap = QT, Y.isMatch = oH, Y.isMatchWith = iH, Y.isNaN = sH, Y.isNative = aH, Y.isNil = cH, Y.isNull = lH, Y.isNumber = XT, Y.isObject = cr, Y.isObjectLike = hr, Y.isPlainObject = tf, Y.isRegExp = wv, Y.isSafeInteger = uH, Y.isSet = JT, Y.isString = eg, Y.isSymbol = Jo, Y.isTypedArray = Qc, Y.isUndefined = dH, Y.isWeakMap = fH, Y.isWeakSet = pH, Y.join = mB, Y.kebabCase = nU, Y.last = Si, Y.lastIndexOf = bB, Y.lowerCase = rU, Y.lowerFirst = oU, Y.lt = hH, Y.lte = gH, Y.max = JU, Y.maxBy = ZU, Y.mean = ez, Y.meanBy = tz, Y.min = nz, Y.minBy = rz, Y.stubArray = Iv, Y.stubFalse = Rv, Y.stubObject = HU, Y.stubString = UU, Y.stubTrue = zU, Y.multiply = oz, Y.nth = yB, Y.noConflict = DU, Y.noop = Pv, Y.now = Qh, Y.pad = iU, Y.padEnd = sU, Y.padStart = aU, Y.parseInt = lU, Y.random = XH, Y.reduce = CV, Y.reduceRight = xV, Y.repeat = cU, Y.replace = uU, Y.result = VH, Y.round = iz, Y.runInContext = ye, Y.sample = EV, Y.size = PV, Y.snakeCase = dU, Y.some = IV, Y.sortedIndex = TB, Y.sortedIndexBy = OB, Y.sortedIndexOf = PB, Y.sortedLastIndex = IB, Y.sortedLastIndexBy = RB, Y.sortedLastIndexOf = _B, Y.startCase = pU, Y.startsWith = hU, Y.subtract = sz, Y.sum = az, Y.sumBy = lz, Y.template = gU, Y.times = GU, Y.toFinite = na, Y.toInteger = Kt, Y.toLength = e1, Y.toLower = mU, Y.toNumber = Ei, Y.toSafeInteger = mH, Y.toString = wn, Y.toUpper = bU, Y.trim = yU, Y.trimEnd = vU, Y.trimStart = wU, Y.truncate = CU, Y.unescape = xU, Y.uniqueId = qU, Y.upperCase = SU, Y.upperFirst = Sv, Y.each = BT, Y.eachRight = VT, Y.first = FT, Ov(Y, function() {
        var u = {};
        return ds(Y, function(h, x) {
          In.call(Y.prototype, x) || (u[x] = h);
        }), u;
      }(), { chain: !1 }), Y.VERSION = r, yi(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(u) {
        Y[u].placeholder = Y;
      }), yi(["drop", "take"], function(u, h) {
        sn.prototype[u] = function(x) {
          x = x === n ? 1 : Br(Kt(x), 0);
          var M = this.__filtered__ && !h ? new sn(this) : this.clone();
          return M.__filtered__ ? M.__takeCount__ = co(x, M.__takeCount__) : M.__views__.push({
            size: co(x, z),
            type: u + (M.__dir__ < 0 ? "Right" : "")
          }), M;
        }, sn.prototype[u + "Right"] = function(x) {
          return this.reverse()[u](x).reverse();
        };
      }), yi(["filter", "map", "takeWhile"], function(u, h) {
        var x = h + 1, M = x == H || x == N;
        sn.prototype[u] = function(G) {
          var X = this.clone();
          return X.__iteratees__.push({
            iteratee: Nt(G, 3),
            type: x
          }), X.__filtered__ = X.__filtered__ || M, X;
        };
      }), yi(["head", "last"], function(u, h) {
        var x = "take" + (h ? "Right" : "");
        sn.prototype[u] = function() {
          return this[x](1).value()[0];
        };
      }), yi(["initial", "tail"], function(u, h) {
        var x = "drop" + (h ? "" : "Right");
        sn.prototype[u] = function() {
          return this.__filtered__ ? new sn(this) : this[x](1);
        };
      }), sn.prototype.compact = function() {
        return this.filter(Do);
      }, sn.prototype.find = function(u) {
        return this.filter(u).head();
      }, sn.prototype.findLast = function(u) {
        return this.reverse().find(u);
      }, sn.prototype.invokeMap = Zt(function(u, h) {
        return typeof u == "function" ? new sn(this) : this.map(function(x) {
          return Yd(x, u, h);
        });
      }), sn.prototype.reject = function(u) {
        return this.filter(Jh(Nt(u)));
      }, sn.prototype.slice = function(u, h) {
        u = Kt(u);
        var x = this;
        return x.__filtered__ && (u > 0 || h < 0) ? new sn(x) : (u < 0 ? x = x.takeRight(-u) : u && (x = x.drop(u)), h !== n && (h = Kt(h), x = h < 0 ? x.dropRight(-h) : x.take(h - u)), x);
      }, sn.prototype.takeRightWhile = function(u) {
        return this.reverse().takeWhile(u).reverse();
      }, sn.prototype.toArray = function() {
        return this.take(z);
      }, ds(sn.prototype, function(u, h) {
        var x = /^(?:filter|find|map|reject)|While$/.test(h), M = /^(?:head|last)$/.test(h), G = Y[M ? "take" + (h == "last" ? "Right" : "") : h], X = M || /^find/.test(h);
        G && (Y.prototype[h] = function() {
          var se = this.__wrapped__, de = M ? [1] : arguments, xe = se instanceof sn, Ve = de[0], He = xe || Gt(se), qe = function(rn) {
            var an = G.apply(Y, _a([rn], de));
            return M && ot ? an[0] : an;
          };
          He && x && typeof Ve == "function" && Ve.length != 1 && (xe = He = !1);
          var ot = this.__chain__, Ot = !!this.__actions__.length, Ft = X && !ot, Yt = xe && !Ot;
          if (!X && He) {
            se = Yt ? se : new sn(this);
            var $t = u.apply(se, de);
            return $t.__actions__.push({ func: Kh, args: [qe], thisArg: n }), new wi($t, ot);
          }
          return Ft && Yt ? u.apply(this, de) : ($t = this.thru(qe), Ft ? M ? $t.value()[0] : $t.value() : $t);
        });
      }), yi(["pop", "push", "shift", "sort", "splice", "unshift"], function(u) {
        var h = wh[u], x = /^(?:push|sort|unshift)$/.test(u) ? "tap" : "thru", M = /^(?:pop|shift)$/.test(u);
        Y.prototype[u] = function() {
          var G = arguments;
          if (M && !this.__chain__) {
            var X = this.value();
            return h.apply(Gt(X) ? X : [], G);
          }
          return this[x](function(se) {
            return h.apply(Gt(se) ? se : [], G);
          });
        };
      }), ds(sn.prototype, function(u, h) {
        var x = Y[h];
        if (x) {
          var M = x.name + "";
          In.call(Gc, M) || (Gc[M] = []), Gc[M].push({ name: h, func: x });
        }
      }), Gc[Vh(n, E).name] = [{
        name: "wrapper",
        func: n
      }], sn.prototype.clone = xj, sn.prototype.reverse = Sj, sn.prototype.value = Ej, Y.prototype.at = ZB, Y.prototype.chain = eV, Y.prototype.commit = tV, Y.prototype.next = nV, Y.prototype.plant = oV, Y.prototype.reverse = iV, Y.prototype.toJSON = Y.prototype.valueOf = Y.prototype.value = sV, Y.prototype.first = Y.prototype.head, Hd && (Y.prototype[Hd] = rV), Y;
    }, Hc = tj();
    $l ? (($l.exports = Hc)._ = Hc, Ty._ = Hc) : to._ = Hc;
  }).call(Cr);
})(mm, mm.exports);
var Bg = mm.exports;
function Ree(e, t, n = {}) {
  let { embeddedObjKeys: r, keysToSkip: o, treatTypeChangeAsReplace: i } = n;
  return r instanceof Map ? r = new Map(
    Array.from(r.entries()).map(([a, l]) => [
      a instanceof RegExp ? a : a.replace(/^\./, ""),
      l
    ])
  ) : r && (r = Object.fromEntries(
    Object.entries(r).map(([a, l]) => [a.replace(/^\./, ""), l])
  )), QA(e, t, [], [], {
    embeddedObjKeys: r,
    keysToSkip: o ?? [],
    treatTypeChangeAsReplace: i ?? !0
  });
}
var H0 = (e) => typeof e > "u" ? "undefined" : e === null ? null : Object.prototype.toString.call(e).match(/^\[object\s(.*)\]$/)[1], Ps = (e) => {
  const t = e[e.length - 1];
  return t ?? "$root";
}, QA = (e, t, n, r, o) => {
  let i = [];
  const a = H0(e), l = H0(t);
  if (o.treatTypeChangeAsReplace && a !== l)
    return i.push({ type: "REMOVE", key: Ps(n), value: e }), l !== "undefined" && i.push({ type: "ADD", key: Ps(n), value: t }), i;
  if (l === "undefined" && a !== "undefined")
    return i.push({ type: "REMOVE", key: Ps(n), value: e }), i;
  if (l === "Object" && a === "Array")
    return i.push({ type: "UPDATE", key: Ps(n), value: t, oldValue: e }), i;
  switch (a) {
    case "Date":
      i = i.concat(
        JP(e.getTime(), t.getTime(), n).map((c) => ({
          ...c,
          value: new Date(c.value),
          oldValue: new Date(c.oldValue)
        }))
      );
      break;
    case "Object": {
      const c = XA(e, t, n, r, !1, o);
      c.length && (n.length ? i.push({
        type: "UPDATE",
        key: Ps(n),
        changes: c
      }) : i = i.concat(c));
      break;
    }
    case "Array":
      i = i.concat(_ee(e, t, n, r, o));
      break;
    case "Function":
      break;
    default:
      i = i.concat(JP(e, t, n));
  }
  return i;
}, XA = (e, t, n, r, o = !1, i = {}) => {
  let a, l, c;
  o == null && (o = !1);
  let d = [];
  const f = Object.keys(e).filter((y) => i.keysToSkip.indexOf(y) === -1), p = Object.keys(t).filter((y) => i.keysToSkip.indexOf(y) === -1), g = Bg.intersection(f, p);
  for (a of g) {
    c = n.concat([a]), l = o ? r : r.concat([a]);
    const y = QA(e[a], t[a], c, l, i);
    y.length && (d = d.concat(y));
  }
  const b = Bg.difference(p, f);
  for (a of b)
    c = n.concat([a]), l = o ? r : r.concat([a]), d.push({
      type: "ADD",
      key: Ps(c),
      value: t[a]
    });
  const v = Bg.difference(f, p);
  for (a of v)
    c = n.concat([a]), l = o ? r : r.concat([a]), d.push({
      type: "REMOVE",
      key: Ps(c),
      value: e[a]
    });
  return d;
}, _ee = (e, t, n, r, o) => {
  if (H0(t) !== "Array")
    return [{ type: "UPDATE", key: Ps(n), value: t, oldValue: e }];
  const i = kee(o.embeddedObjKeys, r), a = i ?? "$index", l = XP(e, a), c = XP(t, a), d = XA(l, c, n, r, !0, o);
  return d.length ? [
    {
      type: "UPDATE",
      key: Ps(n),
      embeddedKey: typeof a == "function" && a.length === 2 ? a(t[0], !0) : a,
      changes: d
    }
  ] : [];
}, kee = (e, t) => {
  if (e != null) {
    const n = t.join(".");
    if (e instanceof Map) {
      for (const [o, i] of e.entries())
        if (o instanceof RegExp) {
          if (n.match(o))
            return i;
        } else if (n === o)
          return i;
    }
    const r = e[n];
    if (r != null)
      return r;
  }
}, XP = (e, t) => {
  let n = {};
  if (t === "$value")
    e.forEach((r) => {
      n[r] = r;
    });
  else if (t !== "$index")
    n = Bg.keyBy(e, t);
  else
    for (let r = 0; r < e.length; r++) {
      const o = e[r];
      n[r] = o;
    }
  return n;
}, JP = (e, t, n) => {
  const r = [];
  return e !== t && r.push({
    type: "UPDATE",
    key: Ps(n),
    value: t,
    oldValue: e
  }), r;
};
function Mee({
  children: e
}) {
  const [t, n] = Jt(null), [r, o] = Jt(!0), [i, a] = Jt(), [l, c] = Jt(!1), d = _d().dataClient, f = pl(() => new Iee(d), [d]), p = Li(Vx), g = !0;
  ir(() => {
    let v = !0;
    async function y() {
      const {
        data: { session: S },
        error: E
      } = await f.getSession();
      if (v) {
        if (E) {
          a(E), o(!1);
          return;
        }
        if (!S && !l && g) {
          async function I() {
            const { data: O } = await f.signInWithSSO(
              p.ssoIdentityProviderId
            );
            O != null && O.url && (window.location.href = O.url);
          }
          I().finally(() => {
            c(!0);
          });
        } else
          n(S), o(!1);
      }
    }
    return y(), () => {
      v = !1;
    };
  }, [
    f,
    l,
    p.ssoIdentityProviderId,
    g
  ]), ir(() => {
    const {
      data: { subscription: v }
    } = f.onAuthStateChange((y, S) => {
      S && ["SIGNED_IN", "TOKEN_REFRESHED", "USER_UPDATED"].includes(y) && n((E) => Ree(E, S).length > 0 ? S : E), y === "SIGNED_OUT" && n(null);
    });
    return () => {
      v.unsubscribe();
    };
  }, [f]);
  const b = pl(() => ({
    isLoading: r,
    session: t,
    error: i ?? null,
    logout: async () => await f.logout(),
    useSso: g
  }), [r, t, i, f, g]);
  return /* @__PURE__ */ w.jsx(eA.Provider, { value: b, children: e });
}
function kt(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function Ln(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function mp(e, t) {
  const n = kt(e);
  return isNaN(t) ? Ln(e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
function Hx(e, t) {
  const n = +kt(e);
  return Ln(e, n + t);
}
function Aee(e, t) {
  return Hx(e, t * 1e3);
}
const JA = 6048e5, Dee = 864e5, ZA = 6e4, eD = 36e5, Nee = 1e3;
function Fee(e, t) {
  return Hx(e, t * ZA);
}
function $ee(e, t) {
  return Hx(e, t * eD);
}
function Lee(e, t) {
  const n = t * 7;
  return mp(e, n);
}
function tD(e, t) {
  const n = kt(e);
  if (isNaN(t)) return Ln(e, NaN);
  if (!t)
    return n;
  const r = n.getDate(), o = Ln(e, n.getTime());
  o.setMonth(n.getMonth() + t + 1, 0);
  const i = o.getDate();
  return r >= i ? o : (n.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    r
  ), n);
}
function jee(e, t) {
  return tD(e, t * 12);
}
function ZP(e) {
  const t = kt(e);
  return t.setHours(23, 59, 59, 999), t;
}
let Bee = {};
function Dc() {
  return Bee;
}
function Vee(e, t) {
  var l, c, d, f;
  const n = Dc(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (l = t == null ? void 0 : t.locale) == null ? void 0 : l.options) == null ? void 0 : c.weekStartsOn) ?? n.weekStartsOn ?? ((f = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) ?? 0, o = kt(e), i = o.getDay(), a = (i < r ? -7 : 0) + 6 - (i - r);
  return o.setDate(o.getDate() + a), o.setHours(23, 59, 59, 999), o;
}
function eI(e) {
  const t = kt(e), n = t.getFullYear();
  return t.setFullYear(n + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
const Hee = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Uee = (e, t, n) => {
  let r;
  const o = Hee[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function pw(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const zee = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Gee = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Wee = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, qee = {
  date: pw({
    formats: zee,
    defaultWidth: "full"
  }),
  time: pw({
    formats: Gee,
    defaultWidth: "full"
  }),
  dateTime: pw({
    formats: Wee,
    defaultWidth: "full"
  })
}, Kee = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Yee = (e, t, n, r) => Kee[e];
function bf(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, l = n != null && n.width ? String(n.width) : a;
      o = e.formattingValues[l] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, l = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[l] || e.values[a];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[i];
  };
}
const Qee = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Xee = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Jee = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Zee = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, ete = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, tte = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, nte = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, rte = {
  ordinalNumber: nte,
  era: bf({
    values: Qee,
    defaultWidth: "wide"
  }),
  quarter: bf({
    values: Xee,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: bf({
    values: Jee,
    defaultWidth: "wide"
  }),
  day: bf({
    values: Zee,
    defaultWidth: "wide"
  }),
  dayPeriod: bf({
    values: ete,
    defaultWidth: "wide",
    formattingValues: tte,
    defaultFormattingWidth: "wide"
  })
};
function yf(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(o);
    if (!i)
      return null;
    const a = i[0], l = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(l) ? ite(l, (p) => p.test(a)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      ote(l, (p) => p.test(a))
    );
    let d;
    d = e.valueCallback ? e.valueCallback(c) : c, d = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(d)
    ) : d;
    const f = t.slice(a.length);
    return { value: d, rest: f };
  };
}
function ote(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function ite(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function ste(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let a = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const l = t.slice(o.length);
    return { value: a, rest: l };
  };
}
const ate = /^(\d+)(th|st|nd|rd)?/i, lte = /\d+/i, cte = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, ute = {
  any: [/^b/i, /^(a|c)/i]
}, dte = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, fte = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, pte = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, hte = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, gte = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, mte = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, bte = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, yte = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, vte = {
  ordinalNumber: ste({
    matchPattern: ate,
    parsePattern: lte,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: yf({
    matchPatterns: cte,
    defaultMatchWidth: "wide",
    parsePatterns: ute,
    defaultParseWidth: "any"
  }),
  quarter: yf({
    matchPatterns: dte,
    defaultMatchWidth: "wide",
    parsePatterns: fte,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: yf({
    matchPatterns: pte,
    defaultMatchWidth: "wide",
    parsePatterns: hte,
    defaultParseWidth: "any"
  }),
  day: yf({
    matchPatterns: gte,
    defaultMatchWidth: "wide",
    parsePatterns: mte,
    defaultParseWidth: "any"
  }),
  dayPeriod: yf({
    matchPatterns: bte,
    defaultMatchWidth: "any",
    parsePatterns: yte,
    defaultParseWidth: "any"
  })
}, Vb = {
  code: "en-US",
  formatDistance: Uee,
  formatLong: qee,
  formatRelative: Yee,
  localize: rte,
  match: vte,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function bp(e) {
  const t = kt(e);
  return t.setHours(0, 0, 0, 0), t;
}
function bm(e) {
  const t = kt(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function wte(e, t) {
  const n = bp(e), r = bp(t), o = +n - bm(n), i = +r - bm(r);
  return Math.round((o - i) / Dee);
}
function nD(e) {
  const t = kt(e), n = Ln(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Cte(e) {
  const t = kt(e);
  return wte(t, nD(t)) + 1;
}
function xa(e, t) {
  var l, c, d, f;
  const n = Dc(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (l = t == null ? void 0 : t.locale) == null ? void 0 : l.options) == null ? void 0 : c.weekStartsOn) ?? n.weekStartsOn ?? ((f = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) ?? 0, o = kt(e), i = o.getDay(), a = (i < r ? 7 : 0) + i - r;
  return o.setDate(o.getDate() - a), o.setHours(0, 0, 0, 0), o;
}
function md(e) {
  return xa(e, { weekStartsOn: 1 });
}
function rD(e) {
  const t = kt(e), n = t.getFullYear(), r = Ln(e, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const o = md(r), i = Ln(e, 0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  const a = md(i);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= a.getTime() ? n : n - 1;
}
function xte(e) {
  const t = rD(e), n = Ln(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), md(n);
}
function oD(e) {
  const t = kt(e), n = +md(t) - +xte(t);
  return Math.round(n / JA) + 1;
}
function Ux(e, t) {
  var f, p, g, b;
  const n = kt(e), r = n.getFullYear(), o = Dc(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((p = (f = t == null ? void 0 : t.locale) == null ? void 0 : f.options) == null ? void 0 : p.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((b = (g = o.locale) == null ? void 0 : g.options) == null ? void 0 : b.firstWeekContainsDate) ?? 1, a = Ln(e, 0);
  a.setFullYear(r + 1, 0, i), a.setHours(0, 0, 0, 0);
  const l = xa(a, t), c = Ln(e, 0);
  c.setFullYear(r, 0, i), c.setHours(0, 0, 0, 0);
  const d = xa(c, t);
  return n.getTime() >= l.getTime() ? r + 1 : n.getTime() >= d.getTime() ? r : r - 1;
}
function Ste(e, t) {
  var l, c, d, f;
  const n = Dc(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((c = (l = t == null ? void 0 : t.locale) == null ? void 0 : l.options) == null ? void 0 : c.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((f = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, o = Ux(e, t), i = Ln(e, 0);
  return i.setFullYear(o, 0, r), i.setHours(0, 0, 0, 0), xa(i, t);
}
function zx(e, t) {
  const n = kt(e), r = +xa(n, t) - +Ste(n, t);
  return Math.round(r / JA) + 1;
}
function _n(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const Ba = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return _n(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : _n(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return _n(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return _n(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return _n(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return _n(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return _n(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return _n(o, t.length);
  }
}, pu = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, tI = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return Ba.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = Ux(e, r), i = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const a = i % 100;
      return _n(a, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : _n(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = rD(e);
    return _n(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return _n(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return _n(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return _n(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Ba.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return _n(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = zx(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : _n(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = oD(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : _n(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Ba.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = Cte(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : _n(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(i);
      case "ee":
        return _n(i, 2);
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(i);
      case "cc":
        return _n(i, t.length);
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(o);
      case "ii":
        return _n(o, t.length);
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = pu.noon : r === 0 ? o = pu.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = pu.evening : r >= 12 ? o = pu.afternoon : r >= 4 ? o = pu.morning : o = pu.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return Ba.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Ba.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : _n(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : _n(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Ba.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Ba.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Ba.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return rI(r);
      case "XXXX":
      case "XX":
        return Ql(r);
      case "XXXXX":
      case "XXX":
      default:
        return Ql(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return rI(r);
      case "xxxx":
      case "xx":
        return Ql(r);
      case "xxxxx":
      case "xxx":
      default:
        return Ql(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + nI(r, ":");
      case "OOOO":
      default:
        return "GMT" + Ql(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + nI(r, ":");
      case "zzzz":
      default:
        return "GMT" + Ql(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(e.getTime() / 1e3);
    return _n(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const r = e.getTime();
    return _n(r, t.length);
  }
};
function nI(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(o) : n + String(o) + t + _n(i, 2);
}
function rI(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + _n(Math.abs(e) / 60, 2) : Ql(e, t);
}
function Ql(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = _n(Math.trunc(r / 60), 2), i = _n(r % 60, 2);
  return n + o + t + i;
}
const oI = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, iD = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, Ete = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return oI(e, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", oI(r, t)).replace("{{time}}", iD(o, t));
}, yp = {
  p: iD,
  P: Ete
}, Tte = /^D+$/, Ote = /^Y+$/, Pte = ["D", "DD", "YY", "YYYY"];
function sD(e) {
  return Tte.test(e);
}
function aD(e) {
  return Ote.test(e);
}
function U0(e, t, n) {
  const r = Ite(e, t, n);
  if (console.warn(r), Pte.includes(e)) throw new RangeError(r);
}
function Ite(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function Rte(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function lD(e) {
  if (!Rte(e) && typeof e != "number")
    return !1;
  const t = kt(e);
  return !isNaN(Number(t));
}
const _te = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, kte = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Mte = /^'([^]*?)'?$/, Ate = /''/g, Dte = /[a-zA-Z]/;
function Nte(e, t, n) {
  var f, p, g, b, v, y, S, E;
  const r = Dc(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? Vb, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((p = (f = n == null ? void 0 : n.locale) == null ? void 0 : f.options) == null ? void 0 : p.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((b = (g = r.locale) == null ? void 0 : g.options) == null ? void 0 : b.firstWeekContainsDate) ?? 1, a = (n == null ? void 0 : n.weekStartsOn) ?? ((y = (v = n == null ? void 0 : n.locale) == null ? void 0 : v.options) == null ? void 0 : y.weekStartsOn) ?? r.weekStartsOn ?? ((E = (S = r.locale) == null ? void 0 : S.options) == null ? void 0 : E.weekStartsOn) ?? 0, l = kt(e);
  if (!lD(l))
    throw new RangeError("Invalid time value");
  let c = t.match(kte).map((I) => {
    const O = I[0];
    if (O === "p" || O === "P") {
      const T = yp[O];
      return T(I, o.formatLong);
    }
    return I;
  }).join("").match(_te).map((I) => {
    if (I === "''")
      return { isToken: !1, value: "'" };
    const O = I[0];
    if (O === "'")
      return { isToken: !1, value: Fte(I) };
    if (tI[O])
      return { isToken: !0, value: I };
    if (O.match(Dte))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + O + "`"
      );
    return { isToken: !1, value: I };
  });
  o.localize.preprocessor && (c = o.localize.preprocessor(l, c));
  const d = {
    firstWeekContainsDate: i,
    weekStartsOn: a,
    locale: o
  };
  return c.map((I) => {
    if (!I.isToken) return I.value;
    const O = I.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && aD(O) || !(n != null && n.useAdditionalDayOfYearTokens) && sD(O)) && U0(O, t, String(e));
    const T = tI[O[0]];
    return T(l, O, o.localize, d);
  }).join("");
}
function Fte(e) {
  const t = e.match(Mte);
  return t ? t[1].replace(Ate, "'") : e;
}
function $te(e) {
  return kt(e).getDate();
}
function cD(e) {
  const t = kt(e), n = t.getFullYear(), r = t.getMonth(), o = Ln(e, 0);
  return o.setFullYear(n, r + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function Lte(e) {
  return kt(e).getHours();
}
function jte(e) {
  return kt(e).getMinutes();
}
function Bte(e) {
  return kt(e).getMonth();
}
function Vte(e) {
  return kt(e).getSeconds();
}
function Hte(e) {
  return kt(e).getMilliseconds();
}
function Ute(e) {
  return kt(e).getFullYear();
}
function hw(e, t) {
  const n = kt(e), r = kt(t);
  return n.getTime() > r.getTime();
}
function gw(e, t) {
  const n = kt(e), r = kt(t);
  return +n < +r;
}
function zte(e, t) {
  const n = kt(e), r = kt(t);
  return +n == +r;
}
function Gte(e, t) {
  const n = bp(e), r = bp(t);
  return +n == +r;
}
function Wte(e, t) {
  const n = kt(e), r = kt(t);
  return n.getFullYear() === r.getFullYear();
}
function qte(e, t) {
  const n = kt(e), r = kt(t);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
function iI(e) {
  const t = kt(e);
  return t.setMinutes(0, 0, 0), t;
}
function Kte(e, t) {
  const n = iI(e), r = iI(t);
  return +n == +r;
}
function Yte() {
  return Object.assign({}, Dc());
}
function Qte(e, t) {
  const n = t instanceof Date ? Ln(t, 0) : new t(0);
  return n.setFullYear(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  ), n.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), n;
}
const Xte = 10;
class uD {
  constructor() {
    nt(this, "subPriority", 0);
  }
  validate(t, n) {
    return !0;
  }
}
class Jte extends uD {
  constructor(t, n, r, o, i) {
    super(), this.value = t, this.validateValue = n, this.setValue = r, this.priority = o, i && (this.subPriority = i);
  }
  validate(t, n) {
    return this.validateValue(t, this.value, n);
  }
  set(t, n, r) {
    return this.setValue(t, n, this.value, r);
  }
}
class Zte extends uD {
  constructor() {
    super(...arguments);
    nt(this, "priority", Xte);
    nt(this, "subPriority", -1);
  }
  set(n, r) {
    return r.timestampIsSet ? n : Ln(n, Qte(n, Date));
  }
}
class vn {
  run(t, n, r, o) {
    const i = this.parse(t, n, r, o);
    return i ? {
      setter: new Jte(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(t, n, r) {
    return !0;
  }
}
class ene extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 140);
    nt(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return o.era(n, { width: "abbreviated" }) || o.era(n, { width: "narrow" });
      case "GGGGG":
        return o.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return o.era(n, { width: "wide" }) || o.era(n, { width: "abbreviated" }) || o.era(n, { width: "narrow" });
    }
  }
  set(n, r, o) {
    return r.era = o, n.setFullYear(o, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
const Ir = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Is = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Rr(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function dr(e, t) {
  const n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function Rs(e, t) {
  const n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const r = n[1] === "+" ? 1 : -1, o = n[2] ? parseInt(n[2], 10) : 0, i = n[3] ? parseInt(n[3], 10) : 0, a = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (o * eD + i * ZA + a * Nee),
    rest: t.slice(n[0].length)
  };
}
function dD(e) {
  return dr(Ir.anyDigitsSigned, e);
}
function Sr(e, t) {
  switch (e) {
    case 1:
      return dr(Ir.singleDigit, t);
    case 2:
      return dr(Ir.twoDigits, t);
    case 3:
      return dr(Ir.threeDigits, t);
    case 4:
      return dr(Ir.fourDigits, t);
    default:
      return dr(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function ym(e, t) {
  switch (e) {
    case 1:
      return dr(Ir.singleDigitSigned, t);
    case 2:
      return dr(Ir.twoDigitsSigned, t);
    case 3:
      return dr(Ir.threeDigitsSigned, t);
    case 4:
      return dr(Ir.fourDigitsSigned, t);
    default:
      return dr(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function Gx(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function fD(e, t) {
  const n = t > 0, r = n ? t : 1 - t;
  let o;
  if (r <= 50)
    o = e || 100;
  else {
    const i = r + 50, a = Math.trunc(i / 100) * 100, l = e >= i % 100;
    o = e + a - (l ? 100 : 0);
  }
  return n ? o : 1 - o;
}
function pD(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class tne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 130);
    nt(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, r, o) {
    const i = (a) => ({
      year: a,
      isTwoDigitYear: r === "yy"
    });
    switch (r) {
      case "y":
        return Rr(Sr(4, n), i);
      case "yo":
        return Rr(
          o.ordinalNumber(n, {
            unit: "year"
          }),
          i
        );
      default:
        return Rr(Sr(r.length, n), i);
    }
  }
  validate(n, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(n, r, o) {
    const i = n.getFullYear();
    if (o.isTwoDigitYear) {
      const l = fD(
        o.year,
        i
      );
      return n.setFullYear(l, 0, 1), n.setHours(0, 0, 0, 0), n;
    }
    const a = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return n.setFullYear(a, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class nne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 130);
    nt(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    const i = (a) => ({
      year: a,
      isTwoDigitYear: r === "YY"
    });
    switch (r) {
      case "Y":
        return Rr(Sr(4, n), i);
      case "Yo":
        return Rr(
          o.ordinalNumber(n, {
            unit: "year"
          }),
          i
        );
      default:
        return Rr(Sr(r.length, n), i);
    }
  }
  validate(n, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(n, r, o, i) {
    const a = Ux(n, i);
    if (o.isTwoDigitYear) {
      const c = fD(
        o.year,
        a
      );
      return n.setFullYear(
        c,
        0,
        i.firstWeekContainsDate
      ), n.setHours(0, 0, 0, 0), xa(n, i);
    }
    const l = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return n.setFullYear(l, 0, i.firstWeekContainsDate), n.setHours(0, 0, 0, 0), xa(n, i);
  }
}
class rne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 130);
    nt(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r) {
    return ym(r === "R" ? 4 : r.length, n);
  }
  set(n, r, o) {
    const i = Ln(n, 0);
    return i.setFullYear(o, 0, 4), i.setHours(0, 0, 0, 0), md(i);
  }
}
class one extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 130);
    nt(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, r) {
    return ym(r === "u" ? 4 : r.length, n);
  }
  set(n, r, o) {
    return n.setFullYear(o, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class ine extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 120);
    nt(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "Q":
      case "QQ":
        return Sr(r.length, n);
      case "Qo":
        return o.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return o.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return o.quarter(n, {
          width: "wide",
          context: "formatting"
        }) || o.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 4;
  }
  set(n, r, o) {
    return n.setMonth((o - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class sne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 120);
    nt(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "q":
      case "qq":
        return Sr(r.length, n);
      case "qo":
        return o.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return o.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return o.quarter(n, {
          width: "wide",
          context: "standalone"
        }) || o.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 4;
  }
  set(n, r, o) {
    return n.setMonth((o - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class ane extends vn {
  constructor() {
    super(...arguments);
    nt(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    nt(this, "priority", 110);
  }
  parse(n, r, o) {
    const i = (a) => a - 1;
    switch (r) {
      case "M":
        return Rr(
          dr(Ir.month, n),
          i
        );
      case "MM":
        return Rr(Sr(2, n), i);
      case "Mo":
        return Rr(
          o.ordinalNumber(n, {
            unit: "month"
          }),
          i
        );
      case "MMM":
        return o.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(n, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return o.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return o.month(n, { width: "wide", context: "formatting" }) || o.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, o) {
    return n.setMonth(o, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class lne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 110);
    nt(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    const i = (a) => a - 1;
    switch (r) {
      case "L":
        return Rr(
          dr(Ir.month, n),
          i
        );
      case "LL":
        return Rr(Sr(2, n), i);
      case "Lo":
        return Rr(
          o.ordinalNumber(n, {
            unit: "month"
          }),
          i
        );
      case "LLL":
        return o.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(n, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return o.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return o.month(n, { width: "wide", context: "standalone" }) || o.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, o) {
    return n.setMonth(o, 1), n.setHours(0, 0, 0, 0), n;
  }
}
function cne(e, t, n) {
  const r = kt(e), o = zx(r, n) - t;
  return r.setDate(r.getDate() - o * 7), r;
}
class une extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 100);
    nt(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "w":
        return dr(Ir.week, n);
      case "wo":
        return o.ordinalNumber(n, { unit: "week" });
      default:
        return Sr(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 53;
  }
  set(n, r, o, i) {
    return xa(cne(n, o, i), i);
  }
}
function dne(e, t) {
  const n = kt(e), r = oD(n) - t;
  return n.setDate(n.getDate() - r * 7), n;
}
class fne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 100);
    nt(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "I":
        return dr(Ir.week, n);
      case "Io":
        return o.ordinalNumber(n, { unit: "week" });
      default:
        return Sr(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 53;
  }
  set(n, r, o) {
    return md(dne(n, o));
  }
}
const pne = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], hne = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class gne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 90);
    nt(this, "subPriority", 1);
    nt(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "d":
        return dr(Ir.date, n);
      case "do":
        return o.ordinalNumber(n, { unit: "date" });
      default:
        return Sr(r.length, n);
    }
  }
  validate(n, r) {
    const o = n.getFullYear(), i = pD(o), a = n.getMonth();
    return i ? r >= 1 && r <= hne[a] : r >= 1 && r <= pne[a];
  }
  set(n, r, o) {
    return n.setDate(o), n.setHours(0, 0, 0, 0), n;
  }
}
class mne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 90);
    nt(this, "subpriority", 1);
    nt(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "D":
      case "DD":
        return dr(Ir.dayOfYear, n);
      case "Do":
        return o.ordinalNumber(n, { unit: "date" });
      default:
        return Sr(r.length, n);
    }
  }
  validate(n, r) {
    const o = n.getFullYear();
    return pD(o) ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(n, r, o) {
    return n.setMonth(0, o), n.setHours(0, 0, 0, 0), n;
  }
}
function Wx(e, t, n) {
  var p, g, b, v;
  const r = Dc(), o = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (p = n == null ? void 0 : n.locale) == null ? void 0 : p.options) == null ? void 0 : g.weekStartsOn) ?? r.weekStartsOn ?? ((v = (b = r.locale) == null ? void 0 : b.options) == null ? void 0 : v.weekStartsOn) ?? 0, i = kt(e), a = i.getDay(), c = (t % 7 + 7) % 7, d = 7 - o, f = t < 0 || t > 6 ? t - (a + d) % 7 : (c + d) % 7 - (a + d) % 7;
  return mp(i, f);
}
class bne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 90);
    nt(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return o.day(n, { width: "wide", context: "formatting" }) || o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, o, i) {
    return n = Wx(n, o, i), n.setHours(0, 0, 0, 0), n;
  }
}
class yne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 90);
    nt(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o, i) {
    const a = (l) => {
      const c = Math.floor((l - 1) / 7) * 7;
      return (l + i.weekStartsOn + 6) % 7 + c;
    };
    switch (r) {
      case "e":
      case "ee":
        return Rr(Sr(r.length, n), a);
      case "eo":
        return Rr(
          o.ordinalNumber(n, {
            unit: "day"
          }),
          a
        );
      case "eee":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      case "eeeee":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return o.day(n, { width: "wide", context: "formatting" }) || o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, o, i) {
    return n = Wx(n, o, i), n.setHours(0, 0, 0, 0), n;
  }
}
class vne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 90);
    nt(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(n, r, o, i) {
    const a = (l) => {
      const c = Math.floor((l - 1) / 7) * 7;
      return (l + i.weekStartsOn + 6) % 7 + c;
    };
    switch (r) {
      case "c":
      case "cc":
        return Rr(Sr(r.length, n), a);
      case "co":
        return Rr(
          o.ordinalNumber(n, {
            unit: "day"
          }),
          a
        );
      case "ccc":
        return o.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(n, { width: "short", context: "standalone" }) || o.day(n, { width: "narrow", context: "standalone" });
      case "ccccc":
        return o.day(n, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return o.day(n, { width: "short", context: "standalone" }) || o.day(n, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return o.day(n, { width: "wide", context: "standalone" }) || o.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(n, { width: "short", context: "standalone" }) || o.day(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, o, i) {
    return n = Wx(n, o, i), n.setHours(0, 0, 0, 0), n;
  }
}
function wne(e) {
  let n = kt(e).getDay();
  return n === 0 && (n = 7), n;
}
function Cne(e, t) {
  const n = kt(e), r = wne(n), o = t - r;
  return mp(n, o);
}
class xne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 90);
    nt(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    const i = (a) => a === 0 ? 7 : a;
    switch (r) {
      case "i":
      case "ii":
        return Sr(r.length, n);
      case "io":
        return o.ordinalNumber(n, { unit: "day" });
      case "iii":
        return Rr(
          o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiiii":
        return Rr(
          o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiiiii":
        return Rr(
          o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      case "iiii":
      default:
        return Rr(
          o.day(n, {
            width: "wide",
            context: "formatting"
          }) || o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 7;
  }
  set(n, r, o) {
    return n = Cne(n, o), n.setHours(0, 0, 0, 0), n;
  }
}
class Sne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 80);
    nt(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return o.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, o) {
    return n.setHours(Gx(o), 0, 0, 0), n;
  }
}
class Ene extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 80);
    nt(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return o.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, o) {
    return n.setHours(Gx(o), 0, 0, 0), n;
  }
}
class Tne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 80);
    nt(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return o.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, o) {
    return n.setHours(Gx(o), 0, 0, 0), n;
  }
}
class One extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 70);
    nt(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "h":
        return dr(Ir.hour12h, n);
      case "ho":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Sr(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 12;
  }
  set(n, r, o) {
    const i = n.getHours() >= 12;
    return i && o < 12 ? n.setHours(o + 12, 0, 0, 0) : !i && o === 12 ? n.setHours(0, 0, 0, 0) : n.setHours(o, 0, 0, 0), n;
  }
}
class Pne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 70);
    nt(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "H":
        return dr(Ir.hour23h, n);
      case "Ho":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Sr(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 23;
  }
  set(n, r, o) {
    return n.setHours(o, 0, 0, 0), n;
  }
}
class Ine extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 70);
    nt(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "K":
        return dr(Ir.hour11h, n);
      case "Ko":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Sr(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, o) {
    return n.getHours() >= 12 && o < 12 ? n.setHours(o + 12, 0, 0, 0) : n.setHours(o, 0, 0, 0), n;
  }
}
class Rne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 70);
    nt(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "k":
        return dr(Ir.hour24h, n);
      case "ko":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Sr(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 24;
  }
  set(n, r, o) {
    const i = o <= 24 ? o % 24 : o;
    return n.setHours(i, 0, 0, 0), n;
  }
}
class _ne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 60);
    nt(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "m":
        return dr(Ir.minute, n);
      case "mo":
        return o.ordinalNumber(n, { unit: "minute" });
      default:
        return Sr(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 59;
  }
  set(n, r, o) {
    return n.setMinutes(o, 0, 0), n;
  }
}
class kne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 50);
    nt(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "s":
        return dr(Ir.second, n);
      case "so":
        return o.ordinalNumber(n, { unit: "second" });
      default:
        return Sr(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 59;
  }
  set(n, r, o) {
    return n.setSeconds(o, 0), n;
  }
}
class Mne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 30);
    nt(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r) {
    const o = (i) => Math.trunc(i * Math.pow(10, -r.length + 3));
    return Rr(Sr(r.length, n), o);
  }
  set(n, r, o) {
    return n.setMilliseconds(o), n;
  }
}
class Ane extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 10);
    nt(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(n, r) {
    switch (r) {
      case "X":
        return Rs(
          Is.basicOptionalMinutes,
          n
        );
      case "XX":
        return Rs(Is.basic, n);
      case "XXXX":
        return Rs(
          Is.basicOptionalSeconds,
          n
        );
      case "XXXXX":
        return Rs(
          Is.extendedOptionalSeconds,
          n
        );
      case "XXX":
      default:
        return Rs(Is.extended, n);
    }
  }
  set(n, r, o) {
    return r.timestampIsSet ? n : Ln(
      n,
      n.getTime() - bm(n) - o
    );
  }
}
class Dne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 10);
    nt(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(n, r) {
    switch (r) {
      case "x":
        return Rs(
          Is.basicOptionalMinutes,
          n
        );
      case "xx":
        return Rs(Is.basic, n);
      case "xxxx":
        return Rs(
          Is.basicOptionalSeconds,
          n
        );
      case "xxxxx":
        return Rs(
          Is.extendedOptionalSeconds,
          n
        );
      case "xxx":
      default:
        return Rs(Is.extended, n);
    }
  }
  set(n, r, o) {
    return r.timestampIsSet ? n : Ln(
      n,
      n.getTime() - bm(n) - o
    );
  }
}
class Nne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 40);
    nt(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return dD(n);
  }
  set(n, r, o) {
    return [Ln(n, o * 1e3), { timestampIsSet: !0 }];
  }
}
class Fne extends vn {
  constructor() {
    super(...arguments);
    nt(this, "priority", 20);
    nt(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return dD(n);
  }
  set(n, r, o) {
    return [Ln(n, o), { timestampIsSet: !0 }];
  }
}
const $ne = {
  G: new ene(),
  y: new tne(),
  Y: new nne(),
  R: new rne(),
  u: new one(),
  Q: new ine(),
  q: new sne(),
  M: new ane(),
  L: new lne(),
  w: new une(),
  I: new fne(),
  d: new gne(),
  D: new mne(),
  E: new bne(),
  e: new yne(),
  c: new vne(),
  i: new xne(),
  a: new Sne(),
  b: new Ene(),
  B: new Tne(),
  h: new One(),
  H: new Pne(),
  K: new Ine(),
  k: new Rne(),
  m: new _ne(),
  s: new kne(),
  S: new Mne(),
  X: new Ane(),
  x: new Dne(),
  t: new Nne(),
  T: new Fne()
}, Lne = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, jne = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Bne = /^'([^]*?)'?$/, Vne = /''/g, Hne = /\S/, Une = /[a-zA-Z]/;
function zne(e, t, n, r) {
  var y, S, E, I, O, T, P, R;
  const o = Yte(), i = (r == null ? void 0 : r.locale) ?? o.locale ?? Vb, a = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((S = (y = r == null ? void 0 : r.locale) == null ? void 0 : y.options) == null ? void 0 : S.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((I = (E = o.locale) == null ? void 0 : E.options) == null ? void 0 : I.firstWeekContainsDate) ?? 1, l = (r == null ? void 0 : r.weekStartsOn) ?? ((T = (O = r == null ? void 0 : r.locale) == null ? void 0 : O.options) == null ? void 0 : T.weekStartsOn) ?? o.weekStartsOn ?? ((R = (P = o.locale) == null ? void 0 : P.options) == null ? void 0 : R.weekStartsOn) ?? 0;
  if (t === "")
    return e === "" ? kt(n) : Ln(n, NaN);
  const c = {
    firstWeekContainsDate: a,
    weekStartsOn: l,
    locale: i
  }, d = [new Zte()], f = t.match(jne).map((F) => {
    const A = F[0];
    if (A in yp) {
      const _ = yp[A];
      return _(F, i.formatLong);
    }
    return F;
  }).join("").match(Lne), p = [];
  for (let F of f) {
    !(r != null && r.useAdditionalWeekYearTokens) && aD(F) && U0(F, t, e), !(r != null && r.useAdditionalDayOfYearTokens) && sD(F) && U0(F, t, e);
    const A = F[0], _ = $ne[A];
    if (_) {
      const { incompatibleTokens: C } = _;
      if (Array.isArray(C)) {
        const L = p.find(
          (B) => C.includes(B.token) || B.token === A
        );
        if (L)
          throw new RangeError(
            `The format string mustn't contain \`${L.fullToken}\` and \`${F}\` at the same time`
          );
      } else if (_.incompatibleTokens === "*" && p.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${F}\` and any other token at the same time`
        );
      p.push({ token: A, fullToken: F });
      const D = _.run(
        e,
        F,
        i.match,
        c
      );
      if (!D)
        return Ln(n, NaN);
      d.push(D.setter), e = D.rest;
    } else {
      if (A.match(Une))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + A + "`"
        );
      if (F === "''" ? F = "'" : A === "'" && (F = Gne(F)), e.indexOf(F) === 0)
        e = e.slice(F.length);
      else
        return Ln(n, NaN);
    }
  }
  if (e.length > 0 && Hne.test(e))
    return Ln(n, NaN);
  const g = d.map((F) => F.priority).sort((F, A) => A - F).filter((F, A, _) => _.indexOf(F) === A).map(
    (F) => d.filter((A) => A.priority === F).sort((A, _) => _.subPriority - A.subPriority)
  ).map((F) => F[0]);
  let b = kt(n);
  if (isNaN(b.getTime()))
    return Ln(n, NaN);
  const v = {};
  for (const F of g) {
    if (!F.validate(b, c))
      return Ln(n, NaN);
    const A = F.set(b, v, c);
    Array.isArray(A) ? (b = A[0], Object.assign(v, A[1])) : b = A;
  }
  return Ln(n, b);
}
function Gne(e) {
  return e.match(Bne)[1].replace(Vne, "'");
}
function Wne(e, t) {
  const n = kt(e);
  return n.setDate(t), n;
}
function qne(e, t) {
  const n = kt(e);
  return n.setHours(t), n;
}
function Kne(e, t) {
  const n = kt(e);
  return n.setMinutes(t), n;
}
function Yne(e, t) {
  const n = kt(e), r = n.getFullYear(), o = n.getDate(), i = Ln(e, 0);
  i.setFullYear(r, t, 15), i.setHours(0, 0, 0, 0);
  const a = cD(i);
  return n.setMonth(t, Math.min(o, a)), n;
}
function Qne(e, t) {
  const n = kt(e);
  return n.setSeconds(t), n;
}
function Xne(e, t) {
  const n = kt(e);
  return n.setMilliseconds(t), n;
}
function Jne(e, t) {
  const n = kt(e);
  return isNaN(+n) ? Ln(e, NaN) : (n.setFullYear(t), n);
}
function Zne(e) {
  const t = kt(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function ere(e) {
  const t = kt(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function tre(e, t) {
  const n = +kt(e), [r, o] = [
    +kt(t.start),
    +kt(t.end)
  ].sort((i, a) => i - a);
  return n >= r && n <= o;
}
const nre = {
  // Year
  y: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yy: "year",
  yyy: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yyyy: "year",
  // Month
  M: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  MM: "month",
  MMMM: {
    sectionType: "month",
    contentType: "letter"
  },
  MMM: {
    sectionType: "month",
    contentType: "letter"
  },
  L: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  LL: "month",
  LLL: {
    sectionType: "month",
    contentType: "letter"
  },
  LLLL: {
    sectionType: "month",
    contentType: "letter"
  },
  // Day of the month
  d: {
    sectionType: "day",
    contentType: "digit",
    maxLength: 2
  },
  dd: "day",
  do: {
    sectionType: "day",
    contentType: "digit-with-letter"
  },
  // Day of the week
  E: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  i: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ii: "weekDay",
  iii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  iiii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // eslint-disable-next-line id-denylist
  e: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ee: "weekDay",
  eee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  c: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  cc: "weekDay",
  ccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  ccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // Meridiem
  a: "meridiem",
  aa: "meridiem",
  aaa: "meridiem",
  // Hours
  H: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  HH: "hours",
  h: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  hh: "hours",
  // Minutes
  m: {
    sectionType: "minutes",
    contentType: "digit",
    maxLength: 2
  },
  mm: "minutes",
  // Seconds
  s: {
    sectionType: "seconds",
    contentType: "digit",
    maxLength: 2
  },
  ss: "seconds"
}, rre = {
  year: "yyyy",
  month: "LLLL",
  monthShort: "MMM",
  dayOfMonth: "d",
  dayOfMonthFull: "do",
  weekday: "EEEE",
  weekdayShort: "EEEEEE",
  hours24h: "HH",
  hours12h: "hh",
  meridiem: "aa",
  minutes: "mm",
  seconds: "ss",
  fullDate: "PP",
  keyboardDate: "P",
  shortDate: "MMM d",
  normalDate: "d MMMM",
  normalDateWithWeekday: "EEE, MMM d",
  fullTime: "p",
  fullTime12h: "hh:mm aa",
  fullTime24h: "HH:mm",
  keyboardDateTime: "P p",
  keyboardDateTime12h: "P hh:mm aa",
  keyboardDateTime24h: "P HH:mm"
};
class ore {
  constructor(t) {
    this.isMUIAdapter = !0, this.isTimezoneCompatible = !1, this.lib = void 0, this.locale = void 0, this.formats = void 0, this.formatTokenMap = nre, this.escapedCharacters = {
      start: "'",
      end: "'"
    }, this.longFormatters = void 0, this.date = (a) => typeof a > "u" ? /* @__PURE__ */ new Date() : a === null ? null : new Date(a), this.getInvalidDate = () => /* @__PURE__ */ new Date("Invalid Date"), this.getTimezone = () => "default", this.setTimezone = (a) => a, this.toJsDate = (a) => a, this.getCurrentLocaleCode = () => this.locale.code, this.is12HourCycleInCurrentLocale = () => /a/.test(this.locale.formatLong.time({
      width: "short"
    })), this.expandFormat = (a) => {
      const l = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
      return a.match(l).map((c) => {
        const d = c[0];
        if (d === "p" || d === "P") {
          const f = this.longFormatters[d];
          return f(c, this.locale.formatLong);
        }
        return c;
      }).join("");
    }, this.formatNumber = (a) => a, this.getDayOfWeek = (a) => a.getDay() + 1;
    const {
      locale: n,
      formats: r,
      longFormatters: o,
      lib: i
    } = t;
    this.locale = n, this.formats = U({}, rre, r), this.longFormatters = o, this.lib = i || "date-fns";
  }
}
class ire extends ore {
  constructor({
    locale: t,
    formats: n
  } = {}) {
    if (process.env.NODE_ENV !== "production") {
      if (typeof mp != "function")
        throw new Error(["MUI: The `date-fns` package v2.x is not compatible with this adapter.", "Please, install v3.x or v4.x of the package or use the `AdapterDateFns` instead."].join(`
`));
      if (!yp)
        throw new Error("MUI: The minimum supported `date-fns` package version compatible with this adapter is `3.2.x`.");
    }
    super({
      locale: t ?? Vb,
      formats: n,
      longFormatters: yp
    }), this.parse = (r, o) => r === "" ? null : zne(r, o, /* @__PURE__ */ new Date(), {
      locale: this.locale
    }), this.isValid = (r) => r == null ? !1 : lD(r), this.format = (r, o) => this.formatByString(r, this.formats[o]), this.formatByString = (r, o) => Nte(r, o, {
      locale: this.locale
    }), this.isEqual = (r, o) => r === null && o === null ? !0 : r === null || o === null ? !1 : zte(r, o), this.isSameYear = (r, o) => Wte(r, o), this.isSameMonth = (r, o) => qte(r, o), this.isSameDay = (r, o) => Gte(r, o), this.isSameHour = (r, o) => Kte(r, o), this.isAfter = (r, o) => hw(r, o), this.isAfterYear = (r, o) => hw(r, eI(o)), this.isAfterDay = (r, o) => hw(r, ZP(o)), this.isBefore = (r, o) => gw(r, o), this.isBeforeYear = (r, o) => gw(r, this.startOfYear(o)), this.isBeforeDay = (r, o) => gw(r, this.startOfDay(o)), this.isWithinRange = (r, [o, i]) => tre(r, {
      start: o,
      end: i
    }), this.startOfYear = (r) => nD(r), this.startOfMonth = (r) => Zne(r), this.startOfWeek = (r) => xa(r, {
      locale: this.locale
    }), this.startOfDay = (r) => bp(r), this.endOfYear = (r) => eI(r), this.endOfMonth = (r) => ere(r), this.endOfWeek = (r) => Vee(r, {
      locale: this.locale
    }), this.endOfDay = (r) => ZP(r), this.addYears = (r, o) => jee(r, o), this.addMonths = (r, o) => tD(r, o), this.addWeeks = (r, o) => Lee(r, o), this.addDays = (r, o) => mp(r, o), this.addHours = (r, o) => $ee(r, o), this.addMinutes = (r, o) => Fee(r, o), this.addSeconds = (r, o) => Aee(r, o), this.getYear = (r) => Ute(r), this.getMonth = (r) => Bte(r), this.getDate = (r) => $te(r), this.getHours = (r) => Lte(r), this.getMinutes = (r) => jte(r), this.getSeconds = (r) => Vte(r), this.getMilliseconds = (r) => Hte(r), this.setYear = (r, o) => Jne(r, o), this.setMonth = (r, o) => Yne(r, o), this.setDate = (r, o) => Wne(r, o), this.setHours = (r, o) => qne(r, o), this.setMinutes = (r, o) => Kne(r, o), this.setSeconds = (r, o) => Qne(r, o), this.setMilliseconds = (r, o) => Xne(r, o), this.getDaysInMonth = (r) => cD(r), this.getWeekArray = (r) => {
      const o = this.startOfWeek(this.startOfMonth(r)), i = this.endOfWeek(this.endOfMonth(r));
      let a = 0, l = o;
      const c = [];
      for (; this.isBefore(l, i); ) {
        const d = Math.floor(a / 7);
        c[d] = c[d] || [], c[d].push(l), l = this.addDays(l, 1), a += 1;
      }
      return c;
    }, this.getWeekNumber = (r) => zx(r, {
      locale: this.locale
    }), this.getYearRange = ([r, o]) => {
      const i = this.startOfYear(r), a = this.endOfYear(o), l = [];
      let c = i;
      for (; this.isBefore(c, a); )
        l.push(c), c = this.addYears(c, 1);
      return l;
    };
  }
}
const sre = {
  dateAdapter: ire,
  adapterLocale: Vb
}, hD = Pc(
  {
    currentBusinessPartner: null,
    businessPartnerQueryIsLoading: !0
  }
);
function are({
  children: e,
  bpno: t
}) {
  var p;
  const n = Ab(), r = Rx(), { dataClient: o } = _d(), i = Db({
    queryKey: ["businessPartners", t],
    queryFn: async () => await o.getBusinessPartner(t),
    enabled: wt(t)
  }), [a, l] = Jt(null), [c, d] = Jt(i.isLoading);
  ir(() => {
    l(null);
  }, [(p = r.session) == null ? void 0 : p.user.id]), ir(() => {
    wt(t) && !i.isLoading && (i.isSuccess && l(i.data ?? null), d(!1));
  }, [
    i.isError,
    i.isLoading,
    i.data,
    t
  ]), ir(() => {
    n.invalidateQueries({
      predicate: (g) => g.queryKey[0] != "businessPartners"
    });
  }, [a]);
  const f = pl(() => ({
    providedBusinessPartnerNumber: t,
    currentBusinessPartner: a,
    setCurrentBusinessPartner: l,
    businessPartnerQueryIsLoading: c
  }), [a, c, t]);
  return /* @__PURE__ */ w.jsx(hD.Provider, { value: f, children: e });
}
const lre = "https://doibqdfjxmzvysheqhde.supabase.co", cre = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRvaWJxZGZqeG16dnlzaGVxaGRlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIzNzI2MzQsImV4cCI6MjA1Nzk0ODYzNH0.e8ODNgBcqqIPczbCYlaYueZagxXc6gKQdfQpPCgqukc", ure = "c1e0b761-d24d-40f0-bd15-86b7d2c62df2", dre = {
  supabaseUrl: lre,
  supabaseAnonKey: cre,
  ssoIdentityProviderId: ure
}, fre = "https://qkcimnhorxzysakhhwav.supabase.co", pre = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFrY2ltbmhvcnh6eXNha2hod2F2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk1MTg1NzMsImV4cCI6MjA1NTA5NDU3M30.LFYZSqC4ocPxLqrIhfn_zmgsW6icVGtyCAW3XwYMUM0", hre = "447cadf5-a30d-4e58-a3e4-34f809ad17da", gre = {
  supabaseUrl: fre,
  supabaseAnonKey: pre,
  ssoIdentityProviderId: hre
}, mre = "https://nltajeiuulmkxmuurlxo.supabase.co", bre = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5sdGFqZWl1dWxta3htdXVybHhvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTA3NjczNTQsImV4cCI6MjAyNjM0MzM1NH0.T6WJulsH4tf9pGywgthh77n5x2-KPFYE8jgD4Xaujrc", yre = "18df1bba-7765-43c5-8850-d6522f3073af", vre = {
  supabaseUrl: mre,
  supabaseAnonKey: bre,
  ssoIdentityProviderId: yre
};
function gD(e) {
  switch (e) {
    case "development":
      return dre;
    case "qualityAssurance":
      return vre;
    case "production":
      return gre;
  }
}
function wre({
  children: e,
  deploymentTarget: t
}) {
  const n = pl(() => {
    if (t) {
      const r = gD(t);
      return {
        supabaseUrl: r.supabaseUrl,
        supabaseAnonKey: r.supabaseAnonKey,
        ssoIdentityProviderId: r.ssoIdentityProviderId
      };
    } else
      return {
        supabaseUrl: void 0,
        supabaseAnonKey: void 0,
        ssoIdentityProviderId: ""
      };
  }, [t]);
  return /* @__PURE__ */ w.jsx(Vx.Provider, { value: n, children: e });
}
function Cre() {
  return process.env.NODE_ENV === "development";
}
const xre = {
  info: () => {
  },
  warn: () => {
  },
  error: () => {
  }
};
function mw(e, t) {
  return (...n) => t(`%cCropConnect:${e}`, "color: blue", ...n);
}
function Ta(e) {
  return Cre() ? {
    /* eslint-disable no-console */
    info: mw(e, console.info),
    warn: mw(e, console.warn),
    error: mw(e, console.error)
    /* eslint-enable no-console */
  } : xre;
}
function Sre() {
  if (console && console.warn) {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    yc(t[0]) && (t[0] = `react-i18next:: ${t[0]}`), console.warn(...t);
  }
}
const sI = {};
function z0() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  yc(t[0]) && sI[t[0]] || (yc(t[0]) && (sI[t[0]] = /* @__PURE__ */ new Date()), Sre(...t));
}
const mD = (e, t) => () => {
  if (e.isInitialized)
    t();
  else {
    const n = () => {
      setTimeout(() => {
        e.off("initialized", n);
      }, 0), t();
    };
    e.on("initialized", n);
  }
}, aI = (e, t, n) => {
  e.loadNamespaces(t, mD(e, n));
}, lI = (e, t, n, r) => {
  yc(n) && (n = [n]), n.forEach((o) => {
    e.options.ns.indexOf(o) < 0 && e.options.ns.push(o);
  }), e.loadLanguages(t, mD(e, r));
}, Ere = function(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const r = t.languages[0], o = t.options ? t.options.fallbackLng : !1, i = t.languages[t.languages.length - 1];
  if (r.toLowerCase() === "cimode") return !0;
  const a = (l, c) => {
    const d = t.services.backendConnector.state[`${l}|${c}`];
    return d === -1 || d === 2;
  };
  return n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !a(t.isLanguageChangingTo, e) ? !1 : !!(t.hasResourceBundle(r, e) || !t.services.backendConnector.backend || t.options.resources && !t.options.partialBundledLanguages || a(r, e) && (!o || a(i, e)));
}, Tre = function(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return !t.languages || !t.languages.length ? (z0("i18n.languages were undefined or empty", t.languages), !0) : t.options.ignoreJSONStructure !== void 0 ? t.hasLoadedNamespace(e, {
    lng: n.lng,
    precheck: (o, i) => {
      if (n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && o.services.backendConnector.backend && o.isLanguageChangingTo && !i(o.isLanguageChangingTo, e)) return !1;
    }
  }) : Ere(e, t, n);
}, yc = (e) => typeof e == "string", Ore = (e) => typeof e == "object" && e !== null, Pre = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Ire = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, Rre = (e) => Ire[e], _re = (e) => e.replace(Pre, Rre);
let G0 = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: _re
};
const kre = function() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  G0 = {
    ...G0,
    ...e
  };
}, Mre = () => G0;
let bD;
const Are = (e) => {
  bD = e;
}, Dre = () => bD, Nre = {
  type: "3rdParty",
  init(e) {
    kre(e.options.react), Are(e);
  }
}, Fre = Pc();
class $re {
  constructor() {
    nt(this, "getUsedNamespaces", () => Object.keys(this.usedNamespaces));
    this.usedNamespaces = {};
  }
  addUsedNamespaces(t) {
    t.forEach((n) => {
      this.usedNamespaces[n] || (this.usedNamespaces[n] = !0);
    });
  }
}
const Lre = (e, t) => {
  const n = ho();
  return ir(() => {
    n.current = e;
  }, [e, t]), n.current;
}, yD = (e, t, n, r) => e.getFixedT(t, n, r), jre = (e, t, n, r) => CC(yD(e, t, n, r), [e, t, n, r]), vD = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    i18n: n
  } = t, {
    i18n: r,
    defaultNS: o
  } = Li(Fre) || {}, i = n || r || Dre();
  if (i && !i.reportNamespaces && (i.reportNamespaces = new $re()), !i) {
    z0("You will need to pass in an i18next instance by using initReactI18next");
    const T = (R, F) => yc(F) ? F : Ore(F) && yc(F.defaultValue) ? F.defaultValue : Array.isArray(R) ? R[R.length - 1] : R, P = [T, {}, !1];
    return P.t = T, P.i18n = {}, P.ready = !1, P;
  }
  i.options.react && i.options.react.wait !== void 0 && z0("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const a = {
    ...Mre(),
    ...i.options.react,
    ...t
  }, {
    useSuspense: l,
    keyPrefix: c
  } = a;
  let d = o || i.options && i.options.defaultNS;
  d = yc(d) ? [d] : d || ["translation"], i.reportNamespaces.addUsedNamespaces && i.reportNamespaces.addUsedNamespaces(d);
  const f = (i.isInitialized || i.initializedStoreOnce) && d.every((T) => Tre(T, i, a)), p = jre(i, t.lng || null, a.nsMode === "fallback" ? d : d[0], c), g = () => p, b = () => yD(i, t.lng || null, a.nsMode === "fallback" ? d : d[0], c), [v, y] = Jt(g);
  let S = d.join();
  t.lng && (S = `${t.lng}${S}`);
  const E = Lre(S), I = ho(!0);
  ir(() => {
    const {
      bindI18n: T,
      bindI18nStore: P
    } = a;
    I.current = !0, !f && !l && (t.lng ? lI(i, t.lng, d, () => {
      I.current && y(b);
    }) : aI(i, d, () => {
      I.current && y(b);
    })), f && E && E !== S && I.current && y(b);
    const R = () => {
      I.current && y(b);
    };
    return T && i && i.on(T, R), P && i && i.store.on(P, R), () => {
      I.current = !1, T && i && T.split(" ").forEach((F) => i.off(F, R)), P && i && P.split(" ").forEach((F) => i.store.off(F, R));
    };
  }, [i, S]), ir(() => {
    I.current && f && y(g);
  }, [i, c, f]);
  const O = [v, i, f];
  if (O.t = v, O.i18n = i, O.ready = f, f || !f && !l) return O;
  throw new Promise((T) => {
    t.lng ? lI(i, t.lng, d, () => T()) : aI(i, d, () => T());
  });
}, wD = "1.12.0", Hb = At(/* @__PURE__ */ w.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"
}), "Error"), Bre = oe($r)(({ theme: e }) => ({
  body: "flex",
  flexDirection: "column",
  backgroundColor: e.palette.error.main,
  alignSelf: "center",
  width: "80%",
  gap: e.spacing(1),
  padding: e.spacing(2),
  marginBottom: e.spacing(1),
  borderRadius: 5,
  boxSizing: "border-box",
  "& .MuiTypography-root": {
    color: e.palette.primary.contrastText
  },
  "& .MuiSvgIcon-root": {
    color: e.palette.primary.contrastText
  }
})), Vre = oe($r)(({ theme: e }) => ({
  body: "flex",
  flexDirection: "row",
  alignItems: "center",
  width: "100%",
  gap: e.spacing(1)
})), Hre = oe($r)(({ theme: e }) => ({
  body: "flex",
  flexDirection: "column",
  width: "100%",
  gap: e.spacing(1)
})), Ure = oe(Hb)(({ theme: e }) => ({
  color: e.palette.primary.contrastText
}));
function Ub(e) {
  return wt(e.heading) ? /* @__PURE__ */ w.jsxs(Bre, { "data-testid": "error-box", children: [
    /* @__PURE__ */ w.jsxs(Vre, { children: [
      /* @__PURE__ */ w.jsx(Ure, {}),
      /* @__PURE__ */ w.jsx(Rt, { variant: "h3", children: e.heading })
    ] }),
    /* @__PURE__ */ w.jsxs(Hre, { children: [
      /* @__PURE__ */ w.jsx(Rt, { variant: "h4", "data-testid": "error-message", children: e.message }),
      e.children
    ] })
  ] }) : null;
}
function jn() {
  const { t: e, i18n: t } = vD();
  return { t: e, i18n: t };
}
const zre = oe(_t)(
  () => ({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    width: "100%",
    height: "100%",
    alignItems: "flex-start"
  })
);
oe(_t)(
  () => ({
    display: "flex",
    width: "100vw",
    height: "100vh"
  })
);
oe(
  pb
)(() => ({
  height: "100%",
  boxSizing: "border-box"
}));
const CD = oe(_t)(
  ({ theme: e }) => ({
    display: "flex",
    justifyContent: "center",
    width: "100%",
    padding: e.spacing(2)
  })
), Gre = oe($r)(
  ({ theme: e }) => ({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    gap: e.spacing(1.5)
  })
), Wre = oe(
  hx
)(() => ({
  width: "50%",
  height: "4px",
  maxWidth: "100px",
  marginTop: "8px",
  borderRadius: 5
})), xD = oe("form")(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(2),
  flexDirection: "column",
  width: "100%"
})), SD = oe(_t)(
  ({ theme: e }) => ({
    display: "flex",
    gap: e.spacing(2),
    justifyContent: "flex-end",
    alignItems: "center",
    width: "100%"
  })
), vm = oe(as)(
  () => ({
    minWidth: "120px"
  })
), qre = oe(
  Rt
)(() => ({
  flexGrow: 1
})), qx = oe(
  Gp
)(() => ({
  position: "absolute",
  zIndex: 3,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)"
})), Kre = oe(
  Gp
)(({ theme: e }) => ({
  padding: e.spacing(2),
  display: "block",
  marginLeft: "auto",
  marginRight: "auto"
}));
oe(ux)(
  ({ theme: e }) => ({
    display: "flex",
    flexDirection: "column",
    gap: e.spacing(3)
  })
);
oe("div")(() => ({
  width: "100%",
  height: "100%"
}));
const Yre = oe(
  qC
)(({ theme: e }) => ({
  borderRadius: e.cropConnect.shape.borderRadius,
  "&:before": {
    display: "none"
    // remove top line
  }
})), Vg = oe(Rt)(
  ({ theme: e }) => ({
    color: "white",
    fontSize: e.typography.body1.fontSize
  })
);
oe(_t)(
  ({ theme: e }) => ({
    display: "flex",
    flexDirection: "row",
    padding: e.spacing(2, 0, 0, 0),
    gap: e.spacing(2),
    width: "70%",
    margin: "0 auto"
  })
);
function Qre(e) {
  const { t } = jn(), n = e.isBusinessPartnerNumberProvided ? "noBusinessPartner" : "noBusinessPartnerNumber";
  return /* @__PURE__ */ w.jsx(CD, { children: /* @__PURE__ */ w.jsx(
    Ub,
    {
      heading: t(`common:accessManagement.error.${n}.headline`),
      message: t(`common:accessManagement.error.${n}.message`)
    }
  ) });
}
function rh() {
  const e = Li(hD);
  if (e === void 0)
    throw new Error(
      "useCurrentBusinessPartner must be used within a BusinessPartnerContextProvider."
    );
  return e;
}
/**
 * @remix-run/router v1.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function or() {
  return or = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, or.apply(this, arguments);
}
var Dr;
(function(e) {
  e.Pop = "POP", e.Push = "PUSH", e.Replace = "REPLACE";
})(Dr || (Dr = {}));
const cI = "popstate";
function Xre(e) {
  e === void 0 && (e = {});
  function t(r, o) {
    let {
      pathname: i,
      search: a,
      hash: l
    } = r.location;
    return vp(
      "",
      {
        pathname: i,
        search: a,
        hash: l
      },
      // state defaults to `null` because `window.history.state` does
      o.state && o.state.usr || null,
      o.state && o.state.key || "default"
    );
  }
  function n(r, o) {
    return typeof o == "string" ? o : Cl(o);
  }
  return Zre(t, n, null, e);
}
function Pt(e, t) {
  if (e === !1 || e === null || typeof e > "u")
    throw new Error(t);
}
function Hr(e, t) {
  if (!e) {
    typeof console < "u" && console.warn(t);
    try {
      throw new Error(t);
    } catch {
    }
  }
}
function Jre() {
  return Math.random().toString(36).substr(2, 8);
}
function uI(e, t) {
  return {
    usr: e.state,
    key: e.key,
    idx: t
  };
}
function vp(e, t, n, r) {
  return n === void 0 && (n = null), or({
    pathname: typeof e == "string" ? e : e.pathname,
    search: "",
    hash: ""
  }, typeof t == "string" ? kl(t) : t, {
    state: n,
    // TODO: This could be cleaned up.  push/replace should probably just take
    // full Locations now and avoid the need to run through this flow at all
    // But that's a pretty big refactor to the current test suite so going to
    // keep as is for the time being and just let any incoming keys take precedence
    key: t && t.key || r || Jre()
  });
}
function Cl(e) {
  let {
    pathname: t = "/",
    search: n = "",
    hash: r = ""
  } = e;
  return n && n !== "?" && (t += n.charAt(0) === "?" ? n : "?" + n), r && r !== "#" && (t += r.charAt(0) === "#" ? r : "#" + r), t;
}
function kl(e) {
  let t = {};
  if (e) {
    let n = e.indexOf("#");
    n >= 0 && (t.hash = e.substr(n), e = e.substr(0, n));
    let r = e.indexOf("?");
    r >= 0 && (t.search = e.substr(r), e = e.substr(0, r)), e && (t.pathname = e);
  }
  return t;
}
function Zre(e, t, n, r) {
  r === void 0 && (r = {});
  let {
    window: o = document.defaultView,
    v5Compat: i = !1
  } = r, a = o.history, l = Dr.Pop, c = null, d = f();
  d == null && (d = 0, a.replaceState(or({}, a.state, {
    idx: d
  }), ""));
  function f() {
    return (a.state || {
      idx: null
    }).idx;
  }
  function p() {
    l = Dr.Pop;
    let S = f(), E = S == null ? null : S - d;
    d = S, c && c({
      action: l,
      location: y.location,
      delta: E
    });
  }
  function g(S, E) {
    l = Dr.Push;
    let I = vp(y.location, S, E);
    d = f() + 1;
    let O = uI(I, d), T = y.createHref(I);
    try {
      a.pushState(O, "", T);
    } catch (P) {
      if (P instanceof DOMException && P.name === "DataCloneError")
        throw P;
      o.location.assign(T);
    }
    i && c && c({
      action: l,
      location: y.location,
      delta: 1
    });
  }
  function b(S, E) {
    l = Dr.Replace;
    let I = vp(y.location, S, E);
    d = f();
    let O = uI(I, d), T = y.createHref(I);
    a.replaceState(O, "", T), i && c && c({
      action: l,
      location: y.location,
      delta: 0
    });
  }
  function v(S) {
    let E = o.location.origin !== "null" ? o.location.origin : o.location.href, I = typeof S == "string" ? S : Cl(S);
    return I = I.replace(/ $/, "%20"), Pt(E, "No window.location.(origin|href) available to create URL for href: " + I), new URL(I, E);
  }
  let y = {
    get action() {
      return l;
    },
    get location() {
      return e(o, a);
    },
    listen(S) {
      if (c)
        throw new Error("A history only accepts one active listener");
      return o.addEventListener(cI, p), c = S, () => {
        o.removeEventListener(cI, p), c = null;
      };
    },
    createHref(S) {
      return t(o, S);
    },
    createURL: v,
    encodeLocation(S) {
      let E = v(S);
      return {
        pathname: E.pathname,
        search: E.search,
        hash: E.hash
      };
    },
    push: g,
    replace: b,
    go(S) {
      return a.go(S);
    }
  };
  return y;
}
var Fn;
(function(e) {
  e.data = "data", e.deferred = "deferred", e.redirect = "redirect", e.error = "error";
})(Fn || (Fn = {}));
const eoe = /* @__PURE__ */ new Set(["lazy", "caseSensitive", "path", "id", "index", "children"]);
function toe(e) {
  return e.index === !0;
}
function wm(e, t, n, r) {
  return n === void 0 && (n = []), r === void 0 && (r = {}), e.map((o, i) => {
    let a = [...n, String(i)], l = typeof o.id == "string" ? o.id : a.join("-");
    if (Pt(o.index !== !0 || !o.children, "Cannot specify children on an index route"), Pt(!r[l], 'Found a route id collision on id "' + l + `".  Route id's must be globally unique within Data Router usages`), toe(o)) {
      let c = or({}, o, t(o), {
        id: l
      });
      return r[l] = c, c;
    } else {
      let c = or({}, o, t(o), {
        id: l,
        children: void 0
      });
      return r[l] = c, o.children && (c.children = wm(o.children, t, a, r)), c;
    }
  });
}
function Zl(e, t, n) {
  return n === void 0 && (n = "/"), Hg(e, t, n, !1);
}
function Hg(e, t, n, r) {
  let o = typeof t == "string" ? kl(t) : t, i = pi(o.pathname || "/", n);
  if (i == null)
    return null;
  let a = ED(e);
  roe(a);
  let l = null;
  for (let c = 0; l == null && c < a.length; ++c) {
    let d = hoe(i);
    l = foe(a[c], d, r);
  }
  return l;
}
function noe(e, t) {
  let {
    route: n,
    pathname: r,
    params: o
  } = e;
  return {
    id: n.id,
    pathname: r,
    params: o,
    data: t[n.id],
    handle: n.handle
  };
}
function ED(e, t, n, r) {
  t === void 0 && (t = []), n === void 0 && (n = []), r === void 0 && (r = "");
  let o = (i, a, l) => {
    let c = {
      relativePath: l === void 0 ? i.path || "" : l,
      caseSensitive: i.caseSensitive === !0,
      childrenIndex: a,
      route: i
    };
    c.relativePath.startsWith("/") && (Pt(c.relativePath.startsWith(r), 'Absolute route path "' + c.relativePath + '" nested under path ' + ('"' + r + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes."), c.relativePath = c.relativePath.slice(r.length));
    let d = $s([r, c.relativePath]), f = n.concat(c);
    i.children && i.children.length > 0 && (Pt(
      // Our types know better, but runtime JS may not!
      // @ts-expect-error
      i.index !== !0,
      "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + d + '".')
    ), ED(i.children, t, f, d)), !(i.path == null && !i.index) && t.push({
      path: d,
      score: uoe(d, i.index),
      routesMeta: f
    });
  };
  return e.forEach((i, a) => {
    var l;
    if (i.path === "" || !((l = i.path) != null && l.includes("?")))
      o(i, a);
    else
      for (let c of TD(i.path))
        o(i, a, c);
  }), t;
}
function TD(e) {
  let t = e.split("/");
  if (t.length === 0) return [];
  let [n, ...r] = t, o = n.endsWith("?"), i = n.replace(/\?$/, "");
  if (r.length === 0)
    return o ? [i, ""] : [i];
  let a = TD(r.join("/")), l = [];
  return l.push(...a.map((c) => c === "" ? i : [i, c].join("/"))), o && l.push(...a), l.map((c) => e.startsWith("/") && c === "" ? "/" : c);
}
function roe(e) {
  e.sort((t, n) => t.score !== n.score ? n.score - t.score : doe(t.routesMeta.map((r) => r.childrenIndex), n.routesMeta.map((r) => r.childrenIndex)));
}
const ooe = /^:[\w-]+$/, ioe = 3, soe = 2, aoe = 1, loe = 10, coe = -2, dI = (e) => e === "*";
function uoe(e, t) {
  let n = e.split("/"), r = n.length;
  return n.some(dI) && (r += coe), t && (r += soe), n.filter((o) => !dI(o)).reduce((o, i) => o + (ooe.test(i) ? ioe : i === "" ? aoe : loe), r);
}
function doe(e, t) {
  return e.length === t.length && e.slice(0, -1).every((r, o) => r === t[o]) ? (
    // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    e[e.length - 1] - t[t.length - 1]
  ) : (
    // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0
  );
}
function foe(e, t, n) {
  n === void 0 && (n = !1);
  let {
    routesMeta: r
  } = e, o = {}, i = "/", a = [];
  for (let l = 0; l < r.length; ++l) {
    let c = r[l], d = l === r.length - 1, f = i === "/" ? t : t.slice(i.length) || "/", p = Cm({
      path: c.relativePath,
      caseSensitive: c.caseSensitive,
      end: d
    }, f), g = c.route;
    if (!p && d && n && !r[r.length - 1].route.index && (p = Cm({
      path: c.relativePath,
      caseSensitive: c.caseSensitive,
      end: !1
    }, f)), !p)
      return null;
    Object.assign(o, p.params), a.push({
      // TODO: Can this as be avoided?
      params: o,
      pathname: $s([i, p.pathname]),
      pathnameBase: boe($s([i, p.pathnameBase])),
      route: g
    }), p.pathnameBase !== "/" && (i = $s([i, p.pathnameBase]));
  }
  return a;
}
function Cm(e, t) {
  typeof e == "string" && (e = {
    path: e,
    caseSensitive: !1,
    end: !0
  });
  let [n, r] = poe(e.path, e.caseSensitive, e.end), o = t.match(n);
  if (!o) return null;
  let i = o[0], a = i.replace(/(.)\/+$/, "$1"), l = o.slice(1);
  return {
    params: r.reduce((d, f, p) => {
      let {
        paramName: g,
        isOptional: b
      } = f;
      if (g === "*") {
        let y = l[p] || "";
        a = i.slice(0, i.length - y.length).replace(/(.)\/+$/, "$1");
      }
      const v = l[p];
      return b && !v ? d[g] = void 0 : d[g] = (v || "").replace(/%2F/g, "/"), d;
    }, {}),
    pathname: i,
    pathnameBase: a,
    pattern: e
  };
}
function poe(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !0), Hr(e === "*" || !e.endsWith("*") || e.endsWith("/*"), 'Route path "' + e + '" will be treated as if it were ' + ('"' + e.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + e.replace(/\*$/, "/*") + '".'));
  let r = [], o = "^" + e.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (a, l, c) => (r.push({
    paramName: l,
    isOptional: c != null
  }), c ? "/?([^\\/]+)?" : "/([^\\/]+)"));
  return e.endsWith("*") ? (r.push({
    paramName: "*"
  }), o += e === "*" || e === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : n ? o += "\\/*$" : e !== "" && e !== "/" && (o += "(?:(?=\\/|$))"), [new RegExp(o, t ? void 0 : "i"), r];
}
function hoe(e) {
  try {
    return e.split("/").map((t) => decodeURIComponent(t).replace(/\//g, "%2F")).join("/");
  } catch (t) {
    return Hr(!1, 'The URL path "' + e + '" could not be decoded because it is is a malformed URL segment. This is probably due to a bad percent ' + ("encoding (" + t + ").")), e;
  }
}
function pi(e, t) {
  if (t === "/") return e;
  if (!e.toLowerCase().startsWith(t.toLowerCase()))
    return null;
  let n = t.endsWith("/") ? t.length - 1 : t.length, r = e.charAt(n);
  return r && r !== "/" ? null : e.slice(n) || "/";
}
function goe(e, t) {
  t === void 0 && (t = "/");
  let {
    pathname: n,
    search: r = "",
    hash: o = ""
  } = typeof e == "string" ? kl(e) : e;
  return {
    pathname: n ? n.startsWith("/") ? n : moe(n, t) : t,
    search: yoe(r),
    hash: voe(o)
  };
}
function moe(e, t) {
  let n = t.replace(/\/+$/, "").split("/");
  return e.split("/").forEach((o) => {
    o === ".." ? n.length > 1 && n.pop() : o !== "." && n.push(o);
  }), n.length > 1 ? n.join("/") : "/";
}
function bw(e, t, n, r) {
  return "Cannot include a '" + e + "' character in a manually specified " + ("`to." + t + "` field [" + JSON.stringify(r) + "].  Please separate it out to the ") + ("`to." + n + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
function OD(e) {
  return e.filter((t, n) => n === 0 || t.route.path && t.route.path.length > 0);
}
function Kx(e, t) {
  let n = OD(e);
  return t ? n.map((r, o) => o === n.length - 1 ? r.pathname : r.pathnameBase) : n.map((r) => r.pathnameBase);
}
function Yx(e, t, n, r) {
  r === void 0 && (r = !1);
  let o;
  typeof e == "string" ? o = kl(e) : (o = or({}, e), Pt(!o.pathname || !o.pathname.includes("?"), bw("?", "pathname", "search", o)), Pt(!o.pathname || !o.pathname.includes("#"), bw("#", "pathname", "hash", o)), Pt(!o.search || !o.search.includes("#"), bw("#", "search", "hash", o)));
  let i = e === "" || o.pathname === "", a = i ? "/" : o.pathname, l;
  if (a == null)
    l = n;
  else {
    let p = t.length - 1;
    if (!r && a.startsWith("..")) {
      let g = a.split("/");
      for (; g[0] === ".."; )
        g.shift(), p -= 1;
      o.pathname = g.join("/");
    }
    l = p >= 0 ? t[p] : "/";
  }
  let c = goe(o, l), d = a && a !== "/" && a.endsWith("/"), f = (i || a === ".") && n.endsWith("/");
  return !c.pathname.endsWith("/") && (d || f) && (c.pathname += "/"), c;
}
const $s = (e) => e.join("/").replace(/\/\/+/g, "/"), boe = (e) => e.replace(/\/+$/, "").replace(/^\/*/, "/"), yoe = (e) => !e || e === "?" ? "" : e.startsWith("?") ? e : "?" + e, voe = (e) => !e || e === "#" ? "" : e.startsWith("#") ? e : "#" + e;
class xm {
  constructor(t, n, r, o) {
    o === void 0 && (o = !1), this.status = t, this.statusText = n || "", this.internal = o, r instanceof Error ? (this.data = r.toString(), this.error = r) : this.data = r;
  }
}
function zb(e) {
  return e != null && typeof e.status == "number" && typeof e.statusText == "string" && typeof e.internal == "boolean" && "data" in e;
}
const PD = ["post", "put", "patch", "delete"], woe = new Set(PD), Coe = ["get", ...PD], xoe = new Set(Coe), Soe = /* @__PURE__ */ new Set([301, 302, 303, 307, 308]), Eoe = /* @__PURE__ */ new Set([307, 308]), yw = {
  state: "idle",
  location: void 0,
  formMethod: void 0,
  formAction: void 0,
  formEncType: void 0,
  formData: void 0,
  json: void 0,
  text: void 0
}, Toe = {
  state: "idle",
  data: void 0,
  formMethod: void 0,
  formAction: void 0,
  formEncType: void 0,
  formData: void 0,
  json: void 0,
  text: void 0
}, Eu = {
  state: "unblocked",
  proceed: void 0,
  reset: void 0,
  location: void 0
}, Qx = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, Ooe = (e) => ({
  hasErrorBoundary: !!e.hasErrorBoundary
}), ID = "remix-router-transitions";
function Poe(e) {
  const t = e.window ? e.window : typeof window < "u" ? window : void 0, n = typeof t < "u" && typeof t.document < "u" && typeof t.document.createElement < "u", r = !n;
  Pt(e.routes.length > 0, "You must provide a non-empty routes array to createRouter");
  let o;
  if (e.mapRouteProperties)
    o = e.mapRouteProperties;
  else if (e.detectErrorBoundary) {
    let ue = e.detectErrorBoundary;
    o = (ve) => ({
      hasErrorBoundary: ue(ve)
    });
  } else
    o = Ooe;
  let i = {}, a = wm(e.routes, o, void 0, i), l, c = e.basename || "/", d = e.dataStrategy || koe, f = e.patchRoutesOnNavigation, p = or({
    v7_fetcherPersist: !1,
    v7_normalizeFormMethod: !1,
    v7_partialHydration: !1,
    v7_prependBasename: !1,
    v7_relativeSplatPath: !1,
    v7_skipActionErrorRevalidation: !1
  }, e.future), g = null, b = /* @__PURE__ */ new Set(), v = null, y = null, S = null, E = e.hydrationData != null, I = Zl(a, e.history.location, c), O = null;
  if (I == null && !f) {
    let ue = Lo(404, {
      pathname: e.history.location.pathname
    }), {
      matches: ve,
      route: Se
    } = xI(a);
    I = ve, O = {
      [Se.id]: ue
    };
  }
  I && !e.hydrationData && lr(I, a, e.history.location.pathname).active && (I = null);
  let T;
  if (I)
    if (I.some((ue) => ue.route.lazy))
      T = !1;
    else if (!I.some((ue) => ue.route.loader))
      T = !0;
    else if (p.v7_partialHydration) {
      let ue = e.hydrationData ? e.hydrationData.loaderData : null, ve = e.hydrationData ? e.hydrationData.errors : null;
      if (ve) {
        let Se = I.findIndex((ze) => ve[ze.route.id] !== void 0);
        T = I.slice(0, Se + 1).every((ze) => !q0(ze.route, ue, ve));
      } else
        T = I.every((Se) => !q0(Se.route, ue, ve));
    } else
      T = e.hydrationData != null;
  else if (T = !1, I = [], p.v7_partialHydration) {
    let ue = lr(null, a, e.history.location.pathname);
    ue.active && ue.matches && (I = ue.matches);
  }
  let P, R = {
    historyAction: e.history.action,
    location: e.history.location,
    matches: I,
    initialized: T,
    navigation: yw,
    // Don't restore on initial updateState() if we were SSR'd
    restoreScrollPosition: e.hydrationData != null ? !1 : null,
    preventScrollReset: !1,
    revalidation: "idle",
    loaderData: e.hydrationData && e.hydrationData.loaderData || {},
    actionData: e.hydrationData && e.hydrationData.actionData || null,
    errors: e.hydrationData && e.hydrationData.errors || O,
    fetchers: /* @__PURE__ */ new Map(),
    blockers: /* @__PURE__ */ new Map()
  }, F = Dr.Pop, A = !1, _, C = !1, D = /* @__PURE__ */ new Map(), L = null, B = !1, H = !1, k = [], N = /* @__PURE__ */ new Set(), j = /* @__PURE__ */ new Map(), W = 0, V = -1, $ = /* @__PURE__ */ new Map(), z = /* @__PURE__ */ new Set(), ne = /* @__PURE__ */ new Map(), K = /* @__PURE__ */ new Map(), Q = /* @__PURE__ */ new Set(), re = /* @__PURE__ */ new Map(), te = /* @__PURE__ */ new Map(), ie;
  function ae() {
    if (g = e.history.listen((ue) => {
      let {
        action: ve,
        location: Se,
        delta: ze
      } = ue;
      if (ie) {
        ie(), ie = void 0;
        return;
      }
      Hr(te.size === 0 || ze != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
      let st = fn({
        currentLocation: R.location,
        nextLocation: Se,
        historyAction: ve
      });
      if (st && ze != null) {
        let bt = new Promise((Dt) => {
          ie = Dt;
        });
        e.history.go(ze * -1), It(st, {
          state: "blocked",
          location: Se,
          proceed() {
            It(st, {
              state: "proceeding",
              proceed: void 0,
              reset: void 0,
              location: Se
            }), bt.then(() => e.history.go(ze));
          },
          reset() {
            let Dt = new Map(R.blockers);
            Dt.set(st, Eu), we({
              blockers: Dt
            });
          }
        });
        return;
      }
      return $e(ve, Se);
    }), n) {
      Goe(t, D);
      let ue = () => Woe(t, D);
      t.addEventListener("pagehide", ue), L = () => t.removeEventListener("pagehide", ue);
    }
    return R.initialized || $e(Dr.Pop, R.location, {
      initialHydration: !0
    }), P;
  }
  function ce() {
    g && g(), L && L(), b.clear(), _ && _.abort(), R.fetchers.forEach((ue, ve) => Et(ve)), R.blockers.forEach((ue, ve) => lt(ve));
  }
  function le(ue) {
    return b.add(ue), () => b.delete(ue);
  }
  function we(ue, ve) {
    ve === void 0 && (ve = {}), R = or({}, R, ue);
    let Se = [], ze = [];
    p.v7_fetcherPersist && R.fetchers.forEach((st, bt) => {
      st.state === "idle" && (Q.has(bt) ? ze.push(bt) : Se.push(bt));
    }), [...b].forEach((st) => st(R, {
      deletedFetchers: ze,
      viewTransitionOpts: ve.viewTransitionOpts,
      flushSync: ve.flushSync === !0
    })), p.v7_fetcherPersist && (Se.forEach((st) => R.fetchers.delete(st)), ze.forEach((st) => Et(st)));
  }
  function q(ue, ve, Se) {
    var ze, st;
    let {
      flushSync: bt
    } = Se === void 0 ? {} : Se, Dt = R.actionData != null && R.navigation.formMethod != null && Ji(R.navigation.formMethod) && R.navigation.state === "loading" && ((ze = ue.state) == null ? void 0 : ze._isRedirect) !== !0, at;
    ve.actionData ? Object.keys(ve.actionData).length > 0 ? at = ve.actionData : at = null : Dt ? at = R.actionData : at = null;
    let Z = ve.loaderData ? wI(R.loaderData, ve.loaderData, ve.matches || [], ve.errors) : R.loaderData, be = R.blockers;
    be.size > 0 && (be = new Map(be), be.forEach((he, Fe) => be.set(Fe, Eu)));
    let Re = A === !0 || R.navigation.formMethod != null && Ji(R.navigation.formMethod) && ((st = ue.state) == null ? void 0 : st._isRedirect) !== !0;
    l && (a = l, l = void 0), B || F === Dr.Pop || (F === Dr.Push ? e.history.push(ue, ue.state) : F === Dr.Replace && e.history.replace(ue, ue.state));
    let pe;
    if (F === Dr.Pop) {
      let he = D.get(R.location.pathname);
      he && he.has(ue.pathname) ? pe = {
        currentLocation: R.location,
        nextLocation: ue
      } : D.has(ue.pathname) && (pe = {
        currentLocation: ue,
        nextLocation: R.location
      });
    } else if (C) {
      let he = D.get(R.location.pathname);
      he ? he.add(ue.pathname) : (he = /* @__PURE__ */ new Set([ue.pathname]), D.set(R.location.pathname, he)), pe = {
        currentLocation: R.location,
        nextLocation: ue
      };
    }
    we(or({}, ve, {
      actionData: at,
      loaderData: Z,
      historyAction: F,
      location: ue,
      initialized: !0,
      navigation: yw,
      revalidation: "idle",
      restoreScrollPosition: Lr(ue, ve.matches || R.matches),
      preventScrollReset: Re,
      blockers: be
    }), {
      viewTransitionOpts: pe,
      flushSync: bt === !0
    }), F = Dr.Pop, A = !1, C = !1, B = !1, H = !1, k = [];
  }
  async function Ee(ue, ve) {
    if (typeof ue == "number") {
      e.history.go(ue);
      return;
    }
    let Se = W0(R.location, R.matches, c, p.v7_prependBasename, ue, p.v7_relativeSplatPath, ve == null ? void 0 : ve.fromRouteId, ve == null ? void 0 : ve.relative), {
      path: ze,
      submission: st,
      error: bt
    } = fI(p.v7_normalizeFormMethod, !1, Se, ve), Dt = R.location, at = vp(R.location, ze, ve && ve.state);
    at = or({}, at, e.history.encodeLocation(at));
    let Z = ve && ve.replace != null ? ve.replace : void 0, be = Dr.Push;
    Z === !0 ? be = Dr.Replace : Z === !1 || st != null && Ji(st.formMethod) && st.formAction === R.location.pathname + R.location.search && (be = Dr.Replace);
    let Re = ve && "preventScrollReset" in ve ? ve.preventScrollReset === !0 : void 0, pe = (ve && ve.flushSync) === !0, he = fn({
      currentLocation: Dt,
      nextLocation: at,
      historyAction: be
    });
    if (he) {
      It(he, {
        state: "blocked",
        location: at,
        proceed() {
          It(he, {
            state: "proceeding",
            proceed: void 0,
            reset: void 0,
            location: at
          }), Ee(ue, ve);
        },
        reset() {
          let Fe = new Map(R.blockers);
          Fe.set(he, Eu), we({
            blockers: Fe
          });
        }
      });
      return;
    }
    return await $e(be, at, {
      submission: st,
      // Send through the formData serialization error if we have one so we can
      // render at the right error boundary after we match routes
      pendingError: bt,
      preventScrollReset: Re,
      replace: ve && ve.replace,
      enableViewTransition: ve && ve.viewTransition,
      flushSync: pe
    });
  }
  function _e() {
    if (Ke(), we({
      revalidation: "loading"
    }), R.navigation.state !== "submitting") {
      if (R.navigation.state === "idle") {
        $e(R.historyAction, R.location, {
          startUninterruptedRevalidation: !0
        });
        return;
      }
      $e(F || R.historyAction, R.navigation.location, {
        overrideNavigation: R.navigation,
        // Proxy through any rending view transition
        enableViewTransition: C === !0
      });
    }
  }
  async function $e(ue, ve, Se) {
    _ && _.abort(), _ = null, F = ue, B = (Se && Se.startUninterruptedRevalidation) === !0, Mr(R.location, R.matches), A = (Se && Se.preventScrollReset) === !0, C = (Se && Se.enableViewTransition) === !0;
    let ze = l || a, st = Se && Se.overrideNavigation, bt = Zl(ze, ve, c), Dt = (Se && Se.flushSync) === !0, at = lr(bt, ze, ve.pathname);
    if (at.active && at.matches && (bt = at.matches), !bt) {
      let {
        error: We,
        notFoundMatches: Ue,
        route: dt
      } = Bn(ve.pathname);
      q(ve, {
        matches: Ue,
        loaderData: {},
        errors: {
          [dt.id]: We
        }
      }, {
        flushSync: Dt
      });
      return;
    }
    if (R.initialized && !H && $oe(R.location, ve) && !(Se && Se.submission && Ji(Se.submission.formMethod))) {
      q(ve, {
        matches: bt
      }, {
        flushSync: Dt
      });
      return;
    }
    _ = new AbortController();
    let Z = hu(e.history, ve, _.signal, Se && Se.submission), be;
    if (Se && Se.pendingError)
      be = [ec(bt).route.id, {
        type: Fn.error,
        error: Se.pendingError
      }];
    else if (Se && Se.submission && Ji(Se.submission.formMethod)) {
      let We = await Le(Z, ve, Se.submission, bt, at.active, {
        replace: Se.replace,
        flushSync: Dt
      });
      if (We.shortCircuited)
        return;
      if (We.pendingActionResult) {
        let [Ue, dt] = We.pendingActionResult;
        if (oi(dt) && zb(dt.error) && dt.error.status === 404) {
          _ = null, q(ve, {
            matches: We.matches,
            loaderData: {},
            errors: {
              [Ue]: dt.error
            }
          });
          return;
        }
      }
      bt = We.matches || bt, be = We.pendingActionResult, st = vw(ve, Se.submission), Dt = !1, at.active = !1, Z = hu(e.history, Z.url, Z.signal);
    }
    let {
      shortCircuited: Re,
      matches: pe,
      loaderData: he,
      errors: Fe
    } = await Ze(Z, ve, bt, at.active, st, Se && Se.submission, Se && Se.fetcherSubmission, Se && Se.replace, Se && Se.initialHydration === !0, Dt, be);
    Re || (_ = null, q(ve, or({
      matches: pe || bt
    }, CI(be), {
      loaderData: he,
      errors: Fe
    })));
  }
  async function Le(ue, ve, Se, ze, st, bt) {
    bt === void 0 && (bt = {}), Ke();
    let Dt = Uoe(ve, Se);
    if (we({
      navigation: Dt
    }, {
      flushSync: bt.flushSync === !0
    }), st) {
      let be = await mt(ze, ve.pathname, ue.signal);
      if (be.type === "aborted")
        return {
          shortCircuited: !0
        };
      if (be.type === "error") {
        let Re = ec(be.partialMatches).route.id;
        return {
          matches: be.partialMatches,
          pendingActionResult: [Re, {
            type: Fn.error,
            error: be.error
          }]
        };
      } else if (be.matches)
        ze = be.matches;
      else {
        let {
          notFoundMatches: Re,
          error: pe,
          route: he
        } = Bn(ve.pathname);
        return {
          matches: Re,
          pendingActionResult: [he.id, {
            type: Fn.error,
            error: pe
          }]
        };
      }
    }
    let at, Z = Df(ze, ve);
    if (!Z.route.action && !Z.route.lazy)
      at = {
        type: Fn.error,
        error: Lo(405, {
          method: ue.method,
          pathname: ve.pathname,
          routeId: Z.route.id
        })
      };
    else if (at = (await Pe("action", R, ue, [Z], ze, null))[Z.route.id], ue.signal.aborted)
      return {
        shortCircuited: !0
      };
    if (rc(at)) {
      let be;
      return bt && bt.replace != null ? be = bt.replace : be = bI(at.response.headers.get("Location"), new URL(ue.url), c) === R.location.pathname + R.location.search, await Te(ue, at, !0, {
        submission: Se,
        replace: be
      }), {
        shortCircuited: !0
      };
    }
    if (al(at))
      throw Lo(400, {
        type: "defer-action"
      });
    if (oi(at)) {
      let be = ec(ze, Z.route.id);
      return (bt && bt.replace) !== !0 && (F = Dr.Push), {
        matches: ze,
        pendingActionResult: [be.route.id, at]
      };
    }
    return {
      matches: ze,
      pendingActionResult: [Z.route.id, at]
    };
  }
  async function Ze(ue, ve, Se, ze, st, bt, Dt, at, Z, be, Re) {
    let pe = st || vw(ve, bt), he = bt || Dt || EI(pe), Fe = !B && (!p.v7_partialHydration || !Z);
    if (ze) {
      if (Fe) {
        let hn = J(Re);
        we(or({
          navigation: pe
        }, hn !== void 0 ? {
          actionData: hn
        } : {}), {
          flushSync: be
        });
      }
      let jt = await mt(Se, ve.pathname, ue.signal);
      if (jt.type === "aborted")
        return {
          shortCircuited: !0
        };
      if (jt.type === "error") {
        let hn = ec(jt.partialMatches).route.id;
        return {
          matches: jt.partialMatches,
          loaderData: {},
          errors: {
            [hn]: jt.error
          }
        };
      } else if (jt.matches)
        Se = jt.matches;
      else {
        let {
          error: hn,
          notFoundMatches: _o,
          route: Ks
        } = Bn(ve.pathname);
        return {
          matches: _o,
          loaderData: {},
          errors: {
            [Ks.id]: hn
          }
        };
      }
    }
    let We = l || a, [Ue, dt] = hI(e.history, R, Se, he, ve, p.v7_partialHydration && Z === !0, p.v7_skipActionErrorRevalidation, H, k, N, Q, ne, z, We, c, Re);
    if (kn((jt) => !(Se && Se.some((hn) => hn.route.id === jt)) || Ue && Ue.some((hn) => hn.route.id === jt)), V = ++W, Ue.length === 0 && dt.length === 0) {
      let jt = ct();
      return q(ve, or({
        matches: Se,
        loaderData: {},
        // Commit pending error if we're short circuiting
        errors: Re && oi(Re[1]) ? {
          [Re[0]]: Re[1].error
        } : null
      }, CI(Re), jt ? {
        fetchers: new Map(R.fetchers)
      } : {}), {
        flushSync: be
      }), {
        shortCircuited: !0
      };
    }
    if (Fe) {
      let jt = {};
      if (!ze) {
        jt.navigation = pe;
        let hn = J(Re);
        hn !== void 0 && (jt.actionData = hn);
      }
      dt.length > 0 && (jt.fetchers = fe(dt)), we(jt, {
        flushSync: be
      });
    }
    dt.forEach((jt) => {
      xt(jt.key), jt.controller && j.set(jt.key, jt.controller);
    });
    let Tt = () => dt.forEach((jt) => xt(jt.key));
    _ && _.signal.addEventListener("abort", Tt);
    let {
      loaderResults: zt,
      fetcherResults: pn
    } = await Ye(R, Se, Ue, dt, ue);
    if (ue.signal.aborted)
      return {
        shortCircuited: !0
      };
    _ && _.signal.removeEventListener("abort", Tt), dt.forEach((jt) => j.delete(jt.key));
    let Ar = xg(zt);
    if (Ar)
      return await Te(ue, Ar.result, !0, {
        replace: at
      }), {
        shortCircuited: !0
      };
    if (Ar = xg(pn), Ar)
      return z.add(Ar.key), await Te(ue, Ar.result, !0, {
        replace: at
      }), {
        shortCircuited: !0
      };
    let {
      loaderData: Gr,
      errors: Qn
    } = vI(R, Se, zt, Re, dt, pn, re);
    re.forEach((jt, hn) => {
      jt.subscribe((_o) => {
        (_o || jt.done) && re.delete(hn);
      });
    }), p.v7_partialHydration && Z && R.errors && (Qn = or({}, R.errors, Qn));
    let Wr = ct(), Ko = Je(V), qt = Wr || Ko || dt.length > 0;
    return or({
      matches: Se,
      loaderData: Gr,
      errors: Qn
    }, qt ? {
      fetchers: new Map(R.fetchers)
    } : {});
  }
  function J(ue) {
    if (ue && !oi(ue[1]))
      return {
        [ue[0]]: ue[1].data
      };
    if (R.actionData)
      return Object.keys(R.actionData).length === 0 ? null : R.actionData;
  }
  function fe(ue) {
    return ue.forEach((ve) => {
      let Se = R.fetchers.get(ve.key), ze = vf(void 0, Se ? Se.data : void 0);
      R.fetchers.set(ve.key, ze);
    }), new Map(R.fetchers);
  }
  function me(ue, ve, Se, ze) {
    if (r)
      throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
    xt(ue);
    let st = (ze && ze.flushSync) === !0, bt = l || a, Dt = W0(R.location, R.matches, c, p.v7_prependBasename, Se, p.v7_relativeSplatPath, ve, ze == null ? void 0 : ze.relative), at = Zl(bt, Dt, c), Z = lr(at, bt, Dt);
    if (Z.active && Z.matches && (at = Z.matches), !at) {
      Qe(ue, ve, Lo(404, {
        pathname: Dt
      }), {
        flushSync: st
      });
      return;
    }
    let {
      path: be,
      submission: Re,
      error: pe
    } = fI(p.v7_normalizeFormMethod, !0, Dt, ze);
    if (pe) {
      Qe(ue, ve, pe, {
        flushSync: st
      });
      return;
    }
    let he = Df(at, be), Fe = (ze && ze.preventScrollReset) === !0;
    if (Re && Ji(Re.formMethod)) {
      Oe(ue, ve, be, he, at, Z.active, st, Fe, Re);
      return;
    }
    ne.set(ue, {
      routeId: ve,
      path: be
    }), Ce(ue, ve, be, he, at, Z.active, st, Fe, Re);
  }
  async function Oe(ue, ve, Se, ze, st, bt, Dt, at, Z) {
    Ke(), ne.delete(ue);
    function be(pr) {
      if (!pr.route.action && !pr.route.lazy) {
        let Ia = Lo(405, {
          method: Z.formMethod,
          pathname: Se,
          routeId: ve
        });
        return Qe(ue, ve, Ia, {
          flushSync: Dt
        }), !0;
      }
      return !1;
    }
    if (!bt && be(ze))
      return;
    let Re = R.fetchers.get(ue);
    je(ue, zoe(Z, Re), {
      flushSync: Dt
    });
    let pe = new AbortController(), he = hu(e.history, Se, pe.signal, Z);
    if (bt) {
      let pr = await mt(st, Se, he.signal);
      if (pr.type === "aborted")
        return;
      if (pr.type === "error") {
        Qe(ue, ve, pr.error, {
          flushSync: Dt
        });
        return;
      } else if (pr.matches) {
        if (st = pr.matches, ze = Df(st, Se), be(ze))
          return;
      } else {
        Qe(ue, ve, Lo(404, {
          pathname: Se
        }), {
          flushSync: Dt
        });
        return;
      }
    }
    j.set(ue, pe);
    let Fe = W, Ue = (await Pe("action", R, he, [ze], st, ue))[ze.route.id];
    if (he.signal.aborted) {
      j.get(ue) === pe && j.delete(ue);
      return;
    }
    if (p.v7_fetcherPersist && Q.has(ue)) {
      if (rc(Ue) || oi(Ue)) {
        je(ue, za(void 0));
        return;
      }
    } else {
      if (rc(Ue))
        if (j.delete(ue), V > Fe) {
          je(ue, za(void 0));
          return;
        } else
          return z.add(ue), je(ue, vf(Z)), Te(he, Ue, !1, {
            fetcherSubmission: Z,
            preventScrollReset: at
          });
      if (oi(Ue)) {
        Qe(ue, ve, Ue.error);
        return;
      }
    }
    if (al(Ue))
      throw Lo(400, {
        type: "defer-action"
      });
    let dt = R.navigation.location || R.location, Tt = hu(e.history, dt, pe.signal), zt = l || a, pn = R.navigation.state !== "idle" ? Zl(zt, R.navigation.location, c) : R.matches;
    Pt(pn, "Didn't find any matches after fetcher action");
    let Ar = ++W;
    $.set(ue, Ar);
    let Gr = vf(Z, Ue.data);
    R.fetchers.set(ue, Gr);
    let [Qn, Wr] = hI(e.history, R, pn, Z, dt, !1, p.v7_skipActionErrorRevalidation, H, k, N, Q, ne, z, zt, c, [ze.route.id, Ue]);
    Wr.filter((pr) => pr.key !== ue).forEach((pr) => {
      let Ia = pr.key, Bd = R.fetchers.get(Ia), gh = vf(void 0, Bd ? Bd.data : void 0);
      R.fetchers.set(Ia, gh), xt(Ia), pr.controller && j.set(Ia, pr.controller);
    }), we({
      fetchers: new Map(R.fetchers)
    });
    let Ko = () => Wr.forEach((pr) => xt(pr.key));
    pe.signal.addEventListener("abort", Ko);
    let {
      loaderResults: qt,
      fetcherResults: jt
    } = await Ye(R, pn, Qn, Wr, Tt);
    if (pe.signal.aborted)
      return;
    pe.signal.removeEventListener("abort", Ko), $.delete(ue), j.delete(ue), Wr.forEach((pr) => j.delete(pr.key));
    let hn = xg(qt);
    if (hn)
      return Te(Tt, hn.result, !1, {
        preventScrollReset: at
      });
    if (hn = xg(jt), hn)
      return z.add(hn.key), Te(Tt, hn.result, !1, {
        preventScrollReset: at
      });
    let {
      loaderData: _o,
      errors: Ks
    } = vI(R, pn, qt, void 0, Wr, jt, re);
    if (R.fetchers.has(ue)) {
      let pr = za(Ue.data);
      R.fetchers.set(ue, pr);
    }
    Je(Ar), R.navigation.state === "loading" && Ar > V ? (Pt(F, "Expected pending action"), _ && _.abort(), q(R.navigation.location, {
      matches: pn,
      loaderData: _o,
      errors: Ks,
      fetchers: new Map(R.fetchers)
    })) : (we({
      errors: Ks,
      loaderData: wI(R.loaderData, _o, pn, Ks),
      fetchers: new Map(R.fetchers)
    }), H = !1);
  }
  async function Ce(ue, ve, Se, ze, st, bt, Dt, at, Z) {
    let be = R.fetchers.get(ue);
    je(ue, vf(Z, be ? be.data : void 0), {
      flushSync: Dt
    });
    let Re = new AbortController(), pe = hu(e.history, Se, Re.signal);
    if (bt) {
      let Ue = await mt(st, Se, pe.signal);
      if (Ue.type === "aborted")
        return;
      if (Ue.type === "error") {
        Qe(ue, ve, Ue.error, {
          flushSync: Dt
        });
        return;
      } else if (Ue.matches)
        st = Ue.matches, ze = Df(st, Se);
      else {
        Qe(ue, ve, Lo(404, {
          pathname: Se
        }), {
          flushSync: Dt
        });
        return;
      }
    }
    j.set(ue, Re);
    let he = W, We = (await Pe("loader", R, pe, [ze], st, ue))[ze.route.id];
    if (al(We) && (We = await Xx(We, pe.signal, !0) || We), j.get(ue) === Re && j.delete(ue), !pe.signal.aborted) {
      if (Q.has(ue)) {
        je(ue, za(void 0));
        return;
      }
      if (rc(We))
        if (V > he) {
          je(ue, za(void 0));
          return;
        } else {
          z.add(ue), await Te(pe, We, !1, {
            preventScrollReset: at
          });
          return;
        }
      if (oi(We)) {
        Qe(ue, ve, We.error);
        return;
      }
      Pt(!al(We), "Unhandled fetcher deferred data"), je(ue, za(We.data));
    }
  }
  async function Te(ue, ve, Se, ze) {
    let {
      submission: st,
      fetcherSubmission: bt,
      preventScrollReset: Dt,
      replace: at
    } = ze === void 0 ? {} : ze;
    ve.response.headers.has("X-Remix-Revalidate") && (H = !0);
    let Z = ve.response.headers.get("Location");
    Pt(Z, "Expected a Location header on the redirect Response"), Z = bI(Z, new URL(ue.url), c);
    let be = vp(R.location, Z, {
      _isRedirect: !0
    });
    if (n) {
      let Ue = !1;
      if (ve.response.headers.has("X-Remix-Reload-Document"))
        Ue = !0;
      else if (Qx.test(Z)) {
        const dt = e.history.createURL(Z);
        Ue = // Hard reload if it's an absolute URL to a new origin
        dt.origin !== t.location.origin || // Hard reload if it's an absolute URL that does not match our basename
        pi(dt.pathname, c) == null;
      }
      if (Ue) {
        at ? t.location.replace(Z) : t.location.assign(Z);
        return;
      }
    }
    _ = null;
    let Re = at === !0 || ve.response.headers.has("X-Remix-Replace") ? Dr.Replace : Dr.Push, {
      formMethod: pe,
      formAction: he,
      formEncType: Fe
    } = R.navigation;
    !st && !bt && pe && he && Fe && (st = EI(R.navigation));
    let We = st || bt;
    if (Eoe.has(ve.response.status) && We && Ji(We.formMethod))
      await $e(Re, be, {
        submission: or({}, We, {
          formAction: Z
        }),
        // Preserve these flags across redirects
        preventScrollReset: Dt || A,
        enableViewTransition: Se ? C : void 0
      });
    else {
      let Ue = vw(be, st);
      await $e(Re, be, {
        overrideNavigation: Ue,
        // Send fetcher submissions through for shouldRevalidate
        fetcherSubmission: bt,
        // Preserve these flags across redirects
        preventScrollReset: Dt || A,
        enableViewTransition: Se ? C : void 0
      });
    }
  }
  async function Pe(ue, ve, Se, ze, st, bt) {
    let Dt, at = {};
    try {
      Dt = await Moe(d, ue, ve, Se, ze, st, bt, i, o);
    } catch (Z) {
      return ze.forEach((be) => {
        at[be.route.id] = {
          type: Fn.error,
          error: Z
        };
      }), at;
    }
    for (let [Z, be] of Object.entries(Dt))
      if (Loe(be)) {
        let Re = be.result;
        at[Z] = {
          type: Fn.redirect,
          response: Noe(Re, Se, Z, st, c, p.v7_relativeSplatPath)
        };
      } else
        at[Z] = await Doe(be);
    return at;
  }
  async function Ye(ue, ve, Se, ze, st) {
    let bt = ue.matches, Dt = Pe("loader", ue, st, Se, ve, null), at = Promise.all(ze.map(async (Re) => {
      if (Re.matches && Re.match && Re.controller) {
        let he = (await Pe("loader", ue, hu(e.history, Re.path, Re.controller.signal), [Re.match], Re.matches, Re.key))[Re.match.route.id];
        return {
          [Re.key]: he
        };
      } else
        return Promise.resolve({
          [Re.key]: {
            type: Fn.error,
            error: Lo(404, {
              pathname: Re.path
            })
          }
        });
    })), Z = await Dt, be = (await at).reduce((Re, pe) => Object.assign(Re, pe), {});
    return await Promise.all([Voe(ve, Z, st.signal, bt, ue.loaderData), Hoe(ve, be, ze)]), {
      loaderResults: Z,
      fetcherResults: be
    };
  }
  function Ke() {
    H = !0, k.push(...kn()), ne.forEach((ue, ve) => {
      j.has(ve) && N.add(ve), xt(ve);
    });
  }
  function je(ue, ve, Se) {
    Se === void 0 && (Se = {}), R.fetchers.set(ue, ve), we({
      fetchers: new Map(R.fetchers)
    }, {
      flushSync: (Se && Se.flushSync) === !0
    });
  }
  function Qe(ue, ve, Se, ze) {
    ze === void 0 && (ze = {});
    let st = ec(R.matches, ve);
    Et(ue), we({
      errors: {
        [st.route.id]: Se
      },
      fetchers: new Map(R.fetchers)
    }, {
      flushSync: (ze && ze.flushSync) === !0
    });
  }
  function et(ue) {
    return p.v7_fetcherPersist && (K.set(ue, (K.get(ue) || 0) + 1), Q.has(ue) && Q.delete(ue)), R.fetchers.get(ue) || Toe;
  }
  function Et(ue) {
    let ve = R.fetchers.get(ue);
    j.has(ue) && !(ve && ve.state === "loading" && $.has(ue)) && xt(ue), ne.delete(ue), $.delete(ue), z.delete(ue), Q.delete(ue), N.delete(ue), R.fetchers.delete(ue);
  }
  function Xe(ue) {
    if (p.v7_fetcherPersist) {
      let ve = (K.get(ue) || 0) - 1;
      ve <= 0 ? (K.delete(ue), Q.add(ue)) : K.set(ue, ve);
    } else
      Et(ue);
    we({
      fetchers: new Map(R.fetchers)
    });
  }
  function xt(ue) {
    let ve = j.get(ue);
    ve && (ve.abort(), j.delete(ue));
  }
  function tt(ue) {
    for (let ve of ue) {
      let Se = et(ve), ze = za(Se.data);
      R.fetchers.set(ve, ze);
    }
  }
  function ct() {
    let ue = [], ve = !1;
    for (let Se of z) {
      let ze = R.fetchers.get(Se);
      Pt(ze, "Expected fetcher: " + Se), ze.state === "loading" && (z.delete(Se), ue.push(Se), ve = !0);
    }
    return tt(ue), ve;
  }
  function Je(ue) {
    let ve = [];
    for (let [Se, ze] of $)
      if (ze < ue) {
        let st = R.fetchers.get(Se);
        Pt(st, "Expected fetcher: " + Se), st.state === "loading" && (xt(Se), $.delete(Se), ve.push(Se));
      }
    return tt(ve), ve.length > 0;
  }
  function Ge(ue, ve) {
    let Se = R.blockers.get(ue) || Eu;
    return te.get(ue) !== ve && te.set(ue, ve), Se;
  }
  function lt(ue) {
    R.blockers.delete(ue), te.delete(ue);
  }
  function It(ue, ve) {
    let Se = R.blockers.get(ue) || Eu;
    Pt(Se.state === "unblocked" && ve.state === "blocked" || Se.state === "blocked" && ve.state === "blocked" || Se.state === "blocked" && ve.state === "proceeding" || Se.state === "blocked" && ve.state === "unblocked" || Se.state === "proceeding" && ve.state === "unblocked", "Invalid blocker state transition: " + Se.state + " -> " + ve.state);
    let ze = new Map(R.blockers);
    ze.set(ue, ve), we({
      blockers: ze
    });
  }
  function fn(ue) {
    let {
      currentLocation: ve,
      nextLocation: Se,
      historyAction: ze
    } = ue;
    if (te.size === 0)
      return;
    te.size > 1 && Hr(!1, "A router only supports one blocker at a time");
    let st = Array.from(te.entries()), [bt, Dt] = st[st.length - 1], at = R.blockers.get(bt);
    if (!(at && at.state === "proceeding") && Dt({
      currentLocation: ve,
      nextLocation: Se,
      historyAction: ze
    }))
      return bt;
  }
  function Bn(ue) {
    let ve = Lo(404, {
      pathname: ue
    }), Se = l || a, {
      matches: ze,
      route: st
    } = xI(Se);
    return kn(), {
      notFoundMatches: ze,
      route: st,
      error: ve
    };
  }
  function kn(ue) {
    let ve = [];
    return re.forEach((Se, ze) => {
      (!ue || ue(ze)) && (Se.cancel(), ve.push(ze), re.delete(ze));
    }), ve;
  }
  function fr(ue, ve, Se) {
    if (v = ue, S = ve, y = Se || null, !E && R.navigation === yw) {
      E = !0;
      let ze = Lr(R.location, R.matches);
      ze != null && we({
        restoreScrollPosition: ze
      });
    }
    return () => {
      v = null, S = null, y = null;
    };
  }
  function ar(ue, ve) {
    return y && y(ue, ve.map((ze) => noe(ze, R.loaderData))) || ue.key;
  }
  function Mr(ue, ve) {
    if (v && S) {
      let Se = ar(ue, ve);
      v[Se] = S();
    }
  }
  function Lr(ue, ve) {
    if (v) {
      let Se = ar(ue, ve), ze = v[Se];
      if (typeof ze == "number")
        return ze;
    }
    return null;
  }
  function lr(ue, ve, Se) {
    if (f)
      if (ue) {
        if (Object.keys(ue[0].params).length > 0)
          return {
            active: !0,
            matches: Hg(ve, Se, c, !0)
          };
      } else
        return {
          active: !0,
          matches: Hg(ve, Se, c, !0) || []
        };
    return {
      active: !1,
      matches: null
    };
  }
  async function mt(ue, ve, Se) {
    if (!f)
      return {
        type: "success",
        matches: ue
      };
    let ze = ue;
    for (; ; ) {
      let st = l == null, bt = l || a, Dt = i;
      try {
        await f({
          path: ve,
          matches: ze,
          patch: (be, Re) => {
            Se.aborted || mI(be, Re, bt, Dt, o);
          }
        });
      } catch (be) {
        return {
          type: "error",
          error: be,
          partialMatches: ze
        };
      } finally {
        st && !Se.aborted && (a = [...a]);
      }
      if (Se.aborted)
        return {
          type: "aborted"
        };
      let at = Zl(bt, ve, c);
      if (at)
        return {
          type: "success",
          matches: at
        };
      let Z = Hg(bt, ve, c, !0);
      if (!Z || ze.length === Z.length && ze.every((be, Re) => be.route.id === Z[Re].route.id))
        return {
          type: "success",
          matches: null
        };
      ze = Z;
    }
  }
  function er(ue) {
    i = {}, l = wm(ue, o, void 0, i);
  }
  function eo(ue, ve) {
    let Se = l == null;
    mI(ue, ve, l || a, i, o), Se && (a = [...a], we({}));
  }
  return P = {
    get basename() {
      return c;
    },
    get future() {
      return p;
    },
    get state() {
      return R;
    },
    get routes() {
      return a;
    },
    get window() {
      return t;
    },
    initialize: ae,
    subscribe: le,
    enableScrollRestoration: fr,
    navigate: Ee,
    fetch: me,
    revalidate: _e,
    // Passthrough to history-aware createHref used by useHref so we get proper
    // hash-aware URLs in DOM paths
    createHref: (ue) => e.history.createHref(ue),
    encodeLocation: (ue) => e.history.encodeLocation(ue),
    getFetcher: et,
    deleteFetcher: Xe,
    dispose: ce,
    getBlocker: Ge,
    deleteBlocker: lt,
    patchRoutes: eo,
    _internalFetchControllers: j,
    _internalActiveDeferreds: re,
    // TODO: Remove setRoutes, it's temporary to avoid dealing with
    // updating the tree while validating the update algorithm.
    _internalSetRoutes: er
  }, P;
}
function Ioe(e) {
  return e != null && ("formData" in e && e.formData != null || "body" in e && e.body !== void 0);
}
function W0(e, t, n, r, o, i, a, l) {
  let c, d;
  if (a) {
    c = [];
    for (let p of t)
      if (c.push(p), p.route.id === a) {
        d = p;
        break;
      }
  } else
    c = t, d = t[t.length - 1];
  let f = Yx(o || ".", Kx(c, i), pi(e.pathname, n) || e.pathname, l === "path");
  if (o == null && (f.search = e.search, f.hash = e.hash), (o == null || o === "" || o === ".") && d) {
    let p = Jx(f.search);
    if (d.route.index && !p)
      f.search = f.search ? f.search.replace(/^\?/, "?index&") : "?index";
    else if (!d.route.index && p) {
      let g = new URLSearchParams(f.search), b = g.getAll("index");
      g.delete("index"), b.filter((y) => y).forEach((y) => g.append("index", y));
      let v = g.toString();
      f.search = v ? "?" + v : "";
    }
  }
  return r && n !== "/" && (f.pathname = f.pathname === "/" ? n : $s([n, f.pathname])), Cl(f);
}
function fI(e, t, n, r) {
  if (!r || !Ioe(r))
    return {
      path: n
    };
  if (r.formMethod && !Boe(r.formMethod))
    return {
      path: n,
      error: Lo(405, {
        method: r.formMethod
      })
    };
  let o = () => ({
    path: n,
    error: Lo(400, {
      type: "invalid-body"
    })
  }), i = r.formMethod || "get", a = e ? i.toUpperCase() : i.toLowerCase(), l = kD(n);
  if (r.body !== void 0) {
    if (r.formEncType === "text/plain") {
      if (!Ji(a))
        return o();
      let g = typeof r.body == "string" ? r.body : r.body instanceof FormData || r.body instanceof URLSearchParams ? (
        // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
        Array.from(r.body.entries()).reduce((b, v) => {
          let [y, S] = v;
          return "" + b + y + "=" + S + `
`;
        }, "")
      ) : String(r.body);
      return {
        path: n,
        submission: {
          formMethod: a,
          formAction: l,
          formEncType: r.formEncType,
          formData: void 0,
          json: void 0,
          text: g
        }
      };
    } else if (r.formEncType === "application/json") {
      if (!Ji(a))
        return o();
      try {
        let g = typeof r.body == "string" ? JSON.parse(r.body) : r.body;
        return {
          path: n,
          submission: {
            formMethod: a,
            formAction: l,
            formEncType: r.formEncType,
            formData: void 0,
            json: g,
            text: void 0
          }
        };
      } catch {
        return o();
      }
    }
  }
  Pt(typeof FormData == "function", "FormData is not available in this environment");
  let c, d;
  if (r.formData)
    c = K0(r.formData), d = r.formData;
  else if (r.body instanceof FormData)
    c = K0(r.body), d = r.body;
  else if (r.body instanceof URLSearchParams)
    c = r.body, d = yI(c);
  else if (r.body == null)
    c = new URLSearchParams(), d = new FormData();
  else
    try {
      c = new URLSearchParams(r.body), d = yI(c);
    } catch {
      return o();
    }
  let f = {
    formMethod: a,
    formAction: l,
    formEncType: r && r.formEncType || "application/x-www-form-urlencoded",
    formData: d,
    json: void 0,
    text: void 0
  };
  if (Ji(f.formMethod))
    return {
      path: n,
      submission: f
    };
  let p = kl(n);
  return t && p.search && Jx(p.search) && c.append("index", ""), p.search = "?" + c, {
    path: Cl(p),
    submission: f
  };
}
function pI(e, t, n) {
  n === void 0 && (n = !1);
  let r = e.findIndex((o) => o.route.id === t);
  return r >= 0 ? e.slice(0, n ? r + 1 : r) : e;
}
function hI(e, t, n, r, o, i, a, l, c, d, f, p, g, b, v, y) {
  let S = y ? oi(y[1]) ? y[1].error : y[1].data : void 0, E = e.createURL(t.location), I = e.createURL(o), O = n;
  i && t.errors ? O = pI(n, Object.keys(t.errors)[0], !0) : y && oi(y[1]) && (O = pI(n, y[0]));
  let T = y ? y[1].statusCode : void 0, P = a && T && T >= 400, R = O.filter((A, _) => {
    let {
      route: C
    } = A;
    if (C.lazy)
      return !0;
    if (C.loader == null)
      return !1;
    if (i)
      return q0(C, t.loaderData, t.errors);
    if (Roe(t.loaderData, t.matches[_], A) || c.some((B) => B === A.route.id))
      return !0;
    let D = t.matches[_], L = A;
    return gI(A, or({
      currentUrl: E,
      currentParams: D.params,
      nextUrl: I,
      nextParams: L.params
    }, r, {
      actionResult: S,
      actionStatus: T,
      defaultShouldRevalidate: P ? !1 : (
        // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        l || E.pathname + E.search === I.pathname + I.search || // Search params affect all loaders
        E.search !== I.search || RD(D, L)
      )
    }));
  }), F = [];
  return p.forEach((A, _) => {
    if (i || !n.some((H) => H.route.id === A.routeId) || f.has(_))
      return;
    let C = Zl(b, A.path, v);
    if (!C) {
      F.push({
        key: _,
        routeId: A.routeId,
        path: A.path,
        matches: null,
        match: null,
        controller: null
      });
      return;
    }
    let D = t.fetchers.get(_), L = Df(C, A.path), B = !1;
    g.has(_) ? B = !1 : d.has(_) ? (d.delete(_), B = !0) : D && D.state !== "idle" && D.data === void 0 ? B = l : B = gI(L, or({
      currentUrl: E,
      currentParams: t.matches[t.matches.length - 1].params,
      nextUrl: I,
      nextParams: n[n.length - 1].params
    }, r, {
      actionResult: S,
      actionStatus: T,
      defaultShouldRevalidate: P ? !1 : l
    })), B && F.push({
      key: _,
      routeId: A.routeId,
      path: A.path,
      matches: C,
      match: L,
      controller: new AbortController()
    });
  }), [R, F];
}
function q0(e, t, n) {
  if (e.lazy)
    return !0;
  if (!e.loader)
    return !1;
  let r = t != null && t[e.id] !== void 0, o = n != null && n[e.id] !== void 0;
  return !r && o ? !1 : typeof e.loader == "function" && e.loader.hydrate === !0 ? !0 : !r && !o;
}
function Roe(e, t, n) {
  let r = (
    // [a] -> [a, b]
    !t || // [a, b] -> [a, c]
    n.route.id !== t.route.id
  ), o = e[n.route.id] === void 0;
  return r || o;
}
function RD(e, t) {
  let n = e.route.path;
  return (
    // param change for this match, /users/123 -> /users/456
    e.pathname !== t.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    n != null && n.endsWith("*") && e.params["*"] !== t.params["*"]
  );
}
function gI(e, t) {
  if (e.route.shouldRevalidate) {
    let n = e.route.shouldRevalidate(t);
    if (typeof n == "boolean")
      return n;
  }
  return t.defaultShouldRevalidate;
}
function mI(e, t, n, r, o) {
  var i;
  let a;
  if (e) {
    let d = r[e];
    Pt(d, "No route found to patch children into: routeId = " + e), d.children || (d.children = []), a = d.children;
  } else
    a = n;
  let l = t.filter((d) => !a.some((f) => _D(d, f))), c = wm(l, o, [e || "_", "patch", String(((i = a) == null ? void 0 : i.length) || "0")], r);
  a.push(...c);
}
function _D(e, t) {
  return "id" in e && "id" in t && e.id === t.id ? !0 : e.index === t.index && e.path === t.path && e.caseSensitive === t.caseSensitive ? (!e.children || e.children.length === 0) && (!t.children || t.children.length === 0) ? !0 : e.children.every((n, r) => {
    var o;
    return (o = t.children) == null ? void 0 : o.some((i) => _D(n, i));
  }) : !1;
}
async function _oe(e, t, n) {
  if (!e.lazy)
    return;
  let r = await e.lazy();
  if (!e.lazy)
    return;
  let o = n[e.id];
  Pt(o, "No route found in manifest");
  let i = {};
  for (let a in r) {
    let c = o[a] !== void 0 && // This property isn't static since it should always be updated based
    // on the route updates
    a !== "hasErrorBoundary";
    Hr(!c, 'Route "' + o.id + '" has a static property "' + a + '" defined but its lazy function is also returning a value for this property. ' + ('The lazy route property "' + a + '" will be ignored.')), !c && !eoe.has(a) && (i[a] = r[a]);
  }
  Object.assign(o, i), Object.assign(o, or({}, t(o), {
    lazy: void 0
  }));
}
async function koe(e) {
  let {
    matches: t
  } = e, n = t.filter((o) => o.shouldLoad);
  return (await Promise.all(n.map((o) => o.resolve()))).reduce((o, i, a) => Object.assign(o, {
    [n[a].route.id]: i
  }), {});
}
async function Moe(e, t, n, r, o, i, a, l, c, d) {
  let f = i.map((b) => b.route.lazy ? _oe(b.route, c, l) : void 0), p = i.map((b, v) => {
    let y = f[v], S = o.some((I) => I.route.id === b.route.id);
    return or({}, b, {
      shouldLoad: S,
      resolve: async (I) => (I && r.method === "GET" && (b.route.lazy || b.route.loader) && (S = !0), S ? Aoe(t, r, b, y, I, d) : Promise.resolve({
        type: Fn.data,
        result: void 0
      }))
    });
  }), g = await e({
    matches: p,
    request: r,
    params: i[0].params,
    fetcherKey: a,
    context: d
  });
  try {
    await Promise.all(f);
  } catch {
  }
  return g;
}
async function Aoe(e, t, n, r, o, i) {
  let a, l, c = (d) => {
    let f, p = new Promise((v, y) => f = y);
    l = () => f(), t.signal.addEventListener("abort", l);
    let g = (v) => typeof d != "function" ? Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + e + '" [routeId: ' + n.route.id + "]"))) : d({
      request: t,
      params: n.params,
      context: i
    }, ...v !== void 0 ? [v] : []), b = (async () => {
      try {
        return {
          type: "data",
          result: await (o ? o((y) => g(y)) : g())
        };
      } catch (v) {
        return {
          type: "error",
          result: v
        };
      }
    })();
    return Promise.race([b, p]);
  };
  try {
    let d = n.route[e];
    if (r)
      if (d) {
        let f, [p] = await Promise.all([
          // If the handler throws, don't let it immediately bubble out,
          // since we need to let the lazy() execution finish so we know if this
          // route has a boundary that can handle the error
          c(d).catch((g) => {
            f = g;
          }),
          r
        ]);
        if (f !== void 0)
          throw f;
        a = p;
      } else if (await r, d = n.route[e], d)
        a = await c(d);
      else if (e === "action") {
        let f = new URL(t.url), p = f.pathname + f.search;
        throw Lo(405, {
          method: t.method,
          pathname: p,
          routeId: n.route.id
        });
      } else
        return {
          type: Fn.data,
          result: void 0
        };
    else if (d)
      a = await c(d);
    else {
      let f = new URL(t.url), p = f.pathname + f.search;
      throw Lo(404, {
        pathname: p
      });
    }
    Pt(a.result !== void 0, "You defined " + (e === "action" ? "an action" : "a loader") + " for route " + ('"' + n.route.id + "\" but didn't return anything from your `" + e + "` ") + "function. Please return a value or `null`.");
  } catch (d) {
    return {
      type: Fn.error,
      result: d
    };
  } finally {
    l && t.signal.removeEventListener("abort", l);
  }
  return a;
}
async function Doe(e) {
  let {
    result: t,
    type: n
  } = e;
  if (MD(t)) {
    let d;
    try {
      let f = t.headers.get("Content-Type");
      f && /\bapplication\/json\b/.test(f) ? t.body == null ? d = null : d = await t.json() : d = await t.text();
    } catch (f) {
      return {
        type: Fn.error,
        error: f
      };
    }
    return n === Fn.error ? {
      type: Fn.error,
      error: new xm(t.status, t.statusText, d),
      statusCode: t.status,
      headers: t.headers
    } : {
      type: Fn.data,
      data: d,
      statusCode: t.status,
      headers: t.headers
    };
  }
  if (n === Fn.error) {
    if (SI(t)) {
      var r;
      if (t.data instanceof Error) {
        var o;
        return {
          type: Fn.error,
          error: t.data,
          statusCode: (o = t.init) == null ? void 0 : o.status
        };
      }
      t = new xm(((r = t.init) == null ? void 0 : r.status) || 500, void 0, t.data);
    }
    return {
      type: Fn.error,
      error: t,
      statusCode: zb(t) ? t.status : void 0
    };
  }
  if (joe(t)) {
    var i, a;
    return {
      type: Fn.deferred,
      deferredData: t,
      statusCode: (i = t.init) == null ? void 0 : i.status,
      headers: ((a = t.init) == null ? void 0 : a.headers) && new Headers(t.init.headers)
    };
  }
  if (SI(t)) {
    var l, c;
    return {
      type: Fn.data,
      data: t.data,
      statusCode: (l = t.init) == null ? void 0 : l.status,
      headers: (c = t.init) != null && c.headers ? new Headers(t.init.headers) : void 0
    };
  }
  return {
    type: Fn.data,
    data: t
  };
}
function Noe(e, t, n, r, o, i) {
  let a = e.headers.get("Location");
  if (Pt(a, "Redirects returned/thrown from loaders/actions must have a Location header"), !Qx.test(a)) {
    let l = r.slice(0, r.findIndex((c) => c.route.id === n) + 1);
    a = W0(new URL(t.url), l, o, !0, a, i), e.headers.set("Location", a);
  }
  return e;
}
function bI(e, t, n) {
  if (Qx.test(e)) {
    let r = e, o = r.startsWith("//") ? new URL(t.protocol + r) : new URL(r), i = pi(o.pathname, n) != null;
    if (o.origin === t.origin && i)
      return o.pathname + o.search + o.hash;
  }
  return e;
}
function hu(e, t, n, r) {
  let o = e.createURL(kD(t)).toString(), i = {
    signal: n
  };
  if (r && Ji(r.formMethod)) {
    let {
      formMethod: a,
      formEncType: l
    } = r;
    i.method = a.toUpperCase(), l === "application/json" ? (i.headers = new Headers({
      "Content-Type": l
    }), i.body = JSON.stringify(r.json)) : l === "text/plain" ? i.body = r.text : l === "application/x-www-form-urlencoded" && r.formData ? i.body = K0(r.formData) : i.body = r.formData;
  }
  return new Request(o, i);
}
function K0(e) {
  let t = new URLSearchParams();
  for (let [n, r] of e.entries())
    t.append(n, typeof r == "string" ? r : r.name);
  return t;
}
function yI(e) {
  let t = new FormData();
  for (let [n, r] of e.entries())
    t.append(n, r);
  return t;
}
function Foe(e, t, n, r, o) {
  let i = {}, a = null, l, c = !1, d = {}, f = n && oi(n[1]) ? n[1].error : void 0;
  return e.forEach((p) => {
    if (!(p.route.id in t))
      return;
    let g = p.route.id, b = t[g];
    if (Pt(!rc(b), "Cannot handle redirect results in processLoaderData"), oi(b)) {
      let v = b.error;
      f !== void 0 && (v = f, f = void 0), a = a || {};
      {
        let y = ec(e, g);
        a[y.route.id] == null && (a[y.route.id] = v);
      }
      i[g] = void 0, c || (c = !0, l = zb(b.error) ? b.error.status : 500), b.headers && (d[g] = b.headers);
    } else
      al(b) ? (r.set(g, b.deferredData), i[g] = b.deferredData.data, b.statusCode != null && b.statusCode !== 200 && !c && (l = b.statusCode), b.headers && (d[g] = b.headers)) : (i[g] = b.data, b.statusCode && b.statusCode !== 200 && !c && (l = b.statusCode), b.headers && (d[g] = b.headers));
  }), f !== void 0 && n && (a = {
    [n[0]]: f
  }, i[n[0]] = void 0), {
    loaderData: i,
    errors: a,
    statusCode: l || 200,
    loaderHeaders: d
  };
}
function vI(e, t, n, r, o, i, a) {
  let {
    loaderData: l,
    errors: c
  } = Foe(t, n, r, a);
  return o.forEach((d) => {
    let {
      key: f,
      match: p,
      controller: g
    } = d, b = i[f];
    if (Pt(b, "Did not find corresponding fetcher result"), !(g && g.signal.aborted))
      if (oi(b)) {
        let v = ec(e.matches, p == null ? void 0 : p.route.id);
        c && c[v.route.id] || (c = or({}, c, {
          [v.route.id]: b.error
        })), e.fetchers.delete(f);
      } else if (rc(b))
        Pt(!1, "Unhandled fetcher revalidation redirect");
      else if (al(b))
        Pt(!1, "Unhandled fetcher deferred data");
      else {
        let v = za(b.data);
        e.fetchers.set(f, v);
      }
  }), {
    loaderData: l,
    errors: c
  };
}
function wI(e, t, n, r) {
  let o = or({}, t);
  for (let i of n) {
    let a = i.route.id;
    if (t.hasOwnProperty(a) ? t[a] !== void 0 && (o[a] = t[a]) : e[a] !== void 0 && i.route.loader && (o[a] = e[a]), r && r.hasOwnProperty(a))
      break;
  }
  return o;
}
function CI(e) {
  return e ? oi(e[1]) ? {
    // Clear out prior actionData on errors
    actionData: {}
  } : {
    actionData: {
      [e[0]]: e[1].data
    }
  } : {};
}
function ec(e, t) {
  return (t ? e.slice(0, e.findIndex((r) => r.route.id === t) + 1) : [...e]).reverse().find((r) => r.route.hasErrorBoundary === !0) || e[0];
}
function xI(e) {
  let t = e.length === 1 ? e[0] : e.find((n) => n.index || !n.path || n.path === "/") || {
    id: "__shim-error-route__"
  };
  return {
    matches: [{
      params: {},
      pathname: "",
      pathnameBase: "",
      route: t
    }],
    route: t
  };
}
function Lo(e, t) {
  let {
    pathname: n,
    routeId: r,
    method: o,
    type: i,
    message: a
  } = t === void 0 ? {} : t, l = "Unknown Server Error", c = "Unknown @remix-run/router error";
  return e === 400 ? (l = "Bad Request", o && n && r ? c = "You made a " + o + ' request to "' + n + '" but ' + ('did not provide a `loader` for route "' + r + '", ') + "so there is no way to handle the request." : i === "defer-action" ? c = "defer() is not supported in actions" : i === "invalid-body" && (c = "Unable to encode submission body")) : e === 403 ? (l = "Forbidden", c = 'Route "' + r + '" does not match URL "' + n + '"') : e === 404 ? (l = "Not Found", c = 'No route matches URL "' + n + '"') : e === 405 && (l = "Method Not Allowed", o && n && r ? c = "You made a " + o.toUpperCase() + ' request to "' + n + '" but ' + ('did not provide an `action` for route "' + r + '", ') + "so there is no way to handle the request." : o && (c = 'Invalid request method "' + o.toUpperCase() + '"')), new xm(e || 500, l, new Error(c), !0);
}
function xg(e) {
  let t = Object.entries(e);
  for (let n = t.length - 1; n >= 0; n--) {
    let [r, o] = t[n];
    if (rc(o))
      return {
        key: r,
        result: o
      };
  }
}
function kD(e) {
  let t = typeof e == "string" ? kl(e) : e;
  return Cl(or({}, t, {
    hash: ""
  }));
}
function $oe(e, t) {
  return e.pathname !== t.pathname || e.search !== t.search ? !1 : e.hash === "" ? t.hash !== "" : e.hash === t.hash ? !0 : t.hash !== "";
}
function Loe(e) {
  return MD(e.result) && Soe.has(e.result.status);
}
function al(e) {
  return e.type === Fn.deferred;
}
function oi(e) {
  return e.type === Fn.error;
}
function rc(e) {
  return (e && e.type) === Fn.redirect;
}
function SI(e) {
  return typeof e == "object" && e != null && "type" in e && "data" in e && "init" in e && e.type === "DataWithResponseInit";
}
function joe(e) {
  let t = e;
  return t && typeof t == "object" && typeof t.data == "object" && typeof t.subscribe == "function" && typeof t.cancel == "function" && typeof t.resolveData == "function";
}
function MD(e) {
  return e != null && typeof e.status == "number" && typeof e.statusText == "string" && typeof e.headers == "object" && typeof e.body < "u";
}
function Boe(e) {
  return xoe.has(e.toLowerCase());
}
function Ji(e) {
  return woe.has(e.toLowerCase());
}
async function Voe(e, t, n, r, o) {
  let i = Object.entries(t);
  for (let a = 0; a < i.length; a++) {
    let [l, c] = i[a], d = e.find((g) => (g == null ? void 0 : g.route.id) === l);
    if (!d)
      continue;
    let f = r.find((g) => g.route.id === d.route.id), p = f != null && !RD(f, d) && (o && o[d.route.id]) !== void 0;
    al(c) && p && await Xx(c, n, !1).then((g) => {
      g && (t[l] = g);
    });
  }
}
async function Hoe(e, t, n) {
  for (let r = 0; r < n.length; r++) {
    let {
      key: o,
      routeId: i,
      controller: a
    } = n[r], l = t[o];
    e.find((d) => (d == null ? void 0 : d.route.id) === i) && al(l) && (Pt(a, "Expected an AbortController for revalidating fetcher deferred result"), await Xx(l, a.signal, !0).then((d) => {
      d && (t[o] = d);
    }));
  }
}
async function Xx(e, t, n) {
  if (n === void 0 && (n = !1), !await e.deferredData.resolveData(t)) {
    if (n)
      try {
        return {
          type: Fn.data,
          data: e.deferredData.unwrappedData
        };
      } catch (o) {
        return {
          type: Fn.error,
          error: o
        };
      }
    return {
      type: Fn.data,
      data: e.deferredData.data
    };
  }
}
function Jx(e) {
  return new URLSearchParams(e).getAll("index").some((t) => t === "");
}
function Df(e, t) {
  let n = typeof t == "string" ? kl(t).search : t.search;
  if (e[e.length - 1].route.index && Jx(n || ""))
    return e[e.length - 1];
  let r = OD(e);
  return r[r.length - 1];
}
function EI(e) {
  let {
    formMethod: t,
    formAction: n,
    formEncType: r,
    text: o,
    formData: i,
    json: a
  } = e;
  if (!(!t || !n || !r)) {
    if (o != null)
      return {
        formMethod: t,
        formAction: n,
        formEncType: r,
        formData: void 0,
        json: void 0,
        text: o
      };
    if (i != null)
      return {
        formMethod: t,
        formAction: n,
        formEncType: r,
        formData: i,
        json: void 0,
        text: void 0
      };
    if (a !== void 0)
      return {
        formMethod: t,
        formAction: n,
        formEncType: r,
        formData: void 0,
        json: a,
        text: void 0
      };
  }
}
function vw(e, t) {
  return t ? {
    state: "loading",
    location: e,
    formMethod: t.formMethod,
    formAction: t.formAction,
    formEncType: t.formEncType,
    formData: t.formData,
    json: t.json,
    text: t.text
  } : {
    state: "loading",
    location: e,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
  };
}
function Uoe(e, t) {
  return {
    state: "submitting",
    location: e,
    formMethod: t.formMethod,
    formAction: t.formAction,
    formEncType: t.formEncType,
    formData: t.formData,
    json: t.json,
    text: t.text
  };
}
function vf(e, t) {
  return e ? {
    state: "loading",
    formMethod: e.formMethod,
    formAction: e.formAction,
    formEncType: e.formEncType,
    formData: e.formData,
    json: e.json,
    text: e.text,
    data: t
  } : {
    state: "loading",
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0,
    data: t
  };
}
function zoe(e, t) {
  return {
    state: "submitting",
    formMethod: e.formMethod,
    formAction: e.formAction,
    formEncType: e.formEncType,
    formData: e.formData,
    json: e.json,
    text: e.text,
    data: t ? t.data : void 0
  };
}
function za(e) {
  return {
    state: "idle",
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0,
    data: e
  };
}
function Goe(e, t) {
  try {
    let n = e.sessionStorage.getItem(ID);
    if (n) {
      let r = JSON.parse(n);
      for (let [o, i] of Object.entries(r || {}))
        i && Array.isArray(i) && t.set(o, new Set(i || []));
    }
  } catch {
  }
}
function Woe(e, t) {
  if (t.size > 0) {
    let n = {};
    for (let [r, o] of t)
      n[r] = [...o];
    try {
      e.sessionStorage.setItem(ID, JSON.stringify(n));
    } catch (r) {
      Hr(!1, "Failed to save applied view transitions in sessionStorage (" + r + ").");
    }
  }
}
/**
 * React Router v6.28.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function bd() {
  return bd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bd.apply(this, arguments);
}
const kd = /* @__PURE__ */ m.createContext(null);
process.env.NODE_ENV !== "production" && (kd.displayName = "DataRouter");
const Gb = /* @__PURE__ */ m.createContext(null);
process.env.NODE_ENV !== "production" && (Gb.displayName = "DataRouterState");
const qoe = /* @__PURE__ */ m.createContext(null);
process.env.NODE_ENV !== "production" && (qoe.displayName = "Await");
const us = /* @__PURE__ */ m.createContext(null);
process.env.NODE_ENV !== "production" && (us.displayName = "Navigation");
const Wb = /* @__PURE__ */ m.createContext(null);
process.env.NODE_ENV !== "production" && (Wb.displayName = "Location");
const qs = /* @__PURE__ */ m.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
process.env.NODE_ENV !== "production" && (qs.displayName = "Route");
const Zx = /* @__PURE__ */ m.createContext(null);
process.env.NODE_ENV !== "production" && (Zx.displayName = "RouteError");
function Koe(e, t) {
  let {
    relative: n
  } = t === void 0 ? {} : t;
  oh() || (process.env.NODE_ENV !== "production" ? Pt(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component."
  ) : Pt(!1));
  let {
    basename: r,
    navigator: o
  } = m.useContext(us), {
    hash: i,
    pathname: a,
    search: l
  } = ih(e, {
    relative: n
  }), c = a;
  return r !== "/" && (c = a === "/" ? r : $s([r, a])), o.createHref({
    pathname: c,
    search: l,
    hash: i
  });
}
function oh() {
  return m.useContext(Wb) != null;
}
function Ml() {
  return oh() || (process.env.NODE_ENV !== "production" ? Pt(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ) : Pt(!1)), m.useContext(Wb).location;
}
const AD = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function DD(e) {
  m.useContext(us).static || m.useLayoutEffect(e);
}
function Md() {
  let {
    isDataRoute: e
  } = m.useContext(qs);
  return e ? cie() : Yoe();
}
function Yoe() {
  oh() || (process.env.NODE_ENV !== "production" ? Pt(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  ) : Pt(!1));
  let e = m.useContext(kd), {
    basename: t,
    future: n,
    navigator: r
  } = m.useContext(us), {
    matches: o
  } = m.useContext(qs), {
    pathname: i
  } = Ml(), a = JSON.stringify(Kx(o, n.v7_relativeSplatPath)), l = m.useRef(!1);
  return DD(() => {
    l.current = !0;
  }), m.useCallback(function(d, f) {
    if (f === void 0 && (f = {}), process.env.NODE_ENV !== "production" && Hr(l.current, AD), !l.current) return;
    if (typeof d == "number") {
      r.go(d);
      return;
    }
    let p = Yx(d, JSON.parse(a), i, f.relative === "path");
    e == null && t !== "/" && (p.pathname = p.pathname === "/" ? t : $s([t, p.pathname])), (f.replace ? r.replace : r.push)(p, f.state, f);
  }, [t, r, a, i, e]);
}
const Qoe = /* @__PURE__ */ m.createContext(null);
function Xoe(e) {
  let t = m.useContext(qs).outlet;
  return t && /* @__PURE__ */ m.createElement(Qoe.Provider, {
    value: e
  }, t);
}
function ih(e, t) {
  let {
    relative: n
  } = t === void 0 ? {} : t, {
    future: r
  } = m.useContext(us), {
    matches: o
  } = m.useContext(qs), {
    pathname: i
  } = Ml(), a = JSON.stringify(Kx(o, r.v7_relativeSplatPath));
  return m.useMemo(() => Yx(e, JSON.parse(a), i, n === "path"), [e, a, i, n]);
}
function Joe(e, t, n, r) {
  oh() || (process.env.NODE_ENV !== "production" ? Pt(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component."
  ) : Pt(!1));
  let {
    navigator: o
  } = m.useContext(us), {
    matches: i
  } = m.useContext(qs), a = i[i.length - 1], l = a ? a.params : {}, c = a ? a.pathname : "/", d = a ? a.pathnameBase : "/", f = a && a.route;
  if (process.env.NODE_ENV !== "production") {
    let E = f && f.path || "";
    $D(c, !f || E.endsWith("*"), "You rendered descendant <Routes> (or called `useRoutes()`) at " + ('"' + c + '" (under <Route path="' + E + '">) but the ') + `parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

` + ('Please change the parent <Route path="' + E + '"> to <Route ') + ('path="' + (E === "/" ? "*" : E + "/*") + '">.'));
  }
  let p = Ml(), g;
  g = p;
  let b = g.pathname || "/", v = b;
  if (d !== "/") {
    let E = d.replace(/^\//, "").split("/");
    v = "/" + b.replace(/^\//, "").split("/").slice(E.length).join("/");
  }
  let y = Zl(e, {
    pathname: v
  });
  return process.env.NODE_ENV !== "production" && (process.env.NODE_ENV !== "production" && Hr(f || y != null, 'No routes matched location "' + g.pathname + g.search + g.hash + '" '), process.env.NODE_ENV !== "production" && Hr(y == null || y[y.length - 1].route.element !== void 0 || y[y.length - 1].route.Component !== void 0 || y[y.length - 1].route.lazy !== void 0, 'Matched leaf route at location "' + g.pathname + g.search + g.hash + '" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.')), rie(y && y.map((E) => Object.assign({}, E, {
    params: Object.assign({}, l, E.params),
    pathname: $s([
      d,
      // Re-encode pathnames that were decoded inside matchRoutes
      o.encodeLocation ? o.encodeLocation(E.pathname).pathname : E.pathname
    ]),
    pathnameBase: E.pathnameBase === "/" ? d : $s([
      d,
      // Re-encode pathnames that were decoded inside matchRoutes
      o.encodeLocation ? o.encodeLocation(E.pathnameBase).pathname : E.pathnameBase
    ])
  })), i, n, r);
}
function Zoe() {
  let e = sie(), t = zb(e) ? e.status + " " + e.statusText : e instanceof Error ? e.message : JSON.stringify(e), n = e instanceof Error ? e.stack : null, r = "rgba(200,200,200, 0.5)", o = {
    padding: "0.5rem",
    backgroundColor: r
  }, i = {
    padding: "2px 4px",
    backgroundColor: r
  }, a = null;
  return process.env.NODE_ENV !== "production" && (console.error("Error handled by React Router default ErrorBoundary:", e), a = /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement("p", null, "💿 Hey developer 👋"), /* @__PURE__ */ m.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ m.createElement("code", {
    style: i
  }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ m.createElement("code", {
    style: i
  }, "errorElement"), " prop on your route."))), /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ m.createElement("h3", {
    style: {
      fontStyle: "italic"
    }
  }, t), n ? /* @__PURE__ */ m.createElement("pre", {
    style: o
  }, n) : null, a);
}
const eie = /* @__PURE__ */ m.createElement(Zoe, null);
class tie extends m.Component {
  constructor(t) {
    super(t), this.state = {
      location: t.location,
      revalidation: t.revalidation,
      error: t.error
    };
  }
  static getDerivedStateFromError(t) {
    return {
      error: t
    };
  }
  static getDerivedStateFromProps(t, n) {
    return n.location !== t.location || n.revalidation !== "idle" && t.revalidation === "idle" ? {
      error: t.error,
      location: t.location,
      revalidation: t.revalidation
    } : {
      error: t.error !== void 0 ? t.error : n.error,
      location: n.location,
      revalidation: t.revalidation || n.revalidation
    };
  }
  componentDidCatch(t, n) {
    console.error("React Router caught the following error during render", t, n);
  }
  render() {
    return this.state.error !== void 0 ? /* @__PURE__ */ m.createElement(qs.Provider, {
      value: this.props.routeContext
    }, /* @__PURE__ */ m.createElement(Zx.Provider, {
      value: this.state.error,
      children: this.props.component
    })) : this.props.children;
  }
}
function nie(e) {
  let {
    routeContext: t,
    match: n,
    children: r
  } = e, o = m.useContext(kd);
  return o && o.static && o.staticContext && (n.route.errorElement || n.route.ErrorBoundary) && (o.staticContext._deepestRenderedBoundaryId = n.route.id), /* @__PURE__ */ m.createElement(qs.Provider, {
    value: t
  }, r);
}
function rie(e, t, n, r) {
  var o;
  if (t === void 0 && (t = []), n === void 0 && (n = null), r === void 0 && (r = null), e == null) {
    var i;
    if (!n)
      return null;
    if (n.errors)
      e = n.matches;
    else if ((i = r) != null && i.v7_partialHydration && t.length === 0 && !n.initialized && n.matches.length > 0)
      e = n.matches;
    else
      return null;
  }
  let a = e, l = (o = n) == null ? void 0 : o.errors;
  if (l != null) {
    let f = a.findIndex((p) => p.route.id && (l == null ? void 0 : l[p.route.id]) !== void 0);
    f >= 0 || (process.env.NODE_ENV !== "production" ? Pt(!1, "Could not find a matching route for errors on route IDs: " + Object.keys(l).join(",")) : Pt(!1)), a = a.slice(0, Math.min(a.length, f + 1));
  }
  let c = !1, d = -1;
  if (n && r && r.v7_partialHydration)
    for (let f = 0; f < a.length; f++) {
      let p = a[f];
      if ((p.route.HydrateFallback || p.route.hydrateFallbackElement) && (d = f), p.route.id) {
        let {
          loaderData: g,
          errors: b
        } = n, v = p.route.loader && g[p.route.id] === void 0 && (!b || b[p.route.id] === void 0);
        if (p.route.lazy || v) {
          c = !0, d >= 0 ? a = a.slice(0, d + 1) : a = [a[0]];
          break;
        }
      }
    }
  return a.reduceRight((f, p, g) => {
    let b, v = !1, y = null, S = null;
    n && (b = l && p.route.id ? l[p.route.id] : void 0, y = p.route.errorElement || eie, c && (d < 0 && g === 0 ? ($D("route-fallback", !1, "No `HydrateFallback` element provided to render during initial hydration"), v = !0, S = null) : d === g && (v = !0, S = p.route.hydrateFallbackElement || null)));
    let E = t.concat(a.slice(0, g + 1)), I = () => {
      let O;
      return b ? O = y : v ? O = S : p.route.Component ? O = /* @__PURE__ */ m.createElement(p.route.Component, null) : p.route.element ? O = p.route.element : O = f, /* @__PURE__ */ m.createElement(nie, {
        match: p,
        routeContext: {
          outlet: f,
          matches: E,
          isDataRoute: n != null
        },
        children: O
      });
    };
    return n && (p.route.ErrorBoundary || p.route.errorElement || g === 0) ? /* @__PURE__ */ m.createElement(tie, {
      location: n.location,
      revalidation: n.revalidation,
      component: y,
      error: b,
      children: I(),
      routeContext: {
        outlet: null,
        matches: E,
        isDataRoute: !0
      }
    }) : I();
  }, null);
}
var eS = /* @__PURE__ */ function(e) {
  return e.UseBlocker = "useBlocker", e.UseRevalidator = "useRevalidator", e.UseNavigateStable = "useNavigate", e;
}(eS || {}), yd = /* @__PURE__ */ function(e) {
  return e.UseBlocker = "useBlocker", e.UseLoaderData = "useLoaderData", e.UseActionData = "useActionData", e.UseRouteError = "useRouteError", e.UseNavigation = "useNavigation", e.UseRouteLoaderData = "useRouteLoaderData", e.UseMatches = "useMatches", e.UseRevalidator = "useRevalidator", e.UseNavigateStable = "useNavigate", e.UseRouteId = "useRouteId", e;
}(yd || {});
function tS(e) {
  return e + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function ND(e) {
  let t = m.useContext(kd);
  return t || (process.env.NODE_ENV !== "production" ? Pt(!1, tS(e)) : Pt(!1)), t;
}
function FD(e) {
  let t = m.useContext(Gb);
  return t || (process.env.NODE_ENV !== "production" ? Pt(!1, tS(e)) : Pt(!1)), t;
}
function oie(e) {
  let t = m.useContext(qs);
  return t || (process.env.NODE_ENV !== "production" ? Pt(!1, tS(e)) : Pt(!1)), t;
}
function nS(e) {
  let t = oie(e), n = t.matches[t.matches.length - 1];
  return n.route.id || (process.env.NODE_ENV !== "production" ? Pt(!1, e + ' can only be used on routes that contain a unique "id"') : Pt(!1)), n.route.id;
}
function iie() {
  return nS(yd.UseRouteId);
}
function sie() {
  var e;
  let t = m.useContext(Zx), n = FD(yd.UseRouteError), r = nS(yd.UseRouteError);
  return t !== void 0 ? t : (e = n.errors) == null ? void 0 : e[r];
}
let aie = 0;
function lie(e) {
  let {
    router: t,
    basename: n
  } = ND(eS.UseBlocker), r = FD(yd.UseBlocker), [o, i] = m.useState(""), a = m.useCallback((l) => {
    if (typeof e != "function")
      return !!e;
    if (n === "/")
      return e(l);
    let {
      currentLocation: c,
      nextLocation: d,
      historyAction: f
    } = l;
    return e({
      currentLocation: bd({}, c, {
        pathname: pi(c.pathname, n) || c.pathname
      }),
      nextLocation: bd({}, d, {
        pathname: pi(d.pathname, n) || d.pathname
      }),
      historyAction: f
    });
  }, [n, e]);
  return m.useEffect(() => {
    let l = String(++aie);
    return i(l), () => t.deleteBlocker(l);
  }, [t]), m.useEffect(() => {
    o !== "" && t.getBlocker(o, a);
  }, [t, o, a]), o && r.blockers.has(o) ? r.blockers.get(o) : Eu;
}
function cie() {
  let {
    router: e
  } = ND(eS.UseNavigateStable), t = nS(yd.UseNavigateStable), n = m.useRef(!1);
  return DD(() => {
    n.current = !0;
  }), m.useCallback(function(o, i) {
    i === void 0 && (i = {}), process.env.NODE_ENV !== "production" && Hr(n.current, AD), n.current && (typeof o == "number" ? e.navigate(o) : e.navigate(o, bd({
      fromRouteId: t
    }, i)));
  }, [e, t]);
}
const TI = {};
function $D(e, t, n) {
  !t && !TI[e] && (TI[e] = !0, process.env.NODE_ENV !== "production" && Hr(!1, n));
}
const OI = {};
function uie(e, t) {
  OI[t] || (OI[t] = !0, console.warn(t));
}
const gu = (e, t, n) => uie(e, "⚠️ React Router Future Flag Warning: " + t + ". " + ("You can use the `" + e + "` future flag to opt-in early. ") + ("For more information, see " + n + "."));
function die(e, t) {
  (e == null ? void 0 : e.v7_startTransition) === void 0 && gu("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition"), (e == null ? void 0 : e.v7_relativeSplatPath) === void 0 && (!t || !t.v7_relativeSplatPath) && gu("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath"), t && (t.v7_fetcherPersist === void 0 && gu("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist"), t.v7_normalizeFormMethod === void 0 && gu("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod"), t.v7_partialHydration === void 0 && gu("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration"), t.v7_skipActionErrorRevalidation === void 0 && gu("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation"));
}
function PI(e) {
  return Xoe(e.context);
}
function Ga(e) {
  process.env.NODE_ENV !== "production" ? Pt(!1, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.") : Pt(!1);
}
function fie(e) {
  let {
    basename: t = "/",
    children: n = null,
    location: r,
    navigationType: o = Dr.Pop,
    navigator: i,
    static: a = !1,
    future: l
  } = e;
  oh() && (process.env.NODE_ENV !== "production" ? Pt(!1, "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.") : Pt(!1));
  let c = t.replace(/^\/*/, "/"), d = m.useMemo(() => ({
    basename: c,
    navigator: i,
    static: a,
    future: bd({
      v7_relativeSplatPath: !1
    }, l)
  }), [c, l, i, a]);
  typeof r == "string" && (r = kl(r));
  let {
    pathname: f = "/",
    search: p = "",
    hash: g = "",
    state: b = null,
    key: v = "default"
  } = r, y = m.useMemo(() => {
    let S = pi(f, c);
    return S == null ? null : {
      location: {
        pathname: S,
        search: p,
        hash: g,
        state: b,
        key: v
      },
      navigationType: o
    };
  }, [c, f, p, g, b, v, o]);
  return process.env.NODE_ENV !== "production" && Hr(y != null, '<Router basename="' + c + '"> is not able to match the URL ' + ('"' + f + p + g + '" because it does not start with the ') + "basename, so the <Router> won't render anything."), y == null ? null : /* @__PURE__ */ m.createElement(us.Provider, {
    value: d
  }, /* @__PURE__ */ m.createElement(Wb.Provider, {
    children: n,
    value: y
  }));
}
new Promise(() => {
});
function Y0(e, t) {
  t === void 0 && (t = []);
  let n = [];
  return m.Children.forEach(e, (r, o) => {
    if (!/* @__PURE__ */ m.isValidElement(r))
      return;
    let i = [...t, o];
    if (r.type === m.Fragment) {
      n.push.apply(n, Y0(r.props.children, i));
      return;
    }
    r.type !== Ga && (process.env.NODE_ENV !== "production" ? Pt(!1, "[" + (typeof r.type == "string" ? r.type : r.type.name) + "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>") : Pt(!1)), !r.props.index || !r.props.children || (process.env.NODE_ENV !== "production" ? Pt(!1, "An index route cannot have child routes.") : Pt(!1));
    let a = {
      id: r.props.id || i.join("-"),
      caseSensitive: r.props.caseSensitive,
      element: r.props.element,
      Component: r.props.Component,
      index: r.props.index,
      path: r.props.path,
      loader: r.props.loader,
      action: r.props.action,
      errorElement: r.props.errorElement,
      ErrorBoundary: r.props.ErrorBoundary,
      hasErrorBoundary: r.props.ErrorBoundary != null || r.props.errorElement != null,
      shouldRevalidate: r.props.shouldRevalidate,
      handle: r.props.handle,
      lazy: r.props.lazy
    };
    r.props.children && (a.children = Y0(r.props.children, i)), n.push(a);
  }), n;
}
function pie(e) {
  let t = {
    // Note: this check also occurs in createRoutesFromChildren so update
    // there if you change this -- please and thank you!
    hasErrorBoundary: e.ErrorBoundary != null || e.errorElement != null
  };
  return e.Component && (process.env.NODE_ENV !== "production" && e.element && process.env.NODE_ENV !== "production" && Hr(!1, "You should not include both `Component` and `element` on your route - `Component` will be used."), Object.assign(t, {
    element: /* @__PURE__ */ m.createElement(e.Component),
    Component: void 0
  })), e.HydrateFallback && (process.env.NODE_ENV !== "production" && e.hydrateFallbackElement && process.env.NODE_ENV !== "production" && Hr(!1, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used."), Object.assign(t, {
    hydrateFallbackElement: /* @__PURE__ */ m.createElement(e.HydrateFallback),
    HydrateFallback: void 0
  })), e.ErrorBoundary && (process.env.NODE_ENV !== "production" && e.errorElement && process.env.NODE_ENV !== "production" && Hr(!1, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used."), Object.assign(t, {
    errorElement: /* @__PURE__ */ m.createElement(e.ErrorBoundary),
    ErrorBoundary: void 0
  })), t;
}
/**
 * React Router DOM v6.28.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function xl() {
  return xl = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xl.apply(this, arguments);
}
function rS(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
const Ug = "get", zg = "application/x-www-form-urlencoded";
function qb(e) {
  return e != null && typeof e.tagName == "string";
}
function hie(e) {
  return qb(e) && e.tagName.toLowerCase() === "button";
}
function gie(e) {
  return qb(e) && e.tagName.toLowerCase() === "form";
}
function mie(e) {
  return qb(e) && e.tagName.toLowerCase() === "input";
}
function bie(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function yie(e, t) {
  return e.button === 0 && // Ignore everything but left clicks
  (!t || t === "_self") && // Let browser handle "target=_blank" etc.
  !bie(e);
}
function Q0(e) {
  return e === void 0 && (e = ""), new URLSearchParams(typeof e == "string" || Array.isArray(e) || e instanceof URLSearchParams ? e : Object.keys(e).reduce((t, n) => {
    let r = e[n];
    return t.concat(Array.isArray(r) ? r.map((o) => [n, o]) : [[n, r]]);
  }, []));
}
function vie(e, t) {
  let n = Q0(e);
  return t && t.forEach((r, o) => {
    n.has(o) || t.getAll(o).forEach((i) => {
      n.append(o, i);
    });
  }), n;
}
let Sg = null;
function wie() {
  if (Sg === null)
    try {
      new FormData(
        document.createElement("form"),
        // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0
      ), Sg = !1;
    } catch {
      Sg = !0;
    }
  return Sg;
}
const Cie = /* @__PURE__ */ new Set(["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"]);
function ww(e) {
  return e != null && !Cie.has(e) ? (process.env.NODE_ENV !== "production" && Hr(!1, '"' + e + '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` ' + ('and will default to "' + zg + '"')), null) : e;
}
function xie(e, t) {
  let n, r, o, i, a;
  if (gie(e)) {
    let l = e.getAttribute("action");
    r = l ? pi(l, t) : null, n = e.getAttribute("method") || Ug, o = ww(e.getAttribute("enctype")) || zg, i = new FormData(e);
  } else if (hie(e) || mie(e) && (e.type === "submit" || e.type === "image")) {
    let l = e.form;
    if (l == null)
      throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
    let c = e.getAttribute("formaction") || l.getAttribute("action");
    if (r = c ? pi(c, t) : null, n = e.getAttribute("formmethod") || l.getAttribute("method") || Ug, o = ww(e.getAttribute("formenctype")) || ww(l.getAttribute("enctype")) || zg, i = new FormData(l, e), !wie()) {
      let {
        name: d,
        type: f,
        value: p
      } = e;
      if (f === "image") {
        let g = d ? d + "." : "";
        i.append(g + "x", "0"), i.append(g + "y", "0");
      } else d && i.append(d, p);
    }
  } else {
    if (qb(e))
      throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    n = Ug, r = null, o = zg, a = e;
  }
  return i && o === "text/plain" && (a = i, i = void 0), {
    action: r,
    method: n.toLowerCase(),
    encType: o,
    formData: i,
    body: a
  };
}
const Sie = ["onClick", "relative", "reloadDocument", "replace", "state", "target", "to", "preventScrollReset", "viewTransition"], Eie = ["aria-current", "caseSensitive", "className", "end", "style", "to", "viewTransition", "children"], Tie = ["fetcherKey", "navigate", "reloadDocument", "replace", "state", "method", "action", "onSubmit", "relative", "preventScrollReset", "viewTransition"], Oie = "6";
try {
  window.__reactRouterVersion = Oie;
} catch {
}
function Pie(e, t) {
  return Poe({
    basename: t == null ? void 0 : t.basename,
    future: xl({}, t == null ? void 0 : t.future, {
      v7_prependBasename: !0
    }),
    history: Xre({
      window: t == null ? void 0 : t.window
    }),
    hydrationData: (t == null ? void 0 : t.hydrationData) || Iie(),
    routes: e,
    mapRouteProperties: pie,
    dataStrategy: t == null ? void 0 : t.dataStrategy,
    patchRoutesOnNavigation: t == null ? void 0 : t.patchRoutesOnNavigation,
    window: t == null ? void 0 : t.window
  }).initialize();
}
function Iie() {
  var e;
  let t = (e = window) == null ? void 0 : e.__staticRouterHydrationData;
  return t && t.errors && (t = xl({}, t, {
    errors: Rie(t.errors)
  })), t;
}
function Rie(e) {
  if (!e) return null;
  let t = Object.entries(e), n = {};
  for (let [r, o] of t)
    if (o && o.__type === "RouteErrorResponse")
      n[r] = new xm(o.status, o.statusText, o.data, o.internal === !0);
    else if (o && o.__type === "Error") {
      if (o.__subType) {
        let i = window[o.__subType];
        if (typeof i == "function")
          try {
            let a = new i(o.message);
            a.stack = "", n[r] = a;
          } catch {
          }
      }
      if (n[r] == null) {
        let i = new Error(o.message);
        i.stack = "", n[r] = i;
      }
    } else
      n[r] = o;
  return n;
}
const oS = /* @__PURE__ */ m.createContext({
  isTransitioning: !1
});
process.env.NODE_ENV !== "production" && (oS.displayName = "ViewTransition");
const LD = /* @__PURE__ */ m.createContext(/* @__PURE__ */ new Map());
process.env.NODE_ENV !== "production" && (LD.displayName = "Fetchers");
const _ie = "startTransition", II = m[_ie], kie = "flushSync", RI = xC[kie];
function Mie(e) {
  II ? II(e) : e();
}
function wf(e) {
  RI ? RI(e) : e();
}
class Aie {
  constructor() {
    this.status = "pending", this.promise = new Promise((t, n) => {
      this.resolve = (r) => {
        this.status === "pending" && (this.status = "resolved", t(r));
      }, this.reject = (r) => {
        this.status === "pending" && (this.status = "rejected", n(r));
      };
    });
  }
}
function Die(e) {
  let {
    fallbackElement: t,
    router: n,
    future: r
  } = e, [o, i] = m.useState(n.state), [a, l] = m.useState(), [c, d] = m.useState({
    isTransitioning: !1
  }), [f, p] = m.useState(), [g, b] = m.useState(), [v, y] = m.useState(), S = m.useRef(/* @__PURE__ */ new Map()), {
    v7_startTransition: E
  } = r || {}, I = m.useCallback((A) => {
    E ? Mie(A) : A();
  }, [E]), O = m.useCallback((A, _) => {
    let {
      deletedFetchers: C,
      flushSync: D,
      viewTransitionOpts: L
    } = _;
    C.forEach((H) => S.current.delete(H)), A.fetchers.forEach((H, k) => {
      H.data !== void 0 && S.current.set(k, H.data);
    });
    let B = n.window == null || n.window.document == null || typeof n.window.document.startViewTransition != "function";
    if (!L || B) {
      D ? wf(() => i(A)) : I(() => i(A));
      return;
    }
    if (D) {
      wf(() => {
        g && (f && f.resolve(), g.skipTransition()), d({
          isTransitioning: !0,
          flushSync: !0,
          currentLocation: L.currentLocation,
          nextLocation: L.nextLocation
        });
      });
      let H = n.window.document.startViewTransition(() => {
        wf(() => i(A));
      });
      H.finished.finally(() => {
        wf(() => {
          p(void 0), b(void 0), l(void 0), d({
            isTransitioning: !1
          });
        });
      }), wf(() => b(H));
      return;
    }
    g ? (f && f.resolve(), g.skipTransition(), y({
      state: A,
      currentLocation: L.currentLocation,
      nextLocation: L.nextLocation
    })) : (l(A), d({
      isTransitioning: !0,
      flushSync: !1,
      currentLocation: L.currentLocation,
      nextLocation: L.nextLocation
    }));
  }, [n.window, g, f, S, I]);
  m.useLayoutEffect(() => n.subscribe(O), [n, O]), m.useEffect(() => {
    c.isTransitioning && !c.flushSync && p(new Aie());
  }, [c]), m.useEffect(() => {
    if (f && a && n.window) {
      let A = a, _ = f.promise, C = n.window.document.startViewTransition(async () => {
        I(() => i(A)), await _;
      });
      C.finished.finally(() => {
        p(void 0), b(void 0), l(void 0), d({
          isTransitioning: !1
        });
      }), b(C);
    }
  }, [I, a, f, n.window]), m.useEffect(() => {
    f && a && o.location.key === a.location.key && f.resolve();
  }, [f, g, o.location, a]), m.useEffect(() => {
    !c.isTransitioning && v && (l(v.state), d({
      isTransitioning: !0,
      flushSync: !1,
      currentLocation: v.currentLocation,
      nextLocation: v.nextLocation
    }), y(void 0));
  }, [c.isTransitioning, v]), m.useEffect(() => {
    process.env.NODE_ENV !== "production" && Hr(t == null || !n.future.v7_partialHydration, "`<RouterProvider fallbackElement>` is deprecated when using `v7_partialHydration`, use a `HydrateFallback` component instead");
  }, []);
  let T = m.useMemo(() => ({
    createHref: n.createHref,
    encodeLocation: n.encodeLocation,
    go: (A) => n.navigate(A),
    push: (A, _, C) => n.navigate(A, {
      state: _,
      preventScrollReset: C == null ? void 0 : C.preventScrollReset
    }),
    replace: (A, _, C) => n.navigate(A, {
      replace: !0,
      state: _,
      preventScrollReset: C == null ? void 0 : C.preventScrollReset
    })
  }), [n]), P = n.basename || "/", R = m.useMemo(() => ({
    router: n,
    navigator: T,
    static: !1,
    basename: P
  }), [n, T, P]), F = m.useMemo(() => ({
    v7_relativeSplatPath: n.future.v7_relativeSplatPath
  }), [n.future.v7_relativeSplatPath]);
  return m.useEffect(() => die(r, n.future), [r, n.future]), /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(kd.Provider, {
    value: R
  }, /* @__PURE__ */ m.createElement(Gb.Provider, {
    value: o
  }, /* @__PURE__ */ m.createElement(LD.Provider, {
    value: S.current
  }, /* @__PURE__ */ m.createElement(oS.Provider, {
    value: c
  }, /* @__PURE__ */ m.createElement(fie, {
    basename: P,
    location: o.location,
    navigationType: o.historyAction,
    navigator: T,
    future: F
  }, o.initialized || n.future.v7_partialHydration ? /* @__PURE__ */ m.createElement(Nie, {
    routes: n.routes,
    future: n.future,
    state: o
  }) : t))))), null);
}
const Nie = /* @__PURE__ */ m.memo(Fie);
function Fie(e) {
  let {
    routes: t,
    future: n,
    state: r
  } = e;
  return Joe(t, void 0, r, n);
}
process.env.NODE_ENV;
const $ie = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Lie = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, jD = /* @__PURE__ */ m.forwardRef(function(t, n) {
  let {
    onClick: r,
    relative: o,
    reloadDocument: i,
    replace: a,
    state: l,
    target: c,
    to: d,
    preventScrollReset: f,
    viewTransition: p
  } = t, g = rS(t, Sie), {
    basename: b
  } = m.useContext(us), v, y = !1;
  if (typeof d == "string" && Lie.test(d) && (v = d, $ie))
    try {
      let O = new URL(window.location.href), T = d.startsWith("//") ? new URL(O.protocol + d) : new URL(d), P = pi(T.pathname, b);
      T.origin === O.origin && P != null ? d = P + T.search + T.hash : y = !0;
    } catch {
      process.env.NODE_ENV !== "production" && Hr(!1, '<Link to="' + d + '"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.');
    }
  let S = Koe(d, {
    relative: o
  }), E = Hie(d, {
    replace: a,
    state: l,
    target: c,
    preventScrollReset: f,
    relative: o,
    viewTransition: p
  });
  function I(O) {
    r && r(O), O.defaultPrevented || E(O);
  }
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ m.createElement("a", xl({}, g, {
      href: v || S,
      onClick: y || i ? r : I,
      ref: n,
      target: c
    }))
  );
});
process.env.NODE_ENV !== "production" && (jD.displayName = "Link");
const jie = /* @__PURE__ */ m.forwardRef(function(t, n) {
  let {
    "aria-current": r = "page",
    caseSensitive: o = !1,
    className: i = "",
    end: a = !1,
    style: l,
    to: c,
    viewTransition: d,
    children: f
  } = t, p = rS(t, Eie), g = ih(c, {
    relative: p.relative
  }), b = Ml(), v = m.useContext(Gb), {
    navigator: y,
    basename: S
  } = m.useContext(us), E = v != null && // Conditional usage is OK here because the usage of a data router is static
  // eslint-disable-next-line react-hooks/rules-of-hooks
  Yie(g) && d === !0, I = y.encodeLocation ? y.encodeLocation(g).pathname : g.pathname, O = b.pathname, T = v && v.navigation && v.navigation.location ? v.navigation.location.pathname : null;
  o || (O = O.toLowerCase(), T = T ? T.toLowerCase() : null, I = I.toLowerCase()), T && S && (T = pi(T, S) || T);
  const P = I !== "/" && I.endsWith("/") ? I.length - 1 : I.length;
  let R = O === I || !a && O.startsWith(I) && O.charAt(P) === "/", F = T != null && (T === I || !a && T.startsWith(I) && T.charAt(I.length) === "/"), A = {
    isActive: R,
    isPending: F,
    isTransitioning: E
  }, _ = R ? r : void 0, C;
  typeof i == "function" ? C = i(A) : C = [i, R ? "active" : null, F ? "pending" : null, E ? "transitioning" : null].filter(Boolean).join(" ");
  let D = typeof l == "function" ? l(A) : l;
  return /* @__PURE__ */ m.createElement(jD, xl({}, p, {
    "aria-current": _,
    className: C,
    ref: n,
    style: D,
    to: c,
    viewTransition: d
  }), typeof f == "function" ? f(A) : f);
});
process.env.NODE_ENV !== "production" && (jie.displayName = "NavLink");
const Bie = /* @__PURE__ */ m.forwardRef((e, t) => {
  let {
    fetcherKey: n,
    navigate: r,
    reloadDocument: o,
    replace: i,
    state: a,
    method: l = Ug,
    action: c,
    onSubmit: d,
    relative: f,
    preventScrollReset: p,
    viewTransition: g
  } = e, b = rS(e, Tie), v = qie(), y = Kie(c, {
    relative: f
  }), S = l.toLowerCase() === "get" ? "get" : "post", E = (I) => {
    if (d && d(I), I.defaultPrevented) return;
    I.preventDefault();
    let O = I.nativeEvent.submitter, T = (O == null ? void 0 : O.getAttribute("formmethod")) || l;
    v(O || I.currentTarget, {
      fetcherKey: n,
      method: T,
      navigate: r,
      replace: i,
      state: a,
      relative: f,
      preventScrollReset: p,
      viewTransition: g
    });
  };
  return /* @__PURE__ */ m.createElement("form", xl({
    ref: t,
    method: S,
    action: y,
    onSubmit: o ? d : E
  }, b));
});
process.env.NODE_ENV !== "production" && (Bie.displayName = "Form");
process.env.NODE_ENV;
var Sm;
(function(e) {
  e.UseScrollRestoration = "useScrollRestoration", e.UseSubmit = "useSubmit", e.UseSubmitFetcher = "useSubmitFetcher", e.UseFetcher = "useFetcher", e.useViewTransitionState = "useViewTransitionState";
})(Sm || (Sm = {}));
var _I;
(function(e) {
  e.UseFetcher = "useFetcher", e.UseFetchers = "useFetchers", e.UseScrollRestoration = "useScrollRestoration";
})(_I || (_I = {}));
function Vie(e) {
  return e + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function BD(e) {
  let t = m.useContext(kd);
  return t || (process.env.NODE_ENV !== "production" ? Pt(!1, Vie(e)) : Pt(!1)), t;
}
function Hie(e, t) {
  let {
    target: n,
    replace: r,
    state: o,
    preventScrollReset: i,
    relative: a,
    viewTransition: l
  } = t === void 0 ? {} : t, c = Md(), d = Ml(), f = ih(e, {
    relative: a
  });
  return m.useCallback((p) => {
    if (yie(p, n)) {
      p.preventDefault();
      let g = r !== void 0 ? r : Cl(d) === Cl(f);
      c(e, {
        replace: g,
        state: o,
        preventScrollReset: i,
        relative: a,
        viewTransition: l
      });
    }
  }, [d, c, f, r, o, n, e, i, a, l]);
}
function Uie(e) {
  process.env.NODE_ENV !== "production" && Hr(typeof URLSearchParams < "u", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
  let t = m.useRef(Q0(e)), n = m.useRef(!1), r = Ml(), o = m.useMemo(() => (
    // Only merge in the defaults if we haven't yet called setSearchParams.
    // Once we call that we want those to take precedence, otherwise you can't
    // remove a param with setSearchParams({}) if it has an initial value
    vie(r.search, n.current ? null : t.current)
  ), [r.search]), i = Md(), a = m.useCallback((l, c) => {
    const d = Q0(typeof l == "function" ? l(o) : l);
    n.current = !0, i("?" + d, c);
  }, [i, o]);
  return [o, a];
}
function zie() {
  if (typeof document > "u")
    throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let Gie = 0, Wie = () => "__" + String(++Gie) + "__";
function qie() {
  let {
    router: e
  } = BD(Sm.UseSubmit), {
    basename: t
  } = m.useContext(us), n = iie();
  return m.useCallback(function(r, o) {
    o === void 0 && (o = {}), zie();
    let {
      action: i,
      method: a,
      encType: l,
      formData: c,
      body: d
    } = xie(r, t);
    if (o.navigate === !1) {
      let f = o.fetcherKey || Wie();
      e.fetch(f, n, o.action || i, {
        preventScrollReset: o.preventScrollReset,
        formData: c,
        body: d,
        formMethod: o.method || a,
        formEncType: o.encType || l,
        flushSync: o.flushSync
      });
    } else
      e.navigate(o.action || i, {
        preventScrollReset: o.preventScrollReset,
        formData: c,
        body: d,
        formMethod: o.method || a,
        formEncType: o.encType || l,
        replace: o.replace,
        state: o.state,
        fromRouteId: n,
        flushSync: o.flushSync,
        viewTransition: o.viewTransition
      });
  }, [e, t, n]);
}
function Kie(e, t) {
  let {
    relative: n
  } = t === void 0 ? {} : t, {
    basename: r
  } = m.useContext(us), o = m.useContext(qs);
  o || (process.env.NODE_ENV !== "production" ? Pt(!1, "useFormAction must be used inside a RouteContext") : Pt(!1));
  let [i] = o.matches.slice(-1), a = xl({}, ih(e || ".", {
    relative: n
  })), l = Ml();
  if (e == null) {
    a.search = l.search;
    let c = new URLSearchParams(a.search), d = c.getAll("index");
    if (d.some((p) => p === "")) {
      c.delete("index"), d.filter((g) => g).forEach((g) => c.append("index", g));
      let p = c.toString();
      a.search = p ? "?" + p : "";
    }
  }
  return (!e || e === ".") && i.route.index && (a.search = a.search ? a.search.replace(/^\?/, "?index&") : "?index"), r !== "/" && (a.pathname = a.pathname === "/" ? r : $s([r, a.pathname])), Cl(a);
}
function Yie(e, t) {
  t === void 0 && (t = {});
  let n = m.useContext(oS);
  n == null && (process.env.NODE_ENV !== "production" ? Pt(!1, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?") : Pt(!1));
  let {
    basename: r
  } = BD(Sm.useViewTransitionState), o = ih(e, {
    relative: t.relative
  });
  if (!n.isTransitioning)
    return !1;
  let i = pi(n.currentLocation.pathname, r) || n.currentLocation.pathname, a = pi(n.nextLocation.pathname, r) || n.nextLocation.pathname;
  return Cm(o.pathname, a) != null || Cm(o.pathname, i) != null;
}
Ta("LanguageSelect");
oe($r)(() => ({
  width: "100%",
  flexDirection: "row",
  justifyContent: "end",
  height: "64px",
  alignItems: "center",
  boxShadow: "-3px 0px 3px 2px rgba(0, 0, 0, 0.20), -3px 0px 4px 0px rgba(0, 0, 0, 0.14), -1px 0px 8px 0px rgba(0, 0, 0, 0.12)",
  zIndex: 1
}));
oe($r)(() => ({
  flexDirection: "row",
  height: "32px",
  alignItems: "center"
}));
oe(as)(({ theme: e }) => ({
  height: "36px",
  borderRadius: e.shape.borderRadius * 5,
  backgroundColor: e.cropConnect.palette.grey
}));
function Qie() {
  return /* @__PURE__ */ w.jsxs(
    "svg",
    {
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ w.jsx("g", { clipPath: "url(#clip0_844_3676)", children: /* @__PURE__ */ w.jsx(
          "path",
          {
            d: "M8.75 10.5L5.25 7L8.75 3.5",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "square",
            strokeLinejoin: "round"
          }
        ) }),
        /* @__PURE__ */ w.jsx("defs", { children: /* @__PURE__ */ w.jsx("clipPath", { id: "clip0_844_3676", children: /* @__PURE__ */ w.jsx("rect", { width: "14", height: "14", fill: "white" }) }) })
      ]
    }
  );
}
const Xie = oe(_t)(({ theme: e }) => ({
  display: "flex",
  width: "100%",
  height: "100%",
  overflowY: "auto",
  backgroundColor: e.cropConnect.palette.background.general
})), Jie = oe(as)(({ theme: e }) => ({
  alignSelf: "start",
  marginTop: 0,
  marginBottom: `-${e.spacing(3)}`,
  marginLeft: `-${e.spacing(1)}`
})), Zie = oe($r)(({ theme: e }) => ({
  display: "flex",
  height: "100%",
  width: "100%",
  flexDirection: "column",
  padding: e.spacing(3),
  [e.breakpoints.up("md")]: {
    paddingTop: e.spacing(5)
  },
  gap: e.spacing(2),
  boxSizing: "border-box"
})), ese = oe(_t)(() => ({
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  alignItems: "center"
})), tse = oe(Rt)(({ theme: e }) => ({
  padding: e.spacing(2, 0)
}));
function iS(e) {
  const t = Md();
  return /* @__PURE__ */ w.jsx(Xie, { children: /* @__PURE__ */ w.jsxs(Zie, { "data-testid": "content-container", children: [
    e.backLink && /* @__PURE__ */ w.jsx(
      Jie,
      {
        onClick: () => {
          t(e.backLink.targetPath);
        },
        variant: "text",
        startIcon: /* @__PURE__ */ w.jsx(Qie, {}),
        children: e.backLink.text
      }
    ),
    (e.title || e.actionElement) && /* @__PURE__ */ w.jsxs(ese, { children: [
      /* @__PURE__ */ w.jsx(tse, { variant: "h2", children: e.title ?? "" }),
      e.actionElement
    ] }),
    e.children
  ] }) });
}
const VD = Pc({
  data: null
});
function nse(e) {
  return {
    ...e,
    already_contracted_freie_menge: e.already_contracted_freie_menge ?? 0,
    already_contracted_lieferanspruch: e.already_contracted_lieferanspruch ?? 0,
    available_lieferanspruch: e.available_lieferanspruch ?? 0,
    multi_year_sugar_content: e.multi_year_sugar_content ?? e.default_multi_year_sugar_content,
    multi_year_yield_average: e.multi_year_yield_average ?? e.default_multi_year_yield_average
  };
}
function rse(e) {
  const { dataClient: t } = _d(), { t: n } = jn(), { currentBusinessPartner: r } = rh(), o = (/* @__PURE__ */ new Date()).getFullYear(), i = r == null ? void 0 : r.id, a = Db({
    queryKey: ["contract", i, o],
    queryFn: async () => await t.getAcreageCalculatorData(
      i,
      o
    ),
    enabled: wt(i)
  }), l = pl(() => {
    if (a.isSuccess)
      return {
        data: nse(a.data),
        individualMultiYearValues: {
          sugarContent: wt(
            a.data.multi_year_sugar_content
          ),
          yieldAverage: wt(
            a.data.multi_year_yield_average
          )
        }
      };
  }, [a.isSuccess, a.data]);
  return !a.isFetching && wt(i) ? /* @__PURE__ */ w.jsx(iS, { title: n("acreageCalculator:title", { year: o }), children: a.isError ? /* @__PURE__ */ w.jsx(
    Ub,
    {
      heading: n("acreageCalculator:error.general"),
      message: n("acreageCalculator:error.fetchingDataFailed"),
      children: /* @__PURE__ */ w.jsxs(Rt, { "data-testid": "details", children: [
        " ",
        n("acreageCalculator:error.details", {
          description: a.error.message
        }),
        " "
      ] })
    }
  ) : /* @__PURE__ */ w.jsx(VD.Provider, { value: l, children: e.children }) }) : /* @__PURE__ */ w.jsx(qx, { "data-testid": "loading-element" });
}
const HD = At(/* @__PURE__ */ w.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z"
}), "Info"), sh = oe(
  ({ className: e, ...t }) => /* @__PURE__ */ w.jsx(yx, { ...t, classes: { popper: e }, disableInteractive: !0 })
)(({ theme: e, flavor: t }) => ({
  [`& .${ur.tooltip}`]: {
    backgroundColor: ose(t ?? "default", e),
    borderRadius: e.spacing(2),
    padding: e.spacing(1.5),
    whiteSpace: "pre-wrap"
  }
}));
function ose(e, t) {
  switch (e) {
    case "error":
      return t.palette.error.main;
    case "warning":
      return t.palette.warning.main;
    default:
      return t.palette.primary.dark;
  }
}
const ise = oe(HD)(({ theme: e }) => ({
  color: e.palette.secondary.main,
  borderRadius: "50%",
  boxShadow: `inset 0 0 0 3px ${e.palette.secondary.main}, inset 0 0 0 20px white`
}));
function Kb(e) {
  const [t, n] = Jt(!1), [r, o] = Jt(!1);
  return /* @__PURE__ */ w.jsx(w.Fragment, { children: wt(e.hint) ? /* @__PURE__ */ w.jsx(
    sh,
    {
      title: e.hint,
      placement: wt(e.placement) ? e.placement : "bottom-end",
      open: t || r,
      children: /* @__PURE__ */ w.jsx(
        ise,
        {
          fontSize: "small",
          onClick: () => {
            n(!t), o(!1);
          },
          onMouseEnter: () => o(!0),
          onMouseLeave: () => o(!1)
        }
      )
    }
  ) : null });
}
const sse = oe(_t)(() => ({
  position: "absolute",
  top: "-6px",
  right: "-6px"
})), ase = oe(_t)(() => ({
  flex: 1
}));
function Yb(e) {
  return /* @__PURE__ */ w.jsxs(ase, { "data-testid": "StackInputField", position: "relative", children: [
    e.children,
    /* @__PURE__ */ w.jsx(sse, { children: /* @__PURE__ */ w.jsx(Kb, { hint: e.hint, placement: e.hintPlacement }) })
  ] });
}
function UD(e) {
  return new RegExp(
    `^(-?(([1-9]\\d{0,2}([\\s.]?\\d{3})*)|0))(\\,\\d{0,${e}})?$`
  );
}
function zD(e) {
  return new Intl.NumberFormat("de-DE", e);
}
function lse(e) {
  return Number.isFinite(e);
}
function cse(e) {
  return Number.isInteger(e);
}
function use(e, t) {
  const n = e.toString(), r = n.lastIndexOf("."), o = r >= 0 ? n.slice(r + 1).length : 0;
  return lse(e) && o <= t;
}
function Qb(e, t) {
  const n = e.replaceAll(/\s/g, "");
  if (!UD(t.maximumFractionDigits).test(
    e
  ))
    return Number.NaN;
  const o = n.replaceAll(".", "").replaceAll(",", ".");
  return Number.parseFloat(o);
}
function Ss(e, t) {
  return typeof e == "number" ? e : Qb(
    e,
    {
      maximumFractionDigits: 100
    }
  );
}
function Or(e, t) {
  return zD({
    style: "decimal",
    minimumFractionDigits: cse(e) ? 0 : t.minimumFractionDigits,
    maximumFractionDigits: t.maximumFractionDigits
  }).format(e).replaceAll(".", " ");
}
function GD(e, t) {
  if (typeof e != "number")
    return e;
  let n = Or(e, t);
  return (!t.useThousandsSeparator || e < 1e4) && (n = n.replaceAll(" ", "")), n;
}
function Xb(e) {
  return X0(
    e,
    dse
  );
}
function dse(e) {
  return lo(e) ? "" : e;
}
function X0(e, t) {
  return Object.fromEntries(
    Object.entries(e).map(([n, r]) => Array.isArray(r) ? [
      n,
      r.map((o) => typeof o == "object" ? X0(o, t) : t(o))
    ] : WX(r) ? [n, X0(r, t)] : [n, t(r)])
  );
}
function fse() {
  return "";
}
function Al(e) {
  return e === fse();
}
const WD = 1500, Jb = "", pse = " ";
function sS(e) {
  if (!lo(e.inputMode))
    return { inputMode: e.inputMode };
}
function aS(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" ? e.toString() : Jb;
}
function hse(e, t) {
  return e.filter((n) => {
    const r = t.inputValue.toLocaleLowerCase().split(" "), o = t.getOptionLabel(n).toLocaleLowerCase();
    return r.every((i) => o.includes(i));
  });
}
function gse(e, t) {
  if (!lo(e.unit))
    return {
      sx: {
        boxShadow: `inset 0 0 0 2px ${t.palette.text.secondary} !important`
      },
      endAdornment: /* @__PURE__ */ w.jsx(bl, { position: "end", children: e.unit })
    };
}
function Ja(e) {
  const t = bo();
  let n = 0, r = 1, o = !0;
  e.inputMode === "decimal" ? (n = e.minimumFractionDigits, r = e.maximumFractionDigits) : o = wt(e.useThousandsSeparator) ? e.useThousandsSeparator : !0;
  const i = sS(e), a = gse(e, t), l = typeof e.textFieldOptions.value == "number" && isNaN(e.textFieldOptions.value) ? Jb : GD(e.textFieldOptions.value, {
    maximumFractionDigits: r,
    minimumFractionDigits: n,
    useThousandsSeparator: o
  });
  return /* @__PURE__ */ w.jsx(Yb, { hint: e.hint, hintPlacement: e.hintPlacement, children: /* @__PURE__ */ w.jsx(
    Ea,
    {
      ...e.textFieldOptions,
      variant: "filled",
      value: l,
      fullWidth: !0,
      disabled: !0,
      helperText: e.textFieldOptions.helperText ?? " ",
      slotProps: {
        input: {
          ...a,
          style: { backgroundColor: "white" },
          disableUnderline: !0
        },
        htmlInput: i
      },
      sx: {
        ".Mui-disabled": {
          color: t.palette.text.secondary,
          WebkitTextFillColor: t.palette.text.secondary
        }
      }
    }
  ) });
}
var ah = (e) => e.type === "checkbox", ku = (e) => e instanceof Date, Eo = (e) => e == null;
const qD = (e) => typeof e == "object";
var Ur = (e) => !Eo(e) && !Array.isArray(e) && qD(e) && !ku(e), KD = (e) => Ur(e) && e.target ? ah(e.target) ? e.target.checked : e.target.value : e, mse = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, YD = (e, t) => e.has(mse(t)), bse = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Ur(t) && t.hasOwnProperty("isPrototypeOf");
}, lS = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Fo(e) {
  let t;
  const n = Array.isArray(e);
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(lS && (e instanceof Blob || e instanceof FileList)) && (n || Ur(e)))
    if (t = n ? [] : {}, !n && !bse(e))
      t = e;
    else
      for (const r in e)
        e.hasOwnProperty(r) && (t[r] = Fo(e[r]));
  else
    return e;
  return t;
}
var lh = (e) => Array.isArray(e) ? e.filter(Boolean) : [], wr = (e) => e === void 0, rt = (e, t, n) => {
  if (!t || !Ur(e))
    return n;
  const r = lh(t.split(/[,[\].]+?/)).reduce((o, i) => Eo(o) ? o : o[i], e);
  return wr(r) || r === e ? wr(e[t]) ? n : e[t] : r;
}, _s = (e) => typeof e == "boolean", cS = (e) => /^\w*$/.test(e), QD = (e) => lh(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Wn = (e, t, n) => {
  let r = -1;
  const o = cS(t) ? [t] : QD(t), i = o.length, a = i - 1;
  for (; ++r < i; ) {
    const l = o[r];
    let c = n;
    if (r !== a) {
      const d = e[l];
      c = Ur(d) || Array.isArray(d) ? d : isNaN(+o[r + 1]) ? {} : [];
    }
    if (l === "__proto__")
      return;
    e[l] = c, e = e[l];
  }
  return e;
};
const Em = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, es = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, aa = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, yse = en.createContext(null), uS = () => en.useContext(yse);
var XD = (e, t, n, r = !0) => {
  const o = {
    defaultValues: t._defaultValues
  };
  for (const i in e)
    Object.defineProperty(o, i, {
      get: () => {
        const a = i;
        return t._proxyFormState[a] !== es.all && (t._proxyFormState[a] = !r || es.all), n && (n[a] = !0), e[a];
      }
    });
  return o;
}, ni = (e) => Ur(e) && !Object.keys(e).length, JD = (e, t, n, r) => {
  n(e);
  const { name: o, ...i } = e;
  return ni(i) || Object.keys(i).length >= Object.keys(t).length || Object.keys(i).find((a) => t[a] === (!r || es.all));
}, Gg = (e) => Array.isArray(e) ? e : [e], ZD = (e, t, n) => !e || !t || e === t || Gg(e).some((r) => r && (n ? r === t : r.startsWith(t) || t.startsWith(r)));
function dS(e) {
  const t = en.useRef(e);
  t.current = e, en.useEffect(() => {
    const n = !e.disabled && t.current.subject && t.current.subject.subscribe({
      next: t.current.next
    });
    return () => {
      n && n.unsubscribe();
    };
  }, [e.disabled]);
}
function vse(e) {
  const t = uS(), { control: n = t.control, disabled: r, name: o, exact: i } = e || {}, [a, l] = en.useState(n._formState), c = en.useRef(!0), d = en.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), f = en.useRef(o);
  return f.current = o, dS({
    disabled: r,
    next: (p) => c.current && ZD(f.current, p.name, i) && JD(p, d.current, n._updateFormState) && l({
      ...n._formState,
      ...p
    }),
    subject: n._subjects.state
  }), en.useEffect(() => (c.current = !0, d.current.isValid && n._updateValid(!0), () => {
    c.current = !1;
  }), [n]), XD(a, n, d.current, !1);
}
var Ms = (e) => typeof e == "string", eN = (e, t, n, r, o) => Ms(e) ? (r && t.watch.add(e), rt(n, e, o)) : Array.isArray(e) ? e.map((i) => (r && t.watch.add(i), rt(n, i))) : (r && (t.watchAll = !0), n);
function wse(e) {
  const t = uS(), { control: n = t.control, name: r, defaultValue: o, disabled: i, exact: a } = e || {}, l = en.useRef(r);
  l.current = r, dS({
    disabled: i,
    subject: n._subjects.values,
    next: (f) => {
      ZD(l.current, f.name, a) && d(Fo(eN(l.current, n._names, f.values || n._formValues, !1, o)));
    }
  });
  const [c, d] = en.useState(n._getWatch(r, o));
  return en.useEffect(() => n._removeUnmounted()), c;
}
function Cse(e) {
  const t = uS(), { name: n, disabled: r, control: o = t.control, shouldUnregister: i } = e, a = YD(o._names.array, n), l = wse({
    control: o,
    name: n,
    defaultValue: rt(o._formValues, n, rt(o._defaultValues, n, e.defaultValue)),
    exact: !0
  }), c = vse({
    control: o,
    name: n
  }), d = en.useRef(o.register(n, {
    ...e.rules,
    value: l,
    ..._s(e.disabled) ? { disabled: e.disabled } : {}
  }));
  return en.useEffect(() => {
    const f = o._options.shouldUnregister || i, p = (g, b) => {
      const v = rt(o._fields, g);
      v && (v._f.mount = b);
    };
    if (p(n, !0), f) {
      const g = Fo(rt(o._options.defaultValues, n));
      Wn(o._defaultValues, n, g), wr(rt(o._formValues, n)) && Wn(o._formValues, n, g);
    }
    return () => {
      (a ? f && !o._state.action : f) ? o.unregister(n) : p(n, !1);
    };
  }, [n, o, a, i]), en.useEffect(() => {
    rt(o._fields, n) && o._updateDisabledField({
      disabled: r,
      fields: o._fields,
      name: n,
      value: rt(o._fields, n)._f.value
    });
  }, [r, n, o]), {
    field: {
      name: n,
      value: l,
      ..._s(r) || c.disabled ? { disabled: c.disabled || r } : {},
      onChange: en.useCallback((f) => d.current.onChange({
        target: {
          value: KD(f),
          name: n
        },
        type: Em.CHANGE
      }), [n]),
      onBlur: en.useCallback(() => d.current.onBlur({
        target: {
          value: rt(o._formValues, n),
          name: n
        },
        type: Em.BLUR
      }), [n, o]),
      ref: (f) => {
        const p = rt(o._fields, n);
        p && f && (p._f.ref = {
          focus: () => f.focus(),
          select: () => f.select(),
          setCustomValidity: (g) => f.setCustomValidity(g),
          reportValidity: () => f.reportValidity()
        });
      }
    },
    formState: c,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!rt(c.errors, n)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!rt(c.dirtyFields, n)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!rt(c.touchedFields, n)
      },
      isValidating: {
        enumerable: !0,
        get: () => !!rt(c.validatingFields, n)
      },
      error: {
        enumerable: !0,
        get: () => rt(c.errors, n)
      }
    })
  };
}
var xse = (e, t, n, r, o) => t ? {
  ...n[e],
  types: {
    ...n[e] && n[e].types ? n[e].types : {},
    [r]: o || !0
  }
} : {}, kI = (e) => ({
  isOnSubmit: !e || e === es.onSubmit,
  isOnBlur: e === es.onBlur,
  isOnChange: e === es.onChange,
  isOnAll: e === es.all,
  isOnTouch: e === es.onTouched
}), MI = (e, t, n) => !n && (t.watchAll || t.watch.has(e) || [...t.watch].some((r) => e.startsWith(r) && /^\.\w+/.test(e.slice(r.length))));
const Wf = (e, t, n, r) => {
  for (const o of n || Object.keys(e)) {
    const i = rt(e, o);
    if (i) {
      const { _f: a, ...l } = i;
      if (a) {
        if (a.refs && a.refs[0] && t(a.refs[0], o) && !r)
          break;
        if (a.ref && t(a.ref, a.name) && !r)
          break;
        Wf(l, t);
      } else Ur(l) && Wf(l, t);
    }
  }
};
var Sse = (e, t, n) => {
  const r = lh(rt(e, n));
  return Wn(r, "root", t[n]), Wn(e, n, r), e;
}, fS = (e) => e.type === "file", ll = (e) => typeof e == "function", Tm = (e) => {
  if (!lS)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, Wg = (e) => Ms(e), pS = (e) => e.type === "radio", Om = (e) => e instanceof RegExp;
const AI = {
  value: !1,
  isValid: !1
}, DI = { value: !0, isValid: !0 };
var tN = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((n) => n && n.checked && !n.disabled).map((n) => n.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !wr(e[0].attributes.value) ? wr(e[0].value) || e[0].value === "" ? DI : { value: e[0].value, isValid: !0 } : DI
    ) : AI;
  }
  return AI;
};
const NI = {
  isValid: !1,
  value: null
};
var nN = (e) => Array.isArray(e) ? e.reduce((t, n) => n && n.checked && !n.disabled ? {
  isValid: !0,
  value: n.value
} : t, NI) : NI;
function FI(e, t, n = "validate") {
  if (Wg(e) || Array.isArray(e) && e.every(Wg) || _s(e) && !e)
    return {
      type: n,
      message: Wg(e) ? e : "",
      ref: t
    };
}
var mu = (e) => Ur(e) && !Om(e) ? e : {
  value: e,
  message: ""
}, $I = async (e, t, n, r, o) => {
  const { ref: i, refs: a, required: l, maxLength: c, minLength: d, min: f, max: p, pattern: g, validate: b, name: v, valueAsNumber: y, mount: S, disabled: E } = e._f, I = rt(t, v);
  if (!S || E)
    return {};
  const O = a ? a[0] : i, T = (L) => {
    r && O.reportValidity && (O.setCustomValidity(_s(L) ? "" : L || ""), O.reportValidity());
  }, P = {}, R = pS(i), F = ah(i), A = R || F, _ = (y || fS(i)) && wr(i.value) && wr(I) || Tm(i) && i.value === "" || I === "" || Array.isArray(I) && !I.length, C = xse.bind(null, v, n, P), D = (L, B, H, k = aa.maxLength, N = aa.minLength) => {
    const j = L ? B : H;
    P[v] = {
      type: L ? k : N,
      message: j,
      ref: i,
      ...C(L ? k : N, j)
    };
  };
  if (o ? !Array.isArray(I) || !I.length : l && (!A && (_ || Eo(I)) || _s(I) && !I || F && !tN(a).isValid || R && !nN(a).isValid)) {
    const { value: L, message: B } = Wg(l) ? { value: !!l, message: l } : mu(l);
    if (L && (P[v] = {
      type: aa.required,
      message: B,
      ref: O,
      ...C(aa.required, B)
    }, !n))
      return T(B), P;
  }
  if (!_ && (!Eo(f) || !Eo(p))) {
    let L, B;
    const H = mu(p), k = mu(f);
    if (!Eo(I) && !isNaN(I)) {
      const N = i.valueAsNumber || I && +I;
      Eo(H.value) || (L = N > H.value), Eo(k.value) || (B = N < k.value);
    } else {
      const N = i.valueAsDate || new Date(I), j = ($) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + $), W = i.type == "time", V = i.type == "week";
      Ms(H.value) && I && (L = W ? j(I) > j(H.value) : V ? I > H.value : N > new Date(H.value)), Ms(k.value) && I && (B = W ? j(I) < j(k.value) : V ? I < k.value : N < new Date(k.value));
    }
    if ((L || B) && (D(!!L, H.message, k.message, aa.max, aa.min), !n))
      return T(P[v].message), P;
  }
  if ((c || d) && !_ && (Ms(I) || o && Array.isArray(I))) {
    const L = mu(c), B = mu(d), H = !Eo(L.value) && I.length > +L.value, k = !Eo(B.value) && I.length < +B.value;
    if ((H || k) && (D(H, L.message, B.message), !n))
      return T(P[v].message), P;
  }
  if (g && !_ && Ms(I)) {
    const { value: L, message: B } = mu(g);
    if (Om(L) && !I.match(L) && (P[v] = {
      type: aa.pattern,
      message: B,
      ref: i,
      ...C(aa.pattern, B)
    }, !n))
      return T(B), P;
  }
  if (b) {
    if (ll(b)) {
      const L = await b(I, t), B = FI(L, O);
      if (B && (P[v] = {
        ...B,
        ...C(aa.validate, B.message)
      }, !n))
        return T(B.message), P;
    } else if (Ur(b)) {
      let L = {};
      for (const B in b) {
        if (!ni(L) && !n)
          break;
        const H = FI(await b[B](I, t), O, B);
        H && (L = {
          ...H,
          ...C(B, H.message)
        }, T(H.message), n && (P[v] = L));
      }
      if (!ni(L) && (P[v] = {
        ref: O,
        ...L
      }, !n))
        return P;
    }
  }
  return T(!0), P;
};
function Ese(e, t) {
  const n = t.slice(0, -1).length;
  let r = 0;
  for (; r < n; )
    e = wr(e) ? r++ : e[t[r++]];
  return e;
}
function Tse(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !wr(e[t]))
      return !1;
  return !0;
}
function Vr(e, t) {
  const n = Array.isArray(t) ? t : cS(t) ? [t] : QD(t), r = n.length === 1 ? e : Ese(e, n), o = n.length - 1, i = n[o];
  return r && delete r[i], o !== 0 && (Ur(r) && ni(r) || Array.isArray(r) && Tse(r)) && Vr(e, n.slice(0, -1)), e;
}
var Cw = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (o) => {
      for (const i of e)
        i.next && i.next(o);
    },
    subscribe: (o) => (e.push(o), {
      unsubscribe: () => {
        e = e.filter((i) => i !== o);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Pm = (e) => Eo(e) || !qD(e);
function oc(e, t) {
  if (Pm(e) || Pm(t))
    return e === t;
  if (ku(e) && ku(t))
    return e.getTime() === t.getTime();
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  for (const o of n) {
    const i = e[o];
    if (!r.includes(o))
      return !1;
    if (o !== "ref") {
      const a = t[o];
      if (ku(i) && ku(a) || Ur(i) && Ur(a) || Array.isArray(i) && Array.isArray(a) ? !oc(i, a) : i !== a)
        return !1;
    }
  }
  return !0;
}
var rN = (e) => e.type === "select-multiple", Ose = (e) => pS(e) || ah(e), xw = (e) => Tm(e) && e.isConnected, oN = (e) => {
  for (const t in e)
    if (ll(e[t]))
      return !0;
  return !1;
};
function Im(e, t = {}) {
  const n = Array.isArray(e);
  if (Ur(e) || n)
    for (const r in e)
      Array.isArray(e[r]) || Ur(e[r]) && !oN(e[r]) ? (t[r] = Array.isArray(e[r]) ? [] : {}, Im(e[r], t[r])) : Eo(e[r]) || (t[r] = !0);
  return t;
}
function iN(e, t, n) {
  const r = Array.isArray(e);
  if (Ur(e) || r)
    for (const o in e)
      Array.isArray(e[o]) || Ur(e[o]) && !oN(e[o]) ? wr(t) || Pm(n[o]) ? n[o] = Array.isArray(e[o]) ? Im(e[o], []) : { ...Im(e[o]) } : iN(e[o], Eo(t) ? {} : t[o], n[o]) : n[o] = !oc(e[o], t[o]);
  return n;
}
var Eg = (e, t) => iN(e, t, Im(t)), sN = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: r }) => wr(e) ? e : t ? e === "" ? NaN : e && +e : n && Ms(e) ? new Date(e) : r ? r(e) : e;
function Sw(e) {
  const t = e.ref;
  if (!(e.refs ? e.refs.every((n) => n.disabled) : t.disabled))
    return fS(t) ? t.files : pS(t) ? nN(e.refs).value : rN(t) ? [...t.selectedOptions].map(({ value: n }) => n) : ah(t) ? tN(e.refs).value : sN(wr(t.value) ? e.ref.value : t.value, e);
}
var Pse = (e, t, n, r) => {
  const o = {};
  for (const i of e) {
    const a = rt(t, i);
    a && Wn(o, i, a._f);
  }
  return {
    criteriaMode: n,
    names: [...e],
    fields: o,
    shouldUseNativeValidation: r
  };
}, Cf = (e) => wr(e) ? e : Om(e) ? e.source : Ur(e) ? Om(e.value) ? e.value.source : e.value : e, Ise = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function LI(e, t, n) {
  const r = rt(e, n);
  if (r || cS(n))
    return {
      error: r,
      name: n
    };
  const o = n.split(".");
  for (; o.length; ) {
    const i = o.join("."), a = rt(t, i), l = rt(e, i);
    if (a && !Array.isArray(a) && n !== i)
      return { name: n };
    if (l && l.type)
      return {
        name: i,
        error: l
      };
    o.pop();
  }
  return {
    name: n
  };
}
var Rse = (e, t, n, r, o) => o.isOnAll ? !1 : !n && o.isOnTouch ? !(t || e) : (n ? r.isOnBlur : o.isOnBlur) ? !e : (n ? r.isOnChange : o.isOnChange) ? e : !0, _se = (e, t) => !lh(rt(e, t)).length && Vr(e, t);
const kse = {
  mode: es.onSubmit,
  reValidateMode: es.onChange,
  shouldFocusError: !0
};
function Mse(e = {}) {
  let t = {
    ...kse,
    ...e
  }, n = {
    submitCount: 0,
    isDirty: !1,
    isLoading: ll(t.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1
  }, r = {}, o = Ur(t.defaultValues) || Ur(t.values) ? Fo(t.defaultValues || t.values) || {} : {}, i = t.shouldUnregister ? {} : Fo(o), a = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, c, d = 0;
  const f = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, p = {
    values: Cw(),
    array: Cw(),
    state: Cw()
  }, g = kI(t.mode), b = kI(t.reValidateMode), v = t.criteriaMode === es.all, y = (J) => (fe) => {
    clearTimeout(d), d = setTimeout(J, fe);
  }, S = async (J) => {
    if (f.isValid || J) {
      const fe = t.resolver ? ni((await A()).errors) : await C(r, !0);
      fe !== n.isValid && p.state.next({
        isValid: fe
      });
    }
  }, E = (J, fe) => {
    (f.isValidating || f.validatingFields) && ((J || Array.from(l.mount)).forEach((me) => {
      me && (fe ? Wn(n.validatingFields, me, fe) : Vr(n.validatingFields, me));
    }), p.state.next({
      validatingFields: n.validatingFields,
      isValidating: !ni(n.validatingFields)
    }));
  }, I = (J, fe = [], me, Oe, Ce = !0, Te = !0) => {
    if (Oe && me) {
      if (a.action = !0, Te && Array.isArray(rt(r, J))) {
        const Pe = me(rt(r, J), Oe.argA, Oe.argB);
        Ce && Wn(r, J, Pe);
      }
      if (Te && Array.isArray(rt(n.errors, J))) {
        const Pe = me(rt(n.errors, J), Oe.argA, Oe.argB);
        Ce && Wn(n.errors, J, Pe), _se(n.errors, J);
      }
      if (f.touchedFields && Te && Array.isArray(rt(n.touchedFields, J))) {
        const Pe = me(rt(n.touchedFields, J), Oe.argA, Oe.argB);
        Ce && Wn(n.touchedFields, J, Pe);
      }
      f.dirtyFields && (n.dirtyFields = Eg(o, i)), p.state.next({
        name: J,
        isDirty: L(J, fe),
        dirtyFields: n.dirtyFields,
        errors: n.errors,
        isValid: n.isValid
      });
    } else
      Wn(i, J, fe);
  }, O = (J, fe) => {
    Wn(n.errors, J, fe), p.state.next({
      errors: n.errors
    });
  }, T = (J) => {
    n.errors = J, p.state.next({
      errors: n.errors,
      isValid: !1
    });
  }, P = (J, fe, me, Oe) => {
    const Ce = rt(r, J);
    if (Ce) {
      const Te = rt(i, J, wr(me) ? rt(o, J) : me);
      wr(Te) || Oe && Oe.defaultChecked || fe ? Wn(i, J, fe ? Te : Sw(Ce._f)) : k(J, Te), a.mount && S();
    }
  }, R = (J, fe, me, Oe, Ce) => {
    let Te = !1, Pe = !1;
    const Ye = {
      name: J
    }, Ke = !!(rt(r, J) && rt(r, J)._f.disabled);
    if (!me || Oe) {
      f.isDirty && (Pe = n.isDirty, n.isDirty = Ye.isDirty = L(), Te = Pe !== Ye.isDirty);
      const je = Ke || oc(rt(o, J), fe);
      Pe = !!(!Ke && rt(n.dirtyFields, J)), je || Ke ? Vr(n.dirtyFields, J) : Wn(n.dirtyFields, J, !0), Ye.dirtyFields = n.dirtyFields, Te = Te || f.dirtyFields && Pe !== !je;
    }
    if (me) {
      const je = rt(n.touchedFields, J);
      je || (Wn(n.touchedFields, J, me), Ye.touchedFields = n.touchedFields, Te = Te || f.touchedFields && je !== me);
    }
    return Te && Ce && p.state.next(Ye), Te ? Ye : {};
  }, F = (J, fe, me, Oe) => {
    const Ce = rt(n.errors, J), Te = f.isValid && _s(fe) && n.isValid !== fe;
    if (e.delayError && me ? (c = y(() => O(J, me)), c(e.delayError)) : (clearTimeout(d), c = null, me ? Wn(n.errors, J, me) : Vr(n.errors, J)), (me ? !oc(Ce, me) : Ce) || !ni(Oe) || Te) {
      const Pe = {
        ...Oe,
        ...Te && _s(fe) ? { isValid: fe } : {},
        errors: n.errors,
        name: J
      };
      n = {
        ...n,
        ...Pe
      }, p.state.next(Pe);
    }
  }, A = async (J) => {
    E(J, !0);
    const fe = await t.resolver(i, t.context, Pse(J || l.mount, r, t.criteriaMode, t.shouldUseNativeValidation));
    return E(J), fe;
  }, _ = async (J) => {
    const { errors: fe } = await A(J);
    if (J)
      for (const me of J) {
        const Oe = rt(fe, me);
        Oe ? Wn(n.errors, me, Oe) : Vr(n.errors, me);
      }
    else
      n.errors = fe;
    return fe;
  }, C = async (J, fe, me = {
    valid: !0
  }) => {
    for (const Oe in J) {
      const Ce = J[Oe];
      if (Ce) {
        const { _f: Te, ...Pe } = Ce;
        if (Te) {
          const Ye = l.array.has(Te.name);
          E([Oe], !0);
          const Ke = await $I(Ce, i, v, t.shouldUseNativeValidation && !fe, Ye);
          if (E([Oe]), Ke[Te.name] && (me.valid = !1, fe))
            break;
          !fe && (rt(Ke, Te.name) ? Ye ? Sse(n.errors, Ke, Te.name) : Wn(n.errors, Te.name, Ke[Te.name]) : Vr(n.errors, Te.name));
        }
        Pe && await C(Pe, fe, me);
      }
    }
    return me.valid;
  }, D = () => {
    for (const J of l.unMount) {
      const fe = rt(r, J);
      fe && (fe._f.refs ? fe._f.refs.every((me) => !xw(me)) : !xw(fe._f.ref)) && te(J);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, L = (J, fe) => (J && fe && Wn(i, J, fe), !oc(z(), o)), B = (J, fe, me) => eN(J, l, {
    ...a.mount ? i : wr(fe) ? o : Ms(J) ? { [J]: fe } : fe
  }, me, fe), H = (J) => lh(rt(a.mount ? i : o, J, e.shouldUnregister ? rt(o, J, []) : [])), k = (J, fe, me = {}) => {
    const Oe = rt(r, J);
    let Ce = fe;
    if (Oe) {
      const Te = Oe._f;
      Te && (!Te.disabled && Wn(i, J, sN(fe, Te)), Ce = Tm(Te.ref) && Eo(fe) ? "" : fe, rN(Te.ref) ? [...Te.ref.options].forEach((Pe) => Pe.selected = Ce.includes(Pe.value)) : Te.refs ? ah(Te.ref) ? Te.refs.length > 1 ? Te.refs.forEach((Pe) => (!Pe.defaultChecked || !Pe.disabled) && (Pe.checked = Array.isArray(Ce) ? !!Ce.find((Ye) => Ye === Pe.value) : Ce === Pe.value)) : Te.refs[0] && (Te.refs[0].checked = !!Ce) : Te.refs.forEach((Pe) => Pe.checked = Pe.value === Ce) : fS(Te.ref) ? Te.ref.value = "" : (Te.ref.value = Ce, Te.ref.type || p.values.next({
        name: J,
        values: { ...i }
      })));
    }
    (me.shouldDirty || me.shouldTouch) && R(J, Ce, me.shouldTouch, me.shouldDirty, !0), me.shouldValidate && $(J);
  }, N = (J, fe, me) => {
    for (const Oe in fe) {
      const Ce = fe[Oe], Te = `${J}.${Oe}`, Pe = rt(r, Te);
      (l.array.has(J) || !Pm(Ce) || Pe && !Pe._f) && !ku(Ce) ? N(Te, Ce, me) : k(Te, Ce, me);
    }
  }, j = (J, fe, me = {}) => {
    const Oe = rt(r, J), Ce = l.array.has(J), Te = Fo(fe);
    Wn(i, J, Te), Ce ? (p.array.next({
      name: J,
      values: { ...i }
    }), (f.isDirty || f.dirtyFields) && me.shouldDirty && p.state.next({
      name: J,
      dirtyFields: Eg(o, i),
      isDirty: L(J, Te)
    })) : Oe && !Oe._f && !Eo(Te) ? N(J, Te, me) : k(J, Te, me), MI(J, l) && p.state.next({ ...n }), p.values.next({
      name: a.mount ? J : void 0,
      values: { ...i }
    });
  }, W = async (J) => {
    a.mount = !0;
    const fe = J.target;
    let me = fe.name, Oe = !0;
    const Ce = rt(r, me), Te = () => fe.type ? Sw(Ce._f) : KD(J), Pe = (Ye) => {
      Oe = Number.isNaN(Ye) || Ye === rt(i, me, Ye);
    };
    if (Ce) {
      let Ye, Ke;
      const je = Te(), Qe = J.type === Em.BLUR || J.type === Em.FOCUS_OUT, et = !Ise(Ce._f) && !t.resolver && !rt(n.errors, me) && !Ce._f.deps || Rse(Qe, rt(n.touchedFields, me), n.isSubmitted, b, g), Et = MI(me, l, Qe);
      Wn(i, me, je), Qe ? (Ce._f.onBlur && Ce._f.onBlur(J), c && c(0)) : Ce._f.onChange && Ce._f.onChange(J);
      const Xe = R(me, je, Qe, !1), xt = !ni(Xe) || Et;
      if (!Qe && p.values.next({
        name: me,
        type: J.type,
        values: { ...i }
      }), et)
        return f.isValid && S(), xt && p.state.next({ name: me, ...Et ? {} : Xe });
      if (!Qe && Et && p.state.next({ ...n }), t.resolver) {
        const { errors: tt } = await A([me]);
        if (Pe(je), Oe) {
          const ct = LI(n.errors, r, me), Je = LI(tt, r, ct.name || me);
          Ye = Je.error, me = Je.name, Ke = ni(tt);
        }
      } else
        E([me], !0), Ye = (await $I(Ce, i, v, t.shouldUseNativeValidation))[me], E([me]), Pe(je), Oe && (Ye ? Ke = !1 : f.isValid && (Ke = await C(r, !0)));
      Oe && (Ce._f.deps && $(Ce._f.deps), F(me, Ke, Ye, Xe));
    }
  }, V = (J, fe) => {
    if (rt(n.errors, fe) && J.focus)
      return J.focus(), 1;
  }, $ = async (J, fe = {}) => {
    let me, Oe;
    const Ce = Gg(J);
    if (t.resolver) {
      const Te = await _(wr(J) ? J : Ce);
      me = ni(Te), Oe = J ? !Ce.some((Pe) => rt(Te, Pe)) : me;
    } else J ? (Oe = (await Promise.all(Ce.map(async (Te) => {
      const Pe = rt(r, Te);
      return await C(Pe && Pe._f ? { [Te]: Pe } : Pe);
    }))).every(Boolean), !(!Oe && !n.isValid) && S()) : Oe = me = await C(r);
    return p.state.next({
      ...!Ms(J) || f.isValid && me !== n.isValid ? {} : { name: J },
      ...t.resolver || !J ? { isValid: me } : {},
      errors: n.errors
    }), fe.shouldFocus && !Oe && Wf(r, V, J ? Ce : l.mount), Oe;
  }, z = (J) => {
    const fe = {
      ...a.mount ? i : o
    };
    return wr(J) ? fe : Ms(J) ? rt(fe, J) : J.map((me) => rt(fe, me));
  }, ne = (J, fe) => ({
    invalid: !!rt((fe || n).errors, J),
    isDirty: !!rt((fe || n).dirtyFields, J),
    isTouched: !!rt((fe || n).touchedFields, J),
    isValidating: !!rt((fe || n).validatingFields, J),
    error: rt((fe || n).errors, J)
  }), K = (J) => {
    J && Gg(J).forEach((fe) => Vr(n.errors, fe)), p.state.next({
      errors: J ? n.errors : {}
    });
  }, Q = (J, fe, me) => {
    const Oe = (rt(r, J, { _f: {} })._f || {}).ref, Ce = rt(n.errors, J) || {}, { ref: Te, message: Pe, type: Ye, ...Ke } = Ce;
    Wn(n.errors, J, {
      ...Ke,
      ...fe,
      ref: Oe
    }), p.state.next({
      name: J,
      errors: n.errors,
      isValid: !1
    }), me && me.shouldFocus && Oe && Oe.focus && Oe.focus();
  }, re = (J, fe) => ll(J) ? p.values.subscribe({
    next: (me) => J(B(void 0, fe), me)
  }) : B(J, fe, !0), te = (J, fe = {}) => {
    for (const me of J ? Gg(J) : l.mount)
      l.mount.delete(me), l.array.delete(me), fe.keepValue || (Vr(r, me), Vr(i, me)), !fe.keepError && Vr(n.errors, me), !fe.keepDirty && Vr(n.dirtyFields, me), !fe.keepTouched && Vr(n.touchedFields, me), !fe.keepIsValidating && Vr(n.validatingFields, me), !t.shouldUnregister && !fe.keepDefaultValue && Vr(o, me);
    p.values.next({
      values: { ...i }
    }), p.state.next({
      ...n,
      ...fe.keepDirty ? { isDirty: L() } : {}
    }), !fe.keepIsValid && S();
  }, ie = ({ disabled: J, name: fe, field: me, fields: Oe, value: Ce }) => {
    if (_s(J) && a.mount || J) {
      const Te = J ? void 0 : wr(Ce) ? Sw(me ? me._f : rt(Oe, fe)._f) : Ce;
      Wn(i, fe, Te), R(fe, Te, !1, !1, !0);
    }
  }, ae = (J, fe = {}) => {
    let me = rt(r, J);
    const Oe = _s(fe.disabled);
    return Wn(r, J, {
      ...me || {},
      _f: {
        ...me && me._f ? me._f : { ref: { name: J } },
        name: J,
        mount: !0,
        ...fe
      }
    }), l.mount.add(J), me ? ie({
      field: me,
      disabled: fe.disabled,
      name: J,
      value: fe.value
    }) : P(J, !0, fe.value), {
      ...Oe ? { disabled: fe.disabled } : {},
      ...t.progressive ? {
        required: !!fe.required,
        min: Cf(fe.min),
        max: Cf(fe.max),
        minLength: Cf(fe.minLength),
        maxLength: Cf(fe.maxLength),
        pattern: Cf(fe.pattern)
      } : {},
      name: J,
      onChange: W,
      onBlur: W,
      ref: (Ce) => {
        if (Ce) {
          ae(J, fe), me = rt(r, J);
          const Te = wr(Ce.value) && Ce.querySelectorAll && Ce.querySelectorAll("input,select,textarea")[0] || Ce, Pe = Ose(Te), Ye = me._f.refs || [];
          if (Pe ? Ye.find((Ke) => Ke === Te) : Te === me._f.ref)
            return;
          Wn(r, J, {
            _f: {
              ...me._f,
              ...Pe ? {
                refs: [
                  ...Ye.filter(xw),
                  Te,
                  ...Array.isArray(rt(o, J)) ? [{}] : []
                ],
                ref: { type: Te.type, name: J }
              } : { ref: Te }
            }
          }), P(J, !1, void 0, Te);
        } else
          me = rt(r, J, {}), me._f && (me._f.mount = !1), (t.shouldUnregister || fe.shouldUnregister) && !(YD(l.array, J) && a.action) && l.unMount.add(J);
      }
    };
  }, ce = () => t.shouldFocusError && Wf(r, V, l.mount), le = (J) => {
    _s(J) && (p.state.next({ disabled: J }), Wf(r, (fe, me) => {
      const Oe = rt(r, me);
      Oe && (fe.disabled = Oe._f.disabled || J, Array.isArray(Oe._f.refs) && Oe._f.refs.forEach((Ce) => {
        Ce.disabled = Oe._f.disabled || J;
      }));
    }, 0, !1));
  }, we = (J, fe) => async (me) => {
    let Oe;
    me && (me.preventDefault && me.preventDefault(), me.persist && me.persist());
    let Ce = Fo(i);
    if (p.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: Te, values: Pe } = await A();
      n.errors = Te, Ce = Pe;
    } else
      await C(r);
    if (Vr(n.errors, "root"), ni(n.errors)) {
      p.state.next({
        errors: {}
      });
      try {
        await J(Ce, me);
      } catch (Te) {
        Oe = Te;
      }
    } else
      fe && await fe({ ...n.errors }, me), ce(), setTimeout(ce);
    if (p.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: ni(n.errors) && !Oe,
      submitCount: n.submitCount + 1,
      errors: n.errors
    }), Oe)
      throw Oe;
  }, q = (J, fe = {}) => {
    rt(r, J) && (wr(fe.defaultValue) ? j(J, Fo(rt(o, J))) : (j(J, fe.defaultValue), Wn(o, J, Fo(fe.defaultValue))), fe.keepTouched || Vr(n.touchedFields, J), fe.keepDirty || (Vr(n.dirtyFields, J), n.isDirty = fe.defaultValue ? L(J, Fo(rt(o, J))) : L()), fe.keepError || (Vr(n.errors, J), f.isValid && S()), p.state.next({ ...n }));
  }, Ee = (J, fe = {}) => {
    const me = J ? Fo(J) : o, Oe = Fo(me), Ce = ni(J), Te = Ce ? o : Oe;
    if (fe.keepDefaultValues || (o = me), !fe.keepValues) {
      if (fe.keepDirtyValues)
        for (const Pe of l.mount)
          rt(n.dirtyFields, Pe) ? Wn(Te, Pe, rt(i, Pe)) : j(Pe, rt(Te, Pe));
      else {
        if (lS && wr(J))
          for (const Pe of l.mount) {
            const Ye = rt(r, Pe);
            if (Ye && Ye._f) {
              const Ke = Array.isArray(Ye._f.refs) ? Ye._f.refs[0] : Ye._f.ref;
              if (Tm(Ke)) {
                const je = Ke.closest("form");
                if (je) {
                  je.reset();
                  break;
                }
              }
            }
          }
        r = {};
      }
      i = e.shouldUnregister ? fe.keepDefaultValues ? Fo(o) : {} : Fo(Te), p.array.next({
        values: { ...Te }
      }), p.values.next({
        values: { ...Te }
      });
    }
    l = {
      mount: fe.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, a.mount = !f.isValid || !!fe.keepIsValid || !!fe.keepDirtyValues, a.watch = !!e.shouldUnregister, p.state.next({
      submitCount: fe.keepSubmitCount ? n.submitCount : 0,
      isDirty: Ce ? !1 : fe.keepDirty ? n.isDirty : !!(fe.keepDefaultValues && !oc(J, o)),
      isSubmitted: fe.keepIsSubmitted ? n.isSubmitted : !1,
      dirtyFields: Ce ? [] : fe.keepDirtyValues ? fe.keepDefaultValues && i ? Eg(o, i) : n.dirtyFields : fe.keepDefaultValues && J ? Eg(o, J) : {},
      touchedFields: fe.keepTouched ? n.touchedFields : {},
      errors: fe.keepErrors ? n.errors : {},
      isSubmitSuccessful: fe.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, _e = (J, fe) => Ee(ll(J) ? J(i) : J, fe);
  return {
    control: {
      register: ae,
      unregister: te,
      getFieldState: ne,
      handleSubmit: we,
      setError: Q,
      _executeSchema: A,
      _getWatch: B,
      _getDirty: L,
      _updateValid: S,
      _removeUnmounted: D,
      _updateFieldArray: I,
      _updateDisabledField: ie,
      _getFieldArray: H,
      _reset: Ee,
      _resetDefaultValues: () => ll(t.defaultValues) && t.defaultValues().then((J) => {
        _e(J, t.resetOptions), p.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (J) => {
        n = {
          ...n,
          ...J
        };
      },
      _disableForm: le,
      _subjects: p,
      _proxyFormState: f,
      _setErrors: T,
      get _fields() {
        return r;
      },
      get _formValues() {
        return i;
      },
      get _state() {
        return a;
      },
      set _state(J) {
        a = J;
      },
      get _defaultValues() {
        return o;
      },
      get _names() {
        return l;
      },
      set _names(J) {
        l = J;
      },
      get _formState() {
        return n;
      },
      set _formState(J) {
        n = J;
      },
      get _options() {
        return t;
      },
      set _options(J) {
        t = {
          ...t,
          ...J
        };
      }
    },
    trigger: $,
    register: ae,
    handleSubmit: we,
    watch: re,
    setValue: j,
    getValues: z,
    reset: _e,
    resetField: q,
    clearErrors: K,
    unregister: te,
    setError: Q,
    setFocus: (J, fe = {}) => {
      const me = rt(r, J), Oe = me && me._f;
      if (Oe) {
        const Ce = Oe.refs ? Oe.refs[0] : Oe.ref;
        Ce.focus && (Ce.focus(), fe.shouldSelect && Ce.select());
      }
    },
    getFieldState: ne
  };
}
function Ase(e = {}) {
  const t = en.useRef(), n = en.useRef(), [r, o] = en.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: ll(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: ll(e.defaultValues) ? void 0 : e.defaultValues
  });
  t.current || (t.current = {
    ...Mse(e),
    formState: r
  });
  const i = t.current.control;
  return i._options = e, dS({
    subject: i._subjects.state,
    next: (a) => {
      JD(a, i._proxyFormState, i._updateFormState, !0) && o({ ...i._formState });
    }
  }), en.useEffect(() => i._disableForm(e.disabled), [i, e.disabled]), en.useEffect(() => {
    if (i._proxyFormState.isDirty) {
      const a = i._getDirty();
      a !== r.isDirty && i._subjects.state.next({
        isDirty: a
      });
    }
  }, [i, r.isDirty]), en.useEffect(() => {
    e.values && !oc(e.values, n.current) ? (i._reset(e.values, i._options.resetOptions), n.current = e.values, o((a) => ({ ...a }))) : i._resetDefaultValues();
  }, [e.values, i]), en.useEffect(() => {
    e.errors && i._setErrors(e.errors);
  }, [e.errors, i]), en.useEffect(() => {
    i._state.mount || (i._updateValid(), i._state.mount = !0), i._state.watch && (i._state.watch = !1, i._subjects.state.next({ ...i._formState })), i._removeUnmounted();
  }), en.useEffect(() => {
    e.shouldUnregister && i._subjects.values.next({
      values: i._getWatch()
    });
  }, [e.shouldUnregister, i]), t.current.formState = XD(r, i), t.current;
}
function Dse(e) {
  return wt(e == null ? void 0 : e.required) ? !0 : typeof (e == null ? void 0 : e.validate) == "object" && wt(e.validate.required);
}
function Nse(e, t) {
  return wt(e) ? e : wt(t) ? t : pse;
}
function Zb(e) {
  const { field: t, fieldState: n } = Cse({
    ...e,
    disabled: !1
    // do not use rhf disabled behavior which turns disabled fields into undefined values
  });
  function r() {
    var l, c;
    const o = (l = n.error) == null ? void 0 : l.message, i = wt(o), a = Nse(
      (c = n.error) == null ? void 0 : c.message,
      e.helperText
    );
    return {
      inputRef: t.ref,
      label: e.label,
      required: Dse(e.rules),
      disabled: e.disabled ?? !1,
      error: i,
      helperText: a
    };
  }
  return { field: t, register: r };
}
function Fse(e, t) {
  if (typeof e != "string")
    return e;
  const n = Qb(e, t);
  return Number.isNaN(n) ? e : n;
}
function $se(e) {
  if (!lo(e.unit))
    return {
      endAdornment: /* @__PURE__ */ w.jsx(
        bl,
        {
          position: "end",
          sx: {
            "& .MuiTypography-root": {
              color: "black"
            }
          },
          children: e.unit
        }
      )
    };
}
function Bu(e) {
  const { field: t, register: n } = Zb(e);
  let r = 0, o = 1, i = !0;
  e.inputMode === "decimal" ? (r = e.minimumFractionDigits, o = e.maximumFractionDigits) : i = wt(e.useThousandsSeparator) ? e.useThousandsSeparator : !0;
  const a = sS(e), l = $se(e), c = aS(
    GD(t.value, {
      maximumFractionDigits: o,
      minimumFractionDigits: r,
      useThousandsSeparator: i
    })
  ), d = ho(void 0), f = ho(e.onChange);
  ir(() => {
    d.current === !1 && wt(f.current) && (d.current = !0, setTimeout(() => {
      d.current = !1, f.current();
    }, WD));
  }, [c]);
  function p(b) {
    t.onChange(
      Fse(b, {
        maximumFractionDigits: o,
        minimumFractionDigits: r
      })
    ), t.onBlur(), wt(e.onBlur) && e.onBlur(b);
  }
  async function g(b) {
    lo(d.current) && (d.current = !1), t.onChange(
      b.target.value
    );
  }
  return /* @__PURE__ */ w.jsx(Yb, { hint: e.hint, hintPlacement: e.hintPlacement, children: /* @__PURE__ */ w.jsx(
    Ea,
    {
      variant: "filled",
      ...n(),
      value: c,
      fullWidth: !0,
      onChange: g,
      onBlur: (b) => p(b.target.value),
      required: e.required,
      ...e.textFieldOptions,
      slotProps: {
        input: {
          ...l,
          style: { backgroundColor: "white" },
          disableUnderline: !0
        },
        htmlInput: a
      }
    }
  ) });
}
const Lse = oe($r)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "start",
  gap: e.spacing(3),
  boxSizing: "border-box"
}));
function Es(e) {
  const t = bo();
  return /* @__PURE__ */ w.jsxs(
    Lse,
    {
      sx: {
        width: e.width ?? "100%",
        paddingRight: e.width === "50%" ? t.spacing(1.5) : 0
      },
      children: [
        e.title && /* @__PURE__ */ w.jsx(Rt, { width: "15%", children: e.title }),
        e.children
      ]
    }
  );
}
function ey(e) {
  const {
    control: t,
    formState: n,
    watch: r,
    handleSubmit: o,
    getValues: i,
    setValue: a,
    reset: l,
    resetField: c,
    trigger: d
  } = Ase({
    mode: "onTouched",
    reValidateMode: "onChange",
    resetOptions: {
      keepDirty: !1
    },
    defaultValues: e.defaultValues,
    values: e.values,
    resolver: e.resolver
  });
  function f(g, b) {
    return {
      control: t,
      name: g,
      rules: b
    };
  }
  function p(g) {
    return {
      control: t,
      name: g
    };
  }
  return {
    registerField: f,
    registerForm: p,
    control: t,
    formState: n,
    watch: r,
    handleSubmit: o,
    getValues: i,
    setValue: a,
    reset: l,
    resetField: c,
    trigger: d
  };
}
function hS(e, t) {
  const n = typeof e == "number" && use(e, t), r = typeof e == "string" && UD(t).test(e);
  return n || r;
}
function aN(e, t) {
  if (!(Al(e) || hS(e, 2)))
    return t("form:validation.decimal2");
}
function Rm(e, t) {
  if (!(Al(e) || hS(e, 3)))
    return t("form:validation.decimal3");
}
const jse = /^[0-9.,\s]*$/, Bse = /^-[0.,\s]*$/;
function lN(e) {
  const t = typeof e == "number" && e >= 0, n = typeof e == "string" && (jse.test(e) || Bse.test(e));
  return t || n;
}
function Vse(e, t) {
  if (!(Al(e) || lN(e)))
    return t("form:validation.nonNegative");
}
function _m(e, t, n, r) {
  if (!(typeof e == "string" || typeof e == "number" && t <= e && e <= n))
    return r("form:validation.numberOutOfBound", {
      lowerBound: t,
      upperBound: n
    });
}
const Hse = /^\w+[\w-+.]*@\w+([-.]\w+)*\.[a-zA-Z]{2,}$/;
function Use(e, t) {
  if (!(Al(e) || Hse.test(e)))
    return t;
}
const zse = At(/* @__PURE__ */ w.jsx("path", {
  d: "m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8z"
}), "ArrowDownward"), Gse = At([/* @__PURE__ */ w.jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14z"
}, "0"), /* @__PURE__ */ w.jsx("path", {
  d: "M6.25 7.72h5v1.5h-5zM13 15.75h5v1.5h-5zm0-2.5h5v1.5h-5zM8 18h1.5v-2h2v-1.5h-2v-2H8v2H6V16h2zm6.09-7.05 1.41-1.41 1.41 1.41 1.06-1.06-1.41-1.42 1.41-1.41L16.91 6 15.5 7.41 14.09 6l-1.06 1.06 1.41 1.41-1.41 1.42z"
}, "1")], "CalculateOutlined");
function Wse(e) {
  const { t } = jn();
  return /* @__PURE__ */ w.jsx(
    as,
    {
      variant: "contained",
      onClick: e.onClick,
      startIcon: /* @__PURE__ */ w.jsx(Gse, { "aria-hidden": !0 }),
      "aria-label": t("acreageCalculator:button.showFormulas.explanation"),
      children: t("acreageCalculator:button.showFormulas.label")
    }
  );
}
const qse = oe(zse)(({ theme: e }) => ({
  color: e.palette.grey.A700,
  alignSelf: "center",
  flex: 1,
  position: "absolute",
  left: "50%",
  top: "50%",
  transform: "translate(-50%, -50%)"
})), Kse = oe(_t)(({ theme: e }) => ({
  display: "flex",
  position: "relative",
  width: "100%",
  justifyContent: "end",
  alignItems: "center",
  marginBottom: e.spacing(2)
}));
function cN(e) {
  return /* @__PURE__ */ w.jsxs(Kse, { children: [
    /* @__PURE__ */ w.jsx(qse, { fontSize: "large" }),
    /* @__PURE__ */ w.jsx(Wse, { onClick: e.onFormulaButtonClick })
  ] });
}
const gS = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (gS.displayName = "GridApiContext");
function Wt() {
  const e = m.useContext(gS);
  if (e === void 0)
    throw new Error(["MUI X: Could not find the Data Grid context.", "It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.", "This can also happen if you are bundling multiple versions of the Data Grid."].join(`
`));
  return e;
}
const jI = () => m.useRef({}), mS = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (mS.displayName = "GridRootPropsContext");
const ft = () => {
  const e = m.useContext(mS);
  if (!e)
    throw new Error("MUI X: useGridRootProps should only be used inside the DataGrid, DataGridPro or DataGridPremium component.");
  return e;
}, Yse = parseInt(m.version, 10), dn = (e) => {
  if (Yse >= 19) {
    const t = (n) => e(n, n.ref ?? null);
    return t.displayName = e.displayName ?? e.name, t;
  }
  return /* @__PURE__ */ m.forwardRef(e);
}, Qse = Object.is;
function uN(e, t) {
  if (e === t)
    return !0;
  if (!(e instanceof Object) || !(t instanceof Object))
    return !1;
  let n = 0, r = 0;
  for (const o in e)
    if (n += 1, !Qse(e[o], t[o]) || !(o in t))
      return !1;
  for (const o in t)
    r += 1;
  return n === r;
}
function Dl(e) {
  return /* @__PURE__ */ m.memo(e, uN);
}
const Xse = {
  // Root
  noRowsLabel: "No rows",
  noResultsOverlayLabel: "No results found.",
  // Density selector toolbar button text
  toolbarDensity: "Density",
  toolbarDensityLabel: "Density",
  toolbarDensityCompact: "Compact",
  toolbarDensityStandard: "Standard",
  toolbarDensityComfortable: "Comfortable",
  // Columns selector toolbar button text
  toolbarColumns: "Columns",
  toolbarColumnsLabel: "Select columns",
  // Filters toolbar button text
  toolbarFilters: "Filters",
  toolbarFiltersLabel: "Show filters",
  toolbarFiltersTooltipHide: "Hide filters",
  toolbarFiltersTooltipShow: "Show filters",
  toolbarFiltersTooltipActive: (e) => e !== 1 ? `${e} active filters` : `${e} active filter`,
  // Quick filter toolbar field
  toolbarQuickFilterPlaceholder: "Search…",
  toolbarQuickFilterLabel: "Search",
  toolbarQuickFilterDeleteIconLabel: "Clear",
  // Export selector toolbar button text
  toolbarExport: "Export",
  toolbarExportLabel: "Export",
  toolbarExportCSV: "Download as CSV",
  toolbarExportPrint: "Print",
  toolbarExportExcel: "Download as Excel",
  // Columns management text
  columnsManagementSearchTitle: "Search",
  columnsManagementNoColumns: "No columns",
  columnsManagementShowHideAllText: "Show/Hide All",
  columnsManagementReset: "Reset",
  columnsManagementDeleteIconLabel: "Clear",
  // Filter panel text
  filterPanelAddFilter: "Add filter",
  filterPanelRemoveAll: "Remove all",
  filterPanelDeleteIconLabel: "Delete",
  filterPanelLogicOperator: "Logic operator",
  filterPanelOperator: "Operator",
  filterPanelOperatorAnd: "And",
  filterPanelOperatorOr: "Or",
  filterPanelColumns: "Columns",
  filterPanelInputLabel: "Value",
  filterPanelInputPlaceholder: "Filter value",
  // Filter operators text
  filterOperatorContains: "contains",
  filterOperatorDoesNotContain: "does not contain",
  filterOperatorEquals: "equals",
  filterOperatorDoesNotEqual: "does not equal",
  filterOperatorStartsWith: "starts with",
  filterOperatorEndsWith: "ends with",
  filterOperatorIs: "is",
  filterOperatorNot: "is not",
  filterOperatorAfter: "is after",
  filterOperatorOnOrAfter: "is on or after",
  filterOperatorBefore: "is before",
  filterOperatorOnOrBefore: "is on or before",
  filterOperatorIsEmpty: "is empty",
  filterOperatorIsNotEmpty: "is not empty",
  filterOperatorIsAnyOf: "is any of",
  "filterOperator=": "=",
  "filterOperator!=": "!=",
  "filterOperator>": ">",
  "filterOperator>=": ">=",
  "filterOperator<": "<",
  "filterOperator<=": "<=",
  // Header filter operators text
  headerFilterOperatorContains: "Contains",
  headerFilterOperatorDoesNotContain: "Does not contain",
  headerFilterOperatorEquals: "Equals",
  headerFilterOperatorDoesNotEqual: "Does not equal",
  headerFilterOperatorStartsWith: "Starts with",
  headerFilterOperatorEndsWith: "Ends with",
  headerFilterOperatorIs: "Is",
  headerFilterOperatorNot: "Is not",
  headerFilterOperatorAfter: "Is after",
  headerFilterOperatorOnOrAfter: "Is on or after",
  headerFilterOperatorBefore: "Is before",
  headerFilterOperatorOnOrBefore: "Is on or before",
  headerFilterOperatorIsEmpty: "Is empty",
  headerFilterOperatorIsNotEmpty: "Is not empty",
  headerFilterOperatorIsAnyOf: "Is any of",
  "headerFilterOperator=": "Equals",
  "headerFilterOperator!=": "Not equals",
  "headerFilterOperator>": "Greater than",
  "headerFilterOperator>=": "Greater than or equal to",
  "headerFilterOperator<": "Less than",
  "headerFilterOperator<=": "Less than or equal to",
  // Filter values text
  filterValueAny: "any",
  filterValueTrue: "true",
  filterValueFalse: "false",
  // Column menu text
  columnMenuLabel: "Menu",
  columnMenuShowColumns: "Show columns",
  columnMenuManageColumns: "Manage columns",
  columnMenuFilter: "Filter",
  columnMenuHideColumn: "Hide column",
  columnMenuUnsort: "Unsort",
  columnMenuSortAsc: "Sort by ASC",
  columnMenuSortDesc: "Sort by DESC",
  // Column header text
  columnHeaderFiltersTooltipActive: (e) => e !== 1 ? `${e} active filters` : `${e} active filter`,
  columnHeaderFiltersLabel: "Show filters",
  columnHeaderSortIconLabel: "Sort",
  // Rows selected footer text
  footerRowSelected: (e) => e !== 1 ? `${e.toLocaleString()} rows selected` : `${e.toLocaleString()} row selected`,
  // Total row amount footer text
  footerTotalRows: "Total Rows:",
  // Total visible row amount footer text
  footerTotalVisibleRows: (e, t) => `${e.toLocaleString()} of ${t.toLocaleString()}`,
  // Checkbox selection text
  checkboxSelectionHeaderName: "Checkbox selection",
  checkboxSelectionSelectAllRows: "Select all rows",
  checkboxSelectionUnselectAllRows: "Unselect all rows",
  checkboxSelectionSelectRow: "Select row",
  checkboxSelectionUnselectRow: "Unselect row",
  // Boolean cell text
  booleanCellTrueLabel: "yes",
  booleanCellFalseLabel: "no",
  // Actions cell more text
  actionsCellMore: "more",
  // Column pinning text
  pinToLeft: "Pin to left",
  pinToRight: "Pin to right",
  unpin: "Unpin",
  // Tree Data
  treeDataGroupingHeaderName: "Group",
  treeDataExpand: "see children",
  treeDataCollapse: "hide children",
  // Grouping columns
  groupingColumnHeaderName: "Group",
  groupColumn: (e) => `Group by ${e}`,
  unGroupColumn: (e) => `Stop grouping by ${e}`,
  // Master/detail
  detailPanelToggle: "Detail panel toggle",
  expandDetailPanel: "Expand",
  collapseDetailPanel: "Collapse",
  // Used core components translation keys
  MuiTablePagination: {},
  // Row reordering text
  rowReorderingHeaderName: "Row reordering",
  // Aggregation
  aggregationMenuItemHeader: "Aggregation",
  aggregationFunctionLabelSum: "sum",
  aggregationFunctionLabelAvg: "avg",
  aggregationFunctionLabelMin: "min",
  aggregationFunctionLabelMax: "max",
  aggregationFunctionLabelSize: "size"
};
function nn(e) {
  return XM("MuiDataGrid", e);
}
const ee = JM("MuiDataGrid", ["actionsCell", "aggregationColumnHeader", "aggregationColumnHeader--alignLeft", "aggregationColumnHeader--alignCenter", "aggregationColumnHeader--alignRight", "aggregationColumnHeaderLabel", "autoHeight", "autosizing", "booleanCell", "cell--editable", "cell--editing", "cell--flex", "cell--textCenter", "cell--textLeft", "cell--textRight", "cell--rangeTop", "cell--rangeBottom", "cell--rangeLeft", "cell--rangeRight", "cell--pinnedLeft", "cell--pinnedRight", "cell--selectionMode", "cell", "cellCheckbox", "cellEmpty", "cellSkeleton", "cellOffsetLeft", "checkboxInput", "columnHeader", "columnHeader--alignCenter", "columnHeader--alignLeft", "columnHeader--alignRight", "columnHeader--dragging", "columnHeader--moving", "columnHeader--numeric", "columnHeader--sortable", "columnHeader--sorted", "columnHeader--filtered", "columnHeader--pinnedLeft", "columnHeader--pinnedRight", "columnHeader--last", "columnHeader--lastUnpinned", "columnHeader--siblingFocused", "columnHeaderCheckbox", "columnHeaderDraggableContainer", "columnHeaderTitle", "columnHeaderTitleContainer", "columnHeaderTitleContainerContent", "columnHeader--filledGroup", "columnHeader--emptyGroup", "columnHeaders", "columnSeparator--resizable", "columnSeparator--resizing", "columnSeparator--sideLeft", "columnSeparator--sideRight", "columnSeparator", "columnsManagement", "columnsManagementRow", "columnsManagementHeader", "columnsManagementSearchInput", "columnsManagementFooter", "container--top", "container--bottom", "detailPanel", "detailPanels", "detailPanelToggleCell", "detailPanelToggleCell--expanded", "footerCell", "panel", "panelHeader", "panelWrapper", "panelContent", "panelFooter", "paper", "editBooleanCell", "editInputCell", "filler", "filler--borderBottom", "filler--pinnedLeft", "filler--pinnedRight", "filterForm", "filterFormDeleteIcon", "filterFormLogicOperatorInput", "filterFormColumnInput", "filterFormOperatorInput", "filterFormValueInput", "filterIcon", "footerContainer", "headerFilterRow", "iconButtonContainer", "iconSeparator", "main", "main--hasPinnedRight", "main--hasSkeletonLoadingOverlay", "menu", "menuIcon", "menuIconButton", "menuOpen", "menuList", "overlay", "overlayWrapper", "overlayWrapperInner", "root", "root--densityStandard", "root--densityComfortable", "root--densityCompact", "root--disableUserSelection", "root--noToolbar", "row", "row--editable", "row--editing", "row--firstVisible", "row--lastVisible", "row--dragging", "row--dynamicHeight", "row--detailPanelExpanded", "row--borderBottom", "rowReorderCellPlaceholder", "rowCount", "rowReorderCellContainer", "rowReorderCell", "rowReorderCell--draggable", "rowSkeleton", "scrollArea--left", "scrollArea--right", "scrollArea", "scrollbar", "scrollbar--vertical", "scrollbar--horizontal", "scrollbarFiller", "scrollbarFiller--header", "scrollbarFiller--borderTop", "scrollbarFiller--borderBottom", "scrollbarFiller--pinnedRight", "selectedRowCount", "sortIcon", "toolbarContainer", "toolbarFilterList", "virtualScroller", "virtualScroller--hasScrollX", "virtualScrollerContent", "virtualScrollerContent--overflowed", "virtualScrollerRenderZone", "pinnedColumns", "withVerticalBorder", "withBorderColor", "cell--withRightBorder", "cell--withLeftBorder", "columnHeader--withRightBorder", "columnHeader--withLeftBorder", "treeDataGroupingCell", "treeDataGroupingCellToggle", "treeDataGroupingCellLoadingContainer", "groupingCriteriaCell", "groupingCriteriaCellToggle", "groupingCriteriaCellLoadingContainer", "pinnedRows", "pinnedRows--top", "pinnedRows--bottom", "pinnedRowsRenderZone"]), BI = 1e3;
class Jse {
  constructor(t = BI) {
    this.timeouts = /* @__PURE__ */ new Map(), this.cleanupTimeout = BI, this.cleanupTimeout = t;
  }
  register(t, n, r) {
    this.timeouts || (this.timeouts = /* @__PURE__ */ new Map());
    const o = setTimeout(() => {
      typeof n == "function" && n(), this.timeouts.delete(r.cleanupToken);
    }, this.cleanupTimeout);
    this.timeouts.set(r.cleanupToken, o);
  }
  unregister(t) {
    const n = this.timeouts.get(t.cleanupToken);
    n && (this.timeouts.delete(t.cleanupToken), clearTimeout(n));
  }
  reset() {
    this.timeouts && (this.timeouts.forEach((t, n) => {
      this.unregister({
        cleanupToken: n
      });
    }), this.timeouts = void 0);
  }
}
class Zse {
  constructor() {
    this.registry = new FinalizationRegistry((t) => {
      typeof t == "function" && t();
    });
  }
  register(t, n, r) {
    this.registry.register(t, n, r);
  }
  unregister(t) {
    this.registry.unregister(t);
  }
  // eslint-disable-next-line class-methods-use-this
  reset() {
  }
}
var di = /* @__PURE__ */ function(e) {
  return e.DataGrid = "DataGrid", e.DataGridPro = "DataGridPro", e.DataGridPremium = "DataGridPremium", e;
}(di || {});
class eae {
}
function tae(e) {
  let t = 0;
  return function(r, o, i, a) {
    e.registry === null && (e.registry = typeof FinalizationRegistry < "u" ? new Zse() : new Jse());
    const [l] = m.useState(new eae()), c = m.useRef(null), d = m.useRef(null);
    d.current = i;
    const f = m.useRef(null);
    if (!c.current && d.current) {
      const p = (g, b, v) => {
        var y;
        b.defaultMuiPrevented || (y = d.current) == null || y.call(d, g, b, v);
      };
      c.current = r.current.subscribeEvent(o, p, a), t += 1, f.current = {
        cleanupToken: t
      }, e.registry.register(
        l,
        // The callback below will be called once this reference stops being retained
        () => {
          var g;
          (g = c.current) == null || g.call(c), c.current = null, f.current = null;
        },
        f.current
      );
    } else !d.current && c.current && (c.current(), c.current = null, f.current && (e.registry.unregister(f.current), f.current = null));
    m.useEffect(() => {
      if (!c.current && d.current) {
        const p = (g, b, v) => {
          var y;
          b.defaultMuiPrevented || (y = d.current) == null || y.call(d, g, b, v);
        };
        c.current = r.current.subscribeEvent(o, p, a);
      }
      return f.current && e.registry && (e.registry.unregister(f.current), f.current = null), () => {
        var p;
        (p = c.current) == null || p.call(c), c.current = null;
      };
    }, [r, o, a]);
  };
}
const nae = {
  registry: null
}, it = tae(nae), rae = {
  isFirst: !0
};
function Nn(e, t, n) {
  it(e, t, n, rae);
}
function oae(e) {
  return e.acceptsApiRef;
}
function VI(e, t) {
  return oae(t) ? t(e) : t(e.current.state);
}
const iae = Object.is, dN = uN, sae = () => ({
  state: null,
  equals: null,
  selector: null,
  args: null
}), Be = (e, t, n = iae) => {
  process.env.NODE_ENV !== "production" && (e.current.state || ns(["MUI X: `useGridSelector` has been called before the initialization of the state.", "This hook can only be used inside the context of the grid."]));
  const r = Ws(sae), o = r.current.selector !== null, [i, a] = m.useState(
    // We don't use an initialization function to avoid allocations
    o ? null : VI(e, t)
  );
  return r.current.state = i, r.current.equals = n, r.current.selector = t, Mb(() => e.current.store.subscribe(() => {
    const l = VI(e, r.current.selector);
    r.current.equals(r.current.state, l) || (r.current.state = l, a(l));
  })), i;
}, mo = (e) => e.dimensions;
var aae = (e, t, n) => {
  if (t.length === 1 && t[0] === n) {
    let r = !1;
    try {
      const o = {};
      e(o) === o && (r = !0);
    } catch {
    }
    if (r) {
      let o;
      try {
        throw new Error();
      } catch (i) {
        ({ stack: o } = i);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: o }
      );
    }
  }
}, lae = (e, t, n) => {
  const { memoize: r, memoizeOptions: o } = t, { inputSelectorResults: i, inputSelectorResultsCopy: a } = e, l = r(() => ({}), ...o);
  if (!(l.apply(null, i) === l.apply(null, a))) {
    let d;
    try {
      throw new Error();
    } catch (f) {
      ({ stack: d } = f);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: n,
        firstInputs: i,
        secondInputs: a,
        stack: d
      }
    );
  }
}, cae = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
}, km = /* @__PURE__ */ Symbol("NOT_FOUND");
function uae(e, t = `expected a function, instead received ${typeof e}`) {
  if (typeof e != "function")
    throw new TypeError(t);
}
function dae(e, t = `expected an object, instead received ${typeof e}`) {
  if (typeof e != "object")
    throw new TypeError(t);
}
function fae(e, t = "expected all items to be functions, instead received the following types: ") {
  if (!e.every((n) => typeof n == "function")) {
    const n = e.map(
      (r) => typeof r == "function" ? `function ${r.name || "unnamed"}()` : typeof r
    ).join(", ");
    throw new TypeError(`${t}[${n}]`);
  }
}
var HI = (e) => Array.isArray(e) ? e : [e];
function pae(e) {
  const t = Array.isArray(e[0]) ? e[0] : e;
  return fae(
    t,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), t;
}
function UI(e, t) {
  const n = [], { length: r } = e;
  for (let o = 0; o < r; o++)
    n.push(e[o].apply(null, t));
  return n;
}
var hae = (e, t) => {
  const { identityFunctionCheck: n, inputStabilityCheck: r } = {
    ...cae,
    ...t
  };
  return {
    identityFunctionCheck: {
      shouldRun: n === "always" || n === "once" && e,
      run: aae
    },
    inputStabilityCheck: {
      shouldRun: r === "always" || r === "once" && e,
      run: lae
    }
  };
};
function gae(e) {
  let t;
  return {
    get(n) {
      return t && e(t.key, n) ? t.value : km;
    },
    put(n, r) {
      t = { key: n, value: r };
    },
    getEntries() {
      return t ? [t] : [];
    },
    clear() {
      t = void 0;
    }
  };
}
function mae(e, t) {
  let n = [];
  function r(l) {
    const c = n.findIndex((d) => t(l, d.key));
    if (c > -1) {
      const d = n[c];
      return c > 0 && (n.splice(c, 1), n.unshift(d)), d.value;
    }
    return km;
  }
  function o(l, c) {
    r(l) === km && (n.unshift({ key: l, value: c }), n.length > e && n.pop());
  }
  function i() {
    return n;
  }
  function a() {
    n = [];
  }
  return { get: r, put: o, getEntries: i, clear: a };
}
var bae = (e, t) => e === t;
function yae(e) {
  return function(n, r) {
    if (n === null || r === null || n.length !== r.length)
      return !1;
    const { length: o } = n;
    for (let i = 0; i < o; i++)
      if (!e(n[i], r[i]))
        return !1;
    return !0;
  };
}
function fN(e, t) {
  const n = typeof t == "object" ? t : { equalityCheck: t }, {
    equalityCheck: r = bae,
    maxSize: o = 1,
    resultEqualityCheck: i
  } = n, a = yae(r);
  let l = 0;
  const c = o <= 1 ? gae(a) : mae(o, a);
  function d() {
    let f = c.get(arguments);
    if (f === km) {
      if (f = e.apply(null, arguments), l++, i) {
        const g = c.getEntries().find(
          (b) => i(b.value, f)
        );
        g && (f = g.value, l !== 0 && l--);
      }
      c.put(arguments, f);
    }
    return f;
  }
  return d.clearCache = () => {
    c.clear(), d.resetResultsCount();
  }, d.resultsCount = () => l, d.resetResultsCount = () => {
    l = 0;
  }, d;
}
var vae = class {
  constructor(e) {
    this.value = e;
  }
  deref() {
    return this.value;
  }
}, wae = typeof WeakRef < "u" ? WeakRef : vae, Cae = 0, zI = 1;
function Tg() {
  return {
    s: Cae,
    v: void 0,
    o: null,
    p: null
  };
}
function pN(e, t = {}) {
  let n = Tg();
  const { resultEqualityCheck: r } = t;
  let o, i = 0;
  function a() {
    var p;
    let l = n;
    const { length: c } = arguments;
    for (let g = 0, b = c; g < b; g++) {
      const v = arguments[g];
      if (typeof v == "function" || typeof v == "object" && v !== null) {
        let y = l.o;
        y === null && (l.o = y = /* @__PURE__ */ new WeakMap());
        const S = y.get(v);
        S === void 0 ? (l = Tg(), y.set(v, l)) : l = S;
      } else {
        let y = l.p;
        y === null && (l.p = y = /* @__PURE__ */ new Map());
        const S = y.get(v);
        S === void 0 ? (l = Tg(), y.set(v, l)) : l = S;
      }
    }
    const d = l;
    let f;
    if (l.s === zI)
      f = l.v;
    else if (f = e.apply(null, arguments), i++, r) {
      const g = ((p = o == null ? void 0 : o.deref) == null ? void 0 : p.call(o)) ?? o;
      g != null && r(g, f) && (f = g, i !== 0 && i--), o = typeof f == "object" && f !== null || typeof f == "function" ? new wae(f) : f;
    }
    return d.s = zI, d.v = f, f;
  }
  return a.clearCache = () => {
    n = Tg(), a.resetResultsCount();
  }, a.resultsCount = () => i, a.resetResultsCount = () => {
    i = 0;
  }, a;
}
function hN(e, ...t) {
  const n = typeof e == "function" ? {
    memoize: e,
    memoizeOptions: t
  } : e, r = (...o) => {
    let i = 0, a = 0, l, c = {}, d = o.pop();
    typeof d == "object" && (c = d, d = o.pop()), uae(
      d,
      `createSelector expects an output function after the inputs, but received: [${typeof d}]`
    );
    const f = {
      ...n,
      ...c
    }, {
      memoize: p,
      memoizeOptions: g = [],
      argsMemoize: b = pN,
      argsMemoizeOptions: v = [],
      devModeChecks: y = {}
    } = f, S = HI(g), E = HI(v), I = pae(o), O = p(function() {
      return i++, d.apply(
        null,
        arguments
      );
    }, ...S);
    let T = !0;
    const P = b(function() {
      a++;
      const F = UI(
        I,
        arguments
      );
      if (l = O.apply(null, F), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: A, inputStabilityCheck: _ } = hae(T, y);
        if (A.shouldRun && A.run(
          d,
          F,
          l
        ), _.shouldRun) {
          const C = UI(
            I,
            arguments
          );
          _.run(
            { inputSelectorResults: F, inputSelectorResultsCopy: C },
            { memoize: p, memoizeOptions: S },
            arguments
          );
        }
        T && (T = !1);
      }
      return l;
    }, ...E);
    return Object.assign(P, {
      resultFunc: d,
      memoizedResultFunc: O,
      dependencies: I,
      dependencyRecomputations: () => a,
      resetDependencyRecomputations: () => {
        a = 0;
      },
      lastResult: () => l,
      recomputations: () => i,
      resetRecomputations: () => {
        i = 0;
      },
      memoize: p,
      argsMemoize: b
    });
  };
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var xae = /* @__PURE__ */ hN(pN), Sae = Object.assign(
  (e, t = xae) => {
    dae(
      e,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof e}`
    );
    const n = Object.keys(e), r = n.map(
      (i) => e[i]
    );
    return t(
      r,
      (...i) => i.reduce((a, l, c) => (a[n[c]] = l, a), {})
    );
  },
  { withTypes: () => Sae }
);
const Eae = hN({
  memoize: fN,
  memoizeOptions: {
    maxSize: 1,
    equalityCheck: Object.is
  }
}), GI = /* @__PURE__ */ new WeakMap();
function Tu(e) {
  return "current" in e && "instanceId" in e.current;
}
const Ou = {
  id: "default"
}, Mt = (e, t, n, r, o, i, ...a) => {
  if (a.length > 0)
    throw new Error("Unsupported number of selectors");
  let l;
  if (e && t && n && r && o && i)
    l = (c, d) => {
      const f = Tu(c), p = d ?? (f ? c.current.instanceId : Ou), g = f ? c.current.state : c, b = e(g, p), v = t(g, p), y = n(g, p), S = r(g, p), E = o(g, p);
      return i(b, v, y, S, E);
    };
  else if (e && t && n && r && o)
    l = (c, d) => {
      const f = Tu(c), p = d ?? (f ? c.current.instanceId : Ou), g = f ? c.current.state : c, b = e(g, p), v = t(g, p), y = n(g, p), S = r(g, p);
      return o(b, v, y, S);
    };
  else if (e && t && n && r)
    l = (c, d) => {
      const f = Tu(c), p = d ?? (f ? c.current.instanceId : Ou), g = f ? c.current.state : c, b = e(g, p), v = t(g, p), y = n(g, p);
      return r(b, v, y);
    };
  else if (e && t && n)
    l = (c, d) => {
      const f = Tu(c), p = d ?? (f ? c.current.instanceId : Ou), g = f ? c.current.state : c, b = e(g, p), v = t(g, p);
      return n(b, v);
    };
  else if (e && t)
    l = (c, d) => {
      const f = Tu(c), p = d ?? (f ? c.current.instanceId : Ou), g = f ? c.current.state : c, b = e(g, p);
      return t(b);
    };
  else
    throw new Error("Missing arguments");
  return l.acceptsApiRef = !0, l;
}, Pn = (...e) => {
  const t = (n, r) => {
    const o = Tu(n), i = o ? n.current.instanceId : r ?? Ou, a = o ? n.current.state : n;
    process.env.NODE_ENV !== "production" && i.id === "default" && ns(["MUI X: A selector was called without passing the instance ID, which may impact the performance of the grid.", "To fix, call it with `apiRef`, for example `mySelector(apiRef)`, or pass the instance ID explicitly, for example `mySelector(state, apiRef.current.instanceId)`."]);
    const l = GI.get(i), c = l ?? /* @__PURE__ */ new Map(), d = c == null ? void 0 : c.get(e);
    if (c && d)
      return d(a, i);
    const f = Eae(...e);
    return l || GI.set(i, c), c.set(e, f), f(a, i);
  };
  return t.acceptsApiRef = !0, t;
}, Tae = 0.7, Oae = 1.3, Pae = {
  compact: Tae,
  comfortable: Oae,
  standard: 1
}, Mu = (e) => e.density, ch = Mt(Mu, (e) => Pae[e]);
let $n = /* @__PURE__ */ function(e) {
  return e.LEFT = "left", e.RIGHT = "right", e;
}({});
const J0 = {
  left: [],
  right: []
}, Iae = (e) => e.isRtl, Ls = (e) => e.columns, ha = Mt(Ls, (e) => e.orderedFields), Oa = Mt(Ls, (e) => e.lookup), rs = Pn(ha, Oa, (e, t) => e.map((n) => t[n])), Ai = Mt(Ls, (e) => e.columnVisibilityModel), Fr = Pn(rs, Ai, (e, t) => e.filter((n) => t[n.field] !== !1)), Ad = Pn(Fr, (e) => e.map((t) => t.field)), Rae = (e) => e.pinnedColumns, uh = Pn(Ls, Rae, Ad, Iae, (e, t, n, r) => {
  const o = _ae(t, n, r);
  return {
    left: o.left.map((a) => e.lookup[a]),
    right: o.right.map((a) => e.lookup[a])
  };
});
function _ae(e, t, n) {
  var l, c;
  if (!Array.isArray(e.left) && !Array.isArray(e.right) || ((l = e.left) == null ? void 0 : l.length) === 0 && ((c = e.right) == null ? void 0 : c.length) === 0)
    return J0;
  const r = (d, f) => Array.isArray(d) ? d.filter((p) => f.includes(p)) : [], o = r(e.left, t), i = t.filter(
    // Filter out from the remaining columns those columns already pinned to the left
    (d) => !o.includes(d)
  ), a = r(e.right, i);
  return n ? {
    left: a,
    right: o
  } : {
    left: o,
    right: a
  };
}
const Nl = Pn(Fr, (e) => {
  const t = [];
  let n = 0;
  for (let r = 0; r < e.length; r += 1)
    t.push(n), n += e[r].computedWidth;
  return t;
}), bS = Mt(Fr, Nl, (e, t) => {
  const n = e.length;
  return n === 0 ? 0 : t[n - 1] + e[n - 1].computedWidth;
}), gN = Pn(rs, (e) => e.filter((t) => t.filterable)), kae = Pn(rs, (e) => e.reduce((t, n) => (n.filterable && (t[n.field] = n), t), {})), Mae = Pn(rs, (e) => e.some((t) => t.colSpan !== void 0)), Aae = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "hasFocus", "isValidating", "debounceMs", "isProcessingProps", "onValueChange"], Dae = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["editInputCell"]
  }, nn, t);
}, Nae = oe(kc, {
  name: "MuiDataGrid",
  slot: "EditInputCell",
  overridesResolver: (e, t) => t.editInputCell
})(({
  theme: e
}) => U({}, e.typography.body2, {
  padding: "1px 0",
  "& input": {
    padding: "0 16px",
    height: "100%"
  }
})), mN = dn((e, t) => {
  const n = ft(), {
    id: r,
    value: o,
    field: i,
    colDef: a,
    hasFocus: l,
    debounceMs: c = 200,
    isProcessingProps: d,
    onValueChange: f
  } = e, p = yt(e, Aae), g = Wt(), b = m.useRef(null), [v, y] = m.useState(o), S = Dae(n), E = m.useCallback(async (O) => {
    const T = O.target.value;
    f && await f(O, T);
    const P = g.current.getColumn(i);
    let R = T;
    P.valueParser && (R = P.valueParser(T, g.current.getRow(r), P, g)), y(R), g.current.setEditCellValue({
      id: r,
      field: i,
      value: R,
      debounceMs: c,
      unstable_skipValueParser: !0
    }, O);
  }, [g, c, i, r, f]), I = g.current.unstable_getEditCellMeta(r, i);
  return m.useEffect(() => {
    (I == null ? void 0 : I.changeReason) !== "debouncedSetEditCellValue" && y(o);
  }, [I, o]), Zr(() => {
    l && b.current.focus();
  }, [l]), /* @__PURE__ */ w.jsx(Nae, U({
    inputRef: b,
    className: S.root,
    ownerState: n,
    fullWidth: !0,
    type: a.type === "number" ? a.type : "text",
    value: v ?? "",
    onChange: E,
    endAdornment: d ? /* @__PURE__ */ w.jsx(n.slots.loadIcon, {
      fontSize: "small",
      color: "action"
    }) : void 0
  }, p, {
    ref: t
  }));
});
process.env.NODE_ENV !== "production" && (mN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: s.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: s.oneOf(["edit", "view"]).isRequired,
  changeReason: s.oneOf(["debouncedSetEditCellValue", "setEditCellValue"]),
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: s.object.isRequired,
  debounceMs: s.number,
  /**
   * The column field of the cell that triggered the event.
   */
  field: s.string.isRequired,
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: s.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: s.bool.isRequired,
  /**
   * The grid row id.
   */
  id: s.oneOfType([s.number, s.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: s.bool,
  isProcessingProps: s.bool,
  isValidating: s.bool,
  /**
   * Callback called when the value is changed by the user.
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {Date | null} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */
  onValueChange: s.func,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: s.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: s.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: s.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: s.any
});
const Fae = (e) => /* @__PURE__ */ w.jsx(mN, U({}, e)), bN = (e, t) => t && e.length > 1 ? (process.env.NODE_ENV !== "production" && ns(["MUI X: The `sortModel` can only contain a single item when the `disableMultipleColumnsSorting` prop is set to `true`.", "If you are using the community version of the Data Grid, this prop is always `true`."], "error"), [e[0]]) : e, WI = (e, t) => (n) => U({}, n, {
  sorting: U({}, n.sorting, {
    sortModel: bN(e, t)
  })
}), $ae = (e) => e === "desc", Lae = (e, t) => {
  const n = t.current.getColumn(e.field);
  if (!n || e.sort === null)
    return null;
  let r;
  return n.getSortComparator ? r = n.getSortComparator(e.sort) : r = $ae(e.sort) ? (...i) => -1 * n.sortComparator(...i) : n.sortComparator, r ? {
    getSortCellParams: (i) => ({
      id: i,
      field: n.field,
      rowNode: t.current.getRowNode(i),
      value: t.current.getCellValue(i, n.field),
      api: t.current
    }),
    comparator: r
  } : null;
}, jae = (e, t, n) => e.reduce((r, o, i) => {
  if (r !== 0)
    return r;
  const a = t.params[i], l = n.params[i];
  return r = o.comparator(a.value, l.value, a, l), r;
}, 0), Bae = (e, t) => {
  const n = e.map((r) => Lae(r, t)).filter((r) => !!r);
  return n.length === 0 ? null : (r) => r.map((o) => ({
    node: o,
    params: n.map((i) => i.getSortCellParams(o.id))
  })).sort((o, i) => jae(n, o, i)).map((o) => o.node.id);
}, qI = (e, t) => {
  const n = e.indexOf(t);
  return !t || n === -1 || n + 1 === e.length ? e[0] : e[n + 1];
}, yS = (e, t) => e == null && t != null ? -1 : t == null && e != null ? 1 : e == null && t == null ? 0 : null, Vae = new Intl.Collator(), Hae = (e, t) => {
  const n = yS(e, t);
  return n !== null ? n : typeof e == "string" ? Vae.compare(e.toString(), t.toString()) : e - t;
}, yN = (e, t) => {
  const n = yS(e, t);
  return n !== null ? n : Number(e) - Number(t);
}, vN = (e, t) => {
  const n = yS(e, t);
  return n !== null ? n : e > t ? 1 : e < t ? -1 : 0;
}, Uae = ["item", "applyValue", "type", "apiRef", "focusElementRef", "tabIndex", "disabled", "isFilterActive", "clearButton", "InputProps", "variant"];
function ii(e) {
  var T;
  const {
    item: t,
    applyValue: n,
    type: r,
    apiRef: o,
    focusElementRef: i,
    tabIndex: a,
    disabled: l,
    clearButton: c,
    InputProps: d,
    variant: f = "standard"
  } = e, p = yt(e, Uae), g = Pd(), [b, v] = m.useState(Ew(t.value)), [y, S] = m.useState(!1), E = xr(), I = ft(), O = m.useCallback((P) => {
    const R = Ew(P.target.value);
    v(R), S(!0), g.start(I.filterDebounceMs, () => {
      const F = U({}, t, {
        value: r === "number" && !Number.isNaN(Number(R)) ? Number(R) : R,
        fromInput: E
      });
      n(F), S(!1);
    });
  }, [g, I.filterDebounceMs, t, r, E, n]);
  return m.useEffect(() => {
    (t.fromInput !== E || t.value == null) && v(Ew(t.value));
  }, [E, t]), /* @__PURE__ */ w.jsx(I.slots.baseTextField, U({
    id: E,
    label: o.current.getLocaleText("filterPanelInputLabel"),
    placeholder: o.current.getLocaleText("filterPanelInputPlaceholder"),
    value: b ?? "",
    onChange: O,
    variant: f,
    type: r || "text",
    InputProps: U({}, y || c ? {
      endAdornment: y ? /* @__PURE__ */ w.jsx(I.slots.loadIcon, {
        fontSize: "small",
        color: "action"
      }) : c
    } : {}, {
      disabled: l
    }, d, {
      inputProps: U({
        tabIndex: a
      }, d == null ? void 0 : d.inputProps)
    }),
    InputLabelProps: {
      shrink: !0
    },
    inputRef: i
  }, p, (T = I.slotProps) == null ? void 0 : T.baseTextField));
}
function Ew(e) {
  if (!(e == null || e === ""))
    return String(e);
}
process.env.NODE_ENV !== "production" && (ii.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: s.shape({
    current: s.object.isRequired
  }).isRequired,
  applyValue: s.func.isRequired,
  clearButton: s.node,
  focusElementRef: s.oneOfType([s.func, s.object]),
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (for example `isEmpty`)
   */
  isFilterActive: s.bool,
  item: s.shape({
    field: s.string.isRequired,
    id: s.oneOfType([s.number, s.string]),
    operator: s.string.isRequired,
    value: s.any
  }).isRequired
});
function wN(e) {
  return typeof e == "number" && !Number.isNaN(e);
}
function CN(e) {
  return typeof e == "function";
}
function vS(e) {
  return typeof e == "object" && e !== null;
}
function zae() {
  try {
    const e = "__some_random_key_you_are_not_going_to_use__";
    return window.localStorage.setItem(e, e), window.localStorage.removeItem(e), !0;
  } catch {
    return !1;
  }
}
function Mm(e) {
  return e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}
const js = (e, t, n) => Math.max(t, Math.min(n, e));
function KI(e, t) {
  return Array.from({
    length: t - e
  }).map((n, r) => e + r);
}
function Vu(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    if (Array.isArray(e)) {
      const o = e.length;
      if (o !== t.length)
        return !1;
      for (let i = 0; i < o; i += 1)
        if (!Vu(e[i], t[i]))
          return !1;
      return !0;
    }
    if (e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      const o = Array.from(e.entries());
      for (let i = 0; i < o.length; i += 1)
        if (!t.has(o[i][0]))
          return !1;
      for (let i = 0; i < o.length; i += 1) {
        const a = o[i];
        if (!Vu(a[1], t.get(a[0])))
          return !1;
      }
      return !0;
    }
    if (e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      const o = Array.from(e.entries());
      for (let i = 0; i < o.length; i += 1)
        if (!t.has(o[i][0]))
          return !1;
      return !0;
    }
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      const o = e.length;
      if (o !== t.length)
        return !1;
      for (let i = 0; i < o; i += 1)
        if (e[i] !== t[i])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    const n = Object.keys(e), r = n.length;
    if (r !== Object.keys(t).length)
      return !1;
    for (let o = 0; o < r; o += 1)
      if (!Object.prototype.hasOwnProperty.call(t, n[o]))
        return !1;
    for (let o = 0; o < r; o += 1) {
      const i = n[o];
      if (!Vu(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Gae(e) {
  return () => {
    let t = e += 1831565813;
    return t = Math.imul(t ^ t >>> 15, t | 1), t ^= t + Math.imul(t ^ t >>> 7, t | 61), ((t ^ t >>> 14) >>> 0) / 4294967296;
  };
}
function Wae(e) {
  const t = Gae(e);
  return (n, r) => n + (r - n) * t();
}
function xN(e) {
  return typeof structuredClone == "function" ? structuredClone(e) : JSON.parse(JSON.stringify(e));
}
const qae = ["item", "applyValue", "type", "apiRef", "focusElementRef", "color", "error", "helperText", "size", "variant"], Kae = ["key"];
function wS(e) {
  const {
    item: t,
    applyValue: n,
    type: r,
    apiRef: o,
    focusElementRef: i,
    color: a,
    error: l,
    helperText: c,
    size: d,
    variant: f = "standard"
  } = e, p = yt(e, qae), g = {
    color: a,
    error: l,
    helperText: c,
    size: d,
    variant: f
  }, [b, v] = m.useState(t.value || []), y = xr(), S = ft();
  m.useEffect(() => {
    const I = t.value ?? [];
    v(I.map(String));
  }, [t.value]);
  const E = m.useCallback((I, O) => {
    v(O.map(String)), n(U({}, t, {
      value: [...O.map((T) => r === "number" ? Number(T) : T)]
    }));
  }, [n, t, r]);
  return /* @__PURE__ */ w.jsx(zp, U({
    multiple: !0,
    freeSolo: !0,
    options: [],
    filterOptions: (I, O) => {
      const {
        inputValue: T
      } = O;
      return T == null || T === "" ? [] : [T];
    },
    id: y,
    value: b,
    onChange: E,
    renderTags: (I, O) => I.map((T, P) => {
      const R = O({
        index: P
      }), {
        key: F
      } = R, A = yt(R, Kae);
      return /* @__PURE__ */ w.jsx(S.slots.baseChip, U({
        variant: "outlined",
        size: "small",
        label: T
      }, A), F);
    }),
    renderInput: (I) => {
      var O;
      return /* @__PURE__ */ w.jsx(S.slots.baseTextField, U({}, I, {
        label: o.current.getLocaleText("filterPanelInputLabel"),
        placeholder: o.current.getLocaleText("filterPanelInputPlaceholder"),
        InputLabelProps: U({}, I.InputLabelProps, {
          shrink: !0
        }),
        inputRef: i,
        type: r || "text"
      }, g, (O = S.slotProps) == null ? void 0 : O.baseTextField));
    }
  }, p));
}
process.env.NODE_ENV !== "production" && (wS.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: s.shape({
    current: s.object.isRequired
  }).isRequired,
  applyValue: s.func.isRequired,
  focusElementRef: s.oneOfType([s.func, s.object]),
  item: s.shape({
    field: s.string.isRequired,
    id: s.oneOfType([s.number, s.string]),
    operator: s.string.isRequired,
    value: s.any
  }).isRequired,
  type: s.oneOf(["date", "datetime-local", "number", "text"])
});
var Us = /* @__PURE__ */ function(e) {
  return e.Cell = "cell", e.Row = "row", e;
}(Us || {}), En = /* @__PURE__ */ function(e) {
  return e.Edit = "edit", e.View = "view", e;
}(En || {}), Dn = /* @__PURE__ */ function(e) {
  return e.Edit = "edit", e.View = "view", e;
}(Dn || {}), Oo = /* @__PURE__ */ function(e) {
  return e.And = "and", e.Or = "or", e;
}(Oo || {}), ca = /* @__PURE__ */ function(e) {
  return e.enterKeyDown = "enterKeyDown", e.cellDoubleClick = "cellDoubleClick", e.printableKeyDown = "printableKeyDown", e.deleteKeyDown = "deleteKeyDown", e.pasteKeyDown = "pasteKeyDown", e;
}(ca || {}), Ki = /* @__PURE__ */ function(e) {
  return e.cellFocusOut = "cellFocusOut", e.escapeKeyDown = "escapeKeyDown", e.enterKeyDown = "enterKeyDown", e.tabKeyDown = "tabKeyDown", e.shiftTabKeyDown = "shiftTabKeyDown", e;
}(Ki || {}), Wa = /* @__PURE__ */ function(e) {
  return e.enterKeyDown = "enterKeyDown", e.cellDoubleClick = "cellDoubleClick", e.printableKeyDown = "printableKeyDown", e.deleteKeyDown = "deleteKeyDown", e;
}(Wa || {}), ms = /* @__PURE__ */ function(e) {
  return e.rowFocusOut = "rowFocusOut", e.escapeKeyDown = "escapeKeyDown", e.enterKeyDown = "enterKeyDown", e.tabKeyDown = "tabKeyDown", e.shiftTabKeyDown = "shiftTabKeyDown", e;
}(ms || {});
function SN(e) {
  return e.field !== void 0;
}
const wp = () => ({
  items: [],
  logicOperator: Oo.And,
  quickFilterValues: [],
  quickFilterLogicOperator: Oo.And
});
function EN(e) {
  return {
    current: e.current.getPublicApi()
  };
}
let xf;
function Yae() {
  if (xf !== void 0)
    return xf;
  try {
    xf = new Function("return true")();
  } catch {
    xf = !1;
  }
  return xf;
}
const Z0 = (e, t) => {
  const n = U({}, e);
  if (n.id == null && (n.id = Math.round(Math.random() * 1e5)), n.operator == null) {
    const r = Oa(t)[n.field];
    n.operator = r && r.filterOperators[0].value;
  }
  return n;
}, CS = (e, t, n) => {
  const r = e.items.length > 1;
  let o;
  r && t ? (process.env.NODE_ENV !== "production" && ns(["MUI X: The `filterModel` can only contain a single item when the `disableMultipleColumnsFiltering` prop is set to `true`.", "If you are using the community version of the Data Grid, this prop is always `true`."], "error"), o = [e.items[0]]) : o = e.items;
  const i = r && o.some((l) => l.id == null), a = o.some((l) => l.operator == null);
  return process.env.NODE_ENV !== "production" && i && ns("MUI X: The `id` field is required on `filterModel.items` when you use multiple filters.", "error"), process.env.NODE_ENV !== "production" && a && ns("MUI X: The `operator` field is required on `filterModel.items`, one or more of your filtering item has no `operator` provided.", "error"), a || i ? U({}, e, {
    items: o.map((l) => Z0(l, n))
  }) : e.items !== o ? U({}, e, {
    items: o
  }) : e;
}, YI = (e, t, n) => (r) => U({}, r, {
  filterModel: CS(e, t, n)
}), Cp = (e) => typeof e == "string" ? e.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : e, TN = (e, t) => {
  var f;
  if (!e.field || !e.operator)
    return null;
  const n = t.current.getColumn(e.field);
  if (!n)
    return null;
  let r;
  if (n.valueParser) {
    const p = n.valueParser;
    r = Array.isArray(e.value) ? (f = e.value) == null ? void 0 : f.map((g) => p(g, void 0, n, t)) : p(e.value, void 0, n, t);
  } else
    r = e.value;
  const {
    ignoreDiacritics: o
  } = t.current.rootProps;
  o && (r = Cp(r));
  const i = U({}, e, {
    value: r
  }), a = n.filterOperators;
  if (!(a != null && a.length))
    throw new Error(`MUI X: No filter operators found for column '${n.field}'.`);
  const l = a.find((p) => p.value === i.operator);
  if (!l)
    throw new Error(`MUI X: No filter operator found for column '${n.field}' and operator value '${i.operator}'.`);
  const c = EN(t), d = l.getApplyFilterFn(i, n);
  return typeof d != "function" ? null : {
    item: i,
    fn: (p) => {
      let g = t.current.getRowValue(p, n);
      return o && (g = Cp(g)), d(g, p, n, c);
    }
  };
};
let QI = 1;
const Qae = (e, t, n) => {
  const {
    items: r
  } = e, o = r.map((l) => TN(l, t)).filter((l) => !!l);
  if (o.length === 0)
    return null;
  if (n || !Yae())
    return (l, c) => {
      const d = {};
      for (let f = 0; f < o.length; f += 1) {
        const p = o[f];
        (!c || c(p.item.field)) && (d[p.item.id] = p.fn(l));
      }
      return d;
    };
  const i = new Function("appliers", "row", "shouldApplyFilter", `"use strict";
${o.map((l, c) => `const shouldApply${c} = !shouldApplyFilter || shouldApplyFilter(${JSON.stringify(l.item.field)});`).join(`
`)}

const result$$ = {
${o.map((l, c) => `  ${JSON.stringify(String(l.item.id))}: !shouldApply${c} ? false : appliers[${c}].fn(row),`).join(`
`)}
};

return result$$;`.replaceAll("$$", String(QI)));
  return QI += 1, (l, c) => i(o, l, c);
}, ON = (e) => e.quickFilterExcludeHiddenColumns ?? !0, Xae = (e, t) => {
  var l;
  const n = ((l = e.quickFilterValues) == null ? void 0 : l.filter(Boolean)) ?? [];
  if (n.length === 0)
    return null;
  const r = ON(e) ? Ad(t) : ha(t), o = [], {
    ignoreDiacritics: i
  } = t.current.rootProps, a = EN(t);
  return r.forEach((c) => {
    const d = t.current.getColumn(c), f = d == null ? void 0 : d.getApplyQuickFilterFn;
    f && o.push({
      column: d,
      appliers: n.map((p) => {
        const g = i ? Cp(p) : p;
        return {
          fn: f(g, d, a)
        };
      })
    });
  }), function(d, f) {
    const p = {};
    e: for (let g = 0; g < n.length; g += 1) {
      const b = n[g];
      for (let v = 0; v < o.length; v += 1) {
        const {
          column: y,
          appliers: S
        } = o[v], {
          field: E
        } = y;
        if (f && !f(E))
          continue;
        const I = S[g];
        let O = t.current.getRowValue(d, y);
        if (I.fn === null)
          continue;
        if (i && (O = Cp(O)), I.fn(O, d, y, a)) {
          p[b] = !0;
          continue e;
        }
      }
      p[b] = !1;
    }
    return p;
  };
}, Jae = (e, t, n) => {
  const r = Qae(e, t, n), o = Xae(e, t);
  return function(a, l, c) {
    c.passingFilterItems = (r == null ? void 0 : r(a, l)) ?? null, c.passingQuickFilterValues = (o == null ? void 0 : o(a, l)) ?? null;
  };
}, XI = (e) => e != null, Zae = (e, t, n) => (e.cleanedFilterItems || (e.cleanedFilterItems = n.filter((r) => TN(r, t) !== null)), e.cleanedFilterItems), ele = (e, t, n, r, o) => {
  const i = Zae(o, r, n.items), a = e.filter(XI), l = t.filter(XI);
  if (a.length > 0) {
    const c = (f) => a.some((p) => p[f.id]);
    if ((n.logicOperator ?? wp().logicOperator) === Oo.And) {
      if (!i.every(c))
        return !1;
    } else if (!i.some(c))
      return !1;
  }
  if (l.length > 0 && n.quickFilterValues != null) {
    const c = (f) => l.some((p) => p[f]);
    if ((n.quickFilterLogicOperator ?? wp().quickFilterLogicOperator) === Oo.And) {
      if (!n.quickFilterValues.every(c))
        return !1;
    } else if (!n.quickFilterValues.some(c))
      return !1;
  }
  return !0;
}, tle = (e) => {
  if (!e)
    return null;
  const t = new RegExp(Mm(e), "i");
  return (n, r, o, i) => {
    let a = i.current.getRowFormattedValue(r, o);
    return i.current.ignoreDiacritics && (a = Cp(a)), a != null ? t.test(a.toString()) : !1;
  };
}, JI = (e, t) => (n) => {
  if (!n.value)
    return null;
  const r = e ? n.value : n.value.trim(), o = new RegExp(Mm(r), "i");
  return (i) => {
    if (i == null)
      return t;
    const a = o.test(String(i));
    return t ? !a : a;
  };
}, ZI = (e, t) => (n) => {
  if (!n.value)
    return null;
  const r = e ? n.value : n.value.trim(), o = new Intl.Collator(void 0, {
    sensitivity: "base",
    usage: "search"
  });
  return (i) => {
    if (i == null)
      return t;
    const a = o.compare(r, i.toString()) === 0;
    return t ? !a : a;
  };
}, eR = (e) => () => (t) => {
  const n = t === "" || t == null;
  return e ? !n : n;
}, nle = (e = !1) => [{
  value: "contains",
  getApplyFilterFn: JI(e, !1),
  InputComponent: ii
}, {
  value: "doesNotContain",
  getApplyFilterFn: JI(e, !0),
  InputComponent: ii
}, {
  value: "equals",
  getApplyFilterFn: ZI(e, !1),
  InputComponent: ii
}, {
  value: "doesNotEqual",
  getApplyFilterFn: ZI(e, !0),
  InputComponent: ii
}, {
  value: "startsWith",
  getApplyFilterFn: (t) => {
    if (!t.value)
      return null;
    const n = e ? t.value : t.value.trim(), r = new RegExp(`^${Mm(n)}.*$`, "i");
    return (o) => o != null ? r.test(o.toString()) : !1;
  },
  InputComponent: ii
}, {
  value: "endsWith",
  getApplyFilterFn: (t) => {
    if (!t.value)
      return null;
    const n = e ? t.value : t.value.trim(), r = new RegExp(`.*${Mm(n)}$`, "i");
    return (o) => o != null ? r.test(o.toString()) : !1;
  },
  InputComponent: ii
}, {
  value: "isEmpty",
  getApplyFilterFn: eR(!1),
  requiresFilterValue: !1
}, {
  value: "isNotEmpty",
  getApplyFilterFn: eR(!0),
  requiresFilterValue: !1
}, {
  value: "isAnyOf",
  getApplyFilterFn: (t) => {
    if (!Array.isArray(t.value) || t.value.length === 0)
      return null;
    const n = e ? t.value : t.value.map((o) => o.trim()), r = new Intl.Collator(void 0, {
      sensitivity: "base",
      usage: "search"
    });
    return (o) => o != null ? n.some((i) => r.compare(i, o.toString() || "") === 0) : !1;
  },
  InputComponent: wS
}], os = {
  width: 100,
  minWidth: 50,
  maxWidth: 1 / 0,
  hideable: !0,
  sortable: !0,
  resizable: !0,
  filterable: !0,
  groupable: !0,
  pinnable: !0,
  // @ts-ignore
  aggregable: !0,
  editable: !1,
  sortComparator: Hae,
  type: "string",
  align: "left",
  filterOperators: nle(),
  renderEditCell: Fae,
  getApplyQuickFilterFn: tle
}, rle = ["open", "target", "onClose", "children", "position", "className", "onExited"], ole = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["menu"]
  }, nn, t);
}, ile = oe(Pl, {
  name: "MuiDataGrid",
  slot: "Menu",
  overridesResolver: (e, t) => t.menu
})(({
  theme: e
}) => ({
  zIndex: e.zIndex.modal,
  [`& .${ee.menuList}`]: {
    outline: 0
  }
})), sle = {
  "bottom-start": "top left",
  "bottom-end": "top right"
};
function ty(e) {
  var y;
  const {
    open: t,
    target: n,
    onClose: r,
    children: o,
    position: i,
    className: a,
    onExited: l
  } = e, c = yt(e, rle), d = Wt(), f = ft(), p = ole(f), g = m.useRef(null);
  Zr(() => {
    var S, E;
    t ? g.current = document.activeElement instanceof HTMLElement ? document.activeElement : null : ((E = (S = g.current) == null ? void 0 : S.focus) == null || E.call(S), g.current = null);
  }, [t]), m.useEffect(() => {
    const S = t ? "menuOpen" : "menuClose";
    d.current.publishEvent(S, {
      target: n
    });
  }, [d, t, n]);
  const b = (S) => (E) => {
    S && S(), l && l(E);
  }, v = (S) => {
    S.target && (n === S.target || n != null && n.contains(S.target)) || r(S);
  };
  return /* @__PURE__ */ w.jsx(ile, U({
    as: f.slots.basePopper,
    className: ke(p.root, a),
    ownerState: f,
    open: t,
    anchorEl: n,
    transition: !0,
    placement: i
  }, c, (y = f.slotProps) == null ? void 0 : y.basePopper, {
    children: ({
      TransitionProps: S,
      placement: E
    }) => /* @__PURE__ */ w.jsx(lp, {
      onClickAway: v,
      mouseEvent: "onMouseDown",
      children: /* @__PURE__ */ w.jsx(hd, U({}, S, {
        style: {
          transformOrigin: sle[E]
        },
        onExited: b(S == null ? void 0 : S.onExited),
        children: /* @__PURE__ */ w.jsx(cs, {
          children: o
        })
      }))
    })
  }));
}
process.env.NODE_ENV !== "production" && (ty.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: s.node,
  onClose: s.func.isRequired,
  onExited: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  position: s.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  target: YM
});
const ale = ["api", "colDef", "id", "hasFocus", "isEditable", "field", "value", "formattedValue", "row", "rowNode", "cellMode", "tabIndex", "position", "focusElementRef"], lle = (e) => typeof e.getActions == "function";
function PN(e) {
  var N;
  const {
    colDef: t,
    id: n,
    hasFocus: r,
    tabIndex: o,
    position: i = "bottom-end",
    focusElementRef: a
  } = e, l = yt(e, ale), [c, d] = m.useState(-1), [f, p] = m.useState(!1), g = Wt(), b = m.useRef(null), v = m.useRef(null), y = m.useRef(!1), S = m.useRef({}), E = mi(), I = xr(), O = xr(), T = ft();
  if (!lle(t))
    throw new Error("MUI X: Missing the `getActions` property in the `GridColDef`.");
  const P = t.getActions(g.current.getRowParams(n)), R = P.filter((j) => !j.props.showInMenu), F = P.filter((j) => j.props.showInMenu), A = R.length + (F.length ? 1 : 0);
  m.useLayoutEffect(() => {
    r || Object.entries(S.current).forEach(([j, W]) => {
      W == null || W.stop({}, () => {
        delete S.current[j];
      });
    });
  }, [r]), m.useEffect(() => {
    if (c < 0 || !b.current || c >= b.current.children.length)
      return;
    b.current.children[c].focus({
      preventScroll: !0
    });
  }, [c]), m.useEffect(() => {
    r || (d(-1), y.current = !1);
  }, [r]), m.useImperativeHandle(a, () => ({
    focus() {
      if (!y.current) {
        const j = P.findIndex((W) => !W.props.disabled);
        d(j);
      }
    }
  }), [P]), m.useEffect(() => {
    c >= A && d(A - 1);
  }, [c, A]);
  const _ = () => {
    p(!0), d(A - 1), y.current = !0;
  }, C = () => {
    p(!1);
  }, D = () => {
    f ? C() : _();
  }, L = (j) => (W) => {
    S.current[j] = W;
  }, B = (j, W) => (V) => {
    d(j), y.current = !0, W && W(V);
  }, H = (j) => {
    if (A <= 1)
      return;
    const W = ($, z) => {
      var Q;
      if ($ < 0 || $ > P.length)
        return $;
      const K = (z === "left" ? -1 : 1) * (E ? -1 : 1);
      return (Q = P[$ + K]) != null && Q.props.disabled ? W($ + K, z) : $ + K;
    };
    let V = c;
    j.key === "ArrowRight" ? V = W(c, "right") : j.key === "ArrowLeft" && (V = W(c, "left")), !(V < 0 || V >= A) && V !== c && (j.preventDefault(), j.stopPropagation(), d(V));
  }, k = (j) => {
    j.key === "Tab" && j.preventDefault(), ["Tab", "Escape"].includes(j.key) && C();
  };
  return /* @__PURE__ */ w.jsxs("div", U({
    role: "menu",
    ref: b,
    tabIndex: -1,
    className: ee.actionsCell,
    onKeyDown: H
  }, l, {
    children: [R.map((j, W) => /* @__PURE__ */ m.cloneElement(j, {
      key: W,
      touchRippleRef: L(W),
      onClick: B(W, j.props.onClick),
      tabIndex: c === W ? o : -1
    })), F.length > 0 && O && /* @__PURE__ */ w.jsx(T.slots.baseIconButton, U({
      ref: v,
      id: O,
      "aria-label": g.current.getLocaleText("actionsCellMore"),
      "aria-haspopup": "menu",
      "aria-expanded": f,
      "aria-controls": f ? I : void 0,
      role: "menuitem",
      size: "small",
      onClick: D,
      touchRippleRef: L(O),
      tabIndex: c === R.length ? o : -1
    }, (N = T.slotProps) == null ? void 0 : N.baseIconButton, {
      children: /* @__PURE__ */ w.jsx(T.slots.moreActionsIcon, {
        fontSize: "small"
      })
    })), F.length > 0 && /* @__PURE__ */ w.jsx(ty, {
      open: f,
      target: v.current,
      position: i,
      onClose: C,
      children: /* @__PURE__ */ w.jsx(qp, {
        id: I,
        className: ee.menuList,
        onKeyDown: k,
        "aria-labelledby": O,
        variant: "menu",
        autoFocusItem: !0,
        children: F.map((j, W) => /* @__PURE__ */ m.cloneElement(j, {
          key: W,
          closeMenu: C
        }))
      })
    })]
  }));
}
process.env.NODE_ENV !== "production" && (PN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  api: s.object,
  /**
   * The mode of the cell.
   */
  cellMode: s.oneOf(["edit", "view"]).isRequired,
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: s.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: s.string.isRequired,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the element that should receive focus.
   * @ignore - do not document.
   */
  focusElementRef: s.oneOfType([s.func, s.shape({
    current: s.shape({
      focus: s.func.isRequired
    })
  })]),
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: s.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: s.bool.isRequired,
  /**
   * The grid row id.
   */
  id: s.oneOfType([s.number, s.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: s.bool,
  position: s.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: s.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: s.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: s.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: s.any
});
const cle = (e) => /* @__PURE__ */ w.jsx(PN, U({}, e)), ny = "actions", ule = U({}, os, {
  sortable: !1,
  filterable: !1,
  // @ts-ignore
  aggregable: !1,
  width: 100,
  display: "flex",
  align: "center",
  headerAlign: "center",
  headerName: "",
  disableColumnMenu: !0,
  disableExport: !0,
  renderCell: cle,
  getApplyQuickFilterFn: void 0
}), Vi = (e) => e.rows, ry = Mt(Vi, (e) => e.totalRowCount), dle = Mt(Vi, (e) => e.loading), fle = Mt(Vi, (e) => e.totalTopLevelRowCount), cl = Mt(Vi, (e) => e.dataRowIdToModelLookup), Am = Mt(Vi, (e) => e.dataRowIdToIdLookup), so = Mt(Vi, (e) => e.tree), ple = Mt(Vi, (e) => e.groupsToFetch), hle = Mt(Vi, (e) => e.groupingName), tR = Mt(Vi, (e) => e.treeDepths), Dd = Pn(Vi, (e) => {
  const t = Object.entries(e.treeDepths);
  return t.length === 0 ? 1 : t.filter(([, n]) => n > 0).map(([n]) => Number(n)).sort((n, r) => r - n)[0] + 1;
}), Og = Mt(Vi, (e) => e.dataRowIds), gle = Mt(Vi, (e) => e == null ? void 0 : e.additionalRowGroups), Nc = Pn(gle, (e) => {
  var n, r;
  const t = e == null ? void 0 : e.pinnedRows;
  return {
    bottom: ((n = t == null ? void 0 : t.bottom) == null ? void 0 : n.map((o) => ({
      id: o.id,
      model: o.model ?? {}
    }))) ?? [],
    top: ((r = t == null ? void 0 : t.top) == null ? void 0 : r.map((o) => ({
      id: o.id,
      model: o.model ?? {}
    }))) ?? []
  };
}), IN = Mt(Nc, (e) => {
  var t, n;
  return (((t = e == null ? void 0 : e.top) == null ? void 0 : t.length) || 0) + (((n = e == null ? void 0 : e.bottom) == null ? void 0 : n.length) || 0);
}), ao = "auto-generated-group-node-root", Hu = Symbol("mui.id_autogenerated"), mle = () => ({
  type: "group",
  id: ao,
  depth: -1,
  groupingField: null,
  groupingKey: null,
  isAutoGenerated: !0,
  children: [],
  childrenFromPath: {},
  childrenExpanded: !0,
  parent: null
});
function ble(e, t, n = "A row was provided without id in the rows prop:") {
  if (e == null)
    throw new Error(["MUI X: The Data Grid component requires all rows to have a unique `id` property.", "Alternatively, you can use the `getRowId` prop to specify a custom id for each row.", n, JSON.stringify(t)].join(`
`));
}
const oy = (e, t, n) => {
  const r = t ? t(e) : e.id;
  return ble(r, e, n), r;
}, qg = ({
  rows: e,
  getRowId: t,
  loading: n,
  rowCount: r
}) => {
  const o = {
    type: "full",
    rows: []
  }, i = {}, a = {};
  for (let l = 0; l < e.length; l += 1) {
    const c = e[l], d = oy(c, t);
    i[d] = c, a[d] = d, o.rows.push(d);
  }
  return {
    rowsBeforePartialUpdates: e,
    loadingPropBeforePartialUpdates: n,
    rowCountPropBeforePartialUpdates: r,
    updates: o,
    dataRowIdToIdLookup: a,
    dataRowIdToModelLookup: i
  };
}, RN = ({
  tree: e,
  rowCountProp: t = 0
}) => {
  const n = e[ao];
  return Math.max(t, n.children.length + (n.footerId == null ? 0 : 1));
}, _N = ({
  apiRef: e,
  rowCountProp: t = 0,
  loadingProp: n,
  previousTree: r,
  previousTreeDepths: o,
  previousGroupsToFetch: i
}) => {
  const a = e.current.caches.rows, {
    tree: l,
    treeDepths: c,
    dataRowIds: d,
    groupingName: f,
    groupsToFetch: p = []
  } = e.current.applyStrategyProcessor("rowTreeCreation", {
    previousTree: r,
    previousTreeDepths: o,
    updates: a.updates,
    dataRowIdToIdLookup: a.dataRowIdToIdLookup,
    dataRowIdToModelLookup: a.dataRowIdToModelLookup,
    previousGroupsToFetch: i
  }), g = e.current.unstable_applyPipeProcessors("hydrateRows", {
    tree: l,
    treeDepths: c,
    dataRowIdToIdLookup: a.dataRowIdToIdLookup,
    dataRowIds: d,
    dataRowIdToModelLookup: a.dataRowIdToModelLookup
  });
  return e.current.caches.rows.updates = {
    type: "partial",
    actions: {
      insert: [],
      modify: [],
      remove: []
    },
    idToActionLookup: {}
  }, U({}, g, {
    totalRowCount: Math.max(t, g.dataRowIds.length),
    totalTopLevelRowCount: RN({
      tree: g.tree,
      rowCountProp: t
    }),
    groupingName: f,
    loading: n,
    groupsToFetch: p
  });
}, vd = (e) => e.type === "skeletonRow" || e.type === "footer" || e.type === "group" && e.isAutoGenerated || e.type === "pinnedRow" && e.isAutoGenerated, xS = (e, t, n) => {
  const r = e[t];
  if (r.type !== "group")
    return [];
  const o = [];
  for (let i = 0; i < r.children.length; i += 1) {
    const a = r.children[i];
    (!n || !vd(e[a])) && o.push(a);
    const l = xS(e, a, n);
    for (let c = 0; c < l.length; c += 1)
      o.push(l[c]);
  }
  return !n && r.footerId != null && o.push(r.footerId), o;
}, nR = ({
  previousCache: e,
  getRowId: t,
  updates: n,
  groupKeys: r
}) => {
  if (e.updates.type === "full")
    throw new Error("MUI X: Unable to prepare a partial update if a full update is not applied yet.");
  const o = /* @__PURE__ */ new Map();
  n.forEach((f) => {
    const p = oy(f, t, "A row was provided without id when calling updateRows():");
    o.has(p) ? o.set(p, U({}, o.get(p), f)) : o.set(p, f);
  });
  const i = {
    type: "partial",
    actions: {
      insert: [...e.updates.actions.insert ?? []],
      modify: [...e.updates.actions.modify ?? []],
      remove: [...e.updates.actions.remove ?? []]
    },
    idToActionLookup: U({}, e.updates.idToActionLookup),
    groupKeys: r
  }, a = U({}, e.dataRowIdToModelLookup), l = U({}, e.dataRowIdToIdLookup), c = {
    insert: {},
    modify: {},
    remove: {}
  };
  o.forEach((f, p) => {
    const g = i.idToActionLookup[p];
    if (f._action === "delete") {
      if (g === "remove" || !a[p])
        return;
      g != null && (c[g][p] = !0), i.actions.remove.push(p), delete a[p], delete l[p];
      return;
    }
    const b = a[p];
    if (b) {
      g === "remove" ? (c.remove[p] = !0, i.actions.modify.push(p)) : g == null && i.actions.modify.push(p), a[p] = U({}, b, f);
      return;
    }
    g === "remove" ? (c.remove[p] = !0, i.actions.insert.push(p)) : g == null && i.actions.insert.push(p), a[p] = f, l[p] = p;
  });
  const d = Object.keys(c);
  for (let f = 0; f < d.length; f += 1) {
    const p = d[f], g = c[p];
    Object.keys(g).length > 0 && (i.actions[p] = i.actions[p].filter((b) => !g[b]));
  }
  return {
    dataRowIdToModelLookup: a,
    dataRowIdToIdLookup: l,
    updates: i,
    rowsBeforePartialUpdates: e.rowsBeforePartialUpdates,
    loadingPropBeforePartialUpdates: e.loadingPropBeforePartialUpdates,
    rowCountPropBeforePartialUpdates: e.rowCountPropBeforePartialUpdates
  };
};
function yle(e) {
  var o, i;
  const t = Nc(e), n = ((o = t == null ? void 0 : t.top) == null ? void 0 : o.reduce((a, l) => (a += e.current.unstable_getRowHeight(l.id), a), 0)) || 0, r = ((i = t == null ? void 0 : t.bottom) == null ? void 0 : i.reduce((a, l) => (a += e.current.unstable_getRowHeight(l.id), a), 0)) || 0;
  return {
    top: n,
    bottom: r
  };
}
const kN = "var(--DataGrid-overlayHeight, calc(var(--height) * 2))";
function rR(e, t, n) {
  const r = [];
  return t.forEach((o) => {
    const i = oy(o, n, "A row was provided without id when calling updateRows():"), a = e.current.getRowNode(i);
    if ((a == null ? void 0 : a.type) === "pinnedRow") {
      const l = e.current.caches.pinnedRows, c = l.idLookup[i];
      c && (l.idLookup[i] = U({}, c, o));
    } else
      r.push(o);
  }), r;
}
let oR = !1;
const MN = (e, t, n) => typeof e == "number" && e > 0 ? e : (process.env.NODE_ENV !== "production" && !oR && typeof e < "u" && e !== null && (console.warn(n), oR = !0), t), vle = ["MUI X: The `rowHeight` prop should be a number greater than 0.", "The default value will be used instead."].join(`
`), wle = ["MUI X: The `getRowHeight` prop should return a number greater than 0 or 'auto'.", "The default value will be used instead."].join(`
`), Cle = "__tree_data_group__", AN = "__row_group_by_columns_group__", iy = "__detail_panel_toggle__", xle = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "hasFocus", "tabIndex", "hideDescendantCount"], Sle = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["booleanCell"]
  }, nn, t);
};
function DN(e) {
  const {
    value: t,
    rowNode: n
  } = e, r = yt(e, xle), o = Wt(), i = ft(), a = {
    classes: i.classes
  }, l = Sle(a), d = (
    // @ts-expect-error - Access tree data prop
    Be(o, Dd) > 0 && n.type === "group" && i.treeData === !1
  ), f = m.useMemo(() => t ? i.slots.booleanCellTrueIcon : i.slots.booleanCellFalseIcon, [i.slots.booleanCellFalseIcon, i.slots.booleanCellTrueIcon, t]);
  return d && t === void 0 ? null : /* @__PURE__ */ w.jsx(f, U({
    fontSize: "small",
    className: l.root,
    titleAccess: o.current.getLocaleText(t ? "booleanCellTrueLabel" : "booleanCellFalseLabel"),
    "data-value": !!t
  }, r));
}
process.env.NODE_ENV !== "production" && (DN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: s.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: s.oneOf(["edit", "view"]).isRequired,
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: s.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: s.string.isRequired,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the element that should receive focus.
   * @ignore - do not document.
   */
  focusElementRef: s.oneOfType([s.func, s.shape({
    current: s.shape({
      focus: s.func.isRequired
    })
  })]),
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: s.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: s.bool.isRequired,
  hideDescendantCount: s.bool,
  /**
   * The grid row id.
   */
  id: s.oneOfType([s.number, s.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: s.bool,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: s.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: s.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: s.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: s.any
});
const Ele = /* @__PURE__ */ m.memo(DN), Tle = (e) => e.field !== AN && vd(e.rowNode) ? "" : /* @__PURE__ */ w.jsx(Ele, U({}, e)), Ole = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "className", "hasFocus", "isValidating", "isProcessingProps", "error", "onValueChange"], Ple = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["editBooleanCell"]
  }, nn, t);
};
function NN(e) {
  var E;
  const {
    id: t,
    value: n,
    field: r,
    className: o,
    hasFocus: i,
    onValueChange: a
  } = e, l = yt(e, Ole), c = Wt(), d = m.useRef(null), f = xr(), [p, g] = m.useState(n), b = ft(), v = {
    classes: b.classes
  }, y = Ple(v), S = m.useCallback(async (I) => {
    const O = I.target.checked;
    a && await a(I, O), g(O), await c.current.setEditCellValue({
      id: t,
      field: r,
      value: O
    }, I);
  }, [c, r, t, a]);
  return m.useEffect(() => {
    g(n);
  }, [n]), Zr(() => {
    i && d.current.focus();
  }, [i]), /* @__PURE__ */ w.jsx("label", U({
    htmlFor: f,
    className: ke(y.root, o)
  }, l, {
    children: /* @__PURE__ */ w.jsx(b.slots.baseCheckbox, U({
      id: f,
      inputRef: d,
      checked: !!p,
      onChange: S,
      size: "small"
    }, (E = b.slotProps) == null ? void 0 : E.baseCheckbox))
  }));
}
process.env.NODE_ENV !== "production" && (NN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: s.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: s.oneOf(["edit", "view"]).isRequired,
  changeReason: s.oneOf(["debouncedSetEditCellValue", "setEditCellValue"]),
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: s.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: s.string.isRequired,
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: s.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: s.bool.isRequired,
  /**
   * The grid row id.
   */
  id: s.oneOfType([s.number, s.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: s.bool,
  isProcessingProps: s.bool,
  isValidating: s.bool,
  /**
   * Callback called when the value is changed by the user.
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {boolean} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */
  onValueChange: s.func,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: s.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: s.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: s.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: s.any
});
const Ile = (e) => /* @__PURE__ */ w.jsx(NN, U({}, e)), Rle = ["item", "applyValue", "apiRef", "focusElementRef", "isFilterActive", "clearButton", "tabIndex", "label", "variant", "InputLabelProps"], Kg = (e) => {
  if (String(e).toLowerCase() === "true")
    return !0;
  if (String(e).toLowerCase() === "false")
    return !1;
}, _le = oe("div")({
  display: "flex",
  alignItems: "center",
  width: "100%",
  "& button": {
    margin: "auto 0px 5px 5px"
  }
});
function FN(e) {
  var T, P, R;
  const {
    item: t,
    applyValue: n,
    apiRef: r,
    focusElementRef: o,
    clearButton: i,
    tabIndex: a,
    label: l,
    variant: c = "standard"
  } = e, d = yt(e, Rle), [f, p] = m.useState(Kg(t.value)), g = ft(), b = xr(), v = xr(), y = ((T = g.slotProps) == null ? void 0 : T.baseSelect) || {}, S = y.native ?? !1, E = ((P = g.slotProps) == null ? void 0 : P.baseSelectOption) || {}, I = m.useCallback((F) => {
    const A = Kg(F.target.value);
    p(A), n(U({}, t, {
      value: A
    }));
  }, [n, t]);
  m.useEffect(() => {
    p(Kg(t.value));
  }, [t.value]);
  const O = l ?? r.current.getLocaleText("filterPanelInputLabel");
  return /* @__PURE__ */ w.jsxs(_le, {
    children: [/* @__PURE__ */ w.jsxs(g.slots.baseFormControl, {
      fullWidth: !0,
      children: [/* @__PURE__ */ w.jsx(g.slots.baseInputLabel, U({}, (R = g.slotProps) == null ? void 0 : R.baseInputLabel, {
        id: b,
        shrink: !0,
        variant: c,
        children: O
      })), /* @__PURE__ */ w.jsxs(g.slots.baseSelect, U({
        labelId: b,
        id: v,
        label: O,
        value: f === void 0 ? "" : String(f),
        onChange: I,
        variant: c,
        notched: c === "outlined" ? !0 : void 0,
        native: S,
        displayEmpty: !0,
        inputProps: {
          ref: o,
          tabIndex: a
        }
      }, d, y, {
        children: [/* @__PURE__ */ w.jsx(g.slots.baseSelectOption, U({}, E, {
          native: S,
          value: "",
          children: r.current.getLocaleText("filterValueAny")
        })), /* @__PURE__ */ w.jsx(g.slots.baseSelectOption, U({}, E, {
          native: S,
          value: "true",
          children: r.current.getLocaleText("filterValueTrue")
        })), /* @__PURE__ */ w.jsx(g.slots.baseSelectOption, U({}, E, {
          native: S,
          value: "false",
          children: r.current.getLocaleText("filterValueFalse")
        }))]
      }))]
    }), i]
  });
}
process.env.NODE_ENV !== "production" && (FN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: s.shape({
    current: s.object.isRequired
  }).isRequired,
  applyValue: s.func.isRequired,
  clearButton: s.node,
  focusElementRef: oX,
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (for example `isEmpty`)
   */
  isFilterActive: s.bool,
  item: s.shape({
    field: s.string.isRequired,
    id: s.oneOfType([s.number, s.string]),
    operator: s.string.isRequired,
    value: s.any
  }).isRequired
});
const kle = () => [{
  value: "is",
  getApplyFilterFn: (e) => {
    const t = Kg(e.value);
    return t === void 0 ? null : (n) => !!n === t;
  },
  InputComponent: FN
}], Mle = (e, t, n, r) => e ? r.current.getLocaleText("booleanCellTrueLabel") : r.current.getLocaleText("booleanCellFalseLabel"), Ale = (e) => {
  switch (e.toLowerCase().trim()) {
    case "true":
    case "yes":
    case "1":
      return !0;
    case "false":
    case "no":
    case "0":
    case "null":
    case "undefined":
      return !1;
    default:
      return;
  }
}, $N = U({}, os, {
  type: "boolean",
  display: "flex",
  align: "center",
  headerAlign: "center",
  renderCell: Tle,
  renderEditCell: Ile,
  sortComparator: yN,
  valueFormatter: Mle,
  filterOperators: kle(),
  getApplyQuickFilterFn: void 0,
  // @ts-ignore
  aggregable: !1,
  // @ts-ignore
  pastedValueParser: (e) => Ale(e)
}), LN = (e) => e.sorting, Nd = Mt(LN, (e) => e.sortedRows), SS = Pn(Nd, cl, so, (e, t, n) => e.reduce((r, o) => {
  const i = t[o];
  i && r.push({
    id: o,
    model: i
  });
  const a = n[o];
  return a && vd(a) && r.push({
    id: o,
    model: {
      [Hu]: o
    }
  }), r;
}, [])), Ii = Mt(LN, (e) => e.sortModel), Dle = Pn(Ii, (e) => e.reduce((n, r, o) => (n[r.field] = {
  sortDirection: r.sort,
  sortIndex: e.length > 1 ? o + 1 : void 0
}, n), {}));
Pn(Nd, (e) => e.reduce((t, n, r) => (t[n] = r, t), /* @__PURE__ */ Object.create(null)));
const sy = (e) => e.filter, ro = Mt(sy, (e) => e.filterModel);
Mt(ro, (e) => e.quickFilterValues);
const Nle = (e) => e.visibleRowsLookup, Fd = Mt(sy, (e) => e.filteredRowsLookup);
Mt(sy, (e) => e.filteredChildrenCountLookup);
Mt(sy, (e) => e.filteredDescendantCountLookup);
const Fl = Pn(Nle, SS, (e, t) => t.filter((n) => e[n.id] !== !1)), Uu = Pn(Fl, (e) => e.map((t) => t.id)), jN = Pn(Fd, SS, (e, t) => t.filter((n) => e[n.id] !== !1)), BN = Pn(jN, (e) => e.map((t) => t.id));
Pn(Uu, so, (e, t) => {
  const n = {};
  let r = 0;
  return e.reduce((o, i) => {
    const a = t[i];
    return n[a.depth] || (n[a.depth] = 0), a.depth > r && (n[a.depth] = 0), r = a.depth, n[a.depth] += 1, o[i] = n[a.depth], o;
  }, {});
});
const VN = Pn(Fl, so, Dd, (e, t, n) => n < 2 ? e : e.filter((r) => {
  var o;
  return ((o = t[r.id]) == null ? void 0 : o.depth) === 0;
})), ES = Mt(Fl, (e) => e.length), TS = Mt(VN, (e) => e.length), Fle = Mt(jN, (e) => e.length);
Mt(Fle, TS, (e, t) => e - t);
const $le = Pn(ro, Oa, (e, t) => {
  var n;
  return (n = e.items) == null ? void 0 : n.filter((r) => {
    var a, l;
    if (!r.field)
      return !1;
    const o = t[r.field];
    if (!(o != null && o.filterOperators) || ((a = o == null ? void 0 : o.filterOperators) == null ? void 0 : a.length) === 0)
      return !1;
    const i = o.filterOperators.find((c) => c.value === r.operator);
    return i ? !i.InputComponent || r.value != null && ((l = r.value) == null ? void 0 : l.toString()) !== "" : !1;
  });
}), Lle = Pn($le, (e) => e.reduce((n, r) => (n[r.field] ? n[r.field].push(r) : n[r.field] = [r], n), {})), Ri = (e) => e.rowSelection, jle = Mt(Ri, (e) => e.length), Ble = Pn(Ri, cl, (e, t) => new Map(e.map((n) => [n, t[n]]))), ga = Pn(Ri, (e) => e.reduce((t, n) => (t[n] = n, t), {}));
function HN(e, t) {
  var c;
  const n = so(e), r = Nd(e), o = Fd(e), i = n[t];
  if (!i || i.type !== "group")
    return [];
  const a = [], l = r.findIndex((d) => d === t) + 1;
  for (let d = l; d < r.length && ((c = n[r[d]]) == null ? void 0 : c.depth) > i.depth; d += 1) {
    const f = r[d];
    o[f] !== !1 && e.current.isRowSelectable(f) && a.push(f);
  }
  return a;
}
function Vle(e, t) {
  return Mt(so, Nd, Fd, ga, (n, r, o, i) => {
    var f;
    const a = n[e];
    if (!a || a.type !== "group")
      return {
        isIndeterminate: !1,
        isChecked: i[e] === e
      };
    if (i[e] === e)
      return {
        isIndeterminate: !1,
        isChecked: !0
      };
    let l = 0, c = 0;
    const d = r.findIndex((p) => p === e) + 1;
    for (let p = d; p < r.length && ((f = n[r[p]]) == null ? void 0 : f.depth) > a.depth; p += 1) {
      const g = r[p];
      o[g] !== !1 && (l += 1, i[g] !== void 0 && (c += 1));
    }
    return {
      isIndeterminate: c > 0 && (c < l || i[e] === void 0),
      isChecked: t ? c > 0 : i[e] === e
    };
  });
}
function OS(e) {
  return e.signature === di.DataGrid ? e.checkboxSelection && e.disableMultipleRowSelection !== !0 : !e.disableMultipleRowSelection;
}
const Hle = (e, t) => {
  const n = [];
  let r = t;
  for (; r != null && r !== ao; ) {
    const o = e[r];
    if (!o)
      return n;
    n.push(r), r = o.parent;
  }
  return n;
}, Ule = (e, t, n) => {
  const r = e[n];
  if (!r)
    return [];
  const o = r.parent;
  return o == null ? [] : e[o].children.filter((a) => a !== n && t[a]);
}, Pg = (e, t, n, r, o, i) => {
  const a = Fd(e), l = ga(e), c = /* @__PURE__ */ new Set([]);
  if (!(!r && !o)) {
    if (r) {
      const d = t[n];
      (d == null ? void 0 : d.type) === "group" && HN(e, n).forEach((p) => {
        i(p), c.add(p);
      });
    }
    if (o) {
      const d = (p) => {
        if (l[p] !== p && !c.has(p))
          return !1;
        const g = t[p];
        return (g == null ? void 0 : g.type) !== "group" ? !0 : g.children.every(d);
      }, f = (p) => {
        const g = Ule(t, a, p);
        if (g.length === 0 || g.every(d)) {
          const v = t[p].parent;
          v != null && v !== ao && e.current.isRowSelectable(v) && (i(v), c.add(v), f(v));
        }
      };
      f(n);
    }
  }
}, iR = (e, t, n, r, o, i) => {
  const a = ga(e);
  if (!(!o && !r) && (o && Hle(t, n).forEach((c) => {
    a[c] === c && i(c);
  }), r)) {
    const l = t[n];
    (l == null ? void 0 : l.type) === "group" && HN(e, n).forEach((d) => {
      i(d);
    });
  }
}, zle = ["field", "id", "formattedValue", "row", "rowNode", "colDef", "isEditable", "cellMode", "hasFocus", "tabIndex", "api"], Gle = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["checkboxInput"]
  }, nn, t);
}, UN = dn(function(t, n) {
  var A, _;
  const {
    field: r,
    id: o,
    rowNode: i,
    hasFocus: a,
    tabIndex: l
  } = t, c = yt(t, zle), d = Wt(), f = ft(), p = {
    classes: f.classes
  }, g = Gle(p), b = m.useRef(null), v = m.useRef(null), y = Rl(b, n), S = (C) => {
    const D = {
      value: C.target.checked,
      id: o
    };
    d.current.publishEvent("rowSelectionCheckboxChange", D, C);
  };
  m.useLayoutEffect(() => {
    if (l === 0) {
      const C = d.current.getCellElement(o, r);
      C && (C.tabIndex = -1);
    }
  }, [d, l, o, r]), m.useEffect(() => {
    var C;
    if (a) {
      const D = (C = b.current) == null ? void 0 : C.querySelector("input");
      D == null || D.focus({
        preventScroll: !0
      });
    } else v.current && v.current.stop({});
  }, [a]);
  const E = m.useCallback((C) => {
    C.key === " " && C.stopPropagation();
  }, []), I = d.current.isRowSelectable(o), O = Vle(o, ((A = f.rowSelectionPropagation) == null ? void 0 : A.parents) ?? !1), {
    isIndeterminate: T,
    isChecked: P
  } = Be(d, O);
  if (i.type === "footer" || i.type === "pinnedRow")
    return null;
  const R = f.indeterminateCheckboxAction === "select" ? P && !T : P, F = d.current.getLocaleText(R ? "checkboxSelectionUnselectRow" : "checkboxSelectionSelectRow");
  return /* @__PURE__ */ w.jsx(f.slots.baseCheckbox, U({
    tabIndex: l,
    checked: R,
    onChange: S,
    className: g.root,
    inputProps: {
      "aria-label": F,
      name: "select_row"
    },
    onKeyDown: E,
    indeterminate: T,
    disabled: !I,
    touchRippleRef: v
    /* FIXME: typing error */
  }, (_ = f.slotProps) == null ? void 0 : _.baseCheckbox, c, {
    ref: y
  }));
});
process.env.NODE_ENV !== "production" && (UN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: s.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: s.oneOf(["edit", "view"]).isRequired,
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: s.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: s.string.isRequired,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the element that should receive focus.
   * @ignore - do not document.
   */
  focusElementRef: s.oneOfType([s.func, s.shape({
    current: s.shape({
      focus: s.func.isRequired
    })
  })]),
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: s.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: s.bool.isRequired,
  /**
   * The grid row id.
   */
  id: s.oneOfType([s.number, s.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: s.bool,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: s.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: s.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: s.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: s.any
});
const Wle = UN, ay = (e) => e.focus, jo = Mt(ay, (e) => e.cell), qle = Mt(ay, (e) => e.columnHeader);
Mt(ay, (e) => e.columnHeaderFilter);
const Dm = Mt(ay, (e) => e.columnGroupHeader), ly = (e) => e.tabIndex, PS = Mt(ly, (e) => e.cell), zN = Mt(ly, (e) => e.columnHeader);
Mt(ly, (e) => e.columnHeaderFilter);
const Kle = Mt(ly, (e) => e.columnGroupHeader);
function Ut(e, t, n) {
  const r = m.useRef(!0);
  Zr(() => {
    r.current = !1, e.current.register(n, t);
  }, [e, n, t]), r.current && e.current.register(n, t);
}
function zr(e, t) {
  const n = m.useRef(null);
  if (n.current)
    return n.current;
  const r = e.current.getLogger(t);
  return n.current = r, r;
}
const GN = (e, t, n, r, o) => {
  const i = zr(e, "useNativeEventListener"), [a, l] = m.useState(!1), c = m.useRef(r), d = CN(t) ? t() : (t == null ? void 0 : t.current) ?? null, f = m.useCallback((p) => c.current && c.current(p), []);
  m.useEffect(() => {
    c.current = r;
  }, [r]), m.useEffect(() => {
    if (d && n && !a) {
      i.debug(`Binding native ${n} event`), d.addEventListener(n, f, o), l(!0);
      const p = () => {
        i.debug(`Clearing native ${n} event`), d.removeEventListener(n, f, o);
      };
      e.current.subscribeEvent("unmount", p);
    }
  }, [d, f, n, a, i, o, e]);
}, dh = (e) => {
  const t = m.useRef(!0);
  t.current && (t.current = !1, e());
}, Yle = () => {
}, Qle = (e, t) => {
  const n = m.useRef(!1);
  Zr(() => n.current || !e ? Yle : (n.current = !0, t()), [n.current || e]);
}, Xle = 100, Jle = (e) => e ? 0 : 100, WN = (e, t, n) => t > 0 && e > 0 ? Math.ceil(e / t) : e === -1 ? n + 2 : 0, qN = (e) => ({
  page: 0,
  pageSize: e ? 0 : 100
}), Zle = (e, t = 0) => t === 0 ? e : Math.max(Math.min(e, t - 1), 0), KN = (e, t) => {
  if (t === di.DataGrid && e > Xle)
    throw new Error(["MUI X: `pageSize` cannot exceed 100 in the MIT version of the DataGrid.", "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."].join(`
`));
}, ece = -1, cy = (e) => e.pagination, To = Mt(cy, (e) => e.paginationModel), Au = Mt(cy, (e) => e.rowCount), Nf = Mt(cy, (e) => e.meta), tce = Mt(To, (e) => e.page), nce = Mt(To, (e) => e.pageSize), YN = Mt(To, Au, (e, t) => WN(t, e.pageSize, e.page)), IS = Pn(To, so, Dd, Fl, VN, (e, t, n, r, o) => {
  var b;
  const i = o.length, a = Math.min(e.pageSize * e.page, i - 1), l = e.pageSize === ece ? i - 1 : Math.min(a + e.pageSize - 1, i - 1);
  if (a === -1 || l === -1)
    return null;
  if (n < 2)
    return {
      firstRowIndex: a,
      lastRowIndex: l
    };
  const c = o[a], d = l - a + 1, f = r.findIndex((v) => v.id === c.id);
  let p = f, g = 0;
  for (; p < r.length && g <= d; ) {
    const v = r[p], y = (b = t[v.id]) == null ? void 0 : b.depth;
    y === void 0 ? p += 1 : ((g < d || y > 0) && (p += 1), y === 0 && (g += 1));
  }
  return {
    firstRowIndex: f,
    lastRowIndex: p - 1
  };
}), rce = Pn(Fl, IS, (e, t) => t ? e.slice(t.firstRowIndex, t.lastRowIndex + 1) : []), QN = Pn(Uu, IS, (e, t) => t ? e.slice(t.firstRowIndex, t.lastRowIndex + 1) : []), oce = ["field", "colDef"], ice = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["checkboxInput"]
  }, nn, t);
}, XN = dn(function(t, n) {
  var A;
  const r = yt(t, oce), [, o] = m.useState(!1), i = Wt(), a = ft(), l = {
    classes: a.classes
  }, c = ice(l), d = Be(i, zN), f = Be(i, Ri), p = Be(i, Uu), g = Be(i, QN), b = m.useMemo(() => typeof a.isRowSelectable != "function" ? f : f.filter((_) => a.keepNonExistentRowsSelected ? !0 : i.current.getRow(_) ? a.isRowSelectable(i.current.getRowParams(_)) : !1), [i, a.isRowSelectable, f, a.keepNonExistentRowsSelected]), v = m.useMemo(() => (!a.pagination || !a.checkboxSelectionVisibleOnly ? p : g).reduce((C, D) => (C[D] = !0, C), {}), [a.pagination, a.checkboxSelectionVisibleOnly, g, p]), y = m.useMemo(() => b.filter((_) => v[_]).length, [b, v]), S = y > 0 && y < Object.keys(v).length, E = y > 0, I = (_) => {
    const C = {
      value: _.target.checked
    };
    i.current.publishEvent("headerSelectionCheckboxChange", C);
  }, O = d !== null && d.field === t.field ? 0 : -1;
  m.useLayoutEffect(() => {
    const _ = i.current.getColumnHeaderElement(t.field);
    O === 0 && _ && (_.tabIndex = -1);
  }, [O, i, t.field]);
  const T = m.useCallback((_) => {
    _.key === " " && i.current.publishEvent("headerSelectionCheckboxChange", {
      value: !E
    });
  }, [i, E]), P = m.useCallback(() => {
    o((_) => !_);
  }, []);
  m.useEffect(() => i.current.subscribeEvent("rowSelectionChange", P), [i, P]);
  const R = a.indeterminateCheckboxAction === "select" ? E && !S : E, F = i.current.getLocaleText(R ? "checkboxSelectionUnselectAllRows" : "checkboxSelectionSelectAllRows");
  return /* @__PURE__ */ w.jsx(a.slots.baseCheckbox, U({
    indeterminate: S,
    checked: R,
    onChange: I,
    className: c.root,
    inputProps: {
      "aria-label": F,
      name: "select_all_rows"
    },
    tabIndex: O,
    onKeyDown: T,
    disabled: !OS(a)
  }, (A = a.slotProps) == null ? void 0 : A.baseCheckbox, r, {
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (XN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The column of the current header component.
   */
  colDef: s.object.isRequired,
  /**
   * The column field of the column that triggered the event
   */
  field: s.string.isRequired
});
const da = "__check__", $d = U({}, $N, {
  type: "custom",
  field: da,
  width: 50,
  resizable: !1,
  sortable: !1,
  filterable: !1,
  // @ts-ignore
  aggregable: !1,
  disableColumnMenu: !0,
  disableReorder: !0,
  disableExport: !0,
  getApplyQuickFilterFn: void 0,
  display: "flex",
  valueGetter: (e, t, n, r) => {
    const o = ga(r), i = r.current.getRowId(t);
    return o[i] !== void 0;
  },
  renderHeader: (e) => /* @__PURE__ */ w.jsx(XN, U({}, e)),
  renderCell: (e) => /* @__PURE__ */ w.jsx(Wle, U({}, e))
}), sce = ["item", "applyValue", "type", "apiRef", "focusElementRef", "InputProps", "isFilterActive", "clearButton", "tabIndex", "disabled"];
function sR(e, t) {
  if (e == null)
    return "";
  const n = new Date(e);
  return Number.isNaN(n.getTime()) ? "" : t === "date" ? n.toISOString().substring(0, 10) : t === "datetime-local" ? (n.setMinutes(n.getMinutes() - n.getTimezoneOffset()), n.toISOString().substring(0, 19)) : n.toISOString().substring(0, 10);
}
function Xl(e) {
  var O;
  const {
    item: t,
    applyValue: n,
    type: r,
    apiRef: o,
    focusElementRef: i,
    InputProps: a,
    clearButton: l,
    tabIndex: c,
    disabled: d
  } = e, f = yt(e, sce), p = Pd(), [g, b] = m.useState(() => sR(t.value, r)), [v, y] = m.useState(!1), S = xr(), E = ft(), I = m.useCallback((T) => {
    p.clear();
    const P = T.target.value;
    b(P), y(!0), p.start(E.filterDebounceMs, () => {
      const R = new Date(P);
      n(U({}, t, {
        value: Number.isNaN(R.getTime()) ? void 0 : R
      })), y(!1);
    });
  }, [n, t, E.filterDebounceMs, p]);
  return m.useEffect(() => {
    const T = sR(t.value, r);
    b(T);
  }, [t.value, r]), /* @__PURE__ */ w.jsx(E.slots.baseTextField, U({
    fullWidth: !0,
    id: S,
    label: o.current.getLocaleText("filterPanelInputLabel"),
    placeholder: o.current.getLocaleText("filterPanelInputPlaceholder"),
    value: g,
    onChange: I,
    variant: "standard",
    type: r || "text",
    InputLabelProps: {
      shrink: !0
    },
    inputRef: i,
    InputProps: U({}, v || l ? {
      endAdornment: v ? /* @__PURE__ */ w.jsx(E.slots.loadIcon, {
        fontSize: "small",
        color: "action"
      }) : l
    } : {}, {
      disabled: d
    }, a, {
      inputProps: U({
        max: r === "datetime-local" ? "9999-12-31T23:59" : "9999-12-31",
        tabIndex: c
      }, a == null ? void 0 : a.inputProps)
    })
  }, f, (O = E.slotProps) == null ? void 0 : O.baseTextField));
}
process.env.NODE_ENV !== "production" && (Xl.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: s.shape({
    current: s.object.isRequired
  }).isRequired,
  applyValue: s.func.isRequired,
  clearButton: s.node,
  focusElementRef: s.oneOfType([s.func, s.object]),
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (for example `isEmpty`)
   */
  isFilterActive: s.bool,
  item: s.shape({
    field: s.string.isRequired,
    id: s.oneOfType([s.number, s.string]),
    operator: s.string.isRequired,
    value: s.any
  }).isRequired
});
function bu(e, t, n, r) {
  if (!e.value)
    return null;
  const o = new Date(e.value);
  n ? o.setSeconds(0, 0) : (o.setMinutes(o.getMinutes() + o.getTimezoneOffset()), o.setHours(0, 0, 0, 0));
  const i = o.getTime();
  return (a) => {
    if (!a)
      return !1;
    if (r)
      return t(a.getTime(), i);
    const l = new Date(a);
    return n ? l.setSeconds(0, 0) : l.setHours(0, 0, 0, 0), t(l.getTime(), i);
  };
}
const JN = (e) => [{
  value: "is",
  getApplyFilterFn: (t) => bu(t, (n, r) => n === r, e),
  InputComponent: Xl,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "not",
  getApplyFilterFn: (t) => bu(t, (n, r) => n !== r, e),
  InputComponent: Xl,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "after",
  getApplyFilterFn: (t) => bu(t, (n, r) => n > r, e),
  InputComponent: Xl,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "onOrAfter",
  getApplyFilterFn: (t) => bu(t, (n, r) => n >= r, e),
  InputComponent: Xl,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "before",
  getApplyFilterFn: (t) => bu(t, (n, r) => n < r, e, !e),
  InputComponent: Xl,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "onOrBefore",
  getApplyFilterFn: (t) => bu(t, (n, r) => n <= r, e),
  InputComponent: Xl,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "isEmpty",
  getApplyFilterFn: () => (t) => t == null,
  requiresFilterValue: !1
}, {
  value: "isNotEmpty",
  getApplyFilterFn: () => (t) => t != null,
  requiresFilterValue: !1
}], ace = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "hasFocus", "inputProps", "isValidating", "isProcessingProps", "onValueChange"], lce = oe(kc)({
  fontSize: "inherit"
}), cce = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["editInputCell"]
  }, nn, t);
};
function ZN(e) {
  const {
    id: t,
    value: n,
    field: r,
    colDef: o,
    hasFocus: i,
    inputProps: a,
    onValueChange: l
  } = e, c = yt(e, ace), d = o.type === "dateTime", f = Wt(), p = m.useRef(null), g = m.useMemo(() => {
    let T;
    n == null ? T = null : n instanceof Date ? T = n : T = new Date((n ?? "").toString());
    let P;
    return T == null || Number.isNaN(T.getTime()) ? P = "" : P = new Date(T.getTime() - T.getTimezoneOffset() * 60 * 1e3).toISOString().substr(0, d ? 16 : 10), {
      parsed: T,
      formatted: P
    };
  }, [n, d]), [b, v] = m.useState(g), S = {
    classes: ft().classes
  }, E = cce(S), I = m.useCallback((T) => {
    if (T === "")
      return null;
    const [P, R] = T.split("T"), [F, A, _] = P.split("-"), C = /* @__PURE__ */ new Date();
    if (C.setFullYear(Number(F), Number(A) - 1, Number(_)), C.setHours(0, 0, 0, 0), R) {
      const [D, L] = R.split(":");
      C.setHours(Number(D), Number(L), 0, 0);
    }
    return C;
  }, []), O = m.useCallback(async (T) => {
    const P = T.target.value, R = I(P);
    l && await l(T, R), v({
      parsed: R,
      formatted: P
    }), f.current.setEditCellValue({
      id: t,
      field: r,
      value: R
    }, T);
  }, [f, r, t, l, I]);
  return m.useEffect(() => {
    v((T) => {
      var P, R;
      return g.parsed !== T.parsed && ((P = g.parsed) == null ? void 0 : P.getTime()) !== ((R = T.parsed) == null ? void 0 : R.getTime()) ? g : T;
    });
  }, [g]), Zr(() => {
    i && p.current.focus();
  }, [i]), /* @__PURE__ */ w.jsx(lce, U({
    inputRef: p,
    fullWidth: !0,
    className: E.root,
    type: d ? "datetime-local" : "date",
    inputProps: U({
      max: d ? "9999-12-31T23:59" : "9999-12-31"
    }, a),
    value: b.formatted,
    onChange: O
  }, c));
}
process.env.NODE_ENV !== "production" && (ZN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: s.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: s.oneOf(["edit", "view"]).isRequired,
  changeReason: s.oneOf(["debouncedSetEditCellValue", "setEditCellValue"]),
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: s.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: s.string.isRequired,
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: s.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: s.bool.isRequired,
  /**
   * The grid row id.
   */
  id: s.oneOfType([s.number, s.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: s.bool,
  isProcessingProps: s.bool,
  isValidating: s.bool,
  /**
   * Callback called when the value is changed by the user.
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {Date | null} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */
  onValueChange: s.func,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: s.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: s.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: s.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: s.any
});
const eF = (e) => /* @__PURE__ */ w.jsx(ZN, U({}, e));
function tF({
  value: e,
  columnType: t,
  rowId: n,
  field: r
}) {
  if (!(e instanceof Date))
    throw new Error([`MUI X: \`${t}\` column type only accepts \`Date\` objects as values.`, "Use `valueGetter` to transform the value into a `Date` object.", `Row ID: ${n}, field: "${r}".`].join(`
`));
}
const uce = (e, t, n, r) => {
  if (!e)
    return "";
  const o = r.current.getRowId(t);
  return tF({
    value: e,
    columnType: "date",
    rowId: o,
    field: n.field
  }), e.toLocaleDateString();
}, dce = (e, t, n, r) => {
  if (!e)
    return "";
  const o = r.current.getRowId(t);
  return tF({
    value: e,
    columnType: "dateTime",
    rowId: o,
    field: n.field
  }), e.toLocaleString();
}, fce = U({}, os, {
  type: "date",
  sortComparator: vN,
  valueFormatter: uce,
  filterOperators: JN(),
  renderEditCell: eF,
  // @ts-ignore
  pastedValueParser: (e) => new Date(e)
}), pce = U({}, os, {
  type: "dateTime",
  sortComparator: vN,
  valueFormatter: dce,
  filterOperators: JN(!0),
  renderEditCell: eF,
  // @ts-ignore
  pastedValueParser: (e) => new Date(e)
}), Ka = (e) => e == null ? null : Number(e), hce = (e) => e == null || Number.isNaN(e) || e === "" ? null : (t) => Ka(t) === Ka(e), gce = () => [{
  value: "=",
  getApplyFilterFn: (e) => e.value == null || Number.isNaN(e.value) ? null : (t) => Ka(t) === e.value,
  InputComponent: ii,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: "!=",
  getApplyFilterFn: (e) => e.value == null || Number.isNaN(e.value) ? null : (t) => Ka(t) !== e.value,
  InputComponent: ii,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: ">",
  getApplyFilterFn: (e) => e.value == null || Number.isNaN(e.value) ? null : (t) => t == null ? !1 : Ka(t) > e.value,
  InputComponent: ii,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: ">=",
  getApplyFilterFn: (e) => e.value == null || Number.isNaN(e.value) ? null : (t) => t == null ? !1 : Ka(t) >= e.value,
  InputComponent: ii,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: "<",
  getApplyFilterFn: (e) => e.value == null || Number.isNaN(e.value) ? null : (t) => t == null ? !1 : Ka(t) < e.value,
  InputComponent: ii,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: "<=",
  getApplyFilterFn: (e) => e.value == null || Number.isNaN(e.value) ? null : (t) => t == null ? !1 : Ka(t) <= e.value,
  InputComponent: ii,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: "isEmpty",
  getApplyFilterFn: () => (e) => e == null,
  requiresFilterValue: !1
}, {
  value: "isNotEmpty",
  getApplyFilterFn: () => (e) => e != null,
  requiresFilterValue: !1
}, {
  value: "isAnyOf",
  getApplyFilterFn: (e) => !Array.isArray(e.value) || e.value.length === 0 ? null : (t) => t != null && e.value.includes(Number(t)),
  InputComponent: wS,
  InputComponentProps: {
    type: "number"
  }
}], mce = U({}, os, {
  type: "number",
  align: "right",
  headerAlign: "right",
  sortComparator: yN,
  valueParser: (e) => e === "" ? null : Number(e),
  valueFormatter: (e) => wN(e) ? e.toLocaleString() : e || "",
  filterOperators: gce(),
  getApplyQuickFilterFn: hce
});
function wd(e) {
  return (e == null ? void 0 : e.type) === "singleSelect";
}
function Sc(e, t) {
  if (e)
    return typeof e.valueOptions == "function" ? e.valueOptions(U({
      field: e.field
    }, t)) : e.valueOptions;
}
function Nm(e, t, n) {
  if (t === void 0)
    return;
  const r = t.find((o) => {
    const i = n(o);
    return String(i) === String(e);
  });
  return n(r);
}
const bce = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "className", "hasFocus", "isValidating", "isProcessingProps", "error", "onValueChange", "initialOpen"], yce = ["MenuProps"];
function vce(e) {
  return !!e.key;
}
function nF(e) {
  var L, B;
  const t = ft(), {
    id: n,
    value: r,
    field: o,
    row: i,
    colDef: a,
    hasFocus: l,
    error: c,
    onValueChange: d,
    initialOpen: f = t.editMode === Us.Cell
  } = e, p = yt(e, bce), g = Wt(), b = m.useRef(null), v = m.useRef(null), [y, S] = m.useState(f), I = (((L = t.slotProps) == null ? void 0 : L.baseSelect) || {}).native ?? !1, O = ((B = t.slotProps) == null ? void 0 : B.baseSelect) || {}, {
    MenuProps: T
  } = O, P = yt(O, yce);
  if (Zr(() => {
    var H;
    l && ((H = v.current) == null || H.focus());
  }, [l]), !wd(a))
    return null;
  const R = Sc(a, {
    id: n,
    row: i
  });
  if (!R)
    return null;
  const F = a.getOptionValue, A = a.getOptionLabel, _ = async (H) => {
    if (!wd(a) || !R)
      return;
    S(!1);
    const k = H.target, N = Nm(k.value, R, F);
    d && await d(H, N), await g.current.setEditCellValue({
      id: n,
      field: o,
      value: N
    }, H);
  }, C = (H, k) => {
    if (t.editMode === Us.Row) {
      S(!1);
      return;
    }
    if (k === "backdropClick" || H.key === "Escape") {
      const N = g.current.getCellParams(n, o);
      g.current.publishEvent("cellEditStop", U({}, N, {
        reason: H.key === "Escape" ? Ki.escapeKeyDown : Ki.cellFocusOut
      }));
    }
  }, D = (H) => {
    vce(H) && H.key === "Enter" || S(!0);
  };
  return !R || !a ? null : /* @__PURE__ */ w.jsx(t.slots.baseSelect, U({
    ref: b,
    inputRef: v,
    value: r,
    onChange: _,
    open: y,
    onOpen: D,
    MenuProps: U({
      onClose: C
    }, T),
    error: c,
    native: I,
    fullWidth: !0
  }, p, P, {
    children: R.map((H) => {
      var N;
      const k = F(H);
      return /* @__PURE__ */ fc(t.slots.baseSelectOption, U({}, ((N = t.slotProps) == null ? void 0 : N.baseSelectOption) || {}, {
        native: I,
        key: k,
        value: k
      }), A(H));
    })
  }));
}
process.env.NODE_ENV !== "production" && (nF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: s.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: s.oneOf(["edit", "view"]).isRequired,
  changeReason: s.oneOf(["debouncedSetEditCellValue", "setEditCellValue"]),
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: s.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: s.string.isRequired,
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: s.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: s.bool.isRequired,
  /**
   * The grid row id.
   */
  id: s.oneOfType([s.number, s.string]).isRequired,
  /**
   * If true, the select opens by default.
   */
  initialOpen: s.bool,
  /**
   * If true, the cell is editable.
   */
  isEditable: s.bool,
  isProcessingProps: s.bool,
  isValidating: s.bool,
  /**
   * Callback called when the value is changed by the user.
   * @param {SelectChangeEvent<any>} event The event source of the callback.
   * @param {any} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */
  onValueChange: s.func,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: s.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: s.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: s.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: s.any
});
const wce = (e) => /* @__PURE__ */ w.jsx(nF, U({}, e)), Cce = ["item", "applyValue", "type", "apiRef", "focusElementRef", "placeholder", "tabIndex", "label", "variant", "isFilterActive", "clearButton", "InputLabelProps"], xce = ({
  column: e,
  OptionComponent: t,
  getOptionLabel: n,
  getOptionValue: r,
  isSelectNative: o,
  baseSelectOptionProps: i
}) => ["", ...Sc(e) || []].map((l) => {
  const c = r(l);
  let d = n(l);
  return d === "" && (d = " "), /* @__PURE__ */ fc(t, U({}, i, {
    native: o,
    key: c,
    value: c
  }), d);
}), Sce = oe("div")({
  display: "flex",
  alignItems: "flex-end",
  width: "100%",
  "& button": {
    margin: "auto 0px 5px 5px"
  }
});
function eC(e) {
  var F, A, _, C, D;
  const {
    item: t,
    applyValue: n,
    type: r,
    apiRef: o,
    focusElementRef: i,
    placeholder: a,
    tabIndex: l,
    label: c,
    variant: d = "standard",
    clearButton: f
  } = e, p = yt(e, Cce), g = t.value ?? "", b = xr(), v = xr(), y = ft(), S = ((A = (F = y.slotProps) == null ? void 0 : F.baseSelect) == null ? void 0 : A.native) ?? !1;
  let E = null;
  if (t.field) {
    const L = o.current.getColumn(t.field);
    wd(L) && (E = L);
  }
  const I = E == null ? void 0 : E.getOptionValue, O = E == null ? void 0 : E.getOptionLabel, T = m.useMemo(() => Sc(E), [E]), P = m.useCallback((L) => {
    let B = L.target.value;
    B = Nm(B, T, I), n(U({}, t, {
      value: B
    }));
  }, [T, I, n, t]);
  if (!wd(E))
    return null;
  const R = c ?? o.current.getLocaleText("filterPanelInputLabel");
  return /* @__PURE__ */ w.jsxs(Sce, {
    children: [/* @__PURE__ */ w.jsxs(y.slots.baseFormControl, {
      fullWidth: !0,
      children: [/* @__PURE__ */ w.jsx(y.slots.baseInputLabel, U({}, (_ = y.slotProps) == null ? void 0 : _.baseInputLabel, {
        id: v,
        htmlFor: b,
        shrink: !0,
        variant: d,
        children: R
      })), /* @__PURE__ */ w.jsx(y.slots.baseSelect, U({
        id: b,
        label: R,
        labelId: v,
        value: g,
        onChange: P,
        variant: d,
        type: r || "text",
        inputProps: {
          tabIndex: l,
          ref: i,
          placeholder: a ?? o.current.getLocaleText("filterPanelInputPlaceholder")
        },
        native: S,
        notched: d === "outlined" ? !0 : void 0
      }, p, (C = y.slotProps) == null ? void 0 : C.baseSelect, {
        children: xce({
          column: E,
          OptionComponent: y.slots.baseSelectOption,
          getOptionLabel: O,
          getOptionValue: I,
          isSelectNative: S,
          baseSelectOptionProps: (D = y.slotProps) == null ? void 0 : D.baseSelectOption
        })
      }))]
    }), f]
  });
}
process.env.NODE_ENV !== "production" && (eC.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: s.shape({
    current: s.object.isRequired
  }).isRequired,
  applyValue: s.func.isRequired,
  clearButton: s.node,
  focusElementRef: s.oneOfType([s.func, s.object]),
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (for example `isEmpty`)
   */
  isFilterActive: s.bool,
  item: s.shape({
    field: s.string.isRequired,
    id: s.oneOfType([s.number, s.string]),
    operator: s.string.isRequired,
    value: s.any
  }).isRequired
});
const Ece = ["item", "applyValue", "type", "apiRef", "focusElementRef", "color", "error", "helperText", "size", "variant"], Tce = ["key"], Oce = Kk();
function rF(e) {
  const {
    item: t,
    applyValue: n,
    apiRef: r,
    focusElementRef: o,
    color: i,
    error: a,
    helperText: l,
    size: c,
    variant: d = "standard"
  } = e, f = yt(e, Ece), p = {
    color: i,
    error: a,
    helperText: l,
    size: c,
    variant: d
  }, g = xr(), b = ft();
  let v = null;
  if (t.field) {
    const P = r.current.getColumn(t.field);
    wd(P) && (v = P);
  }
  const y = v == null ? void 0 : v.getOptionValue, S = v == null ? void 0 : v.getOptionLabel, E = m.useCallback((P, R) => y(P) === y(R), [y]), I = m.useMemo(() => Sc(v) || [], [v]), O = m.useMemo(() => Array.isArray(t.value) ? t.value.reduce((P, R) => {
    const F = I.find((A) => y(A) === R);
    return F != null && P.push(F), P;
  }, []) : [], [y, t.value, I]), T = m.useCallback((P, R) => {
    n(U({}, t, {
      value: R.map(y)
    }));
  }, [n, t, y]);
  return /* @__PURE__ */ w.jsx(zp, U({
    multiple: !0,
    options: I,
    isOptionEqualToValue: E,
    filterOptions: Oce,
    id: g,
    value: O,
    onChange: T,
    getOptionLabel: S,
    renderTags: (P, R) => P.map((F, A) => {
      const _ = R({
        index: A
      }), {
        key: C
      } = _, D = yt(_, Tce);
      return /* @__PURE__ */ w.jsx(b.slots.baseChip, U({
        variant: "outlined",
        size: "small",
        label: S(F)
      }, D), C);
    }),
    renderInput: (P) => {
      var R;
      return /* @__PURE__ */ w.jsx(b.slots.baseTextField, U({}, P, {
        label: r.current.getLocaleText("filterPanelInputLabel"),
        placeholder: r.current.getLocaleText("filterPanelInputPlaceholder"),
        InputLabelProps: U({}, P.InputLabelProps, {
          shrink: !0
        }),
        inputRef: o,
        type: "singleSelect"
      }, p, (R = b.slotProps) == null ? void 0 : R.baseTextField));
    }
  }, f));
}
process.env.NODE_ENV !== "production" && (rF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: s.shape({
    current: s.object.isRequired
  }).isRequired,
  applyValue: s.func.isRequired,
  focusElementRef: s.oneOfType([s.func, s.object]),
  item: s.shape({
    field: s.string.isRequired,
    id: s.oneOfType([s.number, s.string]),
    operator: s.string.isRequired,
    value: s.any
  }).isRequired,
  type: s.oneOf(["singleSelect"])
});
const yu = (e) => e == null || !vS(e) ? e : e.value, Pce = () => [{
  value: "is",
  getApplyFilterFn: (e) => e.value == null || e.value === "" ? null : (t) => yu(t) === yu(e.value),
  InputComponent: eC
}, {
  value: "not",
  getApplyFilterFn: (e) => e.value == null || e.value === "" ? null : (t) => yu(t) !== yu(e.value),
  InputComponent: eC
}, {
  value: "isAnyOf",
  getApplyFilterFn: (e) => {
    if (!Array.isArray(e.value) || e.value.length === 0)
      return null;
    const t = e.value.map(yu);
    return (n) => t.includes(yu(n));
  },
  InputComponent: rF
}], Ice = (e) => typeof e[0] == "object", Rce = (e) => vS(e) ? e.value : e, _ce = (e) => vS(e) ? e.label : String(e), kce = U({}, os, {
  type: "singleSelect",
  getOptionLabel: _ce,
  getOptionValue: Rce,
  valueFormatter(e, t, n, r) {
    const o = r.current.getRowId(t);
    if (!wd(n))
      return "";
    const i = Sc(n, {
      id: o,
      row: t
    });
    if (e == null)
      return "";
    if (!i)
      return e;
    if (!Ice(i))
      return n.getOptionLabel(e);
    const a = i.find((l) => n.getOptionValue(l) === e);
    return a ? n.getOptionLabel(a) : "";
  },
  renderEditCell: wce,
  filterOperators: Pce(),
  // @ts-ignore
  pastedValueParser: (e, t, n) => {
    const r = n, o = Sc(r) || [], i = r.getOptionValue;
    if (o.find((l) => i(l) === e))
      return e;
  }
}), Mce = "string", Ace = () => ({
  string: os,
  number: mce,
  date: fce,
  dateTime: pce,
  boolean: $N,
  singleSelect: kce,
  [ny]: ule,
  custom: os
}), RS = (e) => e.headerFiltering, Dce = Mt(
  RS,
  // No initialization in MIT, so we need to default to false to be used by `getTotalHeaderHeight`
  (e) => (e == null ? void 0 : e.enabled) ?? !1
), Nce = Mt(RS, (e) => e.editing), Fce = Mt(RS, (e) => e.menuOpen), uy = (e) => e.columnGrouping, oF = Pn(uy, (e) => (e == null ? void 0 : e.unwrappedGroupingModel) ?? {}), iF = Pn(uy, (e) => (e == null ? void 0 : e.lookup) ?? {}), $ce = Pn(uy, (e) => (e == null ? void 0 : e.headerStructure) ?? []), fh = Mt(uy, (e) => (e == null ? void 0 : e.maxDepth) ?? 0), sF = ["maxWidth", "minWidth", "width", "flex"], Tw = Ace();
function Lce({
  initialFreeSpace: e,
  totalFlexUnits: t,
  flexColumns: n
}) {
  const r = new Set(n.map((a) => a.field)), o = {
    all: {},
    frozenFields: [],
    freeze: (a) => {
      const l = o.all[a];
      l && l.frozen !== !0 && (o.all[a].frozen = !0, o.frozenFields.push(a));
    }
  };
  function i() {
    if (o.frozenFields.length === r.size)
      return;
    const a = {
      min: {},
      max: {}
    };
    let l = e, c = t, d = 0;
    o.frozenFields.forEach((f) => {
      l -= o.all[f].computedWidth, c -= o.all[f].flex;
    });
    for (let f = 0; f < n.length; f += 1) {
      const p = n[f];
      if (o.all[p.field] && o.all[p.field].frozen === !0)
        continue;
      let b = l / c * p.flex;
      b < p.minWidth ? (d += p.minWidth - b, b = p.minWidth, a.min[p.field] = !0) : b > p.maxWidth && (d += p.maxWidth - b, b = p.maxWidth, a.max[p.field] = !0), o.all[p.field] = {
        frozen: !1,
        computedWidth: b,
        flex: p.flex
      };
    }
    d < 0 ? Object.keys(a.max).forEach((f) => {
      o.freeze(f);
    }) : d > 0 ? Object.keys(a.min).forEach((f) => {
      o.freeze(f);
    }) : n.forEach(({
      field: f
    }) => {
      o.freeze(f);
    }), i();
  }
  return i(), o.all;
}
const tC = (e, t) => {
  const n = {};
  let r = 0, o = 0;
  const i = [];
  e.orderedFields.forEach((c) => {
    let d = e.lookup[c], f = 0, p = !1;
    e.columnVisibilityModel[c] !== !1 && (d.flex && d.flex > 0 ? (r += d.flex, p = !0) : f = js(d.width || os.width, d.minWidth || os.minWidth, d.maxWidth || os.maxWidth), o += f), d.computedWidth !== f && (d = U({}, d, {
      computedWidth: f
    })), p && i.push(d), n[c] = d;
  });
  const a = t === void 0 ? 0 : t.viewportOuterSize.width - (t.hasScrollY ? t.scrollbarSize : 0), l = Math.max(a - o, 0);
  if (r > 0 && a > 0) {
    const c = Lce({
      initialFreeSpace: l,
      totalFlexUnits: r,
      flexColumns: i
    });
    Object.keys(c).forEach((d) => {
      n[d].computedWidth = c[d].computedWidth;
    });
  }
  return U({}, e, {
    lookup: n
  });
}, jce = (e, t) => {
  if (!t)
    return e;
  const {
    orderedFields: n = [],
    dimensions: r = {}
  } = t, o = Object.keys(r);
  if (o.length === 0 && n.length === 0)
    return e;
  const i = {}, a = [];
  for (let f = 0; f < n.length; f += 1) {
    const p = n[f];
    e.lookup[p] && (i[p] = !0, a.push(p));
  }
  const l = a.length === 0 ? e.orderedFields : [...a, ...e.orderedFields.filter((f) => !i[f])], c = U({}, e.lookup);
  for (let f = 0; f < o.length; f += 1) {
    const p = o[f], g = U({}, c[p], {
      hasBeenResized: !0
    });
    Object.entries(r[p]).forEach(([b, v]) => {
      g[b] = v === -1 ? 1 / 0 : v;
    }), c[p] = g;
  }
  return U({}, e, {
    orderedFields: l,
    lookup: c
  });
};
function aR(e) {
  let t = Tw[Mce];
  return e && Tw[e] && (t = Tw[e]), t;
}
const Pu = ({
  apiRef: e,
  columnsToUpsert: t,
  initialState: n,
  columnVisibilityModel: r = Ai(e),
  keepOnlyColumnsToUpsert: o = !1
}) => {
  var f, p;
  const i = !e.current.state.columns;
  let a;
  if (i)
    a = {
      orderedFields: [],
      lookup: {},
      columnVisibilityModel: r
    };
  else {
    const g = Ls(e.current.state);
    a = {
      orderedFields: o ? [] : [...g.orderedFields],
      lookup: U({}, g.lookup),
      // Will be cleaned later if keepOnlyColumnsToUpsert=true
      columnVisibilityModel: r
    };
  }
  let l = {};
  o && !i && (l = Object.keys(a.lookup).reduce((g, b) => U({}, g, {
    [b]: !1
  }), {})), t.forEach((g) => {
    const {
      field: b
    } = g;
    l[b] = !0;
    let v = a.lookup[b];
    v == null ? (v = U({}, aR(g.type), {
      field: b,
      hasBeenResized: !1
    }), a.orderedFields.push(b)) : o && a.orderedFields.push(b), v && v.type !== g.type && (v = U({}, aR(g.type), {
      field: b
    }));
    let y = v.hasBeenResized;
    sF.forEach((S) => {
      g[S] !== void 0 && (y = !0, g[S] === -1 && (g[S] = 1 / 0));
    }), a.lookup[b] = QM(v, U({}, g, {
      hasBeenResized: y
    }));
  }), o && !i && Object.keys(a.lookup).forEach((g) => {
    l[g] || delete a.lookup[g];
  });
  const c = e.current.unstable_applyPipeProcessors("hydrateColumns", a), d = jce(c, n);
  return tC(d, ((p = (f = e.current).getRootDimensions) == null ? void 0 : p.call(f)) ?? void 0);
};
function Bce({
  firstColumnToRender: e,
  apiRef: t,
  firstRowToRender: n,
  lastRowToRender: r,
  visibleRows: o
}) {
  let i = e;
  for (let a = n; a < r; a += 1)
    if (o[a]) {
      const c = o[a].id, d = t.current.unstable_getCellColSpanInfo(c, e);
      d && d.spannedByColSpan && (i = d.leftVisibleCellIndex);
    }
  return i;
}
function _S(e, t) {
  if (t.unstable_listView)
    return 0;
  const n = ch(e), r = fh(e), o = Dce(e), i = Math.floor(t.columnHeaderHeight * n), a = Math.floor((t.columnGroupHeaderHeight ?? t.columnHeaderHeight) * n), l = o ? Math.floor((t.headerFilterHeight ?? t.columnHeaderHeight) * n) : 0;
  return i + a * r + l;
}
const lR = 1, Vce = 1.5, Hce = (e) => {
  const {
    scrollDirection: t,
    classes: n
  } = e, r = {
    root: ["scrollArea", `scrollArea--${t}`]
  };
  return tn(r, nn, n);
}, Uce = On("div", {
  name: "MuiDataGrid",
  slot: "ScrollArea",
  overridesResolver: (e, t) => [{
    [`&.${ee["scrollArea--left"]}`]: t["scrollArea--left"]
  }, {
    [`&.${ee["scrollArea--right"]}`]: t["scrollArea--right"]
  }, t.scrollArea]
})(() => ({
  position: "absolute",
  top: 0,
  zIndex: 101,
  width: 20,
  bottom: 0,
  [`&.${ee["scrollArea--left"]}`]: {
    left: 0
  },
  [`&.${ee["scrollArea--right"]}`]: {
    right: 0
  }
}));
function zce(e) {
  const {
    scrollDirection: t
  } = e, n = m.useRef(null), r = Wt(), o = Pd(), i = Be(r, ch), a = Be(r, bS), l = Be(r, mo), c = m.useRef({
    left: 0,
    top: 0
  }), d = () => {
    if (t === "left")
      return c.current.left > 0;
    if (t === "right") {
      const A = a - l.viewportInnerSize.width;
      return c.current.left < A;
    }
    return !1;
  }, [f, p] = m.useState(!1), [g, b] = m.useState(d), v = ft(), y = U({}, v, {
    scrollDirection: t
  }), S = Hce(y), E = _S(r, v), I = Math.floor(v.columnHeaderHeight * i), O = {
    height: I,
    top: E - I
  };
  t === "left" ? O.left = l.leftPinnedWidth : t === "right" && (O.right = l.rightPinnedWidth + (l.hasScrollX ? l.scrollbarSize : 0));
  const T = (A) => {
    c.current = A, b(d);
  }, P = Yn((A) => {
    let _;
    if (A.preventDefault(), t === "left")
      _ = A.clientX - n.current.getBoundingClientRect().right;
    else if (t === "right")
      _ = Math.max(1, A.clientX - n.current.getBoundingClientRect().left);
    else
      throw new Error("MUI X: Wrong drag direction");
    _ = (_ - lR) * Vce + lR, o.start(0, () => {
      r.current.scroll({
        left: c.current.left + _,
        top: c.current.top
      });
    });
  }), R = Yn(() => {
    p(!0);
  }), F = Yn(() => {
    p(!1);
  });
  return it(r, "scrollPositionChange", T), it(r, "columnHeaderDragStart", R), it(r, "columnHeaderDragEnd", F), !f || !g ? null : /* @__PURE__ */ w.jsx(Uce, {
    ref: n,
    className: ke(S.root),
    ownerState: y,
    onDragOver: P,
    style: O
  });
}
const cR = Dl(zce);
var kS = {}, aF = { exports: {} }, lF = { exports: {} };
(function(e) {
  function t(n) {
    "@babel/helpers - typeof";
    return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(n);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(lF);
var Gce = lF.exports;
(function(e) {
  var t = Gce.default;
  function n(o) {
    if (typeof WeakMap != "function") return null;
    var i = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap();
    return (n = function(c) {
      return c ? a : i;
    })(o);
  }
  function r(o, i) {
    if (!i && o && o.__esModule) return o;
    if (o === null || t(o) != "object" && typeof o != "function") return {
      default: o
    };
    var a = n(i);
    if (a && a.has(o)) return a.get(o);
    var l = {
      __proto__: null
    }, c = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var d in o) if (d !== "default" && {}.hasOwnProperty.call(o, d)) {
      var f = c ? Object.getOwnPropertyDescriptor(o, d) : null;
      f && (f.get || f.set) ? Object.defineProperty(l, d, f) : l[d] = o[d];
    }
    return l.default = o, a && a.set(o, l), l;
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(aF);
var Wce = aF.exports, qce = Wce.default;
Object.defineProperty(kS, "__esModule", {
  value: !0
});
var cF = kS.default = void 0, Kce = qce(en);
cF = kS.default = parseInt(Kce.version, 10);
const MS = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (MS.displayName = "GridPrivateApiContext");
function Hi() {
  const e = m.useContext(MS);
  if (e === void 0)
    throw new Error(["MUI X: Could not find the Data Grid private context.", "It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.", "This can also happen if you are bundling multiple versions of the Data Grid."].join(`
`));
  return e;
}
const zu = (e, t) => {
  let n, r;
  return t.pagination && t.paginationMode === "client" ? (r = IS(e), n = rce(e)) : (n = Fl(e), n.length === 0 ? r = null : r = {
    firstRowIndex: 0,
    lastRowIndex: n.length - 1
  }), {
    rows: n,
    range: r
  };
}, Fc = (e, t) => {
  const n = zu(e, t);
  return m.useMemo(() => ({
    rows: n.rows,
    range: n.range
  }), [n.rows, n.range]);
}, Yce = typeof navigator < "u" ? navigator.userAgent.toLowerCase() : "empty", Qce = Yce.includes("firefox"), Ld = (e) => e.rowsMeta, dy = (e) => e.virtualization;
Mt(dy, (e) => e.enabled);
const fy = Mt(dy, (e) => e.enabledForColumns), Xce = Mt(dy, (e) => e.enabledForRows), py = Mt(dy, (e) => e.renderContext), Jce = Pn((e) => e.virtualization.renderContext.firstColumnIndex, (e) => e.virtualization.renderContext.lastColumnIndex, (e, t) => ({
  firstColumnIndex: e,
  lastColumnIndex: t
})), uF = {
  firstRowIndex: 0,
  lastRowIndex: 0,
  firstColumnIndex: 0,
  lastColumnIndex: 0
}, Zce = (e, t) => {
  const {
    disableVirtualization: n,
    autoHeight: r
  } = t;
  return U({}, e, {
    virtualization: {
      enabled: !n,
      enabledForColumns: !n,
      enabledForRows: !n && !r,
      renderContext: uF
    }
  });
};
function eue(e, t) {
  const n = (i) => {
    e.current.setState((a) => U({}, a, {
      virtualization: U({}, a.virtualization, {
        enabled: i,
        enabledForColumns: i,
        enabledForRows: i && !t.autoHeight
      })
    }));
  };
  Ut(e, {
    unstable_setVirtualization: n,
    unstable_setColumnVirtualization: (i) => {
      e.current.setState((a) => U({}, a, {
        virtualization: U({}, a.virtualization, {
          enabledForColumns: i
        })
      }));
    }
  }, "public"), m.useEffect(() => {
    n(!t.disableVirtualization);
  }, [t.disableVirtualization, t.autoHeight]);
}
const AS = (e) => e.rowSpanning, dF = Mt(AS, (e) => e.hiddenCells), tue = Mt(AS, (e) => e.spannedCells), nue = Mt(AS, (e) => e.hiddenCellOriginMap), Cd = (e) => e.listViewColumn, Ow = 50;
var Pr = /* @__PURE__ */ function(e) {
  return e[e.NONE = 0] = "NONE", e[e.UP = 1] = "UP", e[e.DOWN = 2] = "DOWN", e[e.LEFT = 3] = "LEFT", e[e.RIGHT = 4] = "RIGHT", e;
}(Pr || {});
const uR = {
  top: 0,
  left: 0
}, rue = Object.freeze(/* @__PURE__ */ new Map()), oue = (e, t, n, r, o) => ({
  direction: Pr.NONE,
  buffer: pF(e, Pr.NONE, t, n, r, o)
});
let nC = !1;
try {
  typeof window < "u" && (nC = /jsdom|HappyDOM/.test(window.navigator.userAgent));
} catch {
}
const iue = () => {
  const e = Hi(), t = ft(), {
    unstable_listView: n
  } = t, r = Be(e, () => n ? [Cd(e.current.state)] : Fr(e)), o = Be(e, Xce) && !nC, i = Be(e, fy) && !nC, a = Be(e, mo), l = a.viewportOuterSize, c = Be(e, Nc), d = Be(e, uh), f = n ? {
    left: [],
    right: []
  } : d, p = c.bottom.length > 0, [g, b] = m.useState(rue), v = mi(), y = Be(e, jo), S = Be(e, PS), E = Be(e, Ld), I = Be(e, ga), O = Fc(e, t), T = e.current.rootElementRef, P = e.current.mainElementRef, R = e.current.virtualScrollerRef, F = e.current.virtualScrollbarVerticalRef, A = e.current.virtualScrollbarHorizontalRef, _ = a.contentSize.height, C = a.columnsTotalWidth, D = Be(e, Mae), L = m.useRef(null), B = m.useCallback((q) => {
    if (P.current = q, !q)
      return;
    const Ee = q.getBoundingClientRect();
    let _e = fR(Ee);
    if ((!L.current || _e.width !== L.current.width && _e.height !== L.current.height) && (L.current = _e, e.current.publishEvent("resize", _e)), typeof ResizeObserver > "u")
      return;
    const $e = new ResizeObserver((Le) => {
      const Ze = Le[0];
      if (!Ze)
        return;
      const J = fR(Ze.contentRect);
      J.width === _e.width && J.height === _e.height || (e.current.publishEvent("resize", J), _e = J);
    });
    if ($e.observe(q), cF >= 19)
      return () => {
        P.current = null, $e.disconnect();
      };
  }, [e, P]), H = m.useRef(uR), k = m.useRef(uR), N = m.useRef(uF), j = Be(e, py), W = Pd(), V = m.useRef(void 0), $ = Ws(() => oue(v, t.rowBufferPx, t.columnBufferPx, a.rowHeight * 15, Ow * 6)).current, z = {
    rowIndex: m.useMemo(() => y ? O.rows.findIndex((q) => q.id === y.id) : -1, [y, O.rows]),
    columnIndex: m.useMemo(() => y ? r.findIndex((q) => q.field === y.field) : -1, [y, r])
  }, ne = m.useCallback((q) => {
    if (lue(q, e.current.state.virtualization.renderContext))
      return;
    const Ee = q.firstRowIndex !== N.current.firstRowIndex || q.lastRowIndex !== N.current.lastRowIndex;
    e.current.setState((_e) => U({}, _e, {
      virtualization: U({}, _e.virtualization, {
        renderContext: q
      })
    })), a.isReady && Ee && (N.current = q, e.current.publishEvent("renderedRowsIntervalChange", q)), k.current = H.current;
  }, [e, a.isReady]), K = Yn(() => {
    const q = R.current;
    if (!q)
      return;
    const Ee = {
      top: q.scrollTop,
      left: q.scrollLeft
    }, _e = Ee.left - H.current.left, $e = Ee.top - H.current.top, Le = _e !== 0 || $e !== 0;
    H.current = Ee;
    const Ze = Le ? cue(_e, $e) : Pr.NONE, J = Math.abs(H.current.top - k.current.top), fe = Math.abs(H.current.left - k.current.left), me = J >= a.rowHeight || fe >= Ow, Oe = $.direction !== Ze;
    if (!(me || Oe))
      return j;
    if (Oe)
      switch (Ze) {
        case Pr.NONE:
        case Pr.LEFT:
        case Pr.RIGHT:
          V.current = void 0;
          break;
        default:
          V.current = j;
          break;
      }
    $.direction = Ze, $.buffer = pF(v, Ze, t.rowBufferPx, t.columnBufferPx, a.rowHeight * 15, Ow * 6);
    const Te = Pw(e, t, o, i), Pe = Iw(Te, H.current, $);
    return xC.flushSync(() => {
      ne(Pe);
    }), W.start(1e3, K), Pe;
  }), Q = () => {
    const q = Pw(e, t, o, i), Ee = Iw(q, H.current, $);
    V.current = void 0, ne(Ee);
  }, re = Yn((q) => {
    const {
      scrollTop: Ee,
      scrollLeft: _e
    } = q.currentTarget;
    if (Ee < 0 || !v && _e < 0 || v && _e > 0)
      return;
    const $e = K();
    e.current.publishEvent("scrollPositionChange", {
      top: Ee,
      left: _e,
      renderContext: $e
    });
  }), te = Yn((q) => {
    e.current.publishEvent("virtualScrollerWheel", {}, q);
  }), ie = Yn((q) => {
    e.current.publishEvent("virtualScrollerTouchMove", {}, q);
  }), ae = (q = {}) => {
    var Ye;
    if (!q.rows && !O.range)
      return [];
    const Ee = q.renderContext ?? j, _e = !p && q.position === void 0 || p && q.position === "bottom", $e = q.position !== void 0;
    let Le;
    switch (q.position) {
      case "top":
        Le = 0;
        break;
      case "bottom":
        Le = c.top.length + O.rows.length;
        break;
      case void 0:
        Le = c.top.length;
        break;
    }
    const Ze = q.rows ?? O.rows, J = Ee.firstRowIndex, fe = Math.min(Ee.lastRowIndex, Ze.length), me = q.rows ? KI(0, q.rows.length) : KI(J, fe);
    let Oe = -1;
    !$e && z.rowIndex !== -1 && (z.rowIndex < J && (Oe = z.rowIndex, me.unshift(Oe)), z.rowIndex >= fe && (Oe = z.rowIndex, me.push(Oe)));
    const Ce = [], Te = (Ye = t.slotProps) == null ? void 0 : Ye.row, Pe = Nl(e);
    return me.forEach((Ke) => {
      var ar, Mr, Lr;
      const {
        id: je,
        model: Qe
      } = Ze[Ke], et = (((ar = O == null ? void 0 : O.range) == null ? void 0 : ar.firstRowIndex) || 0) + Le + Ke;
      if (D) {
        const lr = f.left.length, mt = r.length - f.right.length;
        e.current.calculateColSpan({
          rowId: je,
          minFirstColumn: lr,
          maxLastColumn: mt,
          columns: r
        }), f.left.length > 0 && e.current.calculateColSpan({
          rowId: je,
          minFirstColumn: 0,
          maxLastColumn: f.left.length,
          columns: r
        }), f.right.length > 0 && e.current.calculateColSpan({
          rowId: je,
          minFirstColumn: r.length - f.right.length,
          maxLastColumn: r.length,
          columns: r
        });
      }
      const Et = (y == null ? void 0 : y.id) === je, Xe = e.current.rowHasAutoHeight(je) ? "auto" : e.current.unstable_getRowHeight(je);
      let xt;
      I[je] == null ? xt = !1 : xt = e.current.isRowSelectable(je);
      let tt = !1;
      q.position === void 0 && (tt = Ke === 0);
      let ct = !1;
      const Je = Ke === Ze.length - 1;
      if (_e)
        if ($e)
          ct = Je;
        else {
          const lr = O.rows.length - 1;
          Ke === lr && (ct = !0);
        }
      const lt = Ke === Oe;
      let It = null;
      S !== null && S.id === je && (It = e.current.getCellParams(je, S.field).cellMode === "view" ? S.field : null);
      let fn = Ee;
      !$e && V.current && Ke >= V.current.firstRowIndex && Ke < V.current.lastRowIndex && (fn = V.current);
      const Bn = fF(Pe, fn, f.left.length), kn = Je && q.position === "top";
      if (Ce.push(/* @__PURE__ */ w.jsx(t.slots.row, U({
        row: Qe,
        rowId: je,
        index: et,
        selected: xt,
        offsetTop: q.rows ? void 0 : E.positions[Ke],
        offsetLeft: Bn,
        dimensions: a,
        rowHeight: Xe,
        tabbableCell: It,
        pinnedColumns: f,
        visibleColumns: r,
        renderContext: fn,
        focusedColumnIndex: Et ? z.columnIndex : void 0,
        isFirstVisible: tt,
        isLastVisible: ct,
        isNotVisible: lt,
        showBottomBorder: kn
      }, Te), je)), lt)
        return;
      const fr = g.get(je);
      fr && Ce.push(fr), q.position === void 0 && Je && Ce.push((Lr = (Mr = e.current).getInfiniteLoadingTriggerElement) == null ? void 0 : Lr.call(Mr, {
        lastRowId: je
      }));
    }), Ce;
  }, ce = l.width && C > l.width, le = m.useMemo(() => ({
    overflowX: !ce || n ? "hidden" : void 0,
    overflowY: t.autoHeight ? "hidden" : void 0
  }), [ce, t.autoHeight, n]), we = m.useMemo(() => {
    const q = {
      width: ce ? C : "auto",
      flexBasis: _,
      flexShrink: 0
    };
    return q.flexBasis === 0 && (q.flexBasis = kN), q;
  }, [C, _, ce]);
  return m.useEffect(() => {
    e.current.publishEvent("virtualScrollerContentSizeChange");
  }, [e, we]), Zr(() => {
    i && (R.current.scrollLeft = 0), o && (R.current.scrollTop = 0);
  }, [i, o, T, R]), Zr(() => {
    n && (R.current.scrollLeft = 0);
  }, [n, R]), Qle(l.width !== 0, () => {
    const q = Pw(e, t, o, i), Ee = Iw(q, H.current, $);
    ne(Ee), e.current.publishEvent("scrollPositionChange", {
      top: H.current.top,
      left: H.current.left,
      renderContext: Ee
    });
  }), e.current.register("private", {
    updateRenderContext: Q
  }), it(e, "columnsChange", Q), it(e, "filteredRowsSet", Q), it(e, "rowExpansionChange", Q), {
    renderContext: j,
    setPanels: b,
    getRows: ae,
    getContainerProps: () => ({
      ref: B
    }),
    getScrollerProps: () => ({
      ref: R,
      onScroll: re,
      onWheel: te,
      onTouchMove: ie,
      style: le,
      role: "presentation",
      // `tabIndex` shouldn't be used along role=presentation, but it fixes a Firefox bug
      // https://github.com/mui/mui-x/pull/13891#discussion_r1683416024
      tabIndex: Qce ? -1 : void 0
    }),
    getContentProps: () => ({
      style: we,
      role: "presentation"
    }),
    getRenderZoneProps: () => ({
      role: "rowgroup"
    }),
    getScrollbarVerticalProps: () => ({
      ref: F,
      role: "presentation"
    }),
    getScrollbarHorizontalProps: () => ({
      ref: A,
      role: "presentation"
    })
  };
};
function Pw(e, t, n, r) {
  const o = mo(e.current.state), i = zu(e, t), a = t.unstable_listView ? [Cd(e.current.state)] : Fr(e), l = nue(e), c = e.current.state.rows.dataRowIds.at(-1), d = a.at(-1);
  return {
    enabledForRows: n,
    enabledForColumns: r,
    apiRef: e,
    autoHeight: t.autoHeight,
    rowBufferPx: t.rowBufferPx,
    columnBufferPx: t.columnBufferPx,
    leftPinnedWidth: o.leftPinnedWidth,
    columnsTotalWidth: o.columnsTotalWidth,
    viewportInnerWidth: o.viewportInnerSize.width,
    viewportInnerHeight: o.viewportInnerSize.height,
    lastRowHeight: c !== void 0 ? e.current.unstable_getRowHeight(c) : 0,
    lastColumnWidth: (d == null ? void 0 : d.computedWidth) ?? 0,
    rowsMeta: Ld(e.current.state),
    columnPositions: Nl(e),
    rows: i.rows,
    range: i.range,
    pinnedColumns: uh(e),
    visibleColumns: a,
    hiddenCellsOriginMap: l,
    listView: t.unstable_listView ?? !1,
    virtualizeColumnsWithAutoRowHeight: t.virtualizeColumnsWithAutoRowHeight
  };
}
function Iw(e, t, n) {
  const r = {
    firstRowIndex: 0,
    lastRowIndex: e.rows.length,
    firstColumnIndex: 0,
    lastColumnIndex: e.visibleColumns.length
  }, {
    top: o,
    left: i
  } = t, a = Math.abs(i) + e.leftPinnedWidth;
  if (e.enabledForRows) {
    let c = Math.min(dR(e, o, {
      atStart: !0,
      lastPosition: e.rowsMeta.positions[e.rowsMeta.positions.length - 1] + e.lastRowHeight
    }), e.rowsMeta.positions.length - 1);
    const d = e.hiddenCellsOriginMap[c];
    if (d) {
      const p = Math.min(...Object.values(d));
      c = Math.min(c, p);
    }
    const f = e.autoHeight ? c + e.rows.length : dR(e, o + e.viewportInnerHeight);
    r.firstRowIndex = c, r.lastRowIndex = f;
  }
  if (e.enabledForColumns) {
    let c = 0, d = e.columnPositions.length, f = !1;
    const [p, g] = rC({
      firstIndex: r.firstRowIndex,
      lastIndex: r.lastRowIndex,
      minFirstIndex: 0,
      maxLastIndex: e.rows.length,
      bufferBefore: n.buffer.rowBefore,
      bufferAfter: n.buffer.rowAfter,
      positions: e.rowsMeta.positions,
      lastSize: e.lastRowHeight
    });
    if (!e.virtualizeColumnsWithAutoRowHeight)
      for (let b = p; b < g && !f; b += 1) {
        const v = e.rows[b];
        f = e.apiRef.current.rowHasAutoHeight(v.id);
      }
    (!f || e.virtualizeColumnsWithAutoRowHeight) && (c = Sl(a, e.columnPositions, {
      atStart: !0,
      lastPosition: e.columnsTotalWidth
    }), d = Sl(a + e.viewportInnerWidth, e.columnPositions)), r.firstColumnIndex = c, r.lastColumnIndex = d;
  }
  return sue(e, r, n);
}
function dR(e, t, n) {
  var a, l;
  const r = e.apiRef.current.getLastMeasuredRowIndex();
  let o = r === 1 / 0;
  (a = e.range) != null && a.lastRowIndex && !o && (o = r >= e.range.lastRowIndex);
  const i = js(r - (((l = e.range) == null ? void 0 : l.firstRowIndex) || 0), 0, e.rowsMeta.positions.length);
  return o || e.rowsMeta.positions[i] >= t ? Sl(t, e.rowsMeta.positions, n) : aue(t, e.rowsMeta.positions, i, n);
}
function sue(e, t, n) {
  const [r, o] = rC({
    firstIndex: t.firstRowIndex,
    lastIndex: t.lastRowIndex,
    minFirstIndex: 0,
    maxLastIndex: e.rows.length,
    bufferBefore: n.buffer.rowBefore,
    bufferAfter: n.buffer.rowAfter,
    positions: e.rowsMeta.positions,
    lastSize: e.lastRowHeight
  }), [i, a] = rC({
    firstIndex: t.firstColumnIndex,
    lastIndex: t.lastColumnIndex,
    minFirstIndex: e.pinnedColumns.left.length,
    maxLastIndex: e.visibleColumns.length - e.pinnedColumns.right.length,
    bufferBefore: n.buffer.columnBefore,
    bufferAfter: n.buffer.columnAfter,
    positions: e.columnPositions,
    lastSize: e.lastColumnWidth
  }), l = Bce({
    firstColumnToRender: i,
    apiRef: e.apiRef,
    firstRowToRender: r,
    lastRowToRender: o,
    visibleRows: e.rows
  });
  return {
    firstRowIndex: r,
    lastRowIndex: o,
    firstColumnIndex: l,
    lastColumnIndex: a
  };
}
function Sl(e, t, n = void 0, r = 0, o = t.length) {
  if (t.length <= 0)
    return -1;
  if (r >= o)
    return r;
  const i = r + Math.floor((o - r) / 2), a = t[i];
  let l;
  if (n != null && n.atStart) {
    const c = (i === t.length - 1 ? n.lastPosition : t[i + 1]) - a;
    l = e - c < a;
  } else
    l = e <= a;
  return l ? Sl(e, t, n, r, i) : Sl(e, t, n, i + 1, o);
}
function aue(e, t, n, r = void 0) {
  let o = 1;
  for (; n < t.length && Math.abs(t[n]) < e; )
    n += o, o *= 2;
  return Sl(e, t, r, Math.floor(n / 2), Math.min(n, t.length));
}
function rC({
  firstIndex: e,
  lastIndex: t,
  bufferBefore: n,
  bufferAfter: r,
  minFirstIndex: o,
  maxLastIndex: i,
  positions: a,
  lastSize: l
}) {
  const c = a[e] - n, d = a[t] + r, f = Sl(c, a, {
    atStart: !0,
    lastPosition: a[a.length - 1] + l
  }), p = Sl(d, a);
  return [js(f, o, i), js(p, o, i)];
}
function lue(e, t) {
  return e === t ? !0 : e.firstRowIndex === t.firstRowIndex && e.lastRowIndex === t.lastRowIndex && e.firstColumnIndex === t.firstColumnIndex && e.lastColumnIndex === t.lastColumnIndex;
}
function fF(e, t, n) {
  const r = (e[t.firstColumnIndex] ?? 0) - (e[n] ?? 0);
  return Math.abs(r);
}
function cue(e, t) {
  return e === 0 && t === 0 ? Pr.NONE : Math.abs(t) >= Math.abs(e) ? t > 0 ? Pr.DOWN : Pr.UP : e > 0 ? Pr.RIGHT : Pr.LEFT;
}
function pF(e, t, n, r, o, i) {
  if (e)
    switch (t) {
      case Pr.LEFT:
        t = Pr.RIGHT;
        break;
      case Pr.RIGHT:
        t = Pr.LEFT;
        break;
    }
  switch (t) {
    case Pr.NONE:
      return {
        rowAfter: n,
        rowBefore: n,
        columnAfter: r,
        columnBefore: r
      };
    case Pr.LEFT:
      return {
        rowAfter: 0,
        rowBefore: 0,
        columnAfter: 0,
        columnBefore: i
      };
    case Pr.RIGHT:
      return {
        rowAfter: 0,
        rowBefore: 0,
        columnAfter: i,
        columnBefore: 0
      };
    case Pr.UP:
      return {
        rowAfter: 0,
        rowBefore: o,
        columnAfter: 0,
        columnBefore: 0
      };
    case Pr.DOWN:
      return {
        rowAfter: o,
        rowBefore: 0,
        columnAfter: 0,
        columnBefore: 0
      };
    default:
      throw new Error("unreachable");
  }
}
function fR(e) {
  return {
    width: Math.round(e.width * 10) / 10,
    height: Math.round(e.height * 10) / 10
  };
}
const uue = () => {
  var p, g;
  const e = Wt(), t = ft(), n = Be(e, ry), r = Be(e, ES), o = Be(e, IN), i = n === 0 && o === 0, a = Be(e, dle), l = !a && i, c = !a && n > 0 && r === 0;
  let d = null, f = null;
  return l && (d = "noRowsOverlay"), c && (d = "noResultsOverlay"), a && (d = "loadingOverlay", f = ((g = (p = t.slotProps) == null ? void 0 : p.loadingOverlay) == null ? void 0 : g[i ? "noRowsVariant" : "variant"]) || null), {
    overlayType: d,
    loadingOverlayVariant: f
  };
}, due = On("div", {
  name: "MuiDataGrid",
  slot: "OverlayWrapper",
  shouldForwardProp: (e) => e !== "overlayType" && e !== "loadingOverlayVariant",
  overridesResolver: (e, t) => t.overlayWrapper
})(({
  overlayType: e,
  loadingOverlayVariant: t
}) => (
  // Skeleton overlay should flow with the scroll container and not be sticky
  t !== "skeleton" ? {
    position: "sticky",
    // To stay in place while scrolling
    top: "var(--DataGrid-headersTotalHeight)",
    // TODO: take pinned rows into account
    left: 0,
    width: 0,
    // To stay above the content instead of shifting it down
    height: 0,
    // To stay above the content instead of shifting it down
    zIndex: e === "loadingOverlay" ? 5 : 4
    // Should be above pinned columns and detail panel
  } : {}
)), fue = On("div", {
  name: "MuiDataGrid",
  slot: "OverlayWrapperInner",
  shouldForwardProp: (e) => e !== "overlayType" && e !== "loadingOverlayVariant",
  overridesResolver: (e, t) => t.overlayWrapperInner
})({}), pue = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["overlayWrapper"],
    inner: ["overlayWrapperInner"]
  }, nn, t);
};
function hF(e) {
  const t = Wt(), n = ft(), r = Be(t, mo);
  let o = Math.max(r.viewportOuterSize.height - r.topContainerHeight - r.bottomContainerHeight - (r.hasScrollX ? r.scrollbarSize : 0), 0);
  o === 0 && (o = kN);
  const i = pue(U({}, e, {
    classes: n.classes
  }));
  return /* @__PURE__ */ w.jsx(due, U({
    className: ke(i.root)
  }, e, {
    children: /* @__PURE__ */ w.jsx(fue, U({
      className: ke(i.inner),
      style: {
        height: o,
        width: r.viewportOuterSize.width
      }
    }, e))
  }));
}
process.env.NODE_ENV !== "production" && (hF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  loadingOverlayVariant: s.oneOf(["circular-progress", "linear-progress", "skeleton"]),
  overlayType: s.oneOf(["loadingOverlay", "noResultsOverlay", "noRowsOverlay"])
});
process.env.NODE_ENV !== "production" && (gF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  loadingOverlayVariant: s.oneOf(["circular-progress", "linear-progress", "skeleton"]),
  overlayType: s.oneOf(["loadingOverlay", "noResultsOverlay", "noRowsOverlay"])
});
function gF(e) {
  var i, a;
  const {
    overlayType: t
  } = e, n = ft();
  if (!t)
    return null;
  const r = (i = n.slots) == null ? void 0 : i[t], o = (a = n.slotProps) == null ? void 0 : a[t];
  return /* @__PURE__ */ w.jsx(hF, U({}, e, {
    children: /* @__PURE__ */ w.jsx(r, U({}, o))
  }));
}
const Yg = (e) => e.columnMenu;
function hue() {
  var S;
  const e = Hi(), t = ft(), n = Be(e, Fr), r = Be(e, Lle), o = Be(e, Dle), i = Be(e, zN), a = Be(e, PS), l = Be(e, Kle), c = Be(e, qle), d = Be(e, Dm), f = Be(e, fh), p = Be(e, Yg), g = Be(e, Ai), b = Be(e, $ce), v = !(l === null && i === null && a === null), y = e.current.columnHeadersContainerRef;
  return /* @__PURE__ */ w.jsx(t.slots.columnHeaders, U({
    ref: y,
    visibleColumns: n,
    filterColumnLookup: r,
    sortColumnLookup: o,
    columnHeaderTabIndexState: i,
    columnGroupHeaderTabIndexState: l,
    columnHeaderFocus: c,
    columnGroupHeaderFocus: d,
    headerGroupingMaxDepth: f,
    columnMenuState: p,
    columnVisibility: g,
    columnGroupsHeaderStructure: b,
    hasOtherElementInTabSequence: v
  }, (S = t.slotProps) == null ? void 0 : S.columnHeaders));
}
const gue = Dl(hue), DS = /* @__PURE__ */ m.createContext(void 0);
process.env.NODE_ENV !== "production" && (DS.displayName = "GridConfigurationContext");
const mF = () => {
  const e = m.useContext(DS);
  if (e === void 0)
    throw new Error(["MUI X: Could not find the Data Grid configuration context.", "It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.", "This can also happen if you are bundling multiple versions of the Data Grid."].join(`
`));
  return e;
}, mue = On("div")({
  position: "absolute",
  top: "var(--DataGrid-headersTotalHeight)",
  left: 0,
  width: "calc(100% - (var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize)))"
}), bue = On("div", {
  name: "MuiDataGrid",
  slot: "Main",
  overridesResolver: (e, t) => t.main
})({
  flexGrow: 1,
  position: "relative",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column"
}), yue = dn((e, t) => {
  var i;
  const n = ft(), o = mF().hooks.useGridAriaAttributes();
  return /* @__PURE__ */ w.jsxs(bue, U({
    ownerState: n,
    className: e.className,
    tabIndex: -1
  }, o, (i = n.slotProps) == null ? void 0 : i.main, {
    ref: t,
    children: [/* @__PURE__ */ w.jsx(mue, {
      role: "presentation",
      "data-id": "gridPanelAnchor"
    }), e.children]
  }));
}), vue = () => tn({
  root: ["topContainer"]
}, nn, {}), wue = On("div")({
  position: "sticky",
  zIndex: 4,
  top: 0
});
function Cue(e) {
  const t = vue();
  return /* @__PURE__ */ w.jsx(wue, U({}, e, {
    className: ke(t.root, ee["container--top"]),
    role: "presentation"
  }));
}
const xue = () => tn({
  root: ["bottomContainer"]
}, nn, {}), Sue = On("div")({
  position: "sticky",
  zIndex: 4,
  bottom: "calc(var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize))"
});
function Eue(e) {
  const t = xue();
  return /* @__PURE__ */ w.jsx(Sue, U({}, e, {
    className: ke(t.root, ee["container--bottom"]),
    role: "presentation"
  }));
}
const Tue = (e, t) => {
  const {
    classes: n
  } = e;
  return tn({
    root: ["virtualScrollerContent", t && "virtualScrollerContent--overflowed"]
  }, nn, n);
}, Oue = On("div", {
  name: "MuiDataGrid",
  slot: "VirtualScrollerContent",
  overridesResolver: (e, t) => t.virtualScrollerContent
})({}), Pue = dn(function(t, n) {
  var a;
  const r = ft(), o = !r.autoHeight && ((a = t.style) == null ? void 0 : a.minHeight) === "auto", i = Tue(r, o);
  return /* @__PURE__ */ w.jsx(Oue, U({}, t, {
    ownerState: r,
    className: ke(i.root, t.className),
    ref: n
  }));
}), Iue = On("div")({
  display: "flex",
  flexDirection: "row",
  width: "var(--DataGrid-rowWidth)",
  boxSizing: "border-box"
}), bF = On("div")({
  position: "sticky",
  height: "100%",
  boxSizing: "border-box",
  borderTop: "1px solid var(--rowBorderColor)",
  backgroundColor: "var(--DataGrid-pinnedBackground)"
}), Rue = On(bF)({
  left: 0,
  borderRight: "1px solid var(--rowBorderColor)"
}), _ue = On(bF)({
  right: 0,
  borderLeft: "1px solid var(--rowBorderColor)"
}), kue = On("div")({
  flexGrow: 1,
  borderTop: "1px solid var(--rowBorderColor)"
});
function Mue({
  rowsLength: e
}) {
  const t = Wt(), {
    viewportOuterSize: n,
    minimumSize: r,
    hasScrollX: o,
    hasScrollY: i,
    scrollbarSize: a,
    leftPinnedWidth: l,
    rightPinnedWidth: c
  } = Be(t, mo), d = o ? a : 0, f = n.height - r.height > 0;
  return d === 0 && !f ? null : /* @__PURE__ */ w.jsxs(Iue, {
    className: ee.filler,
    role: "presentation",
    style: {
      height: d,
      "--rowBorderColor": e === 0 ? "transparent" : "var(--DataGrid-rowBorderColor)"
    },
    children: [l > 0 && /* @__PURE__ */ w.jsx(Rue, {
      className: ee["filler--pinnedLeft"],
      style: {
        width: l
      }
    }), /* @__PURE__ */ w.jsx(kue, {}), c > 0 && /* @__PURE__ */ w.jsx(_ue, {
      className: ee["filler--pinnedRight"],
      style: {
        width: c + (i ? a : 0)
      }
    })]
  });
}
const Aue = Dl(Mue), Due = ["className"], Nue = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["virtualScrollerRenderZone"]
  }, nn, t);
}, Fue = On("div", {
  name: "MuiDataGrid",
  slot: "VirtualScrollerRenderZone",
  overridesResolver: (e, t) => t.virtualScrollerRenderZone
})({
  position: "absolute",
  display: "flex",
  // Prevents margin collapsing when using `getRowSpacing`
  flexDirection: "column"
}), $ue = dn(function(t, n) {
  const {
    className: r
  } = t, o = yt(t, Due), i = Wt(), a = ft(), l = Nue(a), c = Be(i, () => {
    const d = py(i);
    return Ld(i.current.state).positions[d.firstRowIndex] ?? 0;
  });
  return /* @__PURE__ */ w.jsx(Fue, U({
    className: ke(l.root, r),
    ownerState: a,
    style: {
      transform: `translate3d(0, ${c}px, 0)`
    }
  }, o, {
    ref: n
  }));
}), Lue = {
  includeHeaders: !0,
  includeOutliers: !1,
  outliersFactor: 1.5,
  expand: !1,
  disableColumnVirtualization: !0
}, Qr = (e) => e.editRows, xp = (e) => e.preferencePanel;
var Ec = /* @__PURE__ */ function(e) {
  return e.filters = "filters", e.columns = "columns", e;
}(Ec || {});
const jue = (e, t) => {
  const {
    classes: n
  } = e, r = {
    root: ["scrollbar", `scrollbar--${t}`],
    content: ["scrollbarContent"]
  };
  return tn(r, nn, n);
}, yF = On("div")({
  position: "absolute",
  display: "inline-block",
  zIndex: 6,
  // In macOS Safari and Gnome Web, scrollbars are overlaid and don't affect the layout. So we consider
  // their size to be 0px throughout all the calculations, but the floating scrollbar container does need
  // to appear and have a real size. We set it to 14px because it seems like an acceptable value and we
  // don't have a method to find the required size for scrollbars on those platforms.
  "--size": "calc(max(var(--DataGrid-scrollbarSize), 14px))"
}), Bue = On(yF)({
  width: "var(--size)",
  height: "calc(var(--DataGrid-hasScrollY) * (100% - var(--DataGrid-topContainerHeight) - var(--DataGrid-bottomContainerHeight) - var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize)))",
  overflowY: "auto",
  overflowX: "hidden",
  // Disable focus-visible style, it's a scrollbar.
  outline: 0,
  "& > div": {
    width: "var(--size)"
  },
  top: "var(--DataGrid-topContainerHeight)",
  right: "0px"
}), Vue = On(yF)({
  width: "100%",
  height: "var(--size)",
  overflowY: "hidden",
  overflowX: "auto",
  // Disable focus-visible style, it's a scrollbar.
  outline: 0,
  "& > div": {
    height: "var(--size)"
  },
  bottom: "0px"
}), pR = dn(function(t, n) {
  const r = Hi(), o = ft(), i = m.useRef(!1), a = m.useRef(0), l = m.useRef(null), c = m.useRef(null), d = jue(o, t.position), f = Be(r, mo), p = t.position === "vertical" ? "height" : "width", g = t.position === "vertical" ? "scrollTop" : "scrollLeft", b = t.position === "vertical" ? f.hasScrollX : f.hasScrollY, v = f.minimumSize[p] + (b ? f.scrollbarSize : 0), S = (t.position === "vertical" ? f.viewportInnerSize.height : f.viewportOuterSize.width) * (v / f.viewportOuterSize[p]), E = Yn(() => {
    const T = r.current.virtualScrollerRef.current, P = l.current;
    if (!P || T[g] === a.current)
      return;
    if (a.current = T[g], i.current) {
      i.current = !1;
      return;
    }
    i.current = !0;
    const R = T[g] / v;
    P[g] = R * S;
  }), I = Yn(() => {
    const T = r.current.virtualScrollerRef.current, P = l.current;
    if (!P)
      return;
    if (i.current) {
      i.current = !1;
      return;
    }
    i.current = !0;
    const R = P[g] / S;
    T[g] = R * v;
  });
  Mb(() => {
    const T = r.current.virtualScrollerRef.current, P = l.current;
    return T.addEventListener("scroll", E, {
      capture: !0
    }), P.addEventListener("scroll", I, {
      capture: !0
    }), () => {
      T.removeEventListener("scroll", E, {
        capture: !0
      }), P.removeEventListener("scroll", I, {
        capture: !0
      });
    };
  }), m.useEffect(() => {
    c.current.style.setProperty(p, `${S}px`);
  }, [S, p]);
  const O = t.position === "vertical" ? Bue : Vue;
  return /* @__PURE__ */ w.jsx(O, {
    ref: Rl(n, l),
    className: d.root,
    style: t.position === "vertical" && o.unstable_listView ? {
      height: "100%",
      top: 0
    } : void 0,
    tabIndex: -1,
    "aria-hidden": "true",
    children: /* @__PURE__ */ w.jsx("div", {
      ref: c,
      className: d.content
    })
  });
}), Hue = (e, t, n) => {
  const {
    classes: r
  } = e, o = {
    root: ["main", t.rightPinnedWidth > 0 && "main--hasPinnedRight", n === "skeleton" && "main--hasSkeletonLoadingOverlay"],
    scroller: ["virtualScroller", t.hasScrollX && "virtualScroller--hasScrollX"]
  };
  return tn(o, nn, r);
}, Uue = On("div", {
  name: "MuiDataGrid",
  slot: "VirtualScroller",
  overridesResolver: (e, t) => t.virtualScroller
})({
  position: "relative",
  height: "100%",
  flexGrow: 1,
  overflow: "scroll",
  scrollbarWidth: "none",
  display: "flex",
  flexDirection: "column",
  "&::-webkit-scrollbar": {
    display: "none"
    /* Safari and Chrome */
  },
  "@media print": {
    overflow: "hidden"
  },
  // See https://github.com/mui/mui-x/issues/10547
  zIndex: 0
});
function zue(e) {
  const t = Wt(), n = ft(), r = Be(t, mo), o = uue(), i = Hue(n, r, o.loadingOverlayVariant), a = iue(), {
    getContainerProps: l,
    getScrollerProps: c,
    getContentProps: d,
    getRenderZoneProps: f,
    getScrollbarVerticalProps: p,
    getScrollbarHorizontalProps: g,
    getRows: b
  } = a, v = b();
  return /* @__PURE__ */ w.jsxs(yue, U({
    className: i.root
  }, l(), {
    children: [/* @__PURE__ */ w.jsx(cR, {
      scrollDirection: "left"
    }), /* @__PURE__ */ w.jsx(cR, {
      scrollDirection: "right"
    }), /* @__PURE__ */ w.jsxs(Uue, U({
      className: i.scroller
    }, c(), {
      ownerState: n,
      children: [/* @__PURE__ */ w.jsxs(Cue, {
        children: [!n.unstable_listView && /* @__PURE__ */ w.jsx(gue, {}), /* @__PURE__ */ w.jsx(n.slots.pinnedRows, {
          position: "top",
          virtualScroller: a
        })]
      }), /* @__PURE__ */ w.jsx(gF, U({}, o)), /* @__PURE__ */ w.jsx(Pue, U({}, d(), {
        children: /* @__PURE__ */ w.jsxs($ue, U({}, f(), {
          children: [v, /* @__PURE__ */ w.jsx(n.slots.detailPanels, {
            virtualScroller: a
          })]
        }))
      })), /* @__PURE__ */ w.jsx(Aue, {
        rowsLength: v.length
      }), /* @__PURE__ */ w.jsx(Eue, {
        children: /* @__PURE__ */ w.jsx(n.slots.pinnedRows, {
          position: "bottom",
          virtualScroller: a
        })
      })]
    })), r.hasScrollY && /* @__PURE__ */ w.jsx(pR, U({
      position: "vertical"
    }, p())), r.hasScrollX && !n.unstable_listView && /* @__PURE__ */ w.jsx(pR, U({
      position: "horizontal"
    }, g())), e.children]
  }));
}
function Gue() {
  var t;
  const e = ft();
  return e.hideFooter ? null : /* @__PURE__ */ w.jsx(e.slots.footer, U(
    {},
    (t = e.slotProps) == null ? void 0 : t.footer
    /* FIXME: typing error */
  ));
}
let Rw;
function Wue() {
  return Rw === void 0 && document.createElement("div").focus({
    get preventScroll() {
      return Rw = !0, !1;
    }
  }), Rw;
}
const hy = (e, t, n, r, o) => {
  const i = t === n - 1;
  return e === $n.LEFT && i ? !0 : r ? e === $n.LEFT ? !0 : e === $n.RIGHT ? !i : !i || o : !1;
}, gy = (e, t) => e === $n.RIGHT && t === 0, que = ["column", "rowId", "editCellState", "align", "children", "colIndex", "width", "className", "style", "colSpan", "disableDragEvents", "isNotVisible", "pinnedOffset", "pinnedPosition", "sectionIndex", "sectionLength", "gridHasFiller", "onClick", "onDoubleClick", "onMouseDown", "onMouseUp", "onMouseOver", "onKeyDown", "onKeyUp", "onDragEnter", "onDragOver"], Kue = ["changeReason", "unstable_updateValueOnRender"];
let Vo = /* @__PURE__ */ function(e) {
  return e[e.NONE = 0] = "NONE", e[e.LEFT = 1] = "LEFT", e[e.RIGHT = 2] = "RIGHT", e[e.VIRTUAL = 3] = "VIRTUAL", e;
}({});
const vF = {
  [Vo.LEFT]: $n.LEFT,
  [Vo.RIGHT]: $n.RIGHT,
  [Vo.NONE]: void 0,
  [Vo.VIRTUAL]: void 0
}, hR = {
  id: -1,
  field: "__unset__",
  row: {},
  rowNode: {
    id: -1,
    depth: 0,
    type: "leaf",
    parent: -1,
    groupingKey: null
  },
  colDef: {
    type: "string",
    field: "__unset__",
    computedWidth: 0
  },
  cellMode: En.View,
  hasFocus: !1,
  tabIndex: -1,
  value: null,
  formattedValue: "__unset__",
  isEditable: !1,
  api: {}
}, Yue = (e) => {
  const {
    align: t,
    showLeftBorder: n,
    showRightBorder: r,
    pinnedPosition: o,
    isEditable: i,
    isSelected: a,
    isSelectionMode: l,
    classes: c
  } = e, d = {
    root: ["cell", `cell--text${Jp(t)}`, a && "selected", i && "cell--editable", n && "cell--withLeftBorder", r && "cell--withRightBorder", o === Vo.LEFT && "cell--pinnedLeft", o === Vo.RIGHT && "cell--pinnedRight", l && !i && "cell--selectionMode"]
  };
  return tn(d, nn, c);
};
let gR = !1;
const wF = dn(function(t, n) {
  var Xe, xt, tt, ct;
  const {
    column: r,
    rowId: o,
    editCellState: i,
    align: a,
    colIndex: l,
    width: c,
    className: d,
    style: f,
    colSpan: p,
    disableDragEvents: g,
    isNotVisible: b,
    pinnedOffset: v,
    pinnedPosition: y,
    sectionIndex: S,
    sectionLength: E,
    gridHasFiller: I,
    onClick: O,
    onDoubleClick: T,
    onMouseDown: P,
    onMouseUp: R,
    onMouseOver: F,
    onKeyDown: A,
    onKeyUp: _,
    onDragEnter: C,
    onDragOver: D
  } = t, L = yt(t, que), B = Wt(), H = ft(), k = mi(), N = r.field, j = Be(B, () => {
    if (!B.current.getRow(o))
      return hR;
    const Ge = B.current.getCellParams(o, N);
    return Ge.api = B.current, Ge;
  }, dN), W = Be(B, () => B.current.unstable_applyPipeProcessors("isCellSelected", !1, {
    id: o,
    field: N
  })), V = Be(B, dF), $ = Be(B, tue), {
    cellMode: z,
    hasFocus: ne,
    isEditable: K = !1,
    value: Q
  } = j, re = r.type === "actions" && ((Xe = r.getActions) == null ? void 0 : Xe.call(r, B.current.getRowParams(o)).some((Je) => !Je.props.disabled)), te = (z === "view" || !K) && !re ? j.tabIndex : -1, {
    classes: ie,
    getCellClassName: ae
  } = H, le = [Be(B, () => B.current.unstable_applyPipeProcessors("cellClassName", [], {
    id: o,
    field: N
  }).filter(Boolean).join(" "))];
  r.cellClassName && le.push(typeof r.cellClassName == "function" ? r.cellClassName(j) : r.cellClassName), r.display === "flex" && le.push(ee["cell--flex"]), ae && le.push(ae(j));
  const we = j.formattedValue ?? Q, q = m.useRef(null), Ee = Rl(n, q), _e = m.useRef(null), $e = H.cellSelection ?? !1, Le = vF[y], Ze = gy(Le, S), J = hy(Le, S, E, H.showCellVerticalBorder, I), fe = {
    align: a,
    showLeftBorder: Ze,
    showRightBorder: J,
    isEditable: K,
    classes: H.classes,
    pinnedPosition: y,
    isSelected: W,
    isSelectionMode: $e
  }, me = Yue(fe), Oe = m.useCallback((Je) => (Ge) => {
    const lt = B.current.getCellParams(o, N || "");
    B.current.publishEvent(Je, lt, Ge), R && R(Ge);
  }, [B, N, R, o]), Ce = m.useCallback((Je) => (Ge) => {
    const lt = B.current.getCellParams(o, N || "");
    B.current.publishEvent(Je, lt, Ge), P && P(Ge);
  }, [B, N, P, o]), Te = m.useCallback((Je, Ge) => (lt) => {
    if (!B.current.getRow(o))
      return;
    const It = B.current.getCellParams(o, N || "");
    B.current.publishEvent(Je, It, lt), Ge && Ge(lt);
  }, [B, N, o]), Pe = ((xt = V[o]) == null ? void 0 : xt[N]) ?? !1, Ye = ((tt = $[o]) == null ? void 0 : tt[N]) ?? 1, Ke = m.useMemo(() => {
    if (b)
      return {
        padding: 0,
        opacity: 0,
        width: 0,
        height: 0,
        border: 0
      };
    const Je = U({
      "--width": `${c}px`
    }, f), Ge = y === Vo.LEFT, lt = y === Vo.RIGHT;
    if (Ge || lt) {
      let It = Ge ? "left" : "right";
      k && (It = Ge ? "right" : "left"), Je[It] = v;
    }
    return Ye > 1 && (Je.height = `calc(var(--height) * ${Ye})`, Je.zIndex = 5, (Ge || lt) && (Je.zIndex = 6)), Je;
  }, [c, b, f, v, y, k, Ye]);
  if (m.useEffect(() => {
    if (!ne || z === En.Edit)
      return;
    const Je = fl(B.current.rootElementRef.current);
    if (q.current && !q.current.contains(Je.activeElement)) {
      const Ge = q.current.querySelector('[tabindex="0"]'), lt = _e.current || Ge || q.current;
      if (Wue())
        lt.focus({
          preventScroll: !0
        });
      else {
        const It = B.current.getScrollPosition();
        lt.focus(), B.current.scroll(It);
      }
    }
  }, [ne, z, B]), Pe)
    return /* @__PURE__ */ w.jsx("div", {
      "data-colindex": l,
      role: "presentation",
      style: U({
        width: "var(--width)"
      }, Ke)
    });
  if (j === hR)
    return null;
  let je = L.onFocus;
  process.env.NODE_ENV === "test" && ((ct = H.experimentalFeatures) != null && ct.warnIfFocusStateIsNotSynced) && (je = (Je) => {
    const Ge = jo(B);
    if ((Ge == null ? void 0 : Ge.id) === o && Ge.field === N) {
      typeof L.onFocus == "function" && L.onFocus(Je);
      return;
    }
    gR || (console.warn([`MUI X: The cell with id=${o} and field=${N} received focus.`, `According to the state, the focus should be at id=${Ge == null ? void 0 : Ge.id}, field=${Ge == null ? void 0 : Ge.field}.`, "Not syncing the state may cause unwanted behaviors since the `cellFocusIn` event won't be fired.", "Call `fireEvent.mouseUp` before the `fireEvent.click` to sync the focus with the state."].join(`
`)), gR = !0);
  });
  let Qe, et;
  if (i === null && r.renderCell && (Qe = r.renderCell(j)), i !== null && r.renderEditCell) {
    const Je = B.current.getRowWithUpdatedValues(o, r.field), Ge = yt(i, Kue), lt = r.valueFormatter ? r.valueFormatter(i.value, Je, r, B) : j.formattedValue, It = U({}, j, {
      row: Je,
      formattedValue: lt
    }, Ge);
    Qe = r.renderEditCell(It), le.push(ee["cell--editing"]), le.push(ie == null ? void 0 : ie["cell--editing"]);
  }
  if (Qe === void 0) {
    const Je = we == null ? void 0 : we.toString();
    Qe = Je, et = Je;
  }
  /* @__PURE__ */ m.isValidElement(Qe) && re && (Qe = /* @__PURE__ */ m.cloneElement(Qe, {
    focusElementRef: _e
  }));
  const Et = g ? null : {
    onDragEnter: Te("cellDragEnter", C),
    onDragOver: Te("cellDragOver", D)
  };
  return /* @__PURE__ */ w.jsx("div", U({
    className: ke(me.root, le, d),
    role: "gridcell",
    "data-field": N,
    "data-colindex": l,
    "aria-colindex": l + 1,
    "aria-colspan": p,
    "aria-rowspan": Ye,
    style: Ke,
    title: et,
    tabIndex: te,
    onClick: Te("cellClick", O),
    onDoubleClick: Te("cellDoubleClick", T),
    onMouseOver: Te("cellMouseOver", F),
    onMouseDown: Ce("cellMouseDown"),
    onMouseUp: Oe("cellMouseUp"),
    onKeyDown: Te("cellKeyDown", A),
    onKeyUp: Te("cellKeyUp", _)
  }, Et, L, {
    onFocus: je,
    ref: Ee,
    children: Qe
  }));
});
process.env.NODE_ENV !== "production" && (wF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  align: s.oneOf(["center", "left", "right"]).isRequired,
  colIndex: s.number.isRequired,
  colSpan: s.number,
  column: s.object.isRequired,
  disableDragEvents: s.bool,
  editCellState: s.shape({
    changeReason: s.oneOf(["debouncedSetEditCellValue", "setEditCellValue"]),
    isProcessingProps: s.bool,
    isValidating: s.bool,
    value: s.any
  }),
  gridHasFiller: s.bool.isRequired,
  isNotVisible: s.bool.isRequired,
  pinnedOffset: s.number.isRequired,
  pinnedPosition: s.oneOf([0, 1, 2, 3]).isRequired,
  rowId: s.oneOfType([s.number, s.string]).isRequired,
  sectionIndex: s.number.isRequired,
  sectionLength: s.number.isRequired,
  width: s.number.isRequired
});
const Que = Dl(wF), Xue = ["field", "type", "align", "width", "height", "empty", "style", "className"], mR = "1.3em", Jue = "1.2em", bR = [40, 80], Zue = {
  number: [40, 60],
  string: [40, 80],
  date: [40, 60],
  dateTime: [60, 80],
  singleSelect: [40, 80]
}, ede = (e) => {
  const {
    align: t,
    classes: n,
    empty: r
  } = e, o = {
    root: ["cell", "cellSkeleton", `cell--text${t ? Jp(t) : "Left"}`, r && "cellEmpty"]
  };
  return tn(o, nn, n);
}, tde = Wae(12345);
function CF(e) {
  const {
    field: t,
    type: n,
    align: r,
    width: o,
    height: i,
    empty: a = !1,
    style: l,
    className: c
  } = e, d = yt(e, Xue), p = {
    classes: ft().classes,
    align: r,
    empty: a
  }, g = ede(p), b = m.useMemo(() => {
    if (n === "boolean" || n === "actions")
      return {
        variant: "circular",
        width: mR,
        height: mR
      };
    const [y, S] = n ? Zue[n] ?? bR : bR;
    return {
      variant: "text",
      width: `${Math.round(tde(y, S))}%`,
      height: Jue
    };
  }, [n]);
  return /* @__PURE__ */ w.jsx("div", U({
    "data-field": t,
    className: ke(g.root, c),
    style: U({
      height: i,
      maxWidth: o,
      minWidth: o
    }, l)
  }, d, {
    children: !a && /* @__PURE__ */ w.jsx(OM, U({}, b))
  }));
}
process.env.NODE_ENV !== "production" && (CF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  align: s.string,
  /**
   * If `true`, the cell will not display the skeleton but still reserve the cell space.
   * @default false
   */
  empty: s.bool,
  field: s.string,
  height: s.oneOfType([s.oneOf(["auto"]), s.number]),
  type: s.oneOf(["actions", "boolean", "custom", "date", "dateTime", "number", "singleSelect", "string"]),
  width: s.oneOfType([s.number, s.string])
});
const nde = Dl(CF);
function rde(e) {
  return e.vars ? e.vars.palette.TableCell.border : e.palette.mode === "light" ? ml(Vt(e.palette.divider, 1), 0.88) : gl(Vt(e.palette.divider, 1), 0.68);
}
const yR = {
  [`& .${ee.iconButtonContainer}`]: {
    visibility: "visible",
    width: "auto"
  },
  [`& .${ee.menuIcon}`]: {
    width: "auto",
    visibility: "visible"
  }
}, ode = 10, Ig = -5, vu = 1, vR = {
  width: 3,
  rx: 1.5,
  x: 10.5
}, ide = "/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */", sde = oe("div", {
  name: "MuiDataGrid",
  slot: "Root",
  overridesResolver: (e, t) => [{
    [`&.${ee.autoHeight}`]: t.autoHeight
  }, {
    [`&.${ee.aggregationColumnHeader}`]: t.aggregationColumnHeader
  }, {
    [`&.${ee["aggregationColumnHeader--alignLeft"]}`]: t["aggregationColumnHeader--alignLeft"]
  }, {
    [`&.${ee["aggregationColumnHeader--alignCenter"]}`]: t["aggregationColumnHeader--alignCenter"]
  }, {
    [`&.${ee["aggregationColumnHeader--alignRight"]}`]: t["aggregationColumnHeader--alignRight"]
  }, {
    [`&.${ee.aggregationColumnHeaderLabel}`]: t.aggregationColumnHeaderLabel
  }, {
    [`&.${ee["root--disableUserSelection"]} .${ee.cell}`]: t["root--disableUserSelection"]
  }, {
    [`&.${ee.autosizing}`]: t.autosizing
  }, {
    [`& .${ee.editBooleanCell}`]: t.editBooleanCell
  }, {
    [`& .${ee.cell}`]: t.cell
  }, {
    [`& .${ee["cell--editing"]}`]: t["cell--editing"]
  }, {
    [`& .${ee["cell--textCenter"]}`]: t["cell--textCenter"]
  }, {
    [`& .${ee["cell--textLeft"]}`]: t["cell--textLeft"]
  }, {
    [`& .${ee["cell--textRight"]}`]: t["cell--textRight"]
  }, {
    [`& .${ee["cell--rangeTop"]}`]: t["cell--rangeTop"]
  }, {
    [`& .${ee["cell--rangeBottom"]}`]: t["cell--rangeBottom"]
  }, {
    [`& .${ee["cell--rangeLeft"]}`]: t["cell--rangeLeft"]
  }, {
    [`& .${ee["cell--rangeRight"]}`]: t["cell--rangeRight"]
  }, {
    [`& .${ee["cell--withRightBorder"]}`]: t["cell--withRightBorder"]
  }, {
    [`& .${ee.cellCheckbox}`]: t.cellCheckbox
  }, {
    [`& .${ee.cellSkeleton}`]: t.cellSkeleton
  }, {
    [`& .${ee.checkboxInput}`]: t.checkboxInput
  }, {
    [`& .${ee["columnHeader--alignCenter"]}`]: t["columnHeader--alignCenter"]
  }, {
    [`& .${ee["columnHeader--alignLeft"]}`]: t["columnHeader--alignLeft"]
  }, {
    [`& .${ee["columnHeader--alignRight"]}`]: t["columnHeader--alignRight"]
  }, {
    [`& .${ee["columnHeader--dragging"]}`]: t["columnHeader--dragging"]
  }, {
    [`& .${ee["columnHeader--moving"]}`]: t["columnHeader--moving"]
  }, {
    [`& .${ee["columnHeader--numeric"]}`]: t["columnHeader--numeric"]
  }, {
    [`& .${ee["columnHeader--sortable"]}`]: t["columnHeader--sortable"]
  }, {
    [`& .${ee["columnHeader--sorted"]}`]: t["columnHeader--sorted"]
  }, {
    [`& .${ee["columnHeader--withRightBorder"]}`]: t["columnHeader--withRightBorder"]
  }, {
    [`& .${ee.columnHeader}`]: t.columnHeader
  }, {
    [`& .${ee.headerFilterRow}`]: t.headerFilterRow
  }, {
    [`& .${ee.columnHeaderCheckbox}`]: t.columnHeaderCheckbox
  }, {
    [`& .${ee.columnHeaderDraggableContainer}`]: t.columnHeaderDraggableContainer
  }, {
    [`& .${ee.columnHeaderTitleContainer}`]: t.columnHeaderTitleContainer
  }, {
    [`& .${ee["columnSeparator--resizable"]}`]: t["columnSeparator--resizable"]
  }, {
    [`& .${ee["columnSeparator--resizing"]}`]: t["columnSeparator--resizing"]
  }, {
    [`& .${ee.columnSeparator}`]: t.columnSeparator
  }, {
    [`& .${ee.filterIcon}`]: t.filterIcon
  }, {
    [`& .${ee.iconSeparator}`]: t.iconSeparator
  }, {
    [`& .${ee.menuIcon}`]: t.menuIcon
  }, {
    [`& .${ee.menuIconButton}`]: t.menuIconButton
  }, {
    [`& .${ee.menuOpen}`]: t.menuOpen
  }, {
    [`& .${ee.menuList}`]: t.menuList
  }, {
    [`& .${ee["row--editable"]}`]: t["row--editable"]
  }, {
    [`& .${ee["row--editing"]}`]: t["row--editing"]
  }, {
    [`& .${ee["row--dragging"]}`]: t["row--dragging"]
  }, {
    [`& .${ee.row}`]: t.row
  }, {
    [`& .${ee.rowReorderCellPlaceholder}`]: t.rowReorderCellPlaceholder
  }, {
    [`& .${ee.rowReorderCell}`]: t.rowReorderCell
  }, {
    [`& .${ee["rowReorderCell--draggable"]}`]: t["rowReorderCell--draggable"]
  }, {
    [`& .${ee.sortIcon}`]: t.sortIcon
  }, {
    [`& .${ee.withBorderColor}`]: t.withBorderColor
  }, {
    [`& .${ee.treeDataGroupingCell}`]: t.treeDataGroupingCell
  }, {
    [`& .${ee.treeDataGroupingCellToggle}`]: t.treeDataGroupingCellToggle
  }, {
    [`& .${ee.treeDataGroupingCellLoadingContainer}`]: t.treeDataGroupingCellLoadingContainer
  }, {
    [`& .${ee.groupingCriteriaCellLoadingContainer}`]: t.groupingCriteriaCellLoadingContainer
  }, {
    [`& .${ee.detailPanelToggleCell}`]: t.detailPanelToggleCell
  }, {
    [`& .${ee["detailPanelToggleCell--expanded"]}`]: t["detailPanelToggleCell--expanded"]
  }, t.root]
})(({
  theme: e
}) => {
  var A, _;
  const t = Hi(), n = Be(t, mo), r = rde(e), o = e.shape.borderRadius, i = e.vars ? e.vars.palette.background.default : ((A = e.mixins.MuiDataGrid) == null ? void 0 : A.containerBackground) ?? e.palette.background.default, a = ((_ = e.mixins.MuiDataGrid) == null ? void 0 : _.pinnedBackground) ?? i, l = e.vars ? `rgba(${e.vars.palette.background.defaultChannel} / ${e.vars.palette.action.disabledOpacity})` : Vt(e.palette.background.default, e.palette.action.disabledOpacity), c = (e.vars || e).palette.action.hoverOpacity, d = (e.vars || e).palette.action.hover, f = (e.vars || e).palette.action.selectedOpacity, p = e.vars ? `calc(${c} + ${f})` : c + f, g = e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${f})` : Vt(e.palette.primary.main, f), b = e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${p})` : Vt(e.palette.primary.main, p), v = e.vars ? cde : ade, y = (C) => ({
    [`& .${ee["cell--pinnedLeft"]}, & .${ee["cell--pinnedRight"]}`]: {
      backgroundColor: C,
      "&.Mui-selected": {
        backgroundColor: v(C, g, f),
        "&:hover": {
          backgroundColor: v(C, g, p)
        }
      }
    }
  }), S = v(a, d, c), E = y(S), I = v(a, g, f), O = y(I), T = v(a, b, p), P = y(T), R = {
    backgroundColor: g,
    "&:hover": {
      backgroundColor: b,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: g
      }
    }
  };
  return U({
    "--unstable_DataGrid-radius": typeof o == "number" ? `${o}px` : o,
    "--unstable_DataGrid-headWeight": e.typography.fontWeightMedium,
    "--unstable_DataGrid-overlayBackground": l,
    "--DataGrid-containerBackground": i,
    "--DataGrid-pinnedBackground": a,
    "--DataGrid-rowBorderColor": r,
    "--DataGrid-cellOffsetMultiplier": 2,
    "--DataGrid-width": "0px",
    "--DataGrid-hasScrollX": "0",
    "--DataGrid-hasScrollY": "0",
    "--DataGrid-scrollbarSize": "10px",
    "--DataGrid-rowWidth": "0px",
    "--DataGrid-columnsTotalWidth": "0px",
    "--DataGrid-leftPinnedWidth": "0px",
    "--DataGrid-rightPinnedWidth": "0px",
    "--DataGrid-headerHeight": "0px",
    "--DataGrid-headersTotalHeight": "0px",
    "--DataGrid-topContainerHeight": "0px",
    "--DataGrid-bottomContainerHeight": "0px",
    flex: 1,
    boxSizing: "border-box",
    position: "relative",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: r,
    borderRadius: "var(--unstable_DataGrid-radius)",
    color: (e.vars || e).palette.text.primary
  }, e.typography.body2, {
    outline: "none",
    height: "100%",
    display: "flex",
    minWidth: 0,
    // See https://github.com/mui/mui-x/issues/8547
    minHeight: 0,
    flexDirection: "column",
    overflow: "hidden",
    overflowAnchor: "none",
    // Keep the same scrolling position
    [`.${ee.main} > *:first-child${ide}`]: {
      borderTopLeftRadius: "var(--unstable_DataGrid-radius)",
      borderTopRightRadius: "var(--unstable_DataGrid-radius)"
    },
    [`&.${ee.autoHeight}`]: {
      height: "auto"
    },
    [`&.${ee.autosizing}`]: {
      [`& .${ee.columnHeaderTitleContainerContent} > *`]: {
        overflow: "visible !important"
      },
      "@media (hover: hover)": {
        [`& .${ee.iconButtonContainer}`]: {
          width: "0 !important",
          visibility: "hidden !important"
        },
        [`& .${ee.menuIcon}`]: {
          width: "0 !important",
          visibility: "hidden !important"
        }
      },
      [`& .${ee.cell}`]: {
        overflow: "visible !important",
        whiteSpace: "nowrap",
        minWidth: "max-content !important",
        maxWidth: "max-content !important"
      },
      [`& .${ee.groupingCriteriaCell}`]: {
        width: "unset"
      },
      [`& .${ee.treeDataGroupingCell}`]: {
        width: "unset"
      }
    },
    [`& .${ee.columnHeader}, & .${ee.cell}`]: {
      WebkitTapHighlightColor: "transparent",
      padding: "0 10px",
      boxSizing: "border-box"
    },
    [`& .${ee.columnHeader}:focus-within, & .${ee.cell}:focus-within`]: {
      outline: `solid ${e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / 0.5)` : Vt(e.palette.primary.main, 0.5)} ${vu}px`,
      outlineOffset: vu * -1
    },
    [`& .${ee.columnHeader}:focus, & .${ee.cell}:focus`]: {
      outline: `solid ${e.palette.primary.main} ${vu}px`,
      outlineOffset: vu * -1
    },
    // Hide the column separator when:
    // - the column is focused and has an outline
    // - the next column is focused and has an outline
    // - the column has a left or right border
    // - the next column is pinned right and has a left border
    [`& .${ee.columnHeader}:focus,
      & .${ee["columnHeader--withLeftBorder"]},
      & .${ee["columnHeader--withRightBorder"]},
      & .${ee["columnHeader--siblingFocused"]},
      & .${ee["virtualScroller--hasScrollX"]} .${ee["columnHeader--lastUnpinned"]},
      & .${ee["virtualScroller--hasScrollX"]} .${ee["columnHeader--last"]}
      `]: {
      [`& .${ee.columnSeparator}`]: {
        opacity: 0
      },
      // Show resizable separators at all times on touch devices
      "@media (hover: none)": {
        [`& .${ee["columnSeparator--resizable"]}`]: {
          opacity: 1
        }
      },
      [`& .${ee["columnSeparator--resizable"]}:hover`]: {
        opacity: 1
      }
    },
    [`&.${ee["root--noToolbar"]} [aria-rowindex="1"] [aria-colindex="1"]`]: {
      borderTopLeftRadius: "calc(var(--unstable_DataGrid-radius) - 1px)"
    },
    [`&.${ee["root--noToolbar"]} [aria-rowindex="1"] .${ee["columnHeader--last"]}`]: {
      borderTopRightRadius: n.hasScrollX && (!n.hasScrollY || n.scrollbarSize === 0) ? "calc(var(--unstable_DataGrid-radius) - 1px)" : void 0
    },
    [`& .${ee.columnHeaderCheckbox}, & .${ee.cellCheckbox}`]: {
      padding: 0,
      justifyContent: "center",
      alignItems: "center"
    },
    [`& .${ee.columnHeader}`]: {
      position: "relative",
      display: "flex",
      alignItems: "center"
    },
    [`& .${ee["virtualScroller--hasScrollX"]} .${ee["columnHeader--last"]}`]: {
      overflow: "hidden"
    },
    [`& .${ee["columnHeader--sorted"]} .${ee.iconButtonContainer}, & .${ee["columnHeader--filtered"]} .${ee.iconButtonContainer}`]: {
      visibility: "visible",
      width: "auto"
    },
    [`& .${ee.columnHeader}:not(.${ee["columnHeader--sorted"]}) .${ee.sortIcon}`]: {
      opacity: 0,
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.shorter
      })
    },
    [`& .${ee.columnHeaderTitleContainer}`]: {
      display: "flex",
      alignItems: "center",
      gap: e.spacing(0.25),
      minWidth: 0,
      flex: 1,
      whiteSpace: "nowrap",
      overflow: "hidden"
    },
    [`& .${ee.columnHeaderTitleContainerContent}`]: {
      overflow: "hidden",
      display: "flex",
      alignItems: "center"
    },
    [`& .${ee["columnHeader--filledGroup"]} .${ee.columnHeaderTitleContainer}`]: {
      borderBottomWidth: "1px",
      borderBottomStyle: "solid",
      boxSizing: "border-box"
    },
    [`& .${ee.sortIcon}, & .${ee.filterIcon}`]: {
      fontSize: "inherit"
    },
    [`& .${ee["columnHeader--sortable"]}`]: {
      cursor: "pointer"
    },
    [`& .${ee["columnHeader--alignCenter"]} .${ee.columnHeaderTitleContainer}`]: {
      justifyContent: "center"
    },
    [`& .${ee["columnHeader--alignRight"]} .${ee.columnHeaderDraggableContainer}, & .${ee["columnHeader--alignRight"]} .${ee.columnHeaderTitleContainer}`]: {
      flexDirection: "row-reverse"
    },
    [`& .${ee["columnHeader--alignCenter"]} .${ee.menuIcon}`]: {
      marginLeft: "auto"
    },
    [`& .${ee["columnHeader--alignRight"]} .${ee.menuIcon}`]: {
      marginRight: "auto",
      marginLeft: -5
    },
    [`& .${ee["columnHeader--moving"]}`]: {
      backgroundColor: (e.vars || e).palette.action.hover
    },
    [`& .${ee["columnHeader--pinnedLeft"]}, & .${ee["columnHeader--pinnedRight"]}`]: {
      position: "sticky",
      zIndex: 4,
      // Should be above the column separator
      background: "var(--DataGrid-pinnedBackground)"
    },
    [`& .${ee.columnSeparator}`]: {
      position: "absolute",
      overflow: "hidden",
      zIndex: 3,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      maxWidth: ode,
      color: r
    },
    [`& .${ee.columnHeaders}`]: {
      width: "var(--DataGrid-rowWidth)"
    },
    "@media (hover: hover)": {
      [`& .${ee.columnHeader}:hover`]: yR,
      [`& .${ee.columnHeader}:not(.${ee["columnHeader--sorted"]}):hover .${ee.sortIcon}`]: {
        opacity: 0.5
      }
    },
    "@media (hover: none)": {
      [`& .${ee.columnHeader}`]: yR,
      [`& .${ee.columnHeader}:focus,
        & .${ee["columnHeader--siblingFocused"]}`]: {
        [`.${ee["columnSeparator--resizable"]}`]: {
          color: (e.vars || e).palette.primary.main
        }
      }
    },
    [`& .${ee["columnSeparator--sideLeft"]}`]: {
      left: Ig
    },
    [`& .${ee["columnSeparator--sideRight"]}`]: {
      right: Ig
    },
    [`& .${ee["columnHeader--withRightBorder"]} .${ee["columnSeparator--sideLeft"]}`]: {
      left: Ig - 0.5
    },
    [`& .${ee["columnHeader--withRightBorder"]} .${ee["columnSeparator--sideRight"]}`]: {
      right: Ig - 0.5
    },
    [`& .${ee["columnSeparator--resizable"]}`]: {
      cursor: "col-resize",
      touchAction: "none",
      [`&.${ee["columnSeparator--resizing"]}`]: {
        color: (e.vars || e).palette.primary.main
      },
      // Always appear as draggable on touch devices
      "@media (hover: none)": {
        [`& .${ee.iconSeparator} rect`]: vR
      },
      "@media (hover: hover)": {
        "&:hover": {
          color: (e.vars || e).palette.primary.main,
          [`& .${ee.iconSeparator} rect`]: vR
        }
      },
      "& svg": {
        pointerEvents: "none"
      }
    },
    [`& .${ee.iconSeparator}`]: {
      color: "inherit",
      transition: e.transitions.create(["color", "width"], {
        duration: e.transitions.duration.shortest
      })
    },
    [`& .${ee.menuIcon}`]: {
      width: 0,
      visibility: "hidden",
      fontSize: 20,
      marginRight: -5,
      display: "flex",
      alignItems: "center"
    },
    [`.${ee.menuOpen}`]: {
      visibility: "visible",
      width: "auto"
    },
    [`& .${ee.headerFilterRow}`]: {
      [`& .${ee.columnHeader}`]: {
        boxSizing: "border-box",
        borderBottom: "1px solid var(--DataGrid-rowBorderColor)"
      }
    },
    /* Bottom border of the top-container */
    [`& .${ee["row--borderBottom"]} .${ee.columnHeader},
      & .${ee["row--borderBottom"]} .${ee.filler},
      & .${ee["row--borderBottom"]} .${ee.scrollbarFiller}`]: {
      borderBottom: "1px solid var(--DataGrid-rowBorderColor)"
    },
    [`& .${ee["row--borderBottom"]} .${ee.cell}`]: {
      borderBottom: "1px solid var(--rowBorderColor)"
    },
    /* Row styles */
    [`.${ee.row}`]: {
      display: "flex",
      width: "var(--DataGrid-rowWidth)",
      breakInside: "avoid",
      // Avoid the row to be broken in two different print pages.
      "--rowBorderColor": "var(--DataGrid-rowBorderColor)",
      [`&.${ee["row--firstVisible"]}`]: {
        "--rowBorderColor": "transparent"
      },
      "&:hover": {
        backgroundColor: (e.vars || e).palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      },
      [`&.${ee.rowSkeleton}:hover`]: {
        backgroundColor: "transparent"
      },
      "&.Mui-selected": R
    },
    [`& .${ee["container--top"]}, & .${ee["container--bottom"]}`]: {
      "[role=row]": {
        background: "var(--DataGrid-containerBackground)"
      }
    },
    /* Cell styles */
    [`& .${ee.cell}`]: {
      flex: "0 0 auto",
      height: "var(--height)",
      width: "var(--width)",
      lineHeight: "calc(var(--height) - 1px)",
      // -1px for the border
      boxSizing: "border-box",
      borderTop: "1px solid var(--rowBorderColor)",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      "&.Mui-selected": R
    },
    [`& .${ee["virtualScrollerContent--overflowed"]} .${ee["row--lastVisible"]} .${ee.cell}`]: {
      borderTopColor: "transparent"
    },
    [`& .${ee["pinnedRows--top"]} :first-of-type`]: {
      [`& .${ee.cell}, .${ee.scrollbarFiller}`]: {
        borderTop: "none"
      }
    },
    [`&.${ee["root--disableUserSelection"]} .${ee.cell}`]: {
      userSelect: "none"
    },
    [`& .${ee["row--dynamicHeight"]} > .${ee.cell}`]: {
      whiteSpace: "initial",
      lineHeight: "inherit"
    },
    [`& .${ee.cellEmpty}`]: {
      padding: 0,
      height: "unset"
    },
    [`& .${ee.cell}.${ee["cell--selectionMode"]}`]: {
      cursor: "default"
    },
    [`& .${ee.cell}.${ee["cell--editing"]}`]: {
      padding: 1,
      display: "flex",
      boxShadow: e.shadows[2],
      backgroundColor: (e.vars || e).palette.background.paper,
      "&:focus-within": {
        outline: `${vu}px solid ${(e.vars || e).palette.primary.main}`,
        outlineOffset: vu * -1
      }
    },
    [`& .${ee["row--editing"]}`]: {
      boxShadow: e.shadows[2]
    },
    [`& .${ee["row--editing"]} .${ee.cell}`]: {
      boxShadow: e.shadows[0],
      backgroundColor: (e.vars || e).palette.background.paper
    },
    [`& .${ee.editBooleanCell}`]: {
      display: "flex",
      height: "100%",
      width: "100%",
      alignItems: "center",
      justifyContent: "center"
    },
    [`& .${ee.booleanCell}[data-value="true"]`]: {
      color: (e.vars || e).palette.text.secondary
    },
    [`& .${ee.booleanCell}[data-value="false"]`]: {
      color: (e.vars || e).palette.text.disabled
    },
    [`& .${ee.actionsCell}`]: {
      display: "inline-flex",
      alignItems: "center",
      gridGap: e.spacing(1)
    },
    [`& .${ee.rowReorderCell}`]: {
      display: "inline-flex",
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      opacity: (e.vars || e).palette.action.disabledOpacity
    },
    [`& .${ee["rowReorderCell--draggable"]}`]: {
      cursor: "move",
      opacity: 1
    },
    [`& .${ee.rowReorderCellContainer}`]: {
      padding: 0,
      display: "flex",
      alignItems: "stretch"
    },
    [`.${ee.withBorderColor}`]: {
      borderColor: r
    },
    [`& .${ee["cell--withLeftBorder"]}, & .${ee["columnHeader--withLeftBorder"]}`]: {
      borderLeftColor: "var(--DataGrid-rowBorderColor)",
      borderLeftWidth: "1px",
      borderLeftStyle: "solid"
    },
    [`& .${ee["cell--withRightBorder"]}, & .${ee["columnHeader--withRightBorder"]}`]: {
      borderRightColor: "var(--DataGrid-rowBorderColor)",
      borderRightWidth: "1px",
      borderRightStyle: "solid"
    },
    [`& .${ee["cell--flex"]}`]: {
      display: "flex",
      alignItems: "center",
      lineHeight: "inherit"
    },
    [`& .${ee["cell--textLeft"]}`]: {
      textAlign: "left",
      justifyContent: "flex-start"
    },
    [`& .${ee["cell--textRight"]}`]: {
      textAlign: "right",
      justifyContent: "flex-end"
    },
    [`& .${ee["cell--textCenter"]}`]: {
      textAlign: "center",
      justifyContent: "center"
    },
    [`& .${ee["cell--pinnedLeft"]}, & .${ee["cell--pinnedRight"]}`]: {
      position: "sticky",
      zIndex: 3,
      background: "var(--DataGrid-pinnedBackground)",
      "&.Mui-selected": {
        backgroundColor: I
      }
    },
    [`& .${ee.virtualScrollerContent} .${ee.row}`]: {
      "&:hover": E,
      "&.Mui-selected": O,
      "&.Mui-selected:hover": P
    },
    [`& .${ee.cellOffsetLeft}`]: {
      flex: "0 0 auto",
      display: "inline-block"
    },
    [`& .${ee.cellSkeleton}`]: {
      flex: "0 0 auto",
      height: "100%",
      display: "inline-flex",
      alignItems: "center"
    },
    [`& .${ee.columnHeaderDraggableContainer}`]: {
      display: "flex",
      width: "100%",
      height: "100%"
    },
    [`& .${ee.rowReorderCellPlaceholder}`]: {
      display: "none"
    },
    [`& .${ee["columnHeader--dragging"]}, & .${ee["row--dragging"]}`]: {
      background: (e.vars || e).palette.background.paper,
      padding: "0 12px",
      borderRadius: "var(--unstable_DataGrid-radius)",
      opacity: (e.vars || e).palette.action.disabledOpacity
    },
    [`& .${ee["row--dragging"]}`]: {
      background: (e.vars || e).palette.background.paper,
      padding: "0 12px",
      borderRadius: "var(--unstable_DataGrid-radius)",
      opacity: (e.vars || e).palette.action.disabledOpacity,
      [`& .${ee.rowReorderCellPlaceholder}`]: {
        display: "flex"
      }
    },
    [`& .${ee.treeDataGroupingCell}`]: {
      display: "flex",
      alignItems: "center",
      width: "100%"
    },
    [`& .${ee.treeDataGroupingCellToggle}`]: {
      flex: "0 0 28px",
      alignSelf: "stretch",
      marginRight: e.spacing(2)
    },
    [`& .${ee.treeDataGroupingCellLoadingContainer}, .${ee.groupingCriteriaCellLoadingContainer}`]: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%"
    },
    [`& .${ee.groupingCriteriaCell}`]: {
      display: "flex",
      alignItems: "center",
      width: "100%"
    },
    [`& .${ee.groupingCriteriaCellToggle}`]: {
      flex: "0 0 28px",
      alignSelf: "stretch",
      marginRight: e.spacing(2)
    },
    /* ScrollbarFiller styles */
    [`.${ee.scrollbarFiller}`]: {
      minWidth: "calc(var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize))",
      alignSelf: "stretch",
      [`&.${ee["scrollbarFiller--borderTop"]}`]: {
        borderTop: "1px solid var(--DataGrid-rowBorderColor)"
      },
      [`&.${ee["scrollbarFiller--borderBottom"]}`]: {
        borderBottom: "1px solid var(--DataGrid-rowBorderColor)"
      },
      [`&.${ee["scrollbarFiller--pinnedRight"]}`]: {
        backgroundColor: "var(--DataGrid-pinnedBackground)",
        position: "sticky",
        right: 0
      }
    },
    [`& .${ee.filler}`]: {
      flex: "1 0 auto"
    },
    [`& .${ee["filler--borderBottom"]}`]: {
      borderBottom: "1px solid var(--DataGrid-rowBorderColor)"
    },
    /* Hide grid rows, row filler, and vertical scrollbar when skeleton overlay is visible */
    [`& .${ee["main--hasSkeletonLoadingOverlay"]}`]: {
      [`& .${ee.virtualScrollerContent}`]: {
        // We use visibility hidden so that the virtual scroller content retains its height.
        // Position fixed is used to remove the virtual scroller content from the flow.
        // https://github.com/mui/mui-x/issues/14061
        position: "fixed",
        visibility: "hidden"
      },
      [`& .${ee["scrollbar--vertical"]}, & .${ee.pinnedRows}, & .${ee.virtualScroller} > .${ee.filler}`]: {
        display: "none"
      }
    }
  });
});
function ade(e, t, n, r = 1) {
  const o = (c, d) => Math.round((c ** (1 / r) * (1 - n) + d ** (1 / r) * n) ** r), i = Vs(e), a = Vs(t), l = [o(i.values[0], a.values[0]), o(i.values[1], a.values[1]), o(i.values[2], a.values[2])];
  return jp({
    type: "rgb",
    values: l
  });
}
const lde = (e) => `rgb(from ${e} r g b / 1)`;
function cde(e, t, n) {
  return `color-mix(in srgb,${e}, ${lde(t)} calc(${n} * 100%))`;
}
const ude = ["className"], dde = (e, t) => {
  const {
    autoHeight: n,
    classes: r,
    showCellVerticalBorder: o
  } = e, i = {
    root: ["root", n && "autoHeight", `root--density${Jp(t)}`, e.slots.toolbar === null && "root--noToolbar", "withBorderColor", o && "withVerticalBorder"]
  };
  return tn(i, nn, r);
}, xF = dn(function(t, n) {
  const r = ft(), {
    className: o
  } = t, i = yt(t, ude), a = Hi(), l = Be(a, Mu), c = a.current.rootElementRef, d = Rl(c, n), f = r, p = dde(f, l), [g, b] = m.useState(!1);
  return Zr(() => {
    b(!0);
  }, []), g ? /* @__PURE__ */ w.jsx(sde, U({
    className: ke(p.root, o),
    ownerState: f
  }, i, {
    ref: d
  })) : null;
});
process.env.NODE_ENV !== "production" && (xF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const fde = ["className"], pde = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["footerContainer", "withBorderColor"]
  }, nn, t);
}, hde = On("div", {
  name: "MuiDataGrid",
  slot: "FooterContainer",
  overridesResolver: (e, t) => t.footerContainer
})({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  minHeight: 52,
  borderTop: "1px solid"
}), SF = dn(function(t, n) {
  const {
    className: r
  } = t, o = yt(t, fde), i = ft(), a = pde(i);
  return /* @__PURE__ */ w.jsx(hde, U({
    className: ke(a.root, r),
    ownerState: i
  }, o, {
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (SF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const gde = ["className"], mde = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["overlay"]
  }, nn, t);
}, bde = On("div", {
  name: "MuiDataGrid",
  slot: "Overlay",
  overridesResolver: (e, t) => t.overlay
})({
  width: "100%",
  height: "100%",
  display: "flex",
  alignSelf: "center",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "var(--unstable_DataGrid-overlayBackground)"
}), my = dn(function(t, n) {
  const {
    className: r
  } = t, o = yt(t, gde), i = ft(), a = mde(i);
  return /* @__PURE__ */ w.jsx(bde, U({
    className: ke(a.root, r),
    ownerState: i
  }, o, {
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (my.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const yde = (e) => {
  const {
    classes: t,
    open: n
  } = e;
  return tn({
    root: ["menuIcon", n && "menuOpen"],
    button: ["menuIconButton"]
  }, nn, t);
}, vde = /* @__PURE__ */ m.memo((e) => {
  var p, g;
  const {
    colDef: t,
    open: n,
    columnMenuId: r,
    columnMenuButtonId: o,
    iconButtonRef: i
  } = e, a = Wt(), l = ft(), c = U({}, e, {
    classes: l.classes
  }), d = yde(c), f = m.useCallback((b) => {
    b.preventDefault(), b.stopPropagation(), a.current.toggleColumnMenu(t.field);
  }, [a, t.field]);
  return /* @__PURE__ */ w.jsx("div", {
    className: d.root,
    children: /* @__PURE__ */ w.jsx(l.slots.baseTooltip, U({
      title: a.current.getLocaleText("columnMenuLabel"),
      enterDelay: 1e3
    }, (p = l.slotProps) == null ? void 0 : p.baseTooltip, {
      children: /* @__PURE__ */ w.jsx(l.slots.baseIconButton, U({
        ref: i,
        tabIndex: -1,
        className: d.button,
        "aria-label": a.current.getLocaleText("columnMenuLabel"),
        size: "small",
        onClick: f,
        "aria-haspopup": "menu",
        "aria-expanded": n,
        "aria-controls": n ? r : void 0,
        id: o
      }, (g = l.slotProps) == null ? void 0 : g.baseIconButton, {
        children: /* @__PURE__ */ w.jsx(l.slots.columnMenuIcon, {
          fontSize: "inherit"
        })
      }))
    }))
  });
});
function EF({
  columnMenuId: e,
  columnMenuButtonId: t,
  ContentComponent: n,
  contentComponentProps: r,
  field: o,
  open: i,
  target: a,
  onExited: l
}) {
  const c = Wt(), d = c.current.getColumn(o), f = Yn((p) => {
    p && (p.stopPropagation(), a != null && a.contains(p.target)) || c.current.hideColumnMenu();
  });
  return !a || !d ? null : /* @__PURE__ */ w.jsx(ty, {
    placement: `bottom-${d.align === "right" ? "start" : "end"}`,
    open: i,
    target: a,
    onClose: f,
    onExited: l,
    children: /* @__PURE__ */ w.jsx(n, U({
      colDef: d,
      hideMenu: f,
      open: i,
      id: e,
      labelledby: t
    }, r))
  });
}
process.env.NODE_ENV !== "production" && (EF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  columnMenuButtonId: s.string,
  columnMenuId: s.string,
  ContentComponent: s.elementType.isRequired,
  contentComponentProps: s.any,
  field: s.string.isRequired,
  onExited: s.func,
  open: s.bool.isRequired,
  target: YM
});
function wde(e) {
  return e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth;
}
function Fm(e, t) {
  return e.closest(`.${t}`);
}
function Pa(e) {
  return e.replace(/["\\]/g, "\\$&");
}
function Cde(e, t) {
  return e.querySelector(`[role="columnheader"][data-field="${Pa(t)}"]`);
}
function TF(e) {
  return `.${ee.row}[data-id="${Pa(String(e))}"]`;
}
function xde(e, t) {
  return e.querySelector(TF(t));
}
function Sde(e, {
  id: t,
  field: n
}) {
  const r = TF(t), o = `.${ee.cell}[data-field="${Pa(n)}"]`, i = `${r} ${o}`;
  return e.querySelector(i);
}
function ph(e) {
  return (
    // The target is not an element when triggered by a Select inside the cell
    // See https://github.com/mui/material-ui/issues/10534
    e.target.nodeType === 1 && !e.currentTarget.contains(e.target)
  );
}
function Ede(e) {
  return e.getAttribute("data-field");
}
function Tde(e, t) {
  return e.querySelector(`[data-field="${Pa(t)}"]`);
}
function Ode(e) {
  return e.getAttribute("data-fields").slice(2, -2).split("-|-");
}
function Pde(e, t) {
  return Array.from(e.querySelectorAll(`[data-fields*="|-${Pa(t)}-|"]`) ?? []);
}
function Ide(e, t) {
  var a;
  if (!Fm(e, ee.root))
    throw new Error("MUI X: The root element is not found.");
  const r = e.getAttribute("aria-colindex");
  if (!r)
    return [];
  const o = Number(r) - 1, i = [];
  return (a = t.virtualScrollerRef) != null && a.current ? (IF(t).forEach((l) => {
    const c = l.getAttribute("data-id");
    if (!c)
      return;
    let d = o;
    const f = t.unstable_getCellColSpanInfo(c, o);
    f && f.spannedByColSpan && (d = f.leftVisibleCellIndex);
    const p = l.querySelector(`[data-colindex="${d}"]`);
    p && i.push(p);
  }), i) : [];
}
function wR(e, t) {
  return e.rootElementRef.current.querySelector(`.${ee[t]}`);
}
const OF = ({
  api: e,
  colIndex: t,
  position: n,
  filterFn: r
}) => {
  if (t === null)
    return [];
  const o = [];
  return IF(e).forEach((i) => {
    i.getAttribute("data-id") && i.querySelectorAll(`.${ee[n === "left" ? "cell--pinnedLeft" : "cell--pinnedRight"]}`).forEach((l) => {
      const c = jd(l);
      c !== null && r(c) && o.push(l);
    });
  }), o;
};
function Rde(e, t, n) {
  const r = jd(t);
  return OF({
    api: e,
    colIndex: r,
    position: n ? "right" : "left",
    filterFn: (o) => n ? o < r : o > r
  });
}
function _de(e, t, n) {
  const r = jd(t);
  return OF({
    api: e,
    colIndex: r,
    position: n ? "left" : "right",
    filterFn: (o) => n ? o > r : o < r
  });
}
const PF = ({
  api: e,
  colIndex: t,
  position: n,
  filterFn: r
}) => {
  var i;
  if (!((i = e.columnHeadersContainerRef) != null && i.current))
    return [];
  if (t === null)
    return [];
  const o = [];
  return e.columnHeadersContainerRef.current.querySelectorAll(`.${ee[n === "left" ? "columnHeader--pinnedLeft" : "columnHeader--pinnedRight"]}`).forEach((a) => {
    const l = jd(a);
    l !== null && r(l) && o.push(a);
  }), o;
};
function kde(e, t, n) {
  const r = jd(t);
  return PF({
    api: e,
    position: n ? "right" : "left",
    colIndex: r,
    filterFn: (o) => n ? o < r : o > r
  });
}
function Mde(e, t, n) {
  const r = jd(t);
  return PF({
    api: e,
    position: n ? "left" : "right",
    colIndex: r,
    filterFn: (o) => n ? o > r : o < r
  });
}
function Ade(e, t) {
  return e.columnHeadersContainerRef.current.querySelector(`:scope > div > [data-field="${Pa(t)}"][role="columnheader"]`);
}
function Dde(e, t) {
  const n = e.virtualScrollerRef.current;
  return Array.from(n.querySelectorAll(`:scope > div > div > div > [data-field="${Pa(t)}"][role="gridcell"]`));
}
function IF(e) {
  return e.virtualScrollerRef.current.querySelectorAll(
    // Use > to ignore rows from nested Data Grids (for example in detail panel)
    `:scope > div > div > .${ee.row}`
  );
}
function jd(e) {
  const t = e.getAttribute("aria-colindex");
  return t ? Number(t) - 1 : null;
}
const Nde = ["className", "aria-label"], Fde = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["columnHeaderTitle"]
  }, nn, t);
}, $de = On("div", {
  name: "MuiDataGrid",
  slot: "ColumnHeaderTitle",
  overridesResolver: (e, t) => t.columnHeaderTitle
})({
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
  fontWeight: "var(--unstable_DataGrid-headWeight)",
  lineHeight: "normal"
}), Lde = dn(function(t, n) {
  const {
    className: r
  } = t, o = yt(t, Nde), i = ft(), a = Fde(i);
  return /* @__PURE__ */ w.jsx($de, U({
    className: ke(a.root, r),
    ownerState: i
  }, o, {
    ref: n
  }));
});
function RF(e) {
  var c;
  const {
    label: t,
    description: n
  } = e, r = ft(), o = m.useRef(null), [i, a] = m.useState(""), l = m.useCallback(() => {
    if (!n && (o != null && o.current)) {
      const d = wde(o.current);
      a(d ? t : "");
    }
  }, [n, t]);
  return /* @__PURE__ */ w.jsx(r.slots.baseTooltip, U({
    title: n || i
  }, (c = r.slotProps) == null ? void 0 : c.baseTooltip, {
    children: /* @__PURE__ */ w.jsx(Lde, {
      onMouseOver: l,
      ref: o,
      children: t
    })
  }));
}
process.env.NODE_ENV !== "production" && (RF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  columnWidth: s.number.isRequired,
  description: s.node,
  label: s.string.isRequired
});
const jde = ["resizable", "resizing", "height", "side"];
var NS = /* @__PURE__ */ function(e) {
  return e.Left = "left", e.Right = "right", e;
}(NS || {});
const Bde = (e) => {
  const {
    resizable: t,
    resizing: n,
    classes: r,
    side: o
  } = e, i = {
    root: ["columnSeparator", t && "columnSeparator--resizable", n && "columnSeparator--resizing", o && `columnSeparator--side${Jp(o)}`],
    icon: ["iconSeparator"]
  };
  return tn(i, nn, r);
};
function _F(e) {
  const {
    height: t,
    side: n = NS.Right
  } = e, r = yt(e, jde), o = ft(), i = U({}, e, {
    side: n,
    classes: o.classes
  }), a = Bde(i), l = m.useCallback((c) => {
    c.preventDefault(), c.stopPropagation();
  }, []);
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ w.jsx("div", U({
      className: a.root,
      style: {
        minHeight: t
      }
    }, r, {
      onClick: l,
      children: /* @__PURE__ */ w.jsx(o.slots.columnResizeIcon, {
        className: a.icon
      })
    }))
  );
}
const Vde = /* @__PURE__ */ m.memo(_F);
process.env.NODE_ENV !== "production" && (_F.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  height: s.number.isRequired,
  resizable: s.bool.isRequired,
  resizing: s.bool.isRequired,
  side: s.oneOf(["left", "right"])
});
const Hde = ["classes", "columnMenuOpen", "colIndex", "height", "isResizing", "sortDirection", "hasFocus", "tabIndex", "separatorSide", "isDraggable", "headerComponent", "description", "elementId", "width", "columnMenuIconButton", "columnMenu", "columnTitleIconButtons", "headerClassName", "label", "resizable", "draggableContainerProps", "columnHeaderSeparatorProps", "style"], kF = dn(function(t, n) {
  const {
    classes: r,
    colIndex: o,
    height: i,
    isResizing: a,
    sortDirection: l,
    hasFocus: c,
    tabIndex: d,
    separatorSide: f,
    isDraggable: p,
    headerComponent: g,
    description: b,
    width: v,
    columnMenuIconButton: y = null,
    columnMenu: S = null,
    columnTitleIconButtons: E = null,
    headerClassName: I,
    label: O,
    resizable: T,
    draggableContainerProps: P,
    columnHeaderSeparatorProps: R,
    style: F
  } = t, A = yt(t, Hde), _ = Hi(), C = ft(), D = m.useRef(null), L = Rl(D, n);
  let B = "none";
  return l != null && (B = l === "asc" ? "ascending" : "descending"), m.useLayoutEffect(() => {
    var k;
    const H = _.current.state.columnMenu;
    if (c && !H.open) {
      const j = D.current.querySelector('[tabindex="0"]') || D.current;
      j == null || j.focus(), (k = _.current.columnHeadersContainerRef) != null && k.current && (_.current.columnHeadersContainerRef.current.scrollLeft = 0);
    }
  }, [_, c]), /* @__PURE__ */ w.jsxs("div", U({
    className: ke(r.root, I),
    style: U({}, F, {
      height: i,
      width: v
    }),
    role: "columnheader",
    tabIndex: d,
    "aria-colindex": o + 1,
    "aria-sort": B
  }, A, {
    ref: L,
    children: [/* @__PURE__ */ w.jsxs("div", U({
      className: r.draggableContainer,
      draggable: p,
      role: "presentation"
    }, P, {
      children: [/* @__PURE__ */ w.jsxs("div", {
        className: r.titleContainer,
        role: "presentation",
        children: [/* @__PURE__ */ w.jsx("div", {
          className: r.titleContainerContent,
          children: g !== void 0 ? g : /* @__PURE__ */ w.jsx(RF, {
            label: O,
            description: b,
            columnWidth: v
          })
        }), E]
      }), y]
    })), /* @__PURE__ */ w.jsx(Vde, U({
      resizable: !C.disableColumnResize && !!T,
      resizing: a,
      height: i,
      side: f
    }, R)), S]
  }));
}), Ude = (e) => {
  const {
    colDef: t,
    classes: n,
    isDragging: r,
    sortDirection: o,
    showRightBorder: i,
    showLeftBorder: a,
    filterItemsCounter: l,
    pinnedPosition: c,
    isLastUnpinned: d,
    isSiblingFocused: f
  } = e, p = o != null, g = l != null && l > 0, b = t.type === "number", v = {
    root: [
      "columnHeader",
      t.headerAlign === "left" && "columnHeader--alignLeft",
      t.headerAlign === "center" && "columnHeader--alignCenter",
      t.headerAlign === "right" && "columnHeader--alignRight",
      t.sortable && "columnHeader--sortable",
      r && "columnHeader--moving",
      p && "columnHeader--sorted",
      g && "columnHeader--filtered",
      b && "columnHeader--numeric",
      "withBorderColor",
      i && "columnHeader--withRightBorder",
      a && "columnHeader--withLeftBorder",
      c === "left" && "columnHeader--pinnedLeft",
      c === "right" && "columnHeader--pinnedRight",
      // TODO: Remove classes below and restore `:has` selectors when they are supported in jsdom
      // See https://github.com/mui/mui-x/pull/14559
      d && "columnHeader--lastUnpinned",
      f && "columnHeader--siblingFocused"
    ],
    draggableContainer: ["columnHeaderDraggableContainer"],
    titleContainer: ["columnHeaderTitleContainer"],
    titleContainerContent: ["columnHeaderTitleContainerContent"]
  };
  return tn(v, nn, n);
};
function MF(e) {
  var ce, le, we;
  const {
    colDef: t,
    columnMenuOpen: n,
    colIndex: r,
    headerHeight: o,
    isResizing: i,
    isLast: a,
    sortDirection: l,
    sortIndex: c,
    filterItemsCounter: d,
    hasFocus: f,
    tabIndex: p,
    disableReorder: g,
    separatorSide: b,
    style: v,
    pinnedPosition: y,
    indexInSection: S,
    sectionLength: E,
    gridHasFiller: I
  } = e, O = Hi(), T = ft(), P = m.useRef(null), R = xr(), F = xr(), A = m.useRef(null), [_, C] = m.useState(n), D = m.useMemo(() => !T.disableColumnReorder && !g && !t.disableReorder, [T.disableColumnReorder, g, t.disableReorder]);
  let L;
  t.renderHeader && (L = t.renderHeader(O.current.getColumnHeaderParams(t.field)));
  const B = gy(y, S), H = hy(y, S, E, T.showColumnVerticalBorder, I), k = U({}, e, {
    classes: T.classes,
    showRightBorder: H,
    showLeftBorder: B
  }), N = Ude(k), j = m.useCallback((q) => (Ee) => {
    ph(Ee) || O.current.publishEvent(q, O.current.getColumnHeaderParams(t.field), Ee);
  }, [O, t.field]), W = m.useMemo(() => ({
    onClick: j("columnHeaderClick"),
    onContextMenu: j("columnHeaderContextMenu"),
    onDoubleClick: j("columnHeaderDoubleClick"),
    onMouseOver: j("columnHeaderOver"),
    // TODO remove as it's not used
    onMouseOut: j("columnHeaderOut"),
    // TODO remove as it's not used
    onMouseEnter: j("columnHeaderEnter"),
    // TODO remove as it's not used
    onMouseLeave: j("columnHeaderLeave"),
    // TODO remove as it's not used
    onKeyDown: j("columnHeaderKeyDown"),
    onFocus: j("columnHeaderFocus"),
    onBlur: j("columnHeaderBlur")
  }), [j]), V = m.useMemo(() => D ? {
    onDragStart: j("columnHeaderDragStart"),
    onDragEnter: j("columnHeaderDragEnter"),
    onDragOver: j("columnHeaderDragOver"),
    onDragEnd: j("columnHeaderDragEnd")
  } : {}, [D, j]), $ = m.useMemo(() => ({
    onMouseDown: j("columnSeparatorMouseDown"),
    onDoubleClick: j("columnSeparatorDoubleClick")
  }), [j]);
  m.useEffect(() => {
    _ || C(n);
  }, [_, n]);
  const z = m.useCallback(() => {
    C(!1);
  }, []), ne = !T.disableColumnMenu && !t.disableColumnMenu && /* @__PURE__ */ w.jsx(vde, {
    colDef: t,
    columnMenuId: R,
    columnMenuButtonId: F,
    open: _,
    iconButtonRef: A
  }), K = /* @__PURE__ */ w.jsx(EF, {
    columnMenuId: R,
    columnMenuButtonId: F,
    field: t.field,
    open: n,
    target: A.current,
    ContentComponent: T.slots.columnMenu,
    contentComponentProps: (ce = T.slotProps) == null ? void 0 : ce.columnMenu,
    onExited: z
  }), Q = t.sortingOrder ?? T.sortingOrder, re = (t.sortable || l != null) && !t.hideSortIcons && !T.disableColumnSorting, te = /* @__PURE__ */ w.jsxs(m.Fragment, {
    children: [!T.disableColumnFilter && /* @__PURE__ */ w.jsx(T.slots.columnHeaderFilterIconButton, U({
      field: t.field,
      counter: d
    }, (le = T.slotProps) == null ? void 0 : le.columnHeaderFilterIconButton)), re && /* @__PURE__ */ w.jsx(T.slots.columnHeaderSortIcon, U({
      field: t.field,
      direction: l,
      index: c,
      sortingOrder: Q,
      disabled: !t.sortable
    }, (we = T.slotProps) == null ? void 0 : we.columnHeaderSortIcon))]
  });
  m.useLayoutEffect(() => {
    var Ee;
    const q = O.current.state.columnMenu;
    if (f && !q.open) {
      const $e = P.current.querySelector('[tabindex="0"]') || P.current;
      $e == null || $e.focus(), (Ee = O.current.columnHeadersContainerRef) != null && Ee.current && (O.current.columnHeadersContainerRef.current.scrollLeft = 0);
    }
  }, [O, f]);
  const ie = typeof t.headerClassName == "function" ? t.headerClassName({
    field: t.field,
    colDef: t
  }) : t.headerClassName, ae = t.headerName ?? t.field;
  return /* @__PURE__ */ w.jsx(kF, U({
    ref: P,
    classes: N,
    columnMenuOpen: n,
    colIndex: r,
    height: o,
    isResizing: i,
    sortDirection: l,
    hasFocus: f,
    tabIndex: p,
    separatorSide: b,
    isDraggable: D,
    headerComponent: L,
    description: t.description,
    elementId: t.field,
    width: t.computedWidth,
    columnMenuIconButton: ne,
    columnTitleIconButtons: te,
    headerClassName: ke(ie, a && ee["columnHeader--last"]),
    label: ae,
    resizable: !T.disableColumnResize && !!t.resizable,
    "data-field": t.field,
    columnMenu: K,
    draggableContainerProps: V,
    columnHeaderSeparatorProps: $,
    style: v
  }, W));
}
process.env.NODE_ENV !== "production" && (MF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: s.object.isRequired,
  colIndex: s.number.isRequired,
  columnMenuOpen: s.bool.isRequired,
  disableReorder: s.bool,
  filterItemsCounter: s.number,
  gridHasFiller: s.bool.isRequired,
  hasFocus: s.bool,
  headerHeight: s.number.isRequired,
  indexInSection: s.number.isRequired,
  isDragging: s.bool.isRequired,
  isLast: s.bool.isRequired,
  isLastUnpinned: s.bool.isRequired,
  isResizing: s.bool.isRequired,
  isSiblingFocused: s.bool.isRequired,
  pinnedPosition: s.oneOf(["left", "right"]),
  sectionLength: s.number.isRequired,
  separatorSide: s.oneOf(["left", "right"]),
  sortDirection: s.oneOf(["asc", "desc"]),
  sortIndex: s.number,
  style: s.object,
  tabIndex: s.oneOf([-1, 0]).isRequired
});
const zde = Dl(MF), Gde = ["className"], Wde = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["iconButtonContainer"]
  }, nn, t);
}, qde = On("div", {
  name: "MuiDataGrid",
  slot: "IconButtonContainer",
  overridesResolver: (e, t) => t.iconButtonContainer
})(() => ({
  display: "flex",
  visibility: "hidden",
  width: 0
})), AF = dn(function(t, n) {
  const {
    className: r
  } = t, o = yt(t, Gde), i = ft(), a = Wde(i);
  return /* @__PURE__ */ w.jsx(qde, U({
    className: ke(a.root, r),
    ownerState: i
  }, o, {
    ref: n
  }));
}), Kde = ["direction", "index", "sortingOrder", "disabled"], Yde = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    icon: ["sortIcon"]
  }, nn, t);
};
function Qde(e, t, n, r) {
  let o;
  const i = {};
  return t === "asc" ? o = e.columnSortedAscendingIcon : t === "desc" ? o = e.columnSortedDescendingIcon : (o = e.columnUnsortedIcon, i.sortingOrder = r), o ? /* @__PURE__ */ w.jsx(o, U({
    fontSize: "small",
    className: n
  }, i)) : null;
}
function DF(e) {
  var g;
  const {
    direction: t,
    index: n,
    sortingOrder: r,
    disabled: o
  } = e, i = yt(e, Kde), a = Wt(), l = ft(), c = U({}, e, {
    classes: l.classes
  }), d = Yde(c), f = Qde(l.slots, t, d.icon, r);
  if (!f)
    return null;
  const p = /* @__PURE__ */ w.jsx(l.slots.baseIconButton, U({
    tabIndex: -1,
    "aria-label": a.current.getLocaleText("columnHeaderSortIconLabel"),
    title: a.current.getLocaleText("columnHeaderSortIconLabel"),
    size: "small",
    disabled: o
  }, (g = l.slotProps) == null ? void 0 : g.baseIconButton, i, {
    children: f
  }));
  return /* @__PURE__ */ w.jsxs(AF, {
    children: [n != null && /* @__PURE__ */ w.jsx(l.slots.baseBadge, {
      badgeContent: n,
      color: "default",
      overlap: "circular",
      children: p
    }), n == null && p]
  });
}
const Xde = /* @__PURE__ */ m.memo(DF);
process.env.NODE_ENV !== "production" && (DF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  direction: s.oneOf(["asc", "desc"]),
  disabled: s.bool,
  field: s.string.isRequired,
  index: s.number,
  sortingOrder: s.arrayOf(s.oneOf(["asc", "desc"])).isRequired
});
const Jde = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    icon: ["filterIcon"]
  }, nn, t);
};
function NF(e) {
  var v, y;
  const {
    counter: t,
    field: n,
    onClick: r
  } = e, o = Wt(), i = ft(), a = U({}, e, {
    classes: i.classes
  }), l = Jde(a), c = Be(o, xp), d = xr(), f = xr(), p = m.useCallback((S) => {
    S.preventDefault(), S.stopPropagation();
    const {
      open: E,
      openedPanelValue: I
    } = xp(o.current.state);
    E && I === Ec.filters ? o.current.hideFilterPanel() : o.current.showFilterPanel(void 0, f, d), r && r(o.current.getColumnHeaderParams(n), S);
  }, [o, n, r, f, d]);
  if (!t)
    return null;
  const g = c.open && c.labelId === d, b = /* @__PURE__ */ w.jsx(i.slots.baseIconButton, U({
    id: d,
    onClick: p,
    color: "default",
    "aria-label": o.current.getLocaleText("columnHeaderFiltersLabel"),
    size: "small",
    tabIndex: -1,
    "aria-haspopup": "menu",
    "aria-expanded": g,
    "aria-controls": g ? f : void 0
  }, (v = i.slotProps) == null ? void 0 : v.baseIconButton, {
    children: /* @__PURE__ */ w.jsx(i.slots.columnFilteredIcon, {
      className: l.icon,
      fontSize: "small"
    })
  }));
  return /* @__PURE__ */ w.jsx(i.slots.baseTooltip, U({
    title: o.current.getLocaleText("columnHeaderFiltersTooltipActive")(t),
    enterDelay: 1e3
  }, (y = i.slotProps) == null ? void 0 : y.baseTooltip, {
    children: /* @__PURE__ */ w.jsxs(AF, {
      children: [t > 1 && /* @__PURE__ */ w.jsx(i.slots.baseBadge, {
        badgeContent: t,
        color: "default",
        children: b
      }), t === 1 && b]
    })
  }));
}
process.env.NODE_ENV !== "production" && (NF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  counter: s.number,
  field: s.string.isRequired,
  onClick: s.func
});
const CR = At(/* @__PURE__ */ w.jsx("path", {
  d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), "ArrowUpward"), xR = At(/* @__PURE__ */ w.jsx("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), "ArrowDownward"), SR = At(/* @__PURE__ */ w.jsx("path", {
  d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "KeyboardArrowRight"), ER = At(/* @__PURE__ */ w.jsx("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore"), Zde = At(/* @__PURE__ */ w.jsx("path", {
  d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), "FilterList"), TR = At(/* @__PURE__ */ w.jsx("path", {
  d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
}), "FilterAlt"), efe = At(/* @__PURE__ */ w.jsx("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), "Search");
At(/* @__PURE__ */ w.jsx("path", {
  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), "Menu");
At(/* @__PURE__ */ w.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckCircle");
const tfe = At(/* @__PURE__ */ w.jsx("path", {
  d: "M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
}), "ColumnIcon"), nfe = At(/* @__PURE__ */ w.jsx("rect", {
  width: "1",
  height: "24",
  x: "11.5",
  rx: "0.5"
}), "Separator"), rfe = At(/* @__PURE__ */ w.jsx("path", {
  d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
}), "ViewHeadline"), ofe = At(/* @__PURE__ */ w.jsx("path", {
  d: "M21,8H3V4h18V8z M21,10H3v4h18V10z M21,16H3v4h18V16z"
}), "TableRows"), ife = At(/* @__PURE__ */ w.jsx("path", {
  d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
}), "ViewStream"), sfe = At(/* @__PURE__ */ w.jsx("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "TripleDotsVertical"), _w = At(/* @__PURE__ */ w.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), OR = At(/* @__PURE__ */ w.jsx("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), "Add"), afe = At(/* @__PURE__ */ w.jsx("path", {
  d: "M19 13H5v-2h14v2z"
}), "Remove"), lfe = At(/* @__PURE__ */ w.jsx("path", {
  d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
}), "Load"), PR = At(/* @__PURE__ */ w.jsx("path", {
  d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "Drag"), cfe = At(/* @__PURE__ */ w.jsx("path", {
  d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
}), "SaveAlt"), ufe = At(/* @__PURE__ */ w.jsx("path", {
  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check"), dfe = At(/* @__PURE__ */ w.jsx("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreVert"), ffe = At(/* @__PURE__ */ w.jsx("path", {
  d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
}), "VisibilityOff"), pfe = At(/* @__PURE__ */ w.jsx("g", {
  children: /* @__PURE__ */ w.jsx("path", {
    d: "M14.67,5v14H9.33V5H14.67z M15.67,19H21V5h-5.33V19z M8.33,19V5H3v14H8.33z"
  })
}), "ViewColumn"), hfe = At(/* @__PURE__ */ w.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");
At(/* @__PURE__ */ w.jsx("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), "Delete");
const gfe = At(/* @__PURE__ */ w.jsx("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
}), "Delete");
function FF(e) {
  return e.key.length === 1 && !e.ctrlKey && !e.metaKey;
}
const $m = (e) => e.indexOf("Arrow") === 0 || e.indexOf("Page") === 0 || e === " " || e === "Home" || e === "End", mfe = (e) => !!e.key, $F = (e) => e === "Tab" || e === "Escape";
function LF(e) {
  return (e.ctrlKey || e.metaKey) && // We can't use event.code === 'KeyV' as event.code assumes a QWERTY keyboard layout,
  // for example, it would be another letter on a Dvorak physical keyboard.
  // We can't use event.key === 'v' as event.key is not stable with key modifiers and keyboard layouts,
  // for example, it would be ה on a Hebrew keyboard layout.
  // https://github.com/w3c/uievents/issues/377 could be a long-term solution
  String.fromCharCode(e.keyCode) === "V" && !e.shiftKey && !e.altKey;
}
function bfe(e) {
  return (e.ctrlKey || e.metaKey) && String.fromCharCode(e.keyCode) === "C" && !e.shiftKey && !e.altKey;
}
const yfe = ["hideMenu", "colDef", "id", "labelledby", "className", "children", "open"], vfe = oe(qp)(() => ({
  minWidth: 248
})), jF = dn(function(t, n) {
  const {
    hideMenu: r,
    id: o,
    labelledby: i,
    className: a,
    children: l,
    open: c
  } = t, d = yt(t, yfe), f = m.useCallback((p) => {
    p.key === "Tab" && p.preventDefault(), $F(p.key) && r(p);
  }, [r]);
  return /* @__PURE__ */ w.jsx(vfe, U({
    id: o,
    className: ke(ee.menuList, a),
    "aria-labelledby": i,
    onKeyDown: f,
    autoFocus: c
  }, d, {
    ref: n,
    children: l
  }));
});
process.env.NODE_ENV !== "production" && (jF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: s.object.isRequired,
  hideMenu: s.func.isRequired,
  id: s.string,
  labelledby: s.string,
  open: s.bool.isRequired
});
const wfe = ["displayOrder"], Cfe = (e) => {
  const t = Hi(), n = ft(), {
    defaultSlots: r,
    defaultSlotProps: o,
    slots: i = {},
    slotProps: a = {},
    hideMenu: l,
    colDef: c,
    addDividers: d = !0
  } = e, f = m.useMemo(() => U({}, r, i), [r, i]), p = m.useMemo(() => {
    if (!a || Object.keys(a).length === 0)
      return o;
    const v = U({}, a);
    return Object.entries(o).forEach(([y, S]) => {
      v[y] = U({}, S, a[y] || {});
    }), v;
  }, [o, a]), g = t.current.unstable_applyPipeProcessors("columnMenu", [], e.colDef), b = m.useMemo(() => {
    const v = Object.keys(r);
    return Object.keys(i).filter((y) => !v.includes(y));
  }, [i, r]);
  return m.useMemo(() => {
    const S = Array.from(/* @__PURE__ */ new Set([...g, ...b])).filter((E) => f[E] != null).sort((E, I) => {
      const O = p[E], T = p[I], P = Number.isFinite(O == null ? void 0 : O.displayOrder) ? O.displayOrder : 100, R = Number.isFinite(T == null ? void 0 : T.displayOrder) ? T.displayOrder : 100;
      return P - R;
    });
    return S.reduce((E, I, O) => {
      let T = {
        colDef: c,
        onClick: l
      };
      const P = p[I];
      if (P) {
        const R = yt(P, wfe);
        T = U({}, T, R);
      }
      return d && O !== S.length - 1 ? [...E, [f[I], T], [n.slots.baseDivider, {}]] : [...E, [f[I], T]];
    }, []);
  }, [d, c, g, l, f, p, b, n.slots.baseDivider]);
};
function BF(e) {
  const {
    colDef: t,
    onClick: n
  } = e, r = Wt(), o = ft(), l = Fr(r).filter((d) => d.disableColumnMenu !== !0).length === 1, c = m.useCallback((d) => {
    l || (r.current.setColumnVisibility(t.field, !1), n(d));
  }, [r, t.field, n, l]);
  return o.disableColumnSelector || t.hideable === !1 ? null : /* @__PURE__ */ w.jsxs(ts, {
    onClick: c,
    disabled: l,
    children: [/* @__PURE__ */ w.jsx(gc, {
      children: /* @__PURE__ */ w.jsx(o.slots.columnMenuHideIcon, {
        fontSize: "small"
      })
    }), /* @__PURE__ */ w.jsx(mc, {
      children: r.current.getLocaleText("columnMenuHideColumn")
    })]
  });
}
process.env.NODE_ENV !== "production" && (BF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: s.object.isRequired,
  onClick: s.func.isRequired
});
function VF(e) {
  const {
    onClick: t
  } = e, n = Wt(), r = ft(), o = m.useCallback((i) => {
    t(i), n.current.showPreferences(Ec.columns);
  }, [n, t]);
  return r.disableColumnSelector ? null : /* @__PURE__ */ w.jsxs(ts, {
    onClick: o,
    children: [/* @__PURE__ */ w.jsx(gc, {
      children: /* @__PURE__ */ w.jsx(r.slots.columnMenuManageColumnsIcon, {
        fontSize: "small"
      })
    }), /* @__PURE__ */ w.jsx(mc, {
      children: n.current.getLocaleText("columnMenuManageColumns")
    })]
  });
}
process.env.NODE_ENV !== "production" && (VF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: s.object.isRequired,
  onClick: s.func.isRequired
});
function HF(e) {
  return /* @__PURE__ */ w.jsxs(m.Fragment, {
    children: [/* @__PURE__ */ w.jsx(BF, U({}, e)), /* @__PURE__ */ w.jsx(VF, U({}, e))]
  });
}
process.env.NODE_ENV !== "production" && (HF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: s.object.isRequired,
  onClick: s.func.isRequired
});
function UF(e) {
  const {
    colDef: t,
    onClick: n
  } = e, r = Wt(), o = ft(), i = m.useCallback((a) => {
    n(a), r.current.showFilterPanel(t.field);
  }, [r, t.field, n]);
  return o.disableColumnFilter || !t.filterable ? null : /* @__PURE__ */ w.jsxs(ts, {
    onClick: i,
    children: [/* @__PURE__ */ w.jsx(gc, {
      children: /* @__PURE__ */ w.jsx(o.slots.columnMenuFilterIcon, {
        fontSize: "small"
      })
    }), /* @__PURE__ */ w.jsx(mc, {
      children: r.current.getLocaleText("columnMenuFilter")
    })]
  });
}
process.env.NODE_ENV !== "production" && (UF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: s.object.isRequired,
  onClick: s.func.isRequired
});
function zF(e) {
  const {
    colDef: t,
    onClick: n
  } = e, r = Wt(), o = Be(r, Ii), i = ft(), a = m.useMemo(() => {
    if (!t)
      return null;
    const f = o.find((p) => p.field === t.field);
    return f == null ? void 0 : f.sort;
  }, [t, o]), l = t.sortingOrder ?? i.sortingOrder, c = m.useCallback((f) => {
    n(f);
    const p = f.currentTarget.getAttribute("data-value") || null;
    r.current.sortColumn(t.field, p === a ? null : p);
  }, [r, t, n, a]);
  if (i.disableColumnSorting || !t || !t.sortable || !l.some((f) => !!f))
    return null;
  const d = (f) => {
    const p = r.current.getLocaleText(f);
    return typeof p == "function" ? p(t) : p;
  };
  return /* @__PURE__ */ w.jsxs(m.Fragment, {
    children: [l.includes("asc") && a !== "asc" ? /* @__PURE__ */ w.jsxs(ts, {
      onClick: c,
      "data-value": "asc",
      children: [/* @__PURE__ */ w.jsx(gc, {
        children: /* @__PURE__ */ w.jsx(i.slots.columnMenuSortAscendingIcon, {
          fontSize: "small"
        })
      }), /* @__PURE__ */ w.jsx(mc, {
        children: d("columnMenuSortAsc")
      })]
    }) : null, l.includes("desc") && a !== "desc" ? /* @__PURE__ */ w.jsxs(ts, {
      onClick: c,
      "data-value": "desc",
      children: [/* @__PURE__ */ w.jsx(gc, {
        children: /* @__PURE__ */ w.jsx(i.slots.columnMenuSortDescendingIcon, {
          fontSize: "small"
        })
      }), /* @__PURE__ */ w.jsx(mc, {
        children: d("columnMenuSortDesc")
      })]
    }) : null, l.includes(null) && a != null ? /* @__PURE__ */ w.jsxs(ts, {
      onClick: c,
      children: [/* @__PURE__ */ w.jsx(gc, {}), /* @__PURE__ */ w.jsx(mc, {
        children: r.current.getLocaleText("columnMenuUnsort")
      })]
    }) : null]
  });
}
process.env.NODE_ENV !== "production" && (zF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: s.object.isRequired,
  onClick: s.func.isRequired
});
const xfe = ["defaultSlots", "defaultSlotProps", "slots", "slotProps"], Sfe = {
  columnMenuSortItem: zF,
  columnMenuFilterItem: UF,
  columnMenuColumnsItem: HF
}, Efe = {
  columnMenuSortItem: {
    displayOrder: 10
  },
  columnMenuFilterItem: {
    displayOrder: 20
  },
  columnMenuColumnsItem: {
    displayOrder: 30
  }
}, GF = dn(function(t, n) {
  const {
    defaultSlots: r,
    defaultSlotProps: o,
    slots: i,
    slotProps: a
  } = t, l = yt(t, xfe), c = Cfe(U({}, l, {
    defaultSlots: r,
    defaultSlotProps: o,
    slots: i,
    slotProps: a
  }));
  return /* @__PURE__ */ w.jsx(jF, U({}, l, {
    ref: n,
    children: c.map(([d, f], p) => /* @__PURE__ */ w.jsx(d, U({}, f), p))
  }));
});
process.env.NODE_ENV !== "production" && (GF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: s.object.isRequired,
  /**
   * Initial `slotProps` - it is internal, to be overrriden by Pro or Premium packages
   * @ignore - do not document.
   */
  defaultSlotProps: s.object.isRequired,
  /**
   * Initial `slots` - it is internal, to be overrriden by Pro or Premium packages
   * @ignore - do not document.
   */
  defaultSlots: s.object.isRequired,
  hideMenu: s.func.isRequired,
  id: s.string,
  labelledby: s.string,
  open: s.bool.isRequired,
  /**
   * Could be used to pass new props or override props specific to a column menu component
   * e.g. `displayOrder`
   */
  slotProps: s.object,
  /**
   * `slots` could be used to add new and (or) override default column menu items
   * If you register a nee component you must pass it's `displayOrder` in `slotProps`
   * or it will be placed in the end of the list
   */
  slots: s.object
});
const WF = dn(function(t, n) {
  return /* @__PURE__ */ w.jsx(GF, U({}, t, {
    ref: n,
    defaultSlots: Sfe,
    defaultSlotProps: Efe
  }));
});
process.env.NODE_ENV !== "production" && (WF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: s.object.isRequired,
  hideMenu: s.func.isRequired,
  id: s.string,
  labelledby: s.string,
  open: s.bool.isRequired,
  /**
   * Could be used to pass new props or override props specific to a column menu component
   * e.g. `displayOrder`
   */
  slotProps: s.object,
  /**
   * `slots` could be used to add new and (or) override default column menu items
   * If you register a nee component you must pass it's `displayOrder` in `slotProps`
   * or it will be placed in the end of the list
   */
  slots: s.object
});
const Tfe = ["className", "slotProps"], Ofe = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["panelWrapper"]
  }, nn, t);
}, Pfe = oe("div", {
  name: "MuiDataGrid",
  slot: "PanelWrapper",
  overridesResolver: (e, t) => t.panelWrapper
})({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  "&:focus": {
    outline: 0
  }
}), Ife = () => !0, FS = dn(function(t, n) {
  const {
    className: r,
    slotProps: o = {}
  } = t, i = yt(t, Tfe), a = ft(), l = Ofe(a);
  return /* @__PURE__ */ w.jsx(cp, U({
    open: !0,
    disableEnforceFocus: !0,
    isEnabled: Ife
  }, o.TrapFocus, {
    children: /* @__PURE__ */ w.jsx(Pfe, U({
      tabIndex: -1,
      className: ke(l.root, r),
      ownerState: a
    }, i, {
      ref: n
    }))
  }));
});
process.env.NODE_ENV !== "production" && (FS.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  slotProps: s.object
});
function qF(e) {
  var n;
  const t = ft();
  return /* @__PURE__ */ w.jsx(FS, U({}, e, {
    children: /* @__PURE__ */ w.jsx(t.slots.columnsManagement, U({}, (n = t.slotProps) == null ? void 0 : n.columnsManagement))
  }));
}
process.env.NODE_ENV !== "production" && (qF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  slotProps: s.object
});
const Rfe = ["children", "className", "classes"], _fe = JM("MuiDataGrid", ["panel", "paper"]), kfe = oe(Pl, {
  name: "MuiDataGrid",
  slot: "Panel",
  overridesResolver: (e, t) => t.panel
})(({
  theme: e
}) => ({
  zIndex: e.zIndex.modal
})), Mfe = oe(cs, {
  name: "MuiDataGrid",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  minWidth: 300,
  maxHeight: 450,
  display: "flex",
  maxWidth: `calc(100vw - ${e.spacing(0.5)})`,
  overflow: "auto"
})), KF = dn((e, t) => {
  const {
    children: n,
    className: r
  } = e, o = yt(e, Rfe), i = Wt(), a = ft(), l = _fe, [c, d] = m.useState(!1), f = m.useCallback(() => {
    i.current.hidePreferences();
  }, [i]), p = m.useCallback((y) => {
    y.key === "Escape" && i.current.hidePreferences();
  }, [i]), g = m.useMemo(() => [{
    name: "flip",
    enabled: !0,
    options: {
      rootBoundary: "document"
    }
  }, {
    name: "isPlaced",
    enabled: !0,
    phase: "main",
    fn: () => {
      d(!0);
    },
    effect: () => () => {
      d(!1);
    }
  }], []), [b, v] = m.useState(null);
  return m.useEffect(() => {
    var S, E;
    const y = (E = (S = i.current.rootElementRef) == null ? void 0 : S.current) == null ? void 0 : E.querySelector('[data-id="gridPanelAnchor"]');
    y && v(y);
  }, [i]), b ? /* @__PURE__ */ w.jsx(kfe, U({
    placement: "bottom-start",
    className: ke(l.panel, r),
    ownerState: a,
    anchorEl: b,
    modifiers: g
  }, o, {
    ref: t,
    children: /* @__PURE__ */ w.jsx(lp, {
      mouseEvent: "onMouseUp",
      onClickAway: f,
      children: /* @__PURE__ */ w.jsx(Mfe, {
        className: l.paper,
        ownerState: a,
        elevation: 8,
        onKeyDown: p,
        children: c && n
      })
    })
  })) : null;
});
process.env.NODE_ENV !== "production" && (KF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Popper render function or node.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  ownerState: s.object
});
const Afe = ["className"], Dfe = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["panelContent"]
  }, nn, t);
}, Nfe = On("div", {
  name: "MuiDataGrid",
  slot: "PanelContent",
  overridesResolver: (e, t) => t.panelContent
})({
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
  flex: "1 1",
  maxHeight: 400
});
function YF(e) {
  const {
    className: t
  } = e, n = yt(e, Afe), r = ft(), o = Dfe(r);
  return /* @__PURE__ */ w.jsx(Nfe, U({
    className: ke(o.root, t),
    ownerState: r
  }, n));
}
process.env.NODE_ENV !== "production" && (YF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const Ffe = ["className"], $fe = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["panelFooter"]
  }, nn, t);
}, Lfe = On("div", {
  name: "MuiDataGrid",
  slot: "PanelFooter",
  overridesResolver: (e, t) => t.panelFooter
})(({
  theme: e
}) => ({
  padding: e.spacing(0.5),
  display: "flex",
  justifyContent: "space-between"
}));
function QF(e) {
  const {
    className: t
  } = e, n = yt(e, Ffe), r = ft(), o = $fe(r);
  return /* @__PURE__ */ w.jsx(Lfe, U({
    className: ke(o.root, t),
    ownerState: r
  }, n));
}
process.env.NODE_ENV !== "production" && (QF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const jfe = ["item", "hasMultipleFilters", "deleteFilter", "applyFilterChanges", "showMultiFilterOperators", "disableMultiFilterOperator", "applyMultiFilterOperatorChanges", "focusElementRef", "logicOperators", "columnsSort", "filterColumns", "deleteIconProps", "logicOperatorInputProps", "operatorInputProps", "columnInputProps", "valueInputProps", "readOnly", "children"], Bfe = ["InputComponentProps"], Vfe = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["filterForm"],
    deleteIcon: ["filterFormDeleteIcon"],
    logicOperatorInput: ["filterFormLogicOperatorInput"],
    columnInput: ["filterFormColumnInput"],
    operatorInput: ["filterFormOperatorInput"],
    valueInput: ["filterFormValueInput"]
  }, nn, t);
}, Hfe = oe("div", {
  name: "MuiDataGrid",
  slot: "FilterForm",
  overridesResolver: (e, t) => t.filterForm
})(({
  theme: e
}) => ({
  display: "flex",
  padding: e.spacing(1)
})), Ufe = oe("div", {
  name: "MuiDataGrid",
  slot: "FilterFormDeleteIcon",
  overridesResolver: (e, t) => t.filterFormDeleteIcon
})(({
  theme: e
}) => ({
  flexShrink: 0,
  justifyContent: "flex-end",
  marginRight: e.spacing(0.5),
  marginBottom: e.spacing(0.2)
})), zfe = oe("div", {
  name: "MuiDataGrid",
  slot: "FilterFormLogicOperatorInput",
  overridesResolver: (e, t) => t.filterFormLogicOperatorInput
})({
  minWidth: 55,
  marginRight: 5,
  justifyContent: "end"
}), Gfe = oe("div", {
  name: "MuiDataGrid",
  slot: "FilterFormColumnInput",
  overridesResolver: (e, t) => t.filterFormColumnInput
})({
  width: 150
}), Wfe = oe("div", {
  name: "MuiDataGrid",
  slot: "FilterFormOperatorInput",
  overridesResolver: (e, t) => t.filterFormOperatorInput
})({
  width: 150
}), qfe = oe("div", {
  name: "MuiDataGrid",
  slot: "FilterFormValueInput",
  overridesResolver: (e, t) => t.filterFormValueInput
})({
  width: 190
}), Kfe = (e) => {
  switch (e) {
    case Oo.And:
      return "filterPanelOperatorAnd";
    case Oo.Or:
      return "filterPanelOperatorOr";
    default:
      throw new Error("MUI X: Invalid `logicOperator` property in the `GridFilterPanel`.");
  }
}, Sf = (e) => e.headerName || e.field, IR = new Intl.Collator(), oC = dn(function(t, n) {
  var $e, Le, Ze, J, fe, me, Oe, Ce, Te;
  const {
    item: r,
    hasMultipleFilters: o,
    deleteFilter: i,
    applyFilterChanges: a,
    showMultiFilterOperators: l,
    disableMultiFilterOperator: c,
    applyMultiFilterOperatorChanges: d,
    focusElementRef: f,
    logicOperators: p = [Oo.And, Oo.Or],
    columnsSort: g,
    filterColumns: b,
    deleteIconProps: v = {},
    logicOperatorInputProps: y = {},
    operatorInputProps: S = {},
    columnInputProps: E = {},
    valueInputProps: I = {},
    readOnly: O
  } = t, T = yt(t, jfe), P = Wt(), R = Be(P, Oa), F = Be(P, gN), A = Be(P, ro), _ = xr(), C = xr(), D = xr(), L = xr(), B = ft(), H = Vfe(B), k = m.useRef(null), N = m.useRef(null), j = A.logicOperator ?? Oo.And, W = o && p.length > 0, V = (($e = B.slotProps) == null ? void 0 : $e.baseFormControl) || {}, z = (((Le = B.slotProps) == null ? void 0 : Le.baseSelect) || {}).native ?? !1, ne = ((Ze = B.slotProps) == null ? void 0 : Ze.baseInputLabel) || {}, K = ((J = B.slotProps) == null ? void 0 : J.baseSelectOption) || {}, {
    InputComponentProps: Q
  } = I, re = yt(I, Bfe), {
    filteredColumns: te,
    selectedField: ie
  } = m.useMemo(() => {
    let Pe = r.field;
    const Ye = R[r.field].filterable === !1 ? R[r.field] : null;
    if (Ye)
      return {
        filteredColumns: [Ye],
        selectedField: Pe
      };
    if (b === void 0 || typeof b != "function")
      return {
        filteredColumns: F,
        selectedField: Pe
      };
    const Ke = b({
      field: r.field,
      columns: F,
      currentFilters: (A == null ? void 0 : A.items) || []
    });
    return {
      filteredColumns: F.filter((je) => {
        const Qe = Ke.includes(je.field);
        return je.field === r.field && !Qe && (Pe = void 0), Qe;
      }),
      selectedField: Pe
    };
  }, [b, A == null ? void 0 : A.items, F, r.field, R]), ae = m.useMemo(() => {
    switch (g) {
      case "asc":
        return te.sort((Pe, Ye) => IR.compare(Sf(Pe), Sf(Ye)));
      case "desc":
        return te.sort((Pe, Ye) => -IR.compare(Sf(Pe), Sf(Ye)));
      default:
        return te;
    }
  }, [te, g]), ce = r.field ? P.current.getColumn(r.field) : null, le = m.useMemo(() => {
    var Pe;
    return !r.operator || !ce ? null : (Pe = ce.filterOperators) == null ? void 0 : Pe.find((Ye) => Ye.value === r.operator);
  }, [r, ce]), we = m.useCallback((Pe) => {
    const Ye = Pe.target.value, Ke = P.current.getColumn(Ye);
    if (Ke.field === ce.field)
      return;
    const je = Ke.filterOperators.find((Et) => Et.value === r.operator) || Ke.filterOperators[0];
    let et = !je.InputComponent || je.InputComponent !== (le == null ? void 0 : le.InputComponent) || Ke.type !== ce.type ? void 0 : r.value;
    if (Ke.type === "singleSelect" && et !== void 0) {
      const Et = Ke, Xe = Sc(Et);
      Array.isArray(et) ? et = et.filter((xt) => (
        // Only keep values that are in the new value options
        Nm(xt, Xe, Et == null ? void 0 : Et.getOptionValue) !== void 0
      )) : Nm(r.value, Xe, Et == null ? void 0 : Et.getOptionValue) === void 0 && (et = void 0);
    }
    a(U({}, r, {
      field: Ye,
      operator: je.value,
      value: et
    }));
  }, [P, a, r, ce, le]), q = m.useCallback((Pe) => {
    const Ye = Pe.target.value, Ke = ce == null ? void 0 : ce.filterOperators.find((Qe) => Qe.value === Ye), je = !(Ke != null && Ke.InputComponent) || (Ke == null ? void 0 : Ke.InputComponent) !== (le == null ? void 0 : le.InputComponent);
    a(U({}, r, {
      operator: Ye,
      value: je ? void 0 : r.value
    }));
  }, [a, r, ce, le]), Ee = m.useCallback((Pe) => {
    const Ye = Pe.target.value === Oo.And.toString() ? Oo.And : Oo.Or;
    d(Ye);
  }, [d]), _e = () => {
    i(r);
  };
  return m.useImperativeHandle(f, () => ({
    focus: () => {
      var Pe;
      le != null && le.InputComponent ? (Pe = k == null ? void 0 : k.current) == null || Pe.focus() : N.current.focus();
    }
  }), [le]), /* @__PURE__ */ w.jsxs(Hfe, U({
    className: H.root,
    "data-id": r.id,
    ownerState: B
  }, T, {
    ref: n,
    children: [/* @__PURE__ */ w.jsx(Ufe, U({
      variant: "standard",
      as: B.slots.baseFormControl
    }, V, v, {
      className: ke(H.deleteIcon, V.className, v.className),
      ownerState: B,
      children: /* @__PURE__ */ w.jsx(B.slots.baseIconButton, U({
        "aria-label": P.current.getLocaleText("filterPanelDeleteIconLabel"),
        title: P.current.getLocaleText("filterPanelDeleteIconLabel"),
        onClick: _e,
        size: "small",
        disabled: O
      }, (fe = B.slotProps) == null ? void 0 : fe.baseIconButton, {
        children: /* @__PURE__ */ w.jsx(B.slots.filterPanelDeleteIcon, {
          fontSize: "small"
        })
      }))
    })), /* @__PURE__ */ w.jsx(zfe, U({
      variant: "standard",
      as: B.slots.baseFormControl
    }, V, y, {
      sx: [W ? {
        display: "flex"
      } : {
        display: "none"
      }, l ? {
        visibility: "visible"
      } : {
        visibility: "hidden"
      }, V.sx, y.sx],
      className: ke(H.logicOperatorInput, V.className, y.className),
      ownerState: B,
      children: /* @__PURE__ */ w.jsx(B.slots.baseSelect, U({
        inputProps: {
          "aria-label": P.current.getLocaleText("filterPanelLogicOperator")
        },
        value: j ?? "",
        onChange: Ee,
        disabled: !!c || p.length === 1,
        native: z
      }, (me = B.slotProps) == null ? void 0 : me.baseSelect, {
        children: p.map((Pe) => /* @__PURE__ */ fc(B.slots.baseSelectOption, U({}, K, {
          native: z,
          key: Pe.toString(),
          value: Pe.toString()
        }), P.current.getLocaleText(Kfe(Pe))))
      }))
    })), /* @__PURE__ */ w.jsxs(Gfe, U({
      variant: "standard",
      as: B.slots.baseFormControl
    }, V, E, {
      className: ke(H.columnInput, V.className, E.className),
      ownerState: B,
      children: [/* @__PURE__ */ w.jsx(B.slots.baseInputLabel, U({}, ne, {
        htmlFor: _,
        id: C,
        children: P.current.getLocaleText("filterPanelColumns")
      })), /* @__PURE__ */ w.jsx(B.slots.baseSelect, U({
        labelId: C,
        id: _,
        label: P.current.getLocaleText("filterPanelColumns"),
        value: ie ?? "",
        onChange: we,
        native: z,
        disabled: O
      }, (Oe = B.slotProps) == null ? void 0 : Oe.baseSelect, {
        children: ae.map((Pe) => /* @__PURE__ */ fc(B.slots.baseSelectOption, U({}, K, {
          native: z,
          key: Pe.field,
          value: Pe.field
        }), Sf(Pe)))
      }))]
    })), /* @__PURE__ */ w.jsxs(Wfe, U({
      variant: "standard",
      as: B.slots.baseFormControl
    }, V, S, {
      className: ke(H.operatorInput, V.className, S.className),
      ownerState: B,
      children: [/* @__PURE__ */ w.jsx(B.slots.baseInputLabel, U({}, ne, {
        htmlFor: D,
        id: L,
        children: P.current.getLocaleText("filterPanelOperator")
      })), /* @__PURE__ */ w.jsx(B.slots.baseSelect, U({
        labelId: L,
        label: P.current.getLocaleText("filterPanelOperator"),
        id: D,
        value: r.operator,
        onChange: q,
        native: z,
        inputRef: N,
        disabled: O
      }, (Ce = B.slotProps) == null ? void 0 : Ce.baseSelect, {
        children: (Te = ce == null ? void 0 : ce.filterOperators) == null ? void 0 : Te.map((Pe) => /* @__PURE__ */ fc(B.slots.baseSelectOption, U({}, K, {
          native: z,
          key: Pe.value,
          value: Pe.value
        }), Pe.label || P.current.getLocaleText(`filterOperator${Jp(Pe.value)}`)))
      }))]
    })), /* @__PURE__ */ w.jsx(qfe, U({
      variant: "standard",
      as: B.slots.baseFormControl
    }, V, re, {
      className: ke(H.valueInput, V.className, re.className),
      ownerState: B,
      children: le != null && le.InputComponent ? /* @__PURE__ */ w.jsx(le.InputComponent, U({
        apiRef: P,
        item: r,
        applyValue: a,
        focusElementRef: k,
        disabled: O
      }, le.InputComponentProps, Q), r.field) : null
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (oC.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Callback called when the operator, column field or value is changed.
   * @param {GridFilterItem} item The updated [[GridFilterItem]].
   */
  applyFilterChanges: s.func.isRequired,
  /**
   * Callback called when the logic operator is changed.
   * @param {GridLogicOperator} operator The new logic operator.
   */
  applyMultiFilterOperatorChanges: s.func.isRequired,
  /**
   * @ignore - do not document.
   */
  children: s.node,
  /**
   * Props passed to the column input component.
   * @default {}
   */
  columnInputProps: s.any,
  /**
   * Changes how the options in the columns selector should be ordered.
   * If not specified, the order is derived from the `columns` prop.
   */
  columnsSort: s.oneOf(["asc", "desc"]),
  /**
   * Callback called when the delete button is clicked.
   * @param {GridFilterItem} item The deleted [[GridFilterItem]].
   */
  deleteFilter: s.func.isRequired,
  /**
   * Props passed to the delete icon.
   * @default {}
   */
  deleteIconProps: s.any,
  /**
   * If `true`, disables the logic operator field but still renders it.
   */
  disableMultiFilterOperator: s.bool,
  /**
   * Allows to filter the columns displayed in the filter form.
   * @param {FilterColumnsArgs} args The columns of the grid and name of field.
   * @returns {GridColDef['field'][]} The filtered fields array.
   */
  filterColumns: s.func,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the el
   */
  focusElementRef: s.oneOfType([s.func, s.object]),
  /**
   * If `true`, the logic operator field is rendered.
   * The field will be invisible if `showMultiFilterOperators` is also `true`.
   */
  hasMultipleFilters: s.bool.isRequired,
  /**
   * The [[GridFilterItem]] representing this form.
   */
  item: s.shape({
    field: s.string.isRequired,
    id: s.oneOfType([s.number, s.string]),
    operator: s.string.isRequired,
    value: s.any
  }).isRequired,
  /**
   * Props passed to the logic operator input component.
   * @default {}
   */
  logicOperatorInputProps: s.any,
  /**
   * Sets the available logic operators.
   * @default [GridLogicOperator.And, GridLogicOperator.Or]
   */
  logicOperators: s.arrayOf(s.oneOf(["and", "or"]).isRequired),
  /**
   * Props passed to the operator input component.
   * @default {}
   */
  operatorInputProps: s.any,
  /**
   * `true` if the filter is disabled/read only.
   * i.e. `colDef.fiterable = false` but passed in `filterModel`
   * @default false
   */
  readOnly: s.bool,
  /**
   * If `true`, the logic operator field is visible.
   */
  showMultiFilterOperators: s.bool,
  /**
   * Props passed to the value input component.
   * @default {}
   */
  valueInputProps: s.any
});
const Yfe = ["logicOperators", "columnsSort", "filterFormProps", "getColumnForNewFilter", "children", "disableAddFilterButton", "disableRemoveAllButton"], RR = (e) => ({
  field: e.field,
  operator: e.filterOperators[0].value,
  id: Math.round(Math.random() * 1e5)
}), XF = dn(function(t, n) {
  var L, B;
  const r = Wt(), o = ft(), i = Be(r, ro), a = Be(r, gN), l = Be(r, kae), c = m.useRef(null), d = m.useRef(null), {
    logicOperators: f = [Oo.And, Oo.Or],
    columnsSort: p,
    filterFormProps: g,
    getColumnForNewFilter: b,
    disableAddFilterButton: v = !1,
    disableRemoveAllButton: y = !1
  } = t, S = yt(t, Yfe), E = r.current.upsertFilterItem, I = m.useCallback((H) => {
    r.current.setFilterLogicOperator(H);
  }, [r]), O = m.useCallback(() => {
    let H;
    if (b && typeof b == "function") {
      const k = b({
        currentFilters: (i == null ? void 0 : i.items) || [],
        columns: a
      });
      if (k === null)
        return null;
      H = a.find(({
        field: N
      }) => N === k);
    } else
      H = a.find((k) => {
        var N;
        return (N = k.filterOperators) == null ? void 0 : N.length;
      });
    return H ? RR(H) : null;
  }, [i == null ? void 0 : i.items, a, b]), T = m.useCallback(() => {
    if (b === void 0 || typeof b != "function")
      return O();
    const H = i.items.length ? i.items : [O()].filter(Boolean), k = b({
      currentFilters: H,
      columns: a
    });
    if (k === null)
      return null;
    const N = a.find(({
      field: j
    }) => j === k);
    return N ? RR(N) : null;
  }, [i.items, a, b, O]), P = m.useMemo(() => i.items.length ? i.items : (d.current || (d.current = O()), d.current ? [d.current] : []), [i.items, O]), R = P.length > 1, {
    readOnlyFilters: F,
    validFilters: A
  } = m.useMemo(() => P.reduce((H, k) => (l[k.field] ? H.validFilters.push(k) : H.readOnlyFilters.push(k), H), {
    readOnlyFilters: [],
    validFilters: []
  }), [P, l]), _ = m.useCallback(() => {
    const H = T();
    H && r.current.upsertFilterItems([...P, H]);
  }, [r, T, P]), C = m.useCallback((H) => {
    const k = A.length === 1;
    r.current.deleteFilterItem(H), k && r.current.hideFilterPanel();
  }, [r, A.length]), D = m.useCallback(() => A.length === 1 && A[0].value === void 0 ? (r.current.deleteFilterItem(A[0]), r.current.hideFilterPanel()) : r.current.setFilterModel(U({}, i, {
    items: F
  }), "removeAllFilterItems"), [r, F, i, A]);
  return m.useEffect(() => {
    f.length > 0 && i.logicOperator && !f.includes(i.logicOperator) && I(f[0]);
  }, [f, I, i.logicOperator]), m.useEffect(() => {
    A.length > 0 && c.current.focus();
  }, [A.length]), /* @__PURE__ */ w.jsxs(FS, U({}, S, {
    ref: n,
    children: [/* @__PURE__ */ w.jsxs(YF, {
      children: [F.map((H, k) => /* @__PURE__ */ w.jsx(oC, U({
        item: H,
        applyFilterChanges: E,
        deleteFilter: C,
        hasMultipleFilters: R,
        showMultiFilterOperators: k > 0,
        disableMultiFilterOperator: k !== 1,
        applyMultiFilterOperatorChanges: I,
        focusElementRef: null,
        readOnly: !0,
        logicOperators: f,
        columnsSort: p
      }, g), H.id == null ? k : H.id)), A.map((H, k) => /* @__PURE__ */ w.jsx(oC, U({
        item: H,
        applyFilterChanges: E,
        deleteFilter: C,
        hasMultipleFilters: R,
        showMultiFilterOperators: F.length + k > 0,
        disableMultiFilterOperator: F.length + k !== 1,
        applyMultiFilterOperatorChanges: I,
        focusElementRef: k === A.length - 1 ? c : null,
        logicOperators: f,
        columnsSort: p
      }, g), H.id == null ? k + F.length : H.id))]
    }), !o.disableMultipleColumnsFiltering && !(v && y) ? /* @__PURE__ */ w.jsxs(QF, {
      children: [v ? /* @__PURE__ */ w.jsx("span", {}) : /* @__PURE__ */ w.jsx(o.slots.baseButton, U({
        onClick: _,
        startIcon: /* @__PURE__ */ w.jsx(o.slots.filterPanelAddIcon, {})
      }, (L = o.slotProps) == null ? void 0 : L.baseButton, {
        children: r.current.getLocaleText("filterPanelAddFilter")
      })), !y && A.length > 0 ? /* @__PURE__ */ w.jsx(o.slots.baseButton, U({
        onClick: D,
        startIcon: /* @__PURE__ */ w.jsx(o.slots.filterPanelRemoveAllIcon, {})
      }, (B = o.slotProps) == null ? void 0 : B.baseButton, {
        children: r.current.getLocaleText("filterPanelRemoveAll")
      })) : null]
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (XF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * @ignore - do not document.
   */
  children: s.node,
  /**
   * Changes how the options in the columns selector should be ordered.
   * If not specified, the order is derived from the `columns` prop.
   */
  columnsSort: s.oneOf(["asc", "desc"]),
  /**
   * If `true`, the `Add filter` button will not be displayed.
   * @default false
   */
  disableAddFilterButton: s.bool,
  /**
   * If `true`, the `Remove all` button will be disabled
   * @default false
   */
  disableRemoveAllButton: s.bool,
  /**
   * Props passed to each filter form.
   */
  filterFormProps: s.shape({
    columnInputProps: s.any,
    columnsSort: s.oneOf(["asc", "desc"]),
    deleteIconProps: s.any,
    filterColumns: s.func,
    logicOperatorInputProps: s.any,
    operatorInputProps: s.any,
    valueInputProps: s.any
  }),
  /**
   * Function that returns the next filter item to be picked as default filter.
   * @param {GetColumnForNewFilterArgs} args Currently configured filters and columns.
   * @returns {GridColDef['field']} The field to be used for the next filter or `null` to prevent adding a filter.
   */
  getColumnForNewFilter: s.func,
  /**
   * Sets the available logic operators.
   * @default [GridLogicOperator.And, GridLogicOperator.Or]
   */
  logicOperators: s.arrayOf(s.oneOf(["and", "or"]).isRequired),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const Qfe = (e, t) => {
  const n = new Set(Object.keys(e).filter((i) => e[i] === !1)), r = new Set(Object.keys(t).filter((i) => t[i] === !1));
  if (n.size !== r.size)
    return !1;
  let o = !0;
  return n.forEach((i) => {
    r.has(i) || (o = !1);
  }), o;
}, Xfe = (e, t) => (e.headerName || e.field).toLowerCase().indexOf(t) > -1, Jfe = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["columnsManagement"],
    header: ["columnsManagementHeader"],
    searchInput: ["columnsManagementSearchInput"],
    footer: ["columnsManagementFooter"],
    row: ["columnsManagementRow"]
  }, nn, t);
}, _R = new Intl.Collator();
function JF(e) {
  var k, N, j, W;
  const t = Wt(), n = m.useRef(null), r = Be(t, rs), o = Ws(() => Ai(t)).current, i = Be(t, Ai), a = ft(), [l, c] = m.useState(""), d = Jfe(a), {
    sort: f,
    searchPredicate: p = Xfe,
    autoFocusSearchField: g = !0,
    disableShowHideToggle: b = !1,
    disableResetButton: v = !1,
    toggleAllMode: y = "all",
    getTogglableColumns: S,
    searchInputProps: E
  } = e, I = m.useMemo(() => Qfe(i, o), [i, o]), O = m.useMemo(() => {
    switch (f) {
      case "asc":
        return [...r].sort((V, $) => _R.compare(V.headerName || V.field, $.headerName || $.field));
      case "desc":
        return [...r].sort((V, $) => -_R.compare(V.headerName || V.field, $.headerName || $.field));
      default:
        return r;
    }
  }, [r, f]), T = (V) => {
    const {
      name: $
    } = V.target;
    t.current.setColumnVisibility($, i[$] === !1);
  }, P = m.useMemo(() => {
    const V = S ? S(O) : null, $ = V ? O.filter(({
      field: z
    }) => V.includes(z)) : O;
    return l ? $.filter((z) => p(z, l.toLowerCase())) : $;
  }, [O, l, p, S]), R = m.useCallback((V) => {
    const $ = Ai(t), z = U({}, $), ne = S ? S(r) : null;
    return (y === "filteredOnly" ? P : r).forEach((K) => {
      K.hideable && (ne == null || ne.includes(K.field)) && (V ? delete z[K.field] : z[K.field] = !1);
    }), t.current.setColumnVisibilityModel(z);
  }, [t, r, S, y, P]), F = m.useCallback((V) => {
    c(V.target.value);
  }, []), A = m.useMemo(() => P.filter((V) => V.hideable), [P]), _ = m.useMemo(() => A.every((V) => i[V.field] == null || i[V.field] !== !1), [i, A]), C = m.useMemo(() => A.every((V) => i[V.field] === !1), [i, A]), D = m.useRef(null);
  m.useEffect(() => {
    g ? n.current.focus() : D.current && typeof D.current.focus == "function" && D.current.focus();
  }, [g]);
  let L = !1;
  const B = (V) => L === !1 && V.hideable !== !1 ? (L = !0, !0) : !1, H = m.useCallback(() => {
    c(""), n.current.focus();
  }, []);
  return /* @__PURE__ */ w.jsxs(m.Fragment, {
    children: [/* @__PURE__ */ w.jsx(epe, {
      className: d.header,
      ownerState: a,
      children: /* @__PURE__ */ w.jsx(tpe, U({
        as: a.slots.baseTextField,
        ownerState: a,
        placeholder: t.current.getLocaleText("columnsManagementSearchTitle"),
        inputRef: n,
        className: d.searchInput,
        value: l,
        onChange: F,
        variant: "outlined",
        size: "small",
        type: "search",
        InputProps: {
          startAdornment: /* @__PURE__ */ w.jsx(a.slots.baseInputAdornment, {
            position: "start",
            children: /* @__PURE__ */ w.jsx(a.slots.quickFilterIcon, {})
          }),
          endAdornment: /* @__PURE__ */ w.jsx(a.slots.baseIconButton, U({
            "aria-label": t.current.getLocaleText("columnsManagementDeleteIconLabel"),
            size: "small",
            sx: [l ? {
              visibility: "visible"
            } : {
              visibility: "hidden"
            }],
            tabIndex: -1,
            onClick: H
          }, (k = a.slotProps) == null ? void 0 : k.baseIconButton, {
            children: /* @__PURE__ */ w.jsx(a.slots.quickFilterClearIcon, {
              fontSize: "small"
            })
          }))
        },
        inputProps: {
          "aria-label": t.current.getLocaleText("columnsManagementSearchTitle")
        },
        autoComplete: "off",
        fullWidth: !0
      }, (N = a.slotProps) == null ? void 0 : N.baseTextField, E))
    }), /* @__PURE__ */ w.jsxs(Zfe, {
      className: d.root,
      ownerState: a,
      children: [P.map((V) => {
        var $;
        return /* @__PURE__ */ w.jsx(dp, {
          className: d.row,
          control: /* @__PURE__ */ w.jsx(a.slots.baseCheckbox, U({
            disabled: V.hideable === !1,
            checked: i[V.field] !== !1,
            onClick: T,
            name: V.field,
            sx: {
              p: 0.5
            },
            inputRef: B(V) ? D : void 0
          }, ($ = a.slotProps) == null ? void 0 : $.baseCheckbox)),
          label: V.headerName || V.field
        }, V.field);
      }), P.length === 0 && /* @__PURE__ */ w.jsx(rpe, {
        ownerState: a,
        children: t.current.getLocaleText("columnsManagementNoColumns")
      })]
    }), (!b || !v) && P.length > 0 ? /* @__PURE__ */ w.jsxs(npe, {
      ownerState: a,
      className: d.footer,
      children: [b ? /* @__PURE__ */ w.jsx("span", {}) : /* @__PURE__ */ w.jsx(dp, {
        control: /* @__PURE__ */ w.jsx(a.slots.baseCheckbox, U({
          disabled: A.length === 0,
          checked: _,
          indeterminate: !_ && !C,
          onClick: () => R(!_),
          name: t.current.getLocaleText("columnsManagementShowHideAllText"),
          sx: {
            p: 0.5
          }
        }, (j = a.slotProps) == null ? void 0 : j.baseCheckbox)),
        label: t.current.getLocaleText("columnsManagementShowHideAllText")
      }), v ? null : /* @__PURE__ */ w.jsx(a.slots.baseButton, U({
        onClick: () => t.current.setColumnVisibilityModel(o),
        disabled: I
      }, (W = a.slotProps) == null ? void 0 : W.baseButton, {
        children: t.current.getLocaleText("columnsManagementReset")
      }))]
    }) : null]
  });
}
process.env.NODE_ENV !== "production" && (JF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the column search field will be focused automatically.
   * If `false`, the first column switch input will be focused automatically.
   * This helps to avoid input keyboard panel to popup automatically on touch devices.
   * @default true
   */
  autoFocusSearchField: s.bool,
  /**
   * If `true`, the `Reset` button will not be disabled
   * @default false
   */
  disableResetButton: s.bool,
  /**
   * If `true`, the `Show/Hide all` toggle checkbox will not be displayed.
   * @default false
   */
  disableShowHideToggle: s.bool,
  /**
   * Returns the list of togglable columns.
   * If used, only those columns will be displayed in the panel
   * which are passed as the return value of the function.
   * @param {GridColDef[]} columns The `ColDef` list of all columns.
   * @returns {GridColDef['field'][]} The list of togglable columns' field names.
   */
  getTogglableColumns: s.func,
  searchInputProps: s.object,
  searchPredicate: s.func,
  sort: s.oneOf(["asc", "desc"]),
  /**
   * Changes the behavior of the `Show/Hide All` toggle when the search field is used:
   * - `all`: Will toggle all columns.
   * - `filteredOnly`: Will only toggle columns that match the search criteria.
   * @default 'all'
   */
  toggleAllMode: s.oneOf(["all", "filteredOnly"])
});
const Zfe = oe("div", {
  name: "MuiDataGrid",
  slot: "ColumnsManagement",
  overridesResolver: (e, t) => t.columnsManagement
})(({
  theme: e
}) => ({
  padding: e.spacing(0, 3, 1.5),
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
  flex: "1 1",
  maxHeight: 400,
  alignItems: "flex-start"
})), epe = oe("div", {
  name: "MuiDataGrid",
  slot: "ColumnsManagementHeader",
  overridesResolver: (e, t) => t.columnsManagementHeader
})(({
  theme: e
}) => ({
  padding: e.spacing(1.5, 3)
})), tpe = oe(Ea, {
  name: "MuiDataGrid",
  slot: "ColumnsManagementSearchInput",
  overridesResolver: (e, t) => t.columnsManagementSearchInput
})(({
  theme: e
}) => ({
  [`& .${Xr.root}`]: {
    padding: e.spacing(0, 1.5, 0, 1.5)
  },
  [`& .${Xr.input}::-webkit-search-decoration,
  & .${Xr.input}::-webkit-search-cancel-button,
  & .${Xr.input}::-webkit-search-results-button,
  & .${Xr.input}::-webkit-search-results-decoration`]: {
    /* clears the 'X' icon from Chrome */
    display: "none"
  }
})), npe = oe("div", {
  name: "MuiDataGrid",
  slot: "ColumnsManagementFooter",
  overridesResolver: (e, t) => t.columnsManagementFooter
})(({
  theme: e
}) => ({
  padding: e.spacing(0.5, 1, 0.5, 3),
  display: "flex",
  justifyContent: "space-between",
  borderTop: `1px solid ${e.palette.divider}`
})), rpe = oe("div")(({
  theme: e
}) => ({
  padding: e.spacing(0.5, 0),
  color: e.palette.grey[500]
})), ZF = dn(function(t, n) {
  var I, O;
  const {
    children: r,
    slotProps: o = {}
  } = t, i = o.button || {}, a = o.tooltip || {}, l = Wt(), c = ft(), d = xr(), f = xr(), [p, g] = m.useState(!1), b = m.useRef(null), v = Rl(n, b), y = (T) => {
    var P;
    g((R) => !R), (P = i.onClick) == null || P.call(i, T);
  }, S = () => g(!1), E = (T) => {
    T.key === "Tab" && T.preventDefault(), $F(T.key) && S();
  };
  return r == null ? null : /* @__PURE__ */ w.jsxs(m.Fragment, {
    children: [/* @__PURE__ */ w.jsx(c.slots.baseTooltip, U({
      title: l.current.getLocaleText("toolbarExportLabel"),
      enterDelay: 1e3
    }, (I = c.slotProps) == null ? void 0 : I.baseTooltip, a, {
      children: /* @__PURE__ */ w.jsx(c.slots.baseButton, U({
        size: "small",
        startIcon: /* @__PURE__ */ w.jsx(c.slots.exportIcon, {}),
        "aria-expanded": p,
        "aria-label": l.current.getLocaleText("toolbarExportLabel"),
        "aria-haspopup": "menu",
        "aria-controls": p ? f : void 0,
        id: d,
        onClick: y
      }, (O = c.slotProps) == null ? void 0 : O.baseButton, i, {
        ref: v,
        children: l.current.getLocaleText("toolbarExport")
      }))
    })), /* @__PURE__ */ w.jsx(ty, {
      open: p,
      target: b.current,
      onClose: S,
      position: "bottom-start",
      children: /* @__PURE__ */ w.jsx(qp, {
        id: f,
        className: ee.menuList,
        "aria-labelledby": d,
        onKeyDown: E,
        autoFocusItem: p,
        children: m.Children.map(r, (T) => /* @__PURE__ */ m.isValidElement(T) ? /* @__PURE__ */ m.cloneElement(T, {
          hideMenu: S
        }) : T)
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (ZF.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.object
});
const ope = ["hideMenu", "options"], ipe = ["hideMenu", "options"], spe = ["csvOptions", "printOptions", "excelOptions"];
function e$(e) {
  const t = Wt(), {
    hideMenu: n,
    options: r
  } = e, o = yt(e, ope);
  return /* @__PURE__ */ w.jsx(ts, U({
    onClick: () => {
      t.current.exportDataAsCsv(r), n == null || n();
    }
  }, o, {
    children: t.current.getLocaleText("toolbarExportCSV")
  }));
}
process.env.NODE_ENV !== "production" && (e$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  hideMenu: s.func,
  options: s.shape({
    allColumns: s.bool,
    delimiter: s.string,
    disableToolbarButton: s.bool,
    escapeFormulas: s.bool,
    fields: s.arrayOf(s.string),
    fileName: s.string,
    getRowsToExport: s.func,
    includeColumnGroupsHeaders: s.bool,
    includeHeaders: s.bool,
    shouldAppendQuotes: s.bool,
    utf8WithBom: s.bool
  })
});
function t$(e) {
  const t = Wt(), {
    hideMenu: n,
    options: r
  } = e, o = yt(e, ipe);
  return /* @__PURE__ */ w.jsx(ts, U({
    onClick: () => {
      t.current.exportDataAsPrint(r), n == null || n();
    }
  }, o, {
    children: t.current.getLocaleText("toolbarExportPrint")
  }));
}
process.env.NODE_ENV !== "production" && (t$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  hideMenu: s.func,
  options: s.shape({
    allColumns: s.bool,
    bodyClassName: s.string,
    copyStyles: s.bool,
    disableToolbarButton: s.bool,
    fields: s.arrayOf(s.string),
    fileName: s.string,
    getRowsToExport: s.func,
    hideFooter: s.bool,
    hideToolbar: s.bool,
    includeCheckboxes: s.bool,
    pageStyle: s.oneOfType([s.func, s.string])
  })
});
const ape = dn(function(t, n) {
  const r = t, {
    csvOptions: o = {},
    printOptions: i = {},
    excelOptions: a
  } = r, l = yt(r, spe), d = Wt().current.unstable_applyPipeProcessors("exportMenu", [], {
    excelOptions: a,
    csvOptions: o,
    printOptions: i
  }).sort((f, p) => f.componentName > p.componentName ? 1 : -1);
  return d.length === 0 ? null : /* @__PURE__ */ w.jsx(ZF, U({}, l, {
    ref: n,
    children: d.map((f, p) => /* @__PURE__ */ m.cloneElement(f.component, {
      key: p
    }))
  }));
});
process.env.NODE_ENV !== "production" && (ape.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  csvOptions: s.object,
  printOptions: s.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.object
});
const lpe = ["className", "selectedRowCount"], cpe = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["selectedRowCount"]
  }, nn, t);
}, upe = On("div", {
  name: "MuiDataGrid",
  slot: "SelectedRowCount",
  overridesResolver: (e, t) => t.selectedRowCount
})(({
  theme: e
}) => ({
  alignItems: "center",
  display: "flex",
  margin: e.spacing(0, 2),
  visibility: "hidden",
  width: 0,
  height: 0,
  [e.breakpoints.up("sm")]: {
    visibility: "visible",
    width: "auto",
    height: "auto"
  }
})), n$ = dn(function(t, n) {
  const {
    className: r,
    selectedRowCount: o
  } = t, i = yt(t, lpe), a = Wt(), l = ft(), c = cpe(l), d = a.current.getLocaleText("footerRowSelected")(o);
  return /* @__PURE__ */ w.jsx(upe, U({
    className: ke(c.root, r),
    ownerState: l
  }, i, {
    ref: n,
    children: d
  }));
});
process.env.NODE_ENV !== "production" && (n$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  selectedRowCount: s.number.isRequired,
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const r$ = dn(function(t, n) {
  var p, g;
  const r = Wt(), o = ft(), i = Be(r, fle), a = Be(r, jle), l = Be(r, TS), c = !o.hideFooterSelectedRowCount && a > 0 ? /* @__PURE__ */ w.jsx(n$, {
    selectedRowCount: a
  }) : /* @__PURE__ */ w.jsx("div", {}), d = !o.hideFooterRowCount && !o.pagination ? /* @__PURE__ */ w.jsx(o.slots.footerRowCount, U({}, (p = o.slotProps) == null ? void 0 : p.footerRowCount, {
    rowCount: i,
    visibleRowCount: l
  })) : null, f = o.pagination && !o.hideFooterPagination && o.slots.pagination && /* @__PURE__ */ w.jsx(o.slots.pagination, U({}, (g = o.slotProps) == null ? void 0 : g.pagination));
  return /* @__PURE__ */ w.jsxs(SF, U({}, t, {
    ref: n,
    children: [c, d, f]
  }));
});
process.env.NODE_ENV !== "production" && (r$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function dpe() {
  var i, a;
  const e = Wt(), t = Be(e, rs), n = ft(), r = Be(e, xp), o = e.current.unstable_applyPipeProcessors("preferencePanel", null, r.openedPanelValue ?? Ec.filters);
  return /* @__PURE__ */ w.jsx(n.slots.panel, U({
    as: n.slots.basePopper,
    open: t.length > 0 && r.open,
    id: r.panelId,
    "aria-labelledby": r.labelId
  }, (i = n.slotProps) == null ? void 0 : i.panel, (a = n.slotProps) == null ? void 0 : a.basePopper, {
    children: o
  }));
}
function fpe() {
  var t;
  const e = ft();
  return /* @__PURE__ */ w.jsxs(m.Fragment, {
    children: [/* @__PURE__ */ w.jsx(dpe, {}), e.slots.toolbar && /* @__PURE__ */ w.jsx(e.slots.toolbar, U({}, (t = e.slotProps) == null ? void 0 : t.toolbar))]
  });
}
const $S = (e, t, n, r, o) => {
  const i = o.hasScrollY ? o.scrollbarSize : 0;
  let a;
  switch (e) {
    case $n.LEFT:
      a = r[n];
      break;
    case $n.RIGHT:
      a = o.columnsTotalWidth - r[n] - t + i;
      break;
    default:
      a = 0;
      break;
  }
  return a;
}, Ef = {
  root: ee.scrollbarFiller,
  header: ee["scrollbarFiller--header"],
  borderTop: ee["scrollbarFiller--borderTop"],
  borderBottom: ee["scrollbarFiller--borderBottom"],
  pinnedRight: ee["scrollbarFiller--pinnedRight"]
};
function LS({
  header: e,
  borderTop: t = !0,
  borderBottom: n,
  pinnedRight: r
}) {
  return /* @__PURE__ */ w.jsx("div", {
    role: "presentation",
    className: ke(Ef.root, e && Ef.header, t && Ef.borderTop, n && Ef.borderBottom, r && Ef.pinnedRight)
  });
}
const ppe = On("div", {
  name: "MuiDataGrid",
  slot: "SkeletonLoadingOverlay",
  overridesResolver: (e, t) => t.skeletonLoadingOverlay
})({
  minWidth: "100%",
  width: "max-content",
  // prevents overflow: clip; cutting off the x axis
  height: "100%",
  overflow: "clip"
  // y axis is hidden while the x axis is allowed to overflow
}), hpe = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["skeletonLoadingOverlay"]
  }, nn, t);
}, kR = (e) => parseInt(e.getAttribute("data-colindex"), 10), gpe = dn(function(t, n) {
  const r = ft(), {
    slots: o
  } = r, i = hpe({
    classes: r.classes
  }), a = m.useRef(null), l = Rl(a, n), c = Wt(), d = Be(c, mo), f = (d == null ? void 0 : d.viewportInnerSize.height) ?? 0, p = Math.ceil(f / d.rowHeight), g = Be(c, bS), b = Be(c, Nl), v = m.useMemo(() => b.filter((R) => R <= g).length, [g, b]), y = Be(c, Fr), S = m.useMemo(() => y.slice(0, v), [y, v]), E = Be(c, uh), I = m.useCallback((R, F, A) => {
    const _ = $S(A, R, F, b, d);
    return {
      [A]: _
    };
  }, [d, b]), O = m.useCallback((R) => {
    if (E.left.findIndex((F) => F.field === R) !== -1)
      return $n.LEFT;
    if (E.right.findIndex((F) => F.field === R) !== -1)
      return $n.RIGHT;
  }, [E.left, E.right]), T = m.useMemo(() => {
    const R = [];
    for (let F = 0; F < p; F += 1) {
      const A = [];
      for (let _ = 0; _ < S.length; _ += 1) {
        const C = S[_], D = O(C.field), L = D === $n.LEFT, B = D === $n.RIGHT, H = D ? E[D].length : S.length - E.left.length - E.right.length, k = D ? E[D].findIndex((ce) => ce.field === C.field) : _ - E.left.length, N = D && I(C.computedWidth, _, D), j = d.columnsTotalWidth < d.viewportOuterSize.width, W = hy(D, k, H, r.showCellVerticalBorder, j), V = gy(D, k), $ = _ === S.length - 1, z = B && k === 0, ne = z && j, K = $ && !z && j, Q = d.viewportOuterSize.width - d.columnsTotalWidth, re = Math.max(0, Q), te = /* @__PURE__ */ w.jsx(o.skeletonCell, {
          width: re,
          empty: !0
        }, `skeleton-filler-column-${F}`), ie = d.hasScrollY ? d.scrollbarSize : 0, ae = $ && ie !== 0;
        ne && A.push(te), A.push(/* @__PURE__ */ w.jsx(o.skeletonCell, {
          field: C.field,
          type: C.type,
          align: C.align,
          width: "var(--width)",
          height: d.rowHeight,
          "data-colindex": _,
          className: ke(L && ee["cell--pinnedLeft"], B && ee["cell--pinnedRight"], W && ee["cell--withRightBorder"], V && ee["cell--withLeftBorder"]),
          style: U({
            "--width": `${C.computedWidth}px`
          }, N)
        }, `skeleton-column-${F}-${C.field}`)), K && A.push(te), ae && A.push(/* @__PURE__ */ w.jsx(LS, {
          pinnedRight: E.right.length > 0
        }, `skeleton-scrollbar-filler-${F}`));
      }
      R.push(/* @__PURE__ */ w.jsx("div", {
        className: ke(ee.row, ee.rowSkeleton, F === 0 && ee["row--firstVisible"]),
        children: A
      }, `skeleton-row-${F}`));
    }
    return R;
  }, [o, S, E, p, r.showCellVerticalBorder, d.columnsTotalWidth, d.viewportOuterSize.width, d.rowHeight, d.hasScrollY, d.scrollbarSize, O, I]);
  return it(c, "columnResize", (R) => {
    var N, j, W;
    const {
      colDef: F,
      width: A
    } = R, _ = (N = a.current) == null ? void 0 : N.querySelectorAll(`[data-field="${Pa(F.field)}"]`);
    if (!_)
      throw new Error("MUI X: Expected skeleton cells to be defined with `data-field` attribute.");
    const C = S.findIndex((V) => V.field === F.field), D = O(F.field), L = D === $n.LEFT, B = D === $n.RIGHT, H = getComputedStyle(_[0]).getPropertyValue("--width"), k = parseInt(H, 10) - A;
    if (_ && _.forEach((V) => {
      V.style.setProperty("--width", `${A}px`);
    }), L) {
      const V = (j = a.current) == null ? void 0 : j.querySelectorAll(`.${ee["cell--pinnedLeft"]}`);
      V == null || V.forEach(($) => {
        kR($) > C && ($.style.left = `${parseInt(getComputedStyle($).left, 10) - k}px`);
      });
    }
    if (B) {
      const V = (W = a.current) == null ? void 0 : W.querySelectorAll(`.${ee["cell--pinnedRight"]}`);
      V == null || V.forEach(($) => {
        kR($) < C && ($.style.right = `${parseInt(getComputedStyle($).right, 10) + k}px`);
      });
    }
  }), /* @__PURE__ */ w.jsx(ppe, U({
    className: i.root
  }, t, {
    ref: l,
    children: T
  }));
}), mpe = ["variant", "noRowsVariant", "style"], bpe = {
  "circular-progress": {
    component: Gp,
    style: {}
  },
  "linear-progress": {
    component: hx,
    style: {
      display: "block"
    }
  },
  skeleton: {
    component: gpe,
    style: {
      display: "block"
    }
  }
}, o$ = dn(function(t, n) {
  const {
    variant: r = "circular-progress",
    noRowsVariant: o = "circular-progress",
    style: i
  } = t, a = yt(t, mpe), l = Wt(), c = Be(l, ry), d = bpe[c === 0 ? o : r];
  return /* @__PURE__ */ w.jsx(my, U({
    style: U({}, d.style, i)
  }, a, {
    ref: n,
    children: /* @__PURE__ */ w.jsx(d.component, {})
  }));
});
process.env.NODE_ENV !== "production" && (o$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The variant of the overlay when no rows are displayed.
   * @default 'circular-progress'
   */
  noRowsVariant: s.oneOf(["circular-progress", "linear-progress", "skeleton"]),
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant of the overlay.
   * @default 'circular-progress'
   */
  variant: s.oneOf(["circular-progress", "linear-progress", "skeleton"])
});
const i$ = dn(function(t, n) {
  const o = Wt().current.getLocaleText("noRowsLabel");
  return /* @__PURE__ */ w.jsx(my, U({}, t, {
    ref: n,
    children: o
  }));
});
process.env.NODE_ENV !== "production" && (i$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const ype = oe(NM)(({
  theme: e
}) => ({
  maxHeight: "calc(100% + 1px)",
  // border width
  flexGrow: 1,
  [`& .${bc.selectLabel}`]: {
    display: "none",
    [e.breakpoints.up("sm")]: {
      display: "block"
    }
  },
  [`& .${bc.input}`]: {
    display: "none",
    [e.breakpoints.up("sm")]: {
      display: "inline-flex"
    }
  }
})), vpe = (e, t) => ({
  from: n,
  to: r,
  count: o,
  page: i
}) => e({
  from: n,
  to: r,
  count: o,
  page: i,
  estimated: t
}), wpe = ({
  from: e,
  to: t,
  count: n,
  estimated: r
}) => r ? `${e}–${t} of ${n !== -1 ? n : `more than ${r > t ? r : t}`}` : `${e}–${t} of ${n !== -1 ? n : `more than ${t}`}`, s$ = dn(function(t, n) {
  var T;
  const r = Wt(), o = ft(), i = Be(r, To), a = Be(r, Au), l = Be(r, YN), {
    paginationMode: c,
    loading: d,
    estimatedRowCount: f
  } = o, p = m.useMemo(() => a === -1 && c === "server" && d ? {
    backIconButtonProps: {
      disabled: !0
    },
    nextIconButtonProps: {
      disabled: !0
    }
  } : {}, [d, c, a]), g = m.useMemo(() => Math.max(0, l - 1), [l]), b = m.useMemo(() => a === -1 || i.page <= g ? i.page : g, [g, i.page, a]), v = m.useCallback((P) => {
    const R = Number(P.target.value);
    r.current.setPageSize(R);
  }, [r]), y = m.useCallback((P, R) => {
    r.current.setPage(R);
  }, [r]), S = (P) => {
    for (let R = 0; R < o.pageSizeOptions.length; R += 1) {
      const F = o.pageSizeOptions[R];
      if (typeof F == "number") {
        if (F === P)
          return !0;
      } else if (F.value === P)
        return !0;
    }
    return !1;
  };
  if (process.env.NODE_ENV !== "production") {
    const P = m.useRef(!1), R = ((T = o.paginationModel) == null ? void 0 : T.pageSize) ?? i.pageSize;
    !P.current && !o.autoPageSize && !S(R) && (console.warn([`MUI X: The page size \`${i.pageSize}\` is not present in the \`pageSizeOptions\`.`, "Add it to show the pagination select."].join(`
`)), P.current = !0);
  }
  const E = S(i.pageSize) ? o.pageSizeOptions : [], I = r.current.getLocaleText("MuiTablePagination"), O = vpe(I.labelDisplayedRows || wpe, f);
  return /* @__PURE__ */ w.jsx(ype, U({
    component: "div",
    count: a,
    page: b,
    rowsPerPageOptions: E,
    rowsPerPage: i.pageSize,
    onPageChange: y,
    onRowsPerPageChange: v
  }, p, I, {
    labelDisplayedRows: O
  }, t, {
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (s$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  component: s.elementType
});
const Cpe = ["className", "rowCount", "visibleRowCount"], xpe = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["rowCount"]
  }, nn, t);
}, Spe = On("div", {
  name: "MuiDataGrid",
  slot: "RowCount",
  overridesResolver: (e, t) => t.rowCount
})(({
  theme: e
}) => ({
  alignItems: "center",
  display: "flex",
  margin: e.spacing(0, 2)
})), a$ = dn(function(t, n) {
  const {
    className: r,
    rowCount: o,
    visibleRowCount: i
  } = t, a = yt(t, Cpe), l = Wt(), c = ft(), d = xpe(c);
  if (o === 0)
    return null;
  const f = i < o ? l.current.getLocaleText("footerTotalVisibleRows")(i, o) : o.toLocaleString();
  return /* @__PURE__ */ w.jsxs(Spe, U({
    className: ke(d.root, r),
    ownerState: c
  }, a, {
    ref: n,
    children: [l.current.getLocaleText("footerTotalRows"), " ", f]
  }));
});
process.env.NODE_ENV !== "production" && (a$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  rowCount: s.number.isRequired,
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  visibleRowCount: s.number.isRequired
});
function Epe(e, t) {
  return tn(t, nn, e);
}
const Tpe = ["selected", "rowId", "row", "index", "style", "rowHeight", "className", "visibleColumns", "pinnedColumns", "offsetTop", "offsetLeft", "dimensions", "renderContext", "focusedColumnIndex", "isFirstVisible", "isLastVisible", "isNotVisible", "showBottomBorder", "tabbableCell", "onClick", "onDoubleClick", "onMouseEnter", "onMouseLeave", "onMouseOut", "onMouseOver"];
function l$({
  width: e
}) {
  return e ? /* @__PURE__ */ w.jsx("div", {
    role: "presentation",
    className: ke(ee.cell, ee.cellEmpty),
    style: {
      "--width": `${e}px`
    }
  }) : null;
}
process.env.NODE_ENV !== "production" && (l$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  width: s.number.isRequired
});
const c$ = dn(function(t, n) {
  var xt;
  const {
    selected: r,
    rowId: o,
    row: i,
    index: a,
    style: l,
    rowHeight: c,
    className: d,
    visibleColumns: f,
    pinnedColumns: p,
    offsetLeft: g,
    dimensions: b,
    renderContext: v,
    focusedColumnIndex: y,
    isFirstVisible: S,
    isLastVisible: E,
    isNotVisible: I,
    showBottomBorder: O,
    onClick: T,
    onDoubleClick: P,
    onMouseEnter: R,
    onMouseLeave: F,
    onMouseOut: A,
    onMouseOver: _
  } = t, C = yt(t, Tpe), D = Hi(), L = mF(), B = m.useRef(null), H = ft(), k = Fc(D, H), N = Be(D, Ii), j = Be(D, Dd), W = Be(D, Nl), V = Be(D, Qr), $ = Rl(B, n), z = D.current.getRowNode(o), ne = b.hasScrollY ? b.scrollbarSize : 0, K = b.columnsTotalWidth < b.viewportOuterSize.width, Q = D.current.getRowMode(o) === Dn.Edit, re = H.editMode === Us.Row, te = Be(D, fy), ie = y !== void 0, ae = ie && y >= p.left.length && y < v.firstColumnIndex, ce = ie && y < f.length - p.right.length && y >= v.lastColumnIndex, le = Epe(H.classes, {
    root: ["row", r && "selected", re && "row--editable", Q && "row--editing", S && "row--firstVisible", E && "row--lastVisible", O && "row--borderBottom", c === "auto" && "row--dynamicHeight"]
  }), we = L.hooks.useGridRowAriaAttributes();
  m.useLayoutEffect(() => {
    if (k.range) {
      const tt = D.current.getRowIndexRelativeToVisibleRows(o);
      tt !== void 0 && D.current.unstable_setLastMeasuredRowIndex(tt);
    }
    if (B.current && c === "auto")
      return D.current.observeRowHeight(B.current, o);
  }, [D, k.range, c, o]);
  const q = m.useCallback((tt, ct) => (Je) => {
    ph(Je) || D.current.getRow(o) && (D.current.publishEvent(tt, D.current.getRowParams(o), Je), ct && ct(Je));
  }, [D, o]), Ee = m.useCallback((tt) => {
    const ct = Fm(tt.target, ee.cell), Je = ct == null ? void 0 : ct.getAttribute("data-field");
    if (Je) {
      if (Je === $d.field || Je === iy || Je === "__reorder__" || D.current.getCellMode(o, Je) === En.Edit)
        return;
      const Ge = D.current.getColumn(Je);
      if ((Ge == null ? void 0 : Ge.type) === ny)
        return;
    }
    q("rowClick", T)(tt);
  }, [D, T, q, o]), {
    slots: _e,
    slotProps: $e,
    disableColumnReorder: Le
  } = H, Ze = H.rowReordering, J = Be(D, () => U({}, D.current.getRowHeightEntry(o)), dN), fe = m.useMemo(() => {
    if (I)
      return {
        opacity: 0,
        width: 0,
        height: 0
      };
    const tt = U({}, l, {
      maxHeight: c === "auto" ? "none" : c,
      // max-height doesn't support "auto"
      minHeight: c,
      "--height": typeof c == "number" ? `${c}px` : c
    });
    if (J.spacingTop) {
      const ct = H.rowSpacingType === "border" ? "borderTopWidth" : "marginTop";
      tt[ct] = J.spacingTop;
    }
    if (J.spacingBottom) {
      const ct = H.rowSpacingType === "border" ? "borderBottomWidth" : "marginBottom";
      let Je = tt[ct];
      typeof Je != "number" && (Je = parseInt(Je || "0", 10)), Je += J.spacingBottom, tt[ct] = Je;
    }
    return tt;
  }, [I, c, l, J, H.rowSpacingType]), me = D.current.unstable_applyPipeProcessors("rowClassName", [], o), Oe = z ? we(z, a) : void 0;
  if (typeof H.getRowClassName == "function") {
    const tt = a - (((xt = k.range) == null ? void 0 : xt.firstRowIndex) || 0), ct = U({}, D.current.getRowParams(o), {
      isFirstVisible: tt === 0,
      isLastVisible: tt === k.rows.length - 1,
      indexRelativeToCurrentPage: tt
    });
    me.push(H.getRowClassName(ct));
  }
  const Ce = (tt, ct, Je, Ge, lt = Vo.NONE) => {
    var eo;
    const It = D.current.unstable_getCellColSpanInfo(o, Je);
    if (It != null && It.spannedByColSpan)
      return null;
    const fn = (It == null ? void 0 : It.cellProps.width) ?? tt.computedWidth, Bn = (It == null ? void 0 : It.cellProps.colSpan) ?? 1, kn = $S(vF[lt], tt.computedWidth, Je, W, b);
    if ((z == null ? void 0 : z.type) === "skeletonRow")
      return /* @__PURE__ */ w.jsx(_e.skeletonCell, {
        type: tt.type,
        width: fn,
        height: c,
        field: tt.field,
        align: tt.align
      }, tt.field);
    const fr = ((eo = V[o]) == null ? void 0 : eo[tt.field]) ?? null, ar = tt.field === "__reorder__", Mr = Object.keys(V).length > 0, Lr = !(Le || tt.disableReorder), lr = Ze && !N.length && j <= 1 && !Mr, mt = !(Lr || ar && lr), er = lt === Vo.VIRTUAL;
    return /* @__PURE__ */ w.jsx(_e.cell, U({
      column: tt,
      width: fn,
      rowId: o,
      align: tt.align || "left",
      colIndex: Je,
      colSpan: Bn,
      disableDragEvents: mt,
      editCellState: fr,
      isNotVisible: er,
      pinnedOffset: kn,
      pinnedPosition: lt,
      sectionIndex: ct,
      sectionLength: Ge,
      gridHasFiller: K
    }, $e == null ? void 0 : $e.cell), tt.field);
  };
  if (!z)
    return null;
  const Te = p.left.map((tt, ct) => Ce(tt, ct, ct, p.left.length, Vo.LEFT)), Pe = p.right.map((tt, ct) => {
    const Je = f.length - p.right.length + ct;
    return Ce(tt, ct, Je, p.right.length, Vo.RIGHT);
  }), Ye = f.length - p.left.length - p.right.length, Ke = [];
  ae && Ke.push(Ce(f[y], y - p.left.length, y, Ye, Vo.VIRTUAL));
  let je, Qe;
  !H.disableVirtualization && !te ? (je = 0, Qe = f.length) : (je = v.firstColumnIndex, Qe = v.lastColumnIndex);
  for (let tt = je; tt < Qe; tt += 1) {
    const ct = f[tt], Je = tt - p.left.length;
    ct && Ke.push(Ce(ct, Je, tt, Ye));
  }
  ce && Ke.push(Ce(f[y], y - p.left.length, y, Ye, Vo.VIRTUAL));
  const et = i ? {
    onClick: Ee,
    onDoubleClick: q("rowDoubleClick", P),
    onMouseEnter: q("rowMouseEnter", R),
    onMouseLeave: q("rowMouseLeave", F),
    onMouseOut: q("rowMouseOut", A),
    onMouseOver: q("rowMouseOver", _)
  } : null, Et = b.viewportOuterSize.width - b.columnsTotalWidth - ne, Xe = Math.max(0, Et);
  return /* @__PURE__ */ w.jsxs("div", U({
    "data-id": o,
    "data-rowindex": a,
    role: "row",
    className: ke(...me, le.root, d),
    style: fe
  }, Oe, et, C, {
    ref: $,
    children: [Te, /* @__PURE__ */ w.jsx("div", {
      role: "presentation",
      className: ee.cellOffsetLeft,
      style: {
        width: g
      }
    }), Ke, Xe > 0 && /* @__PURE__ */ w.jsx(l$, {
      width: Xe
    }), Pe.length > 0 && /* @__PURE__ */ w.jsx("div", {
      role: "presentation",
      className: ee.filler
    }), Pe, ne !== 0 && /* @__PURE__ */ w.jsx(LS, {
      pinnedRight: p.right.length > 0
    })]
  }));
});
process.env.NODE_ENV !== "production" && (c$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  dimensions: s.shape({
    bottomContainerHeight: s.number.isRequired,
    columnsTotalWidth: s.number.isRequired,
    contentSize: s.shape({
      height: s.number.isRequired,
      width: s.number.isRequired
    }).isRequired,
    groupHeaderHeight: s.number.isRequired,
    hasScrollX: s.bool.isRequired,
    hasScrollY: s.bool.isRequired,
    headerFilterHeight: s.number.isRequired,
    headerHeight: s.number.isRequired,
    headersTotalHeight: s.number.isRequired,
    isReady: s.bool.isRequired,
    leftPinnedWidth: s.number.isRequired,
    minimumSize: s.shape({
      height: s.number.isRequired,
      width: s.number.isRequired
    }).isRequired,
    rightPinnedWidth: s.number.isRequired,
    root: s.shape({
      height: s.number.isRequired,
      width: s.number.isRequired
    }).isRequired,
    rowHeight: s.number.isRequired,
    rowWidth: s.number.isRequired,
    scrollbarSize: s.number.isRequired,
    topContainerHeight: s.number.isRequired,
    viewportInnerSize: s.shape({
      height: s.number.isRequired,
      width: s.number.isRequired
    }).isRequired,
    viewportOuterSize: s.shape({
      height: s.number.isRequired,
      width: s.number.isRequired
    }).isRequired
  }).isRequired,
  /**
   * Determines which cell has focus.
   * If `null`, no cell in this row has focus.
   */
  focusedColumnIndex: s.number,
  /**
   * Index of the row in the whole sorted and filtered dataset.
   * If some rows above have expanded children, this index also take those children into account.
   */
  index: s.number.isRequired,
  isFirstVisible: s.bool.isRequired,
  isLastVisible: s.bool.isRequired,
  isNotVisible: s.bool.isRequired,
  offsetLeft: s.number.isRequired,
  offsetTop: s.number,
  onClick: s.func,
  onDoubleClick: s.func,
  onMouseEnter: s.func,
  onMouseLeave: s.func,
  pinnedColumns: s.object.isRequired,
  renderContext: s.shape({
    firstColumnIndex: s.number.isRequired,
    firstRowIndex: s.number.isRequired,
    lastColumnIndex: s.number.isRequired,
    lastRowIndex: s.number.isRequired
  }).isRequired,
  row: s.object.isRequired,
  rowHeight: s.oneOfType([s.oneOf(["auto"]), s.number]).isRequired,
  rowId: s.oneOfType([s.number, s.string]).isRequired,
  selected: s.bool.isRequired,
  showBottomBorder: s.bool.isRequired,
  /**
   * Determines which cell should be tabbable by having tabIndex=0.
   * If `null`, no cell in this row is in the tab sequence.
   */
  tabbableCell: s.string,
  visibleColumns: s.arrayOf(s.object).isRequired
});
const Ope = Dl(c$), Ppe = () => {
  const e = Hi(), t = ft(), n = Be(e, Fr), r = Be(e, ES), o = Be(e, fh), i = Be(e, IN);
  return {
    role: "grid",
    "aria-colcount": n.length,
    "aria-rowcount": o + 1 + i + r,
    "aria-multiselectable": OS(t)
  };
}, Ipe = () => {
  const e = Hi(), t = Be(e, ga), n = Be(e, fh);
  return m.useCallback((r, o) => {
    const i = {}, a = o + n + 2;
    return i["aria-rowindex"] = a, e.current.isRowSelectable(r.id) && (i["aria-selected"] = t[r.id] !== void 0), i;
  }, [e, t, n]);
};
function Rpe({
  privateApiRef: e,
  configuration: t,
  props: n,
  children: r
}) {
  const o = m.useRef(e.current.getPublicApi());
  return /* @__PURE__ */ w.jsx(DS.Provider, {
    value: t,
    children: /* @__PURE__ */ w.jsx(mS.Provider, {
      value: n,
      children: /* @__PURE__ */ w.jsx(MS.Provider, {
        value: e,
        children: /* @__PURE__ */ w.jsx(gS.Provider, {
          value: o,
          children: r
        })
      })
    })
  });
}
const _pe = (e) => {
  const t = m.useRef(null), n = m.useRef(null), r = m.useRef(null), o = m.useRef(null), i = m.useRef(null), a = m.useRef(null);
  e.current.register("public", {
    rootElementRef: t
  }), e.current.register("private", {
    mainElementRef: n,
    virtualScrollerRef: r,
    virtualScrollbarVerticalRef: o,
    virtualScrollbarHorizontalRef: i,
    columnHeadersContainerRef: a
  });
}, kpe = (e) => {
  const t = mi();
  e.current.state.isRtl === void 0 && (e.current.state.isRtl = t);
  const n = m.useRef(!0);
  m.useEffect(() => {
    n.current ? n.current = !1 : e.current.setState((r) => U({}, r, {
      isRtl: t
    }));
  }, [e, t]);
}, Mpe = zae() && window.localStorage.getItem("DEBUG") != null, Ff = () => {
}, Ape = {
  debug: Ff,
  info: Ff,
  warn: Ff,
  error: Ff
}, MR = ["debug", "info", "warn", "error"];
function AR(e, t, n = console) {
  const r = MR.indexOf(t);
  if (r === -1)
    throw new Error(`MUI X: Log level ${t} not recognized.`);
  return MR.reduce((i, a, l) => (l >= r ? i[a] = (...c) => {
    const [d, ...f] = c;
    n[a](`MUI X: ${e} - ${d}`, ...f);
  } : i[a] = Ff, i), {});
}
const Dpe = (e, t) => {
  const n = m.useCallback((r) => Mpe ? AR(r, "debug", t.logger) : t.logLevel ? AR(r, t.logLevel.toString(), t.logger) : Ape, [t.logLevel, t.logger]);
  Ut(e, {
    getLogger: n
  }, "private");
};
class Npe {
  constructor() {
    this.maxListeners = 20, this.warnOnce = !1, this.events = {};
  }
  on(t, n, r = {}) {
    let o = this.events[t];
    if (o || (o = {
      highPriority: /* @__PURE__ */ new Map(),
      regular: /* @__PURE__ */ new Map()
    }, this.events[t] = o), r.isFirst ? o.highPriority.set(n, !0) : o.regular.set(n, !0), process.env.NODE_ENV !== "production") {
      const i = o.highPriority.size + o.regular.size;
      i > this.maxListeners && !this.warnOnce && (this.warnOnce = !0, console.warn([`Possible EventEmitter memory leak detected. ${i} ${t} listeners added.`].join(`
`)));
    }
  }
  removeListener(t, n) {
    this.events[t] && (this.events[t].regular.delete(n), this.events[t].highPriority.delete(n));
  }
  removeAllListeners() {
    this.events = {};
  }
  emit(t, ...n) {
    const r = this.events[t];
    if (!r)
      return;
    const o = Array.from(r.highPriority.keys()), i = Array.from(r.regular.keys());
    for (let a = o.length - 1; a >= 0; a -= 1) {
      const l = o[a];
      r.highPriority.has(l) && l.apply(this, n);
    }
    for (let a = 0; a < i.length; a += 1) {
      const l = i[a];
      r.regular.has(l) && l.apply(this, n);
    }
  }
  once(t, n) {
    const r = this;
    this.on(t, function o(...i) {
      r.removeListener(t, o), n.apply(r, i);
    });
  }
}
class jS {
  static create(t) {
    return new jS(t);
  }
  constructor(t) {
    this.value = void 0, this.listeners = void 0, this.subscribe = (n) => (this.listeners.add(n), () => {
      this.listeners.delete(n);
    }), this.getSnapshot = () => this.value, this.update = (n) => {
      this.value = n, this.listeners.forEach((r) => r(n));
    }, this.value = t, this.listeners = /* @__PURE__ */ new Set();
  }
}
const u$ = Symbol("mui.api_private"), Fpe = (e) => e.isPropagationStopped !== void 0;
let DR = 0;
function $pe(e) {
  var o;
  const t = (o = e.current) == null ? void 0 : o[u$];
  if (t)
    return t;
  const n = {}, r = {
    state: n,
    store: jS.create(n),
    instanceId: {
      id: DR
    }
  };
  return DR += 1, r.getPublicApi = () => e.current, r.register = (i, a) => {
    Object.keys(a).forEach((l) => {
      const c = a[l], d = r[l];
      if ((d == null ? void 0 : d.spying) === !0 ? d.target = c : r[l] = c, i === "public") {
        const f = e.current, p = f[l];
        (p == null ? void 0 : p.spying) === !0 ? p.target = c : f[l] = c;
      }
    });
  }, r.register("private", {
    caches: {},
    eventManager: new Npe()
  }), r;
}
function Lpe(e) {
  return {
    get state() {
      return e.current.state;
    },
    get store() {
      return e.current.store;
    },
    get instanceId() {
      return e.current.instanceId;
    },
    [u$]: e.current
  };
}
function jpe(e, t) {
  var a;
  const n = m.useRef(null), r = m.useRef(null);
  r.current || (r.current = $pe(n)), n.current || (n.current = Lpe(r));
  const o = m.useCallback((...l) => {
    const [c, d, f = {}] = l;
    if (f.defaultMuiPrevented = !1, Fpe(f) && f.isPropagationStopped())
      return;
    const p = t.signature === di.DataGridPro || t.signature === di.DataGridPremium ? {
      api: r.current.getPublicApi()
    } : {};
    r.current.eventManager.emit(c, d, f, p);
  }, [r, t.signature]), i = m.useCallback((l, c, d) => {
    r.current.eventManager.on(l, c, d);
    const f = r.current;
    return () => {
      f.eventManager.removeListener(l, c);
    };
  }, [r]);
  return Ut(r, {
    subscribeEvent: i,
    publishEvent: o
  }, "public"), e && !((a = e.current) != null && a.state) && (e.current = n.current), m.useImperativeHandle(e, () => n.current, [n]), m.useEffect(() => {
    const l = r.current;
    return () => {
      l.publishEvent("unmount");
    };
  }, [r]), r;
}
const Bpe = (e, t) => {
  const n = m.useCallback((r) => {
    if (t.localeText[r] == null)
      throw new Error(`Missing translation for key ${r}.`);
    return t.localeText[r];
  }, [t.localeText]);
  e.current.register("public", {
    getLocaleText: n
  });
};
function Sp(e) {
  "@babel/helpers - typeof";
  return Sp = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Sp(e);
}
function Vpe(e, t) {
  if (Sp(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Sp(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Ep(e) {
  var t = Vpe(e, "string");
  return Sp(t) == "symbol" ? t : t + "";
}
const Hpe = (e) => {
  const t = m.useRef({}), n = m.useRef(!1), r = m.useCallback((f) => {
    n.current || !f || (n.current = !0, Object.values(f.appliers).forEach((p) => {
      p();
    }), n.current = !1);
  }, []), o = m.useCallback((f, p, g) => {
    t.current[f] || (t.current[f] = {
      processors: /* @__PURE__ */ new Map(),
      processorsAsArray: [],
      appliers: {}
    });
    const b = t.current[f];
    return b.processors.get(p) !== g && (b.processors.set(p, g), b.processorsAsArray = Array.from(t.current[f].processors.values()), r(b)), () => {
      t.current[f].processors.delete(p), t.current[f].processorsAsArray = Array.from(t.current[f].processors.values());
    };
  }, [r]), i = m.useCallback((f, p, g) => (t.current[f] || (t.current[f] = {
    processors: /* @__PURE__ */ new Map(),
    processorsAsArray: [],
    appliers: {}
  }), t.current[f].appliers[p] = g, () => {
    const b = t.current[f].appliers, v = yt(b, [p].map(Ep));
    t.current[f].appliers = v;
  }), []), a = m.useCallback((f) => {
    r(t.current[f]);
  }, [r]), l = m.useCallback((...f) => {
    const [p, g, b] = f;
    if (!t.current[p])
      return g;
    const v = t.current[p].processorsAsArray;
    let y = g;
    for (let S = 0; S < v.length; S += 1)
      y = v[S](y, b);
    return y;
  }, []), c = {
    registerPipeProcessor: o,
    registerPipeApplier: i,
    requestPipeProcessorsApplication: a
  }, d = {
    unstable_applyPipeProcessors: l
  };
  Ut(e, c, "private"), Ut(e, d, "public");
}, Zn = (e, t, n) => {
  const r = m.useRef(null), o = m.useRef(`mui-${Math.round(Math.random() * 1e9)}`), i = m.useCallback(() => {
    r.current = e.current.registerPipeProcessor(t, o.current, n);
  }, [e, n, t]);
  dh(() => {
    i();
  });
  const a = m.useRef(!0);
  m.useEffect(() => (a.current ? a.current = !1 : i(), () => {
    r.current && (r.current(), r.current = null);
  }), [i]);
}, BS = (e, t, n) => {
  const r = m.useRef(null), o = m.useRef(`mui-${Math.round(Math.random() * 1e9)}`), i = m.useCallback(() => {
    r.current = e.current.registerPipeApplier(t, o.current, n);
  }, [e, n, t]);
  dh(() => {
    i();
  });
  const a = m.useRef(!0);
  m.useEffect(() => (a.current ? a.current = !1 : i(), () => {
    r.current && (r.current(), r.current = null);
  }), [i]);
}, Lm = (e, t, n, r) => {
  const o = m.useCallback(() => {
    e.current.registerStrategyProcessor(t, n, r);
  }, [e, r, n, t]);
  dh(() => {
    o();
  });
  const i = m.useRef(!0);
  m.useEffect(() => {
    i.current ? i.current = !1 : o();
  }, [o]);
}, Tc = "none", NR = {
  rowTreeCreation: "rowTree",
  filtering: "rowTree",
  sorting: "rowTree",
  visibleRowsLookupCreation: "rowTree"
}, Upe = (e) => {
  const t = m.useRef(/* @__PURE__ */ new Map()), n = m.useRef({}), r = m.useCallback((c, d, f) => {
    const p = () => {
      const v = n.current[d], y = yt(v, [c].map(Ep));
      n.current[d] = y;
    };
    n.current[d] || (n.current[d] = {});
    const g = n.current[d], b = g[c];
    return g[c] = f, !b || b === f || c === e.current.getActiveStrategy(NR[d]) && e.current.publishEvent("activeStrategyProcessorChange", d), p;
  }, [e]), o = m.useCallback((c, d) => {
    const f = e.current.getActiveStrategy(NR[c]);
    if (f == null)
      throw new Error("Can't apply a strategy processor before defining an active strategy");
    const p = n.current[c];
    if (!p || !p[f])
      throw new Error(`No processor found for processor "${c}" on strategy "${f}"`);
    const g = p[f];
    return g(d);
  }, [e]), i = m.useCallback((c) => {
    const f = Array.from(t.current.entries()).find(([, p]) => p.group !== c ? !1 : p.isAvailable());
    return (f == null ? void 0 : f[0]) ?? Tc;
  }, []), a = m.useCallback((c, d, f) => {
    t.current.set(d, {
      group: c,
      isAvailable: f
    }), e.current.publishEvent("strategyAvailabilityChange");
  }, [e]);
  Ut(e, {
    registerStrategyProcessor: r,
    applyStrategyProcessor: o,
    getActiveStrategy: i,
    setStrategyAvailability: a
  }, "private");
}, zpe = (e) => {
  const t = m.useRef({}), [, n] = m.useState(), r = m.useCallback((d) => {
    t.current[d.stateId] = d;
  }, []), o = m.useCallback((d, f) => {
    let p;
    if (CN(d) ? p = d(e.current.state) : p = d, e.current.state === p)
      return !1;
    let g = !1;
    const b = [];
    if (Object.keys(t.current).forEach((v) => {
      const y = t.current[v], S = y.stateSelector(e.current.state, e.current.instanceId), E = y.stateSelector(p, e.current.instanceId);
      E !== S && (b.push({
        stateId: y.stateId,
        hasPropChanged: E !== y.propModel
      }), y.propModel !== void 0 && E !== y.propModel && (g = !0));
    }), b.length > 1)
      throw new Error(`You're not allowed to update several sub-state in one transaction. You already updated ${b[0].stateId}, therefore, you're not allowed to update ${b.map((v) => v.stateId).join(", ")} in the same transaction.`);
    if (g || (e.current.state = p, e.current.publishEvent("stateChange", p), e.current.store.update(p)), b.length === 1) {
      const {
        stateId: v,
        hasPropChanged: y
      } = b[0], S = t.current[v], E = S.stateSelector(p, e.current.instanceId);
      S.propOnChange && y && S.propOnChange(E, {
        reason: f,
        api: e.current
      }), g || e.current.publishEvent(S.changeEvent, E, {
        reason: f
      });
    }
    return !g;
  }, [e]), i = m.useCallback((d, f, p) => e.current.setState((g) => U({}, g, {
    [d]: f(g[d])
  }), p), [e]), a = m.useCallback(() => n(() => e.current.state), [e]), l = {
    setState: o,
    forceUpdate: a
  }, c = {
    updateControlState: i,
    registerControlState: r
  };
  Ut(e, l, "public"), Ut(e, c, "private");
}, Gpe = (e, t) => {
  const n = jpe(e, t);
  return _pe(n), kpe(n), Dpe(n, t), zpe(n), Hpe(n), Upe(n), Bpe(n, t), n.current.register("private", {
    rootProps: t
  }), n;
}, Kr = (e, t, n) => {
  const r = m.useRef(!1);
  r.current || (t.current.state = e(t.current.state, n, t), r.current = !0);
};
function iC(e, t) {
  if (e == null)
    return "";
  const n = typeof e == "string" ? e : `${e}`;
  if (t.shouldAppendQuotes || t.escapeFormulas) {
    const r = n.replace(/"/g, '""');
    return t.escapeFormulas && ["=", "+", "-", "@", "	", "\r"].includes(r[0]) ? `"'${r}"` : [t.delimiter, `
`, "\r", '"'].some((o) => n.includes(o)) ? `"${r}"` : r;
  }
  return n;
}
const d$ = (e, t) => {
  var i, a;
  const {
    csvOptions: n,
    ignoreValueFormatter: r
  } = t;
  let o;
  if (r) {
    const l = e.colDef.type;
    l === "number" ? o = String(e.value) : l === "date" || l === "dateTime" ? o = (i = e.value) == null ? void 0 : i.toISOString() : typeof ((a = e.value) == null ? void 0 : a.toString) == "function" ? o = e.value.toString() : o = e.value;
  } else
    o = e.formattedValue;
  return iC(o, n);
};
class sC {
  constructor(t) {
    this.options = void 0, this.rowString = "", this.isEmpty = !0, this.options = t;
  }
  addValue(t) {
    this.isEmpty || (this.rowString += this.options.csvOptions.delimiter), typeof this.options.sanitizeCellValue == "function" ? this.rowString += this.options.sanitizeCellValue(t, this.options.csvOptions) : this.rowString += t, this.isEmpty = !1;
  }
  getRowString() {
    return this.rowString;
  }
}
const Wpe = ({
  id: e,
  columns: t,
  getCellParams: n,
  csvOptions: r,
  ignoreValueFormatter: o
}) => {
  const i = new sC({
    csvOptions: r
  });
  return t.forEach((a) => {
    const l = n(e, a.field);
    process.env.NODE_ENV !== "production" && String(l.formattedValue) === "[object Object]" && ns(["MUI X: When the value of a field is an object or a `renderCell` is provided, the CSV export might not display the value correctly.", "You can provide a `valueFormatter` with a string representation to be used."]), i.addValue(d$(l, {
      ignoreValueFormatter: o,
      csvOptions: r
    }));
  }), i.getRowString();
};
function qpe(e) {
  const {
    columns: t,
    rowIds: n,
    csvOptions: r,
    ignoreValueFormatter: o,
    apiRef: i
  } = e, a = n.reduce((p, g) => `${p}${Wpe({
    id: g,
    columns: t,
    getCellParams: i.current.getCellParams,
    ignoreValueFormatter: o,
    csvOptions: r
  })}\r
`, "").trim();
  if (!r.includeHeaders)
    return a;
  const l = t.filter((p) => p.field !== $d.field), c = [];
  if (r.includeColumnGroupsHeaders) {
    const p = i.current.getAllGroupDetails();
    let g = 0;
    const b = l.reduce((v, y) => {
      const S = i.current.getColumnGroupPath(y.field);
      return v[y.field] = S, g = Math.max(g, S.length), v;
    }, {});
    for (let v = 0; v < g; v += 1) {
      const y = new sC({
        csvOptions: r,
        sanitizeCellValue: iC
      });
      c.push(y), l.forEach((S) => {
        const E = (b[S.field] || [])[v], I = p[E];
        y.addValue(I ? I.headerName || I.groupId : "");
      });
    }
  }
  const d = new sC({
    csvOptions: r,
    sanitizeCellValue: iC
  });
  return l.forEach((p) => {
    d.addValue(p.headerName || p.field);
  }), c.push(d), `${`${c.map((p) => p.getRowString()).join(`\r
`)}\r
`}${a}`.trim();
}
function FR(e) {
  const t = document.createElement("span");
  t.style.whiteSpace = "pre", t.style.userSelect = "all", t.style.opacity = "0px", t.textContent = e, document.body.appendChild(t);
  const n = document.createRange();
  n.selectNode(t);
  const r = window.getSelection();
  r.removeAllRanges(), r.addRange(n);
  try {
    document.execCommand("copy");
  } finally {
    document.body.removeChild(t);
  }
}
function Kpe(e) {
  navigator.clipboard ? navigator.clipboard.writeText(e).catch(() => {
    FR(e);
  }) : FR(e);
}
function Ype(e) {
  var t;
  return !!((t = window.getSelection()) != null && t.toString() || e && (e.selectionEnd || 0) - (e.selectionStart || 0) > 0);
}
const Qpe = (e, t) => {
  const n = t.ignoreValueFormatterDuringExport, r = (typeof n == "object" ? n == null ? void 0 : n.clipboardExport : n) || !1, o = t.clipboardCopyCellDelimiter, i = m.useCallback((a) => {
    if (!bfe(a) || Ype(a.target))
      return;
    let l = "";
    if (e.current.getSelectedRows().size > 0)
      l = e.current.getDataAsCsv({
        includeHeaders: !1,
        delimiter: o,
        shouldAppendQuotes: !1,
        escapeFormulas: !1
      });
    else {
      const d = jo(e);
      if (d) {
        const f = e.current.getCellParams(d.id, d.field);
        l = d$(f, {
          csvOptions: {
            delimiter: o,
            shouldAppendQuotes: !1,
            escapeFormulas: !1
          },
          ignoreValueFormatter: r
        });
      }
    }
    l = e.current.unstable_applyPipeProcessors("clipboardCopy", l), l && (Kpe(l), e.current.publishEvent("clipboardCopy", l));
  }, [e, r, o]);
  GN(e, e.current.rootElementRef, "keydown", i), Nn(e, "clipboardCopy", t.onClipboardCopy);
}, Xpe = (e) => U({}, e, {
  columnMenu: {
    open: !1
  }
}), Jpe = (e) => {
  const t = zr(e, "useGridColumnMenu"), n = m.useCallback((a) => {
    const l = Yg(e.current.state), c = {
      open: !0,
      field: a
    };
    (c.open !== l.open || c.field !== l.field) && (e.current.setState((f) => f.columnMenu.open && f.columnMenu.field === a ? f : (t.debug("Opening Column Menu"), U({}, f, {
      columnMenu: {
        open: !0,
        field: a
      }
    }))), e.current.hidePreferences(), e.current.forceUpdate());
  }, [e, t]), r = m.useCallback(() => {
    const a = Yg(e.current.state);
    if (a.field) {
      const d = Oa(e), f = Ai(e), p = ha(e);
      let g = a.field;
      if (d[g] || (g = p[0]), f[g] === !1) {
        const b = p.filter((y) => y === g ? !0 : f[y] !== !1), v = b.indexOf(g);
        g = b[v + 1] || b[v - 1];
      }
      e.current.setColumnHeaderFocus(g);
    }
    const l = {
      open: !1,
      field: void 0
    };
    (l.open !== a.open || l.field !== a.field) && (e.current.setState((d) => (t.debug("Hiding Column Menu"), U({}, d, {
      columnMenu: l
    }))), e.current.forceUpdate());
  }, [e, t]), o = m.useCallback((a) => {
    t.debug("Toggle Column Menu");
    const l = Yg(e.current.state);
    !l.open || l.field !== a ? n(a) : r();
  }, [e, t, n, r]);
  Ut(e, {
    showColumnMenu: n,
    hideColumnMenu: r,
    toggleColumnMenu: o
  }, "public"), it(e, "columnResizeStart", r), it(e, "virtualScrollerWheel", e.current.hideColumnMenu), it(e, "virtualScrollerTouchMove", e.current.hideColumnMenu);
}, Zpe = (e, t, n) => {
  var o, i, a;
  const r = Pu({
    apiRef: n,
    columnsToUpsert: t.columns,
    initialState: (o = t.initialState) == null ? void 0 : o.columns,
    columnVisibilityModel: t.columnVisibilityModel ?? ((a = (i = t.initialState) == null ? void 0 : i.columns) == null ? void 0 : a.columnVisibilityModel) ?? {},
    keepOnlyColumnsToUpsert: !0
  });
  return U({}, e, {
    columns: r,
    // In pro/premium, this part of the state is defined. We give it an empty but defined value
    // for the community version.
    pinnedColumns: e.pinnedColumns ?? J0
  });
};
function ehe(e, t) {
  var C, D;
  const n = zr(e, "useGridColumns"), r = m.useRef(t.columns);
  e.current.registerControlState({
    stateId: "visibleColumns",
    propModel: t.columnVisibilityModel,
    propOnChange: t.onColumnVisibilityModelChange,
    stateSelector: Ai,
    changeEvent: "columnVisibilityModelChange"
  });
  const o = m.useCallback((L) => {
    var B, H;
    n.debug("Updating columns state."), e.current.setState($R(L)), e.current.publishEvent("columnsChange", L.orderedFields), (H = (B = e.current).updateRenderContext) == null || H.call(B), e.current.forceUpdate();
  }, [n, e]), i = m.useCallback((L) => Oa(e)[L], [e]), a = m.useCallback(() => rs(e), [e]), l = m.useCallback(() => Fr(e), [e]), c = m.useCallback((L, B = !0) => (B ? Fr(e) : rs(e)).findIndex((k) => k.field === L), [e]), d = m.useCallback((L) => {
    const B = c(L);
    return Nl(e)[B];
  }, [e, c]), f = m.useCallback((L) => {
    var H, k;
    Ai(e) !== L && (e.current.setState((N) => U({}, N, {
      columns: Pu({
        apiRef: e,
        columnsToUpsert: [],
        initialState: void 0,
        columnVisibilityModel: L,
        keepOnlyColumnsToUpsert: !1
      })
    })), (k = (H = e.current).updateRenderContext) == null || k.call(H), e.current.forceUpdate());
  }, [e]), p = m.useCallback((L) => {
    const B = Pu({
      apiRef: e,
      columnsToUpsert: L,
      initialState: void 0,
      keepOnlyColumnsToUpsert: !1
    });
    o(B);
  }, [e, o]), g = m.useCallback((L, B) => {
    const H = Ai(e), k = H[L] ?? !0;
    if (B !== k) {
      const N = U({}, H, {
        [L]: B
      });
      e.current.setColumnVisibilityModel(N);
    }
  }, [e]), b = m.useCallback((L) => ha(e).findIndex((H) => H === L), [e]), v = m.useCallback((L, B) => {
    const H = ha(e), k = b(L);
    if (k === B)
      return;
    n.debug(`Moving column ${L} to index ${B}`);
    const N = [...H], j = N.splice(k, 1)[0];
    N.splice(B, 0, j), o(U({}, Ls(e.current.state), {
      orderedFields: N
    }));
    const W = {
      column: e.current.getColumn(L),
      targetIndex: e.current.getColumnIndexRelativeToVisibleColumns(L),
      oldIndex: k
    };
    e.current.publishEvent("columnIndexChange", W);
  }, [e, n, o, b]), y = m.useCallback((L, B) => {
    n.debug(`Updating column ${L} width to ${B}`);
    const H = Ls(e.current.state), k = H.lookup[L], N = U({}, k, {
      width: B,
      hasBeenResized: !0
    });
    o(tC(U({}, H, {
      lookup: U({}, H.lookup, {
        [L]: N
      })
    }), e.current.getRootDimensions())), e.current.publishEvent("columnWidthChange", {
      element: e.current.getColumnHeaderElement(L),
      colDef: N,
      width: B
    });
  }, [e, n, o]), S = {
    getColumn: i,
    getAllColumns: a,
    getColumnIndex: c,
    getColumnPosition: d,
    getVisibleColumns: l,
    getColumnIndexRelativeToVisibleColumns: b,
    updateColumns: p,
    setColumnVisibilityModel: f,
    setColumnVisibility: g,
    setColumnWidth: y
  }, E = {
    setColumnIndex: v
  };
  Ut(e, S, "public"), Ut(e, E, t.signature === di.DataGrid ? "private" : "public");
  const I = m.useCallback((L, B) => {
    var V, $;
    const H = {}, k = Ai(e);
    // Always export if the `exportOnlyDirtyModels` property is not activated
    (!B.exportOnlyDirtyModels || // Always export if the model is controlled
    t.columnVisibilityModel != null || // Always export if the model has been initialized
    // TODO v6 Do a nullish check instead to export even if the initial model equals "{}"
    Object.keys((($ = (V = t.initialState) == null ? void 0 : V.columns) == null ? void 0 : $.columnVisibilityModel) ?? {}).length > 0 || // Always export if the model is not empty
    Object.keys(k).length > 0) && (H.columnVisibilityModel = k), H.orderedFields = ha(e);
    const j = rs(e), W = {};
    return j.forEach((z) => {
      if (z.hasBeenResized) {
        const ne = {};
        sF.forEach((K) => {
          let Q = z[K];
          Q === 1 / 0 && (Q = -1), ne[K] = Q;
        }), W[z.field] = ne;
      }
    }), Object.keys(W).length > 0 && (H.dimensions = W), U({}, L, {
      columns: H
    });
  }, [e, t.columnVisibilityModel, (C = t.initialState) == null ? void 0 : C.columns]), O = m.useCallback((L, B) => {
    var j;
    const H = (j = B.stateToRestore.columns) == null ? void 0 : j.columnVisibilityModel, k = B.stateToRestore.columns;
    if (H == null && k == null)
      return L;
    const N = Pu({
      apiRef: e,
      columnsToUpsert: [],
      initialState: k,
      columnVisibilityModel: H,
      keepOnlyColumnsToUpsert: !1
    });
    return e.current.setState($R(N)), k != null && e.current.publishEvent("columnsChange", N.orderedFields), L;
  }, [e]), T = m.useCallback((L, B) => {
    var H;
    if (B === Ec.columns) {
      const k = t.slots.columnsPanel;
      return /* @__PURE__ */ w.jsx(k, U({}, (H = t.slotProps) == null ? void 0 : H.columnsPanel));
    }
    return L;
  }, [t.slots.columnsPanel, (D = t.slotProps) == null ? void 0 : D.columnsPanel]), P = m.useCallback((L) => t.disableColumnSelector ? L : [...L, "columnMenuColumnsItem"], [t.disableColumnSelector]);
  Zn(e, "columnMenu", P), Zn(e, "exportState", I), Zn(e, "restoreState", O), Zn(e, "preferencePanel", T);
  const R = m.useRef(null);
  it(e, "viewportInnerSizeChange", (L) => {
    R.current !== L.width && (R.current = L.width, o(tC(Ls(e.current.state), e.current.getRootDimensions())));
  });
  const A = m.useCallback(() => {
    n.info("Columns pipe processing have changed, regenerating the columns");
    const L = Pu({
      apiRef: e,
      columnsToUpsert: [],
      initialState: void 0,
      keepOnlyColumnsToUpsert: !1
    });
    o(L);
  }, [e, n, o]);
  BS(e, "hydrateColumns", A);
  const _ = m.useRef(!0);
  m.useEffect(() => {
    if (_.current) {
      _.current = !1;
      return;
    }
    if (n.info(`GridColumns have changed, new length ${t.columns.length}`), r.current === t.columns)
      return;
    const L = Pu({
      apiRef: e,
      initialState: void 0,
      // If the user provides a model, we don't want to set it in the state here because it has it's dedicated `useEffect` which calls `setColumnVisibilityModel`
      columnsToUpsert: t.columns,
      keepOnlyColumnsToUpsert: !0
    });
    r.current = t.columns, o(L);
  }, [n, e, o, t.columns]), m.useEffect(() => {
    t.columnVisibilityModel !== void 0 && e.current.setColumnVisibilityModel(t.columnVisibilityModel);
  }, [e, n, t.columnVisibilityModel]);
}
function $R(e) {
  return (t) => U({}, t, {
    columns: e
  });
}
const the = (e, t) => {
  var n;
  return U({}, e, {
    density: ((n = t.initialState) == null ? void 0 : n.density) ?? t.density ?? "standard"
  });
}, nhe = (e, t) => {
  var l;
  const n = zr(e, "useDensity");
  e.current.registerControlState({
    stateId: "density",
    propModel: t.density,
    propOnChange: t.onDensityChange,
    stateSelector: Mu,
    changeEvent: "densityChange"
  });
  const o = {
    setDensity: Yn((c) => {
      Mu(e.current.state) !== c && (n.debug(`Set grid density to ${c}`), e.current.setState((f) => U({}, f, {
        density: c
      })));
    })
  };
  Ut(e, o, "public");
  const i = m.useCallback((c, d) => {
    var g;
    const f = Mu(e.current.state);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !d.exportOnlyDirtyModels || // Always export if the `density` is controlled
      t.density != null || // Always export if the `density` has been initialized
      ((g = t.initialState) == null ? void 0 : g.density) != null ? U({}, c, {
        density: f
      }) : c
    );
  }, [e, t.density, (l = t.initialState) == null ? void 0 : l.density]), a = m.useCallback((c, d) => {
    var p;
    const f = (p = d.stateToRestore) != null && p.density ? d.stateToRestore.density : Mu(e.current.state);
    return e.current.setState((g) => U({}, g, {
      density: f
    })), c;
  }, [e]);
  Zn(e, "exportState", i), Zn(e, "restoreState", a), m.useEffect(() => {
    t.density && e.current.setDensity(t.density);
  }, [e, t.density]);
};
function rhe(e, t = "csv", n = document.title || "untitled") {
  const r = `${n}.${t}`;
  if ("download" in HTMLAnchorElement.prototype) {
    const o = URL.createObjectURL(e), i = document.createElement("a");
    i.href = o, i.download = r, i.click(), setTimeout(() => {
      URL.revokeObjectURL(o);
    });
    return;
  }
  throw new Error("MUI X: exportAs not supported.");
}
const f$ = ({
  apiRef: e,
  options: t
}) => {
  const n = rs(e);
  return t.fields ? t.fields.reduce((o, i) => {
    const a = n.find((l) => l.field === i);
    return a && o.push(a), o;
  }, []) : (t.allColumns ? n : Fr(e)).filter((o) => !o.disableExport);
}, p$ = ({
  apiRef: e
}) => {
  var c, d;
  const t = BN(e), n = so(e), r = e.current.getSelectedRows(), o = t.filter((f) => n[f].type !== "footer"), i = Nc(e), a = ((c = i == null ? void 0 : i.top) == null ? void 0 : c.map((f) => f.id)) || [], l = ((d = i == null ? void 0 : i.bottom) == null ? void 0 : d.map((f) => f.id)) || [];
  return o.unshift(...a), o.push(...l), r.size > 0 ? o.filter((f) => r.has(f)) : o;
}, ohe = (e, t) => {
  const n = zr(e, "useGridCsvExport"), r = t.ignoreValueFormatterDuringExport, o = (typeof r == "object" ? r == null ? void 0 : r.csvExport : r) || !1, i = m.useCallback((d = {}) => {
    n.debug("Get data as CSV");
    const f = f$({
      apiRef: e,
      options: d
    }), g = (d.getRowsToExport ?? p$)({
      apiRef: e
    });
    return qpe({
      columns: f,
      rowIds: g,
      csvOptions: {
        delimiter: d.delimiter || ",",
        shouldAppendQuotes: d.shouldAppendQuotes ?? !0,
        includeHeaders: d.includeHeaders ?? !0,
        includeColumnGroupsHeaders: d.includeColumnGroupsHeaders ?? !0,
        escapeFormulas: d.escapeFormulas ?? !0
      },
      ignoreValueFormatter: o,
      apiRef: e
    });
  }, [n, e, o]), a = m.useCallback((d) => {
    n.debug("Export data as CSV");
    const f = i(d), p = new Blob([d != null && d.utf8WithBom ? new Uint8Array([239, 187, 191]) : "", f], {
      type: "text/csv"
    });
    rhe(p, "csv", d == null ? void 0 : d.fileName);
  }, [n, i]);
  Ut(e, {
    getDataAsCsv: i,
    exportDataAsCsv: a
  }, "public");
  const c = m.useCallback((d, f) => {
    var p;
    return (p = f.csvOptions) != null && p.disableToolbarButton ? d : [...d, {
      component: /* @__PURE__ */ w.jsx(e$, {
        options: f.csvOptions
      }),
      componentName: "csvExport"
    }];
  }, []);
  Zn(e, "exportMenu", c);
}, Qg = (e, t, n) => {
  let r = e.paginationModel;
  const o = e.rowCount, i = (n == null ? void 0 : n.pageSize) ?? r.pageSize, a = (n == null ? void 0 : n.page) ?? r.page, l = WN(o, i, a);
  n && ((n == null ? void 0 : n.page) !== r.page || (n == null ? void 0 : n.pageSize) !== r.pageSize) && (r = n);
  const c = Zle(r.page, l);
  return c !== r.page && (r = U({}, r, {
    page: c
  })), KN(r.pageSize, t), r;
}, ihe = (e, t) => {
  var v, y;
  const n = zr(e, "useGridPaginationModel"), r = Be(e, ch), o = Math.floor(t.rowHeight * r);
  e.current.registerControlState({
    stateId: "paginationModel",
    propModel: t.paginationModel,
    propOnChange: t.onPaginationModelChange,
    stateSelector: To,
    changeEvent: "paginationModelChange"
  });
  const i = m.useCallback((S) => {
    const E = To(e);
    S !== E.page && (n.debug(`Setting page to ${S}`), e.current.setPaginationModel({
      page: S,
      pageSize: E.pageSize
    }));
  }, [e, n]), a = m.useCallback((S) => {
    const E = To(e);
    S !== E.pageSize && (n.debug(`Setting page size to ${S}`), e.current.setPaginationModel({
      pageSize: S,
      page: E.page
    }));
  }, [e, n]), l = m.useCallback((S) => {
    const E = To(e);
    S !== E && (n.debug("Setting 'paginationModel' to", S), e.current.setState((I) => U({}, I, {
      pagination: U({}, I.pagination, {
        paginationModel: Qg(I.pagination, t.signature, S)
      })
    }), "setPaginationModel"));
  }, [e, n, t.signature]);
  Ut(e, {
    setPage: i,
    setPageSize: a,
    setPaginationModel: l
  }, "public");
  const d = m.useCallback((S, E) => {
    var T, P;
    const I = To(e);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !E.exportOnlyDirtyModels || // Always export if the `paginationModel` is controlled
      t.paginationModel != null || // Always export if the `paginationModel` has been initialized
      ((P = (T = t.initialState) == null ? void 0 : T.pagination) == null ? void 0 : P.paginationModel) != null || // Export if `page` or `pageSize` is not equal to the default value
      I.page !== 0 && I.pageSize !== Jle(t.autoPageSize) ? U({}, S, {
        pagination: U({}, S.pagination, {
          paginationModel: I
        })
      }) : S
    );
  }, [e, t.paginationModel, (y = (v = t.initialState) == null ? void 0 : v.pagination) == null ? void 0 : y.paginationModel, t.autoPageSize]), f = m.useCallback((S, E) => {
    var O, T;
    const I = (O = E.stateToRestore.pagination) != null && O.paginationModel ? U({}, qN(t.autoPageSize), (T = E.stateToRestore.pagination) == null ? void 0 : T.paginationModel) : To(e);
    return e.current.setState((P) => U({}, P, {
      pagination: U({}, P.pagination, {
        paginationModel: Qg(P.pagination, t.signature, I)
      })
    }), "stateRestorePreProcessing"), S;
  }, [e, t.autoPageSize, t.signature]);
  Zn(e, "exportState", d), Zn(e, "restoreState", f);
  const p = () => {
    var E;
    const S = To(e);
    (E = e.current.virtualScrollerRef) != null && E.current && e.current.scrollToIndexes({
      rowIndex: S.page * S.pageSize
    });
  }, g = m.useCallback(() => {
    if (!t.autoPageSize)
      return;
    const S = e.current.getRootDimensions(), E = Math.floor(S.viewportInnerSize.height / o);
    e.current.setPageSize(E);
  }, [e, t.autoPageSize, o]), b = m.useCallback((S) => {
    if (S == null)
      return;
    const E = To(e), I = YN(e);
    E.page > I - 1 && e.current.setPage(Math.max(0, I - 1));
  }, [e]);
  it(e, "viewportInnerSizeChange", g), it(e, "paginationModelChange", p), it(e, "rowCountChange", b), m.useEffect(() => {
    e.current.setState((S) => U({}, S, {
      pagination: U({}, S.pagination, {
        paginationModel: Qg(S.pagination, t.signature, t.paginationModel)
      })
    }));
  }, [e, t.paginationModel, t.paginationMode, t.signature]), m.useEffect(g, [g]);
};
function she() {
  return new Promise((e) => {
    requestAnimationFrame(() => {
      e();
    });
  });
}
function ahe(e) {
  const t = document.createElement("iframe");
  return t.style.position = "absolute", t.style.width = "0px", t.style.height = "0px", t.title = e || document.title, t;
}
const lhe = (e, t) => {
  const n = e.current.rootElementRef.current !== null, r = zr(e, "useGridPrintExport"), o = m.useRef(null), i = m.useRef(null), a = m.useRef({}), l = m.useRef([]), c = m.useRef(null);
  m.useEffect(() => {
    o.current = fl(e.current.rootElementRef.current);
  }, [e, n]);
  const d = m.useCallback((S, E, I) => new Promise((O) => {
    const T = f$({
      apiRef: e,
      options: {
        fields: S,
        allColumns: E
      }
    }).map((F) => F.field), P = rs(e), R = {};
    P.forEach((F) => {
      R[F.field] = T.includes(F.field);
    }), I && (R[$d.field] = !0), e.current.setColumnVisibilityModel(R), O();
  }), [e]), f = m.useCallback((S) => {
    const I = S({
      apiRef: e
    }).reduce((O, T) => {
      const P = e.current.getRow(T);
      return P[Hu] || O.push(P), O;
    }, []);
    e.current.setRows(I);
  }, [e]), p = m.useCallback((S, E) => {
    var H, k, N, j;
    const I = U({
      copyStyles: !0,
      hideToolbar: !1,
      hideFooter: !1,
      includeCheckboxes: !1
    }, E), O = S.contentDocument;
    if (!O)
      return;
    const T = Ld(e.current.state), P = e.current.rootElementRef.current, R = P.cloneNode(!0), F = R.querySelector(`.${ee.main}`);
    F.style.overflow = "visible", R.style.contain = "size";
    let A = ((H = P.querySelector(`.${ee.toolbarContainer}`)) == null ? void 0 : H.offsetHeight) || 0, _ = ((k = P.querySelector(`.${ee.footerContainer}`)) == null ? void 0 : k.offsetHeight) || 0;
    I.hideToolbar && ((N = R.querySelector(`.${ee.toolbarContainer}`)) == null || N.remove(), A = 0), I.hideFooter && ((j = R.querySelector(`.${ee.footerContainer}`)) == null || j.remove(), _ = 0);
    const C = T.currentPageTotalHeight + _S(e, t) + A + _;
    if (R.style.height = `${C}px`, R.style.boxSizing = "content-box", !I.hideFooter) {
      const W = R.querySelector(`.${ee.footerContainer}`);
      W.style.position = "absolute", W.style.width = "100%", W.style.top = `${C - _}px`;
    }
    const D = document.createElement("div");
    D.appendChild(R), O.body.style.marginTop = "0px", O.body.innerHTML = D.innerHTML;
    const L = typeof I.pageStyle == "function" ? I.pageStyle() : I.pageStyle;
    if (typeof L == "string") {
      const W = O.createElement("style");
      W.appendChild(O.createTextNode(L)), O.head.appendChild(W);
    }
    I.bodyClassName && O.body.classList.add(...I.bodyClassName.split(" "));
    const B = [];
    if (I.copyStyles) {
      const W = P.getRootNode(), $ = (W.constructor.name === "ShadowRoot" ? W : o.current).querySelectorAll("style, link[rel='stylesheet']");
      for (let z = 0; z < $.length; z += 1) {
        const ne = $[z];
        if (ne.tagName === "STYLE") {
          const K = O.createElement(ne.tagName), Q = ne.sheet;
          if (Q) {
            let re = "";
            for (let te = 0; te < Q.cssRules.length; te += 1)
              typeof Q.cssRules[te].cssText == "string" && (re += `${Q.cssRules[te].cssText}\r
`);
            K.appendChild(O.createTextNode(re)), O.head.appendChild(K);
          }
        } else if (ne.getAttribute("href")) {
          const K = O.createElement(ne.tagName);
          for (let Q = 0; Q < ne.attributes.length; Q += 1) {
            const re = ne.attributes[Q];
            re && K.setAttribute(re.nodeName, re.nodeValue || "");
          }
          B.push(new Promise((Q) => {
            K.addEventListener("load", () => Q());
          })), O.head.appendChild(K);
        }
      }
    }
    process.env.NODE_ENV !== "test" && Promise.all(B).then(() => {
      S.contentWindow.print();
    });
  }, [e, o, t]), g = m.useCallback((S) => {
    var E, I;
    o.current.body.removeChild(S), e.current.restoreState(i.current || {}), (I = (E = i.current) == null ? void 0 : E.columns) != null && I.columnVisibilityModel || e.current.setColumnVisibilityModel(a.current), e.current.setState((O) => U({}, O, {
      virtualization: c.current
    })), e.current.setRows(l.current), i.current = null, a.current = {}, l.current = [];
  }, [e]), v = {
    exportDataAsPrint: m.useCallback(async (S) => {
      if (r.debug("Export data as Print"), !e.current.rootElementRef.current)
        throw new Error("MUI X: No grid root element available.");
      if (i.current = e.current.exportState(), a.current = Ai(e), l.current = e.current.getSortedRows().filter((I) => !I[Hu]), t.pagination) {
        const O = {
          page: 0,
          pageSize: ES(e)
        };
        e.current.setState((T) => U({}, T, {
          pagination: U({}, T.pagination, {
            paginationModel: Qg(
              T.pagination,
              // Using signature `DataGridPro` to allow more than 100 rows in the print export
              "DataGridPro",
              O
            )
          })
        }));
      }
      c.current = e.current.state.virtualization, e.current.setState((I) => U({}, I, {
        virtualization: U({}, I.virtualization, {
          enabled: !1,
          enabledForColumns: !1
        })
      })), await d(S == null ? void 0 : S.fields, S == null ? void 0 : S.allColumns, S == null ? void 0 : S.includeCheckboxes), f((S == null ? void 0 : S.getRowsToExport) ?? p$), await she();
      const E = ahe(S == null ? void 0 : S.fileName);
      process.env.NODE_ENV === "test" ? (o.current.body.appendChild(E), p(E, S), g(E)) : (E.onload = () => {
        p(E, S), E.contentWindow.matchMedia("print").addEventListener("change", (O) => {
          O.matches === !1 && g(E);
        });
      }, o.current.body.appendChild(E));
    }, [t, r, e, p, g, d, f])
  };
  Ut(e, v, "public");
  const y = m.useCallback((S, E) => {
    var I;
    return (I = E.printOptions) != null && I.disableToolbarButton ? S : [...S, {
      component: /* @__PURE__ */ w.jsx(t$, {
        options: E.printOptions
      }),
      componentName: "printExport"
    }];
  }, []);
  Zn(e, "exportMenu", y);
}, che = (e, t, n) => {
  var o, i;
  const r = t.filterModel ?? ((i = (o = t.initialState) == null ? void 0 : o.filter) == null ? void 0 : i.filterModel) ?? wp();
  return U({}, e, {
    filter: {
      filterModel: CS(r, t.disableMultipleColumnsFiltering, n),
      filteredRowsLookup: {},
      filteredChildrenCountLookup: {},
      filteredDescendantCountLookup: {}
    },
    visibleRowsLookup: {}
  });
}, uhe = (e) => e.filteredRowsLookup;
function LR(e, t) {
  return e.current.applyStrategyProcessor("visibleRowsLookupCreation", {
    tree: t.rows.tree,
    filteredRowsLookup: t.filter.filteredRowsLookup
  });
}
function dhe() {
  return fN(Object.values);
}
const fhe = (e, t) => {
  var _, C, D;
  const n = zr(e, "useGridFilter");
  e.current.registerControlState({
    stateId: "filter",
    propModel: t.filterModel,
    propOnChange: t.onFilterModelChange,
    stateSelector: ro,
    changeEvent: "filterModelChange"
  });
  const r = m.useCallback(() => {
    e.current.setState((L) => {
      const B = ro(L, e.current.instanceId), H = e.current.getFilterState(B), k = U({}, L, {
        filter: U({}, L.filter, H)
      }), N = LR(e, k);
      return U({}, k, {
        visibleRowsLookup: N
      });
    }), e.current.publishEvent("filteredRowsSet");
  }, [e]), o = m.useCallback((L, B) => B == null || B.filterable === !1 || t.disableColumnFilter ? L : [...L, "columnMenuFilterItem"], [t.disableColumnFilter]), i = m.useCallback(() => {
    r(), e.current.forceUpdate();
  }, [e, r]), a = m.useCallback((L) => {
    const B = ro(e), H = [...B.items], k = H.findIndex((N) => N.id === L.id);
    k === -1 ? H.push(L) : H[k] = L, e.current.setFilterModel(U({}, B, {
      items: H
    }), "upsertFilterItem");
  }, [e]), l = m.useCallback((L) => {
    const B = ro(e), H = [...B.items];
    L.forEach((k) => {
      const N = H.findIndex((j) => j.id === k.id);
      N === -1 ? H.push(k) : H[N] = k;
    }), e.current.setFilterModel(U({}, B, {
      items: H
    }), "upsertFilterItems");
  }, [e]), c = m.useCallback((L) => {
    const B = ro(e), H = B.items.filter((k) => k.id !== L.id);
    H.length !== B.items.length && e.current.setFilterModel(U({}, B, {
      items: H
    }), "deleteFilterItem");
  }, [e]), d = m.useCallback((L, B, H) => {
    if (n.debug("Displaying filter panel"), L) {
      const k = ro(e), N = k.items.filter(($) => {
        var Q;
        if ($.value !== void 0)
          return !(Array.isArray($.value) && $.value.length === 0);
        const ne = (Q = e.current.getColumn($.field).filterOperators) == null ? void 0 : Q.find((re) => re.value === $.operator);
        return !(typeof (ne == null ? void 0 : ne.requiresFilterValue) > "u" ? !0 : ne == null ? void 0 : ne.requiresFilterValue);
      });
      let j;
      const W = N.find(($) => $.field === L), V = e.current.getColumn(L);
      W ? j = N : t.disableMultipleColumnsFiltering ? j = [Z0({
        field: L,
        operator: V.filterOperators[0].value
      }, e)] : j = [...N, Z0({
        field: L,
        operator: V.filterOperators[0].value
      }, e)], e.current.setFilterModel(U({}, k, {
        items: j
      }));
    }
    e.current.showPreferences(Ec.filters, B, H);
  }, [e, n, t.disableMultipleColumnsFiltering]), f = m.useCallback(() => {
    n.debug("Hiding filter panel"), e.current.hidePreferences();
  }, [e, n]), p = m.useCallback((L) => {
    const B = ro(e);
    B.logicOperator !== L && e.current.setFilterModel(U({}, B, {
      logicOperator: L
    }), "changeLogicOperator");
  }, [e]), g = m.useCallback((L) => {
    const B = ro(e);
    Vu(B.quickFilterValues, L) || e.current.setFilterModel(U({}, B, {
      quickFilterValues: [...L]
    }));
  }, [e]), b = m.useCallback((L, B) => {
    ro(e) !== L && (n.debug("Setting filter model"), e.current.updateControlState("filter", YI(L, t.disableMultipleColumnsFiltering, e), B), e.current.unstable_applyFilters());
  }, [e, n, t.disableMultipleColumnsFiltering]), v = m.useCallback((L) => {
    const B = CS(L, t.disableMultipleColumnsFiltering, e), H = t.filterMode === "client" ? Jae(B, e, t.disableEval) : null, k = e.current.applyStrategyProcessor("filtering", {
      isRowMatchingFilters: H,
      filterModel: B ?? wp()
    });
    return U({}, k, {
      filterModel: B
    });
  }, [t.disableMultipleColumnsFiltering, t.filterMode, t.disableEval, e]), y = {
    setFilterLogicOperator: p,
    unstable_applyFilters: i,
    deleteFilterItem: c,
    upsertFilterItem: a,
    upsertFilterItems: l,
    setFilterModel: b,
    showFilterPanel: d,
    hideFilterPanel: f,
    setQuickFilterValues: g,
    ignoreDiacritics: t.ignoreDiacritics,
    getFilterState: v
  };
  Ut(e, y, "public");
  const S = m.useCallback((L, B) => {
    var N, j;
    const H = ro(e);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !B.exportOnlyDirtyModels || // Always export if the model is controlled
      t.filterModel != null || // Always export if the model has been initialized
      ((j = (N = t.initialState) == null ? void 0 : N.filter) == null ? void 0 : j.filterModel) != null || // Export if the model is not equal to the default value
      !Vu(H, wp()) ? U({}, L, {
        filter: {
          filterModel: H
        }
      }) : L
    );
  }, [e, t.filterModel, (C = (_ = t.initialState) == null ? void 0 : _.filter) == null ? void 0 : C.filterModel]), E = m.useCallback((L, B) => {
    var k;
    const H = (k = B.stateToRestore.filter) == null ? void 0 : k.filterModel;
    return H == null ? L : (e.current.updateControlState("filter", YI(H, t.disableMultipleColumnsFiltering, e), "restoreState"), U({}, L, {
      callbacks: [...L.callbacks, e.current.unstable_applyFilters]
    }));
  }, [e, t.disableMultipleColumnsFiltering]), I = m.useCallback((L, B) => {
    var H;
    if (B === Ec.filters) {
      const k = t.slots.filterPanel;
      return /* @__PURE__ */ w.jsx(k, U({}, (H = t.slotProps) == null ? void 0 : H.filterPanel));
    }
    return L;
  }, [t.slots.filterPanel, (D = t.slotProps) == null ? void 0 : D.filterPanel]), {
    getRowId: O
  } = t, T = Ws(dhe), P = m.useCallback((L) => {
    if (t.filterMode !== "client" || !L.isRowMatchingFilters)
      return {
        filteredRowsLookup: {},
        filteredChildrenCountLookup: {},
        filteredDescendantCountLookup: {}
      };
    const B = cl(e), H = {}, {
      isRowMatchingFilters: k
    } = L, N = {}, j = {
      passingFilterItems: null,
      passingQuickFilterValues: null
    }, W = T.current(e.current.state.rows.dataRowIdToModelLookup);
    for (let z = 0; z < W.length; z += 1) {
      const ne = W[z], K = O ? O(ne) : ne.id;
      k(ne, void 0, j);
      const Q = ele([j.passingFilterItems], [j.passingQuickFilterValues], L.filterModel, e, N);
      H[K] = Q;
    }
    const V = "auto-generated-group-footer-root";
    return B[V] && (H[V] = !0), {
      filteredRowsLookup: H,
      filteredChildrenCountLookup: {},
      filteredDescendantCountLookup: {}
    };
  }, [e, t.filterMode, O, T]);
  Zn(e, "columnMenu", o), Zn(e, "exportState", S), Zn(e, "restoreState", E), Zn(e, "preferencePanel", I), Lm(e, Tc, "filtering", P), Lm(e, Tc, "visibleRowsLookupCreation", uhe);
  const R = m.useCallback(() => {
    n.debug("onColUpdated - GridColumns changed, applying filters");
    const L = ro(e), B = Oa(e), H = L.items.filter((k) => k.field && B[k.field]);
    H.length < L.items.length && e.current.setFilterModel(U({}, L, {
      items: H
    }));
  }, [e, n]), F = m.useCallback((L) => {
    L === "filtering" && e.current.unstable_applyFilters();
  }, [e]), A = m.useCallback(() => {
    e.current.setState((L) => U({}, L, {
      visibleRowsLookup: LR(e, L)
    })), e.current.forceUpdate();
  }, [e]);
  it(e, "rowsSet", r), it(e, "columnsChange", R), it(e, "activeStrategyProcessorChange", F), it(e, "rowExpansionChange", A), it(e, "columnVisibilityModelChange", () => {
    const L = ro(e);
    L.quickFilterValues && ON(L) && e.current.unstable_applyFilters();
  }), dh(() => {
    e.current.unstable_applyFilters();
  }), Zr(() => {
    t.filterModel !== void 0 && e.current.setFilterModel(t.filterModel);
  }, [e, n, t.filterModel]);
}, phe = (e) => U({}, e, {
  focus: {
    cell: null,
    columnHeader: null,
    columnHeaderFilter: null,
    columnGroupHeader: null
  },
  tabIndex: {
    cell: null,
    columnHeader: null,
    columnHeaderFilter: null,
    columnGroupHeader: null
  }
}), hhe = (e, t) => {
  const n = zr(e, "useGridFocus"), r = m.useRef(null), o = e.current.rootElementRef.current !== null, i = m.useCallback((A, _) => {
    A && e.current.getRow(A.id) && e.current.publishEvent("cellFocusOut", e.current.getCellParams(A.id, A.field), _);
  }, [e]), a = m.useCallback((A, _) => {
    const C = jo(e);
    (C == null ? void 0 : C.id) === A && (C == null ? void 0 : C.field) === _ || (e.current.setState((D) => (n.debug(`Focusing on cell with id=${A} and field=${_}`), U({}, D, {
      tabIndex: {
        cell: {
          id: A,
          field: _
        },
        columnHeader: null,
        columnHeaderFilter: null,
        columnGroupHeader: null
      },
      focus: {
        cell: {
          id: A,
          field: _
        },
        columnHeader: null,
        columnHeaderFilter: null,
        columnGroupHeader: null
      }
    }))), e.current.forceUpdate(), e.current.getRow(A) && (C && i(C, {}), e.current.publishEvent("cellFocusIn", e.current.getCellParams(A, _))));
  }, [e, n, i]), l = m.useCallback((A, _ = {}) => {
    const C = jo(e);
    i(C, _), e.current.setState((D) => (n.debug(`Focusing on column header with colIndex=${A}`), U({}, D, {
      tabIndex: {
        columnHeader: {
          field: A
        },
        columnHeaderFilter: null,
        cell: null,
        columnGroupHeader: null
      },
      focus: {
        columnHeader: {
          field: A
        },
        columnHeaderFilter: null,
        cell: null,
        columnGroupHeader: null
      }
    }))), e.current.forceUpdate();
  }, [e, n, i]), c = m.useCallback((A, _ = {}) => {
    const C = jo(e);
    i(C, _), e.current.setState((D) => (n.debug(`Focusing on column header filter with colIndex=${A}`), U({}, D, {
      tabIndex: {
        columnHeader: null,
        columnHeaderFilter: {
          field: A
        },
        cell: null,
        columnGroupHeader: null
      },
      focus: {
        columnHeader: null,
        columnHeaderFilter: {
          field: A
        },
        cell: null,
        columnGroupHeader: null
      }
    }))), e.current.forceUpdate();
  }, [e, n, i]), d = m.useCallback((A, _, C = {}) => {
    const D = jo(e);
    D && e.current.publishEvent("cellFocusOut", e.current.getCellParams(D.id, D.field), C), e.current.setState((L) => U({}, L, {
      tabIndex: {
        columnGroupHeader: {
          field: A,
          depth: _
        },
        columnHeader: null,
        columnHeaderFilter: null,
        cell: null
      },
      focus: {
        columnGroupHeader: {
          field: A,
          depth: _
        },
        columnHeader: null,
        columnHeaderFilter: null,
        cell: null
      }
    })), e.current.forceUpdate();
  }, [e]), f = m.useCallback(() => Dm(e), [e]), p = m.useCallback((A, _, C) => {
    let D = e.current.getColumnIndex(_);
    const L = Fr(e), B = zu(e, {
      pagination: t.pagination,
      paginationMode: t.paginationMode
    }), H = Nc(e), k = [].concat(H.top || [], B.rows, H.bottom || []);
    let N = k.findIndex(($) => $.id === A);
    C === "right" ? D += 1 : C === "left" ? D -= 1 : N += 1, D >= L.length ? (N += 1, N < k.length && (D = 0)) : D < 0 && (N -= 1, N >= 0 && (D = L.length - 1)), N = js(N, 0, k.length - 1);
    const j = k[N];
    if (!j)
      return;
    const W = e.current.unstable_getCellColSpanInfo(j.id, D);
    W && W.spannedByColSpan && (C === "left" || C === "below" ? D = W.leftVisibleCellIndex : C === "right" && (D = W.rightVisibleCellIndex)), D = js(D, 0, L.length - 1);
    const V = L[D];
    e.current.setCellFocus(j.id, V.field);
  }, [e, t.pagination, t.paginationMode]), g = m.useCallback(({
    id: A,
    field: _
  }) => {
    e.current.setCellFocus(A, _);
  }, [e]), b = m.useCallback((A, _) => {
    _.key === "Enter" || _.key === "Tab" || _.key === "Shift" || $m(_.key) || e.current.setCellFocus(A.id, A.field);
  }, [e]), v = m.useCallback(({
    field: A
  }, _) => {
    _.target === _.currentTarget && e.current.setColumnHeaderFocus(A, _);
  }, [e]), y = m.useCallback(({
    fields: A,
    depth: _
  }, C) => {
    if (C.target !== C.currentTarget)
      return;
    const D = Dm(e);
    D !== null && D.depth === _ && A.includes(D.field) || e.current.setColumnGroupHeaderFocus(A[0], _, C);
  }, [e]), S = m.useCallback((A, _) => {
    var C, D;
    (D = (C = _.relatedTarget) == null ? void 0 : C.getAttribute("class")) != null && D.includes(ee.columnHeader) || (n.debug("Clearing focus"), e.current.setState((L) => U({}, L, {
      focus: {
        cell: null,
        columnHeader: null,
        columnHeaderFilter: null,
        columnGroupHeader: null
      }
    })));
  }, [n, e]), E = m.useCallback((A) => {
    r.current = A;
  }, []), I = m.useCallback((A) => {
    const _ = r.current;
    r.current = null;
    const C = jo(e);
    if (!e.current.unstable_applyPipeProcessors("canUpdateFocus", !0, {
      event: A,
      cell: _
    }))
      return;
    if (!C) {
      _ && e.current.setCellFocus(_.id, _.field);
      return;
    }
    if ((_ == null ? void 0 : _.id) === C.id && (_ == null ? void 0 : _.field) === C.field)
      return;
    const L = e.current.getCellElement(C.id, C.field);
    L != null && L.contains(A.target) || (_ ? e.current.setCellFocus(_.id, _.field) : (e.current.setState((B) => U({}, B, {
      focus: {
        cell: null,
        columnHeader: null,
        columnHeaderFilter: null,
        columnGroupHeader: null
      }
    })), e.current.forceUpdate(), i(C, A)));
  }, [e, i]), O = m.useCallback((A) => {
    if (A.cellMode === "view")
      return;
    const _ = jo(e);
    ((_ == null ? void 0 : _.id) !== A.id || (_ == null ? void 0 : _.field) !== A.field) && e.current.setCellFocus(A.id, A.field);
  }, [e]), T = m.useCallback(() => {
    var _;
    const A = jo(e);
    if (A && !e.current.getRow(A.id)) {
      const C = (_ = jo(e)) == null ? void 0 : _.id;
      let D = null;
      if (typeof C < "u") {
        const L = e.current.getRowIndexRelativeToVisibleRows(C), B = zu(e, {
          pagination: t.pagination,
          paginationMode: t.paginationMode
        }), H = B.rows[js(L, 0, B.rows.length - 1)];
        D = (H == null ? void 0 : H.id) ?? null;
      }
      e.current.setState((L) => U({}, L, {
        focus: {
          cell: D === null ? null : {
            id: D,
            field: A.field
          },
          columnHeader: null,
          columnHeaderFilter: null,
          columnGroupHeader: null
        }
      }));
    }
  }, [e, t.pagination, t.paginationMode]), P = Yn(() => {
    const A = jo(e);
    if (!A)
      return;
    const _ = zu(e, {
      pagination: t.pagination,
      paginationMode: t.paginationMode
    });
    if (_.rows.find((L) => L.id === A.id))
      return;
    const D = Fr(e);
    e.current.setState((L) => U({}, L, {
      tabIndex: {
        cell: {
          id: _.rows[0].id,
          field: D[0].field
        },
        columnGroupHeader: null,
        columnHeader: null,
        columnHeaderFilter: null
      }
    }));
  }), R = {
    setCellFocus: a,
    setColumnHeaderFocus: l,
    setColumnHeaderFilterFocus: c
  }, F = {
    moveFocusToRelativeCell: p,
    setColumnGroupHeaderFocus: d,
    getColumnGroupHeaderFocus: f
  };
  Ut(e, R, "public"), Ut(e, F, "private"), m.useEffect(() => {
    const A = fl(e.current.rootElementRef.current);
    return A.addEventListener("mouseup", I), () => {
      A.removeEventListener("mouseup", I);
    };
  }, [e, o, I]), it(e, "columnHeaderBlur", S), it(e, "cellDoubleClick", g), it(e, "cellMouseDown", E), it(e, "cellKeyDown", b), it(e, "cellModeChange", O), it(e, "columnHeaderFocus", v), it(e, "columnGroupHeaderFocus", y), it(e, "rowsSet", T), it(e, "paginationModelChange", P);
}, ghe = (e) => {
  const t = e.match(/^__row_group_by_columns_group_(.*)__$/);
  return t ? t[1] : null;
}, mhe = (e) => e === AN || ghe(e) !== null;
function bhe(e, t) {
  const n = Nc(e) || {};
  return [...n.top || [], ...t, ...n.bottom || []];
}
const kw = ({
  currentColIndex: e,
  firstColIndex: t,
  lastColIndex: n,
  isRtl: r
}) => {
  if (r) {
    if (e < n)
      return e + 1;
  } else if (!r && e > t)
    return e - 1;
  return null;
}, Mw = ({
  currentColIndex: e,
  firstColIndex: t,
  lastColIndex: n,
  isRtl: r
}) => {
  if (r) {
    if (e > t)
      return e - 1;
  } else if (!r && e < n)
    return e + 1;
  return null;
};
function yhe(e, t, n, r) {
  var l, c;
  const o = dF(e);
  if (!((l = o[t]) != null && l[n]))
    return t;
  const i = BN(e);
  let a = i.indexOf(t) + (r === "down" ? 1 : -1);
  for (; a >= 0 && a < i.length; ) {
    const d = i[a];
    if (!((c = o[d]) != null && c[n]))
      return d;
    a += r === "down" ? 1 : -1;
  }
  return t;
}
const vhe = (e, t) => {
  const n = zr(e, "useGridKeyboardNavigation"), r = Fc(e, t).rows, o = mi(), i = t.unstable_listView, a = m.useMemo(() => bhe(e, r), [e, r]), l = t.signature !== "DataGrid" && t.headerFilters, c = m.useCallback((I, O, T = "left", P = "up") => {
    const R = Fl(e), F = e.current.unstable_getCellColSpanInfo(O, I);
    F && F.spannedByColSpan && (T === "left" ? I = F.leftVisibleCellIndex : T === "right" && (I = F.rightVisibleCellIndex));
    const A = i ? Cd(e.current.state).field : Ad(e)[I], _ = yhe(e, O, A, P), C = R.findIndex((D) => D.id === _);
    n.debug(`Navigating to cell row ${C}, col ${I}`), e.current.scrollToIndexes({
      colIndex: I,
      rowIndex: C
    }), e.current.setCellFocus(_, A);
  }, [e, n, i]), d = m.useCallback((I, O) => {
    n.debug(`Navigating to header col ${I}`), e.current.scrollToIndexes({
      colIndex: I
    });
    const T = e.current.getVisibleColumns()[I].field;
    e.current.setColumnHeaderFocus(T, O);
  }, [e, n]), f = m.useCallback((I, O) => {
    n.debug(`Navigating to header filter col ${I}`), e.current.scrollToIndexes({
      colIndex: I
    });
    const T = e.current.getVisibleColumns()[I].field;
    e.current.setColumnHeaderFilterFocus(T, O);
  }, [e, n]), p = m.useCallback((I, O, T) => {
    n.debug(`Navigating to header col ${I}`), e.current.scrollToIndexes({
      colIndex: I
    });
    const {
      field: P
    } = e.current.getVisibleColumns()[I];
    e.current.setColumnGroupHeaderFocus(P, O, T);
  }, [e, n]), g = m.useCallback((I) => {
    var O;
    return (O = a[I]) == null ? void 0 : O.id;
  }, [a]), b = m.useCallback((I, O) => {
    const T = O.currentTarget.querySelector(`.${ee.columnHeaderTitleContainerContent}`);
    if (!!T && T.contains(O.target) && I.field !== $d.field)
      return;
    const R = e.current.getViewportPageSize(), F = I.field ? e.current.getColumnIndex(I.field) : 0, A = a.length > 0 ? 0 : null, _ = a.length - 1, C = 0, D = Fr(e).length - 1, L = fh(e);
    let B = !0;
    switch (O.key) {
      case "ArrowDown": {
        A !== null && (l ? f(F, O) : c(F, g(A)));
        break;
      }
      case "ArrowRight": {
        const H = Mw({
          currentColIndex: F,
          firstColIndex: C,
          lastColIndex: D,
          isRtl: o
        });
        H !== null && d(H, O);
        break;
      }
      case "ArrowLeft": {
        const H = kw({
          currentColIndex: F,
          firstColIndex: C,
          lastColIndex: D,
          isRtl: o
        });
        H !== null && d(H, O);
        break;
      }
      case "ArrowUp": {
        L > 0 && p(F, L - 1, O);
        break;
      }
      case "PageDown": {
        A !== null && _ !== null && c(F, g(Math.min(A + R, _)));
        break;
      }
      case "Home": {
        d(C, O);
        break;
      }
      case "End": {
        d(D, O);
        break;
      }
      case "Enter": {
        (O.ctrlKey || O.metaKey) && e.current.toggleColumnMenu(I.field);
        break;
      }
      case " ":
        break;
      default:
        B = !1;
    }
    B && O.preventDefault();
  }, [e, a.length, l, f, c, g, o, d, p]), v = m.useCallback((I, O) => {
    const T = Nce(e) === I.field, P = Fce(e) === I.field;
    if (T || P || !$m(O.key))
      return;
    const R = e.current.getViewportPageSize(), F = I.field ? e.current.getColumnIndex(I.field) : 0, A = 0, _ = a.length - 1, C = 0, D = Fr(e).length - 1;
    let L = !0;
    switch (O.key) {
      case "ArrowDown": {
        const B = g(A);
        B != null && c(F, B);
        break;
      }
      case "ArrowRight": {
        const B = Mw({
          currentColIndex: F,
          firstColIndex: C,
          lastColIndex: D,
          isRtl: o
        });
        B !== null && f(B, O);
        break;
      }
      case "ArrowLeft": {
        const B = kw({
          currentColIndex: F,
          firstColIndex: C,
          lastColIndex: D,
          isRtl: o
        });
        B !== null ? f(B, O) : e.current.setColumnHeaderFilterFocus(I.field, O);
        break;
      }
      case "ArrowUp": {
        d(F, O);
        break;
      }
      case "PageDown": {
        _ !== null && c(F, g(Math.min(A + R, _)));
        break;
      }
      case "Home": {
        f(C, O);
        break;
      }
      case "End": {
        f(D, O);
        break;
      }
      case " ":
        break;
      default:
        L = !1;
    }
    L && O.preventDefault();
  }, [e, a.length, f, o, d, c, g]), y = m.useCallback((I, O) => {
    const T = Dm(e);
    if (T === null)
      return;
    const {
      field: P,
      depth: R
    } = T, {
      fields: F,
      depth: A,
      maxDepth: _
    } = I, C = e.current.getViewportPageSize(), D = e.current.getColumnIndex(P), L = P ? e.current.getColumnIndex(P) : 0, B = 0, H = a.length - 1, k = 0, N = Fr(e).length - 1;
    let j = !0;
    switch (O.key) {
      case "ArrowDown": {
        A === _ - 1 ? d(D, O) : p(D, R + 1, O);
        break;
      }
      case "ArrowUp": {
        A > 0 && p(D, R - 1, O);
        break;
      }
      case "ArrowRight": {
        const W = F.length - F.indexOf(P) - 1;
        D + W + 1 <= N && p(D + W + 1, R, O);
        break;
      }
      case "ArrowLeft": {
        const W = F.indexOf(P);
        D - W - 1 >= k && p(D - W - 1, R, O);
        break;
      }
      case "PageDown": {
        H !== null && c(L, g(Math.min(B + C, H)));
        break;
      }
      case "Home": {
        p(k, R, O);
        break;
      }
      case "End": {
        p(N, R, O);
        break;
      }
      case " ":
        break;
      default:
        j = !1;
    }
    j && O.preventDefault();
  }, [e, a.length, d, p, c, g]), S = m.useCallback((I, O) => {
    if (ph(O))
      return;
    const T = e.current.getCellParams(I.id, I.field);
    if (T.cellMode === En.Edit || !$m(O.key) || !e.current.unstable_applyPipeProcessors("canUpdateFocus", !0, {
      event: O,
      cell: T
    }) || a.length === 0)
      return;
    const R = e.current.getViewportPageSize(), F = i ? () => 0 : e.current.getColumnIndex, A = I.field ? F(I.field) : 0, _ = a.findIndex((N) => N.id === I.id), C = 0, D = a.length - 1, L = 0, H = (i ? [Cd(e.current.state)] : Fr(e)).length - 1;
    let k = !0;
    switch (O.key) {
      case "ArrowDown": {
        _ < D && c(A, g(_ + 1), o ? "right" : "left", "down");
        break;
      }
      case "ArrowUp": {
        _ > C ? c(A, g(_ - 1)) : l ? f(A, O) : d(A, O);
        break;
      }
      case "ArrowRight": {
        const N = Mw({
          currentColIndex: A,
          firstColIndex: L,
          lastColIndex: H,
          isRtl: o
        });
        N !== null && c(N, g(_), o ? "left" : "right");
        break;
      }
      case "ArrowLeft": {
        const N = kw({
          currentColIndex: A,
          firstColIndex: L,
          lastColIndex: H,
          isRtl: o
        });
        N !== null && c(N, g(_), o ? "right" : "left");
        break;
      }
      case "Tab": {
        O.shiftKey && A > L ? c(A - 1, g(_), "left") : !O.shiftKey && A < H && c(A + 1, g(_), "right");
        break;
      }
      case " ": {
        if (I.field === iy)
          break;
        const j = I.colDef;
        if (j && (j.field === Cle || mhe(j.field)))
          break;
        !O.shiftKey && _ < D && c(A, g(Math.min(_ + R, D)));
        break;
      }
      case "PageDown": {
        _ < D && c(A, g(Math.min(_ + R, D)));
        break;
      }
      case "PageUp": {
        const N = Math.max(_ - R, C);
        N !== _ && N >= C ? c(A, g(N)) : d(A, O);
        break;
      }
      case "Home": {
        O.ctrlKey || O.metaKey || O.shiftKey ? c(L, g(C)) : c(L, g(_));
        break;
      }
      case "End": {
        O.ctrlKey || O.metaKey || O.shiftKey ? c(H, g(D)) : c(H, g(_));
        break;
      }
      default:
        k = !1;
    }
    k && O.preventDefault();
  }, [e, a, o, c, g, l, f, d, i]), E = m.useCallback((I, {
    event: O
  }) => O.key === " " ? !1 : I, []);
  Zn(e, "canStartEditing", E), it(e, "columnHeaderKeyDown", b), it(e, "headerFilterKeyDown", v), it(e, "columnGroupHeaderKeyDown", y), it(e, "cellKeyDown", S);
}, whe = (e, t) => {
  var v, y;
  const n = zr(e, "useGridRowCount"), r = Be(e, TS), o = Be(e, Au), i = Be(e, Nf), a = Be(e, To), l = Ws(() => To(e).pageSize);
  e.current.registerControlState({
    stateId: "paginationRowCount",
    propModel: t.rowCount,
    propOnChange: t.onRowCountChange,
    stateSelector: Au,
    changeEvent: "rowCountChange"
  });
  const d = {
    setRowCount: m.useCallback((S) => {
      o !== S && (n.debug("Setting 'rowCount' to", S), e.current.setState((E) => U({}, E, {
        pagination: U({}, E.pagination, {
          rowCount: S
        })
      })));
    }, [e, n, o])
  };
  Ut(e, d, "public");
  const f = m.useCallback((S, E) => {
    var T, P;
    const I = Au(e);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !E.exportOnlyDirtyModels || // Always export if the `rowCount` is controlled
      t.rowCount != null || // Always export if the `rowCount` has been initialized
      ((P = (T = t.initialState) == null ? void 0 : T.pagination) == null ? void 0 : P.rowCount) != null ? U({}, S, {
        pagination: U({}, S.pagination, {
          rowCount: I
        })
      }) : S
    );
  }, [e, t.rowCount, (y = (v = t.initialState) == null ? void 0 : v.pagination) == null ? void 0 : y.rowCount]), p = m.useCallback((S, E) => {
    var O;
    const I = (O = E.stateToRestore.pagination) != null && O.rowCount ? E.stateToRestore.pagination.rowCount : Au(e);
    return e.current.setState((T) => U({}, T, {
      pagination: U({}, T.pagination, {
        rowCount: I
      })
    })), S;
  }, [e]);
  Zn(e, "exportState", f), Zn(e, "restoreState", p);
  const g = m.useCallback((S) => {
    t.paginationMode === "client" || !l.current || S.pageSize !== l.current && (l.current = S.pageSize, o === -1 && e.current.setPage(0));
  }, [t.paginationMode, l, o, e]);
  it(e, "paginationModelChange", g), m.useEffect(() => {
    t.paginationMode === "client" ? e.current.setRowCount(r) : t.rowCount != null && e.current.setRowCount(t.rowCount);
  }, [e, t.paginationMode, r, t.rowCount]);
  const b = i.hasNextPage === !1;
  m.useEffect(() => {
    b && o === -1 && e.current.setRowCount(a.pageSize * a.page + r);
  }, [e, r, b, o, a]);
}, Che = (e, t) => {
  var c, d;
  const n = zr(e, "useGridPaginationMeta"), r = Be(e, Nf);
  e.current.registerControlState({
    stateId: "paginationMeta",
    propModel: t.paginationMeta,
    propOnChange: t.onPaginationMetaChange,
    stateSelector: Nf,
    changeEvent: "paginationMetaChange"
  });
  const i = {
    setPaginationMeta: m.useCallback((f) => {
      r !== f && (n.debug("Setting 'paginationMeta' to", f), e.current.setState((p) => U({}, p, {
        pagination: U({}, p.pagination, {
          meta: f
        })
      })));
    }, [e, n, r])
  };
  Ut(e, i, "public");
  const a = m.useCallback((f, p) => {
    var v, y;
    const g = Nf(e);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !p.exportOnlyDirtyModels || // Always export if the `paginationMeta` is controlled
      t.paginationMeta != null || // Always export if the `paginationMeta` has been initialized
      ((y = (v = t.initialState) == null ? void 0 : v.pagination) == null ? void 0 : y.meta) != null ? U({}, f, {
        pagination: U({}, f.pagination, {
          meta: g
        })
      }) : f
    );
  }, [e, t.paginationMeta, (d = (c = t.initialState) == null ? void 0 : c.pagination) == null ? void 0 : d.meta]), l = m.useCallback((f, p) => {
    var b;
    const g = (b = p.stateToRestore.pagination) != null && b.meta ? p.stateToRestore.pagination.meta : Nf(e);
    return e.current.setState((v) => U({}, v, {
      pagination: U({}, v.pagination, {
        meta: g
      })
    })), f;
  }, [e]);
  Zn(e, "exportState", a), Zn(e, "restoreState", l), m.useEffect(() => {
    t.paginationMeta && e.current.setPaginationMeta(t.paginationMeta);
  }, [e, t.paginationMeta]);
}, xhe = (e, t) => {
  var i, a, l, c, d, f;
  const n = U({}, qN(t.autoPageSize), t.paginationModel ?? ((a = (i = t.initialState) == null ? void 0 : i.pagination) == null ? void 0 : a.paginationModel));
  KN(n.pageSize, t.signature);
  const r = t.rowCount ?? ((c = (l = t.initialState) == null ? void 0 : l.pagination) == null ? void 0 : c.rowCount), o = t.paginationMeta ?? ((f = (d = t.initialState) == null ? void 0 : d.pagination) == null ? void 0 : f.meta) ?? {};
  return U({}, e, {
    pagination: {
      paginationModel: n,
      rowCount: r,
      meta: o
    }
  });
}, She = (e, t) => {
  Che(e, t), ihe(e, t), whe(e, t);
}, Ehe = (e, t) => {
  var n;
  return U({}, e, {
    preferencePanel: ((n = t.initialState) == null ? void 0 : n.preferencePanel) ?? {
      open: !1
    }
  });
}, The = (e, t) => {
  var p;
  const n = zr(e, "useGridPreferencesPanel"), r = m.useRef(void 0), o = m.useRef(void 0), i = m.useCallback(() => {
    n.debug("Hiding Preferences Panel");
    const g = xp(e.current.state);
    g.openedPanelValue && e.current.publishEvent("preferencePanelClose", {
      openedPanelValue: g.openedPanelValue
    }), e.current.setState((b) => U({}, b, {
      preferencePanel: {
        open: !1
      }
    })), e.current.forceUpdate();
  }, [e, n]), a = m.useCallback(() => {
    o.current = setTimeout(() => clearTimeout(r.current), 0);
  }, []), l = m.useCallback(() => {
    r.current = setTimeout(i, 100);
  }, [i]), c = m.useCallback((g, b, v) => {
    n.debug("Opening Preferences Panel"), a(), e.current.setState((y) => U({}, y, {
      preferencePanel: U({}, y.preferencePanel, {
        open: !0,
        openedPanelValue: g,
        panelId: b,
        labelId: v
      })
    })), e.current.publishEvent("preferencePanelOpen", {
      openedPanelValue: g
    }), e.current.forceUpdate();
  }, [n, a, e]);
  Ut(e, {
    showPreferences: c,
    hidePreferences: l
  }, "public");
  const d = m.useCallback((g, b) => {
    var S;
    const v = xp(e.current.state);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !b.exportOnlyDirtyModels || // Always export if the panel was initialized
      ((S = t.initialState) == null ? void 0 : S.preferencePanel) != null || // Always export if the panel is opened
      v.open ? U({}, g, {
        preferencePanel: v
      }) : g
    );
  }, [e, (p = t.initialState) == null ? void 0 : p.preferencePanel]), f = m.useCallback((g, b) => {
    const v = b.stateToRestore.preferencePanel;
    return v != null && e.current.setState((y) => U({}, y, {
      preferencePanel: v
    })), g;
  }, [e]);
  Zn(e, "exportState", d), Zn(e, "restoreState", f), m.useEffect(() => () => {
    clearTimeout(r.current), clearTimeout(o.current);
  }, []);
}, aC = (e) => {
  switch (e.type) {
    case "boolean":
      return !1;
    case "date":
    case "dateTime":
    case "number":
      return;
    case "singleSelect":
      return null;
    case "string":
    default:
      return "";
  }
}, Ohe = ["id", "field"], Phe = ["id", "field"], Ihe = (e, t) => {
  const [n, r] = m.useState({}), o = m.useRef(n), i = m.useRef({}), {
    processRowUpdate: a,
    onProcessRowUpdateError: l,
    cellModesModel: c,
    onCellModesModelChange: d
  } = t, f = (k) => (...N) => {
    t.editMode === Us.Cell && k(...N);
  }, p = m.useCallback((k, N) => {
    const j = e.current.getCellParams(k, N);
    if (!e.current.isCellEditable(j))
      throw new Error(`MUI X: The cell with id=${k} and field=${N} is not editable.`);
  }, [e]), g = m.useCallback((k, N, j) => {
    if (e.current.getCellMode(k, N) !== j)
      throw new Error(`MUI X: The cell with id=${k} and field=${N} is not in ${j} mode.`);
  }, [e]), b = m.useCallback((k, N) => {
    if (!k.isEditable || k.cellMode === En.Edit)
      return;
    const j = U({}, k, {
      reason: ca.cellDoubleClick
    });
    e.current.publishEvent("cellEditStart", j, N);
  }, [e]), v = m.useCallback((k, N) => {
    if (k.cellMode === En.View || e.current.getCellMode(k.id, k.field) === En.View)
      return;
    const j = U({}, k, {
      reason: Ki.cellFocusOut
    });
    e.current.publishEvent("cellEditStop", j, N);
  }, [e]), y = m.useCallback((k, N) => {
    if (k.cellMode === En.Edit) {
      if (N.which === 229)
        return;
      let j;
      if (N.key === "Escape" ? j = Ki.escapeKeyDown : N.key === "Enter" ? j = Ki.enterKeyDown : N.key === "Tab" && (j = N.shiftKey ? Ki.shiftTabKeyDown : Ki.tabKeyDown, N.preventDefault()), j) {
        const W = U({}, k, {
          reason: j
        });
        e.current.publishEvent("cellEditStop", W, N);
      }
    } else if (k.isEditable) {
      let j;
      if (!e.current.unstable_applyPipeProcessors("canStartEditing", !0, {
        event: N,
        cellParams: k,
        editMode: "cell"
      }))
        return;
      if (FF(N) ? j = ca.printableKeyDown : LF(N) ? j = ca.pasteKeyDown : N.key === "Enter" ? j = ca.enterKeyDown : (N.key === "Backspace" || N.key === "Delete") && (j = ca.deleteKeyDown), j) {
        const V = U({}, k, {
          reason: j,
          key: N.key
        });
        e.current.publishEvent("cellEditStart", V, N);
      }
    }
  }, [e]), S = m.useCallback((k) => {
    const {
      id: N,
      field: j,
      reason: W
    } = k, V = {
      id: N,
      field: j
    };
    (W === ca.printableKeyDown || W === ca.deleteKeyDown || W === ca.pasteKeyDown) && (V.deleteValue = !0), e.current.startCellEditMode(V);
  }, [e]), E = m.useCallback((k) => {
    const {
      id: N,
      field: j,
      reason: W
    } = k;
    e.current.runPendingEditCellValueMutation(N, j);
    let V;
    W === Ki.enterKeyDown ? V = "below" : W === Ki.tabKeyDown ? V = "right" : W === Ki.shiftTabKeyDown && (V = "left");
    const $ = W === "escapeKeyDown";
    e.current.stopCellEditMode({
      id: N,
      field: j,
      ignoreModifications: $,
      cellToFocusAfter: V
    });
  }, [e]), I = (k) => async (...N) => {
    var j;
    if (k) {
      const {
        id: W,
        field: V
      } = N[0];
      ((j = e.current.state.editRows[W][V]) == null ? void 0 : j.error) || k(...N);
    }
  };
  it(e, "cellDoubleClick", f(b)), it(e, "cellFocusOut", f(v)), it(e, "cellKeyDown", f(y)), it(e, "cellEditStart", f(S)), it(e, "cellEditStop", f(E)), Nn(e, "cellEditStart", t.onCellEditStart), Nn(e, "cellEditStop", I(t.onCellEditStop));
  const O = m.useCallback((k, N) => {
    const j = Qr(e.current.state);
    return j[k] && j[k][N] ? En.Edit : En.View;
  }, [e]), T = Yn((k) => {
    const N = k !== t.cellModesModel;
    d && N && d(k, {
      api: e.current
    }), !(t.cellModesModel && N) && (r(k), o.current = k, e.current.publishEvent("cellModesModelChange", k));
  }), P = m.useCallback((k, N, j) => {
    const W = U({}, o.current);
    if (j !== null)
      W[k] = U({}, W[k], {
        [N]: U({}, j)
      });
    else {
      const V = W[k], $ = yt(V, [N].map(Ep));
      W[k] = $, Object.keys(W[k]).length === 0 && delete W[k];
    }
    T(W);
  }, [T]), R = m.useCallback((k, N, j) => {
    e.current.setState((W) => {
      const V = U({}, W.editRows);
      return j !== null ? V[k] = U({}, V[k], {
        [N]: U({}, j)
      }) : (delete V[k][N], Object.keys(V[k]).length === 0 && delete V[k]), U({}, W, {
        editRows: V
      });
    }), e.current.forceUpdate();
  }, [e]), F = m.useCallback((k) => {
    const {
      id: N,
      field: j
    } = k, W = yt(k, Ohe);
    p(N, j), g(N, j, En.View), P(N, j, U({
      mode: En.Edit
    }, W));
  }, [p, g, P]), A = Yn(async (k) => {
    const {
      id: N,
      field: j,
      deleteValue: W,
      initialValue: V
    } = k, $ = e.current.getCellValue(N, j);
    let z = $;
    W ? z = aC(e.current.getColumn(j)) : V && (z = V);
    const ne = e.current.getColumn(j), K = !!ne.preProcessEditCellProps && W;
    let Q = {
      value: z,
      error: !1,
      isProcessingProps: K
    };
    if (R(N, j, Q), e.current.setCellFocus(N, j), K && (Q = await Promise.resolve(ne.preProcessEditCellProps({
      id: N,
      row: e.current.getRow(N),
      props: Q,
      hasChanged: z !== $
    })), e.current.getCellMode(N, j) === En.Edit)) {
      const re = Qr(e.current.state);
      R(N, j, U({}, Q, {
        value: re[N][j].value,
        isProcessingProps: !1
      }));
    }
  }), _ = m.useCallback((k) => {
    const {
      id: N,
      field: j
    } = k, W = yt(k, Phe);
    g(N, j, En.Edit), P(N, j, U({
      mode: En.View
    }, W));
  }, [g, P]), C = Yn(async (k) => {
    const {
      id: N,
      field: j,
      ignoreModifications: W,
      cellToFocusAfter: V = "none"
    } = k;
    g(N, j, En.Edit), e.current.runPendingEditCellValueMutation(N, j);
    const $ = () => {
      R(N, j, null), P(N, j, null), V !== "none" && e.current.moveFocusToRelativeCell(N, j, V);
    };
    if (W) {
      $();
      return;
    }
    const z = Qr(e.current.state), {
      error: ne,
      isProcessingProps: K
    } = z[N][j];
    if (ne || K) {
      i.current[N][j].mode = En.Edit, P(N, j, {
        mode: En.Edit
      });
      return;
    }
    const Q = e.current.getRowWithUpdatedValuesFromCellEditing(N, j);
    if (a) {
      const re = (te) => {
        i.current[N][j].mode = En.Edit, P(N, j, {
          mode: En.Edit
        }), l ? l(te) : process.env.NODE_ENV !== "production" && ns(["MUI X: A call to `processRowUpdate` threw an error which was not handled because `onProcessRowUpdateError` is missing.", "To handle the error pass a callback to the `onProcessRowUpdateError` prop, for example `<DataGrid onProcessRowUpdateError={(error) => ...} />`.", "For more detail, see https://mui.com/x/react-data-grid/editing/#server-side-persistence."], "error");
      };
      try {
        const te = e.current.getRow(N);
        Promise.resolve(a(Q, te, {
          rowId: N
        })).then((ie) => {
          e.current.updateRows([ie]), $();
        }).catch(re);
      } catch (te) {
        re(te);
      }
    } else
      e.current.updateRows([Q]), $();
  }), D = m.useCallback(async (k) => {
    var te, ie;
    const {
      id: N,
      field: j,
      value: W,
      debounceMs: V,
      unstable_skipValueParser: $
    } = k;
    p(N, j), g(N, j, En.Edit);
    const z = e.current.getColumn(j), ne = e.current.getRow(N);
    let K = W;
    z.valueParser && !$ && (K = z.valueParser(W, ne, z, e));
    let Q = Qr(e.current.state), re = U({}, Q[N][j], {
      value: K,
      changeReason: V ? "debouncedSetEditCellValue" : "setEditCellValue"
    });
    if (z.preProcessEditCellProps) {
      const ae = W !== Q[N][j].value;
      re = U({}, re, {
        isProcessingProps: !0
      }), R(N, j, re), re = await Promise.resolve(z.preProcessEditCellProps({
        id: N,
        row: ne,
        props: re,
        hasChanged: ae
      }));
    }
    return e.current.getCellMode(N, j) === En.View ? !1 : (Q = Qr(e.current.state), re = U({}, re, {
      isProcessingProps: !1
    }), re.value = z.preProcessEditCellProps ? Q[N][j].value : K, R(N, j, re), Q = Qr(e.current.state), !((ie = (te = Q[N]) == null ? void 0 : te[j]) != null && ie.error));
  }, [e, p, g, R]), L = m.useCallback((k, N) => {
    const j = e.current.getColumn(N), W = Qr(e.current.state), V = e.current.getRow(k);
    if (!W[k] || !W[k][N])
      return e.current.getRow(k);
    const {
      value: $
    } = W[k][N];
    return j.valueSetter ? j.valueSetter($, V, j, e) : U({}, V, {
      [N]: $
    });
  }, [e]), B = {
    getCellMode: O,
    startCellEditMode: F,
    stopCellEditMode: _
  }, H = {
    setCellEditingEditCellValue: D,
    getRowWithUpdatedValuesFromCellEditing: L
  };
  Ut(e, B, "public"), Ut(e, H, "private"), m.useEffect(() => {
    c && T(c);
  }, [c, T]), Zr(() => {
    const k = Am(e), N = i.current;
    i.current = xN(n), Object.entries(n).forEach(([j, W]) => {
      Object.entries(W).forEach(([V, $]) => {
        var K, Q;
        const z = ((Q = (K = N[j]) == null ? void 0 : K[V]) == null ? void 0 : Q.mode) || En.View, ne = k[j] ?? j;
        $.mode === En.Edit && z === En.View ? A(U({
          id: ne,
          field: V
        }, $)) : $.mode === En.View && z === En.Edit && C(U({
          id: ne,
          field: V
        }, $));
      });
    });
  }, [e, n, A, C]);
}, Rhe = ["id"], _he = ["id"], khe = (e, t) => {
  const [n, r] = m.useState({}), o = m.useRef(n), i = m.useRef({}), a = m.useRef(void 0), l = m.useRef(null), {
    processRowUpdate: c,
    onProcessRowUpdateError: d,
    rowModesModel: f,
    onRowModesModelChange: p
  } = t, g = (V) => (...$) => {
    t.editMode === Us.Row && V(...$);
  }, b = m.useCallback((V, $) => {
    const z = e.current.getCellParams(V, $);
    if (!e.current.isCellEditable(z))
      throw new Error(`MUI X: The cell with id=${V} and field=${$} is not editable.`);
  }, [e]), v = m.useCallback((V, $) => {
    if (e.current.getRowMode(V) !== $)
      throw new Error(`MUI X: The row with id=${V} is not in ${$} mode.`);
  }, [e]), y = m.useCallback((V) => {
    const $ = Qr(e.current.state);
    return Object.values($[V]).some((z) => z.error);
  }, [e]), S = m.useCallback((V, $) => {
    if (!V.isEditable || e.current.getRowMode(V.id) === Dn.Edit)
      return;
    const z = e.current.getRowParams(V.id), ne = U({}, z, {
      field: V.field,
      reason: Wa.cellDoubleClick
    });
    e.current.publishEvent("rowEditStart", ne, $);
  }, [e]), E = m.useCallback((V) => {
    l.current = V;
  }, []), I = m.useCallback((V, $) => {
    V.isEditable && e.current.getRowMode(V.id) !== Dn.View && (l.current = null, a.current = setTimeout(() => {
      var z;
      if (((z = l.current) == null ? void 0 : z.id) !== V.id) {
        if (!e.current.getRow(V.id) || e.current.getRowMode(V.id) === Dn.View || y(V.id))
          return;
        const ne = e.current.getRowParams(V.id), K = U({}, ne, {
          field: V.field,
          reason: ms.rowFocusOut
        });
        e.current.publishEvent("rowEditStop", K, $);
      }
    }));
  }, [e, y]);
  m.useEffect(() => () => {
    clearTimeout(a.current);
  }, []);
  const O = m.useCallback((V, $) => {
    if (V.cellMode === Dn.Edit) {
      if ($.which === 229)
        return;
      let z;
      if ($.key === "Escape")
        z = ms.escapeKeyDown;
      else if ($.key === "Enter")
        z = ms.enterKeyDown;
      else if ($.key === "Tab") {
        const ne = Ad(e).filter((K) => e.current.getColumn(K).type === ny ? !0 : e.current.isCellEditable(e.current.getCellParams(V.id, K)));
        if ($.shiftKey ? V.field === ne[0] && (z = ms.shiftTabKeyDown) : V.field === ne[ne.length - 1] && (z = ms.tabKeyDown), $.preventDefault(), !z) {
          const K = ne.findIndex((re) => re === V.field), Q = ne[$.shiftKey ? K - 1 : K + 1];
          e.current.setCellFocus(V.id, Q);
        }
      }
      if (z) {
        if (z !== ms.escapeKeyDown && y(V.id))
          return;
        const ne = U({}, e.current.getRowParams(V.id), {
          reason: z,
          field: V.field
        });
        e.current.publishEvent("rowEditStop", ne, $);
      }
    } else if (V.isEditable) {
      let z;
      if (!e.current.unstable_applyPipeProcessors("canStartEditing", !0, {
        event: $,
        cellParams: V,
        editMode: "row"
      }))
        return;
      if (FF($) || LF($) ? z = Wa.printableKeyDown : $.key === "Enter" ? z = Wa.enterKeyDown : ($.key === "Backspace" || $.key === "Delete") && (z = Wa.deleteKeyDown), z) {
        const K = e.current.getRowParams(V.id), Q = U({}, K, {
          field: V.field,
          reason: z
        });
        e.current.publishEvent("rowEditStart", Q, $);
      }
    }
  }, [e, y]), T = m.useCallback((V) => {
    const {
      id: $,
      field: z,
      reason: ne
    } = V, K = {
      id: $,
      fieldToFocus: z
    };
    (ne === Wa.printableKeyDown || ne === Wa.deleteKeyDown) && (K.deleteValue = !!z), e.current.startRowEditMode(K);
  }, [e]), P = m.useCallback((V) => {
    const {
      id: $,
      reason: z,
      field: ne
    } = V;
    e.current.runPendingEditCellValueMutation($);
    let K;
    z === ms.enterKeyDown ? K = "below" : z === ms.tabKeyDown ? K = "right" : z === ms.shiftTabKeyDown && (K = "left");
    const Q = z === "escapeKeyDown";
    e.current.stopRowEditMode({
      id: $,
      ignoreModifications: Q,
      field: ne,
      cellToFocusAfter: K
    });
  }, [e]);
  it(e, "cellDoubleClick", g(S)), it(e, "cellFocusIn", g(E)), it(e, "cellFocusOut", g(I)), it(e, "cellKeyDown", g(O)), it(e, "rowEditStart", g(T)), it(e, "rowEditStop", g(P)), Nn(e, "rowEditStart", t.onRowEditStart), Nn(e, "rowEditStop", t.onRowEditStop);
  const R = m.useCallback((V) => {
    if (t.editMode === Us.Cell)
      return Dn.View;
    const $ = Qr(e.current.state);
    return $[V] && Object.keys($[V]).length > 0 ? Dn.Edit : Dn.View;
  }, [e, t.editMode]), F = Yn((V) => {
    const $ = V !== t.rowModesModel;
    p && $ && p(V, {
      api: e.current
    }), !(t.rowModesModel && $) && (r(V), o.current = V, e.current.publishEvent("rowModesModelChange", V));
  }), A = m.useCallback((V, $) => {
    const z = U({}, o.current);
    $ !== null ? z[V] = U({}, $) : delete z[V], F(z);
  }, [F]), _ = m.useCallback((V, $) => {
    e.current.setState((z) => {
      const ne = U({}, z.editRows);
      return $ !== null ? ne[V] = $ : delete ne[V], U({}, z, {
        editRows: ne
      });
    }), e.current.forceUpdate();
  }, [e]), C = m.useCallback((V, $, z) => {
    e.current.setState((ne) => {
      const K = U({}, ne.editRows);
      return z !== null ? K[V] = U({}, K[V], {
        [$]: U({}, z)
      }) : (delete K[V][$], Object.keys(K[V]).length === 0 && delete K[V]), U({}, ne, {
        editRows: K
      });
    }), e.current.forceUpdate();
  }, [e]), D = m.useCallback((V) => {
    const {
      id: $
    } = V, z = yt(V, Rhe);
    v($, Dn.View), A($, U({
      mode: Dn.Edit
    }, z));
  }, [v, A]), L = Yn((V) => {
    const {
      id: $,
      fieldToFocus: z,
      deleteValue: ne,
      initialValue: K
    } = V, Q = ha(e), re = Q.reduce((te, ie) => {
      if (!e.current.getCellParams($, ie).isEditable)
        return te;
      const ce = e.current.getColumn(ie);
      let le = e.current.getCellValue($, ie);
      return z === ie && (ne || K) && (ne ? le = aC(ce) : K && (le = K)), te[ie] = {
        value: le,
        error: !1,
        isProcessingProps: !!ce.preProcessEditCellProps && ne
      }, te;
    }, {});
    _($, re), z && e.current.setCellFocus($, z), Q.filter((te) => !!e.current.getColumn(te).preProcessEditCellProps && ne).forEach((te) => {
      const ie = e.current.getColumn(te), ae = e.current.getCellValue($, te), ce = ne ? aC(ie) : K ?? ae;
      Promise.resolve(ie.preProcessEditCellProps({
        id: $,
        row: e.current.getRow($),
        props: re[te],
        hasChanged: ce !== ae
      })).then((le) => {
        if (e.current.getRowMode($) === Dn.Edit) {
          const we = Qr(e.current.state);
          C($, te, U({}, le, {
            value: we[$][te].value,
            isProcessingProps: !1
          }));
        }
      });
    });
  }), B = m.useCallback((V) => {
    const {
      id: $
    } = V, z = yt(V, _he);
    v($, Dn.Edit), A($, U({
      mode: Dn.View
    }, z));
  }, [v, A]), H = Yn((V) => {
    const {
      id: $,
      ignoreModifications: z,
      field: ne,
      cellToFocusAfter: K = "none"
    } = V;
    e.current.runPendingEditCellValueMutation($);
    const Q = () => {
      K !== "none" && ne && e.current.moveFocusToRelativeCell($, ne, K), _($, null), A($, null);
    };
    if (z) {
      Q();
      return;
    }
    const re = Qr(e.current.state), te = e.current.getRow($);
    if (Object.values(re[$]).some((ce) => ce.isProcessingProps)) {
      i.current[$].mode = Dn.Edit;
      return;
    }
    if (y($)) {
      i.current[$].mode = Dn.Edit, A($, {
        mode: Dn.Edit
      });
      return;
    }
    const ae = e.current.getRowWithUpdatedValuesFromRowEditing($);
    if (c) {
      const ce = (le) => {
        i.current[$].mode = Dn.Edit, A($, {
          mode: Dn.Edit
        }), d ? d(le) : process.env.NODE_ENV !== "production" && ns(["MUI X: A call to `processRowUpdate` threw an error which was not handled because `onProcessRowUpdateError` is missing.", "To handle the error pass a callback to the `onProcessRowUpdateError` prop, for example `<DataGrid onProcessRowUpdateError={(error) => ...} />`.", "For more detail, see https://mui.com/x/react-data-grid/editing/#server-side-persistence."], "error");
      };
      try {
        Promise.resolve(c(ae, te, {
          rowId: $
        })).then((le) => {
          e.current.updateRows([le]), Q();
        }).catch(ce);
      } catch (le) {
        ce(le);
      }
    } else
      e.current.updateRows([ae]), Q();
  }), k = m.useCallback((V) => {
    const {
      id: $,
      field: z,
      value: ne,
      debounceMs: K,
      unstable_skipValueParser: Q
    } = V;
    b($, z);
    const re = e.current.getColumn(z), te = e.current.getRow($);
    let ie = ne;
    re.valueParser && !Q && (ie = re.valueParser(ne, te, re, e));
    let ae = Qr(e.current.state), ce = U({}, ae[$][z], {
      value: ie,
      changeReason: K ? "debouncedSetEditCellValue" : "setEditCellValue"
    });
    return re.preProcessEditCellProps || C($, z, ce), new Promise((le) => {
      const we = [];
      if (re.preProcessEditCellProps) {
        const q = ce.value !== ae[$][z].value;
        ce = U({}, ce, {
          isProcessingProps: !0
        }), C($, z, ce);
        const Ee = ae[$], _e = yt(Ee, [z].map(Ep)), $e = Promise.resolve(re.preProcessEditCellProps({
          id: $,
          row: te,
          props: ce,
          hasChanged: q,
          otherFieldsProps: _e
        })).then((Le) => {
          if (e.current.getRowMode($) === Dn.View) {
            le(!1);
            return;
          }
          ae = Qr(e.current.state), Le = U({}, Le, {
            isProcessingProps: !1
          }), Le.value = re.preProcessEditCellProps ? ae[$][z].value : ie, C($, z, Le);
        });
        we.push($e);
      }
      Object.entries(ae[$]).forEach(([q, Ee]) => {
        if (q === z)
          return;
        const _e = e.current.getColumn(q);
        if (!_e.preProcessEditCellProps)
          return;
        Ee = U({}, Ee, {
          isProcessingProps: !0
        }), C($, q, Ee), ae = Qr(e.current.state);
        const $e = ae[$], Le = yt($e, [q].map(Ep)), Ze = Promise.resolve(_e.preProcessEditCellProps({
          id: $,
          row: te,
          props: Ee,
          hasChanged: !1,
          otherFieldsProps: Le
        })).then((J) => {
          if (e.current.getRowMode($) === Dn.View) {
            le(!1);
            return;
          }
          J = U({}, J, {
            isProcessingProps: !1
          }), C($, q, J);
        });
        we.push(Ze);
      }), Promise.all(we).then(() => {
        e.current.getRowMode($) === Dn.Edit ? (ae = Qr(e.current.state), le(!ae[$][z].error)) : le(!1);
      });
    });
  }, [e, b, C]), N = m.useCallback((V) => {
    const $ = Qr(e.current.state), z = e.current.getRow(V);
    if (!$[V])
      return e.current.getRow(V);
    let ne = U({}, z);
    return Object.entries($[V]).forEach(([K, Q]) => {
      const re = e.current.getColumn(K);
      re.valueSetter ? ne = re.valueSetter(Q.value, ne, re, e) : ne[K] = Q.value;
    }), ne;
  }, [e]), j = {
    getRowMode: R,
    startRowEditMode: D,
    stopRowEditMode: B
  }, W = {
    setRowEditingEditCellValue: k,
    getRowWithUpdatedValuesFromRowEditing: N
  };
  Ut(e, j, "public"), Ut(e, W, "private"), m.useEffect(() => {
    f && F(f);
  }, [f, F]), Zr(() => {
    const V = Am(e), $ = i.current;
    i.current = xN(n);
    const z = /* @__PURE__ */ new Set([...Object.keys(n), ...Object.keys($)]);
    Array.from(z).forEach((ne) => {
      var te;
      const K = n[ne] ?? {
        mode: Dn.View
      }, Q = ((te = $[ne]) == null ? void 0 : te.mode) || Dn.View, re = V[ne] ?? ne;
      K.mode === Dn.Edit && Q === Dn.View ? L(U({
        id: re
      }, K)) : K.mode === Dn.View && Q === Dn.Edit && H(U({
        id: re
      }, K));
    });
  }, [e, n, L, H]);
}, Mhe = (e) => U({}, e, {
  editRows: {}
}), Ahe = (e, t) => {
  Ihe(e, t), khe(e, t);
  const n = m.useRef({}), {
    isCellEditable: r
  } = t, o = m.useCallback((g) => vd(g.rowNode) || !g.colDef.editable || !g.colDef.renderEditCell ? !1 : r ? r(g) : !0, [r]), i = (g, b, v, y) => {
    if (!v) {
      y();
      return;
    }
    if (n.current[g] || (n.current[g] = {}), n.current[g][b]) {
      const [I] = n.current[g][b];
      clearTimeout(I);
    }
    const S = () => {
      const [I] = n.current[g][b];
      clearTimeout(I), y(), delete n.current[g][b];
    }, E = setTimeout(() => {
      y(), delete n.current[g][b];
    }, v);
    n.current[g][b] = [E, S];
  };
  m.useEffect(() => {
    const g = n.current;
    return () => {
      Object.entries(g).forEach(([b, v]) => {
        Object.keys(v).forEach((y) => {
          const [S] = g[b][y];
          clearTimeout(S), delete g[b][y];
        });
      });
    };
  }, []);
  const a = m.useCallback((g, b) => {
    if (n.current[g]) {
      if (!b)
        Object.keys(n.current[g]).forEach((v) => {
          const [, y] = n.current[g][v];
          y();
        });
      else if (n.current[g][b]) {
        const [, v] = n.current[g][b];
        v();
      }
    }
  }, []), l = m.useCallback((g) => {
    const {
      id: b,
      field: v,
      debounceMs: y
    } = g;
    return new Promise((S) => {
      i(b, v, y, async () => {
        const E = t.editMode === Us.Row ? e.current.setRowEditingEditCellValue : e.current.setCellEditingEditCellValue;
        if (e.current.getCellMode(b, v) === En.Edit) {
          const I = await E(g);
          S(I);
        }
      });
    });
  }, [e, t.editMode]), c = m.useCallback((g, b) => t.editMode === Us.Cell ? e.current.getRowWithUpdatedValuesFromCellEditing(g, b) : e.current.getRowWithUpdatedValuesFromRowEditing(g), [e, t.editMode]), d = m.useCallback((g, b) => {
    var y;
    return ((y = Qr(e.current.state)[g]) == null ? void 0 : y[b]) ?? null;
  }, [e]), f = {
    isCellEditable: o,
    setEditCellValue: l,
    getRowWithUpdatedValues: c,
    unstable_getEditCellMeta: d
  }, p = {
    runPendingEditCellValueMutation: a
  };
  Ut(e, f, "public"), Ut(e, p, "private");
}, Dhe = (e, t, n) => {
  const r = !!t.unstable_dataSource;
  return n.current.caches.rows = qg({
    rows: r ? [] : t.rows,
    getRowId: t.getRowId,
    loading: t.loading,
    rowCount: t.rowCount
  }), U({}, e, {
    rows: _N({
      apiRef: n,
      rowCountProp: t.rowCount,
      loadingProp: r ? !0 : t.loading,
      previousTree: null,
      previousTreeDepths: null
    })
  });
}, Nhe = (e, t) => {
  if (process.env.NODE_ENV !== "production")
    try {
      Object.freeze(t.rows);
    } catch {
    }
  const n = zr(e, "useGridRows"), r = Fc(e, t), o = m.useRef(Date.now()), i = m.useRef(t.rowCount), a = Pd(), l = m.useCallback((W) => {
    const V = cl(e)[W];
    if (V)
      return V;
    const $ = e.current.getRowNode(W);
    return $ && vd($) ? {
      [Hu]: W
    } : null;
  }, [e]), c = t.getRowId, d = m.useCallback((W) => Hu in W ? W[Hu] : c ? c(W) : W.id, [c]), f = m.useMemo(() => r.rows.reduce((W, {
    id: V
  }, $) => (W[V] = $, W), {}), [r.rows]), p = m.useCallback(({
    cache: W,
    throttle: V
  }) => {
    const $ = () => {
      o.current = Date.now(), e.current.setState((ne) => U({}, ne, {
        rows: _N({
          apiRef: e,
          rowCountProp: t.rowCount,
          loadingProp: t.loading,
          previousTree: so(e),
          previousTreeDepths: tR(e),
          previousGroupsToFetch: ple(e)
        })
      })), e.current.publishEvent("rowsSet"), e.current.forceUpdate();
    };
    if (a.clear(), e.current.caches.rows = W, !V) {
      $();
      return;
    }
    const z = t.throttleRowsMs - (Date.now() - o.current);
    if (z > 0) {
      a.start(z, $);
      return;
    }
    $();
  }, [t.throttleRowsMs, t.rowCount, t.loading, e, a]), g = m.useCallback((W) => {
    n.debug(`Updating all rows, new length ${W.length}`);
    const V = qg({
      rows: W,
      getRowId: t.getRowId,
      loading: t.loading,
      rowCount: t.rowCount
    }), $ = e.current.caches.rows;
    V.rowsBeforePartialUpdates = $.rowsBeforePartialUpdates, p({
      cache: V,
      throttle: !0
    });
  }, [n, t.getRowId, t.loading, t.rowCount, p, e]), b = m.useCallback((W) => {
    if (t.signature === di.DataGrid && W.length > 1)
      throw new Error(["MUI X: You cannot update several rows at once in `apiRef.current.updateRows` on the DataGrid.", "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."].join(`
`));
    const V = rR(e, W, t.getRowId), $ = nR({
      updates: V,
      getRowId: t.getRowId,
      previousCache: e.current.caches.rows
    });
    p({
      cache: $,
      throttle: !0
    });
  }, [t.signature, t.getRowId, p, e]), v = m.useCallback((W, V) => {
    const $ = rR(e, W, t.getRowId), z = nR({
      updates: $,
      getRowId: t.getRowId,
      previousCache: e.current.caches.rows,
      groupKeys: V ?? []
    });
    p({
      cache: z,
      throttle: !1
    });
  }, [t.getRowId, p, e]), y = m.useCallback((W) => {
    W !== t.loading && (n.debug(`Setting loading to ${W}`), e.current.setState((V) => U({}, V, {
      rows: U({}, V.rows, {
        loading: W
      })
    })), e.current.caches.rows.loadingPropBeforePartialUpdates = W);
  }, [t.loading, e, n]), S = m.useCallback(() => {
    const W = Og(e), V = cl(e);
    return new Map(W.map(($) => [$, V[$] ?? {}]));
  }, [e]), E = m.useCallback(() => ry(e), [e]), I = m.useCallback(() => Og(e), [e]), O = m.useCallback((W) => f[W], [f]), T = m.useCallback((W, V) => {
    const $ = e.current.getRowNode(W);
    if (!$)
      throw new Error(`MUI X: No row with id #${W} found.`);
    if ($.type !== "group")
      throw new Error("MUI X: Only group nodes can be expanded or collapsed.");
    const z = U({}, $, {
      childrenExpanded: V
    });
    e.current.setState((ne) => U({}, ne, {
      rows: U({}, ne.rows, {
        tree: U({}, ne.rows.tree, {
          [W]: z
        })
      })
    })), e.current.forceUpdate(), e.current.publishEvent("rowExpansionChange", z);
  }, [e]), P = m.useCallback((W) => so(e)[W] ?? null, [e]), R = m.useCallback(({
    skipAutoGeneratedRows: W = !0,
    groupId: V,
    applySorting: $,
    applyFiltering: z
  }) => {
    const ne = so(e);
    let K;
    if ($) {
      const Q = ne[V];
      if (!Q)
        return [];
      const re = Nd(e);
      K = [];
      const te = re.findIndex((ie) => ie === V) + 1;
      for (let ie = te; ie < re.length && ne[re[ie]].depth > Q.depth; ie += 1) {
        const ae = re[ie];
        (!W || !vd(ne[ae])) && K.push(ae);
      }
    } else
      K = xS(ne, V, W);
    if (z) {
      const Q = Fd(e);
      K = K.filter((re) => Q[re] !== !1);
    }
    return K;
  }, [e]), F = m.useCallback((W, V) => {
    const $ = e.current.getRowNode(W);
    if (!$)
      throw new Error(`MUI X: No row with id #${W} found.`);
    if ($.parent !== ao)
      throw new Error("MUI X: The row reordering do not support reordering of grouped rows yet.");
    if ($.type !== "leaf")
      throw new Error("MUI X: The row reordering do not support reordering of footer or grouping rows.");
    e.current.setState((z) => {
      const ne = so(z, e.current.instanceId)[ao], K = ne.children, Q = K.findIndex((te) => te === W);
      if (Q === -1 || Q === V)
        return z;
      n.debug(`Moving row ${W} to index ${V}`);
      const re = [...K];
      return re.splice(V, 0, re.splice(Q, 1)[0]), U({}, z, {
        rows: U({}, z.rows, {
          tree: U({}, z.rows.tree, {
            [ao]: U({}, ne, {
              children: re
            })
          })
        })
      });
    }), e.current.publishEvent("rowsSet");
  }, [e, n]), A = m.useCallback((W, V) => {
    if (t.signature === di.DataGrid && V.length > 1)
      throw new Error(["MUI X: You cannot replace rows using `apiRef.current.unstable_replaceRows` on the DataGrid.", "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."].join(`
`));
    if (V.length === 0)
      return;
    if (Dd(e) > 1)
      throw new Error("`apiRef.current.unstable_replaceRows` is not compatible with tree data and row grouping");
    const z = U({}, so(e)), ne = U({}, cl(e)), K = U({}, Am(e)), Q = z[ao], re = [...Q.children], te = /* @__PURE__ */ new Set();
    for (let ae = 0; ae < V.length; ae += 1) {
      const ce = V[ae], le = oy(ce, t.getRowId, "A row was provided without id when calling replaceRows()."), [we] = re.splice(W + ae, 1, le);
      te.has(we) || (delete ne[we], delete K[we], delete z[we]);
      const q = {
        id: le,
        depth: 0,
        parent: ao,
        type: "leaf",
        groupingKey: null
      };
      ne[le] = ce, K[le] = le, z[le] = q, te.add(le);
    }
    z[ao] = U({}, Q, {
      children: re
    });
    const ie = re.filter((ae) => {
      var ce;
      return ((ce = z[ae]) == null ? void 0 : ce.type) === "leaf";
    });
    e.current.caches.rows.dataRowIdToModelLookup = ne, e.current.caches.rows.dataRowIdToIdLookup = K, e.current.setState((ae) => U({}, ae, {
      rows: U({}, ae.rows, {
        dataRowIdToModelLookup: ne,
        dataRowIdToIdLookup: K,
        dataRowIds: ie,
        tree: z
      })
    })), e.current.publishEvent("rowsSet");
  }, [e, t.signature, t.getRowId]), _ = {
    getRow: l,
    setLoading: y,
    getRowId: d,
    getRowModels: S,
    getRowsCount: E,
    getAllRowIds: I,
    setRows: g,
    updateRows: b,
    getRowNode: P,
    getRowIndexRelativeToVisibleRows: O,
    unstable_replaceRows: A
  }, C = {
    setRowIndex: F,
    setRowChildrenExpansion: T,
    getRowGroupChildren: R
  }, D = {
    updateServerRows: v
  }, L = m.useCallback(() => {
    n.info("Row grouping pre-processing have changed, regenerating the row tree");
    let W;
    e.current.caches.rows.rowsBeforePartialUpdates === t.rows ? W = U({}, e.current.caches.rows, {
      updates: {
        type: "full",
        rows: Og(e)
      }
    }) : W = qg({
      rows: t.rows,
      getRowId: t.getRowId,
      loading: t.loading,
      rowCount: t.rowCount
    }), p({
      cache: W,
      throttle: !1
    });
  }, [n, e, t.rows, t.getRowId, t.loading, t.rowCount, p]), B = Ws(() => t.unstable_dataSource), H = m.useCallback((W) => {
    if (t.unstable_dataSource && t.unstable_dataSource !== B.current) {
      B.current = t.unstable_dataSource;
      return;
    }
    W === "rowTreeCreation" && L();
  }, [L, B, t.unstable_dataSource]), k = m.useCallback(() => {
    e.current.getActiveStrategy("rowTree") !== hle(e) && L();
  }, [e, L]);
  it(e, "activeStrategyProcessorChange", H), it(e, "strategyAvailabilityChange", k);
  const N = m.useCallback(() => {
    e.current.setState((W) => {
      const V = e.current.unstable_applyPipeProcessors("hydrateRows", {
        tree: so(W, e.current.instanceId),
        treeDepths: tR(W, e.current.instanceId),
        dataRowIds: Og(W, e.current.instanceId),
        dataRowIdToModelLookup: cl(W, e.current.instanceId),
        dataRowIdToIdLookup: Am(W, e.current.instanceId)
      });
      return U({}, W, {
        rows: U({}, W.rows, V, {
          totalTopLevelRowCount: RN({
            tree: V.tree,
            rowCountProp: t.rowCount
          })
        })
      });
    }), e.current.publishEvent("rowsSet"), e.current.forceUpdate();
  }, [e, t.rowCount]);
  BS(e, "hydrateRows", N), Ut(e, _, "public"), Ut(e, C, t.signature === di.DataGrid ? "private" : "public"), Ut(e, D, "private");
  const j = m.useRef(!0);
  m.useEffect(() => {
    var ne;
    if (j.current) {
      j.current = !1;
      return;
    }
    let W = !1;
    t.rowCount !== i.current && (W = !0, i.current = t.rowCount);
    const V = e.current.caches.rows.rowsBeforePartialUpdates === t.rows, $ = e.current.caches.rows.loadingPropBeforePartialUpdates === t.loading, z = e.current.caches.rows.rowCountPropBeforePartialUpdates === t.rowCount;
    V && ($ || (e.current.setState((K) => U({}, K, {
      rows: U({}, K.rows, {
        loading: t.loading
      })
    })), e.current.caches.rows.loadingPropBeforePartialUpdates = t.loading, e.current.forceUpdate()), z || (e.current.setState((K) => U({}, K, {
      rows: U({}, K.rows, {
        totalRowCount: Math.max(t.rowCount || 0, K.rows.totalRowCount),
        totalTopLevelRowCount: Math.max(t.rowCount || 0, K.rows.totalTopLevelRowCount)
      })
    })), e.current.caches.rows.rowCountPropBeforePartialUpdates = t.rowCount, e.current.forceUpdate()), !W) || (n.debug(`Updating all rows, new length ${(ne = t.rows) == null ? void 0 : ne.length}`), p({
      cache: qg({
        rows: t.rows,
        getRowId: t.getRowId,
        loading: t.loading,
        rowCount: t.rowCount
      }),
      throttle: !1
    }));
  }, [t.rows, t.rowCount, t.getRowId, t.loading, n, p, e]);
}, Fhe = (e) => {
  const t = {
    [ao]: U({}, mle(), {
      children: e
    })
  };
  for (let n = 0; n < e.length; n += 1) {
    const r = e[n];
    t[r] = {
      id: r,
      depth: 0,
      parent: ao,
      type: "leaf",
      groupingKey: null
    };
  }
  return {
    groupingName: Tc,
    tree: t,
    treeDepths: {
      0: e.length
    },
    dataRowIds: e
  };
}, $he = ({
  previousTree: e,
  actions: t
}) => {
  const n = U({}, e), r = {};
  for (let a = 0; a < t.remove.length; a += 1) {
    const l = t.remove[a];
    r[l] = !0, delete n[l];
  }
  for (let a = 0; a < t.insert.length; a += 1) {
    const l = t.insert[a];
    n[l] = {
      id: l,
      depth: 0,
      parent: ao,
      type: "leaf",
      groupingKey: null
    };
  }
  const o = n[ao];
  let i = [...o.children, ...t.insert];
  return Object.values(r).length && (i = i.filter((a) => !r[a])), n[ao] = U({}, o, {
    children: i
  }), {
    groupingName: Tc,
    tree: n,
    treeDepths: {
      0: i.length
    },
    dataRowIds: i
  };
}, Lhe = (e) => e.updates.type === "full" ? Fhe(e.updates.rows) : $he({
  previousTree: e.previousTree,
  actions: e.updates.actions
}), jhe = (e) => {
  Lm(e, Tc, "rowTreeCreation", Lhe);
};
class Aw extends Error {
}
function Bhe(e, t) {
  const n = m.useCallback((g) => ({
    field: g,
    colDef: e.current.getColumn(g)
  }), [e]), r = m.useCallback((g) => {
    const b = e.current.getRow(g);
    if (!b)
      throw new Aw(`No row with id #${g} found`);
    return {
      id: g,
      columns: e.current.getAllColumns(),
      row: b
    };
  }, [e]), o = m.useCallback((g, b) => {
    const v = t.unstable_listView ? Cd(e.current.state) : e.current.getColumn(b), y = e.current.getRow(g), S = e.current.getRowNode(g);
    if (!y || !S)
      throw new Aw(`No row with id #${g} found`);
    const E = y[b], I = v != null && v.valueGetter ? v.valueGetter(E, y, v, e) : E, O = jo(e), T = PS(e), P = {
      id: g,
      field: b,
      row: y,
      rowNode: S,
      colDef: v,
      cellMode: e.current.getCellMode(g, b),
      hasFocus: O !== null && O.field === b && O.id === g,
      tabIndex: T && T.field === b && T.id === g ? 0 : -1,
      value: I,
      formattedValue: I,
      isEditable: !1,
      api: {}
    };
    return v && v.valueFormatter && (P.formattedValue = v.valueFormatter(I, y, v, e)), P.isEditable = v && e.current.isCellEditable(P), P;
  }, [e, t.unstable_listView]), i = m.useCallback((g, b) => {
    const v = e.current.getColumn(b), y = e.current.getRow(g);
    if (!y)
      throw new Aw(`No row with id #${g} found`);
    return !v || !v.valueGetter ? y[b] : v.valueGetter(y[v.field], y, v, e);
  }, [e]), a = m.useCallback((g, b) => {
    const v = b.field;
    if (!b || !b.valueGetter)
      return g[v];
    const y = g[b.field];
    return b.valueGetter(y, g, b, e);
  }, [e]), l = m.useCallback((g, b) => {
    const v = a(g, b);
    return !b || !b.valueFormatter ? v : b.valueFormatter(v, g, b, e);
  }, [e, a]), c = m.useCallback((g) => e.current.rootElementRef.current ? Cde(e.current.rootElementRef.current, g) : null, [e]), d = m.useCallback((g) => e.current.rootElementRef.current ? xde(e.current.rootElementRef.current, g) : null, [e]), f = m.useCallback((g, b) => e.current.rootElementRef.current ? Sde(e.current.rootElementRef.current, {
    id: g,
    field: b
  }) : null, [e]);
  Ut(e, {
    getCellValue: i,
    getCellParams: o,
    getCellElement: f,
    getRowValue: a,
    getRowFormattedValue: l,
    getRowParams: r,
    getRowElement: d,
    getColumnHeaderParams: n,
    getColumnHeaderElement: c
  }, "public");
}
const h$ = (e, t) => e == null || Array.isArray(e) ? e : t && t[0] === e ? t : [e], Vhe = (e, t) => U({}, e, {
  rowSelection: t.rowSelection ? h$(t.rowSelectionModel) ?? [] : []
}), Hhe = (e, t) => {
  var N, j, W, V, $, z, ne;
  const n = zr(e, "useGridSelection"), r = m.useCallback((K) => (...Q) => {
    t.rowSelection && K(...Q);
  }, [t.rowSelection]), o = t.signature !== di.DataGrid && (((N = t.rowSelectionPropagation) == null ? void 0 : N.parents) || ((j = t.rowSelectionPropagation) == null ? void 0 : j.descendants)), i = m.useMemo(() => h$(t.rowSelectionModel, Ri(e.current.state)), [e, t.rowSelectionModel]), a = m.useRef(null);
  e.current.registerControlState({
    stateId: "rowSelection",
    propModel: i,
    propOnChange: t.onRowSelectionModelChange,
    stateSelector: Ri,
    changeEvent: "rowSelectionChange"
  });
  const {
    checkboxSelection: l,
    disableRowSelectionOnClick: c,
    isRowSelectable: d
  } = t, f = OS(t), p = Fc(e, t), g = Be(e, so), b = Be(e, Dd) > 1, v = m.useCallback((K) => {
    let Q = K;
    const re = a.current ?? K, te = e.current.isRowSelected(K);
    if (te) {
      const ie = Uu(e), ae = ie.findIndex((le) => le === re), ce = ie.findIndex((le) => le === Q);
      if (ae === ce)
        return;
      ae > ce ? Q = ie[ce + 1] : Q = ie[ce - 1];
    }
    a.current = K, e.current.selectRowRange({
      startId: re,
      endId: Q
    }, !te);
  }, [e]), y = m.useCallback((K) => {
    if (t.signature === di.DataGrid && !f && Array.isArray(K) && K.length > 1)
      throw new Error(["MUI X: `rowSelectionModel` can only contain 1 item in DataGrid.", "You need to upgrade to DataGridPro or DataGridPremium component to unlock multiple selection."].join(`
`));
    Ri(e.current.state) !== K && (n.debug("Setting selection model"), e.current.setState((re) => U({}, re, {
      rowSelection: t.rowSelection ? K : []
    })), e.current.forceUpdate());
  }, [e, n, t.rowSelection, t.signature, f]), S = m.useCallback((K) => Ri(e.current.state).includes(K), [e]), E = m.useCallback((K) => {
    if (t.rowSelection === !1 || d && !d(e.current.getRowParams(K)))
      return !1;
    const Q = e.current.getRowNode(K);
    return !((Q == null ? void 0 : Q.type) === "footer" || (Q == null ? void 0 : Q.type) === "pinnedRow");
  }, [e, t.rowSelection, d]), I = m.useCallback(() => Ble(e), [e]), O = m.useCallback((K, Q = !0, re = !1) => {
    var te, ie, ae, ce, le, we;
    if (e.current.isRowSelectable(K))
      if (a.current = K, re) {
        n.debug(`Setting selection for row ${K}`);
        const q = [], Ee = (_e) => {
          q.push(_e);
        };
        Q && (Ee(K), o && Pg(e, g, K, ((te = t.rowSelectionPropagation) == null ? void 0 : te.descendants) ?? !1, ((ie = t.rowSelectionPropagation) == null ? void 0 : ie.parents) ?? !1, Ee)), e.current.setRowSelectionModel(q);
      } else {
        n.debug(`Toggling selection for row ${K}`);
        const q = Ri(e.current.state), Ee = new Set(q);
        Ee.delete(K);
        const _e = (Ze) => {
          Ee.add(Ze);
        }, $e = (Ze) => {
          Ee.delete(Ze);
        };
        Q ? (_e(K), o && Pg(e, g, K, ((ae = t.rowSelectionPropagation) == null ? void 0 : ae.descendants) ?? !1, ((ce = t.rowSelectionPropagation) == null ? void 0 : ce.parents) ?? !1, _e)) : o && iR(e, g, K, ((le = t.rowSelectionPropagation) == null ? void 0 : le.descendants) ?? !1, ((we = t.rowSelectionPropagation) == null ? void 0 : we.parents) ?? !1, $e), (Ee.size < 2 || f) && e.current.setRowSelectionModel(Array.from(Ee));
      }
  }, [e, n, o, g, (W = t.rowSelectionPropagation) == null ? void 0 : W.descendants, (V = t.rowSelectionPropagation) == null ? void 0 : V.parents, f]), T = m.useCallback((K, Q = !0, re = !1) => {
    n.debug("Setting selection for several rows");
    const te = K.filter((ce) => e.current.isRowSelectable(ce));
    let ie;
    if (re) {
      if (Q) {
        if (ie = new Set(te), o) {
          const le = (we) => {
            ie.add(we);
          };
          te.forEach((we) => {
            var q, Ee;
            Pg(e, g, we, ((q = t.rowSelectionPropagation) == null ? void 0 : q.descendants) ?? !1, ((Ee = t.rowSelectionPropagation) == null ? void 0 : Ee.parents) ?? !1, le);
          });
        }
      } else
        ie = /* @__PURE__ */ new Set();
      const ce = ga(e);
      if (ie.size === Object.keys(ce).length && Array.from(ie).every((le) => ce[le] === le))
        return;
    } else {
      ie = new Set(Object.values(ga(e)));
      const ce = (we) => {
        ie.add(we);
      }, le = (we) => {
        ie.delete(we);
      };
      te.forEach((we) => {
        var q, Ee, _e, $e;
        Q ? (ie.add(we), o && Pg(e, g, we, ((q = t.rowSelectionPropagation) == null ? void 0 : q.descendants) ?? !1, ((Ee = t.rowSelectionPropagation) == null ? void 0 : Ee.parents) ?? !1, ce)) : (le(we), o && iR(e, g, we, ((_e = t.rowSelectionPropagation) == null ? void 0 : _e.descendants) ?? !1, (($e = t.rowSelectionPropagation) == null ? void 0 : $e.parents) ?? !1, le));
      });
    }
    (ie.size < 2 || f) && e.current.setRowSelectionModel(Array.from(ie));
  }, [n, o, f, e, g, ($ = t.rowSelectionPropagation) == null ? void 0 : $.descendants, (z = t.rowSelectionPropagation) == null ? void 0 : z.parents]), P = m.useCallback(({
    startId: K,
    endId: Q
  }, re = !0, te = !1) => {
    if (!e.current.getRow(K) || !e.current.getRow(Q))
      return;
    n.debug(`Expanding selection from row ${K} to row ${Q}`);
    const ie = Uu(e), ae = ie.indexOf(K), ce = ie.indexOf(Q), [le, we] = ae > ce ? [ce, ae] : [ae, ce], q = ie.slice(le, we + 1);
    e.current.selectRows(q, re, te);
  }, [e, n]), R = {
    selectRow: O,
    setRowSelectionModel: y,
    getSelectedRows: I,
    isRowSelected: S,
    isRowSelectable: E
  }, F = {
    selectRows: T,
    selectRowRange: P
  };
  Ut(e, R, "public"), Ut(e, F, t.signature === di.DataGrid ? "private" : "public");
  const A = m.useCallback((K = !1) => {
    var we;
    const Q = Ri(e.current.state), re = cl(e), te = Fd(e), ie = U({}, ga(e)), ae = (q) => t.filterMode === "server" ? !re[q] : te[q] !== !0;
    let ce = !1;
    Q.forEach((q) => {
      var _e;
      if (ae(q)) {
        if (t.keepNonExistentRowsSelected)
          return;
        delete ie[q], ce = !0;
        return;
      }
      if (!((_e = t.rowSelectionPropagation) != null && _e.parents))
        return;
      const Ee = g[q];
      if (Ee.type === "group") {
        if (Ee.isAutoGenerated) {
          delete ie[q], ce = !0;
          return;
        }
        Ee.children.every((Le) => te[Le] === !1) || (delete ie[q], ce = !0);
      }
    });
    const le = b && ((we = t.rowSelectionPropagation) == null ? void 0 : we.parents) && Object.keys(ie).length > 0;
    if (ce || le && !K) {
      const q = Object.values(ie);
      le ? e.current.selectRows(q, !0, !0) : e.current.setRowSelectionModel(q);
    }
  }, [e, b, (ne = t.rowSelectionPropagation) == null ? void 0 : ne.parents, t.keepNonExistentRowsSelected, t.filterMode, g]), _ = m.useCallback((K, Q) => {
    const re = Q.metaKey || Q.ctrlKey, te = !l && !re && !mfe(Q), ie = !f || te, ae = e.current.isRowSelected(K);
    ie ? e.current.selectRow(K, te ? !0 : !ae, !0) : e.current.selectRow(K, !ae, !1);
  }, [e, f, l]), C = m.useCallback((K, Q) => {
    var ie;
    if (c)
      return;
    const re = (ie = Q.target.closest(`.${ee.cell}`)) == null ? void 0 : ie.getAttribute("data-field");
    if (re === $d.field || re === iy)
      return;
    if (re) {
      const ae = e.current.getColumn(re);
      if ((ae == null ? void 0 : ae.type) === ny)
        return;
    }
    e.current.getRowNode(K.id).type !== "pinnedRow" && (Q.shiftKey && f ? v(K.id) : _(K.id, Q));
  }, [c, f, e, v, _]), D = m.useCallback((K, Q) => {
    var re;
    f && Q.shiftKey && ((re = window.getSelection()) == null || re.removeAllRanges());
  }, [f]), L = m.useCallback((K, Q) => {
    f && Q.nativeEvent.shiftKey ? v(K.id) : e.current.selectRow(K.id, K.value, !f);
  }, [e, v, f]), B = m.useCallback((K) => {
    const Q = t.pagination && t.checkboxSelectionVisibleOnly && t.paginationMode === "client" ? QN(e) : Uu(e);
    e.current.selectRows(Q, K.value);
  }, [e, t.checkboxSelectionVisibleOnly, t.pagination, t.paginationMode]), H = m.useCallback((K, Q) => {
    if (e.current.getCellMode(K.id, K.field) !== En.Edit && !ph(Q)) {
      if ($m(Q.key) && Q.shiftKey) {
        const re = jo(e);
        if (re && re.id !== K.id) {
          Q.preventDefault();
          const te = e.current.isRowSelected(re.id);
          if (!f) {
            e.current.selectRow(re.id, !te, !0);
            return;
          }
          const ie = e.current.getRowIndexRelativeToVisibleRows(re.id), ae = e.current.getRowIndexRelativeToVisibleRows(K.id);
          let ce, le;
          ie > ae ? te ? (ce = ae, le = ie - 1) : (ce = ae, le = ie) : te ? (ce = ie + 1, le = ae) : (ce = ie, le = ae);
          const we = p.rows.slice(ce, le + 1).map((q) => q.id);
          e.current.selectRows(we, !te);
          return;
        }
      }
      if (Q.key === " " && Q.shiftKey) {
        Q.preventDefault(), _(K.id, Q);
        return;
      }
      String.fromCharCode(Q.keyCode) === "A" && (Q.ctrlKey || Q.metaKey) && (Q.preventDefault(), T(e.current.getAllRowIds(), !0));
    }
  }, [e, _, T, p.rows, f]);
  it(e, "sortedRowsSet", r(() => A(!0))), it(e, "filteredRowsSet", r(A)), it(e, "rowClick", r(C)), it(e, "rowSelectionCheckboxChange", r(L)), it(e, "headerSelectionCheckboxChange", B), it(e, "cellMouseDown", r(D)), it(e, "cellKeyDown", r(H)), m.useEffect(() => {
    i !== void 0 && e.current.setRowSelectionModel(i);
  }, [e, i, t.rowSelection]), m.useEffect(() => {
    t.rowSelection || e.current.setRowSelectionModel([]);
  }, [e, t.rowSelection]);
  const k = i != null;
  m.useEffect(() => {
    if (k || !t.rowSelection)
      return;
    const K = Ri(e.current.state);
    if (E) {
      const Q = K.filter((re) => E(re));
      Q.length < K.length && e.current.setRowSelectionModel(Q);
    }
  }, [e, E, k, t.rowSelection]), m.useEffect(() => {
    if (!t.rowSelection || k)
      return;
    const K = Ri(e.current.state);
    !f && K.length > 1 && e.current.setRowSelectionModel([]);
  }, [e, f, l, k, t.rowSelection]), m.useEffect(() => {
    r(A);
  }, [A, r]);
}, Uhe = (e) => {
  const {
    classes: t
  } = e;
  return m.useMemo(() => tn({
    cellCheckbox: ["cellCheckbox"],
    columnHeaderCheckbox: ["columnHeaderCheckbox"]
  }, nn, t), [t]);
}, zhe = (e, t) => {
  const n = {
    classes: t.classes
  }, r = Uhe(n), o = m.useCallback((i) => {
    const a = U({}, $d, {
      cellClassName: r.cellCheckbox,
      headerClassName: r.columnHeaderCheckbox,
      headerName: e.current.getLocaleText("checkboxSelectionHeaderName")
    }), l = t.checkboxSelection, c = i.lookup[da] != null;
    return l && !c ? (i.lookup[da] = a, i.orderedFields = [da, ...i.orderedFields]) : !l && c ? (delete i.lookup[da], i.orderedFields = i.orderedFields.filter((d) => d !== da)) : l && c && (i.lookup[da] = U({}, a, i.lookup[da])), i;
  }, [e, r, t.checkboxSelection]);
  Zn(e, "hydrateColumns", o);
}, Ghe = (e, t) => {
  var r, o;
  const n = t.sortModel ?? ((o = (r = t.initialState) == null ? void 0 : r.sorting) == null ? void 0 : o.sortModel) ?? [];
  return U({}, e, {
    sorting: {
      sortModel: bN(n, t.disableMultipleColumnsSorting),
      sortedRows: []
    }
  });
}, Whe = (e, t) => {
  var P, R;
  const n = zr(e, "useGridSorting");
  e.current.registerControlState({
    stateId: "sortModel",
    propModel: t.sortModel,
    propOnChange: t.onSortModelChange,
    stateSelector: Ii,
    changeEvent: "sortModelChange"
  });
  const r = m.useCallback((F, A) => {
    const _ = Ii(e), C = _.findIndex((L) => L.field === F);
    let D = [..._];
    return C > -1 ? (A == null ? void 0 : A.sort) == null ? D.splice(C, 1) : D.splice(C, 1, A) : D = [..._, A], D;
  }, [e]), o = m.useCallback((F, A) => {
    const C = Ii(e).find((D) => D.field === F.field);
    if (C) {
      const D = A === void 0 ? qI(F.sortingOrder ?? t.sortingOrder, C.sort) : A;
      return D === void 0 ? void 0 : U({}, C, {
        sort: D
      });
    }
    return {
      field: F.field,
      sort: A === void 0 ? qI(F.sortingOrder ?? t.sortingOrder) : A
    };
  }, [e, t.sortingOrder]), i = m.useCallback((F, A) => A == null || A.sortable === !1 || t.disableColumnSorting ? F : (A.sortingOrder || t.sortingOrder).some((C) => !!C) ? [...F, "columnMenuSortItem"] : F, [t.sortingOrder, t.disableColumnSorting]), a = m.useCallback(() => {
    e.current.setState((F) => {
      if (t.sortingMode === "server")
        return n.debug("Skipping sorting rows as sortingMode = server"), U({}, F, {
          sorting: U({}, F.sorting, {
            sortedRows: xS(so(e), ao, !1)
          })
        });
      const A = Ii(F, e.current.instanceId), _ = Bae(A, e), C = e.current.applyStrategyProcessor("sorting", {
        sortRowList: _
      });
      return U({}, F, {
        sorting: U({}, F.sorting, {
          sortedRows: C
        })
      });
    }), e.current.publishEvent("sortedRowsSet"), e.current.forceUpdate();
  }, [e, n, t.sortingMode]), l = m.useCallback((F) => {
    Ii(e) !== F && (n.debug("Setting sort model"), e.current.setState(WI(F, t.disableMultipleColumnsSorting)), e.current.forceUpdate(), e.current.applySorting());
  }, [e, n, t.disableMultipleColumnsSorting]), c = m.useCallback((F, A, _) => {
    const C = e.current.getColumn(F), D = o(C, A);
    let L;
    !_ || t.disableMultipleColumnsSorting ? L = (D == null ? void 0 : D.sort) == null ? [] : [D] : L = r(C.field, D), e.current.setSortModel(L);
  }, [e, r, o, t.disableMultipleColumnsSorting]), d = m.useCallback(() => Ii(e), [e]), f = m.useCallback(() => SS(e).map((A) => A.model), [e]), p = m.useCallback(() => Nd(e), [e]), g = m.useCallback((F) => e.current.getSortedRowIds()[F], [e]);
  Ut(e, {
    getSortModel: d,
    getSortedRows: f,
    getSortedRowIds: p,
    getRowIdFromRowIndex: g,
    setSortModel: l,
    sortColumn: c,
    applySorting: a
  }, "public");
  const v = m.useCallback((F, A) => {
    var D, L;
    const _ = Ii(e);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !A.exportOnlyDirtyModels || // Always export if the model is controlled
      t.sortModel != null || // Always export if the model has been initialized
      ((L = (D = t.initialState) == null ? void 0 : D.sorting) == null ? void 0 : L.sortModel) != null || // Export if the model is not empty
      _.length > 0 ? U({}, F, {
        sorting: {
          sortModel: _
        }
      }) : F
    );
  }, [e, t.sortModel, (R = (P = t.initialState) == null ? void 0 : P.sorting) == null ? void 0 : R.sortModel]), y = m.useCallback((F, A) => {
    var C;
    const _ = (C = A.stateToRestore.sorting) == null ? void 0 : C.sortModel;
    return _ == null ? F : (e.current.setState(WI(_, t.disableMultipleColumnsSorting)), U({}, F, {
      callbacks: [...F.callbacks, e.current.applySorting]
    }));
  }, [e, t.disableMultipleColumnsSorting]), S = m.useCallback((F) => {
    const A = so(e), _ = A[ao], C = F.sortRowList ? F.sortRowList(_.children.map((D) => A[D])) : [..._.children];
    return _.footerId != null && C.push(_.footerId), C;
  }, [e]);
  Zn(e, "exportState", v), Zn(e, "restoreState", y), Lm(e, Tc, "sorting", S);
  const E = m.useCallback(({
    field: F,
    colDef: A
  }, _) => {
    if (!A.sortable || t.disableColumnSorting)
      return;
    const C = _.shiftKey || _.metaKey || _.ctrlKey;
    c(F, void 0, C);
  }, [c, t.disableColumnSorting]), I = m.useCallback(({
    field: F,
    colDef: A
  }, _) => {
    !A.sortable || t.disableColumnSorting || _.key === "Enter" && !_.ctrlKey && !_.metaKey && c(F, void 0, _.shiftKey);
  }, [c, t.disableColumnSorting]), O = m.useCallback(() => {
    const F = Ii(e), A = Oa(e);
    if (F.length > 0) {
      const _ = F.filter((C) => A[C.field]);
      _.length < F.length && e.current.setSortModel(_);
    }
  }, [e]), T = m.useCallback((F) => {
    F === "sorting" && e.current.applySorting();
  }, [e]);
  Zn(e, "columnMenu", i), it(e, "columnHeaderClick", E), it(e, "columnHeaderKeyDown", I), it(e, "rowsSet", e.current.applySorting), it(e, "columnsChange", O), it(e, "activeStrategyProcessorChange", T), dh(() => {
    e.current.applySorting();
  }), Zr(() => {
    t.sortModel !== void 0 && e.current.setSortModel(t.sortModel);
  }, [e, t.sortModel]);
};
function jR(e) {
  const {
    containerSize: t,
    scrollPosition: n,
    elementSize: r,
    elementOffset: o
  } = e, i = o + r;
  if (r > t)
    return o;
  if (i - t > n)
    return i - t;
  if (o < n)
    return o;
}
const qhe = (e, t) => {
  const n = mi(), r = zr(e, "useGridScroll"), o = e.current.columnHeadersContainerRef, i = e.current.virtualScrollerRef, a = Be(e, Fl), l = m.useCallback((p) => {
    var E;
    const g = mo(e.current.state), b = ry(e), v = t.unstable_listView ? [Cd(e.current.state)] : Fr(e);
    if (!(p.rowIndex == null) && b === 0 || v.length === 0)
      return !1;
    r.debug(`Scrolling to cell at row ${p.rowIndex}, col: ${p.colIndex} `);
    let S = {};
    if (p.colIndex !== void 0) {
      const I = Nl(e);
      let O;
      if (typeof p.rowIndex < "u") {
        const T = (E = a[p.rowIndex]) == null ? void 0 : E.id, P = e.current.unstable_getCellColSpanInfo(T, p.colIndex);
        P && !P.spannedByColSpan && (O = P.cellProps.width);
      }
      typeof O > "u" && (O = v[p.colIndex].computedWidth), S.left = jR({
        containerSize: g.viewportOuterSize.width,
        scrollPosition: Math.abs(i.current.scrollLeft),
        elementSize: O,
        elementOffset: I[p.colIndex]
      });
    }
    if (p.rowIndex !== void 0) {
      const I = Ld(e.current.state), O = tce(e), T = nce(e), P = t.pagination ? p.rowIndex - O * T : p.rowIndex, R = I.positions[P + 1] ? I.positions[P + 1] - I.positions[P] : I.currentPageTotalHeight - I.positions[P];
      S.top = jR({
        containerSize: g.viewportInnerSize.height,
        scrollPosition: i.current.scrollTop,
        elementSize: R,
        elementOffset: I.positions[P]
      });
    }
    return S = e.current.unstable_applyPipeProcessors("scrollToIndexes", S, p), typeof S.left !== void 0 || typeof S.top !== void 0 ? (e.current.scroll(S), !0) : !1;
  }, [r, e, i, t.pagination, a, t.unstable_listView]), c = m.useCallback((p) => {
    if (i.current && p.left !== void 0 && o.current) {
      const g = n ? -1 : 1;
      o.current.scrollLeft = p.left, i.current.scrollLeft = g * p.left, r.debug(`Scrolling left: ${p.left}`);
    }
    i.current && p.top !== void 0 && (i.current.scrollTop = p.top, r.debug(`Scrolling top: ${p.top}`)), r.debug("Scrolling, updating container, and viewport");
  }, [i, n, o, r]), d = m.useCallback(() => i != null && i.current ? {
    top: i.current.scrollTop,
    left: i.current.scrollLeft
  } : {
    top: 0,
    left: 0
  }, [i]);
  Ut(e, {
    scroll: c,
    scrollToIndexes: l,
    getScrollPosition: d
  }, "public");
};
function Khe(e, t) {
  Nn(e, "columnHeaderClick", t.onColumnHeaderClick), Nn(e, "columnHeaderContextMenu", t.onColumnHeaderContextMenu), Nn(e, "columnHeaderDoubleClick", t.onColumnHeaderDoubleClick), Nn(e, "columnHeaderOver", t.onColumnHeaderOver), Nn(e, "columnHeaderOut", t.onColumnHeaderOut), Nn(e, "columnHeaderEnter", t.onColumnHeaderEnter), Nn(e, "columnHeaderLeave", t.onColumnHeaderLeave), Nn(e, "cellClick", t.onCellClick), Nn(e, "cellDoubleClick", t.onCellDoubleClick), Nn(e, "cellKeyDown", t.onCellKeyDown), Nn(e, "preferencePanelClose", t.onPreferencePanelClose), Nn(e, "preferencePanelOpen", t.onPreferencePanelOpen), Nn(e, "menuOpen", t.onMenuOpen), Nn(e, "menuClose", t.onMenuClose), Nn(e, "rowDoubleClick", t.onRowDoubleClick), Nn(e, "rowClick", t.onRowClick), Nn(e, "stateChange", t.onStateChange);
}
function Yhe(e, t = 166) {
  let n, r;
  const o = () => {
    n = void 0, e(...r);
  };
  function i(...a) {
    r = a, n === void 0 && (n = setTimeout(o, t));
  }
  return i.clear = () => {
    clearTimeout(n), n = void 0;
  }, i;
}
const lC = {
  autoHeight: !1,
  autoPageSize: !1,
  autosizeOnMount: !1,
  checkboxSelection: !1,
  checkboxSelectionVisibleOnly: !1,
  clipboardCopyCellDelimiter: "	",
  columnBufferPx: 150,
  columnHeaderHeight: 56,
  disableAutosize: !1,
  disableColumnFilter: !1,
  disableColumnMenu: !1,
  disableColumnReorder: !1,
  disableColumnResize: !1,
  disableColumnSelector: !1,
  disableColumnSorting: !1,
  disableDensitySelector: !1,
  disableEval: !1,
  disableMultipleColumnsFiltering: !1,
  disableMultipleColumnsSorting: !1,
  disableMultipleRowSelection: !1,
  disableRowSelectionOnClick: !1,
  disableVirtualization: !1,
  editMode: Us.Cell,
  filterDebounceMs: 150,
  filterMode: "client",
  hideFooter: !1,
  hideFooterPagination: !1,
  hideFooterRowCount: !1,
  hideFooterSelectedRowCount: !1,
  ignoreDiacritics: !1,
  ignoreValueFormatterDuringExport: !1,
  // TODO v8: Update to 'select'
  indeterminateCheckboxAction: "deselect",
  keepColumnPositionIfDraggedOutside: !1,
  keepNonExistentRowsSelected: !1,
  loading: !1,
  logger: console,
  logLevel: process.env.NODE_ENV === "production" ? "error" : "warn",
  pageSizeOptions: [25, 50, 100],
  pagination: !1,
  paginationMode: "client",
  resizeThrottleMs: 60,
  rowBufferPx: 150,
  rowHeight: 52,
  rowPositionsDebounceMs: 166,
  rows: [],
  rowSelection: !0,
  rowSpacingType: "margin",
  showCellVerticalBorder: !1,
  showColumnVerticalBorder: !1,
  sortingMode: "client",
  sortingOrder: ["asc", "desc", null],
  throttleRowsMs: 0,
  unstable_rowSpanning: !1,
  virtualizeColumnsWithAutoRowHeight: !1
}, Iu = {
  width: 0,
  height: 0
}, Qhe = {
  isReady: !1,
  root: Iu,
  viewportOuterSize: Iu,
  viewportInnerSize: Iu,
  contentSize: Iu,
  minimumSize: Iu,
  hasScrollX: !1,
  hasScrollY: !1,
  scrollbarSize: 0,
  headerHeight: 0,
  groupHeaderHeight: 0,
  headerFilterHeight: 0,
  rowWidth: 0,
  rowHeight: 0,
  columnsTotalWidth: 0,
  leftPinnedWidth: 0,
  rightPinnedWidth: 0,
  headersTotalHeight: 0,
  topContainerHeight: 0,
  bottomContainerHeight: 0
}, Xhe = (e) => U({}, e, {
  dimensions: Qhe
});
function Jhe(e, t) {
  const n = zr(e, "useResizeContainer"), r = m.useRef(!1), o = m.useRef(Iu), i = Be(e, mo), a = Be(e, Ld), l = Be(e, uh), c = Be(e, ch), d = m.useMemo(() => MN(t.rowHeight, lC.rowHeight, vle), [t.rowHeight]), f = Math.floor(d * c), p = Math.floor(t.columnHeaderHeight * c), g = Math.floor((t.columnGroupHeaderHeight ?? t.columnHeaderHeight) * c), b = Math.floor((t.headerFilterHeight ?? t.columnHeaderHeight) * c), v = ege(bS(e), 6), y = _S(e, t), S = l.left.reduce((N, j) => N + j.computedWidth, 0), E = l.right.reduce((N, j) => N + j.computedWidth, 0), [I, O] = m.useState(), T = m.useMemo(() => Yhe(O, t.resizeThrottleMs), [t.resizeThrottleMs]);
  m.useEffect(() => T.clear, [T]);
  const P = m.useRef(void 0), R = () => e.current.state.dimensions, F = Yn((N) => {
    e.current.setState((j) => U({}, j, {
      dimensions: N
    }));
  }), A = m.useCallback(() => {
    const N = e.current.mainElementRef.current;
    if (!N)
      return;
    const j = iX(N).getComputedStyle(N), W = {
      width: parseFloat(j.width) || 0,
      height: parseFloat(j.height) || 0
    };
    (!P.current || !BR(P.current, W)) && (e.current.publishEvent("resize", W), P.current = W);
  }, [e]), _ = m.useCallback(() => {
    const N = mo(e.current.state);
    if (!N.isReady)
      return 0;
    const j = zu(e, {
      pagination: t.pagination,
      paginationMode: t.paginationMode
    });
    if (t.getRowHeight) {
      const V = py(e), $ = V.lastRowIndex - V.firstRowIndex;
      return Math.min($ - 1, j.rows.length);
    }
    const W = Math.floor(N.viewportInnerSize.height / f);
    return Math.min(W, j.rows.length);
  }, [e, t.pagination, t.paginationMode, t.getRowHeight, f]), C = m.useCallback(() => {
    var we, q;
    const N = e.current.rootElementRef.current, j = yle(e), W = Zhe(N, v, t.scrollbarSize), V = y + j.top, $ = j.bottom, ne = {
      width: v - S - E,
      height: a.currentPageTotalHeight
    };
    let K, Q, re = !1, te = !1;
    if (t.autoHeight)
      te = !1, re = Math.round(v) > Math.round(o.current.width), K = {
        width: o.current.width,
        height: V + $ + ne.height
      }, Q = {
        width: Math.max(0, K.width - (te ? W : 0)),
        height: Math.max(0, K.height - (re ? W : 0))
      };
    else {
      K = {
        width: o.current.width,
        height: o.current.height
      }, Q = {
        width: Math.max(0, K.width - S - E),
        height: Math.max(0, K.height - V - $)
      };
      const Ee = ne, _e = Q, $e = Ee.width > _e.width, Le = Ee.height > _e.height;
      ($e || Le) && (te = Le, re = Ee.width + (te ? W : 0) > _e.width, re && (te = Ee.height + W > _e.height)), te && (Q.width -= W), re && (Q.height -= W);
    }
    const ie = Math.max(K.width, v + (te ? W : 0)), ae = {
      width: v,
      height: V + ne.height + $
    }, ce = {
      isReady: !0,
      root: o.current,
      viewportOuterSize: K,
      viewportInnerSize: Q,
      contentSize: ne,
      minimumSize: ae,
      hasScrollX: re,
      hasScrollY: te,
      scrollbarSize: W,
      headerHeight: p,
      groupHeaderHeight: g,
      headerFilterHeight: b,
      rowWidth: ie,
      rowHeight: f,
      columnsTotalWidth: v,
      leftPinnedWidth: S,
      rightPinnedWidth: E,
      headersTotalHeight: y,
      topContainerHeight: V,
      bottomContainerHeight: $
    }, le = e.current.state.dimensions;
    F(ce), BR(ce.viewportInnerSize, le.viewportInnerSize) || e.current.publishEvent("viewportInnerSizeChange", ce.viewportInnerSize), (q = (we = e.current).updateRenderContext) == null || q.call(we);
  }, [e, F, t.scrollbarSize, t.autoHeight, a.currentPageTotalHeight, f, p, g, b, v, y, S, E]), D = {
    resize: A,
    getRootDimensions: R
  }, L = {
    updateDimensions: C,
    getViewportPageSize: _
  };
  Ut(e, D, "public"), Ut(e, L, "private"), Zr(() => {
    I && (C(), e.current.publishEvent("debouncedResize", o.current));
  }, [e, I, C]);
  const B = e.current.rootElementRef.current;
  Zr(() => {
    if (!B)
      return;
    const N = (j, W) => B.style.setProperty(j, W);
    N("--DataGrid-width", `${i.viewportOuterSize.width}px`), N("--DataGrid-hasScrollX", `${Number(i.hasScrollX)}`), N("--DataGrid-hasScrollY", `${Number(i.hasScrollY)}`), N("--DataGrid-scrollbarSize", `${i.scrollbarSize}px`), N("--DataGrid-rowWidth", `${i.rowWidth}px`), N("--DataGrid-columnsTotalWidth", `${i.columnsTotalWidth}px`), N("--DataGrid-leftPinnedWidth", `${i.leftPinnedWidth}px`), N("--DataGrid-rightPinnedWidth", `${i.rightPinnedWidth}px`), N("--DataGrid-headerHeight", `${i.headerHeight}px`), N("--DataGrid-headersTotalHeight", `${i.headersTotalHeight}px`), N("--DataGrid-topContainerHeight", `${i.topContainerHeight}px`), N("--DataGrid-bottomContainerHeight", `${i.bottomContainerHeight}px`), N("--height", `${i.rowHeight}px`);
  }, [B, i]);
  const H = m.useRef(!0), k = m.useCallback((N) => {
    o.current = N;
    const j = /jsdom|HappyDOM/.test(window.navigator.userAgent);
    if (N.height === 0 && !r.current && !t.autoHeight && !j && (n.error(["The parent DOM element of the Data Grid has an empty height.", "Please make sure that this element has an intrinsic height.", "The grid displays with a height of 0px.", "", "More details: https://mui.com/r/x-data-grid-no-dimensions."].join(`
`)), r.current = !0), N.width === 0 && !r.current && !j && (n.error(["The parent DOM element of the Data Grid has an empty width.", "Please make sure that this element has an intrinsic width.", "The grid displays with a width of 0px.", "", "More details: https://mui.com/r/x-data-grid-no-dimensions."].join(`
`)), r.current = !0), H.current) {
      O(N), H.current = !1;
      return;
    }
    T(N);
  }, [t.autoHeight, T, n]);
  Zr(C, [C]), Nn(e, "sortedRowsSet", C), Nn(e, "paginationModelChange", C), Nn(e, "columnsChange", C), it(e, "resize", k), Nn(e, "debouncedResize", t.onResize);
}
function Zhe(e, t, n) {
  if (n !== void 0)
    return n;
  if (e === null || t === 0)
    return 0;
  const o = fl(e).createElement("div");
  o.style.width = "99px", o.style.height = "99px", o.style.position = "absolute", o.style.overflow = "scroll", o.className = "scrollDiv", e.appendChild(o);
  const i = o.offsetWidth - o.clientWidth;
  return e.removeChild(o), i;
}
function ege(e, t) {
  return Math.round(e * 10 ** t) / 10 ** t;
}
function BR(e, t) {
  return e.width === t.width && e.height === t.height;
}
const tge = typeof globalThis.ResizeObserver < "u" ? globalThis.ResizeObserver : class {
  observe() {
  }
  unobserve() {
  }
  disconnect() {
  }
}, nge = (e, t, n) => (n.current.caches.rowsMeta = {
  heights: /* @__PURE__ */ new Map()
}, U({}, e, {
  rowsMeta: {
    currentPageTotalHeight: 0,
    positions: []
  }
})), rge = (e, t) => {
  const {
    getRowHeight: n,
    getRowSpacing: r,
    getEstimatedRowHeight: o
  } = t, i = e.current.caches.rowsMeta.heights, a = m.useRef(-1), l = m.useRef(!1), c = m.useRef(!1), d = Be(e, ch), f = Be(e, ro), p = Be(e, cy), g = Be(e, Ii), b = Fc(e, t), v = Be(e, Nc), y = Be(e, () => mo(e.current.state).rowHeight), S = (B) => {
    let H = i.get(B);
    return H === void 0 && (H = {
      content: y,
      spacingTop: 0,
      spacingBottom: 0,
      detail: 0,
      autoHeight: !1,
      needsFirstMeasurement: !0
    }, i.set(B, H)), H;
  }, E = m.useCallback((B) => {
    const H = mo(e.current.state).rowHeight, k = e.current.getRowHeightEntry(B.id);
    if (!n)
      k.content = H, k.needsFirstMeasurement = !1;
    else {
      const N = n(U({}, B, {
        densityFactor: d
      }));
      if (N === "auto") {
        if (k.needsFirstMeasurement) {
          const j = o ? o(U({}, B, {
            densityFactor: d
          })) : H;
          k.content = j ?? H;
        }
        l.current = !0, k.autoHeight = !0;
      } else
        k.content = MN(N, H, wle), k.needsFirstMeasurement = !1, k.autoHeight = !1;
    }
    if (r) {
      const N = e.current.getRowIndexRelativeToVisibleRows(B.id), j = r(U({}, B, {
        isFirstVisible: N === 0,
        isLastVisible: N === b.rows.length - 1,
        indexRelativeToCurrentPage: N
      }));
      k.spacingTop = j.top ?? 0, k.spacingBottom = j.bottom ?? 0;
    } else
      k.spacingTop = 0, k.spacingBottom = 0;
    return e.current.unstable_applyPipeProcessors("rowHeight", k, B), k;
  }, [e, b.rows.length, n, o, y, r, d]), I = m.useCallback(() => {
    l.current = !1, v.top.forEach(E), v.bottom.forEach(E);
    const B = [], H = b.rows.reduce((k, N) => {
      B.push(k);
      const j = E(N), W = j.content + j.spacingTop + j.spacingBottom + j.detail;
      return k + W;
    }, 0);
    l.current || (a.current = 1 / 0), e.current.setState((k) => U({}, k, {
      rowsMeta: {
        currentPageTotalHeight: H,
        positions: B
      }
    })), c.current = !0;
  }, [e, v, b.rows, E]), O = (B) => {
    var H;
    return ((H = i.get(B)) == null ? void 0 : H.content) ?? y;
  }, T = (B, H) => {
    const k = e.current.getRowHeightEntry(B), N = k.content !== H;
    k.needsFirstMeasurement = !1, k.content = H, c.current && (c.current = !N);
  }, P = (B) => {
    var H;
    return ((H = i.get(B)) == null ? void 0 : H.autoHeight) ?? !1;
  }, R = () => a.current, F = (B) => {
    l.current && B > a.current && (a.current = B);
  }, A = () => {
    i.clear(), I();
  }, _ = Ws(() => new tge((B) => {
    for (let H = 0; H < B.length; H += 1) {
      const k = B[H], N = k.borderBoxSize && k.borderBoxSize.length > 0 ? k.borderBoxSize[0].blockSize : k.contentRect.height, j = k.target.__mui_id;
      e.current.unstable_storeRowHeightMeasurement(j, N);
    }
    c.current || e.current.requestPipeProcessorsApplication("rowHeight");
  })).current, C = (B, H) => (B.__mui_id = H, _.observe(B), () => _.unobserve(B));
  BS(e, "rowHeight", I), m.useEffect(() => {
    I();
  }, [f, p, g, I]);
  const D = {
    unstable_getRowHeight: O,
    unstable_setLastMeasuredRowIndex: F,
    unstable_storeRowHeightMeasurement: T,
    resetRowHeights: A
  }, L = {
    hydrateRowsMeta: I,
    observeRowHeight: C,
    rowHasAutoHeight: P,
    getRowHeightEntry: S,
    getLastMeasuredRowIndex: R
  };
  Ut(e, D, "public"), Ut(e, L, "private");
}, oge = (e) => {
  const t = m.useCallback((o = {}) => e.current.unstable_applyPipeProcessors("exportState", {}, o), [e]), n = m.useCallback((o) => {
    e.current.unstable_applyPipeProcessors("restoreState", {
      callbacks: []
    }, {
      stateToRestore: o
    }).callbacks.forEach((a) => {
      a();
    }), e.current.forceUpdate();
  }, [e]);
  Ut(e, {
    exportState: t,
    restoreState: n
  }, "public");
}, ige = (e) => {
  const t = m.useRef({}), n = (l, c) => {
    var d;
    return (d = t.current[l]) == null ? void 0 : d[c];
  }, r = () => {
    t.current = {};
  }, o = m.useCallback(({
    rowId: l,
    minFirstColumn: c,
    maxLastColumn: d,
    columns: f
  }) => {
    for (let p = c; p < d; p += 1) {
      const g = sge({
        apiRef: e,
        lookup: t.current,
        columnIndex: p,
        rowId: l,
        minFirstColumnIndex: c,
        maxLastColumnIndex: d,
        columns: f
      });
      g.colSpan > 1 && (p += g.colSpan - 1);
    }
  }, [e]), i = {
    unstable_getCellColSpanInfo: n
  }, a = {
    resetColSpan: r,
    calculateColSpan: o
  };
  Ut(e, i, "public"), Ut(e, a, "private"), it(e, "columnOrderChange", r);
};
function sge(e) {
  const {
    apiRef: t,
    lookup: n,
    columnIndex: r,
    rowId: o,
    minFirstColumnIndex: i,
    maxLastColumnIndex: a,
    columns: l
  } = e, c = l.length, d = l[r], f = t.current.getRow(o), p = t.current.getRowValue(f, d), g = typeof d.colSpan == "function" ? d.colSpan(p, f, d, t) : d.colSpan;
  if (!g || g === 1)
    return Dw(n, o, r, {
      spannedByColSpan: !1,
      cellProps: {
        colSpan: 1,
        width: d.computedWidth
      }
    }), {
      colSpan: 1
    };
  let b = d.computedWidth;
  for (let v = 1; v < g; v += 1) {
    const y = r + v;
    if (y >= i && y < a) {
      const S = l[y];
      b += S.computedWidth, Dw(n, o, r + v, {
        spannedByColSpan: !0,
        rightVisibleCellIndex: Math.min(r + g, c - 1),
        leftVisibleCellIndex: r
      });
    }
    Dw(n, o, r, {
      spannedByColSpan: !1,
      cellProps: {
        colSpan: g,
        width: b
      }
    });
  }
  return {
    colSpan: g
  };
}
function Dw(e, t, n, r) {
  e[t] || (e[t] = {}), e[t][n] = r;
}
const g$ = (e, t, n) => {
  if (SN(e)) {
    if (n[e.field] !== void 0)
      throw new Error(["MUI X: columnGroupingModel contains duplicated field", `column field ${e.field} occurs two times in the grouping model:`, `- ${n[e.field].join(" > ")}`, `- ${t.join(" > ")}`].join(`
`));
    n[e.field] = t;
    return;
  }
  const {
    groupId: r,
    children: o
  } = e;
  o.forEach((i) => {
    g$(i, [...t, r], n);
  });
}, cC = (e) => {
  if (!e)
    return {};
  const t = {};
  return e.forEach((n) => {
    g$(n, [], t);
  }), t;
}, uC = (e, t, n) => {
  const r = (c) => t[c] ?? [], o = [], i = Math.max(...e.map((c) => r(c).length)), a = (c, d, f) => Vu(r(c).slice(0, f + 1), r(d).slice(0, f + 1)), l = (c, d) => !!(n != null && n.left && n.left.includes(c) && !n.left.includes(d) || n != null && n.right && !n.right.includes(c) && n.right.includes(d));
  for (let c = 0; c < i; c += 1) {
    const d = e.reduce((f, p) => {
      const g = r(p)[c] ?? null;
      if (f.length === 0)
        return [{
          columnFields: [p],
          groupId: g
        }];
      const b = f[f.length - 1], v = b.columnFields[b.columnFields.length - 1];
      return b.groupId !== g || !a(v, p, c) || // Fix for https://github.com/mui/mui-x/issues/7041
      l(v, p) ? [...f, {
        columnFields: [p],
        groupId: g
      }] : [...f.slice(0, f.length - 1), {
        columnFields: [...b.columnFields, p],
        groupId: g
      }];
    }, []);
    o.push(d);
  }
  return o;
}, age = ["groupId", "children"], VS = (e) => {
  let t = {};
  return e.forEach((n) => {
    if (SN(n))
      return;
    const {
      groupId: r,
      children: o
    } = n, i = yt(n, age);
    if (!r)
      throw new Error("MUI X: An element of the columnGroupingModel does not have either `field` or `groupId`.");
    process.env.NODE_ENV !== "production" && (o || console.warn(`MUI X: group groupId=${r} has no children.`));
    const a = U({}, i, {
      groupId: r
    }), l = VS(o);
    if (l[r] !== void 0 || t[r] !== void 0)
      throw new Error(`MUI X: The groupId ${r} is used multiple times in the columnGroupingModel.`);
    t = U({}, t, l, {
      [r]: a
    });
  }), U({}, t);
}, lge = (e, t, n) => {
  if (!t.columnGroupingModel)
    return e;
  const r = ha(n), o = Ad(n), i = VS(t.columnGroupingModel ?? []), a = cC(t.columnGroupingModel ?? []), l = uC(r, a, n.current.state.pinnedColumns ?? {}), c = o.length === 0 ? 0 : Math.max(...o.map((d) => {
    var f;
    return ((f = a[d]) == null ? void 0 : f.length) ?? 0;
  }));
  return U({}, e, {
    columnGrouping: {
      lookup: i,
      unwrappedGroupingModel: a,
      headerStructure: l,
      maxDepth: c
    }
  });
}, cge = (e, t) => {
  const n = m.useCallback((l) => oF(e)[l] ?? [], [e]), r = m.useCallback(() => iF(e), [e]);
  Ut(e, {
    getColumnGroupPath: n,
    getAllGroupDetails: r
  }, "public");
  const i = m.useCallback(() => {
    const l = cC(t.columnGroupingModel ?? []);
    e.current.setState((c) => {
      var g;
      const d = ((g = c.columns) == null ? void 0 : g.orderedFields) ?? [], f = c.pinnedColumns ?? {}, p = uC(d, l, f);
      return U({}, c, {
        columnGrouping: U({}, c.columnGrouping, {
          headerStructure: p
        })
      });
    });
  }, [e, t.columnGroupingModel]), a = m.useCallback((l) => {
    var y, S;
    const c = ((S = (y = e.current).getPinnedColumns) == null ? void 0 : S.call(y)) ?? {}, d = ha(e), f = Ad(e), p = VS(l ?? []), g = cC(l ?? []), b = uC(d, g, c), v = f.length === 0 ? 0 : Math.max(...f.map((E) => {
      var I;
      return ((I = g[E]) == null ? void 0 : I.length) ?? 0;
    }));
    e.current.setState((E) => U({}, E, {
      columnGrouping: {
        lookup: p,
        unwrappedGroupingModel: g,
        headerStructure: b,
        maxDepth: v
      }
    }));
  }, [e]);
  it(e, "columnIndexChange", i), it(e, "columnsChange", () => {
    a(t.columnGroupingModel);
  }), it(e, "columnVisibilityModelChange", () => {
    a(t.columnGroupingModel);
  }), m.useEffect(() => {
    a(t.columnGroupingModel);
  }, [a, t.columnGroupingModel]);
};
function uge() {
  let e, t;
  const n = new Promise((r, o) => {
    e = r, t = o;
  });
  return n.resolve = e, n.reject = t, n;
}
function VR(e, t) {
  if (t !== void 0 && e.changedTouches) {
    for (let n = 0; n < e.changedTouches.length; n += 1) {
      const r = e.changedTouches[n];
      if (r.identifier === t)
        return {
          x: r.clientX,
          y: r.clientY
        };
    }
    return !1;
  }
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function HR(e, t, n, r) {
  let o = e;
  return r === "Right" ? o += t - n.left : o += n.right - t, o;
}
function dge(e, t, n) {
  return n === "Left" ? e - t.left : t.right - e;
}
function fge(e) {
  return e === "Right" ? "Left" : "Right";
}
function pge(e, t) {
  const n = e.classList.contains(ee["columnSeparator--sideRight"]) ? "Right" : "Left";
  return t ? fge(n) : n;
}
function UR(e) {
  e.preventDefault(), e.stopImmediatePropagation();
}
function hge(e) {
  const t = m.useRef(void 0), n = () => fy(e), r = Be(e, n);
  return m.useEffect(() => {
    t.current && r === !1 && (t.current.resolve(), t.current = void 0);
  }), () => {
    if (!t.current) {
      if (n() === !1)
        return Promise.resolve();
      t.current = uge();
    }
    return t.current;
  };
}
function gge(e, t) {
  if (e.length < 4)
    return e;
  const n = e.slice();
  n.sort((l, c) => l - c);
  const r = n[Math.floor(n.length * 0.25)], o = n[Math.floor(n.length * 0.75) - 1], i = o - r, a = i < 5 ? 5 : i * t;
  return n.filter((l) => l > r - a && l < o + a);
}
function mge(e, t, n) {
  const r = {}, o = e.current.rootElementRef.current;
  return o.classList.add(ee.autosizing), n.forEach((i) => {
    const l = Dde(e.current, i.field).map((v) => v.getBoundingClientRect().width ?? 0), c = t.includeOutliers ? l : gge(l, t.outliersFactor);
    if (t.includeHeaders) {
      const v = Ade(e.current, i.field);
      if (v) {
        const y = v.querySelector(`.${ee.columnHeaderTitle}`), S = v.querySelector(`.${ee.columnHeaderTitleContainerContent}`), E = v.querySelector(`.${ee.iconButtonContainer}`), I = v.querySelector(`.${ee.menuIcon}`), O = y ?? S, T = window.getComputedStyle(v, null), P = parseInt(T.paddingLeft, 10) + parseInt(T.paddingRight, 10), F = O.scrollWidth + 1 + P + ((E == null ? void 0 : E.clientWidth) ?? 0) + ((I == null ? void 0 : I.clientWidth) ?? 0);
        c.push(F);
      }
    }
    const d = i.minWidth !== -1 / 0 && i.minWidth !== void 0, f = i.maxWidth !== 1 / 0 && i.maxWidth !== void 0, p = d ? i.minWidth : 0, g = f ? i.maxWidth : 1 / 0, b = c.length === 0 ? 0 : Math.max(...c);
    r[i.field] = js(b, p, g);
  }), o.classList.remove(ee.autosizing), r;
}
const bge = (e) => U({}, e, {
  columnResize: {
    resizingColumnField: ""
  }
});
function yge() {
  return {
    colDef: void 0,
    initialColWidth: 0,
    initialTotalWidth: 0,
    previousMouseClickEvent: void 0,
    columnHeaderElement: void 0,
    headerFilterElement: void 0,
    groupHeaderElements: [],
    cellElements: [],
    leftPinnedCellsAfter: [],
    rightPinnedCellsBefore: [],
    fillerLeft: void 0,
    fillerRight: void 0,
    leftPinnedHeadersAfter: [],
    rightPinnedHeadersBefore: []
  };
}
const vge = (e, t) => {
  const n = mi(), r = zr(e, "useGridColumnResize"), o = Ws(yge).current, i = m.useRef(null), a = m.useRef(null), l = Pd(), c = m.useRef(void 0), d = (_) => {
    var N, j;
    r.debug(`Updating width to ${_} for col ${o.colDef.field}`);
    const C = o.columnHeaderElement.offsetWidth, D = _ - C, L = _ - o.initialColWidth, B = o.initialTotalWidth + L;
    (j = (N = e.current.rootElementRef) == null ? void 0 : N.current) == null || j.style.setProperty("--DataGrid-rowWidth", `${B}px`), o.colDef.computedWidth = _, o.colDef.width = _, o.colDef.flex = 0, o.columnHeaderElement.style.width = `${_}px`;
    const H = o.headerFilterElement;
    H && (H.style.width = `${_}px`), o.groupHeaderElements.forEach((W) => {
      const V = W;
      let $;
      V.getAttribute("aria-colspan") === "1" ? $ = `${_}px` : $ = `${V.offsetWidth + D}px`, V.style.width = $;
    }), o.cellElements.forEach((W) => {
      const V = W;
      let $;
      V.getAttribute("aria-colspan") === "1" ? $ = `${_}px` : $ = `${V.offsetWidth + D}px`, V.style.setProperty("--width", $);
    });
    const k = e.current.unstable_applyPipeProcessors("isColumnPinned", !1, o.colDef.field);
    k === $n.LEFT && (wu(o.fillerLeft, "width", D), o.leftPinnedCellsAfter.forEach((W) => {
      wu(W, "left", D);
    }), o.leftPinnedHeadersAfter.forEach((W) => {
      wu(W, "left", D);
    })), k === $n.RIGHT && (wu(o.fillerRight, "width", D), o.rightPinnedCellsBefore.forEach((W) => {
      wu(W, "right", D);
    }), o.rightPinnedHeadersBefore.forEach((W) => {
      wu(W, "right", D);
    }));
  }, f = (_) => {
    if (E(), o.previousMouseClickEvent) {
      const C = o.previousMouseClickEvent, D = C.timeStamp, L = C.clientX, B = C.clientY;
      if (_.timeStamp - D < 300 && _.clientX === L && _.clientY === B) {
        o.previousMouseClickEvent = void 0, e.current.publishEvent("columnResizeStop", null, _);
        return;
      }
    }
    if (o.colDef) {
      e.current.setColumnWidth(o.colDef.field, o.colDef.width), r.debug(`Updating col ${o.colDef.field} with new width: ${o.colDef.width}`);
      const C = Ls(e.current.state);
      o.groupHeaderElements.forEach((D) => {
        const L = Ode(D), B = D, k = `${L.reduce((N, j) => C.columnVisibilityModel[j] !== !1 ? N + C.lookup[j].computedWidth : N, 0)}px`;
        B.style.width = k;
      });
    }
    l.start(0, () => {
      e.current.publishEvent("columnResizeStop", null, _);
    });
  }, p = (_, C, D) => {
    var k;
    const L = e.current.rootElementRef.current;
    o.initialColWidth = _.computedWidth, o.initialTotalWidth = e.current.getRootDimensions().rowWidth, o.colDef = _, o.columnHeaderElement = Tde(e.current.columnHeadersContainerRef.current, _.field);
    const B = L.querySelector(`.${ee.headerFilterRow} [data-field="${Pa(_.field)}"]`);
    B && (o.headerFilterElement = B), o.groupHeaderElements = Pde((k = e.current.columnHeadersContainerRef) == null ? void 0 : k.current, _.field), o.cellElements = Ide(o.columnHeaderElement, e.current), o.fillerLeft = wR(e.current, n ? "filler--pinnedRight" : "filler--pinnedLeft"), o.fillerRight = wR(e.current, n ? "filler--pinnedLeft" : "filler--pinnedRight");
    const H = e.current.unstable_applyPipeProcessors("isColumnPinned", !1, o.colDef.field);
    o.leftPinnedCellsAfter = H !== $n.LEFT ? [] : Rde(e.current, o.columnHeaderElement, n), o.rightPinnedCellsBefore = H !== $n.RIGHT ? [] : _de(e.current, o.columnHeaderElement, n), o.leftPinnedHeadersAfter = H !== $n.LEFT ? [] : kde(e.current, o.columnHeaderElement, n), o.rightPinnedHeadersBefore = H !== $n.RIGHT ? [] : Mde(e.current, o.columnHeaderElement, n), a.current = pge(C, n), i.current = dge(D, o.columnHeaderElement.getBoundingClientRect(), a.current);
  }, g = Yn(f), b = Yn((_) => {
    if (_.buttons === 0) {
      g(_);
      return;
    }
    let C = HR(i.current, _.clientX, o.columnHeaderElement.getBoundingClientRect(), a.current);
    C = js(C, o.colDef.minWidth, o.colDef.maxWidth), d(C);
    const D = {
      element: o.columnHeaderElement,
      colDef: o.colDef,
      width: C
    };
    e.current.publishEvent("columnResize", D, _);
  }), v = Yn((_) => {
    VR(_, c.current) && f(_);
  }), y = Yn((_) => {
    const C = VR(_, c.current);
    if (!C)
      return;
    if (_.type === "mousemove" && _.buttons === 0) {
      v(_);
      return;
    }
    let D = HR(i.current, C.x, o.columnHeaderElement.getBoundingClientRect(), a.current);
    D = js(D, o.colDef.minWidth, o.colDef.maxWidth), d(D);
    const L = {
      element: o.columnHeaderElement,
      colDef: o.colDef,
      width: D
    };
    e.current.publishEvent("columnResize", L, _);
  }), S = Yn((_) => {
    const C = Fm(_.target, ee["columnSeparator--resizable"]);
    if (!C)
      return;
    const D = _.changedTouches[0];
    D != null && (c.current = D.identifier);
    const L = Fm(_.target, ee.columnHeader), B = Ede(L), H = e.current.getColumn(B);
    r.debug(`Start Resize on col ${H.field}`), e.current.publishEvent("columnResizeStart", {
      field: B
    }, _), p(H, C, D.clientX);
    const k = fl(_.currentTarget);
    k.addEventListener("touchmove", y), k.addEventListener("touchend", v);
  }), E = m.useCallback(() => {
    const _ = fl(e.current.rootElementRef.current);
    _.body.style.removeProperty("cursor"), _.removeEventListener("mousemove", b), _.removeEventListener("mouseup", g), _.removeEventListener("touchmove", y), _.removeEventListener("touchend", v), setTimeout(() => {
      _.removeEventListener("click", UR, !0);
    }, 100), o.columnHeaderElement && (o.columnHeaderElement.style.pointerEvents = "unset");
  }, [e, o, b, g, y, v]), I = m.useCallback(({
    field: _
  }) => {
    e.current.setState((C) => U({}, C, {
      columnResize: U({}, C.columnResize, {
        resizingColumnField: _
      })
    })), e.current.forceUpdate();
  }, [e]), O = m.useCallback(() => {
    e.current.setState((_) => U({}, _, {
      columnResize: U({}, _.columnResize, {
        resizingColumnField: ""
      })
    })), e.current.forceUpdate();
  }, [e]), T = Yn(({
    colDef: _
  }, C) => {
    if (C.button !== 0 || !C.currentTarget.classList.contains(ee["columnSeparator--resizable"]))
      return;
    C.preventDefault(), r.debug(`Start Resize on col ${_.field}`), e.current.publishEvent("columnResizeStart", {
      field: _.field
    }, C), p(_, C.currentTarget, C.clientX);
    const D = fl(e.current.rootElementRef.current);
    D.body.style.cursor = "col-resize", o.previousMouseClickEvent = C.nativeEvent, D.addEventListener("mousemove", b), D.addEventListener("mouseup", g), D.addEventListener("click", UR, !0);
  }), P = Yn((_, C) => {
    if (t.disableAutosize || C.button !== 0)
      return;
    const D = e.current.state.columns.lookup[_.field];
    D.resizable !== !1 && e.current.autosizeColumns(U({}, t.autosizeOptions, {
      disableColumnVirtualization: !1,
      columns: [D.field]
    }));
  }), R = hge(e), F = m.useRef(!1), A = m.useCallback(async (_) => {
    var H;
    if (!((H = e.current.rootElementRef) == null ? void 0 : H.current) || F.current)
      return;
    F.current = !0;
    const D = Ls(e.current.state), L = U({}, Lue, _, {
      columns: (_ == null ? void 0 : _.columns) ?? D.orderedFields
    });
    L.columns = L.columns.filter((k) => D.columnVisibilityModel[k] !== !1);
    const B = L.columns.map((k) => e.current.state.columns.lookup[k]);
    try {
      !t.disableVirtualization && L.disableColumnVirtualization && (e.current.unstable_setColumnVirtualization(!1), await R());
      const k = mge(e, L, B), N = B.map((j) => U({}, j, {
        width: k[j.field],
        computedWidth: k[j.field],
        flex: 0
      }));
      if (L.expand) {
        const W = D.orderedFields.map((z) => D.lookup[z]).filter((z) => D.columnVisibilityModel[z.field] !== !1).reduce((z, ne) => z + (k[ne.field] ?? ne.computedWidth ?? ne.width), 0), $ = e.current.getRootDimensions().viewportInnerSize.width - W;
        if ($ > 0) {
          const z = $ / (N.length || 1);
          N.forEach((ne) => {
            ne.width += z, ne.computedWidth += z;
          });
        }
      }
      e.current.updateColumns(N), N.forEach((j, W) => {
        if (j.width !== B[W].width) {
          const V = j.width;
          e.current.publishEvent("columnWidthChange", {
            element: e.current.getColumnHeaderElement(j.field),
            colDef: j,
            width: V
          });
        }
      });
    } finally {
      t.disableVirtualization || e.current.unstable_setColumnVirtualization(!0), F.current = !1;
    }
  }, [e, R, t.disableVirtualization]);
  m.useEffect(() => E, [E]), Mb(() => {
    t.autosizeOnMount && Promise.resolve().then(() => {
      e.current.autosizeColumns(t.autosizeOptions);
    });
  }), GN(e, () => {
    var _;
    return (_ = e.current.columnHeadersContainerRef) == null ? void 0 : _.current;
  }, "touchstart", S, {
    passive: !0
  }), Ut(e, {
    autosizeColumns: A
  }, "public"), it(e, "columnResizeStop", O), it(e, "columnResizeStart", I), it(e, "columnSeparatorMouseDown", T), it(e, "columnSeparatorDoubleClick", P), Nn(e, "columnResize", t.onColumnResize), Nn(e, "columnWidthChange", t.onColumnWidthChange);
};
function wu(e, t, n) {
  e && (e.style[t] = `${parseInt(e.style[t], 10) + n}px`);
}
function wge(e, t) {
  return e.firstRowIndex >= t.firstRowIndex && e.lastRowIndex <= t.lastRowIndex ? null : e.firstRowIndex >= t.firstRowIndex && e.lastRowIndex > t.lastRowIndex ? {
    firstRowIndex: t.lastRowIndex,
    lastRowIndex: e.lastRowIndex
  } : e.firstRowIndex < t.firstRowIndex && e.lastRowIndex <= t.lastRowIndex ? {
    firstRowIndex: e.firstRowIndex,
    lastRowIndex: t.firstRowIndex - 1
  } : e;
}
function Cge(e) {
  return e.firstRowIndex !== 0 || e.lastRowIndex !== 0;
}
function zR(e, t) {
  return e.firstRowIndex !== t.firstRowIndex || e.lastRowIndex !== t.lastRowIndex;
}
const Nw = (e, t, n) => {
  if (!e)
    return null;
  let r = e[t.field];
  const o = t.rowSpanValueGetter ?? t.valueGetter;
  return o && (r = o(r, e, t, n)), r;
}, jm = {
  spannedCells: {},
  hiddenCells: {},
  hiddenCellOriginMap: {}
}, qf = {
  firstRowIndex: 0,
  lastRowIndex: 0
}, xge = /* @__PURE__ */ new Set([da, "__reorder__", iy]), m$ = 20, b$ = (e, t, n, r, o, i, a) => {
  const l = i ? {} : U({}, e.current.state.rowSpanning.spannedCells), c = i ? {} : U({}, e.current.state.rowSpanning.hiddenCells), d = i ? {} : U({}, e.current.state.rowSpanning.hiddenCellOriginMap);
  return i && (a = qf), t.forEach((f) => {
    var p;
    if (!xge.has(f.field)) {
      for (let g = o.firstRowIndex; g < o.lastRowIndex; g += 1) {
        const b = n[g];
        if ((p = c[b.id]) != null && p[f.field])
          continue;
        const v = Nw(b.model, f, e);
        if (v == null)
          continue;
        let y = b.id, S = g, E = 0;
        const I = [];
        if (g === o.firstRowIndex) {
          let T = g - 1;
          const P = n[T];
          for (; T >= r.firstRowIndex && Nw(P.model, f, e) === v; ) {
            const R = n[T + 1];
            c[R.id] ? c[R.id][f.field] = !0 : c[R.id] = {
              [f.field]: !0
            }, I.push(g), E += 1, y = P.id, S = T, T -= 1;
          }
        }
        I.forEach((T) => {
          d[T] ? d[T][f.field] = S : d[T] = {
            [f.field]: S
          };
        });
        let O = g + 1;
        for (; O <= r.lastRowIndex && n[O] && Nw(n[O].model, f, e) === v; ) {
          const T = n[O];
          c[T.id] ? c[T.id][f.field] = !0 : c[T.id] = {
            [f.field]: !0
          }, d[O] ? d[O][f.field] = S : d[O] = {
            [f.field]: S
          }, O += 1, E += 1;
        }
        E > 0 && (l[y] ? l[y][f.field] = E + 1 : l[y] = {
          [f.field]: E + 1
        });
      }
      a = {
        firstRowIndex: Math.min(a.firstRowIndex, o.firstRowIndex),
        lastRowIndex: Math.max(a.lastRowIndex, o.lastRowIndex)
      };
    }
  }), {
    spannedCells: l,
    hiddenCells: c,
    hiddenCellOriginMap: d,
    processedRange: a
  };
}, Sge = (e, t, n) => {
  var r;
  if (t.unstable_rowSpanning) {
    const o = e.rows.dataRowIds || [], i = e.columns.orderedFields || [], a = e.rows.dataRowIdToModelLookup, l = e.columns.lookup, c = !!e.filter.filterModel.items.length || !!((r = e.filter.filterModel.quickFilterValues) != null && r.length);
    if (!o.length || !i.length || !a || !l || c)
      return U({}, e, {
        rowSpanning: jm
      });
    const d = {
      firstRowIndex: 0,
      lastRowIndex: Math.min(m$, Math.max(o.length, 0))
    }, f = o.map((y) => ({
      id: y,
      model: a[y]
    })), p = i.map((y) => l[y]), {
      spannedCells: g,
      hiddenCells: b,
      hiddenCellOriginMap: v
    } = b$(n, p, f, d, d, !0, qf);
    return U({}, e, {
      rowSpanning: {
        spannedCells: g,
        hiddenCells: b,
        hiddenCellOriginMap: v
      }
    });
  }
  return U({}, e, {
    rowSpanning: jm
  });
}, Ege = (e, t) => {
  const {
    range: n,
    rows: r
  } = Fc(e, t), o = Be(e, py), i = Be(e, Fr), a = Be(e, so), l = Ws(() => Object.keys(e.current.state.rowSpanning.spannedCells).length > 0 ? {
    firstRowIndex: 0,
    lastRowIndex: Math.min(m$, Math.max(e.current.state.rows.dataRowIds.length, 0))
  } : qf), c = m.useRef(qf), d = m.useCallback(
    // A reset needs to occur when:
    // - The `unstable_rowSpanning` prop is updated (feature flag)
    // - The filtering is applied
    // - The sorting is applied
    // - The `paginationModel` is updated
    // - The rows are updated
    (v = !0) => {
      if (!t.unstable_rowSpanning) {
        e.current.state.rowSpanning !== jm && e.current.setState((_) => U({}, _, {
          rowSpanning: jm
        }));
        return;
      }
      if (n === null || !Cge(o))
        return;
      v && (l.current = qf);
      const y = wge({
        firstRowIndex: o.firstRowIndex,
        lastRowIndex: Math.min(o.lastRowIndex, n.lastRowIndex + 1)
      }, l.current);
      if (y === null)
        return;
      const {
        spannedCells: S,
        hiddenCells: E,
        hiddenCellOriginMap: I,
        processedRange: O
      } = b$(e, i, r, n, y, v, l.current);
      l.current = O;
      const T = Object.keys(S).length, P = Object.keys(E).length, R = Object.keys(e.current.state.rowSpanning.spannedCells).length, F = Object.keys(e.current.state.rowSpanning.hiddenCells).length;
      (v || T !== R || P !== F) && e.current.setState((_) => U({}, _, {
        rowSpanning: {
          spannedCells: S,
          hiddenCells: E,
          hiddenCellOriginMap: I
        }
      }));
    },
    [e, t.unstable_rowSpanning, n, o, r, i, l]
  ), f = m.useRef(o), p = m.useRef(!0), g = m.useRef(!1), b = m.useRef(a);
  m.useEffect(() => {
    const v = p.current;
    if (p.current && (p.current = !1), a !== b.current) {
      b.current = a, d(!0);
      return;
    }
    if (n && c.current && zR(n, c.current) && (c.current = n, g.current = !0), !v && f.current !== o) {
      zR(f.current, o) && (d(g.current), g.current = !1), f.current = o;
      return;
    }
    d();
  }, [d, o, n, c, a]);
}, Tge = (e, t, n) => U({}, e, {
  listViewColumn: t.unstable_listColumn ? U({}, t.unstable_listColumn, {
    computedWidth: dC(n)
  }) : void 0
});
function Oge(e, t) {
  const n = () => {
    e.current.setState((i) => i.listViewColumn ? U({}, i, {
      listViewColumn: U({}, i.listViewColumn, {
        computedWidth: dC(e)
      })
    }) : i);
  }, r = m.useRef(null);
  it(e, "viewportInnerSizeChange", (i) => {
    r.current !== i.width && (r.current = i.width, n());
  }), it(e, "columnVisibilityModelChange", n), m.useEffect(() => {
    const i = t.unstable_listColumn;
    i && e.current.setState((a) => U({}, a, {
      listViewColumn: U({}, i, {
        computedWidth: dC(e)
      })
    }));
  }, [e, t.unstable_listColumn]), m.useEffect(() => {
    t.unstable_listView && !t.unstable_listColumn && ns(["MUI X: The `unstable_listColumn` prop must be set if `unstable_listView` is enabled.", 'To fix, pass a column definition to the `unstable_listColumn` prop, e.g. `{ field: "example", renderCell: (params) => <div>{params.row.id}</div> }`.', "For more details, see https://mui.com/x/react-data-grid/list-view/"]);
  }, [t.unstable_listView, t.unstable_listColumn]);
}
function dC(e) {
  return mo(e.current.state).viewportInnerSize.width;
}
const Pge = (e, t) => {
  const n = Gpe(e, t);
  return zhe(n, t), jhe(n), Kr(Xhe, n, t), Kr(Vhe, n, t), Kr(Zpe, n, t), Kr(Dhe, n, t), Kr(Mhe, n, t), Kr(phe, n, t), Kr(Ghe, n, t), Kr(Ehe, n, t), Kr(che, n, t), Kr(Sge, n, t), Kr(the, n, t), Kr(bge, n, t), Kr(xhe, n, t), Kr(nge, n, t), Kr(Xpe, n, t), Kr(lge, n, t), Kr(Zce, n, t), Kr(Tge, n, t), vhe(n, t), Hhe(n, t), ehe(n, t), Nhe(n, t), Ege(n, t), Bhe(n, t), ige(n), cge(n, t), Ahe(n, t), hhe(n, t), The(n, t), fhe(n, t), Whe(n, t), nhe(n, t), vge(n, t), She(n, t), rge(n, t), qhe(n, t), Jpe(n), ohe(n, t), lhe(n, t), Qpe(n, t), Jhe(n, t), Khe(n, t), oge(n), eue(n, t), Oge(n, t), n;
}, Ige = (e) => {
  const {
    classes: t,
    headerAlign: n,
    isDragging: r,
    isLastColumn: o,
    showLeftBorder: i,
    showRightBorder: a,
    groupId: l,
    pinnedPosition: c
  } = e;
  return tn({
    root: ["columnHeader", n === "left" && "columnHeader--alignLeft", n === "center" && "columnHeader--alignCenter", n === "right" && "columnHeader--alignRight", r && "columnHeader--moving", a && "columnHeader--withRightBorder", i && "columnHeader--withLeftBorder", "withBorderColor", l === null ? "columnHeader--emptyGroup" : "columnHeader--filledGroup", c === "left" && "columnHeader--pinnedLeft", c === "right" && "columnHeader--pinnedRight", o && "columnHeader--last"],
    draggableContainer: ["columnHeaderDraggableContainer"],
    titleContainer: ["columnHeaderTitleContainer", "withBorderColor"],
    titleContainerContent: ["columnHeaderTitleContainerContent"]
  }, nn, t);
};
function Rge(e) {
  var z;
  const {
    groupId: t,
    width: n,
    depth: r,
    maxDepth: o,
    fields: i,
    height: a,
    colIndex: l,
    hasFocus: c,
    tabIndex: d,
    isLastColumn: f,
    pinnedPosition: p,
    style: g,
    indexInSection: b,
    sectionLength: v,
    gridHasFiller: y
  } = e, S = ft(), E = m.useRef(null), I = Wt(), O = Be(I, iF), T = t ? O[t] : {}, {
    headerName: P = t ?? "",
    description: R = "",
    headerAlign: F = void 0
  } = T;
  let A;
  const _ = t && ((z = O[t]) == null ? void 0 : z.renderHeaderGroup), C = m.useMemo(() => ({
    groupId: t,
    headerName: P,
    description: R,
    depth: r,
    maxDepth: o,
    fields: i,
    colIndex: l,
    isLastColumn: f
  }), [t, P, R, r, o, i, l, f]);
  t && _ && (A = _(C));
  const D = gy(p, b), L = hy(p, b, v, S.showColumnVerticalBorder, y), B = U({}, e, {
    classes: S.classes,
    showLeftBorder: D,
    showRightBorder: L,
    headerAlign: F,
    depth: r,
    isDragging: !1
  }), H = P ?? t, k = xr(), N = t === null ? `empty-group-cell-${k}` : t, j = Ige(B);
  m.useLayoutEffect(() => {
    if (c) {
      const K = E.current.querySelector('[tabindex="0"]') || E.current;
      K == null || K.focus();
    }
  }, [I, c]);
  const W = m.useCallback(
    (ne) => (K) => {
      ph(K) || I.current.publishEvent(ne, C, K);
    },
    // For now this is stupid, because renderParams change all the time.
    // Need to move it's computation in the api, such that for a given depth+columnField, I can get the group parameters
    [I, C]
  ), V = m.useMemo(() => ({
    onKeyDown: W("columnGroupHeaderKeyDown"),
    onFocus: W("columnGroupHeaderFocus"),
    onBlur: W("columnGroupHeaderBlur")
  }), [W]), $ = typeof T.headerClassName == "function" ? T.headerClassName(C) : T.headerClassName;
  return /* @__PURE__ */ w.jsx(kF, U({
    ref: E,
    classes: j,
    columnMenuOpen: !1,
    colIndex: l,
    height: a,
    isResizing: !1,
    sortDirection: null,
    hasFocus: !1,
    tabIndex: d,
    isDraggable: !1,
    headerComponent: A,
    headerClassName: $,
    description: R,
    elementId: N,
    width: n,
    columnMenuIconButton: null,
    columnTitleIconButtons: null,
    resizable: !1,
    label: H,
    "aria-colspan": i.length,
    "data-fields": `|-${i.join("-|-")}-|`,
    style: g
  }, V));
}
const GR = oe("div", {
  name: "MuiDataGrid",
  slot: "ColumnHeaderRow",
  overridesResolver: (e, t) => t.columnHeaderRow
})({
  display: "flex"
}), _ge = (e) => {
  const {
    visibleColumns: t,
    sortColumnLookup: n,
    filterColumnLookup: r,
    columnHeaderTabIndexState: o,
    columnGroupHeaderTabIndexState: i,
    columnHeaderFocus: a,
    columnGroupHeaderFocus: l,
    headerGroupingMaxDepth: c,
    columnMenuState: d,
    columnVisibility: f,
    columnGroupsHeaderStructure: p,
    hasOtherElementInTabSequence: g
  } = e, [b, v] = m.useState(""), [y, S] = m.useState(""), E = Hi(), I = mi(), O = ft(), T = Be(E, mo), P = Be(E, fy), R = Be(E, oF), F = Be(E, Nl), A = Be(E, Jce), _ = Be(E, uh), C = Be(E, Oa), D = fF(F, A, _.left.length), L = T.columnsTotalWidth < T.viewportOuterSize.width;
  m.useEffect(() => {
    E.current.columnHeadersContainerRef.current && (E.current.columnHeadersContainerRef.current.scrollLeft = 0);
  }, [E]);
  const B = m.useCallback((te) => S(te.field), []), H = m.useCallback(() => S(""), []), k = m.useCallback((te) => v(te.field), []), N = m.useCallback(() => v(""), []), j = m.useMemo(() => _.left.length ? {
    firstColumnIndex: 0,
    lastColumnIndex: _.left.length
  } : null, [_.left.length]), W = m.useMemo(() => _.right.length ? {
    firstColumnIndex: t.length - _.right.length,
    lastColumnIndex: t.length
  } : null, [_.right.length, t.length]);
  it(E, "columnResizeStart", B), it(E, "columnResizeStop", H), it(E, "columnHeaderDragStart", k), it(E, "columnHeaderDragEnd", N);
  const V = (te) => {
    const {
      renderContext: ie = A,
      maxLastColumn: ae = t.length
    } = te || {};
    let ce, le;
    return !O.disableVirtualization && !P ? (ce = 0, le = ae) : (ce = ie.firstColumnIndex, le = ie.lastColumnIndex), {
      renderedColumns: t.slice(ce, le),
      firstColumnToRender: ce,
      lastColumnToRender: le
    };
  }, $ = (te, ie, ae, ce = !1) => {
    const le = (te == null ? void 0 : te.position) === $n.RIGHT, we = (te == null ? void 0 : te.position) === void 0, q = _.right.length > 0 && le || _.right.length === 0 && we, Ee = D - ae;
    return /* @__PURE__ */ w.jsxs(m.Fragment, {
      children: [we && /* @__PURE__ */ w.jsx("div", {
        role: "presentation",
        style: {
          width: Ee
        }
      }), ie, we && /* @__PURE__ */ w.jsx("div", {
        role: "presentation",
        className: ke(ee.filler, ce && ee["filler--borderBottom"])
      }), q && /* @__PURE__ */ w.jsx(LS, {
        header: !0,
        pinnedRight: le,
        borderBottom: ce,
        borderTop: !1
      })]
    });
  }, z = ({
    pinnedPosition: te,
    columnIndex: ie,
    computedWidth: ae
  }) => {
    let ce;
    const le = te === $n.LEFT, we = te === $n.RIGHT;
    if (le || we) {
      const q = $S(te, ae, ie, F, T);
      let Ee = le ? "left" : "right";
      I && (Ee = le ? "right" : "left"), te === "left" && (ce = {
        [Ee]: q
      }), te === "right" && (ce = {
        [Ee]: q
      });
    }
    return ce;
  }, ne = (te, ie = {}) => {
    const {
      renderedColumns: ae,
      firstColumnToRender: ce
    } = V(te), le = [];
    for (let we = 0; we < ae.length; we += 1) {
      const q = ae[we], Ee = ce + we, _e = Ee === 0, $e = o !== null && o.field === q.field || _e && !g ? 0 : -1, Le = a !== null && a.field === q.field, Ze = d.open && d.field === q.field, J = te == null ? void 0 : te.position, fe = z({
        pinnedPosition: J,
        columnIndex: Ee,
        computedWidth: q.computedWidth
      }), me = J === $n.RIGHT ? ae[we - 1] : ae[we + 1], Oe = me ? a !== null && a.field === me.field : !1, Ce = Ee + 1 === F.length - _.right.length;
      le.push(/* @__PURE__ */ w.jsx(zde, U({}, n[q.field], {
        columnMenuOpen: Ze,
        filterItemsCounter: r[q.field] && r[q.field].length,
        headerHeight: T.headerHeight,
        isDragging: q.field === b,
        colDef: q,
        colIndex: Ee,
        isResizing: y === q.field,
        isLast: Ee === F.length - 1,
        hasFocus: Le,
        tabIndex: $e,
        pinnedPosition: J,
        style: fe,
        indexInSection: we,
        sectionLength: ae.length,
        gridHasFiller: L,
        isLastUnpinned: Ce,
        isSiblingFocused: Oe
      }, ie), q.field));
    }
    return $(te, le, 0);
  }, K = () => /* @__PURE__ */ w.jsxs(GR, {
    role: "row",
    "aria-rowindex": c + 1,
    ownerState: O,
    className: ee["row--borderBottom"],
    children: [j && ne({
      position: $n.LEFT,
      renderContext: j,
      maxLastColumn: j.lastColumnIndex
    }, {
      disableReorder: !0
    }), ne({
      renderContext: A,
      maxLastColumn: t.length - _.right.length
    }), W && ne({
      position: $n.RIGHT,
      renderContext: W,
      maxLastColumn: W.lastColumnIndex
    }, {
      disableReorder: !0,
      separatorSide: NS.Left
    })]
  }), Q = ({
    depth: te,
    params: ie
  }) => {
    var Pe, Ye;
    const ae = V(ie);
    if (ae.renderedColumns.length === 0)
      return null;
    const {
      firstColumnToRender: ce,
      lastColumnToRender: le
    } = ae, we = p[te], q = t[ce].field, Ee = ((Pe = R[q]) == null ? void 0 : Pe[te]) ?? null, _e = we.findIndex(({
      groupId: Ke,
      columnFields: je
    }) => Ke === Ee && je.includes(q)), $e = t[le - 1].field, Le = ((Ye = R[$e]) == null ? void 0 : Ye[te]) ?? null, Ze = we.findIndex(({
      groupId: Ke,
      columnFields: je
    }) => Ke === Le && je.includes($e)), J = we.slice(_e, Ze + 1).map((Ke) => U({}, Ke, {
      columnFields: Ke.columnFields.filter((je) => f[je] !== !1)
    })).filter((Ke) => Ke.columnFields.length > 0), fe = J[0].columnFields.indexOf(q), Oe = J[0].columnFields.slice(0, fe).reduce((Ke, je) => {
      const Qe = C[je];
      return Ke + (Qe.computedWidth ?? 0);
    }, 0);
    let Ce = ce;
    const Te = J.map(({
      groupId: Ke,
      columnFields: je
    }, Qe) => {
      const et = l !== null && l.depth === te && je.includes(l.field), Et = i !== null && i.depth === te && je.includes(i.field) ? 0 : -1, Xe = {
        groupId: Ke,
        width: je.reduce((Je, Ge) => Je + C[Ge].computedWidth, 0),
        fields: je,
        colIndex: Ce,
        hasFocus: et,
        tabIndex: Et
      }, xt = ie.position, tt = z({
        pinnedPosition: xt,
        columnIndex: Ce,
        computedWidth: Xe.width
      });
      Ce += je.length;
      let ct = Qe;
      return xt === "left" && (ct = Ce - 1), /* @__PURE__ */ w.jsx(Rge, {
        groupId: Ke,
        width: Xe.width,
        fields: Xe.fields,
        colIndex: Xe.colIndex,
        depth: te,
        isLastColumn: Qe === J.length - 1,
        maxDepth: c,
        height: T.groupHeaderHeight,
        hasFocus: et,
        tabIndex: Et,
        pinnedPosition: xt,
        style: tt,
        indexInSection: ct,
        sectionLength: J.length,
        gridHasFiller: L
      }, Qe);
    });
    return $(ie, Te, Oe);
  };
  return {
    renderContext: A,
    leftRenderContext: j,
    rightRenderContext: W,
    pinnedColumns: _,
    visibleColumns: t,
    getCellOffsetStyle: z,
    getFillers: $,
    getColumnHeadersRow: K,
    getColumnsToRender: V,
    getColumnGroupHeadersRows: () => {
      if (c === 0)
        return null;
      const te = [];
      for (let ie = 0; ie < c; ie += 1)
        te.push(/* @__PURE__ */ w.jsxs(GR, {
          role: "row",
          "aria-rowindex": ie + 1,
          ownerState: O,
          children: [j && Q({
            depth: ie,
            params: {
              position: $n.LEFT,
              renderContext: j,
              maxLastColumn: j.lastColumnIndex
            }
          }), Q({
            depth: ie,
            params: {
              renderContext: A
            }
          }), W && Q({
            depth: ie,
            params: {
              position: $n.RIGHT,
              renderContext: W,
              maxLastColumn: W.lastColumnIndex
            }
          })]
        }, ie));
      return te;
    },
    isDragging: !!b,
    getInnerProps: () => ({
      role: "rowgroup"
    })
  };
}, kge = ["className"], Mge = (e) => {
  const {
    classes: t
  } = e;
  return tn({
    root: ["columnHeaders"]
  }, nn, t);
}, Age = On("div", {
  name: "MuiDataGrid",
  slot: "ColumnHeaders",
  overridesResolver: (e, t) => t.columnHeaders
})({
  display: "flex",
  flexDirection: "column",
  borderTopLeftRadius: "var(--unstable_DataGrid-radius)",
  borderTopRightRadius: "var(--unstable_DataGrid-radius)"
}), Dge = dn(function(t, n) {
  const {
    className: r
  } = t, o = yt(t, kge), i = ft(), a = Mge(i);
  return /* @__PURE__ */ w.jsx(Age, U({
    className: ke(a.root, r),
    ownerState: i
  }, o, {
    role: "presentation",
    ref: n
  }));
}), Nge = ["className", "visibleColumns", "sortColumnLookup", "filterColumnLookup", "columnHeaderTabIndexState", "columnGroupHeaderTabIndexState", "columnHeaderFocus", "columnGroupHeaderFocus", "headerGroupingMaxDepth", "columnMenuState", "columnVisibility", "columnGroupsHeaderStructure", "hasOtherElementInTabSequence"], y$ = dn(function(t, n) {
  const {
    visibleColumns: r,
    sortColumnLookup: o,
    filterColumnLookup: i,
    columnHeaderTabIndexState: a,
    columnGroupHeaderTabIndexState: l,
    columnHeaderFocus: c,
    columnGroupHeaderFocus: d,
    headerGroupingMaxDepth: f,
    columnMenuState: p,
    columnVisibility: g,
    columnGroupsHeaderStructure: b,
    hasOtherElementInTabSequence: v
  } = t, y = yt(t, Nge), {
    getInnerProps: S,
    getColumnHeadersRow: E,
    getColumnGroupHeadersRows: I
  } = _ge({
    visibleColumns: r,
    sortColumnLookup: o,
    filterColumnLookup: i,
    columnHeaderTabIndexState: a,
    columnGroupHeaderTabIndexState: l,
    columnHeaderFocus: c,
    columnGroupHeaderFocus: d,
    headerGroupingMaxDepth: f,
    columnMenuState: p,
    columnVisibility: g,
    columnGroupsHeaderStructure: b,
    hasOtherElementInTabSequence: v
  });
  return /* @__PURE__ */ w.jsxs(Dge, U({}, y, S(), {
    ref: n,
    children: [I(), E()]
  }));
});
process.env.NODE_ENV !== "production" && (y$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  columnGroupHeaderFocus: s.shape({
    depth: s.number.isRequired,
    field: s.string.isRequired
  }),
  columnGroupHeaderTabIndexState: s.shape({
    depth: s.number.isRequired,
    field: s.string.isRequired
  }),
  columnGroupsHeaderStructure: s.arrayOf(s.arrayOf(s.shape({
    columnFields: s.arrayOf(s.string).isRequired,
    groupId: s.string
  }))).isRequired,
  columnHeaderFocus: s.shape({
    field: s.string.isRequired
  }),
  columnHeaderTabIndexState: s.shape({
    field: s.string.isRequired
  }),
  columnMenuState: s.shape({
    field: s.string,
    open: s.bool.isRequired
  }).isRequired,
  columnVisibility: s.object.isRequired,
  filterColumnLookup: s.object.isRequired,
  hasOtherElementInTabSequence: s.bool.isRequired,
  headerGroupingMaxDepth: s.number.isRequired,
  sortColumnLookup: s.object.isRequired,
  visibleColumns: s.arrayOf(s.object).isRequired
});
const Fge = Dl(y$);
function $ge(e) {
  return null;
}
function Lge(e) {
  return null;
}
const jge = dn(function(t, n) {
  const o = Wt().current.getLocaleText("noResultsOverlayLabel");
  return /* @__PURE__ */ w.jsx(my, U({}, t, {
    ref: n,
    children: o
  }));
}), Bge = ["sortingOrder"], Vge = /* @__PURE__ */ m.memo(function(t) {
  const {
    sortingOrder: n
  } = t, r = yt(t, Bge), o = ft(), [i] = n, a = i === "asc" ? o.slots.columnSortedAscendingIcon : o.slots.columnSortedDescendingIcon;
  return a ? /* @__PURE__ */ w.jsx(a, U({}, r)) : null;
}), Hge = ["native"];
function Uge(e) {
  let {
    native: t
  } = e, n = yt(e, Hge);
  return t ? /* @__PURE__ */ w.jsx("option", U({}, n)) : /* @__PURE__ */ w.jsx(ts, U({}, n));
}
const zge = {
  booleanCellTrueIcon: ufe,
  booleanCellFalseIcon: _w,
  columnMenuIcon: sfe,
  openFilterButtonIcon: Zde,
  filterPanelDeleteIcon: _w,
  columnFilteredIcon: TR,
  columnSelectorIcon: tfe,
  columnUnsortedIcon: Vge,
  columnSortedAscendingIcon: CR,
  columnSortedDescendingIcon: xR,
  columnResizeIcon: nfe,
  densityCompactIcon: rfe,
  densityStandardIcon: ofe,
  densityComfortableIcon: ife,
  exportIcon: cfe,
  moreActionsIcon: dfe,
  treeDataCollapseIcon: ER,
  treeDataExpandIcon: SR,
  groupingCriteriaCollapseIcon: ER,
  groupingCriteriaExpandIcon: SR,
  detailPanelExpandIcon: OR,
  detailPanelCollapseIcon: afe,
  rowReorderIcon: PR,
  quickFilterIcon: efe,
  quickFilterClearIcon: _w,
  columnMenuHideIcon: ffe,
  columnMenuSortAscendingIcon: CR,
  columnMenuSortDescendingIcon: xR,
  columnMenuFilterIcon: TR,
  columnMenuManageColumnsIcon: pfe,
  columnMenuClearIcon: hfe,
  loadIcon: lfe,
  filterPanelAddIcon: OR,
  filterPanelRemoveAllIcon: gfe,
  columnReorderIcon: PR
}, Gge = U({}, zge, {
  baseBadge: aM,
  baseCheckbox: hb,
  baseDivider: up,
  baseTextField: Ea,
  baseFormControl: lx,
  baseSelect: Kp,
  baseButton: as,
  baseIconButton: ks,
  baseInputAdornment: bl,
  baseTooltip: yx,
  basePopper: Pl,
  baseInputLabel: fx,
  baseSelectOption: Uge,
  baseChip: rx
}), Wge = U({}, Gge, {
  cell: Que,
  skeletonCell: nde,
  columnHeaderFilterIconButton: NF,
  columnHeaderSortIcon: Xde,
  columnMenu: WF,
  columnHeaders: Fge,
  detailPanels: $ge,
  footer: r$,
  footerRowCount: a$,
  toolbar: null,
  pinnedRows: Lge,
  loadingOverlay: o$,
  noResultsOverlay: jge,
  noRowsOverlay: i$,
  pagination: s$,
  filterPanel: XF,
  columnsPanel: qF,
  columnsManagement: JF,
  panel: KF,
  row: Ope
});
function qge({
  defaultSlots: e,
  slots: t
}) {
  const n = t;
  if (!n || Object.keys(n).length === 0)
    return e;
  const r = U({}, e);
  return Object.keys(n).forEach((o) => {
    const i = o;
    n[i] !== void 0 && (r[i] = n[i]);
  }), r;
}
function Kge(e) {
  var o;
  if ((o = e.slotProps) != null && o.root)
    return e;
  const t = Object.keys(e);
  if (!t.some((i) => i.startsWith("aria-") || i.startsWith("data-")))
    return e;
  const n = {}, r = e.forwardedProps ?? {};
  for (let i = 0; i < t.length; i += 1) {
    const a = t[i];
    a.startsWith("aria-") || a.startsWith("data-") ? r[a] = e[a] : n[a] = e[a];
  }
  return n.forwardedProps = r, n;
}
function Yge(e) {
  return m.useMemo(() => Kge(e), [e]);
}
const Qge = [(e) => e.autoPageSize && e.autoHeight && ["MUI X: `<DataGrid autoPageSize={true} autoHeight={true} />` are not valid props.", "You cannot use both the `autoPageSize` and `autoHeight` props at the same time because `autoHeight` scales the height of the Data Grid according to the `pageSize`.", "", "Please remove one of these two props."].join(`
`) || void 0, (e) => e.paginationMode === "client" && e.paginationMeta != null && ['MUI X: Usage of the `paginationMeta` prop with client-side pagination (`paginationMode="client"`) has no effect.', '`paginationMeta` is only meant to be used with `paginationMode="server"`.'].join(`
`) || void 0, (e) => e.signature === di.DataGrid && e.paginationMode === "client" && wN(e.rowCount) && ['MUI X: Usage of the `rowCount` prop with client side pagination (`paginationMode="client"`) has no effect.', '`rowCount` is only meant to be used with `paginationMode="server"`.'].join(`
`) || void 0, (e) => e.paginationMode === "server" && e.rowCount == null && !e.unstable_dataSource && ["MUI X: The `rowCount` prop must be passed using `paginationMode='server'`", "For more detail, see http://mui.com/components/data-grid/pagination/#index-based-pagination"].join(`
`) || void 0];
function Xge(e, t) {
  t.forEach((n) => {
    const r = n(e);
    r && ns(r, "error");
  });
}
const Jge = {
  disableMultipleColumnsFiltering: !0,
  disableMultipleColumnsSorting: !0,
  throttleRowsMs: void 0,
  hideFooterRowCount: !1,
  pagination: !0,
  checkboxSelectionVisibleOnly: !1,
  disableColumnReorder: !0,
  keepColumnPositionIfDraggedOutside: !1,
  signature: "DataGrid",
  unstable_listView: !1
}, Zge = Wge, eme = (e) => {
  const t = Yge(
    // eslint-disable-next-line material-ui/mui-name-matches-component-name
    Lk({
      props: e,
      name: "MuiDataGrid"
    })
  ), n = m.useMemo(() => U({}, Xse, t.localeText), [t.localeText]), r = m.useMemo(() => qge({
    defaultSlots: Zge,
    slots: t.slots
  }), [t.slots]), o = m.useMemo(() => Object.keys(lC).reduce((i, a) => (i[a] = t[a] ?? lC[a], i), {}), [t]);
  return m.useMemo(() => U({}, t, o, {
    localeText: n,
    slots: r
  }, Jge), [t, n, r, o]);
}, tme = {
  hooks: {
    useGridAriaAttributes: Ppe,
    useGridRowAriaAttributes: Ipe
  }
};
let v$;
process.env.NODE_ENV !== "production" && (v$ = [
  ...Qge,
  // Only validate in MIT version
  (e) => e.columns && e.columns.some((t) => t.resizable) && ["MUI X: `column.resizable = true` is not a valid prop.", "Column resizing is not available in the MIT version.", "", "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."].join(`
`) || void 0
]);
const w$ = dn(function(t, n) {
  var i;
  const r = eme(t), o = Pge(r.apiRef, r);
  return process.env.NODE_ENV !== "production" && Xge(r, v$), /* @__PURE__ */ w.jsx(Rpe, {
    privateApiRef: o,
    configuration: tme,
    props: r,
    children: /* @__PURE__ */ w.jsxs(xF, U({
      className: r.className,
      style: r.style,
      sx: r.sx
    }, r.forwardedProps, (i = r.slotProps) == null ? void 0 : i.root, {
      ref: n,
      children: [/* @__PURE__ */ w.jsx(fpe, {}), /* @__PURE__ */ w.jsx(zue, {}), /* @__PURE__ */ w.jsx(Gue, {})]
    }))
  });
}), C$ = /* @__PURE__ */ m.memo(w$);
w$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The ref object that allows Data Grid manipulation. Can be instantiated with `useGridApiRef()`.
   */
  apiRef: s.shape({
    current: s.object.isRequired
  }),
  /**
   * The label of the Data Grid.
   */
  "aria-label": s.string,
  /**
   * The id of the element containing a label for the Data Grid.
   */
  "aria-labelledby": s.string,
  /**
   * If `true`, the Data Grid height is dynamic and follows the number of rows in the Data Grid.
   * @default false
   * @deprecated Use flex parent container instead: https://mui.com/x/react-data-grid/layout/#flex-parent-container
   * @example
   * <div style={{ display: 'flex', flexDirection: 'column' }}>
   *   <DataGrid />
   * </div>
   */
  autoHeight: s.bool,
  /**
   * If `true`, the pageSize is calculated according to the container size and the max number of rows to avoid rendering a vertical scroll bar.
   * @default false
   */
  autoPageSize: s.bool,
  /**
   * If `true`, columns are autosized after the datagrid is mounted.
   * @default false
   */
  autosizeOnMount: s.bool,
  /**
   * The options for autosize when user-initiated.
   */
  autosizeOptions: s.shape({
    columns: s.arrayOf(s.string),
    disableColumnVirtualization: s.bool,
    expand: s.bool,
    includeHeaders: s.bool,
    includeOutliers: s.bool,
    outliersFactor: s.number
  }),
  /**
   * Controls the modes of the cells.
   */
  cellModesModel: s.object,
  /**
   * If `true`, the Data Grid will display an extra column with checkboxes for selecting rows.
   * @default false
   */
  checkboxSelection: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The character used to separate cell values when copying to the clipboard.
   * @default '\t'
   */
  clipboardCopyCellDelimiter: s.string,
  /**
   * Column region in pixels to render before/after the viewport
   * @default 150
   */
  columnBufferPx: s.number,
  /**
   * Sets the height in pixels of the column group headers in the Data Grid.
   * Inherits the `columnHeaderHeight` value if not set.
   */
  columnGroupHeaderHeight: s.number,
  columnGroupingModel: s.arrayOf(s.object),
  /**
   * Sets the height in pixel of the column headers in the Data Grid.
   * @default 56
   */
  columnHeaderHeight: s.number,
  /**
   * Set of columns of type [[GridColDef]][].
   */
  columns: s.arrayOf(s.object).isRequired,
  /**
   * Set the column visibility model of the Data Grid.
   * If defined, the Data Grid will ignore the `hide` property in [[GridColDef]].
   */
  columnVisibilityModel: s.object,
  /**
   * Set the density of the Data Grid.
   * @default "standard"
   */
  density: s.oneOf(["comfortable", "compact", "standard"]),
  /**
   * If `true`, column autosizing on header separator double-click is disabled.
   * @default false
   */
  disableAutosize: s.bool,
  /**
   * If `true`, column filters are disabled.
   * @default false
   */
  disableColumnFilter: s.bool,
  /**
   * If `true`, the column menu is disabled.
   * @default false
   */
  disableColumnMenu: s.bool,
  /**
   * If `true`, resizing columns is disabled.
   * @default false
   */
  disableColumnResize: s.bool,
  /**
   * If `true`, hiding/showing columns is disabled.
   * @default false
   */
  disableColumnSelector: s.bool,
  /**
   * If `true`, the column sorting feature will be disabled.
   * @default false
   */
  disableColumnSorting: s.bool,
  /**
   * If `true`, the density selector is disabled.
   * @default false
   */
  disableDensitySelector: s.bool,
  /**
   * If `true`, `eval()` is not used for performance optimization.
   * @default false
   */
  disableEval: s.bool,
  /**
   * If `true`, multiple selection using the Ctrl/CMD or Shift key is disabled.
   * The MIT DataGrid will ignore this prop, unless `checkboxSelection` is enabled.
   * @default false (`!props.checkboxSelection` for MIT Data Grid)
   */
  disableMultipleRowSelection: s.bool,
  /**
   * If `true`, the selection on click on a row or cell is disabled.
   * @default false
   */
  disableRowSelectionOnClick: s.bool,
  /**
   * If `true`, the virtualization is disabled.
   * @default false
   */
  disableVirtualization: s.bool,
  /**
   * Controls whether to use the cell or row editing.
   * @default "cell"
   */
  editMode: s.oneOf(["cell", "row"]),
  /**
   * Use if the actual rowCount is not known upfront, but an estimation is available.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   * Applicable only with `paginationMode="server"` and when `rowCount="-1"`
   */
  estimatedRowCount: s.number,
  /**
   * Unstable features, breaking changes might be introduced.
   * For each feature, if the flag is not explicitly set to `true`, the feature will be fully disabled and any property / method call will not have any effect.
   */
  experimentalFeatures: s.shape({
    warnIfFocusStateIsNotSynced: s.bool
  }),
  /**
   * The milliseconds delay to wait after a keystroke before triggering filtering.
   * @default 150
   */
  filterDebounceMs: s.number,
  /**
   * Filtering can be processed on the server or client-side.
   * Set it to 'server' if you would like to handle filtering on the server-side.
   * @default "client"
   */
  filterMode: s.oneOf(["client", "server"]),
  /**
   * Set the filter model of the Data Grid.
   */
  filterModel: s.shape({
    items: s.arrayOf(s.shape({
      field: s.string.isRequired,
      id: s.oneOfType([s.number, s.string]),
      operator: s.string.isRequired,
      value: s.any
    })).isRequired,
    logicOperator: s.oneOf(["and", "or"]),
    quickFilterExcludeHiddenColumns: s.bool,
    quickFilterLogicOperator: s.oneOf(["and", "or"]),
    quickFilterValues: s.array
  }),
  /**
   * Forwarded props for the Data Grid root element.
   * @ignore - do not document.
   */
  forwardedProps: s.object,
  /**
   * Function that applies CSS classes dynamically on cells.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {string} The CSS class to apply to the cell.
   */
  getCellClassName: s.func,
  /**
   * Function that returns the element to render in row detail.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {React.JSX.Element} The row detail element.
   */
  getDetailPanelContent: s.func,
  /**
   * Function that returns the estimated height for a row.
   * Only works if dynamic row height is used.
   * Once the row height is measured this value is discarded.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {number | null} The estimated row height value. If `null` or `undefined` then the default row height, based on the density, is applied.
   */
  getEstimatedRowHeight: s.func,
  /**
   * Function that applies CSS classes dynamically on rows.
   * @param {GridRowClassNameParams} params With all properties from [[GridRowClassNameParams]].
   * @returns {string} The CSS class to apply to the row.
   */
  getRowClassName: s.func,
  /**
   * Function that sets the row height per row.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {GridRowHeightReturnValue} The row height value. If `null` or `undefined` then the default row height is applied. If "auto" then the row height is calculated based on the content.
   */
  getRowHeight: s.func,
  /**
   * Return the id of a given [[GridRowModel]].
   */
  getRowId: s.func,
  /**
   * Function that allows to specify the spacing between rows.
   * @param {GridRowSpacingParams} params With all properties from [[GridRowSpacingParams]].
   * @returns {GridRowSpacing} The row spacing values.
   */
  getRowSpacing: s.func,
  /**
   * If `true`, the footer component is hidden.
   * @default false
   */
  hideFooter: s.bool,
  /**
   * If `true`, the pagination component in the footer is hidden.
   * @default false
   */
  hideFooterPagination: s.bool,
  /**
   * If `true`, the selected row count in the footer is hidden.
   * @default false
   */
  hideFooterSelectedRowCount: s.bool,
  /**
   * If `true`, the diacritics (accents) are ignored when filtering or quick filtering.
   * E.g. when filter value is `cafe`, the rows with `café` will be visible.
   * @default false
   */
  ignoreDiacritics: s.bool,
  /**
   * If `true`, the Data Grid will not use `valueFormatter` when exporting to CSV or copying to clipboard.
   * If an object is provided, you can choose to ignore the `valueFormatter` for CSV export or clipboard export.
   * @default false
   */
  ignoreValueFormatterDuringExport: s.oneOfType([s.shape({
    clipboardExport: s.bool,
    csvExport: s.bool
  }), s.bool]),
  /**
   * If `select`, a group header checkbox in indeterminate state (like "Select All" checkbox)
   * will select all the rows under it.
   * If `deselect`, it will deselect all the rows under it.
   * Works only if `checkboxSelection` is enabled.
   * @default "deselect"
   * @deprecated `select` will be the default behavior from v8 onwards
   */
  indeterminateCheckboxAction: s.oneOf(["deselect", "select"]),
  /**
   * The initial state of the DataGrid.
   * The data in it will be set in the state on initialization but will not be controlled.
   * If one of the data in `initialState` is also being controlled, then the control state wins.
   */
  initialState: s.object,
  /**
   * Callback fired when a cell is rendered, returns true if the cell is editable.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {boolean} A boolean indicating if the cell is editable.
   */
  isCellEditable: s.func,
  /**
   * Determines if a row can be selected.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {boolean} A boolean indicating if the row is selectable.
   */
  isRowSelectable: s.func,
  /**
   * If `true`, the selection model will retain selected rows that do not exist.
   * Useful when using server side pagination and row selections need to be retained
   * when changing pages.
   * @default false
   */
  keepNonExistentRowsSelected: s.bool,
  /**
   * If `true`, a loading overlay is displayed.
   * @default false
   */
  loading: s.bool,
  /**
   * Set the locale text of the Data Grid.
   * You can find all the translation keys supported in [the source](https://github.com/mui/mui-x/blob/HEAD/packages/x-data-grid/src/constants/localeTextConstants.ts) in the GitHub repository.
   */
  localeText: s.object,
  /**
   * Pass a custom logger in the components that implements the [[Logger]] interface.
   * @default console
   */
  logger: s.shape({
    debug: s.func.isRequired,
    error: s.func.isRequired,
    info: s.func.isRequired,
    warn: s.func.isRequired
  }),
  /**
   * Allows to pass the logging level or false to turn off logging.
   * @default "error" ("warn" in dev mode)
   */
  logLevel: s.oneOf(["debug", "error", "info", "warn", !1]),
  /**
   * Nonce of the inline styles for [Content Security Policy](https://www.w3.org/TR/2016/REC-CSP2-20161215/#script-src-the-nonce-attribute).
   */
  nonce: s.string,
  /**
   * Callback fired when any cell is clicked.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onCellClick: s.func,
  /**
   * Callback fired when a double click event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onCellDoubleClick: s.func,
  /**
   * Callback fired when the cell turns to edit mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */
  onCellEditStart: s.func,
  /**
   * Callback fired when the cell turns to view mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */
  onCellEditStop: s.func,
  /**
   * Callback fired when a keydown event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onCellKeyDown: s.func,
  /**
   * Callback fired when the `cellModesModel` prop changes.
   * @param {GridCellModesModel} cellModesModel Object containing which cells are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onCellModesModelChange: s.func,
  /**
   * Callback called when the data is copied to the clipboard.
   * @param {string} data The data copied to the clipboard.
   */
  onClipboardCopy: s.func,
  /**
   * Callback fired when a click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderClick: s.func,
  /**
   * Callback fired when a contextmenu event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   */
  onColumnHeaderContextMenu: s.func,
  /**
   * Callback fired when a double click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderDoubleClick: s.func,
  /**
   * Callback fired when a mouse enter event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderEnter: s.func,
  /**
   * Callback fired when a mouse leave event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderLeave: s.func,
  /**
   * Callback fired when a mouseout event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderOut: s.func,
  /**
   * Callback fired when a mouseover event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderOver: s.func,
  /**
   * Callback fired when a column is reordered.
   * @param {GridColumnOrderChangeParams} params With all properties from [[GridColumnOrderChangeParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnOrderChange: s.func,
  /**
   * Callback fired while a column is being resized.
   * @param {GridColumnResizeParams} params With all properties from [[GridColumnResizeParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnResize: s.func,
  /**
   * Callback fired when the column visibility model changes.
   * @param {GridColumnVisibilityModel} model The new model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnVisibilityModelChange: s.func,
  /**
   * Callback fired when the width of a column is changed.
   * @param {GridColumnResizeParams} params With all properties from [[GridColumnResizeParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnWidthChange: s.func,
  /**
   * Callback fired when the density changes.
   * @param {GridDensity} density New density value.
   */
  onDensityChange: s.func,
  /**
   * Callback fired when the Filter model changes before the filters are applied.
   * @param {GridFilterModel} model With all properties from [[GridFilterModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onFilterModelChange: s.func,
  /**
   * Callback fired when the menu is closed.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onMenuClose: s.func,
  /**
   * Callback fired when the menu is opened.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onMenuOpen: s.func,
  /**
   * Callback fired when the pagination meta has changed.
   * @param {GridPaginationMeta} paginationMeta Updated pagination meta.
   */
  onPaginationMetaChange: s.func,
  /**
   * Callback fired when the pagination model has changed.
   * @param {GridPaginationModel} model Updated pagination model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onPaginationModelChange: s.func,
  /**
   * Callback fired when the preferences panel is closed.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onPreferencePanelClose: s.func,
  /**
   * Callback fired when the preferences panel is opened.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onPreferencePanelOpen: s.func,
  /**
   * Callback called when `processRowUpdate` throws an error or rejects.
   * @param {any} error The error thrown.
   */
  onProcessRowUpdateError: s.func,
  /**
   * Callback fired when the Data Grid is resized.
   * @param {ElementSize} containerSize With all properties from [[ElementSize]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onResize: s.func,
  /**
   * Callback fired when a row is clicked.
   * Not called if the target clicked is an interactive element added by the built-in columns.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowClick: s.func,
  /**
   * Callback fired when the row count has changed.
   * @param {number} count Updated row count.
   */
  onRowCountChange: s.func,
  /**
   * Callback fired when a double click event comes from a row container element.
   * @param {GridRowParams} params With all properties from [[RowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowDoubleClick: s.func,
  /**
   * Callback fired when the row turns to edit mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */
  onRowEditStart: s.func,
  /**
   * Callback fired when the row turns to view mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */
  onRowEditStop: s.func,
  /**
   * Callback fired when the `rowModesModel` prop changes.
   * @param {GridRowModesModel} rowModesModel Object containing which rows are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowModesModelChange: s.func,
  /**
   * Callback fired when the selection state of one or multiple rows changes.
   * @param {GridRowSelectionModel} rowSelectionModel With all the row ids [[GridSelectionModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowSelectionModelChange: s.func,
  /**
   * Callback fired when the sort model changes before a column is sorted.
   * @param {GridSortModel} model With all properties from [[GridSortModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onSortModelChange: s.func,
  /**
   * Callback fired when the state of the Data Grid is updated.
   * @param {GridState} state The new state.
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   * @ignore - do not document.
   */
  onStateChange: s.func,
  /**
   * Select the pageSize dynamically using the component UI.
   * @default [25, 50, 100]
   */
  pageSizeOptions: s.arrayOf(s.oneOfType([s.number, s.shape({
    label: s.string.isRequired,
    value: s.number.isRequired
  })]).isRequired),
  pagination: s.oneOf([!0]),
  /**
   * The extra information about the pagination state of the Data Grid.
   * Only applicable with `paginationMode="server"`.
   */
  paginationMeta: s.shape({
    hasNextPage: s.bool
  }),
  /**
   * Pagination can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle the pagination on the client-side.
   * Set it to 'server' if you would like to handle the pagination on the server-side.
   * @default "client"
   */
  paginationMode: s.oneOf(["client", "server"]),
  /**
   * The pagination model of type [[GridPaginationModel]] which refers to current `page` and `pageSize`.
   */
  paginationModel: s.shape({
    page: s.number.isRequired,
    pageSize: s.number.isRequired
  }),
  /**
   * Callback called before updating a row with new values in the row and cell editing.
   * @template R
   * @param {R} newRow Row object with the new values.
   * @param {R} oldRow Row object with the old values.
   * @param {{ rowId: GridRowId }} params Additional parameters.
   * @returns {Promise<R> | R} The final values to update the row.
   */
  processRowUpdate: s.func,
  /**
   * The milliseconds throttle delay for resizing the grid.
   * @default 60
   */
  resizeThrottleMs: s.number,
  /**
   * Row region in pixels to render before/after the viewport
   * @default 150
   */
  rowBufferPx: s.number,
  /**
   * Set the total number of rows, if it is different from the length of the value `rows` prop.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   * Only works with `paginationMode="server"`, ignored when `paginationMode="client"`.
   */
  rowCount: s.number,
  /**
   * Sets the height in pixel of a row in the Data Grid.
   * @default 52
   */
  rowHeight: s.number,
  /**
   * Controls the modes of the rows.
   */
  rowModesModel: s.object,
  /**
   * The milliseconds delay to wait after measuring the row height before recalculating row positions.
   * Setting it to a lower value could be useful when using dynamic row height,
   * but might reduce performance when displaying a large number of rows.
   * @default 166
   * @deprecated
   */
  rowPositionsDebounceMs: s.number,
  /**
   * Set of rows of type [[GridRowsProp]].
   * @default []
   */
  rows: s.arrayOf(s.object),
  /**
   * If `false`, the row selection mode is disabled.
   * @default true
   */
  rowSelection: s.bool,
  /**
   * Sets the row selection model of the Data Grid.
   */
  rowSelectionModel: s.oneOfType([s.arrayOf(s.oneOfType([s.number, s.string]).isRequired), s.number, s.string]),
  /**
   * Sets the type of space between rows added by `getRowSpacing`.
   * @default "margin"
   */
  rowSpacingType: s.oneOf(["border", "margin"]),
  /**
   * Override the height/width of the Data Grid inner scrollbar.
   */
  scrollbarSize: s.number,
  /**
   * If `true`, vertical borders will be displayed between cells.
   * @default false
   */
  showCellVerticalBorder: s.bool,
  /**
   * If `true`, vertical borders will be displayed between column header items.
   * @default false
   */
  showColumnVerticalBorder: s.bool,
  /**
   * Overridable components props dynamically passed to the component at rendering.
   */
  slotProps: s.object,
  /**
   * Overridable components.
   */
  slots: s.object,
  /**
   * Sorting can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle sorting on the client-side.
   * Set it to 'server' if you would like to handle sorting on the server-side.
   * @default "client"
   */
  sortingMode: s.oneOf(["client", "server"]),
  /**
   * The order of the sorting sequence.
   * @default ['asc', 'desc', null]
   */
  sortingOrder: s.arrayOf(s.oneOf(["asc", "desc"])),
  /**
   * Set the sort model of the Data Grid.
   */
  sortModel: s.arrayOf(s.shape({
    field: s.string.isRequired,
    sort: s.oneOf(["asc", "desc"])
  })),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * If `true`, the Data Grid will auto span the cells over the rows having the same value.
   * @default false
   */
  unstable_rowSpanning: s.bool,
  /**
   * If `true`, the Data Grid enables column virtualization when `getRowHeight` is set to `() => 'auto'`.
   * By default, column virtualization is disabled when dynamic row height is enabled to measure the row height correctly.
   * For datasets with a large number of columns, this can cause performance issues.
   * The downside of enabling this prop is that the row height will be estimated based the cells that are currently rendered, which can cause row height change when scrolling horizontally.
   * @default false
   */
  virtualizeColumnsWithAutoRowHeight: s.bool
};
const HS = oe(Rt)(() => ({
  whiteSpace: "normal",
  width: "fit-content"
})), nme = oe(sx)(({ theme: e }) => ({
  padding: e.spacing(1),
  margin: e.spacing(1, 0)
})), rme = oe(_t)(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: e.spacing(1.5)
})), ome = oe(C$)(({ theme: e }) => ({
  [e.breakpoints.up("md")]: {
    maxWidth: "50vw"
    // Makes the datagrid responsive
  },
  [e.breakpoints.down("md")]: {
    maxWidth: "100vw"
    // Makes the datagrid responsive
  },
  border: 0,
  "& .MuiDataGrid-cell, & .MuiDataGrid-columnHeaders, & .MuiDataGrid-columnHeader": {
    border: "none !important"
  },
  "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus-within": {
    outline: "none"
  },
  "& .MuiDataGrid-columnSeparator": {
    display: "none"
  },
  "& .Mui-selected, & :hover": {
    backgroundColor: "transparent !important"
  }
})), ime = oe(pb)(({ theme: e }) => ({
  padding: e.spacing(1, 2),
  "&:last-child": {
    paddingBottom: e.spacing(1)
  }
}));
function WR(e) {
  return /* @__PURE__ */ w.jsxs(rme, { children: [
    /* @__PURE__ */ w.jsx(HS, { variant: "h4", children: e.colDef.headerName }),
    /* @__PURE__ */ w.jsx(Kb, { hint: e.colDef.headerHint })
  ] });
}
function sme(e) {
  return /* @__PURE__ */ w.jsx(_t, { sx: { height: "100%", alignContent: "center" }, children: /* @__PURE__ */ w.jsx(HS, { variant: "h4", children: e.row.id }) });
}
function qR(e) {
  return /* @__PURE__ */ w.jsx(_t, { sx: { height: "100%", alignContent: "center" }, children: /* @__PURE__ */ w.jsx(HS, { variant: "body1", children: Number.isNaN(e.value) ? "-" : Or(e.value, { maximumFractionDigits: 1 }) + " t" }) });
}
function ame(e) {
  const { t } = jn();
  return /* @__PURE__ */ w.jsx(nme, { "data-testid": "quantities-table", children: /* @__PURE__ */ w.jsx(ime, { children: /* @__PURE__ */ w.jsx(
    ome,
    {
      rows: [
        {
          id: t("acreageCalculator:label.quantityLieferanspruch"),
          already: e.alreadyContracted.lieferanspruch,
          next: e.adjustmentsNextContracting.lieferanspruch
        },
        {
          id: t("acreageCalculator:label.quantityFreieMenge"),
          already: e.alreadyContracted.freieMenge,
          next: e.adjustmentsNextContracting.freieMenge
        },
        {
          id: t("acreageCalculator:label.sum"),
          already: e.alreadyContracted.lieferanspruch + e.alreadyContracted.freieMenge,
          next: e.adjustmentsNextContracting.lieferanspruch + e.adjustmentsNextContracting.freieMenge
        }
      ],
      columns: [
        {
          field: "id",
          headerName: "",
          flex: 4,
          renderCell: sme
        },
        {
          field: "already",
          headerName: t(
            "acreageCalculator:label.quantityAlreadyContracted"
          ),
          headerHint: t(
            "acreageCalculator:hint.quantityAlreadyContracted"
          ),
          flex: 3,
          renderHeader: WR,
          renderCell: qR
        },
        {
          field: "next",
          headerName: t(
            "acreageCalculator:label.quantityNextContracting"
          ),
          headerHint: t("acreageCalculator:hint.quantityNextContracting"),
          flex: 3,
          renderHeader: WR,
          renderCell: qR
        }
      ],
      hideFooter: !0,
      disableColumnMenu: !0,
      disableColumnSorting: !0
    }
  ) }) });
}
const lme = At(/* @__PURE__ */ w.jsx("path", {
  d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8"
}), "Replay");
function x$(e) {
  const { t } = jn();
  return /* @__PURE__ */ w.jsx(
    as,
    {
      variant: "contained",
      onClick: e.onClick,
      startIcon: /* @__PURE__ */ w.jsx(lme, { "aria-hidden": !0 }),
      "aria-label": t("acreageCalculator:button.resetParameters.explanation"),
      children: t("acreageCalculator:button.resetParameters.label")
    }
  );
}
const cme = oe($r)(({ theme: e }) => ({
  width: "100%",
  boxSizing: "border-box",
  padding: e.spacing(3),
  gap: e.spacing(2)
})), ume = oe($r)(({ theme: e }) => ({
  width: "100%",
  alignItems: "center",
  flexDirection: "row",
  gap: e.spacing(2)
})), dme = oe(_t)(({ theme: e }) => ({
  display: "flex",
  justifyContent: "flex-end",
  gap: e.spacing(1),
  marginTop: e.spacing(1)
}));
function Tp(e) {
  const {
    open: t,
    titleText: n,
    explanationText: r,
    informationText: o,
    informationElement: i,
    primaryAction: a,
    secondaryAction: l
  } = e;
  return /* @__PURE__ */ w.jsx(
    hM,
    {
      onClose: l.onClick,
      open: t,
      maxWidth: wt(i) ? "md" : void 0,
      children: /* @__PURE__ */ w.jsxs(cme, { children: [
        /* @__PURE__ */ w.jsxs(ume, { children: [
          e.icon,
          /* @__PURE__ */ w.jsx(Rt, { variant: "h3", children: n })
        ] }),
        /* @__PURE__ */ w.jsxs(_t, { "data-testid": "confirmation-dialog-content", children: [
          /* @__PURE__ */ w.jsx(Rt, { marginBottom: "8px", children: r }),
          o && (Array.isArray(o) ? o.map((c) => /* @__PURE__ */ w.jsx(Rt, { children: c }, c)) : /* @__PURE__ */ w.jsx(Rt, { children: o })),
          i
        ] }),
        /* @__PURE__ */ w.jsxs(dme, { children: [
          /* @__PURE__ */ w.jsx(
            as,
            {
              variant: "outlined",
              color: l.color,
              onClick: l.onClick,
              children: /* @__PURE__ */ w.jsx(Rt, { color: l.color, variant: "button", children: l.text })
            }
          ),
          a && /* @__PURE__ */ w.jsx(
            as,
            {
              variant: "contained",
              color: a.color,
              onClick: a.onClick,
              children: /* @__PURE__ */ w.jsx(Rt, { variant: "button", color: "#FFFFFF", children: a.text })
            }
          )
        ] })
      ] })
    }
  );
}
const fme = oe(_t)(({ theme: e }) => ({
  display: "flex",
  alignItems: "start",
  gap: e.spacing(0, 1)
})), KR = oe(Rt)(() => ({
  fontWeight: 300,
  lineHeight: 0.8,
  fontSize: "4rem"
}));
function pme(e) {
  const { content: t } = e;
  return /* @__PURE__ */ w.jsxs(fme, { children: [
    /* @__PURE__ */ w.jsx(KR, { children: "(" }),
    t,
    /* @__PURE__ */ w.jsx(KR, { children: ")" })
  ] });
}
const Ts = oe(Rt)(
  {
    fontWeight: 600
  }
), hme = oe(_t)(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  gap: e.spacing(1)
}));
function YR(e) {
  const { minuend: t, subtrahend: n } = e;
  return /* @__PURE__ */ w.jsxs(hme, { children: [
    /* @__PURE__ */ w.jsx(Ts, { children: t }),
    /* @__PURE__ */ w.jsx(Ts, { children: "-" }),
    /* @__PURE__ */ w.jsx(Ts, { children: n })
  ] });
}
const gme = oe(_t)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  width: "max-content"
}), mme = oe("div")(({ theme: e }) => ({
  width: "100%",
  height: "2px",
  backgroundColor: e.palette.text.primary,
  margin: e.spacing(1, 0)
})), QR = oe(_t)(({ theme: e }) => ({
  padding: e.spacing(0, 1)
}));
function Rg(e) {
  return /* @__PURE__ */ w.jsxs(gme, { children: [
    /* @__PURE__ */ w.jsx(QR, { children: e.numerator }),
    /* @__PURE__ */ w.jsx(mme, {}),
    /* @__PURE__ */ w.jsx(QR, { children: e.denominator })
  ] });
}
const bme = oe(_t)(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  gap: e.spacing(1)
}));
function Fw(e) {
  const { factor1: t, factor2: n } = e;
  return /* @__PURE__ */ w.jsxs(bme, { children: [
    t,
    /* @__PURE__ */ w.jsx(Ts, { children: "*" }),
    n
  ] });
}
const yme = oe(_t)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  gap: e.spacing(3)
})), $w = oe(_t)(({ theme: e }) => ({
  display: "flex",
  justifyContent: "center",
  margin: e.spacing(1, 1, 1, 1)
}));
function S$(e) {
  const { t } = jn(), n = e.data, r = /* @__PURE__ */ w.jsx(
    Rg,
    {
      numerator: /* @__PURE__ */ w.jsx(
        YR,
        {
          minuend: t(
            "acreageCalculator:formulasDialog.label.baseSugarContent",
            { value: n.baseSugarContent }
          ),
          subtrahend: t("acreageCalculator:formulasDialog.label.yieldLoss", {
            value: n.yieldLoss
          })
        }
      ),
      denominator: /* @__PURE__ */ w.jsx(
        YR,
        {
          minuend: t(
            "acreageCalculator:formulasDialog.label.individualSugarContent",
            { value: n.individualSugarContent }
          ),
          subtrahend: t("acreageCalculator:formulasDialog.label.yieldLoss", {
            value: n.yieldLoss
          })
        }
      )
    }
  );
  let o, i;
  switch (e.mode) {
    case "PLANNER": {
      o = t(
        "acreageCalculator:formulasDialog.explanationBeetGrowingArea"
      ), i = /* @__PURE__ */ w.jsx($w, { children: /* @__PURE__ */ w.jsx(
        Fw,
        {
          factor1: /* @__PURE__ */ w.jsx(
            Rg,
            {
              numerator: /* @__PURE__ */ w.jsx(Ts, { children: t(
                "acreageCalculator:formulasDialog.label.alreadyContractedQuantity",
                {
                  value: n.alreadyContractedQuantity
                }
              ) }),
              denominator: /* @__PURE__ */ w.jsx(Ts, { children: t("acreageCalculator:formulasDialog.label.beetsYield", {
                value: n.beetsYield
              }) })
            }
          ),
          factor2: r
        }
      ) });
      break;
    }
    case "ASSISTANT": {
      o = t(
        "acreageCalculator:formulasDialog.explanationTotalContractingQuantity"
      ), i = /* @__PURE__ */ w.jsx($w, { children: /* @__PURE__ */ w.jsx(
        Rg,
        {
          numerator: /* @__PURE__ */ w.jsx(
            Fw,
            {
              factor1: /* @__PURE__ */ w.jsx(Ts, { children: t("acreageCalculator:formulasDialog.label.growingArea", {
                value: n.growingArea
              }) }),
              factor2: /* @__PURE__ */ w.jsx(Ts, { children: t("acreageCalculator:formulasDialog.label.beetsYield", {
                value: n.beetsYield
              }) })
            }
          ),
          denominator: /* @__PURE__ */ w.jsx(pme, { content: r })
        }
      ) });
      break;
    }
  }
  return /* @__PURE__ */ w.jsx(
    Tp,
    {
      open: e.open,
      titleText: t("acreageCalculator:formulasDialog.title"),
      informationElement: /* @__PURE__ */ w.jsxs(yme, { children: [
        /* @__PURE__ */ w.jsxs(_t, { children: [
          /* @__PURE__ */ w.jsx(Rt, { children: t("acreageCalculator:formulasDialog.explanationRequiredAcreage") }),
          /* @__PURE__ */ w.jsx($w, { children: /* @__PURE__ */ w.jsx(
            Fw,
            {
              factor1: /* @__PURE__ */ w.jsx(
                Rg,
                {
                  numerator: /* @__PURE__ */ w.jsx(Ts, { children: "100 t" }),
                  denominator: /* @__PURE__ */ w.jsx(Ts, { children: t(
                    "acreageCalculator:formulasDialog.label.beetsYield",
                    {
                      value: n.beetsYield
                    }
                  ) })
                }
              ),
              factor2: r
            }
          ) })
        ] }),
        /* @__PURE__ */ w.jsxs(_t, { children: [
          /* @__PURE__ */ w.jsx(Rt, { children: o }),
          i
        ] })
      ] }),
      secondaryAction: {
        text: t("acreageCalculator:formulasDialog.ok"),
        color: "primary",
        onClick: e.closeDialog
      }
    }
  );
}
const E$ = {
  validations: {
    individualBeetYield: {
      minimum: 10,
      maximum: 170
    },
    individualSugarContent: {
      minimum: 13,
      maximum: 25
    }
  }
};
function T$() {
  const e = Li(VD);
  if (e === void 0)
    throw new Error(
      "useAcreageCalculator must be used within a AcreageCalculatorWrapper."
    );
  return e;
}
const US = "Lieferanspruch", zS = "FreieMenge";
function vme(e, t) {
  sessionStorage.setItem(US, e.toString()), sessionStorage.setItem(zS, t.toString());
}
function wme() {
  const e = sessionStorage.getItem(US), t = sessionStorage.getItem(zS);
  return {
    lieferanspruch: e !== null ? parseFloat(e) : null,
    freieMenge: t !== null ? parseFloat(t) : null
  };
}
function O$() {
  return sessionStorage.getItem(US) !== null && sessionStorage.getItem(zS) !== null;
}
function XR(e) {
  const t = Math.round(e * 10) / 10;
  return Object.is(t, -0) ? 0 : t;
}
function by(e, t, n) {
  return (e - n) / (t - n);
}
function fC(e, t, n, r, o) {
  const i = by(
    n,
    r,
    o
  );
  return e * i / t;
}
function pC(e, t, n, r) {
  return 100 * by(
    t,
    n,
    r
  ) / e;
}
function Cme(e, t, n, r, o) {
  const i = by(
    n,
    r,
    o
  );
  return e * t / i;
}
function xme(e, t, n, r) {
  const o = e + t, i = r - o, a = XR(
    Math.min(n, i)
  );
  return {
    lieferanspruch: a,
    freieMenge: XR(i - a)
  };
}
function Sme(e, t, n, r, o, i) {
  const a = t + e, l = by(
    n,
    r,
    o
  ), c = i - a;
  return {
    fromExistingContracts: a * l,
    adjustmentsForNextContracting: c * l
  };
}
const Eme = oe($r)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "row",
  [e.breakpoints.down("md")]: {
    flexDirection: "column"
  },
  gap: e.spacing(5),
  padding: e.spacing(2, 5),
  alignItems: "flex-top"
})), Tme = oe(up)(({ theme: e }) => ({
  [e.breakpoints.up("md")]: {
    borderRightWidth: 3
  },
  [e.breakpoints.down("xs")]: {
    borderBottomWidth: 3
  }
})), Ome = oe(_t)(({ theme: e }) => ({
  display: "flex",
  flex: 2,
  flexDirection: "column",
  gap: e.spacing(1)
})), Pme = oe(_t)(({ theme: e }) => ({
  display: "flex",
  flex: 3,
  flexDirection: "column",
  gap: e.spacing(1)
})), JR = oe(_t)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  justifyContent: "space-between",
  alignItems: "center",
  paddingBottom: e.spacing(1)
})), Ime = oe(_t)(({ theme: e }) => ({
  display: "flex",
  alignSelf: "flex-end",
  alignItems: "center",
  width: "max-content",
  marginBottom: e.spacing(2),
  gap: e.spacing(2),
  height: "30px"
}));
function Rme(e) {
  const t = e.multi_year_yield_average * e.yield_year_factor, n = e.multi_year_sugar_content;
  return {
    beetGrowingArea: fC(
      e.already_contracted_lieferanspruch + e.already_contracted_freie_menge,
      t,
      e.basis_sugar_content,
      n,
      e.extraction_loss
    ),
    individualBeetYield: t,
    individualSugarContent: n
  };
}
function _me() {
  const e = bo(), t = dx(e.breakpoints.down("md")), { t: n } = jn(), r = Md(), o = T$(), i = o.data, a = o.individualMultiYearValues, [l, c] = Jt(!1), [d, f] = Jt(!0), [p, g] = Jt(0), [b, v] = Jt(0), [
    y,
    S
  ] = Jt(0), [
    E,
    I
  ] = Jt(0), [O, T] = Jt(!0), P = Rme(i), { registerField: R, watch: F, formState: A, getValues: _, reset: C } = ey({
    values: Xb(P)
  }), D = F("beetGrowingArea"), L = F("individualSugarContent"), B = F("individualBeetYield"), H = CC(() => {
    const { beetGrowingArea: V, individualBeetYield: $, individualSugarContent: z } = _(), ne = pC(
      Ss($),
      i.basis_sugar_content,
      Ss(z),
      i.extraction_loss
    ), K = Cme(
      Ss(V),
      Ss($),
      i.basis_sugar_content,
      Ss(z),
      i.extraction_loss
    ), Q = Sme(
      i.already_contracted_lieferanspruch,
      i.already_contracted_freie_menge,
      i.basis_sugar_content,
      Ss(z),
      i.extraction_loss,
      K
    );
    g(ne), v(K), S(
      Q.fromExistingContracts
    ), I(
      Q.adjustmentsForNextContracting
    ), T(
      K >= i.already_contracted_lieferanspruch + i.already_contracted_freie_menge
    );
  }, [_, i]);
  ir(() => {
    d && (H(), f(!1));
  }, [H, d]);
  async function k() {
    f(!0);
  }
  const N = xme(
    i.already_contracted_lieferanspruch,
    i.already_contracted_freie_menge,
    i.available_lieferanspruch,
    b
  ), j = A.isDirty && !A.isValid || !O, W = E$.validations;
  return /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
    /* @__PURE__ */ w.jsx(
      S$,
      {
        open: l,
        closeDialog: () => {
          c(!1);
        },
        mode: "ASSISTANT",
        data: {
          baseSugarContent: Or(i.basis_sugar_content, {
            maximumFractionDigits: 3
          }),
          individualSugarContent: Or(
            L,
            { maximumFractionDigits: 3 }
          ),
          yieldLoss: Or(i.extraction_loss, {
            maximumFractionDigits: 2
          }),
          beetsYield: Or(B, {
            maximumFractionDigits: 3
          }),
          growingArea: Or(D, {
            maximumFractionDigits: 2
          })
        }
      }
    ),
    /* @__PURE__ */ w.jsx(xD, { noValidate: !0, autoComplete: "off", children: /* @__PURE__ */ w.jsxs(Eme, { children: [
      /* @__PURE__ */ w.jsxs(Ome, { "data-testid": "calculator-section", children: [
        /* @__PURE__ */ w.jsxs(JR, { children: [
          /* @__PURE__ */ w.jsx(Rt, { variant: "h3", children: n("acreageCalculator:heading.calculator") }),
          /* @__PURE__ */ w.jsx(
            x$,
            {
              onClick: () => {
                C(), H();
              }
            }
          )
        ] }),
        /* @__PURE__ */ w.jsx(Rt, { "data-testid": "section-explanation", children: n("acreageCalculator:explanation.adaptParameters") }),
        /* @__PURE__ */ w.jsx(Es, { children: /* @__PURE__ */ w.jsx(
          Bu,
          {
            ...R("beetGrowingArea", {
              validate: {
                number: (V) => V === P.beetGrowingArea ? void 0 : aN(V, n),
                nonNegative: (V) => Vse(V, n)
              },
              required: n("acreageCalculator:validation.required")
            }),
            label: n("acreageCalculator:label.beetGrowingArea"),
            inputMode: "decimal",
            maximumFractionDigits: 2,
            unit: "ha",
            helperText: A.dirtyFields.beetGrowingArea ? n("acreageCalculator:helperText.defaultBeetGrowingArea", {
              recommendedArea: Or(
                P.beetGrowingArea,
                { maximumFractionDigits: 2 }
              )
            }) : void 0,
            hint: n("acreageCalculator:hint.beetGrowingArea"),
            onChange: k,
            onBlur: k
          }
        ) }),
        /* @__PURE__ */ w.jsx(Es, { children: /* @__PURE__ */ w.jsx(
          Bu,
          {
            ...R("individualBeetYield", {
              validate: {
                number: (V) => Rm(V, n),
                range: (V) => _m(
                  V,
                  W.individualBeetYield.minimum,
                  W.individualBeetYield.maximum,
                  n
                )
              },
              required: n("acreageCalculator:validation.required")
            }),
            label: n("acreageCalculator:label.individualBeetYield"),
            inputMode: "decimal",
            maximumFractionDigits: 3,
            unit: "t/ha",
            helperText: A.dirtyFields.individualBeetYield ? n(
              "acreageCalculator:helperText.defaultIndividualBeetYield",
              {
                defaultValue: Or(
                  P.individualBeetYield,
                  { maximumFractionDigits: 3 }
                )
              }
            ) : void 0,
            hint: n("acreageCalculator:hint.individualBeetYield") + (a.yieldAverage ? n("acreageCalculator:hint.individualSource") : n("acreageCalculator:hint.defaultSource")) + (i.yield_year_factor !== 1 ? n(
              "acreageCalculator:hint.individualBeetYieldYearFactor",
              { factor: i.yield_year_factor }
            ) : ""),
            onChange: k,
            onBlur: k
          }
        ) }),
        /* @__PURE__ */ w.jsx(Es, { children: /* @__PURE__ */ w.jsx(
          Bu,
          {
            ...R("individualSugarContent", {
              validate: {
                number: (V) => Rm(V, n),
                range: (V) => _m(
                  V,
                  W.individualSugarContent.minimum,
                  W.individualSugarContent.maximum,
                  n
                )
              },
              required: n("acreageCalculator:validation.required")
            }),
            label: n("acreageCalculator:label.individualSugarContent"),
            inputMode: "decimal",
            maximumFractionDigits: 3,
            unit: "%",
            helperText: A.dirtyFields.individualSugarContent ? n(
              "acreageCalculator:helperText.defaultIndividualSugarContent",
              {
                defaultValue: Or(
                  P.individualSugarContent,
                  { maximumFractionDigits: 3 }
                )
              }
            ) : void 0,
            hint: n("acreageCalculator:hint.individualSugarContent") + (a.sugarContent ? n("acreageCalculator:hint.individualSource") : n("acreageCalculator:hint.defaultSource")),
            onChange: k,
            onBlur: k
          }
        ) }),
        /* @__PURE__ */ w.jsx(
          cN,
          {
            onFormulaButtonClick: () => c(!0)
          }
        ),
        /* @__PURE__ */ w.jsxs(Es, { children: [
          /* @__PURE__ */ w.jsx(
            Ja,
            {
              textFieldOptions: {
                label: n("acreageCalculator:label.requiredAcreagePer100t"),
                value: p
              },
              inputMode: "decimal",
              maximumFractionDigits: 2,
              unit: "ha",
              hint: n("acreageCalculator:hint.requiredAcreagePer100t")
            }
          ),
          /* @__PURE__ */ w.jsx(
            Ja,
            {
              textFieldOptions: {
                label: n("acreageCalculator:label.totalContractingQuantity"),
                value: b
              },
              inputMode: "decimal",
              maximumFractionDigits: 1,
              unit: "t",
              hint: n("acreageCalculator:hint.totalContractingQuantity")
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ w.jsx(
        Tme,
        {
          orientation: t ? "horizontal" : "vertical"
        }
      ),
      /* @__PURE__ */ w.jsxs(Pme, { "data-testid": "assistant-section", children: [
        /* @__PURE__ */ w.jsx(JR, { children: /* @__PURE__ */ w.jsx(Rt, { variant: "h3", children: n("acreageCalculator:heading.assistant") }) }),
        /* @__PURE__ */ w.jsx(Rt, { "data-testid": "section-explanation", children: n("acreageCalculator:explanation.contractingRecommendations") }),
        /* @__PURE__ */ w.jsx(Es, { width: "50%", children: /* @__PURE__ */ w.jsx(
          Ja,
          {
            textFieldOptions: {
              label: n("acreageCalculator:label.availableLieferanspruch"),
              value: i.available_lieferanspruch,
              helperText: n(
                "acreageCalculator:helperText.contractingReference",
                { year: (/* @__PURE__ */ new Date()).getFullYear() }
              )
            },
            inputMode: "decimal",
            maximumFractionDigits: 2,
            unit: "t"
          }
        ) }),
        /* @__PURE__ */ w.jsx(
          ame,
          {
            alreadyContracted: {
              lieferanspruch: i.already_contracted_lieferanspruch,
              freieMenge: i.already_contracted_freie_menge
            },
            adjustmentsNextContracting: N
          }
        ),
        /* @__PURE__ */ w.jsxs(Ime, { children: [
          j && /* @__PURE__ */ w.jsx(
            sh,
            {
              title: n("acreageCalculator:error.toEContractingDisabled") + (O ? "" : " " + n(
                "acreageCalculator:error.signedContractsNotFulfilled"
              )),
              flavor: "error",
              children: /* @__PURE__ */ w.jsx(
                Hb,
                {
                  color: "error",
                  fontSize: "large",
                  "data-testid": "to-e-contracting-error"
                }
              )
            }
          ),
          /* @__PURE__ */ w.jsx(
            as,
            {
              variant: "contained",
              disabled: j,
              onClick: async () => {
                r("/"), vme(
                  N.lieferanspruch,
                  N.freieMenge
                );
              },
              "aria-label": n(
                "acreageCalculator:button.toEContracting.explanation"
              ),
              children: n("acreageCalculator:button.toEContracting.label")
            }
          )
        ] }),
        /* @__PURE__ */ w.jsx(
          Rt,
          {
            "data-testid": "assistant-explanation-individual-sugar-content",
            children: n(
              "acreageCalculator:explanation.individualSugarContentQuantities",
              {
                sugarContent: typeof L == "string" ? L : Or(L, {
                  maximumFractionDigits: 3
                })
              }
            )
          }
        ),
        /* @__PURE__ */ w.jsxs(Es, { children: [
          /* @__PURE__ */ w.jsx(
            Ja,
            {
              textFieldOptions: {
                label: n(
                  "acreageCalculator:label.quantityFromExitingContracts"
                ),
                value: y
              },
              inputMode: "decimal",
              maximumFractionDigits: 2,
              unit: "t"
            }
          ),
          /* @__PURE__ */ w.jsx(
            Ja,
            {
              textFieldOptions: {
                label: n("acreageCalculator:label.quantityAdjustment"),
                value: E
              },
              inputMode: "decimal",
              maximumFractionDigits: 2,
              unit: "t"
            }
          )
        ] })
      ] })
    ] }) })
  ] });
}
const kme = oe($r)(({ theme: e }) => ({
  display: "flex",
  padding: e.spacing(2, 5),
  alignItems: "center"
})), Mme = oe(_t)(({ theme: e }) => ({
  display: "flex",
  flex: 2,
  flexDirection: "column",
  minWidth: "500px",
  [e.breakpoints.down("sm")]: {
    minWidth: "300px"
  },
  maxWidth: "700px",
  width: "95%",
  gap: e.spacing(1),
  alignSelf: "center"
})), Ame = oe(_t)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  justifyContent: "space-between",
  alignItems: "center",
  paddingBottom: e.spacing(1)
}));
function Dme(e) {
  const t = e.multi_year_yield_average * e.yield_year_factor, n = e.multi_year_sugar_content;
  return {
    individualBeetYield: t,
    individualSugarContent: n
  };
}
function Nme() {
  const { t: e } = jn(), t = T$(), n = t.data, r = t.individualMultiYearValues, [o, i] = Jt(!1), [a, l] = Jt(!0), [c, d] = Jt(0), [f, p] = Jt(0), g = Dme(n), b = pC(
    g.individualBeetYield,
    n.basis_sugar_content,
    g.individualSugarContent,
    n.extraction_loss
  ), v = fC(
    n.already_contracted_total,
    g.individualBeetYield,
    n.basis_sugar_content,
    g.individualSugarContent,
    n.extraction_loss
  ), { registerField: y, watch: S, formState: E, getValues: I, reset: O } = ey({
    values: Xb(g)
  }), T = S("individualSugarContent"), P = S("individualBeetYield"), R = CC(() => {
    const { individualBeetYield: _, individualSugarContent: C } = I(), D = pC(
      Ss(_),
      n.basis_sugar_content,
      Ss(C),
      n.extraction_loss
    ), L = fC(
      n.already_contracted_total,
      Ss(_),
      n.basis_sugar_content,
      Ss(C),
      n.extraction_loss
    );
    d(D), p(L);
  }, [I, n]);
  ir(() => {
    a && (R(), l(!1));
  }, [R, a]);
  async function F() {
    l(!0);
  }
  const A = E$.validations;
  return /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
    /* @__PURE__ */ w.jsx(
      S$,
      {
        open: o,
        closeDialog: () => {
          i(!1);
        },
        mode: "PLANNER",
        data: {
          baseSugarContent: Or(n.basis_sugar_content, {
            maximumFractionDigits: 3
          }),
          individualSugarContent: Or(
            T,
            { maximumFractionDigits: 3 }
          ),
          yieldLoss: Or(n.extraction_loss, {
            maximumFractionDigits: 2
          }),
          beetsYield: Or(P, {
            maximumFractionDigits: 3
          }),
          alreadyContractedQuantity: Or(
            n.already_contracted_total,
            {
              maximumFractionDigits: 2
            }
          )
        }
      }
    ),
    /* @__PURE__ */ w.jsx(xD, { noValidate: !0, autoComplete: "off", children: /* @__PURE__ */ w.jsx(kme, { children: /* @__PURE__ */ w.jsxs(Mme, { "data-testid": "planner-section", children: [
      /* @__PURE__ */ w.jsxs(Ame, { children: [
        /* @__PURE__ */ w.jsx(Rt, { variant: "h3", children: e("acreageCalculator:heading.planner") }),
        /* @__PURE__ */ w.jsx(
          x$,
          {
            onClick: () => {
              O(), R();
            }
          }
        )
      ] }),
      /* @__PURE__ */ w.jsx(Rt, { "data-testid": "section-explanation", children: e("acreageCalculator:explanation.adaptParameters") }),
      /* @__PURE__ */ w.jsx(Es, { children: /* @__PURE__ */ w.jsx(
        Ja,
        {
          textFieldOptions: {
            label: e("acreageCalculator:label.quantityContracted"),
            value: n.already_contracted_total
          },
          inputMode: "decimal",
          maximumFractionDigits: 1,
          unit: "t",
          hint: e("acreageCalculator:hint.quantityContracted")
        }
      ) }),
      /* @__PURE__ */ w.jsx(Es, { children: /* @__PURE__ */ w.jsx(
        Bu,
        {
          ...y("individualBeetYield", {
            validate: {
              number: (_) => Rm(_, e),
              range: (_) => _m(
                _,
                A.individualBeetYield.minimum,
                A.individualBeetYield.maximum,
                e
              )
            },
            required: e("acreageCalculator:validation.required")
          }),
          label: e("acreageCalculator:label.individualBeetYield"),
          inputMode: "decimal",
          maximumFractionDigits: 3,
          unit: "t/ha",
          helperText: E.dirtyFields.individualBeetYield ? e(
            "acreageCalculator:helperText.defaultIndividualBeetYield",
            {
              defaultValue: Or(
                g.individualBeetYield,
                { maximumFractionDigits: 3 }
              )
            }
          ) : void 0,
          hint: e("acreageCalculator:hint.individualBeetYield") + (r.yieldAverage ? e("acreageCalculator:hint.individualSource") : e("acreageCalculator:hint.defaultSource")) + (n.yield_year_factor !== 1 ? e(
            "acreageCalculator:hint.individualBeetYieldYearFactor",
            { factor: n.yield_year_factor }
          ) : ""),
          onChange: F,
          onBlur: F
        }
      ) }),
      /* @__PURE__ */ w.jsx(Es, { children: /* @__PURE__ */ w.jsx(
        Bu,
        {
          ...y("individualSugarContent", {
            validate: {
              number: (_) => Rm(_, e),
              range: (_) => _m(
                _,
                A.individualSugarContent.minimum,
                A.individualSugarContent.maximum,
                e
              )
            },
            required: e("acreageCalculator:validation.required")
          }),
          label: e("acreageCalculator:label.individualSugarContent"),
          inputMode: "decimal",
          maximumFractionDigits: 3,
          unit: "%",
          helperText: E.dirtyFields.individualSugarContent ? e(
            "acreageCalculator:helperText.defaultIndividualSugarContent",
            {
              defaultValue: Or(
                g.individualSugarContent,
                { maximumFractionDigits: 3 }
              )
            }
          ) : void 0,
          hint: e("acreageCalculator:hint.individualSugarContent") + (r.sugarContent ? e("acreageCalculator:hint.individualSource") : e("acreageCalculator:hint.defaultSource")),
          onChange: F,
          onBlur: F
        }
      ) }),
      /* @__PURE__ */ w.jsx(
        cN,
        {
          onFormulaButtonClick: () => i(!0)
        }
      ),
      /* @__PURE__ */ w.jsxs(Es, { children: [
        /* @__PURE__ */ w.jsx(
          Ja,
          {
            textFieldOptions: {
              label: e("acreageCalculator:label.requiredAcreagePer100t"),
              value: c,
              helperText: b !== c ? e(
                "acreageCalculator:helperText.requiredAcreagePer100t",
                {
                  defaultValue: Or(
                    b,
                    {
                      maximumFractionDigits: 2
                    }
                  )
                }
              ) : void 0
            },
            inputMode: "decimal",
            maximumFractionDigits: 2,
            unit: "ha",
            hint: e("acreageCalculator:hint.requiredAcreagePer100t")
          }
        ),
        /* @__PURE__ */ w.jsx(
          Ja,
          {
            textFieldOptions: {
              label: e("acreageCalculator:label.beetGrowingArea"),
              value: f,
              helperText: v !== f ? e(
                "acreageCalculator:helperText.defaultComputeBeetGrowingArea",
                {
                  defaultValue: Or(v, {
                    maximumFractionDigits: 2
                  })
                }
              ) : void 0
            },
            inputMode: "decimal",
            maximumFractionDigits: 2,
            unit: "ha",
            hint: e("acreageCalculator:hint.computedBeetGrowingArea")
          }
        )
      ] })
    ] }) }) })
  ] });
}
const Fme = At(/* @__PURE__ */ w.jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), $me = oe($r)(({ theme: e }) => ({
  body: "flex",
  flexDirection: "row",
  alignItems: "center",
  width: "100%",
  gap: e.spacing(2),
  padding: e.spacing(2),
  boxSizing: "border-box",
  borderRadius: e.cropConnect.shape.borderRadius
})), Lme = oe(HD)(() => ({
  color: "white"
}));
function jme(e) {
  const t = bo();
  return /* @__PURE__ */ w.jsxs(
    $me,
    {
      "data-testid": "info-alert-box",
      sx: {
        backgroundColor: e.isError ? t.palette.error.main : t.palette.info.main
      },
      children: [
        /* @__PURE__ */ w.jsx(Lme, { "aria-hidden": !0 }),
        /* @__PURE__ */ w.jsx(Rt, { color: "white", children: e.text })
      ]
    }
  );
}
const Bme = oe(_t)(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(2),
  flex: "1",
  flexDirection: "row",
  alignItems: "center"
})), Vme = oe(Hb)(({ theme: e }) => ({
  alignSelf: "center",
  color: e.palette.error.main
})), Hme = oe($r)(() => ({
  flexDirection: "column",
  minWidth: 0,
  // prevents flexbox issues with text wrapping
  wordWrap: "break-word"
})), Ume = oe(_t)(() => ({
  minHeight: "22px"
}));
function zme(e) {
  const t = bo();
  return /* @__PURE__ */ w.jsxs(Bme, { children: [
    e.showError && /* @__PURE__ */ w.jsx(Vme, {}),
    /* @__PURE__ */ w.jsxs(Hme, { "data-testid": "detail-entry-row", children: [
      /* @__PURE__ */ w.jsx(
        Rt,
        {
          variant: "h4",
          style: {
            fontSize: 12
          },
          color: t.palette.text.secondary,
          children: e.label
        }
      ),
      /* @__PURE__ */ w.jsx(Ume, { children: e.showLoadingIndicator ? /* @__PURE__ */ w.jsx(Wre, {}) : e.children })
    ] }),
    wt(e.hint) ? /* @__PURE__ */ w.jsx(Kb, { hint: e.hint, placement: "right" }) : null
  ] });
}
function Gme(e) {
  const { t } = jn(), n = lo(e.value) || e.value === "" ? t("common:placeholder") : e.value;
  return /* @__PURE__ */ w.jsx(
    zme,
    {
      label: e.label,
      showLoadingIndicator: e.showLoadingIndicator,
      showError: e.showError,
      hint: e.hint,
      children: /* @__PURE__ */ w.jsx(
        Rt,
        {
          style: {
            fontWeight: 500
          },
          "data-testid": "detail-entry-value",
          children: n
        }
      )
    }
  );
}
function Wme(e) {
  return /* @__PURE__ */ w.jsx(
    Gme,
    {
      label: e.label,
      value: e.value,
      showLoadingIndicator: e.requiredQueries.some(
        (t) => t.isPending
      ),
      showError: e.requiredQueries.some((t) => t.isError),
      hint: e.hint
    }
  );
}
const qme = oe(Rt)(() => ({
  width: "100%",
  textAlign: "center"
}));
function Kme(e) {
  const { t } = jn();
  return lo(e.contractHeaders) || e.contractHeaders.length != 0 ? null : /* @__PURE__ */ w.jsx(qme, { variant: "h3", "data-testid": "infoText", children: t("contracts:error.noElements") });
}
const Yme = At(/* @__PURE__ */ w.jsx("path", {
  d: "m7 10 5 5 5-5z"
}), "ArrowDropDown"), Qme = oe(qC)(({ theme: e }) => ({
  body: "flex",
  flexDirection: "row",
  width: "100%",
  gap: e.spacing(1),
  marginTop: e.spacing(1),
  backgroundColor: e.palette.error.light
}));
function P$(e) {
  const { t } = jn();
  return lo(e.errors) || e.errors.length === 0 ? null : /* @__PURE__ */ w.jsx(
    Ub,
    {
      heading: e.message,
      message: t("contracts:error.generalResolveAdvice"),
      children: /* @__PURE__ */ w.jsxs(Qme, { children: [
        /* @__PURE__ */ w.jsx(YC, { expandIcon: /* @__PURE__ */ w.jsx(Yme, {}), children: /* @__PURE__ */ w.jsx(Rt, { variant: "h4", children: t("contracts:error.details") }) }),
        /* @__PURE__ */ w.jsx(KC, { children: e.errors.map((n) => /* @__PURE__ */ w.jsx(
          Rt,
          {
            "data-testid": "error-details-entry",
            children: `${n.table}[${n.rowId}]: ${n.message}`
          },
          n.rowId + n.message
        )) })
      ] })
    }
  );
}
const Xme = oe(bl)({
  color: "inherit"
});
function I$(e) {
  return /* @__PURE__ */ w.jsxs(Xme, { position: "end", children: [
    e.loading && /* @__PURE__ */ w.jsx(Gp, { color: "inherit", size: 20 }),
    e.children
  ] });
}
const Jme = oe(zp)(({ theme: e }) => ({
  backgroundColor: e.palette.primary.main,
  borderRadius: 20,
  minHeight: "37px",
  boxSizing: "border-box",
  alignContent: "center",
  color: "#fff",
  width: "300px"
})), Zme = oe(Ea)(({ theme: e }) => ({
  padding: e.spacing(0, 1, 0, 2),
  boxSizing: "border-box",
  "& .MuiAutocomplete-popupIndicator, & .MuiAutocomplete-clearIndicator": {
    color: "#fff"
  },
  "& .MuiInputBase-input": {
    color: "#fff",
    textTransform: "uppercase",
    fontWeight: "bold",
    fontSize: 12,
    letterSpacing: 1.25
  }
}));
function ebe(e) {
  return /* @__PURE__ */ w.jsx(
    Jme,
    {
      selectOnFocus: !0,
      blurOnSelect: !0,
      fullWidth: !0,
      value: e.currentSelection,
      options: [...e.options, Jb],
      getOptionLabel: e.getOptionLabel,
      isOptionEqualToValue: (t, n) => t === n,
      onChange: (t, n) => {
        e.setCurrentSelection(
          Al(n) ? void 0 : n
        );
      },
      renderInput: (t) => /* @__PURE__ */ w.jsx(
        Zme,
        {
          ...t,
          variant: "standard",
          slotProps: {
            input: {
              ...t.InputProps,
              disableUnderline: !0,
              endAdornment: /* @__PURE__ */ w.jsx(I$, { loading: e.showLoading ?? !1, children: t.InputProps.endAdornment })
            }
          }
        }
      )
    }
  );
}
function tbe(e) {
  const { t } = jn();
  return /* @__PURE__ */ w.jsx(
    ebe,
    {
      currentSelection: e.currentCampaign,
      setCurrentSelection: e.setCurrentCampaign,
      options: e.campaigns,
      getOptionLabel: (n) => Al(n) ? t("contracts:contractList.allYears") : n,
      showLoading: e.showLoading
    }
  );
}
const nbe = Ta("ConfirmDeclineDialog");
function rbe(e) {
  const { t } = jn(), { dataClient: n } = _d(), { currentBusinessPartner: r } = rh(), o = Ab();
  async function i() {
    try {
      wt(e.contract) && (await n.declineContract(
        e.contract.contractUuid,
        {
          ...e.contract.contractHeader,
          status: "REJECTED",
          statusText: e.contract.contractHeader.statusDescriptions.get("REJECTED")
        },
        e.contract.originalContractDefinition,
        e.contract.mdwTransferredAt
      ), await o.invalidateQueries({
        queryKey: ["contractHeaders", r == null ? void 0 : r.id]
      }), e.closeModal());
    } catch (l) {
      nbe.warn("error rejecting contract", l), e.closeModal();
    }
  }
  function a() {
    e.closeModal();
  }
  return /* @__PURE__ */ w.jsx(
    Tp,
    {
      open: e.open,
      titleText: wt(e.contract) ? e.contract.contractHeader.texts.safeGet("HL_PR", t, !0) : "",
      informationText: wt(e.contract) ? e.contract.contractHeader.texts.safeGet("PT_PR", t) : "",
      primaryAction: {
        text: wt(e.contract) ? e.contract.contractHeader.texts.safeGet("YES", t, !0) : "",
        color: "error",
        onClick: i
      },
      secondaryAction: {
        text: wt(e.contract) ? e.contract.contractHeader.texts.safeGet("NO", t, !0) : "",
        color: "primary",
        onClick: a
      }
    }
  );
}
function obe(e, t) {
  return /* @__PURE__ */ w.jsx(wx, { variant: "outlined", onClick: t, children: e("common:components.button.decline") });
}
function ibe(e, t) {
  return /* @__PURE__ */ w.jsx(wx, { variant: "outlined", onClick: t, children: e("common:components.button.revise") });
}
function sbe(e, t) {
  return /* @__PURE__ */ w.jsx(wx, { variant: "outlined", onClick: t, children: e("common:components.button.view") });
}
function R$(e) {
  const { t } = jn(), n = Md(), r = e.contract.editable && e.contract.status !== "REJECTED" && !e.isWaitingForResponse, o = e.contract.editable && !e.isWaitingForResponse, i = !e.contract.editable || e.isWaitingForResponse;
  return /* @__PURE__ */ w.jsxs(SD, { sx: { display: "grid" }, children: [
    r && obe(t, e.onDeclineClick),
    o && ibe(t, () => n("wizard?id=" + e.contractUuid)),
    i && sbe(t, () => n("view?id=" + e.contractUuid))
  ] });
}
const abe = oe($r)(({ theme: e }) => ({
  alignSelf: "center",
  maxWidth: "600px",
  width: "100%",
  padding: e.spacing(1),
  gap: e.spacing(2),
  boxSizing: "border-box"
}));
function lbe(e, t, n, r, o, i, a) {
  return /* @__PURE__ */ w.jsxs(_t, { alignItems: "center", display: "flex", children: [
    /* @__PURE__ */ w.jsx(Gre, { children: /* @__PURE__ */ w.jsx(
      Wme,
      {
        label: a("contracts:contractList.statusText"),
        requiredQueries: [e],
        value: n.statusText
      }
    ) }),
    /* @__PURE__ */ w.jsx(
      R$,
      {
        contract: n,
        contractUuid: r,
        onDeclineClick: () => {
          t({
            contractUuid: r,
            contractHeader: n,
            mdwTransferredAt: i,
            originalContractDefinition: o
          });
        },
        isWaitingForResponse: !1
      }
    )
  ] });
}
function cbe(e, t, n) {
  return /* @__PURE__ */ w.jsxs(_t, { alignItems: "center", display: "flex", gap: "32px", children: [
    /* @__PURE__ */ w.jsx(Rt, { "data-testid": "waiting-for-response-message", children: n }),
    /* @__PURE__ */ w.jsx(_t, { children: /* @__PURE__ */ w.jsx(
      R$,
      {
        contract: e,
        contractUuid: t,
        isWaitingForResponse: !0
      }
    ) })
  ] });
}
function ube(e) {
  var y, S, E, I, O, T;
  const { dataClient: t } = _d(), { t: n } = jn(), [r, o] = Jt(void 0), [i, a] = Jt(void 0), l = Ml(), [c, d] = Jt(
    ((y = l.state) == null ? void 0 : y.showSuccess) === !0
  ), f = (S = l.state) == null ? void 0 : S.successTitle, p = (E = l.state) == null ? void 0 : E.successMessage, g = Db({
    queryKey: ["contractHeaders", (I = e.currentBusinessPartner) == null ? void 0 : I.id],
    queryFn: async () => {
      var P;
      return await t.getContractHeaders(
        (P = e.currentBusinessPartner) == null ? void 0 : P.id
      );
    },
    throwOnError: !0,
    refetchInterval: 18e4
  }), b = (O = g.data) == null ? void 0 : O.contracts, v = pl(() => g.isSuccess && wt(b) ? new Array(
    ...new Set(
      b.map((P) => P.campaignYear)
    )
  ).sort((P, R) => Number(R) - Number(P)) : [], [g.isSuccess, b]);
  return ir(() => {
    var P;
    if ((P = l.state) != null && P.showSuccess && window.history.replaceState(
      {
        ...window.history.state,
        usr: { ...l.state, showSuccess: !1 }
      },
      ""
    ), c) {
      const R = setTimeout(() => {
        d(!1);
      }, 12e3);
      return () => clearTimeout(R);
    }
  }, [l.state, c]), /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
    /* @__PURE__ */ w.jsx(
      rbe,
      {
        open: wt(i),
        closeModal: () => {
          a(void 0);
        },
        contract: i
      }
    ),
    /* @__PURE__ */ w.jsx(
      P$,
      {
        message: n("contracts:error.generalIncompleteMessage"),
        errors: (T = g.data) == null ? void 0 : T.errors
      }
    ),
    /* @__PURE__ */ w.jsx(Kme, { contractHeaders: b }),
    O$() && /* @__PURE__ */ w.jsx(
      jme,
      {
        text: n("contracts:contractList.recommendationsAvailable")
      }
    ),
    g.isFetching ? /* @__PURE__ */ w.jsx(qx, {}) : /* @__PURE__ */ w.jsxs(abe, { "data-testid": "contract-list", children: [
      /* @__PURE__ */ w.jsx(rp, { in: c, children: /* @__PURE__ */ w.jsxs(
        Wk,
        {
          severity: "success",
          action: /* @__PURE__ */ w.jsx(
            ks,
            {
              "aria-label": "close",
              color: "inherit",
              size: "small",
              onClick: () => {
                d(!1);
              },
              children: /* @__PURE__ */ w.jsx(Fme, { fontSize: "inherit" })
            }
          ),
          children: [
            /* @__PURE__ */ w.jsx(qk, { "data-testid": "success-title", children: f }),
            /* @__PURE__ */ w.jsx(Rt, { "data-testid": "success-message", children: p })
          ]
        }
      ) }),
      g.isSuccess && v.length > 1 && /* @__PURE__ */ w.jsx(
        tbe,
        {
          campaigns: v,
          currentCampaign: r ?? Jb,
          setCurrentCampaign: o,
          showLoading: g.isPending
        }
      ),
      b == null ? void 0 : b.filter(
        (P) => lo(r) || P.campaignYear === r
      ).map(
        ({
          contractUuid: P,
          contractHeader: R,
          mdwTransferredAt: F,
          originalContractDefinition: A,
          waitingForResponse: _
        }) => /* @__PURE__ */ w.jsxs(sx, { "data-testid": "contract-card", children: [
          /* @__PURE__ */ w.jsx(
            dM,
            {
              title: /* @__PURE__ */ w.jsx(Rt, { variant: "h3", children: R.title }),
              "data-testid": "contract-title"
            }
          ),
          /* @__PURE__ */ w.jsx(pb, { sx: { justifyContent: "end" }, children: _ ? cbe(
            R,
            P,
            n("contracts:contractList.waitingForResponse")
          ) : lbe(
            g,
            a,
            R,
            P,
            A,
            F,
            n
          ) })
        ] }, R.title)
      )
    ] })
  ] });
}
function dbe() {
  const { t: e } = jn(), { currentBusinessPartner: t, businessPartnerQueryIsLoading: n } = rh();
  return /* @__PURE__ */ w.jsx(iS, { title: e("common:pageTitles:startPage"), children: n ? null : /* @__PURE__ */ w.jsx(ube, { currentBusinessPartner: t }) });
}
const yy = Pc(
  void 0
), _$ = At(/* @__PURE__ */ w.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2"
}), "Circle"), fbe = At(/* @__PURE__ */ w.jsx("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore"), pbe = At(/* @__PURE__ */ w.jsx("path", {
  d: "M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"
}), "Warning"), hbe = oe(_M)(({ theme: e }) => ({
  padding: e.spacing(3, 1)
})), gbe = oe(_$)(() => ({
  fontSize: 15,
  marginTop: "5px"
}));
function mbe(e) {
  return /* @__PURE__ */ w.jsx(
    vx,
    {
      icon: /* @__PURE__ */ w.jsx(gbe, { color: e.active ? "primary" : "disabled" })
    }
  );
}
function bbe(e) {
  return /* @__PURE__ */ w.jsx(_$, { color: e ? "primary" : "disabled" });
}
function ybe(e, t, n, r) {
  const o = e === n.selectedStepIndex, i = n.stepsClickable && e < n.selectedStepIndex;
  return n.compactSteps && r ? /* @__PURE__ */ w.jsx(
    vb,
    {
      onClick: i ? () => n.setSelectedStepIndex(e) : void 0,
      slots: {
        stepIcon: mbe
      }
    }
  ) : /* @__PURE__ */ w.jsx(
    IM,
    {
      disabled: !i,
      onClick: () => n.setSelectedStepIndex(e),
      icon: n.compactSteps ? bbe(o) : void 0,
      children: !n.compactSteps || o ? t : ""
    }
  );
}
function vbe(e) {
  const t = bo(), n = dx(t.breakpoints.down("md"));
  return /* @__PURE__ */ w.jsx(
    hbe,
    {
      activeStep: Math.min(
        e.selectedStepIndex,
        e.necessarySteps.length - 1
      ),
      alternativeLabel: !0,
      "data-testid": "progress-indicator",
      children: e.necessarySteps.map((r, o) => {
        const i = r.title;
        return /* @__PURE__ */ w.jsx(PM, { children: /* @__PURE__ */ w.jsx(sh, { title: i, children: /* @__PURE__ */ w.jsx(_t, { children: ybe(o, i, e, n) }) }) }, `${i}-${r.component.name}`);
      })
    }
  );
}
const wbe = oe(_t)(() => ({
  display: "flex",
  flexDirection: "column",
  flex: 1
})), Cbe = Ta("Wizard");
function ZR(e, t) {
  return e.filter((n) => lo(n.isNecessary) || n.isNecessary(t));
}
function xbe({
  steps: e,
  initialValues: t,
  onSubmit: n,
  options: r,
  mode: o,
  confirmDataLoss: i
}) {
  const [a, l] = Jt(!1), [c, d] = Jt(0), [f, p] = Jt(t), [g, b] = Jt(
    ZR(e, f)
  ), v = ho(!1), { t: y } = jn();
  ir(() => {
    function E(I) {
      a && i && I.preventDefault();
    }
    return window.addEventListener("beforeunload", E), () => {
      window.removeEventListener("beforeunload", E);
    };
  }, [i, a]), lie(() => a && i ? !window.confirm(
    y("common:navigation.unsavedChangesWarning")
  ) : !1);
  const S = pl(() => {
    function E(O) {
      wt(O) && p(O), d((T) => T === 0 ? (Cbe.error("Can't go back from first page."), T) : T - 1);
    }
    function I(O) {
      const T = ZR(e, O);
      p(O), d(
        Math.min(c + 1, T.length - 1)
      ), l(!0), b(T), c >= T.length - 1 && (l(!1), wt(n) && !v.current && (v.current = !0, n(O)));
    }
    return {
      steps: g,
      selectedStepIndex: c,
      values: f,
      completeStep: I,
      goBack: E
    };
  }, [e, g, n, c, f]);
  return /* @__PURE__ */ w.jsx(yy.Provider, { value: S, children: /* @__PURE__ */ w.jsxs(wbe, { children: [
    /* @__PURE__ */ w.jsx(
      vbe,
      {
        necessarySteps: g,
        selectedStepIndex: c,
        setSelectedStepIndex: d,
        stepsClickable: wt(r == null ? void 0 : r.stepsClickable) && r.stepsClickable,
        compactSteps: wt(r == null ? void 0 : r.compactSteps) && r.compactSteps
      }
    ),
    /* @__PURE__ */ w.jsx(
      Rt,
      {
        variant: "h3",
        sx: { mb: 2 },
        "data-testid": "wizard-step-title",
        children: g[c].title
      }
    ),
    fc(g[c].component, {
      values: f,
      mode: o
    })
  ] }) });
}
function Sbe() {
  const [e] = Uie();
  return { id: e.get("id") };
}
const Ebe = ["901", "904"];
function k$(e, t) {
  return t.quantities.filter((n) => ["FM", "FQ"].includes(n.bfGroupId)).every((n) => n.amount === 0) ? e.filter(
    (n) => !Ebe.includes(n.id)
  ) : e;
}
const Tbe = {
  DE: "de",
  SE: "sv",
  PL: "pl",
  DK: "da",
  LT: "lt",
  SK: "sk",
  FI: "fi",
  EN: "en"
};
function Obe(e) {
  const t = e.toUpperCase();
  return Tbe[t] ?? "en";
}
function Pbe(e) {
  const { t } = jn();
  async function n() {
    e.closeModal();
  }
  return /* @__PURE__ */ w.jsx(
    Tp,
    {
      open: e.open,
      icon: /* @__PURE__ */ w.jsx(Hb, {}),
      titleText: t("contracts:contractWizard.saveErrorDialog.title"),
      informationText: t("contracts:contractWizard.saveErrorDialog.info"),
      secondaryAction: {
        text: t("contracts:contractWizard.saveErrorDialog.ok"),
        color: "primary",
        onClick: n
      }
    }
  );
}
function M$(e) {
  const { field: t, register: n } = Zb(e);
  function r(a) {
    t.onChange(a.target.checked), e.afterChange && e.afterChange(a);
  }
  const o = n();
  let i;
  switch (t.value) {
    case !0: {
      i = !0;
      break;
    }
    case !1: {
      i = !1;
      break;
    }
    default:
      i = t.value === "true";
  }
  return /* @__PURE__ */ w.jsxs(_t, { display: "flex", "data-testid": "StackInputField", alignItems: "center", children: [
    /* @__PURE__ */ w.jsx(
      dp,
      {
        value: aS(t.value),
        checked: i,
        label: /* @__PURE__ */ w.jsx(Rt, { variant: wt(e.variant) ? e.variant : "h6", children: e.label }),
        labelPlacement: e.labelPlacement,
        control: /* @__PURE__ */ w.jsx(
          hb,
          {
            inputRef: o.inputRef,
            label: o.label,
            disabled: o.disabled,
            required: o.required,
            onChange: r,
            onBlur: t.onBlur
          }
        )
      }
    ),
    /* @__PURE__ */ w.jsx(Kb, { hint: e.hint, placement: e.hintPlacement })
  ] });
}
function Ibe(e) {
  const t = lo(e.startAdornment) ? void 0 : /* @__PURE__ */ w.jsx(bl, { position: "start", children: e.startAdornment }), n = lo(e.unit) ? void 0 : /* @__PURE__ */ w.jsx(bl, { position: "end", children: e.unit });
  return {
    startAdornment: t,
    endAdornment: n
  };
}
function hC(e) {
  const { field: t, register: n } = Zb(e), r = aS(t.value), o = ho(void 0), i = ho(e.onChangeOrBlur);
  ir(() => {
    o.current === !1 && wt(i.current) && (o.current = !0, setTimeout(() => {
      o.current = !1, i.current();
    }, WD));
  }, [r]);
  const a = sS(e), l = Ibe(e);
  function c(g) {
    return wt(e.formatValue) ? e.formatValue(g) : g;
  }
  function d(g) {
    return wt(e.formatDisplayedValue) ? e.formatDisplayedValue(g) : g;
  }
  async function f(g) {
    lo(o.current) && (o.current = !1), wt(e.setCursorPosition) && e.setCursorPosition(g.target), t.onChange(
      c(g.target.value)
    );
  }
  async function p() {
    t.onBlur(), wt(e.onChangeOrBlur) && await e.onChangeOrBlur();
  }
  return /* @__PURE__ */ w.jsx(Yb, { hint: e.hint, hintPlacement: e.hintPlacement, children: /* @__PURE__ */ w.jsx(
    Ea,
    {
      variant: "filled",
      ...n(),
      value: d(r),
      multiline: e.multiline,
      maxRows: e.maxRows,
      fullWidth: !0,
      onChange: f,
      onBlur: p,
      required: e.required,
      disabled: e.disabled,
      ...e.textFieldOptions,
      slotProps: {
        input: {
          ...l,
          style: { backgroundColor: "white" },
          disableUnderline: !0
        },
        htmlInput: a
      }
    }
  ) });
}
function Rbe() {
  return /* @__PURE__ */ w.jsxs(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ w.jsx(
          "path",
          {
            d: "M18 13V19C18 20.1046 17.1046 21 16 21H5C3.89543 21 3 20.1046 3 19V8C3 6.89543 3.89543 6 5 6H11",
            stroke: "#323F4B",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ w.jsx(
          "path",
          {
            d: "M15 3H21V9",
            stroke: "#323F4B",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ w.jsx(
          "path",
          {
            d: "M10 14L21 3",
            stroke: "#323F4B",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}
const _be = oe(ld)(({ theme: e }) => ({
  marginLeft: e.spacing(1),
  alignSelf: "baseline",
  fontSize: "1rem"
}));
function A$(e) {
  return /* @__PURE__ */ w.jsxs($r, { direction: "row", alignItems: "baseline", children: [
    /* @__PURE__ */ w.jsx(mM, { href: e.url, underline: "none", target: "_blank", children: e.label }),
    /* @__PURE__ */ w.jsx(_be, { children: /* @__PURE__ */ w.jsx(Rbe, {}) })
  ] });
}
const kbe = Pc({
  showSideAndTopBar: !1
});
function Mbe() {
  const e = Li(kbe);
  if (e === void 0)
    throw new Error(
      "useEnvironment must be used within a EnvironmentContextProvider."
    );
  return e;
}
const Abe = oe(_t)(() => ({
  height: "100px"
})), Dbe = oe(_t)(({ theme: e }) => ({
  display: "flex",
  position: "absolute",
  zIndex: 1e3,
  right: 16,
  bottom: 10,
  borderRadius: e.cropConnect.shape.borderRadius,
  padding: e.spacing(2),
  margin: e.spacing(1),
  background: "white",
  borderTop: "1px solid var(--divider, rgba(52, 60, 61, 0.12))",
  justifyContent: "end",
  /* elevation/5 */
  boxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.20), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)"
}));
function GS(e) {
  const { t } = jn(), { showSideAndTopBar: n } = Mbe(), r = Li(
    yy
  ), o = Ax(r);
  function i() {
    return e.primaryActionLabel ? e.primaryActionLabel : o.selectedStepIndex + 1 < o.steps.length ? t("common:components.button.next") : t("common:components.button.complete");
  }
  function a() {
    return wt(e.secondaryActionLabel) ? e.secondaryActionLabel : t("common:components.button.back");
  }
  const l = n ? 136 : 16, c = e.showMandatoryFieldsHint && (o.steps[o.selectedStepIndex].showMandatoryFieldsHint ?? !0);
  return /* @__PURE__ */ w.jsx(Abe, { children: /* @__PURE__ */ w.jsx(
    Dbe,
    {
      sx: {
        left: l
      },
      children: /* @__PURE__ */ w.jsxs(SD, { "data-testid": "wizard-button-bar", children: [
        c && /* @__PURE__ */ w.jsx(qre, { variant: "subtitle1", children: wt(e.mandatoryFieldsHintText) ? e.mandatoryFieldsHintText : "* " + t("form:mandatoryInputs") }),
        e.children,
        o.selectedStepIndex > 0 && /* @__PURE__ */ w.jsx(
          vm,
          {
            variant: "outlined",
            onClick: () => {
              wt(e.onSecondaryActionClicked) && e.onSecondaryActionClicked();
            },
            children: a()
          }
        ),
        /* @__PURE__ */ w.jsx(
          vm,
          {
            variant: "contained",
            onClick: e.onPrimaryActionClicked,
            type: "submit",
            children: i()
          }
        )
      ] })
    }
  ) });
}
function WS() {
  const e = Li(
    yy
  );
  return Ax(e);
}
function Nbe(e) {
  const [t, n] = Jt(!1), r = WS(), { t: o } = jn(), {
    registerField: i,
    getValues: a,
    formState: { isValid: l },
    trigger: c
  } = ey({
    values: {
      contract: Xb(r.values.contract),
      termsAccepted: e.isReadonly || r.values.termsAccepted
    }
  });
  function d() {
    a().termsAccepted && l ? r.completeStep({
      ...r.values,
      contract: {
        ...r.values.contract,
        deviantMail: a("contract.deviantMail")
      },
      termsAccepted: !0
    }) : (a().termsAccepted || n(!0), l || c());
  }
  return /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
    /* @__PURE__ */ w.jsx(Wp, { children: e.values.contract.documents.map((f) => /* @__PURE__ */ w.jsx(bb, { disableGutters: !0, children: /* @__PURE__ */ w.jsx(A$, { label: f.description, url: f.link }) }, f.description)) }),
    /* @__PURE__ */ w.jsx(
      M$,
      {
        ...i("termsAccepted"),
        afterChange: (f) => {
          f.target.checked && n(!1);
        },
        variant: "body1",
        label: e.values.contract.texts.safeGet("CONDACCEPT", o, !0),
        disabled: e.isReadonly
      }
    ),
    t && /* @__PURE__ */ w.jsx(
      cx,
      {
        error: !0,
        sx: { mt: 0, marginBottom: "16px" },
        "data-testid": "please-consent-message",
        children: e.values.contract.texts.safeGet("EM_CC", o, !0)
      }
    ),
    /* @__PURE__ */ w.jsx(
      hC,
      {
        ...i("contract.deviantMail", {
          validate: {
            mail: (f) => Use(
              f,
              e.values.contract.texts.safeGet("EMEA_CC", o, !0)
            )
          }
        }),
        label: e.values.contract.texts.safeGet("DEVMAIL", o, !0),
        disabled: e.isReadonly
      }
    ),
    /* @__PURE__ */ w.jsx(
      GS,
      {
        primaryActionLabel: e.values.contract.texts.safeGet(
          "BUTTON1",
          o,
          !0
        ),
        showMandatoryFieldsHint: !1,
        onPrimaryActionClicked: d,
        onSecondaryActionClicked: () => {
          r.goBack();
        }
      }
    )
  ] });
}
function Fbe(e, t) {
  const n = e.quantityDetails.positions.map((l) => l.yearFrom), r = e.quantityDetails.positions.map((l) => l.yearTo), o = Math.min(...n), i = Math.max(...r), a = [];
  for (let l = o; l <= i; l++) {
    const c = e.quantityDetails.positions.filter(
      (d) => l >= d.yearFrom && l <= d.yearTo
    );
    a.push({
      id: `SUM_${l}`,
      position: e.texts.safeGet("SUMS_TOTAL", t),
      yearFrom: l,
      yearTo: l,
      isSumRow: !0,
      amount: c.map((d) => d.amount).reduce((d, f) => d + f, 0),
      percentage: c.map((d) => d.percentage).reduce((d, f) => d + f, 0),
      acreage: c.map((d) => d.acreage).reduce((d, f) => d + f, 0)
    });
  }
  return a;
}
function $be(e, t) {
  return e.quantityDetails.positions.map((n) => ({
    id: n.positionNumber,
    bfGroupId: n.bfGroupId,
    title: n.bfGroupId,
    position: n.positionName,
    yearFrom: n.yearFrom,
    yearTo: n.yearTo,
    percentage: n.percentage,
    amount: n.amount,
    acreage: n.acreage,
    price: n.price,
    information: n.information,
    amountForInput: n.amountForInput,
    maxPercentage: n.maxPercentage,
    maxAmount: n.maxAmount,
    confirmInformation: n.confirmInformation,
    informationLink: n.informationLink,
    informationWasConfirmed: n.informationWasConfirmed,
    positionGroup: n.positionGroup
  })).concat(Fbe(e, t));
}
function hh(e, t, n) {
  const r = e.quantityDetails.characteristics.find(
    (o) => o.fieldname === t && o.positionNumber === n
  );
  return (r == null ? void 0 : r.attributeState) ?? "HIDDEN";
}
function Lbe(e, t) {
  return e.quantityDetails.characteristics.some((n) => n.fieldname === t && n.attributeState != "HIDDEN");
}
function jbe(e, t) {
  return e.quantityDetails.positions.findIndex(t) != -1;
}
function Bbe(e) {
  return e.quantityDetails.positions.some((t) => t.amountForInput === "EDITABLE");
}
function Vbe(e) {
  const t = e.quantityDetails.positions.map((n) => n.bfGroupId);
  return new Set(t).size > 1;
}
function Hbe(e) {
  return e.quantityDetails.characteristics.some((t) => t.fieldname === "CY_F" && t.attributeState != "HIDDEN");
}
function Ube(e) {
  return e.quantityDetails.characteristics.some((t) => t.fieldname === "CY_T" && t.attributeState != "HIDDEN");
}
function zbe(e) {
  return e.quantityDetails.positionDistributionUnit === "PERCENT" || e.quantityDetails.positions.findIndex((t) => t.percentage != 0) != -1 || e.quantityDetails.characteristics.some((t) => t.fieldname === "percentage" && t.attributeState != "HIDDEN");
}
function Gbe(e) {
  return e.quantityDetails.positionDistributionUnit === "PERCENT" || Lbe(e, "AMOUNT") || e.quantityDetails.contractUnit !== "ACREAGE" && (jbe(e, (t) => t.amount != 0) || Bbe(e));
}
function Wbe(e) {
  return e.quantityDetails.contractUnit === "ACREAGE" || e.quantityDetails.positions.findIndex((t) => t.acreage != 0) != -1 || e.quantityDetails.characteristics.some((t) => t.fieldname === "ACERAGE" && t.attributeState != "HIDDEN");
}
function qbe(e) {
  return e.quantityDetails.positions.findIndex((t) => t.price != 0) != -1 || e.quantityDetails.characteristics.some((t) => t.fieldname === "PRICE" && t.attributeState != "HIDDEN");
}
function Kbe(e) {
  return e.quantityDetails.positions.some((t) => !!t.information);
}
function $c(e, t, n) {
  let r = Ro(
    e,
    (a) => t !== a.id
  );
  const o = r.filter((a) => a && !a.isSumRow);
  r.filter((a) => a == null ? void 0 : a.isSumRow).forEach((a) => {
    const l = a == null ? void 0 : a.yearFrom, c = o.filter((d) => d && l && l >= d.yearFrom && l <= d.yearTo).map((d) => ({
      amount: (d == null ? void 0 : d.amount) ?? 0,
      percentage: (d == null ? void 0 : d.percentage) ?? 0,
      acreage: (d == null ? void 0 : d.acreage) ?? 0
    })).reduce(
      (d, f) => ({
        amount: d.amount + f.amount,
        percentage: d.percentage + f.percentage,
        acreage: d.acreage + f.acreage
      }),
      { amount: 0, percentage: 0, acreage: 0 }
    );
    e.current.updateRows([
      {
        id: `SUM_${l}`,
        amount: c.amount,
        percentage: c.percentage,
        acreage: c.acreage
      }
    ]);
  });
}
function D$(e, t, n) {
  return Ro(
    t,
    (r) => n !== r.id && r.bfGroupId === e
  ).map((r) => (r == null ? void 0 : r.amount) ?? 0).reduce((r, o) => r + o, 0);
}
function Ybe(e, t) {
  Ro(t, (n) => !n.isSumRow).forEach(
    (n) => {
      const o = D$(
        (n == null ? void 0 : n.bfGroupId) ?? "",
        e
      ) * ((n == null ? void 0 : n.percentage) ?? 0) / 100;
      t.current.updateRows([{ id: n == null ? void 0 : n.id, amount: o }]);
    }
  ), $c(t);
}
function Qbe(e, t, n, r, o) {
  $c(o);
}
function Xbe(e, t, n, r, o) {
  const i = n.quantityDetails.quantities[0];
  o.current.updateRows([
    {
      id: t.id,
      amount: e * i.fiveYearsYield
    }
  ]), $c(o);
}
function Jbe(e, t, n, r, o) {
  const i = D$(
    t.bfGroupId ?? "",
    r
  );
  o.current.updateRows([
    {
      id: t.id,
      amount: i * e / 100
    }
  ]), $c(o);
}
function Zbe(e, t) {
  return t.row.isSumRow ? "READONLY" : hh(e, "CY_F", t.row.id);
}
function eye(e, t) {
  return t.row.isSumRow ? "READONLY" : hh(e, "CY_T", t.row.id);
}
function tye(e, t, n) {
  return N$(
    e,
    t,
    n
  ) || t.row.isSumRow || e.quantityDetails.contractUnit === "ACREAGE" ? "READONLY" : hh(e, "PERCENTAGE", t.row.id);
}
function nye(e, t, n, r) {
  return N$(
    e,
    t,
    n
  ) || F$(
    t,
    r
  ) || t.row.isSumRow || e.quantityDetails.contractUnit === "ACREAGE" ? "READONLY" : hh(e, "AMOUNT", t.row.id);
}
function rye(e, t, n) {
  const r = e.quantityDetails.quantities.find(
    (o) => o.bfGroupId === t.row.bfGroupId
  );
  if (wt(r)) {
    const o = zs(r);
    return n.current.getCellValue(
      o,
      "acreage"
    ) === 0 ? "READONLY" : "EDITABLE";
  }
  return t.row.isSumRow || e.quantityDetails.contractUnit === "ACREAGE" ? "READONLY" : hh(e, "ACERAGE", t.row.id);
}
function N$(e, t, n) {
  const r = e.quantityDetails.quantities.filter(
    (o) => o.bfGroupId === t.row.bfGroupId
  );
  return r.length > 0 ? !r.map((o) => {
    const i = zs(o);
    return n.current.getCellValue(
      i,
      "amount"
    );
  }).some((o) => o > 0) : !1;
}
function F$(e, t) {
  if (wt(e.row.positionGroup)) {
    const n = t.current.getAllRowIds().map((r) => t.current.getRow(r)).filter(
      (r) => wt(r.positionGroup) && r.positionGroup !== e.row.positionGroup
    );
    if (n.length > 0)
      return n.map((r) => r.amount).some((r) => r != 0);
  }
  return !1;
}
function oye(e, t, n) {
  return F$(
    e,
    t
  ) ? n("contracts:contractWizard.tooltip") : "";
}
function iye(e) {
  return "%";
}
function Lw(e) {
  return ({ contract: t, gridCellParams: n }) => {
    function r(i) {
      return n.row.isSumRow ? i.fieldname === e : i.fieldname === e && i.positionNumber === n.row.id;
    }
    const o = t.quantityDetails.characteristics.find(r);
    return (o == null ? void 0 : o.unit) ?? "";
  };
}
function sye(e) {
  return e.gridCellParams.row.confirmInformation ? {
    type: "checkbox",
    targetField: H$,
    label: e.gridCellParams.row.information ?? "",
    removePadding: !0
  } : e.gridCellParams.row.informationLink ? { type: "link", url: e.gridCellParams.row.informationLink } : { type: "text" };
}
const $$ = "percentage", L$ = "amount", j$ = "acreage", B$ = "price", V$ = "information", H$ = "informationWasConfirmed", aye = [
  {
    field: "title",
    headerNameTextKey: "BFGRP_NAME",
    showColumn: Vbe
  },
  {
    field: "position",
    headerNameTextKey: "POSNAME"
  },
  {
    field: "yearFrom",
    headerNameTextKey: "CY_F",
    getCellState: Zbe,
    showColumn: Hbe
  },
  {
    field: "yearTo",
    headerNameTextKey: "CY_T",
    getCellState: eye,
    showColumn: Ube
  },
  {
    field: $$,
    headerNameTextKey: "PERCENTAGE",
    getCellState: tye,
    onChangeCell: Jbe,
    getCellUnit: iye,
    showColumn: zbe,
    columnType: "number",
    getRenderInstruction: fa
  },
  {
    field: L$,
    headerNameTextKey: "AMOUNT",
    getCellState: nye,
    onChangeCell: Qbe,
    getCellUnit: Lw("AMOUNT"),
    showColumn: Gbe,
    columnType: "number",
    getRenderInstruction: fa,
    getToolTipText: oye
  },
  {
    field: j$,
    headerNameTextKey: "ACERAGE",
    getCellState: rye,
    onChangeCell: Xbe,
    getCellUnit: Lw("ACERAGE"),
    showColumn: Wbe,
    columnType: "number",
    getRenderInstruction: fa
  },
  {
    field: B$,
    headerNameTextKey: "PRICE",
    getCellUnit: Lw("PRICE"),
    showColumn: qbe
  },
  {
    field: V$,
    headerNameTextKey: "GROWERINFO",
    showColumn: Kbe,
    getRenderInstruction: sye,
    hiddenInReadonly: !0
  }
];
function zs(e) {
  return `${e.campaign}_${e.bfName}`;
}
const Bm = 1;
function lye(e, t, n) {
  let r = 0;
  return t.forEach((o) => {
    const i = hi(
      e * ((o == null ? void 0 : o.maxPercentage) ?? 0) / 100,
      Bm
    );
    r += i, n.current.updateRows([
      {
        id: o == null ? void 0 : o.id,
        amount: i
      }
    ]);
  }), r;
}
function cye(e, t, n, r) {
  let o = hi(
    e - t,
    Bm
  );
  const i = n.length;
  if (o > 0 && i > 0) {
    const a = hi(
      o / i,
      Bm
    );
    n.forEach((l) => {
      const c = Math.min(o, a);
      r.current.updateRows([
        {
          id: l == null ? void 0 : l.id,
          amount: c
        }
      ]), o -= c;
    });
  }
}
function hi(e, t) {
  const n = zD({
    style: "decimal",
    maximumFractionDigits: t
  }).format(e);
  return Qb(n, {
    maximumFractionDigits: t
  });
}
function U$(e) {
  return hi(
    (e.amount ?? 0) - (e.reduce ?? 0),
    Bm
  );
}
function uye(e, t, n) {
  const r = U$(e);
  if (r <= 0)
    return;
  const o = t.filter(
    (c) => (c == null ? void 0 : c.bfGroupId) === (e == null ? void 0 : e.bfGroupId)
  ), i = o.filter(
    (c) => ((c == null ? void 0 : c.maxPercentage) ?? 0) > 0
  ), a = o.filter(
    (c) => ((c == null ? void 0 : c.maxPercentage) ?? 0) <= 0
  );
  let l = lye(
    r,
    i,
    n
  );
  cye(
    r,
    l,
    a,
    n
  );
}
function dye(e, t) {
  const n = Ro(
    t,
    (r) => !r.isSumRow
  );
  Ro(e).forEach(
    (r) => uye(r, n, t)
  ), $c(t);
}
function fa(e) {
  return { type: "number", removePadding: !0 };
}
function Ro(e, t) {
  const n = e.current.getAllRowIds().map((r) => e.current.getRow(r));
  return wt(t) ? n.filter(t) : n;
}
function Kf(...e) {
  e.forEach((t) => {
    t.publishEvent("rowsSet");
  });
}
function fye(e) {
  const { t } = jn();
  function n() {
    return !e.isReadonly && O$() && e.contract.country === "DE" && e.contract.quantityDetails.quantities.some(
      (o) => o.bfGroupId === "LA"
    ) && e.contract.quantityDetails.quantities.some(
      (o) => o.bfGroupId === "FM"
    );
  }
  function r() {
    const {
      lieferanspruch: o,
      freieMenge: i
    } = wme();
    if (wt(o) && wt(i)) {
      const a = zs(
        e.contract.quantityDetails.quantities.find(
          (c) => c.bfGroupId === "LA"
        )
      ), l = e.quantitiesGridApi.current.getCellValue(
        a,
        "amount"
      );
      if (l - o > 0 && i > 0)
        throw Error("Invalid recommendations");
      e.quantitiesGridApi.current.updateRows([
        {
          id: a,
          reduce: l - o
        }
      ]), e.quantitiesGridApi.current.updateRows([
        {
          id: zs(
            e.contract.quantityDetails.quantities.find(
              (c) => c.bfGroupId === "FM"
            )
          ),
          amount: i
        }
      ]);
    }
  }
  return n() && /* @__PURE__ */ w.jsx(
    vm,
    {
      variant: "outlined",
      sx: { mb: 2 },
      onClick: () => {
        r(), e.afterClick();
      },
      "data-testid": "import-recommendations-button",
      children: t("contracts:contractWizard.importRecommendations")
    }
  );
}
const Bt = (e) => typeof e == "string", Tf = () => {
  let e, t;
  const n = new Promise((r, o) => {
    e = r, t = o;
  });
  return n.resolve = e, n.reject = t, n;
}, e_ = (e) => e == null ? "" : "" + e, pye = (e, t, n) => {
  e.forEach((r) => {
    t[r] && (n[r] = t[r]);
  });
}, hye = /###/g, t_ = (e) => e && e.indexOf("###") > -1 ? e.replace(hye, ".") : e, n_ = (e) => !e || Bt(e), Yf = (e, t, n) => {
  const r = Bt(t) ? t.split(".") : t;
  let o = 0;
  for (; o < r.length - 1; ) {
    if (n_(e)) return {};
    const i = t_(r[o]);
    !e[i] && n && (e[i] = new n()), Object.prototype.hasOwnProperty.call(e, i) ? e = e[i] : e = {}, ++o;
  }
  return n_(e) ? {} : {
    obj: e,
    k: t_(r[o])
  };
}, r_ = (e, t, n) => {
  const {
    obj: r,
    k: o
  } = Yf(e, t, Object);
  if (r !== void 0 || t.length === 1) {
    r[o] = n;
    return;
  }
  let i = t[t.length - 1], a = t.slice(0, t.length - 1), l = Yf(e, a, Object);
  for (; l.obj === void 0 && a.length; )
    i = `${a[a.length - 1]}.${i}`, a = a.slice(0, a.length - 1), l = Yf(e, a, Object), l && l.obj && typeof l.obj[`${l.k}.${i}`] < "u" && (l.obj = void 0);
  l.obj[`${l.k}.${i}`] = n;
}, gye = (e, t, n, r) => {
  const {
    obj: o,
    k: i
  } = Yf(e, t, Object);
  o[i] = o[i] || [], o[i].push(n);
}, Vm = (e, t) => {
  const {
    obj: n,
    k: r
  } = Yf(e, t);
  if (n)
    return n[r];
}, mye = (e, t, n) => {
  const r = Vm(e, n);
  return r !== void 0 ? r : Vm(t, n);
}, z$ = (e, t, n) => {
  for (const r in t)
    r !== "__proto__" && r !== "constructor" && (r in e ? Bt(e[r]) || e[r] instanceof String || Bt(t[r]) || t[r] instanceof String ? n && (e[r] = t[r]) : z$(e[r], t[r], n) : e[r] = t[r]);
  return e;
}, Cu = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var bye = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const yye = (e) => Bt(e) ? e.replace(/[&<>"'\/]/g, (t) => bye[t]) : e;
class vye {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const n = this.regExpMap.get(t);
    if (n !== void 0)
      return n;
    const r = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, r), this.regExpQueue.push(t), r;
  }
}
const wye = [" ", ",", "?", "!", ";"], Cye = new vye(20), xye = (e, t, n) => {
  t = t || "", n = n || "";
  const r = wye.filter((a) => t.indexOf(a) < 0 && n.indexOf(a) < 0);
  if (r.length === 0) return !0;
  const o = Cye.getRegExp(`(${r.map((a) => a === "?" ? "\\?" : a).join("|")})`);
  let i = !o.test(e);
  if (!i) {
    const a = e.indexOf(n);
    a > 0 && !o.test(e.substring(0, a)) && (i = !0);
  }
  return i;
}, gC = function(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!e) return;
  if (e[t]) return e[t];
  const r = t.split(n);
  let o = e;
  for (let i = 0; i < r.length; ) {
    if (!o || typeof o != "object")
      return;
    let a, l = "";
    for (let c = i; c < r.length; ++c)
      if (c !== i && (l += n), l += r[c], a = o[l], a !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof a) > -1 && c < r.length - 1)
          continue;
        i += c - i + 1;
        break;
      }
    o = a;
  }
  return o;
}, Hm = (e) => e && e.replace("_", "-"), Sye = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console && console[e] && console[e].apply(console, t);
  }
};
class Um {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(t, n);
  }
  init(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = n.prefix || "i18next:", this.logger = t || Sye, this.options = n, this.debug = n.debug;
  }
  log() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "log", "", !0);
  }
  warn() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "", !0);
  }
  error() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "error", "");
  }
  deprecate() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, n, r, o) {
    return o && !this.debug ? null : (Bt(t[0]) && (t[0] = `${r}${this.prefix} ${t[0]}`), this.logger[n](t));
  }
  create(t) {
    return new Um(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new Um(this.logger, t);
  }
}
var As = new Um();
class vy {
  constructor() {
    this.observers = {};
  }
  on(t, n) {
    return t.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const o = this.observers[r].get(n) || 0;
      this.observers[r].set(n, o + 1);
    }), this;
  }
  off(t, n) {
    if (this.observers[t]) {
      if (!n) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(n);
    }
  }
  emit(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      r[o - 1] = arguments[o];
    this.observers[t] && Array.from(this.observers[t].entries()).forEach((a) => {
      let [l, c] = a;
      for (let d = 0; d < c; d++)
        l(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((a) => {
      let [l, c] = a;
      for (let d = 0; d < c; d++)
        l.apply(l, [t, ...r]);
    });
  }
}
class o_ extends vy {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = t || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const n = this.options.ns.indexOf(t);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator, a = o.ignoreJSONStructure !== void 0 ? o.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let l;
    t.indexOf(".") > -1 ? l = t.split(".") : (l = [t, n], r && (Array.isArray(r) ? l.push(...r) : Bt(r) && i ? l.push(...r.split(i)) : l.push(r)));
    const c = Vm(this.data, l);
    return !c && !n && !r && t.indexOf(".") > -1 && (t = l[0], n = l[1], r = l.slice(2).join(".")), c || !a || !Bt(r) ? c : gC(this.data && this.data[t] && this.data[t][n], r, i);
  }
  addResource(t, n, r, o) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const a = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let l = [t, n];
    r && (l = l.concat(a ? r.split(a) : r)), t.indexOf(".") > -1 && (l = t.split("."), o = n, n = l[1]), this.addNamespaces(n), r_(this.data, l, o), i.silent || this.emit("added", t, n, r, o);
  }
  addResources(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in r)
      (Bt(r[i]) || Array.isArray(r[i])) && this.addResource(t, n, i, r[i], {
        silent: !0
      });
    o.silent || this.emit("added", t, n, r);
  }
  addResourceBundle(t, n, r, o, i) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, l = [t, n];
    t.indexOf(".") > -1 && (l = t.split("."), o = r, r = n, n = l[1]), this.addNamespaces(n);
    let c = Vm(this.data, l) || {};
    a.skipCopy || (r = JSON.parse(JSON.stringify(r))), o ? z$(c, r, i) : c = {
      ...c,
      ...r
    }, r_(this.data, l, c), a.silent || this.emit("added", t, n, r);
  }
  removeResourceBundle(t, n) {
    this.hasResourceBundle(t, n) && delete this.data[t][n], this.removeNamespaces(n), this.emit("removed", t, n);
  }
  hasResourceBundle(t, n) {
    return this.getResource(t, n) !== void 0;
  }
  getResourceBundle(t, n) {
    return n || (n = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(t, n)
    } : this.getResource(t, n);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const n = this.getDataByLanguage(t);
    return !!(n && Object.keys(n) || []).find((o) => n[o] && Object.keys(n[o]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var G$ = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, n, r, o) {
    return e.forEach((i) => {
      this.processors[i] && (t = this.processors[i].process(t, n, r, o));
    }), t;
  }
};
const i_ = {};
class zm extends vy {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), pye(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = As.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (t == null)
      return !1;
    const r = this.resolve(t, n);
    return r && r.res !== void 0;
  }
  extractFromKey(t, n) {
    let r = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const o = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let i = n.ns || this.options.defaultNS || [];
    const a = r && t.indexOf(r) > -1, l = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !xye(t, r, o);
    if (a && !l) {
      const c = t.match(this.interpolator.nestingRegexp);
      if (c && c.length > 0)
        return {
          key: t,
          namespaces: Bt(i) ? [i] : i
        };
      const d = t.split(r);
      (r !== o || r === o && this.options.ns.indexOf(d[0]) > -1) && (i = d.shift()), t = d.join(o);
    }
    return {
      key: t,
      namespaces: Bt(i) ? [i] : i
    };
  }
  translate(t, n, r) {
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), t == null) return "";
    Array.isArray(t) || (t = [String(t)]);
    const o = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: a,
      namespaces: l
    } = this.extractFromKey(t[t.length - 1], n), c = l[l.length - 1], d = n.lng || this.language, f = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (d && d.toLowerCase() === "cimode") {
      if (f) {
        const T = n.nsSeparator || this.options.nsSeparator;
        return o ? {
          res: `${c}${T}${a}`,
          usedKey: a,
          exactUsedKey: a,
          usedLng: d,
          usedNS: c,
          usedParams: this.getUsedParamsDetails(n)
        } : `${c}${T}${a}`;
      }
      return o ? {
        res: a,
        usedKey: a,
        exactUsedKey: a,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(n)
      } : a;
    }
    const p = this.resolve(t, n);
    let g = p && p.res;
    const b = p && p.usedKey || a, v = p && p.exactUsedKey || a, y = Object.prototype.toString.apply(g), S = ["[object Number]", "[object Function]", "[object RegExp]"], E = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, I = !this.i18nFormat || this.i18nFormat.handleAsObject, O = !Bt(g) && typeof g != "boolean" && typeof g != "number";
    if (I && g && O && S.indexOf(y) < 0 && !(Bt(E) && Array.isArray(g))) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const T = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(b, g, {
          ...n,
          ns: l
        }) : `key '${a} (${this.language})' returned an object instead of string.`;
        return o ? (p.res = T, p.usedParams = this.getUsedParamsDetails(n), p) : T;
      }
      if (i) {
        const T = Array.isArray(g), P = T ? [] : {}, R = T ? v : b;
        for (const F in g)
          if (Object.prototype.hasOwnProperty.call(g, F)) {
            const A = `${R}${i}${F}`;
            P[F] = this.translate(A, {
              ...n,
              joinArrays: !1,
              ns: l
            }), P[F] === A && (P[F] = g[F]);
          }
        g = P;
      }
    } else if (I && Bt(E) && Array.isArray(g))
      g = g.join(E), g && (g = this.extendTranslation(g, t, n, r));
    else {
      let T = !1, P = !1;
      const R = n.count !== void 0 && !Bt(n.count), F = zm.hasDefaultValue(n), A = R ? this.pluralResolver.getSuffix(d, n.count, n) : "", _ = n.ordinal && R ? this.pluralResolver.getSuffix(d, n.count, {
        ordinal: !1
      }) : "", C = R && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), D = C && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${A}`] || n[`defaultValue${_}`] || n.defaultValue;
      !this.isValidLookup(g) && F && (T = !0, g = D), this.isValidLookup(g) || (P = !0, g = a);
      const B = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && P ? void 0 : g, H = F && D !== g && this.options.updateMissing;
      if (P || T || H) {
        if (this.logger.log(H ? "updateKey" : "missingKey", d, c, a, H ? D : g), i) {
          const W = this.resolve(a, {
            ...n,
            keySeparator: !1
          });
          W && W.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let k = [];
        const N = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && N && N[0])
          for (let W = 0; W < N.length; W++)
            k.push(N[W]);
        else this.options.saveMissingTo === "all" ? k = this.languageUtils.toResolveHierarchy(n.lng || this.language) : k.push(n.lng || this.language);
        const j = (W, V, $) => {
          const z = F && $ !== g ? $ : B;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(W, c, V, z, H, n) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(W, c, V, z, H, n), this.emit("missingKey", W, c, V, g);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && R ? k.forEach((W) => {
          const V = this.pluralResolver.getSuffixes(W, n);
          C && n[`defaultValue${this.options.pluralSeparator}zero`] && V.indexOf(`${this.options.pluralSeparator}zero`) < 0 && V.push(`${this.options.pluralSeparator}zero`), V.forEach(($) => {
            j([W], a + $, n[`defaultValue${$}`] || D);
          });
        }) : j(k, a, D));
      }
      g = this.extendTranslation(g, t, n, p, r), P && g === a && this.options.appendNamespaceToMissingKey && (g = `${c}:${a}`), (P || T) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? g = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${c}:${a}` : a, T ? g : void 0) : g = this.options.parseMissingKeyHandler(g));
    }
    return o ? (p.res = g, p.usedParams = this.getUsedParamsDetails(n), p) : g;
  }
  extendTranslation(t, n, r, o, i) {
    var a = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...r
      }, r.lng || this.language || o.usedLng, o.usedNS, o.usedKey, {
        resolved: o
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init({
        ...r,
        interpolation: {
          ...this.options.interpolation,
          ...r.interpolation
        }
      });
      const d = Bt(t) && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let f;
      if (d) {
        const g = t.match(this.interpolator.nestingRegexp);
        f = g && g.length;
      }
      let p = r.replace && !Bt(r.replace) ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (p = {
        ...this.options.interpolation.defaultVariables,
        ...p
      }), t = this.interpolator.interpolate(t, p, r.lng || this.language || o.usedLng, r), d) {
        const g = t.match(this.interpolator.nestingRegexp), b = g && g.length;
        f < b && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && o && o.res && (r.lng = this.language || o.usedLng), r.nest !== !1 && (t = this.interpolator.nest(t, function() {
        for (var g = arguments.length, b = new Array(g), v = 0; v < g; v++)
          b[v] = arguments[v];
        return i && i[0] === b[0] && !r.context ? (a.logger.warn(`It seems you are nesting recursively key: ${b[0]} in key: ${n[0]}`), null) : a.translate(...b, n);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const l = r.postProcess || this.options.postProcess, c = Bt(l) ? [l] : l;
    return t != null && c && c.length && r.applyPostProcessor !== !1 && (t = G$.handle(c, t, n, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...o,
        usedParams: this.getUsedParamsDetails(r)
      },
      ...r
    } : r, this)), t;
  }
  resolve(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, o, i, a, l;
    return Bt(t) && (t = [t]), t.forEach((c) => {
      if (this.isValidLookup(r)) return;
      const d = this.extractFromKey(c, n), f = d.key;
      o = f;
      let p = d.namespaces;
      this.options.fallbackNS && (p = p.concat(this.options.fallbackNS));
      const g = n.count !== void 0 && !Bt(n.count), b = g && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), v = n.context !== void 0 && (Bt(n.context) || typeof n.context == "number") && n.context !== "", y = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      p.forEach((S) => {
        this.isValidLookup(r) || (l = S, !i_[`${y[0]}-${S}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(l) && (i_[`${y[0]}-${S}`] = !0, this.logger.warn(`key "${o}" for languages "${y.join(", ")}" won't get resolved as namespace "${l}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), y.forEach((E) => {
          if (this.isValidLookup(r)) return;
          a = E;
          const I = [f];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(I, f, E, S, n);
          else {
            let T;
            g && (T = this.pluralResolver.getSuffix(E, n.count, n));
            const P = `${this.options.pluralSeparator}zero`, R = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (g && (I.push(f + T), n.ordinal && T.indexOf(R) === 0 && I.push(f + T.replace(R, this.options.pluralSeparator)), b && I.push(f + P)), v) {
              const F = `${f}${this.options.contextSeparator}${n.context}`;
              I.push(F), g && (I.push(F + T), n.ordinal && T.indexOf(R) === 0 && I.push(F + T.replace(R, this.options.pluralSeparator)), b && I.push(F + P));
            }
          }
          let O;
          for (; O = I.pop(); )
            this.isValidLookup(r) || (i = O, r = this.getResource(E, S, O, n));
        }));
      });
    }), {
      res: r,
      usedKey: o,
      exactUsedKey: i,
      usedLng: a,
      usedNS: l
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(t, n, r, o) : this.resourceStore.getResource(t, n, r, o);
  }
  getUsedParamsDetails() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = t.replace && !Bt(t.replace);
    let o = r ? t.replace : t;
    if (r && typeof t.count < "u" && (o.count = t.count), this.options.interpolation.defaultVariables && (o = {
      ...this.options.interpolation.defaultVariables,
      ...o
    }), !r) {
      o = {
        ...o
      };
      for (const i of n)
        delete o[i];
    }
    return o;
  }
  static hasDefaultValue(t) {
    const n = "defaultValue";
    for (const r in t)
      if (Object.prototype.hasOwnProperty.call(t, r) && n === r.substring(0, n.length) && t[r] !== void 0)
        return !0;
    return !1;
  }
}
const jw = (e) => e.charAt(0).toUpperCase() + e.slice(1);
class s_ {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = As.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = Hm(t), !t || t.indexOf("-") < 0) return null;
    const n = t.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = Hm(t), !t || t.indexOf("-") < 0) return t;
    const n = t.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(t) {
    if (Bt(t) && t.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let o = Intl.getCanonicalLocales(t)[0];
          if (o && this.options.lowerCaseLng && (o = o.toLowerCase()), o) return o;
        } catch {
        }
      const n = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = t.split("-");
      return this.options.lowerCaseLng ? r = r.map((o) => o.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = jw(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = jw(r[1].toLowerCase())), n.indexOf(r[2].toLowerCase()) > -1 && (r[2] = jw(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let n;
    return t.forEach((r) => {
      if (n) return;
      const o = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(o)) && (n = o);
    }), !n && this.options.supportedLngs && t.forEach((r) => {
      if (n) return;
      const o = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(o)) return n = o;
      n = this.options.supportedLngs.find((i) => {
        if (i === o) return i;
        if (!(i.indexOf("-") < 0 && o.indexOf("-") < 0) && (i.indexOf("-") > 0 && o.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === o || i.indexOf(o) === 0 && o.length > 1))
          return i;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(t, n) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(n)), Bt(t) && (t = [t]), Array.isArray(t)) return t;
    if (!n) return t.default || [];
    let r = t[n];
    return r || (r = t[this.getScriptPartFromCode(n)]), r || (r = t[this.formatLanguageCode(n)]), r || (r = t[this.getLanguagePartFromCode(n)]), r || (r = t.default), r || [];
  }
  toResolveHierarchy(t, n) {
    const r = this.getFallbackCodes(n || this.options.fallbackLng || [], t), o = [], i = (a) => {
      a && (this.isSupportedCode(a) ? o.push(a) : this.logger.warn(`rejecting language code not found in supportedLngs: ${a}`));
    };
    return Bt(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(t))) : Bt(t) && i(this.formatLanguageCode(t)), r.forEach((a) => {
      o.indexOf(a) < 0 && i(this.formatLanguageCode(a));
    }), o;
  }
}
let Eye = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], Tye = {
  1: (e) => +(e > 1),
  2: (e) => +(e != 1),
  3: (e) => 0,
  4: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  5: (e) => e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5,
  6: (e) => e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2,
  7: (e) => e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  8: (e) => e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3,
  9: (e) => +(e >= 2),
  10: (e) => e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4,
  11: (e) => e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3,
  12: (e) => +(e % 10 != 1 || e % 100 == 11),
  13: (e) => +(e !== 0),
  14: (e) => e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3,
  15: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  16: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2,
  17: (e) => e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1,
  18: (e) => e == 0 ? 0 : e == 1 ? 1 : 2,
  19: (e) => e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3,
  20: (e) => e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2,
  21: (e) => e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0,
  22: (e) => e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3
};
const Oye = ["v1", "v2", "v3"], Pye = ["v4"], a_ = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Iye = () => {
  const e = {};
  return Eye.forEach((t) => {
    t.lngs.forEach((n) => {
      e[n] = {
        numbers: t.nr,
        plurals: Tye[t.fc]
      };
    });
  }), e;
};
class Rye {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = t, this.options = n, this.logger = As.create("pluralResolver"), (!this.options.compatibilityJSON || Pye.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Iye(), this.pluralRulesCache = {};
  }
  addRule(t, n) {
    this.rules[t] = n;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const r = Hm(t === "dev" ? "en" : t), o = n.ordinal ? "ordinal" : "cardinal", i = JSON.stringify({
        cleanedCode: r,
        type: o
      });
      if (i in this.pluralRulesCache)
        return this.pluralRulesCache[i];
      let a;
      try {
        a = new Intl.PluralRules(r, {
          type: o
        });
      } catch {
        if (!t.match(/-|_/)) return;
        const c = this.languageUtils.getLanguagePartFromCode(t);
        a = this.getRule(c, n);
      }
      return this.pluralRulesCache[i] = a, a;
    }
    return this.rules[t] || this.rules[this.languageUtils.getLanguagePartFromCode(t)];
  }
  needsPlural(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(t, r).map((o) => `${n}${o}`);
  }
  getSuffixes(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((o, i) => a_[o] - a_[i]).map((o) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${o}`) : r.numbers.map((o) => this.getSuffix(t, o, n)) : [];
  }
  getSuffix(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const o = this.getRule(t, r);
    return o ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${o.select(n)}` : this.getSuffixRetroCompatible(o, n) : (this.logger.warn(`no plural rule found for: ${t}`), "");
  }
  getSuffixRetroCompatible(t, n) {
    const r = t.noAbs ? t.plurals(n) : t.plurals(Math.abs(n));
    let o = t.numbers[r];
    this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 && (o === 2 ? o = "plural" : o === 1 && (o = ""));
    const i = () => this.options.prepend && o.toString() ? this.options.prepend + o.toString() : o.toString();
    return this.options.compatibilityJSON === "v1" ? o === 1 ? "" : typeof o == "number" ? `_plural_${o.toString()}` : i() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 ? i() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !Oye.includes(this.options.compatibilityJSON);
  }
}
const l_ = function(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = mye(e, t, n);
  return !i && o && Bt(n) && (i = gC(e, n, r), i === void 0 && (i = gC(t, n, r))), i;
}, Bw = (e) => e.replace(/\$/g, "$$$$");
class _ye {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = As.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || ((n) => n), this.init(t);
  }
  init() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: n,
      escapeValue: r,
      useRawValueToEscape: o,
      prefix: i,
      prefixEscaped: a,
      suffix: l,
      suffixEscaped: c,
      formatSeparator: d,
      unescapeSuffix: f,
      unescapePrefix: p,
      nestingPrefix: g,
      nestingPrefixEscaped: b,
      nestingSuffix: v,
      nestingSuffixEscaped: y,
      nestingOptionsSeparator: S,
      maxReplaces: E,
      alwaysFormat: I
    } = t.interpolation;
    this.escape = n !== void 0 ? n : yye, this.escapeValue = r !== void 0 ? r : !0, this.useRawValueToEscape = o !== void 0 ? o : !1, this.prefix = i ? Cu(i) : a || "{{", this.suffix = l ? Cu(l) : c || "}}", this.formatSeparator = d || ",", this.unescapePrefix = f ? "" : p || "-", this.unescapeSuffix = this.unescapePrefix ? "" : f || "", this.nestingPrefix = g ? Cu(g) : b || Cu("$t("), this.nestingSuffix = v ? Cu(v) : y || Cu(")"), this.nestingOptionsSeparator = S || ",", this.maxReplaces = E || 1e3, this.alwaysFormat = I !== void 0 ? I : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (n, r) => n && n.source === r ? (n.lastIndex = 0, n) : new RegExp(r, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(t, n, r, o) {
    let i, a, l;
    const c = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, d = (b) => {
      if (b.indexOf(this.formatSeparator) < 0) {
        const E = l_(n, c, b, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(E, void 0, r, {
          ...o,
          ...n,
          interpolationkey: b
        }) : E;
      }
      const v = b.split(this.formatSeparator), y = v.shift().trim(), S = v.join(this.formatSeparator).trim();
      return this.format(l_(n, c, y, this.options.keySeparator, this.options.ignoreJSONStructure), S, r, {
        ...o,
        ...n,
        interpolationkey: y
      });
    };
    this.resetRegExp();
    const f = o && o.missingInterpolationHandler || this.options.missingInterpolationHandler, p = o && o.interpolation && o.interpolation.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (b) => Bw(b)
    }, {
      regex: this.regexp,
      safeValue: (b) => this.escapeValue ? Bw(this.escape(b)) : Bw(b)
    }].forEach((b) => {
      for (l = 0; i = b.regex.exec(t); ) {
        const v = i[1].trim();
        if (a = d(v), a === void 0)
          if (typeof f == "function") {
            const S = f(t, i, o);
            a = Bt(S) ? S : "";
          } else if (o && Object.prototype.hasOwnProperty.call(o, v))
            a = "";
          else if (p) {
            a = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${v} for interpolating ${t}`), a = "";
        else !Bt(a) && !this.useRawValueToEscape && (a = e_(a));
        const y = b.safeValue(a);
        if (t = t.replace(i[0], y), p ? (b.regex.lastIndex += a.length, b.regex.lastIndex -= i[0].length) : b.regex.lastIndex = 0, l++, l >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o, i, a;
    const l = (c, d) => {
      const f = this.nestingOptionsSeparator;
      if (c.indexOf(f) < 0) return c;
      const p = c.split(new RegExp(`${f}[ ]*{`));
      let g = `{${p[1]}`;
      c = p[0], g = this.interpolate(g, a);
      const b = g.match(/'/g), v = g.match(/"/g);
      (b && b.length % 2 === 0 && !v || v.length % 2 !== 0) && (g = g.replace(/'/g, '"'));
      try {
        a = JSON.parse(g), d && (a = {
          ...d,
          ...a
        });
      } catch (y) {
        return this.logger.warn(`failed parsing options string in nesting for key ${c}`, y), `${c}${f}${g}`;
      }
      return a.defaultValue && a.defaultValue.indexOf(this.prefix) > -1 && delete a.defaultValue, c;
    };
    for (; o = this.nestingRegexp.exec(t); ) {
      let c = [];
      a = {
        ...r
      }, a = a.replace && !Bt(a.replace) ? a.replace : a, a.applyPostProcessor = !1, delete a.defaultValue;
      let d = !1;
      if (o[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(o[1])) {
        const f = o[1].split(this.formatSeparator).map((p) => p.trim());
        o[1] = f.shift(), c = f, d = !0;
      }
      if (i = n(l.call(this, o[1].trim(), a), a), i && o[0] === t && !Bt(i)) return i;
      Bt(i) || (i = e_(i)), i || (this.logger.warn(`missed to resolve ${o[1]} for nesting ${t}`), i = ""), d && (i = c.reduce((f, p) => this.format(f, p, r.lng, {
        ...r,
        interpolationkey: o[1].trim()
      }), i.trim())), t = t.replace(o[0], i), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const kye = (e) => {
  let t = e.toLowerCase().trim();
  const n = {};
  if (e.indexOf("(") > -1) {
    const r = e.split("(");
    t = r[0].toLowerCase().trim();
    const o = r[1].substring(0, r[1].length - 1);
    t === "currency" && o.indexOf(":") < 0 ? n.currency || (n.currency = o.trim()) : t === "relativetime" && o.indexOf(":") < 0 ? n.range || (n.range = o.trim()) : o.split(";").forEach((a) => {
      if (a) {
        const [l, ...c] = a.split(":"), d = c.join(":").trim().replace(/^'+|'+$/g, ""), f = l.trim();
        n[f] || (n[f] = d), d === "false" && (n[f] = !1), d === "true" && (n[f] = !0), isNaN(d) || (n[f] = parseInt(d, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: n
  };
}, xu = (e) => {
  const t = {};
  return (n, r, o) => {
    let i = o;
    o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey] && (i = {
      ...i,
      [o.interpolationkey]: void 0
    });
    const a = r + JSON.stringify(i);
    let l = t[a];
    return l || (l = e(Hm(r), o), t[a] = l), l(n);
  };
};
class Mye {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = As.create("formatter"), this.options = t, this.formats = {
      number: xu((n, r) => {
        const o = new Intl.NumberFormat(n, {
          ...r
        });
        return (i) => o.format(i);
      }),
      currency: xu((n, r) => {
        const o = new Intl.NumberFormat(n, {
          ...r,
          style: "currency"
        });
        return (i) => o.format(i);
      }),
      datetime: xu((n, r) => {
        const o = new Intl.DateTimeFormat(n, {
          ...r
        });
        return (i) => o.format(i);
      }),
      relativetime: xu((n, r) => {
        const o = new Intl.RelativeTimeFormat(n, {
          ...r
        });
        return (i) => o.format(i, r.range || "day");
      }),
      list: xu((n, r) => {
        const o = new Intl.ListFormat(n, {
          ...r
        });
        return (i) => o.format(i);
      })
    }, this.init(t);
  }
  init(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = n.interpolation.formatSeparator || ",";
  }
  add(t, n) {
    this.formats[t.toLowerCase().trim()] = n;
  }
  addCached(t, n) {
    this.formats[t.toLowerCase().trim()] = xu(n);
  }
  format(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = n.split(this.formatSeparator);
    if (i.length > 1 && i[0].indexOf("(") > 1 && i[0].indexOf(")") < 0 && i.find((l) => l.indexOf(")") > -1)) {
      const l = i.findIndex((c) => c.indexOf(")") > -1);
      i[0] = [i[0], ...i.splice(1, l)].join(this.formatSeparator);
    }
    return i.reduce((l, c) => {
      const {
        formatName: d,
        formatOptions: f
      } = kye(c);
      if (this.formats[d]) {
        let p = l;
        try {
          const g = o && o.formatParams && o.formatParams[o.interpolationkey] || {}, b = g.locale || g.lng || o.locale || o.lng || r;
          p = this.formats[d](l, b, {
            ...f,
            ...o,
            ...g
          });
        } catch (g) {
          this.logger.warn(g);
        }
        return p;
      } else
        this.logger.warn(`there was no format function for ${d}`);
      return l;
    }, t);
  }
}
const Aye = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class Dye extends vy {
  constructor(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = t, this.store = n, this.services = r, this.languageUtils = r.languageUtils, this.options = o, this.logger = As.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = o.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = o.maxRetries >= 0 ? o.maxRetries : 5, this.retryTimeout = o.retryTimeout >= 1 ? o.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, o.backend, o);
  }
  queueLoad(t, n, r, o) {
    const i = {}, a = {}, l = {}, c = {};
    return t.forEach((d) => {
      let f = !0;
      n.forEach((p) => {
        const g = `${d}|${p}`;
        !r.reload && this.store.hasResourceBundle(d, p) ? this.state[g] = 2 : this.state[g] < 0 || (this.state[g] === 1 ? a[g] === void 0 && (a[g] = !0) : (this.state[g] = 1, f = !1, a[g] === void 0 && (a[g] = !0), i[g] === void 0 && (i[g] = !0), c[p] === void 0 && (c[p] = !0)));
      }), f || (l[d] = !0);
    }), (Object.keys(i).length || Object.keys(a).length) && this.queue.push({
      pending: a,
      pendingCount: Object.keys(a).length,
      loaded: {},
      errors: [],
      callback: o
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(a),
      toLoadLanguages: Object.keys(l),
      toLoadNamespaces: Object.keys(c)
    };
  }
  loaded(t, n, r) {
    const o = t.split("|"), i = o[0], a = o[1];
    n && this.emit("failedLoading", i, a, n), !n && r && this.store.addResourceBundle(i, a, r, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = n ? -1 : 2, n && r && (this.state[t] = 0);
    const l = {};
    this.queue.forEach((c) => {
      gye(c.loaded, [i], a), Aye(c, t), n && c.errors.push(n), c.pendingCount === 0 && !c.done && (Object.keys(c.loaded).forEach((d) => {
        l[d] || (l[d] = {});
        const f = c.loaded[d];
        f.length && f.forEach((p) => {
          l[d][p] === void 0 && (l[d][p] = !0);
        });
      }), c.done = !0, c.errors.length ? c.callback(c.errors) : c.callback());
    }), this.emit("loaded", l), this.queue = this.queue.filter((c) => !c.done);
  }
  read(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, a = arguments.length > 5 ? arguments[5] : void 0;
    if (!t.length) return a(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: n,
        fcName: r,
        tried: o,
        wait: i,
        callback: a
      });
      return;
    }
    this.readingCalls++;
    const l = (d, f) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const p = this.waitingReads.shift();
        this.read(p.lng, p.ns, p.fcName, p.tried, p.wait, p.callback);
      }
      if (d && f && o < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, n, r, o + 1, i * 2, a);
        }, i);
        return;
      }
      a(d, f);
    }, c = this.backend[r].bind(this.backend);
    if (c.length === 2) {
      try {
        const d = c(t, n);
        d && typeof d.then == "function" ? d.then((f) => l(null, f)).catch(l) : l(null, d);
      } catch (d) {
        l(d);
      }
      return;
    }
    return c(t, n, l);
  }
  prepareLoading(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), o && o();
    Bt(t) && (t = this.languageUtils.toResolveHierarchy(t)), Bt(n) && (n = [n]);
    const i = this.queueLoad(t, n, r, o);
    if (!i.toLoad.length)
      return i.pending.length || o(), null;
    i.toLoad.forEach((a) => {
      this.loadOne(a);
    });
  }
  load(t, n, r) {
    this.prepareLoading(t, n, {}, r);
  }
  reload(t, n, r) {
    this.prepareLoading(t, n, {
      reload: !0
    }, r);
  }
  loadOne(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = t.split("|"), o = r[0], i = r[1];
    this.read(o, i, "read", void 0, void 0, (a, l) => {
      a && this.logger.warn(`${n}loading namespace ${i} for language ${o} failed`, a), !a && l && this.logger.log(`${n}loaded namespace ${i} for language ${o}`, l), this.loaded(t, a, l);
    });
  }
  saveMissing(t, n, r, o, i) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, l = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const c = {
          ...a,
          isUpdate: i
        }, d = this.backend.create.bind(this.backend);
        if (d.length < 6)
          try {
            let f;
            d.length === 5 ? f = d(t, n, r, o, c) : f = d(t, n, r, o), f && typeof f.then == "function" ? f.then((p) => l(null, p)).catch(l) : l(null, f);
          } catch (f) {
            l(f);
          }
        else
          d(t, n, r, o, l, c);
      }
      !t || !t[0] || this.store.addResource(t[0], n, r, o);
    }
  }
}
const c_ = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), Bt(e[1]) && (t.defaultValue = e[1]), Bt(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const n = e[3] || e[2];
      Object.keys(n).forEach((r) => {
        t[r] = n[r];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), u_ = (e) => (Bt(e.ns) && (e.ns = [e.ns]), Bt(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), Bt(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e), _g = () => {
}, Nye = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((n) => {
    typeof e[n] == "function" && (e[n] = e[n].bind(e));
  });
};
class Op extends vy {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = u_(t), this.services = {}, this.logger = As, this.modules = {
      external: []
    }, Nye(this), n && !this.isInitialized && !t.isClone) {
      if (!this.options.initImmediate)
        return this.init(t, n), this;
      setTimeout(() => {
        this.init(t, n);
      }, 0);
    }
  }
  init() {
    var t = this;
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof n == "function" && (r = n, n = {}), !n.defaultNS && n.defaultNS !== !1 && n.ns && (Bt(n.ns) ? n.defaultNS = n.ns : n.ns.indexOf("translation") < 0 && (n.defaultNS = n.ns[0]));
    const o = c_();
    this.options = {
      ...o,
      ...this.options,
      ...u_(n)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...o.interpolation,
      ...this.options.interpolation
    }), n.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = n.keySeparator), n.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = n.nsSeparator);
    const i = (f) => f ? typeof f == "function" ? new f() : f : null;
    if (!this.options.isClone) {
      this.modules.logger ? As.init(i(this.modules.logger), this.options) : As.init(null, this.options);
      let f;
      this.modules.formatter ? f = this.modules.formatter : typeof Intl < "u" && (f = Mye);
      const p = new s_(this.options);
      this.store = new o_(this.options.resources, this.options);
      const g = this.services;
      g.logger = As, g.resourceStore = this.store, g.languageUtils = p, g.pluralResolver = new Rye(p, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), f && (!this.options.interpolation.format || this.options.interpolation.format === o.interpolation.format) && (g.formatter = i(f), g.formatter.init(g, this.options), this.options.interpolation.format = g.formatter.format.bind(g.formatter)), g.interpolator = new _ye(this.options), g.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, g.backendConnector = new Dye(i(this.modules.backend), g.resourceStore, g, this.options), g.backendConnector.on("*", function(b) {
        for (var v = arguments.length, y = new Array(v > 1 ? v - 1 : 0), S = 1; S < v; S++)
          y[S - 1] = arguments[S];
        t.emit(b, ...y);
      }), this.modules.languageDetector && (g.languageDetector = i(this.modules.languageDetector), g.languageDetector.init && g.languageDetector.init(g, this.options.detection, this.options)), this.modules.i18nFormat && (g.i18nFormat = i(this.modules.i18nFormat), g.i18nFormat.init && g.i18nFormat.init(this)), this.translator = new zm(this.services, this.options), this.translator.on("*", function(b) {
        for (var v = arguments.length, y = new Array(v > 1 ? v - 1 : 0), S = 1; S < v; S++)
          y[S - 1] = arguments[S];
        t.emit(b, ...y);
      }), this.modules.external.forEach((b) => {
        b.init && b.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = _g), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const f = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      f.length > 0 && f[0] !== "dev" && (this.options.lng = f[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((f) => {
      this[f] = function() {
        return t.store[f](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((f) => {
      this[f] = function() {
        return t.store[f](...arguments), t;
      };
    });
    const c = Tf(), d = () => {
      const f = (p, g) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), c.resolve(g), r(p, g);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return f(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, f);
    };
    return this.options.resources || !this.options.initImmediate ? d() : setTimeout(d, 0), c;
  }
  loadResources(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _g;
    const o = Bt(t) ? t : this.language;
    if (typeof t == "function" && (r = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (o && o.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return r();
      const i = [], a = (l) => {
        if (!l || l === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(l).forEach((d) => {
          d !== "cimode" && i.indexOf(d) < 0 && i.push(d);
        });
      };
      o ? a(o) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((c) => a(c)), this.options.preload && this.options.preload.forEach((l) => a(l)), this.services.backendConnector.load(i, this.options.ns, (l) => {
        !l && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), r(l);
      });
    } else
      r(null);
  }
  reloadResources(t, n, r) {
    const o = Tf();
    return typeof t == "function" && (r = t, t = void 0), typeof n == "function" && (r = n, n = void 0), t || (t = this.languages), n || (n = this.options.ns), r || (r = _g), this.services.backendConnector.reload(t, n, (i) => {
      o.resolve(), r(i);
    }), o;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && G$.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1))
      for (let n = 0; n < this.languages.length; n++) {
        const r = this.languages[n];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(t, n) {
    var r = this;
    this.isLanguageChangingTo = t;
    const o = Tf();
    this.emit("languageChanging", t);
    const i = (c) => {
      this.language = c, this.languages = this.services.languageUtils.toResolveHierarchy(c), this.resolvedLanguage = void 0, this.setResolvedLanguage(c);
    }, a = (c, d) => {
      d ? (i(d), this.translator.changeLanguage(d), this.isLanguageChangingTo = void 0, this.emit("languageChanged", d), this.logger.log("languageChanged", d)) : this.isLanguageChangingTo = void 0, o.resolve(function() {
        return r.t(...arguments);
      }), n && n(c, function() {
        return r.t(...arguments);
      });
    }, l = (c) => {
      !t && !c && this.services.languageDetector && (c = []);
      const d = Bt(c) ? c : this.services.languageUtils.getBestMatchFromCodes(c);
      d && (this.language || i(d), this.translator.language || this.translator.changeLanguage(d), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(d)), this.loadResources(d, (f) => {
        a(f, d);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? l(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(l) : this.services.languageDetector.detect(l) : l(t), o;
  }
  getFixedT(t, n, r) {
    var o = this;
    const i = function(a, l) {
      let c;
      if (typeof l != "object") {
        for (var d = arguments.length, f = new Array(d > 2 ? d - 2 : 0), p = 2; p < d; p++)
          f[p - 2] = arguments[p];
        c = o.options.overloadTranslationOptionHandler([a, l].concat(f));
      } else
        c = {
          ...l
        };
      c.lng = c.lng || i.lng, c.lngs = c.lngs || i.lngs, c.ns = c.ns || i.ns, c.keyPrefix !== "" && (c.keyPrefix = c.keyPrefix || r || i.keyPrefix);
      const g = o.options.keySeparator || ".";
      let b;
      return c.keyPrefix && Array.isArray(a) ? b = a.map((v) => `${c.keyPrefix}${g}${v}`) : b = c.keyPrefix ? `${c.keyPrefix}${g}${a}` : a, o.t(b, c);
    };
    return Bt(t) ? i.lng = t : i.lngs = t, i.ns = n, i.keyPrefix = r, i;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = n.lng || this.resolvedLanguage || this.languages[0], o = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode") return !0;
    const a = (l, c) => {
      const d = this.services.backendConnector.state[`${l}|${c}`];
      return d === -1 || d === 0 || d === 2;
    };
    if (n.precheck) {
      const l = n.precheck(this, a);
      if (l !== void 0) return l;
    }
    return !!(this.hasResourceBundle(r, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || a(r, t) && (!o || a(i, t)));
  }
  loadNamespaces(t, n) {
    const r = Tf();
    return this.options.ns ? (Bt(t) && (t = [t]), t.forEach((o) => {
      this.options.ns.indexOf(o) < 0 && this.options.ns.push(o);
    }), this.loadResources((o) => {
      r.resolve(), n && n(o);
    }), r) : (n && n(), Promise.resolve());
  }
  loadLanguages(t, n) {
    const r = Tf();
    Bt(t) && (t = [t]);
    const o = this.options.preload || [], i = t.filter((a) => o.indexOf(a) < 0 && this.services.languageUtils.isSupportedCode(a));
    return i.length ? (this.options.preload = o.concat(i), this.loadResources((a) => {
      r.resolve(), n && n(a);
    }), r) : (n && n(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new s_(c_());
    return n.indexOf(r.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    return new Op(t, n);
  }
  cloneInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _g;
    const r = t.forkResourceStore;
    r && delete t.forkResourceStore;
    const o = {
      ...this.options,
      ...t,
      isClone: !0
    }, i = new Op(o);
    return (t.debug !== void 0 || t.prefix !== void 0) && (i.logger = i.logger.clone(t)), ["store", "services", "language"].forEach((l) => {
      i[l] = this[l];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, r && (i.store = new o_(this.store.data, o), i.services.resourceStore = i.store), i.translator = new zm(i.services, o), i.translator.on("*", function(l) {
      for (var c = arguments.length, d = new Array(c > 1 ? c - 1 : 0), f = 1; f < c; f++)
        d[f - 1] = arguments[f];
      i.emit(l, ...d);
    }), i.init(o, n), i.translator.options = o, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const yo = Op.createInstance();
yo.createInstance = Op.createInstance;
yo.createInstance;
yo.dir;
yo.init;
yo.loadResources;
yo.reloadResources;
yo.use;
yo.changeLanguage;
yo.getFixedT;
const $f = yo.t;
yo.exists;
yo.setDefaultNamespace;
yo.hasLoadedNamespace;
yo.loadNamespaces;
yo.loadLanguages;
function Fye(e, t, n, r) {
  let o = [], i = [];
  return W$(e, n, o, r), $ye(
    t,
    e,
    n,
    o,
    i,
    r
  ), { errors: o, warnings: i };
}
function W$(e, t, n, r) {
  Lye(e, t, n), Bye(e, t, n, r), Vye(
    e,
    t,
    n,
    r
  ), Hye(e, t, n, r);
}
function $ye(e, t, n, r, o, i) {
  jye(
    e,
    n,
    r,
    o
  ), Uye(e, n, r, i), zye(e, n, r, i), Gye(
    e,
    t,
    n,
    r,
    i
  ), qye(
    e,
    t,
    n,
    r
  ), Kye(e, n, r);
}
function Lye(e, t, n) {
  const r = t.quantityDetails.checks.filter(
    (o) => o.bfGroupId
  );
  if (r.length > 0) {
    const o = [];
    for (const i of r) {
      const a = t.quantityDetails.quantities.find(
        (l) => i.bfGroupId === l.bfGroupId
      );
      if (a) {
        const l = zs(a), c = e.current.getCellValue(
          l,
          "amount"
        );
        if (gi(l, o, t, "quantity"), !q$(c, i.checkValue, i.checkType)) {
          Po(i.messageText, o, n);
          break;
        }
      }
    }
  }
}
function jye(e, t, n, r) {
  const o = t.quantityDetails.checks.filter(
    (i) => !i.bfGroupId
  );
  if (o.length > 0)
    for (const i of o) {
      const a = [], l = e.current.getCellValue(
        i.positionNumber,
        "amount"
      );
      if (gi(
        i.positionNumber,
        a,
        t,
        "position"
      ), l && !q$(l, i.checkValue, i.checkType))
        if (i.messageType === "ERROR") {
          Po(i.messageText, a, n);
          break;
        } else i.messageType === "WARNING" && Po(i.messageText, a, r);
    }
}
function Bye(e, t, n, r) {
  const o = [], i = e.current.getAllRowIds();
  let a = 0;
  i.forEach((l) => {
    a += hi(
      e.current.getCellValue(
        l,
        t.quantityDetails.contractUnit === "ACREAGE" ? "acreage" : "amount"
      ) - e.current.getCellValue(l, "reduce"),
      1
    ), gi(l, o, t, "quantity"), gi(l, o, t, "quantity", "reduce");
  }), a < 0 && Po(
    t.texts.safeGet("EMP4_CD", r),
    o,
    n
  );
}
function Vye(e, t, n, r) {
  e.current.getAllRowIds().forEach((i) => {
    const a = e.current.getRow(i);
    if ((a == null ? void 0 : a.bfGroupId) === "FM")
      return;
    if (hi(
      (t.quantityDetails.contractUnit === "ACREAGE" ? a == null ? void 0 : a.acreage : a == null ? void 0 : a.amount) ?? 0,
      1
    ) <= 0) {
      const c = [];
      gi(i, c, t, "quantity"), Po(
        t.texts.safeGet("EMP4_CD", r),
        c,
        n
      );
    }
  });
}
function Hye(e, t, n, r) {
  e.current.getAllRowIds().forEach((i) => {
    if (hi(
      e.current.getCellValue(
        i,
        t.quantityDetails.contractUnit === "ACREAGE" ? "acreage" : "amount"
      ) - e.current.getCellValue(i, "reduce"),
      1
    ) < 0) {
      const l = [];
      gi(i, l, t, "quantity"), gi(i, l, t, "quantity", "reduce"), Po(
        t.texts.safeGet("EMP2_CD", r),
        l,
        n
      );
    }
  });
}
function Uye(e, t, n, r) {
  Ro(
    e,
    (i) => !i.isSumRow
  ).filter((i) => i.confirmInformation && !i.informationWasConfirmed).forEach((i) => {
    const a = [];
    t.quantityDetails.contractUnit === "PERCENT" ? i.percentage !== 0 && (a.push({
      rowId: i.id,
      column: "information",
      targetTable: "position"
    }), Po(
      t.texts.safeGet("EM_CD", r),
      a,
      n
    )) : i.amount !== 0 && (a.push({
      rowId: i.id,
      column: "information",
      targetTable: "position"
    }), Po(
      t.texts.safeGet("EM_CD", r),
      a,
      n
    ));
  });
}
function zye(e, t, n, r) {
  const o = Ro(
    e,
    (i) => !i.isSumRow
  );
  for (const i of o) {
    const a = [];
    if (i.maxAmount > 0 && i.amount > hi(i.maxAmount, 1)) {
      gi(i.id, a, t, "position");
      const l = t.texts.safeGet("EMP4_CD", r).replace(/&/g, i.maxAmount);
      Po(l, a, n);
    }
  }
}
function Gye(e, t, n, r, o) {
  const i = Ro(
    e,
    (a) => !a.isSumRow
  );
  for (const a of i) {
    const l = [];
    if (a.maxPercentage > 0) {
      const c = Jye(
        a.bfGroupId,
        t
      );
      if (c) {
        const d = U$(
          c
        ), f = hi(
          d * a.maxPercentage / 100,
          1
        );
        if (a.amount > f) {
          gi(a.id, l, n, "position");
          const p = n.texts.safeGet("EMP1_CD", o).replace(/&/g, f);
          Po(p, l, r);
        }
      }
    }
  }
}
function Wye(e, t, n, r) {
  const o = n.quantityDetails.quantities.filter(
    (a) => a.bfGroupId === e
  );
  let i = 0;
  return o.forEach((a) => {
    const l = zs(a);
    i += t.current.getCellValue(l, "amount") - t.current.getCellValue(l, "reduce"), gi(
      l,
      r,
      n,
      "quantity",
      "reduce"
    ), gi(l, r, n, "quantity");
  }), i;
}
function qye(e, t, n, r) {
  const o = Yye(e);
  for (const i of o) {
    const a = [], l = hi(
      Zye(
        i,
        e,
        n,
        a
      ),
      1
    ), c = n.quantityDetails.quantities.find(
      (d) => d.bfGroupId === i
    );
    if (c) {
      const d = hi(
        Wye(
          i,
          t,
          n,
          a
        ),
        1
      );
      if (l > d) {
        const f = n.texts.safeGet("EMP5_CD", $f).replace(/&/g, i);
        Po(f, a, r);
      } else if (l < d) {
        const f = n.texts.safeGet("EMP6_CD", $f).replace(/&/g, i);
        Po(f, a, r);
      } else if (l < c.minAmount) {
        const f = n.texts.safeGet("EMP8_CD", $f, !0).replace(
          /&/g,
          c.minAmount
        );
        Po(f, a, r);
      } else if (c.maxAmount > 0 && l > c.maxAmount) {
        const f = n.texts.safeGet("EMP1_CD", $f).replace(
          /&/g,
          c.maxAmount
        );
        Po(f, a, r);
      }
    }
  }
}
function Kye(e, t, n) {
  const r = [];
  if (t.quantityDetails.contractUnit === "PERCENT") {
    const o = Xye(e);
    Qye(
      e,
      r,
      t
    ), hi(o.percentage, 2) !== 100 && Po(
      t.texts.safeGet("EMP9_CD", $f),
      r,
      n
    );
  }
}
function q$(e, t, n) {
  switch (n) {
    case "COMPARISON_EQUALITY":
      return e === t;
    case "COMPARISON_LARGER_EQUAL":
      return e >= t;
    case "COMPARISON_SMALLER_EQUAL":
      return e <= t;
  }
}
function Yye(e) {
  const t = Ro(e).map(
    (n) => n.bfGroupId
  );
  return [...new Set(t)].filter((n) => wt(n));
}
function Po(e, t, n) {
  n.push({
    message: e,
    affectedCells: t
  });
}
function Qye(e, t, n) {
  return e.current.getAllRowIds().filter((r) => !e.current.getRow(r).isSumRow).forEach((r) => {
    gi(r, t, n, "position", "percentage");
  });
}
function Xye(e) {
  const t = Ro(
    e,
    (r) => r.isSumRow
  ), n = t.map(
    (r) => r.yearFrom
  );
  n.sort((r, o) => r - o);
  for (const r of t)
    if (r.yearFrom === n[0])
      return r;
}
function Jye(e, t) {
  return Ro(t).find(
    (n) => n.bfGroupId === e
  );
}
function Zye(e, t, n, r) {
  let o = 0;
  return t.current.getAllRowIds().forEach((a) => {
    t.current.getCellValue(a, "bfGroupId") && t.current.getCellValue(a, "bfGroupId") === e && (o += t.current.getCellValue(
      a,
      "amount"
    ), gi(a, r, n, "position"));
  }), o;
}
function gi(e, t, n, r, o) {
  o ? t.push({
    rowId: e,
    column: o,
    targetTable: r
  }) : t.push({
    rowId: e,
    column: n.quantityDetails.contractUnit === "ACREAGE" ? "acreage" : "amount",
    targetTable: r
  });
}
const mC = {
  amount: 1,
  reduce: 1,
  min: 1,
  max: 1,
  percentage: 2,
  price: 2,
  acreage: 2
}, eve = oe(Ea)(({ theme: e }) => ({
  width: "100%",
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none"
  },
  "&.validationWarning": {
    border: `2px solid ${e.palette.warning.main} !important`,
    width: "calc(100% - 4px)",
    height: "calc(100% - 4px)"
  },
  "&.validationError": {
    border: `2px solid ${e.palette.error.main} !important`,
    width: "calc(100% - 4px)",
    height: "calc(100% - 4px)"
  }
})), tve = Ta("DataGridNumberCell");
function nve(e, t) {
  if (lo(t) && !e)
    return;
  const n = /* @__PURE__ */ w.jsxs(_t, { display: "flex", flexDirection: "row", alignItems: "center", gap: "4px", children: [
    e ? /* @__PURE__ */ w.jsx(pbe, { color: "warning" }) : null,
    wt(t) ? t : null
  ] });
  return {
    endAdornment: /* @__PURE__ */ w.jsx(bl, { position: "end", children: n })
  };
}
function rve(e) {
  let t;
  return e in mC ? t = mC[e] : (tve.warn(
    `Decimal places not configured for ${e}. Continue with default`,
    e
  ), t = 2), {
    minimumFractionDigits: t,
    maximumFractionDigits: t,
    useThousandsSeparator: !1
  };
}
function ove(e) {
  return e.replace(/^(?!0(,|$))0+/, "");
}
function ive(e) {
  return Qb(e, { maximumFractionDigits: 100 });
}
function K$(e, t) {
  return Or(e, rve(t));
}
function d_(e, t) {
  return wt(e) ? K$(e, t) : "";
}
function sve({
  column: e,
  params: t,
  contract: n,
  onChangeCell: r,
  toolTipText: o,
  getErrorMessages: i,
  getWarningMessages: a,
  doAfterFocused: l
}) {
  var C;
  const [c, d] = Jt(!1), [f, p] = Jt(
    d_(t.value, t.field)
  );
  ir(() => {
    c || p(d_(t.value, t.field));
  }, [t.value, t.field, c]);
  const g = (C = e.getCellUnit) == null ? void 0 : C.call(e, {
    contract: n,
    gridCellParams: t
  });
  function b() {
    const D = t.api.getCellValue(
      t.id,
      t.field
    );
    p(K$(D, t.field)), t.api.setEditCellValue({
      id: t.id,
      field: t.field,
      value: D
    });
  }
  function v(D) {
    const L = hi(
      D,
      mC[t.field]
    );
    t.api.updateRows([
      {
        id: t.id,
        [t.field]: L
      }
    ]), t.api.setEditCellValue({
      id: t.id,
      field: t.field,
      value: L
    }), r && r(L, t.row, n), t.api.publishEvent("rowsSet");
  }
  function y(D) {
    return hS(D, 100) && lN(D);
  }
  function S(D) {
    const L = D.target.value === "" ? "0" : ove(D.target.value);
    if (p(L), y(L)) {
      const B = ive(L);
      v(B);
    }
  }
  function E() {
    d(!1), y(f === "" ? "0" : f) || b();
  }
  function I() {
    p((D) => D.replaceAll(/\s+/g, "")), d(!0), l();
  }
  function O(D) {
    return D.length > 1 ? P(D) : /* @__PURE__ */ w.jsx(Vg, { children: D[0] });
  }
  function T() {
    const D = i(), L = a();
    if (D.length > 0 && t.isEditable)
      return O(D);
    if (L.length > 0 && t.isEditable)
      return O(L);
    if (o)
      return /* @__PURE__ */ w.jsx(Vg, { children: o });
  }
  function P(D) {
    return /* @__PURE__ */ w.jsx(
      Wp,
      {
        sx: {
          listStyleType: "disc",
          pt: 0,
          bp: 0,
          pr: 0,
          pl: 2
        },
        children: D.map((L) => /* @__PURE__ */ w.jsx(
          bb,
          {
            sx: { display: "list-item", pl: 0, pr: 0 },
            children: /* @__PURE__ */ w.jsx(Vg, { children: L })
          },
          L
        ))
      }
    );
  }
  function R() {
    return i().length > 0 && t.isEditable ? "error" : a().length > 0 && t.isEditable ? "warning" : "default";
  }
  function F(D) {
    return D === "error" && t.isEditable ? "validationError" : D === "warning" && t.isEditable ? "validationWarning" : "";
  }
  const A = R(), _ = T();
  return /* @__PURE__ */ w.jsx(
    sh,
    {
      title: _,
      "data-test-has-tooltip": _ !== void 0,
      flavor: A,
      children: /* @__PURE__ */ w.jsx(
        eve,
        {
          value: f,
          slotProps: {
            input: {
              ...nve(A === "warning", g),
              sx: {
                margin: A !== "default" && t.isEditable ? "-2px" : void 0
              }
            }
          },
          onChange: S,
          disabled: !t.isEditable,
          onBlur: E,
          onFocus: I,
          className: F(A)
        }
      )
    }
  );
}
const ave = oe(_t)(({ theme: e }) => ({
  padding: e.spacing(0, 1),
  border: "2px solid transparent",
  "&.validationError": {
    border: `2px solid ${e.palette.error.main} !important`,
    height: "calc(100% - 4px)"
  }
}));
function lve({
  params: e,
  fieldName: t,
  label: n,
  getErrorMessage: r,
  doAfterChecked: o
}) {
  const [i, a] = Jt(
    e.api.getCellValue(e.id, t) ?? !1
  );
  async function l(d) {
    a(d.target.checked), e.api.updateRows([
      { id: e.id, [t]: d.target.checked }
    ]);
  }
  const c = r();
  return /* @__PURE__ */ w.jsx(
    sh,
    {
      title: c ? /* @__PURE__ */ w.jsx(Vg, { children: r() }) : "",
      "data-test-has-tooltip": !!c,
      flavor: "error",
      children: /* @__PURE__ */ w.jsx(
        ave,
        {
          className: c && "validationError",
          "data-testid": "checkbox-border",
          children: /* @__PURE__ */ w.jsx(
            dp,
            {
              control: /* @__PURE__ */ w.jsx(
                hb,
                {
                  onChange: (d) => {
                    l(d).then(() => o());
                  },
                  checked: i
                }
              ),
              label: n
            }
          )
        }
      )
    }
  );
}
const cve = oe(
  (e) => /* @__PURE__ */ w.jsx(Yre, { ...e })
)(({ theme: e, bordercolor: t }) => ({
  marginTop: e.spacing(1),
  border: `2px solid ${t} !important`
}));
function f_(e) {
  const { t } = jn(), n = bo(), r = dx(n.breakpoints.down("md"));
  function o(d) {
    return d.filter((f) => f.targetTable === e.targetTable).reduce(
      (f, p) => (f[p.rowId] || (f[p.rowId] = []), f[p.rowId].push(p.column), f),
      {}
    );
  }
  function i(d, f) {
    const p = e.targetTable === "quantity" ? e.quantitiesGridApi.current.getRow(d) : e.positionsGridApi.current.getRow(d);
    if (p) {
      const g = f.map((y) => e.columns.find((S) => S.field === y)).filter((y) => {
        var S;
        return ((S = y == null ? void 0 : y.getCellState) == null ? void 0 : S.call(
          y,
          e.contract,
          e.targetTable === "quantity" ? e.quantitiesGridApi.current.getCellParams(
            d,
            y.field
          ) : e.positionsGridApi.current.getCellParams(
            d,
            y.field
          ),
          e.quantitiesGridApi,
          e.positionsGridApi
        )) === "EDITABLE";
      }).map((y) => e.contract.texts.safeGet(y.headerNameTextKey, t)).filter((y) => y), b = "position" in p ? p.position : p.title, v = g.length > 0 ? `: ${g.join(", ")}` : "";
      return `${b}${v}`;
    }
  }
  function a(d) {
    const f = o(d);
    return /* @__PURE__ */ w.jsx(Wp, { sx: { listStyleType: "disc", pl: 2, py: 0.5 }, children: Object.entries(f).map(([p, g]) => /* @__PURE__ */ w.jsx(
      bb,
      {
        sx: { display: "list-item", px: 0, pt: 0, pb: 0.3 },
        children: /* @__PURE__ */ w.jsx(Rt, { children: i(p, g) })
      },
      p
    )) });
  }
  function l(d, f) {
    return /* @__PURE__ */ w.jsxs(
      $r,
      {
        "data-testid": "validation-summary-entry",
        children: [
          /* @__PURE__ */ w.jsx(Rt, { variant: "body2", "data-testid": "validation-summary-message", children: d.message }),
          a(d.affectedCells)
        ]
      },
      d.message + "-" + f
    );
  }
  const c = e.validationOutput.filter(
    (d) => d.affectedCells.some(
      (f) => f.targetTable === e.targetTable
    )
  );
  return c.length > 0 && /* @__PURE__ */ w.jsxs(
    cve,
    {
      "data-testid": "validation-summary",
      bordercolor: e.borderColor,
      disableGutters: !0,
      children: [
        !r && /* @__PURE__ */ w.jsx(YC, { expandIcon: /* @__PURE__ */ w.jsx(fbe, {}), children: /* @__PURE__ */ w.jsx(Rt, { variant: "h4", children: e.title }) }),
        /* @__PURE__ */ w.jsx(KC, { children: /* @__PURE__ */ w.jsx($r, { spacing: 1, children: c.map((d, f) => l(d, f)) }) })
      ]
    }
  );
}
const uve = oe(C$)(() => ({
  height: "fit-content",
  "& .editable": {
    backgroundColor: "white"
  },
  "& .hidden": {
    visibility: "hidden"
  },
  "& .MuiDataGrid-cell.MuiDataGrid-cell--editing, .removePadding": {
    padding: 0
  },
  "& .MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: "black"
  }
}));
function dve(e) {
  return /* @__PURE__ */ w.jsx(Rt, { variant: "h4", children: e.colDef.headerName });
}
const fve = Ta("QuantitiesOrDistributionDataGrid");
function bC(e, t) {
  var n;
  return ((n = e == null ? void 0 : e.current) == null ? void 0 : n.filter((r) => r.affectedCells.some((o) => o.rowId === t.id && o.column == t.field)).map((r) => r.message)) || [];
}
function pve(e, t, n, r, o, i) {
  return /* @__PURE__ */ w.jsx(
    sve,
    {
      column: e,
      params: n,
      contract: t.contract,
      errorMessage: n.errorMessage,
      onChangeCell: wt(e.onChangeCell) ? (a, l, c) => e.onChangeCell(
        a,
        l,
        c,
        t.quantitiesGridApi,
        t.positionsGridApi
      ) : void 0,
      toolTipText: wt(e.getToolTipText) ? e.getToolTipText(n, t.positionsGridApi, i) : void 0,
      getErrorMessages: () => bC(r, n),
      getWarningMessages: () => bC(o, n),
      doAfterFocused: () => {
        t.doAfterNumberCellFocused(), Kf(
          t.quantitiesGridApi.current,
          t.positionsGridApi.current
        );
      }
    }
  );
}
function hve(e, t, n, r, o) {
  return (i) => {
    var l;
    const a = (l = e.getRenderInstruction) == null ? void 0 : l.call(e, {
      contract: t.contract,
      gridCellParams: i
    });
    switch (a == null ? void 0 : a.type) {
      case "number":
        return pve(
          e,
          t,
          i,
          n,
          r,
          o
        );
      case "text":
        return /* @__PURE__ */ w.jsx(_t, { children: i.value });
      case "checkbox":
        return /* @__PURE__ */ w.jsx(
          lve,
          {
            params: i,
            fieldName: a.targetField,
            label: a.label,
            getErrorMessage: () => bC(n, i)[0],
            doAfterChecked: () => {
              t.doAfterNumberCellFocused(), Kf(
                t.quantitiesGridApi.current,
                t.positionsGridApi.current
              );
            }
          }
        );
      case "link":
        return /* @__PURE__ */ w.jsx(A$, { label: i.value, url: a.url });
      default:
        return /* @__PURE__ */ w.jsx(_t, { children: i.value });
    }
  };
}
function p_(e) {
  const { t } = jn(), n = bo(), r = ho([]), o = ho([]), i = ho(c(e, t));
  ir(() => {
    r.current = e.validationErrors;
  }, [e.validationErrors]), ir(() => {
    o.current = e.validationWarnings;
  }, [e.validationWarnings]);
  function a() {
    return (f) => {
      if (e.isReadonly)
        return !1;
      const p = e.columns.find((g) => g.field == f.colDef.field);
      return p != null && p.getCellState ? p.getCellState(
        e.contract,
        f,
        e.quantitiesGridApi,
        e.positionsGridApi
      ) === "EDITABLE" : !1;
    };
  }
  function l() {
    return (f) => {
      var b;
      const p = e.columns.find((v) => v.field == f.colDef.field);
      let g = "";
      if (p != null && p.getCellState)
        switch (p.getCellState(
          e.contract,
          f,
          e.quantitiesGridApi,
          e.positionsGridApi
        )) {
          case "EDITABLE":
            g = e.isReadonly ? "readonly" : "editable";
            break;
          case "READONLY":
            g = "readonly";
            break;
          case "HIDDEN":
            g = "hidden";
            break;
          default:
            g = "readonly";
            break;
        }
      return (b = p == null ? void 0 : p.getRenderInstruction) != null && b.call(p, {
        contract: e.contract,
        gridCellParams: f
      }).removePadding && (g += " removePadding"), g;
    };
  }
  function c(f, p) {
    return f.columns.filter((g) => !(g.hiddenInReadonly && f.isReadonly) && (!g.showColumn || g.showColumn(f.contract))).map((g) => {
      const b = hve(
        g,
        f,
        r,
        o,
        p
      );
      return {
        field: g.field,
        headerName: f.contract.texts.safeGet(g.headerNameTextKey, p),
        renderHeader: dve,
        editable: !0,
        type: g.columnType,
        align: "left",
        headerAlign: "left",
        renderCell: b,
        renderEditCell: b
      };
    });
  }
  function d(f) {
    fve.error("DataGrid Error", f);
  }
  return /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
    /* @__PURE__ */ w.jsx(
      uve,
      {
        apiRef: e.ownApi,
        columns: i.current,
        rows: e.rows,
        isCellEditable: a(),
        getCellClassName: l(),
        hideFooter: !0,
        disableColumnSorting: !0,
        disableColumnMenu: !0,
        disableAutosize: !1,
        autosizeOnMount: !0,
        autosizeOptions: {
          includeHeaders: !0,
          includeOutliers: !0,
          expand: !0
        },
        onProcessRowUpdateError: d
      }
    ),
    e.validationErrors.length > 0 ? /* @__PURE__ */ w.jsx(
      f_,
      {
        title: t("contracts:contractWizard.validationSummary.errorsTitle"),
        borderColor: n.palette.error.main,
        validationOutput: e.validationErrors,
        targetTable: e.ownApi === e.quantitiesGridApi ? "quantity" : "position",
        columns: e.columns,
        quantitiesGridApi: e.quantitiesGridApi,
        positionsGridApi: e.positionsGridApi,
        contract: e.contract
      }
    ) : /* @__PURE__ */ w.jsx(_t, { sx: { height: 60 } }),
    /* @__PURE__ */ w.jsx(
      f_,
      {
        title: t("contracts:contractWizard.validationSummary.warningsTitle"),
        borderColor: n.palette.warning.main,
        validationOutput: e.validationWarnings,
        targetTable: e.ownApi === e.quantitiesGridApi ? "quantity" : "position",
        columns: e.columns,
        quantitiesGridApi: e.quantitiesGridApi,
        positionsGridApi: e.positionsGridApi,
        contract: e.contract
      }
    )
  ] });
}
function gve(e) {
  return e.quantityDetails.quantities.map((t) => ({
    id: zs(t),
    title: t.bfName,
    amount: t.totalAcreage > 0 ? t.totalAcreage * t.fiveYearsYield : t.amount,
    acreage: t.totalAcreage,
    blocked: t.blockedQuantity,
    reduce: t.reducedAmount,
    min: t.minAmount,
    max: t.maxAmount,
    bfGroup: t.bfName,
    bfGroupId: t.bfGroupId,
    amountForInput: t.amountForInput,
    reduceForInput: t.reduceForInput,
    inputIfNoReduceAt: t.inputIfNoReduceAt,
    fiveYearsYield: t.fiveYearsYield
  }));
}
function mve(e, t, n, r, o) {
  const i = Ro(
    r,
    (l) => l.bfGroupId === t.bfGroupId
  ), a = Ro(
    o,
    (l) => l.bfGroupId === t.bfGroupId
  );
  i.some((l) => l.amount > 0) ? a.length == 1 && o.current.updateRows([
    {
      id: a[0].id,
      amount: e
    }
  ]) : a.forEach((l) => {
    o.current.updateRows([
      { id: l.id, amount: 0, percentage: 0 }
    ]);
  }), n.quantityDetails.positionDistributionUnit === "PERCENT" && Ybe(r, o), $c(o);
}
function bve(e, t, n, r, o) {
  r.current.updateRows([
    {
      id: t.id,
      amount: e * t.fiveYearsYield
    }
  ]);
  const i = Ro(r).find(
    (l) => l.acreage != 0
  ), a = Ro(
    o,
    (l) => l.bfGroupId === t.bfGroupId
  );
  if (!i)
    a.forEach((l) => {
      o.current.updateRows([
        { id: l == null ? void 0 : l.id, amount: 0, acreage: 0 }
      ]);
    });
  else if (a.length == 1) {
    const l = n.quantityDetails.quantities.find(
      (c) => c.bfGroupId == t.bfGroupId
    );
    o.current.updateRows([
      {
        id: a[0].id,
        acreage: e,
        amount: e * l.fiveYearsYield
      }
    ]);
  }
  $c(o);
}
function yve(e, t, n) {
  return Y$(
    e,
    t,
    n
  ) ? "READONLY" : t.row.amountForInput ?? "READONLY";
}
function vve(e, t, n) {
  const r = e.quantityDetails.quantities.find(
    (o) => o.inputIfNoReduceAt === t.row.bfGroupId
  );
  if (wt(r)) {
    const o = zs(r);
    if (n && n.current.getCellValue(
      o,
      e.quantityDetails.contractUnit === "WEIGHT" ? "amount" : "acreage"
    ) > 0)
      return "READONLY";
  }
  return t.row.reduceForInput ?? "READONLY";
}
function wve(e, t, n) {
  return Y$(
    e,
    t,
    n
  ) ? "READONLY" : Q$(e) ? "EDITABLE" : "HIDDEN";
}
function Y$(e, t, n) {
  if (!Al(t.row.inputIfNoReduceAt)) {
    const r = e.quantityDetails.quantities.find(
      (o) => o.bfGroupId === t.row.inputIfNoReduceAt
    );
    if (wt(r)) {
      const o = zs(r);
      if (n.current.getCellValue(
        o,
        "reduce"
      ) > 0)
        return !0;
    }
  }
  return !1;
}
function Cve(e) {
  return e.quantityDetails.contractUnit !== "ACREAGE" && e.quantityDetails.quantities.some((t) => t.amountForInput !== "HIDDEN" || t.reducedAmount > 0);
}
function Q$(e) {
  return e.quantityDetails.contractUnit === "ACREAGE";
}
function xve(e) {
  return e.quantityDetails.quantities.some((t) => t.showBlockedQuantity && t.blockedQuantity > 0);
}
function Sve(e) {
  return e.quantityDetails.quantities.some((t) => t.reduceForInput != "HIDDEN");
}
function Eve(e) {
  return e.quantityDetails.quantities.some((t) => t.minAmount != 0);
}
function Tve(e) {
  return e.quantityDetails.quantities.some((t) => t.maxAmount != 0);
}
const X$ = "amount", J$ = "acreage", Z$ = "blocked", eL = "reduce", tL = "min", nL = "max", Ove = [
  {
    field: "title",
    headerNameTextKey: "BFGRP_NAME"
  },
  {
    field: X$,
    headerNameTextKey: "AMOUNT",
    onChangeCell: mve,
    getCellState: yve,
    showColumn: Cve,
    columnType: "number",
    getRenderInstruction: fa
  },
  {
    field: J$,
    headerNameTextKey: "TOTACREAGE",
    onChangeCell: bve,
    getCellState: wve,
    showColumn: Q$,
    columnType: "number",
    getRenderInstruction: fa
  },
  {
    field: Z$,
    headerNameTextKey: "BLOCKED",
    showColumn: xve,
    columnType: "number",
    getRenderInstruction: fa
  },
  {
    field: eL,
    headerNameTextKey: "REDUCE",
    getCellState: vve,
    showColumn: Sve,
    columnType: "number",
    getRenderInstruction: fa
  },
  {
    field: tL,
    headerNameTextKey: "MIN",
    showColumn: Eve,
    columnType: "number",
    getRenderInstruction: fa
  },
  {
    field: nL,
    headerNameTextKey: "MAX",
    showColumn: Tve,
    columnType: "number",
    getRenderInstruction: fa
  }
], h_ = Ta("WizardPageQuantitiesAndDistribution");
function Pve(e, t, n) {
  const r = e.values.contract.quantityDetails;
  function o(l, c) {
    return t.current.getCellValue(
      zs(l),
      c
    );
  }
  function i(l, c) {
    return n.current.getCellValue(
      l.positionNumber,
      c
    );
  }
  const a = {
    ...r,
    quantities: r.quantities.map((l) => ({
      ...l,
      amount: o(l, X$),
      totalAcreage: o(l, J$),
      blocked: o(l, Z$),
      reducedAmount: o(l, eL),
      minAmount: o(l, tL),
      maxAmount: o(l, nL)
    })),
    positions: r.positions.map((l) => ({
      ...l,
      percentage: i(l, $$),
      amount: i(l, L$),
      acreage: i(l, j$),
      price: i(l, B$),
      information: i(
        l,
        V$
      ),
      informationWasConfirmed: i(
        l,
        H$
      )
    }))
  };
  return {
    ...e.values.contract,
    quantityDetails: a
  };
}
function g_(e) {
  const t = WS(), { t: n } = jn(), [r, o] = Jt(!1), [i, a] = Jt(!1), [l, c] = Jt([]), [d, f] = Jt([]), [p, g] = Jt(0), b = ho(jI().current), v = ho(jI().current), y = ho(gve(e.values.contract)), S = ho($be(e.values.contract, n)), [E, I] = Jt(
    []
  ), [O, T] = Jt([]);
  function P() {
    return {
      ...t.values,
      contract: Pve(t, b, v)
    };
  }
  function R() {
    if (g(p + 1), !e.isReadonly) {
      const D = Fye(
        b,
        v,
        e.values.contract,
        n
      );
      I(D.errors), T(D.warnings), Kf(b.current, v.current);
      const L = document.getElementsByClassName("Mui-error").length, B = D.errors.length, H = D.warnings.length;
      if (B + L > 0) {
        g(0), h_.warn("There is at least one invalid input");
        return;
      }
      if (H > 0) {
        h_.warn("There is at least one warning"), p > 0 && (c(
          D.warnings.map((k) => k.message)
        ), o(!0));
        return;
      }
    }
    t.completeStep(P());
  }
  function F() {
    return !e.isReadonly && e.values.contract.country === "DE" && e.values.contract.companyCode === "1000" && e.values.contract.quantityDetails.positions.some(
      (D) => D.maxPercentage > 0
    );
  }
  const A = e.values.contract.texts.safeGet(
    "BUTTON3",
    n
  );
  function _() {
    I([]), T([]);
  }
  function C() {
    let D = [];
    W$(b, e.values.contract, D, n), D.length > 0 ? (f(D.map((L) => L.message)), a(!0)) : (dye(b, v), _(), Kf(b.current, v.current));
  }
  return /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
    /* @__PURE__ */ w.jsx(
      Tp,
      {
        open: r,
        titleText: n("contracts:contractWizard.warningDialog.title"),
        explanationText: n(
          "contracts:contractWizard.warningDialog.explanationText"
        ),
        informationText: l,
        primaryAction: {
          text: e.values.contract.texts.safeGet("BUTTON1", n),
          color: "primary",
          onClick: () => {
            t.completeStep(P());
          }
        },
        secondaryAction: {
          text: A,
          color: "primary",
          onClick: () => {
            o(!1);
          }
        }
      }
    ),
    /* @__PURE__ */ w.jsx(
      Tp,
      {
        open: i,
        titleText: n("contracts:contractWizard.distributeErrorDialog.title"),
        informationText: d,
        secondaryAction: {
          text: n("contracts:contractWizard.distributeErrorDialog.ok"),
          color: "primary",
          onClick: () => {
            a(!1);
          }
        }
      }
    ),
    /* @__PURE__ */ w.jsxs(_t, { sx: { height: "100%" }, children: [
      /* @__PURE__ */ w.jsx(
        fye,
        {
          contract: t.values.contract,
          isReadonly: e.isReadonly,
          quantitiesGridApi: b,
          afterClick: () => {
            _(), Kf(b.current, v.current);
          }
        }
      ),
      /* @__PURE__ */ w.jsx(
        p_,
        {
          ownApi: b,
          quantitiesGridApi: b,
          positionsGridApi: v,
          columns: Ove,
          contract: e.values.contract,
          rows: y.current,
          isReadonly: e.isReadonly,
          validationErrors: E,
          validationWarnings: O,
          doAfterNumberCellFocused: () => {
            _();
          }
        }
      ),
      /* @__PURE__ */ w.jsx(
        Rt,
        {
          variant: "h4",
          sx: { mt: 3, mb: 2 },
          "data-testid": "wizard-positions-title",
          children: e.values.contract.texts.safeGet(
            e.isReadonly ? "POS_OVWZF" : "POSI_OVW",
            n
          )
        }
      ),
      F() && /* @__PURE__ */ w.jsx(
        vm,
        {
          variant: "outlined",
          sx: { mb: 2 },
          onClick: () => {
            C();
          },
          "data-testid": "distribute-button",
          children: n("contracts:contractWizard.distributeQuantities")
        }
      ),
      /* @__PURE__ */ w.jsx(
        p_,
        {
          ownApi: v,
          quantitiesGridApi: b,
          positionsGridApi: v,
          columns: aye,
          contract: e.values.contract,
          rows: S.current,
          isReadonly: e.isReadonly,
          validationErrors: E,
          validationWarnings: O,
          doAfterNumberCellFocused: () => {
            _();
          }
        }
      ),
      /* @__PURE__ */ w.jsx(
        GS,
        {
          primaryActionLabel: e.continueButtonLabel,
          secondaryActionLabel: A,
          showMandatoryFieldsHint: !1,
          onPrimaryActionClicked: R,
          onSecondaryActionClicked: () => {
            t.goBack(P());
          }
        }
      )
    ] })
  ] });
}
function Ive(e) {
  const {
    name: t,
    control: n,
    rules: r,
    label: o,
    helperText: i,
    getOptions: a,
    setCurrentFilter: l,
    onOpen: c,
    showLoading: d,
    textFieldOptions: f,
    noSelectionAndOptionsLabel: p,
    hint: g,
    hintPlacement: b,
    ...v
  } = e, { field: y, register: S } = Zb({
    name: t,
    control: n,
    rules: r,
    label: o,
    helperText: i
  }), { t: E } = jn(), I = " ", O = E("form:select.default"), T = p ?? E("form:select.noOptionsAvailable"), P = E("form:select.unresolvable"), R = [...a ? a.keys() : [], ""];
  return /* @__PURE__ */ w.jsx(Yb, { hint: g, hintPlacement: b, children: /* @__PURE__ */ w.jsx(
    zp,
    {
      ...v,
      onInputChange: (F, A, _) => {
        wt(l) && A !== I && _ !== "blur" && _ !== "selectOption" && (A.startsWith(P) || A === "" || _ === "reset" ? l(void 0) : l(A));
      },
      filterOptions: hse,
      selectOnFocus: !0,
      blurOnSelect: !0,
      fullWidth: !0,
      value: y.value,
      options: R,
      getOptionLabel: (F) => d ? I : Al(F) ? a && a.size > 0 ? O : T : (a ? a.get(F) : void 0) ?? P + F,
      isOptionEqualToValue: wt(e.isOptionEqualToValue) ? e.isOptionEqualToValue : (F, A) => F === A,
      disabled: e.disabled,
      renderInput: (F) => /* @__PURE__ */ w.jsx(
        Ea,
        {
          variant: "filled",
          ...F,
          ...S(),
          required: e.required,
          slotProps: {
            input: {
              ...F.InputProps,
              endAdornment: /* @__PURE__ */ w.jsx(I$, { loading: d ?? !1, children: F.InputProps.endAdornment }),
              style: { backgroundColor: "white" },
              disableUnderline: !0
            }
          }
        }
      ),
      onChange: (F, A, _) => _ === "clear" ? y.onChange("") : y.onChange(A),
      onReset: () => y.onChange(null),
      onBlur: y.onBlur,
      ...f,
      onOpen: () => {
        wt(c) && c();
      }
    }
  ) });
}
const Rve = oe(_t)(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(2),
  flexDirection: "column",
  width: "100%"
})), _ve = Ta("WizardStepForm");
function kve(e) {
  var l;
  const t = Li(
    yy
  ), n = Ax(t);
  function r(c, d) {
    return { ...d, ...c };
  }
  async function o(c) {
    const d = wt(e.modifySubmitValues) ? await e.modifySubmitValues(c) : c;
    n.completeStep(r(d, n.values));
  }
  function i(c) {
    _ve.error("Invalid step submitted", c);
  }
  function a(c) {
    c.key === "Enter" && c.preventDefault();
  }
  return /* @__PURE__ */ w.jsxs(
    "form",
    {
      noValidate: !0,
      autoComplete: "off",
      onSubmit: e.handleSubmit(o, i),
      onKeyDown: a,
      "aria-label": "wizard step",
      children: [
        /* @__PURE__ */ w.jsx(Rve, { children: e.children }),
        /* @__PURE__ */ w.jsx(
          GS,
          {
            ...e.buttonBarConfig,
            onSecondaryActionClicked: () => {
              n.goBack(r(e.getFormValues(), n.values));
            },
            showMandatoryFieldsHint: !0,
            children: (l = e.buttonBarConfig) == null ? void 0 : l.additionalContent
          }
        )
      ]
    }
  );
}
const Mve = oe($r)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: e.spacing(2),
  width: "100%"
})), Ave = oe(_t)(() => ({
  body: "flex",
  alignItems: "flex-start",
  width: "50px"
})), Dve = oe(_t)(({ theme: e }) => ({
  display: "flex",
  alignItems: "flex-end",
  width: "100%",
  padding: e.spacing(1, 0)
})), Nve = oe(_t)(() => ({
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "center",
  width: "400px"
}));
function Fve(e) {
  return /* @__PURE__ */ w.jsxs(Mve, { "data-testid": "question-row", children: [
    /* @__PURE__ */ w.jsx(Ave, { children: /* @__PURE__ */ w.jsx(Rt, { variant: "h4", children: e.number + "." }) }),
    /* @__PURE__ */ w.jsx(Dve, { "data-testid": "question", children: /* @__PURE__ */ w.jsx(Rt, { children: e.question }) }),
    /* @__PURE__ */ w.jsx(Nve, { children: e.answerSection })
  ] });
}
const $ve = oe(_t)(({ theme: e }) => ({
  width: "100%",
  alignSelf: "center",
  [e.breakpoints.up("sm")]: {
    width: "85%"
  },
  [e.breakpoints.up("md")]: {
    width: "70%"
  }
})), Vw = oe(_t)(() => ({
  marginBottom: "-8px",
  marginTop: "16px",
  width: "100%"
})), Lve = oe(_t)(() => ({
  display: "flex",
  // makes up for the padding the checkbox has as default for its label
  paddingLeft: "21.5px",
  justifyContent: "center",
  width: "100%"
}));
function jve(e, t) {
  return {
    contract: {
      ...e.values.contract,
      questions: e.values.contract.questions.map((n, r) => ({ ...n, answer: t[r].answer.toString() }))
    }
  };
}
function Bve(e) {
  const t = WS(), { t: n } = jn();
  async function r(b) {
    return {
      values: b,
      errors: {}
    };
  }
  const { registerField: o, handleSubmit: i, getValues: a } = ey({
    values: {
      questions: Xb(t.values.contract.questions)
    },
    resolver: e.isReadonly ? r : void 0
  }), l = {
    required: e.values.contract.texts.safeGet("EM_CQ", n, !0)
  }, c = {
    validate: {
      number: (b) => aN(b, n)
    }
  }, d = {
    ...c,
    ...l
  }, f = k$(
    t.values.contract.questions,
    t.values.contract.quantityDetails
  ), p = f.map((b, v) => {
    const y = "questionItems" + b.id, S = b;
    function E() {
      switch (S.type) {
        case "INFO":
          return null;
        case "FREETEXT":
          return /* @__PURE__ */ w.jsx(Vw, { children: /* @__PURE__ */ w.jsx(
            hC,
            {
              ...o(
                `questions.${v}.answer`,
                S.mandatory ? l : void 0
              ),
              label: e.values.contract.texts.safeGet("ANSWER", n, !0),
              required: S.mandatory,
              unit: S.unit,
              textFieldOptions: { size: "small" },
              disabled: e.isReadonly
            }
          ) });
        case "NUMERIC":
          return /* @__PURE__ */ w.jsx(Vw, { children: /* @__PURE__ */ w.jsx(
            Bu,
            {
              ...o(
                `questions.${v}.answer`,
                S.mandatory ? d : c
              ),
              label: e.values.contract.texts.safeGet("ANSWER", n, !0),
              required: S.mandatory,
              inputMode: "decimal",
              maximumFractionDigits: 2,
              unit: S.unit,
              textFieldOptions: { size: "small" },
              disabled: e.isReadonly
            }
          ) });
        case "CHECKBOX":
          return /* @__PURE__ */ w.jsx(Lve, { children: /* @__PURE__ */ w.jsx(
            M$,
            {
              ...o(`questions.${v}.answer`),
              disabled: e.isReadonly
            }
          ) });
        case "DROPDOWN":
          return /* @__PURE__ */ w.jsx(Vw, { children: e.isReadonly ? /* @__PURE__ */ w.jsx(
            hC,
            {
              ...o(
                `questions.${v}.answer`,
                S.mandatory ? l : void 0
              ),
              label: e.values.contract.texts.safeGet("ANSWER", n, !0),
              required: S.mandatory,
              unit: S.unit,
              textFieldOptions: { size: "small" },
              disabled: !0
            }
          ) : /* @__PURE__ */ w.jsx(
            Ive,
            {
              ...o(
                `questions.${v}.answer`,
                S.mandatory ? l : void 0
              ),
              label: e.values.contract.texts.safeGet("ANSWER", n, !0),
              required: S.mandatory,
              getOptions: S.answerOptions,
              textFieldOptions: { size: "small" },
              disabled: e.isReadonly
            }
          ) });
        default:
          throw Error(
            `Error: Questions of type ${S.type} are not supported!"`
          );
      }
    }
    return /* @__PURE__ */ w.jsx(
      Fve,
      {
        number: b.id,
        question: b.question,
        answerSection: E()
      },
      y
    );
  }), g = f.some(
    (b) => b.mandatory
  );
  return /* @__PURE__ */ w.jsx(
    kve,
    {
      getFormValues: a,
      handleSubmit: i,
      modifySubmitValues: (b) => jve(t, b.questions),
      buttonBarConfig: {
        primaryActionLabel: e.continueButtonLabel,
        secondaryActionLabel: e.values.contract.texts.safeGet(
          "BUTTON3",
          n,
          !0
        ),
        mandatoryFieldsHintText: g ? "* " + e.values.contract.texts.safeGet("EM_CQ", n) : ""
      },
      children: /* @__PURE__ */ w.jsx($ve, { children: p })
    }
  );
}
const Vve = oe(P$)(
  ({ theme: e }) => ({
    marginTop: e.spacing(2)
  })
), Hve = oe(_t)(({ theme: e }) => ({
  [e.breakpoints.up("md")]: {
    paddingTop: "80px"
  }
}));
function Uve(e, t, n) {
  return {
    contract: e,
    termsAccepted: !1,
    originalContractDefinition: t,
    mdwTransferredAt: n
  };
}
function m_(e) {
  return k$(e.contract.questions, e.contract.quantityDetails).length > 0;
}
function zve(e) {
  return e.companyCode === "1000" && e.quantityDetails.quantities.filter((t) => t.bfGroupId === "LA").some(
    (t) => t.amount > 0 && t.amount === t.reducedAmount
  ) ? (e.status = "REJECTED", e) : (e.status = "ACCEPTED", e);
}
const Gve = Ta("ContractWizard");
function b_(e) {
  var y, S, E;
  const { dataClient: t } = _d(), n = Ab(), { t: r, i18n: o } = jn(), { currentBusinessPartner: i } = rh(), { id: a } = Sbe(), l = Md(), c = ho(void 0), d = ho(!1), f = Db({
    refetchOnMount: "always",
    queryKey: [
      "contract",
      a,
      e.inViewMode,
      d.current
    ],
    queryFn: async () => await t.getContract(
      a,
      e.inViewMode || d.current
    ),
    enabled: wt(a)
  }), p = (S = (y = f.data) == null ? void 0 : y.contract) == null ? void 0 : S.contract.country;
  ir(() => {
    if (lo(p))
      return;
    const I = o.language, O = Obe(p);
    if (I !== O)
      return o.changeLanguage(O), () => {
        o.changeLanguage(I);
      };
  }, [p, o]), ir(() => {
    wt(c.current) && c.current !== (i == null ? void 0 : i.id) && l("/"), c.current = i == null ? void 0 : i.id;
  }, [i == null ? void 0 : i.id, l]);
  const [g, b] = Jt(!1);
  async function v() {
    await n.invalidateQueries({
      queryKey: ["contractHeaders"]
    }), await n.invalidateQueries({
      queryKey: ["contract", a]
    });
  }
  if (f.isSuccess && a) {
    const I = f.data.errors, O = f.data.contract, T = (E = f.data.contract) == null ? void 0 : E.contract.texts.safeGet("BUTTON1", r, !0);
    return /* @__PURE__ */ w.jsxs(iS, { title: "", children: [
      /* @__PURE__ */ w.jsx(
        Vve,
        {
          message: r("contracts:error.contractDefinitionInvalid"),
          errors: I
        }
      ),
      /* @__PURE__ */ w.jsx(
        Pbe,
        {
          open: g,
          closeModal: async () => {
            v(), b(!1), l("/");
          }
        }
      ),
      I.length === 0 && /* @__PURE__ */ w.jsx(Hve, { children: /* @__PURE__ */ w.jsx(
        xbe,
        {
          steps: [
            {
              component: (P) => Nbe({
                ...P,
                isReadonly: e.inViewMode ?? !1
              }),
              title: O.contract.texts.safeGet("HL_CC", r)
            },
            {
              component: (P) => g_({
                ...P,
                isReadonly: e.inViewMode ?? !1,
                continueButtonLabel: e.inViewMode && !m_(P.values) ? r("common:components.button.close") : T
              }),
              title: O.contract.texts.safeGet("HL_CD", r)
            },
            {
              component: (P) => Bve({
                ...P,
                isReadonly: e.inViewMode ?? !1,
                continueButtonLabel: e.inViewMode ? r("common:components.button.close") : T
              }),
              title: O.contract.texts.safeGet("HL_CQ", r),
              isNecessary: m_
            },
            {
              component: (P) => g_({
                ...P,
                isReadonly: !0,
                continueButtonLabel: P.values.contract.texts.safeGet(
                  "BUTTON4",
                  r,
                  !0
                )
              }),
              title: O.contract.texts.safeGet("HL_CS", r),
              isNecessary: () => !e.inViewMode
            }
          ],
          initialValues: Uve(
            f.data.contract.contract,
            f.data.contract.originalContractDefinition,
            f.data.contract.mdwTransferredAt
          ),
          options: { stepsClickable: !0 },
          mode: "CREATE",
          confirmDataLoss: !e.inViewMode,
          onSubmit: async (P) => {
            if (e.inViewMode)
              l("/");
            else
              try {
                const R = zve(
                  P.contract
                );
                await t.updateContract(
                  a,
                  R,
                  P.originalContractDefinition,
                  P.mdwTransferredAt
                ), d.current = !0, v(), l("/", {
                  state: {
                    showSuccess: !0,
                    successMessage: O.contract.texts.safeGet(
                      "PT_AP",
                      r,
                      !0
                    ),
                    successTitle: O.contract.texts.safeGet(
                      "HL_AP",
                      r,
                      !0
                    )
                  }
                });
              } catch (R) {
                Gve.warn("error updating contract", R), b(!0);
              }
          }
        }
      ) })
    ] });
  } else
    return /* @__PURE__ */ w.jsx(qx, { "data-testid": "loading-element" });
}
function Wve(e) {
  const n = /* @__PURE__ */ w.jsxs(zre, { children: [
    !1,
    /* @__PURE__ */ w.jsx(PI, {})
  ] });
  return Pie(
    Y0(
      /* @__PURE__ */ w.jsxs(Ga, { element: n, children: [
        /* @__PURE__ */ w.jsx(Ga, { path: "/", element: /* @__PURE__ */ w.jsx(dbe, {}) }),
        /* @__PURE__ */ w.jsx(Ga, { path: "wizard", element: /* @__PURE__ */ w.jsx(b_, {}) }),
        /* @__PURE__ */ w.jsx(Ga, { path: "view", element: /* @__PURE__ */ w.jsx(b_, { inViewMode: !0 }) }),
        /* @__PURE__ */ w.jsxs(
          Ga,
          {
            path: "acreageCalculator",
            element: /* @__PURE__ */ w.jsx(rse, { children: /* @__PURE__ */ w.jsx(PI, {}) }),
            children: [
              /* @__PURE__ */ w.jsx(Ga, { path: "assistant", element: /* @__PURE__ */ w.jsx(_me, {}) }),
              /* @__PURE__ */ w.jsx(Ga, { path: "planner", element: /* @__PURE__ */ w.jsx(Nme, {}) })
            ]
          }
        )
      ] })
    ),
    { basename: e }
  );
}
const qve = oe(_t)(() => ({
  display: "flex",
  flexDirection: "row",
  height: "100%",
  width: "100vw",
  alignItems: "flex-start"
}));
function Kve(e) {
  const t = Rx(), { t: n } = jn(), {
    currentBusinessPartner: r,
    businessPartnerQueryIsLoading: o,
    providedBusinessPartnerNumber: i
  } = rh();
  return t.session ? /* @__PURE__ */ w.jsx(qve, { "data-testid": `contracting-module-${wD}`, children: !o && lo(r) ? /* @__PURE__ */ w.jsx(
    Qre,
    {
      isBusinessPartnerNumberProvided: wt(
        i
      )
    }
  ) : /* @__PURE__ */ w.jsx(Die, { router: Wve(e.baseRouterPath) }) }) : t.isLoading || t.useSso ? /* @__PURE__ */ w.jsx(Kre, {}) : /* @__PURE__ */ w.jsx(CD, { children: /* @__PURE__ */ w.jsx(
    Ub,
    {
      heading: n("common:accessManagement.error.noSession.headline"),
      message: n("common:accessManagement.error.noSession.message")
    }
  ) });
}
function yC(e) {
  "@babel/helpers - typeof";
  return yC = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, yC(e);
}
function rL() {
  return typeof XMLHttpRequest == "function" || (typeof XMLHttpRequest > "u" ? "undefined" : yC(XMLHttpRequest)) === "object";
}
function Yve(e) {
  return !!e && typeof e.then == "function";
}
function Qve(e) {
  return Yve(e) ? e : Promise.resolve(e);
}
function Xve(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var vC = { exports: {} }, kg = { exports: {} }, y_;
function Jve() {
  return y_ || (y_ = 1, function(e, t) {
    var n = typeof globalThis < "u" && globalThis || typeof self < "u" && self || typeof Cr < "u" && Cr, r = function() {
      function i() {
        this.fetch = !1, this.DOMException = n.DOMException;
      }
      return i.prototype = n, new i();
    }();
    (function(i) {
      (function(a) {
        var l = typeof i < "u" && i || typeof self < "u" && self || typeof l < "u" && l, c = {
          searchParams: "URLSearchParams" in l,
          iterable: "Symbol" in l && "iterator" in Symbol,
          blob: "FileReader" in l && "Blob" in l && function() {
            try {
              return new Blob(), !0;
            } catch {
              return !1;
            }
          }(),
          formData: "FormData" in l,
          arrayBuffer: "ArrayBuffer" in l
        };
        function d(k) {
          return k && DataView.prototype.isPrototypeOf(k);
        }
        if (c.arrayBuffer)
          var f = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]"
          ], p = ArrayBuffer.isView || function(k) {
            return k && f.indexOf(Object.prototype.toString.call(k)) > -1;
          };
        function g(k) {
          if (typeof k != "string" && (k = String(k)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(k) || k === "")
            throw new TypeError('Invalid character in header field name: "' + k + '"');
          return k.toLowerCase();
        }
        function b(k) {
          return typeof k != "string" && (k = String(k)), k;
        }
        function v(k) {
          var N = {
            next: function() {
              var j = k.shift();
              return { done: j === void 0, value: j };
            }
          };
          return c.iterable && (N[Symbol.iterator] = function() {
            return N;
          }), N;
        }
        function y(k) {
          this.map = {}, k instanceof y ? k.forEach(function(N, j) {
            this.append(j, N);
          }, this) : Array.isArray(k) ? k.forEach(function(N) {
            this.append(N[0], N[1]);
          }, this) : k && Object.getOwnPropertyNames(k).forEach(function(N) {
            this.append(N, k[N]);
          }, this);
        }
        y.prototype.append = function(k, N) {
          k = g(k), N = b(N);
          var j = this.map[k];
          this.map[k] = j ? j + ", " + N : N;
        }, y.prototype.delete = function(k) {
          delete this.map[g(k)];
        }, y.prototype.get = function(k) {
          return k = g(k), this.has(k) ? this.map[k] : null;
        }, y.prototype.has = function(k) {
          return this.map.hasOwnProperty(g(k));
        }, y.prototype.set = function(k, N) {
          this.map[g(k)] = b(N);
        }, y.prototype.forEach = function(k, N) {
          for (var j in this.map)
            this.map.hasOwnProperty(j) && k.call(N, this.map[j], j, this);
        }, y.prototype.keys = function() {
          var k = [];
          return this.forEach(function(N, j) {
            k.push(j);
          }), v(k);
        }, y.prototype.values = function() {
          var k = [];
          return this.forEach(function(N) {
            k.push(N);
          }), v(k);
        }, y.prototype.entries = function() {
          var k = [];
          return this.forEach(function(N, j) {
            k.push([j, N]);
          }), v(k);
        }, c.iterable && (y.prototype[Symbol.iterator] = y.prototype.entries);
        function S(k) {
          if (k.bodyUsed)
            return Promise.reject(new TypeError("Already read"));
          k.bodyUsed = !0;
        }
        function E(k) {
          return new Promise(function(N, j) {
            k.onload = function() {
              N(k.result);
            }, k.onerror = function() {
              j(k.error);
            };
          });
        }
        function I(k) {
          var N = new FileReader(), j = E(N);
          return N.readAsArrayBuffer(k), j;
        }
        function O(k) {
          var N = new FileReader(), j = E(N);
          return N.readAsText(k), j;
        }
        function T(k) {
          for (var N = new Uint8Array(k), j = new Array(N.length), W = 0; W < N.length; W++)
            j[W] = String.fromCharCode(N[W]);
          return j.join("");
        }
        function P(k) {
          if (k.slice)
            return k.slice(0);
          var N = new Uint8Array(k.byteLength);
          return N.set(new Uint8Array(k)), N.buffer;
        }
        function R() {
          return this.bodyUsed = !1, this._initBody = function(k) {
            this.bodyUsed = this.bodyUsed, this._bodyInit = k, k ? typeof k == "string" ? this._bodyText = k : c.blob && Blob.prototype.isPrototypeOf(k) ? this._bodyBlob = k : c.formData && FormData.prototype.isPrototypeOf(k) ? this._bodyFormData = k : c.searchParams && URLSearchParams.prototype.isPrototypeOf(k) ? this._bodyText = k.toString() : c.arrayBuffer && c.blob && d(k) ? (this._bodyArrayBuffer = P(k.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : c.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(k) || p(k)) ? this._bodyArrayBuffer = P(k) : this._bodyText = k = Object.prototype.toString.call(k) : this._bodyText = "", this.headers.get("content-type") || (typeof k == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : c.searchParams && URLSearchParams.prototype.isPrototypeOf(k) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, c.blob && (this.blob = function() {
            var k = S(this);
            if (k)
              return k;
            if (this._bodyBlob)
              return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }, this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
              var k = S(this);
              return k || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
                this._bodyArrayBuffer.buffer.slice(
                  this._bodyArrayBuffer.byteOffset,
                  this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
                )
              ) : Promise.resolve(this._bodyArrayBuffer));
            } else
              return this.blob().then(I);
          }), this.text = function() {
            var k = S(this);
            if (k)
              return k;
            if (this._bodyBlob)
              return O(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(T(this._bodyArrayBuffer));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, c.formData && (this.formData = function() {
            return this.text().then(C);
          }), this.json = function() {
            return this.text().then(JSON.parse);
          }, this;
        }
        var F = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
        function A(k) {
          var N = k.toUpperCase();
          return F.indexOf(N) > -1 ? N : k;
        }
        function _(k, N) {
          if (!(this instanceof _))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          N = N || {};
          var j = N.body;
          if (k instanceof _) {
            if (k.bodyUsed)
              throw new TypeError("Already read");
            this.url = k.url, this.credentials = k.credentials, N.headers || (this.headers = new y(k.headers)), this.method = k.method, this.mode = k.mode, this.signal = k.signal, !j && k._bodyInit != null && (j = k._bodyInit, k.bodyUsed = !0);
          } else
            this.url = String(k);
          if (this.credentials = N.credentials || this.credentials || "same-origin", (N.headers || !this.headers) && (this.headers = new y(N.headers)), this.method = A(N.method || this.method || "GET"), this.mode = N.mode || this.mode || null, this.signal = N.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && j)
            throw new TypeError("Body not allowed for GET or HEAD requests");
          if (this._initBody(j), (this.method === "GET" || this.method === "HEAD") && (N.cache === "no-store" || N.cache === "no-cache")) {
            var W = /([?&])_=[^&]*/;
            if (W.test(this.url))
              this.url = this.url.replace(W, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
            else {
              var V = /\?/;
              this.url += (V.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
            }
          }
        }
        _.prototype.clone = function() {
          return new _(this, { body: this._bodyInit });
        };
        function C(k) {
          var N = new FormData();
          return k.trim().split("&").forEach(function(j) {
            if (j) {
              var W = j.split("="), V = W.shift().replace(/\+/g, " "), $ = W.join("=").replace(/\+/g, " ");
              N.append(decodeURIComponent(V), decodeURIComponent($));
            }
          }), N;
        }
        function D(k) {
          var N = new y(), j = k.replace(/\r?\n[\t ]+/g, " ");
          return j.split("\r").map(function(W) {
            return W.indexOf(`
`) === 0 ? W.substr(1, W.length) : W;
          }).forEach(function(W) {
            var V = W.split(":"), $ = V.shift().trim();
            if ($) {
              var z = V.join(":").trim();
              N.append($, z);
            }
          }), N;
        }
        R.call(_.prototype);
        function L(k, N) {
          if (!(this instanceof L))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          N || (N = {}), this.type = "default", this.status = N.status === void 0 ? 200 : N.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = N.statusText === void 0 ? "" : "" + N.statusText, this.headers = new y(N.headers), this.url = N.url || "", this._initBody(k);
        }
        R.call(L.prototype), L.prototype.clone = function() {
          return new L(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new y(this.headers),
            url: this.url
          });
        }, L.error = function() {
          var k = new L(null, { status: 0, statusText: "" });
          return k.type = "error", k;
        };
        var B = [301, 302, 303, 307, 308];
        L.redirect = function(k, N) {
          if (B.indexOf(N) === -1)
            throw new RangeError("Invalid status code");
          return new L(null, { status: N, headers: { location: k } });
        }, a.DOMException = l.DOMException;
        try {
          new a.DOMException();
        } catch {
          a.DOMException = function(N, j) {
            this.message = N, this.name = j;
            var W = Error(N);
            this.stack = W.stack;
          }, a.DOMException.prototype = Object.create(Error.prototype), a.DOMException.prototype.constructor = a.DOMException;
        }
        function H(k, N) {
          return new Promise(function(j, W) {
            var V = new _(k, N);
            if (V.signal && V.signal.aborted)
              return W(new a.DOMException("Aborted", "AbortError"));
            var $ = new XMLHttpRequest();
            function z() {
              $.abort();
            }
            $.onload = function() {
              var K = {
                status: $.status,
                statusText: $.statusText,
                headers: D($.getAllResponseHeaders() || "")
              };
              K.url = "responseURL" in $ ? $.responseURL : K.headers.get("X-Request-URL");
              var Q = "response" in $ ? $.response : $.responseText;
              setTimeout(function() {
                j(new L(Q, K));
              }, 0);
            }, $.onerror = function() {
              setTimeout(function() {
                W(new TypeError("Network request failed"));
              }, 0);
            }, $.ontimeout = function() {
              setTimeout(function() {
                W(new TypeError("Network request failed"));
              }, 0);
            }, $.onabort = function() {
              setTimeout(function() {
                W(new a.DOMException("Aborted", "AbortError"));
              }, 0);
            };
            function ne(K) {
              try {
                return K === "" && l.location.href ? l.location.href : K;
              } catch {
                return K;
              }
            }
            $.open(V.method, ne(V.url), !0), V.credentials === "include" ? $.withCredentials = !0 : V.credentials === "omit" && ($.withCredentials = !1), "responseType" in $ && (c.blob ? $.responseType = "blob" : c.arrayBuffer && V.headers.get("Content-Type") && V.headers.get("Content-Type").indexOf("application/octet-stream") !== -1 && ($.responseType = "arraybuffer")), N && typeof N.headers == "object" && !(N.headers instanceof y) ? Object.getOwnPropertyNames(N.headers).forEach(function(K) {
              $.setRequestHeader(K, b(N.headers[K]));
            }) : V.headers.forEach(function(K, Q) {
              $.setRequestHeader(Q, K);
            }), V.signal && (V.signal.addEventListener("abort", z), $.onreadystatechange = function() {
              $.readyState === 4 && V.signal.removeEventListener("abort", z);
            }), $.send(typeof V._bodyInit > "u" ? null : V._bodyInit);
          });
        }
        return H.polyfill = !0, l.fetch || (l.fetch = H, l.Headers = y, l.Request = _, l.Response = L), a.Headers = y, a.Request = _, a.Response = L, a.fetch = H, a;
      })({});
    })(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
    var o = n.fetch ? n : r;
    t = o.fetch, t.default = o.fetch, t.fetch = o.fetch, t.Headers = o.Headers, t.Request = o.Request, t.Response = o.Response, e.exports = t;
  }(kg, kg.exports)), kg.exports;
}
(function(e, t) {
  var n;
  if (typeof fetch == "function" && (typeof Cr < "u" && Cr.fetch ? n = Cr.fetch : typeof window < "u" && window.fetch ? n = window.fetch : n = fetch), typeof Xve < "u" && typeof window > "u") {
    var r = n || Jve();
    r.default && (r = r.default), t.default = r, e.exports = t.default;
  }
})(vC, vC.exports);
var oL = vC.exports;
const iL = /* @__PURE__ */ D_(oL), v_ = /* @__PURE__ */ pz({
  __proto__: null,
  default: iL
}, [oL]);
function w_(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function C_(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? w_(Object(n), !0).forEach(function(r) {
      Zve(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : w_(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Zve(e, t, n) {
  return (t = ewe(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ewe(e) {
  var t = twe(e, "string");
  return Oc(t) == "symbol" ? t : t + "";
}
function twe(e, t) {
  if (Oc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Oc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Oc(e) {
  "@babel/helpers - typeof";
  return Oc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Oc(e);
}
var ma;
typeof fetch == "function" && (typeof global < "u" && global.fetch ? ma = global.fetch : typeof window < "u" && window.fetch ? ma = window.fetch : ma = fetch);
var Pp;
rL() && (typeof global < "u" && global.XMLHttpRequest ? Pp = global.XMLHttpRequest : typeof window < "u" && window.XMLHttpRequest && (Pp = window.XMLHttpRequest));
var Gm;
typeof ActiveXObject == "function" && (typeof global < "u" && global.ActiveXObject ? Gm = global.ActiveXObject : typeof window < "u" && window.ActiveXObject && (Gm = window.ActiveXObject));
!ma && v_ && !Pp && !Gm && (ma = iL || v_);
typeof ma != "function" && (ma = void 0);
var wC = function(t, n) {
  if (n && Oc(n) === "object") {
    var r = "";
    for (var o in n)
      r += "&" + encodeURIComponent(o) + "=" + encodeURIComponent(n[o]);
    if (!r) return t;
    t = t + (t.indexOf("?") !== -1 ? "&" : "?") + r.slice(1);
  }
  return t;
}, x_ = function(t, n, r, o) {
  var i = function(c) {
    if (!c.ok) return r(c.statusText || "Error", {
      status: c.status
    });
    c.text().then(function(d) {
      r(null, {
        status: c.status,
        data: d
      });
    }).catch(r);
  };
  if (o) {
    var a = o(t, n);
    if (a instanceof Promise) {
      a.then(i).catch(r);
      return;
    }
  }
  typeof fetch == "function" ? fetch(t, n).then(i).catch(r) : ma(t, n).then(i).catch(r);
}, S_ = !1, nwe = function(t, n, r, o) {
  t.queryStringParams && (n = wC(n, t.queryStringParams));
  var i = C_({}, typeof t.customHeaders == "function" ? t.customHeaders() : t.customHeaders);
  typeof window > "u" && typeof global < "u" && typeof global.process < "u" && global.process.versions && global.process.versions.node && (i["User-Agent"] = "i18next-http-backend (node/".concat(global.process.version, "; ").concat(global.process.platform, " ").concat(global.process.arch, ")")), r && (i["Content-Type"] = "application/json");
  var a = typeof t.requestOptions == "function" ? t.requestOptions(r) : t.requestOptions, l = C_({
    method: r ? "POST" : "GET",
    body: r ? t.stringify(r) : void 0,
    headers: i
  }, S_ ? {} : a), c = typeof t.alternateFetch == "function" && t.alternateFetch.length >= 1 ? t.alternateFetch : void 0;
  try {
    x_(n, l, o, c);
  } catch (d) {
    if (!a || Object.keys(a).length === 0 || !d.message || d.message.indexOf("not implemented") < 0)
      return o(d);
    try {
      Object.keys(a).forEach(function(f) {
        delete l[f];
      }), x_(n, l, o, c), S_ = !0;
    } catch (f) {
      o(f);
    }
  }
}, rwe = function(t, n, r, o) {
  r && Oc(r) === "object" && (r = wC("", r).slice(1)), t.queryStringParams && (n = wC(n, t.queryStringParams));
  try {
    var i;
    Pp ? i = new Pp() : i = new Gm("MSXML2.XMLHTTP.3.0"), i.open(r ? "POST" : "GET", n, 1), t.crossDomain || i.setRequestHeader("X-Requested-With", "XMLHttpRequest"), i.withCredentials = !!t.withCredentials, r && i.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), i.overrideMimeType && i.overrideMimeType("application/json");
    var a = t.customHeaders;
    if (a = typeof a == "function" ? a() : a, a)
      for (var l in a)
        i.setRequestHeader(l, a[l]);
    i.onreadystatechange = function() {
      i.readyState > 3 && o(i.status >= 400 ? i.statusText : null, {
        status: i.status,
        data: i.responseText
      });
    }, i.send(r);
  } catch (c) {
    console && console.log(c);
  }
}, owe = function(t, n, r, o) {
  if (typeof r == "function" && (o = r, r = void 0), o = o || function() {
  }, ma && n.indexOf("file:") !== 0)
    return nwe(t, n, r, o);
  if (rL() || typeof ActiveXObject == "function")
    return rwe(t, n, r, o);
  o(new Error("No fetch and no xhr implementation found!"));
};
function xd(e) {
  "@babel/helpers - typeof";
  return xd = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, xd(e);
}
function E_(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Hw(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? E_(Object(n), !0).forEach(function(r) {
      sL(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : E_(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function iwe(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function swe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, aL(r.key), r);
  }
}
function awe(e, t, n) {
  return t && swe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function sL(e, t, n) {
  return (t = aL(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function aL(e) {
  var t = lwe(e, "string");
  return xd(t) == "symbol" ? t : t + "";
}
function lwe(e, t) {
  if (xd(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (xd(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var cwe = function() {
  return {
    loadPath: "/locales/{{lng}}/{{ns}}.json",
    addPath: "/locales/add/{{lng}}/{{ns}}",
    parse: function(n) {
      return JSON.parse(n);
    },
    stringify: JSON.stringify,
    parsePayload: function(n, r, o) {
      return sL({}, r, o || "");
    },
    parseLoadPayload: function(n, r) {
    },
    request: owe,
    reloadInterval: typeof window < "u" ? !1 : 60 * 60 * 1e3,
    customHeaders: {},
    queryStringParams: {},
    crossDomain: !1,
    withCredentials: !1,
    overrideMimeType: !1,
    requestOptions: {
      mode: "cors",
      credentials: "same-origin",
      cache: "default"
    }
  };
}, lL = function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    iwe(this, e), this.services = t, this.options = n, this.allOptions = r, this.type = "backend", this.init(t, n, r);
  }
  return awe(e, [{
    key: "init",
    value: function(n) {
      var r = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (this.services = n, this.options = Hw(Hw(Hw({}, cwe()), this.options || {}), o), this.allOptions = i, this.services && this.options.reloadInterval) {
        var a = setInterval(function() {
          return r.reload();
        }, this.options.reloadInterval);
        xd(a) === "object" && typeof a.unref == "function" && a.unref();
      }
    }
  }, {
    key: "readMulti",
    value: function(n, r, o) {
      this._readAny(n, n, r, r, o);
    }
  }, {
    key: "read",
    value: function(n, r, o) {
      this._readAny([n], n, [r], r, o);
    }
  }, {
    key: "_readAny",
    value: function(n, r, o, i, a) {
      var l = this, c = this.options.loadPath;
      typeof this.options.loadPath == "function" && (c = this.options.loadPath(n, o)), c = Qve(c), c.then(function(d) {
        if (!d) return a(null, {});
        var f = l.services.interpolator.interpolate(d, {
          lng: n.join("+"),
          ns: o.join("+")
        });
        l.loadUrl(f, a, r, i);
      });
    }
  }, {
    key: "loadUrl",
    value: function(n, r, o, i) {
      var a = this, l = typeof o == "string" ? [o] : o, c = typeof i == "string" ? [i] : i, d = this.options.parseLoadPayload(l, c);
      this.options.request(this.options, n, d, function(f, p) {
        if (p && (p.status >= 500 && p.status < 600 || !p.status)) return r("failed loading " + n + "; status code: " + p.status, !0);
        if (p && p.status >= 400 && p.status < 500) return r("failed loading " + n + "; status code: " + p.status, !1);
        if (!p && f && f.message) {
          var g = f.message.toLowerCase(), b = ["failed", "fetch", "network", "load"].find(function(S) {
            return g.indexOf(S) > -1;
          });
          if (b)
            return r("failed loading " + n + ": " + f.message, !0);
        }
        if (f) return r(f, !1);
        var v, y;
        try {
          typeof p.data == "string" ? v = a.options.parse(p.data, o, i) : v = p.data;
        } catch {
          y = "failed parsing " + n + " to json";
        }
        if (y) return r(y, !1);
        r(null, v);
      });
    }
  }, {
    key: "create",
    value: function(n, r, o, i, a) {
      var l = this;
      if (this.options.addPath) {
        typeof n == "string" && (n = [n]);
        var c = this.options.parsePayload(r, o, i), d = 0, f = [], p = [];
        n.forEach(function(g) {
          var b = l.options.addPath;
          typeof l.options.addPath == "function" && (b = l.options.addPath(g, r));
          var v = l.services.interpolator.interpolate(b, {
            lng: g,
            ns: r
          });
          l.options.request(l.options, v, c, function(y, S) {
            d += 1, f.push(y), p.push(S), d === n.length && typeof a == "function" && a(f, p);
          });
        });
      }
    }
  }, {
    key: "reload",
    value: function() {
      var n = this, r = this.services, o = r.backendConnector, i = r.languageUtils, a = r.logger, l = o.language;
      if (!(l && l.toLowerCase() === "cimode")) {
        var c = [], d = function(p) {
          var g = i.toResolveHierarchy(p);
          g.forEach(function(b) {
            c.indexOf(b) < 0 && c.push(b);
          });
        };
        d(l), this.allOptions.preload && this.allOptions.preload.forEach(function(f) {
          return d(f);
        }), c.forEach(function(f) {
          n.allOptions.ns.forEach(function(p) {
            o.read(f, p, "read", null, null, function(g, b) {
              g && a.warn("loading namespace ".concat(p, " for language ").concat(f, " failed"), g), !g && b && a.log("loaded namespace ".concat(p, " for language ").concat(f), b), o.loaded("".concat(f, "|").concat(p), g, b);
            });
          });
        });
      }
    }
  }]);
}();
lL.type = "backend";
const uwe = "/node_modules/@cropconnect/contracting-module/dist/locales/{{lng}}/{{ns}}.json";
yo.use(Nre).use(lL).init({
  lng: "en",
  fallbackLng: "en",
  ns: [
    "common",
    "acreageCalculator",
    "contracts",
    "form",
    "login",
    "fallBackTexts"
  ],
  // first entry is default namespace
  debug: !1,
  // adds console log for unresolved keys
  backend: {
    loadPath: uwe
  },
  interpolation: {
    escapeValue: !1
    // not needed for react as it escapes by default
  }
});
const dwe = Ta("AppWithProviders");
function Pwe(e) {
  const { i18n: t } = vD();
  return ir(() => {
    console.log(`Contracting-module version ${wD} is running.`);
  }, []), ir(() => {
    console.log(`Got bp no ${e.bpno}`);
  }, [e.bpno]), ir(() => {
    console.log(`Got deploymentTarget no ${e.deploymentTarget}`);
  }, [e.deploymentTarget]), ir(() => {
    t.changeLanguage(e.language ?? "en").then(
      (n) => dwe.info(`Language is set to ${e.language ?? "en"}`)
    );
  }, [e.language, t]), /* @__PURE__ */ w.jsx(ZM, { ...sre, children: /* @__PURE__ */ w.jsx(
    wre,
    {
      deploymentTarget: e.deploymentTarget,
      children: /* @__PURE__ */ w.jsx(Pee, { children: /* @__PURE__ */ w.jsx(Mee, { children: /* @__PURE__ */ w.jsx(QX, { children: /* @__PURE__ */ w.jsx(Oq, { theme: nX, children: /* @__PURE__ */ w.jsx(are, { bpno: e.bpno, children: /* @__PURE__ */ w.jsx(Kve, { baseRouterPath: e.baseRouterPath }) }) }) }) }) })
    }
  ) });
}
async function fwe(e) {
  const t = gD(e), n = t.supabaseUrl, r = t.supabaseAnonKey;
  if (!n || !r)
    throw Error("Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY variable");
  await new KA(n, r).getBaseClient().auth.signOut();
}
async function Iwe(e) {
  await fwe(e);
}
export {
  Pwe as A,
  D_ as g,
  Iwe as s
};
//# sourceMappingURL=index-D7hcJoWt.mjs.map
